/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/custom/plugins/NetiPlexipeopleLeonardo/Resources/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 228);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(16);
var hide = __webpack_require__(25);
var redefine = __webpack_require__(19);
var ctx = __webpack_require__(35);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(14)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(233)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(79)('wks');
var uid = __webpack_require__(46);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(292).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)(module)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(30);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var IE8_DOM_DEFINE = __webpack_require__(198);
var toPrimitive = __webpack_require__(41);
var dP = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(255)
var ieee754 = __webpack_require__(256)
var isArray = __webpack_require__(140)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(4)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 16 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(298).version;
elliptic.utils = __webpack_require__(299);
elliptic.rand = __webpack_require__(165);
elliptic.curve = __webpack_require__(76);
elliptic.curves = __webpack_require__(304);

// Protocols
elliptic.ec = __webpack_require__(312);
elliptic.eddsa = __webpack_require__(316);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(25);
var has = __webpack_require__(24);
var SRC = __webpack_require__(46)('src');
var $toString = __webpack_require__(431);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(16).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(38);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(4);
var defined = __webpack_require__(38);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13);
var createDesc = __webpack_require__(45);
module.exports = __webpack_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(68);
var defined = __webpack_require__(38);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(23);
var inherits = __webpack_require__(1);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(69);
var createDesc = __webpack_require__(45);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(41);
var has = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(198);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(16);
var fails = __webpack_require__(4);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(35);
var IObject = __webpack_require__(68);
var toObject = __webpack_require__(20);
var toLength = __webpack_require__(12);
var asc = __webpack_require__(521);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, Promise */

;(function ($) {
  'use strict'

  var urlAPI = $.URL || $.webkitURL

  /**
   * Creates an object URL for a given File object.
   *
   * @param {Blob} blob Blob object
   * @returns {string|boolean} Returns object URL if API exists, else false.
   */
  function createObjectURL(blob) {
    return urlAPI ? urlAPI.createObjectURL(blob) : false
  }

  /**
   * Revokes a given object URL.
   *
   * @param {string} url Blob object URL
   * @returns {undefined|boolean} Returns undefined if API exists, else false.
   */
  function revokeObjectURL(url) {
    return urlAPI ? urlAPI.revokeObjectURL(url) : false
  }

  /**
   * Helper function to revoke an object URL
   *
   * @param {string} url Blob Object URL
   * @param {object} [options] Options object
   */
  function revokeHelper(url, options) {
    if (url && url.slice(0, 5) === 'blob:' && !(options && options.noRevoke)) {
      revokeObjectURL(url)
    }
  }

  /**
   * Loads a given File object via FileReader interface.
   *
   * @param {Blob} file Blob object
   * @param {Function} onload Load event callback
   * @param {Function} [onerror] Error/Abort event callback
   * @param {string} [method=readAsDataURL] FileReader method
   * @returns {FileReader|boolean} Returns FileReader if API exists, else false.
   */
  function readFile(file, onload, onerror, method) {
    if (!$.FileReader) return false
    var reader = new FileReader()
    reader.onload = function () {
      onload.call(reader, this.result)
    }
    if (onerror) {
      reader.onabort = reader.onerror = function () {
        onerror.call(reader, this.error)
      }
    }
    var readerMethod = reader[method || 'readAsDataURL']
    if (readerMethod) {
      readerMethod.call(reader, file)
      return reader
    }
  }

  /**
   * Cross-frame instanceof check.
   *
   * @param {string} type Instance type
   * @param {object} obj Object instance
   * @returns {boolean} Returns true if the object is of the given instance.
   */
  function isInstanceOf(type, obj) {
    // Cross-frame instanceof check
    return Object.prototype.toString.call(obj) === '[object ' + type + ']'
  }

  /**
   * @typedef { HTMLImageElement|HTMLCanvasElement } Result
   */

  /**
   * Loads an image for a given File object.
   *
   * @param {Blob|string} file Blob object or image URL
   * @param {Function|object} [callback] Image load event callback or options
   * @param {object} [options] Options object
   * @returns {HTMLImageElement|FileReader|Promise<Result>} Object
   */
  function loadImage(file, callback, options) {
    /**
     * Promise executor
     *
     * @param {Function} resolve Resolution function
     * @param {Function} reject Rejection function
     * @returns {HTMLImageElement|FileReader} Object
     */
    function executor(resolve, reject) {
      var img = document.createElement('img')
      var url
      /**
       * Callback for the fetchBlob call.
       *
       * @param {HTMLImageElement|HTMLCanvasElement} img Error object
       * @param {object} data Data object
       * @returns {undefined} Undefined
       */
      function resolveWrapper(img, data) {
        if (resolve === reject) {
          // Not using Promises
          if (resolve) resolve(img, data)
          return
        } else if (img instanceof Error) {
          reject(img)
          return
        }
        data = data || {} // eslint-disable-line no-param-reassign
        data.image = img
        resolve(data)
      }
      /**
       * Callback for the fetchBlob call.
       *
       * @param {Blob} blob Blob object
       * @param {Error} err Error object
       */
      function fetchBlobCallback(blob, err) {
        if (err && $.console) console.log(err) // eslint-disable-line no-console
        if (blob && isInstanceOf('Blob', blob)) {
          file = blob // eslint-disable-line no-param-reassign
          url = createObjectURL(file)
        } else {
          url = file
          if (options && options.crossOrigin) {
            img.crossOrigin = options.crossOrigin
          }
        }
        img.src = url
      }
      img.onerror = function (event) {
        revokeHelper(url, options)
        if (reject) reject.call(img, event)
      }
      img.onload = function () {
        revokeHelper(url, options)
        var data = {
          originalWidth: img.naturalWidth || img.width,
          originalHeight: img.naturalHeight || img.height
        }
        try {
          loadImage.transform(img, options, resolveWrapper, file, data)
        } catch (error) {
          if (reject) reject(error)
        }
      }
      if (typeof file === 'string') {
        if (loadImage.requiresMetaData(options)) {
          loadImage.fetchBlob(file, fetchBlobCallback, options)
        } else {
          fetchBlobCallback()
        }
        return img
      } else if (isInstanceOf('Blob', file) || isInstanceOf('File', file)) {
        url = createObjectURL(file)
        if (url) {
          img.src = url
          return img
        }
        return readFile(
          file,
          function (url) {
            img.src = url
          },
          reject
        )
      }
    }
    if ($.Promise && typeof callback !== 'function') {
      options = callback // eslint-disable-line no-param-reassign
      return new Promise(executor)
    }
    return executor(callback, callback)
  }

  // Determines if metadata should be loaded automatically.
  // Requires the load image meta extension to load metadata.
  loadImage.requiresMetaData = function (options) {
    return options && options.meta
  }

  // If the callback given to this function returns a blob, it is used as image
  // source instead of the original url and overrides the file argument used in
  // the onload and onerror event callbacks:
  loadImage.fetchBlob = function (url, callback) {
    callback()
  }

  loadImage.transform = function (img, options, callback, file, data) {
    callback(img, data)
  }

  loadImage.global = $
  loadImage.readFile = readFile
  loadImage.isInstanceOf = isInstanceOf
  loadImage.createObjectURL = createObjectURL
  loadImage.revokeObjectURL = revokeObjectURL

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return loadImage
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    module.exports = loadImage
  } else {
    $.loadImage = loadImage
  }
})((typeof window !== 'undefined' && window) || this)


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(36);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(15)) {
  var LIBRARY = __webpack_require__(47);
  var global = __webpack_require__(3);
  var fails = __webpack_require__(4);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(90);
  var $buffer = __webpack_require__(133);
  var ctx = __webpack_require__(35);
  var anInstance = __webpack_require__(60);
  var propertyDesc = __webpack_require__(45);
  var hide = __webpack_require__(25);
  var redefineAll = __webpack_require__(61);
  var toInteger = __webpack_require__(30);
  var toLength = __webpack_require__(12);
  var toIndex = __webpack_require__(224);
  var toAbsoluteIndex = __webpack_require__(49);
  var toPrimitive = __webpack_require__(41);
  var has = __webpack_require__(24);
  var classof = __webpack_require__(70);
  var isObject = __webpack_require__(6);
  var toObject = __webpack_require__(20);
  var isArrayIter = __webpack_require__(125);
  var create = __webpack_require__(50);
  var getPrototypeOf = __webpack_require__(52);
  var gOPN = __webpack_require__(51).f;
  var getIterFn = __webpack_require__(127);
  var uid = __webpack_require__(46);
  var wks = __webpack_require__(9);
  var createArrayMethod = __webpack_require__(33);
  var createArrayIncludes = __webpack_require__(80);
  var speciesConstructor = __webpack_require__(71);
  var ArrayIterators = __webpack_require__(129);
  var Iterators = __webpack_require__(57);
  var $iterDetect = __webpack_require__(83);
  var setSpecies = __webpack_require__(59);
  var arrayFill = __webpack_require__(128);
  var arrayCopyWithin = __webpack_require__(215);
  var $DP = __webpack_require__(13);
  var $GOPD = __webpack_require__(31);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2).Buffer
var Transform = __webpack_require__(96).Transform
var StringDecoder = __webpack_require__(100).StringDecoder
var inherits = __webpack_require__(1)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(6);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(46)('meta');
var isObject = __webpack_require__(6);
var has = __webpack_require__(24);
var setDesc = __webpack_require__(13).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(4)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = gtag_event;
function gtag_event(event, value, label) {
    label = label || event;

    if (!window.gtag) {
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        gtag('js', new Date());
        gtag('config', 'GTM-5474V97');
    }

    window.gtag('event', 'Konfigurator', {
        'event_category': 'Zielvorhaben',
        'event_label': label,
        'value': value || ''
    });
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(73);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(63);
util.inherits = __webpack_require__(1);
/*</replacement>*/

var Readable = __webpack_require__(144);
var Writable = __webpack_require__(99);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(200);
var enumBugKeys = __webpack_require__(111);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(30);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(5);
var dPs = __webpack_require__(201);
var enumBugKeys = __webpack_require__(111);
var IE_PROTO = __webpack_require__(110)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(108)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(113).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(200);
var hiddenKeys = __webpack_require__(111).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(24);
var toObject = __webpack_require__(20);
var IE_PROTO = __webpack_require__(110)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(2).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(28)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(13).f;
var has = __webpack_require__(24);
var TAG = __webpack_require__(9)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(9)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(25)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var dP = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(15);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(19);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(1)
var MD5 = __webpack_require__(95)
var RIPEMD160 = __webpack_require__(101)
var sha = __webpack_require__(102)
var Base = __webpack_require__(40)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var assert = __webpack_require__(23);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(11);

asn1.define = __webpack_require__(320).define;
asn1.base = __webpack_require__(67);
asn1.constants = __webpack_require__(171);
asn1.decoders = __webpack_require__(326);
asn1.encoders = __webpack_require__(328);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(323).Reporter;
base.DecoderBuffer = __webpack_require__(170).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(170).EncoderBuffer;
base.Node = __webpack_require__(324);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(37);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(37);
var TAG = __webpack_require__(9)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(36);
var SPECIES = __webpack_require__(9)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clipCSS */
/* harmony export (immutable) */ __webpack_exports__["b"] = clipPoints;
/* harmony export (immutable) */ __webpack_exports__["a"] = calcMaxDimensions;
/* harmony export (immutable) */ __webpack_exports__["c"] = generateRandomID;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeURIParams;
function clipCSS(opts) {
    var coords = opts.coords;


    return 'polygon(' + clipPoints(coords).join(', ') + ')';
}

function clipPoints(coords) {
    return coords.map(function (i) {
        return i.map(function (o) {
            return o + '%';
        }).join(' ');
    });
}

function calcMaxDimensions(x, y, maxWidth, maxHeight) {
    if (y > maxHeight) {
        x = x * (maxHeight / y);
        y = maxHeight;
    }

    if (x > maxWidth) {
        y = y * (maxWidth / x);
        x = maxWidth;
    }

    return { x: x, y: y };
}

function generateRandomID() {
    function chr4() {
        return Math.random().toString(16).slice(-4);
    }

    return [chr4() + chr4(), chr4(), chr4(), chr4(), chr4() + chr4() + chr4()].join('-');
}

function removeURIParams(uri) {
    return uri.split('?', 1)[0];
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(2).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2).Buffer
var MD5 = __webpack_require__(95)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(300);
curve.short = __webpack_require__(301);
curve.mont = __webpack_require__(302);
curve.edwards = __webpack_require__(303);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(319)
var aesid = __webpack_require__(331)
var fixProc = __webpack_require__(332)
var ciphers = __webpack_require__(104)
var compat = __webpack_require__(153)
var Buffer = __webpack_require__(2).Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Meta
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Image metadata handling implementation
 * based on the help and contribution of
 * Achim Stöhr.
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, Promise, DataView, Uint8Array, ArrayBuffer */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var global = loadImage.global
  var originalTransform = loadImage.transform

  var blobSlice =
    global.Blob &&
    (Blob.prototype.slice ||
      Blob.prototype.webkitSlice ||
      Blob.prototype.mozSlice)

  var bufferSlice =
    (global.ArrayBuffer && ArrayBuffer.prototype.slice) ||
    function (begin, end) {
      // Polyfill for IE10, which does not support ArrayBuffer.slice
      // eslint-disable-next-line no-param-reassign
      end = end || this.byteLength - begin
      var arr1 = new Uint8Array(this, begin, end)
      var arr2 = new Uint8Array(end)
      arr2.set(arr1)
      return arr2.buffer
    }

  var metaDataParsers = {
    jpeg: {
      0xffe1: [], // APP1 marker
      0xffed: [] // APP13 marker
    }
  }

  /**
   * Parses image metadata and calls the callback with an object argument
   * with the following property:
   * - imageHead: The complete image head as ArrayBuffer
   * The options argument accepts an object and supports the following
   * properties:
   * - maxMetaDataSize: Defines the maximum number of bytes to parse.
   * - disableImageHead: Disables creating the imageHead property.
   *
   * @param {Blob} file Blob object
   * @param {Function} [callback] Callback function
   * @param {object} [options] Parsing options
   * @param {object} [data] Result data object
   * @returns {Promise<object>|undefined} Returns Promise if no callback given.
   */
  function parseMetaData(file, callback, options, data) {
    var that = this
    /**
     * Promise executor
     *
     * @param {Function} resolve Resolution function
     * @param {Function} reject Rejection function
     * @returns {undefined} Undefined
     */
    function executor(resolve, reject) {
      if (
        !(
          global.DataView &&
          blobSlice &&
          file &&
          file.size >= 12 &&
          file.type === 'image/jpeg'
        )
      ) {
        // Nothing to parse
        return resolve(data)
      }
      // 256 KiB should contain all EXIF/ICC/IPTC segments:
      var maxMetaDataSize = options.maxMetaDataSize || 262144
      if (
        !loadImage.readFile(
          blobSlice.call(file, 0, maxMetaDataSize),
          function (buffer) {
            // Note on endianness:
            // Since the marker and length bytes in JPEG files are always
            // stored in big endian order, we can leave the endian parameter
            // of the DataView methods undefined, defaulting to big endian.
            var dataView = new DataView(buffer)
            // Check for the JPEG marker (0xffd8):
            if (dataView.getUint16(0) !== 0xffd8) {
              return reject(
                new Error('Invalid JPEG file: Missing JPEG marker.')
              )
            }
            var offset = 2
            var maxOffset = dataView.byteLength - 4
            var headLength = offset
            var markerBytes
            var markerLength
            var parsers
            var i
            while (offset < maxOffset) {
              markerBytes = dataView.getUint16(offset)
              // Search for APPn (0xffeN) and COM (0xfffe) markers,
              // which contain application-specific metadata like
              // Exif, ICC and IPTC data and text comments:
              if (
                (markerBytes >= 0xffe0 && markerBytes <= 0xffef) ||
                markerBytes === 0xfffe
              ) {
                // The marker bytes (2) are always followed by
                // the length bytes (2), indicating the length of the
                // marker segment, which includes the length bytes,
                // but not the marker bytes, so we add 2:
                markerLength = dataView.getUint16(offset + 2) + 2
                if (offset + markerLength > dataView.byteLength) {
                  // eslint-disable-next-line no-console
                  console.log('Invalid JPEG metadata: Invalid segment size.')
                  break
                }
                parsers = metaDataParsers.jpeg[markerBytes]
                if (parsers && !options.disableMetaDataParsers) {
                  for (i = 0; i < parsers.length; i += 1) {
                    parsers[i].call(
                      that,
                      dataView,
                      offset,
                      markerLength,
                      data,
                      options
                    )
                  }
                }
                offset += markerLength
                headLength = offset
              } else {
                // Not an APPn or COM marker, probably safe to
                // assume that this is the end of the metadata
                break
              }
            }
            // Meta length must be longer than JPEG marker (2)
            // plus APPn marker (2), followed by length bytes (2):
            if (!options.disableImageHead && headLength > 6) {
              data.imageHead = bufferSlice.call(buffer, 0, headLength)
            }
            resolve(data)
          },
          reject,
          'readAsArrayBuffer'
        )
      ) {
        // No support for the FileReader interface, nothing to parse
        resolve(data)
      }
    }
    options = options || {} // eslint-disable-line no-param-reassign
    if (global.Promise && typeof callback !== 'function') {
      options = callback || {} // eslint-disable-line no-param-reassign
      data = options // eslint-disable-line no-param-reassign
      return new Promise(executor)
    }
    data = data || {} // eslint-disable-line no-param-reassign
    return executor(callback, callback)
  }

  /**
   * Replaces the head of a JPEG Blob
   *
   * @param {Blob} blob Blob object
   * @param {ArrayBuffer} oldHead Old JPEG head
   * @param {ArrayBuffer} newHead New JPEG head
   * @returns {Blob} Combined Blob
   */
  function replaceJPEGHead(blob, oldHead, newHead) {
    if (!blob || !oldHead || !newHead) return null
    return new Blob([newHead, blobSlice.call(blob, oldHead.byteLength)], {
      type: 'image/jpeg'
    })
  }

  /**
   * Replaces the image head of a JPEG blob with the given one.
   * Returns a Promise or calls the callback with the new Blob.
   *
   * @param {Blob} blob Blob object
   * @param {ArrayBuffer} head New JPEG head
   * @param {Function} [callback] Callback function
   * @returns {Promise<Blob|null>|undefined} Combined Blob
   */
  function replaceHead(blob, head, callback) {
    var options = { maxMetaDataSize: 256, disableMetaDataParsers: true }
    if (!callback && global.Promise) {
      return parseMetaData(blob, options).then(function (data) {
        return replaceJPEGHead(blob, data.imageHead, head)
      })
    }
    parseMetaData(
      blob,
      function (data) {
        callback(replaceJPEGHead(blob, data.imageHead, head))
      },
      options
    )
  }

  loadImage.transform = function (img, options, callback, file, data) {
    if (loadImage.requiresMetaData(options)) {
      data = data || {} // eslint-disable-line no-param-reassign
      parseMetaData(
        file,
        function (result) {
          if (result !== data) {
            // eslint-disable-next-line no-console
            if (global.console) console.log(result)
            result = data // eslint-disable-line no-param-reassign
          }
          originalTransform.call(
            loadImage,
            img,
            options,
            callback,
            file,
            result
          )
        },
        options,
        data
      )
    } else {
      originalTransform.apply(loadImage, arguments)
    }
  }

  loadImage.blobSlice = blobSlice
  loadImage.bufferSlice = bufferSlice
  loadImage.replaceHead = replaceHead
  loadImage.parseMetaData = parseMetaData
  loadImage.metaDataParsers = metaDataParsers
})


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(16);
var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(47) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(49);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(38);
var fails = __webpack_require__(4);
var spaces = __webpack_require__(115);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(9)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(5);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(70);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(217);
var redefine = __webpack_require__(19);
var hide = __webpack_require__(25);
var fails = __webpack_require__(4);
var defined = __webpack_require__(38);
var wks = __webpack_require__(9);
var regexpExec = __webpack_require__(130);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(35);
var call = __webpack_require__(213);
var isArrayIter = __webpack_require__(125);
var anObject = __webpack_require__(5);
var toLength = __webpack_require__(12);
var getIterFn = __webpack_require__(127);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(19);
var redefineAll = __webpack_require__(61);
var meta = __webpack_require__(42);
var forOf = __webpack_require__(87);
var anInstance = __webpack_require__(60);
var isObject = __webpack_require__(6);
var fails = __webpack_require__(4);
var $iterDetect = __webpack_require__(83);
var setToStringTag = __webpack_require__(56);
var inheritIfRequired = __webpack_require__(116);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(25);
var uid = __webpack_require__(46);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.8
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res)) {
      // issue #9511
      // reassign to res to avoid catch triggering multiple times when nested calls
      res = res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var isStable = slots ? !!slots.$stable : true;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    Object.keys(normalSlots).length === 0
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && res.length === 0
      ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        if (!(key in hash) && !(camelizedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + camelizedKey)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (!isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
if (inBrowser && getNow() > document.createEvent('Event').timeStamp) {
  // if the low-res timestamp which is bigger than the event timestamp
  // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
  // and we need to use the hi-res version for event listeners as well.
  getNow = function () { return performance.now(); };
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.8';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // #9462 bail for iOS 9 bug: event.timeStamp is 0 after history.pushState
        e.timeStamp === 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22), __webpack_require__(92).setImmediate))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(229);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Decagon',
  // coords: [ [50, 0], [80, 10], [100, 35], [100, 70], [80, 90], [50, 100], [20, 90], [0, 70], [0, 35], [20, 10] ],
  // coords: [ [10, 90], [35, 90], [65, 90], [90, 90], [90, 50], [90, 10], [65, 10], [35, 10], [10, 10], [10, 50] ],
  coords: [[10, 90], [90, 90], [90, 65], [90, 35], [90, 10], [65, 10], [35, 10], [10, 10], [10, 35], [10, 65]]
}]);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(1)
var HashBase = __webpack_require__(143)
var Buffer = __webpack_require__(2).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(97).EventEmitter;
var inherits = __webpack_require__(1);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(98);
Stream.Writable = __webpack_require__(263);
Stream.Duplex = __webpack_require__(264);
Stream.Transform = __webpack_require__(265);
Stream.PassThrough = __webpack_require__(266);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(144);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(99);
exports.Duplex = __webpack_require__(44);
exports.Transform = __webpack_require__(147);
exports.PassThrough = __webpack_require__(262);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(73);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(63);
util.inherits = __webpack_require__(1);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(261)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(145);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(2).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(146);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(44);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(44);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(92).setImmediate, __webpack_require__(22)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(2).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(14).Buffer
var inherits = __webpack_require__(1)
var HashBase = __webpack_require__(143)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(267)
exports.sha1 = __webpack_require__(268)
exports.sha224 = __webpack_require__(269)
exports.sha256 = __webpack_require__(148)
exports.sha384 = __webpack_require__(270)
exports.sha512 = __webpack_require__(149)


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(276);
exports.Cipher = __webpack_require__(277);
exports.DES = __webpack_require__(278);
exports.CBC = __webpack_require__(279);
exports.EDE = __webpack_require__(280);


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(281)
var deciphers = __webpack_require__(289)
var modes = __webpack_require__(159)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(282),
  CBC: __webpack_require__(283),
  CFB: __webpack_require__(284),
  CFB8: __webpack_require__(285),
  CFB1: __webpack_require__(286),
  OFB: __webpack_require__(287),
  CTR: __webpack_require__(157),
  GCM: __webpack_require__(157)
}

var modes = __webpack_require__(159)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(11);
var randomBytes = __webpack_require__(54);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(29);
hash.common = __webpack_require__(65);
hash.sha = __webpack_require__(305);
hash.ripemd = __webpack_require__(309);
hash.hmac = __webpack_require__(310);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(9);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(79)('keys');
var uid = __webpack_require__(46);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(37);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(6);
var anObject = __webpack_require__(5);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(35)(Function.call, __webpack_require__(31).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var setPrototypeOf = __webpack_require__(114).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(30);
var defined = __webpack_require__(38);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(30);
var defined = __webpack_require__(38);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(47);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(19);
var hide = __webpack_require__(25);
var Iterators = __webpack_require__(57);
var $iterCreate = __webpack_require__(212);
var setToStringTag = __webpack_require__(56);
var getPrototypeOf = __webpack_require__(52);
var ITERATOR = __webpack_require__(9)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(123);
var defined = __webpack_require__(38);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(6);
var cof = __webpack_require__(37);
var MATCH = __webpack_require__(9)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(9)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(57);
var ITERATOR = __webpack_require__(9)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(13);
var createDesc = __webpack_require__(45);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(70);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(57);
module.exports = __webpack_require__(16).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(20);
var toAbsoluteIndex = __webpack_require__(49);
var toLength = __webpack_require__(12);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(58);
var step = __webpack_require__(216);
var Iterators = __webpack_require__(57);
var toIObject = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(121)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(84);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(120)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(35);
var invoke = __webpack_require__(206);
var html = __webpack_require__(113);
var cel = __webpack_require__(108);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(37)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(15);
var LIBRARY = __webpack_require__(47);
var $typed = __webpack_require__(90);
var hide = __webpack_require__(25);
var redefineAll = __webpack_require__(61);
var fails = __webpack_require__(4);
var anInstance = __webpack_require__(60);
var toInteger = __webpack_require__(30);
var toLength = __webpack_require__(12);
var toIndex = __webpack_require__(224);
var gOPN = __webpack_require__(51).f;
var dP = __webpack_require__(13).f;
var arrayFill = __webpack_require__(128);
var setToStringTag = __webpack_require__(56);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "#nprogress{pointer-events:none}#nprogress .bar{background:#29d;position:fixed;z-index:1031;top:0;left:0;width:100%;height:2px}#nprogress .peg{display:block;position:absolute;right:0;width:100px;height:100%;box-shadow:0 0 10px #29d,0 0 5px #29d;opacity:1;-webkit-transform:rotate(3deg) translateY(-4px);-ms-transform:rotate(3deg) translateY(-4px);transform:rotate(3deg) translateY(-4px)}#nprogress .spinner{display:block;position:fixed;z-index:1031;top:15px;right:15px}#nprogress .spinner-icon{width:18px;height:18px;box-sizing:border-box;border:2px solid transparent;border-top-color:#29d;border-left-color:#29d;border-radius:50%;-webkit-animation:nprogress-spinner .4s linear infinite;animation:nprogress-spinner .4s linear infinite}.nprogress-custom-parent{overflow:hidden;position:relative}.nprogress-custom-parent #nprogress .bar,.nprogress-custom-parent #nprogress .spinner{position:absolute}@-webkit-keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes nprogress-spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shapes_configuration__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobile_detect__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobile_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_InAppBrowserTurorial__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoadingSplash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Navigation__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ClipPath__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PlexipeopleVisualization__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PriceList__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Base__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BuyButton__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_randomcolor__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_randomcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_randomcolor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vimeo_player__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Praise__ = __webpack_require__(418);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var isMobile = null !== new __WEBPACK_IMPORTED_MODULE_2_mobile_detect___default.a(window.navigator.userAgent).mobile(),
            variants = App.configuration.variants;

        var _App = App,
            _App$record = _App.record,
            record = _App$record === undefined ? false : _App$record;


        var isInAppBrowser = function () {
            var ua = navigator.userAgent || navigator.vendor || window.opera;

            var isIos = 'iOS' === new __WEBPACK_IMPORTED_MODULE_2_mobile_detect___default.a(window.navigator.userAgent).os();
            if (isIos === true) {
                return false;
            }
            return ua.indexOf('Instagram') > -1 || ua.indexOf('Pinterest') > -1;
        }();

        return {
            isInAppBrowser: isInAppBrowser,
            record: record,
            showBrowserPreloadingSplash: false,
            // showIntroVideo: ! (this.$cookies.get('introVideoShown') || false),
            showIntroVideo: !record,
            restoreable: false,
            player: false,
            videoLoaded: false,
            introVideoShown: false,
            introJsShown: this.$cookies.get('introJsShown') || {},
            //introJsShown: {},
            introJsInstance: false,
            introJsMessages: [],
            leavingEditorEventListenerRegistered: false,
            showAutoWidthDialog: false,
            loadingSplashOpen: true,
            showPreloader: false,
            extractorOpen: false,
            imagesOpen: false,
            images: [],
            preview: {
                'max-height': '150px'
            },

            extractor: {
                editInPlace: false,
                target: false,
                images: [],
                coords: [],
                showModalOnClose: false
            },

            viewport: {
                isMobile: isMobile,
                width: window.innerWidth,
                height: window.innerHeight,
                factor: 20,
                format: 'portrait',

                trigger: [{
                    indicator: 'S',
                    label: '15 x 18 cm',
                    value: {
                        x: 150,
                        y: 180
                    },
                    line: {
                        width: 100 / (30 / 15) + '%',
                        height: 100 / (30 / 18) + '%'
                    },
                    active: false
                }, {
                    indicator: 'M',
                    label: '22 x 25 cm',
                    value: {
                        x: 220,
                        y: 250
                    },
                    line: {
                        width: 100 / (30 / 22) + '%',
                        height: 100 / (30 / 25) + '%'
                    },
                    active: false
                }, {
                    indicator: 'L',
                    label: '30 x 30 cm',
                    value: {
                        x: 300,
                        y: 300
                    },
                    line: {
                        width: 100 / (30 / 30) + '%',
                        height: 100 / (30 / 30) + '%'
                    },
                    active: false
                }]
            },

            availableHeight: 0,

            base: {
                autoWidth: true,
                color: variants.colors.elements[variants.colors.selected || 0],
                grooves: variants.grooves.elements[variants.grooves.selected || 0],
                height: {
                    value: 20
                },
                material: variants.materials.elements[variants.materials.selected || 0],
                width: variants.widths.elements[variants.widths.selected || 0]
            },

            plexipeople: [],

            visualization: {
                plexipeople: {}
            },

            quantity: 1,

            price: .0,
            openPraise: false
        };
    },


    computed: {
        afterVideoLayerStyle: function afterVideoLayerStyle() {
            var size = this.getIntroVideoSize() + "px";

            return {
                width: size,
                height: size
            };
        }
    },

    methods: {
        openBrowserPeloadingSplash: function openBrowserPeloadingSplash() {
            this.showBrowserPreloadingSplash = true;
        },
        closeBrowserPeloadingSplash: function closeBrowserPeloadingSplash() {
            this.showBrowserPreloadingSplash = false;
        },
        preloaderDone: function preloaderDone() {
            this.showPreloader = false;
            this.startIntroDelayedBy('navigation', 1000, false);
        },
        closeIntroVideo: function closeIntroVideo() {
            this.$cookies.set('introVideoShown', !(this.showIntroVideo = false));
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('navigation_triggerUploadButton');
        },
        updateQuantity: function updateQuantity(quantity) {
            this.quantity = quantity;
        },
        setBaseWidth: function setBaseWidth(id) {
            var i = 0;

            for (; i < App.configuration.variants.widths.elements.length; i++) {
                if (id !== App.configuration.variants.widths.elements[i].id) {
                    continue;
                }

                this.base.width = App.configuration.variants.widths.elements[i];

                if (!this.showAutoWidthDialog) {
                    return;
                }

                this.showAutoWidthDialog = false;

                this.$modal.show('dialog', {
                    title: this._i18n.t('hint.autoWidth.headline'),
                    text: this._i18n.t('hint.autoWidth.body') + '<img src="/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/hint-auto-width.png" />',
                    buttons: [{
                        title: this._i18n.t('hint.autoWidth.confirm')
                    }]
                });

                return;
            }
        },
        setPrice: function setPrice(price) {
            this.price = price;
        },
        resetActivePlexipeople: function resetActivePlexipeople() {
            this.visualization.plexipeople = {};
        },
        setActivePlexipeople: function setActivePlexipeople(plexipeople) {
            var i = 0;

            for (; i < this.plexipeople.length; i++) {
                if (this.plexipeople[i].uuid !== plexipeople.uuid) {
                    continue;
                }

                this.visualization.plexipeople = this.plexipeople[i];
                this.viewport.format = plexipeople.format;
            }
        },
        activatePlexipeople: function activatePlexipeople(plexipeople) {
            var i = 0,
                match = void 0,
                undef = void 0;

            for (; i < this.plexipeople.length; i++) {
                if (this.plexipeople[i].uuid !== plexipeople.uuid) {
                    this.plexipeople[i].active = false;

                    continue;
                }

                match = this.plexipeople[i];
                this.plexipeople[i].active = true;
            }

            if (undef === match) {
                this.resetActivePlexipeople();
            }

            this.setActivePlexipeople(match);
        },
        deactivePlexipeople: function deactivePlexipeople(plexipeople) {
            if (this.visualization.plexipeople.uuid === plexipeople.uuid) {
                this.resetActivePlexipeople();
            }
        },
        resizePlexipeople: function resizePlexipeople(plexipeople, size) {
            var i = 0;

            for (; i < this.plexipeople.length; i++) {
                if (this.plexipeople[i].uuid !== plexipeople.uuid) {
                    continue;
                }

                var isPortrait = this.plexipeople[i].format !== 'panorama',
                    dim = Object(__WEBPACK_IMPORTED_MODULE_13__utilities__["a" /* calcMaxDimensions */])(this.plexipeople[i].extraction.geometry.width, this.plexipeople[i].extraction.geometry.height, isPortrait ? size.value.x : size.value.y, isPortrait ? size.value.y : size.value.x);

                this.plexipeople[i].width = dim.x / 10 * this.viewport.factor;
                this.plexipeople[i].height = dim.y / 10 * this.viewport.factor;

                var viewportWidth = 30 * this.viewport.factor;

                if (1 === this.plexipeople.length) {
                    this.plexipeople[i].x = (viewportWidth - this.plexipeople[i].width) / 2;
                } else if (viewportWidth < this.plexipeople[i].x + this.plexipeople[i].width) {
                    this.plexipeople[i].x = viewportWidth - this.plexipeople[i].width;
                }

                __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');

                return;
            }
        },
        closeExtractor: function closeExtractor(openEditor) {
            this.imagesOpen = !(openEditor || false);
            this.showPreloader = openEditor || false;
            this.extractor.images = [];
            this.extractor.editInPlace = false;
            this.extractorOpen = false;

            if (!(this.extractor.showModalOnClose && openEditor)) {
                return;
            }

            this.extractor.showModalOnClose = false;

            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');
        },
        openExtractor: function openExtractor(images, extraction, editInPlace) {
            var undef = void 0;

            if ('_uploaded' === images) {
                images = [];

                this.images.forEach(function (image) {
                    if (0 === image.extractions.length) {
                        images.push(image);
                    }
                });
            }

            if (0 === this.images.length) {
                return;
            }

            if (undef === images) {
                images = [this.visualization.plexipeople.extraction.parent];
                extraction = this.visualization.plexipeople.extraction;
            }

            editInPlace = editInPlace || false;

            this.extractor.images = images;
            this.extractor.editInPlace = editInPlace;
            this.extractor.target = extraction || false;
            this.extractor.coords = JSON.parse(JSON.stringify(extraction ? extraction.coords : __WEBPACK_IMPORTED_MODULE_1__shapes_configuration__["a" /* default */][0].coords));

            if (this.extractorOpen) {
                __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('Handles:reset', this.extractor.coords);
            }

            this.extractorOpen = true;
        },
        addImage: function addImage(file) {
            this.images.push({
                completeTimestamp: file.completeTimestamp,
                source: file.leonardo.fileUrl,
                origin: file.leonardo.originUrl || '',
                info: file.leonardo.info,
                extractions: [],
                uuid: file.uuid || Object(__WEBPACK_IMPORTED_MODULE_13__utilities__["c" /* generateRandomID */])()
            });
        },
        completeImage: function completeImage(file) {
            var image = this.images.find(function (img) {
                return img.uuid === file.uuid;
            });

            image.completeTimestamp = file.completeTimestamp;
            image.source = file.leonardo.fileUrl;
            image.origin = file.leonardo.originUrl || "";
            image.info = file.leonardo.info || "";
        },
        addExtraction: function addExtraction(extraction) {
            var image = extraction.parent,
                i = void 0;

            for (i = 0; i < this.images.length; i++) {
                if (image !== this.images[i]) {
                    continue;
                }

                this.images[i].extractions = [extraction];
            }
        },
        removeExtraction: function removeExtraction(key) {
            var _this = this;

            var undef = void 0;

            if (undef === key) {
                this.plexipeople.forEach(function (plexipeople, pKey) {
                    if (plexipeople === _this.visualization.plexipeople) {
                        key = pKey;
                    }
                });
            }

            if (undef === key) {
                return;
            }

            var _remove = function _remove() {
                var uuid = _this.plexipeople[key].extraction.parent.uuid;

                _this.deactivePlexipeople(_this.plexipeople[key]);
                _this.plexipeople.splice(key, 1);

                if (0 < _this.plexipeople.length) {
                    _this.activatePlexipeople(_this.plexipeople[0]);
                }

                _this.images.forEach(function (image, key) {
                    if (image.uuid === uuid) {
                        _this.images.splice(key, 1);
                    }
                });

                __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');
            };

            this.$modal.show('dialog', {
                title: this._i18n.t('editor.remove-dialog.title'),
                text: this._i18n.t('editor.remove-dialog.text'),
                buttons: [{
                    title: this._i18n.t('editor.remove-dialog.confirm'),
                    handler: function handler() {
                        _remove();
                        _this.$modal.hide('dialog');
                    },
                    class: 'vue-dialog-button is--error'
                }, {
                    title: this._i18n.t('editor.remove-dialog.cancel'),
                    class: 'vue-dialog-button is--success'
                }]
            });
        },
        addToEditor: function addToEditor(extraction, preset, target) {
            var vm = this,
                image = new Image();

            preset = preset || { groove: 1, x: false, y: false, width: false, height: false };

            image.addEventListener('load', function () {
                var i = 0,
                    maxWidth = vm.viewport.trigger[0].value.x / 10 * vm.viewport.factor,
                    maxHeight = vm.viewport.trigger[0].value.y / 10 * vm.viewport.factor;

                if (false !== target) {
                    for (; i < vm.plexipeople.length; i++) {
                        if (vm.plexipeople[i].extraction === target) {
                            maxWidth = vm.plexipeople[i].width;
                            maxHeight = vm.plexipeople[i].height;
                            preset.x = vm.plexipeople[i].x;

                            vm.plexipeople[i].extraction.inUse = false;
                            vm.plexipeople.splice(i, 1);

                            break;
                        }
                    }
                }

                var plexipeople = void 0,
                    format = image.width > image.height ? 'panorama' : 'portrait',
                    isPortrait = format !== 'panorama',
                    dim = Object(__WEBPACK_IMPORTED_MODULE_13__utilities__["a" /* calcMaxDimensions */])(image.width, image.height, isPortrait ? maxWidth : maxHeight, isPortrait ? maxHeight : maxWidth);

                plexipeople = {
                    extraction: extraction,
                    active: false,
                    groove: 1,
                    x: preset.x || (30 * vm.viewport.factor - dim.x) / 2,
                    y: preset.y || 0,
                    width: preset.width || dim.x,
                    height: preset.height || dim.y,
                    uuid: Object(__WEBPACK_IMPORTED_MODULE_13__utilities__["c" /* generateRandomID */])(),
                    indicator: __WEBPACK_IMPORTED_MODULE_12_randomcolor___default()(),
                    size: preset.size || 'S'
                };

                plexipeople.format = format;

                vm.plexipeople.push(plexipeople);

                extraction.inUse = true;

                __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');

                vm.activatePlexipeople(plexipeople);
            });

            image.src = extraction.source;
            vm.openPraise = true;
            console.log('praise');
        },
        openEditor: function openEditor() {
            this.closeExtractor(true);
        },
        findBaseElementById: function findBaseElementById(element, id) {
            var elements = App.configuration.variants[element].elements,
                i = void 0;

            for (i in elements) {
                if (elements[i].id === id) {
                    return elements[i];
                }
            }
        },
        disableAutoWidth: function disableAutoWidth() {
            this.base.autoWidth = false;
        },
        restoreDataFromRecord: function restoreDataFromRecord() {
            var vm = this;

            if (!vm.restoreable) {
                return;
            }

            vm.$http.post(App.url.loadRecordData, { record: vm.record }).then(
            // Successful
            function (response) {
                vm.disableAutoWidth();

                var restoreData = JSON.parse(response.data.leonardoData),
                    imageCollection = [],
                    i = void 0;

                vm.closeExtractor();

                restoreData.plexipeople.forEach(function (plexipeopleEntry) {
                    var extraction = void 0,
                        image = void 0,
                        plexipeople = void 0;

                    extraction = JSON.parse(JSON.stringify(plexipeopleEntry.extraction));

                    if (imageCollection[plexipeopleEntry.extraction.parent.uuid]) {
                        image = imageCollection[plexipeopleEntry.extraction.parent.uuid];
                    } else {
                        image = JSON.parse(JSON.stringify(plexipeopleEntry.extraction.parent));
                        image.extractions = [];

                        imageCollection[plexipeopleEntry.extraction.parent.uuid] = image;
                    }

                    extraction.parent = image;
                    image.extractions.push(extraction);

                    plexipeople = JSON.parse(JSON.stringify(plexipeopleEntry));

                    var x = vm.viewport.width < plexipeople.x * vm.viewport.factor ? false : plexipeople.x * vm.viewport.factor;

                    vm.addToEditor(extraction, {
                        groove: 1,
                        x: x,
                        width: plexipeople.width / 10 * vm.viewport.factor,
                        height: plexipeople.height / 10 * vm.viewport.factor
                    });
                });

                for (i in imageCollection) {
                    vm.images.push(imageCollection[i]);
                }

                vm.base.color = vm.findBaseElementById('colors', restoreData.base.color.value.id);
                vm.base.grooves = vm.findBaseElementById('grooves', restoreData.base.grooves.value.id);
                vm.base.material = vm.findBaseElementById('materials', restoreData.base.material.value.id);
                vm.base.width = vm.findBaseElementById('widths', restoreData.base.width.value.id);

                vm.loadingSplashOpen = false;
                vm.restoreable = false;

                vm.openEditor();

                __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');
            }, function (response) {
                vm.record = false;
                vm.loadingSplashOpen = false;
                vm.showPreloader = false;
                vm.restoreable = false;

                vm.$modal.show('dialog', {
                    title: vm._i18n.t('error.restore.label'),
                    text: response.data.error || vm._i18n.t('error.restore.body'),
                    buttons: [{
                        title: vm._i18n.t('error.restore.confirm')
                    }]
                });
            });
        },
        displayLeavingEditorWarning: function displayLeavingEditorWarning(event) {
            if (0 === this.plexipeople.length && 0 === this.images.length) {
                return false;
            }

            event.preventDefault();

            return event.returnValue = this._i18n.t('app.leavingEditorWarning');
        },
        addLeavingEditorEventListener: function addLeavingEditorEventListener() {
            if (true === this.leavingEditorEventListenerRegistered) {
                return;
            }

            window.addEventListener('beforeunload', this.displayLeavingEditorWarning);
            this.leavingEditorEventListenerRegistered = true;
        },
        removeLeavingEditorEventListener: function removeLeavingEditorEventListener() {
            if (false === this.leavingEditorEventListenerRegistered) {
                return;
            }

            window.removeEventListener('beforeunload', this.displayLeavingEditorWarning);
            this.leavingEditorEventListenerRegistered = false;
        },
        onResize: function onResize(event) {
            var oldWidth = this.viewport.width,
                oldHeight = this.viewport.height;

            this.setViewportWidth(event.target.innerWidth);
            this.setViewportHeight(event.target.innerHeight);

            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('resized', {
                oldWidth: oldWidth,
                oldHeight: oldHeight,
                newWidth: this.viewport.width,
                newHeight: this.viewport.height
            });
        },
        setViewportWidth: function setViewportWidth(width) {
            this.viewport.width = width;
        },
        setViewportHeight: function setViewportHeight(height) {
            this.viewport.height = height;
        },
        setViewportFactor: function setViewportFactor(factor) {
            this.viewport.factor = factor;
        },
        closePraise: function closePraise() {
            this.openPraise = false;
        },
        startIntroDelayedBy: function startIntroDelayedBy(view) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
            var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var blockNextCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            var vm = this;

            window.setTimeout(function () {
                return vm.startIntro(view, force, blockNextCall);
            }, delay);
        },
        startIntro: function startIntro(view) {
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var blockNextCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var previousState = this.introJsShown[view] || 0;

            if (!force && 1 === previousState) {
                return;
            }

            this.introJsShown[view] = blockNextCall ? 1 : 0;
            this.introJsInstance = this.$intro();
            this.introJsMessages = [];

            this.introJsInstance.setOptions({
                exitOnOverlayClick: false,
                disableInteraction: !this.extractorOpen,
                nextLabel: 'Weiter',
                prevLabel: 'Zurück',
                skipLabel: 'Skip',
                doneLabel: 'Ok',
                hidePrev: true,
                hideNext: true,
                tooltipPosition: "bottom-middle"
            });

            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('collectIntroJsSteps', {
                view: view,
                instance: this.introJsMessages
            });

            this.introJsMessages.sort(function (a, b) {
                return a.step > b.step ? 1 : b.step > a.step ? -1 : 0;
            });
            this.introJsInstance.addSteps(this.introJsMessages);
            this.introJsInstance.start();

            this.$cookies.set('introJsShown', JSON.stringify(this.introJsShown), '7d');
        },
        getIntroVideoSize: function getIntroVideoSize() {
            var style = window.getComputedStyle(this.$refs["player"], null),
                size = Math.round(parseFloat(style.getPropertyValue("height")));

            if (size > this.viewport.width) {
                size = this.viewport.width;
            }

            return size - 20;
        },
        initIntroVideo: function initIntroVideo() {
            var _this2 = this;

            this.introVideoShown = false;

            var size = this.getIntroVideoSize();

            this.player = new __WEBPACK_IMPORTED_MODULE_14__vimeo_player__["a" /* default */]('player', {
                id: "366764812",
                width: size,
                controls: false
            });

            this.player.element.style.width = size + "px";
            this.player.element.style.height = size + "px";

            this.player.setVolume(0);
            this.player.play();

            this.player.on("loaded", function () {
                _this2.videoLoaded = true;
            });

            this.player.on("ended", function () {
                _this2.introVideoShown = true;
                _this2.videoLoaded = false;

                _this2.player.destroy();
            });
        }
    },

    beforeCreate: function beforeCreate() {
        var beforeCreate = App.events.beforeCreate;


        if ("function" === typeof beforeCreate) {
            beforeCreate();
        }

        new Image().src = "/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg";
    },
    created: function created() {
        var created = App.events.created;


        if ("function" === typeof created) {
            created();
        }

        window.addEventListener('resize', this.onResize);
        this.addLeavingEditorEventListener();
        document.body.style['overscroll-behavior'] = 'contain';
    },
    beforeMount: function beforeMount() {
        var beforeMount = App.events.beforeMount;


        if ("function" === typeof beforeMount) {
            beforeMount();
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        var mounted = App.events.mounted;


        if ("function" === typeof mounted) {
            mounted();
        }

        this.setViewportWidth(window.innerWidth);

        // console.log({
        //     'this.viewport.height': this.viewport.height,
        //     'this.$refs[\'navigation\'].$el': this.$refs['navigation'].$el,
        //     'this.$refs[\'navigation\'].$el.offsetHeight': this.$refs['navigation'].$el.offsetHeight,
        //     'availableHeight': this.viewport.height - this.$refs['navigation'].$el.offsetHeight,
        // });

        this.availableHeight = this.viewport.height - this.$refs['navigation'].$el.offsetHeight;

        this.loadingSplashOpen = false;

        if (!this.record) {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');
        } else {
            this.restoreable = true;
            this.closeExtractor(true);
        }

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('startBrowserPreloading', this.openBrowserPeloadingSplash);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('finishedBrowserPreloading', this.closeBrowserPeloadingSplash);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('widthChanged', this.disableAutoWidth);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('addLeavingEditorEventListener', this.addLeavingEditorEventListener);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('removeLeavingEditorEventListener', this.removeLeavingEditorEventListener);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('startIntroDelayedBy', this.startIntroDelayedBy);

        if (this.showIntroVideo) {
            window.setTimeout(function () {
                _this3.initIntroVideo();
            }, 1000);
        }
    },
    beforeDestroy: function beforeDestroy() {
        var beforeDestroy = App.events.beforeDestroy;


        if ("function" === typeof beforeDestroy) {
            beforeDestroy();
        }

        window.removeEventListener('resize', this.onResize);

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('startBrowserPreloading', this.openBrowserPeloadingSplash);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('closeBrowserPreloading', this.closeBrowserPeloadingSplash);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('widthChanged', this.disableAutoWidth);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('addLeavingEditorEventListener', this.addLeavingEditorEventListener);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('removeLeavingEditorEventListener', this.removeLeavingEditorEventListener);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('startIntroDelayedBy', this.startIntroDelayedBy);

        document.body.style['overscroll-behavior'] = 'unset';
    },


    components: {
        Praise: __WEBPACK_IMPORTED_MODULE_15__components_Praise__["a" /* default */],
        InAppBrowserTutorial: __WEBPACK_IMPORTED_MODULE_3__components_InAppBrowserTurorial__["a" /* default */],
        AppLoadingSplash: __WEBPACK_IMPORTED_MODULE_4__components_LoadingSplash__["a" /* default */],
        AppNavigation: __WEBPACK_IMPORTED_MODULE_5__components_Navigation__["a" /* default */],
        AppExtractor: __WEBPACK_IMPORTED_MODULE_6__components_ClipPath__["a" /* default */],
        AppEditor: __WEBPACK_IMPORTED_MODULE_7__components_Editor__["a" /* default */],
        AppPlexipeopleVisualization: __WEBPACK_IMPORTED_MODULE_8__components_PlexipeopleVisualization__["a" /* default */],
        AppPriceList: __WEBPACK_IMPORTED_MODULE_9__components_PriceList__["a" /* default */],
        AppBase: __WEBPACK_IMPORTED_MODULE_10__components_Base__["a" /* default */],
        AppBuyButton: __WEBPACK_IMPORTED_MODULE_11__components_BuyButton__["a" /* default */]
    }
});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.3 2018-09-08*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo (3DS|Switch)",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "GoogleTablet": "Android.*Pixel C",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304F|TB-X304L|TB-8703F|Tab2A7-10F|TB2-X30L",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android.*\\bG1\\b(?!\\))",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9|TECNO DP8D",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "WeChat": "\\bMicroMessenger\\b",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Puffin": "Puffin",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UCBrowser": [
            "UCWEB[VER]",
            "UC.*Browser\/[VER]"
        ],
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    function prepareUserAgent(userAgent) {
        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = prepareUserAgent(userAgent);
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin,
         * Mercury, ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin,
         * Mercury, ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.4.3 2018-09-08';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (true) {
        return __webpack_require__(236);
    } else if (typeof window !== 'undefined') {
        return function (factory) { window.MobileDetect = factory(); };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
})());

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uploader__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Guide__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gtag__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        images: Array,
        plexipeople: Array,
        enableButtons: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        removeClicked: function removeClicked() {
            Object(__WEBPACK_IMPORTED_MODULE_3__gtag__["a" /* gtag_event */])('Button Löschen');
            this.$emit('remove');
        },
        editClicked: function editClicked() {
            Object(__WEBPACK_IMPORTED_MODULE_3__gtag__["a" /* gtag_event */])('Button Bearbeiten');
            this.$emit('openExtractor', undefined, undefined, true);
        },
        infoClicked: function infoClicked() {
            Object(__WEBPACK_IMPORTED_MODULE_3__gtag__["a" /* gtag_event */])('Button Anleitung');
            this.$emit('startIntro');
        },
        addImage: function addImage(file) {
            this.$emit("addImage", file);
        },
        completeImage: function completeImage(file) {
            this.$emit("completeImage", file);
        },
        registerIntroJsStep: function registerIntroJsStep(config) {
            if ('navigation' !== config.view) {
                return;
            }

            if (0 === this.plexipeople.length) {
                config.instance.push({
                    element: this.$refs['intro-upload'],
                    intro: 'Lade hier Dein Foto hoch.',
                    step: 10
                });

                return;
            }

            config.instance.push({
                element: this.$refs['intro-clipping'],
                intro: 'Möchtest Du Dein markiertes Element noch\n' + 'einmal überarbeiten, dann klicke hier.',
                step: 30
            });

            config.instance.push({
                element: this.$refs['intro-delete'],
                intro: 'Hier kannst Du das aktuelle Element löschen',
                step: 40
            });

            config.instance.push({
                element: this.$refs['intro-upload'],
                intro: 'Möchtest Du ein mehrteiliges Plexipeople bestellen, dann lade hier ein\n' + '<span>weiteres</span> Foto hoch.',
                step: 100
            });
        }
    },

    created: function created() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('collectIntroJsSteps', this.registerIntroJsStep);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('collectIntroJsSteps', this.registerIntroJsStep);
    },


    components: {
        AppUploader: __WEBPACK_IMPORTED_MODULE_1__Uploader__["a" /* default */],
        AppGuide: __WEBPACK_IMPORTED_MODULE_2__Guide__["a" /* default */]
    }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_detect__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobile_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_compress_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_compress_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_compress_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_convertingMixin__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gtag__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiff_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiff_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_tiff_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_exif_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_exif_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_exif_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blueimp_load_image__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blueimp_load_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_blueimp_load_image__);
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            compressor: new __WEBPACK_IMPORTED_MODULE_4_compress_js___default.a(),
            uploader: false,
            files: [],
            errors: [],
            chunkSize: '1mb',
            maxFileCount: 1,
            minFileSize: '100kb',
            maxFileSize: '25mb',
            mimeTypes: [{ 'title': 'Image files', 'extensions': 'jpg,jpeg,png,tif,tiff' }],
            uploadFinished: false,
            interval: false,
            countdown: 0
        };
    },


    props: {
        eventPrefix: {
            type: String,
            default: function _default() {
                return '';
            }
        },

        classes: {
            type: Object,
            default: function _default() {
                return {};
            }
        },

        styles: {
            type: Object,
            default: function _default() {
                return {};
            }
        },

        timeout: {
            type: Number,
            default: 5
        },

        modalWidth: {
            default: function _default() {
                return new __WEBPACK_IMPORTED_MODULE_1_mobile_detect___default.a(window.navigator.userAgent).mobile() ? 300 : 600;
            }
        },

        modalHeight: {
            default: function _default() {
                return 'auto';
            }
        }
    },

    methods: {
        convertErrorToMessage: function convertErrorToMessage(error) {
            var messageKey = void 0;

            switch (error.code) {
                case -600:
                    var minSize = __WEBPACK_IMPORTED_MODULE_3_plupload___default.a.parseSize(this.minFileSize);

                    if (error.file.origSize < minSize) {
                        messageKey = 'uploader.minSizeViolation';
                    } else {
                        messageKey = 'uploader.maxSizeViolation';
                    }
                    break;

                case -601:
                    messageKey = 'uploader.fileTypeViolation';
                    break;

                default:
                    messageKey = 'uploader.unknownError';
            }

            return this._i18n.t(messageKey);
        },
        add: function add(file) {
            this.$emit('added', file);
        },
        complete: function complete(file) {
            this.$emit('completed', file);
        },
        reset: function reset() {
            this.files = [];
            this.errors = [];
            this.uploadFinished = false;
            window.clearInterval(this.interval);
            this.countdown = 0;
        },
        close: function close() {
            if (this.uploadFinished) {
                this.$emit('finished');
            }

            this.reset();
        },
        loadFileIntoCanvas: function loadFileIntoCanvas(file) {
            var _this = this;

            return new Promise(function (resolve, reject) {
                switch (file.type) {
                    case "image/tiff":
                        var reader = new FileReader();

                        reader.onload = function (ev) {
                            __WEBPACK_IMPORTED_MODULE_8_tiff_js___default.a.initialize({ TOTAL_MEMORY: 30000000 }); // 30MB

                            var tiff = new __WEBPACK_IMPORTED_MODULE_8_tiff_js___default.a({ buffer: ev.target.result }),
                                canvas = tiff.toCanvas();

                            resolve(canvas);
                        };

                        reader.readAsArrayBuffer(file.getNative());
                        break;

                    default:
                        __WEBPACK_IMPORTED_MODULE_10_blueimp_load_image___default()(_this.createUrlToFile(file.getNative()), function (img) {
                            resolve(img);
                        }, {
                            maxWidth: 2000,
                            maxHeight: 2000,
                            minWidth: 100,
                            minHeight: 100,
                            canvas: true
                        });
                    /*
                                                let image = new Image();
                    
                                                image.onload = () => {
                                                    let canvas  = document.createElement("canvas"),
                                                        context = canvas.getContext("2d");
                                                    EXIF.getData(image, function() {
                                                        let width       = image.width,
                                                            height      = image.height,
                                                            orientation = EXIF.getTag(this, "Orientation"),
                                                            max         = 2000;
                    
                                                        if (Math.pow(max, 2) < width * height) {
                                                            let factor = 1;
                    
                                                            if (width > height) {
                                                                factor = max / width;
                                                            } else {
                                                                factor = max / height;
                                                            }
                    
                                                            width  *= factor;
                                                            height *= factor;
                                                        }
                    
                                                        canvas.width  = width;
                                                        canvas.height = height;
                    
                                                        context.save();
                    
                                                        switch (orientation) {
                                                            case 3:
                                                                context.translate(width, height);
                                                                context.rotate(180 * Math.PI / 180);
                                                                break;
                    
                                                            case 6:
                                                                if (canvas.width >= canvas.height) {
                                                                    // noinspection JSSuspiciousNameCombination
                                                                    canvas.width = height;
                    
                                                                    // noinspection JSSuspiciousNameCombination
                                                                    canvas.height = width;
                    
                                                                    context.rotate(90 * Math.PI / 180);
                                                                    context.translate(0, -height);
                                                                    }
                                                                break;
                    
                                                            case 8:
                                                                if (canvas.width >= canvas.height) {
                                                                    // noinspection JSSuspiciousNameCombination
                                                                    canvas.width = height;
                    
                                                                    // noinspection JSSuspiciousNameCombination
                                                                    canvas.height = width;
                    
                                                                    // noinspection JSSuspiciousNameCombination
                                                                    context.translate(0, width);
                                                                    context.rotate(-90 * Math.PI / 180);
                                                                }
                                                                break;
                                                        }
                    
                                                        context.drawImage(image, 0, 0, width, height);
                                                        context.restore();
                    
                                                        resolve(canvas);
                                                    });
                                                };
                    
                                                image.src = this.createUrlToFile(file.getNative());
                                                break;
                    
                     */
                }
            });
        },
        getImageDimensions: function getImageDimensions(imageUrl) {
            var image = new Image();

            return new Promise(function (resolve, reject) {
                image.onload = function () {
                    resolve({
                        image: image,
                        insufficientQuality: image.width < 800 || image.height < 800
                    });
                };

                // image.onerror = event => {};

                image.src = imageUrl;
            });
        }
    },

    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off(this.eventPrefix + '_triggerUploadButton', this.$el.firstChild.click);
    },
    mounted: function mounted() {
        var _this2 = this;

        var vm = this;

        __WEBPACK_IMPORTED_MODULE_3_plupload___default.a.addFileFilter('min_file_size', function (minSize, file, cb) {
            var undef = void 0;

            minSize = __WEBPACK_IMPORTED_MODULE_3_plupload___default.a.parseSize(minSize);

            // Invalid file size
            if (file.size !== undef && minSize && file.size < minSize) {
                this.trigger('Error', {
                    code: __WEBPACK_IMPORTED_MODULE_3_plupload___default.a.FILE_SIZE_ERROR,
                    message: __WEBPACK_IMPORTED_MODULE_3_plupload___default.a.translate('File size error.'),
                    file: file
                });
                cb(false);
            } else {
                cb(true);
            }
        });

        var isInAppBrowser = function () {
            var ua = navigator.userAgent || navigator.vendor || window.opera;

            return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
        }();

        (vm.uploader = new __WEBPACK_IMPORTED_MODULE_3_plupload___default.a.Uploader({
            browse_button: vm.$el.firstChild,
            runtimes: 'html5',
            url: App.url.upload,
            chunk_size: vm.chunkSize,
            max_file_count: vm.maxFileCount,
            filters: {
                min_file_size: vm.minFileSize,
                max_file_size: vm.maxFileSize,
                mime_types: vm.mimeTypes,
                prevent_duplicates: true
            },
            init: {
                PostInit: function PostInit(up) {
                    if (!isInAppBrowser) {
                        return;
                    }

                    var uploads = document.querySelectorAll('input[type="file"]'),
                        i = 0;

                    for (; i < uploads.length; i++) {
                        uploads[i].removeAttribute('accept');
                    }
                },


                Browse: function Browse(up) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__gtag__["a" /* gtag_event */])('Button Bildupload');
                },

                FilesAdded: function FilesAdded(up, files) {
                    while (files.length > vm.maxFileCount) {
                        up.removeFile(files.pop());
                    }

                    var length = files.length;
                    vm.files = files;

                    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit("startBrowserPreloading");

                    var filesAdded = function filesAdded() {
                        if (0 === --length) {
                            vm.$emit('filesAdded', vm.files);
                            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit("finishedBrowserPreloading");
                        }
                    };

                    var config = {
                        size: 1,
                        quality: 1,
                        maxWidth: 640,
                        maxHeight: 480,
                        resize: true
                    };

                    files.forEach(function (file, idx) {
                        function proceed(canvas) {
                            canvas.toBlob(function (blob) {
                                vm.compressor.compress([blob], config).then(function (results) {
                                    var compressedImage = ['data:', results[0].ext, ';base64,', results[0].data].join("");

                                    file.uuid = Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* generateRandomID */])();
                                    file.leonardo = {
                                        fileUrl: compressedImage,
                                        info: false
                                    };

                                    vm.add(file);
                                }).then(filesAdded).catch(function (error) {
                                    filesAdded();
                                });
                            });

                            up.start();
                        }

                        vm.loadFileIntoCanvas(file).then(function (canvas) {
                            vm.getImageDimensions(canvas.toDataURL("image/png")).then(function (info) {
                                if (info.insufficientQuality) {
                                    vm.$modal.show('dialog', {
                                        title: vm._i18n.t('hint.handles.title'),
                                        text: vm._i18n.t('uploader.insufficientQualityViolation'),
                                        buttons: [{
                                            title: vm._i18n.t('uploader.buttonForce'),
                                            handler: function handler() {
                                                proceed(canvas);
                                                vm.$modal.hide('dialog');
                                            }
                                        }, {
                                            title: vm._i18n.t('uploader.buttonTryOtherImages'),
                                            handler: function handler() {
                                                up.removeFile(files.pop());
                                                vm.$el.firstChild.click();
                                                vm.$modal.hide('dialog');
                                            }
                                        }]
                                    });

                                    return;
                                }

                                proceed(canvas);
                            });
                        });
                    });
                },
                FilesRemoved: function FilesRemoved(up, files) {},
                BeforeUpload: function BeforeUpload(up, file) {
                    file.origName = file.name;
                    file.name = new Date().getTime() + '_' + file.name.replace(/([^0-9a-zA-Z\.\-\_]+)/g, '_');
                },
                UploadProgress: function UploadProgress(up, file) {
                    __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.set(up.total.percent / 110);
                },
                FileUploaded: function FileUploaded(up, file, xhr) {
                    var response = JSON.parse(xhr.response);

                    file.leonardo = {
                        fileUrl: response.fileUrl,
                        originUrl: response.originUrl,
                        info: response.info
                    };

                    vm.complete(file);
                },
                UploadComplete: function UploadComplete(up, files) {
                    // files.forEach(file => vm.add(file));

                    up.splice();
                    up.refresh();

                    vm.uploadFinished = true;

                    // NProgress.done();
                    // NProgress.remove();

                    if (0 < vm.errors.length) {
                        return;
                    }

                    vm.countdown = vm.timeout;
                    vm.interval = window.setInterval(function () {
                        vm.countdown--;

                        if (vm.countdown > 0) {
                            return;
                        }

                        vm.close();
                    }, 1000);
                },
                Error: function Error(up, args) {
                    var text = vm.convertErrorToMessage(args);

                    vm.$modal.show('dialog', {
                        title: vm._i18n.t('hint.handles.title'),
                        text: text,
                        buttons: [{
                            title: vm._i18n.t('hint.autoWidth.confirm'),
                            handler: function handler() {
                                vm.$modal.hide('dialog');
                            }
                        }]
                    });

                    __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.remove();
                }
            }
        })).init();

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.eventPrefix + '_triggerUploadButton', function () {
            return _this2.$el.firstChild.click();
        });
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_convertingMixin__["a" /* converting */]]
});

/***/ }),
/* 140 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {



/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(2).Buffer
var Transform = __webpack_require__(96).Transform
var inherits = __webpack_require__(1)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(73);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(140);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(97).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(145);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(2).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(63);
util.inherits = __webpack_require__(1);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(258);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(259);
var destroyImpl = __webpack_require__(146);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(44);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(100).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(44);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(100).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(28)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97).EventEmitter;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(73);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(44);

/*<replacement>*/
var util = __webpack_require__(63);
util.inherits = __webpack_require__(1);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(1)
var Hash = __webpack_require__(55)
var Buffer = __webpack_require__(2).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1)
var Hash = __webpack_require__(55)
var Buffer = __webpack_require__(2).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(1)
var Legacy = __webpack_require__(271)
var Base = __webpack_require__(40)
var Buffer = __webpack_require__(2).Buffer
var md5 = __webpack_require__(151)
var RIPEMD160 = __webpack_require__(101)

var sha = __webpack_require__(102)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(95)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(273)
exports.pbkdf2Sync = __webpack_require__(156)


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(151)
var RIPEMD160 = __webpack_require__(101)
var sha = __webpack_require__(102)

var checkParameters = __webpack_require__(154)
var defaultEncoding = __webpack_require__(155)
var Buffer = __webpack_require__(2).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(64)
var Buffer = __webpack_require__(2).Buffer
var incr32 = __webpack_require__(158)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 158 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(74)
var Buffer = __webpack_require__(2).Buffer
var Transform = __webpack_require__(40)
var inherits = __webpack_require__(1)
var GHASH = __webpack_require__(288)
var xor = __webpack_require__(64)
var incr32 = __webpack_require__(158)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(74)
var Buffer = __webpack_require__(2).Buffer
var Transform = __webpack_require__(40)
var inherits = __webpack_require__(1)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(54);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(11);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(164);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(11);
var brorand = __webpack_require__(165);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(293);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var common = __webpack_require__(65);
var shaCommon = __webpack_require__(167);
var assert = __webpack_require__(23);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var common = __webpack_require__(65);
var assert = __webpack_require__(23);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);
var Reporter = __webpack_require__(67).Reporter;
var Buffer = __webpack_require__(14).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(325);


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);

var asn1 = __webpack_require__(66);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);
var Buffer = __webpack_require__(14).Buffer;

var asn1 = __webpack_require__(66);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(62)
var Buffer = __webpack_require__(2).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(11)
var Buffer = __webpack_require__(2).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Scaling
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var originalTransform = loadImage.transform

  loadImage.createCanvas = function (width, height, offscreen) {
    if (offscreen && loadImage.global.OffscreenCanvas) {
      return new OffscreenCanvas(width, height)
    }
    var canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    return canvas
  }

  loadImage.transform = function (img, options, callback, file, data) {
    originalTransform.call(
      loadImage,
      loadImage.scale(img, options, data),
      options,
      callback,
      file,
      data
    )
  }

  // Transform image coordinates, allows to override e.g.
  // the canvas orientation based on the orientation option,
  // gets canvas, options and data passed as arguments:
  loadImage.transformCoordinates = function () {}

  // Returns transformed options, allows to override e.g.
  // maxWidth, maxHeight and crop options based on the aspectRatio.
  // gets img, options, data passed as arguments:
  loadImage.getTransformedOptions = function (img, options) {
    var aspectRatio = options.aspectRatio
    var newOptions
    var i
    var width
    var height
    if (!aspectRatio) {
      return options
    }
    newOptions = {}
    for (i in options) {
      if (Object.prototype.hasOwnProperty.call(options, i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.crop = true
    width = img.naturalWidth || img.width
    height = img.naturalHeight || img.height
    if (width / height > aspectRatio) {
      newOptions.maxWidth = height * aspectRatio
      newOptions.maxHeight = height
    } else {
      newOptions.maxWidth = width
      newOptions.maxHeight = width / aspectRatio
    }
    return newOptions
  }

  // Canvas render method, allows to implement a different rendering algorithm:
  loadImage.drawImage = function (
    img,
    canvas,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    destWidth,
    destHeight,
    options
  ) {
    var ctx = canvas.getContext('2d')
    if (options.imageSmoothingEnabled === false) {
      ctx.msImageSmoothingEnabled = false
      ctx.imageSmoothingEnabled = false
    } else if (options.imageSmoothingQuality) {
      ctx.imageSmoothingQuality = options.imageSmoothingQuality
    }
    ctx.drawImage(
      img,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      0,
      0,
      destWidth,
      destHeight
    )
    return ctx
  }

  // Determines if the target image should be a canvas element:
  loadImage.requiresCanvas = function (options) {
    return options.canvas || options.crop || !!options.aspectRatio
  }

  // Scales and/or crops the given image (img or canvas HTML element)
  // using the given options:
  loadImage.scale = function (img, options, data) {
    // eslint-disable-next-line no-param-reassign
    options = options || {}
    // eslint-disable-next-line no-param-reassign
    data = data || {}
    var useCanvas =
      img.getContext ||
      (loadImage.requiresCanvas(options) &&
        !!loadImage.global.HTMLCanvasElement)
    var width = img.naturalWidth || img.width
    var height = img.naturalHeight || img.height
    var destWidth = width
    var destHeight = height
    var maxWidth
    var maxHeight
    var minWidth
    var minHeight
    var sourceWidth
    var sourceHeight
    var sourceX
    var sourceY
    var pixelRatio
    var downsamplingRatio
    var tmp
    var canvas
    /**
     * Scales up image dimensions
     */
    function scaleUp() {
      var scale = Math.max(
        (minWidth || destWidth) / destWidth,
        (minHeight || destHeight) / destHeight
      )
      if (scale > 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    /**
     * Scales down image dimensions
     */
    function scaleDown() {
      var scale = Math.min(
        (maxWidth || destWidth) / destWidth,
        (maxHeight || destHeight) / destHeight
      )
      if (scale < 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    if (useCanvas) {
      // eslint-disable-next-line no-param-reassign
      options = loadImage.getTransformedOptions(img, options, data)
      sourceX = options.left || 0
      sourceY = options.top || 0
      if (options.sourceWidth) {
        sourceWidth = options.sourceWidth
        if (options.right !== undefined && options.left === undefined) {
          sourceX = width - sourceWidth - options.right
        }
      } else {
        sourceWidth = width - sourceX - (options.right || 0)
      }
      if (options.sourceHeight) {
        sourceHeight = options.sourceHeight
        if (options.bottom !== undefined && options.top === undefined) {
          sourceY = height - sourceHeight - options.bottom
        }
      } else {
        sourceHeight = height - sourceY - (options.bottom || 0)
      }
      destWidth = sourceWidth
      destHeight = sourceHeight
    }
    maxWidth = options.maxWidth
    maxHeight = options.maxHeight
    minWidth = options.minWidth
    minHeight = options.minHeight
    if (useCanvas && maxWidth && maxHeight && options.crop) {
      destWidth = maxWidth
      destHeight = maxHeight
      tmp = sourceWidth / sourceHeight - maxWidth / maxHeight
      if (tmp < 0) {
        sourceHeight = (maxHeight * sourceWidth) / maxWidth
        if (options.top === undefined && options.bottom === undefined) {
          sourceY = (height - sourceHeight) / 2
        }
      } else if (tmp > 0) {
        sourceWidth = (maxWidth * sourceHeight) / maxHeight
        if (options.left === undefined && options.right === undefined) {
          sourceX = (width - sourceWidth) / 2
        }
      }
    } else {
      if (options.contain || options.cover) {
        minWidth = maxWidth = maxWidth || minWidth
        minHeight = maxHeight = maxHeight || minHeight
      }
      if (options.cover) {
        scaleDown()
        scaleUp()
      } else {
        scaleUp()
        scaleDown()
      }
    }
    if (useCanvas) {
      pixelRatio = options.pixelRatio
      if (
        pixelRatio > 1 &&
        // Check if the image has not yet had the device pixel ratio applied:
        !(
          img.style.width &&
          Math.floor(parseFloat(img.style.width, 10)) ===
            Math.floor(width / pixelRatio)
        )
      ) {
        destWidth *= pixelRatio
        destHeight *= pixelRatio
      }
      // Check if workaround for Chromium orientation crop bug is required:
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1074354
      if (
        loadImage.orientationCropBug &&
        !img.getContext &&
        (sourceX || sourceY || sourceWidth !== width || sourceHeight !== height)
      ) {
        // Write the complete source image to an intermediate canvas first:
        tmp = img
        // eslint-disable-next-line no-param-reassign
        img = loadImage.createCanvas(width, height, true)
        loadImage.drawImage(
          tmp,
          img,
          0,
          0,
          width,
          height,
          width,
          height,
          options
        )
      }
      downsamplingRatio = options.downsamplingRatio
      if (
        downsamplingRatio > 0 &&
        downsamplingRatio < 1 &&
        destWidth < sourceWidth &&
        destHeight < sourceHeight
      ) {
        while (sourceWidth * downsamplingRatio > destWidth) {
          canvas = loadImage.createCanvas(
            sourceWidth * downsamplingRatio,
            sourceHeight * downsamplingRatio,
            true
          )
          loadImage.drawImage(
            img,
            canvas,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            canvas.width,
            canvas.height,
            options
          )
          sourceX = 0
          sourceY = 0
          sourceWidth = canvas.width
          sourceHeight = canvas.height
          // eslint-disable-next-line no-param-reassign
          img = canvas
        }
      }
      canvas = loadImage.createCanvas(destWidth, destHeight)
      loadImage.transformCoordinates(canvas, options, data)
      if (pixelRatio > 1) {
        canvas.style.width = canvas.width / pixelRatio + 'px'
      }
      loadImage
        .drawImage(
          img,
          canvas,
          sourceX,
          sourceY,
          sourceWidth,
          sourceHeight,
          destWidth,
          destHeight,
          options
        )
        .setTransform(1, 0, 0, 1, 0, 0) // reset to the identity matrix
      return canvas
    }
    img.width = destWidth
    img.height = destHeight
    return img
  }
})


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, DataView */

/* eslint-disable no-console */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34), __webpack_require__(78)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  /**
   * Exif tag map
   *
   * @name ExifMap
   * @class
   * @param {number|string} tagCode IFD tag code
   */
  function ExifMap(tagCode) {
    if (tagCode) {
      Object.defineProperty(this, 'map', {
        value: this.ifds[tagCode].map
      })
      Object.defineProperty(this, 'tags', {
        value: (this.tags && this.tags[tagCode]) || {}
      })
    }
  }

  ExifMap.prototype.map = {
    Orientation: 0x0112,
    Thumbnail: 'ifd1',
    Blob: 0x0201, // Alias for JPEGInterchangeFormat
    Exif: 0x8769,
    GPSInfo: 0x8825,
    Interoperability: 0xa005
  }

  ExifMap.prototype.ifds = {
    ifd1: { name: 'Thumbnail', map: ExifMap.prototype.map },
    0x8769: { name: 'Exif', map: {} },
    0x8825: { name: 'GPSInfo', map: {} },
    0xa005: { name: 'Interoperability', map: {} }
  }

  /**
   * Retrieves exif tag value
   *
   * @param {number|string} id Exif tag code or name
   * @returns {object} Exif tag value
   */
  ExifMap.prototype.get = function (id) {
    return this[id] || this[this.map[id]]
  }

  /**
   * Returns the Exif Thumbnail data as Blob.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Thumbnail data offset
   * @param {number} length Thumbnail data length
   * @returns {undefined|Blob} Returns the Thumbnail Blob or undefined
   */
  function getExifThumbnail(dataView, offset, length) {
    if (!length) return
    if (offset + length > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid thumbnail data.')
      return
    }
    return new Blob(
      [loadImage.bufferSlice.call(dataView.buffer, offset, offset + length)],
      {
        type: 'image/jpeg'
      }
    )
  }

  var ExifTagTypes = {
    // byte, 8-bit unsigned int:
    1: {
      getValue: function (dataView, dataOffset) {
        return dataView.getUint8(dataOffset)
      },
      size: 1
    },
    // ascii, 8-bit byte:
    2: {
      getValue: function (dataView, dataOffset) {
        return String.fromCharCode(dataView.getUint8(dataOffset))
      },
      size: 1,
      ascii: true
    },
    // short, 16 bit int:
    3: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint16(dataOffset, littleEndian)
      },
      size: 2
    },
    // long, 32 bit int:
    4: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint32(dataOffset, littleEndian)
      },
      size: 4
    },
    // rational = two long values, first is numerator, second is denominator:
    5: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return (
          dataView.getUint32(dataOffset, littleEndian) /
          dataView.getUint32(dataOffset + 4, littleEndian)
        )
      },
      size: 8
    },
    // slong, 32 bit signed int:
    9: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getInt32(dataOffset, littleEndian)
      },
      size: 4
    },
    // srational, two slongs, first is numerator, second is denominator:
    10: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return (
          dataView.getInt32(dataOffset, littleEndian) /
          dataView.getInt32(dataOffset + 4, littleEndian)
        )
      },
      size: 8
    }
  }
  // undefined, 8-bit byte, value depending on field:
  ExifTagTypes[7] = ExifTagTypes[1]

  /**
   * Returns Exif tag value.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {number} offset Tag offset
   * @param {number} type Tag type
   * @param {number} length Tag length
   * @param {boolean} littleEndian Little endian encoding
   * @returns {object} Tag value
   */
  function getExifValue(
    dataView,
    tiffOffset,
    offset,
    type,
    length,
    littleEndian
  ) {
    var tagType = ExifTagTypes[type]
    var tagSize
    var dataOffset
    var values
    var i
    var str
    var c
    if (!tagType) {
      console.log('Invalid Exif data: Invalid tag type.')
      return
    }
    tagSize = tagType.size * length
    // Determine if the value is contained in the dataOffset bytes,
    // or if the value at the dataOffset is a pointer to the actual data:
    dataOffset =
      tagSize > 4
        ? tiffOffset + dataView.getUint32(offset + 8, littleEndian)
        : offset + 8
    if (dataOffset + tagSize > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid data offset.')
      return
    }
    if (length === 1) {
      return tagType.getValue(dataView, dataOffset, littleEndian)
    }
    values = []
    for (i = 0; i < length; i += 1) {
      values[i] = tagType.getValue(
        dataView,
        dataOffset + i * tagType.size,
        littleEndian
      )
    }
    if (tagType.ascii) {
      str = ''
      // Concatenate the chars:
      for (i = 0; i < values.length; i += 1) {
        c = values[i]
        // Ignore the terminating NULL byte(s):
        if (c === '\u0000') {
          break
        }
        str += c
      }
      return str
    }
    return values
  }

  /**
   * Determines if the given tag should be included.
   *
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   * @param {number|string} tagCode Tag code to check
   * @returns {boolean} True if the tag should be included
   */
  function shouldIncludeTag(includeTags, excludeTags, tagCode) {
    return (
      (!includeTags || includeTags[tagCode]) &&
      (!excludeTags || excludeTags[tagCode] !== true)
    )
  }

  /**
   * Parses Exif tags.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {number} dirOffset Directory offset
   * @param {boolean} littleEndian Little endian encoding
   * @param {ExifMap} tags Map to store parsed exif tags
   * @param {ExifMap} tagOffsets Map to store parsed exif tag offsets
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   * @returns {number} Next directory offset
   */
  function parseExifTags(
    dataView,
    tiffOffset,
    dirOffset,
    littleEndian,
    tags,
    tagOffsets,
    includeTags,
    excludeTags
  ) {
    var tagsNumber, dirEndOffset, i, tagOffset, tagNumber, tagValue
    if (dirOffset + 6 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory offset.')
      return
    }
    tagsNumber = dataView.getUint16(dirOffset, littleEndian)
    dirEndOffset = dirOffset + 2 + 12 * tagsNumber
    if (dirEndOffset + 4 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory size.')
      return
    }
    for (i = 0; i < tagsNumber; i += 1) {
      tagOffset = dirOffset + 2 + 12 * i
      tagNumber = dataView.getUint16(tagOffset, littleEndian)
      if (!shouldIncludeTag(includeTags, excludeTags, tagNumber)) continue
      tagValue = getExifValue(
        dataView,
        tiffOffset,
        tagOffset,
        dataView.getUint16(tagOffset + 2, littleEndian), // tag type
        dataView.getUint32(tagOffset + 4, littleEndian), // tag length
        littleEndian
      )
      tags[tagNumber] = tagValue
      if (tagOffsets) {
        tagOffsets[tagNumber] = tagOffset
      }
    }
    // Return the offset to the next directory:
    return dataView.getUint32(dirEndOffset, littleEndian)
  }

  /**
   * Parses tags in a given IFD (Image File Directory).
   *
   * @param {object} data Data object to store exif tags and offsets
   * @param {number|string} tagCode IFD tag code
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {boolean} littleEndian Little endian encoding
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   */
  function parseExifIFD(
    data,
    tagCode,
    dataView,
    tiffOffset,
    littleEndian,
    includeTags,
    excludeTags
  ) {
    var dirOffset = data.exif[tagCode]
    if (dirOffset) {
      data.exif[tagCode] = new ExifMap(tagCode)
      if (data.exifOffsets) {
        data.exifOffsets[tagCode] = new ExifMap(tagCode)
      }
      parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + dirOffset,
        littleEndian,
        data.exif[tagCode],
        data.exifOffsets && data.exifOffsets[tagCode],
        includeTags && includeTags[tagCode],
        excludeTags && excludeTags[tagCode]
      )
    }
  }

  loadImage.parseExifData = function (dataView, offset, length, data, options) {
    if (options.disableExif) {
      return
    }
    var includeTags = options.includeExifTags
    var excludeTags = options.excludeExifTags || {
      0x8769: {
        // ExifIFDPointer
        0x927c: true // MakerNote
      }
    }
    var tiffOffset = offset + 10
    var littleEndian
    var dirOffset
    var thumbnailIFD
    // Check for the ASCII code for "Exif" (0x45786966):
    if (dataView.getUint32(offset + 4) !== 0x45786966) {
      // No Exif data, might be XMP data instead
      return
    }
    if (tiffOffset + 8 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid segment size.')
      return
    }
    // Check for the two null bytes:
    if (dataView.getUint16(offset + 8) !== 0x0000) {
      console.log('Invalid Exif data: Missing byte alignment offset.')
      return
    }
    // Check the byte alignment:
    switch (dataView.getUint16(tiffOffset)) {
      case 0x4949:
        littleEndian = true
        break
      case 0x4d4d:
        littleEndian = false
        break
      default:
        console.log('Invalid Exif data: Invalid byte alignment marker.')
        return
    }
    // Check for the TIFF tag marker (0x002A):
    if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002a) {
      console.log('Invalid Exif data: Missing TIFF marker.')
      return
    }
    // Retrieve the directory offset bytes, usually 0x00000008 or 8 decimal:
    dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian)
    // Create the exif object to store the tags:
    data.exif = new ExifMap()
    if (!options.disableExifOffsets) {
      data.exifOffsets = new ExifMap()
      data.exifTiffOffset = tiffOffset
      data.exifLittleEndian = littleEndian
    }
    // Parse the tags of the main image directory (IFD0) and retrieve the
    // offset to the next directory (IFD1), usually the thumbnail directory:
    dirOffset = parseExifTags(
      dataView,
      tiffOffset,
      tiffOffset + dirOffset,
      littleEndian,
      data.exif,
      data.exifOffsets,
      includeTags,
      excludeTags
    )
    if (dirOffset && shouldIncludeTag(includeTags, excludeTags, 'ifd1')) {
      data.exif.ifd1 = dirOffset
      if (data.exifOffsets) {
        data.exifOffsets.ifd1 = tiffOffset + dirOffset
      }
    }
    Object.keys(data.exif.ifds).forEach(function (tagCode) {
      parseExifIFD(
        data,
        tagCode,
        dataView,
        tiffOffset,
        littleEndian,
        includeTags,
        excludeTags
      )
    })
    thumbnailIFD = data.exif.ifd1
    // Check for JPEG Thumbnail offset and data length:
    if (thumbnailIFD && thumbnailIFD[0x0201]) {
      thumbnailIFD[0x0201] = getExifThumbnail(
        dataView,
        tiffOffset + thumbnailIFD[0x0201],
        thumbnailIFD[0x0202] // Thumbnail data length
      )
    }
  }

  // Registers the Exif parser for the APP1 JPEG metadata segment:
  loadImage.metaDataParsers.jpeg[0xffe1].push(loadImage.parseExifData)

  loadImage.exifWriters = {
    // Orientation writer:
    0x0112: function (buffer, data, value) {
      var orientationOffset = data.exifOffsets[0x0112]
      if (!orientationOffset) return buffer
      var view = new DataView(buffer, orientationOffset + 8, 2)
      view.setUint16(0, value, data.exifLittleEndian)
      return buffer
    }
  }

  loadImage.writeExifData = function (buffer, data, id, value) {
    return loadImage.exifWriters[data.exif.map[id]](buffer, data, value)
  }

  loadImage.ExifMap = ExifMap

  // Adds the following properties to the parseMetaData callback data:
  // - exif: The parsed Exif tags
  // - exifOffsets: The parsed Exif tag offsets
  // - exifTiffOffset: TIFF header offset (used for offset pointers)
  // - exifLittleEndian: little endian order if true, big endian if false

  // Adds the following options to the parseMetaData method:
  // - disableExif: Disables Exif parsing when true.
  // - disableExifOffsets: Disables storing Exif tag offsets when true.
  // - includeExifTags: A map of Exif tags to include for parsing.
  // - excludeExifTags: A map of Exif tags to exclude from parsing.
})


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image IPTC Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, DataView */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34), __webpack_require__(78)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  /**
   * IPTC tag map
   *
   * @name IptcMap
   * @class
   */
  function IptcMap() {}

  IptcMap.prototype.map = {
    ObjectName: 5
  }

  IptcMap.prototype.types = {
    0: 'Uint16', // ApplicationRecordVersion
    200: 'Uint16', // ObjectPreviewFileFormat
    201: 'Uint16', // ObjectPreviewFileVersion
    202: 'binary' // ObjectPreviewData
  }

  /**
   * Retrieves IPTC tag value
   *
   * @param {number|string} id IPTC tag code or name
   * @returns {object} IPTC tag value
   */
  IptcMap.prototype.get = function (id) {
    return this[id] || this[this.map[id]]
  }

  /**
   * Retrieves string for the given DataView and range
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Offset start
   * @param {number} length Offset length
   * @returns {string} String value
   */
  function getStringValue(dataView, offset, length) {
    var outstr = ''
    var end = offset + length
    for (var n = offset; n < end; n += 1) {
      outstr += String.fromCharCode(dataView.getUint8(n))
    }
    return outstr
  }

  /**
   * Retrieves tag value for the given DataView and range
   *
   * @param {number} tagCode tag code
   * @param {IptcMap} map IPTC tag map
   * @param {DataView} dataView Data view interface
   * @param {number} offset Range start
   * @param {number} length Range length
   * @returns {object} Tag value
   */
  function getTagValue(tagCode, map, dataView, offset, length) {
    if (map.types[tagCode] === 'binary') {
      return new Blob([dataView.buffer.slice(offset, offset + length)])
    }
    if (map.types[tagCode] === 'Uint16') {
      return dataView.getUint16(offset)
    }
    return getStringValue(dataView, offset, length)
  }

  /**
   * Combines IPTC value with existing ones.
   *
   * @param {object} value Existing IPTC field value
   * @param {object} newValue New IPTC field value
   * @returns {object} Resulting IPTC field value
   */
  function combineTagValues(value, newValue) {
    if (value === undefined) return newValue
    if (value instanceof Array) {
      value.push(newValue)
      return value
    }
    return [value, newValue]
  }

  /**
   * Parses IPTC tags.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} segmentOffset Segment offset
   * @param {number} segmentLength Segment length
   * @param {object} data Data export object
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   */
  function parseIptcTags(
    dataView,
    segmentOffset,
    segmentLength,
    data,
    includeTags,
    excludeTags
  ) {
    var value, tagSize, tagCode
    var segmentEnd = segmentOffset + segmentLength
    var offset = segmentOffset
    while (offset < segmentEnd) {
      if (
        dataView.getUint8(offset) === 0x1c && // tag marker
        dataView.getUint8(offset + 1) === 0x02 // record number, only handles v2
      ) {
        tagCode = dataView.getUint8(offset + 2)
        if (
          (!includeTags || includeTags[tagCode]) &&
          (!excludeTags || !excludeTags[tagCode])
        ) {
          tagSize = dataView.getInt16(offset + 3)
          value = getTagValue(tagCode, data.iptc, dataView, offset + 5, tagSize)
          data.iptc[tagCode] = combineTagValues(data.iptc[tagCode], value)
          if (data.iptcOffsets) {
            data.iptcOffsets[tagCode] = offset
          }
        }
      }
      offset += 1
    }
  }

  /**
   * Tests if field segment starts at offset.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Segment offset
   * @returns {boolean} True if '8BIM<EOT><EOT>' exists at offset
   */
  function isSegmentStart(dataView, offset) {
    return (
      dataView.getUint32(offset) === 0x3842494d && // Photoshop segment start
      dataView.getUint16(offset + 4) === 0x0404 // IPTC segment start
    )
  }

  /**
   * Returns header length.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Segment offset
   * @returns {number} Header length
   */
  function getHeaderLength(dataView, offset) {
    var length = dataView.getUint8(offset + 7)
    if (length % 2 !== 0) length += 1
    // Check for pre photoshop 6 format
    if (length === 0) {
      // Always 4
      length = 4
    }
    return length
  }

  loadImage.parseIptcData = function (dataView, offset, length, data, options) {
    if (options.disableIptc) {
      return
    }
    var markerLength = offset + length
    while (offset + 8 < markerLength) {
      if (isSegmentStart(dataView, offset)) {
        var headerLength = getHeaderLength(dataView, offset)
        var segmentOffset = offset + 8 + headerLength
        if (segmentOffset > markerLength) {
          // eslint-disable-next-line no-console
          console.log('Invalid IPTC data: Invalid segment offset.')
          break
        }
        var segmentLength = dataView.getUint16(offset + 6 + headerLength)
        if (offset + segmentLength > markerLength) {
          // eslint-disable-next-line no-console
          console.log('Invalid IPTC data: Invalid segment size.')
          break
        }
        // Create the iptc object to store the tags:
        data.iptc = new IptcMap()
        if (!options.disableIptcOffsets) {
          data.iptcOffsets = new IptcMap()
        }
        parseIptcTags(
          dataView,
          segmentOffset,
          segmentLength,
          data,
          options.includeIptcTags,
          options.excludeIptcTags || { 202: true } // ObjectPreviewData
        )
        return
      }
      // eslint-disable-next-line no-param-reassign
      offset += 1
    }
  }

  // Registers this IPTC parser for the APP13 JPEG metadata segment:
  loadImage.metaDataParsers.jpeg[0xffed].push(loadImage.parseIptcData)

  loadImage.IptcMap = IptcMap

  // Adds the following properties to the parseMetaData callback data:
  // - iptc: The iptc tags, parsed by the parseIptcData method

  // Adds the following options to the parseMetaData method:
  // - disableIptc: Disables IPTC parsing when true.
  // - disableIptcOffsets: Disables storing IPTC tag offsets when true.
  // - includeIptcTags: A map of IPTC tags to include for parsing.
  // - excludeIptcTags: A map of IPTC tags to exclude from parsing.
})


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    menuitem: Number
  },
  methods: {
    closeModal: function closeModal() {
      this.$emit('closeModal');
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shapes_configuration__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClipPath_Playground__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Offcanvas__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities__ = __webpack_require__(72);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var orientation = this.viewport.width < this.viewport.height ? 'portrait' : 'landscape';

        return {
            showPlayground: false,
            selectedImage: 0,
            isLoading: false,

            orientation: orientation,

            options: {
                width: 640,
                height: 480,
                maxWidth: 640,
                maxHeight: 480,
                shadowBoard: true
            },

            selectedIndex: 0,
            shapes: __WEBPACK_IMPORTED_MODULE_1__shapes_configuration__["a" /* default */],
            offcanvasMenuIsOpen: false,
            resizeOffsetTimeout: false,
            timeoutResizeFunction: false,
            offset: {
                x: 20,
                y: 0
            },
            handlesInitialized: false,
            handlesMoved: false,
            warningOpened: false
        };
    },


    props: {
        viewport: Object,
        config: Object,
        availableHeight: Number
    },

    computed: {
        insufficientQuality: function insufficientQuality() {
            var undef = void 0;

            if (undef === this.config.images[this.selectedImage].info) {
                return false;
            }

            return this.config.images[this.selectedImage].info['insufficient-quality'];
        },
        isLoadingActive: function isLoadingActive() {
            return 0 === this.config.images[this.selectedImage].completeTimestamp || this.isLoading;
        }
    },

    methods: {
        handlesReady: function handlesReady() {
            this.handlesInitialized = true;
            this.handlesMoved = false;
        },
        updateHandle: function updateHandle(payload, percental) {
            percental = percental || false;

            var x = payload.x,
                y = payload.y;

            if (!percental) {
                x = Math.round(x / this.options.width * 100);
                y = Math.round(y / this.options.height * 100);
            }

            if (this.handlesInitialized) {
                this.handlesMoved = true;
            }

            this.$set(this.config.coords, payload.i, [x, y]);
        },
        openOffcanvasMenu: function openOffcanvasMenu() {
            this.offcanvasMenuIsOpen = true;
        },
        closeOffcanvasMenu: function closeOffcanvasMenu() {
            this.offcanvasMenuIsOpen = false;
        },
        showHandlesNotMovedWarning: function showHandlesNotMovedWarning() {
            var _this = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            var vm = this;

            if (vm.handlesInitialized && !vm.handlesMoved && !vm.warningOpened) {
                vm.warningOpened = true;

                vm.$modal.show('dialog', {
                    title: vm._i18n.t('hint.handles.title'),
                    text: vm._i18n.t('hint.handles.text'),
                    buttons: [{
                        title: vm._i18n.t('hint.handles.button.left'),
                        handler: function handler() {
                            // console.log(callback);
                            callback();
                            _this.$modal.hide('dialog');
                        },
                        class: 'vue-dialog-button is--error'
                    }, {
                        title: vm._i18n.t('hint.handles.button.right'),
                        handler: function handler() {
                            vm.warningOpened = false;
                            _this.$modal.hide('dialog');
                        },
                        class: 'vue-dialog-button is--success'
                    }]
                });

                return true;
            }

            return false;
        },
        addExtractionAndNext: function addExtractionAndNext(event) {
            var vm = this;

            if (!this.config.editInPlace && this.showHandlesNotMovedWarning(function () {
                vm.addExtractionAndNext(event);
            })) {
                return;
            }

            this.addExtraction(event, function (extraction) {
                vm.$emit('addToEditor', extraction, false);
                vm.next();

                return false;
            });
        },
        addExtractionAndClose: function addExtractionAndClose(event) {
            var vm = this;

            if (!this.config.editInPlace && this.showHandlesNotMovedWarning(function () {
                vm.addExtractionAndClose(event);
            })) {
                return;
            }

            this.addExtraction(event, function (extraction) {
                vm.$emit('addToEditor', extraction, false);
                vm.close(true);

                return false;
            });
        },
        addExtraction: function addExtraction(event, callback) {
            this.isLoading = true;

            callback = callback || function () {};

            var vm = this,
                coords = Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["b" /* clipPoints */])(vm.config.coords),
                parent = vm.config.images[vm.selectedImage];

            __WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.start();

            vm.$http.post(App.url.clip, {
                source: Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["d" /* removeURIParams */])(parent.source),
                coords: coords
            }).then(
            // Successful
            function (response) {
                vm.isLoading = false;

                var extraction = {
                    parent: parent,
                    geometry: response.data.geometry,
                    source: response.data.pathToFile,
                    coords: JSON.parse(JSON.stringify(vm.config.coords)),
                    inUse: false,
                    uuid: Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* generateRandomID */])()
                };

                // TODO: Evaluate loading image dimensions by php
                vm.$emit('addExtraction', extraction);

                __WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.done();
                window.setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.remove();
                    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('Handles:reset');
                }, 500);

                if (vm.config.editInPlace) {
                    vm.$emit('addToEditor', extraction, false, vm.config.target);
                    vm.close(true);

                    return;
                }

                if (false === callback.call(vm, extraction)) {
                    return;
                }

                if (vm.offcanvasMenuIsOpen) {
                    return;
                }

                vm.openOffcanvasMenu();

                window.setTimeout(function () {
                    vm.closeOffcanvasMenu();
                }, 1000);
            },
            // Errors occurs
            function (response) {
                // alert('Kapott');
                __WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.remove();
            });
        },
        loadCoords: function loadCoords(extraction) {
            this.config.coords = JSON.parse(JSON.stringify(extraction.coords));
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('Handles:reset', this.config.coords);
        },
        previous: function previous() {
            if (1 > this.selectedImage) {
                return;
            }

            this.selectedImage = this.selectedImage - 1;
            this.calculatePlaygroundDimensions();
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('Handles:reset');
        },
        next: function next() {
            if (this.selectedImage >= this.config.images.length - 1) {
                return;
            }

            this.handlesMoved = false;
            this.warningOpened = false;

            this.selectedImage = this.selectedImage + 1;
            this.calculatePlaygroundDimensions();
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('Handles:reset');
        },
        resetHandles: function resetHandles() {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('Handles:reset');
        },
        close: function close(openEditor) {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('Handles:reset');
            this.$emit('close', openEditor);
        },
        calculatePlaygroundDimensions: function calculatePlaygroundDimensions() {
            var vm = this,
                image = new Image();

            image.addEventListener('load', function () {
                var dim = Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["a" /* calcMaxDimensions */])(image.width, image.height, vm.options.maxWidth, vm.options.maxHeight);

                // console.log({
                //     'image.width': image.width,
                //     'image.height': image.height,
                //     'vm.options.maxWidth': vm.options.maxWidth,
                //     'vm.options.maxHeight': vm.options.maxHeight,
                // });

                // console.log(dim);

                vm.options.width = dim.x;
                vm.options.height = dim.y;

                vm.showPlayground = true;
            });

            // console.log(vm.config.images[this.selectedImage].source);

            image.src = vm.config.images[this.selectedImage].source;
        },
        viewportResized: function viewportResized() {
            this.options.width = this.$refs['wrapping-container'].offsetWidth - 20 - 2 * this.offset.x;
            this.options.maxWidth = this.options.width;
            this.options.maxHeight = this.availableHeight - 160;

            this.calculatePlaygroundDimensions();
        },
        registerIntroJsStep: function registerIntroJsStep(config) {
            if ('clipping' !== config.view) {
                return;
            }

            config.instance.push({
                element: this.$refs['wrapping-container'].querySelector('.sandbox'),
                position: 'top-middle-aligned',
                intro: 'Markiere mit den blauen Anfassern nur <span>grob den Bereich</span>, den Du freigestellt\n' + 'bekommen möchtest. Die <span>exakte Entfernung</span> des Hintergrund übernehmen\n' + 'wir mit unseren erfahrenen <span>Grafikern</span>.',
                step: 10
            });
        }
    },

    created: function created() {
        var vm = this,
            newOrientation = void 0;

        vm.timeoutResizeFunction = function (values) {
            newOrientation = vm.viewport.width < vm.viewport.height ? 'portrait' : 'landscape';

            if (vm.orientation === newOrientation) {
                return;
            }

            vm.orientation = newOrientation;

            if (false !== vm.resizeOffsetTimeout) {
                window.clearTimeout(vm.resizeOffsetTimeout);
            }

            vm.resizeOffsetTimeout = window.setTimeout(function () {
                vm.viewportResized.call(vm, values);
            }, 500);
        };

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('resized', vm.timeoutResizeFunction);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('collectIntroJsSteps', this.registerIntroJsStep);
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('ClipPath:handlesReady', this.handlesReady);
        this.viewportResized();

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('startIntroDelayedBy', 'clipping');
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('resized', this.timeoutResizeFunction);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('ClipPath:handlesReady', this.handlesReady);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('collectIntroJsSteps', this.registerIntroJsStep);
    },


    components: {
        Playground: __WEBPACK_IMPORTED_MODULE_2__ClipPath_Playground__["a" /* default */],
        Offcanvas: __WEBPACK_IMPORTED_MODULE_3__Offcanvas__["a" /* default */]
    }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Handles__ = __webpack_require__(359);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        viewport: Object,
        shape: Object,
        coords: Array,
        options: Object,
        images: Array,
        selectedImage: Number
    },

    computed: {
        background: function background() {
            var src = this.images[this.selectedImage].source,
                img = new Image();

            img.onload = function () {
                __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
                __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.remove();
            };

            img.src = src;

            return { 'background-image': 'url(' + src + ')' };
        },
        clipPoints: function clipPoints() {
            var vm = this;

            return this.coords.map(function (i) {
                return i.map(function (o, key) {
                    if (0 === key) {
                        return o / 100 * vm.options.width;
                    } else {
                        return o / 100 * vm.options.height;
                    }
                }).join(',');
            }).join(' ');
        }
    },

    components: {
        Handles: __WEBPACK_IMPORTED_MODULE_1__Handles__["a" /* default */]
    },

    methods: {
        updateHandle: function updateHandle(payload, percental) {
            this.$emit('updateHandle', payload, percental);
        },
        removeImage: function removeImage() {
            this.$emit('removeImage');
        }
    }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shapes_configuration__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draggabilly__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draggabilly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_draggabilly__);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        coords: Array,
        options: Object,
        shape: Object
    },

    data: function data() {
        return {
            draggies: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on('Handles:reset', this.resetHandles);

        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit('Handles:reset', _this.coords);
        });
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$off('Handles:reset', this.resetHandles);
    },


    watch: {
        'options.width': function optionsWidth() {
            __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit('Handles:reset', this.coords);
        },
        'options.height': function optionsHeight() {
            __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit('Handles:reset', this.coords);
        }
    },

    methods: {
        placeHandle: function placeHandle(coord) {
            return {
                left: Math.round(coord[0] / 100 * this.options.width) + 'px',
                top: Math.round(coord[1] / 100 * this.options.height) + 'px'
            };
        },
        resetHandles: function resetHandles(coords) {
            var vm = this,
                handles = document.querySelectorAll('.handle');

            this.clearDraggies();

            this.coords = coords || JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__shapes_configuration__["a" /* default */][0].coords));

            for (var i = 0; i < handles.length; i++) {
                var handle = handles[i];
                if (!handle.dataset.handle) {
                    return;
                }

                var i = handle.dataset.handle,
                    x = this.coords[i][0],
                    y = this.coords[i][1];

                this.styleHandle(handle, this.coords[i]);
                this.makeDraggable(handle);

                vm.$emit('updateHandle', { x: x, y: y, i: i }, true);
            };
            __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit('ClipPath:handlesReady');
        },
        clearDraggies: function clearDraggies() {
            for (var i = 0; i < this.draggies.length; i++) {
                this.draggies[i].destroy();
            }
            this.draggies = [];
        },
        styleHandle: function styleHandle(handle, coord) {
            Object.assign(handle.style, this.placeHandle(coord));
        },
        makeDraggable: function makeDraggable(handle) {
            var self = this,
                i = handle.dataset.handle;

            handle.classList.add('draggable');

            var draggie = new __WEBPACK_IMPORTED_MODULE_2_draggabilly___default.a(handle, {
                containment: true,
                grid: [0, 0]
            }).on('pointerDown', function () {
                document.querySelectorAll('[data-handle="' + i + '"]')[0].classList.add('changing');
            }).on('dragMove', function () {
                var x = this.position.x;
                var y = this.position.y;

                self.$emit('updateHandle', { x: x, y: y, i: i });
            }).on('pointerUp', function () {
                var elm = document.querySelectorAll('[data-handle]');
                for (var _i = 0; _i < elm.length; _i++) {
                    elm[_i].classList.remove('changing');
                }
            });

            this.draggies.push(draggie);
        }
    }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        open: {
            type: Boolean,
            default: false
        },
        configuration: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    methods: {
        openOffcanvasMenu: function openOffcanvasMenu() {
            this.open = true;
        },
        closeOffcanvasMenu: function closeOffcanvasMenu() {
            this.open = false;
        }
    }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DraggableResizeable__ = __webpack_require__(377);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            baseWidthCollection: App.configuration.variants.widths.elements,
            baseColorClassName: this.base.color.class,
            resizeOffsetTimeout: false,
            timeoutResizeFunction: false,
            maxEditorWidth: 600
        };
    },


    computed: {
        baseColorClass: function baseColorClass() {
            return 'is--' + this.base.color.class;
        }
    },

    props: {
        editInPlace: Boolean,
        viewport: Object,
        base: Object,
        plexipeople: Array,
        isLoading: {
            type: Boolean,
            default: true
        },
        preloadActive: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        plexipeople: function plexipeople() {
            var vm = this,
                imagePreloader = [];

            if (0 === vm.plexipeople.length) {
                return;
            }

            vm.preloadActive = true;

            vm.plexipeople.forEach(function (entry) {
                imagePreloader.push(new Promise(function (resolve, reject) {
                    var image = new Image();

                    image.addEventListener('load', function () {
                        resolve();
                    });

                    image.src = entry.extraction.source;
                }));
            });

            Promise.all(imagePreloader).then(function () {
                window.setTimeout(function () {
                    vm.preloadActive = false;
                    vm.$emit("preloaderDone");
                }, 1000);
            });
        }
    },

    methods: {
        openUploader: function openUploader() {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('navigation_triggerUploadButton');
        },


        handleDown: function handleDown(e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
        },

        triggerLine: function triggerLine(line) {
            if ('portrait' === this.viewport.format) {
                return {
                    width: line.width,
                    height: line.height
                };
            }

            // noinspection JSSuspiciousNameCombination
            return {
                width: line.height,
                height: line.width
            };
        },
        activated: function activated(vm) {
            vm.plexipeople.active = true;

            this.$emit('activated', vm.plexipeople);
        },
        deactivated: function deactivated(vm) {
            vm.plexipeople.active = false;

            this.$emit('deactivated', vm.plexipeople);
        },
        resized: function resized(x, y, width, height, vm) {
            var _this = this;

            var maxHeight = 30 * this.viewport.factor,
                maxWidth = 30 * this.viewport.factor;

            vm.plexipeople.x = x;

            if (height > maxHeight) {
                height = maxHeight;
                vm.height = maxHeight;
            }

            window.setTimeout(function () {
                vm.y = maxHeight - height;
                vm.top = maxHeight - height;
                vm.plexipeople.y = maxHeight - height;

                if (1 === _this.plexipeople.length) {
                    vm.elmX = vm.x = vm.plexipeople.x = (maxWidth - vm.width) / 2;
                }
            }, 100);

            vm.plexipeople.width = width;
            vm.plexipeople.height = height;

            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');
        },
        dragged: function dragged(x, y, vm) {
            var maxHeight = 30 * this.viewport.factor;

            y = maxHeight - vm.height;

            vm.plexipeople.x = x;
            vm.y = y;
            vm.plexipeople.y = y;
        },
        toggleGroove: function toggleGroove(plexipeople) {
            plexipeople.groove = plexipeople.groove % this.base.grooves.value + 1;

            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');
        },
        setBaseColor: function setBaseColor(colorItem) {
            this.baseColorClassName = colorItem.class;
            this.baseColorClass = 'is--' + colorItem.class;
        },
        resetGrooveOnAllPlexipeople: function resetGrooveOnAllPlexipeople(groove) {
            this.plexipeople.forEach(function (plexipeople) {
                if (plexipeople.groove > groove.value) {
                    plexipeople.groove = groove.value;
                }
            });

            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');
        },
        closeModal: function closeModal() {
            var vm = this;

            //@TODO: Ω make dynamic
            vm.$modal.hide('preview');

            window.setTimeout(function () {
                vm.previewImage = '';
            }, 100);
        },
        viewportResized: function viewportResized() {
            var oldFactor = this.viewport.factor,
                newFactor = (this.$refs['wrapping-container'].offsetWidth - 2 * 20) / 30;

            if (this.maxEditorWidth < 30 * newFactor) {
                newFactor = this.maxEditorWidth / 30;
            }

            this.viewport.factor = newFactor;

            this.$emit('viewportFactorChanged', this.viewport.factor);

            this.plexipeople.forEach(function (plexipeople) {
                plexipeople.width = plexipeople.width / oldFactor * newFactor;
                plexipeople.height = plexipeople.height / oldFactor * newFactor;
                plexipeople.x = plexipeople.x / oldFactor * newFactor;
            });
        }
    },

    components: {
        VueDraggableResizable: __WEBPACK_IMPORTED_MODULE_1__DraggableResizeable__["a" /* default */]
    },

    created: function created() {
        var vm = this;

        vm.timeoutResizeFunction = function (values) {
            if (vm.resizeOffsetTimeout) {
                window.clearTimeout(vm.resizeOffsetTimeout);
            }

            vm.resizeOffsetTimeout = window.setTimeout(function () {
                vm.viewportResized.call(vm, values);
            }, 500);
        };

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('resized', vm.timeoutResizeFunction);
    },
    mounted: function mounted() {
        var vm = this;

        vm.viewportResized();

        vm.$emit("mounted");

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('colorChanged', vm.setBaseColor);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('groovesChanged', vm.resetGrooveOnAllPlexipeople);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('colorChanged', this.setBaseColor);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('groovesChanged', this.resetGrooveOnAllPlexipeople);
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('resized', this.timeoutResizeFunction);
    }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable__);




/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_1_vue_draggable_resizable___default.a,

    data: function data() {
        return {
            processing: false
        };
    },


    props: { plexipeople: Object },

    watch: {
        x: function x(value) {
            this.left = value;
        },
        y: function y(value) {
            this.top = value;
        },
        w: function w(value) {
            this.width = value;
        },
        h: function h(value) {
            this.height = value;
        },
        'plexipeople.x': function plexipeopleX(value) {
            this.left = value;
            this.x = value;

            this.delayedReview();
        },
        'plexipeople.width': function plexipeopleWidth(value) {
            this.width = value;
            this.w = value;

            this.delayedReview();
        },
        'plexipeople.height': function plexipeopleHeight(value) {
            this.height = value;
            this.h = value;

            this.delayedReview();
        }
    },

    methods: {
        delayedReview: function delayedReview() {
            var vm = this;

            if (false !== vm.processing) {
                window.clearTimeout(vm.processing);
            }

            vm.processing = window.setTimeout(function () {
                vm.reviewDimensions.call(vm);

                vm.elmW = vm.width;
                vm.elmH = vm.height;
                vm.elmX = vm.left;
            }, 100);
        },
        deselect: function deselect(e) {
            if (e.type.indexOf('touch') !== -1) {
                this.mouseX = e.changedTouches[0].clientX;
                this.mouseY = e.changedTouches[0].clientY;
            } else {
                this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
                this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;
            }

            var target = e.target || e.srcElement;

            if (!(target.classList.contains('vdr') && target.classList.contains('draggable'))) {
                return;
            }

            this.lastMouseX = this.mouseX;
            this.lastMouseY = this.mouseY;

            var regex = new RegExp('handle-([trmbl]{2})', '');

            if (!(this.$el.contains(target) || regex.test(target.className))) {
                if (this.enabled) {
                    this.enabled = false;

                    this.$emit('deactivated', this);
                    this.$emit('update:active', false, this);
                }
            }
        },
        registerIntroJsStep: function registerIntroJsStep(config) {
            if (!this.active || 'navigation' !== config.view) {
                return;
            }

            config.instance.push({
                element: this.$el.querySelector('.handle'),
                intro: 'Bestimme hiermit die Größe Deiner Figur. Der\n' + 'Preis wird Dir unten angezeigt.',
                step: 10
            });
        }
    },

    mounted: function mounted() {
        document.documentElement.addEventListener('mousemove', this.handleMove, true);
        document.documentElement.addEventListener('mousedown', this.deselect, true);
        document.documentElement.addEventListener('mouseup', this.handleUp, true);

        // touch events bindings
        document.documentElement.addEventListener('touchmove', this.handleMove, true);
        document.documentElement.addEventListener('touchend', this.deselect, true);
        document.documentElement.addEventListener('touchcancel', this.deselect, true);
        document.documentElement.addEventListener('touchstart', this.handleUp, true);

        this.elmX = parseInt(this.$el.style.left);
        this.elmY = parseInt(this.$el.style.top);
        this.elmW = this.$el.offsetWidth || this.$el.clientWidth;
        this.elmH = this.$el.offsetHeight || this.$el.clientHeight;

        this.reviewDimensions();
    },

    created: function created() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('collectIntroJsSteps', this.registerIntroJsStep);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('collectIntroJsSteps', this.registerIntroJsStep);
    }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        sizes: Array,
        plexipeople: Object
    },

    methods: {
        resize: function resize(size) {
            this.$emit('resize', this.plexipeople, size);
        }
    }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            positions: [],
            sum: .0
        };
    },


    props: {
        viewport: Object,
        base: Object,
        plexipeople: Array,
        activePlexipeople: Object
    },

    methods: {
        activatePlexipeople: function activatePlexipeople(position) {
            this.$emit('activatePlexipeople', position);
        },
        calculatePrices: function calculatePrices() {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('addLeavingEditorEventListener');

            // console.log('calculatePrices called');
            if (0 === this.plexipeople.length) {
                this.positions = [];
                this.$emit('priceUpdated', .0);

                return;
            }

            var vm = this,
                requestBody = {
                quantity: 1, // number of configured product
                base: { // false on order without base
                    autoWidth: vm.base.autoWidth,
                    material: {
                        id: App.configuration.variants.materials.id,
                        value: vm.base.material
                    },
                    color: {
                        id: App.configuration.variants.colors.id,
                        value: vm.base.color
                    },
                    grooves: {
                        id: App.configuration.variants.grooves.id,
                        value: vm.base.grooves
                    },
                    width: {
                        id: App.configuration.variants.widths.id,
                        value: vm.base.width
                    }
                },
                plexipeople: []
            };

            vm.plexipeople.forEach(function (position) {
                requestBody.plexipeople.push({
                    uuid: position.uuid,
                    indicator: position.indicator,
                    groove: position.groove,
                    height: position.height / vm.viewport.factor * 10,
                    width: position.width / vm.viewport.factor * 10
                });
            });

            vm.$http.post(App.url.priceCalculator, requestBody).then(
            // Successful
            function (response) {
                vm.positions = response.data.positions;
                vm.sum = response.data.sum;

                if (!vm.positions) {
                    return;
                }

                var base = vm.positions[vm.positions.length - 1];

                if (true === requestBody.base.autoWidth && requestBody.base.width.value.id !== base.values.width.id) {
                    vm.$emit('baseWidthChanged', base.values.width.id);
                }

                vm.positions.splice(vm.positions.length - 1, 1);

                vm.positions.forEach(function (position) {
                    var i = 0;

                    for (; i < vm.plexipeople.length; i++) {
                        if (vm.plexipeople[i].uuid !== position.uuid) {
                            continue;
                        }

                        vm.plexipeople[i].size = position.size || 'S';
                        vm.plexipeople[i].color = requestBody.base.color.value;
                    }
                });

                vm.$emit('priceUpdated', vm.sum);
            },
            // Errors occurs
            function (response) {
                // alert('Kapott');
            });
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('calculatePrices', this.calculatePrices);
        // window.setTimeout(this.calculatePrices, 500);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('calculatePrices', this.calculatePrices);
    }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base_Color__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_Desktop_Width__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Base_Mobile_Width__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Base_Grooves__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Base_Cake__ = __webpack_require__(409);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        viewport: Object,
        base: Object,
        plexipeople: Array
    },

    computed: {
        baseWidthComponent: function baseWidthComponent() {
            if (this.viewport.isMobile) {
                return 'app-base-width-mobile';
            }

            return 'app-base-width-desktop';
        }
    },

    methods: {
        calculatePrices: function calculatePrices() {
            // console.log('Base.vue->calculatePrices');
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('calculatePrices');
        },
        registerIntroJsStep: function registerIntroJsStep(config) {
            if (0 === this.plexipeople.length || 'navigation' !== config.view) {
                return;
            }

            config.instance.push({
                element: this.$refs['intro'],
                intro: 'Wähle nun den passenden Motivsockel zu Deiner Acrylfigur aus. <span>2 Nuten</span> werden <span>nur</span> bei einem <span>mehrteiligen</span> Plexipeople mit <span>mindestens 2 Acrylfiguren</span> benötigt.',
                step: 20
            });
        }
    },

    created: function created() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('collectIntroJsSteps', this.registerIntroJsStep);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('collectIntroJsSteps', this.registerIntroJsStep);
    },


    components: {
        AppBaseColor: __WEBPACK_IMPORTED_MODULE_1__Base_Color__["a" /* default */],
        AppBaseWidthDesktop: __WEBPACK_IMPORTED_MODULE_2__Base_Desktop_Width__["a" /* default */],
        AppBaseWidthMobile: __WEBPACK_IMPORTED_MODULE_3__Base_Mobile_Width__["a" /* default */],
        AppBaseGrooves: __WEBPACK_IMPORTED_MODULE_4__Base_Grooves__["a" /* default */],
        AppBaseCake: __WEBPACK_IMPORTED_MODULE_5__Base_Cake__["a" /* default */]
    }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gtag__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            label: App.configuration.variants.colors.label,
            collection: App.configuration.variants.colors.elements
        };
    },


    props: ["value"],

    methods: {
        change: function change() {
            var _this = this;

            var vm = this;

            switch (this.value.class) {
                case 'nut-tree':
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Motivsockel Nussbaum', 1);
                    break;

                case 'white':
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Motivsockel Weiß', 2);
                    break;

                case 'cake-topper':
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button CakeTopper', 4);
                    break;

                case 'none':
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Motivsockel Ohne', 3);
                    break;
            }

            if (this.value.class && "none" === this.value.class) {
                this.$modal.show("dialog", {
                    title: vm._i18n.t("hint.color.none.title"),
                    text: vm._i18n.t("hint.color.none.text"),
                    buttons: [{
                        title: vm._i18n.t("hint.color.none.button")
                    }]
                });
            }

            this.$emit("input", this.value);
            this.$nextTick(function () {
                __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit("colorChanged", _this.value);
            });
        }
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gtag__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            label: App.configuration.variants.widths.label,
            collection: App.configuration.variants.widths.elements,
            previewImage: ''
        };
    },


    props: {
        value: Object,
        disabled: Boolean,
        color: Object,
        grooves: Object
    },

    computed: {
        colorClass: function colorClass() {
            if ('none' === this.color.class || 'cake-topper' === this.color.class) {
                return App.configuration.variants.colors.elements[0].class;
            }

            return this.color.class;
        }
    },

    methods: {
        openPreview: function openPreview(image) {
            this.previewImage = image.source;
            this.$modal.show('preview');
        },
        closeModal: function closeModal() {
            var vm = this;

            vm.$modal.hide('preview');

            window.setTimeout(function () {
                vm.previewImage = '';
            }, 100);
        },
        input: function input(item) {
            if (this.disabled) {
                return;
            }

            switch (item.value) {
                case 100:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 10cm', 10);
                    break;

                case 150:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 15cm', 15);
                    break;

                case 200:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 20cm', 20);
                    break;

                case 250:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 25cm', 25);
                    break;

                case 300:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 30cm', 30);
                    break;
            }

            if (this.value === item) {
                this.openPreview({
                    source: '/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/' + this.color.class + '/' + item.value + '-' + this.grooves.value + '.png'
                });

                return;
            }

            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit('widthChanged', item);
            this.$emit('input', item);
        },
        colorChanged: function colorChanged(item) {
            if ('none' !== item.class) {
                return;
            }
            if ("cake-topper" !== item.class) {
                return;
            }

            this.input(this.collection[0]);
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('colorChanged', this.colorChanged);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off('colorChanged', this.colorChanged);
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gtag__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            label: App.configuration.variants.widths.label,
            collection: App.configuration.variants.widths.elements
        };
    },


    props: {
        value: Object,
        disabled: Boolean
    },

    methods: {
        change: function change() {
            switch (this.value.value) {
                case 100:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 10cm', 10);
                    break;

                case 150:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 15cm', 15);
                    break;

                case 200:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 20cm', 20);
                    break;

                case 250:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 25cm', 25);
                    break;

                case 300:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Sockel 30cm', 30);
                    break;
            }

            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit("widthChanged", this.value);
            this.$emit("input", this.value);
        },
        colorChanged: function colorChanged(item) {
            if ("none" !== item.class) {
                return;
            }
            if ("cake-topper" !== item.class) {
                return;
            }

            this.value = this.collection[0];
            this.change();
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on("colorChanged", this.colorChanged);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off("colorChanged", this.colorChanged);
    }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gtag__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            label: App.configuration.variants.grooves.label,
            collection: App.configuration.variants.grooves.elements
        };
    },


    props: {
        value: Object,
        disabled: Boolean
    },

    methods: {
        change: function change() {
            switch (this.value.value) {
                case 1:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Motivsockel Nut', 1);
                    break;

                case 2:
                    Object(__WEBPACK_IMPORTED_MODULE_1__gtag__["a" /* gtag_event */])('Button Motivsockel 2 Nuten', 2);
                    break;
            }

            this.$emit("input", this.value);
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit("groovesChanged", this.value);
        },
        colorChanged: function colorChanged(item) {
            if ("none" !== item.class) {
                return;
            }
            if ("cake-topper" !== item.class) {
                return;
            }

            this.value = this.collection[0];
            this.change();
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on("colorChanged", this.colorChanged);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$off("colorChanged", this.colorChanged);
    }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {}
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gtag__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isLoading: false,
            min: 1,
            max: 25,
            quantity: 1
        };
    },


    props: {
        viewport: Object,
        base: Object,
        plexipeople: Array,
        price: Number,
        quantity: {
            type: Number,
            default: function _default() {
                return 1;
            }
        },
        record: {
            type: [Number, Boolean],
            default: function _default() {
                return false;
            }
        }
    },

    methods: {
        handleQuantity: function handleQuantity() {
            if (this.max < this.quantity) {
                this.quantity = this.max;
            } else if (this.min > this.quantity) {
                this.quantity = this.min;
            }

            this.$emit('quantity-changed', this.quantity);
        },
        increase: function increase() {
            this.quantity++;
            this.handleQuantity();
        },
        decrease: function decrease() {
            this.quantity--;
            this.handleQuantity();
        },
        addToBasket: function addToBasket() {
            var _this = this;

            Object(__WEBPACK_IMPORTED_MODULE_2__gtag__["a" /* gtag_event */])('Button Warenkorb');

            this.isLoading = true;

            var requestBody = {
                quantity: this.quantity, // number of configured product
                base: { // false on order without base
                    material: {
                        id: App.configuration.variants.materials.id,
                        value: this.base.material
                    },
                    color: {
                        id: App.configuration.variants.colors.id,
                        value: this.base.color
                    },
                    grooves: {
                        id: App.configuration.variants.grooves.id,
                        value: this.base.grooves
                    },
                    width: {
                        id: App.configuration.variants.widths.id,
                        value: this.base.width
                    }
                },
                record: this.record,
                plexipeople: []
            };

            this.plexipeople.forEach(function (position) {
                requestBody.plexipeople.push({
                    extraction: {
                        coords: position.extraction.coords,
                        parent: {
                            source: Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["d" /* removeURIParams */])(position.extraction.parent.source),
                            origin: Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["d" /* removeURIParams */])(position.extraction.parent.origin || ''),
                            uuid: position.extraction.parent.uuid
                        },
                        source: Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["d" /* removeURIParams */])(position.extraction.source),
                        geometry: position.extraction.geometry
                    },
                    groove: position.groove,
                    x: position.x / _this.viewport.factor,
                    y: position.y / _this.viewport.factor,
                    height: position.height / _this.viewport.factor * 10,
                    width: position.width / _this.viewport.factor * 10,
                    uuid: position.uuid,
                    indicator: position.indicator
                });
            });

            this.$http.post(App.url.addToBasketAction, requestBody).then(
            // Successful
            function (response) {
                __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit('removeLeavingEditorEventListener');
                window.location.href = App.url.swCartAction;
            },
            // Errors occurs
            function (response) {
                _this.isLoading = false;
            });
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on('triggerBuyButton', this.addToBasket);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$off('triggerBuyButton', this.addToBasket);
    }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        close: function close() {
            this.$emit('closePraise');
        }
    }
});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(4)(function () {
  return Object.defineProperty(__webpack_require__(108)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(16);
var LIBRARY = __webpack_require__(47);
var wksExt = __webpack_require__(109);
var defineProperty = __webpack_require__(13).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(24);
var toIObject = __webpack_require__(26);
var arrayIndexOf = __webpack_require__(80)(false);
var IE_PROTO = __webpack_require__(110)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13);
var anObject = __webpack_require__(5);
var getKeys = __webpack_require__(48);

module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26);
var gOPN = __webpack_require__(51).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(48);
var gOPS = __webpack_require__(81);
var pIE = __webpack_require__(69);
var toObject = __webpack_require__(20);
var IObject = __webpack_require__(68);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(4)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(36);
var isObject = __webpack_require__(6);
var invoke = __webpack_require__(206);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(3).parseInt;
var $trim = __webpack_require__(82).trim;
var ws = __webpack_require__(115);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(3).parseFloat;
var $trim = __webpack_require__(82).trim;

module.exports = 1 / $parseFloat(__webpack_require__(115) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(37);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(6);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(50);
var descriptor = __webpack_require__(45);
var setToStringTag = __webpack_require__(56);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(25)(IteratorPrototype, __webpack_require__(9)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(5);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(36);
var toObject = __webpack_require__(20);
var IObject = __webpack_require__(68);
var toLength = __webpack_require__(12);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(20);
var toAbsoluteIndex = __webpack_require__(49);
var toLength = __webpack_require__(12);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(130);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(15) && /./g.flags != 'g') __webpack_require__(13).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(84)
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(47);
var global = __webpack_require__(3);
var ctx = __webpack_require__(35);
var classof = __webpack_require__(70);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(6);
var aFunction = __webpack_require__(36);
var anInstance = __webpack_require__(60);
var forOf = __webpack_require__(87);
var speciesConstructor = __webpack_require__(71);
var task = __webpack_require__(132).set;
var microtask = __webpack_require__(542)();
var newPromiseCapabilityModule = __webpack_require__(220);
var perform = __webpack_require__(543);
var userAgent = __webpack_require__(88);
var promiseResolve = __webpack_require__(221);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(61)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(56)($Promise, PROMISE);
__webpack_require__(59)(PROMISE);
Wrapper = __webpack_require__(16)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(83)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(36);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var isObject = __webpack_require__(6);
var newPromiseCapability = __webpack_require__(220);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(13).f;
var create = __webpack_require__(50);
var redefineAll = __webpack_require__(61);
var ctx = __webpack_require__(35);
var anInstance = __webpack_require__(60);
var forOf = __webpack_require__(87);
var $iterDefine = __webpack_require__(121);
var step = __webpack_require__(216);
var setSpecies = __webpack_require__(59);
var DESCRIPTORS = __webpack_require__(15);
var fastKey = __webpack_require__(42).fastKey;
var validate = __webpack_require__(53);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(61);
var getWeak = __webpack_require__(42).getWeak;
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(6);
var anInstance = __webpack_require__(60);
var forOf = __webpack_require__(87);
var createArrayMethod = __webpack_require__(33);
var $has = __webpack_require__(24);
var validate = __webpack_require__(53);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(30);
var toLength = __webpack_require__(12);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(51);
var gOPS = __webpack_require__(81);
var anObject = __webpack_require__(5);
var Reflect = __webpack_require__(3).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(12);
var repeat = __webpack_require__(117);
var defined = __webpack_require__(38);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(48);
var toIObject = __webpack_require__(26);
var isEnum = __webpack_require__(69).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notification__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_polyfill__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_browserupdate__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_browserupdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_browserupdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_introjs_dist_index_min__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_introjs_dist_index_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_introjs_dist_index_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_cookies__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blueimp_canvas_to_blob__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_blueimp_canvas_to_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_blueimp_canvas_to_blob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_intro_js_introjs_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_intro_js_introjs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_intro_js_introjs_css__);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default.a, {
    dialog: true,
    dynamic: true,
    injectModalsContainer: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_notification___default.a);

/*Browser-update configuration*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_browserupdate___default.a, {
    options: {
        container: document.body,
        reminder: 0,
        nomessage: true,
        required: {
            e: 10, // Edge latest: 17
            f: 56, // Firefox latest: 63
            o: 51, // Opera latest: 70
            s: -2, // Safari latest: 11.1
            c: "55.0.2883.75", // Chrome latest: 70
            i: 10, // Internet Explodierer latest: 11
            y: 18.1, // Yandex Browser
            v: "1.10", // Vivaldi
            uc: 11.5, // UC Browser
            o_a: 45, // Opera Android
            samsung: 7.0 // Samsung Internet Android
        }
    }
    // test: false,
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_introjs_dist_index_min___default.a, {
    waitTimeout: 400
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue_cookies___default.a.config('7d');



var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
    locale: 'de',
    fallbackLocale: 'en',
    messages: messages
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = 'http://plexipeople.dev.sw.netinventors.de/custom/plugins/NetiPlexipeopleLeonardo/';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
    data: function data() {
        return {
            get basePath() {
                return '/files/NetiPlexipeopleLeonardo/';
            }
        };
    }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
    },
    i18n: i18n
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].browserUpdate.onshow(function (infos) {
    __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */].methods.updateBrowserVersion(true);
});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(28)))

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de4d5f42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(422);
function injectStyle (ssrContext) {
  __webpack_require__(231)
  __webpack_require__(234)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de4d5f42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(232);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1f7a5c72", content, true, {});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "@font-face{font-family:icofont;src:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.eot\");src:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.eot#iefix\") format(\"embedded-opentype\"),url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.ttf\") format(\"truetype\"),url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.woff\") format(\"woff\"),url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.svg#icofont\") format(\"svg\");font-weight:400;font-style:normal}", ""]);

// exports


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(235);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("b103a866", content, true, {});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports
exports.i(__webpack_require__(134), "");

// module
exports.push([module.i, ".pb-0{padding-bottom:0}.pb-1{padding-bottom:10px}.pb-2{padding-bottom:20px}.pr-1,.px-1{padding-right:10px}.px-1{padding-left:10px}.py-1{padding-top:5px;padding-bottom:5px}@media screen and (min-width:48em){.py-1{padding-top:10px;padding-bottom:10px}}.py-2{padding-top:20px;padding-bottom:20px}.mb-0{margin-bottom:0}.mb-1{margin-bottom:10px}.mb-15{margin-bottom:15px}.mb-2{margin-bottom:20px}.mb-4{margin-bottom:40px}.mx-auto{margin-left:auto;margin-right:auto}.my-0{margin-top:0;margin-bottom:0}.my-2{margin-top:20px;margin-bottom:20px}.is--flex{display:flex;flex-wrap:wrap;flex-direction:row}.justify-content-start{justify-content:flex-start}.justify-content-center{justify-content:center}.justify-content-end{justify-content:flex-end}.justify-content-between{justify-content:space-between}.justify-content-around{justify-content:space-around}.flex-wrap{flex-wrap:wrap}.align-items-center{align-items:center}.align-items-baseline{align-items:baseline}.align-items-start{align-items:flex-start}.flex-fill{-ms-flex:1 1 auto;flex:1 1 auto}.cursor-pointer{cursor:pointer}.icofont-close:before{content:\"\\EEE4\"}.icofont-info:before{content:\"\\EF50\"}.icofont-plus:before{content:\"\\EFC2\"}.icofont-arrow-left:before{content:\"\\EA5C\"}.btn--plain{background:none;border:none;border-radius:0;font-size:20px}.btn--plain:focus{outline:none}.btn.is--third{padding:2px 12px;line-height:34px}.btn.is--third.is--small{line-height:30px}.btn.is--third.is--large{line-height:38px}.btn--plain.has--extra-space,.btn.has--extra-space{width:40px;height:40px}.btn--plain.has--extra-space-left,.btn.has--extra-space-left{text-align:left}.btn--plain.has--extra-space-right,.btn.has--extra-space-right{text-align:right}.btn--plain.is--primary-icon,.btn--plain i.icon--trash,.btn.is--primary-icon,.btn i.icon--trash{color:#009fe3}.btn--plain.button-guide i,.btn.button-guide i{color:#009600}body{overflow:hidden}#nprogress .spinner{display:none}.is--leonardo{position:fixed;top:0;bottom:0;left:0;right:0;background:#fff;z-index:600}.is--leonardo .leonardo-wrapper{position:relative;height:100%;display:flex;flex-flow:column;margin:0 auto;max-width:78.75em;box-shadow:0 0 5px 0 rgba(0,0,0,.2)}.is--leonardo .leonardo-wrapper .is--intro-video{display:flex;flex-grow:1;flex-direction:column;justify-content:center;align-items:center;background-color:hsla(0,0%,100%,.8)}.is--leonardo .leonardo-wrapper .is--intro-video #player{position:relative;z-index:999;margin:0 auto 30px;flex-grow:1;background-color:#fff;background-image:url(/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg);background-position:50%;background-repeat:no-repeat}.is--leonardo .leonardo-wrapper .is--intro-video #player .is--after-video-uploader,.is--leonardo .leonardo-wrapper .is--intro-video #player.show--border iframe{box-shadow:0 0 20px #009fe3}.is--leonardo .leonardo-wrapper .is--intro-video #player iframe{display:block}.is--leonardo .leonardo-wrapper .is--intro-video #player .is--after-video-uploader{position:relative;background-color:#009fe3;background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/video-upload.png\");background-repeat:no-repeat;background-size:contain;width:100%;height:100%;cursor:pointer}.is--leonardo .leonardo-wrapper .is--intro-video #player .is--after-video-uploader img{position:absolute;left:9px;bottom:9px;width:67px;cursor:pointer}.is--leonardo .leonardo-wrapper .is--intro-video .is-actions{text-align:center;margin-bottom:50px}.is--leonardo .leonardo-wrapper .is--intro-video .is-actions button{background-color:#009600;font-size:19px;margin-bottom:10px}.is--leonardo .leonardo-wrapper .is--intro-video .is-actions .uploadhint{font-size:14px}.is--netiplexipeopleleonardo{flex-grow:1;display:flex;flex-direction:column;justify-content:center;overflow:auto}.is--netiplexipeopleleonardo .content--upload{align-self:center;height:100%;width:100%}.is--netiplexipeopleleonardo .content--title{font-size:1.4rem;font-weight:400}.is--netiplexipeopleleonardo .content--title.hide--mobile{display:none}@media screen and (min-width:48em){.is--netiplexipeopleleonardo .content--title.hide--mobile{display:block}}.is--netiplexipeopleleonardo .product--image-container{width:100%;padding-top:10px;margin-bottom:20px}@media screen and (min-width:48em){.is--netiplexipeopleleonardo .product--image-container{width:65%}}.is--netiplexipeopleleonardo .product--buybox{width:100%}@media screen and (min-width:48em){.is--netiplexipeopleleonardo .product--buybox{width:35%}}.is--netiplexipeopleleonardo .product--buybox .buybox--container{display:flex;justify-content:center;flex-wrap:wrap}@media screen and (min-width:48em){.is--netiplexipeopleleonardo .product--buybox .buybox--container{justify-content:space-between}}.is--netiplexipeopleleonardo .product--buybox .buybox--container .price--container{font-size:20px;color:#009fe3}.is--netiplexipeopleleonardo .product--buybox .buybox--container .price--container .price--content{color:#009fe3}.v--modal-overlay .vue-dialog{padding:15px;text-align:center;margin:auto;left:0!important;max-width:320px;border-radius:0}@media screen and (min-width:48em){.v--modal-overlay .vue-dialog{max-width:350px}}.v--modal-overlay .vue-dialog .dialog-content{padding:0}.v--modal-overlay .vue-dialog .dialog-content .dialog-c-title{font-weight:400;font-size:1.6rem;color:#e74c3c}@media screen and (min-width:48em){.v--modal-overlay .vue-dialog .dialog-content .dialog-c-title{font-size:1.8rem}}.v--modal-overlay .vue-dialog .dialog-content .dialog-c-text{font-size:1rem;padding-bottom:15px}@media screen and (min-width:48em){.v--modal-overlay .vue-dialog .dialog-content .dialog-c-text{font-size:1.1rem}}.v--modal-overlay .vue-dialog .dialog-content .dialog-c-text img{margin:10px auto}.v--modal-overlay .vue-dialog .vue-dialog-buttons{width:auto;margin:auto;justify-content:center;border:none}.v--modal-overlay .vue-dialog .vue-dialog-buttons .vue-dialog-button{padding:4px 25px 7px;margin:0 5px;font-size:.9rem!important;border-radius:0;height:auto;min-height:40px;border:1px solid #444041;flex:0 1 auto!important}@media screen and (min-width:48em){.v--modal-overlay .vue-dialog .vue-dialog-buttons .vue-dialog-button{font-size:1rem!important;padding:4px 5px 7px;flex:1 1 100%!important}}.v--modal-overlay .vue-dialog .vue-dialog-buttons .vue-dialog-button:hover{border:1px solid #e74c3c}.v--modal-overlay .vue-dialog .vue-dialog-buttons .vue-dialog-button.is--error{color:#e74c3c}.v--modal-overlay .vue-dialog .vue-dialog-buttons .vue-dialog-button.is--success{color:#2ecc71}.introjs-overlay{background:#fff}.is--leonardo.introjs-fixParent{position:absolute}.introjs-helperNumberLayer{display:none}.introjs-helperLayer{border-radius:0;background-color:hsla(0,0%,100%,.25)}.introjs-tooltip{border-radius:0;min-width:260px;max-width:350px;margin-top:5px}.introjs-tooltip.introjs-bottom-left-aligned{margin-left:10px}.introjs-tooltip.introjs-bottom-right-aligned{margin-right:15px}.introjs-tooltip.introjs-bottom-middle-aligned{margin-left:10px;margin-right:10px}.introjs-tooltiptext{margin-bottom:10px;margin-left:5px}.introjs-tooltiptext span{color:#009fe3;font-weight:700}.introjs-arrow.top,.introjs-arrow.top-middle,.introjs-arrow.top-right{width:10px;height:10px;transform:rotate(-45deg);background:#fff;border-color:transparent;border-width:1px 1px 0 0;border-style:solid;top:-5px}.introjs-button,.introjs-button:active,.introjs-button:focus{padding:5px 10px;background:#fff;text-shadow:none;border-radius:0;border:none}.introjs-button.introjs-skipbutton,.introjs-button:active.introjs-skipbutton,.introjs-button:focus.introjs-skipbutton{background-color:#e74c3c;color:#fff}.introjs-button.introjs-donebutton,.introjs-button.introjs-nextbutton,.introjs-button:active.introjs-donebutton,.introjs-button:active.introjs-nextbutton,.introjs-button:focus.introjs-donebutton,.introjs-button:focus.introjs-nextbutton{background-color:#009600;color:#fff}.introjs-prevbutton{display:none}.introjs-nextbutton{position:absolute;right:10px}.introjs-nextbutton.introjs-disabled{display:none}.introjs-tooltipbuttons{text-align:left}.introjs-bullets ul li a.active,.introjs-bullets ul li a:hover{background:#009fe3}.introjs-bullets ul li a{width:4px;height:4px}.introjs-bullets ul li{float:none;margin:0 3px;display:inline-block}.introjs-bullets ul{position:absolute;bottom:5px;right:0;left:0;margin:auto}", ""]);

// exports


/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ded4fdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InAppBrowserTurorial_vue__ = __webpack_require__(240);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(10)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ded4fdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InAppBrowserTurorial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(239);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("bab502a2", content, true, {});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".intro-box--wrapper{display:flex;flex-grow:1;flex-direction:column;justify-content:center;align-items:center;background-color:hsla(0,0%,100%,.8)}.intro-box--wrapper .intro-box--content{position:relative;z-index:999;margin:0 auto 30px;flex-grow:1;width:350px;height:350px;display:block;justify-content:center;flex-direction:column;background-color:#fff}.intro-box--wrapper .intro-box--content p{color:#fff;text-align:center;font-size:23px;line-height:34px;font-weight:500}.intro-box--wrapper .intro-box--content span{font-size:34px;font-weight:700}", ""]);

// exports


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-box--wrapper"},[_c('div',{staticClass:"intro-box--content"},[_c('video',{attrs:{"width":"350","height":"350","autoplay":"","controls":""}},[_c('source',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/android_app.mp4","type":"video/mp4"}}),_vm._v("\n            Your browser does not support the video tag.\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingSplash_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458b304a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingSplash_vue__ = __webpack_require__(244);
function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingSplash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458b304a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingSplash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(243);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0d7b070d", content, true, {});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Loading ...")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc607e1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(350);
function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dc607e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc607e1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(247);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("53795fec", content, true, {});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".icofont-close[data-v-6dc607e1]:before{content:\"\\EEE4\"}.icofont-info[data-v-6dc607e1]:before{content:\"\\EF50\"}.icofont-plus[data-v-6dc607e1]:before{content:\"\\EFC2\"}.icofont-arrow-left[data-v-6dc607e1]:before{content:\"\\EA5C\"}.btn--plain[data-v-6dc607e1]{background:none;border:none;border-radius:0;font-size:20px}.btn--plain[data-v-6dc607e1]:focus{outline:none}.btn.is--third[data-v-6dc607e1]{padding:2px 12px;line-height:34px}.btn.is--third.is--small[data-v-6dc607e1]{line-height:30px}.btn.is--third.is--large[data-v-6dc607e1]{line-height:38px}.btn--plain.has--extra-space[data-v-6dc607e1],.btn.has--extra-space[data-v-6dc607e1]{width:40px;height:40px}.btn--plain.has--extra-space-left[data-v-6dc607e1],.btn.has--extra-space-left[data-v-6dc607e1]{text-align:left}.btn--plain.has--extra-space-right[data-v-6dc607e1],.btn.has--extra-space-right[data-v-6dc607e1]{text-align:right}.btn--plain.is--primary-icon[data-v-6dc607e1],.btn--plain i.icon--trash[data-v-6dc607e1],.btn.is--primary-icon[data-v-6dc607e1],.btn i.icon--trash[data-v-6dc607e1]{color:#009fe3}.btn--plain.button-guide i[data-v-6dc607e1],.btn.button-guide i[data-v-6dc607e1]{color:#009600}.action-navi[data-v-6dc607e1]{margin:10px 20px}.action-navi .is--actionNavList[data-v-6dc607e1]{display:flex;flex-direction:row;flex-wrap:nowrap;align-content:center}.action-navi .is--actionNavList .is--listItem[data-v-6dc607e1]{color:#009fe3;align-self:center;min-width:40px;text-align:center}.action-navi .is--actionNavList .is--listItem .btn--plain[data-v-6dc607e1]{padding:0;display:inline-flex;align-items:center}@media screen and (min-width:48em){.action-navi .is--actionNavList .is--listItem .btn--plain[data-v-6dc607e1]{margin-right:15px}}.action-navi .is--actionNavList .is--listItem.is--delete[data-v-6dc607e1]{color:#e74c3c}.action-navi .is--actionNavList .is--listItem.is--brand[data-v-6dc607e1]{flex-grow:1}.action-navi .is--actionNavList .is--listItem.is--brand .is--brandLogo[data-v-6dc607e1]{display:block;width:100px;margin:0 auto}@media only screen and (min-width:1024px){.action-navi .is--actionNavList .is--listItem.is--brand .is--brandLogo[data-v-6dc607e1]{width:150px}}.action-navi .is--actionNavList .is--listItem.is--manual[data-v-6dc607e1]{color:#009600}.action-navi .is--actionNavList .is--listItem.is--upload .btn--plain[data-v-6dc607e1]{margin-right:0}.action-navi .is--actionNavList .is--listItem i[data-v-6dc607e1]{font-size:18px}.action-navi .is--actionNavList .is--listItem[data-v-6dc607e1]:hover{color:#a3a3a3}.action-navi .is--actionNavList [class*=\" icofont-\"][data-v-6dc607e1],.action-navi .is--actionNavList [class^=icofont-][data-v-6dc607e1]{font-family:icofont;font-style:normal;font-weight:400;font-variant:normal}.action-navi .is--actionNavList span[data-v-6dc607e1]{display:none}@media screen and (min-width:48em){.action-navi .is--actionNavList span[data-v-6dc607e1]{font-weight:700;font-size:1rem;vertical-align:text-top;display:inline-block;margin-left:5px}}", ""]);

// exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uploader_vue__ = __webpack_require__(139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dacabd0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uploader_vue__ = __webpack_require__(345);
function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5dacabd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dacabd0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uploader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(250);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("3bc2e318", content, true, {});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".btn .icon-upload2[data-v-5dacabd0]{font-size:1.8rem;line-height:2.4rem}.upload-status[data-v-5dacabd0]{height:100%;box-sizing:border-box;padding:10px;font-size:13px;overflow:auto;text-align:center;color:#444041;background:#eaeaea;border-radius:6px}.upload-status h3[data-v-5dacabd0]{margin:10px 0}.upload-status p[data-v-5dacabd0]{font-weight:400}.upload-status li[data-v-5dacabd0]{position:relative;margin:6px 0;line-height:1.8rem}.upload-status li .is--progress-bar[data-v-5dacabd0]{background-color:#21bdff;background-image:linear-gradient(180deg,#21bdff 0,#009fe3);border:0 none;border-radius:4px;width:0;height:100%;position:absolute;top:0;left:0}.upload-status li .is--message[data-v-5dacabd0],.upload-status li .is--name[data-v-5dacabd0],.upload-status li .is--progress-label[data-v-5dacabd0]{position:absolute;top:0;left:6px;color:#fff}.upload-status li .is--message[data-v-5dacabd0],.upload-status li .is--progress-label[data-v-5dacabd0]{left:auto;right:6px}.upload-status ul.is--errors li .is--progress-bar[data-v-5dacabd0]{background-color:#ff1c26;background-image:linear-gradient(180deg,#ff1c26 0,#e30135);width:100%}.upload-status .is--countdown[data-v-5dacabd0]{margin-top:40px;font-weight:400;font-style:italic;font-size:smaller;margin-top:20px;text-align:right}", ""]);

// exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_LOCAL_MODULE_0__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * mOxie - multi-runtime File API & XMLHttpRequest L2 Polyfill
 * v1.5.7
 *
 * Copyright 2013, Moxiecode Systems AB
 * Released under GPL License.
 *
 * License: http://www.plupload.com/license
 * Contributing: http://www.plupload.com/contributing
 *
 * Date: 2017-11-03
 */
!function(e,t){var i=function(){var e={};return t.apply(e,arguments),e.moxie}; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_LOCAL_MODULE_0__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__)):"object"==typeof module&&module.exports?module.exports=i():e.moxie=i()}(this||window,function(){!function(e,t){"use strict";function i(e,t){for(var i,n=[],r=0;r<e.length;++r){if(i=s[e[r]]||o(e[r]),!i)throw"module definition dependecy not found: "+e[r];n.push(i)}t.apply(null,n)}function n(e,n,r){if("string"!=typeof e)throw"invalid module definition, module id must be defined and be a string";if(n===t)throw"invalid module definition, dependencies must be specified";if(r===t)throw"invalid module definition, definition function must be specified";i(n,function(){s[e]=r.apply(null,arguments)})}function r(e){return!!s[e]}function o(t){for(var i=e,n=t.split(/[.\/]/),r=0;r<n.length;++r){if(!i[n[r]])return;i=i[n[r]]}return i}function a(i){for(var n=0;n<i.length;n++){for(var r=e,o=i[n],a=o.split(/[.\/]/),u=0;u<a.length-1;++u)r[a[u]]===t&&(r[a[u]]={}),r=r[a[u]];r[a[a.length-1]]=s[o]}}var s={};n("moxie/core/utils/Basic",[],function(){function e(e){var t;return e===t?"undefined":null===e?"null":e.nodeType?"node":{}.toString.call(e).match(/\s([a-z|A-Z]+)/)[1].toLowerCase()}function t(){return s(!1,!1,arguments)}function i(){return s(!0,!1,arguments)}function n(){return s(!1,!0,arguments)}function r(){return s(!0,!0,arguments)}function o(t){switch(e(t)){case"array":return s(!1,!0,[[],t]);case"object":return s(!1,!0,[{},t]);default:return t}}function a(i){switch(e(i)){case"array":return Array.prototype.slice.call(i);case"object":return t({},i)}return i}function s(t,i,n){var r,o=n[0];return c(n,function(n,u){u>0&&c(n,function(n,u){var c=-1!==h(e(n),["array","object"]);return n===r||t&&o[u]===r?!0:(c&&i&&(n=a(n)),e(o[u])===e(n)&&c?s(t,i,[o[u],n]):o[u]=n,void 0)})}),o}function u(e,t){function i(){this.constructor=e}for(var n in t)({}).hasOwnProperty.call(t,n)&&(e[n]=t[n]);return i.prototype=t.prototype,e.prototype=new i,e.parent=t.prototype,e}function c(e,t){var i,n,r,o;if(e){try{i=e.length}catch(a){i=o}if(i===o||"number"!=typeof i){for(n in e)if(e.hasOwnProperty(n)&&t(e[n],n)===!1)return}else for(r=0;i>r;r++)if(t(e[r],r)===!1)return}}function l(t){var i;if(!t||"object"!==e(t))return!0;for(i in t)return!1;return!0}function d(t,i){function n(r){"function"===e(t[r])&&t[r](function(e){++r<o&&!e?n(r):i(e)})}var r=0,o=t.length;"function"!==e(i)&&(i=function(){}),t&&t.length||i(),n(r)}function m(e,t){var i=0,n=e.length,r=new Array(n);c(e,function(e,o){e(function(e){if(e)return t(e);var a=[].slice.call(arguments);a.shift(),r[o]=a,i++,i===n&&(r.unshift(null),t.apply(this,r))})})}function h(e,t){if(t){if(Array.prototype.indexOf)return Array.prototype.indexOf.call(t,e);for(var i=0,n=t.length;n>i;i++)if(t[i]===e)return i}return-1}function f(t,i){var n=[];"array"!==e(t)&&(t=[t]),"array"!==e(i)&&(i=[i]);for(var r in t)-1===h(t[r],i)&&n.push(t[r]);return n.length?n:!1}function p(e,t){var i=[];return c(e,function(e){-1!==h(e,t)&&i.push(e)}),i.length?i:null}function g(e){var t,i=[];for(t=0;t<e.length;t++)i[t]=e[t];return i}function x(e){return e?String.prototype.trim?String.prototype.trim.call(e):e.toString().replace(/^\s*/,"").replace(/\s*$/,""):e}function v(e){if("string"!=typeof e)return e;var t,i={t:1099511627776,g:1073741824,m:1048576,k:1024};return e=/^([0-9\.]+)([tmgk]?)$/.exec(e.toLowerCase().replace(/[^0-9\.tmkg]/g,"")),t=e[2],e=+e[1],i.hasOwnProperty(t)&&(e*=i[t]),Math.floor(e)}function w(e){var t=[].slice.call(arguments,1);return e.replace(/%([a-z])/g,function(e,i){var n=t.shift();switch(i){case"s":return n+"";case"d":return parseInt(n,10);case"f":return parseFloat(n);case"c":return"";default:return n}})}function y(e,t){var i=this;setTimeout(function(){e.call(i)},t||1)}var E=function(){var e=0;return function(t){var i,n=(new Date).getTime().toString(32);for(i=0;5>i;i++)n+=Math.floor(65535*Math.random()).toString(32);return(t||"o_")+n+(e++).toString(32)}}();return{guid:E,typeOf:e,extend:t,extendIf:i,extendImmutable:n,extendImmutableIf:r,clone:o,inherit:u,each:c,isEmptyObj:l,inSeries:d,inParallel:m,inArray:h,arrayDiff:f,arrayIntersect:p,toArray:g,trim:x,sprintf:w,parseSizeStr:v,delay:y}}),n("moxie/core/utils/Encode",[],function(){var e=function(e){return unescape(encodeURIComponent(e))},t=function(e){return decodeURIComponent(escape(e))},i=function(e,i){if("function"==typeof window.atob)return i?t(window.atob(e)):window.atob(e);var n,r,o,a,s,u,c,l,d="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",m=0,h=0,f="",p=[];if(!e)return e;e+="";do a=d.indexOf(e.charAt(m++)),s=d.indexOf(e.charAt(m++)),u=d.indexOf(e.charAt(m++)),c=d.indexOf(e.charAt(m++)),l=a<<18|s<<12|u<<6|c,n=255&l>>16,r=255&l>>8,o=255&l,p[h++]=64==u?String.fromCharCode(n):64==c?String.fromCharCode(n,r):String.fromCharCode(n,r,o);while(m<e.length);return f=p.join(""),i?t(f):f},n=function(t,i){if(i&&(t=e(t)),"function"==typeof window.btoa)return window.btoa(t);var n,r,o,a,s,u,c,l,d="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",m=0,h=0,f="",p=[];if(!t)return t;do n=t.charCodeAt(m++),r=t.charCodeAt(m++),o=t.charCodeAt(m++),l=n<<16|r<<8|o,a=63&l>>18,s=63&l>>12,u=63&l>>6,c=63&l,p[h++]=d.charAt(a)+d.charAt(s)+d.charAt(u)+d.charAt(c);while(m<t.length);f=p.join("");var g=t.length%3;return(g?f.slice(0,g-3):f)+"===".slice(g||3)};return{utf8_encode:e,utf8_decode:t,atob:i,btoa:n}}),n("moxie/core/utils/Env",["moxie/core/utils/Basic"],function(e){function i(e,t,i){var n=0,r=0,o=0,a={dev:-6,alpha:-5,a:-5,beta:-4,b:-4,RC:-3,rc:-3,"#":-2,p:1,pl:1},s=function(e){return e=(""+e).replace(/[_\-+]/g,"."),e=e.replace(/([^.\d]+)/g,".$1.").replace(/\.{2,}/g,"."),e.length?e.split("."):[-8]},u=function(e){return e?isNaN(e)?a[e]||-7:parseInt(e,10):0};for(e=s(e),t=s(t),r=Math.max(e.length,t.length),n=0;r>n;n++)if(e[n]!=t[n]){if(e[n]=u(e[n]),t[n]=u(t[n]),e[n]<t[n]){o=-1;break}if(e[n]>t[n]){o=1;break}}if(!i)return o;switch(i){case">":case"gt":return o>0;case">=":case"ge":return o>=0;case"<=":case"le":return 0>=o;case"==":case"=":case"eq":return 0===o;case"<>":case"!=":case"ne":return 0!==o;case"":case"<":case"lt":return 0>o;default:return null}}var n=function(e){var t="",i="?",n="function",r="undefined",o="object",a="name",s="version",u={has:function(e,t){return-1!==t.toLowerCase().indexOf(e.toLowerCase())},lowerize:function(e){return e.toLowerCase()}},c={rgx:function(){for(var t,i,a,s,u,c,l,d=0,m=arguments;d<m.length;d+=2){var h=m[d],f=m[d+1];if(typeof t===r){t={};for(s in f)u=f[s],typeof u===o?t[u[0]]=e:t[u]=e}for(i=a=0;i<h.length;i++)if(c=h[i].exec(this.getUA())){for(s=0;s<f.length;s++)l=c[++a],u=f[s],typeof u===o&&u.length>0?2==u.length?t[u[0]]=typeof u[1]==n?u[1].call(this,l):u[1]:3==u.length?t[u[0]]=typeof u[1]!==n||u[1].exec&&u[1].test?l?l.replace(u[1],u[2]):e:l?u[1].call(this,l,u[2]):e:4==u.length&&(t[u[0]]=l?u[3].call(this,l.replace(u[1],u[2])):e):t[u]=l?l:e;break}if(c)break}return t},str:function(t,n){for(var r in n)if(typeof n[r]===o&&n[r].length>0){for(var a=0;a<n[r].length;a++)if(u.has(n[r][a],t))return r===i?e:r}else if(u.has(n[r],t))return r===i?e:r;return t}},l={browser:{oldsafari:{major:{1:["/8","/1","/3"],2:"/4","?":"/"},version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",RT:"ARM"}}}},d={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[a,s],[/\s(opr)\/([\w\.]+)/i],[[a,"Opera"],s],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi)\/([\w\.-]+)/i],[a,s],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[a,"IE"],s],[/(edge)\/((\d+)?[\w\.]+)/i],[a,s],[/(yabrowser)\/([\w\.]+)/i],[[a,"Yandex"],s],[/(comodo_dragon)\/([\w\.]+)/i],[[a,/_/g," "],s],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,/(uc\s?browser|qqbrowser)[\/\s]?([\w\.]+)/i],[a,s],[/(dolfin)\/([\w\.]+)/i],[[a,"Dolphin"],s],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[a,"Chrome"],s],[/XiaoMi\/MiuiBrowser\/([\w\.]+)/i],[s,[a,"MIUI Browser"]],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)/i],[s,[a,"Android Browser"]],[/FBAV\/([\w\.]+);/i],[s,[a,"Facebook"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[s,[a,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[s,a],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[a,[s,c.str,l.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[a,s],[/(navigator|netscape)\/([\w\.-]+)/i],[[a,"Netscape"],s],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[a,s]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[s,[a,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[a,s],[/rv\:([\w\.]+).*(gecko)/i],[s,a]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[a,s],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[a,[s,c.str,l.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[a,"Windows"],[s,c.str,l.os.windows.version]],[/\((bb)(10);/i],[[a,"BlackBerry"],s],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\os|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[a,s],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[a,"Symbian"],s],[/\((series40);/i],[a],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[a,"Firefox OS"],s],[/(nintendo|playstation)\s([wids3portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[a,s],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[a,"Chromium OS"],s],[/(sunos)\s?([\w\.]+\d)*/i],[[a,"Solaris"],s],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[a,s],[/(ip[honead]+)(?:.*os\s*([\w]+)*\slike\smac|;\sopera)/i],[[a,"iOS"],[s,/_/g,"."]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[a,"Mac OS"],[s,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(haiku)\s(\w+)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[a,s]]},m=function(e){var i=e||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:t);this.getBrowser=function(){return c.rgx.apply(this,d.browser)},this.getEngine=function(){return c.rgx.apply(this,d.engine)},this.getOS=function(){return c.rgx.apply(this,d.os)},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS()}},this.getUA=function(){return i},this.setUA=function(e){return i=e,this},this.setUA(i)};return m}(),r=function(){var i={access_global_ns:function(){return!!window.moxie},define_property:function(){return!1}(),create_canvas:function(){var e=document.createElement("canvas"),t=!(!e.getContext||!e.getContext("2d"));return i.create_canvas=t,t},return_response_type:function(t){try{if(-1!==e.inArray(t,["","text","document"]))return!0;if(window.XMLHttpRequest){var i=new XMLHttpRequest;if(i.open("get","/"),"responseType"in i)return i.responseType=t,i.responseType!==t?!1:!0}}catch(n){}return!1},use_blob_uri:function(){var e=window.URL;return i.use_blob_uri=e&&"createObjectURL"in e&&"revokeObjectURL"in e&&("IE"!==a.browser||a.verComp(a.version,"11.0.46",">=")),i.use_blob_uri},use_data_uri:function(){var e=new Image;return e.onload=function(){i.use_data_uri=1===e.width&&1===e.height},setTimeout(function(){e.src="data:image/gif;base64,R0lGODlhAQABAIAAAP8AAAAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="},1),!1}(),use_data_uri_over32kb:function(){return i.use_data_uri&&("IE"!==a.browser||a.version>=9)},use_data_uri_of:function(e){return i.use_data_uri&&33e3>e||i.use_data_uri_over32kb()},use_fileinput:function(){if(navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/))return!1;var e=document.createElement("input");return e.setAttribute("type","file"),i.use_fileinput=!e.disabled},use_webgl:function(){var e,n=document.createElement("canvas"),r=null;try{r=n.getContext("webgl")||n.getContext("experimental-webgl")}catch(o){}return r||(r=null),e=!!r,i.use_webgl=e,n=t,e}};return function(t){var n=[].slice.call(arguments);return n.shift(),"function"===e.typeOf(i[t])?i[t].apply(this,n):!!i[t]}}(),o=(new n).getResult(),a={can:r,uaParser:n,browser:o.browser.name,version:o.browser.version,os:o.os.name,osVersion:o.os.version,verComp:i,swf_url:"../flash/Moxie.swf",xap_url:"../silverlight/Moxie.xap",global_event_dispatcher:"moxie.core.EventTarget.instance.dispatchEvent"};return a.OS=a.os,a}),n("moxie/core/Exceptions",["moxie/core/utils/Basic"],function(e){function t(e,t){var i;for(i in e)if(e[i]===t)return i;return null}return{RuntimeError:function(){function i(e,i){this.code=e,this.name=t(n,e),this.message=this.name+(i||": RuntimeError "+this.code)}var n={NOT_INIT_ERR:1,EXCEPTION_ERR:3,NOT_SUPPORTED_ERR:9,JS_ERR:4};return e.extend(i,n),i.prototype=Error.prototype,i}(),OperationNotAllowedException:function(){function t(e){this.code=e,this.name="OperationNotAllowedException"}return e.extend(t,{NOT_ALLOWED_ERR:1}),t.prototype=Error.prototype,t}(),ImageError:function(){function i(e){this.code=e,this.name=t(n,e),this.message=this.name+": ImageError "+this.code}var n={WRONG_FORMAT:1,MAX_RESOLUTION_ERR:2,INVALID_META_ERR:3};return e.extend(i,n),i.prototype=Error.prototype,i}(),FileException:function(){function i(e){this.code=e,this.name=t(n,e),this.message=this.name+": FileException "+this.code}var n={NOT_FOUND_ERR:1,SECURITY_ERR:2,ABORT_ERR:3,NOT_READABLE_ERR:4,ENCODING_ERR:5,NO_MODIFICATION_ALLOWED_ERR:6,INVALID_STATE_ERR:7,SYNTAX_ERR:8};return e.extend(i,n),i.prototype=Error.prototype,i}(),DOMException:function(){function i(e){this.code=e,this.name=t(n,e),this.message=this.name+": DOMException "+this.code}var n={INDEX_SIZE_ERR:1,DOMSTRING_SIZE_ERR:2,HIERARCHY_REQUEST_ERR:3,WRONG_DOCUMENT_ERR:4,INVALID_CHARACTER_ERR:5,NO_DATA_ALLOWED_ERR:6,NO_MODIFICATION_ALLOWED_ERR:7,NOT_FOUND_ERR:8,NOT_SUPPORTED_ERR:9,INUSE_ATTRIBUTE_ERR:10,INVALID_STATE_ERR:11,SYNTAX_ERR:12,INVALID_MODIFICATION_ERR:13,NAMESPACE_ERR:14,INVALID_ACCESS_ERR:15,VALIDATION_ERR:16,TYPE_MISMATCH_ERR:17,SECURITY_ERR:18,NETWORK_ERR:19,ABORT_ERR:20,URL_MISMATCH_ERR:21,QUOTA_EXCEEDED_ERR:22,TIMEOUT_ERR:23,INVALID_NODE_TYPE_ERR:24,DATA_CLONE_ERR:25};return e.extend(i,n),i.prototype=Error.prototype,i}(),EventException:function(){function t(e){this.code=e,this.name="EventException"}return e.extend(t,{UNSPECIFIED_EVENT_TYPE_ERR:0}),t.prototype=Error.prototype,t}()}}),n("moxie/core/utils/Dom",["moxie/core/utils/Env"],function(e){var t=function(e){return"string"!=typeof e?e:document.getElementById(e)},i=function(e,t){if(!e.className)return!1;var i=new RegExp("(^|\\s+)"+t+"(\\s+|$)");return i.test(e.className)},n=function(e,t){i(e,t)||(e.className=e.className?e.className.replace(/\s+$/,"")+" "+t:t)},r=function(e,t){if(e.className){var i=new RegExp("(^|\\s+)"+t+"(\\s+|$)");e.className=e.className.replace(i,function(e,t,i){return" "===t&&" "===i?" ":""})}},o=function(e,t){return e.currentStyle?e.currentStyle[t]:window.getComputedStyle?window.getComputedStyle(e,null)[t]:void 0},a=function(t,i){function n(e){var t,i,n=0,r=0;return e&&(i=e.getBoundingClientRect(),t="CSS1Compat"===c.compatMode?c.documentElement:c.body,n=i.left+t.scrollLeft,r=i.top+t.scrollTop),{x:n,y:r}}var r,o,a,s=0,u=0,c=document;if(t=t,i=i||c.body,t&&t.getBoundingClientRect&&"IE"===e.browser&&(!c.documentMode||c.documentMode<8))return o=n(t),a=n(i),{x:o.x-a.x,y:o.y-a.y};for(r=t;r&&r!=i&&r.nodeType;)s+=r.offsetLeft||0,u+=r.offsetTop||0,r=r.offsetParent;for(r=t.parentNode;r&&r!=i&&r.nodeType;)s-=r.scrollLeft||0,u-=r.scrollTop||0,r=r.parentNode;return{x:s,y:u}},s=function(e){return{w:e.offsetWidth||e.clientWidth,h:e.offsetHeight||e.clientHeight}};return{get:t,hasClass:i,addClass:n,removeClass:r,getStyle:o,getPos:a,getSize:s}}),n("moxie/core/EventTarget",["moxie/core/utils/Env","moxie/core/Exceptions","moxie/core/utils/Basic"],function(e,t,i){function n(){this.uid=i.guid()}var r={};return i.extend(n.prototype,{init:function(){this.uid||(this.uid=i.guid("uid_"))},addEventListener:function(e,t,n,o){var a,s=this;return this.hasOwnProperty("uid")||(this.uid=i.guid("uid_")),e=i.trim(e),/\s/.test(e)?(i.each(e.split(/\s+/),function(e){s.addEventListener(e,t,n,o)}),void 0):(e=e.toLowerCase(),n=parseInt(n,10)||0,a=r[this.uid]&&r[this.uid][e]||[],a.push({fn:t,priority:n,scope:o||this}),r[this.uid]||(r[this.uid]={}),r[this.uid][e]=a,void 0)},hasEventListener:function(e){var t;return e?(e=e.toLowerCase(),t=r[this.uid]&&r[this.uid][e]):t=r[this.uid],t?t:!1},removeEventListener:function(e,t){var n,o,a=this;if(e=e.toLowerCase(),/\s/.test(e))return i.each(e.split(/\s+/),function(e){a.removeEventListener(e,t)}),void 0;if(n=r[this.uid]&&r[this.uid][e]){if(t){for(o=n.length-1;o>=0;o--)if(n[o].fn===t){n.splice(o,1);break}}else n=[];n.length||(delete r[this.uid][e],i.isEmptyObj(r[this.uid])&&delete r[this.uid])}},removeAllEventListeners:function(){r[this.uid]&&delete r[this.uid]},dispatchEvent:function(e){var n,o,a,s,u,c={},l=!0;if("string"!==i.typeOf(e)){if(s=e,"string"!==i.typeOf(s.type))throw new t.EventException(t.EventException.UNSPECIFIED_EVENT_TYPE_ERR);e=s.type,s.total!==u&&s.loaded!==u&&(c.total=s.total,c.loaded=s.loaded),c.async=s.async||!1}if(-1!==e.indexOf("::")?function(t){n=t[0],e=t[1]}(e.split("::")):n=this.uid,e=e.toLowerCase(),o=r[n]&&r[n][e]){o.sort(function(e,t){return t.priority-e.priority}),a=[].slice.call(arguments),a.shift(),c.type=e,a.unshift(c);var d=[];i.each(o,function(e){a[0].target=e.scope,c.async?d.push(function(t){setTimeout(function(){t(e.fn.apply(e.scope,a)===!1)},1)}):d.push(function(t){t(e.fn.apply(e.scope,a)===!1)})}),d.length&&i.inSeries(d,function(e){l=!e})}return l},bindOnce:function(e,t,i,n){var r=this;r.bind.call(this,e,function o(){return r.unbind(e,o),t.apply(this,arguments)},i,n)},bind:function(){this.addEventListener.apply(this,arguments)},unbind:function(){this.removeEventListener.apply(this,arguments)},unbindAll:function(){this.removeAllEventListeners.apply(this,arguments)},trigger:function(){return this.dispatchEvent.apply(this,arguments)},handleEventProps:function(e){var t=this;this.bind(e.join(" "),function(e){var t="on"+e.type.toLowerCase();"function"===i.typeOf(this[t])&&this[t].apply(this,arguments)}),i.each(e,function(e){e="on"+e.toLowerCase(e),"undefined"===i.typeOf(t[e])&&(t[e]=null)})}}),n.instance=new n,n}),n("moxie/runtime/Runtime",["moxie/core/utils/Env","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/EventTarget"],function(e,t,i,n){function r(e,n,o,s,u){var c,l=this,d=t.guid(n+"_"),m=u||"browser";e=e||{},a[d]=this,o=t.extend({access_binary:!1,access_image_binary:!1,display_media:!1,do_cors:!1,drag_and_drop:!1,filter_by_extension:!0,resize_image:!1,report_upload_progress:!1,return_response_headers:!1,return_response_type:!1,return_status_code:!0,send_custom_headers:!1,select_file:!1,select_folder:!1,select_multiple:!0,send_binary_string:!1,send_browser_cookies:!0,send_multipart:!0,slice_blob:!1,stream_upload:!1,summon_file_dialog:!1,upload_filesize:!0,use_http_method:!0},o),e.preferred_caps&&(m=r.getMode(s,e.preferred_caps,m)),c=function(){var e={};return{exec:function(t,i,n,r){return c[i]&&(e[t]||(e[t]={context:this,instance:new c[i]}),e[t].instance[n])?e[t].instance[n].apply(this,r):void 0},removeInstance:function(t){delete e[t]},removeAllInstances:function(){var i=this;t.each(e,function(e,n){"function"===t.typeOf(e.instance.destroy)&&e.instance.destroy.call(e.context),i.removeInstance(n)})}}}(),t.extend(this,{initialized:!1,uid:d,type:n,mode:r.getMode(s,e.required_caps,m),shimid:d+"_container",clients:0,options:e,can:function(e,i){var n=arguments[2]||o;if("string"===t.typeOf(e)&&"undefined"===t.typeOf(i)&&(e=r.parseCaps(e)),"object"===t.typeOf(e)){for(var a in e)if(!this.can(a,e[a],n))return!1;return!0}return"function"===t.typeOf(n[e])?n[e].call(this,i):i===n[e]},getShimContainer:function(){var e,n=i.get(this.shimid);return n||(e=i.get(this.options.container)||document.body,n=document.createElement("div"),n.id=this.shimid,n.className="moxie-shim moxie-shim-"+this.type,t.extend(n.style,{position:"absolute",top:"0px",left:"0px",width:"1px",height:"1px",overflow:"hidden"}),e.appendChild(n),e=null),n},getShim:function(){return c},shimExec:function(e,t){var i=[].slice.call(arguments,2);return l.getShim().exec.call(this,this.uid,e,t,i)},exec:function(e,t){var i=[].slice.call(arguments,2);return l[e]&&l[e][t]?l[e][t].apply(this,i):l.shimExec.apply(this,arguments)},destroy:function(){if(l){var e=i.get(this.shimid);e&&e.parentNode.removeChild(e),c&&c.removeAllInstances(),this.unbindAll(),delete a[this.uid],this.uid=null,d=l=c=e=null}}}),this.mode&&e.required_caps&&!this.can(e.required_caps)&&(this.mode=!1)}var o={},a={};return r.order="html5,flash,silverlight,html4",r.getRuntime=function(e){return a[e]?a[e]:!1},r.addConstructor=function(e,t){t.prototype=n.instance,o[e]=t},r.getConstructor=function(e){return o[e]||null},r.getInfo=function(e){var t=r.getRuntime(e);return t?{uid:t.uid,type:t.type,mode:t.mode,can:function(){return t.can.apply(t,arguments)}}:null},r.parseCaps=function(e){var i={};return"string"!==t.typeOf(e)?e||{}:(t.each(e.split(","),function(e){i[e]=!0}),i)},r.can=function(e,t){var i,n,o=r.getConstructor(e);return o?(i=new o({required_caps:t}),n=i.mode,i.destroy(),!!n):!1},r.thatCan=function(e,t){var i=(t||r.order).split(/\s*,\s*/);for(var n in i)if(r.can(i[n],e))return i[n];return null},r.getMode=function(e,i,n){var r=null;if("undefined"===t.typeOf(n)&&(n="browser"),i&&!t.isEmptyObj(e)){if(t.each(i,function(i,n){if(e.hasOwnProperty(n)){var o=e[n](i);if("string"==typeof o&&(o=[o]),r){if(!(r=t.arrayIntersect(r,o)))return r=!1}else r=o}}),r)return-1!==t.inArray(n,r)?n:r[0];if(r===!1)return!1}return n},r.getGlobalEventTarget=function(){if(/^moxie\./.test(e.global_event_dispatcher)&&!e.can("access_global_ns")){var i=t.guid("moxie_event_target_");window[i]=function(e,t){n.instance.dispatchEvent(e,t)},e.global_event_dispatcher=i}return e.global_event_dispatcher},r.capTrue=function(){return!0},r.capFalse=function(){return!1},r.capTest=function(e){return function(){return!!e}},r}),n("moxie/runtime/RuntimeClient",["moxie/core/utils/Env","moxie/core/Exceptions","moxie/core/utils/Basic","moxie/runtime/Runtime"],function(e,t,i,n){return function(){var e;i.extend(this,{connectRuntime:function(r){function o(i){var a,u;return i.length?(a=i.shift().toLowerCase(),(u=n.getConstructor(a))?(e=new u(r),e.bind("Init",function(){e.initialized=!0,setTimeout(function(){e.clients++,s.ruid=e.uid,s.trigger("RuntimeInit",e)},1)}),e.bind("Error",function(){e.destroy(),o(i)}),e.bind("Exception",function(e,i){var n=i.name+"(#"+i.code+")"+(i.message?", from: "+i.message:"");s.trigger("RuntimeError",new t.RuntimeError(t.RuntimeError.EXCEPTION_ERR,n))}),e.mode?(e.init(),void 0):(e.trigger("Error"),void 0)):(o(i),void 0)):(s.trigger("RuntimeError",new t.RuntimeError(t.RuntimeError.NOT_INIT_ERR)),e=null,void 0)}var a,s=this;if("string"===i.typeOf(r)?a=r:"string"===i.typeOf(r.ruid)&&(a=r.ruid),a){if(e=n.getRuntime(a))return s.ruid=a,e.clients++,e;throw new t.RuntimeError(t.RuntimeError.NOT_INIT_ERR)}o((r.runtime_order||n.order).split(/\s*,\s*/))},disconnectRuntime:function(){e&&--e.clients<=0&&e.destroy(),e=null},getRuntime:function(){return e&&e.uid?e:e=null},exec:function(){return e?e.exec.apply(this,arguments):null},can:function(t){return e?e.can(t):!1}})}}),n("moxie/file/Blob",["moxie/core/utils/Basic","moxie/core/utils/Encode","moxie/runtime/RuntimeClient"],function(e,t,i){function n(o,a){function s(t,i,o){var a,s=r[this.uid];return"string"===e.typeOf(s)&&s.length?(a=new n(null,{type:o,size:i-t}),a.detach(s.substr(t,a.size)),a):null}i.call(this),o&&this.connectRuntime(o),a?"string"===e.typeOf(a)&&(a={data:a}):a={},e.extend(this,{uid:a.uid||e.guid("uid_"),ruid:o,size:a.size||0,type:a.type||"",slice:function(e,t,i){return this.isDetached()?s.apply(this,arguments):this.getRuntime().exec.call(this,"Blob","slice",this.getSource(),e,t,i)},getSource:function(){return r[this.uid]?r[this.uid]:null},detach:function(e){if(this.ruid&&(this.getRuntime().exec.call(this,"Blob","destroy"),this.disconnectRuntime(),this.ruid=null),e=e||"","data:"==e.substr(0,5)){var i=e.indexOf(";base64,");this.type=e.substring(5,i),e=t.atob(e.substring(i+8))}this.size=e.length,r[this.uid]=e},isDetached:function(){return!this.ruid&&"string"===e.typeOf(r[this.uid])},destroy:function(){this.detach(),delete r[this.uid]}}),a.data?this.detach(a.data):r[this.uid]=a}var r={};return n}),n("moxie/core/I18n",["moxie/core/utils/Basic"],function(e){var t={};return{addI18n:function(i){return e.extend(t,i)},translate:function(e){return t[e]||e},_:function(e){return this.translate(e)},sprintf:function(t){var i=[].slice.call(arguments,1);return t.replace(/%[a-z]/g,function(){var t=i.shift();return"undefined"!==e.typeOf(t)?t:""})}}}),n("moxie/core/utils/Mime",["moxie/core/utils/Basic","moxie/core/I18n"],function(e,t){var i="application/msword,doc dot,application/pdf,pdf,application/pgp-signature,pgp,application/postscript,ps ai eps,application/rtf,rtf,application/vnd.ms-excel,xls xlb xlt xla,application/vnd.ms-powerpoint,ppt pps pot ppa,application/zip,zip,application/x-shockwave-flash,swf swfl,application/vnd.openxmlformats-officedocument.wordprocessingml.document,docx,application/vnd.openxmlformats-officedocument.wordprocessingml.template,dotx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,xlsx,application/vnd.openxmlformats-officedocument.presentationml.presentation,pptx,application/vnd.openxmlformats-officedocument.presentationml.template,potx,application/vnd.openxmlformats-officedocument.presentationml.slideshow,ppsx,application/x-javascript,js,application/json,json,audio/mpeg,mp3 mpga mpega mp2,audio/x-wav,wav,audio/x-m4a,m4a,audio/ogg,oga ogg,audio/aiff,aiff aif,audio/flac,flac,audio/aac,aac,audio/ac3,ac3,audio/x-ms-wma,wma,image/bmp,bmp,image/gif,gif,image/jpeg,jpg jpeg jpe,image/photoshop,psd,image/png,png,image/svg+xml,svg svgz,image/tiff,tiff tif,text/plain,asc txt text diff log,text/html,htm html xhtml,text/css,css,text/csv,csv,text/rtf,rtf,video/mpeg,mpeg mpg mpe m2v,video/quicktime,qt mov,video/mp4,mp4,video/x-m4v,m4v,video/x-flv,flv,video/x-ms-wmv,wmv,video/avi,avi,video/webm,webm,video/3gpp,3gpp 3gp,video/3gpp2,3g2,video/vnd.rn-realvideo,rv,video/ogg,ogv,video/x-matroska,mkv,application/vnd.oasis.opendocument.formula-template,otf,application/octet-stream,exe",n={},r={},o=function(e){var t,i,o,a=e.split(/,/);for(t=0;t<a.length;t+=2){for(o=a[t+1].split(/ /),i=0;i<o.length;i++)n[o[i]]=a[t];r[a[t]]=o}},a=function(t,i){var n,r,o,a,s=[];for(r=0;r<t.length;r++)for(n=t[r].extensions.toLowerCase().split(/\s*,\s*/),o=0;o<n.length;o++){if("*"===n[o])return[];if(a=s[n[o]],i&&/^\w+$/.test(n[o]))s.push("."+n[o]);else if(a&&-1===e.inArray(a,s))s.push(a);else if(!a)return[]}return s},s=function(t){var i=[];return e.each(t,function(t){if(t=t.toLowerCase(),"*"===t)return i=[],!1;var n=t.match(/^(\w+)\/(\*|\w+)$/);n&&("*"===n[2]?e.each(r,function(e,t){new RegExp("^"+n[1]+"/").test(t)&&[].push.apply(i,r[t])}):r[t]&&[].push.apply(i,r[t]))}),i},u=function(i){var n=[],r=[];return"string"===e.typeOf(i)&&(i=e.trim(i).split(/\s*,\s*/)),r=s(i),n.push({title:t.translate("Files"),extensions:r.length?r.join(","):"*"}),n},c=function(e){var t=e&&e.match(/\.([^.]+)$/);return t?t[1].toLowerCase():""},l=function(e){return n[c(e)]||""};return o(i),{mimes:n,extensions:r,addMimeType:o,extList2mimes:a,mimes2exts:s,mimes2extList:u,getFileExtension:c,getFileMime:l}}),n("moxie/file/FileInput",["moxie/core/utils/Basic","moxie/core/utils/Env","moxie/core/utils/Mime","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/core/EventTarget","moxie/core/I18n","moxie/runtime/Runtime","moxie/runtime/RuntimeClient"],function(e,t,i,n,r,o,a,s,u){function c(t){var o,c,d;if(-1!==e.inArray(e.typeOf(t),["string","node"])&&(t={browse_button:t}),c=n.get(t.browse_button),!c)throw new r.DOMException(r.DOMException.NOT_FOUND_ERR);d={accept:[{title:a.translate("All Files"),extensions:"*"}],multiple:!1,required_caps:!1,container:c.parentNode||document.body},t=e.extend({},d,t),"string"==typeof t.required_caps&&(t.required_caps=s.parseCaps(t.required_caps)),"string"==typeof t.accept&&(t.accept=i.mimes2extList(t.accept)),o=n.get(t.container),o||(o=document.body),"static"===n.getStyle(o,"position")&&(o.style.position="relative"),o=c=null,u.call(this),e.extend(this,{uid:e.guid("uid_"),ruid:null,shimid:null,files:null,init:function(){var i=this;i.bind("RuntimeInit",function(r,o){i.ruid=o.uid,i.shimid=o.shimid,i.bind("Ready",function(){i.trigger("Refresh")},999),i.bind("Refresh",function(){var i,r,a,s,u;a=n.get(t.browse_button),s=n.get(o.shimid),a&&(i=n.getPos(a,n.get(t.container)),r=n.getSize(a),u=parseInt(n.getStyle(a,"z-index"),10)||0,s&&e.extend(s.style,{top:i.y+"px",left:i.x+"px",width:r.w+"px",height:r.h+"px",zIndex:u+1})),s=a=null}),o.exec.call(i,"FileInput","init",t)}),i.connectRuntime(e.extend({},t,{required_caps:{select_file:!0}}))},getOption:function(e){return t[e]},setOption:function(e,n){if(t.hasOwnProperty(e)){var o=t[e];switch(e){case"accept":"string"==typeof n&&(n=i.mimes2extList(n));break;case"container":case"required_caps":throw new r.FileException(r.FileException.NO_MODIFICATION_ALLOWED_ERR)}t[e]=n,this.exec("FileInput","setOption",e,n),this.trigger("OptionChanged",e,n,o)}},disable:function(t){var i=this.getRuntime();i&&this.exec("FileInput","disable","undefined"===e.typeOf(t)?!0:t)},refresh:function(){this.trigger("Refresh")},destroy:function(){var t=this.getRuntime();t&&(t.exec.call(this,"FileInput","destroy"),this.disconnectRuntime()),"array"===e.typeOf(this.files)&&e.each(this.files,function(e){e.destroy()}),this.files=null,this.unbindAll()}}),this.handleEventProps(l)}var l=["ready","change","cancel","mouseenter","mouseleave","mousedown","mouseup"];return c.prototype=o.instance,c}),n("moxie/file/File",["moxie/core/utils/Basic","moxie/core/utils/Mime","moxie/file/Blob"],function(e,t,i){function n(n,r){r||(r={}),i.apply(this,arguments),this.type||(this.type=t.getFileMime(r.name));var o;if(r.name)o=r.name.replace(/\\/g,"/"),o=o.substr(o.lastIndexOf("/")+1);else if(this.type){var a=this.type.split("/")[0];o=e.guid((""!==a?a:"file")+"_"),t.extensions[this.type]&&(o+="."+t.extensions[this.type][0])}e.extend(this,{name:o||e.guid("file_"),relativePath:"",lastModifiedDate:r.lastModifiedDate||(new Date).toLocaleString()})}return n.prototype=i.prototype,n}),n("moxie/file/FileDrop",["moxie/core/I18n","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/core/utils/Basic","moxie/core/utils/Env","moxie/file/File","moxie/runtime/RuntimeClient","moxie/core/EventTarget","moxie/core/utils/Mime"],function(e,t,i,n,r,o,a,s,u){function c(i){var r,o=this;"string"==typeof i&&(i={drop_zone:i}),r={accept:[{title:e.translate("All Files"),extensions:"*"}],required_caps:{drag_and_drop:!0}},i="object"==typeof i?n.extend({},r,i):r,i.container=t.get(i.drop_zone)||document.body,"static"===t.getStyle(i.container,"position")&&(i.container.style.position="relative"),"string"==typeof i.accept&&(i.accept=u.mimes2extList(i.accept)),a.call(o),n.extend(o,{uid:n.guid("uid_"),ruid:null,files:null,init:function(){o.bind("RuntimeInit",function(e,t){o.ruid=t.uid,t.exec.call(o,"FileDrop","init",i),o.dispatchEvent("ready")
}),o.connectRuntime(i)},destroy:function(){var e=this.getRuntime();e&&(e.exec.call(this,"FileDrop","destroy"),this.disconnectRuntime()),this.files=null,this.unbindAll()}}),this.handleEventProps(l)}var l=["ready","dragenter","dragleave","drop","error"];return c.prototype=s.instance,c}),n("moxie/file/FileReader",["moxie/core/utils/Basic","moxie/core/utils/Encode","moxie/core/Exceptions","moxie/core/EventTarget","moxie/file/Blob","moxie/runtime/RuntimeClient"],function(e,t,i,n,r,o){function a(){function n(e,n){if(this.trigger("loadstart"),this.readyState===a.LOADING)return this.trigger("error",new i.DOMException(i.DOMException.INVALID_STATE_ERR)),this.trigger("loadend"),void 0;if(!(n instanceof r))return this.trigger("error",new i.DOMException(i.DOMException.NOT_FOUND_ERR)),this.trigger("loadend"),void 0;if(this.result=null,this.readyState=a.LOADING,n.isDetached()){var o=n.getSource();switch(e){case"readAsText":case"readAsBinaryString":this.result=o;break;case"readAsDataURL":this.result="data:"+n.type+";base64,"+t.btoa(o)}this.readyState=a.DONE,this.trigger("load"),this.trigger("loadend")}else this.connectRuntime(n.ruid),this.exec("FileReader","read",e,n)}o.call(this),e.extend(this,{uid:e.guid("uid_"),readyState:a.EMPTY,result:null,error:null,readAsBinaryString:function(e){n.call(this,"readAsBinaryString",e)},readAsDataURL:function(e){n.call(this,"readAsDataURL",e)},readAsText:function(e){n.call(this,"readAsText",e)},abort:function(){this.result=null,-1===e.inArray(this.readyState,[a.EMPTY,a.DONE])&&(this.readyState===a.LOADING&&(this.readyState=a.DONE),this.exec("FileReader","abort"),this.trigger("abort"),this.trigger("loadend"))},destroy:function(){this.abort(),this.exec("FileReader","destroy"),this.disconnectRuntime(),this.unbindAll()}}),this.handleEventProps(s),this.bind("Error",function(e,t){this.readyState=a.DONE,this.error=t},999),this.bind("Load",function(){this.readyState=a.DONE},999)}var s=["loadstart","progress","load","abort","error","loadend"];return a.EMPTY=0,a.LOADING=1,a.DONE=2,a.prototype=n.instance,a}),n("moxie/core/utils/Url",["moxie/core/utils/Basic"],function(e){var t=function(i,n){var r,o=["source","scheme","authority","userInfo","user","pass","host","port","relative","path","directory","file","query","fragment"],a=o.length,s={http:80,https:443},u={},c=/^(?:([^:\/?#]+):)?(?:\/\/()(?:(?:()(?:([^:@\/]*):?([^:@\/]*))?@)?(\[[\da-fA-F:]+\]|[^:\/?#]*)(?::(\d*))?))?()(?:(()(?:(?:[^?#\/]*\/)*)()(?:[^?#]*))(?:\\?([^#]*))?(?:#(.*))?)/,l=c.exec(i||""),d=/^\/\/\w/.test(i);switch(e.typeOf(n)){case"undefined":n=t(document.location.href,!1);break;case"string":n=t(n,!1)}for(;a--;)l[a]&&(u[o[a]]=l[a]);if(r=!d&&!u.scheme,(d||r)&&(u.scheme=n.scheme),r){u.host=n.host,u.port=n.port;var m="";/^[^\/]/.test(u.path)&&(m=n.path,m=/\/[^\/]*\.[^\/]*$/.test(m)?m.replace(/\/[^\/]+$/,"/"):m.replace(/\/?$/,"/")),u.path=m+(u.path||"")}return u.port||(u.port=s[u.scheme]||80),u.port=parseInt(u.port,10),u.path||(u.path="/"),delete u.source,u},i=function(e){var i={http:80,https:443},n="object"==typeof e?e:t(e);return n.scheme+"://"+n.host+(n.port!==i[n.scheme]?":"+n.port:"")+n.path+(n.query?n.query:"")},n=function(e){function i(e){return[e.scheme,e.host,e.port].join("/")}return"string"==typeof e&&(e=t(e)),i(t())===i(e)};return{parseUrl:t,resolveUrl:i,hasSameOrigin:n}}),n("moxie/runtime/RuntimeTarget",["moxie/core/utils/Basic","moxie/runtime/RuntimeClient","moxie/core/EventTarget"],function(e,t,i){function n(){this.uid=e.guid("uid_"),t.call(this),this.destroy=function(){this.disconnectRuntime(),this.unbindAll()}}return n.prototype=i.instance,n}),n("moxie/file/FileReaderSync",["moxie/core/utils/Basic","moxie/runtime/RuntimeClient","moxie/core/utils/Encode"],function(e,t,i){return function(){function n(e,t){if(!t.isDetached()){var n=this.connectRuntime(t.ruid).exec.call(this,"FileReaderSync","read",e,t);return this.disconnectRuntime(),n}var r=t.getSource();switch(e){case"readAsBinaryString":return r;case"readAsDataURL":return"data:"+t.type+";base64,"+i.btoa(r);case"readAsText":for(var o="",a=0,s=r.length;s>a;a++)o+=String.fromCharCode(r[a]);return o}}t.call(this),e.extend(this,{uid:e.guid("uid_"),readAsBinaryString:function(e){return n.call(this,"readAsBinaryString",e)},readAsDataURL:function(e){return n.call(this,"readAsDataURL",e)},readAsText:function(e){return n.call(this,"readAsText",e)}})}}),n("moxie/xhr/FormData",["moxie/core/Exceptions","moxie/core/utils/Basic","moxie/file/Blob"],function(e,t,i){function n(){var e,n=[];t.extend(this,{append:function(r,o){var a=this,s=t.typeOf(o);o instanceof i?e={name:r,value:o}:"array"===s?(r+="[]",t.each(o,function(e){a.append(r,e)})):"object"===s?t.each(o,function(e,t){a.append(r+"["+t+"]",e)}):"null"===s||"undefined"===s||"number"===s&&isNaN(o)?a.append(r,"false"):n.push({name:r,value:o.toString()})},hasBlob:function(){return!!this.getBlob()},getBlob:function(){return e&&e.value||null},getBlobName:function(){return e&&e.name||null},each:function(i){t.each(n,function(e){i(e.value,e.name)}),e&&i(e.value,e.name)},destroy:function(){e=null,n=[]}})}return n}),n("moxie/xhr/XMLHttpRequest",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/core/EventTarget","moxie/core/utils/Encode","moxie/core/utils/Url","moxie/runtime/Runtime","moxie/runtime/RuntimeTarget","moxie/file/Blob","moxie/file/FileReaderSync","moxie/xhr/FormData","moxie/core/utils/Env","moxie/core/utils/Mime"],function(e,t,i,n,r,o,a,s,u,c,l,d){function m(){this.uid=e.guid("uid_")}function h(){function i(e,t){return I.hasOwnProperty(e)?1===arguments.length?l.can("define_property")?I[e]:A[e]:(l.can("define_property")?I[e]=t:A[e]=t,void 0):void 0}function u(t){function n(){_&&(_.destroy(),_=null),s.dispatchEvent("loadend"),s=null}function r(r){_.bind("LoadStart",function(e){i("readyState",h.LOADING),s.dispatchEvent("readystatechange"),s.dispatchEvent(e),L&&s.upload.dispatchEvent(e)}),_.bind("Progress",function(e){i("readyState")!==h.LOADING&&(i("readyState",h.LOADING),s.dispatchEvent("readystatechange")),s.dispatchEvent(e)}),_.bind("UploadProgress",function(e){L&&s.upload.dispatchEvent({type:"progress",lengthComputable:!1,total:e.total,loaded:e.loaded})}),_.bind("Load",function(t){i("readyState",h.DONE),i("status",Number(r.exec.call(_,"XMLHttpRequest","getStatus")||0)),i("statusText",f[i("status")]||""),i("response",r.exec.call(_,"XMLHttpRequest","getResponse",i("responseType"))),~e.inArray(i("responseType"),["text",""])?i("responseText",i("response")):"document"===i("responseType")&&i("responseXML",i("response")),U=r.exec.call(_,"XMLHttpRequest","getAllResponseHeaders"),s.dispatchEvent("readystatechange"),i("status")>0?(L&&s.upload.dispatchEvent(t),s.dispatchEvent(t)):(F=!0,s.dispatchEvent("error")),n()}),_.bind("Abort",function(e){s.dispatchEvent(e),n()}),_.bind("Error",function(e){F=!0,i("readyState",h.DONE),s.dispatchEvent("readystatechange"),M=!0,s.dispatchEvent(e),n()}),r.exec.call(_,"XMLHttpRequest","send",{url:x,method:v,async:T,user:w,password:y,headers:S,mimeType:D,encoding:O,responseType:s.responseType,withCredentials:s.withCredentials,options:k},t)}var s=this;E=(new Date).getTime(),_=new a,"string"==typeof k.required_caps&&(k.required_caps=o.parseCaps(k.required_caps)),k.required_caps=e.extend({},k.required_caps,{return_response_type:s.responseType}),t instanceof c&&(k.required_caps.send_multipart=!0),e.isEmptyObj(S)||(k.required_caps.send_custom_headers=!0),B||(k.required_caps.do_cors=!0),k.ruid?r(_.connectRuntime(k)):(_.bind("RuntimeInit",function(e,t){r(t)}),_.bind("RuntimeError",function(e,t){s.dispatchEvent("RuntimeError",t)}),_.connectRuntime(k))}function g(){i("responseText",""),i("responseXML",null),i("response",null),i("status",0),i("statusText",""),E=b=null}var x,v,w,y,E,b,_,R,A=this,I={timeout:0,readyState:h.UNSENT,withCredentials:!1,status:0,statusText:"",responseType:"",responseXML:null,responseText:null,response:null},T=!0,S={},O=null,D=null,N=!1,C=!1,L=!1,M=!1,F=!1,B=!1,P=null,H=null,k={},U="";e.extend(this,I,{uid:e.guid("uid_"),upload:new m,open:function(o,a,s,u,c){var l;if(!o||!a)throw new t.DOMException(t.DOMException.SYNTAX_ERR);if(/[\u0100-\uffff]/.test(o)||n.utf8_encode(o)!==o)throw new t.DOMException(t.DOMException.SYNTAX_ERR);if(~e.inArray(o.toUpperCase(),["CONNECT","DELETE","GET","HEAD","OPTIONS","POST","PUT","TRACE","TRACK"])&&(v=o.toUpperCase()),~e.inArray(v,["CONNECT","TRACE","TRACK"]))throw new t.DOMException(t.DOMException.SECURITY_ERR);if(a=n.utf8_encode(a),l=r.parseUrl(a),B=r.hasSameOrigin(l),x=r.resolveUrl(a),(u||c)&&!B)throw new t.DOMException(t.DOMException.INVALID_ACCESS_ERR);if(w=u||l.user,y=c||l.pass,T=s||!0,T===!1&&(i("timeout")||i("withCredentials")||""!==i("responseType")))throw new t.DOMException(t.DOMException.INVALID_ACCESS_ERR);N=!T,C=!1,S={},g.call(this),i("readyState",h.OPENED),this.dispatchEvent("readystatechange")},setRequestHeader:function(r,o){var a=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","content-transfer-encoding","date","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","user-agent","via"];if(i("readyState")!==h.OPENED||C)throw new t.DOMException(t.DOMException.INVALID_STATE_ERR);if(/[\u0100-\uffff]/.test(r)||n.utf8_encode(r)!==r)throw new t.DOMException(t.DOMException.SYNTAX_ERR);return r=e.trim(r).toLowerCase(),~e.inArray(r,a)||/^(proxy\-|sec\-)/.test(r)?!1:(S[r]?S[r]+=", "+o:S[r]=o,!0)},hasRequestHeader:function(e){return e&&S[e.toLowerCase()]||!1},getAllResponseHeaders:function(){return U||""},getResponseHeader:function(t){return t=t.toLowerCase(),F||~e.inArray(t,["set-cookie","set-cookie2"])?null:U&&""!==U&&(R||(R={},e.each(U.split(/\r\n/),function(t){var i=t.split(/:\s+/);2===i.length&&(i[0]=e.trim(i[0]),R[i[0].toLowerCase()]={header:i[0],value:e.trim(i[1])})})),R.hasOwnProperty(t))?R[t].header+": "+R[t].value:null},overrideMimeType:function(n){var r,o;if(~e.inArray(i("readyState"),[h.LOADING,h.DONE]))throw new t.DOMException(t.DOMException.INVALID_STATE_ERR);if(n=e.trim(n.toLowerCase()),/;/.test(n)&&(r=n.match(/^([^;]+)(?:;\scharset\=)?(.*)$/))&&(n=r[1],r[2]&&(o=r[2])),!d.mimes[n])throw new t.DOMException(t.DOMException.SYNTAX_ERR);P=n,H=o},send:function(i,r){if(k="string"===e.typeOf(r)?{ruid:r}:r?r:{},this.readyState!==h.OPENED||C)throw new t.DOMException(t.DOMException.INVALID_STATE_ERR);if(i instanceof s)k.ruid=i.ruid,D=i.type||"application/octet-stream";else if(i instanceof c){if(i.hasBlob()){var o=i.getBlob();k.ruid=o.ruid,D=o.type||"application/octet-stream"}}else"string"==typeof i&&(O="UTF-8",D="text/plain;charset=UTF-8",i=n.utf8_encode(i));this.withCredentials||(this.withCredentials=k.required_caps&&k.required_caps.send_browser_cookies&&!B),L=!N&&this.upload.hasEventListener(),F=!1,M=!i,N||(C=!0),u.call(this,i)},abort:function(){if(F=!0,N=!1,~e.inArray(i("readyState"),[h.UNSENT,h.OPENED,h.DONE]))i("readyState",h.UNSENT);else{if(i("readyState",h.DONE),C=!1,!_)throw new t.DOMException(t.DOMException.INVALID_STATE_ERR);_.getRuntime().exec.call(_,"XMLHttpRequest","abort",M),M=!0}},destroy:function(){_&&("function"===e.typeOf(_.destroy)&&_.destroy(),_=null),this.unbindAll(),this.upload&&(this.upload.unbindAll(),this.upload=null)}}),this.handleEventProps(p.concat(["readystatechange"])),this.upload.handleEventProps(p)}var f={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",306:"Reserved",307:"Temporary Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Request Entity Too Large",414:"Request-URI Too Long",415:"Unsupported Media Type",416:"Requested Range Not Satisfiable",417:"Expectation Failed",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",426:"Upgrade Required",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",510:"Not Extended"};m.prototype=i.instance;var p=["loadstart","progress","abort","error","load","timeout","loadend"];return h.UNSENT=0,h.OPENED=1,h.HEADERS_RECEIVED=2,h.LOADING=3,h.DONE=4,h.prototype=i.instance,h}),n("moxie/runtime/Transporter",["moxie/core/utils/Basic","moxie/core/utils/Encode","moxie/runtime/RuntimeClient","moxie/core/EventTarget"],function(e,t,i,n){function r(){function n(){l=d=0,c=this.result=null}function o(t,i){var n=this;u=i,n.bind("TransportingProgress",function(t){d=t.loaded,l>d&&-1===e.inArray(n.state,[r.IDLE,r.DONE])&&a.call(n)},999),n.bind("TransportingComplete",function(){d=l,n.state=r.DONE,c=null,n.result=u.exec.call(n,"Transporter","getAsBlob",t||"")},999),n.state=r.BUSY,n.trigger("TransportingStarted"),a.call(n)}function a(){var e,i=this,n=l-d;m>n&&(m=n),e=t.btoa(c.substr(d,m)),u.exec.call(i,"Transporter","receive",e,l)}var s,u,c,l,d,m;i.call(this),e.extend(this,{uid:e.guid("uid_"),state:r.IDLE,result:null,transport:function(t,i,r){var a=this;if(r=e.extend({chunk_size:204798},r),(s=r.chunk_size%3)&&(r.chunk_size+=3-s),m=r.chunk_size,n.call(this),c=t,l=t.length,"string"===e.typeOf(r)||r.ruid)o.call(a,i,this.connectRuntime(r));else{var u=function(e,t){a.unbind("RuntimeInit",u),o.call(a,i,t)};this.bind("RuntimeInit",u),this.connectRuntime(r)}},abort:function(){var e=this;e.state=r.IDLE,u&&(u.exec.call(e,"Transporter","clear"),e.trigger("TransportingAborted")),n.call(e)},destroy:function(){this.unbindAll(),u=null,this.disconnectRuntime(),n.call(this)}})}return r.IDLE=0,r.BUSY=1,r.DONE=2,r.prototype=n.instance,r}),n("moxie/image/Image",["moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/file/FileReaderSync","moxie/xhr/XMLHttpRequest","moxie/runtime/Runtime","moxie/runtime/RuntimeClient","moxie/runtime/Transporter","moxie/core/utils/Env","moxie/core/EventTarget","moxie/file/Blob","moxie/file/File","moxie/core/utils/Encode"],function(e,t,i,n,r,o,a,s,u,c,l,d,m){function h(){function n(e){try{return e||(e=this.exec("Image","getInfo")),this.size=e.size,this.width=e.width,this.height=e.height,this.type=e.type,this.meta=e.meta,""===this.name&&(this.name=e.name),!0}catch(t){return this.trigger("error",t.code),!1}}function c(t){var n=e.typeOf(t);try{if(t instanceof h){if(!t.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);p.apply(this,arguments)}else if(t instanceof l){if(!~e.inArray(t.type,["image/jpeg","image/png"]))throw new i.ImageError(i.ImageError.WRONG_FORMAT);g.apply(this,arguments)}else if(-1!==e.inArray(n,["blob","file"]))c.call(this,new d(null,t),arguments[1]);else if("string"===n)"data:"===t.substr(0,5)?c.call(this,new l(null,{data:t}),arguments[1]):x.apply(this,arguments);else{if("node"!==n||"img"!==t.nodeName.toLowerCase())throw new i.DOMException(i.DOMException.TYPE_MISMATCH_ERR);c.call(this,t.src,arguments[1])}}catch(r){this.trigger("error",r.code)}}function p(t,i){var n=this.connectRuntime(t.ruid);this.ruid=n.uid,n.exec.call(this,"Image","loadFromImage",t,"undefined"===e.typeOf(i)?!0:i)}function g(t,i){function n(e){r.ruid=e.uid,e.exec.call(r,"Image","loadFromBlob",t)}var r=this;r.name=t.name||"",t.isDetached()?(this.bind("RuntimeInit",function(e,t){n(t)}),i&&"string"==typeof i.required_caps&&(i.required_caps=o.parseCaps(i.required_caps)),this.connectRuntime(e.extend({required_caps:{access_image_binary:!0,resize_image:!0}},i))):n(this.connectRuntime(t.ruid))}function x(e,t){var i,n=this;i=new r,i.open("get",e),i.responseType="blob",i.onprogress=function(e){n.trigger(e)},i.onload=function(){g.call(n,i.response,!0)},i.onerror=function(e){n.trigger(e)},i.onloadend=function(){i.destroy()},i.bind("RuntimeError",function(e,t){n.trigger("RuntimeError",t)}),i.send(null,t)}a.call(this),e.extend(this,{uid:e.guid("uid_"),ruid:null,name:"",size:0,width:0,height:0,type:"",meta:{},clone:function(){this.load.apply(this,arguments)},load:function(){c.apply(this,arguments)},resize:function(t){var n,r,o=this,a={x:0,y:0,width:o.width,height:o.height},s=e.extendIf({width:o.width,height:o.height,type:o.type||"image/jpeg",quality:90,crop:!1,fit:!0,preserveHeaders:!0,resample:"default",multipass:!0},t);try{if(!o.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);if(o.width>h.MAX_RESIZE_WIDTH||o.height>h.MAX_RESIZE_HEIGHT)throw new i.ImageError(i.ImageError.MAX_RESOLUTION_ERR);if(n=o.meta&&o.meta.tiff&&o.meta.tiff.Orientation||1,-1!==e.inArray(n,[5,6,7,8])){var u=s.width;s.width=s.height,s.height=u}if(s.crop){switch(r=Math.max(s.width/o.width,s.height/o.height),t.fit?(a.width=Math.min(Math.ceil(s.width/r),o.width),a.height=Math.min(Math.ceil(s.height/r),o.height),r=s.width/a.width):(a.width=Math.min(s.width,o.width),a.height=Math.min(s.height,o.height),r=1),"boolean"==typeof s.crop&&(s.crop="cc"),s.crop.toLowerCase().replace(/_/,"-")){case"rb":case"right-bottom":a.x=o.width-a.width,a.y=o.height-a.height;break;case"cb":case"center-bottom":a.x=Math.floor((o.width-a.width)/2),a.y=o.height-a.height;break;case"lb":case"left-bottom":a.x=0,a.y=o.height-a.height;break;case"lt":case"left-top":a.x=0,a.y=0;break;case"ct":case"center-top":a.x=Math.floor((o.width-a.width)/2),a.y=0;break;case"rt":case"right-top":a.x=o.width-a.width,a.y=0;break;case"rc":case"right-center":case"right-middle":a.x=o.width-a.width,a.y=Math.floor((o.height-a.height)/2);break;case"lc":case"left-center":case"left-middle":a.x=0,a.y=Math.floor((o.height-a.height)/2);break;case"cc":case"center-center":case"center-middle":default:a.x=Math.floor((o.width-a.width)/2),a.y=Math.floor((o.height-a.height)/2)}a.x=Math.max(a.x,0),a.y=Math.max(a.y,0)}else r=Math.min(s.width/o.width,s.height/o.height),r>1&&!s.fit&&(r=1);this.exec("Image","resize",a,r,s)}catch(c){o.trigger("error",c.code)}},downsize:function(t){var i,n={width:this.width,height:this.height,type:this.type||"image/jpeg",quality:90,crop:!1,fit:!1,preserveHeaders:!0,resample:"default"};i="object"==typeof t?e.extend(n,t):e.extend(n,{width:arguments[0],height:arguments[1],crop:arguments[2],preserveHeaders:arguments[3]}),this.resize(i)},crop:function(e,t,i){this.downsize(e,t,!0,i)},getAsCanvas:function(){if(!u.can("create_canvas"))throw new i.RuntimeError(i.RuntimeError.NOT_SUPPORTED_ERR);return this.exec("Image","getAsCanvas")},getAsBlob:function(e,t){if(!this.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);return this.exec("Image","getAsBlob",e||"image/jpeg",t||90)},getAsDataURL:function(e,t){if(!this.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);return this.exec("Image","getAsDataURL",e||"image/jpeg",t||90)},getAsBinaryString:function(e,t){var i=this.getAsDataURL(e,t);return m.atob(i.substring(i.indexOf("base64,")+7))},embed:function(n,r){function o(t,r){var o=this;if(u.can("create_canvas")){var l=o.getAsCanvas();if(l)return n.appendChild(l),l=null,o.destroy(),c.trigger("embedded"),void 0}var d=o.getAsDataURL(t,r);if(!d)throw new i.ImageError(i.ImageError.WRONG_FORMAT);if(u.can("use_data_uri_of",d.length))n.innerHTML='<img src="'+d+'" width="'+o.width+'" height="'+o.height+'" alt="" />',o.destroy(),c.trigger("embedded");else{var h=new s;h.bind("TransportingComplete",function(){a=c.connectRuntime(this.result.ruid),c.bind("Embedded",function(){e.extend(a.getShimContainer().style,{top:"0px",left:"0px",width:o.width+"px",height:o.height+"px"}),a=null},999),a.exec.call(c,"ImageView","display",this.result.uid,width,height),o.destroy()}),h.transport(m.atob(d.substring(d.indexOf("base64,")+7)),t,{required_caps:{display_media:!0},runtime_order:"flash,silverlight",container:n})}}var a,c=this,l=e.extend({width:this.width,height:this.height,type:this.type||"image/jpeg",quality:90,fit:!0,resample:"nearest"},r);try{if(!(n=t.get(n)))throw new i.DOMException(i.DOMException.INVALID_NODE_TYPE_ERR);if(!this.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);this.width>h.MAX_RESIZE_WIDTH||this.height>h.MAX_RESIZE_HEIGHT;var d=new h;return d.bind("Resize",function(){o.call(this,l.type,l.quality)}),d.bind("Load",function(){this.downsize(l)}),this.meta.thumb&&this.meta.thumb.width>=l.width&&this.meta.thumb.height>=l.height?d.load(this.meta.thumb.data):d.clone(this,!1),d}catch(f){this.trigger("error",f.code)}},destroy:function(){this.ruid&&(this.getRuntime().exec.call(this,"Image","destroy"),this.disconnectRuntime()),this.meta&&this.meta.thumb&&this.meta.thumb.data.destroy(),this.unbindAll()}}),this.handleEventProps(f),this.bind("Load Resize",function(){return n.call(this)},999)}var f=["progress","load","error","resize","embedded"];return h.MAX_RESIZE_WIDTH=8192,h.MAX_RESIZE_HEIGHT=8192,h.prototype=c.instance,h}),n("moxie/runtime/html5/Runtime",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/runtime/Runtime","moxie/core/utils/Env"],function(e,t,i,n){function o(t){var o=this,u=i.capTest,c=i.capTrue,l=e.extend({access_binary:u(window.FileReader||window.File&&window.File.getAsDataURL),access_image_binary:function(){return o.can("access_binary")&&!!s.Image},display_media:u((n.can("create_canvas")||n.can("use_data_uri_over32kb"))&&r("moxie/image/Image")),do_cors:u(window.XMLHttpRequest&&"withCredentials"in new XMLHttpRequest),drag_and_drop:u(function(){var e=document.createElement("div");return("draggable"in e||"ondragstart"in e&&"ondrop"in e)&&("IE"!==n.browser||n.verComp(n.version,9,">"))}()),filter_by_extension:u(function(){return!("Chrome"===n.browser&&n.verComp(n.version,28,"<")||"IE"===n.browser&&n.verComp(n.version,10,"<")||"Safari"===n.browser&&n.verComp(n.version,7,"<")||"Firefox"===n.browser&&n.verComp(n.version,37,"<"))}()),return_response_headers:c,return_response_type:function(e){return"json"===e&&window.JSON?!0:n.can("return_response_type",e)},return_status_code:c,report_upload_progress:u(window.XMLHttpRequest&&(new XMLHttpRequest).upload),resize_image:function(){return o.can("access_binary")&&n.can("create_canvas")},select_file:function(){return n.can("use_fileinput")&&window.File},select_folder:function(){return o.can("select_file")&&("Chrome"===n.browser&&n.verComp(n.version,21,">=")||"Firefox"===n.browser&&n.verComp(n.version,42,">="))},select_multiple:function(){return!(!o.can("select_file")||"Safari"===n.browser&&"Windows"===n.os||"iOS"===n.os&&n.verComp(n.osVersion,"7.0.0",">")&&n.verComp(n.osVersion,"8.0.0","<"))},send_binary_string:u(window.XMLHttpRequest&&((new XMLHttpRequest).sendAsBinary||window.Uint8Array&&window.ArrayBuffer)),send_custom_headers:u(window.XMLHttpRequest),send_multipart:function(){return!!(window.XMLHttpRequest&&(new XMLHttpRequest).upload&&window.FormData)||o.can("send_binary_string")},slice_blob:u(window.File&&(File.prototype.mozSlice||File.prototype.webkitSlice||File.prototype.slice)),stream_upload:function(){return o.can("slice_blob")&&o.can("send_multipart")},summon_file_dialog:function(){return o.can("select_file")&&!("Firefox"===n.browser&&n.verComp(n.version,4,"<")||"Opera"===n.browser&&n.verComp(n.version,12,"<")||"IE"===n.browser&&n.verComp(n.version,10,"<"))},upload_filesize:c,use_http_method:c},arguments[2]);i.call(this,t,arguments[1]||a,l),e.extend(this,{init:function(){this.trigger("Init")},destroy:function(e){return function(){e.call(o),e=o=null}}(this.destroy)}),e.extend(this.getShim(),s)}var a="html5",s={};return i.addConstructor(a,o),s}),n("moxie/runtime/html5/file/Blob",["moxie/runtime/html5/Runtime","moxie/file/Blob"],function(e,t){function i(){function e(e,t,i){var n;if(!window.File.prototype.slice)return(n=window.File.prototype.webkitSlice||window.File.prototype.mozSlice)?n.call(e,t,i):null;try{return e.slice(),e.slice(t,i)}catch(r){return e.slice(t,i-t)}}this.slice=function(){return new t(this.getRuntime().uid,e.apply(this,arguments))},this.destroy=function(){this.getRuntime().getShim().removeInstance(this.uid)}}return e.Blob=i}),n("moxie/core/utils/Events",["moxie/core/utils/Basic"],function(e){function t(){this.returnValue=!1}function i(){this.cancelBubble=!0}var n={},r="moxie_"+e.guid(),o=function(o,a,s,u){var c,l;a=a.toLowerCase(),o.addEventListener?(c=s,o.addEventListener(a,c,!1)):o.attachEvent&&(c=function(){var e=window.event;e.target||(e.target=e.srcElement),e.preventDefault=t,e.stopPropagation=i,s(e)},o.attachEvent("on"+a,c)),o[r]||(o[r]=e.guid()),n.hasOwnProperty(o[r])||(n[o[r]]={}),l=n[o[r]],l.hasOwnProperty(a)||(l[a]=[]),l[a].push({func:c,orig:s,key:u})},a=function(t,i,o){var a,s;if(i=i.toLowerCase(),t[r]&&n[t[r]]&&n[t[r]][i]){a=n[t[r]][i];for(var u=a.length-1;u>=0&&(a[u].orig!==o&&a[u].key!==o||(t.removeEventListener?t.removeEventListener(i,a[u].func,!1):t.detachEvent&&t.detachEvent("on"+i,a[u].func),a[u].orig=null,a[u].func=null,a.splice(u,1),o===s));u--);if(a.length||delete n[t[r]][i],e.isEmptyObj(n[t[r]])){delete n[t[r]];try{delete t[r]}catch(c){t[r]=s}}}},s=function(t,i){t&&t[r]&&e.each(n[t[r]],function(e,n){a(t,n,i)})};return{addEvent:o,removeEvent:a,removeAllEvents:s}}),n("moxie/runtime/html5/file/FileInput",["moxie/runtime/html5/Runtime","moxie/file/File","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/utils/Events","moxie/core/utils/Mime","moxie/core/utils/Env"],function(e,t,i,n,r,o,a){function s(){var e,s;i.extend(this,{init:function(u){var c,l,d,m,h,f,p=this,g=p.getRuntime();e=u,d=o.extList2mimes(e.accept,g.can("filter_by_extension")),l=g.getShimContainer(),l.innerHTML='<input id="'+g.uid+'" type="file" style="font-size:999px;opacity:0;"'+(e.multiple&&g.can("select_multiple")?"multiple":"")+(e.directory&&g.can("select_folder")?"webkitdirectory directory":"")+(d?' accept="'+d.join(",")+'"':"")+" />",c=n.get(g.uid),i.extend(c.style,{position:"absolute",top:0,left:0,width:"100%",height:"100%"}),m=n.get(e.browse_button),s=n.getStyle(m,"z-index")||"auto",g.can("summon_file_dialog")&&("static"===n.getStyle(m,"position")&&(m.style.position="relative"),r.addEvent(m,"click",function(e){var t=n.get(g.uid);t&&!t.disabled&&t.click(),e.preventDefault()},p.uid),p.bind("Refresh",function(){h=parseInt(s,10)||1,n.get(e.browse_button).style.zIndex=h,this.getRuntime().getShimContainer().style.zIndex=h-1})),f=g.can("summon_file_dialog")?m:l,r.addEvent(f,"mouseover",function(){p.trigger("mouseenter")},p.uid),r.addEvent(f,"mouseout",function(){p.trigger("mouseleave")},p.uid),r.addEvent(f,"mousedown",function(){p.trigger("mousedown")},p.uid),r.addEvent(n.get(e.container),"mouseup",function(){p.trigger("mouseup")},p.uid),(g.can("summon_file_dialog")?c:m).setAttribute("tabindex",-1),c.onchange=function x(){if(p.files=[],i.each(this.files,function(i){var n="";return e.directory&&"."==i.name?!0:(i.webkitRelativePath&&(n="/"+i.webkitRelativePath.replace(/^\//,"")),i=new t(g.uid,i),i.relativePath=n,p.files.push(i),void 0)}),"IE"!==a.browser&&"IEMobile"!==a.browser)this.value="";else{var n=this.cloneNode(!0);this.parentNode.replaceChild(n,this),n.onchange=x}p.files.length&&p.trigger("change")},p.trigger({type:"ready",async:!0}),l=null},setOption:function(e,t){var i=this.getRuntime(),r=n.get(i.uid);switch(e){case"accept":if(t){var a=t.mimes||o.extList2mimes(t,i.can("filter_by_extension"));r.setAttribute("accept",a.join(","))}else r.removeAttribute("accept");break;case"directory":t&&i.can("select_folder")?(r.setAttribute("directory",""),r.setAttribute("webkitdirectory","")):(r.removeAttribute("directory"),r.removeAttribute("webkitdirectory"));break;case"multiple":t&&i.can("select_multiple")?r.setAttribute("multiple",""):r.removeAttribute("multiple")}},disable:function(e){var t,i=this.getRuntime();(t=n.get(i.uid))&&(t.disabled=!!e)},destroy:function(){var t=this.getRuntime(),i=t.getShim(),o=t.getShimContainer(),a=e&&n.get(e.container),u=e&&n.get(e.browse_button);a&&r.removeAllEvents(a,this.uid),u&&(r.removeAllEvents(u,this.uid),u.style.zIndex=s),o&&(r.removeAllEvents(o,this.uid),o.innerHTML=""),i.removeInstance(this.uid),e=o=a=u=i=null}})}return e.FileInput=s}),n("moxie/runtime/html5/file/FileDrop",["moxie/runtime/html5/Runtime","moxie/file/File","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/utils/Events","moxie/core/utils/Mime"],function(e,t,i,n,r,o){function a(){function e(e){if(!e.dataTransfer||!e.dataTransfer.types)return!1;var t=i.toArray(e.dataTransfer.types||[]);return-1!==i.inArray("Files",t)||-1!==i.inArray("public.file-url",t)||-1!==i.inArray("application/x-moz-file",t)}function a(e,i){if(u(e)){var n=new t(f,e);n.relativePath=i||"",p.push(n)}}function s(e){for(var t=[],n=0;n<e.length;n++)[].push.apply(t,e[n].extensions.split(/\s*,\s*/));return-1===i.inArray("*",t)?t:[]}function u(e){if(!g.length)return!0;var t=o.getFileExtension(e.name);return!t||-1!==i.inArray(t,g)}function c(e,t){var n=[];i.each(e,function(e){var t=e.webkitGetAsEntry();t&&(t.isFile?a(e.getAsFile(),t.fullPath):n.push(t))}),n.length?l(n,t):t()}function l(e,t){var n=[];i.each(e,function(e){n.push(function(t){d(e,t)})}),i.inSeries(n,function(){t()})}function d(e,t){e.isFile?e.file(function(i){a(i,e.fullPath),t()},function(){t()}):e.isDirectory?m(e,t):t()}function m(e,t){function i(e){r.readEntries(function(t){t.length?([].push.apply(n,t),i(e)):e()},e)}var n=[],r=e.createReader();i(function(){l(n,t)})}var h,f,p=[],g=[];i.extend(this,{init:function(t){var n,o=this;h=t,f=o.ruid,g=s(h.accept),n=h.container,r.addEvent(n,"dragover",function(t){e(t)&&(t.preventDefault(),t.dataTransfer.dropEffect="copy")},o.uid),r.addEvent(n,"drop",function(t){e(t)&&(t.preventDefault(),p=[],t.dataTransfer.items&&t.dataTransfer.items[0].webkitGetAsEntry?c(t.dataTransfer.items,function(){o.files=p,o.trigger("drop")}):(i.each(t.dataTransfer.files,function(e){a(e)}),o.files=p,o.trigger("drop")))},o.uid),r.addEvent(n,"dragenter",function(){o.trigger("dragenter")},o.uid),r.addEvent(n,"dragleave",function(){o.trigger("dragleave")},o.uid)},destroy:function(){r.removeAllEvents(h&&n.get(h.container),this.uid),f=p=g=h=null,this.getRuntime().getShim().removeInstance(this.uid)}})}return e.FileDrop=a}),n("moxie/runtime/html5/file/FileReader",["moxie/runtime/html5/Runtime","moxie/core/utils/Encode","moxie/core/utils/Basic"],function(e,t,i){function n(){function e(e){return t.atob(e.substring(e.indexOf("base64,")+7))}var n,r=!1;i.extend(this,{read:function(t,o){var a=this;a.result="",n=new window.FileReader,n.addEventListener("progress",function(e){a.trigger(e)}),n.addEventListener("load",function(t){a.result=r?e(n.result):n.result,a.trigger(t)}),n.addEventListener("error",function(e){a.trigger(e,n.error)}),n.addEventListener("loadend",function(e){n=null,a.trigger(e)}),"function"===i.typeOf(n[t])?(r=!1,n[t](o.getSource())):"readAsBinaryString"===t&&(r=!0,n.readAsDataURL(o.getSource()))},abort:function(){n&&n.abort()},destroy:function(){n=null,this.getRuntime().getShim().removeInstance(this.uid)}})}return e.FileReader=n}),n("moxie/runtime/html5/xhr/XMLHttpRequest",["moxie/runtime/html5/Runtime","moxie/core/utils/Basic","moxie/core/utils/Mime","moxie/core/utils/Url","moxie/file/File","moxie/file/Blob","moxie/xhr/FormData","moxie/core/Exceptions","moxie/core/utils/Env"],function(e,t,i,n,r,o,a,s,u){function c(){function e(e,t){var i,n,r=this;i=t.getBlob().getSource(),n=new window.FileReader,n.onload=function(){t.append(t.getBlobName(),new o(null,{type:i.type,data:n.result})),f.send.call(r,e,t)},n.readAsBinaryString(i)}function c(){return!window.XMLHttpRequest||"IE"===u.browser&&u.verComp(u.version,8,"<")?function(){for(var e=["Msxml2.XMLHTTP.6.0","Microsoft.XMLHTTP"],t=0;t<e.length;t++)try{return new ActiveXObject(e[t])}catch(i){}}():new window.XMLHttpRequest}function l(e){var t=e.responseXML,i=e.responseText;return"IE"===u.browser&&i&&t&&!t.documentElement&&/[^\/]+\/[^\+]+\+xml/.test(e.getResponseHeader("Content-Type"))&&(t=new window.ActiveXObject("Microsoft.XMLDOM"),t.async=!1,t.validateOnParse=!1,t.loadXML(i)),t&&("IE"===u.browser&&0!==t.parseError||!t.documentElement||"parsererror"===t.documentElement.tagName)?null:t
}function d(e){var t="----moxieboundary"+(new Date).getTime(),i="--",n="\r\n",r="",a=this.getRuntime();if(!a.can("send_binary_string"))throw new s.RuntimeError(s.RuntimeError.NOT_SUPPORTED_ERR);return m.setRequestHeader("Content-Type","multipart/form-data; boundary="+t),e.each(function(e,a){r+=e instanceof o?i+t+n+'Content-Disposition: form-data; name="'+a+'"; filename="'+unescape(encodeURIComponent(e.name||"blob"))+'"'+n+"Content-Type: "+(e.type||"application/octet-stream")+n+n+e.getSource()+n:i+t+n+'Content-Disposition: form-data; name="'+a+'"'+n+n+unescape(encodeURIComponent(e))+n}),r+=i+t+i+n}var m,h,f=this;t.extend(this,{send:function(i,r){var s=this,l="Mozilla"===u.browser&&u.verComp(u.version,4,">=")&&u.verComp(u.version,7,"<"),f="Android Browser"===u.browser,p=!1;if(h=i.url.replace(/^.+?\/([\w\-\.]+)$/,"$1").toLowerCase(),m=c(),m.open(i.method,i.url,i.async,i.user,i.password),r instanceof o)r.isDetached()&&(p=!0),r=r.getSource();else if(r instanceof a){if(r.hasBlob())if(r.getBlob().isDetached())r=d.call(s,r),p=!0;else if((l||f)&&"blob"===t.typeOf(r.getBlob().getSource())&&window.FileReader)return e.call(s,i,r),void 0;if(r instanceof a){var g=new window.FormData;r.each(function(e,t){e instanceof o?g.append(t,e.getSource()):g.append(t,e)}),r=g}}m.upload?(i.withCredentials&&(m.withCredentials=!0),m.addEventListener("load",function(e){s.trigger(e)}),m.addEventListener("error",function(e){s.trigger(e)}),m.addEventListener("progress",function(e){s.trigger(e)}),m.upload.addEventListener("progress",function(e){s.trigger({type:"UploadProgress",loaded:e.loaded,total:e.total})})):m.onreadystatechange=function(){switch(m.readyState){case 1:break;case 2:break;case 3:var e,t;try{n.hasSameOrigin(i.url)&&(e=m.getResponseHeader("Content-Length")||0),m.responseText&&(t=m.responseText.length)}catch(r){e=t=0}s.trigger({type:"progress",lengthComputable:!!e,total:parseInt(e,10),loaded:t});break;case 4:m.onreadystatechange=function(){};try{if(m.status>=200&&m.status<400){s.trigger("load");break}}catch(r){}s.trigger("error")}},t.isEmptyObj(i.headers)||t.each(i.headers,function(e,t){m.setRequestHeader(t,e)}),""!==i.responseType&&"responseType"in m&&(m.responseType="json"!==i.responseType||u.can("return_response_type","json")?i.responseType:"text"),p?m.sendAsBinary?m.sendAsBinary(r):function(){for(var e=new Uint8Array(r.length),t=0;t<r.length;t++)e[t]=255&r.charCodeAt(t);m.send(e.buffer)}():m.send(r),s.trigger("loadstart")},getStatus:function(){try{if(m)return m.status}catch(e){}return 0},getResponse:function(e){var t=this.getRuntime();try{switch(e){case"blob":var n=new r(t.uid,m.response),o=m.getResponseHeader("Content-Disposition");if(o){var a=o.match(/filename=([\'\"'])([^\1]+)\1/);a&&(h=a[2])}return n.name=h,n.type||(n.type=i.getFileMime(h)),n;case"json":return u.can("return_response_type","json")?m.response:200===m.status&&window.JSON?JSON.parse(m.responseText):null;case"document":return l(m);default:return""!==m.responseText?m.responseText:null}}catch(s){return null}},getAllResponseHeaders:function(){try{return m.getAllResponseHeaders()}catch(e){}return""},abort:function(){m&&m.abort()},destroy:function(){f=h=null,this.getRuntime().getShim().removeInstance(this.uid)}})}return e.XMLHttpRequest=c}),n("moxie/runtime/html5/utils/BinaryReader",["moxie/core/utils/Basic"],function(e){function t(e){e instanceof ArrayBuffer?i.apply(this,arguments):n.apply(this,arguments)}function i(t){var i=new DataView(t);e.extend(this,{readByteAt:function(e){return i.getUint8(e)},writeByteAt:function(e,t){i.setUint8(e,t)},SEGMENT:function(e,n,r){switch(arguments.length){case 2:return t.slice(e,e+n);case 1:return t.slice(e);case 3:if(null===r&&(r=new ArrayBuffer),r instanceof ArrayBuffer){var o=new Uint8Array(this.length()-n+r.byteLength);e>0&&o.set(new Uint8Array(t.slice(0,e)),0),o.set(new Uint8Array(r),e),o.set(new Uint8Array(t.slice(e+n)),e+r.byteLength),this.clear(),t=o.buffer,i=new DataView(t);break}default:return t}},length:function(){return t?t.byteLength:0},clear:function(){i=t=null}})}function n(t){function i(e,i,n){n=3===arguments.length?n:t.length-i-1,t=t.substr(0,i)+e+t.substr(n+i)}e.extend(this,{readByteAt:function(e){return t.charCodeAt(e)},writeByteAt:function(e,t){i(String.fromCharCode(t),e,1)},SEGMENT:function(e,n,r){switch(arguments.length){case 1:return t.substr(e);case 2:return t.substr(e,n);case 3:i(null!==r?r:"",e,n);break;default:return t}},length:function(){return t?t.length:0},clear:function(){t=null}})}return e.extend(t.prototype,{littleEndian:!1,read:function(e,t){var i,n,r;if(e+t>this.length())throw new Error("You are trying to read outside the source boundaries.");for(n=this.littleEndian?0:-8*(t-1),r=0,i=0;t>r;r++)i|=this.readByteAt(e+r)<<Math.abs(n+8*r);return i},write:function(e,t,i){var n,r;if(e>this.length())throw new Error("You are trying to write outside the source boundaries.");for(n=this.littleEndian?0:-8*(i-1),r=0;i>r;r++)this.writeByteAt(e+r,255&t>>Math.abs(n+8*r))},BYTE:function(e){return this.read(e,1)},SHORT:function(e){return this.read(e,2)},LONG:function(e){return this.read(e,4)},SLONG:function(e){var t=this.read(e,4);return t>2147483647?t-4294967296:t},CHAR:function(e){return String.fromCharCode(this.read(e,1))},STRING:function(e,t){return this.asArray("CHAR",e,t).join("")},asArray:function(e,t,i){for(var n=[],r=0;i>r;r++)n[r]=this[e](t+r);return n}}),t}),n("moxie/runtime/html5/image/JPEGHeaders",["moxie/runtime/html5/utils/BinaryReader","moxie/core/Exceptions"],function(e,t){return function i(n){var r,o,a,s=[],u=0;if(r=new e(n),65496!==r.SHORT(0))throw r.clear(),new t.ImageError(t.ImageError.WRONG_FORMAT);for(o=2;o<=r.length();)if(a=r.SHORT(o),a>=65488&&65495>=a)o+=2;else{if(65498===a||65497===a)break;u=r.SHORT(o+2)+2,a>=65505&&65519>=a&&s.push({hex:a,name:"APP"+(15&a),start:o,length:u,segment:r.SEGMENT(o,u)}),o+=u}return r.clear(),{headers:s,restore:function(t){var i,n,r;for(r=new e(t),o=65504==r.SHORT(2)?4+r.SHORT(4):2,n=0,i=s.length;i>n;n++)r.SEGMENT(o,0,s[n].segment),o+=s[n].length;return t=r.SEGMENT(),r.clear(),t},strip:function(t){var n,r,o,a;for(o=new i(t),r=o.headers,o.purge(),n=new e(t),a=r.length;a--;)n.SEGMENT(r[a].start,r[a].length,"");return t=n.SEGMENT(),n.clear(),t},get:function(e){for(var t=[],i=0,n=s.length;n>i;i++)s[i].name===e.toUpperCase()&&t.push(s[i].segment);return t},set:function(e,t){var i,n,r,o=[];for("string"==typeof t?o.push(t):o=t,i=n=0,r=s.length;r>i&&(s[i].name===e.toUpperCase()&&(s[i].segment=o[n],s[i].length=o[n].length,n++),!(n>=o.length));i++);},purge:function(){this.headers=s=[]}}}}),n("moxie/runtime/html5/image/ExifParser",["moxie/core/utils/Basic","moxie/runtime/html5/utils/BinaryReader","moxie/core/Exceptions"],function(e,i,n){function r(o){function a(i,r){var o,a,s,u,c,m,h,f,p=this,g=[],x={},v={1:"BYTE",7:"UNDEFINED",2:"ASCII",3:"SHORT",4:"LONG",5:"RATIONAL",9:"SLONG",10:"SRATIONAL"},w={BYTE:1,UNDEFINED:1,ASCII:1,SHORT:2,LONG:4,RATIONAL:8,SLONG:4,SRATIONAL:8};for(o=p.SHORT(i),a=0;o>a;a++)if(g=[],h=i+2+12*a,s=r[p.SHORT(h)],s!==t){if(u=v[p.SHORT(h+=2)],c=p.LONG(h+=2),m=w[u],!m)throw new n.ImageError(n.ImageError.INVALID_META_ERR);if(h+=4,m*c>4&&(h=p.LONG(h)+d.tiffHeader),h+m*c>=this.length())throw new n.ImageError(n.ImageError.INVALID_META_ERR);"ASCII"!==u?(g=p.asArray(u,h,c),f=1==c?g[0]:g,x[s]=l.hasOwnProperty(s)&&"object"!=typeof f?l[s][f]:f):x[s]=e.trim(p.STRING(h,c).replace(/\0$/,""))}return x}function s(e,t,i){var n,r,o,a=0;if("string"==typeof t){var s=c[e.toLowerCase()];for(var u in s)if(s[u]===t){t=u;break}}n=d[e.toLowerCase()+"IFD"],r=this.SHORT(n);for(var l=0;r>l;l++)if(o=n+12*l+2,this.SHORT(o)==t){a=o+8;break}if(!a)return!1;try{this.write(a,i,4)}catch(m){return!1}return!0}var u,c,l,d,m,h;if(i.call(this,o),c={tiff:{274:"Orientation",270:"ImageDescription",271:"Make",272:"Model",305:"Software",34665:"ExifIFDPointer",34853:"GPSInfoIFDPointer"},exif:{36864:"ExifVersion",40961:"ColorSpace",40962:"PixelXDimension",40963:"PixelYDimension",36867:"DateTimeOriginal",33434:"ExposureTime",33437:"FNumber",34855:"ISOSpeedRatings",37377:"ShutterSpeedValue",37378:"ApertureValue",37383:"MeteringMode",37384:"LightSource",37385:"Flash",37386:"FocalLength",41986:"ExposureMode",41987:"WhiteBalance",41990:"SceneCaptureType",41988:"DigitalZoomRatio",41992:"Contrast",41993:"Saturation",41994:"Sharpness"},gps:{0:"GPSVersionID",1:"GPSLatitudeRef",2:"GPSLatitude",3:"GPSLongitudeRef",4:"GPSLongitude"},thumb:{513:"JPEGInterchangeFormat",514:"JPEGInterchangeFormatLength"}},l={ColorSpace:{1:"sRGB",0:"Uncalibrated"},MeteringMode:{0:"Unknown",1:"Average",2:"CenterWeightedAverage",3:"Spot",4:"MultiSpot",5:"Pattern",6:"Partial",255:"Other"},LightSource:{1:"Daylight",2:"Fliorescent",3:"Tungsten",4:"Flash",9:"Fine weather",10:"Cloudy weather",11:"Shade",12:"Daylight fluorescent (D 5700 - 7100K)",13:"Day white fluorescent (N 4600 -5400K)",14:"Cool white fluorescent (W 3900 - 4500K)",15:"White fluorescent (WW 3200 - 3700K)",17:"Standard light A",18:"Standard light B",19:"Standard light C",20:"D55",21:"D65",22:"D75",23:"D50",24:"ISO studio tungsten",255:"Other"},Flash:{0:"Flash did not fire",1:"Flash fired",5:"Strobe return light not detected",7:"Strobe return light detected",9:"Flash fired, compulsory flash mode",13:"Flash fired, compulsory flash mode, return light not detected",15:"Flash fired, compulsory flash mode, return light detected",16:"Flash did not fire, compulsory flash mode",24:"Flash did not fire, auto mode",25:"Flash fired, auto mode",29:"Flash fired, auto mode, return light not detected",31:"Flash fired, auto mode, return light detected",32:"No flash function",65:"Flash fired, red-eye reduction mode",69:"Flash fired, red-eye reduction mode, return light not detected",71:"Flash fired, red-eye reduction mode, return light detected",73:"Flash fired, compulsory flash mode, red-eye reduction mode",77:"Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",79:"Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",89:"Flash fired, auto mode, red-eye reduction mode",93:"Flash fired, auto mode, return light not detected, red-eye reduction mode",95:"Flash fired, auto mode, return light detected, red-eye reduction mode"},ExposureMode:{0:"Auto exposure",1:"Manual exposure",2:"Auto bracket"},WhiteBalance:{0:"Auto white balance",1:"Manual white balance"},SceneCaptureType:{0:"Standard",1:"Landscape",2:"Portrait",3:"Night scene"},Contrast:{0:"Normal",1:"Soft",2:"Hard"},Saturation:{0:"Normal",1:"Low saturation",2:"High saturation"},Sharpness:{0:"Normal",1:"Soft",2:"Hard"},GPSLatitudeRef:{N:"North latitude",S:"South latitude"},GPSLongitudeRef:{E:"East longitude",W:"West longitude"}},d={tiffHeader:10},m=d.tiffHeader,u={clear:this.clear},e.extend(this,{read:function(){try{return r.prototype.read.apply(this,arguments)}catch(e){throw new n.ImageError(n.ImageError.INVALID_META_ERR)}},write:function(){try{return r.prototype.write.apply(this,arguments)}catch(e){throw new n.ImageError(n.ImageError.INVALID_META_ERR)}},UNDEFINED:function(){return this.BYTE.apply(this,arguments)},RATIONAL:function(e){return this.LONG(e)/this.LONG(e+4)},SRATIONAL:function(e){return this.SLONG(e)/this.SLONG(e+4)},ASCII:function(e){return this.CHAR(e)},TIFF:function(){return h||null},EXIF:function(){var t=null;if(d.exifIFD){try{t=a.call(this,d.exifIFD,c.exif)}catch(i){return null}if(t.ExifVersion&&"array"===e.typeOf(t.ExifVersion)){for(var n=0,r="";n<t.ExifVersion.length;n++)r+=String.fromCharCode(t.ExifVersion[n]);t.ExifVersion=r}}return t},GPS:function(){var t=null;if(d.gpsIFD){try{t=a.call(this,d.gpsIFD,c.gps)}catch(i){return null}t.GPSVersionID&&"array"===e.typeOf(t.GPSVersionID)&&(t.GPSVersionID=t.GPSVersionID.join("."))}return t},thumb:function(){if(d.IFD1)try{var e=a.call(this,d.IFD1,c.thumb);if("JPEGInterchangeFormat"in e)return this.SEGMENT(d.tiffHeader+e.JPEGInterchangeFormat,e.JPEGInterchangeFormatLength)}catch(t){}return null},setExif:function(e,t){return"PixelXDimension"!==e&&"PixelYDimension"!==e?!1:s.call(this,"exif",e,t)},clear:function(){u.clear(),o=c=l=h=d=u=null}}),65505!==this.SHORT(0)||"EXIF\0"!==this.STRING(4,5).toUpperCase())throw new n.ImageError(n.ImageError.INVALID_META_ERR);if(this.littleEndian=18761==this.SHORT(m),42!==this.SHORT(m+=2))throw new n.ImageError(n.ImageError.INVALID_META_ERR);d.IFD0=d.tiffHeader+this.LONG(m+=2),h=a.call(this,d.IFD0,c.tiff),"ExifIFDPointer"in h&&(d.exifIFD=d.tiffHeader+h.ExifIFDPointer,delete h.ExifIFDPointer),"GPSInfoIFDPointer"in h&&(d.gpsIFD=d.tiffHeader+h.GPSInfoIFDPointer,delete h.GPSInfoIFDPointer),e.isEmptyObj(h)&&(h=null);var f=this.LONG(d.IFD0+12*this.SHORT(d.IFD0)+2);f&&(d.IFD1=d.tiffHeader+f)}return r.prototype=i.prototype,r}),n("moxie/runtime/html5/image/JPEG",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/runtime/html5/image/JPEGHeaders","moxie/runtime/html5/utils/BinaryReader","moxie/runtime/html5/image/ExifParser"],function(e,t,i,n,r){function o(o){function a(e){var t,i,n=0;for(e||(e=c);n<=e.length();){if(t=e.SHORT(n+=2),t>=65472&&65475>=t)return n+=5,{height:e.SHORT(n),width:e.SHORT(n+=2)};i=e.SHORT(n+=2),n+=i-2}return null}function s(){var e,t,i=d.thumb();return i&&(e=new n(i),t=a(e),e.clear(),t)?(t.data=i,t):null}function u(){d&&l&&c&&(d.clear(),l.purge(),c.clear(),m=l=d=c=null)}var c,l,d,m;if(c=new n(o),65496!==c.SHORT(0))throw new t.ImageError(t.ImageError.WRONG_FORMAT);l=new i(o);try{d=new r(l.get("app1")[0])}catch(h){}m=a.call(this),e.extend(this,{type:"image/jpeg",size:c.length(),width:m&&m.width||0,height:m&&m.height||0,setExif:function(t,i){return d?("object"===e.typeOf(t)?e.each(t,function(e,t){d.setExif(t,e)}):d.setExif(t,i),l.set("app1",d.SEGMENT()),void 0):!1},writeHeaders:function(){return arguments.length?l.restore(arguments[0]):l.restore(o)},stripHeaders:function(e){return l.strip(e)},purge:function(){u.call(this)}}),d&&(this.meta={tiff:d.TIFF(),exif:d.EXIF(),gps:d.GPS(),thumb:s()})}return o}),n("moxie/runtime/html5/image/PNG",["moxie/core/Exceptions","moxie/core/utils/Basic","moxie/runtime/html5/utils/BinaryReader"],function(e,t,i){function n(n){function r(){var e,t;return e=a.call(this,8),"IHDR"==e.type?(t=e.start,{width:s.LONG(t),height:s.LONG(t+=4)}):null}function o(){s&&(s.clear(),n=l=u=c=s=null)}function a(e){var t,i,n,r;return t=s.LONG(e),i=s.STRING(e+=4,4),n=e+=4,r=s.LONG(e+t),{length:t,type:i,start:n,CRC:r}}var s,u,c,l;s=new i(n),function(){var t=0,i=0,n=[35152,20039,3338,6666];for(i=0;i<n.length;i++,t+=2)if(n[i]!=s.SHORT(t))throw new e.ImageError(e.ImageError.WRONG_FORMAT)}(),l=r.call(this),t.extend(this,{type:"image/png",size:s.length(),width:l.width,height:l.height,purge:function(){o.call(this)}}),o.call(this)}return n}),n("moxie/runtime/html5/image/ImageInfo",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/runtime/html5/image/JPEG","moxie/runtime/html5/image/PNG"],function(e,t,i,n){return function(r){var o,a=[i,n];o=function(){for(var e=0;e<a.length;e++)try{return new a[e](r)}catch(i){}throw new t.ImageError(t.ImageError.WRONG_FORMAT)}(),e.extend(this,{type:"",size:0,width:0,height:0,setExif:function(){},writeHeaders:function(e){return e},stripHeaders:function(e){return e},purge:function(){r=null}}),e.extend(this,o),this.purge=function(){o.purge(),o=null}}}),n("moxie/runtime/html5/image/ResizerCanvas",[],function(){function e(i,n,r){var o=i.width>i.height?"width":"height",a=Math.round(i[o]*n),s=!1;"nearest"!==r&&(.5>n||n>2)&&(n=.5>n?.5:2,s=!0);var u=t(i,n);return s?e(u,a/u[o],r):u}function t(e,t){var i=e.width,n=e.height,r=Math.round(i*t),o=Math.round(n*t),a=document.createElement("canvas");return a.width=r,a.height=o,a.getContext("2d").drawImage(e,0,0,i,n,0,0,r,o),e=null,a}return{scale:e}}),n("moxie/runtime/html5/image/Image",["moxie/runtime/html5/Runtime","moxie/core/utils/Basic","moxie/core/Exceptions","moxie/core/utils/Encode","moxie/file/Blob","moxie/file/File","moxie/runtime/html5/image/ImageInfo","moxie/runtime/html5/image/ResizerCanvas","moxie/core/utils/Mime","moxie/core/utils/Env"],function(e,t,i,n,r,o,a,s,u){function c(){function e(){if(!v&&!g)throw new i.ImageError(i.DOMException.INVALID_STATE_ERR);return v||g}function c(){var t=e();return"canvas"==t.nodeName.toLowerCase()?t:(v=document.createElement("canvas"),v.width=t.width,v.height=t.height,v.getContext("2d").drawImage(t,0,0),v)}function l(e){return n.atob(e.substring(e.indexOf("base64,")+7))}function d(e,t){return"data:"+(t||"")+";base64,"+n.btoa(e)}function m(e){var t=this;g=new Image,g.onerror=function(){p.call(this),t.trigger("error",i.ImageError.WRONG_FORMAT)},g.onload=function(){t.trigger("load")},g.src="data:"==e.substr(0,5)?e:d(e,y.type)}function h(e,t){var n,r=this;return window.FileReader?(n=new FileReader,n.onload=function(){t.call(r,this.result)},n.onerror=function(){r.trigger("error",i.ImageError.WRONG_FORMAT)},n.readAsDataURL(e),void 0):t.call(this,e.getAsDataURL())}function f(e,i){var n=Math.PI/180,r=document.createElement("canvas"),o=r.getContext("2d"),a=e.width,s=e.height;switch(t.inArray(i,[5,6,7,8])>-1?(r.width=s,r.height=a):(r.width=a,r.height=s),i){case 2:o.translate(a,0),o.scale(-1,1);break;case 3:o.translate(a,s),o.rotate(180*n);break;case 4:o.translate(0,s),o.scale(1,-1);break;case 5:o.rotate(90*n),o.scale(1,-1);break;case 6:o.rotate(90*n),o.translate(0,-s);break;case 7:o.rotate(90*n),o.translate(a,-s),o.scale(-1,1);break;case 8:o.rotate(-90*n),o.translate(-a,0)}return o.drawImage(e,0,0,a,s),r}function p(){x&&(x.purge(),x=null),w=g=v=y=null,b=!1}var g,x,v,w,y,E=this,b=!1,_=!0;t.extend(this,{loadFromBlob:function(e){var t=this.getRuntime(),n=arguments.length>1?arguments[1]:!0;if(!t.can("access_binary"))throw new i.RuntimeError(i.RuntimeError.NOT_SUPPORTED_ERR);return y=e,e.isDetached()?(w=e.getSource(),m.call(this,w),void 0):(h.call(this,e.getSource(),function(e){n&&(w=l(e)),m.call(this,e)}),void 0)},loadFromImage:function(e,t){this.meta=e.meta,y=new o(null,{name:e.name,size:e.size,type:e.type}),m.call(this,t?w=e.getAsBinaryString():e.getAsDataURL())},getInfo:function(){var t,i=this.getRuntime();return!x&&w&&i.can("access_image_binary")&&(x=new a(w)),t={width:e().width||0,height:e().height||0,type:y.type||u.getFileMime(y.name),size:w&&w.length||y.size||0,name:y.name||"",meta:null},_&&(t.meta=x&&x.meta||this.meta||{},!t.meta||!t.meta.thumb||t.meta.thumb.data instanceof r||(t.meta.thumb.data=new r(null,{type:"image/jpeg",data:t.meta.thumb.data}))),t},resize:function(t,i,n){var r=document.createElement("canvas");if(r.width=t.width,r.height=t.height,r.getContext("2d").drawImage(e(),t.x,t.y,t.width,t.height,0,0,r.width,r.height),v=s.scale(r,i),_=n.preserveHeaders,!_){var o=this.meta&&this.meta.tiff&&this.meta.tiff.Orientation||1;v=f(v,o)}this.width=v.width,this.height=v.height,b=!0,this.trigger("Resize")},getAsCanvas:function(){return v||(v=c()),v.id=this.uid+"_canvas",v},getAsBlob:function(e,t){return e!==this.type?(b=!0,new o(null,{name:y.name||"",type:e,data:E.getAsDataURL(e,t)})):new o(null,{name:y.name||"",type:e,data:E.getAsBinaryString(e,t)})},getAsDataURL:function(e){var t=arguments[1]||90;if(!b)return g.src;if(c(),"image/jpeg"!==e)return v.toDataURL("image/png");try{return v.toDataURL("image/jpeg",t/100)}catch(i){return v.toDataURL("image/jpeg")}},getAsBinaryString:function(e,t){if(!b)return w||(w=l(E.getAsDataURL(e,t))),w;if("image/jpeg"!==e)w=l(E.getAsDataURL(e,t));else{var i;t||(t=90),c();try{i=v.toDataURL("image/jpeg",t/100)}catch(n){i=v.toDataURL("image/jpeg")}w=l(i),x&&(w=x.stripHeaders(w),_&&(x.meta&&x.meta.exif&&x.setExif({PixelXDimension:this.width,PixelYDimension:this.height}),w=x.writeHeaders(w)),x.purge(),x=null)}return b=!1,w},destroy:function(){E=null,p.call(this),this.getRuntime().getShim().removeInstance(this.uid)}})}return e.Image=c}),n("moxie/runtime/flash/Runtime",["moxie/core/utils/Basic","moxie/core/utils/Env","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/runtime/Runtime"],function(e,t,i,n,o){function a(){var e;try{e=navigator.plugins["Shockwave Flash"],e=e.description}catch(t){try{e=new ActiveXObject("ShockwaveFlash.ShockwaveFlash").GetVariable("$version")}catch(i){e="0.0"}}return e=e.match(/\d+/g),parseFloat(e[0]+"."+e[1])}function s(e){var n=i.get(e);n&&"OBJECT"==n.nodeName&&("IE"===t.browser?(n.style.display="none",function r(){4==n.readyState?u(e):setTimeout(r,10)}()):n.parentNode.removeChild(n))}function u(e){var t=i.get(e);if(t){for(var n in t)"function"==typeof t[n]&&(t[n]=null);t.parentNode.removeChild(t)}}function c(u){var c,m=this;u=e.extend({swf_url:t.swf_url},u),o.call(this,u,l,{access_binary:function(e){return e&&"browser"===m.mode},access_image_binary:function(e){return e&&"browser"===m.mode},display_media:o.capTest(r("moxie/image/Image")),do_cors:o.capTrue,drag_and_drop:!1,report_upload_progress:function(){return"client"===m.mode},resize_image:o.capTrue,return_response_headers:!1,return_response_type:function(t){return"json"===t&&window.JSON?!0:!e.arrayDiff(t,["","text","document"])||"browser"===m.mode},return_status_code:function(t){return"browser"===m.mode||!e.arrayDiff(t,[200,404])},select_file:o.capTrue,select_multiple:o.capTrue,send_binary_string:function(e){return e&&"browser"===m.mode},send_browser_cookies:function(e){return e&&"browser"===m.mode},send_custom_headers:function(e){return e&&"browser"===m.mode},send_multipart:o.capTrue,slice_blob:function(e){return e&&"browser"===m.mode},stream_upload:function(e){return e&&"browser"===m.mode},summon_file_dialog:!1,upload_filesize:function(t){return e.parseSizeStr(t)<=2097152||"client"===m.mode},use_http_method:function(t){return!e.arrayDiff(t,["GET","POST"])}},{access_binary:function(e){return e?"browser":"client"},access_image_binary:function(e){return e?"browser":"client"},report_upload_progress:function(e){return e?"browser":"client"},return_response_type:function(t){return e.arrayDiff(t,["","text","json","document"])?"browser":["client","browser"]},return_status_code:function(t){return e.arrayDiff(t,[200,404])?"browser":["client","browser"]},send_binary_string:function(e){return e?"browser":"client"},send_browser_cookies:function(e){return e?"browser":"client"},send_custom_headers:function(e){return e?"browser":"client"},slice_blob:function(e){return e?"browser":"client"},stream_upload:function(e){return e?"client":"browser"},upload_filesize:function(t){return e.parseSizeStr(t)>=2097152?"client":"browser"}},"client"),a()<11.3&&(this.mode=!1),e.extend(this,{getShim:function(){return i.get(this.uid)},shimExec:function(e,t){var i=[].slice.call(arguments,2);return m.getShim().exec(this.uid,e,t,i)},init:function(){var i,r,a;a=this.getShimContainer(),e.extend(a.style,{position:"absolute",top:"-8px",left:"-8px",width:"9px",height:"9px",overflow:"hidden"}),i='<object id="'+this.uid+'" type="application/x-shockwave-flash" data="'+u.swf_url+'" ',"IE"===t.browser&&(i+='classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" '),i+='width="100%" height="100%" style="outline:0"><param name="movie" value="'+u.swf_url+'" />'+'<param name="flashvars" value="uid='+escape(this.uid)+"&target="+o.getGlobalEventTarget()+'" />'+'<param name="wmode" value="transparent" />'+'<param name="allowscriptaccess" value="always" />'+"</object>","IE"===t.browser?(r=document.createElement("div"),a.appendChild(r),r.outerHTML=i,r=a=null):a.innerHTML=i,c=setTimeout(function(){m&&!m.initialized&&m.trigger("Error",new n.RuntimeError(n.RuntimeError.NOT_INIT_ERR))},5e3)},destroy:function(e){return function(){s(m.uid),e.call(m),clearTimeout(c),u=c=e=m=null}}(this.destroy)},d)}var l="flash",d={};return o.addConstructor(l,c),d}),n("moxie/runtime/flash/file/Blob",["moxie/runtime/flash/Runtime","moxie/file/Blob"],function(e,t){var i={slice:function(e,i,n,r){var o=this.getRuntime();return 0>i?i=Math.max(e.size+i,0):i>0&&(i=Math.min(i,e.size)),0>n?n=Math.max(e.size+n,0):n>0&&(n=Math.min(n,e.size)),e=o.shimExec.call(this,"Blob","slice",i,n,r||""),e&&(e=new t(o.uid,e)),e}};return e.Blob=i}),n("moxie/runtime/flash/file/FileInput",["moxie/runtime/flash/Runtime","moxie/file/File","moxie/core/utils/Dom","moxie/core/utils/Basic"],function(e,t,i,n){var r={init:function(e){var r=this,o=this.getRuntime(),a=i.get(e.browse_button);a&&(a.setAttribute("tabindex",-1),a=null),this.bind("Change",function(){var e=o.shimExec.call(r,"FileInput","getFiles");r.files=[],n.each(e,function(e){r.files.push(new t(o.uid,e))})},999),this.getRuntime().shimExec.call(this,"FileInput","init",{accept:e.accept,multiple:e.multiple}),this.trigger("ready")}};return e.FileInput=r}),n("moxie/runtime/flash/file/FileReader",["moxie/runtime/flash/Runtime","moxie/core/utils/Encode"],function(e,t){function i(e,i){switch(i){case"readAsText":return t.atob(e,"utf8");case"readAsBinaryString":return t.atob(e);case"readAsDataURL":return e}return null}var n={read:function(e,t){var n=this;return n.result="","readAsDataURL"===e&&(n.result="data:"+(t.type||"")+";base64,"),n.bind("Progress",function(t,r){r&&(n.result+=i(r,e))},999),n.getRuntime().shimExec.call(this,"FileReader","readAsBase64",t.uid)}};return e.FileReader=n}),n("moxie/runtime/flash/file/FileReaderSync",["moxie/runtime/flash/Runtime","moxie/core/utils/Encode"],function(e,t){function i(e,i){switch(i){case"readAsText":return t.atob(e,"utf8");case"readAsBinaryString":return t.atob(e);case"readAsDataURL":return e}return null}var n={read:function(e,t){var n,r=this.getRuntime();return(n=r.shimExec.call(this,"FileReaderSync","readAsBase64",t.uid))?("readAsDataURL"===e&&(n="data:"+(t.type||"")+";base64,"+n),i(n,e,t.type)):null}};return e.FileReaderSync=n}),n("moxie/runtime/flash/runtime/Transporter",["moxie/runtime/flash/Runtime","moxie/file/Blob"],function(e,t){var i={getAsBlob:function(e){var i=this.getRuntime(),n=i.shimExec.call(this,"Transporter","getAsBlob",e);return n?new t(i.uid,n):null}};return e.Transporter=i}),n("moxie/runtime/flash/xhr/XMLHttpRequest",["moxie/runtime/flash/Runtime","moxie/core/utils/Basic","moxie/file/Blob","moxie/file/File","moxie/file/FileReaderSync","moxie/runtime/flash/file/FileReaderSync","moxie/xhr/FormData","moxie/runtime/Transporter","moxie/runtime/flash/runtime/Transporter"],function(e,t,i,n,r,o,a,s){var u={send:function(e,n){function r(){e.transport=l.mode,l.shimExec.call(c,"XMLHttpRequest","send",e,n)}function o(e,t){l.shimExec.call(c,"XMLHttpRequest","appendBlob",e,t.uid),n=null,r()}function u(e,t){var i=new s;i.bind("TransportingComplete",function(){t(this.result)}),i.transport(e.getSource(),e.type,{ruid:l.uid})}var c=this,l=c.getRuntime();if(t.isEmptyObj(e.headers)||t.each(e.headers,function(e,t){l.shimExec.call(c,"XMLHttpRequest","setRequestHeader",t,e.toString())}),n instanceof a){var d;if(n.each(function(e,t){e instanceof i?d=t:l.shimExec.call(c,"XMLHttpRequest","append",t,e)}),n.hasBlob()){var m=n.getBlob();m.isDetached()?u(m,function(e){m.destroy(),o(d,e)}):o(d,m)}else n=null,r()}else n instanceof i?n.isDetached()?u(n,function(e){n.destroy(),n=e.uid,r()}):(n=n.uid,r()):r()},getResponse:function(e){var i,o,a=this.getRuntime();if(o=a.shimExec.call(this,"XMLHttpRequest","getResponseAsBlob")){if(o=new n(a.uid,o),"blob"===e)return o;try{if(i=new r,~t.inArray(e,["","text"]))return i.readAsText(o);if("json"===e&&window.JSON)return JSON.parse(i.readAsText(o))}finally{o.destroy()}}return null},abort:function(){var e=this.getRuntime();e.shimExec.call(this,"XMLHttpRequest","abort"),this.dispatchEvent("readystatechange"),this.dispatchEvent("abort")}};return e.XMLHttpRequest=u}),n("moxie/runtime/flash/image/Image",["moxie/runtime/flash/Runtime","moxie/core/utils/Basic","moxie/runtime/Transporter","moxie/file/Blob","moxie/file/FileReaderSync"],function(e,t,i,n,r){var o={loadFromBlob:function(e){function t(e){r.shimExec.call(n,"Image","loadFromBlob",e.uid),n=r=null}var n=this,r=n.getRuntime();if(e.isDetached()){var o=new i;o.bind("TransportingComplete",function(){t(o.result.getSource())}),o.transport(e.getSource(),e.type,{ruid:r.uid})}else t(e.getSource())},loadFromImage:function(e){var t=this.getRuntime();return t.shimExec.call(this,"Image","loadFromImage",e.uid)},getInfo:function(){var e=this.getRuntime(),t=e.shimExec.call(this,"Image","getInfo");return t.meta&&t.meta.thumb&&t.meta.thumb.data&&!(e.meta.thumb.data instanceof n)&&(t.meta.thumb.data=new n(e.uid,t.meta.thumb.data)),t},getAsBlob:function(e,t){var i=this.getRuntime(),r=i.shimExec.call(this,"Image","getAsBlob",e,t);return r?new n(i.uid,r):null},getAsDataURL:function(){var e,t=this.getRuntime(),i=t.Image.getAsBlob.apply(this,arguments);return i?(e=new r,e.readAsDataURL(i)):null}};return e.Image=o}),n("moxie/runtime/silverlight/Runtime",["moxie/core/utils/Basic","moxie/core/utils/Env","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/runtime/Runtime"],function(e,t,i,n,o){function a(e){var t,i,n,r,o,a=!1,s=null,u=0;try{try{s=new ActiveXObject("AgControl.AgControl"),s.IsVersionSupported(e)&&(a=!0),s=null}catch(c){var l=navigator.plugins["Silverlight Plug-In"];if(l){for(t=l.description,"1.0.30226.2"===t&&(t="2.0.30226.2"),i=t.split(".");i.length>3;)i.pop();for(;i.length<4;)i.push(0);for(n=e.split(".");n.length>4;)n.pop();do r=parseInt(n[u],10),o=parseInt(i[u],10),u++;while(u<n.length&&r===o);o>=r&&!isNaN(r)&&(a=!0)}}}catch(d){a=!1}return a}function s(s){var l,d=this;s=e.extend({xap_url:t.xap_url},s),o.call(this,s,u,{access_binary:o.capTrue,access_image_binary:o.capTrue,display_media:o.capTest(r("moxie/image/Image")),do_cors:o.capTrue,drag_and_drop:!1,report_upload_progress:o.capTrue,resize_image:o.capTrue,return_response_headers:function(e){return e&&"client"===d.mode},return_response_type:function(e){return"json"!==e?!0:!!window.JSON},return_status_code:function(t){return"client"===d.mode||!e.arrayDiff(t,[200,404])},select_file:o.capTrue,select_multiple:o.capTrue,send_binary_string:o.capTrue,send_browser_cookies:function(e){return e&&"browser"===d.mode},send_custom_headers:function(e){return e&&"client"===d.mode},send_multipart:o.capTrue,slice_blob:o.capTrue,stream_upload:!0,summon_file_dialog:!1,upload_filesize:o.capTrue,use_http_method:function(t){return"client"===d.mode||!e.arrayDiff(t,["GET","POST"])}},{return_response_headers:function(e){return e?"client":"browser"},return_status_code:function(t){return e.arrayDiff(t,[200,404])?"client":["client","browser"]},send_browser_cookies:function(e){return e?"browser":"client"},send_custom_headers:function(e){return e?"client":"browser"},use_http_method:function(t){return e.arrayDiff(t,["GET","POST"])?"client":["client","browser"]}}),a("2.0.31005.0")&&"Opera"!==t.browser||(this.mode=!1),e.extend(this,{getShim:function(){return i.get(this.uid).content.Moxie},shimExec:function(e,t){var i=[].slice.call(arguments,2);return d.getShim().exec(this.uid,e,t,i)},init:function(){var e;e=this.getShimContainer(),e.innerHTML='<object id="'+this.uid+'" data="data:application/x-silverlight," type="application/x-silverlight-2" width="100%" height="100%" style="outline:none;">'+'<param name="source" value="'+s.xap_url+'"/>'+'<param name="background" value="Transparent"/>'+'<param name="windowless" value="true"/>'+'<param name="enablehtmlaccess" value="true"/>'+'<param name="initParams" value="uid='+this.uid+",target="+o.getGlobalEventTarget()+'"/>'+"</object>",l=setTimeout(function(){d&&!d.initialized&&d.trigger("Error",new n.RuntimeError(n.RuntimeError.NOT_INIT_ERR))},"Windows"!==t.OS?1e4:5e3)},destroy:function(e){return function(){e.call(d),clearTimeout(l),s=l=e=d=null}}(this.destroy)},c)}var u="silverlight",c={};return o.addConstructor(u,s),c}),n("moxie/runtime/silverlight/file/Blob",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/file/Blob"],function(e,t,i){return e.Blob=t.extend({},i)}),n("moxie/runtime/silverlight/file/FileInput",["moxie/runtime/silverlight/Runtime","moxie/file/File","moxie/core/utils/Dom","moxie/core/utils/Basic"],function(e,t,i,n){function r(e){for(var t="",i=0;i<e.length;i++)t+=(""!==t?"|":"")+e[i].title+" | *."+e[i].extensions.replace(/,/g,";*.");return t}var o={init:function(e){var o=this,a=this.getRuntime(),s=i.get(e.browse_button);s&&(s.setAttribute("tabindex",-1),s=null),this.bind("Change",function(){var e=a.shimExec.call(o,"FileInput","getFiles");
o.files=[],n.each(e,function(e){o.files.push(new t(a.uid,e))})},999),a.shimExec.call(this,"FileInput","init",r(e.accept),e.multiple),this.trigger("ready")},setOption:function(e,t){"accept"==e&&(t=r(t)),this.getRuntime().shimExec.call(this,"FileInput","setOption",e,t)}};return e.FileInput=o}),n("moxie/runtime/silverlight/file/FileDrop",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Dom","moxie/core/utils/Events"],function(e,t,i){var n={init:function(){var e,n=this,r=n.getRuntime();return e=r.getShimContainer(),i.addEvent(e,"dragover",function(e){e.preventDefault(),e.stopPropagation(),e.dataTransfer.dropEffect="copy"},n.uid),i.addEvent(e,"dragenter",function(e){e.preventDefault();var i=t.get(r.uid).dragEnter(e);i&&e.stopPropagation()},n.uid),i.addEvent(e,"drop",function(e){e.preventDefault();var i=t.get(r.uid).dragDrop(e);i&&e.stopPropagation()},n.uid),r.shimExec.call(this,"FileDrop","init")}};return e.FileDrop=n}),n("moxie/runtime/silverlight/file/FileReader",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/file/FileReader"],function(e,t,i){return e.FileReader=t.extend({},i)}),n("moxie/runtime/silverlight/file/FileReaderSync",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/file/FileReaderSync"],function(e,t,i){return e.FileReaderSync=t.extend({},i)}),n("moxie/runtime/silverlight/runtime/Transporter",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/runtime/Transporter"],function(e,t,i){return e.Transporter=t.extend({},i)}),n("moxie/runtime/silverlight/xhr/XMLHttpRequest",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/xhr/XMLHttpRequest","moxie/runtime/silverlight/file/FileReaderSync","moxie/runtime/silverlight/runtime/Transporter"],function(e,t,i){return e.XMLHttpRequest=t.extend({},i)}),n("moxie/runtime/silverlight/image/Image",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/file/Blob","moxie/runtime/flash/image/Image"],function(e,t,i,n){return e.Image=t.extend({},n,{getInfo:function(){var e=this.getRuntime(),n=["tiff","exif","gps","thumb"],r={meta:{}},o=e.shimExec.call(this,"Image","getInfo");return o.meta&&(t.each(n,function(e){var t,i,n,a,s=o.meta[e];if(s&&s.keys)for(r.meta[e]={},i=0,n=s.keys.length;n>i;i++)t=s.keys[i],a=s[t],a&&(/^(\d|[1-9]\d+)$/.test(a)?a=parseInt(a,10):/^\d*\.\d+$/.test(a)&&(a=parseFloat(a)),r.meta[e][t]=a)}),r.meta&&r.meta.thumb&&r.meta.thumb.data&&!(e.meta.thumb.data instanceof i)&&(r.meta.thumb.data=new i(e.uid,r.meta.thumb.data))),r.width=parseInt(o.width,10),r.height=parseInt(o.height,10),r.size=parseInt(o.size,10),r.type=o.type,r.name=o.name,r},resize:function(e,t,i){this.getRuntime().shimExec.call(this,"Image","resize",e.x,e.y,e.width,e.height,t,i.preserveHeaders,i.resample)}})}),n("moxie/runtime/html4/Runtime",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/runtime/Runtime","moxie/core/utils/Env"],function(e,t,i,n){function o(t){var o=this,u=i.capTest,c=i.capTrue;i.call(this,t,a,{access_binary:u(window.FileReader||window.File&&File.getAsDataURL),access_image_binary:!1,display_media:u((n.can("create_canvas")||n.can("use_data_uri_over32kb"))&&r("moxie/image/Image")),do_cors:!1,drag_and_drop:!1,filter_by_extension:u(function(){return!("Chrome"===n.browser&&n.verComp(n.version,28,"<")||"IE"===n.browser&&n.verComp(n.version,10,"<")||"Safari"===n.browser&&n.verComp(n.version,7,"<")||"Firefox"===n.browser&&n.verComp(n.version,37,"<"))}()),resize_image:function(){return s.Image&&o.can("access_binary")&&n.can("create_canvas")},report_upload_progress:!1,return_response_headers:!1,return_response_type:function(t){return"json"===t&&window.JSON?!0:!!~e.inArray(t,["text","document",""])},return_status_code:function(t){return!e.arrayDiff(t,[200,404])},select_file:function(){return n.can("use_fileinput")},select_multiple:!1,send_binary_string:!1,send_custom_headers:!1,send_multipart:!0,slice_blob:!1,stream_upload:function(){return o.can("select_file")},summon_file_dialog:function(){return o.can("select_file")&&!("Firefox"===n.browser&&n.verComp(n.version,4,"<")||"Opera"===n.browser&&n.verComp(n.version,12,"<")||"IE"===n.browser&&n.verComp(n.version,10,"<"))},upload_filesize:c,use_http_method:function(t){return!e.arrayDiff(t,["GET","POST"])}}),e.extend(this,{init:function(){this.trigger("Init")},destroy:function(e){return function(){e.call(o),e=o=null}}(this.destroy)}),e.extend(this.getShim(),s)}var a="html4",s={};return i.addConstructor(a,o),s}),n("moxie/runtime/html4/file/FileInput",["moxie/runtime/html4/Runtime","moxie/file/File","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/utils/Events","moxie/core/utils/Mime","moxie/core/utils/Env"],function(e,t,i,n,r,o,a){function s(){function e(){var o,c,d,m,h,f,p=this,g=p.getRuntime();f=i.guid("uid_"),o=g.getShimContainer(),s&&(d=n.get(s+"_form"),d&&(i.extend(d.style,{top:"100%"}),d.firstChild.setAttribute("tabindex",-1))),m=document.createElement("form"),m.setAttribute("id",f+"_form"),m.setAttribute("method","post"),m.setAttribute("enctype","multipart/form-data"),m.setAttribute("encoding","multipart/form-data"),i.extend(m.style,{overflow:"hidden",position:"absolute",top:0,left:0,width:"100%",height:"100%"}),h=document.createElement("input"),h.setAttribute("id",f),h.setAttribute("type","file"),h.setAttribute("accept",l.join(",")),g.can("summon_file_dialog")&&h.setAttribute("tabindex",-1),i.extend(h.style,{fontSize:"999px",opacity:0}),m.appendChild(h),o.appendChild(m),i.extend(h.style,{position:"absolute",top:0,left:0,width:"100%",height:"100%"}),"IE"===a.browser&&a.verComp(a.version,10,"<")&&i.extend(h.style,{filter:"progid:DXImageTransform.Microsoft.Alpha(opacity=0)"}),h.onchange=function(){var i;this.value&&(i=this.files?this.files[0]:{name:this.value},i=new t(g.uid,i),this.onchange=function(){},e.call(p),p.files=[i],h.setAttribute("id",i.uid),m.setAttribute("id",i.uid+"_form"),p.trigger("change"),h=m=null)},g.can("summon_file_dialog")&&(c=n.get(u.browse_button),r.removeEvent(c,"click",p.uid),r.addEvent(c,"click",function(e){h&&!h.disabled&&h.click(),e.preventDefault()},p.uid)),s=f,o=d=c=null}var s,u,c,l=[];i.extend(this,{init:function(t){var i,a=this,s=a.getRuntime();u=t,l=o.extList2mimes(t.accept,s.can("filter_by_extension")),i=s.getShimContainer(),function(){var e,o,l;e=n.get(t.browse_button),c=n.getStyle(e,"z-index")||"auto",s.can("summon_file_dialog")?("static"===n.getStyle(e,"position")&&(e.style.position="relative"),a.bind("Refresh",function(){o=parseInt(c,10)||1,n.get(u.browse_button).style.zIndex=o,this.getRuntime().getShimContainer().style.zIndex=o-1})):e.setAttribute("tabindex",-1),l=s.can("summon_file_dialog")?e:i,r.addEvent(l,"mouseover",function(){a.trigger("mouseenter")},a.uid),r.addEvent(l,"mouseout",function(){a.trigger("mouseleave")},a.uid),r.addEvent(l,"mousedown",function(){a.trigger("mousedown")},a.uid),r.addEvent(n.get(t.container),"mouseup",function(){a.trigger("mouseup")},a.uid),e=null}(),e.call(this),i=null,a.trigger({type:"ready",async:!0})},setOption:function(e,t){var i,r=this.getRuntime();"accept"==e&&(l=t.mimes||o.extList2mimes(t,r.can("filter_by_extension"))),i=n.get(s),i&&i.setAttribute("accept",l.join(","))},disable:function(e){var t;(t=n.get(s))&&(t.disabled=!!e)},destroy:function(){var e=this.getRuntime(),t=e.getShim(),i=e.getShimContainer(),o=u&&n.get(u.container),a=u&&n.get(u.browse_button);o&&r.removeAllEvents(o,this.uid),a&&(r.removeAllEvents(a,this.uid),a.style.zIndex=c),i&&(r.removeAllEvents(i,this.uid),i.innerHTML=""),t.removeInstance(this.uid),s=l=u=i=o=a=t=null}})}return e.FileInput=s}),n("moxie/runtime/html4/file/FileReader",["moxie/runtime/html4/Runtime","moxie/runtime/html5/file/FileReader"],function(e,t){return e.FileReader=t}),n("moxie/runtime/html4/xhr/XMLHttpRequest",["moxie/runtime/html4/Runtime","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/utils/Url","moxie/core/Exceptions","moxie/core/utils/Events","moxie/file/Blob","moxie/xhr/FormData"],function(e,t,i,n,r,o,a,s){function u(){function e(e){var t,n,r,a,s=this,u=!1;if(l){if(t=l.id.replace(/_iframe$/,""),n=i.get(t+"_form")){for(r=n.getElementsByTagName("input"),a=r.length;a--;)switch(r[a].getAttribute("type")){case"hidden":r[a].parentNode.removeChild(r[a]);break;case"file":u=!0}r=[],u||n.parentNode.removeChild(n),n=null}setTimeout(function(){o.removeEvent(l,"load",s.uid),l.parentNode&&l.parentNode.removeChild(l);var t=s.getRuntime().getShimContainer();t.children.length||t.parentNode.removeChild(t),t=l=null,e()},1)}}var u,c,l;t.extend(this,{send:function(d,m){function h(){var i=w.getShimContainer()||document.body,r=document.createElement("div");r.innerHTML='<iframe id="'+f+'_iframe" name="'+f+'_iframe" src="javascript:&quot;&quot;" style="display:none"></iframe>',l=r.firstChild,i.appendChild(l),o.addEvent(l,"load",function(){var i;try{i=l.contentWindow.document||l.contentDocument||window.frames[l.id].document,/^4(0[0-9]|1[0-7]|2[2346])\s/.test(i.title)?u=i.title.replace(/^(\d+).*$/,"$1"):(u=200,c=t.trim(i.body.innerHTML),v.trigger({type:"progress",loaded:c.length,total:c.length}),x&&v.trigger({type:"uploadprogress",loaded:x.size||1025,total:x.size||1025}))}catch(r){if(!n.hasSameOrigin(d.url))return e.call(v,function(){v.trigger("error")}),void 0;u=404}e.call(v,function(){v.trigger("load")})},v.uid)}var f,p,g,x,v=this,w=v.getRuntime();if(u=c=null,m instanceof s&&m.hasBlob()){if(x=m.getBlob(),f=x.uid,g=i.get(f),p=i.get(f+"_form"),!p)throw new r.DOMException(r.DOMException.NOT_FOUND_ERR)}else f=t.guid("uid_"),p=document.createElement("form"),p.setAttribute("id",f+"_form"),p.setAttribute("method",d.method),p.setAttribute("enctype","multipart/form-data"),p.setAttribute("encoding","multipart/form-data"),w.getShimContainer().appendChild(p);p.setAttribute("target",f+"_iframe"),m instanceof s&&m.each(function(e,i){if(e instanceof a)g&&g.setAttribute("name",i);else{var n=document.createElement("input");t.extend(n,{type:"hidden",name:i,value:e}),g?p.insertBefore(n,g):p.appendChild(n)}}),p.setAttribute("action",d.url),h(),p.submit(),v.trigger("loadstart")},getStatus:function(){return u},getResponse:function(e){if("json"===e&&"string"===t.typeOf(c)&&window.JSON)try{return JSON.parse(c.replace(/^\s*<pre[^>]*>/,"").replace(/<\/pre>\s*$/,""))}catch(i){return null}return c},abort:function(){var t=this;l&&l.contentWindow&&(l.contentWindow.stop?l.contentWindow.stop():l.contentWindow.document.execCommand?l.contentWindow.document.execCommand("Stop"):l.src="about:blank"),e.call(this,function(){t.dispatchEvent("abort")})},destroy:function(){this.getRuntime().getShim().removeInstance(this.uid)}})}return e.XMLHttpRequest=u}),n("moxie/runtime/html4/image/Image",["moxie/runtime/html4/Runtime","moxie/runtime/html5/image/Image"],function(e,t){return e.Image=t}),a(["moxie/core/utils/Basic","moxie/core/utils/Encode","moxie/core/utils/Env","moxie/core/Exceptions","moxie/core/utils/Dom","moxie/core/EventTarget","moxie/runtime/Runtime","moxie/runtime/RuntimeClient","moxie/file/Blob","moxie/core/I18n","moxie/core/utils/Mime","moxie/file/FileInput","moxie/file/File","moxie/file/FileDrop","moxie/file/FileReader","moxie/core/utils/Url","moxie/runtime/RuntimeTarget","moxie/xhr/FormData","moxie/xhr/XMLHttpRequest","moxie/image/Image","moxie/core/utils/Events","moxie/runtime/html5/image/ResizerCanvas"])}(this)});
/**
 * Plupload - multi-runtime File Uploader
 * v2.3.6
 *
 * Copyright 2013, Moxiecode Systems AB
 * Released under GPL License.
 *
 * License: http://www.plupload.com/license
 * Contributing: http://www.plupload.com/contributing
 *
 * Date: 2017-11-03
 */
!function(e,t){var i=function(){var e={};return t.apply(e,arguments),e.plupload}; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__WEBPACK_LOCAL_MODULE_0__], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=i(require("./moxie")):e.plupload=i(e.moxie)}(this||window,function(e){!function(e,t,i){function n(e){function t(e,t,i){var r={chunks:"slice_blob",jpgresize:"send_binary_string",pngresize:"send_binary_string",progress:"report_upload_progress",multi_selection:"select_multiple",dragdrop:"drag_and_drop",drop_element:"drag_and_drop",headers:"send_custom_headers",urlstream_upload:"send_binary_string",canSendBinary:"send_binary",triggerDialog:"summon_file_dialog"};r[e]?n[r[e]]=t:i||(n[e]=t)}var i=e.required_features,n={};return"string"==typeof i?l.each(i.split(/\s*,\s*/),function(e){t(e,!0)}):"object"==typeof i?l.each(i,function(e,i){t(i,e)}):i===!0&&(e.chunk_size&&e.chunk_size>0&&(n.slice_blob=!0),l.isEmptyObj(e.resize)&&e.multipart!==!1||(n.send_binary_string=!0),e.http_method&&(n.use_http_method=e.http_method),l.each(e,function(e,i){t(i,!!e,!0)})),n}var r=window.setTimeout,s={},a=t.core.utils,o=t.runtime.Runtime,l={VERSION:"2.3.6",STOPPED:1,STARTED:2,QUEUED:1,UPLOADING:2,FAILED:4,DONE:5,GENERIC_ERROR:-100,HTTP_ERROR:-200,IO_ERROR:-300,SECURITY_ERROR:-400,INIT_ERROR:-500,FILE_SIZE_ERROR:-600,FILE_EXTENSION_ERROR:-601,FILE_DUPLICATE_ERROR:-602,IMAGE_FORMAT_ERROR:-700,MEMORY_ERROR:-701,IMAGE_DIMENSIONS_ERROR:-702,moxie:t,mimeTypes:a.Mime.mimes,ua:a.Env,typeOf:a.Basic.typeOf,extend:a.Basic.extend,guid:a.Basic.guid,getAll:function(e){var t,i=[];"array"!==l.typeOf(e)&&(e=[e]);for(var n=e.length;n--;)t=l.get(e[n]),t&&i.push(t);return i.length?i:null},get:a.Dom.get,each:a.Basic.each,getPos:a.Dom.getPos,getSize:a.Dom.getSize,xmlEncode:function(e){var t={"<":"lt",">":"gt","&":"amp",'"':"quot","'":"#39"},i=/[<>&\"\']/g;return e?(""+e).replace(i,function(e){return t[e]?"&"+t[e]+";":e}):e},toArray:a.Basic.toArray,inArray:a.Basic.inArray,inSeries:a.Basic.inSeries,addI18n:t.core.I18n.addI18n,translate:t.core.I18n.translate,sprintf:a.Basic.sprintf,isEmptyObj:a.Basic.isEmptyObj,hasClass:a.Dom.hasClass,addClass:a.Dom.addClass,removeClass:a.Dom.removeClass,getStyle:a.Dom.getStyle,addEvent:a.Events.addEvent,removeEvent:a.Events.removeEvent,removeAllEvents:a.Events.removeAllEvents,cleanName:function(e){var t,i;for(i=[/[\300-\306]/g,"A",/[\340-\346]/g,"a",/\307/g,"C",/\347/g,"c",/[\310-\313]/g,"E",/[\350-\353]/g,"e",/[\314-\317]/g,"I",/[\354-\357]/g,"i",/\321/g,"N",/\361/g,"n",/[\322-\330]/g,"O",/[\362-\370]/g,"o",/[\331-\334]/g,"U",/[\371-\374]/g,"u"],t=0;t<i.length;t+=2)e=e.replace(i[t],i[t+1]);return e=e.replace(/\s+/g,"_"),e=e.replace(/[^a-z0-9_\-\.]+/gi,"")},buildUrl:function(e,t){var i="";return l.each(t,function(e,t){i+=(i?"&":"")+encodeURIComponent(t)+"="+encodeURIComponent(e)}),i&&(e+=(e.indexOf("?")>0?"&":"?")+i),e},formatSize:function(e){function t(e,t){return Math.round(e*Math.pow(10,t))/Math.pow(10,t)}if(e===i||/\D/.test(e))return l.translate("N/A");var n=Math.pow(1024,4);return e>n?t(e/n,1)+" "+l.translate("tb"):e>(n/=1024)?t(e/n,1)+" "+l.translate("gb"):e>(n/=1024)?t(e/n,1)+" "+l.translate("mb"):e>1024?Math.round(e/1024)+" "+l.translate("kb"):e+" "+l.translate("b")},parseSize:a.Basic.parseSizeStr,predictRuntime:function(e,t){var i,n;return i=new l.Uploader(e),n=o.thatCan(i.getOption().required_features,t||e.runtimes),i.destroy(),n},addFileFilter:function(e,t){s[e]=t}};l.addFileFilter("mime_types",function(e,t,i){e.length&&!e.regexp.test(t.name)?(this.trigger("Error",{code:l.FILE_EXTENSION_ERROR,message:l.translate("File extension error."),file:t}),i(!1)):i(!0)}),l.addFileFilter("max_file_size",function(e,t,i){var n;e=l.parseSize(e),t.size!==n&&e&&t.size>e?(this.trigger("Error",{code:l.FILE_SIZE_ERROR,message:l.translate("File size error."),file:t}),i(!1)):i(!0)}),l.addFileFilter("prevent_duplicates",function(e,t,i){if(e)for(var n=this.files.length;n--;)if(t.name===this.files[n].name&&t.size===this.files[n].size)return this.trigger("Error",{code:l.FILE_DUPLICATE_ERROR,message:l.translate("Duplicate file error."),file:t}),i(!1),void 0;i(!0)}),l.addFileFilter("prevent_empty",function(e,t,n){e&&!t.size&&t.size!==i?(this.trigger("Error",{code:l.FILE_SIZE_ERROR,message:l.translate("File size error."),file:t}),n(!1)):n(!0)}),l.Uploader=function(e){function a(){var e,t,i=0;if(this.state==l.STARTED){for(t=0;t<D.length;t++)e||D[t].status!=l.QUEUED?i++:(e=D[t],this.trigger("BeforeUpload",e)&&(e.status=l.UPLOADING,this.trigger("UploadFile",e)));i==D.length&&(this.state!==l.STOPPED&&(this.state=l.STOPPED,this.trigger("StateChanged")),this.trigger("UploadComplete",D))}}function u(e){e.percent=e.size>0?Math.ceil(100*(e.loaded/e.size)):100,d()}function d(){var e,t,n,r=0;for(I.reset(),e=0;e<D.length;e++)t=D[e],t.size!==i?(I.size+=t.origSize,n=t.loaded*t.origSize/t.size,(!t.completeTimestamp||t.completeTimestamp>S)&&(r+=n),I.loaded+=n):I.size=i,t.status==l.DONE?I.uploaded++:t.status==l.FAILED?I.failed++:I.queued++;I.size===i?I.percent=D.length>0?Math.ceil(100*(I.uploaded/D.length)):0:(I.bytesPerSec=Math.ceil(r/((+new Date-S||1)/1e3)),I.percent=I.size>0?Math.ceil(100*(I.loaded/I.size)):0)}function c(){var e=F[0]||P[0];return e?e.getRuntime().uid:!1}function f(){this.bind("FilesAdded FilesRemoved",function(e){e.trigger("QueueChanged"),e.refresh()}),this.bind("CancelUpload",b),this.bind("BeforeUpload",m),this.bind("UploadFile",_),this.bind("UploadProgress",E),this.bind("StateChanged",v),this.bind("QueueChanged",d),this.bind("Error",R),this.bind("FileUploaded",y),this.bind("Destroy",z)}function p(e,i){var n=this,r=0,s=[],a={runtime_order:e.runtimes,required_caps:e.required_features,preferred_caps:x,swf_url:e.flash_swf_url,xap_url:e.silverlight_xap_url};l.each(e.runtimes.split(/\s*,\s*/),function(t){e[t]&&(a[t]=e[t])}),e.browse_button&&l.each(e.browse_button,function(i){s.push(function(s){var u=new t.file.FileInput(l.extend({},a,{accept:e.filters.mime_types,name:e.file_data_name,multiple:e.multi_selection,container:e.container,browse_button:i}));u.onready=function(){var e=o.getInfo(this.ruid);l.extend(n.features,{chunks:e.can("slice_blob"),multipart:e.can("send_multipart"),multi_selection:e.can("select_multiple")}),r++,F.push(this),s()},u.onchange=function(){n.addFile(this.files)},u.bind("mouseenter mouseleave mousedown mouseup",function(t){U||(e.browse_button_hover&&("mouseenter"===t.type?l.addClass(i,e.browse_button_hover):"mouseleave"===t.type&&l.removeClass(i,e.browse_button_hover)),e.browse_button_active&&("mousedown"===t.type?l.addClass(i,e.browse_button_active):"mouseup"===t.type&&l.removeClass(i,e.browse_button_active)))}),u.bind("mousedown",function(){n.trigger("Browse")}),u.bind("error runtimeerror",function(){u=null,s()}),u.init()})}),e.drop_element&&l.each(e.drop_element,function(e){s.push(function(i){var s=new t.file.FileDrop(l.extend({},a,{drop_zone:e}));s.onready=function(){var e=o.getInfo(this.ruid);l.extend(n.features,{chunks:e.can("slice_blob"),multipart:e.can("send_multipart"),dragdrop:e.can("drag_and_drop")}),r++,P.push(this),i()},s.ondrop=function(){n.addFile(this.files)},s.bind("error runtimeerror",function(){s=null,i()}),s.init()})}),l.inSeries(s,function(){"function"==typeof i&&i(r)})}function g(e,n,r,s){var a=new t.image.Image;try{a.onload=function(){n.width>this.width&&n.height>this.height&&n.quality===i&&n.preserve_headers&&!n.crop?(this.destroy(),s(e)):a.downsize(n.width,n.height,n.crop,n.preserve_headers)},a.onresize=function(){var t=this.getAsBlob(e.type,n.quality);this.destroy(),s(t)},a.bind("error runtimeerror",function(){this.destroy(),s(e)}),a.load(e,r)}catch(o){s(e)}}function h(e,i,r){function s(e,i,n){var r=O[e];switch(e){case"max_file_size":"max_file_size"===e&&(O.max_file_size=O.filters.max_file_size=i);break;case"chunk_size":(i=l.parseSize(i))&&(O[e]=i,O.send_file_name=!0);break;case"multipart":O[e]=i,i||(O.send_file_name=!0);break;case"http_method":O[e]="PUT"===i.toUpperCase()?"PUT":"POST";break;case"unique_names":O[e]=i,i&&(O.send_file_name=!0);break;case"filters":"array"===l.typeOf(i)&&(i={mime_types:i}),n?l.extend(O.filters,i):O.filters=i,i.mime_types&&("string"===l.typeOf(i.mime_types)&&(i.mime_types=t.core.utils.Mime.mimes2extList(i.mime_types)),i.mime_types.regexp=function(e){var t=[];return l.each(e,function(e){l.each(e.extensions.split(/,/),function(e){/^\s*\*\s*$/.test(e)?t.push("\\.*"):t.push("\\."+e.replace(new RegExp("["+"/^$.*+?|()[]{}\\".replace(/./g,"\\$&")+"]","g"),"\\$&"))})}),new RegExp("("+t.join("|")+")$","i")}(i.mime_types),O.filters.mime_types=i.mime_types);break;case"resize":O.resize=i?l.extend({preserve_headers:!0,crop:!1},i):!1;break;case"prevent_duplicates":O.prevent_duplicates=O.filters.prevent_duplicates=!!i;break;case"container":case"browse_button":case"drop_element":i="container"===e?l.get(i):l.getAll(i);case"runtimes":case"multi_selection":case"flash_swf_url":case"silverlight_xap_url":O[e]=i,n||(u=!0);break;default:O[e]=i}n||a.trigger("OptionChanged",e,i,r)}var a=this,u=!1;"object"==typeof e?l.each(e,function(e,t){s(t,e,r)}):s(e,i,r),r?(O.required_features=n(l.extend({},O)),x=n(l.extend({},O,{required_features:!0}))):u&&(a.trigger("Destroy"),p.call(a,O,function(e){e?(a.runtime=o.getInfo(c()).type,a.trigger("Init",{runtime:a.runtime}),a.trigger("PostInit")):a.trigger("Error",{code:l.INIT_ERROR,message:l.translate("Init error.")})}))}function m(e,t){if(e.settings.unique_names){var i=t.name.match(/\.([^.]+)$/),n="part";i&&(n=i[1]),t.target_name=t.id+"."+n}}function _(e,i){function n(){c-->0?r(s,1e3):(i.loaded=p,e.trigger("Error",{code:l.HTTP_ERROR,message:l.translate("HTTP Error."),file:i,response:T.responseText,status:T.status,responseHeaders:T.getAllResponseHeaders()}))}function s(){var t,n,r={};i.status===l.UPLOADING&&e.state!==l.STOPPED&&(e.settings.send_file_name&&(r.name=i.target_name||i.name),d&&f.chunks&&o.size>d?(n=Math.min(d,o.size-p),t=o.slice(p,p+n)):(n=o.size,t=o),d&&f.chunks&&(e.settings.send_chunk_number?(r.chunk=Math.ceil(p/d),r.chunks=Math.ceil(o.size/d)):(r.offset=p,r.total=o.size)),e.trigger("BeforeChunkUpload",i,r,t,p)&&a(r,t,n))}function a(a,d,g){var m;T=new t.xhr.XMLHttpRequest,T.upload&&(T.upload.onprogress=function(t){i.loaded=Math.min(i.size,p+t.loaded),e.trigger("UploadProgress",i)}),T.onload=function(){return T.status<200||T.status>=400?(n(),void 0):(c=e.settings.max_retries,g<o.size?(d.destroy(),p+=g,i.loaded=Math.min(p,o.size),e.trigger("ChunkUploaded",i,{offset:i.loaded,total:o.size,response:T.responseText,status:T.status,responseHeaders:T.getAllResponseHeaders()}),"Android Browser"===l.ua.browser&&e.trigger("UploadProgress",i)):i.loaded=i.size,d=m=null,!p||p>=o.size?(i.size!=i.origSize&&(o.destroy(),o=null),e.trigger("UploadProgress",i),i.status=l.DONE,i.completeTimestamp=+new Date,e.trigger("FileUploaded",i,{response:T.responseText,status:T.status,responseHeaders:T.getAllResponseHeaders()})):r(s,1),void 0)},T.onerror=function(){n()},T.onloadend=function(){this.destroy()},e.settings.multipart&&f.multipart?(T.open(e.settings.http_method,u,!0),l.each(e.settings.headers,function(e,t){T.setRequestHeader(t,e)}),m=new t.xhr.FormData,l.each(l.extend(a,e.settings.multipart_params),function(e,t){m.append(t,e)}),m.append(e.settings.file_data_name,d),T.send(m,h)):(u=l.buildUrl(e.settings.url,l.extend(a,e.settings.multipart_params)),T.open(e.settings.http_method,u,!0),l.each(e.settings.headers,function(e,t){T.setRequestHeader(t,e)}),T.hasRequestHeader("Content-Type")||T.setRequestHeader("Content-Type","application/octet-stream"),T.send(d,h))}var o,u=e.settings.url,d=e.settings.chunk_size,c=e.settings.max_retries,f=e.features,p=0,h={runtime_order:e.settings.runtimes,required_caps:e.settings.required_features,preferred_caps:x,swf_url:e.settings.flash_swf_url,xap_url:e.settings.silverlight_xap_url};i.loaded&&(p=i.loaded=d?d*Math.floor(i.loaded/d):0),o=i.getSource(),l.isEmptyObj(e.settings.resize)||-1===l.inArray(o.type,["image/jpeg","image/png"])?s():g(o,e.settings.resize,h,function(e){o=e,i.size=e.size,s()})}function E(e,t){u(t)}function v(e){if(e.state==l.STARTED)S=+new Date;else if(e.state==l.STOPPED)for(var t=e.files.length-1;t>=0;t--)e.files[t].status==l.UPLOADING&&(e.files[t].status=l.QUEUED,d())}function b(){T&&T.abort()}function y(e){d(),r(function(){a.call(e)},1)}function R(e,t){t.code===l.INIT_ERROR?e.destroy():t.code===l.HTTP_ERROR&&(t.file.status=l.FAILED,t.file.completeTimestamp=+new Date,u(t.file),e.state==l.STARTED&&(e.trigger("CancelUpload"),r(function(){a.call(e)},1)))}function z(e){e.stop(),l.each(D,function(e){e.destroy()}),D=[],F.length&&(l.each(F,function(e){e.destroy()}),F=[]),P.length&&(l.each(P,function(e){e.destroy()}),P=[]),x={},U=!1,S=T=null,I.reset()}var O,S,I,T,w=l.guid(),D=[],x={},F=[],P=[],U=!1;O={chunk_size:0,file_data_name:"file",filters:{mime_types:[],max_file_size:0,prevent_duplicates:!1,prevent_empty:!0},flash_swf_url:"js/Moxie.swf",http_method:"POST",max_retries:0,multipart:!0,multi_selection:!0,resize:!1,runtimes:o.order,send_file_name:!0,send_chunk_number:!0,silverlight_xap_url:"js/Moxie.xap"},h.call(this,e,null,!0),I=new l.QueueProgress,l.extend(this,{id:w,uid:w,state:l.STOPPED,features:{},runtime:null,files:D,settings:O,total:I,init:function(){var e,t,i=this;return e=i.getOption("preinit"),"function"==typeof e?e(i):l.each(e,function(e,t){i.bind(t,e)}),f.call(i),l.each(["container","browse_button","drop_element"],function(e){return null===i.getOption(e)?(t={code:l.INIT_ERROR,message:l.sprintf(l.translate("%s specified, but cannot be found."),e)},!1):void 0}),t?i.trigger("Error",t):O.browse_button||O.drop_element?(p.call(i,O,function(e){var t=i.getOption("init");"function"==typeof t?t(i):l.each(t,function(e,t){i.bind(t,e)}),e?(i.runtime=o.getInfo(c()).type,i.trigger("Init",{runtime:i.runtime}),i.trigger("PostInit")):i.trigger("Error",{code:l.INIT_ERROR,message:l.translate("Init error.")})}),void 0):i.trigger("Error",{code:l.INIT_ERROR,message:l.translate("You must specify either browse_button or drop_element.")})},setOption:function(e,t){h.call(this,e,t,!this.runtime)},getOption:function(e){return e?O[e]:O},refresh:function(){F.length&&l.each(F,function(e){e.trigger("Refresh")}),this.trigger("Refresh")},start:function(){this.state!=l.STARTED&&(this.state=l.STARTED,this.trigger("StateChanged"),a.call(this))},stop:function(){this.state!=l.STOPPED&&(this.state=l.STOPPED,this.trigger("StateChanged"),this.trigger("CancelUpload"))},disableBrowse:function(){U=arguments[0]!==i?arguments[0]:!0,F.length&&l.each(F,function(e){e.disable(U)}),this.trigger("DisableBrowse",U)},getFile:function(e){var t;for(t=D.length-1;t>=0;t--)if(D[t].id===e)return D[t]},addFile:function(e,i){function n(e,t){var i=[];l.each(u.settings.filters,function(t,n){s[n]&&i.push(function(i){s[n].call(u,t,e,function(e){i(!e)})})}),l.inSeries(i,t)}function a(e){var s=l.typeOf(e);if(e instanceof t.file.File){if(!e.ruid&&!e.isDetached()){if(!o)return!1;e.ruid=o,e.connectRuntime(o)}a(new l.File(e))}else e instanceof t.file.Blob?(a(e.getSource()),e.destroy()):e instanceof l.File?(i&&(e.name=i),d.push(function(t){n(e,function(i){i||(D.push(e),f.push(e),u.trigger("FileFiltered",e)),r(t,1)})})):-1!==l.inArray(s,["file","blob"])?a(new t.file.File(null,e)):"node"===s&&"filelist"===l.typeOf(e.files)?l.each(e.files,a):"array"===s&&(i=null,l.each(e,a))}var o,u=this,d=[],f=[];o=c(),a(e),d.length&&l.inSeries(d,function(){f.length&&u.trigger("FilesAdded",f)})},removeFile:function(e){for(var t="string"==typeof e?e:e.id,i=D.length-1;i>=0;i--)if(D[i].id===t)return this.splice(i,1)[0]},splice:function(e,t){var n=D.splice(e===i?0:e,t===i?D.length:t),r=!1;return this.state==l.STARTED&&(l.each(n,function(e){return e.status===l.UPLOADING?(r=!0,!1):void 0}),r&&this.stop()),this.trigger("FilesRemoved",n),l.each(n,function(e){e.destroy()}),r&&this.start(),n},dispatchEvent:function(e){var t,i;if(e=e.toLowerCase(),t=this.hasEventListener(e)){t.sort(function(e,t){return t.priority-e.priority}),i=[].slice.call(arguments),i.shift(),i.unshift(this);for(var n=0;n<t.length;n++)if(t[n].fn.apply(t[n].scope,i)===!1)return!1}return!0},bind:function(e,t,i,n){l.Uploader.prototype.bind.call(this,e,t,n,i)},destroy:function(){this.trigger("Destroy"),O=I=null,this.unbindAll()}})},l.Uploader.prototype=t.core.EventTarget.instance,l.File=function(){function e(e){l.extend(this,{id:l.guid(),name:e.name||e.fileName,type:e.type||"",relativePath:e.relativePath||"",size:e.fileSize||e.size,origSize:e.fileSize||e.size,loaded:0,percent:0,status:l.QUEUED,lastModifiedDate:e.lastModifiedDate||(new Date).toLocaleString(),completeTimestamp:0,getNative:function(){var e=this.getSource().getSource();return-1!==l.inArray(l.typeOf(e),["blob","file"])?e:null},getSource:function(){return t[this.id]?t[this.id]:null},destroy:function(){var e=this.getSource();e&&(e.destroy(),delete t[this.id])}}),t[this.id]=e}var t={};return e}(),l.QueueProgress=function(){var e=this;e.size=0,e.loaded=0,e.uploaded=0,e.failed=0,e.queued=0,e.percent=0,e.bytesPerSec=0,e.reset=function(){e.size=e.loaded=e.uploaded=e.failed=e.queued=e.percent=e.bytesPerSec=0}},e.plupload=l}(this,e)});

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.Compress=e():t.Compress=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var a=n[i]={exports:{},id:i,loaded:!1};return t[i].call(a.exports,a,a.exports,e),a.loaded=!0,a.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){var i,a,r;!function(o,u){a=[t,n(1),n(2),n(3),n(4),n(5),n(6)],i=u,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t,e,n,i,a,r,o){"use strict";function u(t){return t&&t.__esModule?t:{default:t}}function s(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function f(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var d=u(e),l=u(n),c=u(i),h=u(a),v=u(r),p=u(o),g=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),w=function(){function t(){f(this,t)}return g(t,[{key:"attach",value:function(t,e){var n=this;return new Promise(function(i,a){var r=document.querySelector(t);r.setAttribute("accept","image/*"),r.addEventListener("change",function(t){var a=n.compress([].concat(s(t.target.files)),e);i(a)},!1)})}},{key:"compress",value:function(t,e){function n(t,e){var n=new v.default(e);return n.start=window.performance.now(),n.alt=t.name,n.ext=t.type,n.startSize=t.size,p.default.orientation(t).then(function(e){return n.orientation=e,c.default.load(t)}).then(i(n))}function i(t){return function(e){return h.default.load(e).then(function(e){if(t.startWidth=e.naturalWidth,t.startHeight=e.naturalHeight,t.resize){var n=h.default.resize(t.maxWidth,t.maxHeight)(e.naturalWidth,e.naturalHeight),i=n.width,a=n.height;t.endWidth=i,t.endHeight=a}else t.endWidth=e.naturalWidth,t.endHeight=e.naturalHeight;return l.default.imageToCanvas(t.endWidth,t.endHeight,t.orientation)(e)}).then(function(e){return t.iterations=1,t.base64prefix=d.default.prefix(t.ext),a(e,t.startSize,t.quality,t.size,t.minQuality,t.iterations)}).then(function(e){return t.finalSize=d.default.size(e),d.default.data(e)}).then(function(e){t.end=window.performance.now();var n=t.end-t.start;return{data:e,prefix:t.base64prefix,elapsedTimeInSeconds:n/1e3,alt:t.alt,initialSizeInMb:l.default.size(t.startSize).MB,endSizeInMb:l.default.size(t.finalSize).MB,ext:t.ext,quality:t.quality,endWidthInPx:t.endWidth,endHeightInPx:t.endHeight,initialWidthInPx:t.startWidth,initialHeightInPx:t.startHeight,sizeReducedInPercent:(t.startSize-t.finalSize)/t.startSize*100,iterations:t.iterations}})}}function a(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments[3],r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:1,o=arguments[5],u=l.default.canvasToBase64(t,n),s=d.default.size(u);return o+=1,s>i?a(t,s,n-.1,i,r,o):n>r?a(t,s,n-.1,i,r,o):n<.5?u:u}return Promise.all(t.map(function(t){return n(t,e)}))}}],[{key:"convertBase64ToFile",value:function(t,e){return l.default.base64ToFile(t,e)}}]),t}();t.exports=w})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){var e=t.replace(/^data:image\/\w+;base64,/,"").length;return(e-814)/1.37},n=function(t){return t.split(";")[0].match(/jpeg|png|gif/)[0]},i=function(t){return t.replace(/^data:image\/\w+;base64,/,"")},a=function(t){return"data:"+t+";base64,"};t.default={size:e,mime:n,data:i,prefix:a}})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){for(var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"image/jpeg",n=window.atob(t),i=[],a=0;a<n.length;a++)i[a]=n.charCodeAt(a);return new window.Blob([new Uint8Array(i)],{type:e})},n=function(t,e,n){var i=document.createElement("canvas"),a=i.getContext("2d");return i.width=t,i.height=e,function(r){if(!n||n>8)return a.drawImage(r,0,0,i.width,i.height),i;switch(n>4&&(i.width=e,i.height=t),n){case 2:a.translate(t,0),a.scale(-1,1);break;case 3:a.translate(t,e),a.rotate(Math.PI);break;case 4:a.translate(0,e),a.scale(1,-1);break;case 5:a.rotate(.5*Math.PI),a.scale(1,-1);break;case 6:a.rotate(.5*Math.PI),a.translate(0,-e);break;case 7:a.rotate(.5*Math.PI),a.translate(t,-e),a.scale(-1,1);break;case 8:a.rotate(-.5*Math.PI),a.translate(-t,0)}return n>4?a.drawImage(r,0,0,i.height,i.width):a.drawImage(r,0,0,i.width,i.height),i}},i=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.75,n=t.toDataURL("image/jpeg",e);return n},a=function(t){return{KB:t/1e3,MB:t/1e6}};t.default={base64ToFile:e,imageToCanvas:n,canvasToBase64:i,size:a}})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){return new Promise(function(e,n){var i=new window.FileReader;i.addEventListener("load",function(t){e(t.target.result)},!1),i.addEventListener("error",function(t){n(t)},!1),i.readAsDataURL(t)})};t.default={load:e}})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){return new Promise(function(e,n){var i=new window.Image;i.addEventListener("load",function(){e(i)},!1),i.addEventListener("error",function(t){n(t)},!1),i.src=t})},n=function(t,e){return function(n,i){if(!t&&!e)return{width:n,height:i};var a=n/i,r=t/e,o=void 0,u=void 0;return a>r?(o=Math.min(n,t),u=o/a):(u=Math.min(i,e),o=u*a),{width:o,height:u}}};t.default={load:e,resize:n}})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";function e(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function t(n){var i=n.quality,a=void 0===i?.75:i,r=n.size,o=void 0===r?2:r,u=n.maxWidth,s=void 0===u?1920:u,f=n.maxHeight,d=void 0===f?1920:f,l=n.resize,c=void 0===l||l;e(this,t),this.start=window.performance.now(),this.end=null,this.alt=null,this.ext=null,this.startSize=null,this.startWidth=null,this.startHeight=null,this.size=1e3*o*1e3,this.endSize=null,this.endWidth=null,this.endHeight=null,this.iterations=0,this.base64prefix=null,this.quality=a,this.resize=c,this.maxWidth=s,this.maxHeight=d,this.orientation=1};t.default=n})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){return new Promise(function(e,n){var i=new window.FileReader;i.onload=function(t){var n=new DataView(t.target.result);65496!==n.getUint16(0,!1)&&e(-2);for(var i=n.byteLength,a=2;a<i;){var r=n.getUint16(a,!1);if(a+=2,65505===r){1165519206!==n.getUint32(a+=2,!1)&&e(-1);var o=18761===n.getUint16(a+=6,!1);a+=n.getUint32(a+4,o);var u=n.getUint16(a,o);a+=2;for(var s=0;s<u;s++)274===n.getUint16(a+12*s,o)&&e(n.getUint16(a+12*s+8,o))}else{if(65280!==(65280&r))break;a+=n.getUint16(a,!1)}}e(-1)},i.readAsArrayBuffer(t.slice(0,65536))})};t.default={orientation:e}})}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return converting; });
var converting = {
    methods: {
        base64toBlob: function base64toBlob(base64Data, contentType) {
            contentType = contentType || '';
            var sliceSize = 1024,
                byteCharacters = atob(base64Data),
                bytesLength = byteCharacters.length,
                sliceCount = Math.ceil(bytesLength / sliceSize),
                byteArray = new Array(sliceCount);

            for (var sliceIndex = 0; sliceIndex < sliceCount; ++sliceIndex) {
                var begin = sliceIndex * sliceSize,
                    end = Math.min(begin + sliceSize, bytesLength),
                    bytes = new Array(end - begin);

                for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArray[sliceIndex] = new Uint8Array(bytes);
            }

            return new Blob(byteArray, { type: contentType });
        },
        createUrlToFile: function createUrlToFile(file) {
            var urlCreator = window.URL || window.webkitURL;
            return urlCreator.createObjectURL(file);
        }
    }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, __dirname, Buffer) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {/*

   ----
   tiff.js: https://github.com/seikichi/tiff.js

   Copyright (C) 2013 seikichi[at]kmc.gr.jp

   This software is provided 'as-is', without any express or implied
   warranty. In no event will the authors be held liable for any damages
   arising from the use of this software.

   Permission is granted to anyone to use this software for any purpose,
   including commercial applications, and to alter it and redistribute it
   freely, subject to the following restrictions:

   1. The origin of this software must not be misrepresented; you must not
   claim that you wrote the original software. If you use this software
   in a product, an acknowledgment in the product documentation would be
   appreciated but is not required.

   2. Altered source versions must be plainly marked as such, and must not be
   misrepresented as being the original software.

   3. This notice may not be removed or altered from any source
   distribution.
   ----
   zlib: http://www.zlib.net/

   Copyright (C) 1995-2013 Jean-loup Gailly and Mark Adler

   This software is provided 'as-is', without any express or implied
   warranty.  In no event will the authors be held liable for any damages
   arising from the use of this software.

   Permission is granted to anyone to use this software for any purpose,
   including commercial applications, and to alter it and redistribute it
   freely, subject to the following restrictions:

   1. The origin of this software must not be misrepresented; you must not
   claim that you wrote the original software. If you use this software
   in a product, an acknowledgment in the product documentation would be
   appreciated but is not required.
   2. Altered source versions must be plainly marked as such, and must not be
   misrepresented as being the original software.
   3. This notice may not be removed or altered from any source distribution.

   Jean-loup Gailly        Mark Adler
   jloup@gzip.org          madler@alumni.caltech.edu


   The data format used by the zlib library is described by RFCs (Request for
   Comments) 1950 to 1952 in the files http://tools.ietf.org/html/rfc1950
   (zlib format), rfc1951 (deflate format) and rfc1952 (gzip format).
   ----
   LibTIFF: http://www.remotesensing.org/libtiff/

   Copyright (c) 1988-1997 Sam Leffler
   Copyright (c) 1991-1997 Silicon Graphics, Inc.

   Permission to use, copy, modify, distribute, and sell this software and 
   its documentation for any purpose is hereby granted without fee, provided
   that (i) the above copyright notices and this permission notice appear in
   all copies of the software and related documentation, and (ii) the names of
   Sam Leffler and Silicon Graphics may not be used in any advertising or
   publicity relating to the software without the specific, prior written
   permission of Sam Leffler and Silicon Graphics.

   THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND, 
   EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY 
   WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.  

   IN NO EVENT SHALL SAM LEFFLER OR SILICON GRAPHICS BE LIABLE FOR
   ANY SPECIAL, INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND,
   OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS,
   WHETHER OR NOT ADVISED OF THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF 
   LIABILITY, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE 
   OF THIS SOFTWARE.
*/
var loadModule=function(Lb){function nc(r){eval.call(null,r)}function fb(r,v){r||Vc("Assertion failed: "+v)}function me(r){var v=F["_"+r];if(!v)try{v=eval("_"+r)}catch(A){}fb(v,"Cannot call unknown function "+r+" (perhaps LLVM optimizations or closure removed it?)");return v}function If(r,v,A,fa){A=A||"i8";"*"===A.charAt(A.length-1)&&(A="i32");switch(A){case "i1":Dd[r>>0]=v;break;case "i8":Dd[r>>0]=v;break;case "i16":gf[r>>1]=v;break;case "i32":Sb[r>>2]=v;break;case "i64":kg=[v>>>0,(Re=v,1<=+Fg(Re)?
0<Re?(dj(+Lh(Re/4294967296),4294967295)|0)>>>0:~~+ej((Re-+(~~Re>>>0))/4294967296)>>>0:0)];Sb[r>>2]=kg[0];Sb[r+4>>2]=kg[1];break;case "float":mf[r>>2]=v;break;case "double":tf[r>>3]=v;break;default:Vc("invalid type for setValue: "+A)}}function dg(r,v,A){v=v||"i8";"*"===v.charAt(v.length-1)&&(v="i32");switch(v){case "i1":return Dd[r>>0];case "i8":return Dd[r>>0];case "i16":return gf[r>>1];case "i32":return Sb[r>>2];case "i64":return Sb[r>>2];case "float":return mf[r>>2];case "double":return tf[r>>3];
default:Vc("invalid type for setValue: "+v)}return null}function vc(r,v,A,fa){var D,F;"number"===typeof r?(D=!0,F=r):(D=!1,F=r.length);var ya="string"===typeof v?v:null;A=4==A?fa:[uf,ra.stackAlloc,ra.staticAlloc,ra.dynamicAlloc][void 0===A?2:A](Math.max(F,ya?1:v.length));if(D){fa=A;fb(0==(A&3));for(r=A+(F&-4);fa<r;fa+=4)Sb[fa>>2]=0;for(r=A+F;fa<r;)Dd[fa++>>0]=0;return A}if("i8"===ya)return r.subarray||r.slice?Od.set(r,A):Od.set(new Uint8Array(r),A),A;fa=0;for(var S,ca;fa<F;){var Xd=r[fa];"function"===
typeof Xd&&(Xd=ra.getFunctionIndex(Xd));D=ya||v[fa];0===D?fa++:("i64"==D&&(D="i32"),If(A+fa,Xd,D),ca!==D&&(S=ra.getNativeTypeSize(D),ca=D),fa+=S)}return A}function Yd(r,v){if(0===v||!r)return"";for(var A=0,fa,D=0;;){fa=Od[r+D>>0];A|=fa;if(0==fa&&!v)break;D++;if(v&&D==v)break}v||(v=D);fa="";if(128>A){for(;0<v;)A=String.fromCharCode.apply(String,Od.subarray(r,r+Math.min(v,1024))),fa=fa?fa+A:A,r+=1024,v-=1024;return fa}return F.UTF8ToString(r)}function nf(r,v){for(var A,fa,D,F,ya,S,ca="";;){A=r[v++];
if(!A)return ca;A&128?(fa=r[v++]&63,192==(A&224)?ca+=String.fromCharCode((A&31)<<6|fa):(D=r[v++]&63,224==(A&240)?A=(A&15)<<12|fa<<6|D:(F=r[v++]&63,240==(A&248)?A=(A&7)<<18|fa<<12|D<<6|F:(ya=r[v++]&63,248==(A&252)?A=(A&3)<<24|fa<<18|D<<12|F<<6|ya:(S=r[v++]&63,A=(A&1)<<30|fa<<24|D<<18|F<<12|ya<<6|S))),65536>A?ca+=String.fromCharCode(A):(A-=65536,ca+=String.fromCharCode(55296|A>>10,56320|A&1023)))):ca+=String.fromCharCode(A)}}function Ug(r,v,A,fa){if(!(0<fa))return 0;var D=A;fa=A+fa-1;for(var F=0;F<
r.length;++F){var ya=r.charCodeAt(F);55296<=ya&&57343>=ya&&(ya=65536+((ya&1023)<<10)|r.charCodeAt(++F)&1023);if(127>=ya){if(A>=fa)break;v[A++]=ya}else{if(2047>=ya){if(A+1>=fa)break;v[A++]=192|ya>>6}else{if(65535>=ya){if(A+2>=fa)break;v[A++]=224|ya>>12}else{if(2097151>=ya){if(A+3>=fa)break;v[A++]=240|ya>>18}else{if(67108863>=ya){if(A+4>=fa)break;v[A++]=248|ya>>24}else{if(A+5>=fa)break;v[A++]=252|ya>>30;v[A++]=128|ya>>24&63}v[A++]=128|ya>>18&63}v[A++]=128|ya>>12&63}v[A++]=128|ya>>6&63}v[A++]=128|ya&
63}}v[A]=0;return A-D}function lg(r){for(var v=0,A=0;A<r.length;++A){var fa=r.charCodeAt(A);55296<=fa&&57343>=fa&&(fa=65536+((fa&1023)<<10)|r.charCodeAt(++A)&1023);127>=fa?++v:v=2047>=fa?v+2:65535>=fa?v+3:2097151>=fa?v+4:67108863>=fa?v+5:v+6}return v}function fj(r){function v(A,fa,D){fa=fa||Infinity;var F="",yc=[],aa;if("N"===r[ya]){ya++;"K"===r[ya]&&ya++;for(aa=[];"E"!==r[ya];)if("S"===r[ya]){ya++;var S=r.indexOf("_",ya),ra=r.substring(ya,S)||0;aa.push(Hk[ra]||"?");ya=S+1}else if("C"===r[ya])aa.push(aa[aa.length-
1]),ya+=2;else{S=parseInt(r.substr(ya));ra=S.toString().length;if(!S||!ra){ya--;break}var Ka=r.substr(ya+ra,S);aa.push(Ka);Hk.push(Ka);ya+=ra+S}ya++;aa=aa.join("::");fa--;if(0===fa)return A?[aa]:aa}else if(("K"===r[ya]||Xd&&"L"===r[ya])&&ya++,S=parseInt(r.substr(ya)))ra=S.toString().length,aa=r.substr(ya+ra,S),ya+=ra+S;Xd=!1;"I"===r[ya]?(ya++,S=v(!0),ra=v(!0,1,!0),F+=ra[0]+" "+aa+"<"+S.join(", ")+">"):F=aa;a:for(;ya<r.length&&0<fa--;)if(aa=r[ya++],aa in ca)yc.push(ca[aa]);else switch(aa){case "P":yc.push(v(!0,
1,!0)[0]+"*");break;case "R":yc.push(v(!0,1,!0)[0]+"&");break;case "L":ya++;S=r.indexOf("E",ya)-ya;yc.push(r.substr(ya,S));ya+=S+2;break;case "A":S=parseInt(r.substr(ya));ya+=S.toString().length;if("_"!==r[ya])throw"?";ya++;yc.push(v(!0,1,!0)[0]+" ["+S+"]");break;case "E":break a;default:F+="?"+aa;break a}D||1!==yc.length||"void"!==yc[0]||(yc=[]);return A?(F&&yc.push(F+"?"),yc):F+("("+yc.join(", ")+")")}var A=!!F.___cxa_demangle;if(A)try{var fa=uf(r.length);Ji(r.substr(1),fa);var D=uf(4),aa=F.___cxa_demangle(fa,
0,0,D);if(0===dg(D,"i32")&&aa)return Yd(aa)}catch(S){}finally{fa&&vf(fa),D&&vf(D),aa&&vf(aa)}var ya=3,ca={v:"void",b:"bool",c:"char",s:"short",i:"int",l:"long",f:"float",d:"double",w:"wchar_t",a:"signed char",h:"unsigned char",t:"unsigned short",j:"unsigned int",m:"unsigned long",x:"long long",y:"unsigned long long",z:"..."},Hk=[],Xd=!0,fa=r;try{if("Object._main"==r||"_main"==r)return"main()";"number"===typeof r&&(r=Yd(r));if("_"!==r[0]||"_"!==r[1]||"Z"!==r[2])return r;switch(r[3]){case "n":return"operator new()";
case "d":return"operator delete()"}fa=v()}catch(S){fa+="?"}0<=fa.indexOf("?")&&!A&&ra.warnOnce("warning: a problem occurred in builtin C++ name demangling; build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling");return fa}function gj(r){return r.replace(/__Z[\w\d_]+/g,function(r){var A=fj(r);return r===A?r:r+" ["+A+"]"})}function wf(){var r=gj,v;a:{v=Error();if(!v.stack){try{throw Error(0);}catch(A){v=A}if(!v.stack){v="(no stack trace available)";break a}}v=v.stack.toString()}return r(v)}
function Gg(r){0<r%4096&&(r+=4096-r%4096);return r}function Cj(){var r=Math.pow(2,31);if(we>=r)return!1;for(;ld<=we;)if(ld<r/2)ld=Gg(2*ld);else{var v=ld;ld=Gg((3*ld+r)/4);if(ld<=v)return!1}ld=Math.max(ld,16777216);if(ld>=r)return!1;try{if(ArrayBuffer.transfer)rd=ArrayBuffer.transfer(rd,ld);else{var A=Dd;rd=new ArrayBuffer(ld)}}catch(fa){return!1}if(!Dj(rd))return!1;F.buffer=rd;F.HEAP8=Dd=new Int8Array(rd);F.HEAP16=gf=new Int16Array(rd);F.HEAP32=Sb=new Int32Array(rd);F.HEAPU8=Od=new Uint8Array(rd);
F.HEAPU16=Vg=new Uint16Array(rd);F.HEAPU32=xf=new Uint32Array(rd);F.HEAPF32=mf=new Float32Array(rd);F.HEAPF64=tf=new Float64Array(rd);ArrayBuffer.transfer||Dd.set(A);return!0}function mg(r){for(;0<r.length;){var v=r.shift();if("function"==typeof v)v();else{var A=v.func;"number"===typeof A?void 0===v.arg?ra.dynCall("v",A):ra.dynCall("vi",A,[v.arg]):A(void 0===v.arg?null:v.arg)}}}function Mh(r){Jf.unshift(r)}function Hg(r){Wg.unshift(r)}function yf(r,v,A){A=0<A?A:lg(r)+1;A=Array(A);r=Ug(r,A,0,A.length);
v&&(A.length=r);return A}function Ji(r,v,A){r=yf(r,A);for(A=0;A<r.length;)Dd[v+A>>0]=r[A],A+=1}function Xg(r,v){for(var A=0;A<r.length;A++)Dd[v++>>0]=r[A]}function zf(r,v,A){for(var fa=0;fa<r.length;++fa)Dd[v++>>0]=r.charCodeAt(fa);A||(Dd[v>>0]=0)}function Yg(r){Uf++;F.monitorRunDependencies&&F.monitorRunDependencies(Uf)}function ng(r){Uf--;F.monitorRunDependencies&&F.monitorRunDependencies(Uf);0==Uf&&(null!==Nh&&(clearInterval(Nh),Nh=null),Vf&&(r=Vf,Vf=null,r()))}function eg(r){F.___errno_location&&
(Sb[F.___errno_location()>>2]=r);return r}function hj(r,v){S.mainLoop.timingMode=r;S.mainLoop.timingValue=v;if(!S.mainLoop.func)return 1;if(0==r)S.mainLoop.scheduler=function(){setTimeout(S.mainLoop.runner,v)},S.mainLoop.method="timeout";else if(1==r)S.mainLoop.scheduler=function(){S.requestAnimationFrame(S.mainLoop.runner)},S.mainLoop.method="rAF";else if(2==r){if(!window.setImmediate){var A=[];window.addEventListener("message",function(r){r.source===window&&"__emcc"===r.data&&(r.stopPropagation(),
A.shift()())},!0);window.setImmediate=function(r){A.push(r);window.postMessage("__emcc","*")}}S.mainLoop.scheduler=function(){window.setImmediate(S.mainLoop.runner)};S.mainLoop.method="immediate"}return 0}function Oh(r,v,A,fa,D){F.noExitRuntime=!0;fb(!S.mainLoop.func,"emscripten_set_main_loop: there can only be one main loop function at once: call emscripten_cancel_main_loop to cancel the previous one before setting a new one with different parameters.");S.mainLoop.func=r;S.mainLoop.arg=fa;var aa=
S.mainLoop.currentlyRunningMainloop;S.mainLoop.runner=function(){if(!xe)if(0<S.mainLoop.queue.length){var v=Date.now(),A=S.mainLoop.queue.shift();A.func(A.arg);if(S.mainLoop.remainingBlockers){var D=S.mainLoop.remainingBlockers,yc=0==D%1?D-1:Math.floor(D);S.mainLoop.remainingBlockers=A.counted?yc:(8*D+(yc+.5))/9}console.log('main loop blocker "'+A.name+'" took '+(Date.now()-v)+" ms");S.mainLoop.updateStatus();setTimeout(S.mainLoop.runner,0)}else aa<S.mainLoop.currentlyRunningMainloop||(S.mainLoop.currentFrameNumber=
S.mainLoop.currentFrameNumber+1|0,1==S.mainLoop.timingMode&&1<S.mainLoop.timingValue&&0!=S.mainLoop.currentFrameNumber%S.mainLoop.timingValue?S.mainLoop.scheduler():("timeout"===S.mainLoop.method&&F.ctx&&(F.printErr("Looks like you are rendering without using requestAnimationFrame for the main loop. You should use 0 for the frame rate in emscripten_set_main_loop in order to use requestAnimationFrame, as that can greatly improve your frame rates!"),S.mainLoop.method=""),S.mainLoop.runIter(function(){"undefined"!==
typeof fa?ra.dynCall("vi",r,[fa]):ra.dynCall("v",r)}),aa<S.mainLoop.currentlyRunningMainloop||("object"===typeof SDL&&SDL.audio&&SDL.audio.queueNewAudioData&&SDL.audio.queueNewAudioData(),S.mainLoop.scheduler())))};D||(v&&0<v?hj(0,1E3/v):hj(1,1),S.mainLoop.scheduler());if(A)throw"SimulateInfiniteLoop";}function Ph(){throw"bad";}function Qh(r){F.exit(r)}function Zg(r,v){ab.setThrew(r,v||1);throw"longjmp";}function ni(r,v){re.push(function(){ra.dynCall("vi",r,[v])});ni.level=re.length}function Af(r){var v,
A;Af.called?(A=Sb[Rh>>2],v=Sb[A>>2]):(Af.called=!0,Td.USER=Td.LOGNAME="web_user",Td.PATH="/",Td.PWD="/",Td.HOME="/home/web_user",Td.LANG="C",Td._=F.thisProgram,v=vc(1024,"i8",2),A=vc(256,"i8*",2),Sb[A>>2]=v,Sb[Rh>>2]=A);var fa=[],D=0,aa;for(aa in r)if("string"===typeof r[aa]){var ya=aa+"="+r[aa];fa.push(ya);D+=ya.length}if(1024<D)throw Error("Environment size exceeded TOTAL_ENV_SIZE!");for(r=0;r<fa.length;r++)ya=fa[r],zf(ya,v),Sb[A+4*r>>2]=v,v+=ya.length+1;Sb[A+4*fa.length>>2]=0}function Ig(r){if(0===
r)return 0;r=Yd(r);if(!Td.hasOwnProperty(r))return 0;Ig.ret&&vf(Ig.ret);Ig.ret=vc(yf(Td[r]),"i8",0);return Ig.ret}function og(r){var v=og;v.called||(we=Gg(we),v.called=!0,fb(ra.dynamicAlloc),v.alloc=ra.dynamicAlloc,ra.dynamicAlloc=function(){Vc("cannot dynamically allocate, sbrk now has control")});var A=we;return 0==r||v.alloc(r)?A:4294967295}function of(r){this.name="ExitStatus";this.message="Program terminated with exit("+r+")";this.status=r}function $g(r){function v(){if(!F.calledRun&&(F.calledRun=
!0,!xe)){pg||(pg=!0,mg(qg));mg(rg);if(F.onRuntimeInitialized)F.onRuntimeInitialized();F._main&&Sh&&F.callMain(r);if(F.postRun)for("function"==typeof F.postRun&&(F.postRun=[F.postRun]);F.postRun.length;)Hg(F.postRun.shift());mg(Wg)}}r=r||F.arguments;null===Th&&(Th=Date.now());if(!(0<Uf)){if(F.preRun)for("function"==typeof F.preRun&&(F.preRun=[F.preRun]);F.preRun.length;)Mh(F.preRun.shift());mg(Jf);0<Uf||F.calledRun||(F.setStatus?(F.setStatus("Running..."),setTimeout(function(){setTimeout(function(){F.setStatus("")},
1);v()},1)):v())}}function Jg(r,v){if(!v||!F.noExitRuntime){if(!F.noExitRuntime&&(xe=!0,se=Ej,mg(re),F.onExit))F.onExit(r);Bf?(process.stdout.once("drain",function(){process.exit(r)}),console.log(" "),setTimeout(function(){process.exit(r)},500)):ah&&"function"===typeof quit&&quit(r);throw new of(r);}}function Vc(r){void 0!==r?(F.print(r),F.printErr(r),r=JSON.stringify(r)):r="";xe=!0;var v="abort("+r+") at "+wf()+"\nIf this abort() is unexpected, build with -s ASSERTIONS=1 which can give more information.";
bh&&bh.forEach(function(A){v=A(v,r)});throw v;}var F={};"TOTAL_MEMORY"in Lb&&(F.TOTAL_MEMORY=Lb.TOTAL_MEMORY);F||(F=("undefined"!==typeof F?F:null)||{});var sg={},Kf;for(Kf in F)F.hasOwnProperty(Kf)&&(sg[Kf]=F[Kf]);var Uh="object"===typeof window,fg="function"===typeof importScripts,Bf="object"===typeof process&&"function"==="function"&&!Uh&&!fg,ah=!Uh&&!Bf&&!fg;if(Bf){F.print||(F.print=function(r){process.stdout.write(r+"\n")});F.printErr||(F.printErr=function(r){process.stderr.write(r+"\n")});
var Vh=__webpack_require__(141),Wh=__webpack_require__(142);F.read=function(r,v){r=Wh.normalize(r);var A=Vh.readFileSync(r);A||r==Wh.resolve(r)||(r=path.join(__dirname,"..","src",r),A=Vh.readFileSync(r));A&&!v&&(A=A.toString());return A};F.readBinary=function(r){r=F.read(r,!0);r.buffer||(r=new Uint8Array(r));fb(r.buffer);return r};F.load=function(r){nc(read(r))};F.thisProgram||(F.thisProgram=1<process.argv.length?process.argv[1].replace(/\\/g,"/"):"unknown-program");F.arguments=process.argv.slice(2);"undefined"!==typeof module&&
(module.exports=F);process.on("uncaughtException",function(r){if(!(r instanceof of))throw r;});F.inspect=function(){return"[Emscripten Module object]"}}else if(ah)F.print||(F.print=print),"undefined"!=typeof printErr&&(F.printErr=printErr),F.read="undefined"!=typeof read?read:function(){throw"no read() available (jsc?)";},F.readBinary=function(r){if("function"===typeof readbuffer)return new Uint8Array(readbuffer(r));r=read(r,"binary");fb("object"===typeof r);return r},"undefined"!=typeof scriptArgs?
F.arguments=scriptArgs:"undefined"!=typeof arguments&&(F.arguments=arguments);else if(Uh||fg)F.read=function(r){var v=new XMLHttpRequest;v.open("GET",r,!1);v.send(null);return v.responseText},"undefined"!=typeof arguments&&(F.arguments=arguments),"undefined"!==typeof console?(F.print||(F.print=function(r){console.log(r)}),F.printErr||(F.printErr=function(r){console.log(r)})):F.print||(F.print=function(r){}),fg&&(F.load=importScripts),"undefined"===typeof F.setWindowTitle&&(F.setWindowTitle=function(r){document.title=
r});else throw"Unknown runtime environment. Where are we?";!F.load&&F.read&&(F.load=function(r){nc(F.read(r))});F.print||(F.print=function(){});F.printErr||(F.printErr=F.print);F.arguments||(F.arguments=[]);F.thisProgram||(F.thisProgram="./this.program");F.print=F.print;F.printErr=F.printErr;F.preRun=[];F.postRun=[];for(Kf in sg)sg.hasOwnProperty(Kf)&&(F[Kf]=sg[Kf]);var ra={setTempRet0:function(r){oi=r},getTempRet0:function(){return oi},stackSave:function(){return se},stackRestore:function(r){se=
r},getNativeTypeSize:function(r){switch(r){case "i1":case "i8":return 1;case "i16":return 2;case "i32":return 4;case "i64":return 8;case "float":return 4;case "double":return 8;default:return"*"===r[r.length-1]?ra.QUANTUM_SIZE:"i"===r[0]?(r=parseInt(r.substr(1)),fb(0===r%8),r/8):0}},getNativeFieldSize:function(r){return Math.max(ra.getNativeTypeSize(r),ra.QUANTUM_SIZE)},STACK_ALIGN:16,prepVararg:function(r,v){"double"===v||"i64"===v?r&7&&(fb(4===(r&7)),r+=4):fb(0===(r&3));return r},getAlignSize:function(r,
v,A){return A||"i64"!=r&&"double"!=r?r?Math.min(v||(r?ra.getNativeFieldSize(r):0),ra.QUANTUM_SIZE):Math.min(v,8):8},dynCall:function(r,v,A){return A&&A.length?(A.splice||(A=Array.prototype.slice.call(A)),A.splice(0,0,v),F["dynCall_"+r].apply(null,A)):F["dynCall_"+r].call(null,v)},functionPointers:[],addFunction:function(r){for(var v=0;v<ra.functionPointers.length;v++)if(!ra.functionPointers[v])return ra.functionPointers[v]=r,2*(1+v);throw"Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.";
},removeFunction:function(r){ra.functionPointers[(r-2)/2]=null},warnOnce:function(r){ra.warnOnce.shown||(ra.warnOnce.shown={});ra.warnOnce.shown[r]||(ra.warnOnce.shown[r]=1,F.printErr(r))},funcWrappers:{},getFuncWrapper:function(r,v){fb(v);ra.funcWrappers[v]||(ra.funcWrappers[v]={});var A=ra.funcWrappers[v];A[r]||(A[r]=function(){return ra.dynCall(v,r,arguments)});return A[r]},getCompilerSetting:function(r){throw"You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work";
},stackAlloc:function(r){var v=se;se=se+r|0;se=se+15&-16;return v},staticAlloc:function(r){var v=Se;Se=Se+r|0;Se=Se+15&-16;return v},dynamicAlloc:function(r){var v=we;we=we+r|0;we=we+15&-16;return we>=ld&&!Cj()?(we=v,0):v},alignMemory:function(r,v){return Math.ceil(r/(v?v:16))*(v?v:16)},makeBigInt:function(r,v,A){return A?+(r>>>0)+4294967296*+(v>>>0):+(r>>>0)+4294967296*+(v|0)},GLOBAL_BASE:8,QUANTUM_SIZE:4,__dummy__:0};F.Runtime=ra;var xe=!1,Re,kg,oi,Xh,Yh;(function(){function r(r){r=r.toString().match(fa).slice(1);
return{arguments:r[0],body:r[1],returnValue:r[2]}}var v={stackSave:function(){ra.stackSave()},stackRestore:function(){ra.stackRestore()},arrayToC:function(r){var v=ra.stackAlloc(r.length);Xg(r,v);return v},stringToC:function(r){var v=0;null!==r&&void 0!==r&&0!==r&&(v=ra.stackAlloc((r.length<<2)+1),Ji(r,v));return v}},A={string:v.stringToC,array:v.arrayToC};Yh=function(r,v,D,fa,F){r=me(r);var yc=[],Y=0;if(fa)for(var aa=0;aa<fa.length;aa++){var S=A[D[aa]];S?(0===Y&&(Y=ra.stackSave()),yc[aa]=S(fa[aa])):
yc[aa]=fa[aa]}D=r.apply(null,yc);"string"===v&&(D=Yd(D));if(0!==Y){if(F&&F.async){EmterpreterAsync.asyncFinalizers.push(function(){ra.stackRestore(Y)});return}ra.stackRestore(Y)}return D};var fa=/^function\s*\(([^)]*)\)\s*{\s*([^*]*?)[\s;]*(?:return\s*(.*?)[;\s]*)?}$/,D={},F;for(F in v)v.hasOwnProperty(F)&&(D[F]=r(v[F]));Xh=function(v,A,fa){fa=fa||[];var F=me(v);v=fa.every(function(r){return"number"===r});var aa="string"!==A;if(aa&&v)return F;var S=fa.map(function(r,v){return"$"+v});A="(function("+
S.join(",")+") {";var Y=fa.length;if(!v){A+="var stack = "+D.stackSave.body+";";for(var ca=0;ca<Y;ca++){var ra=S[ca],Ka=fa[ca];"number"!==Ka&&(Ka=D[Ka+"ToC"],A+="var "+Ka.arguments+" = "+ra+";",A+=Ka.body+";",A+=ra+"="+Ka.returnValue+";")}}fa=r(function(){return F}).returnValue;A+="var ret = "+fa+"("+S.join(",")+");";aa||(fa=r(function(){return Yd}).returnValue,A+="ret = "+fa+"(ret);");v||(A+=D.stackRestore.body.replace("()","(stack)")+";");return eval(A+"return ret})")}})();F.ccall=Yh;F.cwrap=Xh;
F.setValue=If;F.getValue=dg;F.ALLOC_NORMAL=0;F.ALLOC_STACK=1;F.ALLOC_STATIC=2;F.ALLOC_DYNAMIC=3;F.ALLOC_NONE=4;F.allocate=vc;F.getMemory=function(r){return pi?"undefined"!==typeof og&&!og.called||!pg?ra.dynamicAlloc(r):uf(r):ra.staticAlloc(r)};F.Pointer_stringify=Yd;F.AsciiToString=function(r){for(var v="";;){var A=Dd[r++>>0];if(!A)return v;v+=String.fromCharCode(A)}};F.stringToAscii=function(r,v){return zf(r,v,!1)};F.UTF8ArrayToString=nf;F.UTF8ToString=function(r){return nf(Od,r)};F.stringToUTF8Array=
Ug;F.stringToUTF8=function(r,v,A){return Ug(r,Od,v,A)};F.lengthBytesUTF8=lg;F.UTF16ToString=function(r){for(var v=0,A="";;){var fa=gf[r+2*v>>1];if(0==fa)return A;++v;A+=String.fromCharCode(fa)}};F.stringToUTF16=function(r,v,A){void 0===A&&(A=2147483647);if(2>A)return 0;A-=2;var fa=v;A=A<2*r.length?A/2:r.length;for(var D=0;D<A;++D){var F=r.charCodeAt(D);gf[v>>1]=F;v+=2}gf[v>>1]=0;return v-fa};F.lengthBytesUTF16=function(r){return 2*r.length};F.UTF32ToString=function(r){for(var v=0,A="";;){var fa=Sb[r+
4*v>>2];if(0==fa)return A;++v;65536<=fa?(fa-=65536,A+=String.fromCharCode(55296|fa>>10,56320|fa&1023)):A+=String.fromCharCode(fa)}};F.stringToUTF32=function(r,v,A){void 0===A&&(A=2147483647);if(4>A)return 0;var fa=v;A=fa+A-4;for(var D=0;D<r.length;++D){var F=r.charCodeAt(D);if(55296<=F&&57343>=F)var ya=r.charCodeAt(++D),F=65536+((F&1023)<<10)|ya&1023;Sb[v>>2]=F;v+=4;if(v+4>A)break}Sb[v>>2]=0;return v-fa};F.lengthBytesUTF32=function(r){for(var v=0,A=0;A<r.length;++A){var D=r.charCodeAt(A);55296<=D&&
57343>=D&&++A;v+=4}return v};F.stackTrace=wf;var Dd,Od,gf,Vg,Sb,xf,mf,tf,Ki=0,Se=0,pi=!1,Zh=0,se=0,vh=0,ch=0,we=0,Kg;try{Kg=Function.prototype.call.bind(Object.getOwnPropertyDescriptor(ArrayBuffer.prototype,"byteLength").get),Kg(new ArrayBuffer(4))}catch(r){Kg=function(r){return r.byteLength}}for(var $h=F.TOTAL_STACK||5242880,ld=F.TOTAL_MEMORY||16777216,Pc=65536;Pc<ld||Pc<2*$h;)Pc=16777216>Pc?2*Pc:Pc+16777216;Pc=Math.max(Pc,16777216);Pc!==ld&&(ld=Pc);fb("undefined"!==typeof Int32Array&&"undefined"!==
typeof Float64Array&&!!(new Int32Array(1)).subarray&&!!(new Int32Array(1)).set,"JS engine does not provide full typed array support");var rd;rd=new ArrayBuffer(ld);Dd=new Int8Array(rd);gf=new Int16Array(rd);Sb=new Int32Array(rd);Od=new Uint8Array(rd);Vg=new Uint16Array(rd);xf=new Uint32Array(rd);mf=new Float32Array(rd);tf=new Float64Array(rd);Sb[0]=255;fb(255===Od[0]&&0===Od[3],"Typed arrays 2 must be run on a little-endian system");F.HEAP=void 0;F.buffer=rd;F.HEAP8=Dd;F.HEAP16=gf;F.HEAP32=Sb;F.HEAPU8=
Od;F.HEAPU16=Vg;F.HEAPU32=xf;F.HEAPF32=mf;F.HEAPF64=tf;var Jf=[],qg=[],rg=[],re=[],Wg=[],pg=!1;F.addOnPreRun=Mh;F.addOnInit=function(r){qg.unshift(r)};F.addOnPreMain=function(r){rg.unshift(r)};F.addOnExit=function(r){re.unshift(r)};F.addOnPostRun=Hg;F.intArrayFromString=yf;F.intArrayToString=function(r){for(var v=[],A=0;A<r.length;A++){var D=r[A];255<D&&(D&=255);v.push(String.fromCharCode(D))}return v.join("")};F.writeStringToMemory=Ji;F.writeArrayToMemory=Xg;F.writeAsciiToMemory=zf;Math.imul&&-5===
Math.imul(4294967295,5)||(Math.imul=function(r,v){var A=r&65535,D=v&65535;return A*D+((r>>>16)*D+A*(v>>>16)<<16)|0});Math.imul=Math.imul;Math.clz32||(Math.clz32=function(r){r>>>=0;for(var v=0;32>v;v++)if(r&1<<31-v)return v;return 32});Math.clz32=Math.clz32;var Fg=Math.abs,Fj=Math.atan2,Gj=Math.exp,Hj=Math.log,Ij=Math.sqrt,ej=Math.ceil,Lh=Math.floor,Jj=Math.pow,dj=Math.min,Uf=0,Nh=null,Vf=null;F.addRunDependency=Yg;F.removeRunDependency=ng;F.preloadedImages={};F.preloadedAudios={};Ki=8;Se=Ki+164992;
qg.push();vc([0,0,0,0,0,0,240,63,239,97,72,177,80,49,246,63,202,111,77,145,174,231,244,63,170,17,108,239,98,208,242,63,0,0,0,0,0,0,240,63,59,191,167,192,105,36,233,63,187,32,199,123,122,81,225,63,93,171,114,222,85,168,209,63,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,153,0,0,0,84,8,0,0,1,0,0,0,0,0,0,0,56,0,0,0,116,0,0,0,154,130,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,82,251,1,0,0,0,0,0,157,130,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,95,251,1,0,0,0,0,0,34,136,0,0,1,0,1,0,3,
0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,103,251,1,0,0,0,0,0,36,136,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,119,251,1,0,0,0,0,0,39,136,0,0,255,255,255,255,3,0,0,0,0,0,0,0,30,0,0,0,0,0,0,0,65,0,1,1,139,251,1,0,0,0,0,0,40,136,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,1,1,155,251,1,0,0,0,0,0,0,144,0,0,4,0,4,0,7,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,65,0,1,0,184,251,1,0,0,0,0,0,3,144,0,0,20,0,20,0,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,196,251,1,0,0,0,0,0,4,144,0,0,20,0,
20,0,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,213,251,1,0,0,0,0,0,1,145,0,0,4,0,4,0,7,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,65,0,1,0,231,251,1,0,0,0,0,0,2,145,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,255,251,1,0,0,0,0,0,1,146,0,0,1,0,1,0,10,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,22,252,1,0,0,0,0,0,2,146,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,40,252,1,0,0,0,0,0,3,146,0,0,1,0,1,0,10,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,54,252,1,0,0,0,0,0,4,146,0,0,1,0,1,0,10,0,0,0,0,0,0,0,11,
0,0,0,0,0,0,0,65,0,1,0,70,252,1,0,0,0,0,0,5,146,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,88,252,1,0,0,0,0,0,6,146,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,105,252,1,0,0,0,0,0,7,146,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,121,252,1,0,0,0,0,0,8,146,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,134,252,1,0,0,0,0,0,9,146,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,146,252,1,0,0,0,0,0,10,146,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,152,
252,1,0,0,0,0,0,20,146,0,0,255,255,255,255,3,0,0,0,0,0,0,0,30,0,0,0,0,0,0,0,65,0,1,1,164,252,1,0,0,0,0,0,124,146,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,1,1,176,252,1,0,0,0,0,0,134,146,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,1,1,186,252,1,0,0,0,0,0,144,146,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,198,252,1,0,0,0,0,0,145,146,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,209,252,1,0,0,0,0,0,146,146,0,0,255,255,255,255,2,0,0,0,0,
0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,228,252,1,0,0,0,0,0,0,160,0,0,4,0,4,0,7,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,65,0,1,0,248,252,1,0,0,0,0,0,1,160,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,8,253,1,0,0,0,0,0,2,160,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,65,0,1,0,19,253,1,0,0,0,0,0,3,160,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,65,0,1,0,35,253,1,0,0,0,0,0,4,160,0,0,13,0,13,0,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,51,253,1,0,0,0,0,0,11,162,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,
1,0,68,253,1,0,0,0,0,0,12,162,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,1,1,80,253,1,0,0,0,0,0,14,162,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,105,253,1,0,0,0,0,0,15,162,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,127,253,1,0,0,0,0,0,16,162,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,149,253,1,0,0,0,0,0,20,162,0,0,2,0,2,0,3,0,0,0,0,0,0,0,18,0,0,0,0,0,0,0,65,0,1,0,174,253,1,0,0,0,0,0,21,162,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,190,253,
1,0,0,0,0,0,23,162,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,204,253,1,0,0,0,0,0,0,163,0,0,1,0,1,0,7,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,65,0,1,0,218,253,1,0,0,0,0,0,1,163,0,0,1,0,1,0,7,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,65,0,1,0,229,253,1,0,0,0,0,0,2,163,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,1,1,239,253,1,0,0,0,0,0,1,164,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,250,253,1,0,0,0,0,0,2,164,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,9,254,1,0,0,0,0,0,3,164,0,
0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,22,254,1,0,0,0,0,0,4,164,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,35,254,1,0,0,0,0,0,5,164,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,52,254,1,0,0,0,0,0,6,164,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,74,254,1,0,0,0,0,0,7,164,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,1,0,91,254,1,0,0,0,0,0,8,164,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,103,254,1,0,0,0,0,0,9,164,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,
0,0,0,0,0,0,65,0,1,0,112,254,1,0,0,0,0,0,10,164,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,123,254,1,0,0,0,0,0,11,164,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,1,1,133,254,1,0,0,0,0,0,12,164,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,158,254,1,0,0,0,0,0,32,164,0,0,33,0,33,0,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,179,254,1,0,0,0,0,0,254,0,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,5,0,1,0,193,254,1,0,0,0,0,0,255,0,0,0,1,0,1,0,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,
0,1,0,205,254,1,0,0,0,0,0,0,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,1,0,0,0,220,254,1,0,0,0,0,0,1,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,1,0,1,0,211,8,2,0,0,0,0,0,2,1,0,0,255,255,255,255,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,6,0,0,0,231,254,1,0,0,0,0,0,3,1,0,0,255,255,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,7,0,0,0,99,20,2,0,0,0,0,0,6,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,8,0,0,0,245,254,1,0,0,0,0,0,7,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,9,0,1,0,15,255,1,0,0,0,0,0,8,1,0,0,1,0,
1,0,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,29,255,1,0,0,0,0,0,9,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,39,255,1,0,0,0,0,0,10,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,10,0,0,0,50,255,1,0,0,0,0,0,13,1,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,60,255,1,0,0,0,0,0,14,1,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,73,255,1,0,0,0,0,0,15,1,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,90,255,1,0,0,0,0,0,16,1,0,0,255,255,255,255,2,0,0,
0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,95,255,1,0,0,0,0,0,17,1,0,0,255,255,255,255,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,25,0,0,0,24,9,2,0,0,0,0,0,18,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,15,0,0,0,101,255,1,0,0,0,0,0,21,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,16,0,0,0,113,255,1,0,0,0,0,0,22,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,17,0,0,0,129,255,1,0,0,0,0,0,23,1,0,0,255,255,255,255,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,0,0,0,191,10,2,0,0,0,0,0,24,1,0,0,254,255,255,255,3,0,0,0,0,0,0,0,4,
0,0,0,0,0,0,0,18,0,1,0,142,255,1,0,0,0,0,0,25,1,0,0,254,255,255,255,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,19,0,1,0,157,255,1,0,0,0,0,0,26,1,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,3,0,1,0,172,255,1,0,0,0,0,0,27,1,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,3,0,1,0,184,255,1,0,0,0,0,0,28,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,20,0,0,0,196,255,1,0,0,0,0,0,29,1,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,216,255,1,0,0,0,0,0,30,1,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,4,
0,1,0,225,255,1,0,0,0,0,0,31,1,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,4,0,1,0,235,255,1,0,0,0,0,0,32,1,0,0,255,255,255,255,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,245,255,1,0,0,0,0,0,33,1,0,0,255,255,255,255,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,2,0,0,0,0,0,34,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,16,0,2,0,0,0,0,0,35,1,0,0,255,255,255,255,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,33,0,2,0,0,0,0,0,40,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,22,0,1,0,51,0,2,0,0,0,0,
0,41,1,0,0,2,0,2,0,3,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,23,0,1,0,66,0,2,0,0,0,0,0,44,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,77,0,2,0,0,0,0,0,45,1,0,0,255,255,255,255,3,0,0,0,0,0,0,0,51,0,0,0,0,0,0,0,44,0,1,0,95,0,2,0,0,0,0,0,49,1,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,112,0,2,0,0,0,0,0,50,1,0,0,20,0,20,0,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,121,0,2,0,0,0,0,0,59,1,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,130,0,2,0,0,0,0,0,60,1,0,0,255,255,255,
255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,137,0,2,0,0,0,0,0,62,1,0,0,2,0,2,0,5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,1,0,150,0,2,0,0,0,0,0,63,1,0,0,6,0,6,0,5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,1,0,161,0,2,0,0,0,0,0,64,1,0,0,255,255,255,255,3,0,0,0,0,0,0,0,51,0,0,0,0,0,0,0,26,0,1,0,183,0,2,0,0,0,0,0,65,1,0,0,2,0,2,0,3,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,37,0,1,0,192,0,2,0,0,0,0,0,66,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,2,0,0,0,206,0,2,0,0,0,0,0,67,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,
0,2,0,0,0,216,0,2,0,0,0,0,0,68,1,0,0,255,255,1,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,25,0,0,0,12,9,2,0,0,0,0,0,69,1,0,0,255,255,1,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,0,0,0,227,0,2,0,0,0,0,0,74,1,0,0,255,255,255,255,18,0,0,0,0,0,0,0,38,0,0,0,0,0,0,0,49,0,1,1,242,0,2,0,84,0,0,0,76,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,0,0,59,20,2,0,0,0,0,0,77,1,0,0,255,255,255,255,2,0,0,0,0,0,0,0,27,0,0,0,0,0,0,0,46,0,1,1,249,0,2,0,0,0,0,0,78,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,1,0,2,1,2,
0,0,0,0,0,80,1,0,0,2,0,2,0,3,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,65,0,0,0,15,1,2,0,0,0,0,0,81,1,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,24,1,2,0,0,0,0,0,82,1,0,0,255,255,255,255,3,0,0,0,0,0,0,0,30,0,0,0,0,0,0,0,31,0,0,1,38,1,2,0,0,0,0,0,83,1,0,0,255,255,255,255,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,32,0,0,0,51,1,2,0,0,0,0,0,84,1,0,0,254,255,255,255,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,33,0,1,0,64,1,2,0,0,0,0,0,85,1,0,0,254,255,255,255,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,34,0,1,0,80,1,2,0,0,0,0,
0,87,1,0,0,255,255,253,255,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,65,0,0,1,96,1,2,0,0,0,0,0,88,1,0,0,1,0,1,0,9,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,65,0,0,0,105,1,2,0,0,0,0,0,88,1,0,0,1,0,1,0,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,65,0,0,0,105,1,2,0,0,0,0,0,89,1,0,0,1,0,1,0,9,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,65,0,0,0,120,1,2,0,0,0,0,0,17,2,0,0,3,0,3,0,5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,0,0,135,1,2,0,0,0,0,0,18,2,0,0,2,0,2,0,3,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,39,0,0,0,153,1,2,0,0,0,0,0,19,2,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,
0,0,0,0,0,0,0,40,0,0,0,170,1,2,0,0,0,0,0,20,2,0,0,6,0,6,0,5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,41,0,1,0,187,1,2,0,0,0,0,0,188,2,0,0,253,255,253,255,1,0,0,0,0,0,0,0,40,0,0,0,0,0,0,0,65,0,0,1,207,1,2,0,0,0,0,0,227,128,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,31,0,0,0,217,1,2,0,0,0,0,0,228,128,0,0,254,255,255,255,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,32,0,0,0,226,1,2,0,0,0,0,0,229,128,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,35,0,0,0,235,1,2,0,0,0,0,0,230,128,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,
36,0,0,0,246,1,2,0,0,0,0,0,20,130,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,65,0,1,0,0,2,2,0,0,0,0,0,21,130,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,65,0,1,0,15,2,2,0,0,0,0,0,22,130,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,31,2,2,0,0,0,0,0,23,130,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,45,2,2,0,0,0,0,0,24,130,0,0,1,0,1,0,11,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,65,0,1,0,62,2,2,0,0,0,0,0,25,130,0,0,16,0,16,0,11,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,1,0,83,2,2,0,
0,0,0,0,26,130,0,0,16,0,16,0,11,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,1,0,103,2,2,0,0,0,0,0,141,130,0,0,2,0,2,0,3,0,0,0,0,0,0,0,18,0,0,0,0,0,0,0,65,0,0,0,123,2,2,0,0,0,0,0,142,130,0,0,4,0,4,0,1,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,65,0,0,0,239,253,1,0,0,0,0,0,152,130,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,143,2,2,0,0,0,0,0,187,131,0,0,253,255,253,255,4,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,65,0,0,1,153,2,2,0,0,0,0,0,73,134,0,0,253,255,253,255,1,0,0,0,0,0,0,0,40,0,0,0,0,0,0,0,65,0,0,1,166,2,
2,0,0,0,0,0,105,135,0,0,1,0,1,0,18,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,65,0,0,0,176,2,2,0,100,0,0,0,115,135,0,0,253,255,253,255,7,0,0,0,0,0,0,0,40,0,0,0,0,0,0,0,65,0,0,1,190,2,2,0,0,0,0,0,37,136,0,0,1,0,1,0,18,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,65,0,0,0,202,2,2,0,0,0,0,0,92,136,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,6,0,0,0,65,0,1,0,215,2,2,0,0,0,0,0,93,136,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,65,0,1,0,229,2,2,0,0,0,0,0,94,136,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,6,0,0,0,65,0,1,0,243,2,2,0,0,0,
0,0,95,136,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,65,0,1,0,255,2,2,0,0,0,0,0,63,146,0,0,1,0,1,0,12,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,0,0,6,3,2,0,0,0,0,0,5,160,0,0,1,0,1,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,65,0,0,0,14,3,2,0,0,0,0,0,18,198,0,0,4,0,4,0,1,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,65,0,0,0,40,3,2,0,0,0,0,0,19,198,0,0,4,0,4,0,1,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,65,0,0,0,51,3,2,0,0,0,0,0,20,198,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,70,3,2,0,0,0,0,0,21,198,0,0,255,
255,255,255,1,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,1,1,88,3,2,0,0,0,0,0,22,198,0,0,255,255,255,255,1,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,0,1,109,3,2,0,0,0,0,0,23,198,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,0,0,123,3,2,0,0,0,0,0,24,198,0,0,255,255,255,255,3,0,0,0,0,0,0,0,30,0,0,0,0,0,0,0,65,0,0,1,133,3,2,0,0,0,0,0,25,198,0,0,2,0,2,0,3,0,0,0,0,0,0,0,18,0,0,0,0,0,0,0,65,0,0,0,152,3,2,0,0,0,0,0,26,198,0,0,255,255,255,255,5,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,172,3,2,0,0,0,0,0,27,198,0,0,255,
255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,183,3,2,0,0,0,0,0,28,198,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,200,3,2,0,0,0,0,0,29,198,0,0,255,255,255,255,4,0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,65,0,0,1,217,3,2,0,0,0,0,0,30,198,0,0,2,0,2,0,5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,0,0,228,3,2,0,0,0,0,0,92,198,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,0,0,241,3,2,0,0,0,0,0,31,198,0,0,2,0,2,0,5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,0,0,2,4,2,0,0,0,0,0,32,198,0,0,2,0,2,0,
5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,0,0,20,4,2,0,0,0,0,0,33,198,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,36,4,2,0,0,0,0,0,34,198,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,49,4,2,0,0,0,0,0,35,198,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,62,4,2,0,0,0,0,0,36,198,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,81,4,2,0,0,0,0,0,37,198,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,100,4,2,0,0,0,0,0,38,198,
0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,117,4,2,0,0,0,0,0,39,198,0,0,255,255,255,255,5,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,134,4,2,0,0,0,0,0,40,198,0,0,255,255,255,255,5,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,148,4,2,0,0,0,0,0,41,198,0,0,2,0,2,0,5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,0,0,162,4,2,0,0,0,0,0,42,198,0,0,1,0,1,0,10,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,0,0,176,4,2,0,0,0,0,0,43,198,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,0,0,193,4,2,0,0,0,0,0,44,198,0,
0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,0,0,207,4,2,0,0,0,0,0,45,198,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,65,0,0,0,225,4,2,0,0,0,0,0,46,198,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,0,0,241,4,2,0,0,0,0,0,47,198,0,0,255,255,255,255,2,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,65,0,1,0,5,5,2,0,0,0,0,0,48,198,0,0,4,0,4,0,5,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,65,0,0,0,24,5,2,0,0,0,0,0,49,198,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,0,0,33,5,2,0,0,0,0,0,50,198,0,0,1,0,1,0,5,0,0,0,0,0,0,0,
11,0,0,0,0,0,0,0,65,0,0,0,50,5,2,0,0,0,0,0,51,198,0,0,1,0,1,0,5,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,65,0,0,0,68,5,2,0,0,0,0,0,52,198,0,0,255,255,255,255,1,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,0,1,80,5,2,0,0,0,0,0,53,198,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,0,0,95,5,2,0,0,0,0,0,90,198,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,0,0,111,5,2,0,0,0,0,0,91,198,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,0,0,134,5,2,0,0,0,0,0,93,198,0,0,16,0,16,0,1,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,65,0,0,
0,157,5,2,0,0,0,0,0,139,198,0,0,255,255,255,255,1,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,1,1,173,5,2,0,0,0,0,0,140,198,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,0,1,193,5,2,0,0,0,0,0,141,198,0,0,4,0,4,0,4,0,0,0,0,0,0,0,20,0,0,0,0,0,0,0,65,0,0,0,213,5,2,0,0,0,0,0,142,198,0,0,255,255,255,255,4,0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,65,0,0,1,224,5,2,0,0,0,0,0,143,198,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,0,1,236,5,2,0,0,0,0,0,144,198,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,
0,0,0,0,0,0,65,0,0,1,253,5,2,0,0,0,0,0,145,198,0,0,255,255,255,255,7,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,65,0,0,1,20,6,2,0,0,0,0,0,146,198,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,38,6,2,0,0,0,0,0,27,0,1,0,0,0,0,0,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,62,6,2,0,0,0,0,0,90,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,65,0,0,0,72,6,2,0,0,0,0,0,144,1,0,0,1,0,1,0,18,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,65,0,0,0,80,6,2,0,0,0,0,0,145,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,65,0,0,0,100,
6,2,0,0,0,0,0,146,1,0,0,1,0,1,0,1,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,65,0,0,0,112,6,2,0,0,0,0,0,147,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,65,0,0,0,123,6,2,0,0,0,0,0,148,1,0,0,4,0,4,0,1,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,65,0,0,0,137,6,2,0,0,0,0,0,149,1,0,0,1,0,1,0,1,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,65,0,0,0,149,6,2,0,0,0,0,0,177,1,0,0,255,255,255,255,10,0,0,0,0,0,0,0,36,0,0,0,0,0,0,0,65,0,0,1,160,6,2,0,0,0,0,0,178,1,0,0,255,255,255,255,3,0,0,0,0,0,0,0,30,0,0,0,0,0,0,0,65,0,0,1,167,6,2,0,0,0,0,0,179,1,
0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,65,0,0,0,182,6,2,0,0,0,0,0,47,2,0,0,255,255,255,255,4,0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,65,0,0,1,193,6,2,0,0,0,0,0,172,135,0,0,2,0,2,0,4,0,0,0,0,0,0,0,20,0,0,0,0,0,0,0,65,0,0,0,208,6,2,0,0,0,0,0,0,0,0,0,139,108,79,64,134,201,196,191,128,72,255,190,126,29,120,191,197,32,240,63,195,100,42,61,211,188,99,61,96,229,80,190,199,75,135,63,0,0,200,66,0,0,200,66,0,0,200,66,255,0,0,0,255,0,0,0,255,0,0,0,0,0,128,63,0,0,128,63,0,0,128,63,154,153,25,64,154,153,25,64,154,
153,25,64,0,0,0,0,1,0,0,0,2,0,0,0,135,22,153,62,162,69,22,63,213,120,233,61,0,0,0,0,0,0,0,0,0,0,0,0,101,44,2,0,1,0,0,0,1,0,0,0,106,44,2,0,5,0,0,0,2,0,0,0,110,44,2,0,5,128,0,0,3,0,0,0,119,44,2,0,41,128,0,0,4,0,0,0,131,44,2,0,254,127,0,0,5,0,0,0,136,44,2,0,7,0,0,0,6,0,0,0,141,44,2,0,6,0,0,0,7,0,0,0,156,44,2,0,2,0,0,0,8,0,0,0,166,44,2,0,3,128,0,0,9,0,0,0,178,44,2,0,3,0,0,0,10,0,0,0,192,44,2,0,4,0,0,0,11,0,0,0,206,44,2,0,101,135,0,0,12,0,0,0,215,44,2,0,178,128,0,0,13,0,0,0,223,44,2,0,8,0,0,0,13,0,0,0,
236,44,2,0,141,128,0,0,14,0,0,0,245,44,2,0,116,135,0,0,15,0,0,0,252,44,2,0,117,135,0,0,15,0,0,0,5,45,2,0,109,136,0,0,12,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,36,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,6,0,0,0,73,0,0,0,3,50,2,0,0,0,0,0,37,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,6,0,0,0,73,0,0,0,245,49,2,0,0,0,0,0,0,0,0,0,1,0,0,0,3,0,0,0,7,0,0,0,15,0,0,0,31,0,0,0,63,0,0,0,127,0,0,0,255,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,168,52,2,0,0,0,0,0,4,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0,0,0,0,0,
0,0,0,0,0,0,176,52,2,0,0,0,0,0,70,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,6,0,0,0,66,0,1,0,188,52,2,0,0,0,0,0,71,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,4,0,0,0,67,0,1,0,200,52,2,0,0,0,0,0,72,1,0,0,1,0,1,0,4,0,0,0,0,0,0,0,6,0,0,0,6,0,0,0,68,0,1,0,213,52,2,0,0,0,0,0,12,7,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,1,4,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,
0,3,1,0,0,0,0,0,0,5,6,0,0,2,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,1,4,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,5,7,0,0,3,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,1,4,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,
0,0,1,0,0,0,3,1,0,0,0,0,0,0,4,6,0,0,2,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,1,4,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,6,7,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,1,4,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,
0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,5,6,0,0,2,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,1,4,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,4,7,0,0,3,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,1,4,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,
3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,4,6,0,0,2,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,1,4,0,0,0,0,0,0,3,1,0,0,0,0,0,0,5,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,2,3,0,0,0,0,0,0,3,1,0,0,0,0,0,0,4,3,0,0,1,0,0,0,3,1,0,0,0,0,0,0,12,11,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,
0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,
0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,5,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,192,4,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,
7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,192,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,
9,0,0,192,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17],"i8",4,ra.GLOBAL_BASE);vc([9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,11,0,0,0,7,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,
0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,
7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,64,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,64,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,
0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,
4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,
0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,
0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,0,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,0,5,0,0,7,4,0,0,6,0,0,0,7,
6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,
0,0,0,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,0,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,
0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,11,0,0,64,7,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,
0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,
7,4,0,0,3,0,0,0,9,9,0,0,192,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,128,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,
7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,
7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,
0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,
0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,5,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,192,4,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,
0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,192,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,
0,9,9,0,0,192,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,64,8,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,
7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,
5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,64,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,64,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,
30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,
0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,
0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,
9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,0,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,0,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,
0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,0,4,0,0,7,4,0,0,
6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,0,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,
0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,64,9,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,
0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,
9,0,0,192,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,128,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,
8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,
4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,
0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,
0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,5,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,192,4,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,
0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,192,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,192,2,0,
0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,192,7,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,
7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,
4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,64,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,64,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,
3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,
0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,
0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,
7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,0,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,0,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,
0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,0,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,
31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,0,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17],"i8",4,ra.GLOBAL_BASE+
10240);vc([9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,11,0,0,128,7,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,
0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,
0,0,0,9,9,0,0,192,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,128,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,
0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,
0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,
0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,
8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,5,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,192,4,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,
0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,192,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,
0,192,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,192,8,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,
0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,
11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,64,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,64,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,
0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,
0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,
7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,
0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,0,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,0,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,
0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,0,4,0,0,7,4,0,0,6,0,
0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,0,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,
9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,192,9,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,
8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,
0,192,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,128,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,
0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,
0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,12,11,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,
28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,
0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,5,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,192,4,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,
0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,192,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,192,2,0,
0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,11,0,0,0,7,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,
5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,
0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,64,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,64,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,
0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,
0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,
0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,
5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,0,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,0,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,
192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,0,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,
0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,0,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,
7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,11,0,0,64,7,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,
6,0,0,16,0,0,0,9,9,0,0,128,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,6,0,0,7,4,0,
0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,128,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,
3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,
7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,
0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,
0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,5,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,192,4,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,
7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,192,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,192,2,0,0,7,4,0,0,6,0,0,0,7,8,
0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17],"i8",4,ra.GLOBAL_BASE+20480);vc([9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,128,8,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,
0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,
0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,64,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,64,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,
4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,
0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,
0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,
0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,0,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,0,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,
9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,0,4,0,0,7,4,0,0,6,0,0,0,7,
8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,0,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,
0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,128,9,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,
40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,
6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,128,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,
0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,
0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,
7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,
0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,5,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,192,4,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,
0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,192,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,192,2,0,0,7,4,0,0,
6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,0,8,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,
0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,
0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,64,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,64,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,
0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,
0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,
2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,
0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,0,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,0,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,
9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,0,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,
0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,0,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,
0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,11,0,0,128,7,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,
0,0,0,9,9,0,0,128,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,6,0,0,7,4,0,0,5,0,0,
0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,128,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,
7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,
7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,
0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,
0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,5,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,192,4,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,
49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,192,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,192,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,
0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,0,9,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,
0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,
7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,64,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,64,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,
0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,64,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,
3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,
0,0,0,0,0,0,0,0,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,39,0,0,0,7,6,0,0,16,0,0,0,9,8,0,0,64,2,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,55,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,
0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,45,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,53,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,192,1,0,0,7,4,0,0,6,0,0,0,7,8,0,0,35,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,51,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,63,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,0,6,0,0,7,4,0,0,5,0,0,0,7,8,0,0,43,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,0,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,
7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,29,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,33,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,49,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,61,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,47,0,0,0,7,4,0,0,3,0,0,0,7,8,0,0,59,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,41,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,0,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,31,0,0,0,7,5,0,0,8,0,0,0,7,8,
0,0,57,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,9,0,0,0,3,0,0,7,4,0,0,6,0,0,0,7,8,0,0,37,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,64,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17],"i8",4,ra.GLOBAL_BASE+30720);vc([9,7,0,0,0,1,0,
0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,11,12,0,0,0,10,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,7,0,0,20,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,24,0,0,0,7,6,0,0,14,0,0,0,7,7,0,0,28,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,23,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,27,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,40,0,0,0,
7,6,0,0,16,0,0,0,9,9,0,0,128,3,0,0,7,4,0,0,6,0,0,0,7,7,0,0,19,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,56,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,46,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,54,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,0,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,36,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,52,0,0,0,7,6,0,0,15,0,0,0,7,8,0,0,0,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,9,9,0,0,192,6,0,0,7,4,
0,0,5,0,0,0,7,8,0,0,44,0,0,0,7,6,0,0,17,0,0,0,9,9,0,0,128,5,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,30,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,6,0,0,12,0,0,0,7,5,0,0,9,0,0,0,9,6,0,0,128,6,0,0,7,4,0,0,6,0,0,0,7,8,0,0,34,0,0,0,9,5,0,0,128,0,0,0,7,8,0,0,50,0,0,0,7,6,0,0,14,0,0,0,7,8,0,0,62,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,8,0,0,48,0,0,0,7,4,0,
0,3,0,0,0,7,8,0,0,60,0,0,0,7,4,0,0,5,0,0,0,7,8,0,0,42,0,0,0,7,6,0,0,16,0,0,0,9,9,0,0,128,4,0,0,7,4,0,0,6,0,0,0,7,8,0,0,32,0,0,0,7,5,0,0,8,0,0,0,7,8,0,0,58,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,7,7,0,0,22,0,0,0,7,4,0,0,3,0,0,0,7,5,0,0,11,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,26,0,0,0,7,5,0,0,9,0,0,0,9,8,0,0,128,2,0,0,7,4,0,0,6,0,0,0,7,8,0,0,38,0,0,0,9,5,0,0,128,0,0,0,7,7,0,0,25,0,0,0,7,6,0,0,15,0,0,0,9,8,0,0,128,1,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,
0,7,0,0,0,7,6,0,0,13,0,0,0,7,4,0,0,3,0,0,0,7,7,0,0,18,0,0,0,7,4,0,0,5,0,0,0,7,7,0,0,21,0,0,0,7,6,0,0,17,0,0,0,9,7,0,0,0,1,0,0,7,4,0,0,6,0,0,0,7,6,0,0,1,0,0,0,7,5,0,0,8,0,0,0,9,6,0,0,192,0,0,0,9,5,0,0,64,0,0,0,7,5,0,0,10,0,0,0,7,4,0,0,4,0,0,0,7,4,0,0,2,0,0,0,7,4,0,0,7,0,0,0,12,11,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,
0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,18,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,
5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,17,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,
0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,0,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,
0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,23,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,
0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,20,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,25,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,
0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,
2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,
0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,128,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,56,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,30,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,64,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,
8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,57,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,
2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,21,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,54,0,0,0,8,2,0,0,3,0,0,0,8,3,
0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,
3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,
8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,
0,0,2,0,0,0,8,12,0,0,52,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,
0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,48,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,
3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,64,8,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,
0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,44,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,36,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,
0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,128,1,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,
0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,28,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,
0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,60,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,
2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,40,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,
0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,64,9,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,16,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,10,0,0,64,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,
8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,
0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,
1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,18,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,17,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,
7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3],"i8",4,ra.GLOBAL_BASE+40960);vc([8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,192,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,
0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,50,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,
5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,34,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,128,6,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,
0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,26,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,128,5,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,
0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,32,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,
0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,128,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,
0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,61,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,
3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,42,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,0,4,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,
0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,
0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,
2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,
0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,0,3,0,0,8,2,0,0,
3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,62,
0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,11,12,0,0,192,8,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,
0,8,2,0,0,2,0,0,0,8,12,0,0,46,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,38,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,0,2,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,
2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,
0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,
0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,19,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,
0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,24,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,
0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,22,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,192,9,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,
8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,16,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,
2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,10,0,0,64,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,
0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,
3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,12,11,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,
0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,
0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,18,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,
8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,17,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,0,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,23,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,
0,20,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,25,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,
2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,
0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,192,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,0,5,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,
0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,31,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,
0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3],"i8",4,ra.GLOBAL_BASE+51200);vc([8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,64,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,58,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,21,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,128,3,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,
0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,
0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,
0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,128,2,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,
0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,49,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,
0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,128,8,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,45,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,37,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,
12,0,0,192,1,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,
0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,
4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,29,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,0,6,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,
8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,41,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,
2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,128,9,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,16,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,10,0,0,64,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,
0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,
0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,
0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,18,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,17,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,
0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,0,8,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,51,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,35,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,
0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,64,1,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,
0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,
0,0,0,8,12,0,0,27,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,59,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,
0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,33,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,
0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,128,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,0,1,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,
8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,43,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,128,4,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,
8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,
0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,
3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,55,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,63,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,
8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3],"i8",4,ra.GLOBAL_BASE+61440);vc([8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,0,9,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,
0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,47,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,39,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,53,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,
0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,
0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,
2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,
0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,19,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,
2,0,0,0,8,11,0,0,24,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,
0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,22,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,0,10,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,16,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,
8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,10,0,0,64,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,
2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,
0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,12,11,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,
3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,18,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,17,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,
8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,0,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,23,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,20,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,25,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,
0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,
0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,
0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,128,0,0,0,8,2,0,0,3,0,0,
0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,56,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,30,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,
0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,64,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,
0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,57,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,
4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,21,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,54,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,
0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,
4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,
0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,52,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,
1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,48,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,
0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,64,8,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,44,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,36,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,128,1,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,
0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,
0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,
0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,28,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,60,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,
0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,40,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,
0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3],"i8",4,ra.GLOBAL_BASE+71680);vc([8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,
0,0,64,9,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,
2,0,0,0,8,10,0,0,16,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,
0,0,0,8,2,0,0,2,0,0,0,10,10,0,0,64,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,
0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,18,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,
0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,17,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,192,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,50,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,34,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,192,6,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,
0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,
0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,26,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,
6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,192,5,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,32,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,
0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,128,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,
0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,61,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,42,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,64,4,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,
2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,
0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,
0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,64,3,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,62,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,
0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,192,8,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,
0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,46,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,38,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,64,2,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,
0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,
2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,
0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,19,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,24,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,
0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,22,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,192,9,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,
8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,16,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,
2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,10,0,0,64,0,0,0,8,2,0,0,3,0,0,0,8,3,
0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,
3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,12,11,0,0,0,
0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,
2,0,0,2,0,0,0,8,10,0,0,18,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,
0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,17,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3],"i8",4,ra.GLOBAL_BASE+81920);vc([8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,
0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,0,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,
0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,23,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,20,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,
0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,25,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,
0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,
2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,192,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,
4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,64,5,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,
0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,31,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,
0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,64,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,
0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,58,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,21,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,
8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,192,3,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,
0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,192,2,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,
0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,49,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,128,8,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,45,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,
4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,37,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,192,1,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,
2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,
0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,
0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,29,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,64,6,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,
0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,41,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,
8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,128,9,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,16,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,
2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,10,0,0,64,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,
0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,
0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,18,0,0,0,8,
2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,
0,17,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,
0,0,0,11,12,0,0,0,8,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,
0,0,8,2,0,0,2,0,0,0,8,12,0,0,51,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,35,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,
0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,64,1,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,
0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,27,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,
0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,59,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,33,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3],"i8",4,ra.GLOBAL_BASE+92160);vc([8,3,0,0,4,0,0,0,8,
2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,11,0,0,128,7,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,
3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,12,0,0,0,1,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,43,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,
0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,13,0,0,192,4,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,
0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,
0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,9,0,0,15,0,0,0,8,2,0,0,3,0,0,0,
8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,55,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,
2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,63,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,
0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,0,9,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,
2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,47,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,
0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,39,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,12,0,0,53,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,
8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,
0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,13,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,
2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,19,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,24,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,
0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,11,0,0,22,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,
0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,11,12,0,0,0,10,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,9,0,0,
0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,10,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,16,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,
8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,10,0,0,0,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,10,10,0,0,64,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,
2,0,0,2,0,0,0,8,6,0,0,9,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,11,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,8,0,0,14,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,
0,4,0,0,0,8,2,0,0,2,0,0,0,8,6,0,0,8,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,7,0,0,12,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,6,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,8,5,0,0,7,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,1,0,0,0,8,2,0,0,2,0,0,0,8,4,0,0,5,0,0,0,8,2,0,0,3,0,0,0,8,3,0,0,4,0,0,0,8,2,0,0,2,0,0,0,91,1,0,0,253,255,253,255,7,0,0,0,0,0,0,0,40,0,0,0,40,0,0,0,66,0,0,1,140,60,2,0,0,0,0,0,1,0,
1,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,1,0,39,96,2,0,0,0,0,0,2,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,39,96,2,0,0,0,0,0,3,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,39,96,2,0,0,0,0,0,95,155,125,62,4,0,0,0,52,161,121,62,6,0,4,0,3,124,119,62,7,0,10,0,62,149,115,62,9,0,17,0,88,145,113,62,10,0,26,0,132,185,109,62,12,0,36,0,27,213,105,62,14,0,48,0,112,176,103,62,15,0,62,0,57,181,99,62,17,0,77,0,41,179,97,62,18,0,94,0,240,220,91,62,21,0,112,0,179,209,89,62,22,0,133,
0,63,199,87,62,23,0,155,0,59,229,81,62,26,0,178,0,144,219,79,62,27,0,204,0,226,6,76,62,29,0,231,0,181,55,72,62,31,0,4,1,152,52,70,62,32,0,35,1,97,111,66,62,34,0,67,1,104,175,62,62,36,0,101,1,104,175,62,62,36,0,137,1,102,249,58,62,38,0,173,1,144,76,55,62,40,0,211,1,92,173,51,62,42,0,251,1,8,33,48,62,44,0,37,2,8,33,48,62,44,0,81,2,160,168,44,62,46,0,125,2,160,168,44,62,46,0,171,2,52,128,39,62,49,0,217,2,12,115,34,62,52,0,10,3,12,115,34,62,52,0,62,3,12,115,34,62,52,0,114,3,174,129,29,62,55,0,166,3,174,
129,29,62,55,0,221,3,226,172,24,62,58,0,20,4,226,172,24,62,58,0,78,4,2,44,18,62,62,0,136,4,2,44,18,62,62,0,198,4,2,44,18,62,62,0,4,5,167,150,13,62,65,0,66,5,167,150,13,62,65,0,131,5,167,150,13,62,65,0,196,5,134,86,7,62,69,0,5,6,134,86,7,62,69,0,74,6,159,59,1,62,73,0,143,6,159,59,1,62,73,0,216,6,159,59,1,62,73,0,33,7,80,138,246,61,77,0,106,7,80,138,246,61,77,0,183,7,80,138,246,61,77,0,4,8,80,138,246,61,77,0,81,8,159,88,231,61,82,0,158,8,159,88,231,61,82,0,240,8,159,88,231,61,82,0,66,9,191,14,220,61,
86,0,148,9,191,14,220,61,86,0,234,9,191,14,220,61,86,0,64,10,191,14,220,61,86,0,150,10,161,128,205,61,91,0,236,10,161,128,205,61,91,0,71,11,161,128,205,61,91,0,162,11,108,209,194,61,95,0,253,11,108,209,194,61,95,0,92,12,108,209,194,61,95,0,187,12,108,209,194,61,95,0,26,13,12,202,180,61,100,0,121,13,12,202,180,61,100,0,221,13,12,202,180,61,100,0,65,14,12,202,180,61,100,0,165,14,136,245,166,61,105,0,9,15,136,245,166,61,105,0,114,15,136,245,166,61,105,0,219,15,136,245,166,61,105,0,68,16,185,80,153,61,
110,0,173,16,185,80,153,61,110,0,27,17,185,80,153,61,110,0,137,17,185,80,153,61,110,0,247,17,161,219,139,61,115,0,101,18,161,219,139,61,115,0,216,18,161,219,139,61,115,0,75,19,161,219,139,61,115,0,190,19,144,50,130,61,119,0,49,20,144,50,130,61,119,0,168,20,144,50,130,61,119,0,31,21,144,50,130,61,119,0,150,21,120,94,106,61,124,0,13,22,120,94,106,61,124,0,137,22,120,94,106,61,124,0,5,23,120,94,106,61,124,0,129,23,166,213,80,61,129,0,253,23,166,213,80,61,129,0,126,24,166,213,80,61,129,0,255,24,166,213,
80,61,129,0,128,25,166,213,80,61,129,0,1,26,18,190,55,61,134,0,130,26,18,190,55,61,134,0,8,27,18,190,55,61,134,0,142,27,18,190,55,61,134,0,20,28,199,45,38,61,138,0,154,28,199,45,38,61,138,0,36,29,199,45,38,61,138,0,174,29,199,45,38,61,138,0,56,30,52,216,20,61,142,0,194,30,52,216,20,61,142,0,80,31,52,216,20,61,142,0,222,31,52,216,20,61,142,0,108,32,47,164,3,61,146,0,250,32,47,164,3,61,146,0,140,33,47,164,3,61,146,0,30,34,47,164,3,61,146,0,176,34,27,241,228,60,150,0,66,35,27,241,228,60,150,0,216,35,
27,241,228,60,150,0,110,36,75,120,194,60,154,0,4,37,75,120,194,60,154,0,158,37,75,120,194,60,154,0,56,38,75,120,194,60,154,0,210,38,218,198,159,60,158,0,108,39,218,198,159,60,158,0,10,40,218,198,159,60,158,0,168,40,65,17,139,60,161,0,70,41,65,17,139,60,161,0,231,41,65,17,139,60,161,0,136,42,65,17,139,60,161,0,41,43,207,19,79,60,165,0,202,43,207,19,79,60,165,0,111,44,207,19,79,60,165,0,20,45,75,177,35,60,168,0,185,45,75,177,35,60,168,0,97,46,75,177,35,60,168,0,9,47,216,183,19,60,170,0,177,47,216,183,
19,60,170,0,91,48,216,183,19,60,170,0,5,49,250,183,203,59,173,0,175,49,250,183,203,59,173,0,92,50,188,4,167,59,175,0,9,51,188,4,167,59,175,0,184,51,188,4,167,59,175,0,103,52,18,23,128,59,177,0,22,53,18,23,128,59,177,0,199,53,175,90,25,59,177,0,120,54,197,144,28,59,170,0,41,55,34,252,139,58,164,0,211,55,122,169,216,58,157,0,119,56,14,245,59,58,150,0,20,57,218,140,211,58,143,0,170,57,201,142,141,57,136,0,57,58,97,193,253,57,129,0,193,58,138,146,144,58,123,0,66,59,155,202,162,58,115,0,189,59,170,182,
155,58,109,0,48,60,136,131,132,58,103,0,157,60,47,220,57,58,97,0,4,61,137,207,157,57,89,0,101,61,193,85,30,59,82,0,190,61,187,14,85,59,76,0,16,62,216,186,84,59,69,0,92,62,58,177,135,59,62,0,161,62,69,101,195,59,55,0,223,62,116,209,16,60,47,0,22,63,64,222,43,60,40,0,69,63,0,55,139,60,31,0,109,63,133,208,193,60,21,0,140,63,24,0,1,0,0,0,0,0,3,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,1,0,173,64,2,0,0,0,0,0,25,0,1,0,0,0,0,0,3,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,1,0,187,64,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,2,0,0,1,0,1,0,16,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,66,0,1,0,190,81,2,0,0,0,0,0,2,2,0,0,1,0,1,0,16,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,67,0,1,0,212,81,2,0,0,0,0,0,7,2,0,0,253,255,253,255,16,0,0,0,0,0,0,0,46,0,0,0,0,0,0,0,68,0,0,
1,240,81,2,0,0,0,0,0,8,2,0,0,253,255,253,255,16,0,0,0,0,0,0,0,46,0,0,0,0,0,0,0,69,0,0,1,252,81,2,0,0,0,0,0,9,2,0,0,253,255,253,255,16,0,0,0,0,0,0,0,46,0,0,0,0,0,0,0,70,0,0,1,9,82,2,0,0,0,0,0,0,2,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,71,0,0,0,22,82,2,0,0,0,0,0,3,2,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,72,0,0,0,31,82,2,0,0,0,0,0,13,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,39,96,2,0,0,0,0,0,22,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,39,96,2,0,0,0,0,0,0,0,0,0,
0,0,0,0,0,0,0,0,61,1,0,0,1,0,1,0,3,0,0,0,0,0,0,0,4,0,0,0,4,0,0,0,66,0,0,0,166,88,2,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,255,255,255,255,0,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,0,0,0,0,253,255,255,255,254,255,255,255,255,255,255,255,21,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,1,0,39,96,2,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,4,0,4,0,8,0,4,0,17,0,0,0,4,0,5,0,16,0,8,0,17,0,0,0,4,0,6,0,32,0,32,0,17,0,0,0,4,0,4,0,16,0,16,0,18,0,0,0,8,0,16,0,32,0,32,0,18,0,0,0,8,0,16,0,128,0,128,0,18,0,0,0,8,0,32,0,128,0,0,
1,18,0,0,0,32,0,128,0,2,1,0,4,18,0,0,0,32,0,2,1,2,1,0,16,18,0,0,0,48,242,1,0,88,174,1,0,1,1,0,0,30,1,0,0,15,0,0,0,176,246,1,0,64,175,1,0,0,0,0,0,30,0,0,0,15,0,0,0,0,0,0,0,48,176,1,0,0,0,0,0,19,0,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,3,0,0,0,3,0,0,0,3,0,0,0,4,0,0,0,4,0,0,0,4,0,0,0,4,0,0,0,5,0,0,0,5,0,0,0,5,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,5,0,0,0,6,0,0,0,7,0,0,
0,8,0,0,0,10,0,0,0,12,0,0,0,14,0,0,0,16,0,0,0,20,0,0,0,24,0,0,0,28,0,0,0,32,0,0,0,40,0,0,0,48,0,0,0,56,0,0,0,64,0,0,0,80,0,0,0,96,0,0,0,112,0,0,0,128,0,0,0,160,0,0,0,192,0,0,0,224,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,2,0,0,0,3,0,0,0,3,0,0,0,4,0,0,0,4,0,0,0,5,0,0,0,5,0,0,0,6,0,0,0,6,0,0,0,7,0,0,0,7,0,0,0,8,0,0,0,8,0,0,0,9,0,0,0,9,0,0,0,10,0,0,0,10,0,0,0,11,0,0,0,11,0,0,0,12,0,0,0,12,0,0,0,13,0,0,0,13,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,6,0,0,0,8,0,0,0,12,
0,0,0,16,0,0,0,24,0,0,0,32,0,0,0,48,0,0,0,64,0,0,0,96,0,0,0,128,0,0,0,192,0,0,0,0,1,0,0,128,1,0,0,0,2,0,0,0,3,0,0,0,4,0,0,0,6,0,0,0,8,0,0,0,12,0,0,0,16,0,0,0,24,0,0,0,32,0,0,0,48,0,0,0,64,0,0,0,96,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,3,0,0,0,7,0,0,0,12,96,2,0,28,96,2,0,39,96,2,0,40,96,2,0,51,96,2,0,64,96,2,0,75,96,2,0,95,96,2,0,108,96,2,0,39,96,2,0,0,0,0,0,150,48,7,119,44,97,14,238,186,81,9,153,
25,196,109,7,143,244,106,112,53,165,99,233,163,149,100,158,50,136,219,14,164,184,220,121,30,233,213,224,136,217,210,151,43,76,182,9,189,124,177,126,7,45,184,231,145,29,191,144,100,16,183,29,242,32,176,106,72,113,185,243,222,65,190,132,125,212,218,26,235,228,221,109,81,181,212,244,199,133,211,131,86,152,108,19,192,168,107,100,122,249,98,253,236,201,101,138,79,92,1,20,217,108,6,99,99,61,15,250,245,13,8,141,200,32,110,59,94,16,105,76,228,65,96,213,114,113,103,162,209,228,3,60,71,212,4,75,253,133,13,
210,107,181,10,165,250,168,181,53,108,152,178,66,214,201,187,219,64,249,188,172,227,108,216,50,117,92,223,69,207,13,214,220,89,61,209,171,172,48,217,38,58,0,222,81,128,81,215,200,22,97,208,191,181,244,180,33,35,196,179,86,153,149,186,207,15,165,189,184,158,184,2,40,8,136,5,95,178,217,12,198,36,233,11,177,135,124,111,47,17,76,104,88,171,29,97,193,61,45,102,182,144,65,220,118,6,113,219,1,188,32,210,152,42,16,213,239,137,133,177,113,31,181,182,6,165,228,191,159,51,212,184,232,162,201,7,120,52,249,0,
15,142,168,9,150,24,152,14,225,187,13,106,127,45,61,109,8,151,108,100,145,1,92,99,230,244,81,107,107,98,97,108,28,216,48,101,133,78,0,98,242,237,149,6,108,123,165,1,27,193,244,8,130,87,196,15,245,198,217,176,101,80,233,183,18,234,184,190,139,124,136,185,252,223,29,221,98,73,45,218,21,243,124,211,140,101,76,212,251,88,97,178,77,206,81,181,58,116,0,188,163,226,48,187,212,65,165,223,74,215,149,216,61,109,196,209,164,251,244,214,211,106,233,105,67,252,217,110,52,70,136,103,173,208,184,96,218,115,45,4,
68,229,29,3,51,95,76,10,170,201,124,13,221,60,113,5,80,170,65,2,39,16,16,11,190,134,32,12,201,37,181,104,87,179,133,111,32,9,212,102,185,159,228,97,206,14,249,222,94,152,201,217,41,34,152,208,176,180,168,215,199,23,61,179,89,129,13,180,46,59,92,189,183,173,108,186,192,32,131,184,237,182,179,191,154,12,226,182,3,154,210,177,116,57,71,213,234,175,119,210,157,21,38,219,4,131,22,220,115,18,11,99,227,132,59,100,148,62,106,109,13,168,90,106,122,11,207,14,228,157,255,9,147,39,174,0,10,177,158,7,125,68,147,
15,240,210,163,8,135,104,242,1,30,254,194,6,105,93,87,98,247,203,103,101,128,113,54,108,25,231,6,107,110,118,27,212,254,224,43,211,137,90,122,218,16,204,74,221,103,111,223,185,249,249,239,190,142,67,190,183,23,213,142,176,96,232,163,214,214,126,147,209,161,196,194,216,56,82,242,223,79,241,103,187,209,103,87,188,166,221,6,181,63,75,54,178,72,218,43,13,216,76,27,10,175,246,74,3,54,96,122,4,65,195,239,96,223,85,223,103,168,239,142,110,49,121,190,105,70,140,179,97,203,26,131,102,188,160,210,111,37,54,
226,104,82,149,119,12,204,3,71,11,187,185,22,2,34,47,38,5,85,190,59,186,197,40,11,189,178,146,90,180,43,4,106,179,92,167,255,215,194,49,207,208,181,139,158,217,44,29,174,222,91,176,194,100,155,38,242,99,236,156,163,106,117,10,147,109,2,169,6,9,156,63,54,14,235,133,103,7,114,19,87,0,5,130,74,191,149,20,122,184,226,174,43,177,123,56,27,182,12,155,142,210,146,13,190,213,229,183,239,220,124,33,223,219,11,212,210,211,134,66,226,212,241,248,179,221,104,110,131,218,31,205,22,190,129,91,38,185,246,225,119,
176,111,119,71,183,24,230,90,8,136,112,106,15,255,202,59,6,102,92,11,1,17,255,158,101,143,105,174,98,248,211,255,107,97,69,207,108,22,120,226,10,160,238,210,13,215,84,131,4,78,194,179,3,57,97,38,103,167,247,22,96,208,77,71,105,73,219,119,110,62,74,106,209,174,220,90,214,217,102,11,223,64,240,59,216,55,83,174,188,169,197,158,187,222,127,207,178,71,233,255,181,48,28,242,189,189,138,194,186,202,48,147,179,83,166,163,180,36,5,54,208,186,147,6,215,205,41,87,222,84,191,103,217,35,46,122,102,179,184,74,
97,196,2,27,104,93,148,43,111,42,55,190,11,180,161,142,12,195,27,223,5,90,141,239,2,45,0,0,0,0,65,49,27,25,130,98,54,50,195,83,45,43,4,197,108,100,69,244,119,125,134,167,90,86,199,150,65,79,8,138,217,200,73,187,194,209,138,232,239,250,203,217,244,227,12,79,181,172,77,126,174,181,142,45,131,158,207,28,152,135,81,18,194,74,16,35,217,83,211,112,244,120,146,65,239,97,85,215,174,46,20,230,181,55,215,181,152,28,150,132,131,5,89,152,27,130,24,169,0,155,219,250,45,176,154,203,54,169,93,93,119,230,28,108,
108,255,223,63,65,212,158,14,90,205,162,36,132,149,227,21,159,140,32,70,178,167,97,119,169,190,166,225,232,241,231,208,243,232,36,131,222,195,101,178,197,218,170,174,93,93,235,159,70,68,40,204,107,111,105,253,112,118,174,107,49,57,239,90,42,32,44,9,7,11,109,56,28,18,243,54,70,223,178,7,93,198,113,84,112,237,48,101,107,244,247,243,42,187,182,194,49,162,117,145,28,137,52,160,7,144,251,188,159,23,186,141,132,14,121,222,169,37,56,239,178,60,255,121,243,115,190,72,232,106,125,27,197,65,60,42,222,88,5,
79,121,240,68,126,98,233,135,45,79,194,198,28,84,219,1,138,21,148,64,187,14,141,131,232,35,166,194,217,56,191,13,197,160,56,76,244,187,33,143,167,150,10,206,150,141,19,9,0,204,92,72,49,215,69,139,98,250,110,202,83,225,119,84,93,187,186,21,108,160,163,214,63,141,136,151,14,150,145,80,152,215,222,17,169,204,199,210,250,225,236,147,203,250,245,92,215,98,114,29,230,121,107,222,181,84,64,159,132,79,89,88,18,14,22,25,35,21,15,218,112,56,36,155,65,35,61,167,107,253,101,230,90,230,124,37,9,203,87,100,56,
208,78,163,174,145,1,226,159,138,24,33,204,167,51,96,253,188,42,175,225,36,173,238,208,63,180,45,131,18,159,108,178,9,134,171,36,72,201,234,21,83,208,41,70,126,251,104,119,101,226,246,121,63,47,183,72,36,54,116,27,9,29,53,42,18,4,242,188,83,75,179,141,72,82,112,222,101,121,49,239,126,96,254,243,230,231,191,194,253,254,124,145,208,213,61,160,203,204,250,54,138,131,187,7,145,154,120,84,188,177,57,101,167,168,75,152,131,59,10,169,152,34,201,250,181,9,136,203,174,16,79,93,239,95,14,108,244,70,205,63,
217,109,140,14,194,116,67,18,90,243,2,35,65,234,193,112,108,193,128,65,119,216,71,215,54,151,6,230,45,142,197,181,0,165,132,132,27,188,26,138,65,113,91,187,90,104,152,232,119,67,217,217,108,90,30,79,45,21,95,126,54,12,156,45,27,39,221,28,0,62,18,0,152,185,83,49,131,160,144,98,174,139,209,83,181,146,22,197,244,221,87,244,239,196,148,167,194,239,213,150,217,246,233,188,7,174,168,141,28,183,107,222,49,156,42,239,42,133,237,121,107,202,172,72,112,211,111,27,93,248,46,42,70,225,225,54,222,102,160,7,197,
127,99,84,232,84,34,101,243,77,229,243,178,2,164,194,169,27,103,145,132,48,38,160,159,41,184,174,197,228,249,159,222,253,58,204,243,214,123,253,232,207,188,107,169,128,253,90,178,153,62,9,159,178,127,56,132,171,176,36,28,44,241,21,7,53,50,70,42,30,115,119,49,7,180,225,112,72,245,208,107,81,54,131,70,122,119,178,93,99,78,215,250,203,15,230,225,210,204,181,204,249,141,132,215,224,74,18,150,175,11,35,141,182,200,112,160,157,137,65,187,132,70,93,35,3,7,108,56,26,196,63,21,49,133,14,14,40,66,152,79,103,
3,169,84,126,192,250,121,85,129,203,98,76,31,197,56,129,94,244,35,152,157,167,14,179,220,150,21,170,27,0,84,229,90,49,79,252,153,98,98,215,216,83,121,206,23,79,225,73],"i8",4,ra.GLOBAL_BASE+102400);vc([86,126,250,80,149,45,215,123,212,28,204,98,19,138,141,45,82,187,150,52,145,232,187,31,208,217,160,6,236,243,126,94,173,194,101,71,110,145,72,108,47,160,83,117,232,54,18,58,169,7,9,35,106,84,36,8,43,101,63,17,228,121,167,150,165,72,188,143,102,27,145,164,39,42,138,189,224,188,203,242,161,141,208,235,
98,222,253,192,35,239,230,217,189,225,188,20,252,208,167,13,63,131,138,38,126,178,145,63,185,36,208,112,248,21,203,105,59,70,230,66,122,119,253,91,181,107,101,220,244,90,126,197,55,9,83,238,118,56,72,247,177,174,9,184,240,159,18,161,51,204,63,138,114,253,36,147,0,0,0,0,55,106,194,1,110,212,132,3,89,190,70,2,220,168,9,7,235,194,203,6,178,124,141,4,133,22,79,5,184,81,19,14,143,59,209,15,214,133,151,13,225,239,85,12,100,249,26,9,83,147,216,8,10,45,158,10,61,71,92,11,112,163,38,28,71,201,228,29,30,119,
162,31,41,29,96,30,172,11,47,27,155,97,237,26,194,223,171,24,245,181,105,25,200,242,53,18,255,152,247,19,166,38,177,17,145,76,115,16,20,90,60,21,35,48,254,20,122,142,184,22,77,228,122,23,224,70,77,56,215,44,143,57,142,146,201,59,185,248,11,58,60,238,68,63,11,132,134,62,82,58,192,60,101,80,2,61,88,23,94,54,111,125,156,55,54,195,218,53,1,169,24,52,132,191,87,49,179,213,149,48,234,107,211,50,221,1,17,51,144,229,107,36,167,143,169,37,254,49,239,39,201,91,45,38,76,77,98,35,123,39,160,34,34,153,230,32,
21,243,36,33,40,180,120,42,31,222,186,43,70,96,252,41,113,10,62,40,244,28,113,45,195,118,179,44,154,200,245,46,173,162,55,47,192,141,154,112,247,231,88,113,174,89,30,115,153,51,220,114,28,37,147,119,43,79,81,118,114,241,23,116,69,155,213,117,120,220,137,126,79,182,75,127,22,8,13,125,33,98,207,124,164,116,128,121,147,30,66,120,202,160,4,122,253,202,198,123,176,46,188,108,135,68,126,109,222,250,56,111,233,144,250,110,108,134,181,107,91,236,119,106,2,82,49,104,53,56,243,105,8,127,175,98,63,21,109,99,
102,171,43,97,81,193,233,96,212,215,166,101,227,189,100,100,186,3,34,102,141,105,224,103,32,203,215,72,23,161,21,73,78,31,83,75,121,117,145,74,252,99,222,79,203,9,28,78,146,183,90,76,165,221,152,77,152,154,196,70,175,240,6,71,246,78,64,69,193,36,130,68,68,50,205,65,115,88,15,64,42,230,73,66,29,140,139,67,80,104,241,84,103,2,51,85,62,188,117,87,9,214,183,86,140,192,248,83,187,170,58,82,226,20,124,80,213,126,190,81,232,57,226,90,223,83,32,91,134,237,102,89,177,135,164,88,52,145,235,93,3,251,41,92,90,
69,111,94,109,47,173,95,128,27,53,225,183,113,247,224,238,207,177,226,217,165,115,227,92,179,60,230,107,217,254,231,50,103,184,229,5,13,122,228,56,74,38,239,15,32,228,238,86,158,162,236,97,244,96,237,228,226,47,232,211,136,237,233,138,54,171,235,189,92,105,234,240,184,19,253,199,210,209,252,158,108,151,254,169,6,85,255,44,16,26,250,27,122,216,251,66,196,158,249,117,174,92,248,72,233,0,243,127,131,194,242,38,61,132,240,17,87,70,241,148,65,9,244,163,43,203,245,250,149,141,247,205,255,79,246,96,93,120,
217,87,55,186,216,14,137,252,218,57,227,62,219,188,245,113,222,139,159,179,223,210,33,245,221,229,75,55,220,216,12,107,215,239,102,169,214,182,216,239,212,129,178,45,213,4,164,98,208,51,206,160,209,106,112,230,211,93,26,36,210,16,254,94,197,39,148,156,196,126,42,218,198,73,64,24,199,204,86,87,194,251,60,149,195,162,130,211,193,149,232,17,192,168,175,77,203,159,197,143,202,198,123,201,200,241,17,11,201,116,7,68,204,67,109,134,205,26,211,192,207,45,185,2,206,64,150,175,145,119,252,109,144,46,66,43,
146,25,40,233,147,156,62,166,150,171,84,100,151,242,234,34,149,197,128,224,148,248,199,188,159,207,173,126,158,150,19,56,156,161,121,250,157,36,111,181,152,19,5,119,153,74,187,49,155,125,209,243,154,48,53,137,141,7,95,75,140,94,225,13,142,105,139,207,143,236,157,128,138,219,247,66,139,130,73,4,137,181,35,198,136,136,100,154,131,191,14,88,130,230,176,30,128,209,218,220,129,84,204,147,132,99,166,81,133,58,24,23,135,13,114,213,134,160,208,226,169,151,186,32,168,206,4,102,170,249,110,164,171,124,120,
235,174,75,18,41,175,18,172,111,173,37,198,173,172,24,129,241,167,47,235,51,166,118,85,117,164,65,63,183,165,196,41,248,160,243,67,58,161,170,253,124,163,157,151,190,162,208,115,196,181,231,25,6,180,190,167,64,182,137,205,130,183,12,219,205,178,59,177,15,179,98,15,73,177,85,101,139,176,104,34,215,187,95,72,21,186,6,246,83,184,49,156,145,185,180,138,222,188,131,224,28,189,218,94,90,191,237,52,152,190,0,0,0,0,101,103,188,184,139,200,9,170,238,175,181,18,87,151,98,143,50,240,222,55,220,95,107,37,185,
56,215,157,239,40,180,197,138,79,8,125,100,224,189,111,1,135,1,215,184,191,214,74,221,216,106,242,51,119,223,224,86,16,99,88,159,87,25,80,250,48,165,232,20,159,16,250,113,248,172,66,200,192,123,223,173,167,199,103,67,8,114,117,38,111,206,205,112,127,173,149,21,24,17,45,251,183,164,63,158,208,24,135,39,232,207,26,66,143,115,162,172,32,198,176,201,71,122,8,62,175,50,160,91,200,142,24,181,103,59,10,208,0,135,178,105,56,80,47,12,95,236,151,226,240,89,133,135,151,229,61,209,135,134,101,180,224,58,221,
90,79,143,207,63,40,51,119,134,16,228,234,227,119,88,82,13,216,237,64,104,191,81,248,161,248,43,240,196,159,151,72,42,48,34,90,79,87,158,226,246,111,73,127,147,8,245,199,125,167,64,213,24,192,252,109,78,208,159,53,43,183,35,141,197,24,150,159,160,127,42,39,25,71,253,186,124,32,65,2,146,143,244,16,247,232,72,168,61,88,20,155,88,63,168,35,182,144,29,49,211,247,161,137,106,207,118,20,15,168,202,172,225,7,127,190,132,96,195,6,210,112,160,94,183,23,28,230,89,184,169,244,60,223,21,76,133,231,194,209,224,
128,126,105,14,47,203,123,107,72,119,195,162,15,13,203,199,104,177,115,41,199,4,97,76,160,184,217,245,152,111,68,144,255,211,252,126,80,102,238,27,55,218,86,77,39,185,14,40,64,5,182,198,239,176,164,163,136,12,28,26,176,219,129,127,215,103,57,145,120,210,43,244,31,110,147,3,247,38,59,102,144,154,131,136,63,47,145,237,88,147,41,84,96,68,180,49,7,248,12,223,168,77,30,186,207,241,166,236,223,146,254,137,184,46,70,103,23,155,84,2,112,39,236,187,72,240,113,222,47,76,201,48,128,249,219,85,231,69,99,156,
160,63,107,249,199,131,211,23,104,54,193,114,15,138,121,203,55,93,228,174,80,225,92,64,255,84,78,37,152,232,246,115,136,139,174,22,239,55,22,248,64,130,4,157,39,62,188,36,31,233,33,65,120,85,153,175,215,224,139,202,176,92,51,59,182,89,237,94,209,229,85,176,126,80,71,213,25,236,255,108,33,59,98,9,70,135,218,231,233,50,200,130,142,142,112,212,158,237,40,177,249,81,144,95,86,228,130,58,49,88,58,131,9,143,167,230,110,51,31,8,193,134,13,109,166,58,181,164,225,64,189,193,134,252,5,47,41,73,23,74,78,245,
175,243,118,34,50,150,17,158,138,120,190,43,152,29,217,151,32,75,201,244,120,46,174,72,192,192,1,253,210,165,102,65,106,28,94,150,247,121,57,42,79,151,150,159,93,242,241,35,229,5,25,107,77,96,126,215,245,142,209,98,231,235,182,222,95,82,142,9,194,55,233,181,122,217,70,0,104,188,33,188,208,234,49,223,136,143,86,99,48,97,249,214,34,4,158,106,154,189,166,189,7,216,193,1,191,54,110,180,173,83,9,8,21,154,78,114,29,255,41,206,165,17,134,123,183,116,225,199,15,205,217,16,146,168,190,172,42,70,17,25,56,35,
118,165,128,117,102,198,216,16,1,122,96,254,174,207,114,155,201,115,202,34,241,164,87,71,150,24,239,169,57,173,253,204,94,17,69,6,238,77,118,99,137,241,206,141,38,68,220,232,65,248,100,81,121,47,249,52,30,147,65,218,177,38,83,191,214,154,235,233,198,249,179,140,161,69,11,98,14,240,25,7,105,76,161,190,81,155,60,219,54,39,132,53,153,146,150,80,254,46,46,153,185,84,38,252,222,232,158,18,113,93,140,119,22,225,52,206,46,54,169,171,73,138,17,69,230,63,3,32,129,131,187,118,145,224,227,19,246,92,91,253,89,
233,73,152,62,85,241,33,6,130,108,68,97,62,212,170,206,139,198,207,169,55,126,56,65,127,214,93,38,195,110,179,137,118,124,214,238,202,196,111,214,29,89,10,177,161,225,228,30,20,243,129,121,168,75,215,105,203,19,178,14,119,171,92,161,194,185,57,198,126,1,128,254,169,156,229,153,21,36,11,54,160,54,110,81,28,142,167,22,102,134,194,113,218,62,44,222,111,44,73,185,211,148,240,129,4,9,149,230,184,177,123,73,13,163,30,46,177,27,72,62,210,67,45,89,110,251,195,246,219,233,166,145,103,81,31,169,176,204,122,
206,12,116,148,97,185,102,241,6,5,222,0,0,0,0,119,7,48,150,238,14,97,44,153,9,81,186,7,109,196,25,112,106,244,143,233,99,165,53,158,100,149,163,14,219,136,50,121,220,184,164,224,213,233,30,151,210,217,136,9,182,76,43,126,177,124,189,231,184,45,7,144,191,29,145,29,183,16,100,106,176,32,242,243,185,113,72,132,190,65,222,26,218,212,125,109,221,228,235,244,212,181,81,131,211,133,199,19,108,152,86,100,107,168,192,253,98,249,122,138,101,201,236,20,1,92,79,99,6,108,217,250,15,61,99,141,8,13,245,59,110,32,
200,76,105,16,94,213,96,65,228,162,103,113,114,60,3,228,209,75,4,212,71,210,13,133,253,165,10,181,107,53,181,168,250,66,178,152,108,219,187,201,214,172,188,249,64,50,216,108,227,69,223,92,117,220,214,13,207,171,209,61,89,38,217,48,172,81,222,0,58,200,215,81,128,191,208,97,22,33,180,244,181,86,179,196,35,207,186,149,153,184,189,165,15,40,2,184,158,95,5,136,8,198,12,217,178,177,11,233,36,47,111,124,135,88,104,76,17,193,97,29,171,182,102,45,61,118,220,65,144,1,219,113,6,152,210,32,188,239,213,16,42,
113,177,133,137,6,182,181,31,159,191,228,165,232,184,212,51,120,7,201,162,15,0,249,52,150,9,168,142,225,14,152,24,127,106,13,187,8,109,61,45,145,100,108,151,230,99,92,1,107,107,81,244,28,108,97,98,133,101,48,216,242,98,0,78,108,6,149,237,27,1,165,123,130,8,244,193,245,15,196,87,101,176,217,198,18,183,233,80,139,190,184,234,252,185,136,124,98,221,29,223,21,218,45,73,140,211,124,243,251,212,76,101,77,178,97,88,58,181,81,206,163,188,0,116,212,187,48,226,74,223,165,65,61,216,149,215,164,209,196,109,211,
214,244,251,67,105,233,106,52,110,217,252,173,103,136,70,218,96,184,208,68,4,45,115,51,3,29,229,170,10,76,95,221,13,124,201,80,5,113,60,39,2,65,170,190,11,16,16,201,12,32,134,87,104,181,37,32,111,133,179,185,102,212,9,206,97,228,159,94,222,249,14,41,217,201,152,176,208,152,34,199,215,168,180,89,179,61,23,46,180,13,129,183,189,92,59,192,186,108,173,237,184,131,32,154,191,179,182,3,182,226,12,116,177,210,154,234,213,71,57,157,210,119,175,4,219,38,21,115,220,22,131,227,99,11,18,148,100,59,132,13,109,
106,62,122,106,90,168,228,14,207,11,147,9,255,157,10,0,174,39,125,7,158,177,240,15,147,68,135,8,163,210,30,1,242,104,105,6,194,254,247,98,87,93,128,101,103,203,25,108,54,113,110,107,6,231,254,212,27,118,137,211,43,224,16,218,122,90,103,221,74,204,249,185,223,111,142,190,239,249,23,183,190,67,96,176,142,213,214,214,163,232,161,209,147,126,56,216,194,196,79,223,242,82,209,187,103,241,166,188,87,103,63,181,6,221,72,178,54,75,216,13,43,218,175,10,27,76,54,3,74,246,65,4,122,96,223,96,239,195,168,103,223,
85,49,110,142,239,70,105,190,121,203,97,179,140,188,102,131,26,37,111,210,160,82,104,226,54,204,12,119,149,187,11,71,3,34,2,22,185,85,5,38,47,197,186,59,190,178,189,11,40,43,180,90,146,92,179,106,4,194,215,255,167,181,208,207,49,44,217,158,139,91,222,174,29,155,100,194,176,236,99,242,38,117,106,163,156,2,109,147,10,156,9,6,169,235,14,54,63,114,7,103,133,5,0,87,19,149,191,74,130,226,184,122,20,123,177,43,174,12,182,27,56,146,210,142,155,229,213,190,13,124,220,239,183,11,219,223,33,134,211,210,212,
241,212,226,66,104,221,179,248,31,218,131,110,129,190,22,205,246,185,38,91,111,176,119,225,24,183,71,119,136,8,90,230,255,15,106,112,102,6,59,202,17,1,11,92,143,101,158,255,248,98,174,105,97,107,255,211,22,108,207,69,160,10,226,120,215,13,210,238,78,4,131,84,57,3,179,194,167,103,38,97,208,96,22,247,73,105,71,77,62,110,119,219,174,209,106,74,217,214,90,220,64,223,11,102,55,216,59,240,169,188,174,83,222,187,158,197,71,178,207,127,48,181,255,233,189,189,242,28,202,186,194,138,83,179,147,48,36,180,163,
166,186,208,54,5,205,215,6,147,84,222,87,41,35,217,103,191,179,102,122,46,196,97,74,184,93,104,27,2,42,111,43,148,180,11,190,55,195,12,142,161,90,5,223,27,45,2,239,141,0,0,0,0,25,27,49,65,50,54,98,130,43,45,83,195,100,108,197,4,125,119,244,69,86,90,167,134,79,65,150,199,200,217,138,8,209,194,187,73,250,239,232,138,227,244,217,203,172,181,79,12,181,174,126,77,158,131,45,142,135,152,28,207,74,194,18,81,83,217,35,16,120,244,112,211,97,239,65,146,46,174,215,85,55,181,230,20,28,152,181,215,5,131,132,150,
130,27,152,89,155,0,169,24,176,45,250,219,169,54,203,154,230,119,93,93,255,108,108,28,212,65,63,223,205,90,14,158,149,132,36,162,140,159,21,227,167,178,70,32,190,169,119,97,241,232,225,166,232,243,208,231,195,222,131,36,218,197,178,101,93,93,174,170,68,70,159,235,111,107,204,40,118,112,253,105,57,49,107,174,32,42,90,239,11,7,9,44,18,28,56,109,223,70,54,243,198,93,7,178,237,112,84,113,244,107,101,48,187,42,243,247,162,49,194,182,137,28,145,117,144,7,160,52,23,159,188,251,14,132,141,186,37,169,222,
121,60,178,239,56,115,243,121,255,106,232,72,190,65,197,27,125,88,222,42,60,240,121,79,5,233,98,126,68,194,79,45,135,219,84,28,198,148,21,138,1,141,14,187,64,166,35,232,131,191,56,217,194,56,160,197,13,33,187,244,76,10,150,167,143,19,141,150,206,92,204,0,9,69,215,49,72,110,250,98,139,119,225,83,202,186,187,93,84,163,160,108,21,136,141,63,214,145,150,14,151,222,215,152,80,199,204,169,17,236,225,250,210,245,250,203,147,114,98,215,92,107,121,230,29,64,84,181,222,89,79,132,159,22,14,18,88,15,21,35,25,
36,56,112,218,61,35,65,155,101,253,107,167,124,230,90,230,87,203,9,37,78,208,56,100,1,145,174,163,24,138,159,226,51,167,204,33,42,188,253,96,173,36,225,175,180,63,208,238,159,18,131,45,134,9,178,108,201,72,36,171,208,83,21,234,251,126,70,41,226,101,119,104,47,63,121,246,54,36,72,183,29,9,27,116,4,18,42,53,75,83,188,242,82,72,141,179,121,101,222,112,96,126,239,49,231,230,243,254,254,253,194,191,213,208,145,124,204,203,160,61,131,138,54,250,154,145,7,187,177,188,84,120,168,167,101,57,59,131,152,75,
34,152,169,10,9,181,250,201,16,174,203,136,95,239,93,79,70,244,108,14,109,217,63,205,116,194,14,140,243,90,18,67,234,65,35,2,193,108,112,193,216,119,65,128,151,54,215,71,142,45,230,6,165,0,181,197,188,27,132,132,113,65,138,26,104,90,187,91,67,119,232,152,90,108,217,217,21,45,79,30,12,54,126,95,39,27,45,156,62,0,28,221,185,152,0,18,160,131,49,83,139,174,98,144,146,181,83,209,221,244,197,22,196,239,244,87,239,194,167,148,246,217,150,213,174,7,188,233,183,28,141,168,156,49,222,107,133,42,239,42,202,
107,121,237,211,112,72,172,248,93,27,111,225,70,42,46,102,222,54,225,127,197,7,160,84,232,84,99,77,243,101,34,2,178,243,229,27,169,194,164,48,132,145,103,41,159,160,38,228,197,174,184,253,222,159,249,214,243,204,58,207,232,253,123,128,169,107,188,153,178,90,253,178,159,9,62,171,132,56,127,44,28,36,176,53,7,21,241,30,42,70,50,7,49,119,115,72,112,225,180,81,107,208,245,122,70,131,54,99,93,178,119,203,250,215,78,210,225,230,15,249,204,181,204,224,215,132,141,175,150,18,74,182,141,35,11,157,160,112,200,
132,187,65,137,3,35,93,70,26,56,108,7,49,21,63,196,40,14,14,133,103,79,152,66,126,84,169,3,85,121,250,192,76,98,203,129,129,56,197,31,152,35,244,94,179,14,167,157,170,21,150,220,229,84,0,27,252,79,49,90,215,98,98,153,206,121,83,216,73,225,79,23,80,250,126,86,123,215,45,149,98,204,28,212,45,141,138,19,52,150,187,82,31,187,232,145,6,160,217,208,94,126,243,236,71,101,194,173,108,72,145,110,117,83,160,47,58,18,54,232,35,9,7,169,8,36,84,106,17,63,101,43,150,167,121,228,143,188,72,165,164,145,27,102,189,
138,42,39,242,203,188,224,235,208,141,161,192,253,222,98,217,230,239,35,20,188,225,189,13,167,208,252,38,138,131,63,63,145,178,126,112,208,36,185,105,203,21,248,66,230,70,59,91,253,119,122,220,101,107,181,197,126,90,244,238,83,9,55,247,72,56,118,184,9,174,177,161,18,159,240,138,63,204,51,147,36,253,114,0,0,0,0,1,194,106,55,3,132,212,110,2,70,190,89,7,9,168,220,6,203,194,235,4,141,124,178,5,79,22,133,14,19,81,184,15,209,59,143,13,151,133,214,12,85,239,225,9,26,249,100,8,216,147,83,10,158,45,10,11,
92,71,61,28,38,163,112,29,228,201,71,31,162,119,30,30,96,29,41,27,47,11,172,26,237,97,155,24,171,223,194,25,105,181,245,18,53,242,200,19,247,152,255,17,177,38,166,16,115,76,145,21,60,90,20,20,254,48,35,22,184,142,122,23,122,228,77,56,77,70,224,57,143,44,215,59,201,146,142,58,11,248,185,63,68,238,60,62,134,132,11,60,192,58,82,61,2,80,101,54,94,23,88,55,156,125,111,53,218,195,54,52,24,169,1,49,87,191,132,48,149,213,179,50,211,107,234,51,17,1,221,36,107,229,144,37,169,143,167,39,239,49,254,38,45,91,
201,35,98,77,76,34,160,39,123,32,230,153,34,33,36,243,21,42,120,180,40,43,186,222,31,41,252,96,70,40,62,10,113,45,113,28,244,44,179,118,195,46,245,200,154,47,55,162,173,112,154,141,192,113,88,231,247,115,30,89,174,114,220,51,153,119,147,37,28,118,81,79,43,116,23,241,114,117,213,155,69,126,137,220,120,127,75,182,79,125,13,8,22,124,207,98,33,121,128,116,164,120,66,30,147,122,4,160,202,123,198,202,253,108,188,46,176,109,126,68,135,111,56,250,222,110,250,144,233,107,181,134,108,106,119,236,91,104,49,
82,2,105,243,56,53,98,175,127,8,99,109,21,63,97,43,171,102,96,233,193,81,101,166,215,212,100,100,189,227,102,34,3,186,103,224,105,141,72,215,203,32,73,21,161,23,75,83,31,78,74,145,117,121,79,222,99,252,78,28,9,203,76,90,183,146,77,152,221,165,70,196,154,152,71,6,240,175,69,64,78,246,68,130,36,193,65,205,50,68,64,15,88,115,66,73,230,42,67,139,140,29,84,241,104,80,85,51,2,103,87,117,188,62,86,183,214,9,83,248,192,140,82,58,170,187,80,124,20,226,81,190,126,213,90,226,57,232,91,32,83,223,89,102,237,134,
88,164,135,177,93,235,145,52,92,41,251,3,94,111,69,90,95,173,47,109,225,53,27,128,224,247,113,183,226,177,207,238,227,115,165,217,230,60,179,92,231,254,217,107,229,184,103,50,228,122,13,5,239,38,74,56,238,228,32,15,236,162,158,86,237,96,244,97,232,47,226,228,233,237,136,211,235,171,54,138,234,105,92,189,253,19,184,240,252,209,210,199,254,151,108,158,255,85,6,169,250,26,16,44,251,216,122,27,249,158,196,66,248,92,174,117,243,0,233,72,242,194,131,127,240,132,61,38,241,70,87,17,244,9,65,148,245,203,43,
163,247,141,149,250,246,79,255,205,217,120,93,96,216,186,55,87,218,252,137,14,219,62,227,57,222,113,245,188,223,179,159,139,221,245,33,210,220,55,75,229,215,107,12,216,214,169,102,239,212,239,216,182,213,45,178,129,208,98,164,4,209,160,206,51,211,230,112,106,210,36,26,93,197,94,254,16,196,156,148,39,198,218,42,126,199,24,64,73,194,87,86,204,195,149,60,251,193,211,130,162,192,17,232,149,203,77,175,168,202,143,197,159,200,201,123,198,201,11,17,241,204,68,7,116,205,134,109,67,207,192,211,26,206,2,185,
45,145,175,150,64,144,109,252,119,146,43,66,46,147,233,40,25,150,166,62,156,151,100,84,171,149,34,234,242,148,224,128,197,159,188,199,248,158,126,173,207,156,56,19,150,157,250,121,161,152,181,111,36,153,119,5,19,155,49,187,74,154,243,209,125,141,137,53,48,140,75,95,7,142,13,225,94,143,207,139,105,138,128,157,236,139,66,247,219,137,4,73,130,136,198,35,181,131,154,100,136,130,88,14,191,128,30,176,230,129,220,218,209,132,147,204,84,133,81,166,99,135,23,24,58,134,213,114,13,169,226,208,160,168,32,186,
151,170,102,4,206,171,164,110,249,174,235,120,124,175,41,18,75,173,111,172,18,172,173,198,37,167,241,129,24,166,51,235,47,164,117,85,118,165,183,63,65,160,248,41,196,161,58,67,243,163,124,253,170,162,190,151,157,181,196,115,208,180,6,25,231,182,64,167,190,183,130,205,137,178,205,219,12,179,15,177,59,177,73,15,98,176,139,101,85,187,215,34,104,186,21,72,95,184,83,246,6,185,145,156,49,188,222,138,180,189,28,224,131,191,90,94,218,190,152,52,237,0,0,0,0,184,188,103,101,170,9,200,139,18,181,175,238,143,
98,151,87,55,222,240,50,37,107,95,220,157,215,56,185,197,180,40,239,125,8,79,138,111,189,224,100,215,1,135,1,74,214,191,184,242,106,216,221,224,223,119,51,88,99,16,86,80,25,87,159,232,165,48,250,250,16,159,20,66,172,248,113,223,123,192,200,103,199,167,173,117,114,8,67,205,206,111,38,149,173,127,112,45,17,24,21,63,164,183,251,135,24,208,158,26,207,232,39,162,115,143,66,176,198,32,172,8,122,71,201,160,50,175,62,24,142,200,91,10,59,103,181,178,135,0,208,47,80,56,105,151,236,95,12,133,89,240,226,61,229,
151,135,101,134,135,209,221,58,224,180,207,143,79,90,119,51,40,63,234,228,16,134,82,88,119,227,64,237,216,13,248,81,191,104,240,43,248,161,72,151,159,196,90,34,48,42,226,158,87,79,127,73,111,246,199,245,8,147,213,64,167,125,109,252,192,24,53,159,208,78,141,35,183,43,159,150,24,197,39,42,127,160,186,253,71,25,2,65,32,124,16,244,143,146,168,72,232,247,155,20,88,61,35,168,63,88,49,29,144,182,137,161,247,211,20,118,207,106,172,202,168,15,190,127,7,225,6,195,96,132,94,160,112,210,230,28,23,183,244,169,
184,89,76,21,223,60,209,194,231,133,105,126,128,224,123,203,47,14,195,119,72,107,203,13,15,162,115,177,104,199,97,4,199,41,217,184,160,76,68,111,152,245,252,211,255,144,238,102,80,126,86,218,55,27,14,185,39,77,182,5,64,40,164,176,239,198,28,12,136,163,129,219,176,26,57,103,215,127,43,210,120,145,147,110,31,244,59,38,247,3,131,154,144,102,145,47,63,136,41,147,88,237,180,68,96,84,12,248,7,49,30,77,168,223,166,241,207,186,254,146,223,236,70,46,184,137,84,155,23,103,236,39,112,2,113,240,72,187,201,76,
47,222,219,249,128,48,99,69,231,85,107,63,160,156,211,131,199,249,193,54,104,23,121,138,15,114,228,93,55,203,92,225,80,174,78,84,255,64,246,232,152,37,174,139,136,115,22,55,239,22,4,130,64,248,188,62,39,157,33,233,31,36,153,85,120,65,139,224,215,175,51,92,176,202,237,89,182,59,85,229,209,94,71,80,126,176,255,236,25,213,98,59,33,108,218,135,70,9,200,50,233,231,112,142,142,130,40,237,158,212,144,81,249,177,130,228,86,95,58,88,49,58,167,143,9,131,31,51,110,230,13,134,193,8,181,58,166,109,189,64,225,
164,5,252,134,193,23,73,41,47,175,245,78,74,50,34,118,243,138,158,17,150,152,43,190,120,32,151,217,29,120,244,201,75,192,72,174,46,210,253,1,192,106,65,102,165,247,150,94,28,79,42,57,121,93,159,150,151,229,35,241,242,77,107,25,5,245,215,126,96,231,98,209,142,95,222,182,235,194,9,142,82,122,181,233,55,104,0,70,217,208,188,33,188,136,223,49,234,48,99,86,143,34,214,249,97,154,106,158,4,7,189,166,189,191,1,193,216,173,180,110,54,21,8,9,83,29,114,78,154,165,206,41,255,183,123,134,17,15,199,225,116,146,
16,217,205,42,172,190,168,56,25,17,70,128,165,118,35,216,198,102,117,96,122,1,16,114,207,174,254,202,115,201,155,87,164,241,34,239,24,150,71,253,173,57,169,69,17,94,204,118,77,238,6,206,241,137,99,220,68,38,141,100,248,65,232,249,47,121,81,65,147,30,52,83,38,177,218,235,154,214,191,179,249,198,233,11,69,161,140,25,240,14,98,161,76,105,7,60,155,81,190,132,39,54,219,150,146,153,53,46,46,254,80,38,84,185,153,158,232,222,252,140,93,113,18,52,225,22,119,169,54,46,206,17,138,73,171,3,63,230,69,187,131,
129,32,227,224,145,118,91,92,246,19,73,233,89,253,241,85,62,152,108,130,6,33,212,62,97,68,198,139,206,170,126,55,169,207,214,127,65,56,110,195,38,93,124,118,137,179,196,202,238,214,89,29,214,111,225,161,177,10,243,20,30,228,75,168,121,129,19,203,105,215,171,119,14,178,185,194,161,92,1,126,198,57,156,169,254,128,36,21,153,229,54,160,54,11,142,28,81,110,134,102,22,167,62,218,113,194,44,111,222,44,148,211,185,73,9,4,129,240,177,184,230,149,163,13,73,123,27,177,46,30,67,210,62,72,251,110,89,45,233,219,
246,195,81,103,145,166,204,176,169,31,116,12,206,122,102,185,97,148,222,5,6,241,16,0,0,0,11,0,0,0,10,0,0,0,16,0,0,0,24,0,0,0,40,0,0,0,51,0,0,0,61,0,0,0,12,0,0,0,12,0,0,0,14,0,0,0,19,0,0,0,26,0,0,0,58,0,0,0,60,0,0,0,55,0,0,0,14,0,0,0,13,0,0,0,16,0,0,0,24,0,0,0,40,0,0,0,57,0,0,0,69,0,0,0,56,0,0,0,14,0,0,0,17,0,0,0,22,0,0,0,29,0,0,0,51,0,0,0,87,0,0,0,80,0,0,0,62,0,0,0,18,0,0,0,22,0,0,0,37,0,0,0,56,0,0,0,68,0,0,0,109,0,0,0,103,0,0,0,77,0,0,0,24,0,0,0,35,0,0,0,55,0,0,0,64,0,0,0,81,0,0,0,104,0,0,0,113,
0,0,0,92,0,0,0,49,0,0,0,64,0,0,0,78,0,0,0,87,0,0,0,103,0,0,0,121,0,0,0,120,0,0,0,101,0,0,0,72,0,0,0,92,0,0,0,95,0,0,0,98,0,0,0,112,0,0,0,100,0,0,0,103,0,0,0,99,0,0,0,17,0,0,0,18,0,0,0,24,0,0,0,47,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,18,0,0,0,21,0,0,0,26,0,0,0,66,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,24,0,0,0,26,0,0,0,56,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,47,0,0,0,66,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,
0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,99,0,0,0,121,98,2,0,143,98,2,0,175,98,2,0,212,98,2,0,238,98,2,0,13,99,2,0,34,99,2,0,63,99,2,0,105,99,2,0,169,99,2,0,200,99,2,0,223,99,2,0,245,99,2,0,9,100,2,0,70,100,2,0,118,100,2,0,146,100,2,0,181,100,2,0,236,100,2,0,35,101,2,0,58,101,2,0,90,101,2,0,132,101,2,0,209,101,
2,0,236,101,2,0,23,102,2,0,51,102,2,0,88,102,2,0,126,102,2,0,163,102,2,0,182,102,2,0,203,102,2,0,222,102,2,0,241,102,2,0,22,103,2,0,43,103,2,0,63,103,2,0,96,103,2,0,118,103,2,0,165,103,2,0,205,103,2,0,238,103,2,0,15,104,2,0,62,104,2,0,79,104,2,0,107,104,2,0,169,104,2,0,208,104,2,0,247,104,2,0,11,105,2,0,57,105,2,0,97,105,2,0,125,105,2,0,162,105,2,0,196,105,2,0,238,105,2,0,25,106,2,0,55,106,2,0,101,106,2,0,141,106,2,0,180,106,2,0,223,106,2,0,12,107,2,0,60,107,2,0,102,107,2,0,147,107,2,0,182,107,2,
0,212,107,2,0,242,107,2,0,40,108,2,0,82,108,2,0,113,108,2,0,148,108,2,0,187,108,2,0,208,108,2,0,228,108,2,0,25,109,2,0,41,109,2,0,103,109,2,0,169,109,2,0,211,109,2,0,255,109,2,0,38,110,2,0,66,110,2,0,109,110,2,0,136,110,2,0,156,110,2,0,179,110,2,0,192,110,2,0,232,110,2,0,29,111,2,0,89,111,2,0,135,111,2,0,168,111,2,0,207,111,2,0,232,111,2,0,16,112,2,0,51,112,2,0,75,112,2,0,111,112,2,0,148,112,2,0,154,112,2,0,211,112,2,0,13,113,2,0,44,113,2,0,59,113,2,0,88,113,2,0,118,113,2,0,147,113,2,0,172,113,2,
0,197,113,2,0,7,114,2,0,65,114,2,0,119,114,2,0,171,114,2,0,191,114,2,0,214,114,2,0,252,114,2,0,35,115,2,0,101,115,2,0,161,115,2,0,210,115,2,0,246,115,2,0,36,116,2,0,63,116,2,0,119,116,2,0,162,116,2,0,0,0,0,0,1,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,1,0,0,0,8,0,0,0,16,0,0,0,9,0,0,0,2,0,0,0,3,0,0,0,10,0,0,0,17,0,0,0,24,0,0,0,32,0,0,0,25,0,0,0,18,0,0,0,11,0,0,0,4,0,0,0,5,0,0,0,12,0,0,0,19,0,0,0,26,0,0,0,33,0,0,0,40,0,0,0,48,0,0,0,41,0,0,0,34,0,0,0,27,0,0,0,20,0,0,0,13,0,0,0,6,0,0,0,7,0,0,0,14,0,0,0,21,0,0,0,
28,0,0,0,35,0,0,0,42,0,0,0,49,0,0,0,56,0,0,0,57,0,0,0,50,0,0,0,43,0,0,0,36,0,0,0,29,0,0,0,22,0,0,0,15,0,0,0,23,0,0,0,30,0,0,0,37,0,0,0,44,0,0,0,51,0,0,0,58,0,0,0,59,0,0,0,52,0,0,0,45,0,0,0,38,0,0,0,31,0,0,0,39,0,0,0,46,0,0,0,53,0,0,0,60,0,0,0,61,0,0,0,54,0,0,0,47,0,0,0,55,0,0,0,62,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,0,0,0,0,1,0,0,0,8,0,0,0,16,0,0,0,9,0,0,0,2,0,0,0,3,0,0,0,10,
0,0,0,17,0,0,0,24,0,0,0,32,0,0,0,25,0,0,0,18,0,0,0,11,0,0,0,4,0,0,0,5,0,0,0,12,0,0,0,19,0,0,0,26,0,0,0,33,0,0,0,40,0,0,0,48,0,0,0,41,0,0,0,34,0,0,0,27,0,0,0,20,0,0,0,13,0,0,0,6,0,0,0,14,0,0,0,21,0,0,0,28,0,0,0,35,0,0,0,42,0,0,0,49,0,0,0,50,0,0,0,43,0,0,0,36,0,0,0,29,0,0,0,22,0,0,0,30,0,0,0,37,0,0,0,44,0,0,0,51,0,0,0,52,0,0,0,45,0,0,0,38,0,0,0,46,0,0,0,53,0,0,0,54,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,
0,0,0,63,0,0,0,0,0,0,0,1,0,0,0,8,0,0,0,16,0,0,0,9,0,0,0,2,0,0,0,3,0,0,0,10,0,0,0,17,0,0,0,24,0,0,0,32,0,0,0,25,0,0,0,18,0,0,0,11,0,0,0,4,0,0,0,5,0,0,0,12,0,0,0,19,0,0,0,26,0,0,0,33,0,0,0,40,0,0,0,41,0,0,0,34,0,0,0,27,0,0,0,20,0,0,0,13,0,0,0,21,0,0,0,28,0,0,0,35,0,0,0,42,0,0,0,43,0,0,0,36,0,0,0,29,0,0,0,37,0,0,0,44,0,0,0,45,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,0,0,0,0,1,0,0,0,8,0,0,0,16,
0,0,0,9,0,0,0,2,0,0,0,3,0,0,0,10,0,0,0,17,0,0,0,24,0,0,0,32,0,0,0,25,0,0,0,18,0,0,0,11,0,0,0,4,0,0,0,12,0,0,0,19,0,0,0,26,0,0,0,33,0,0,0,34,0,0,0,27,0,0,0,20,0,0,0,28,0,0,0,35,0,0,0,36,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,0,0,0,0,1,0,0,0,8,0,0,0,16,0,0,0,9,0,0,0,2,0,0,0,3,0,0,0,10,0,0,0,17,0,0,0,24,0,0,0,25,0,0,0,18,0,0,0,11,0,0,0,19,0,0,0,26,0,0,0,27,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,
0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,0,0,0,0,1,0,0,0,8,0,0,0,16,0,0,0,9,0,0,0,2,0,0,0,10,0,0,0,17,0,0,0,18,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,0,0,0,0,1,0,0,0,8,0,0,0,9,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,63,0,0,0,
63,0,0,0,64,6,0,0,128,62,0,0,0,0,0,0,136,19,0,0,0,0,0,0,1,0,0,0,2,0,0,0,3,0,0,0,0,0,0,0,1,0,0,0,5,0,0,0,2,0,0,0,4,0,0,0,6,0,0,0,3,0,0,0,7,0,0,0,8,0,0,0,0,0,0,0,1,0,0,0,5,0,0,0,6,0,0,0,2,0,0,0,4,0,0,0,7,0,0,0,12,0,0,0,3,0,0,0,8,0,0,0,11,0,0,0,13,0,0,0,9,0,0,0,10,0,0,0,14,0,0,0,15,0,0,0,0,0,0,0,1,0,0,0,5,0,0,0,6,0,0,0,14,0,0,0,2,0,0,0,4,0,0,0,7,0,0,0,13,0,0,0,15,0,0,0,3,0,0,0,8,0,0,0,12,0,0,0,16,0,0,0,21,0,0,0,9,0,0,0,11,0,0,0,17,0,0,0,20,0,0,0,22,0,0,0,10,0,0,0,18,0,0,0,19,0,0,0,23,0,0,0,24,0,0,0,
0,0,0,0,1,0,0,0,5,0,0,0,6,0,0,0,14,0,0,0,15,0,0,0,2,0,0,0,4,0,0,0,7,0,0,0,13,0,0,0,16,0,0,0,25,0,0,0,3,0,0,0,8,0,0,0,12,0,0,0,17,0,0,0,24,0,0,0,26,0,0,0,9,0,0,0,11,0,0,0,18,0,0,0,23,0,0,0,27,0,0,0,32,0,0,0,10,0,0,0,19,0,0,0,22,0,0,0,28,0,0,0,31,0,0,0,33,0,0,0,20,0,0,0,21,0,0,0,29,0,0,0,30,0,0,0,34,0,0,0,35,0,0,0,0,0,0,0,1,0,0,0,5,0,0,0,6,0,0,0,14,0,0,0,15,0,0,0,27,0,0,0,2,0,0,0,4,0,0,0,7,0,0,0,13,0,0,0,16,0,0,0,26,0,0,0,28,0,0,0,3,0,0,0,8,0,0,0,12,0,0,0,17,0,0,0,25,0,0,0,29,0,0,0,38,0,0,0,9,0,0,0,
11,0,0,0,18,0,0,0,24,0,0,0,30,0,0,0,37,0,0,0,39,0,0,0,10,0,0,0,19,0,0,0,23,0,0,0,31,0,0,0,36,0,0,0,40,0,0,0,45,0,0,0,20,0,0,0,22,0,0,0,32,0,0,0,35,0,0,0,41,0,0,0,44,0,0,0,46,0,0,0,21,0,0,0,33,0,0,0,34,0,0,0,42,0,0,0,43,0,0,0,47,0,0,0,48,0,0,0,0,0,0,0,1,0,0,0,5,0,0,0,6,0,0,0,14,0,0,0,15,0,0,0,27,0,0,0,28,0,0,0,2,0,0,0,4,0,0,0,7,0,0,0,13,0,0,0,16,0,0,0,26,0,0,0,29,0,0,0,42,0,0,0,3,0,0,0,8,0,0,0,12,0,0,0,17,0,0,0,25,0,0,0,30,0,0,0,41,0,0,0,43,0,0,0,9,0,0,0,11,0,0,0,18,0,0,0,24,0,0,0,31,0,0,0,40,0,0,
0,44,0,0,0,53,0,0,0,10,0,0,0,19,0,0,0,23,0,0,0,32,0,0,0,39,0,0,0,45,0,0,0,52,0,0,0,54,0,0,0,20,0,0,0,22,0,0,0,33,0,0,0,38,0,0,0,46,0,0,0,51,0,0,0,55,0,0,0,60,0,0,0,21,0,0,0,34,0,0,0,37,0,0,0,47,0,0,0,50,0,0,0,56,0,0,0,59,0,0,0,61,0,0,0,35,0,0,0,36,0,0,0,48,0,0,0,49,0,0,0,57,0,0,0,58,0,0,0,62,0,0,0,63,0,0,0,0,0,0,0,1,0,0,0,3,0,0,0,7,0,0,0,15,0,0,0,31,0,0,0,63,0,0,0,127,0,0,0,255,0,0,0,255,1,0,0,255,3,0,0,255,7,0,0,255,15,0,0,255,31,0,0,255,63,0,0,255,127,0,0,129,1,29,90,14,2,134,37,16,3,20,17,18,4,
11,8,20,5,216,3,23,6,218,1,25,7,229,0,28,8,111,0,30,9,54,0,33,10,26,0,35,11,13,0,9,12,6,0,10,13,3,0,12,13,1,0,143,15,127,90,36,16,37,63,38,17,242,44,39,18,124,32,40,19,185,23,42,20,130,17,43,21,239,12,45,22,161,9,46,23,47,7,48,24,92,5,49,25,6,4,51,26,3,3,52,27,64,2,54,28,177,1,56,29,68,1,57,30,245,0,59,31,183,0,60,32,138,0,62,33,104,0,63,34,78,0,32,35,59,0,33,9,44,0,165,37,225,90,64,38,76,72,65,39,13,58,67,40,241,46,68,41,31,38,69,42,51,31,70,43,168,25,72,44,24,21,73,45,119,17,74,46,116,14,75,47,
251,11,77,48,248,9,78,49,97,8,79,50,6,7,48,51,205,5,50,52,222,4,50,53,15,4,51,54,99,3,52,55,212,2,53,56,92,2,54,57,248,1,55,58,164,1,56,59,96,1,57,60,37,1,58,61,246,0,59,62,203,0,61,63,171,0,61,32,143,0,193,65,18,91,80,66,4,77,81,67,44,65,82,68,216,55,83,69,232,47,84,70,60,41,86,71,121,35,87,72,223,30,87,73,169,26,72,74,78,23,72,75,36,20,74,76,156,17,74,77,107,15,75,78,81,13,77,79,182,11,77,48,64,10,208,81,50,88,88,82,28,77,89,83,142,67,90,84,221,59,91,85,238,52,92,86,174,46,93,87,154,41,86,71,22,
37,216,89,112,85,95,90,169,76,96,91,217,68,97,92,34,62,99,93,36,56,99,94,180,50,93,86,23,46,223,96,168,86,101,97,70,79,102,98,229,71,103,99,207,65,104,100,61,60,99,93,94,55,105,102,49,82,106,103,15,76,107,104,57,70,103,99,94,65,233,106,39,86,108,107,231,80,109,103,133,75,110,109,151,85,111,107,79,80,238,111,16,90,112,109,34,85,240,111,235,89,113,113,29,90,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,192,3,0,0,192,4,0,0,192,5,0,0,192,6,0,0,192,7,0,0,
192,8,0,0,192,9,0,0,192,10,0,0,192,11,0,0,192,12,0,0,192,13,0,0,192,14,0,0,192,15,0,0,192,16,0,0,192,17,0,0,192,18,0,0,192,19,0,0,192,20,0,0,192,21,0,0,192,22,0,0,192,23,0,0,192,24,0,0,192,25,0,0,192,26,0,0,192,27,0,0,192,28,0,0,192,29,0,0,192,30,0,0,192,31,0,0,192,0,0,0,179,1,0,0,195,2,0,0,195,3,0,0,195,4,0,0,195,5,0,0,195,6,0,0,195,7,0,0,195,8,0,0,195,9,0,0,195,10,0,0,195,11,0,0,195,12,0,0,195,13,0,0,211,14,0,0,195,15,0,0,195,0,0,12,187,1,0,12,195,2,0,12,195,3,0,12,195,4,0,12,211,120,224,1,0,232,
224,1,0,0,0,0,0,10,0,0,0,100,0,0,0,232,3,0,0,16,39,0,0,160,134,1,0,64,66,15,0,128,150,152,0,0,225,245,5],"i8",4,ra.GLOBAL_BASE+112640);vc([1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255,255,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,3,0,0,0,102,130,2,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255,255,0,0,0,0,0,0,0,0,0,0,0,0,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,3,0,0,0,94,126,2,0,0,4,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,255,255,255,255,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,53,0,0,0,6,0,7,0,1,0,4,0,7,0,2,0,4,0,8,0,3,0,4,0,11,0,4,0,4,0,12,0,5,0,4,0,14,0,6,0,4,0,15,0,7,0,5,0,19,0,8,0,5,0,20,0,9,0,5,0,7,0,10,0,5,0,8,0,11,0,6,0,8,0,12,0,6,0,3,0,13,0,6,0,52,0,14,0,6,0,53,0,15,0,6,0,42,0,16,0,6,0,43,0,17,0,7,0,
39,0,18,0,7,0,12,0,19,0,7,0,8,0,20,0,7,0,23,0,21,0,7,0,3,0,22,0,7,0,4,0,23,0,7,0,40,0,24,0,7,0,43,0,25,0,7,0,19,0,26,0,7,0,36,0,27,0,7,0,24,0,28,0,8,0,2,0,29,0,8,0,3,0,30,0,8,0,26,0,31,0,8,0,27,0,32,0,8,0,18,0,33,0,8,0,19,0,34,0,8,0,20,0,35,0,8,0,21,0,36,0,8,0,22,0,37,0,8,0,23,0,38,0,8,0,40,0,39,0,8,0,41,0,40,0,8,0,42,0,41,0,8,0,43,0,42,0,8,0,44,0,43,0,8,0,45,0,44,0,8,0,4,0,45,0,8,0,5,0,46,0,8,0,10,0,47,0,8,0,11,0,48,0,8,0,82,0,49,0,8,0,83,0,50,0,8,0,84,0,51,0,8,0,85,0,52,0,8,0,36,0,53,0,8,0,37,0,
54,0,8,0,88,0,55,0,8,0,89,0,56,0,8,0,90,0,57,0,8,0,91,0,58,0,8,0,74,0,59,0,8,0,75,0,60,0,8,0,50,0,61,0,8,0,51,0,62,0,8,0,52,0,63,0,5,0,27,0,64,0,5,0,18,0,128,0,6,0,23,0,192,0,7,0,55,0,0,1,8,0,54,0,64,1,8,0,55,0,128,1,8,0,100,0,192,1,8,0,101,0,0,2,8,0,104,0,64,2,8,0,103,0,128,2,9,0,204,0,192,2,9,0,205,0,0,3,9,0,210,0,64,3,9,0,211,0,128,3,9,0,212,0,192,3,9,0,213,0,0,4,9,0,214,0,64,4,9,0,215,0,128,4,9,0,216,0,192,4,9,0,217,0,0,5,9,0,218,0,64,5,9,0,219,0,128,5,9,0,152,0,192,5,9,0,153,0,0,6,9,0,154,0,
64,6,6,0,24,0,128,6,9,0,155,0,192,6,11,0,8,0,0,7,11,0,12,0,64,7,11,0,13,0,128,7,12,0,18,0,192,7,12,0,19,0,0,8,12,0,20,0,64,8,12,0,21,0,128,8,12,0,22,0,192,8,12,0,23,0,0,9,12,0,28,0,64,9,12,0,29,0,128,9,12,0,30,0,192,9,12,0,31,0,0,10,12,0,1,0,255,255,9,0,1,0,254,255,10,0,1,0,254,255,11,0,1,0,254,255,12,0,0,0,254,255,10,0,55,0,0,0,3,0,2,0,1,0,2,0,3,0,2,0,2,0,2,0,3,0,3,0,3,0,4,0,4,0,3,0,5,0,4,0,2,0,6,0,5,0,3,0,7,0,6,0,5,0,8,0,6,0,4,0,9,0,7,0,4,0,10,0,7,0,5,0,11,0,7,0,7,0,12,0,8,0,4,0,13,0,8,0,7,0,14,
0,9,0,24,0,15,0,10,0,23,0,16,0,10,0,24,0,17,0,10,0,8,0,18,0,11,0,103,0,19,0,11,0,104,0,20,0,11,0,108,0,21,0,11,0,55,0,22,0,11,0,40,0,23,0,11,0,23,0,24,0,11,0,24,0,25,0,12,0,202,0,26,0,12,0,203,0,27,0,12,0,204,0,28,0,12,0,205,0,29,0,12,0,104,0,30,0,12,0,105,0,31,0,12,0,106,0,32,0,12,0,107,0,33,0,12,0,210,0,34,0,12,0,211,0,35,0,12,0,212,0,36,0,12,0,213,0,37,0,12,0,214,0,38,0,12,0,215,0,39,0,12,0,108,0,40,0,12,0,109,0,41,0,12,0,218,0,42,0,12,0,219,0,43,0,12,0,84,0,44,0,12,0,85,0,45,0,12,0,86,0,46,0,
12,0,87,0,47,0,12,0,100,0,48,0,12,0,101,0,49,0,12,0,82,0,50,0,12,0,83,0,51,0,12,0,36,0,52,0,12,0,55,0,53,0,12,0,56,0,54,0,12,0,39,0,55,0,12,0,40,0,56,0,12,0,88,0,57,0,12,0,89,0,58,0,12,0,43,0,59,0,12,0,44,0,60,0,12,0,90,0,61,0,12,0,102,0,62,0,12,0,103,0,63,0,10,0,15,0,64,0,12,0,200,0,128,0,12,0,201,0,192,0,12,0,91,0,0,1,12,0,51,0,64,1,12,0,52,0,128,1,12,0,53,0,192,1,13,0,108,0,0,2,13,0,109,0,64,2,13,0,74,0,128,2,13,0,75,0,192,2,13,0,76,0,0,3,13,0,77,0,64,3,13,0,114,0,128,3,13,0,115,0,192,3,13,0,116,
0,0,4,13,0,117,0,64,4,13,0,118,0,128,4,13,0,119,0,192,4,13,0,82,0,0,5,13,0,83,0,64,5,13,0,84,0,128,5,13,0,85,0,192,5,13,0,90,0,0,6,13,0,91,0,64,6,13,0,100,0,128,6,13,0,101,0,192,6,11,0,8,0,0,7,11,0,12,0,64,7,11,0,13,0,128,7,12,0,18,0,192,7,12,0,19,0,0,8,12,0,20,0,64,8,12,0,21,0,128,8,12,0,22,0,192,8,12,0,23,0,0,9,12,0,28,0,64,9,12,0,29,0,128,9,12,0,30,0,192,9,12,0,31,0,0,10,12,0,1,0,255,255,9,0,1,0,254,255,10,0,1,0,254,255,11,0,1,0,254,255,12,0,0,0,254,255,7,0,3,0,0,0,6,0,3,0,0,0,3,0,3,0,0,0,1,0,
1,0,0,0,3,0,2,0,0,0,6,0,2,0,0,0,7,0,2,0,0,0,96,7,0,0,0,8,80,0,0,8,16,0,20,8,115,0,18,7,31,0,0,8,112,0,0,8,48,0,0,9,192,0,16,7,10,0,0,8,96,0,0,8,32,0,0,9,160,0,0,8,0,0,0,8,128,0,0,8,64,0,0,9,224,0,16,7,6,0,0,8,88,0,0,8,24,0,0,9,144,0,19,7,59,0,0,8,120,0,0,8,56,0,0,9,208,0,17,7,17,0,0,8,104,0,0,8,40,0,0,9,176,0,0,8,8,0,0,8,136,0,0,8,72,0,0,9,240,0,16,7,4,0,0,8,84,0,0,8,20,0,21,8,227,0,19,7,43,0,0,8,116,0,0,8,52,0,0,9,200,0,17,7,13,0,0,8,100,0,0,8,36,0,0,9,168,0,0,8,4,0,0,8,132,0,0,8,68,0,0,9,232,0,
16,7,8,0,0,8,92,0,0,8,28,0,0,9,152,0,20,7,83,0,0,8,124,0,0,8,60,0,0,9,216,0,18,7,23,0,0,8,108,0,0,8,44,0,0,9,184,0,0,8,12,0,0,8,140,0,0,8,76,0,0,9,248,0,16,7,3,0,0,8,82,0,0,8,18,0,21,8,163,0,19,7,35,0,0,8,114,0,0,8,50,0,0,9,196,0,17,7,11,0,0,8,98,0,0,8,34,0,0,9,164,0,0,8,2,0,0,8,130,0,0,8,66,0,0,9,228,0,16,7,7,0,0,8,90,0,0,8,26,0,0,9,148,0,20,7,67,0,0,8,122,0,0,8,58,0,0,9,212,0,18,7,19,0,0,8,106,0,0,8,42,0,0,9,180,0,0,8,10,0,0,8,138,0,0,8,74,0,0,9,244,0,16,7,5,0,0,8,86,0,0,8,22,0,64,8,0,0,19,7,51,
0,0,8,118,0,0,8,54,0,0,9,204,0,17,7,15,0,0,8,102,0,0,8,38,0,0,9,172,0,0,8,6,0,0,8,134,0,0,8,70,0,0,9,236,0,16,7,9,0,0,8,94,0,0,8,30,0,0,9,156,0,20,7,99,0,0,8,126,0,0,8,62,0,0,9,220,0,18,7,27,0,0,8,110,0,0,8,46,0,0,9,188,0,0,8,14,0,0,8,142,0,0,8,78,0,0,9,252,0,96,7,0,0,0,8,81,0,0,8,17,0,21,8,131,0,18,7,31,0,0,8,113,0,0,8,49,0,0,9,194,0,16,7,10,0,0,8,97,0,0,8,33,0,0,9,162,0,0,8,1,0,0,8,129,0,0,8,65,0,0,9,226,0,16,7,6,0,0,8,89,0,0,8,25,0,0,9,146,0,19,7,59,0,0,8,121,0,0,8,57,0,0,9,210,0,17,7,17,0,0,8,
105,0,0,8,41,0,0,9,178,0,0,8,9,0,0,8,137,0,0,8,73,0,0,9,242,0,16,7,4,0,0,8,85,0,0,8,21,0,16,8,2,1,19,7,43,0,0,8,117,0,0,8,53,0,0,9,202,0,17,7,13,0,0,8,101,0,0,8,37,0,0,9,170,0,0,8,5,0,0,8,133,0,0,8,69,0,0,9,234,0,16,7,8,0,0,8,93,0,0,8,29,0,0,9,154,0,20,7,83,0,0,8,125,0,0,8,61,0,0,9,218,0,18,7,23,0,0,8,109,0,0,8,45,0,0,9,186,0,0,8,13,0,0,8,141,0,0,8,77,0,0,9,250,0,16,7,3,0,0,8,83,0,0,8,19,0,21,8,195,0,19,7,35,0,0,8,115,0,0,8,51,0,0,9,198,0,17,7,11,0,0,8,99,0,0,8,35,0,0,9,166,0,0,8,3,0,0,8,131,0,0,
8,67,0,0,9,230,0,16,7,7,0,0,8,91,0,0,8,27,0,0,9,150,0,20,7,67,0,0,8,123,0,0,8,59,0,0,9,214,0,18,7,19,0,0,8,107,0,0,8,43,0,0,9,182,0,0,8,11,0,0,8,139,0,0,8,75,0,0,9,246,0,16,7,5,0,0,8,87,0,0,8,23,0,64,8,0,0,19,7,51,0,0,8,119,0,0,8,55,0,0,9,206,0,17,7,15,0,0,8,103,0,0,8,39,0,0,9,174,0,0,8,7,0,0,8,135,0,0,8,71,0,0,9,238,0,16,7,9,0,0,8,95,0,0,8,31,0,0,9,158,0,20,7,99,0,0,8,127,0,0,8,63,0,0,9,222,0,18,7,27,0,0,8,111,0,0,8,47,0,0,9,190,0,0,8,15,0,0,8,143,0,0,8,79,0,0,9,254,0,96,7,0,0,0,8,80,0,0,8,16,0,
20,8,115,0,18,7,31,0,0,8,112,0,0,8,48,0,0,9,193,0,16,7,10,0,0,8,96,0,0,8,32,0,0,9,161,0,0,8,0,0,0,8,128,0,0,8,64,0,0,9,225,0,16,7,6,0,0,8,88,0,0,8,24,0,0,9,145,0,19,7,59,0,0,8,120,0,0,8,56,0,0,9,209,0,17,7,17,0,0,8,104,0,0,8,40,0,0,9,177,0,0,8,8,0,0,8,136,0,0,8,72,0,0,9,241,0,16,7,4,0,0,8,84,0,0,8,20,0,21,8,227,0,19,7,43,0,0,8,116,0,0,8,52,0,0,9,201,0,17,7,13,0,0,8,100,0,0,8,36,0,0,9,169,0,0,8,4,0,0,8,132,0,0,8,68,0,0,9,233,0,16,7,8,0,0,8,92,0,0,8,28,0,0,9,153,0,20,7,83,0,0,8,124,0,0,8,60,0,0,9,217,
0,18,7,23,0,0,8,108,0,0,8,44,0,0,9,185,0,0,8,12,0,0,8,140,0,0,8,76,0,0,9,249,0,16,7,3,0,0,8,82,0,0,8,18,0,21,8,163,0,19,7,35,0,0,8,114,0,0,8,50,0,0,9,197,0,17,7,11,0,0,8,98,0,0,8,34,0,0,9,165,0,0,8,2,0,0,8,130,0,0,8,66,0,0,9,229,0,16,7,7,0,0,8,90,0,0,8,26,0,0,9,149,0,20,7,67,0,0,8,122,0,0,8,58,0,0,9,213,0,18,7,19,0,0,8,106,0,0,8,42,0,0,9,181,0,0,8,10,0,0,8,138,0,0,8,74,0,0,9,245,0,16,7,5,0,0,8,86,0,0,8,22,0,64,8,0,0,19,7,51,0,0,8,118,0,0,8,54,0,0,9,205,0,17,7,15,0,0,8,102,0,0,8,38,0,0,9,173,0,0,8,
6,0,0,8,134,0,0,8,70,0,0,9,237,0,16,7,9,0,0,8,94,0,0,8,30,0,0,9,157,0,20,7,99,0,0,8,126,0,0,8,62,0,0,9,221,0,18,7,27,0,0,8,110,0,0,8,46,0,0,9,189,0,0,8,14,0,0,8,142,0,0,8,78,0,0,9,253,0,96,7,0,0,0,8,81,0,0,8,17,0,21,8,131,0,18,7,31,0,0,8,113,0,0,8,49,0,0,9,195,0,16,7,10,0,0,8,97,0,0,8,33,0,0,9,163,0,0,8,1,0,0,8,129,0,0,8,65,0,0,9,227,0,16,7,6,0,0,8,89,0,0,8,25,0,0,9,147,0,19,7,59,0,0,8,121,0,0,8,57,0,0,9,211,0,17,7,17,0,0,8,105,0,0,8,41,0,0,9,179,0,0,8,9,0,0,8,137,0,0,8,73,0,0,9,243,0,16,7,4,0,0,
8,85,0,0,8,21,0,16,8,2,1,19,7,43,0,0,8,117,0,0,8,53,0,0,9,203,0,17,7,13,0,0,8,101,0,0,8,37,0,0,9,171,0,0,8,5,0,0,8,133,0,0,8,69,0,0,9,235,0,16,7,8,0,0,8,93,0,0,8,29,0,0,9,155,0,20,7,83,0,0,8,125,0,0,8,61,0,0,9,219,0,18,7,23,0,0,8,109,0,0,8,45,0,0,9,187,0,0,8,13,0,0,8,141,0,0,8,77,0,0,9,251,0,16,7,3,0,0,8,83,0,0,8,19,0,21,8,195,0,19,7,35,0,0,8,115,0,0,8,51,0,0,9,199,0,17,7,11,0,0,8,99,0,0,8,35,0,0,9,167,0,0,8,3,0,0,8,131,0,0,8,67,0,0,9,231,0,16,7,7,0,0,8,91,0,0,8,27,0,0,9,151,0,20,7,67,0,0,8,123,0,
0,8,59,0,0,9,215,0,18,7,19,0,0,8,107,0,0,8,43,0,0,9,183,0,0,8,11,0,0,8,139,0,0,8,75,0,0,9,247,0,16,7,5,0,0,8,87,0,0,8,23,0,64,8,0,0,19,7,51,0,0,8,119,0,0,8,55,0,0,9,207,0,17,7,15,0,0,8,103,0,0,8,39,0,0,9,175,0,0,8,7,0,0,8,135,0,0,8,71,0,0,9,239,0,16,7,9,0,0,8,95,0,0,8,31,0,0,9,159,0,20,7,99,0,0,8,127,0,0,8,63,0,0,9,223,0,18,7,27,0,0,8,111,0,0,8,47,0,0,9,191,0,0,8,15,0,0,8,143,0,0,8,79,0,0,9,255,0,16,5,1,0,23,5,1,1,19,5,17,0,27,5,1,16,17,5,5,0,25,5,1,4,21,5,65,0,29,5,1,64,16,5,3,0,24,5,1,2,20,5,33,
0,28,5,1,32,18,5,9,0,26,5,1,8,22,5,129,0,64,5,0,0,16,5,2,0,23,5,129,1,19,5,25,0,27,5,1,24,17,5,7,0,25,5,1,6,21,5,97,0,29,5,1,96,16,5,4,0,24,5,1,3,20,5,49,0,28,5,1,48,18,5,13,0,26,5,1,12,22,5,193,0,64,5,0,0,16,0,17,0,18,0,0,0,8,0,7,0,9,0,6,0,10,0,5,0,11,0,4,0,12,0,3,0,13,0,2,0,14,0,1,0,15,0,1,0,2,0,3,0,4,0,5,0,7,0,9,0,13,0,17,0,25,0,33,0,49,0,65,0,97,0,129,0,193,0,1,1,129,1,1,2,1,3,1,4,1,6,1,8,1,12,1,16,1,24,1,32,1,48,1,64,1,96,0,0,0,0,3,0,4,0,5,0,6,0,7,0,8,0,9,0,10,0,11,0,13,0,15,0,17,0,19,0,23,0,
27,0,31,0,35,0,43,0,51,0,59,0,67,0,83,0,99,0,115,0,131,0,163,0,195,0,227,0,2,1,0,0,0,0,16,0,16,0,16,0,16,0,17,0,17,0,18,0,18,0,19,0,19,0,20,0,20,0,21,0,21,0,22,0,22,0,23,0,23,0,24,0,24,0,25,0,25,0,26,0,26,0,27,0,27,0,28,0,28,0,29,0,29,0,64,0,64,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,16,0,17,0,17,0,17,0,17,0,18,0,18,0,18,0,18,0,19,0,19,0,19,0,19,0,20,0,20,0,20,0,20,0,21,0,21,0,21,0,21,0,16,0,72,0,78,0,12,0,8,0,140,0,8,0,76,0,8,0,204,0,8,0,44,0,8,0,172,0,8,0,108,0,8,0,236,0,8,0,28,0,8,0,156,0,8,0,92,
0,8,0,220,0,8,0,60,0,8,0,188,0,8,0,124,0,8,0,252,0,8,0,2,0,8,0,130,0,8,0,66,0,8,0,194,0,8,0,34,0,8,0,162,0,8,0,98,0,8,0,226,0,8,0,18,0,8,0,146,0,8,0,82,0,8,0,210,0,8,0,50,0,8,0,178,0,8,0,114,0,8,0,242,0,8,0,10,0,8,0,138,0,8,0,74,0,8,0,202,0,8,0,42,0,8,0,170,0,8,0,106,0,8,0,234,0,8,0,26,0,8,0,154,0,8,0,90,0,8,0,218,0,8,0,58,0,8,0,186,0,8,0,122,0,8,0,250,0,8,0,6,0,8,0,134,0,8,0,70,0,8,0,198,0,8,0,38,0,8,0,166,0,8,0,102,0,8,0,230,0,8,0,22,0,8,0,150,0,8,0,86,0,8,0,214,0,8,0,54,0,8,0,182,0,8,0,118,0,8,
0,246,0,8,0,14,0,8,0,142,0,8,0,78,0,8,0,206,0,8,0,46,0,8,0,174,0,8,0,110,0,8,0,238,0,8,0,30,0,8,0,158,0,8,0,94,0,8,0,222,0,8,0,62,0,8,0,190,0,8,0,126,0,8,0,254,0,8,0,1,0,8,0,129,0,8,0,65,0,8,0,193,0,8,0,33,0,8,0,161,0,8,0,97,0,8,0,225,0,8,0,17,0,8,0,145,0,8,0,81,0,8,0,209,0,8,0,49,0,8,0,177,0,8,0,113,0,8,0,241,0,8,0,9,0,8,0,137,0,8,0,73,0,8,0,201,0,8,0,41,0,8,0,169,0,8,0,105,0,8,0,233,0,8,0,25,0,8,0,153,0,8,0,89,0,8,0,217,0,8,0,57,0,8,0,185,0,8,0,121,0,8,0,249,0,8,0,5,0,8,0,133,0,8,0,69,0,8,0,197,
0,8,0,37,0,8,0,165,0,8,0,101,0,8,0,229,0,8,0,21,0,8,0,149,0,8,0,85,0,8,0,213,0,8,0,53,0,8,0,181,0,8,0,117,0,8,0,245,0,8,0,13,0,8,0,141,0,8,0,77,0,8,0,205,0,8,0,45,0,8,0,173,0,8,0,109,0,8,0,237,0,8,0,29,0,8,0,157,0,8,0,93,0,8,0,221,0,8,0,61,0,8,0,189,0,8,0,125,0,8,0,253,0,8,0,19,0,9,0,19,1,9,0,147,0,9,0,147,1,9,0,83,0,9,0,83,1,9,0,211,0,9,0,211,1,9,0,51,0,9,0,51,1,9,0,179,0,9,0,179,1,9,0,115,0,9,0,115,1,9,0,243,0,9,0,243,1,9,0,11,0,9,0,11,1,9,0,139,0,9,0,139,1,9,0,75,0,9,0,75,1,9,0,203,0,9,0,203,1,
9,0,43,0,9,0,43,1,9,0,171,0,9,0,171,1,9,0,107,0,9,0,107,1,9,0,235,0,9,0,235,1,9,0,27,0,9,0,27,1,9,0,155,0,9,0,155,1,9,0,91,0,9,0,91,1,9,0,219,0,9,0,219,1,9,0,59,0,9,0,59,1,9,0,187,0,9,0,187,1,9,0,123,0,9,0,123,1,9,0,251,0,9,0,251,1,9,0,7,0,9,0,7,1,9,0,135,0,9,0,135,1,9,0,71,0,9,0,71,1,9,0,199,0,9,0,199,1,9,0,39,0,9,0,39,1,9,0,167,0,9,0,167,1,9,0,103,0,9,0,103,1,9,0,231,0,9,0,231,1,9,0,23,0,9,0,23,1,9,0,151,0,9,0,151,1,9,0,87,0,9,0,87,1,9,0,215,0,9,0,215,1,9,0,55,0,9,0,55,1,9,0,183,0,9,0,183,1,9,0,
119,0,9,0,119,1,9,0,247,0,9,0,247,1,9,0,15,0,9,0,15,1,9,0,143,0,9,0,143,1,9,0,79,0,9,0,79,1,9,0,207,0,9,0,207,1,9,0,47,0,9,0,47,1,9,0,175,0,9,0,175,1,9,0,111,0,9,0,111,1,9,0,239,0,9,0,239,1,9,0,31,0,9,0,31,1,9,0,159,0,9,0,159,1,9,0,95,0,9,0,95,1,9,0,223,0,9,0,223,1,9,0,63,0,9,0,63,1,9,0,191,0,9,0,191,1,9,0,127,0,9,0,127,1,9,0,255,0,9,0,255,1,9,0,0,0,7,0,64,0,7,0,32,0,7,0,96,0,7,0,16,0,7,0,80,0,7,0,48,0,7,0,112,0,7,0,8,0,7,0,72,0,7,0,40,0,7,0,104,0,7,0,24,0,7,0,88,0,7,0,56,0,7,0,120,0,7,0,4,0,7,0,
68,0,7,0,36,0,7,0,100,0,7,0,20,0,7,0,84,0,7,0,52,0,7,0,116,0,7,0,3,0,8,0,131,0,8,0,67,0,8,0,195,0,8,0,35,0,8,0,163,0,8,0,99,0,8,0,227,0,8,0,0,0,5,0,16,0,5,0,8,0,5,0,24,0,5,0,4,0,5,0,20,0,5,0,12,0,5,0,28,0,5,0,2,0,5,0,18,0,5,0,10,0,5,0,26,0,5,0,6,0,5,0,22,0,5,0,14,0,5,0,30,0,5,0,1,0,5,0,17,0,5,0,9,0,5,0,25,0,5,0,5,0,5,0,21,0,5,0,13,0,5,0,29,0,5,0,3,0,5,0,19,0,5,0,11,0,5,0,27,0,5,0,7,0,5,0,23,0,5,0,0,64,197,88,159,83,66,75,0,64,73,50,163,34,168,17,197,88,33,123,252,115,98,104,197,88,191,69,11,48,126,
24,159,83,252,115,65,109,84,98,159,83,179,65,65,45,18,23,66,75,98,104,84,98,126,88,66,75,33,59,186,40,195,20,0,64,197,88,159,83,66,75,0,64,73,50,163,34,168,17,73,50,191,69,179,65,33,59,73,50,130,39,55,27,224,13,163,34,11,48,65,45,186,40,163,34,55,27,191,18,142,9,168,17,126,24,18,23,195,20,168,17,224,13,142,9,223,4,112,115,101,117,100,111,45,0,84,73,70,70,83,101,116,70,105,101,108,100,0,37,115,58,32,85,110,107,110,111,119,110,32,37,115,116,97,103,32,37,117,0,37,115,58,32,67,97,110,110,111,116,32,109,
111,100,105,102,121,32,116,97,103,32,34,37,115,34,32,119,104,105,108,101,32,119,114,105,116,105,110,103,0,116,105,102,95,100,105,114,46,99,0,84,73,70,70,65,100,118,97,110,99,101,68,105,114,101,99,116,111,114,121,0,83,97,110,105,116,121,32,99,104,101,99,107,32,111,110,32,100,105,114,101,99,116,111,114,121,32,99,111,117,110,116,32,102,97,105,108,101,100,0,37,115,58,32,69,114,114,111,114,32,102,101,116,99,104,105,110,103,32,100,105,114,101,99,116,111,114,121,32,99,111,117,110,116,0,37,115,58,32,69,114,
114,111,114,32,102,101,116,99,104,105,110,103,32,100,105,114,101,99,116,111,114,121,32,108,105,110,107,0,95,84,73,70,70,86,71,101,116,70,105,101,108,100,0,37,115,58,32,73,110,118,97,108,105,100,32,37,115,116,97,103,32,34,37,115,34,32,40,110,111,116,32,115,117,112,112,111,114,116,101,100,32,98,121,32,99,111,100,101,99,41,0,116,118,45,62,99,111,117,110,116,32,61,61,32,49,0,78,111,110,115,116,97,110,100,97,114,100,32,116,105,108,101,32,119,105,100,116,104,32,37,100,44,32,99,111,110,118,101,114,116,32,
102,105,108,101,0,78,111,110,115,116,97,110,100,97,114,100,32,116,105,108,101,32,108,101,110,103,116,104,32,37,100,44,32,99,111,110,118,101,114,116,32,102,105,108,101,0,95,84,73,70,70,86,83,101,116,70,105,101,108,100,0,37,115,58,32,83,111,114,114,121,44,32,99,97,110,110,111,116,32,110,101,115,116,32,83,117,98,73,70,68,115,0,37,115,58,32,73,110,118,97,108,105,100,32,73,110,107,78,97,109,101,115,32,118,97,108,117,101,59,32,101,120,112,101,99,116,105,110,103,32,37,100,32,110,97,109,101,115,44,32,102,
111,117,110,100,32,37,100,0,37,115,58,32,70,97,105,108,101,100,32,116,111,32,97,108,108,111,99,97,116,101,32,115,112,97,99,101,32,102,111,114,32,108,105,115,116,32,111,102,32,99,117,115,116,111,109,32,118,97,108,117,101,115,0,37,115,58,32,66,97,100,32,102,105,101,108,100,32,116,121,112,101,32,37,100,32,102,111,114,32,34,37,115,34,0,102,105,112,45,62,102,105,101,108,100,95,119,114,105,116,101,99,111,117,110,116,61,61,84,73,70,70,95,86,65,82,73,65,66,76,69,50,0,37,115,58,32,78,117,108,108,32,99,111,
117,110,116,32,102,111,114,32,34,37,115,34,32,40,116,121,112,101,32,37,100,44,32,119,114,105,116,101,99,111,117,110,116,32,37,100,44,32,112,97,115,115,99,111,117,110,116,32,37,100,41,0,99,117,115,116,111,109,32,116,97,103,32,98,105,110,97,114,121,32,111,98,106,101,99,116,0,85,110,107,110,111,119,110,0,37,115,58,32,66,97,100,32,118,97,108,117,101,32,37,117,32,102,111,114,32,34,37,115,34,32,116,97,103,0,37,115,58,32,66,97,100,32,118,97,108,117,101,32,37,102,32,102,111,114,32,34,37,115,34,32,116,97,
103,0,84,97,103,32,0,95,84,73,70,70,83,101,116,117,112,70,105,101,108,100,115,0,83,101,116,116,105,110,103,32,117,112,32,102,105,101,108,100,32,105,110,102,111,32,102,97,105,108,101,100,0,102,111,114,32,102,105,101,108,100,115,32,97,114,114,97,121,0,95,84,73,70,70,77,101,114,103,101,70,105,101,108,100,115,0,70,97,105,108,101,100,32,116,111,32,97,108,108,111,99,97,116,101,32,102,105,101,108,100,115,32,97,114,114,97,121,0,84,73,70,70,70,105,101,108,100,87,105,116,104,84,97,103,0,73,110,116,101,114,
110,97,108,32,101,114,114,111,114,44,32,117,110,107,110,111,119,110,32,116,97,103,32,48,120,37,120,0,84,97,103,32,37,100,0,69,120,112,111,115,117,114,101,84,105,109,101,0,70,78,117,109,98,101,114,0,69,120,112,111,115,117,114,101,80,114,111,103,114,97,109,0,83,112,101,99,116,114,97,108,83,101,110,115,105,116,105,118,105,116,121,0,73,83,79,83,112,101,101,100,82,97,116,105,110,103,115,0,79,112,116,111,101,108,101,99,116,114,105,99,67,111,110,118,101,114,115,105,111,110,70,97,99,116,111,114,0,69,120,
105,102,86,101,114,115,105,111,110,0,68,97,116,101,84,105,109,101,79,114,105,103,105,110,97,108,0,68,97,116,101,84,105,109,101,68,105,103,105,116,105,122,101,100,0,67,111,109,112,111,110,101,110,116,115,67,111,110,102,105,103,117,114,97,116,105,111,110,0,67,111,109,112,114,101,115,115,101,100,66,105,116,115,80,101,114,80,105,120,101,108,0,83,104,117,116,116,101,114,83,112,101,101,100,86,97,108,117,101,0,65,112,101,114,116,117,114,101,86,97,108,117,101,0,66,114,105,103,104,116,110,101,115,115,86,97,
108,117,101,0,69,120,112,111,115,117,114,101,66,105,97,115,86,97,108,117,101,0,77,97,120,65,112,101,114,116,117,114,101,86,97,108,117,101,0,83,117,98,106,101,99,116,68,105,115,116,97,110,99,101,0,77,101,116,101,114,105,110,103,77,111,100,101,0,76,105,103,104,116,83,111,117,114,99,101,0,70,108,97,115,104,0,70,111,99,97,108,76,101,110,103,116,104,0,83,117,98,106,101,99,116,65,114,101,97,0,77,97,107,101,114,78,111,116,101,0,85,115,101,114,67,111,109,109,101,110,116,0,83,117,98,83,101,99,84,105,109,101,
0,83,117,98,83,101,99,84,105,109,101,79,114,105,103,105,110,97,108,0,83,117,98,83,101,99,84,105,109,101,68,105,103,105,116,105,122,101,100,0,70,108,97,115,104,112,105,120,86,101,114,115,105,111,110,0,67,111,108,111,114,83,112,97,99,101,0,80,105,120,101,108,88,68,105,109,101,110,115,105,111,110,0,80,105,120,101,108,89,68,105,109,101,110,115,105,111,110,0,82,101,108,97,116,101,100,83,111,117,110,100,70,105,108,101,0,70,108,97,115,104,69,110,101,114,103,121,0,83,112,97,116,105,97,108,70,114,101,113,
117,101,110,99,121,82,101,115,112,111,110,115,101,0,70,111,99,97,108,80,108,97,110,101,88,82,101,115,111,108,117,116,105,111,110,0,70,111,99,97,108,80,108,97,110,101,89,82,101,115,111,108,117,116,105,111,110,0,70,111,99,97,108,80,108,97,110,101,82,101,115,111,108,117,116,105,111,110,85,110,105,116,0,83,117,98,106,101,99,116,76,111,99,97,116,105,111,110,0,69,120,112,111,115,117,114,101,73,110,100,101,120,0,83,101,110,115,105,110,103,77,101,116,104,111,100,0,70,105,108,101,83,111,117,114,99,101,0,83,
99,101,110,101,84,121,112,101,0,67,70,65,80,97,116,116,101,114,110,0,67,117,115,116,111,109,82,101,110,100,101,114,101,100,0,69,120,112,111,115,117,114,101,77,111,100,101,0,87,104,105,116,101,66,97,108,97,110,99,101,0,68,105,103,105,116,97,108,90,111,111,109,82,97,116,105,111,0,70,111,99,97,108,76,101,110,103,116,104,73,110,51,53,109,109,70,105,108,109,0,83,99,101,110,101,67,97,112,116,117,114,101,84,121,112,101,0,71,97,105,110,67,111,110,116,114,111,108,0,67,111,110,116,114,97,115,116,0,83,97,116,
117,114,97,116,105,111,110,0,83,104,97,114,112,110,101,115,115,0,68,101,118,105,99,101,83,101,116,116,105,110,103,68,101,115,99,114,105,112,116,105,111,110,0,83,117,98,106,101,99,116,68,105,115,116,97,110,99,101,82,97,110,103,101,0,73,109,97,103,101,85,110,105,113,117,101,73,68,0,83,117,98,102,105,108,101,84,121,112,101,0,79,108,100,83,117,98,102,105,108,101,84,121,112,101,0,73,109,97,103,101,87,105,100,116,104,0,66,105,116,115,80,101,114,83,97,109,112,108,101,0,80,104,111,116,111,109,101,116,114,
105,99,73,110,116,101,114,112,114,101,116,97,116,105,111,110,0,84,104,114,101,115,104,104,111,108,100,105,110,103,0,67,101,108,108,87,105,100,116,104,0,67,101,108,108,76,101,110,103,116,104,0,70,105,108,108,79,114,100,101,114,0,68,111,99,117,109,101,110,116,78,97,109,101,0,73,109,97,103,101,68,101,115,99,114,105,112,116,105,111,110,0,77,97,107,101,0,77,111,100,101,108,0,79,114,105,101,110,116,97,116,105,111,110,0,83,97,109,112,108,101,115,80,101,114,80,105,120,101,108,0,82,111,119,115,80,101,114,
83,116,114,105,112,0,77,105,110,83,97,109,112,108,101,86,97,108,117,101,0,77,97,120,83,97,109,112,108,101,86,97,108,117,101,0,88,82,101,115,111,108,117,116,105,111,110,0,89,82,101,115,111,108,117,116,105,111,110,0,80,108,97,110,97,114,67,111,110,102,105,103,117,114,97,116,105,111,110,0,80,97,103,101,78,97,109,101,0,88,80,111,115,105,116,105,111,110,0,89,80,111,115,105,116,105,111,110,0,70,114,101,101,79,102,102,115,101,116,115,0,70,114,101,101,66,121,116,101,67,111,117,110,116,115,0,71,114,97,121,
82,101,115,112,111,110,115,101,85,110,105,116,0,71,114,97,121,82,101,115,112,111,110,115,101,67,117,114,118,101,0,82,101,115,111,108,117,116,105,111,110,85,110,105,116,0,80,97,103,101,78,117,109,98,101,114,0,67,111,108,111,114,82,101,115,112,111,110,115,101,85,110,105,116,0,84,114,97,110,115,102,101,114,70,117,110,99,116,105,111,110,0,83,111,102,116,119,97,114,101,0,68,97,116,101,84,105,109,101,0,65,114,116,105,115,116,0,72,111,115,116,67,111,109,112,117,116,101,114,0,87,104,105,116,101,80,111,105,
110,116,0,80,114,105,109,97,114,121,67,104,114,111,109,97,116,105,99,105,116,105,101,115,0,67,111,108,111,114,77,97,112,0,72,97,108,102,116,111,110,101,72,105,110,116,115,0,84,105,108,101,87,105,100,116,104,0,84,105,108,101,76,101,110,103,116,104,0,84,105,108,101,66,121,116,101,67,111,117,110,116,115,0,83,117,98,73,70,68,0,73,110,107,78,97,109,101,115,0,78,117,109,98,101,114,79,102,73,110,107,115,0,68,111,116,82,97,110,103,101,0,84,97,114,103,101,116,80,114,105,110,116,101,114,0,69,120,116,114,97,
83,97,109,112,108,101,115,0,83,97,109,112,108,101,70,111,114,109,97,116,0,83,77,105,110,83,97,109,112,108,101,86,97,108,117,101,0,83,77,97,120,83,97,109,112,108,101,86,97,108,117,101,0,67,108,105,112,80,97,116,104,0,88,67,108,105,112,80,97,116,104,85,110,105,116,115,0,89,67,108,105,112,80,97,116,104,85,110,105,116,115,0,89,67,98,67,114,67,111,101,102,102,105,99,105,101,110,116,115,0,89,67,98,67,114,83,117,98,115,97,109,112,108,105,110,103,0,89,67,98,67,114,80,111,115,105,116,105,111,110,105,110,103,
0,82,101,102,101,114,101,110,99,101,66,108,97,99,107,87,104,105,116,101,0,88,77,76,80,97,99,107,101,116,0,77,97,116,116,101,105,110,103,0,68,97,116,97,84,121,112,101,0,73,109,97,103,101,68,101,112,116,104,0,84,105,108,101,68,101,112,116,104,0,73,109,97,103,101,70,117,108,108,87,105,100,116,104,0,73,109,97,103,101,70,117,108,108,76,101,110,103,116,104,0,84,101,120,116,117,114,101,70,111,114,109,97,116,0,84,101,120,116,117,114,101,87,114,97,112,77,111,100,101,115,0,70,105,101,108,100,79,102,86,105,
101,119,67,111,116,97,110,103,101,110,116,0,77,97,116,114,105,120,87,111,114,108,100,84,111,83,99,114,101,101,110,0,77,97,116,114,105,120,87,111,114,108,100,84,111,67,97,109,101,114,97,0,67,70,65,82,101,112,101,97,116,80,97,116,116,101,114,110,68,105,109,0,67,111,112,121,114,105,103,104,116,0,82,105,99,104,84,73,70,70,73,80,84,67,0,80,104,111,116,111,115,104,111,112,0,69,88,73,70,73,70,68,79,102,102,115,101,116,0,73,67,67,32,80,114,111,102,105,108,101,0,71,80,83,73,70,68,79,102,102,115,101,116,0,
70,97,120,82,101,99,118,80,97,114,97,109,115,0,70,97,120,83,117,98,65,100,100,114,101,115,115,0,70,97,120,82,101,99,118,84,105,109,101,0,70,97,120,68,99,115,0,83,116,111,78,105,116,115,0,73,110,116,101,114,111,112,101,114,97,98,105,108,105,116,121,73,70,68,79,102,102,115,101,116,0,68,78,71,86,101,114,115,105,111,110,0,68,78,71,66,97,99,107,119,97,114,100,86,101,114,115,105,111,110,0,85,110,105,113,117,101,67,97,109,101,114,97,77,111,100,101,108,0,76,111,99,97,108,105,122,101,100,67,97,109,101,114,
97,77,111,100,101,108,0,67,70,65,80,108,97,110,101,67,111,108,111,114,0,67,70,65,76,97,121,111,117,116,0,76,105,110,101,97,114,105,122,97,116,105,111,110,84,97,98,108,101,0,66,108,97,99,107,76,101,118,101,108,82,101,112,101,97,116,68,105,109,0,66,108,97,99,107,76,101,118,101,108,0,66,108,97,99,107,76,101,118,101,108,68,101,108,116,97,72,0,66,108,97,99,107,76,101,118,101,108,68,101,108,116,97,86,0,87,104,105,116,101,76,101,118,101,108,0,68,101,102,97,117,108,116,83,99,97,108,101,0,66,101,115,116,81,
117,97,108,105,116,121,83,99,97,108,101,0,68,101,102,97,117,108,116,67,114,111,112,79,114,105,103,105,110,0,68,101,102,97,117,108,116,67,114,111,112,83,105,122,101,0,67,111,108,111,114,77,97,116,114,105,120,49,0,67,111,108,111,114,77,97,116,114,105,120,50,0,67,97,109,101,114,97,67,97,108,105,98,114,97,116,105,111,110,49,0,67,97,109,101,114,97,67,97,108,105,98,114,97,116,105,111,110,50,0,82,101,100,117,99,116,105,111,110,77,97,116,114,105,120,49,0,82,101,100,117,99,116,105,111,110,77,97,116,114,105,
120,50,0,65,110,97,108,111,103,66,97,108,97,110,99,101,0,65,115,83,104,111,116,78,101,117,116,114,97,108,0,65,115,83,104,111,116,87,104,105,116,101,88,89,0,66,97,115,101,108,105,110,101,69,120,112,111,115,117,114,101,0,66,97,115,101,108,105,110,101,78,111,105,115,101,0,66,97,115,101,108,105,110,101,83,104,97,114,112,110,101,115,115,0,66,97,121,101,114,71,114,101,101,110,83,112,108,105,116,0,76,105,110,101,97,114,82,101,115,112,111,110,115,101,76,105,109,105,116,0,67,97,109,101,114,97,83,101,114,105,
97,108,78,117,109,98,101,114,0,76,101,110,115,73,110,102,111,0,67,104,114,111,109,97,66,108,117,114,82,97,100,105,117,115,0,65,110,116,105,65,108,105,97,115,83,116,114,101,110,103,116,104,0,83,104,97,100,111,119,83,99,97,108,101,0,68,78,71,80,114,105,118,97,116,101,68,97,116,97,0,77,97,107,101,114,78,111,116,101,83,97,102,101,116,121,0,67,97,108,105,98,114,97,116,105,111,110,73,108,108,117,109,105,110,97,110,116,49,0,67,97,108,105,98,114,97,116,105,111,110,73,108,108,117,109,105,110,97,110,116,50,
0,82,97,119,68,97,116,97,85,110,105,113,117,101,73,68,0,79,114,105,103,105,110,97,108,82,97,119,70,105,108,101,78,97,109,101,0,79,114,105,103,105,110,97,108,82,97,119,70,105,108,101,68,97,116,97,0,65,99,116,105,118,101,65,114,101,97,0,77,97,115,107,101,100,65,114,101,97,115,0,65,115,83,104,111,116,73,67,67,80,114,111,102,105,108,101,0,65,115,83,104,111,116,80,114,101,80,114,111,102,105,108,101,77,97,116,114,105,120,0,67,117,114,114,101,110,116,73,67,67,80,114,111,102,105,108,101,0,67,117,114,114,
101,110,116,80,114,101,80,114,111,102,105,108,101,77,97,116,114,105,120,0,80,101,114,83,97,109,112,108,101,0,73,110,100,101,120,101,100,0,71,108,111,98,97,108,80,97,114,97,109,101,116,101,114,115,73,70,68,0,80,114,111,102,105,108,101,84,121,112,101,0,70,97,120,80,114,111,102,105,108,101,0,67,111,100,105,110,103,77,101,116,104,111,100,115,0,86,101,114,115,105,111,110,89,101,97,114,0,77,111,100,101,78,117,109,98,101,114,0,68,101,99,111,100,101,0,73,109,97,103,101,66,97,115,101,67,111,108,111,114,0,
84,56,50,79,112,116,105,111,110,115,0,83,116,114,105,112,82,111,119,67,111,117,110,116,115,0,73,109,97,103,101,76,97,121,101,114,0,84,73,70,70,67,104,101,99,107,68,105,114,79,102,102,115,101,116,0,67,97,110,110,111,116,32,104,97,110,100,108,101,32,109,111,114,101,32,116,104,97,110,32,54,53,53,51,53,32,84,73,70,70,32,100,105,114,101,99,116,111,114,105,101,115,0,102,111,114,32,73,70,68,32,108,105,115,116,0,84,73,70,70,82,101,97,100,68,105,114,101,99,116,111,114,121,0,70,97,105,108,101,100,32,116,111,
32,114,101,97,100,32,100,105,114,101,99,116,111,114,121,32,97,116,32,111,102,102,115,101,116,32,37,108,117,0,84,73,70,70,82,101,97,100,68,105,114,101,99,116,111,114,121,67,104,101,99,107,79,114,100,101,114,0,73,110,118,97,108,105,100,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,59,32,116,97,103,115,32,97,114,101,32,110,111,116,32,115,111,114,116,101,100,32,105,110,32,97,115,99,101,110,100,105,110,103,32,111,114,100,101,114,0,85,110,107,110,111,119,110,32,102,105,101,108,100,32,119,105,116,
104,32,116,97,103,32,37,100,32,40,48,120,37,120,41,32,101,110,99,111,117,110,116,101,114,101,100,0,82,101,103,105,115,116,101,114,105,110,103,32,97,110,111,110,121,109,111,117,115,32,102,105,101,108,100,32,119,105,116,104,32,116,97,103,32,37,100,32,40,48,120,37,120,41,32,102,97,105,108,101,100,0,102,105,105,32,33,61,32,70,65,73,76],"i8",4,ra.GLOBAL_BASE+122916);vc([69,68,95,70,73,73,0,116,105,102,95,100,105,114,114,101,97,100,46,99,0,80,108,97,110,97,114,99,111,110,102,105,103,32,116,97,103,32,118,
97,108,117,101,32,97,115,115,117,109,101,100,32,105,110,99,111,114,114,101,99,116,44,32,97,115,115,117,109,105,110,103,32,100,97,116,97,32,105,115,32,99,111,110,116,105,103,32,105,110,115,116,101,97,100,32,111,102,32,99,104,117,110,107,121,0,77,105,115,115,105,110,103,82,101,113,117,105,114,101,100,0,84,73,70,70,32,100,105,114,101,99,116,111,114,121,32,105,115,32,109,105,115,115,105,110,103,32,114,101,113,117,105,114,101,100,32,34,37,115,34,32,102,105,101,108,100,0,73,109,97,103,101,76,101,110,103,
116,104,0,116,105,108,101,115,0,115,116,114,105,112,115,0,67,97,110,110,111,116,32,104,97,110,100,108,101,32,122,101,114,111,32,110,117,109,98,101,114,32,111,102,32,37,115,0,84,105,108,101,79,102,102,115,101,116,115,0,83,116,114,105,112,79,102,102,115,101,116,115,0,117,110,107,110,111,119,110,32,116,97,103,110,97,109,101,0,73,103,110,111,114,105,110,103,32,37,115,32,115,105,110,99,101,32,66,105,116,115,80,101,114,83,97,109,112,108,101,32,116,97,103,32,110,111,116,32,102,111,117,110,100,0,80,104,111,
116,111,109,101,116,114,105,99,32,116,97,103,32,105,115,32,109,105,115,115,105,110,103,44,32,97,115,115,117,109,105,110,103,32,100,97,116,97,32,105,115,32,89,67,98,67,114,0,80,104,111,116,111,109,101,116,114,105,99,32,116,97,103,32,118,97,108,117,101,32,97,115,115,117,109,101,100,32,105,110,99,111,114,114,101,99,116,44,32,97,115,115,117,109,105,110,103,32,100,97,116,97,32,105,115,32,89,67,98,67,114,32,105,110,115,116,101,97,100,32,111,102,32,82,71,66,0,66,105,116,115,80,101,114,83,97,109,112,108,
101,32,116,97,103,32,105,115,32,109,105,115,115,105,110,103,44,32,97,115,115,117,109,105,110,103,32,56,32,98,105,116,115,32,112,101,114,32,115,97,109,112,108,101,0,83,97,109,112,108,101,115,80,101,114,80,105,120,101,108,32,116,97,103,32,105,115,32,109,105,115,115,105,110,103,44,32,97,115,115,117,109,105,110,103,32,99,111,114,114,101,99,116,32,83,97,109,112,108,101,115,80,101,114,80,105,120,101,108,32,118,97,108,117,101,32,105,115,32,51,0,83,97,109,112,108,101,115,80,101,114,80,105,120,101,108,32,
116,97,103,32,105,115,32,109,105,115,115,105,110,103,44,32,97,112,112,108,121,105,110,103,32,99,111,114,114,101,99,116,32,83,97,109,112,108,101,115,80,101,114,80,105,120,101,108,32,118,97,108,117,101,32,111,102,32,51,0,67,111,108,111,114,109,97,112,0,83,116,114,105,112,66,121,116,101,67,111,117,110,116,115,0,84,73,70,70,32,100,105,114,101,99,116,111,114,121,32,105,115,32,109,105,115,115,105,110,103,32,114,101,113,117,105,114,101,100,32,34,83,116,114,105,112,66,121,116,101,67,111,117,110,116,115,34,
32,102,105,101,108,100,44,32,99,97,108,99,117,108,97,116,105,110,103,32,102,114,111,109,32,105,109,97,103,101,108,101,110,103,116,104,0,66,111,103,117,115,32,34,83,116,114,105,112,66,121,116,101,67,111,117,110,116,115,34,32,102,105,101,108,100,44,32,105,103,110,111,114,105,110,103,32,97,110,100,32,99,97,108,99,117,108,97,116,105,110,103,32,102,114,111,109,32,105,109,97,103,101,108,101,110,103,116,104,0,87,114,111,110,103,32,34,83,116,114,105,112,66,121,116,101,67,111,117,110,116,115,34,32,102,105,
101,108,100,44,32,105,103,110,111,114,105,110,103,32,97,110,100,32,99,97,108,99,117,108,97,116,105,110,103,32,102,114,111,109,32,105,109,97,103,101,108,101,110,103,116,104,0,102,111,114,32,99,104,111,112,112,101,100,32,34,83,116,114,105,112,66,121,116,101,67,111,117,110,116,115,34,32,97,114,114,97,121,0,102,111,114,32,99,104,111,112,112,101,100,32,34,83,116,114,105,112,79,102,102,115,101,116,115,34,32,97,114,114,97,121,0,67,97,110,110,111,116,32,104,97,110,100,108,101,32,122,101,114,111,32,115,99,
97,110,108,105,110,101,32,115,105,122,101,0,67,97,110,110,111,116,32,104,97,110,100,108,101,32,122,101,114,111,32,116,105,108,101,32,115,105,122,101,0,67,97,110,110,111,116,32,104,97,110,100,108,101,32,122,101,114,111,32,115,116,114,105,112,32,115,105,122,101,0,102,111,114,32,34,83,116,114,105,112,66,121,116,101,67,111,117,110,116,115,34,32,97,114,114,97,121,0,69,115,116,105,109,97,116,101,83,116,114,105,112,66,121,116,101,67,111,117,110,116,115,0,67,97,110,110,111,116,32,100,101,116,101,114,109,
105,110,101,32,115,105,122,101,32,111,102,32,117,110,107,110,111,119,110,32,116,97,103,32,116,121,112,101,32,37,100,0,84,73,70,70,70,101,116,99,104,83,116,114,105,112,84,104,105,110,103,0,102,111,114,32,115,116,114,105,112,32,97,114,114,97,121,0,40,116,109,115,105,122,101,95,116,41,100,97,116,97,115,105,122,101,62,48,0,84,73,70,70,82,101,97,100,68,105,114,69,110,116,114,121,65,114,114,97,121,0,82,101,97,100,68,105,114,69,110,116,114,121,65,114,114,97,121,0,73,110,99,111,114,114,101,99,116,32,99,111,
117,110,116,32,102,111,114,32,34,37,115,34,0,73,110,99,111,109,112,97,116,105,98,108,101,32,116,121,112,101,32,102,111,114,32,34,37,115,34,0,73,79,32,101,114,114,111,114,32,100,117,114,105,110,103,32,114,101,97,100,105,110,103,32,111,102,32,34,37,115,34,0,73,110,99,111,114,114,101,99,116,32,118,97,108,117,101,32,102,111,114,32,34,37,115,34,0,67,97,110,110,111,116,32,104,97,110,100,108,101,32,100,105,102,102,101,114,101,110,116,32,118,97,108,117,101,115,32,112,101,114,32,115,97,109,112,108,101,32,
102,111,114,32,34,37,115,34,0,83,97,110,105,116,121,32,99,104,101,99,107,32,111,110,32,115,105,122,101,32,111,102,32,34,37,115,34,32,118,97,108,117,101,32,102,97,105,108,101,100,0,79,117,116,32,111,102,32,109,101,109,111,114,121,32,114,101,97,100,105,110,103,32,111,102,32,34,37,115,34,0,84,73,70,70,82,101,97,100,68,105,114,69,110,116,114,121,79,117,116,112,117,116,69,114,114,0,73,110,99,111,114,114,101,99,116,32,99,111,117,110,116,32,102,111,114,32,34,37,115,34,59,32,116,97,103,32,105,103,110,111,
114,101,100,0,73,110,99,111,109,112,97,116,105,98,108,101,32,116,121,112,101,32,102,111,114,32,34,37,115,34,59,32,116,97,103,32,105,103,110,111,114,101,100,0,73,79,32,101,114,114,111,114,32,100,117,114,105,110,103,32,114,101,97,100,105,110,103,32,111,102,32,34,37,115,34,59,32,116,97,103,32,105,103,110,111,114,101,100,0,73,110,99,111,114,114,101,99,116,32,118,97,108,117,101,32,102,111,114,32,34,37,115,34,59,32,116,97,103,32,105,103,110,111,114,101,100,0,67,97,110,110,111,116,32,104,97,110,100,108,
101,32,100,105,102,102,101,114,101,110,116,32,118,97,108,117,101,115,32,112,101,114,32,115,97,109,112,108,101,32,102,111,114,32,34,37,115,34,59,32,116,97,103,32,105,103,110,111,114,101,100,0,83,97,110,105,116,121,32,99,104,101,99,107,32,111,110,32,115,105,122,101,32,111,102,32,34,37,115,34,32,118,97,108,117,101,32,102,97,105,108,101,100,59,32,116,97,103,32,105,103,110,111,114,101,100,0,79,117,116,32,111,102,32,109,101,109,111,114,121,32,114,101,97,100,105,110,103,32,111,102,32,34,37,115,34,59,32,
116,97,103,32,105,103,110,111,114,101,100,0,84,73,70,70,70,101,116,99,104,78,111,114,109,97,108,84,97,103,0,78,111,32,100,101,102,105,110,105,116,105,111,110,32,102,111,117,110,100,32,102,111,114,32,116,97,103,32,37,100,0,102,105,112,32,33,61,32,78,85,76,76,0,102,105,112,45,62,115,101,116,95,102,105,101,108,100,95,116,121,112,101,33,61,84,73,70,70,95,83,69,84,71,69,84,95,79,84,72,69,82,0,102,105,112,45,62,115,101,116,95,102,105,101,108,100,95,116,121,112,101,33,61,84,73,70,70,95,83,69,84,71,69,84,
95,73,78,84,0,102,105,112,45,62,102,105,101,108,100,95,112,97,115,115,99,111,117,110,116,61,61,48,0,65,83,67,73,73,32,118,97,108,117,101,32,102,111,114,32,116,97,103,32,34,37,115,34,32,99,111,110,116,97,105,110,115,32,110,117,108,108,32,98,121,116,101,32,105,110,32,118,97,108,117,101,59,32,118,97,108,117,101,32,105,110,99,111,114,114,101,99,116,108,121,32,116,114,117,110,99,97,116,101,100,32,100,117,114,105,110,103,32,114,101,97,100,105,110,103,32,100,117,101,32,116,111,32,105,109,112,108,101,109,
101,110,116,97,116,105,111,110,32,108,105,109,105,116,97,116,105,111,110,115,0,65,83,67,73,73,32,118,97,108,117,101,32,102,111,114,32,116,97,103,32,34,37,115,34,32,100,111,101,115,32,110,111,116,32,101,110,100,32,105,110,32,110,117,108,108,32,98,121,116,101,0,102,105,112,45,62,102,105,101,108,100,95,114,101,97,100,99,111,117,110,116,61,61,49,0,102,105,112,45,62,102,105,101,108,100,95,114,101,97,100,99,111,117,110,116,61,61,50,0,105,110,99,111,114,114,101,99,116,32,99,111,117,110,116,32,102,111,114,
32,102,105,101,108,100,32,34,37,115,34,44,32,101,120,112,101,99,116,101,100,32,50,44,32,103,111,116,32,37,100,0,102,105,112,45,62,102,105,101,108,100,95,114,101,97,100,99,111,117,110,116,62,61,49,0,105,110,99,111,114,114,101,99,116,32,99,111,117,110,116,32,102,111,114,32,102,105,101,108,100,32,34,37,115,34,44,32,101,120,112,101,99,116,101,100,32,37,100,44,32,103,111,116,32,37,100,0,102,105,112,45,62,102,105,101,108,100,95,114,101,97,100,99,111,117,110,116,61,61,84,73,70,70,95,86,65,82,73,65,66,76,
69,0,102,105,112,45,62,102,105,101,108,100,95,112,97,115,115,99,111,117,110,116,61,61,49,0,102,105,112,45,62,102,105,101,108,100,95,114,101,97,100,99,111,117,110,116,61,61,84,73,70,70,95,86,65,82,73,65,66,76,69,50,0,112,100,105,114,0,84,73,70,70,70,101,116,99,104,68,105,114,101,99,116,111,114,121,0,83,97,110,105,116,121,32,99,104,101,99,107,32,111,110,32,100,105,114,101,99,116,111,114,121,32,99,111,117,110,116,32,102,97,105,108,101,100,44,32,116,104,105,115,32,105,115,32,112,114,111,98,97,98,108,
121,32,110,111,116,32,97,32,118,97,108,105,100,32,73,70,68,32,111,102,102,115,101,116,0,116,111,32,114,101,97,100,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,0,37,46,49,48,48,115,58,32,67,97,110,32,110,111,116,32,114,101,97,100,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,0,67,97,110,32,110,111,116,32,114,101,97,100,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,32,99,111,117,110,116,0,83,97,110,105,116,121,32,99,104,101,99,107,32,111,110,32,100,105,114,101,99,116,111,114,121,
32,99,111,117,110,116,32,102,97,105,108,101,100,44,32,122,101,114,111,32,116,97,103,32,100,105,114,101,99,116,111,114,105,101,115,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,67,97,110,32,110,111,116,32,114,101,97,100,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,0,83,111,114,114,121,44,32,114,101,113,117,101,115,116,101,100,32,99,111,109,112,114,101,115,115,105,111,110,32,109,101,116,104,111,100,32,105,115,32,110,111,116,32,99,111,110,102,105,103,117,114,101,100,0,83,111,114,114,
121,44,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,105,109,97,103,101,115,32,119,105,116,104,32,37,100,45,98,105,116,32,115,97,109,112,108,101,115,0,77,105,115,115,105,110,103,32,110,101,101,100,101,100,32,37,115,32,116,97,103,0,83,111,114,114,121,44,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,99,111,110,116,105,103,117,111,117,115,32,100,97,116,97,32,119,105,116,104,32,37,115,61,37,100,44,32,97,110,100,32,37,115,61,37,100,32,97,110,100,32,66,105,116,115,47,83,97,109,112,
108,101,61,37,100,0,83,97,109,112,108,101,115,47,112,105,120,101,108,0,83,111,114,114,121,44,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,82,71,66,32,105,109,97,103,101,32,119,105,116,104,32,37,115,61,37,100,0,67,111,108,111,114,32,99,104,97,110,110,101,108,115,0,83,111,114,114,121,44,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,115,101,112,97,114,97,116,101,100,32,105,109,97,103,101,32,119,105,116,104,32,37,115,61,37,100,0,73,110,107,83,101,116,0,83,111,114,114,121,44,32,
76,111,103,76,32,100,97,116,97,32,109,117,115,116,32,104,97,118,101,32,37,115,61,37,100,0,67,111,109,112,114,101,115,115,105,111,110,0,83,111,114,114,121,44,32,76,111,103,76,117,118,32,100,97,116,97,32,109,117,115,116,32,104,97,118,101,32,37,115,61,37,100,32,111,114,32,37,100,0,83,111,114,114,121,44,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,76,111,103,76,117,118,32,105,109,97,103,101,115,32,119,105,116,104,32,37,115,61,37,100,0,80,108,97,110,97,114,99,111,110,102,105,103,117,114,97,
116,105,111,110,0,83,111,114,114,121,44,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,105,109,97,103,101,32,119,105,116,104,32,37,115,61,37,100,0,83,111,114,114,121,44,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,105,109,97,103,101,32,119,105,116,104,32,37,115,61,37,100,32,97,110,100,32,37,115,61,37,100,0,66,105,116,115,47,115,97,109,112,108,101,0,77,105,115,115,105,110,103,32,114,101,113,117,105,114,101,100,32,34,67,111,108,111,114,109,97,112,34,32,116,97,103,0,79,117,116,
32,111,102,32,109,101,109,111,114,121,32,102,111,114,32,99,111,108,111,114,109,97,112,32,99,111,112,121,0,105,109,103,45,62,85,97,84,111,65,97,61,61,78,85,76,76,0,116,105,102,95,103,101,116,105,109,97,103,101,46,99,0,66,117,105,108,100,77,97,112,85,97,84,111,65,97,0,105,109,103,45,62,66,105,116,100,101,112,116,104,49,54,84,111,56,61,61,78,85,76,76,0,66,117,105,108,100,77,97,112,66,105,116,100,101,112,116,104,49,54,84,111,56,0,105,110,105,116,67,73,69,76,97,98,67,111,110,118,101,114,115,105,111,110,
0,78,111,32,115,112,97,99,101,32,102,111,114,32,67,73,69,32,76,42,97,42,98,42,45,62,82,71,66,32,99,111,110,118,101,114,115,105,111,110,32,115,116,97,116,101,46,0,70,97,105,108,101,100,32,116,111,32,105,110,105,116,105,97,108,105,122,101,32,67,73,69,32,76,42,97,42,98,42,45,62,82,71,66,32,99,111,110,118,101,114,115,105,111,110,32,115,116,97,116,101,46,0,83,111,114,114,121,44,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,105,109,97,103,101,0,78,111,32,34,103,101,116,34,32,114,111,117,116,
105,110,101,32,115,101,116,117,112,0,78,111,32,34,112,117,116,34,32,114,111,117,116,105,110,101,32,115,101,116,117,112,108,59,32,112,114,111,98,97,98,108,121,32,99,97,110,32,110,111,116,32,104,97,110,100,108,101,32,105,109,97,103,101,32,102,111,114,109,97,116,0,103,116,83,116,114,105,112,83,101,112,97,114,97,116,101,0,78,111,32,115,112,97,99,101,32,102,111,114,32,116,105,108,101,32,98,117,102,102,101,114,0,103,116,84,105,108,101,83,101,112,97,114,97,116,101,0,105,110,105,116,89,67,98,67,114,67,111,
110,118,101,114,115,105,111,110,0,78,111,32,115,112,97,99,101,32,102,111,114,32,89,67,98,67,114,45,62,82,71,66,32,99,111,110,118,101,114,115,105,111,110,32,115,116,97,116,101,0,78,111,32,115,112,97,99,101,32,102,111,114,32,112,104,111,116,111,109,101,116,114,105,99,32,99,111,110,118,101,114,115,105,111,110,32,116,97,98,108,101,0,78,111,32,115,112,97,99,101,32,102,111,114,32,66,38,87,32,109,97,112,112,105,110,103,32,116,97,98,108,101,0,65,115,115,117,109,105,110,103,32,56,45,98,105,116,32,99,111,108,
111,114,109,97,112,0,78,111,32,115,112,97,99,101,32,102,111,114,32,80,97,108,101,116,116,101,32,109,97,112,112,105,110,103,32,116,97,98,108,101,0,73,110,118,97,108,105,100,32,118,101,114,116,105,99,97,108,32,89,67,98,67,114,32,115,117,98,115,97,109,112,108,105,110,103,0,78,111,32,115,112,97,99,101,32,102,111,114,32,115,116,114,105,112,32,98,117,102,102,101,114,0,34,37,115,34,58,32,66,97,100,32,109,111,100,101,0,84,73,70,70,67,108,105,101,110,116,79,112,101,110,0,37,115,58,32,79,117,116,32,111,102,
32,109,101,109,111,114,121,32,40,84,73,70,70,32,115,116,114,117,99,116,117,114,101,41,0,79,110,101,32,111,102,32,116,104,101,32,99,108,105,101,110,116,32,112,114,111,99,101,100,117,114,101,115,32,105,115,32,78,85,76,76,32,112,111,105,110,116,101,114,46,0,67,97,110,110,111,116,32,114,101,97,100,32,84,73,70,70,32,104,101,97,100,101,114,0,78,111,116,32,97,32,84,73,70,70,32,111,114,32,77,68,73,32,102,105,108,101,44,32,98,97,100,32,109,97,103,105,99,32,110,117,109,98,101,114,32,37,100,32,40,48,120,37,
120,41,0,78,111,116,32,97,32,84,73,70,70,32,102,105,108,101,44,32,98,97,100,32,118,101,114,115,105,111,110,32,110,117,109,98,101,114,32,37,100,32,40,48,120,37,120,41,0,78,111,116,32,97,32,84,73,70,70,32,102,105,108,101,44,32,98,97,100,32,66,105,103,84,73,70,70,32,111,102,102,115,101,116,115,105,122,101,32,37,100,32,40,48,120,37,120,41,0,78,111,116,32,97,32,84,73,70,70,32,102,105,108,101,44,32,98,97,100,32,66,105,103,84,73,70,70,32,117,110,117,115,101,100,32,37,100,32,40,48,120,37,120,41,0,40,116,
111,102,102,95,116,41,116,105,102,45,62,116,105,102,95,115,105,122,101,61,61,110,0,116,105,102,95,111,112,101,110,46,99,0,70,105,108,101,32,110,111,116,32,111,112,101,110,32,102,111,114,32,114,101,97,100,105,110,103,0,67,97,110,32,110,111,116,32,114,101,97,100,32,115,99,97,110,108,105,110,101,115,32,102,114,111,109,32,97,32,116,105,108,101,100,32,105,109,97,103,101,0,40,116,105,102,45,62,116,105,102,95,102,108,97,103,115,38,84,73,70,70,95,78,79,82,69,65,68,82,65,87,41,61,61,48,0,116,105,102,95,114,
101,97,100,46,99,0,84,73,70,70,82,101,97,100,66,117,102,102,101,114,83,101,116,117,112,0,73,110,118,97,108,105,100,32,98,117,102,102,101,114,32,115,105,122,101,0,83,101,101,107,32,101,114,114,111,114,32,97,116,32,115,99,97,110,108,105,110,101,32,37,108,117,44,32,115,116,114,105,112,32,37,108,117,0,82,101,97,100,32,101,114,114,111,114,32,97,116,32,115,99,97,110,108,105,110,101,32,37,108,117,59,32,103,111,116,32,37,108,108,117,32,98,121,116,101,115,44,32,101,120,112,101,99,116,101,100,32,37,108,108,
117,0,84,73,70,70,82,101,97,100,69,110,99,111,100,101,100,83,116,114,105,112,0,37,108,117,58,32,83,116,114,105,112,32,111,117,116,32,111,102,32,114,97,110,103,101,44,32,109,97,120,32,37,108,117,0,84,73,70,70,70,105,108,108,83,116,114,105,112,0,73,110,118,97,108,105,100,32,115,116,114,105,112,32,98,121,116,101,32,99,111,117,110,116,32,37,108,108,117,44,32,115,116,114,105,112,32,37,108,117,0,82,101,97,100,32,101,114,114,111,114,32,111,110,32,115,116,114,105,112,32,37,108,117,59,32,103,111,116,32,37,
108,108,117,32,98,121,116,101,115,44,32,101,120,112,101,99,116,101,100,32,37,108,108,117,0,68,97,116,97,32,98,117,102,102,101,114,32,116,111,111,32,115,109,97,108,108,32,116,111,32,104,111,108,100,32,115,116,114,105,112,32,37,108,117,0,78,111,32,115,112,97,99,101,32,102,111,114,32,100,97,116,97,32,98,117,102,102,101,114,32,97,116,32,115,99,97,110,108,105,110,101,32,37,108,117,0,67,97,110,32,110,111,116,32,114,101,97,100,32,116,105,108,101,115,32,102,114,111,109,32,97,32,115,116,114,105,112,112,101,
100,32,105,109,97,103,101,0,84,73,70,70,82,101,97,100,69,110,99,111,100,101,100,84,105,108,101,0,37,108,117,58,32,84,105,108,101,32,111,117,116,32,111,102,32,114,97,110,103,101,44,32,109,97,120,32,37,108,117,0,84,73,70,70,70,105,108,108,84,105,108,101,0,37,108,108,117,58,32,73,110,118,97,108,105,100,32,116,105,108,101,32,98,121,116,101,32,99,111,117,110,116,44,32,116,105,108,101,32,37,108,117,0,68,97,116,97,32,98,117,102,102,101,114,32,116,111,111,32,115,109,97,108,108,32,116,111,32,104,111,108,100,
32,116,105,108,101,32,37,108,117,0,84,73,70,70,83,116,97,114,116,84,105,108,101,0,90,101,114,111,32,116,105,108,101,115,0,40,99,99,32,38,32,49,41,32,61,61,32,48,0,95,84,73,70,70,83,119,97,98,49,54,66,105,116,68,97,116,97,0,40,99,99,32,37,32,51,41,32,61,61,32,48,0,95,84,73,70,70,83,119,97,98,50,52,66,105,116,68,97,116,97,0,40,99,99,32,38,32,51,41,32,61,61,32,48,0,95,84,73,70,70,83,119,97,98,51,50,66,105,116,68,97,116,97,0,40,99,99,32,38,32,55,41,32,61,61,32,48,0,95,84,73,70,70,83,119,97,98,54,52,66,
105,116,68,97,116,97,0,84,73,70,70,82,101,97,100,82,97,119,84,105,108,101,49,0,83,101,101,107,32,101,114,114,111,114,32,97,116,32,114,111,119,32,37,108,117,44,32,99,111,108,32,37,108,117,44,32,116,105,108,101,32,37,108,117,0,82,101,97,100,32,101,114,114,111,114,32,97,116,32,114,111,119,32,37,108,117,44,32,99,111,108,32,37,108,117,59,32,103,111,116,32,37,108,108,117,32,98,121,116,101,115,44,32,101,120,112,101,99,116,101,100,32,37,108,108,117,0,82,101,97,100,32,101,114,114,111,114,32,97,116,32,114,
111,119,32,37,108,117,44,32,99,111,108,32,37,108,117,44,32,116,105,108,101,32,37,108,117,59,32,103,111,116,32,37,108,108,117,32,98,121,116,101,115,44,32,101,120,112,101,99,116,101,100,32,37,108,108,117,0,84,73,70,70,82,101,97,100,82,97,119,83,116,114,105,112,49,0,82,101,97,100,32,101,114,114,111,114,32,97,116,32,115,99,97,110,108,105,110,101,32,37,108,117,44,32,115,116,114,105,112,32,37,108,117,59,32,103,111,116,32,37,108,108,117,32,98,121,116,101,115,44,32,101,120,112,101,99,116,101,100,32,37,108,
108,117,0,84,73,70,70,67,111,109,112,117,116,101,83,116,114,105,112,0,84,73,70,70,78,117,109,98,101,114,79,102,83,116,114,105,112,115,0,84,73,70,70,86,83,116,114,105,112,83,105,122,101,54,52,0,73,110,118,97,108,105,100,32,116,100,95,115,97,109,112,108,101,115,112,101,114,112,105,120,101,108,32,118,97,108,117,101,0,84,73,70,70,83,99,97,110,108,105,110,101,83,105,122,101,54,52,0,73,110,118,97,108,105,100,32,89,67,98,67,114,32,115,117,98,115,97,109,112,108,105,110,103,0,67,111,109,112,117,116,101,100,
32,115,99,97,110,108,105,110,101,32,115,105,122,101,32,105,115,32,122,101,114,111,0,84,73,70,70,86,83,116,114,105,112,83,105,122,101,0,84,73,70,70,83,116,114,105,112,83,105,122,101,0,84,73,70,70,83,99,97,110,108,105,110,101,83,105,122,101,0,73,110,116,101,103,101,114,32,97,114,105,116,104,109,101,116,105,99,32,111,118,101,114,102,108,111,119,0,0,128,64,192,32,160,96,224,16,144,80,208,48,176,112,240,8,136,72,200,40,168,104,232,24,152,88,216,56,184,120,248,4,132,68,196,36,164,100,228,20,148,84,212,
52,180,116,244,12,140,76,204,44,172,108,236,28,156,92,220,60,188,124,252,2,130,66,194,34,162,98,226,18,146,82,210,50,178,114,242,10,138,74,202,42,170,106,234,26,154,90,218,58,186,122,250,6,134,70,198,38,166,102,230,22,150,86,214,54,182,118,246,14,142,78,206,46,174,110,238,30,158,94,222,62,190,126,254,1,129,65,193,33,161,97,225,17,145,81,209,49,177,113,241,9,137,73,201,41,169,105,233,25,153,89,217,57,185,121,249,5,133,69,197,37,165,101,229,21,149,85,213,53,181,117,245,13,141,77,205,45,173,109,237,
29,157,93,221,61,189,125,253,3,131,67,195,35,163,99,227,19,147,83,211,51,179,115,243,11,139,75,203,43,171,107,235,27,155,91,219,59,187,123,251,7,135,71,199,39,167,103,231,23,151,87,215,55,183,119,247,15,143,79,207,47,175,111,239,31,159,95,223,63,191,127,255,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,
85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,
214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255,37,108,117,58,32,67,111,108,32,111,117,116,32,111,102,32,114,97,110,103,101,44,32,109,97,120,32,37,108,117,0,37,108,117,58,32,82,111,119,32,111,117,116,32,111,102,32,114,97,110,103,101,44,32,109,97,120,32,37,108,117,0,37,108,117,58,32,68,101,112,116,104,32,111,117,116,32,111,102,32,114,97,110,103,101,44,32,109,97,120,32,37,108,117,
0,37,108,117,58,32,83,97,109,112,108,101,32,111,117,116,32,111,102,32,114,97,110,103,101,44,32,109,97,120,32,37,108,117,0,84,73,70,70,78,117,109,98,101,114,79,102,84,105,108,101,115,0,84,73,70,70,84,105,108,101,82,111,119,83,105,122,101,54,52,0,84,105,108,101,32,108,101,110,103,116,104,32,105,115,32,122,101,114,111,0,84,105,108,101,32,119,105,100,116,104,32,105,115,32,122,101,114,111,0,84,73,70,70,84,105,108,101,82,111,119,83,105,122,101,0,83,97,109,112,108,101,115,32,112,101,114,32,112,105,120,101,
108,32,105,115,32,122,101,114,111,0,67,111,109,112,117,116,101,100,32,116,105,108,101,32,114,111,119,32,115,105,122,101,32,105,115,32,122,101,114,111,0,73,110,116,101,103,101,114,32,111,118,101,114,102,108,111,119,0,84,73,70,70,86,84,105,108,101,83,105,122,101,54,52,0,73,110,118,97,108,105,100,32,89,67,98,67,114,32,115,117,98,115,97,109,112,108,105,110,103,32,40,37,100,120,37,100,41,0,84,73,70,70,84,105,108,101,83,105,122,101,0,116,100,45,62,116,100,95,110,115,116,114,105,112,115,32,62,32,48,0,116,
105,102,95,119,114,105,116,101,46,99,0,84,73,70,70,65,112,112,101,110,100,84,111,83,116,114,105,112,0,83,101,101,107,32,101,114,114,111,114,32,97,116,32,115,99,97,110,108,105,110,101,32,37,108,117,0,87,114,105,116,101,32,101,114,114,111,114,32,97,116,32,115,99,97,110,108,105,110,101,32,37,108,117,0,84,73,70,70,79,112,101,110,0,37,115,58,32,37,115,0,37,115,58,32,67,97,110,110,111,116,32,111,112,101,110,0,37,115,58,32,0,46,10,0,87,97,114,110,105,110,103,44,32,0,73,110,116,101,103,101,114,32,111,118,
101,114,102,108,111,119,32,105,110,32,37,115,0,70,97,105,108,101,100,32,116,111,32,97,108,108,111,99,97,116,101,32,109,101,109,111,114,121,32,102,111,114,32,37,115,32,40,37,108,100,32,101,108,101,109,101,110,116,115,32,111,102,32,37,108,100,32,98,121,116,101,115,32,101,97,99,104,41,0,78,111,32,115,112,97,99,101,32,102,111,114,32,34,84,114,97,110,115,102,101,114,70,117,110,99,116,105,111,110,34,32,116,97,103,0,37,115,32,37,115,32,101,110,99,111,100,105,110,103,32,105,115,32,110,111,116,32,105,109,
112,108,101,109,101,110,116,101,100,0,115,99,97,110,108,105,110,101,0,67,111,109,112,114,101,115,115,105,111,110,32,115,99,104,101,109,101,32,37,117,32,37,115,32,101,110,99,111,100,105,110,103,32,105,115,32,110,111,116,32,105,109,112,108,101,109,101,110,116,101,100,0,37,115,32,37,115,32,100,101,99,111,100,105,110,103,32,105,115,32,110,111,116,32,105,109,112,108,101,109,101,110,116,101,100,0,67,111,109,112,114,101,115,115,105,111,110,32,115,99,104,101,109,101,32,37,117,32,37,115,32,100,101,99,111,
100,105,110,103,32,105,115,32,110,111,116,32,105,109,112,108,101,109,101,110,116,101,100,0,67,111,109,112,114,101,115,115,105,111,110,32,97,108,103,111,114,105,116,104,109,32,100,111,101,115,32,110,111,116,32,115,117,112,112,111,114,116,32,114,97,110,100,111,109,32,97,99,99,101,115,115,0,69,114,114,111,114,32,117,112,100,97,116,105,110,103,32,84,73,70,70,32,104,101,97,100,101,114,0,84,73,70,70,82,101,119,114,105,116,101,68,105,114,101,99,116,111,114,121,0,69,114,114,111,114,32,102,101,116,99,104,
105,110,103,32,100,105,114,101,99,116,111,114,121,32,99,111,117,110,116,0,69,114,114,111,114,32,102,101,116,99,104,105,110,103,32,100,105,114,101,99,116,111,114,121,32,108,105,110,107,0,69,114,114,111,114,32,119,114,105,116,105,110,103,32,100,105,114,101,99,116,111,114,121,32,108,105,110,107,0,83,97,110,105,116,121,32,99,104,101,99,107,32,111,110,32,116,97,103,32,99,111,117,110,116,32,102,97,105,108,101,100,44,32,108,105,107,101,108,121,32,99,111,114,114,117,112,116,32,84,73,70,70,0,84,73,70,70,82,
101,115,101,116,70,105,101,108,100,0,77,101,109,111,114,121,32,109,97,112,112,101,100,32,102,105,108,101,115,32,110,111,116,32,99,117,114,114,101,110,116,108,121,32,115,117,112,112,111,114,116,101,100,32,102,111,114,32,116,104,105,115,32,111,112,101,114,97,116,105,111,110,46,0,65,116,116,101,109,112,116,32,116,111,32,114,101,115,101,116,32,102,105,101,108,100,32,111,110,32,100,105,114,101,99,116,111,114,121,32,110,111,116,32,97,108,114,101,97,100,121,32,111,110,32,100,105,115,107,46,0,37,115,58,32,
83,101,101,107,32,101,114,114,111,114,32,97,99,99,101,115,115,105,110,103,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,0,37,115,58,32,67,97,110,32,110,111,116,32,114,101,97,100,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,32,99,111,117,110,116,0,37,115,58,32,67,97,110,32,110,111,116,32,114,101,97,100,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,32,101,110,116,114,121,46,0,37,115,58,32,67,111,117,108,100,32,110,111,116,32,102,105,110,100,32,116,97,103,32,37,100,46,0,102,111,
114,32,102,105,101,108,100,32,98,117,102,102,101,114,46,0,86,97,108,117,101,32,101,120,99,101,101,100,115,32,51,50,98,105,116,32,114,97,110,103,101,32,111,102,32,111,117,116,112,117,116,32,116,121,112,101,46,0,37,115,58,32,67,97,110,32,110,111,116,32,119,114,105,116,101,32,84,73,70,70,32,100,105,114,101,99,116,111,114,121,32,101,110,116,114,121,46,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,83,101,99,0,69,114,114,111,114,32,112,111,115,116,45,101,110,99,111,100,105,110,103,
32,98,101,102,111,114,101,32,100,105,114,101,99,116,111,114,121,32,119,114,105,116,101,0,69,114,114,111,114,32,102,108,117,115,104,105,110,103,32,100,97,116,97,32,98,101,102,111,114,101,32,100,105,114,101,99,116,111,114,121,32,119,114,105,116,101,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,83,104,111,114,116,80,101,114,83,97,109,112,108,101,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,111,108,111,114,109,97,112,0,99,111,117,110,116,
60,48,120,56,48,48,48,48,48,48,48,0,116,105,102,95,100,105,114,119,114,105,116,101,46,99,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,83,104,111,114,116,65,114,114,97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,84,114,97,110,115,102,101,114,102,117,110,99,116,105,111,110,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,83,117,98,105,102,100,0,112,97,32,33,61,32,48,0,42,112,97,
32,60,61,32,48,120,70,70,70,70,70,70,70,70,85,76,0,111,45,62,102,105,101,108,100,95,116,121,112,101,61,61,84,73,70,70,95,65,83,67,73,73,0,111,45,62,102,105,101,108,100,95,114,101,97,100,99,111,117,110,116,61,61,84,73,70,70,95,86,65,82,73,65,66,76,69,0,111,45,62,102,105,101,108,100,95,112,97,115,115,99,111,117,110,116,61,61,48,0,111,45,62,102,105,101,108,100,95,116,121,112,101,61,61,84,73,70,70,95,83,72,79,82,84,0,111,45,62,102,105,101,108,100,95,114,101,97,100,99,111,117,110,116,61,61,49,0,111,45,
62,102,105,101,108,100,95,116,121,112,101,61,61,84,73,70,70,95,76,79,78,71,0,111,45,62,102,105,101,108,100,95,116,121,112,101,61,61,84,73,70,70,95,85,78,68,69,70,73,78,69,68,0,111,45,62,102,105,101,108,100,95,114,101,97,100,99,111,117,110,116,61,61,84,73,70,70,95,86,65,82,73,65,66,76,69,50,0,111,45,62,102,105,101,108,100,95,112,97,115,115,99,111,117,110,116,61,61,49,0,48,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,83,115,104,111,114,116,65,
114,114,97,121,0,99,111,117,110,116,60,48,120,52,48,48,48,48,48,48,48,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,76,111,110,103,65,114,114,97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,83,108,111,110,103,65,114,114,97,121,0,99,111,117,110,116,60,48,120,50,48,48,48,48,48,48,48,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,
76,111,110,103,56,65,114,114,97,121,0,116,105,102,45,62,116,105,102,95,102,108,97,103,115,38,84,73,70,70,95,66,73,71,84,73,70,70,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,83,108,111,110,103,56,65,114,114,97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,83,114,97,116,105,111,110,97,108,65,114,114,97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,
67,104,101,99,107,101,100,70,108,111,97,116,65,114,114,97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,68,111,117,98,108,101,65,114,114,97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,73,102,100,65,114,114,97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,73,102,100,56,65,114,114,97,121,0,84,73,70,70,87,114,105,116,
101,68,105,114,101,99,116,111,114,121,84,97,103,73,102,100,73,102,100,56,65,114,114,97,121,0,65,116,116,101,109,112,116,32,116,111,32,119,114,105,116,101,32,118,97,108,117,101,32,108,97,114,103,101,114,32,116,104,97,110,32,48,120,70,70,70,70,70,70,70,70,32,105,110,32,67,108,97,115,115,105,99,32,84,73,70,70,32,102,105,108,101,46,0,84,73,70,70,76,105,110,107,68,105,114,101,99,116,111,114,121,0,69,114,114,111,114,32,119,114,105,116,105,110,103,32,83,117,98,73,70,68,32,100,105,114,101,99,116,111,114,
121,32,108,105,110,107,0,69,114,114,111,114,32,119,114,105,116,105,110,103,32,84,73,70,70,32,104,101,97,100,101,114,0,77,97,120,105,109,117,109,32,84,73,70,70,32,102,105,108,101,32,115,105,122,101,32,101,120,99,101,101,100,101,100,0,110,97,60,110,100,105,114,0,73,79,32,101,114,114,111,114,32,119,114,105,116,105,110,103,32,100,105,114,101,99,116,111,114,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,82,97,116,105,111,110,97,108,65,114,114,
97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,83,97,109,112,108,101,102,111,114,109,97,116,65,114,114,97,121,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,76,111,110,103,76,111,110,103,56,65,114,114,97,121,0,118,97,108,117,101,62,61,48,46,48,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,67,104,101,99,107,101,100,82,97,116,105,111,110,97,108,0,100,105,114,91,109,93,46,116,100,105,114,95,116,97,103,33,
61,116,97,103,0,84,73,70,70,87,114,105,116,101,68,105,114,101,99,116,111,114,121,84,97,103,68,97,116,97,0,73,79,32,101,114,114,111,114,32,119,114,105,116,105,110,103,32,116,97,103,32,100,97,116,97,0,100,97,116,97,108,101,110,103,116,104,60,48,120,56,48,48,48,48,48,48,48,85,76,0,78,111,110,101,0,76,90,87,0,80,97,99,107,66,105,116,115,0,84,104,117,110,100,101,114,83,99,97,110,0,78,101,88,84,0,74,80,69,71,0,79,108,100,45,115,116,121,108,101,32,74,80,69,71,0,67,67,73,84,84,32,82,76,69,0,67,67,73,84,84,
32,82,76,69,47,87,0,67,67,73,84,84,32,71,114,111,117,112,32,51,0,67,67,73,84,84,32,71,114,111,117,112,32,52,0,73,83,79,32,74,66,73,71,0,68,101,102,108,97,116,101,0,65,100,111,98,101,68,101,102,108,97,116,101,0,80,105,120,97,114,76,111,103,0,83,71,73,76,111,103,0,83,71,73,76,111,103,50,52,0,76,90,77,65,0,37,100,0,37,115,32,99,111,109,112,114,101,115,115,105,111,110,32,115,117,112,112,111,114,116,32,105,115,32,110,111,116,32,99,111,110,102,105,103,117,114,101,100,0,110,32,62,32,48,0,116,105,102,95,
100,117,109,112,109,111,100,101,46,99,0,68,117,109,112,77,111,100,101,69,110,99,111,100,101,0,68,117,109,112,77,111,100,101,68,101,99,111,100,101,0,78,111,116,32,101,110,111,117,103,104,32,100,97,116,97,32,102,111,114,32,115,99,97,110,108,105,110,101,32,37,108,117,44,32,101,120,112,101,99,116,101,100,32,97,32,114,101,113,117,101,115,116,32,102,111,114,32,97,116,32,109,111,115,116,32,37,108,108,100,32,98,121,116,101,115,44,32,103,111,116,32,97,32,114,101,113,117,101,115,116,32,102,111,114,32,37,108,
108,100,32,98,121,116,101,115,0,0,128,192,224,240,248,252,254,255,120,32,61,61,32,108,97,115,116,120,0,116,105,102,95,102,97,120,51,46,99,0,95,84,73,70,70,70,97,120,51,102,105,108,108,114,117,110,115,0,84,73,70,70,73,110,105,116,67,67,73,84,84,70,97,120,51,0,77,101,114,103,105,110,103,32,67,67,73,84,84,32,70,97,120,32,51,32,99,111,100,101,99,45,115,112,101,99,105,102,105,99,32,116,97,103,115,32,102,97,105,108,101,100,0,84,73,70,70,73,110,105,116,67,67,73,84,84,70,97,120,52,0,77,101,114,103,105,110,
103,32,67,67,73,84,84,32,70,97,120,32,52,32,99,111,100,101,99,45,115,112,101,99,105,102,105,99,32,116,97,103,115,32,102,97,105,108,101,100,0,70,97,120,51,68,101,99,111,100,101,82,76,69,0,116,105,108,101,0,115,116,114,105,112,0,66,97,100,32,99,111,100,101,32,119,111,114,100,32,97,116,32,108,105,110,101,32,37,117,32,111,102,32,37,115,32,37,117,32,40,120,32,37,117,41,0,80,114,101,109,97,116,117,114,101,32,69,79,70,32,97,116,32,108,105,110,101,32,37,117,32,111,102,32,37,115,32,37,117,32,40,120,32,37,
117,41,0,80,114,101,109,97,116,117,114,101,32,69,79,76,0,76,105,110,101,32,108,101,110,103,116,104,32,109,105,115,109,97,116,99,104,0,37,115,32,97,116,32,108,105,110,101,32,37,117,32,111,102,32,37,115,32,37,117,32,40,103,111,116,32,37,117,44,32,101,120,112,101,99,116,101,100,32,37,117,41,0,108,101,110,103,116,104,32,60,32,57,0,70,97,120,51,80,117,116,66,105,116,115,0,70,97,120,52,69,110,99,111,100,101,0,70,114,97,99,116,105,111,110,97,108,32,115,99,97,110,108,105,110,101,115,32,99,97,110,110,111,
116,32,98,101,32,119,114,105,116,116,101,110,0,8,7,6,6,5,5,5,5,4,4,4,4,4,4,4,4,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"i8",4,ra.GLOBAL_BASE+133156);vc([112,117,116,115,112,97,110,0,116,101,45,62,114,117,110,108,101,110,32,61,61,32,54,52,42,40,115,112,97,110,62,62,54,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,5,5,5,5,6,6,7,8,70,97,120,52,68,101,99,111,100,101,
0,85,110,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,32,40,110,111,116,32,115,117,112,112,111,114,116,101,100,41,32,97,116,32,108,105,110,101,32,37,117,32,111,102,32,37,115,32,37,117,32,40,120,32,37,117,41,0,71,114,111,117,112,52,79,112,116,105,111,110,115,0,71,114,111,117,112,51,79,112,116,105,111,110,115,0,73,110,105,116,67,67,73,84,84,70,97,120,51,0,77,101,114,103,105,110,103,32,99,111,109,109,111,110,32,67,67,73,84,84,32,70,97,120,32,99,111,100,101,99,45,115,112,101,99,105,102,105,
99,32,116,97,103,115,32,102,97,105,108,101,100,0,78,111,32,115,112,97,99,101,32,102,111,114,32,115,116,97,116,101,32,98,108,111,99,107,0,70,97,120,51,67,108,101,97,110,117,112,0,70,97,120,51,69,110,99,111,100,101,0,116,112,97,114,109,32,60,32,57,0,70,97,120,51,80,117,116,69,79,76,0,70,97,120,51,80,114,101,69,110,99,111,100,101,0,70,97,120,51,68,101,99,111,100,101,49,68,0,70,97,120,51,80,114,101,68,101,99,111,100,101,0,70,97,120,51,83,101,116,117,112,83,116,97,116,101,0,66,105,116,115,47,115,97,109,
112,108,101,32,109,117,115,116,32,98,101,32,49,32,102,111,114,32,71,114,111,117,112,32,51,47,52,32,101,110,99,111,100,105,110,103,47,100,101,99,111,100,105,110,103,0,82,111,119,32,112,105,120,101,108,115,32,105,110,116,101,103,101,114,32,111,118,101,114,102,108,111,119,32,40,114,111,119,112,105,120,101,108,115,32,37,117,41,0,102,111,114,32,71,114,111,117,112,32,51,47,52,32,114,117,110,32,97,114,114,97,121,115,0,78,111,32,115,112,97,99,101,32,102,111,114,32,71,114,111,117,112,32,51,47,52,32,114,101,
102,101,114,101,110,99,101,32,108,105,110,101,0,70,97,120,51,68,101,99,111,100,101,50,68,0,70,97,120,51,80,114,105,110,116,68,105,114,0,32,32,71,114,111,117,112,32,52,32,79,112,116,105,111,110,115,58,0,37,115,117,110,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,0,32,0,32,32,71,114,111,117,112,32,51,32,79,112,116,105,111,110,115,58,0,37,115,50,45,100,32,101,110,99,111,100,105,110,103,0,43,0,37,115,69,79,76,32,112,97,100,100,105,110,103,0,32,40,37,108,117,32,61,32,48,120,37,108,120,41,10,
0,32,32,70,97,120,32,68,97,116,97,58,0,32,99,108,101,97,110,0,32,114,101,99,101,105,118,101,114,32,114,101,103,101,110,101,114,97,116,101,100,0,32,117,110,99,111,114,114,101,99,116,101,100,32,101,114,114,111,114,115,0,32,40,37,117,32,61,32,48,120,37,120,41,10,0,32,32,66,97,100,32,70,97,120,32,76,105,110,101,115,58,32,37,108,117,10,0,32,32,67,111,110,115,101,99,117,116,105,118,101,32,66,97,100,32,70,97,120,32,76,105,110,101,115,58,32,37,108,117,10,0,70,97,120,51,86,83,101,116,70,105,101,108,100,0,
115,112,45,62,118,115,101,116,112,97,114,101,110,116,32,33,61,32,48,0,70,97,120,51,86,71,101,116,70,105,101,108,100,0,70,97,120,77,111,100,101,0,70,97,120,70,105,108,108,70,117,110,99,0,66,97,100,70,97,120,76,105,110,101,115,0,67,108,101,97,110,70,97,120,68,97,116,97,0,67,111,110,115,101,99,117,116,105,118,101,66,97,100,70,97,120,76,105,110,101,115,0,115,99,104,101,109,101,32,61,61,32,67,79,77,80,82,69,83,83,73,79,78,95,74,80,69,71,0,116,105,102,95,106,112,101,103,46,99,0,84,73,70,70,73,110,105,116,
74,80,69,71,0,77,101,114,103,105,110,103,32,74,80,69,71,32,99,111,100,101,99,45,115,112,101,99,105,102,105,99,32,116,97,103,115,32,102,97,105,108,101,100,0,78,111,32,115,112,97,99,101,32,102,111,114,32,74,80,69,71,32,115,116,97,116,101,32,98,108,111,99,107,0,70,97,105,108,101,100,32,116,111,32,97,108,108,111,99,97,116,101,32,109,101,109,111,114,121,32,102,111,114,32,74,80,69,71,32,116,97,98,108,101,115,0,74,80,69,71,67,108,101,97,110,117,112,0,74,80,69,71,69,110,99,111,100,101,0,102,114,97,99,116,
105,111,110,97,108,32,115,99,97,110,108,105,110,101,32,100,105,115,99,97,114,100,101,100,0,70,97,105,108,101,100,32,116,111,32,97,108,108,111,99,97,116,101,32,109,101,109,111,114,121,0,74,80,69,71,80,114,101,69,110,99,111,100,101,0,33,115,112,45,62,99,105,110,102,111,46,99,111,109,109,46,105,115,95,100,101,99,111,109,112,114,101,115,115,111,114,0,83,116,114,105,112,47,116,105,108,101,32,116,111,111,32,108,97,114,103,101,32,102,111,114,32,74,80,69,71,0,74,80,69,71,69,110,99,111,100,101,82,97,119,0,
74,80,69,71,83,101,116,117,112,69,110,99,111,100,101,0,80,104,111,116,111,109,101,116,114,105,99,73,110,116,101,114,112,114,101,116,97,116,105,111,110,32,37,100,32,110,111,116,32,97,108,108,111,119,101,100,32,102,111,114,32,74,80,69,71,0,66,105,116,115,80,101,114,83,97,109,112,108,101,32,37,100,32,110,111,116,32,97,108,108,111,119,101,100,32,102,111,114,32,74,80,69,71,0,74,80,69,71,32,116,105,108,101,32,104,101,105,103,104,116,32,109,117,115,116,32,98,101,32,109,117,108,116,105,112,108,101,32,111,
102,32,37,100,0,74,80,69,71,32,116,105,108,101,32,119,105,100,116,104,32,109,117,115,116,32,98,101,32,109,117,108,116,105,112,108,101,32,111,102,32,37,100,0,82,111,119,115,80,101,114,83,116,114,105,112,32,109,117,115,116,32,98,101,32,109,117,108,116,105,112,108,101,32,111,102,32,37,100,32,102,111,114,32,74,80,69,71,0,0,0,0,0,0,0,0,0,0,0,84,73,70,70,106,112,101,103,95,116,97,98,108,101,115,95,100,101,115,116,0,78,111,32,115,112,97,99,101,32,102,111,114,32,74,80,69,71,84,97,98,108,101,115,0,74,80,69,
71,76,105,98,0,102,114,97,99,116,105,111,110,97,108,32,115,99,97,110,108,105,110,101,32,110,111,116,32,114,101,97,100,0,74,80,69,71,80,114,101,68,101,99,111,100,101,0,115,112,45,62,99,105,110,102,111,46,99,111,109,109,46,105,115,95,100,101,99,111,109,112,114,101,115,115,111,114,0,73,109,112,114,111,112,101,114,32,74,80,69,71,32,115,116,114,105,112,47,116,105,108,101,32,115,105,122,101,44,32,101,120,112,101,99,116,101,100,32,37,100,120,37,100,44,32,103,111,116,32,37,100,120,37,100,0,74,80,69,71,32,
115,116,114,105,112,47,116,105,108,101,32,115,105,122,101,32,101,120,99,101,101,100,115,32,101,120,112,101,99,116,101,100,32,100,105,109,101,110,115,105,111,110,115,44,32,101,120,112,101,99,116,101,100,32,37,100,120,37,100,44,32,103,111,116,32,37,100,120,37,100,0,73,109,112,114,111,112,101,114,32,74,80,69,71,32,99,111,109,112,111,110,101,110,116,32,99,111,117,110,116,0,73,109,112,114,111,112,101,114,32,74,80,69,71,32,100,97,116,97,32,112,114,101,99,105,115,105,111,110,0,73,109,112,114,111,112,101,
114,32,74,80,69,71,32,115,97,109,112,108,105,110,103,32,102,97,99,116,111,114,115,32,37,100,44,37,100,10,65,112,112,97,114,101,110,116,108,121,32,115,104,111,117,108,100,32,98,101,32,37,100,44,37,100,46,0,73,109,112,114,111,112,101,114,32,74,80,69,71,32,115,97,109,112,108,105,110,103,32,102,97,99,116,111,114,115,0,74,80,69,71,68,101,99,111,100,101,82,97,119,0,97,112,112,108,105,99,97,116,105,111,110,32,98,117,102,102,101,114,32,110,111,116,32,108,97,114,103,101,32,101,110,111,117,103,104,32,102,111,
114,32,97,108,108,32,100,97,116,97,46,0,97,112,112,108,105,99,97,116,105,111,110,32,98,117,102,102,101,114,32,110,111,116,32,108,97,114,103,101,32,101,110,111,117,103,104,32,102,111,114,32,97,108,108,32,100,97,116,97,44,32,112,111,115,115,105,98,108,101,32,115,117,98,115,97,109,112,108,105,110,103,32,105,115,115,117,101,0,84,73,70,70,82,101,97,100,83,99,97,110,108,105,110,101,0,115,99,97,110,108,105,110,101,32,111,114,105,101,110,116,101,100,32,97,99,99,101,115,115,32,105,115,32,110,111,116,32,115,
117,112,112,111,114,116,101,100,32,102,111,114,32,100,111,119,110,115,97,109,112,108,101,100,32,74,80,69,71,32,99,111,109,112,114,101,115,115,101,100,32,105,109,97,103,101,115,44,32,99,111,110,115,105,100,101,114,32,101,110,97,98,108,105,110,103,32,84,73,70,70,95,74,80,69,71,67,79,76,79,82,77,79,68,69,32,97,115,32,74,80,69,71,67,79,76,79,82,77,79,68,69,95,82,71,66,46,0,74,80,69,71,83,101,116,117,112,68,101,99,111,100,101,0,66,111,103,117,115,32,74,80,69,71,84,97,98,108,101,115,32,102,105,101,108,
100,0,255,217,74,80,69,71,70,105,120,117,112,84,97,103,115,83,117,98,115,97,109,112,108,105,110,103,0,85,110,97,98,108,101,32,116,111,32,97,108,108,111,99,97,116,101,32,109,101,109,111,114,121,32,102,111,114,32,97,117,116,111,45,99,111,114,114,101,99,116,105,110,103,32,111,102,32,115,117,98,115,97,109,112,108,105,110,103,32,118,97,108,117,101,115,59,32,97,117,116,111,45,99,111,114,114,101,99,116,105,110,103,32,115,107,105,112,112,101,100,0,109,60,48,120,56,48,48,48,48,48,48,48,85,76,0,74,80,69,71,
70,105,120,117,112,84,97,103,115,83,117,98,115,97,109,112,108,105,110,103,82,101,97,100,66,121,116,101,0,74,80,69,71,70,105,120,117,112,84,97,103,115,83,117,98,115,97,109,112,108,105,110,103,83,101,99,0,83,117,98,115,97,109,112,108,105,110,103,32,118,97,108,117,101,115,32,105,110,115,105,100,101,32,74,80,69,71,32,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,32,104,97,118,101,32,110,111,32,84,73,70,70,32,101,113,117,105,118,97,108,101,110,116,44,32,97,117,116,111,45,99,111,114,114,101,99,
116,105,111,110,32,111,102,32,84,73,70,70,32,115,117,98,115,97,109,112,108,105,110,103,32,118,97,108,117,101,115,32,102,97,105,108,101,100,0,65,117,116,111,45,99,111,114,114,101,99,116,101,100,32,102,111,114,109,101,114,32,84,73,70,70,32,115,117,98,115,97,109,112,108,105,110,103,32,118,97,108,117,101,115,32,91,37,100,44,37,100,93,32,116,111,32,109,97,116,99,104,32,115,117,98,115,97,109,112,108,105,110,103,32,118,97,108,117,101,115,32,105,110,115,105,100,101,32,74,80,69,71,32,99,111,109,112,114,101,
115,115,101,100,32,100,97,116,97,32,91,37,100,44,37,100,93,0,85,110,97,98,108,101,32,116,111,32,97,117,116,111,45,99,111,114,114,101,99,116,32,115,117,98,115,97,109,112,108,105,110,103,32,118,97,108,117,101,115,44,32,108,105,107,101,108,121,32,99,111,114,114,117,112,116,32,74,80,69,71,32,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,32,105,110,32,102,105,114,115,116,32,115,116,114,105,112,47,116,105,108,101,59,32,97,117,116,111,45,99,111,114,114,101,99,116,105,110,103,32,115,107,105,112,
112,101,100,0,74,80,69,71,80,114,105,110,116,68,105,114,0,32,32,74,80,69,71,32,84,97,98,108,101,115,58,32,40,37,108,117,32,98,121,116,101,115,41,10,0,74,80,69,71,86,83,101,116,70,105,101,108,100,0,74,80,69,71,86,71,101,116,70,105,101,108,100,0,74,80,69,71,84,97,98,108,101,115,0,115,99,104,101,109,101,32,61,61,32,67,79,77,80,82,69,83,83,73,79,78,95,83,71,73,76,79,71,50,52,32,124,124,32,115,99,104,101,109,101,32,61,61,32,67,79,77,80,82,69,83,83,73,79,78,95,83,71,73,76,79,71,0,116,105,102,95,108,117,
118,46,99,0,84,73,70,70,73,110,105,116,83,71,73,76,111,103,0,77,101,114,103,105,110,103,32,83,71,73,76,111,103,32,99,111,100,101,99,45,115,112,101,99,105,102,105,99,32,116,97,103,115,32,102,97,105,108,101,100,0,37,115,58,32,78,111,32,115,112,97,99,101,32,102,111,114,32,76,111,103,76,117,118,32,115,116,97,116,101,32,98,108,111,99,107,0,85,110,107,110,111,119,110,32,100,97,116,97,32,102,111,114,109,97,116,32,37,100,32,102,111,114,32,76,111,103,76,117,118,32,99,111,109,112,114,101,115,115,105,111,110,
0,76,111,103,76,117,118,86,83,101,116,70,105,101,108,100,0,85,110,107,110,111,119,110,32,101,110,99,111,100,105,110,103,32,37,100,32,102,111,114,32,76,111,103,76,117,118,32,99,111,109,112,114,101,115,115,105,111,110,0,76,111,103,76,117,118,67,108,101,97,110,117,112,0,99,99,37,114,111,119,108,101,110,32,61,61,32,48,0,76,111,103,76,117,118,69,110,99,111,100,101,84,105,108,101,0,76,111,103,76,117,118,69,110,99,111,100,101,83,116,114,105,112,0,76,111,103,76,117,118,83,101,116,117,112,69,110,99,111,100,
101,0,73,110,97,112,112,114,111,112,114,105,97,116,101,32,112,104,111,116,111,109,101,116,114,105,99,32,105,110,116,101,114,112,114,101,116,97,116,105,111,110,32,37,100,32,102,111,114,32,83,71,73,76,111,103,32,99,111,109,112,114,101,115,115,105,111,110,59,32,37,115,0,109,117,115,116,32,98,101,32,101,105,116,104,101,114,32,76,111,103,76,85,86,32,111,114,32,76,111,103,76,0,89,44,32,76,0,88,89,90,44,32,76,117,118,0,83,71,73,76,111,103,32,99,111,109,112,114,101,115,115,105,111,110,32,115,117,112,112,
111,114,116,101,100,32,111,110,108,121,32,102,111,114,32,37,115,44,32,111,114,32,114,97,119,32,100,97,116,97,0,115,32,61,61,32,48,0,76,111,103,76,49,54,69,110,99,111,100,101,0,115,112,45,62,116,98,117,102,108,101,110,32,62,61,32,110,112,105,120,101,108,115,0,76,111,103,76,49,54,73,110,105,116,83,116,97,116,101,0,116,100,45,62,116,100,95,112,104,111,116,111,109,101,116,114,105,99,32,61,61,32,80,72,79,84,79,77,69,84,82,73,67,95,76,79,71,76,0,78,111,32,115,117,112,112,111,114,116,32,102,111,114,32,99,
111,110,118,101,114,116,105,110,103,32,117,115,101,114,32,100,97,116,97,32,102,111,114,109,97,116,32,116,111,32,76,111,103,76,0,78,111,32,115,112,97,99,101,32,102,111,114,32,83,71,73,76,111,103,32,116,114,97,110,115,108,97,116,105,111,110,32,98,117,102,102,101,114,0,76,111,103,76,117,118,69,110,99,111,100,101,51,50,0,76,111,103,76,117,118,69,110,99,111,100,101,50,52,0,76,111,103,76,117,118,73,110,105,116,83,116,97,116,101,0,116,100,45,62,116,100,95,112,104,111,116,111,109,101,116,114,105,99,32,61,
61,32,80,72,79,84,79,77,69,84,82,73,67,95,76,79,71,76,85,86,0,83,71,73,76,111,103,32,99,111,109,112,114,101,115,115,105,111,110,32,99,97,110,110,111,116,32,104,97,110,100,108,101,32,110,111,110,45,99,111,110,116,105,103,117,111,117,115,32,100,97,116,97,0,78,111,32,115,117,112,112,111,114,116,32,102,111,114,32,99,111,110,118,101,114,116,105,110,103,32,117,115,101,114,32,100,97,116,97,32,102,111,114,109,97,116,32,116,111,32,76,111,103,76,117,118,0,76,111,103,76,117,118,68,101,99,111,100,101,84,105,
108,101,0,76,111,103,76,117,118,68,101,99,111,100,101,83,116,114,105,112,0,76,111,103,76,117,118,83,101,116,117,112,68,101,99,111,100,101,0,76,111,103,76,49,54,68,101,99,111,100,101,0,78,111,116,32,101,110,111,117,103,104,32,100,97,116,97,32,97,116,32,114,111,119,32,37,108,117,32,40,115,104,111,114,116,32,37,108,108,117,32,112,105,120,101,108,115,41,0,76,111,103,76,117,118,68,101,99,111,100,101,51,50,0,76,111,103,76,117,118,68,101,99,111,100,101,50,52,0,83,71,73,76,111,103,68,97,116,97,70,109,116,
0,83,71,73,76,111,103,69,110,99,111,100,101,0,115,99,104,101,109,101,32,61,61,32,67,79,77,80,82,69,83,83,73,79,78,95,76,90,87,0,116,105,102,95,108,122,119,46,99,0,84,73,70,70,73,110,105,116,76,90,87,0,78,111,32,115,112,97,99,101,32,102,111,114,32,76,90,87,32,115,116,97,116,101,32,98,108,111,99,107,0,116,105,102,45,62,116,105,102,95,100,97,116,97,32,33,61,32,48,0,76,90,87,67,108,101,97,110,117,112,0,115,112,45,62,101,110,99,95,104,97,115,104,116,97,98,32,33,61,32,78,85,76,76,0,76,90,87,69,110,99,111,
100,101,0,110,98,105,116,115,32,60,61,32,66,73,84,83,95,77,65,88,0,76,90,87,80,114,101,69,110,99,111,100,101,0,76,90,87,83,101,116,117,112,69,110,99,111,100,101,0,78,111,32,115,112,97,99,101,32,102,111,114,32,76,90,87,32,104,97,115,104,32,116,97,98,108,101,0,76,90,87,68,101,99,111,100,101,0,115,112,45,62,100,101,99,95,99,111,100,101,116,97,98,32,33,61,32,78,85,76,76,0,76,90,87,68,101,99,111,100,101,58,32,83,116,114,105,112,32,37,100,32,110,111,116,32,116,101,114,109,105,110,97,116,101,100,32,119,
105,116,104,32,69,79,73,32,99,111,100,101,0,76,90,87,68,101,99,111,100,101,58,32,67,111,114,114,117,112,116,101,100,32,76,90,87,32,116,97,98,108,101,32,97,116,32,115,99,97,110,108,105,110,101,32,37,100,0,67,111,114,114,117,112,116,101,100,32,76,90,87,32,116,97,98,108,101,32,97,116,32,115,99,97,110,108,105,110,101,32,37,100,0,87,114,111,110,103,32,108,101,110,103,116,104,32,111,102,32,100,101,99,111,100,101,100,32,115,116,114,105,110,103,58,32,100,97,116,97,32,112,114,111,98,97,98,108,121,32,99,111,
114,114,117,112,116,101,100,32,97,116,32,115,99,97,110,108,105,110,101,32,37,100,0,66,111,103,117,115,32,101,110,99,111,100,105,110,103,44,32,108,111,111,112,32,105,110,32,116,104,101,32,99,111,100,101,32,116,97,98,108,101,59,32,115,99,97,110,108,105,110,101,32,37,100,0,78,111,116,32,101,110,111,117,103,104,32,100,97,116,97,32,97,116,32,115,99,97,110,108,105,110,101,32,37,100,32,40,115,104,111,114,116,32,37,108,108,117,32,98,121,116,101,115,41,0,76,90,87,80,114,101,68,101,99,111,100,101,0,79,108,
100,45,115,116,121,108,101,32,76,90,87,32,99,111,100,101,115,44,32,99,111,110,118,101,114,116,32,102,105,108,101,0,76,90,87,68,101,99,111,100,101,67,111,109,112,97,116,0,76,90,87,83,101,116,117,112,68,101,99,111,100,101,0,78,111,32,115,112,97,99,101,32,102,111,114,32,76,90,87,32,99,111,100,101,32,116,97,98,108,101,0,78,101,88,84,68,101,99,111,100,101,0,78,111,116,32,101,110,111,117,103,104,32,100,97,116,97,32,102,111,114,32,115,99,97,110,108,105,110,101,32,37,108,100,0,78,101,88,84,80,114,101,68,
101,99,111,100,101,0,85,110,115,117,112,112,111,114,116,101,100,32,66,105,116,115,80,101,114,83,97,109,112,108,101,32,61,32,37,100,0,115,99,104,101,109,101,61,61,67,79,77,80,82,69,83,83,73,79,78,95,79,74,80,69,71,0,116,105,102,95,111,106,112,101,103,46,99,0,84,73,70,70,73,110,105,116,79,74,80,69,71,0,77,101,114,103,105,110,103,32,79,108,100,32,74,80,69,71,32,99,111,100,101,99,45,115,112,101,99,105,102,105,99,32,116,97,103,115,32,102,97,105,108,101,100,0,78,111,32,115,112,97,99,101,32,102,111,114,
32,79,74,80,69,71,32,115,116,97,116,101,32,98,108,111,99,107,0,115,112,33,61,78,85,76,76,0,79,74,80,69,71,80,114,105,110,116,68,105,114,0,32,32,74,112,101,103,73,110,116,101,114,99,104,97,110,103,101,70,111,114,109,97,116,58,32,37,108,117,10,0,32,32,74,112,101,103,73,110,116,101,114,99,104,97,110,103,101,70,111,114,109,97,116,76,101,110,103,116,104,58,32,37,108,117,10,0,32,32,74,112,101,103,81,84,97,98,108,101,115,58,0,32,37,108,117,0,32,32,74,112,101,103,68,99,84,97,98,108,101,115,58,0,32,32,74,
112,101,103,65,99,84,97,98,108,101,115,58,0,32,32,74,112,101,103,80,114,111,99,58,32,37,117,10,0,32,32,74,112,101,103,82,101,115,116,97,114,116,73,110,116,101,114,118,97,108,58,32,37,117,10,0,79,74,80,69,71,86,83,101,116,70,105,101,108,100,0,74,112,101,103,81,84,97,98,108,101,115,32,116,97,103,32,104,97,115,32,105,110,99,111,114,114,101,99,116,32,99,111,117,110,116,0,74,112,101,103,68,99,84,97,98,108,101,115,32,116,97,103,32,104,97,115,32,105,110,99,111,114,114,101,99,116,32,99,111,117,110,116,0,
74,112,101,103,65,99,84,97,98,108,101,115,32,116,97,103,32,104,97,115,32,105,110,99,111,114,114,101,99,116,32,99,111,117,110,116,0,115,112,45,62,115,117,98,115,97,109,112,108,105,110,103,99,111,114,114,101,99,116,95,100,111,110,101,61,61,48,0,79,74,80,69,71,83,117,98,115,97,109,112,108,105,110,103,67,111,114,114,101,99,116,0,83,117,98,115,97,109,112,108,105,110,103,32,116,97,103,32,110,111,116,32,97,112,112,114,111,112,114,105,97,116,101,32,102,111,114,32,116,104,105,115,32,80,104,111,116,111,109,
101,116,114,105,99,32,97,110,100,47,111,114,32,83,97,109,112,108,101,115,80,101,114,80,105,120,101,108,0,83,117,98,115,97,109,112,108,105,110,103,32,116,97,103,32,105,115,32,110,111,116,32,115,101,116,44,32,121,101,116,32,115,117,98,115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,97,116,97,32,91,37,100,44,37,100,93,32,100,111,101,115,32,110,111,116,32,109,97,116,99,104,32,100,101,102,97,117,108,116,32,118,97,108,117,101,115,32,91,50,44,50,93,59,32,97,115,115,117,109,
105,110,103,32,115,117,98,115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,97,116,97,32,105,115,32,99,111,114,114,101,99,116,0,83,117,98,115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,97,116,97,32,91,37,100,44,37,100,93,32,100,111,101,115,32,110,111,116,32,109,97,116,99,104,32,115,117,98,115,97,109,112,108,105,110,103,32,116,97,103,32,118,97,108,117,101,115,32,91,37,100,44,37,100,93,59,32,97,115,115,117,109,105,110,103,32,115,117,98,
115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,97,116,97,32,105,115,32,99,111,114,114,101,99,116,0,83,117,98,115,97,109,112,108,105,110,103,32,116,97,103,32,105,115,32,110,111,116,32,115,101,116,44,32,121,101,116,32,115,117,98,115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,97,116,97,32,100,111,101,115,32,110,111,116,32,109,97,116,99,104,32,100,101,102,97,117,108,116,32,118,97,108,117,101,115,32,91,50,44,50,93,32,40,110,111,114,32,97,
110,121,32,111,116,104,101,114,32,118,97,108,117,101,115,32,97,108,108,111,119,101,100,32,105,110,32,84,73,70,70,41,59,32,97,115,115,117,109,105,110,103,32,115,117,98,115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,97,116,97,32,105,115,32,99,111,114,114,101,99,116,32,97,110,100,32,100,101,115,117,98,115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,101,99,111,109,112,114,101,115,115,105,111,110,0,83,117,98,115,97,109,112,108,105,110,103,
32,105,110,115,105,100,101,32,74,80,69,71,32,100,97,116,97,32,100,111,101,115,32,110,111,116,32,109,97,116,99,104,32,115,117,98,115,97,109,112,108,105,110,103,32,116,97,103,32,118,97,108,117,101,115,32,91,37,100,44,37,100,93,32,40,110,111,114,32,97,110,121,32,111,116,104,101,114,32,118,97,108,117,101,115,32,97,108,108,111,119,101,100,32,105,110,32,84,73,70,70,41,59,32,97,115,115,117,109,105,110,103,32,115,117,98,115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,97,116,
97,32,105,115,32,99,111,114,114,101,99,116,32,97,110,100,32,100,101,115,117,98,115,97,109,112,108,105,110,103,32,105,110,115,105,100,101,32,74,80,69,71,32,100,101,99,111,109,112,114,101,115,115,105,111,110,0,83,117,98,115,97,109,112,108,105,110,103,32,118,97,108,117,101,115,32,91,37,100,44,37,100,93,32,97,114,101,32,110,111,116,32,97,108,108,111,119,101,100,32,105,110,32,84,73,70,70,0,115,112,45,62,105,110,95,98,117,102,102,101,114,95,116,111,103,111,62,48,0,79,74,80,69,71,82,101,97,100,66,121,116,
101,80,101,101,107,0,79,74,80,69,71,82,101,97,100,66,121,116,101,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,0,67,111,114,114,117,112,116,32,74,80,69,71,32,100,97,116,97,0,115,112,45,62,105,110,95,98,117,102,102,101,114,95,116,111,103,111,61,61,48,0,79,74,80,69,71,82,101,97,100,83,107,105,112,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,83,116,114,101,97,109,68,114,105,0,67,111,114,114,117,112,116,32,68,82,73,32,109,97,114,107,101,
114,32,105,110,32,74,80,69,71,32,100,97,116,97,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,83,116,114,101,97,109,68,113,116,0,67,111,114,114,117,112,116,32,68,81,84,32,109,97,114,107,101,114,32,105,110,32,74,80,69,71,32,100,97,116,97,0,79,117,116,32,111,102,32,109,101,109,111,114,121,0,79,74,80,69,71,82,101,97,100,66,108,111,99,107,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,83,116,114,101,97,109,68,104,116,0,67,111,114,114,117,112,
116,32,68,72,84,32,109,97,114,107,101,114,32,105,110,32,74,80,69,71,32,100,97,116,97,0,108,101,110,62,48,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,83,116,114,101,97,109,83,111,102,0,67,111,114,114,117,112,116,32,83,79,70,32,109,97,114,107,101,114,32,105,110,32,74,80,69,71,32,100,97,116,97,0,74,80,69,71,32,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,32,105,110,100,105,99,97,116,101,115,32,117,110,101,120,112,101,99,116,101,100,32,110,117,109,98,101,114,
32,111,102,32,115,97,109,112,108,101,115,0,74,80,69,71,32,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,32,105,110,100,105,99,97,116,101,115,32,117,110,101,120,112,101,99,116,101,100,32,110,117,109,98,101,114,32,111,102,32,98,105,116,115,32,112,101,114,32,115,97,109,112,108,101,0,74,80,69,71,32,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,32,105,110,100,105,99,97,116,101,115,32,117,110,101,120,112,101,99,116,101,100,32,104,101,105,103,104,116,0,74,80,69,71,32,99,111,109,112,114,
101,115,115,101,100,32,100,97,116,97,32,105,110,100,105,99,97,116,101,115,32,117,110,101,120,112,101,99,116,101,100,32,119,105,100,116,104,0,74,80,69,71,32,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,32,105,109,97,103,101,32,119,105,100,116,104,32,101,120,99,101,101,100,115,32,101,120,112,101,99,116,101,100,32,105,109,97,103,101,32,119,105,100,116,104,0,74,80,69,71,32,99,111,109,112,114,101,115,115,101,100,32,100,97,116,97,32,105,110,100,105,99,97,116,101,115,32,117,110,101,120,112,101,
99,116,101,100,32,115,117,98,115,97,109,112,108,105,110,103,32,118,97,108,117,101,115,0,115,112,45,62,112,108,97,110,101,95,115,97,109,112,108,101,95,111,102,102,115,101,116,61,61,48,0,85,110,107,110,111,119,110,32,109,97,114,107,101,114,32,116,121,112,101,32,37,100,32,105,110,32,74,80,69,71,32,100,97,116,97,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,84,97,98,108,101,115,81,84,97,98,108,101,0,77,105,115,115,105,110,103,32,74,80,69,71,32,116,97,98,108,101,115,0,67,
111,114,114,117,112,116,32,74,112,101,103,81,84,97,98,108,101,115,32,116,97,103,32,118,97,108,117,101,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,84,97,98,108,101,115,68,99,84,97,98,108,101,0,67,111,114,114,117,112,116,32,74,112,101,103,68,99,84,97,98,108,101,115,32,116,97,103,32,118,97,108,117,101,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,84,97,98,108,101,115,65,99,84,97,98,108,101,0,67,111,114,114,117,112,116,32,74,112,101,103,
65,99,84,97,98,108,101,115,32,116,97,103,32,118,97,108,117,101,0,115,112,45,62,115,117,98,115,97,109,112,108,105,110,103,99,111,114,114,101,99,116,61,61,48,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,83,101,99,83,116,114,101,97,109,83,111,115,0,67,111,114,114,117,112,116,32,83,79,83,32,109,97,114,107,101,114,32,105,110,32,74,80,69,71,32,100,97,116,97,0,110,62,48,0,79,74,80,69,71,82,101,97,100,66,117,102,102,101,114,70,105,108,108,0,110,60,61,79,74,80,69,71,95,66,85,70,70,69,
82,0,40,117,105,110,116,54,52,41,110,60,61,115,112,45,62,105,110,95,98,117,102,102,101,114,95,102,105,108,101,95,116,111,103,111,0,115,112,45,62,108,105,98,106,112,101,103,95,115,101,115,115,105,111,110,95,97,99,116,105,118,101,33,61,48,0,79,74,80,69,71,76,105,98,106,112,101,103,83,101,115,115,105,111,110,65,98,111,114,116,0,79,74,80,69,71,69,110,99,111,100,101,0,79,74,80,69,71,32,101,110,99,111,100,105,110,103,32,110,111,116,32,115,117,112,112,111,114,116,101,100,59,32,117,115,101,32,110,101,119,
45,115,116,121,108,101,32,74,80,69,71,32,99,111,109,112,114,101,115,115,105,111,110,32,105,110,115,116,101,97,100,0,79,74,80,69,71,80,111,115,116,69,110,99,111,100,101,0,79,74,80,69,71,80,114,101,69,110,99,111,100,101,0,79,74,80,69,71,83,101,116,117,112,69,110,99,111,100,101,0,79,74,80,69,71,68,101,99,111,100,101,82,97,119,0,70,114,97,99,116,105,111,110,97,108,32,115,99,97,110,108,105,110,101,32,110,111,116,32,114,101,97,100,0,99,99,62,48,0,79,74,80,69,71,68,101,99,111,100,101,83,99,97,110,108,105,
110,101,115,0,79,74,80,69,71,80,111,115,116,68,101,99,111,100,101,0,115,112,45,62,114,101,97,100,104,101,97,100,101,114,95,100,111,110,101,61,61,48,0,79,74,80,69,71,82,101,97,100,72,101,97,100,101,114,73,110,102,111,0,83,97,109,112,108,101,115,80,101,114,80,105,120,101,108,32,37,100,32,110,111,116,32,115,117,112,112,111,114,116,101,100,32,102,111,114,32,116,104,105,115,32,99,111,109,112,114,101,115,115,105,111,110,32,115,99,104,101,109,101,0,73,110,99,111,109,112,97,116,105,98,108,101,32,118,101,
114,116,105,99,97,108,32,115,117,98,115,97,109,112,108,105,110,103,32,97,110,100,32,105,109,97,103,101,32,115,116,114,105,112,47,116,105,108,101,32,108,101,110,103,116,104,0,115,62,48,0,79,74,80,69,71,82,101,97,100,83,101,99,111,110,100,97,114,121,83,111,115,0,115,60,51,0,115,112,45,62,115,111,115,95,101,110,100,91,48,93,46,108,111,103,33,61,48,0,115,112,45,62,115,111,115,95,101,110,100,91,115,93,46,108,111,103,61,61,48,0,115,112,45,62,115,117,98,115,97,109,112,108,105,110,103,95,99,111,110,118,101,
114,116,95,121,99,98,99,114,98,117,102,61,61,48,0,79,74,80,69,71,87,114,105,116,101,72,101,97,100,101,114,73,110,102,111,0,115,112,45,62,115,117,98,115,97,109,112,108,105,110,103,95,99,111,110,118,101,114,116,95,121,99,98,99,114,105,109,97,103,101,61,61,48,0,79,74,80,69,71,80,114,101,68,101,99,111,100,101,83,107,105,112,83,99,97,110,108,105,110,101,115,0,76,105,98,74,112,101,103,0,85,110,101,120,112,101,99,116,101,100,32,101,114,114,111,114,0,115,112,45,62,111,117,116,95,115,116,97,116,101,60,61,
111,115,111,115,69,111,105,0,79,74,80,69,71,87,114,105,116,101,83,116,114,101,97,109,0,50,53,53,62,61,56,43,115,112,45,62,115,97,109,112,108,101,115,95,112,101,114,95,112,105,120,101,108,95,112,101,114,95,112,108,97,110,101,42,51,0,79,74,80,69,71,87,114,105,116,101,83,116,114,101,97,109,83,111,102,0,50,53,53,62,61,54,43,115,112,45,62,115,97,109,112,108,101,115,95,112,101,114,95,112,105,120,101,108,95,112,101,114,95,112,108,97,110,101,42,50,0,79,74,80,69,71,87,114,105,116,101,83,116,114,101,97,109,
83,111,115,0,79,74,80,69,71,87,114,105,116,101,83,116,114,101,97,109,67,111,109,112,114,101,115,115,101,100,0,80,114,101,109,97,116,117,114,101,32,101,110,100,32,111,102,32,74,80,69,71,32,100,97,116,97,0,79,74,80,69,71,83,101,116,117,112,68,101,99,111,100,101,0,68,101,112,114,101,99,105,97,116,101,100,32,97,110,100,32,116,114,111,117,98,108,101,115,111,109,101,32,111,108,100,45,115,116,121,108,101,32,74,80,69,71,32,99,111,109,112,114,101,115,115,105,111,110,32,109,111,100,101,44,32,112,108,101,97,
115,101,32,99,111,110,118,101,114,116,32,116,111,32,110,101,119,45,115,116,121,108,101,32,74,80,69,71,32,99,111,109,112,114,101,115,115,105,111,110,32,97,110,100,32,110,111,116,105,102,121,32,118,101,110,100,111,114,32,111,102,32,119,114,105,116,105,110,103,32,115,111,102,116,119,97,114,101,0,74,112,101,103,73,110,116,101,114,99,104,97,110,103,101,70,111,114,109,97,116,0,74,112,101,103,73,110,116,101,114,99,104,97,110,103,101,70,111,114,109,97,116,76,101,110,103,116,104,0,74,112,101,103,81,84,97,
98,108,101,115,0,74,112,101,103,68,99,84,97,98,108,101,115,0,74,112,101,103,65,99,84,97,98,108,101,115,0,74,112,101,103,80,114,111,99,0,74,112,101,103,82,101,115,116,97,114,116,73,110,116,101,114,118,97,108,0,80,97,99,107,66,105,116,115,68,101,99,111,100,101,0,68,105,115,99,97,114,100,105,110,103,32,37,108,117,32,98,121,116,101,115,32,116,111,32,97,118,111,105,100,32,98,117,102,102,101,114,32,111,118,101,114,114,117,110,0,84,101,114,109,105,110,97,116,105,110,103,32,80,97,99,107,66,105,116,115,68,
101,99,111,100,101,32,100,117,101,32,116,111,32,108,97,99,107,32,111,102,32,100,97,116,97,46,0,78,111,116,32,101,110,111,117,103,104,32,100,97,116,97,32,102,111,114,32,115,99,97,110,108,105,110,101,32,37,108,117,0,115,99,104,101,109,101,32,61,61,32,67,79,77,80,82,69,83,83,73,79,78,95,80,73,88,65,82,76,79,71,0,116,105,102,95,112,105,120,97,114,108,111,103,46,99,0,84,73,70,70,73,110,105,116,80,105,120,97,114,76,111,103,0,77,101,114,103,105,110,103,32,80,105,120,97,114,76,111,103,32,99,111,100,101,99,
45,115,112,101,99,105,102,105,99,32,116,97,103,115,32,102,97,105,108,101,100,0,78,111,32,115,112,97,99,101,32,102,111,114,32,80,105,120,97,114,76,111,103,32,115,116,97,116,101,32,98,108,111,99,107,0,80,105,120,97,114,76,111,103,86,83,101,116,70,105,101,108,100,0,80,105,120,97,114,76,111,103,67,108,101,97,110,117,112,0,80,105,120,97,114,76,111,103,69,110,99,111,100,101,0,37,100,32,98,105,116,32,105,110,112,117,116,32,110,111,116,32,115,117,112,112,111,114,116,101,100,32,105,110,32,80,105,120,97,114,
76,111,103,0,90,76,105,98,32,99,97,110,110,111,116,32,100,101,97,108,32,119,105,116,104,32,98,117,102,102,101,114,115,32,116,104,105,115,32,115,105,122,101,0,80,105,120,97,114,76,111,103,80,111,115,116,69,110,99,111,100,101,0,80,105,120,97,114,76,111,103,80,114,101,69,110,99,111,100,101,0,80,105,120,97,114,76,111,103,83,101,116,117,112,69,110,99,111,100,101,0,80,105,120,97,114,76,111,103,32,99,111,109,112,114,101,115,115,105,111,110,32,99,97,110,39,116,32,104,97,110,100,108,101,32,37,100,32,98,105,
116,32,108,105,110,101,97,114,32,101,110,99,111,100,105,110,103,115,0,80,105,120,97,114,76,111,103,68,101,99,111,100,101,0,115,116,114,105,100,101,32,37,108,117,32,105,115,32,110,111,116,32,97,32,109,117,108,116,105,112,108,101,32,111,102,32,115,97,109,112,108,101,32,99,111,117,110,116,44,32,37,108,117,44,32,100,97,116,97,32,116,114,117,110,99,97,116,101,100,46,0,85,110,115,117,112,112,111,114,116,101,100,32,98,105,116,115,47,115,97,109,112,108,101,58,32,37,100,0,80,105,120,97,114,76,111,103,80,114,
101,68,101,99,111,100,101,0,80,105,120,97,114,76,111,103,83,101,116,117,112,68,101,99,111,100,101,0,80,105,120,97,114,76,111,103,32,99,111,109,112,114,101,115,115,105,111,110,32,99,97,110,39,116,32,104,97,110,100,108,101,32,98,105,116,115,32,100,101,112,116,104,47,100,97,116,97,32,102,111,114,109,97,116,32,99,111,109,98,105,110,97,116,105,111,110,32,40,100,101,112,116,104,58,32,37,100,41,0,116,105,102,95,112,114,101,100,105,99,116,46,99,0,84,73,70,70,80,114,101,100,105,99,116,111,114,73,110,105,116,
0,77,101,114,103,105,110,103,32,80,114,101,100,105,99,116,111,114,32,99,111,100,101,99,45,115,112,101,99,105,102,105,99,32,116,97,103,115,32,102,97,105,108,101,100,0,84,73,70,70,80,114,101,100,105,99,116,111,114,67,108,101,97,110,117,112,0,40,99,99,37,40,98,112,115,42,115,116,114,105,100,101,41,41,61,61,48,0,102,112,68,105,102,102,0,80,114,101,100,105,99,116,111,114,69,110,99,111,100,101,84,105,108,101,0,115,112,45,62,101,110,99,111,100,101,112,102,117,110,99,32,33,61,32,78,85,76,76,0,115,112,45,
62,101,110,99,111,100,101,116,105,108,101,32,33,61,32,78,85,76,76,0,79,117,116,32,111,102,32,109,101,109,111,114,121,32,97,108,108,111,99,97,116,105,110,103,32,37,108,100,32,98,121,116,101,32,116,101,109,112,32,98,117,102,102,101,114,46,0,114,111,119,115,105,122,101,32,62,32,48,0,40,99,99,48,37,114,111,119,115,105,122,101,41,61,61,48,0,80,114,101,100,105,99,116,111,114,69,110,99,111,100,101,82,111,119,0,115,112,45,62,101,110,99,111,100,101,114,111,119,32,33,61,32,78,85,76,76,0,40,99,99,37,40,52,42,
115,116,114,105,100,101,41,41,61,61,48,0,104,111,114,68,105,102,102,51,50,0,40,99,99,37,40,50,42,115,116,114,105,100,101,41,41,61,61,48,0,104,111,114,68,105,102,102,49,54,0,40,99,99,37,115,116,114,105,100,101,41,61,61,48,0,104,111,114,68,105,102,102,56,0,80,114,101,100,105,99,116,111,114,83,101,116,117,112,0,72,111,114,105,122,111,110,116,97,108,32,100,105,102,102,101,114,101,110,99,105,110,103,32,34,80,114,101,100,105,99,116,111,114,34,32,110,111,116,32,115,117,112,112,111,114,116,101,100,32,119,
105,116,104,32,37,100,45,98,105,116,32,115,97,109,112,108,101,115,0,70,108,111,97,116,105,110,103,32,112,111,105,110,116,32,34,80,114,101,100,105,99,116,111,114,34,32,110,111,116,32,115,117,112,112,111,114,116,101,100,32,119,105,116,104,32,37,100,32,100,97,116,97,32,102,111,114,109,97,116,0,34,80,114,101,100,105,99,116,111,114,34,32,118,97,108,117,101,32,37,100,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,102,112,65,99,99,0,80,114,101,100,105,99,116,111,114,68,101,99,111,100,101,84,105,
108,101,0,115,112,45,62,100,101,99,111,100,101,116,105,108,101,32,33,61,32,78,85,76,76,0,40,111,99,99,48,37,114,111,119,115,105,122,101,41,61,61,48,0,115,112,45,62,100,101,99,111,100,101,112,102,117,110,99,32,33,61,32,78,85,76,76,0,80,114,101,100,105,99,116,111,114,68,101,99,111,100,101,82,111,119,0,115,112,45,62,100,101,99,111,100,101,114,111,119,32,33,61,32,78,85,76,76,0,104,111,114,65,99,99,51,50,0,104,111,114,65,99,99,49,54,0,104,111,114,65,99,99,56,0,32,32,80,114,101,100,105,99,116,111,114,58,
32,0,110,111,110,101,32,0,104,111,114,105,122,111,110,116,97,108,32,100,105,102,102,101,114,101,110,99,105,110,103,32,0,102,108,111,97,116,105,110,103,32,112,111,105,110,116,32,112,114,101,100,105,99,116,111,114,32,0,37,117,32,40,48,120,37,120,41,10,0,80,114,101,100,105,99,116,111,114,86,83,101,116,70,105,101,108,100,0,115,112,45,62,118,115,101,116,112,97,114,101,110,116,32,33,61,32,78,85,76,76,0,80,114,101,100,105,99,116,111,114,86,71,101,116,70],"i8",4,ra.GLOBAL_BASE+143490);vc([105,101,108,100,
0,115,112,45,62,118,103,101,116,112,97,114,101,110,116,32,33,61,32,78,85,76,76,0,80,114,101,100,105,99,116,111,114,0,84,104,117,110,100,101,114,68,101,99,111,100,101,82,111,119,0,70,114,97,99,116,105,111,110,97,108,32,115,99,97,110,108,105,110,101,115,32,99,97,110,110,111,116,32,98,101,32,114,101,97,100,0,78,111,116,32,101,110,111,117,103,104,0,84,111,111,32,109,117,99,104,0,84,104,117,110,100,101,114,68,101,99,111,100,101,0,37,115,32,100,97,116,97,32,97,116,32,115,99,97,110,108,105,110,101,32,37,
108,117,32,40,37,108,108,117,32,33,61,32,37,108,108,117,41,0,84,104,117,110,100,101,114,83,101,116,117,112,68,101,99,111,100,101,0,87,114,111,110,103,32,98,105,116,115,112,101,114,115,97,109,112,108,101,32,118,97,108,117,101,32,40,37,100,41,44,32,84,104,117,110,100,101,114,32,100,101,99,111,100,101,114,32,111,110,108,121,32,115,117,112,112,111,114,116,115,32,52,98,105,116,115,32,112,101,114,32,115,97,109,112,108,101,46,0,40,115,99,104,101,109,101,32,61,61,32,67,79,77,80,82,69,83,83,73,79,78,95,68,
69,70,76,65,84,69,41,32,124,124,32,40,115,99,104,101,109,101,32,61,61,32,67,79,77,80,82,69,83,83,73,79,78,95,65,68,79,66,69,95,68,69,70,76,65,84,69,41,0,116,105,102,95,122,105,112,46,99,0,84,73,70,70,73,110,105,116,90,73,80,0,77,101,114,103,105,110,103,32,68,101,102,108,97,116,101,32,99,111,100,101,99,45,115,112,101,99,105,102,105,99,32,116,97,103,115,32,102,97,105,108,101,100,0,78,111,32,115,112,97,99,101,32,102,111,114,32,90,73,80,32,115,116,97,116,101,32,98,108,111,99,107,0,115,112,32,33,61,32,
48,0,90,73,80,67,108,101,97,110,117,112,0,115,112,32,33,61,32,78,85,76,76,0,90,73,80,69,110,99,111,100,101,0,115,112,45,62,115,116,97,116,101,32,61,61,32,90,83,84,65,84,69,95,73,78,73,84,95,69,78,67,79,68,69,0,69,110,99,111,100,101,114,32,101,114,114,111,114,58,32,37,115,0,90,73,80,80,111,115,116,69,110,99,111,100,101,0,90,76,105,98,32,101,114,114,111,114,58,32,37,115,0,90,73,80,80,114,101,69,110,99,111,100,101,0,90,73,80,83,101,116,117,112,69,110,99,111,100,101,0,49,46,50,46,56,0,37,115,0,90,73,
80,68,101,99,111,100,101,0,115,112,45,62,115,116,97,116,101,32,61,61,32,90,83,84,65,84,69,95,73,78,73,84,95,68,69,67,79,68,69,0,68,101,99,111,100,105,110,103,32,101,114,114,111,114,32,97,116,32,115,99,97,110,108,105,110,101,32,37,108,117,44,32,37,115,0,78,111,116,32,101,110,111,117,103,104,32,100,97,116,97,32,97,116,32,115,99,97,110,108,105,110,101,32,37,108,117,32,40,115,104,111,114,116,32,37,108,117,32,98,121,116,101,115,41,0,90,73,80,80,114,101,68,101,99,111,100,101,0,90,73,80,83,101,116,117,112,
68,101,99,111,100,101,0,90,73,80,86,83,101,116,70,105,101,108,100,0,105,110,99,111,114,114,101,99,116,32,104,101,97,100,101,114,32,99,104,101,99,107,0,117,110,107,110,111,119,110,32,99,111,109,112,114,101,115,115,105,111,110,32,109,101,116,104,111,100,0,105,110,118,97,108,105,100,32,119,105,110,100,111,119,32,115,105,122,101,0,117,110,107,110,111,119,110,32,104,101,97,100,101,114,32,102,108,97,103,115,32,115,101,116,0,104,101,97,100,101,114,32,99,114,99,32,109,105,115,109,97,116,99,104,0,105,110,
118,97,108,105,100,32,98,108,111,99,107,32,116,121,112,101,0,105,110,118,97,108,105,100,32,115,116,111,114,101,100,32,98,108,111,99,107,32,108,101,110,103,116,104,115,0,116,111,111,32,109,97,110,121,32,108,101,110,103,116,104,32,111,114,32,100,105,115,116,97,110,99,101,32,115,121,109,98,111,108,115,0,105,110,118,97,108,105,100,32,99,111,100,101,32,108,101,110,103,116,104,115,32,115,101,116,0,105,110,118,97,108,105,100,32,98,105,116,32,108,101,110,103,116,104,32,114,101,112,101,97,116,0,105,110,118,
97,108,105,100,32,99,111,100,101,32,45,45,32,109,105,115,115,105,110,103,32,101,110,100,45,111,102,45,98,108,111,99,107,0,105,110,118,97,108,105,100,32,108,105,116,101,114,97,108,47,108,101,110,103,116,104,115,32,115,101,116,0,105,110,118,97,108,105,100,32,100,105,115,116,97,110,99,101,115,32,115,101,116,0,105,110,99,111,114,114,101,99,116,32,100,97,116,97,32,99,104,101,99,107,0,105,110,99,111,114,114,101,99,116,32,108,101,110,103,116,104,32,99,104,101,99,107,0,0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,
8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,
14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,
27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,
12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,
25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15,110,101,101,100,32,100,105,99,116,105,111,110,97,114,121,0,115,116,114,101,97,109,32,101,110,100,0,0,102,105,108,101,32,101,114,114,111,114,0,115,116,114,101,97,109,32,101,114,114,111,114,0,100,97,116,97,32,101,114,114,111,114,0,105,110,115,
117,102,102,105,99,105,101,110,116,32,109,101,109,111,114,121,0,98,117,102,102,101,114,32,101,114,114,111,114,0,105,110,99,111,109,112,97,116,105,98,108,101,32,118,101,114,115,105,111,110,0,105,110,118,97,108,105,100,32,100,105,115,116,97,110,99,101,32,116,111,111,32,102,97,114,32,98,97,99,107,0,105,110,118,97,108,105,100,32,100,105,115,116,97,110,99,101,32,99,111,100,101,0,105,110,118,97,108,105,100,32,108,105,116,101,114,97,108,47,108,101,110,103,116,104,32,99,111,100,101,0,0,0,1,5,1,1,1,1,1,1,
0,0,0,0,0,0,0,0,1,2,3,4,5,6,7,8,9,10,11,0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125,1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,
195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250,0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,2,3,4,5,6,7,8,9,10,11,0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119,0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,
116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250,83,79,83,0,76,83,69,0,66,111,103,117,115,32,109,101,115,115,97,103,101,32,99,111,100,101,32,37,100,0,65,76,73,71,78,95,84,89,80,69,32,105,115,32,119,114,111,110,103,44,32,112,108,101,97,
115,101,32,102,105,120,0,77,65,88,95,65,76,76,79,67,95,67,72,85,78,75,32,105,115,32,119,114,111,110,103,44,32,112,108,101,97,115,101,32,102,105,120,0,66,111,103,117,115,32,98,117,102,102,101,114,32,99,111,110,116,114,111,108,32,109,111,100,101,0,73,110,118,97,108,105,100,32,99,111,109,112,111,110,101,110,116,32,73,68,32,37,100,32,105,110,32,83,79,83,0,73,110,118,97,108,105,100,32,99,114,111,112,32,114,101,113,117,101,115,116,0,68,67,84,32,99,111,101,102,102,105,99,105,101,110,116,32,111,117,116,32,
111,102,32,114,97,110,103,101,0,68,67,84,32,115,99,97,108,101,100,32,98,108,111,99,107,32,115,105,122,101,32,37,100,120,37,100,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,67,111,109,112,111,110,101,110,116,32,105,110,100,101,120,32,37,100,58,32,109,105,115,109,97,116,99,104,105,110,103,32,115,97,109,112,108,105,110,103,32,114,97,116,105,111,32,37,100,58,37,100,44,32,37,100,58,37,100,44,32,37,99,0,66,111,103,117,115,32,72,117,102,102,109,97,110,32,116,97,98,108,101,32,100,101,102,105,110,
105,116,105,111,110,0,66,111,103,117,115,32,105,110,112,117,116,32,99,111,108,111,114,115,112,97,99,101,0,66,111,103,117,115,32,74,80,69,71,32,99,111,108,111,114,115,112,97,99,101,0,66,111,103,117,115,32,109,97,114,107,101,114,32,108,101,110,103,116,104,0,87,114,111,110,103,32,74,80,69,71,32,108,105,98,114,97,114,121,32,118,101,114,115,105,111,110,58,32,108,105,98,114,97,114,121,32,105,115,32,37,100,44,32,99,97,108,108,101,114,32,101,120,112,101,99,116,115,32,37,100,0,83,97,109,112,108,105,110,103,
32,102,97,99,116,111,114,115,32,116,111,111,32,108,97,114,103,101,32,102,111,114,32,105,110,116,101,114,108,101,97,118,101,100,32,115,99,97,110,0,73,110,118,97,108,105,100,32,109,101,109,111,114,121,32,112,111,111,108,32,99,111,100,101,32,37,100,0,85,110,115,117,112,112,111,114,116,101,100,32,74,80,69,71,32,100,97,116,97,32,112,114,101,99,105,115,105,111,110,32,37,100,0,73,110,118,97,108,105,100,32,112,114,111,103,114,101,115,115,105,118,101,32,112,97,114,97,109,101,116,101,114,115,32,83,115,61,37,
100,32,83,101,61,37,100,32,65,104,61,37,100,32,65,108,61,37,100,0,73,110,118,97,108,105,100,32,112,114,111,103,114,101,115,115,105,118,101,32,112,97,114,97,109,101,116,101,114,115,32,97,116,32,115,99,97,110,32,115,99,114,105,112,116,32,101,110,116,114,121,32,37,100,0,66,111,103,117,115,32,115,97,109,112,108,105,110,103,32,102,97,99,116,111,114,115,0,73,110,118,97,108,105,100,32,115,99,97,110,32,115,99,114,105,112,116,32,97,116,32,101,110,116,114,121,32,37,100,0,73,109,112,114,111,112,101,114,32,99,
97,108,108,32,116,111,32,74,80,69,71,32,108,105,98,114,97,114,121,32,105,110,32,115,116,97,116,101,32,37,100,0,74,80,69,71,32,112,97,114,97,109,101,116,101,114,32,115,116,114,117,99,116,32,109,105,115,109,97,116,99,104,58,32,108,105,98,114,97,114,121,32,116,104,105,110,107,115,32,115,105,122,101,32,105,115,32,37,117,44,32,99,97,108,108,101,114,32,101,120,112,101,99,116,115,32,37,117,0,66,111,103,117,115,32,118,105,114,116,117,97,108,32,97,114,114,97,121,32,97,99,99,101,115,115,0,66,117,102,102,101,
114,32,112,97,115,115,101,100,32,116,111,32,74,80,69,71,32,108,105,98,114,97,114,121,32,105,115,32,116,111,111,32,115,109,97,108,108,0,83,117,115,112,101,110,115,105,111,110,32,110,111,116,32,97,108,108,111,119,101,100,32,104,101,114,101,0,67,67,73,82,54,48,49,32,115,97,109,112,108,105,110,103,32,110,111,116,32,105,109,112,108,101,109,101,110,116,101,100,32,121,101,116,0,84,111,111,32,109,97,110,121,32,99,111,108,111,114,32,99,111,109,112,111,110,101,110,116,115,58,32,37,100,44,32,109,97,120,32,37,
100,0,85,110,115,117,112,112,111,114,116,101,100,32,99,111,108,111,114,32,99,111,110,118,101,114,115,105,111,110,32,114,101,113,117,101,115,116,0,66,111,103,117,115,32,68,65,67,32,105,110,100,101,120,32,37,100,0,66,111,103,117,115,32,68,65,67,32,118,97,108,117,101,32,48,120,37,120,0,66,111,103,117,115,32,68,72,84,32,105,110,100,101,120,32,37,100,0,66,111,103,117,115,32,68,81,84,32,105,110,100,101,120,32,37,100,0,69,109,112,116,121,32,74,80,69,71,32,105,109,97,103,101,32,40,68,78,76,32,110,111,116,
32,115,117,112,112,111,114,116,101,100,41,0,82,101,97,100,32,102,114,111,109,32,69,77,83,32,102,97,105,108,101,100,0,87,114,105,116,101,32,116,111,32,69,77,83,32,102,97,105,108,101,100,0,68,105,100,110,39,116,32,101,120,112,101,99,116,32,109,111,114,101,32,116,104,97,110,32,111,110,101,32,115,99,97,110,0,73,110,112,117,116,32,102,105,108,101,32,114,101,97,100,32,101,114,114,111,114,0,79,117,116,112,117,116,32,102,105,108,101,32,119,114,105,116,101,32,101,114,114,111,114,32,45,45,45,32,111,117,116,
32,111,102,32,100,105,115,107,32,115,112,97,99,101,63,0,70,114,97,99,116,105,111,110,97,108,32,115,97,109,112,108,105,110,103,32,110,111,116,32,105,109,112,108,101,109,101,110,116,101,100,32,121,101,116,0,72,117,102,102,109,97,110,32,99,111,100,101,32,115,105,122,101,32,116,97,98,108,101,32,111,118,101,114,102,108,111,119,0,77,105,115,115,105,110,103,32,72,117,102,102,109,97,110,32,99,111,100,101,32,116,97,98,108,101,32,101,110,116,114,121,0,77,97,120,105,109,117,109,32,115,117,112,112,111,114,116,
101,100,32,105,109,97,103,101,32,100,105,109,101,110,115,105,111,110,32,105,115,32,37,117,32,112,105,120,101,108,115,0,69,109,112,116,121,32,105,110,112,117,116,32,102,105,108,101,0,80,114,101,109,97,116,117,114,101,32,101,110,100,32,111,102,32,105,110,112,117,116,32,102,105,108,101,0,67,97,110,110,111,116,32,116,114,97,110,115,99,111,100,101,32,100,117,101,32,116,111,32,109,117,108,116,105,112,108,101,32,117,115,101,32,111,102,32,113,117,97,110,116,105,122,97,116,105,111,110,32,116,97,98,108,101,
32,37,100,0,83,99,97,110,32,115,99,114,105,112,116,32,100,111,101,115,32,110,111,116,32,116,114,97,110,115,109,105,116,32,97,108,108,32,100,97,116,97,0,73,110,118,97,108,105,100,32,99,111,108,111,114,32,113,117,97,110,116,105,122,97,116,105,111,110,32,109,111,100,101,32,99,104,97,110,103,101,0,78,111,116,32,105,109,112,108,101,109,101,110,116,101,100,32,121,101,116,0,82,101,113,117,101,115,116,101,100,32,102,101,97,116,117,114,101,32,119,97,115,32,111,109,105,116,116,101,100,32,97,116,32,99,111,109,
112,105,108,101,32,116,105,109,101,0,65,114,105,116,104,109,101,116,105,99,32,116,97,98,108,101,32,48,120,37,48,50,120,32,119,97,115,32,110,111,116,32,100,101,102,105,110,101,100,0,66,97,99,107,105,110,103,32,115,116,111,114,101,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,72,117,102,102,109,97,110,32,116,97,98,108,101,32,48,120,37,48,50,120,32,119,97,115,32,110,111,116,32,100,101,102,105,110,101,100,0,74,80,69,71,32,100,97,116,97,115,116,114,101,97,109,32,99,111,110,116,97,105,110,115,
32,110,111,32,105,109,97,103,101,0,81,117,97,110,116,105,122,97,116,105,111,110,32,116,97,98,108,101,32,48,120,37,48,50,120,32,119,97,115,32,110,111,116,32,100,101,102,105,110,101,100,0,78,111,116,32,97,32,74,80,69,71,32,102,105,108,101,58,32,115,116,97,114,116,115,32,119,105,116,104,32,48,120,37,48,50,120,32,48,120,37,48,50,120,0,73,110,115,117,102,102,105,99,105,101,110,116,32,109,101,109,111,114,121,32,40,99,97,115,101,32,37,100,41,0,67,97,110,110,111,116,32,113,117,97,110,116,105,122,101,32,109,
111,114,101,32,116,104,97,110,32,37,100,32,99,111,108,111,114,32,99,111,109,112,111,110,101,110,116,115,0,67,97,110,110,111,116,32,113,117,97,110,116,105,122,101,32,116,111,32,102,101,119,101,114,32,116,104,97,110,32,37,100,32,99,111,108,111,114,115,0,67,97,110,110,111,116,32,113,117,97,110,116,105,122,101,32,116,111,32,109,111,114,101,32,116,104,97,110,32,37,100,32,99,111,108,111,114,115,0,73,110,118,97,108,105,100,32,74,80,69,71,32,102,105,108,101,32,115,116,114,117,99,116,117,114,101,58,32,37,
115,32,98,101,102,111,114,101,32,83,79,70,0,73,110,118,97,108,105,100,32,74,80,69,71,32,102,105,108,101,32,115,116,114,117,99,116,117,114,101,58,32,116,119,111,32,83,79,70,32,109,97,114,107,101,114,115,0,73,110,118,97,108,105,100,32,74,80,69,71,32,102,105,108,101,32,115,116,114,117,99,116,117,114,101,58,32,109,105,115,115,105,110,103,32,83,79,83,32,109,97,114,107,101,114,0,85,110,115,117,112,112,111,114,116,101,100,32,74,80,69,71,32,112,114,111,99,101,115,115,58,32,83,79,70,32,116,121,112,101,32,
48,120,37,48,50,120,0,73,110,118,97,108,105,100,32,74,80,69,71,32,102,105,108,101,32,115,116,114,117,99,116,117,114,101,58,32,116,119,111,32,83,79,73,32,109,97,114,107,101,114,115,0,70,97,105,108,101,100,32,116,111,32,99,114,101,97,116,101,32,116,101,109,112,111,114,97,114,121,32,102,105,108,101,32,37,115,0,82,101,97,100,32,102,97,105,108,101,100,32,111,110,32,116,101,109,112,111,114,97,114,121,32,102,105,108,101,0,83,101,101,107,32,102,97,105,108,101,100,32,111,110,32,116,101,109,112,111,114,97,
114,121,32,102,105,108,101,0,87,114,105,116,101,32,102,97,105,108,101,100,32,111,110,32,116,101,109,112,111,114,97,114,121,32,102,105,108,101,32,45,45,45,32,111,117,116,32,111,102,32,100,105,115,107,32,115,112,97,99,101,63,0,65,112,112,108,105,99,97,116,105,111,110,32,116,114,97,110,115,102,101,114,114,101,100,32,116,111,111,32,102,101,119,32,115,99,97,110,108,105,110,101,115,0,85,110,115,117,112,112,111,114,116,101,100,32,109,97,114,107,101,114,32,116,121,112,101,32,48,120,37,48,50,120,0,86,105,
114,116,117,97,108,32,97,114,114,97,121,32,99,111,110,116,114,111,108,108,101,114,32,109,101,115,115,101,100,32,117,112,0,73,109,97,103,101,32,116,111,111,32,119,105,100,101,32,102,111,114,32,116,104,105,115,32,105,109,112,108,101,109,101,110,116,97,116,105,111,110,0,82,101,97,100,32,102,114,111,109,32,88,77,83,32,102,97,105,108,101,100,0,87,114,105,116,101,32,116,111,32,88,77,83,32,102,97,105,108,101,100,0,67,111,112,121,114,105,103,104,116,32,40,67,41,32,50,48,49,54,44,32,84,104,111,109,97,115,
32,71,46,32,76,97,110,101,44,32,71,117,105,100,111,32,86,111,108,108,98,101,100,105,110,103,0,57,98,32,32,49,55,45,74,97,110,45,50,48,49,54,0,67,97,117,116,105,111,110,58,32,113,117,97,110,116,105,122,97,116,105,111,110,32,116,97,98,108,101,115,32,97,114,101,32,116,111,111,32,99,111,97,114,115,101,32,102,111,114,32,98,97,115,101,108,105,110,101,32,74,80,69,71,0,65,100,111,98,101,32,65,80,80,49,52,32,109,97,114,107,101,114,58,32,118,101,114,115,105,111,110,32,37,100,44,32,102,108,97,103,115,32,48,
120,37,48,52,120,32,48,120,37,48,52,120,44,32,116,114,97,110,115,102,111,114,109,32,37,100,0,85,110,107,110,111,119,110,32,65,80,80,48,32,109,97,114,107,101,114,32,40,110,111,116,32,74,70,73,70,41,44,32,108,101,110,103,116,104,32,37,117,0,85,110,107,110,111,119,110,32,65,80,80,49,52,32,109,97,114,107,101,114,32,40,110,111,116,32,65,100,111,98,101,41,44,32,108,101,110,103,116,104,32,37,117,0,68,101,102,105,110,101,32,65,114,105,116,104,109,101,116,105,99,32,84,97,98,108,101,32,48,120,37,48,50,120,
58,32,48,120,37,48,50,120,0,68,101,102,105,110,101,32,72,117,102,102,109,97,110,32,84,97,98,108,101,32,48,120,37,48,50,120,0,68,101,102,105,110,101,32,81,117,97,110,116,105,122,97,116,105,111,110,32,84,97,98,108,101,32,37,100,32,32,112,114,101,99,105,115,105,111,110,32,37,100,0,68,101,102,105,110,101,32,82,101,115,116,97,114,116,32,73,110,116,101,114,118,97,108,32,37,117,0,70,114,101,101,100,32,69,77,83,32,104,97,110,100,108,101,32,37,117,0,79,98,116,97,105,110,101,100,32,69,77,83,32,104,97,110,100,
108,101,32,37,117,0,69,110,100,32,79,102,32,73,109,97,103,101,0,32,32,32,32,32,32,32,32,37,51,100,32,37,51,100,32,37,51,100,32,37,51,100,32,37,51,100,32,37,51,100,32,37,51,100,32,37,51,100,0,74,70,73,70,32,65,80,80,48,32,109,97,114,107,101,114,58,32,118,101,114,115,105,111,110,32,37,100,46,37,48,50,100,44,32,100,101,110,115,105,116,121,32,37,100,120,37,100,32,32,37,100,0,87,97,114,110,105,110,103,58,32,116,104,117,109,98,110,97,105,108,32,105,109,97,103,101,32,115,105,122,101,32,100,111,101,115,32,
110,111,116,32,109,97,116,99,104,32,100,97,116,97,32,108,101,110,103,116,104,32,37,117,0,74,70,73,70,32,101,120,116,101,110,115,105,111,110,32,109,97,114,107,101,114,58,32,116,121,112,101,32,48,120,37,48,50,120,44,32,108,101,110,103,116,104,32,37,117,0,32,32,32,32,119,105,116,104,32,37,100,32,120,32,37,100,32,116,104,117,109,98,110,97,105,108,32,105,109,97,103,101,0,77,105,115,99,101,108,108,97,110,101,111,117,115,32,109,97,114,107,101,114,32,48,120,37,48,50,120,44,32,108,101,110,103,116,104,32,37,
117,0,85,110,101,120,112,101,99,116,101,100,32,109,97,114,107,101,114,32,48,120,37,48,50,120,0,32,32,32,32,32,32,32,32,37,52,117,32,37,52,117,32,37,52,117,32,37,52,117,32,37,52,117,32,37,52,117,32,37,52,117,32,37,52,117,0,81,117,97,110,116,105,122,105,110,103,32,116,111,32,37,100,32,61,32,37,100,42,37,100,42,37,100,32,99,111,108,111,114,115,0,81,117,97,110,116,105,122,105,110,103,32,116,111,32,37,100,32,99,111,108,111,114,115,0,83,101,108,101,99,116,101,100,32,37,100,32,99,111,108,111,114,115,32,
102,111,114,32,113,117,97,110,116,105,122,97,116,105,111,110,0,65,116,32,109,97,114,107,101,114,32,48,120,37,48,50,120,44,32,114,101,99,111,118,101,114,121,32,97,99,116,105,111,110,32,37,100,0,82,83,84,37,100,0,83,109,111,111,116,104,105,110,103,32,110,111,116,32,115,117,112,112,111,114,116,101,100,32,119,105,116,104,32,110,111,110,115,116,97,110,100,97,114,100,32,115,97,109,112,108,105,110,103,32,114,97,116,105,111,115,0,83,116,97,114,116,32,79,102,32,70,114,97,109,101,32,48,120,37,48,50,120,58,
32,119,105,100,116,104,61,37,117,44,32,104,101,105,103,104,116,61,37,117,44,32,99,111,109,112,111,110,101,110,116,115,61,37,100,0,32,32,32,32,67,111,109,112,111,110,101,110,116,32,37,100,58,32,37,100,104,120,37,100,118,32,113,61,37,100,0,83,116,97,114,116,32,111,102,32,73,109,97,103,101,0,83,116,97,114,116,32,79,102,32,83,99,97,110,58,32,37,100,32,99,111,109,112,111,110,101,110,116,115,0,32,32,32,32,67,111,109,112,111,110,101,110,116,32,37,100,58,32,100,99,61,37,100,32,97,99,61,37,100,0,32,32,83,
115,61,37,100,44,32,83,101,61,37,100,44,32,65,104,61,37,100,44,32,65,108,61,37,100,0,67,108,111,115,101,100,32,116,101,109,112,111,114,97,114,121,32,102,105,108,101,32,37,115,0,79,112,101,110,101,100,32,116,101,109,112,111,114,97,114,121,32,102,105,108,101,32,37,115,0,74,70,73,70,32,101,120,116,101,110,115,105,111,110,32,109,97,114,107,101,114,58,32,74,80,69,71,45,99,111,109,112,114,101,115,115,101,100,32,116,104,117,109,98,110,97,105,108,32,105,109,97,103,101,44,32,108,101,110,103,116,104,32,37,
117,0,74,70,73,70,32,101,120,116,101,110,115,105,111,110,32,109,97,114,107,101,114,58,32,112,97,108,101,116,116,101,32,116,104,117,109,98,110,97,105,108,32,105,109,97,103,101,44,32,108,101,110,103,116,104,32,37,117,0,74,70,73,70,32,101,120,116,101,110,115,105,111,110,32,109,97,114,107,101,114,58,32,82,71,66,32,116,104,117,109,98,110,97,105,108,32,105,109,97,103,101,44,32,108,101,110,103,116,104,32,37,117,0,85,110,114,101,99,111,103,110,105,122,101,100,32,99,111,109,112,111,110,101,110,116,32,73,68,
115,32,37,100,32,37,100,32,37,100,44,32,97,115,115,117,109,105,110,103,32,89,67,98,67,114,0,70,114,101,101,100,32,88,77,83,32,104,97,110,100,108,101,32,37,117,0,79,98,116,97,105,110,101,100,32,88,77,83,32,104,97,110,100,108,101,32,37,117,0,85,110,107,110,111,119,110,32,65,100,111,98,101,32,99,111,108,111,114,32,116,114,97,110,115,102,111,114,109,32,99,111,100,101,32,37,100,0,67,111,114,114,117,112,116,32,74,80,69,71,32,100,97,116,97,58,32,98,97,100,32,97,114,105,116,104,109,101,116,105,99,32,99,111,
100,101,0,73,110,99,111,110,115,105,115,116,101,110,116,32,112,114,111,103,114,101,115,115,105,111,110,32,115,101,113,117,101,110,99,101,32,102,111,114,32,99,111,109,112,111,110,101,110,116,32,37,100,32,99,111,101,102,102,105,99,105,101,110,116,32,37,100,0,67,111,114,114,117,112,116,32,74,80,69,71,32,100,97,116,97,58,32,37,117,32,101,120,116,114,97,110,101,111,117,115,32,98,121,116,101,115,32,98,101,102,111,114,101,32,109,97,114,107,101,114,32,48,120,37,48,50,120,0,67,111,114,114,117,112,116,32,74,
80,69,71,32,100,97,116,97,58,32,112,114,101,109,97,116,117,114,101,32,101,110,100,32,111,102,32,100,97,116,97,32,115,101,103,109,101,110,116,0,67,111,114,114,117,112,116,32,74,80,69,71,32,100,97,116,97,58,32,98,97,100,32,72,117,102,102,109,97,110,32,99,111,100,101,0,87,97,114,110,105,110,103,58,32,117,110,107,110,111,119,110,32,74,70,73,70,32,114,101,118,105,115,105,111,110,32,110,117,109,98,101,114,32,37,100,46,37,48,50,100,0,80,114,101,109,97,116,117,114,101,32,101,110,100,32,111,102,32,74,80,69,
71,32,102,105,108,101,0,67,111,114,114,117,112,116,32,74,80,69,71,32,100,97,116,97,58,32,102,111,117,110,100,32,109,97,114,107,101,114,32,48,120,37,48,50,120,32,105,110,115,116,101,97,100,32,111,102,32,82,83,84,37,100,0,73,110,118,97,108,105,100,32,83,79,83,32,112,97,114,97,109,101,116,101,114,115,32,102,111,114,32,115,101,113,117,101,110,116,105,97,108,32,74,80,69,71,0,65,112,112,108,105,99,97,116,105,111,110,32,116,114,97,110,115,102,101,114,114,101,100,32,116,111,111,32,109,97,110,121,32,115,99,
97,110,108,105,110,101,115,0,37,115,10,0,0,192,48,240,12,204,60,252,3,195,51,243,15,207,63,255,128,64,176,112,140,76,188,124,131,67,179,115,143,79,191,127,32,224,16,208,44,236,28,220,35,227,19,211,47,239,31,223,160,96,144,80,172,108,156,92,163,99,147,83,175,111,159,95,8,200,56,248,4,196,52,244,11,203,59,251,7,199,55,247,136,72,184,120,132,68,180,116,139,75,187,123,135,71,183,119,40,232,24,216,36,228,20,212,43,235,27,219,39,231,23,215,168,104,152,88,164,100,148,84,171,107,155,91,167,103,151,87,2,194,
50,242,14,206,62,254,1,193,49,241,13,205,61,253,130,66,178,114,142,78,190,126,129,65,177,113,141,77,189,125,34,226,18,210,46,238,30,222,33,225,17,209,45,237,29,221,162,98,146,82,174,110,158,94,161,97,145,81,173,109,157,93,10,202,58,250,6,198,54,246,9,201,57,249,5,197,53,245,138,74,186,122,134,70,182,118,137,73,185,121,133,69,181,117,42,234,26,218,38,230,22,214,41,233,25,217,37,229,21,213,170,106,154,90,166,102,150,86,169,105,153,89,165,101,149,85,74,80,69,71,77,69,77,0,37,108,100,37,99,0,84,33,34,
25,13,1,2,3,17,75,28,12,16,4,11,29,18,30,39,104,110,111,112,113,98,32,5,6,15,19,20,21,26,8,22,7,40,36,23,24,9,10,14,27,31,37,35,131,130,125,38,42,43,60,61,62,63,67,71,74,77,88,89,90,91,92,93,94,95,96,97,99,100,101,102,103,105,106,107,108,114,115,116,121,122,123,124,0,73,108,108,101,103,97,108,32,98,121,116,101,32,115,101,113,117,101,110,99,101,0,68,111,109,97,105,110,32,101,114,114,111,114,0,82,101,115,117,108,116,32,110,111,116,32,114,101,112,114,101,115,101,110,116,97,98,108,101,0,78,111,116,32,
97,32,116,116,121,0,80,101,114,109,105,115,115,105,111,110,32,100,101,110,105,101,100,0,79,112,101,114,97,116,105,111,110,32,110,111,116,32,112,101,114,109,105,116,116,101,100,0,78,111,32,115,117,99,104,32,102,105,108,101,32,111,114,32,100,105,114,101,99,116,111,114,121,0,78,111,32,115,117,99,104,32,112,114,111,99,101,115,115,0,70,105,108,101,32,101,120,105,115,116,115,0,86,97,108,117,101,32,116,111,111,32,108,97,114,103,101,32,102,111,114,32,100,97,116,97,32,116,121,112,101,0,78,111,32,115,112,97,
99,101,32,108,101,102,116,32,111,110,32,100,101,118,105,99,101,0,79,117,116,32,111,102,32,109,101,109,111,114,121,0,82,101,115,111,117,114,99,101,32,98,117,115,121,0,73,110,116,101,114,114,117,112,116,101,100,32,115,121,115,116,101,109,32,99,97,108,108,0,82,101,115,111,117,114,99,101,32,116,101,109,112,111,114,97,114,105,108,121,32,117,110,97,118,97,105,108,97,98,108,101,0,73,110,118,97,108,105,100,32,115,101,101,107,0,67,114,111,115,115,45,100,101,118,105,99,101,32,108,105,110,107,0,82,101,97,100,
45,111,110,108,121,32,102,105,108,101,32,115,121,115,116,101,109,0,68,105,114,101,99,116,111,114,121,32,110,111,116,32,101,109,112,116,121,0,67,111,110,110,101,99,116,105,111,110,32,114,101,115,101,116,32,98,121,32,112,101,101,114,0,79,112,101,114,97,116,105,111,110,32,116,105,109,101,100,32,111,117,116,0,67,111,110,110,101,99,116,105,111,110,32,114,101,102,117,115,101,100,0,72,111,115,116,32,105,115,32,100,111,119,110,0,72,111,115,116,32,105,115,32,117,110,114,101,97,99,104,97,98,108,101,0,65,100,
100,114,101,115,115,32,105,110,32,117,115,101,0,66,114,111,107,101,110,32,112,105,112,101,0,73,47,79,32,101,114,114,111,114,0,78,111,32,115,117,99,104,32,100,101,118,105,99,101,32,111,114,32,97,100,100,114,101,115,115,0,66,108,111,99,107,32,100,101,118,105,99,101,32,114,101,113,117,105,114,101,100,0,78,111,32,115,117,99,104,32,100,101,118,105,99,101,0,78,111,116,32,97,32,100,105,114,101,99,116,111,114,121,0,73,115,32,97,32,100,105,114,101,99,116,111,114,121,0,84,101,120,116,32,102,105,108,101,32,
98,117,115,121,0,69,120,101,99,32,102,111,114,109,97,116,32,101,114,114,111,114,0,73,110,118,97,108,105,100,32,97,114,103,117,109,101,110,116,0,65,114,103,117,109,101,110,116,32,108,105,115,116,32,116,111,111,32,108,111,110,103,0,83,121,109,98,111,108,105,99,32,108,105,110,107,32,108,111,111,112,0,70,105,108,101,110,97,109,101,32,116,111,111,32,108,111,110,103,0,84,111,111,32,109,97,110,121,32,111,112,101,110,32,102,105,108,101,115,32,105,110,32,115,121,115,116,101,109,0,78,111,32,102,105,108,101,
32,100,101,115,99,114,105,112,116,111,114,115,32,97,118,97,105,108,97,98,108,101,0,66,97,100,32,102,105,108,101,32,100,101,115,99,114,105,112,116,111,114,0,78,111,32,99,104,105,108,100,32,112,114,111,99,101,115,115,0,66,97,100,32,97,100,100,114,101,115,115,0,70,105,108,101,32,116,111,111,32,108,97,114,103,101,0,84,111,111,32,109,97,110,121,32,108,105,110,107,115,0,78,111,32,108,111,99,107,115,32,97,118,97,105,108,97,98,108,101,0,82,101,115,111,117,114,99,101,32,100,101,97,100,108,111,99,107,32,119,
111,117,108,100,32,111,99,99,117,114,0,83,116,97,116,101,32,110,111,116,32,114,101,99,111,118,101,114,97,98,108,101,0,80,114,101,118,105,111,117,115,32,111,119,110,101,114,32,100,105,101,100,0,79,112,101,114,97,116,105,111,110,32,99,97,110,99,101,108,101,100,0,70,117,110,99,116,105,111,110,32,110,111,116,32,105,109,112,108,101,109,101,110,116,101,100,0,78,111,32,109,101,115,115,97,103,101,32,111,102,32,100,101,115,105,114,101,100,32,116,121,112,101,0,73,100,101,110,116,105,102,105,101,114,32,114,
101,109,111,118,101,100,0,68,101,118,105,99,101,32,110,111,116,32,97,32,115,116,114,101,97,109,0,78,111,32,100,97,116,97,32,97,118,97,105,108,97,98,108,101,0,68,101,118,105,99,101,32,116,105,109,101,111,117,116,0,79,117,116,32,111,102,32,115,116,114,101,97,109,115,32,114,101,115,111,117,114,99,101,115,0,76,105,110,107,32,104,97,115,32,98,101,101,110,32,115,101,118,101,114,101,100,0,80,114,111,116,111,99,111,108,32,101,114,114,111,114,0,66,97,100,32,109,101,115,115,97,103,101,0,70,105,108,101,32,100,
101,115,99,114,105,112,116,111,114,32,105,110,32,98,97,100,32,115,116,97,116,101,0,78,111,116,32,97,32,115,111,99,107,101,116,0,68,101,115,116,105,110,97,116,105,111,110,32,97,100,100,114,101,115,115,32,114,101,113,117,105,114,101,100,0,77,101,115,115,97,103,101,32,116,111,111,32,108,97,114,103,101,0,80,114,111,116,111,99,111,108,32,119,114,111,110,103,32,116,121,112,101,32,102,111,114,32,115,111,99,107,101,116,0,80,114,111,116,111,99,111,108,32,110,111,116,32,97,118,97,105,108,97,98,108,101,0,80,
114,111,116,111,99,111,108,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,83,111,99,107,101,116,32,116,121,112,101,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,78,111,116,32,115,117,112,112,111,114,116,101,100,0,80,114,111,116,111,99,111,108,32,102,97,109,105,108,121,32,110,111,116,32,115,117,112,112,111,114,116,101,100,0,65,100,100,114,101,115,115,32,102,97,109,105,108,121,32,110,111,116,32,115,117,112,112,111,114,116,101,100,32,98,121,32,112,114,111,116,111,99,111,108,0,65,100,
100,114,101,115,115,32,110,111,116,32,97,118,97,105,108,97,98,108,101,0,78,101,116,119,111,114,107,32,105,115,32,100,111,119,110,0,78,101,116,119,111,114,107,32,117,110,114,101,97,99,104,97,98,108,101,0,67,111,110,110,101,99,116,105,111,110,32,114,101,115,101,116,32,98,121,32,110,101,116,119,111,114,107,0,67,111,110,110,101,99,116,105,111,110,32,97,98,111,114,116,101,100,0,78,111,32,98,117,102,102,101,114,32,115,112,97,99,101,32,97,118,97,105,108,97,98,108,101,0,83,111,99,107,101,116,32,105,115,32,
99,111,110,110,101,99,116,101,100,0,83,111,99,107,101,116,32,110,111,116,32,99,111,110,110,101,99,116,101,100,0,67,97,110,110,111,116,32,115,101,110,100,32,97,102,116,101,114,32,115,111,99,107,101,116,32,115,104,117,116,100,111,119,110,0,79,112,101,114,97,116,105,111,110,32,97,108,114,101,97,100,121,32,105,110,32,112,114,111,103,114,101,115,115,0,79,112,101,114,97,116,105,111,110,32,105,110,32,112,114,111,103,114,101,115,115,0,83,116,97,108,101,32,102,105,108,101,32,104,97,110,100,108,101,0,82,101,
109,111,116,101,32,73,47,79,32,101,114,114,111,114,0,81,117,111,116,97,32,101,120,99,101,101,100,101,100,0,78,111,32,109,101,100,105,117,109,32,102,111,117,110,100,0,87,114,111,110,103,32,109,101,100,105,117,109,32,116,121,112,101,0,78,111,32,101,114,114,111,114,32,105,110,102,111,114,109,97,116,105,111,110,0,0,105,110,102,105,110,105,116,121,0,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
255,255,255,255,255,255,255,255,255,255,0,1,2,3,4,5,6,7,8,9,255,255,255,255,255,255,255,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,255,255,255,255,255,255,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,0,1,2,4,7,3,6,5],"i8",4,ra.GLOBAL_BASE+153730);vc([17,0,10,0,17,17,17,0,0,0,0,5,0,0,0,0,0,0,9,0,0,0,0,11,0,0,0,0,0,0,0,0,17,0,15,10,17,17,17,3,10,7,0,1,19,9,11,11,0,0,9,6,11,0,0,11,0,6,17,0,0,0,17,17,17,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,17,0,10,10,17,17,17,0,10,0,0,2,0,9,11,0,0,0,9,0,11,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,0,0,0,0,12,0,0,0,0,12,0,0,0,0,9,12,0,0,0,0,0,12,0,0,12,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,4,13,0,0,0,0,9,14,0,0,0,0,0,14,0,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,15,0,0,0,0,15,0,0,0,0,9,16,0,0,0,0,0,16,0,0,16,0,0,18,0,0,0,18,18,18,0,0,0,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,18,0,0,0,18,18,18,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,10,0,0,0,0,9,11,0,0,0,0,0,11,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,0,0,0,0,12,0,0,0,0,12,0,0,0,0,9,12,0,0,0,0,0,12,0,0,12,0,0,48,49,50,51,52,53,54,55,56,57,65,66,67,68,69,70,45,43,32,32,32,48,88,48,120,0,40,110,117,108,108,41,0,45,48,88,43,48,88,32,48,88,45,48,120,43,48,120,32,48,120,
0,105,110,102,0,73,78,70,0,110,97,110,0,78,65,78,0,46,0],"i8",4,ra.GLOBAL_BASE+164446);var ai=ra.alignMemory(vc(12,"i8",2),8);fb(0==ai%8);var ca={EPERM:1,ENOENT:2,ESRCH:3,EINTR:4,EIO:5,ENXIO:6,E2BIG:7,ENOEXEC:8,EBADF:9,ECHILD:10,EAGAIN:11,EWOULDBLOCK:11,ENOMEM:12,EACCES:13,EFAULT:14,ENOTBLK:15,EBUSY:16,EEXIST:17,EXDEV:18,ENODEV:19,ENOTDIR:20,EISDIR:21,EINVAL:22,ENFILE:23,EMFILE:24,ENOTTY:25,ETXTBSY:26,EFBIG:27,ENOSPC:28,ESPIPE:29,EROFS:30,EMLINK:31,EPIPE:32,EDOM:33,ERANGE:34,ENOMSG:42,EIDRM:43,ECHRNG:44,
EL2NSYNC:45,EL3HLT:46,EL3RST:47,ELNRNG:48,EUNATCH:49,ENOCSI:50,EL2HLT:51,EDEADLK:35,ENOLCK:37,EBADE:52,EBADR:53,EXFULL:54,ENOANO:55,EBADRQC:56,EBADSLT:57,EDEADLOCK:35,EBFONT:59,ENOSTR:60,ENODATA:61,ETIME:62,ENOSR:63,ENONET:64,ENOPKG:65,EREMOTE:66,ENOLINK:67,EADV:68,ESRMNT:69,ECOMM:70,EPROTO:71,EMULTIHOP:72,EDOTDOT:73,EBADMSG:74,ENOTUNIQ:76,EBADFD:77,EREMCHG:78,ELIBACC:79,ELIBBAD:80,ELIBSCN:81,ELIBMAX:82,ELIBEXEC:83,ENOSYS:38,ENOTEMPTY:39,ENAMETOOLONG:36,ELOOP:40,EOPNOTSUPP:95,EPFNOSUPPORT:96,ECONNRESET:104,
ENOBUFS:105,EAFNOSUPPORT:97,EPROTOTYPE:91,ENOTSOCK:88,ENOPROTOOPT:92,ESHUTDOWN:108,ECONNREFUSED:111,EADDRINUSE:98,ECONNABORTED:103,ENETUNREACH:101,ENETDOWN:100,ETIMEDOUT:110,EHOSTDOWN:112,EHOSTUNREACH:113,EINPROGRESS:115,EALREADY:114,EDESTADDRREQ:89,EMSGSIZE:90,EPROTONOSUPPORT:93,ESOCKTNOSUPPORT:94,EADDRNOTAVAIL:99,ENETRESET:102,EISCONN:106,ENOTCONN:107,ETOOMANYREFS:109,EUSERS:87,EDQUOT:122,ESTALE:116,ENOTSUP:95,ENOMEDIUM:123,EILSEQ:84,EOVERFLOW:75,ECANCELED:125,ENOTRECOVERABLE:131,EOWNERDEAD:130,
ESTRPIPE:86},Kj={0:"Success",1:"Not super-user",2:"No such file or directory",3:"No such process",4:"Interrupted system call",5:"I/O error",6:"No such device or address",7:"Arg list too long",8:"Exec format error",9:"Bad file number",10:"No children",11:"No more processes",12:"Not enough core",13:"Permission denied",14:"Bad address",15:"Block device required",16:"Mount device busy",17:"File exists",18:"Cross-device link",19:"No such device",20:"Not a directory",21:"Is a directory",22:"Invalid argument",
23:"Too many open files in system",24:"Too many open files",25:"Not a typewriter",26:"Text file busy",27:"File too large",28:"No space left on device",29:"Illegal seek",30:"Read only file system",31:"Too many links",32:"Broken pipe",33:"Math arg out of domain of func",34:"Math result not representable",35:"File locking deadlock error",36:"File or path name too long",37:"No record locks available",38:"Function not implemented",39:"Directory not empty",40:"Too many symbolic links",42:"No message of desired type",
43:"Identifier removed",44:"Channel number out of range",45:"Level 2 not synchronized",46:"Level 3 halted",47:"Level 3 reset",48:"Link number out of range",49:"Protocol driver not attached",50:"No CSI structure available",51:"Level 2 halted",52:"Invalid exchange",53:"Invalid request descriptor",54:"Exchange full",55:"No anode",56:"Invalid request code",57:"Invalid slot",59:"Bad font file fmt",60:"Device not a stream",61:"No data (for no delay io)",62:"Timer expired",63:"Out of streams resources",
64:"Machine is not on the network",65:"Package not installed",66:"The object is remote",67:"The link has been severed",68:"Advertise error",69:"Srmount error",70:"Communication error on send",71:"Protocol error",72:"Multihop attempted",73:"Cross mount point (not really error)",74:"Trying to read unreadable message",75:"Value too large for defined data type",76:"Given log. name not unique",77:"f.d. invalid for this operation",78:"Remote address changed",79:"Can   access a needed shared lib",80:"Accessing a corrupted shared lib",
81:".lib section in a.out corrupted",82:"Attempting to link in too many libs",83:"Attempting to exec a shared library",84:"Illegal byte sequence",86:"Streams pipe error",87:"Too many users",88:"Socket operation on non-socket",89:"Destination address required",90:"Message too long",91:"Protocol wrong type for socket",92:"Protocol not available",93:"Unknown protocol",94:"Socket type not supported",95:"Not supported",96:"Protocol family not supported",97:"Address family not supported by protocol family",
98:"Address already in use",99:"Address not available",100:"Network interface is not configured",101:"Network is unreachable",102:"Connection reset by network",103:"Connection aborted",104:"Connection reset by peer",105:"No buffer space available",106:"Socket is already connected",107:"Socket is not connected",108:"Can't send after socket shutdown",109:"Too many references",110:"Connection timed out",111:"Connection refused",112:"Host is down",113:"Host is unreachable",114:"Socket already connected",
115:"Connection already in progress",116:"Stale file handle",122:"Quota exceeded",123:"No medium (in tape drive)",125:"Operation canceled",130:"Previous owner died",131:"State not recoverable"},ye={ttys:[],init:function(){},shutdown:function(){},register:function(r,v){ye.ttys[r]={input:[],output:[],ops:v};D.registerDevice(r,ye.stream_ops)},stream_ops:{open:function(r){var v=ye.ttys[r.node.rdev];if(!v)throw new D.ErrnoError(ca.ENODEV);r.tty=v;r.seekable=!1},close:function(r){r.tty.ops.flush(r.tty)},
flush:function(r){r.tty.ops.flush(r.tty)},read:function(r,v,A,fa,F){if(!r.tty||!r.tty.ops.get_char)throw new D.ErrnoError(ca.ENXIO);for(var aa=F=0;aa<fa;aa++){var ya;try{ya=r.tty.ops.get_char(r.tty)}catch(S){throw new D.ErrnoError(ca.EIO);}if(void 0===ya&&0===F)throw new D.ErrnoError(ca.EAGAIN);if(null===ya||void 0===ya)break;F++;v[A+aa]=ya}F&&(r.node.timestamp=Date.now());return F},write:function(r,v,A,fa,F){if(!r.tty||!r.tty.ops.put_char)throw new D.ErrnoError(ca.ENXIO);for(F=0;F<fa;F++)try{r.tty.ops.put_char(r.tty,
v[A+F])}catch(aa){throw new D.ErrnoError(ca.EIO);}fa&&(r.node.timestamp=Date.now());return F}},default_tty_ops:{get_char:function(r){if(!r.input.length){var v=null;if(Bf){var v=new Buffer(256),A,D=process.stdin.fd,F=!1;try{D=cd.openSync("/dev/stdin","r"),F=!0}catch(aa){}A=cd.readSync(D,v,0,256,null);F&&cd.closeSync(D);v=0<A?v.slice(0,A).toString("utf-8"):null}else"undefined"!=typeof window&&"function"==typeof window.prompt?(v=window.prompt("Input: "),null!==v&&(v+="\n")):"function"==typeof readline&&
(v=readline(),null!==v&&(v+="\n"));if(!v)return null;r.input=yf(v,!0)}return r.input.shift()},put_char:function(r,v){null===v||10===v?(F.print(nf(r.output,0)),r.output=[]):0!=v&&r.output.push(v)},flush:function(r){r.output&&0<r.output.length&&(F.print(nf(r.output,0)),r.output=[])}},default_tty1_ops:{put_char:function(r,v){null===v||10===v?(F.printErr(nf(r.output,0)),r.output=[]):0!=v&&r.output.push(v)},flush:function(r){r.output&&0<r.output.length&&(F.printErr(nf(r.output,0)),r.output=[])}}},lc={ops_table:null,
mount:function(r){return lc.createNode(null,"/",16895,0)},createNode:function(r,v,A,fa){if(D.isBlkdev(A)||D.isFIFO(A))throw new D.ErrnoError(ca.EPERM);lc.ops_table||(lc.ops_table={dir:{node:{getattr:lc.node_ops.getattr,setattr:lc.node_ops.setattr,lookup:lc.node_ops.lookup,mknod:lc.node_ops.mknod,rename:lc.node_ops.rename,unlink:lc.node_ops.unlink,rmdir:lc.node_ops.rmdir,readdir:lc.node_ops.readdir,symlink:lc.node_ops.symlink},stream:{llseek:lc.stream_ops.llseek}},file:{node:{getattr:lc.node_ops.getattr,
setattr:lc.node_ops.setattr},stream:{llseek:lc.stream_ops.llseek,read:lc.stream_ops.read,write:lc.stream_ops.write,allocate:lc.stream_ops.allocate,mmap:lc.stream_ops.mmap,msync:lc.stream_ops.msync}},link:{node:{getattr:lc.node_ops.getattr,setattr:lc.node_ops.setattr,readlink:lc.node_ops.readlink},stream:{}},chrdev:{node:{getattr:lc.node_ops.getattr,setattr:lc.node_ops.setattr},stream:D.chrdev_stream_ops}});A=D.createNode(r,v,A,fa);D.isDir(A.mode)?(A.node_ops=lc.ops_table.dir.node,A.stream_ops=lc.ops_table.dir.stream,
A.contents={}):D.isFile(A.mode)?(A.node_ops=lc.ops_table.file.node,A.stream_ops=lc.ops_table.file.stream,A.usedBytes=0,A.contents=null):D.isLink(A.mode)?(A.node_ops=lc.ops_table.link.node,A.stream_ops=lc.ops_table.link.stream):D.isChrdev(A.mode)&&(A.node_ops=lc.ops_table.chrdev.node,A.stream_ops=lc.ops_table.chrdev.stream);A.timestamp=Date.now();r&&(r.contents[v]=A);return A},getFileDataAsRegularArray:function(r){if(r.contents&&r.contents.subarray){for(var v=[],A=0;A<r.usedBytes;++A)v.push(r.contents[A]);
return v}return r.contents},getFileDataAsTypedArray:function(r){return r.contents?r.contents.subarray?r.contents.subarray(0,r.usedBytes):new Uint8Array(r.contents):new Uint8Array},expandFileStorage:function(r,v){r.contents&&r.contents.subarray&&v>r.contents.length&&(r.contents=lc.getFileDataAsRegularArray(r),r.usedBytes=r.contents.length);if(!r.contents||r.contents.subarray){var A=r.contents?r.contents.buffer.byteLength:0;A>=v||(v=Math.max(v,A*(1048576>A?2:1.125)|0),0!=A&&(v=Math.max(v,256)),A=r.contents,
r.contents=new Uint8Array(v),0<r.usedBytes&&r.contents.set(A.subarray(0,r.usedBytes),0))}else for(!r.contents&&0<v&&(r.contents=[]);r.contents.length<v;)r.contents.push(0)},resizeFileStorage:function(r,v){if(r.usedBytes!=v)if(0==v)r.contents=null,r.usedBytes=0;else{if(!r.contents||r.contents.subarray){var A=r.contents;r.contents=new Uint8Array(new ArrayBuffer(v));A&&r.contents.set(A.subarray(0,Math.min(v,r.usedBytes)))}else if(r.contents||(r.contents=[]),r.contents.length>v)r.contents.length=v;else for(;r.contents.length<
v;)r.contents.push(0);r.usedBytes=v}},node_ops:{getattr:function(r){var v={};v.dev=D.isChrdev(r.mode)?r.id:1;v.ino=r.id;v.mode=r.mode;v.nlink=1;v.uid=0;v.gid=0;v.rdev=r.rdev;D.isDir(r.mode)?v.size=4096:D.isFile(r.mode)?v.size=r.usedBytes:D.isLink(r.mode)?v.size=r.link.length:v.size=0;v.atime=new Date(r.timestamp);v.mtime=new Date(r.timestamp);v.ctime=new Date(r.timestamp);v.blksize=4096;v.blocks=Math.ceil(v.size/v.blksize);return v},setattr:function(r,v){void 0!==v.mode&&(r.mode=v.mode);void 0!==
v.timestamp&&(r.timestamp=v.timestamp);void 0!==v.size&&lc.resizeFileStorage(r,v.size)},lookup:function(r,v){throw D.genericErrors[ca.ENOENT];},mknod:function(r,v,A,D){return lc.createNode(r,v,A,D)},rename:function(r,v,A){if(D.isDir(r.mode)){var fa;try{fa=D.lookupNode(v,A)}catch(F){}if(fa)for(var yc in fa.contents)throw new D.ErrnoError(ca.ENOTEMPTY);}delete r.parent.contents[r.name];r.name=A;v.contents[A]=r;r.parent=v},unlink:function(r,v){delete r.contents[v]},rmdir:function(r,v){var A=D.lookupNode(r,
v),fa;for(fa in A.contents)throw new D.ErrnoError(ca.ENOTEMPTY);delete r.contents[v]},readdir:function(r){var v=[".",".."],A;for(A in r.contents)r.contents.hasOwnProperty(A)&&v.push(A);return v},symlink:function(r,v,A){r=lc.createNode(r,v,41471,0);r.link=A;return r},readlink:function(r){if(!D.isLink(r.mode))throw new D.ErrnoError(ca.EINVAL);return r.link}},stream_ops:{read:function(r,v,A,D,F){var aa=r.node.contents;if(F>=r.node.usedBytes)return 0;r=Math.min(r.node.usedBytes-F,D);fb(0<=r);if(8<r&&
aa.subarray)v.set(aa.subarray(F,F+r),A);else for(D=0;D<r;D++)v[A+D]=aa[F+D];return r},write:function(r,v,A,D,F,aa){if(!D)return 0;r=r.node;r.timestamp=Date.now();if(v.subarray&&(!r.contents||r.contents.subarray)){if(aa)return r.contents=v.subarray(A,A+D),r.usedBytes=D;if(0===r.usedBytes&&0===F)return r.contents=new Uint8Array(v.subarray(A,A+D)),r.usedBytes=D;if(F+D<=r.usedBytes)return r.contents.set(v.subarray(A,A+D),F),D}lc.expandFileStorage(r,F+D);if(r.contents.subarray&&v.subarray)r.contents.set(v.subarray(A,
A+D),F);else for(aa=0;aa<D;aa++)r.contents[F+aa]=v[A+aa];r.usedBytes=Math.max(r.usedBytes,F+D);return D},llseek:function(r,v,A){1===A?v+=r.position:2===A&&D.isFile(r.node.mode)&&(v+=r.node.usedBytes);if(0>v)throw new D.ErrnoError(ca.EINVAL);return v},allocate:function(r,v,A){lc.expandFileStorage(r.node,v+A);r.node.usedBytes=Math.max(r.node.usedBytes,v+A)},mmap:function(r,v,A,fa,F,aa,ya){if(!D.isFile(r.node.mode))throw new D.ErrnoError(ca.ENODEV);A=r.node.contents;if(ya&2||A.buffer!==v&&A.buffer!==
v.buffer){if(0<F||F+fa<r.node.usedBytes)A=A.subarray?A.subarray(F,F+fa):Array.prototype.slice.call(A,F,F+fa);r=!0;fa=uf(fa);if(!fa)throw new D.ErrnoError(ca.ENOMEM);v.set(A,fa)}else r=!1,fa=A.byteOffset;return{ptr:fa,allocated:r}},msync:function(r,v,A,fa,F){if(!D.isFile(r.node.mode))throw new D.ErrnoError(ca.ENODEV);if(F&2)return 0;lc.stream_ops.write(r,v,0,fa,A,!1);return 0}}},Bc={dbs:{},indexedDB:function(){if("undefined"!==typeof indexedDB)return indexedDB;var r=null;"object"===typeof window&&
(r=window.indexedDB||window.mozIndexedDB||window.webkitIndexedDB||window.msIndexedDB);fb(r,"IDBFS used, but indexedDB not supported");return r},DB_VERSION:21,DB_STORE_NAME:"FILE_DATA",mount:function(r){return lc.mount.apply(null,arguments)},syncfs:function(r,v,A){Bc.getLocalSet(r,function(D,F){if(D)return A(D);Bc.getRemoteSet(r,function(r,D){if(r)return A(r);Bc.reconcile(v?D:F,v?F:D,A)})})},getDB:function(r,v){var A=Bc.dbs[r];if(A)return v(null,A);var D;try{D=Bc.indexedDB().open(r,Bc.DB_VERSION)}catch(F){return v(F)}D.onupgradeneeded=
function(r){var v=r.target.result;r=r.target.transaction;v=v.objectStoreNames.contains(Bc.DB_STORE_NAME)?r.objectStore(Bc.DB_STORE_NAME):v.createObjectStore(Bc.DB_STORE_NAME);v.indexNames.contains("timestamp")||v.createIndex("timestamp","timestamp",{unique:!1})};D.onsuccess=function(){A=D.result;Bc.dbs[r]=A;v(null,A)};D.onerror=function(r){v(this.error);r.preventDefault()}},getLocalSet:function(r,v){function A(r){return"."!==r&&".."!==r}function fa(r){return function(v){return jc.join2(r,v)}}for(var F=
{},aa=D.readdir(r.mountpoint).filter(A).map(fa(r.mountpoint));aa.length;){var ya=aa.pop(),S;try{S=D.stat(ya)}catch(ca){return v(ca)}D.isDir(S.mode)&&aa.push.apply(aa,D.readdir(ya).filter(A).map(fa(ya)));F[ya]={timestamp:S.mtime}}return v(null,{type:"local",entries:F})},getRemoteSet:function(r,v){var A={};Bc.getDB(r.mountpoint,function(r,D){if(r)return v(r);var F=D.transaction([Bc.DB_STORE_NAME],"readonly");F.onerror=function(r){v(this.error);r.preventDefault()};F.objectStore(Bc.DB_STORE_NAME).index("timestamp").openKeyCursor().onsuccess=
function(r){r=r.target.result;if(!r)return v(null,{type:"remote",db:D,entries:A});A[r.primaryKey]={timestamp:r.key};r["continue"]()}})},loadLocalEntry:function(r,v){var A,fa;try{fa=D.lookupPath(r).node,A=D.stat(r)}catch(F){return v(F)}return D.isDir(A.mode)?v(null,{timestamp:A.mtime,mode:A.mode}):D.isFile(A.mode)?(fa.contents=lc.getFileDataAsTypedArray(fa),v(null,{timestamp:A.mtime,mode:A.mode,contents:fa.contents})):v(Error("node type not supported"))},storeLocalEntry:function(r,v,A){try{if(D.isDir(v.mode))D.mkdir(r,
v.mode);else if(D.isFile(v.mode))D.writeFile(r,v.contents,{encoding:"binary",canOwn:!0});else return A(Error("node type not supported"));D.chmod(r,v.mode);D.utime(r,v.timestamp,v.timestamp)}catch(fa){return A(fa)}A(null)},removeLocalEntry:function(r,v){try{D.lookupPath(r);var A=D.stat(r);D.isDir(A.mode)?D.rmdir(r):D.isFile(A.mode)&&D.unlink(r)}catch(fa){return v(fa)}v(null)},loadRemoteEntry:function(r,v,A){r=r.get(v);r.onsuccess=function(r){A(null,r.target.result)};r.onerror=function(r){A(this.error);
r.preventDefault()}},storeRemoteEntry:function(r,v,A,D){r=r.put(A,v);r.onsuccess=function(){D(null)};r.onerror=function(r){D(this.error);r.preventDefault()}},removeRemoteEntry:function(r,v,A){r=r["delete"](v);r.onsuccess=function(){A(null)};r.onerror=function(r){A(this.error);r.preventDefault()}},reconcile:function(r,v,A){function D(r){if(r){if(!D.errored)return D.errored=!0,A(r)}else if(++S>=F)return A(null)}var F=0,aa=[];Object.keys(r.entries).forEach(function(A){var D=r.entries[A],fa=v.entries[A];
if(!fa||D.timestamp>fa.timestamp)aa.push(A),F++});var ya=[];Object.keys(v.entries).forEach(function(v){r.entries[v]||(ya.push(v),F++)});if(!F)return A(null);var S=0,ca=("remote"===r.type?r.db:v.db).transaction([Bc.DB_STORE_NAME],"readwrite"),Xd=ca.objectStore(Bc.DB_STORE_NAME);ca.onerror=function(r){D(this.error);r.preventDefault()};aa.sort().forEach(function(r){"local"===v.type?Bc.loadRemoteEntry(Xd,r,function(v,A){if(v)return D(v);Bc.storeLocalEntry(r,A,D)}):Bc.loadLocalEntry(r,function(v,A){if(v)return D(v);
Bc.storeRemoteEntry(Xd,r,A,D)})});ya.sort().reverse().forEach(function(r){"local"===v.type?Bc.removeLocalEntry(r,D):Bc.removeRemoteEntry(Xd,r,D)})}},Wc={isWindows:!1,staticInit:function(){Wc.isWindows=!!process.platform.match(/^win/)},mount:function(r){fb(Bf);return Wc.createNode(null,"/",Wc.getMode(r.opts.root),0)},createNode:function(r,v,A,fa){if(!D.isDir(A)&&!D.isFile(A)&&!D.isLink(A))throw new D.ErrnoError(ca.EINVAL);r=D.createNode(r,v,A);r.node_ops=Wc.node_ops;r.stream_ops=Wc.stream_ops;return r},
getMode:function(r){var v;try{v=cd.lstatSync(r),Wc.isWindows&&(v.mode|=(v.mode&146)>>1)}catch(A){if(!A.code)throw A;throw new D.ErrnoError(ca[A.code]);}return v.mode},realPath:function(r){for(var v=[];r.parent!==r;)v.push(r.name),r=r.parent;v.push(r.mount.opts.root);v.reverse();return jc.join.apply(null,v)},flagsToPermissionStringMap:{0:"r",1:"r+",2:"r+",64:"r",65:"r+",66:"r+",129:"rx+",193:"rx+",514:"w+",577:"w",578:"w+",705:"wx",706:"wx+",1024:"a",1025:"a",1026:"a+",1089:"a",1090:"a+",1153:"ax",
1154:"ax+",1217:"ax",1218:"ax+",4096:"rs",4098:"rs+"},flagsToPermissionString:function(r){r&=-32769;if(r in Wc.flagsToPermissionStringMap)return Wc.flagsToPermissionStringMap[r];throw new D.ErrnoError(ca.EINVAL);},node_ops:{getattr:function(r){r=Wc.realPath(r);var v;try{v=cd.lstatSync(r)}catch(A){if(!A.code)throw A;throw new D.ErrnoError(ca[A.code]);}Wc.isWindows&&!v.blksize&&(v.blksize=4096);Wc.isWindows&&!v.blocks&&(v.blocks=(v.size+v.blksize-1)/v.blksize|0);return{dev:v.dev,ino:v.ino,mode:v.mode,
nlink:v.nlink,uid:v.uid,gid:v.gid,rdev:v.rdev,size:v.size,atime:v.atime,mtime:v.mtime,ctime:v.ctime,blksize:v.blksize,blocks:v.blocks}},setattr:function(r,v){var A=Wc.realPath(r);try{void 0!==v.mode&&(cd.chmodSync(A,v.mode),r.mode=v.mode);if(void 0!==v.timestamp){var fa=new Date(v.timestamp);cd.utimesSync(A,fa,fa)}void 0!==v.size&&cd.truncateSync(A,v.size)}catch(F){if(!F.code)throw F;throw new D.ErrnoError(ca[F.code]);}},lookup:function(r,v){var A=jc.join2(Wc.realPath(r),v),A=Wc.getMode(A);return Wc.createNode(r,
v,A)},mknod:function(r,v,A,fa){r=Wc.createNode(r,v,A,fa);v=Wc.realPath(r);try{D.isDir(r.mode)?cd.mkdirSync(v,r.mode):cd.writeFileSync(v,"",{mode:r.mode})}catch(F){if(!F.code)throw F;throw new D.ErrnoError(ca[F.code]);}return r},rename:function(r,v,A){r=Wc.realPath(r);v=jc.join2(Wc.realPath(v),A);try{cd.renameSync(r,v)}catch(fa){if(!fa.code)throw fa;throw new D.ErrnoError(ca[fa.code]);}},unlink:function(r,v){var A=jc.join2(Wc.realPath(r),v);try{cd.unlinkSync(A)}catch(fa){if(!fa.code)throw fa;throw new D.ErrnoError(ca[fa.code]);
}},rmdir:function(r,v){var A=jc.join2(Wc.realPath(r),v);try{cd.rmdirSync(A)}catch(fa){if(!fa.code)throw fa;throw new D.ErrnoError(ca[fa.code]);}},readdir:function(r){r=Wc.realPath(r);try{return cd.readdirSync(r)}catch(v){if(!v.code)throw v;throw new D.ErrnoError(ca[v.code]);}},symlink:function(r,v,A){r=jc.join2(Wc.realPath(r),v);try{cd.symlinkSync(A,r)}catch(fa){if(!fa.code)throw fa;throw new D.ErrnoError(ca[fa.code]);}},readlink:function(r){var v=Wc.realPath(r);try{return v=cd.readlinkSync(v),v=
Li.relative(Li.resolve(r.mount.opts.root),v)}catch(A){if(!A.code)throw A;throw new D.ErrnoError(ca[A.code]);}}},stream_ops:{open:function(r){var v=Wc.realPath(r.node);try{D.isFile(r.node.mode)&&(r.nfd=cd.openSync(v,Wc.flagsToPermissionString(r.flags)))}catch(A){if(!A.code)throw A;throw new D.ErrnoError(ca[A.code]);}},close:function(r){try{D.isFile(r.node.mode)&&r.nfd&&cd.closeSync(r.nfd)}catch(v){if(!v.code)throw v;throw new D.ErrnoError(ca[v.code]);}},read:function(r,v,A,fa,F){if(0===fa)return 0;
var aa=new Buffer(fa),ya;try{ya=cd.readSync(r.nfd,aa,0,fa,F)}catch(S){throw new D.ErrnoError(ca[S.code]);}if(0<ya)for(r=0;r<ya;r++)v[A+r]=aa[r];return ya},write:function(r,v,A,fa,F){v=new Buffer(v.subarray(A,A+fa));var aa;try{aa=cd.writeSync(r.nfd,v,0,fa,F)}catch(ya){throw new D.ErrnoError(ca[ya.code]);}return aa},llseek:function(r,v,A){if(1===A)v+=r.position;else if(2===A&&D.isFile(r.node.mode))try{var fa=cd.fstatSync(r.nfd);v+=fa.size}catch(F){throw new D.ErrnoError(ca[F.code]);}if(0>v)throw new D.ErrnoError(ca.EINVAL);
return v}}},sd={DIR_MODE:16895,FILE_MODE:33279,reader:null,mount:function(r){function v(r){r=r.split("/");for(var v=D,A=0;A<r.length-1;A++){var S=r.slice(0,A+1).join("/");F[S]||(F[S]=sd.createNode(v,S,sd.DIR_MODE,0));v=F[S]}return v}function A(r){r=r.split("/");return r[r.length-1]}fb(fg);sd.reader||(sd.reader=new FileReaderSync);var D=sd.createNode(null,"/",sd.DIR_MODE,0),F={};Array.prototype.forEach.call(r.opts.files||[],function(r){sd.createNode(v(r.name),A(r.name),sd.FILE_MODE,0,r,r.lastModifiedDate)});
(r.opts.blobs||[]).forEach(function(r){sd.createNode(v(r.name),A(r.name),sd.FILE_MODE,0,r.data)});(r.opts.packages||[]).forEach(function(r){r.metadata.files.forEach(function(D){var fa=D.filename.substr(1);sd.createNode(v(fa),A(fa),sd.FILE_MODE,0,r.blob.slice(D.start,D.end))})});return D},createNode:function(r,v,A,fa,F,aa){fa=D.createNode(r,v,A);fa.mode=A;fa.node_ops=sd.node_ops;fa.stream_ops=sd.stream_ops;fa.timestamp=(aa||new Date).getTime();fb(sd.FILE_MODE!==sd.DIR_MODE);A===sd.FILE_MODE?(fa.size=
F.size,fa.contents=F):(fa.size=4096,fa.contents={});r&&(r.contents[v]=fa);return fa},node_ops:{getattr:function(r){return{dev:1,ino:void 0,mode:r.mode,nlink:1,uid:0,gid:0,rdev:void 0,size:r.size,atime:new Date(r.timestamp),mtime:new Date(r.timestamp),ctime:new Date(r.timestamp),blksize:4096,blocks:Math.ceil(r.size/4096)}},setattr:function(r,v){void 0!==v.mode&&(r.mode=v.mode);void 0!==v.timestamp&&(r.timestamp=v.timestamp)},lookup:function(r,v){throw new D.ErrnoError(ca.ENOENT);},mknod:function(r,
v,A,fa){throw new D.ErrnoError(ca.EPERM);},rename:function(r,v,A){throw new D.ErrnoError(ca.EPERM);},unlink:function(r,v){throw new D.ErrnoError(ca.EPERM);},rmdir:function(r,v){throw new D.ErrnoError(ca.EPERM);},readdir:function(r){throw new D.ErrnoError(ca.EPERM);},symlink:function(r,v,A){throw new D.ErrnoError(ca.EPERM);},readlink:function(r){throw new D.ErrnoError(ca.EPERM);}},stream_ops:{read:function(r,v,A,D,F){if(F>=r.node.size)return 0;r=r.node.contents.slice(F,F+D);D=sd.reader.readAsArrayBuffer(r);
v.set(new Uint8Array(D),A);return r.size},write:function(r,v,A,fa,F){throw new D.ErrnoError(ca.EIO);},llseek:function(r,v,A){1===A?v+=r.position:2===A&&D.isFile(r.node.mode)&&(v+=r.node.size);if(0>v)throw new D.ErrnoError(ca.EINVAL);return v}}};vc(1,"i32*",2);vc(1,"i32*",2);vc(1,"i32*",2);var D={root:null,mounts:[],devices:[null],streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:!1,ignorePermissions:!0,trackingDelegate:{},tracking:{openFlags:{READ:1,WRITE:2}},ErrnoError:null,genericErrors:{},
filesystems:null,handleFSError:function(r){if(!(r instanceof D.ErrnoError))throw r+" : "+wf();return eg(r.errno)},lookupPath:function(r,v){r=jc.resolve(D.cwd(),r);v=v||{};if(!r)return{path:"",node:null};var A={follow_mount:!0,recurse_count:0},fa;for(fa in A)void 0===v[fa]&&(v[fa]=A[fa]);if(8<v.recurse_count)throw new D.ErrnoError(ca.ELOOP);var A=jc.normalizeArray(r.split("/").filter(function(r){return!!r}),!1),F=D.root;fa="/";for(var aa=0;aa<A.length;aa++){var ya=aa===A.length-1;if(ya&&v.parent)break;
F=D.lookupNode(F,A[aa]);fa=jc.join2(fa,A[aa]);D.isMountpoint(F)&&(!ya||ya&&v.follow_mount)&&(F=F.mounted.root);if(!ya||v.follow)for(ya=0;D.isLink(F.mode);)if(F=D.readlink(fa),fa=jc.resolve(jc.dirname(fa),F),F=D.lookupPath(fa,{recurse_count:v.recurse_count}).node,40<ya++)throw new D.ErrnoError(ca.ELOOP);}return{path:fa,node:F}},getPath:function(r){for(var v;;){if(D.isRoot(r))return r=r.mount.mountpoint,v?"/"!==r[r.length-1]?r+"/"+v:r+v:r;v=v?r.name+"/"+v:r.name;r=r.parent}},hashName:function(r,v){for(var A=
0,fa=0;fa<v.length;fa++)A=(A<<5)-A+v.charCodeAt(fa)|0;return(r+A>>>0)%D.nameTable.length},hashAddNode:function(r){var v=D.hashName(r.parent.id,r.name);r.name_next=D.nameTable[v];D.nameTable[v]=r},hashRemoveNode:function(r){var v=D.hashName(r.parent.id,r.name);if(D.nameTable[v]===r)D.nameTable[v]=r.name_next;else for(v=D.nameTable[v];v;){if(v.name_next===r){v.name_next=r.name_next;break}v=v.name_next}},lookupNode:function(r,v){var A=D.mayLookup(r);if(A)throw new D.ErrnoError(A,r);A=D.hashName(r.id,
v);for(A=D.nameTable[A];A;A=A.name_next){var fa=A.name;if(A.parent.id===r.id&&fa===v)return A}return D.lookup(r,v)},createNode:function(r,v,A,fa){D.FSNode||(D.FSNode=function(r,v,A,fa){r||(r=this);this.parent=r;this.mount=r.mount;this.mounted=null;this.id=D.nextInode++;this.name=v;this.mode=A;this.node_ops={};this.stream_ops={};this.rdev=fa},D.FSNode.prototype={},Object.defineProperties(D.FSNode.prototype,{read:{get:function(){return 365===(this.mode&365)},set:function(r){r?this.mode|=365:this.mode&=
-366}},write:{get:function(){return 146===(this.mode&146)},set:function(r){r?this.mode|=146:this.mode&=-147}},isFolder:{get:function(){return D.isDir(this.mode)}},isDevice:{get:function(){return D.isChrdev(this.mode)}}}));r=new D.FSNode(r,v,A,fa);D.hashAddNode(r);return r},destroyNode:function(r){D.hashRemoveNode(r)},isRoot:function(r){return r===r.parent},isMountpoint:function(r){return!!r.mounted},isFile:function(r){return 32768===(r&61440)},isDir:function(r){return 16384===(r&61440)},isLink:function(r){return 40960===
(r&61440)},isChrdev:function(r){return 8192===(r&61440)},isBlkdev:function(r){return 24576===(r&61440)},isFIFO:function(r){return 4096===(r&61440)},isSocket:function(r){return 49152===(r&49152)},flagModes:{r:0,rs:1052672,"r+":2,w:577,wx:705,xw:705,"w+":578,"wx+":706,"xw+":706,a:1089,ax:1217,xa:1217,"a+":1090,"ax+":1218,"xa+":1218},modeStringToFlags:function(r){var v=D.flagModes[r];if("undefined"===typeof v)throw Error("Unknown file open mode: "+r);return v},flagsToPermissionString:function(r){var v=
["r","w","rw"][r&3];r&512&&(v+="w");return v},nodePermissions:function(r,v){if(D.ignorePermissions)return 0;if(-1===v.indexOf("r")||r.mode&292){if(-1!==v.indexOf("w")&&!(r.mode&146)||-1!==v.indexOf("x")&&!(r.mode&73))return ca.EACCES}else return ca.EACCES;return 0},mayLookup:function(r){var v=D.nodePermissions(r,"x");return v?v:r.node_ops.lookup?0:ca.EACCES},mayCreate:function(r,v){try{return D.lookupNode(r,v),ca.EEXIST}catch(A){}return D.nodePermissions(r,"wx")},mayDelete:function(r,v,A){var fa;
try{fa=D.lookupNode(r,v)}catch(F){return F.errno}if(r=D.nodePermissions(r,"wx"))return r;if(A){if(!D.isDir(fa.mode))return ca.ENOTDIR;if(D.isRoot(fa)||D.getPath(fa)===D.cwd())return ca.EBUSY}else if(D.isDir(fa.mode))return ca.EISDIR;return 0},mayOpen:function(r,v){return r?D.isLink(r.mode)?ca.ELOOP:D.isDir(r.mode)&&(0!==(v&2097155)||v&512)?ca.EISDIR:D.nodePermissions(r,D.flagsToPermissionString(v)):ca.ENOENT},MAX_OPEN_FDS:4096,nextfd:function(r,v){v=v||D.MAX_OPEN_FDS;for(var A=r||0;A<=v;A++)if(!D.streams[A])return A;
throw new D.ErrnoError(ca.EMFILE);},getStream:function(r){return D.streams[r]},createStream:function(r,v,A){D.FSStream||(D.FSStream=function(){},D.FSStream.prototype={},Object.defineProperties(D.FSStream.prototype,{object:{get:function(){return this.node},set:function(r){this.node=r}},isRead:{get:function(){return 1!==(this.flags&2097155)}},isWrite:{get:function(){return 0!==(this.flags&2097155)}},isAppend:{get:function(){return this.flags&1024}}}));var fa=new D.FSStream,F;for(F in r)fa[F]=r[F];r=
fa;v=D.nextfd(v,A);r.fd=v;return D.streams[v]=r},closeStream:function(r){D.streams[r]=null},chrdev_stream_ops:{open:function(r){var v=D.getDevice(r.node.rdev);r.stream_ops=v.stream_ops;r.stream_ops.open&&r.stream_ops.open(r)},llseek:function(){throw new D.ErrnoError(ca.ESPIPE);}},major:function(r){return r>>8},minor:function(r){return r&255},makedev:function(r,v){return r<<8|v},registerDevice:function(r,v){D.devices[r]={stream_ops:v}},getDevice:function(r){return D.devices[r]},getMounts:function(r){var v=
[];for(r=[r];r.length;){var A=r.pop();v.push(A);r.push.apply(r,A.mounts)}return v},syncfs:function(r,v){function A(r){if(r){if(!A.errored)return A.errored=!0,v(r)}else++F>=fa.length&&v(null)}"function"===typeof r&&(v=r,r=!1);var fa=D.getMounts(D.root.mount),F=0;fa.forEach(function(v){if(!v.type.syncfs)return A(null);v.type.syncfs(v,r,A)})},mount:function(r,v,A){var fa="/"===A,F=!A,aa;if(fa&&D.root)throw new D.ErrnoError(ca.EBUSY);if(!fa&&!F){aa=D.lookupPath(A,{follow_mount:!1});A=aa.path;aa=aa.node;
if(D.isMountpoint(aa))throw new D.ErrnoError(ca.EBUSY);if(!D.isDir(aa.mode))throw new D.ErrnoError(ca.ENOTDIR);}v={type:r,opts:v,mountpoint:A,mounts:[]};r=r.mount(v);r.mount=v;v.root=r;fa?D.root=r:aa&&(aa.mounted=v,aa.mount&&aa.mount.mounts.push(v));return r},unmount:function(r){r=D.lookupPath(r,{follow_mount:!1});if(!D.isMountpoint(r.node))throw new D.ErrnoError(ca.EINVAL);r=r.node;var v=r.mounted,A=D.getMounts(v);Object.keys(D.nameTable).forEach(function(r){for(r=D.nameTable[r];r;){var v=r.name_next;
-1!==A.indexOf(r.mount)&&D.destroyNode(r);r=v}});r.mounted=null;v=r.mount.mounts.indexOf(v);fb(-1!==v);r.mount.mounts.splice(v,1)},lookup:function(r,v){return r.node_ops.lookup(r,v)},mknod:function(r,v,A){var fa=D.lookupPath(r,{parent:!0}).node;r=jc.basename(r);if(!r||"."===r||".."===r)throw new D.ErrnoError(ca.EINVAL);var F=D.mayCreate(fa,r);if(F)throw new D.ErrnoError(F);if(!fa.node_ops.mknod)throw new D.ErrnoError(ca.EPERM);return fa.node_ops.mknod(fa,r,v,A)},create:function(r,v){return D.mknod(r,
(void 0!==v?v:438)&4095|32768,0)},mkdir:function(r,v){return D.mknod(r,(void 0!==v?v:511)&1023|16384,0)},mkdev:function(r,v,A){"undefined"===typeof A&&(A=v,v=438);return D.mknod(r,v|8192,A)},symlink:function(r,v){if(!jc.resolve(r))throw new D.ErrnoError(ca.ENOENT);var A=D.lookupPath(v,{parent:!0}).node;if(!A)throw new D.ErrnoError(ca.ENOENT);var fa=jc.basename(v),F=D.mayCreate(A,fa);if(F)throw new D.ErrnoError(F);if(!A.node_ops.symlink)throw new D.ErrnoError(ca.EPERM);return A.node_ops.symlink(A,
fa,r)},rename:function(r,v){var A=jc.dirname(r),fa=jc.dirname(v),F=jc.basename(r),aa=jc.basename(v),ya,S,ra;try{ya=D.lookupPath(r,{parent:!0}),S=ya.node,ya=D.lookupPath(v,{parent:!0}),ra=ya.node}catch(Ka){throw new D.ErrnoError(ca.EBUSY);}if(!S||!ra)throw new D.ErrnoError(ca.ENOENT);if(S.mount!==ra.mount)throw new D.ErrnoError(ca.EXDEV);ya=D.lookupNode(S,F);fa=jc.relative(r,fa);if("."!==fa.charAt(0))throw new D.ErrnoError(ca.EINVAL);fa=jc.relative(v,A);if("."!==fa.charAt(0))throw new D.ErrnoError(ca.ENOTEMPTY);
var Xd;try{Xd=D.lookupNode(ra,aa)}catch(Ka){}if(ya!==Xd){A=D.isDir(ya.mode);if(F=D.mayDelete(S,F,A))throw new D.ErrnoError(F);if(F=Xd?D.mayDelete(ra,aa,A):D.mayCreate(ra,aa))throw new D.ErrnoError(F);if(!S.node_ops.rename)throw new D.ErrnoError(ca.EPERM);if(D.isMountpoint(ya)||Xd&&D.isMountpoint(Xd))throw new D.ErrnoError(ca.EBUSY);if(ra!==S&&(F=D.nodePermissions(S,"w")))throw new D.ErrnoError(F);try{D.trackingDelegate.willMovePath&&D.trackingDelegate.willMovePath(r,v)}catch(Ka){console.log("FS.trackingDelegate['willMovePath']('"+
r+"', '"+v+"') threw an exception: "+Ka.message)}D.hashRemoveNode(ya);try{S.node_ops.rename(ya,ra,aa)}catch(Ka){throw Ka;}finally{D.hashAddNode(ya)}try{if(D.trackingDelegate.onMovePath)D.trackingDelegate.onMovePath(r,v)}catch(Ka){console.log("FS.trackingDelegate['onMovePath']('"+r+"', '"+v+"') threw an exception: "+Ka.message)}}},rmdir:function(r){var v=D.lookupPath(r,{parent:!0}).node,A=jc.basename(r),fa=D.lookupNode(v,A),F=D.mayDelete(v,A,!0);if(F)throw new D.ErrnoError(F);if(!v.node_ops.rmdir)throw new D.ErrnoError(ca.EPERM);
if(D.isMountpoint(fa))throw new D.ErrnoError(ca.EBUSY);try{D.trackingDelegate.willDeletePath&&D.trackingDelegate.willDeletePath(r)}catch(aa){console.log("FS.trackingDelegate['willDeletePath']('"+r+"') threw an exception: "+aa.message)}v.node_ops.rmdir(v,A);D.destroyNode(fa);try{if(D.trackingDelegate.onDeletePath)D.trackingDelegate.onDeletePath(r)}catch(aa){console.log("FS.trackingDelegate['onDeletePath']('"+r+"') threw an exception: "+aa.message)}},readdir:function(r){r=D.lookupPath(r,{follow:!0}).node;
if(!r.node_ops.readdir)throw new D.ErrnoError(ca.ENOTDIR);return r.node_ops.readdir(r)},unlink:function(r){var v=D.lookupPath(r,{parent:!0}).node,A=jc.basename(r),F=D.lookupNode(v,A),yc=D.mayDelete(v,A,!1);if(yc)throw yc===ca.EISDIR&&(yc=ca.EPERM),new D.ErrnoError(yc);if(!v.node_ops.unlink)throw new D.ErrnoError(ca.EPERM);if(D.isMountpoint(F))throw new D.ErrnoError(ca.EBUSY);try{D.trackingDelegate.willDeletePath&&D.trackingDelegate.willDeletePath(r)}catch(aa){console.log("FS.trackingDelegate['willDeletePath']('"+
r+"') threw an exception: "+aa.message)}v.node_ops.unlink(v,A);D.destroyNode(F);try{if(D.trackingDelegate.onDeletePath)D.trackingDelegate.onDeletePath(r)}catch(aa){console.log("FS.trackingDelegate['onDeletePath']('"+r+"') threw an exception: "+aa.message)}},readlink:function(r){r=D.lookupPath(r).node;if(!r)throw new D.ErrnoError(ca.ENOENT);if(!r.node_ops.readlink)throw new D.ErrnoError(ca.EINVAL);return jc.resolve(D.getPath(r.parent),r.node_ops.readlink(r))},stat:function(r,v){var A=D.lookupPath(r,
{follow:!v}).node;if(!A)throw new D.ErrnoError(ca.ENOENT);if(!A.node_ops.getattr)throw new D.ErrnoError(ca.EPERM);return A.node_ops.getattr(A)},lstat:function(r){return D.stat(r,!0)},chmod:function(r,v,A){r="string"===typeof r?D.lookupPath(r,{follow:!A}).node:r;if(!r.node_ops.setattr)throw new D.ErrnoError(ca.EPERM);r.node_ops.setattr(r,{mode:v&4095|r.mode&-4096,timestamp:Date.now()})},lchmod:function(r,v){D.chmod(r,v,!0)},fchmod:function(r,v){var A=D.getStream(r);if(!A)throw new D.ErrnoError(ca.EBADF);
D.chmod(A.node,v)},chown:function(r,v,A,F){r="string"===typeof r?D.lookupPath(r,{follow:!F}).node:r;if(!r.node_ops.setattr)throw new D.ErrnoError(ca.EPERM);r.node_ops.setattr(r,{timestamp:Date.now()})},lchown:function(r,v,A){D.chown(r,v,A,!0)},fchown:function(r,v,A){r=D.getStream(r);if(!r)throw new D.ErrnoError(ca.EBADF);D.chown(r.node,v,A)},truncate:function(r,v){if(0>v)throw new D.ErrnoError(ca.EINVAL);var A;A="string"===typeof r?D.lookupPath(r,{follow:!0}).node:r;if(!A.node_ops.setattr)throw new D.ErrnoError(ca.EPERM);
if(D.isDir(A.mode))throw new D.ErrnoError(ca.EISDIR);if(!D.isFile(A.mode))throw new D.ErrnoError(ca.EINVAL);var F=D.nodePermissions(A,"w");if(F)throw new D.ErrnoError(F);A.node_ops.setattr(A,{size:v,timestamp:Date.now()})},ftruncate:function(r,v){var A=D.getStream(r);if(!A)throw new D.ErrnoError(ca.EBADF);if(0===(A.flags&2097155))throw new D.ErrnoError(ca.EINVAL);D.truncate(A.node,v)},utime:function(r,v,A){r=D.lookupPath(r,{follow:!0}).node;r.node_ops.setattr(r,{timestamp:Math.max(v,A)})},open:function(r,
v,A,fa,yc){if(""===r)throw new D.ErrnoError(ca.ENOENT);v="string"===typeof v?D.modeStringToFlags(v):v;A=v&64?("undefined"===typeof A?438:A)&4095|32768:0;var aa;if("object"===typeof r)aa=r;else{r=jc.normalize(r);try{aa=D.lookupPath(r,{follow:!(v&131072)}).node}catch(S){}}var ya=!1;if(v&64)if(aa){if(v&128)throw new D.ErrnoError(ca.EEXIST);}else aa=D.mknod(r,A,0),ya=!0;if(!aa)throw new D.ErrnoError(ca.ENOENT);D.isChrdev(aa.mode)&&(v&=-513);if(v&65536&&!D.isDir(aa.mode))throw new D.ErrnoError(ca.ENOTDIR);
if(!ya&&(A=D.mayOpen(aa,v)))throw new D.ErrnoError(A);v&512&&D.truncate(aa,0);v&=-641;fa=D.createStream({node:aa,path:D.getPath(aa),flags:v,seekable:!0,position:0,stream_ops:aa.stream_ops,ungotten:[],error:!1},fa,yc);fa.stream_ops.open&&fa.stream_ops.open(fa);!F.logReadFiles||v&1||(D.readFiles||(D.readFiles={}),r in D.readFiles||(D.readFiles[r]=1,F.printErr("read file: "+r)));try{D.trackingDelegate.onOpenFile&&(yc=0,1!==(v&2097155)&&(yc|=D.tracking.openFlags.READ),0!==(v&2097155)&&(yc|=D.tracking.openFlags.WRITE),
D.trackingDelegate.onOpenFile(r,yc))}catch(S){console.log("FS.trackingDelegate['onOpenFile']('"+r+"', flags) threw an exception: "+S.message)}return fa},close:function(r){r.getdents&&(r.getdents=null);try{r.stream_ops.close&&r.stream_ops.close(r)}catch(v){throw v;}finally{D.closeStream(r.fd)}},llseek:function(r,v,A){if(!r.seekable||!r.stream_ops.llseek)throw new D.ErrnoError(ca.ESPIPE);r.position=r.stream_ops.llseek(r,v,A);r.ungotten=[];return r.position},read:function(r,v,A,F,S){if(0>F||0>S)throw new D.ErrnoError(ca.EINVAL);
if(1===(r.flags&2097155))throw new D.ErrnoError(ca.EBADF);if(D.isDir(r.node.mode))throw new D.ErrnoError(ca.EISDIR);if(!r.stream_ops.read)throw new D.ErrnoError(ca.EINVAL);var aa=!0;if("undefined"===typeof S)S=r.position,aa=!1;else if(!r.seekable)throw new D.ErrnoError(ca.ESPIPE);v=r.stream_ops.read(r,v,A,F,S);aa||(r.position+=v);return v},write:function(r,v,A,F,S,aa){if(0>F||0>S)throw new D.ErrnoError(ca.EINVAL);if(0===(r.flags&2097155))throw new D.ErrnoError(ca.EBADF);if(D.isDir(r.node.mode))throw new D.ErrnoError(ca.EISDIR);
if(!r.stream_ops.write)throw new D.ErrnoError(ca.EINVAL);r.flags&1024&&D.llseek(r,0,2);var ya=!0;if("undefined"===typeof S)S=r.position,ya=!1;else if(!r.seekable)throw new D.ErrnoError(ca.ESPIPE);v=r.stream_ops.write(r,v,A,F,S,aa);ya||(r.position+=v);try{if(r.path&&D.trackingDelegate.onWriteToFile)D.trackingDelegate.onWriteToFile(r.path)}catch(ra){console.log("FS.trackingDelegate['onWriteToFile']('"+path+"') threw an exception: "+ra.message)}return v},allocate:function(r,v,A){if(0>v||0>=A)throw new D.ErrnoError(ca.EINVAL);
if(0===(r.flags&2097155))throw new D.ErrnoError(ca.EBADF);if(!D.isFile(r.node.mode)&&!D.isDir(node.mode))throw new D.ErrnoError(ca.ENODEV);if(!r.stream_ops.allocate)throw new D.ErrnoError(ca.EOPNOTSUPP);r.stream_ops.allocate(r,v,A)},mmap:function(r,v,A,F,S,aa,ya){if(1===(r.flags&2097155))throw new D.ErrnoError(ca.EACCES);if(!r.stream_ops.mmap)throw new D.ErrnoError(ca.ENODEV);return r.stream_ops.mmap(r,v,A,F,S,aa,ya)},msync:function(r,v,A,D,F){return r&&r.stream_ops.msync?r.stream_ops.msync(r,v,A,
D,F):0},munmap:function(r){return 0},ioctl:function(r,v,A){if(!r.stream_ops.ioctl)throw new D.ErrnoError(ca.ENOTTY);return r.stream_ops.ioctl(r,v,A)},readFile:function(r,v){v=v||{};v.flags=v.flags||"r";v.encoding=v.encoding||"binary";if("utf8"!==v.encoding&&"binary"!==v.encoding)throw Error('Invalid encoding type "'+v.encoding+'"');var A,F=D.open(r,v.flags),S=D.stat(r).size,aa=new Uint8Array(S);D.read(F,aa,0,S,0);"utf8"===v.encoding?A=nf(aa,0):"binary"===v.encoding&&(A=aa);D.close(F);return A},writeFile:function(r,
v,A){A=A||{};A.flags=A.flags||"w";A.encoding=A.encoding||"utf8";if("utf8"!==A.encoding&&"binary"!==A.encoding)throw Error('Invalid encoding type "'+A.encoding+'"');r=D.open(r,A.flags,A.mode);if("utf8"===A.encoding){var F=new Uint8Array(lg(v)+1);v=Ug(v,F,0,F.length);D.write(r,F,0,v,0,A.canOwn)}else"binary"===A.encoding&&D.write(r,v,0,v.length,0,A.canOwn);D.close(r)},cwd:function(){return D.currentPath},chdir:function(r){r=D.lookupPath(r,{follow:!0});if(!D.isDir(r.node.mode))throw new D.ErrnoError(ca.ENOTDIR);
var v=D.nodePermissions(r.node,"x");if(v)throw new D.ErrnoError(v);D.currentPath=r.path},createDefaultDirectories:function(){D.mkdir("/tmp");D.mkdir("/home");D.mkdir("/home/web_user")},createDefaultDevices:function(){D.mkdir("/dev");D.registerDevice(D.makedev(1,3),{read:function(){return 0},write:function(r,v,D,F,S){return F}});D.mkdev("/dev/null",D.makedev(1,3));ye.register(D.makedev(5,0),ye.default_tty_ops);ye.register(D.makedev(6,0),ye.default_tty1_ops);D.mkdev("/dev/tty",D.makedev(5,0));D.mkdev("/dev/tty1",
D.makedev(6,0));var r;if("undefined"!==typeof crypto){var v=new Uint8Array(1);r=function(){crypto.getRandomValues(v);return v[0]}}else r=Bf?function(){return __webpack_require__(257).randomBytes(1)[0]}:function(){return 256*Math.random()|0};D.createDevice("/dev","random",r);D.createDevice("/dev","urandom",r);D.mkdir("/dev/shm");D.mkdir("/dev/shm/tmp")},createSpecialDirectories:function(){D.mkdir("/proc");D.mkdir("/proc/self");D.mkdir("/proc/self/fd");D.mount({mount:function(){var r=D.createNode("/proc/self",
"fd",16895,73);r.node_ops={lookup:function(r,A){var F=D.getStream(+A);if(!F)throw new D.ErrnoError(ca.EBADF);var S={parent:null,mount:{mountpoint:"fake"},node_ops:{readlink:function(){return F.path}}};return S.parent=S}};return r}},{},"/proc/self/fd")},createStandardStreams:function(){F.stdin?D.createDevice("/dev","stdin",F.stdin):D.symlink("/dev/tty","/dev/stdin");F.stdout?D.createDevice("/dev","stdout",null,F.stdout):D.symlink("/dev/tty","/dev/stdout");F.stderr?D.createDevice("/dev","stderr",null,
F.stderr):D.symlink("/dev/tty1","/dev/stderr");var r=D.open("/dev/stdin","r");fb(0===r.fd,"invalid handle for stdin ("+r.fd+")");r=D.open("/dev/stdout","w");fb(1===r.fd,"invalid handle for stdout ("+r.fd+")");r=D.open("/dev/stderr","w");fb(2===r.fd,"invalid handle for stderr ("+r.fd+")")},ensureErrnoError:function(){D.ErrnoError||(D.ErrnoError=function(r,v){this.node=v;this.setErrno=function(r){this.errno=r;for(var v in ca)if(ca[v]===r){this.code=v;break}};this.setErrno(r);this.message=Kj[r]},D.ErrnoError.prototype=
Error(),D.ErrnoError.prototype.constructor=D.ErrnoError,[ca.ENOENT].forEach(function(r){D.genericErrors[r]=new D.ErrnoError(r);D.genericErrors[r].stack="<generic error, no stack>"}))},staticInit:function(){D.ensureErrnoError();D.nameTable=Array(4096);D.mount(lc,{},"/");D.createDefaultDirectories();D.createDefaultDevices();D.createSpecialDirectories();D.filesystems={MEMFS:lc,IDBFS:Bc,NODEFS:Wc,WORKERFS:sd}},init:function(r,v,A){fb(!D.init.initialized,"FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)");
D.init.initialized=!0;D.ensureErrnoError();F.stdin=r||F.stdin;F.stdout=v||F.stdout;F.stderr=A||F.stderr;D.createStandardStreams()},quit:function(){D.init.initialized=!1;var r=F._fflush;r&&r(0);for(r=0;r<D.streams.length;r++){var v=D.streams[r];v&&D.close(v)}},getMode:function(r,v){var A=0;r&&(A|=365);v&&(A|=146);return A},joinPath:function(r,v){var A=jc.join.apply(null,r);v&&"/"==A[0]&&(A=A.substr(1));return A},absolutePath:function(r,v){return jc.resolve(v,r)},standardizePath:function(r){return jc.normalize(r)},
findObject:function(r,v){var A=D.analyzePath(r,v);if(A.exists)return A.object;eg(A.error);return null},analyzePath:function(r,v){try{var A=D.lookupPath(r,{follow:!v});r=A.path}catch(F){}var fa={isRoot:!1,exists:!1,error:0,name:null,path:null,object:null,parentExists:!1,parentPath:null,parentObject:null};try{A=D.lookupPath(r,{parent:!0}),fa.parentExists=!0,fa.parentPath=A.path,fa.parentObject=A.node,fa.name=jc.basename(r),A=D.lookupPath(r,{follow:!v}),fa.exists=!0,fa.path=A.path,fa.object=A.node,fa.name=
A.node.name,fa.isRoot="/"===A.path}catch(F){fa.error=F.errno}return fa},createFolder:function(r,v,A,F){r=jc.join2("string"===typeof r?r:D.getPath(r),v);A=D.getMode(A,F);return D.mkdir(r,A)},createPath:function(r,v,A,F){r="string"===typeof r?r:D.getPath(r);for(v=v.split("/").reverse();v.length;)if(A=v.pop()){var S=jc.join2(r,A);try{D.mkdir(S)}catch(aa){}r=S}return S},createFile:function(r,v,A,F,S){r=jc.join2("string"===typeof r?r:D.getPath(r),v);F=D.getMode(F,S);return D.create(r,F)},createDataFile:function(r,
v,A,F,S,aa){r=v?jc.join2("string"===typeof r?r:D.getPath(r),v):r;F=D.getMode(F,S);S=D.create(r,F);if(A){if("string"===typeof A){r=Array(A.length);v=0;for(var ya=A.length;v<ya;++v)r[v]=A.charCodeAt(v);A=r}D.chmod(S,F|146);r=D.open(S,"w");D.write(r,A,0,A.length,0,aa);D.close(r);D.chmod(S,F)}return S},createDevice:function(r,v,A,F){r=jc.join2("string"===typeof r?r:D.getPath(r),v);v=D.getMode(!!A,!!F);D.createDevice.major||(D.createDevice.major=64);var S=D.makedev(D.createDevice.major++,0);D.registerDevice(S,
{open:function(r){r.seekable=!1},close:function(r){F&&F.buffer&&F.buffer.length&&F(10)},read:function(r,v,F,fa,S){for(var yc=S=0;yc<fa;yc++){var ra;try{ra=A()}catch(Y){throw new D.ErrnoError(ca.EIO);}if(void 0===ra&&0===S)throw new D.ErrnoError(ca.EAGAIN);if(null===ra||void 0===ra)break;S++;v[F+yc]=ra}S&&(r.node.timestamp=Date.now());return S},write:function(r,v,A,S,yc){for(yc=0;yc<S;yc++)try{F(v[A+yc])}catch(ra){throw new D.ErrnoError(ca.EIO);}S&&(r.node.timestamp=Date.now());return yc}});return D.mkdev(r,
v,S)},createLink:function(r,v,A,F,S){r=jc.join2("string"===typeof r?r:D.getPath(r),v);return D.symlink(A,r)},forceLoadFile:function(r){if(r.isDevice||r.isFolder||r.link||r.contents)return!0;var v=!0;if("undefined"!==typeof XMLHttpRequest)throw Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");if(F.read)try{r.contents=yf(F.read(r.url),!0),r.usedBytes=
r.contents.length}catch(A){v=!1}else throw Error("Cannot load without read() or XMLHttpRequest.");v||eg(ca.EIO);return v},createLazyFile:function(r,v,A,F,S){function aa(){this.lengthKnown=!1;this.chunks=[]}aa.prototype.get=function(r){if(!(r>this.length-1||0>r)){var v=r%this.chunkSize;return this.getter(r/this.chunkSize|0)[v]}};aa.prototype.setDataGetter=function(r){this.getter=r};aa.prototype.cacheLength=function(){var r=new XMLHttpRequest;r.open("HEAD",A,!1);r.send(null);if(!(200<=r.status&&300>
r.status||304===r.status))throw Error("Couldn't load "+A+". Status: "+r.status);var v=Number(r.getResponseHeader("Content-length")),D,F=1048576;(D=r.getResponseHeader("Accept-Ranges"))&&"bytes"===D||(F=v);var fa=this;fa.setDataGetter(function(r){var D=r*F,S=(r+1)*F-1,S=Math.min(S,v-1);if("undefined"===typeof fa.chunks[r]){var aa=fa.chunks;if(D>S)throw Error("invalid range ("+D+", "+S+") or no bytes requested!");if(S>v-1)throw Error("only "+v+" bytes available! programmer error!");var ya=new XMLHttpRequest;
ya.open("GET",A,!1);v!==F&&ya.setRequestHeader("Range","bytes="+D+"-"+S);"undefined"!=typeof Uint8Array&&(ya.responseType="arraybuffer");ya.overrideMimeType&&ya.overrideMimeType("text/plain; charset=x-user-defined");ya.send(null);if(!(200<=ya.status&&300>ya.status||304===ya.status))throw Error("Couldn't load "+A+". Status: "+ya.status);D=void 0!==ya.response?new Uint8Array(ya.response||[]):yf(ya.responseText||"",!0);aa[r]=D}if("undefined"===typeof fa.chunks[r])throw Error("doXHR failed!");return fa.chunks[r]});
this._length=v;this._chunkSize=F;this.lengthKnown=!0};if("undefined"!==typeof XMLHttpRequest){if(!fg)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var ya=new aa;Object.defineProperty(ya,"length",{get:function(){this.lengthKnown||this.cacheLength();return this._length}});Object.defineProperty(ya,"chunkSize",{get:function(){this.lengthKnown||this.cacheLength();return this._chunkSize}});ya={isDevice:!1,contents:ya}}else ya=
{isDevice:!1,url:A};var ra=D.createFile(r,v,ya,F,S);ya.contents?ra.contents=ya.contents:ya.url&&(ra.contents=null,ra.url=ya.url);Object.defineProperty(ra,"usedBytes",{get:function(){return this.contents.length}});var Ka={};Object.keys(ra.stream_ops).forEach(function(r){var v=ra.stream_ops[r];Ka[r]=function(){if(!D.forceLoadFile(ra))throw new D.ErrnoError(ca.EIO);return v.apply(null,arguments)}});Ka.read=function(r,v,A,F,fa){if(!D.forceLoadFile(ra))throw new D.ErrnoError(ca.EIO);r=r.node.contents;
if(fa>=r.length)return 0;F=Math.min(r.length-fa,F);fb(0<=F);if(r.slice)for(var S=0;S<F;S++)v[A+S]=r[fa+S];else for(S=0;S<F;S++)v[A+S]=r.get(fa+S);return F};ra.stream_ops=Ka;return ra},createPreloadedFile:function(r,v,A,fa,yc,aa,ya,ca,ra,Ka){function ab(A){function S(A){Ka&&Ka();ca||D.createDataFile(r,v,A,fa,yc,ra);aa&&aa();ng(Y)}var Lb=!1;F.preloadPlugins.forEach(function(r){!Lb&&r.canHandle(fb)&&(r.handle(A,fb,S,function(){ya&&ya();ng(Y)}),Lb=!0)});Lb||S(A)}S.init();var fb=v?jc.resolve(jc.join2(r,
v)):r,Y="cp "+fb;Yg(Y);"string"==typeof A?S.asyncLoad(A,function(r){ab(r)},ya):ab(A)},indexedDB:function(){return window.indexedDB||window.mozIndexedDB||window.webkitIndexedDB||window.msIndexedDB},DB_NAME:function(){return"EM_FS_"+window.location.pathname},DB_VERSION:20,DB_STORE_NAME:"FILE_DATA",saveFilesToDB:function(r,v,A){v=v||function(){};A=A||function(){};var F=D.indexedDB();try{var S=F.open(D.DB_NAME(),D.DB_VERSION)}catch(aa){return A(aa)}S.onupgradeneeded=function(){console.log("creating db");
S.result.createObjectStore(D.DB_STORE_NAME)};S.onsuccess=function(){var F=S.result.transaction([D.DB_STORE_NAME],"readwrite"),fa=F.objectStore(D.DB_STORE_NAME),ca=0,ra=0,Ka=r.length;r.forEach(function(r){r=fa.put(D.analyzePath(r).object.contents,r);r.onsuccess=function(){ca++;ca+ra==Ka&&(0==ra?v():A())};r.onerror=function(){ra++;ca+ra==Ka&&(0==ra?v():A())}});F.onerror=A};S.onerror=A},loadFilesFromDB:function(r,v,A){v=v||function(){};A=A||function(){};var F=D.indexedDB();try{var S=F.open(D.DB_NAME(),
D.DB_VERSION)}catch(aa){return A(aa)}S.onupgradeneeded=A;S.onsuccess=function(){var F=S.result;try{var fa=F.transaction([D.DB_STORE_NAME],"readonly")}catch(ca){A(ca);return}var ra=fa.objectStore(D.DB_STORE_NAME),Ka=0,ab=0,fb=r.length;r.forEach(function(r){var F=ra.get(r);F.onsuccess=function(){D.analyzePath(r).exists&&D.unlink(r);D.createDataFile(jc.dirname(r),jc.basename(r),F.result,!0,!0,!0);Ka++;Ka+ab==fb&&(0==ab?v():A())};F.onerror=function(){ab++;Ka+ab==fb&&(0==ab?v():A())}});fa.onerror=A};S.onerror=
A}};F.FS=D;var jc={splitPath:function(r){return/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(r).slice(1)},normalizeArray:function(r,v){for(var A=0,D=r.length-1;0<=D;D--){var F=r[D];"."===F?r.splice(D,1):".."===F?(r.splice(D,1),A++):A&&(r.splice(D,1),A--)}if(v)for(;A--;A)r.unshift("..");return r},normalize:function(r){var v="/"===r.charAt(0),A="/"===r.substr(-1);(r=jc.normalizeArray(r.split("/").filter(function(r){return!!r}),!v).join("/"))||v||(r=".");r&&A&&(r+="/");return(v?
"/":"")+r},dirname:function(r){var v=jc.splitPath(r);r=v[0];v=v[1];if(!r&&!v)return".";v&&(v=v.substr(0,v.length-1));return r+v},basename:function(r){if("/"===r)return"/";var v=r.lastIndexOf("/");return-1===v?r:r.substr(v+1)},extname:function(r){return jc.splitPath(r)[3]},join:function(){var r=Array.prototype.slice.call(arguments,0);return jc.normalize(r.join("/"))},join2:function(r,v){return jc.normalize(r+"/"+v)},resolve:function(){for(var r="",v=!1,A=arguments.length-1;-1<=A&&!v;A--){v=0<=A?arguments[A]:
D.cwd();if("string"!==typeof v)throw new TypeError("Arguments to path.resolve must be strings");if(!v)return"";r=v+"/"+r;v="/"===v.charAt(0)}r=jc.normalizeArray(r.split("/").filter(function(r){return!!r}),!v).join("/");return(v?"/":"")+r||"."},relative:function(r,v){function A(r){for(var v=0;v<r.length&&""===r[v];v++);for(var A=r.length-1;0<=A&&""===r[A];A--);return v>A?[]:r.slice(v,A-v+1)}r=jc.resolve(r).substr(1);v=jc.resolve(v).substr(1);for(var D=A(r.split("/")),F=A(v.split("/")),S=Math.min(D.length,
F.length),ya=S,ca=0;ca<S;ca++)if(D[ca]!==F[ca]){ya=ca;break}S=[];for(ca=ya;ca<D.length;ca++)S.push("..");S=S.concat(F.slice(ya));return S.join("/")}},S={mainLoop:{scheduler:null,method:"",currentlyRunningMainloop:0,func:null,arg:0,timingMode:0,timingValue:0,currentFrameNumber:0,queue:[],pause:function(){S.mainLoop.scheduler=null;S.mainLoop.currentlyRunningMainloop++},resume:function(){S.mainLoop.currentlyRunningMainloop++;var r=S.mainLoop.timingMode,v=S.mainLoop.timingValue,A=S.mainLoop.func;S.mainLoop.func=
null;Oh(A,0,!1,S.mainLoop.arg,!0);hj(r,v);S.mainLoop.scheduler()},updateStatus:function(){if(F.setStatus){var r=F.statusMessage||"Please wait...",v=S.mainLoop.remainingBlockers,A=S.mainLoop.expectedBlockers;v?v<A?F.setStatus(r+" ("+(A-v)+"/"+A+")"):F.setStatus(r):F.setStatus("")}},runIter:function(r){if(!(xe||F.preMainLoop&&!1===F.preMainLoop())){try{r()}catch(v){if(v instanceof of)return;v&&"object"===typeof v&&v.stack&&F.printErr("exception thrown: "+[v,v.stack]);throw v;}F.postMainLoop&&F.postMainLoop()}}},
isFullScreen:!1,pointerLock:!1,moduleContextCreatedCallbacks:[],workers:[],init:function(){function r(){S.pointerLock=document.pointerLockElement===v||document.mozPointerLockElement===v||document.webkitPointerLockElement===v||document.msPointerLockElement===v}F.preloadPlugins||(F.preloadPlugins=[]);if(!S.initted){S.initted=!0;try{new Blob,S.hasBlobConstructor=!0}catch(A){S.hasBlobConstructor=!1,console.log("warning: no blob constructor, cannot create blobs with mimetypes")}S.BlobBuilder="undefined"!=
typeof MozBlobBuilder?MozBlobBuilder:"undefined"!=typeof WebKitBlobBuilder?WebKitBlobBuilder:S.hasBlobConstructor?null:console.log("warning: no BlobBuilder");S.URLObject="undefined"!=typeof window?window.URL?window.URL:window.webkitURL:void 0;F.noImageDecoding||"undefined"!==typeof S.URLObject||(console.log("warning: Browser does not support creating object URLs. Built-in browser image decoding will not be available."),F.noImageDecoding=!0);F.preloadPlugins.push({canHandle:function(r){return!F.noImageDecoding&&
/\.(jpg|jpeg|png|bmp)$/i.test(r)},handle:function(r,v,D,aa){var ya=null;if(S.hasBlobConstructor)try{ya=new Blob([r],{type:S.getMimetype(v)}),ya.size!==r.length&&(ya=new Blob([(new Uint8Array(r)).buffer],{type:S.getMimetype(v)}))}catch(ca){ra.warnOnce("Blob constructor present but fails: "+ca+"; falling back to blob builder")}ya||(ya=new S.BlobBuilder,ya.append((new Uint8Array(r)).buffer),ya=ya.getBlob());var Ka=S.URLObject.createObjectURL(ya),ab=new Image;ab.onload=function(){fb(ab.complete,"Image "+
v+" could not be decoded");var aa=document.createElement("canvas");aa.width=ab.width;aa.height=ab.height;aa.getContext("2d").drawImage(ab,0,0);F.preloadedImages[v]=aa;S.URLObject.revokeObjectURL(Ka);D&&D(r)};ab.onerror=function(r){console.log("Image "+Ka+" could not be decoded");aa&&aa()};ab.src=Ka}});F.preloadPlugins.push({canHandle:function(r){return!F.noAudioDecoding&&r.substr(-4)in{".ogg":1,".wav":1,".mp3":1}},handle:function(r,v,D,aa){function ya(S){ra||(ra=!0,F.preloadedAudios[v]=S,D&&D(r))}
function ca(){ra||(ra=!0,F.preloadedAudios[v]=new Audio,aa&&aa())}var ra=!1;if(S.hasBlobConstructor){try{var Ka=new Blob([r],{type:S.getMimetype(v)})}catch(ab){return ca()}var Ka=S.URLObject.createObjectURL(Ka),fb=new Audio;fb.addEventListener("canplaythrough",function(){ya(fb)},!1);fb.onerror=function(D){if(!ra){console.log("warning: browser could not fully decode audio "+v+", trying slower base64 approach");D="data:audio/x-"+v.substr(-3)+";base64,";for(var F="",S=0,aa=0,ca=0;ca<r.length;ca++)for(S=
S<<8|r[ca],aa+=8;6<=aa;)var yc=S>>aa-6&63,aa=aa-6,F=F+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[yc];2==aa?(F+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(S&3)<<4],F+="=="):4==aa&&(F+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(S&15)<<2],F+="=");fb.src=D+F;ya(fb)}};fb.src=Ka;S.safeSetTimeout(function(){ya(fb)},1E4)}else return ca()}});var v=F.canvas;v&&(v.requestPointerLock=v.requestPointerLock||v.mozRequestPointerLock||v.webkitRequestPointerLock||
v.msRequestPointerLock||function(){},v.exitPointerLock=document.exitPointerLock||document.mozExitPointerLock||document.webkitExitPointerLock||document.msExitPointerLock||function(){},v.exitPointerLock=v.exitPointerLock.bind(document),document.addEventListener("pointerlockchange",r,!1),document.addEventListener("mozpointerlockchange",r,!1),document.addEventListener("webkitpointerlockchange",r,!1),document.addEventListener("mspointerlockchange",r,!1),F.elementPointerLock&&v.addEventListener("click",
function(r){!S.pointerLock&&v.requestPointerLock&&(v.requestPointerLock(),r.preventDefault())},!1))}},createContext:function(r,v,A,D){if(v&&F.ctx&&r==F.canvas)return F.ctx;var ca,aa;if(v){aa={antialias:!1,alpha:!1};if(D)for(var ya in D)aa[ya]=D[ya];if(aa=GL.createContext(r,aa))ca=GL.getContext(aa).GLctx;r.style.backgroundColor="black"}else ca=r.getContext("2d");if(!ca)return null;A&&(v||fb("undefined"===typeof GLctx,"cannot set in module if GLctx is used, but we are a non-GL context that would replace it"),
F.ctx=ca,v&&GL.makeContextCurrent(aa),F.useWebGL=v,S.moduleContextCreatedCallbacks.forEach(function(r){r()}),S.init());return ca},destroyContext:function(r,v,A){},fullScreenHandlersInstalled:!1,lockPointer:void 0,resizeCanvas:void 0,requestFullScreen:function(r,v,A){function D(){S.isFullScreen=!1;var r=ca.parentNode;(document.webkitFullScreenElement||document.webkitFullscreenElement||document.mozFullScreenElement||document.mozFullscreenElement||document.fullScreenElement||document.fullscreenElement||
document.msFullScreenElement||document.msFullscreenElement||document.webkitCurrentFullScreenElement)===r?(ca.cancelFullScreen=document.cancelFullScreen||document.mozCancelFullScreen||document.webkitCancelFullScreen||document.msExitFullscreen||document.exitFullscreen||function(){},ca.cancelFullScreen=ca.cancelFullScreen.bind(document),S.lockPointer&&ca.requestPointerLock(),S.isFullScreen=!0,S.resizeCanvas&&S.setFullScreenCanvasSize()):(r.parentNode.insertBefore(ca,r),r.parentNode.removeChild(r),S.resizeCanvas&&
S.setWindowedCanvasSize());if(F.onFullScreen)F.onFullScreen(S.isFullScreen);S.updateCanvasDimensions(ca)}S.lockPointer=r;S.resizeCanvas=v;S.vrDevice=A;"undefined"===typeof S.lockPointer&&(S.lockPointer=!0);"undefined"===typeof S.resizeCanvas&&(S.resizeCanvas=!1);"undefined"===typeof S.vrDevice&&(S.vrDevice=null);var ca=F.canvas;S.fullScreenHandlersInstalled||(S.fullScreenHandlersInstalled=!0,document.addEventListener("fullscreenchange",D,!1),document.addEventListener("mozfullscreenchange",D,!1),document.addEventListener("webkitfullscreenchange",
D,!1),document.addEventListener("MSFullscreenChange",D,!1));var aa=document.createElement("div");ca.parentNode.insertBefore(aa,ca);aa.appendChild(ca);aa.requestFullScreen=aa.requestFullScreen||aa.mozRequestFullScreen||aa.msRequestFullscreen||(aa.webkitRequestFullScreen?function(){aa.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)}:null);A?aa.requestFullScreen({vrDisplay:A}):aa.requestFullScreen()},nextRAF:0,fakeRequestAnimationFrame:function(r){var v=Date.now();if(0===S.nextRAF)S.nextRAF=v+
1E3/60;else for(;v+2>=S.nextRAF;)S.nextRAF+=1E3/60;setTimeout(r,Math.max(S.nextRAF-v,0))},requestAnimationFrame:function(r){"undefined"===typeof window?S.fakeRequestAnimationFrame(r):(window.requestAnimationFrame||(window.requestAnimationFrame=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame||S.fakeRequestAnimationFrame),window.requestAnimationFrame(r))},safeCallback:function(r){return function(){if(!xe)return r.apply(null,
arguments)}},allowAsyncCallbacks:!0,queuedAsyncCallbacks:[],pauseAsyncCallbacks:function(){S.allowAsyncCallbacks=!1},resumeAsyncCallbacks:function(){S.allowAsyncCallbacks=!0;if(0<S.queuedAsyncCallbacks.length){var r=S.queuedAsyncCallbacks;S.queuedAsyncCallbacks=[];r.forEach(function(r){r()})}},safeRequestAnimationFrame:function(r){return S.requestAnimationFrame(function(){xe||(S.allowAsyncCallbacks?r():S.queuedAsyncCallbacks.push(r))})},safeSetTimeout:function(r,v){F.noExitRuntime=!0;return setTimeout(function(){xe||
(S.allowAsyncCallbacks?r():S.queuedAsyncCallbacks.push(r))},v)},safeSetInterval:function(r,v){F.noExitRuntime=!0;return setInterval(function(){xe||S.allowAsyncCallbacks&&r()},v)},getMimetype:function(r){return{jpg:"image/jpeg",jpeg:"image/jpeg",png:"image/png",bmp:"image/bmp",ogg:"audio/ogg",wav:"audio/wav",mp3:"audio/mpeg"}[r.substr(r.lastIndexOf(".")+1)]},getUserMedia:function(r){window.getUserMedia||(window.getUserMedia=navigator.getUserMedia||navigator.mozGetUserMedia);window.getUserMedia(r)},
getMovementX:function(r){return r.movementX||r.mozMovementX||r.webkitMovementX||0},getMovementY:function(r){return r.movementY||r.mozMovementY||r.webkitMovementY||0},getMouseWheelDelta:function(r){switch(r.type){case "DOMMouseScroll":r=r.detail;break;case "mousewheel":r=r.wheelDelta;break;case "wheel":r=r.deltaY;break;default:throw"unrecognized mouse wheel event: "+r.type;}return r},mouseX:0,mouseY:0,mouseMovementX:0,mouseMovementY:0,touches:{},lastTouches:{},calculateMouseEvent:function(r){if(S.pointerLock)"mousemove"!=
r.type&&"mozMovementX"in r?S.mouseMovementX=S.mouseMovementY=0:(S.mouseMovementX=S.getMovementX(r),S.mouseMovementY=S.getMovementY(r)),"undefined"!=typeof SDL?(S.mouseX=SDL.mouseX+S.mouseMovementX,S.mouseY=SDL.mouseY+S.mouseMovementY):(S.mouseX+=S.mouseMovementX,S.mouseY+=S.mouseMovementY);else{var v=F.canvas.getBoundingClientRect(),A=F.canvas.width,D=F.canvas.height,ca="undefined"!==typeof window.scrollX?window.scrollX:window.pageXOffset,aa="undefined"!==typeof window.scrollY?window.scrollY:window.pageYOffset;
if("touchstart"===r.type||"touchend"===r.type||"touchmove"===r.type){var ya=r.touch;if(void 0!==ya)if(ca=ya.pageX-(ca+v.left),aa=ya.pageY-(aa+v.top),ca*=A/v.width,aa*=D/v.height,v={x:ca,y:aa},"touchstart"===r.type)S.lastTouches[ya.identifier]=v,S.touches[ya.identifier]=v;else if("touchend"===r.type||"touchmove"===r.type)(r=S.touches[ya.identifier])||(r=v),S.lastTouches[ya.identifier]=r,S.touches[ya.identifier]=v}else ya=r.pageX-(ca+v.left),r=r.pageY-(aa+v.top),ya*=A/v.width,r*=D/v.height,S.mouseMovementX=
ya-S.mouseX,S.mouseMovementY=r-S.mouseY,S.mouseX=ya,S.mouseY=r}},xhrLoad:function(r,v,A){var D=new XMLHttpRequest;D.open("GET",r,!0);D.responseType="arraybuffer";D.onload=function(){200==D.status||0==D.status&&D.response?v(D.response):A()};D.onerror=A;D.send(null)},asyncLoad:function(r,v,A,D){S.xhrLoad(r,function(A){fb(A,'Loading data file "'+r+'" failed (no arrayBuffer).');v(new Uint8Array(A));D||ng("al "+r)},function(v){if(A)A();else throw'Loading data file "'+r+'" failed.';});D||Yg("al "+r)},resizeListeners:[],
updateResizeListeners:function(){var r=F.canvas;S.resizeListeners.forEach(function(v){v(r.width,r.height)})},setCanvasSize:function(r,v,A){S.updateCanvasDimensions(F.canvas,r,v);A||S.updateResizeListeners()},windowedWidth:0,windowedHeight:0,setFullScreenCanvasSize:function(){"undefined"!=typeof SDL&&(Sb[SDL.screen+0*ra.QUANTUM_SIZE>>2]=xf[SDL.screen+0*ra.QUANTUM_SIZE>>2]|8388608);S.updateResizeListeners()},setWindowedCanvasSize:function(){"undefined"!=typeof SDL&&(Sb[SDL.screen+0*ra.QUANTUM_SIZE>>
2]=xf[SDL.screen+0*ra.QUANTUM_SIZE>>2]&-8388609);S.updateResizeListeners()},updateCanvasDimensions:function(r,v,A){v&&A?(r.widthNative=v,r.heightNative=A):(v=r.widthNative,A=r.heightNative);var D=v,ca=A;F.forcedAspectRatio&&0<F.forcedAspectRatio&&(D/ca<F.forcedAspectRatio?D=Math.round(ca*F.forcedAspectRatio):ca=Math.round(D/F.forcedAspectRatio));if((document.webkitFullScreenElement||document.webkitFullscreenElement||document.mozFullScreenElement||document.mozFullscreenElement||document.fullScreenElement||
document.fullscreenElement||document.msFullScreenElement||document.msFullscreenElement||document.webkitCurrentFullScreenElement)===r.parentNode&&"undefined"!=typeof screen)var aa=Math.min(screen.width/D,screen.height/ca),D=Math.round(D*aa),ca=Math.round(ca*aa);S.resizeCanvas?(r.width!=D&&(r.width=D),r.height!=ca&&(r.height=ca),"undefined"!=typeof r.style&&(r.style.removeProperty("width"),r.style.removeProperty("height"))):(r.width!=v&&(r.width=v),r.height!=A&&(r.height=A),"undefined"!=typeof r.style&&
(D!=v||ca!=A?(r.style.setProperty("width",D+"px","important"),r.style.setProperty("height",ca+"px","important")):(r.style.removeProperty("width"),r.style.removeProperty("height"))))},wgetRequests:{},nextWgetRequestHandle:0,getNextWgetRequestHandle:function(){var r=S.nextWgetRequestHandle;S.nextWgetRequestHandle++;return r}};F._i64Subtract=Lj;F._memset=Mi;F._bitshift64Shl=Mj;var Ka={DEFAULT_POLLMASK:5,mappings:{},umask:511,calculateAt:function(r,v){if("/"!==v[0]){var A;if(-100===r)A=D.cwd();else{A=
D.getStream(r);if(!A)throw new D.ErrnoError(ca.EBADF);A=A.path}v=jc.join2(A,v)}return v},doStat:function(r,v,A){try{var F=r(v)}catch(S){if(S&&S.node&&jc.normalize(v)!==jc.normalize(D.getPath(S.node)))return-ca.ENOTDIR;throw S;}Sb[A>>2]=F.dev;Sb[A+4>>2]=0;Sb[A+8>>2]=F.ino;Sb[A+12>>2]=F.mode;Sb[A+16>>2]=F.nlink;Sb[A+20>>2]=F.uid;Sb[A+24>>2]=F.gid;Sb[A+28>>2]=F.rdev;Sb[A+32>>2]=0;Sb[A+36>>2]=F.size;Sb[A+40>>2]=4096;Sb[A+44>>2]=F.blocks;Sb[A+48>>2]=F.atime.getTime()/1E3|0;Sb[A+52>>2]=0;Sb[A+56>>2]=F.mtime.getTime()/
1E3|0;Sb[A+60>>2]=0;Sb[A+64>>2]=F.ctime.getTime()/1E3|0;Sb[A+68>>2]=0;Sb[A+72>>2]=F.ino;return 0},doMsync:function(r,v,A,F){r=new Uint8Array(Od.subarray(r,r+A));D.msync(v,r,0,A,F)},doMkdir:function(r,v){r=jc.normalize(r);"/"===r[r.length-1]&&(r=r.substr(0,r.length-1));D.mkdir(r,v,0);return 0},doMknod:function(r,v,A){switch(v&61440){case 32768:case 8192:case 24576:case 4096:case 49152:break;default:return-ca.EINVAL}D.mknod(r,v,A);return 0},doReadlink:function(r,v,A){if(0>=A)return-ca.EINVAL;r=D.readlink(r);
r=r.slice(0,Math.max(0,A));Ji(r,v,!0);return r.length},doAccess:function(r,v){if(v&-8)return-ca.EINVAL;var A;A=D.lookupPath(r,{follow:!0}).node;var F="";v&4&&(F+="r");v&2&&(F+="w");v&1&&(F+="x");return F&&D.nodePermissions(A,F)?-ca.EACCES:0},doDup:function(r,v,A){var F=D.getStream(A);F&&D.close(F);return D.open(r,v,0,A,A).fd},doReadv:function(r,v,A,F){for(var S=0,aa=0;aa<A;aa++){var ca=Sb[v+(8*aa+4)>>2],ra=D.read(r,Dd,Sb[v+8*aa>>2],ca,F);if(0>ra)return-1;S+=ra;if(ra<ca)break}return S},doWritev:function(r,
v,A,F){for(var S=0,aa=0;aa<A;aa++){var ca=D.write(r,Dd,Sb[v+8*aa>>2],Sb[v+(8*aa+4)>>2],F);if(0>ca)return-1;S+=ca}return S},varargs:0,get:function(r){Ka.varargs+=4;return Sb[Ka.varargs-4>>2]},getStr:function(){return Yd(Ka.get())},getStreamFromFD:function(){var r=D.getStream(Ka.get());if(!r)throw new D.ErrnoError(ca.EBADF);return r},getSocketFromFD:function(){var r=SOCKFS.getSocket(Ka.get());if(!r)throw new D.ErrnoError(ca.EBADF);return r},getSocketAddress:function(r){var v=Ka.get(),A=Ka.get();if(r&&
0===v)return null;r=__read_sockaddr(v,A);if(r.errno)throw new D.ErrnoError(r.errno);r.addr=DNS.lookup_addr(r.addr)||r.addr;return r},get64:function(){var r=Ka.get(),v=Ka.get();0<=r?fb(0===v):fb(-1===v);return r},getZero:function(){fb(0===Ka.get())}};F._i64Add=Nj;var Oj=Lh,Pj=Ij;F._realloc=Ph;F._saveSetjmp=Qj;F._bitshift64Lshr=Rj;F._testSetjmp=Sj;var Rh=vc(1,"i32*",2),Td={},Tj=Hj,Uj=Fg;F._memcpy=Vj;var Wj=Fj;F._llvm_bswap_i32=Xj;var Yj=Gj,Zj=Jj;F.requestFullScreen=function(r,v,A){S.requestFullScreen(r,
v,A)};F.requestAnimationFrame=function(r){S.requestAnimationFrame(r)};F.setCanvasSize=function(r,v,A){S.setCanvasSize(r,v,A)};F.pauseMainLoop=function(){S.mainLoop.pause()};F.resumeMainLoop=function(){S.mainLoop.resume()};F.getUserMedia=function(){S.getUserMedia()};F.createContext=function(r,v,A,D){return S.createContext(r,v,A,D)};D.staticInit();qg.unshift(function(){F.noFSInit||D.init.initialized||D.init()});rg.push(function(){D.ignorePermissions=!1});re.push(function(){D.quit()});F.FS_createFolder=
D.createFolder;F.FS_createPath=D.createPath;F.FS_createDataFile=D.createDataFile;F.FS_createPreloadedFile=D.createPreloadedFile;F.FS_createLazyFile=D.createLazyFile;F.FS_createLink=D.createLink;F.FS_createDevice=D.createDevice;F.FS_unlink=D.unlink;qg.unshift(function(){ye.init()});re.push(function(){ye.shutdown()});if(Bf){var cd=__webpack_require__(141),Li=__webpack_require__(142);Wc.staticInit()}Af(Td);Zh=se=ra.alignMemory(Se);pi=!0;vh=Zh+$h;ch=we=ra.alignMemory(vh);fb(ch<ld,"TOTAL_MEMORY not big enough for stack");
var ak=vc([8,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,6,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,7,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,6,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,
0,1,0,3,0,1,0,2,0,1,0],"i8",3);F.asmGlobalArg={Math:Math,Int8Array:Int8Array,Int16Array:Int16Array,Int32Array:Int32Array,Uint8Array:Uint8Array,Uint16Array:Uint16Array,Uint32Array:Uint32Array,Float32Array:Float32Array,Float64Array:Float64Array,NaN:NaN,Infinity:Infinity,byteLength:Kg};F.asmLibraryArg={abort:Vc,assert:fb,invoke_iiii:function(r,v,A,D){try{return F.dynCall_iiii(r,v,A,D)}catch(S){if("number"!==typeof S&&"longjmp"!==S)throw S;ab.setThrew(1,0)}},invoke_viiiiiii:function(r,v,A,D,S,aa,ca,ra){try{F.dynCall_viiiiiii(r,
v,A,D,S,aa,ca,ra)}catch(Ka){if("number"!==typeof Ka&&"longjmp"!==Ka)throw Ka;ab.setThrew(1,0)}},invoke_viiiii:function(r,v,A,D,S,aa){try{F.dynCall_viiiii(r,v,A,D,S,aa)}catch(ca){if("number"!==typeof ca&&"longjmp"!==ca)throw ca;ab.setThrew(1,0)}},invoke_vi:function(r,v){try{F.dynCall_vi(r,v)}catch(A){if("number"!==typeof A&&"longjmp"!==A)throw A;ab.setThrew(1,0)}},invoke_vii:function(r,v,A){try{F.dynCall_vii(r,v,A)}catch(D){if("number"!==typeof D&&"longjmp"!==D)throw D;ab.setThrew(1,0)}},invoke_iiiiiii:function(r,
v,A,D,S,aa,ca){try{return F.dynCall_iiiiiii(r,v,A,D,S,aa,ca)}catch(ra){if("number"!==typeof ra&&"longjmp"!==ra)throw ra;ab.setThrew(1,0)}},invoke_viiiiiiiiiiii:function(r,v,A,D,S,aa,ca,ra,Ka,fb,Lb,jc,Y){try{F.dynCall_viiiiiiiiiiii(r,v,A,D,S,aa,ca,ra,Ka,fb,Lb,jc,Y)}catch(Sb){if("number"!==typeof Sb&&"longjmp"!==Sb)throw Sb;ab.setThrew(1,0)}},invoke_ii:function(r,v){try{return F.dynCall_ii(r,v)}catch(A){if("number"!==typeof A&&"longjmp"!==A)throw A;ab.setThrew(1,0)}},invoke_viii:function(r,v,A,D){try{F.dynCall_viii(r,
v,A,D)}catch(S){if("number"!==typeof S&&"longjmp"!==S)throw S;ab.setThrew(1,0)}},invoke_viiiiiiiii:function(r,v,A,D,S,aa,ca,ra,Ka,fb){try{F.dynCall_viiiiiiiii(r,v,A,D,S,aa,ca,ra,Ka,fb)}catch(Lb){if("number"!==typeof Lb&&"longjmp"!==Lb)throw Lb;ab.setThrew(1,0)}},invoke_iiiii:function(r,v,A,D,S){try{return F.dynCall_iiiii(r,v,A,D,S)}catch(aa){if("number"!==typeof aa&&"longjmp"!==aa)throw aa;ab.setThrew(1,0)}},invoke_iii:function(r,v,A){try{return F.dynCall_iii(r,v,A)}catch(D){if("number"!==typeof D&&
"longjmp"!==D)throw D;ab.setThrew(1,0)}},invoke_iiiiii:function(r,v,A,D,S,aa){try{return F.dynCall_iiiiii(r,v,A,D,S,aa)}catch(ca){if("number"!==typeof ca&&"longjmp"!==ca)throw ca;ab.setThrew(1,0)}},invoke_viiii:function(r,v,A,D,S){try{F.dynCall_viiii(r,v,A,D,S)}catch(aa){if("number"!==typeof aa&&"longjmp"!==aa)throw aa;ab.setThrew(1,0)}},_pthread_cleanup_pop:function(){fb(ni.level==re.length,"cannot pop if something else added meanwhile!");re.pop();ni.level=re.length},_fabs:Uj,_exp:Yj,_llvm_pow_f64:Zj,
___syscall54:function(r,v){Ka.varargs=v;try{var A=Ka.getStreamFromFD(),F=Ka.get();switch(F){case 21505:return A.tty?0:-ca.ENOTTY;case 21506:return A.tty?0:-ca.ENOTTY;case 21519:if(!A.tty)return-ca.ENOTTY;var S=Ka.get();return Sb[S>>2]=0;case 21520:return A.tty?-ca.EINVAL:-ca.ENOTTY;case 21531:return S=Ka.get(),D.ioctl(A,F,S);default:Vc("bad ioctl syscall "+F)}}catch(aa){return"undefined"!==typeof D&&aa instanceof D.ErrnoError||Vc(aa),-aa.errno}},_pthread_cleanup_push:ni,___syscall6:function(r,v){Ka.varargs=
v;try{var A=Ka.getStreamFromFD();D.close(A);return 0}catch(F){return"undefined"!==typeof D&&F instanceof D.ErrnoError||Vc(F),-F.errno}},_atan2:Wj,___setErrNo:eg,___assert_fail:function(r,v,A,D){xe=!0;throw"Assertion failed: "+Yd(r)+", at: "+[v?Yd(v):"unknown filename",A,D?Yd(D):"unknown function"]+" at "+wf();},___buildEnvironment:Af,_longjmp:Zg,___syscall91:function(r,v){Ka.varargs=v;try{var A=Ka.get(),F=Ka.get(),S=Ka.mappings[A];if(!S)return 0;if(F===S.len){var aa=D.getStream(S.fd);Ka.doMsync(A,
aa,F,S.flags);D.munmap(aa);Ka.mappings[A]=null;S.allocated&&vf(S.malloc)}return 0}catch(ca){return"undefined"!==typeof D&&ca instanceof D.ErrnoError||Vc(ca),-ca.errno}},_emscripten_set_main_loop_timing:hj,_sbrk:og,___syscall192:function(r,v){Ka.varargs=v;try{var A=Ka.get(),F=Ka.get(),S=Ka.get(),aa=Ka.get(),ya=Ka.get(),ra=Ka.get(),ra=ra<<12,ab,fb=!1;if(-1===ya){ab=uf(F);if(!ab)return-ca.ENOMEM;Mi(ab,0,F);fb=!0}else{var Lb=D.getStream(ya);if(!Lb)return-ca.EBADF;var Sb=D.mmap(Lb,Od,A,F,ra,S,aa);ab=Sb.ptr;
fb=Sb.allocated}Ka.mappings[ab]={malloc:ab,len:F,allocated:fb,fd:ya,flags:aa};return ab}catch(Y){return"undefined"!==typeof D&&Y instanceof D.ErrnoError||Vc(Y),-Y.errno}},___syscall197:function(r,v){Ka.varargs=v;try{var A=Ka.getStreamFromFD(),F=Ka.get();return Ka.doStat(D.stat,A.path,F)}catch(S){return"undefined"!==typeof D&&S instanceof D.ErrnoError||Vc(S),-S.errno}},_emscripten_memcpy_big:function(r,v,A){Od.set(Od.subarray(v,v+A),r);return r},__exit:Qh,___syscall195:function(r,v){Ka.varargs=v;try{var A=
Ka.getStr(),F=Ka.get();return Ka.doStat(D.stat,A,F)}catch(S){return"undefined"!==typeof D&&S instanceof D.ErrnoError||Vc(S),-S.errno}},___syscall221:function(r,v){Ka.varargs=v;try{var A=Ka.getStreamFromFD();switch(Ka.get()){case 0:var F=Ka.get();return 0>F?-ca.EINVAL:D.open(A.path,A.flags,0,F).fd;case 1:case 2:return 0;case 3:return A.flags;case 4:return F=Ka.get(),A.flags|=F,0;case 12:case 12:return F=Ka.get(),gf[F+0>>1]=2,0;case 13:case 14:case 13:case 14:return 0;case 16:case 8:return-ca.EINVAL;
case 9:return eg(ca.EINVAL),-1;default:return-ca.EINVAL}}catch(S){return"undefined"!==typeof D&&S instanceof D.ErrnoError||Vc(S),-S.errno}},_floor:Oj,_pthread_self:function(){return 0},_getenv:Ig,_sqrt:Pj,_log:Tj,___unlock:function(){},_emscripten_set_main_loop:Oh,___syscall3:function(r,v){Ka.varargs=v;try{var A=Ka.getStreamFromFD(),F=Ka.get(),S=Ka.get();return D.read(A,Dd,F,S)}catch(aa){return"undefined"!==typeof D&&aa instanceof D.ErrnoError||Vc(aa),-aa.errno}},_sysconf:function(r){switch(r){case 30:return 4096;
case 85:return Pc/4096;case 132:case 133:case 12:case 137:case 138:case 15:case 235:case 16:case 17:case 18:case 19:case 20:case 149:case 13:case 10:case 236:case 153:case 9:case 21:case 22:case 159:case 154:case 14:case 77:case 78:case 139:case 80:case 81:case 82:case 68:case 67:case 164:case 11:case 29:case 47:case 48:case 95:case 52:case 51:case 46:return 200809;case 79:return 0;case 27:case 246:case 127:case 128:case 23:case 24:case 160:case 161:case 181:case 182:case 242:case 183:case 184:case 243:case 244:case 245:case 165:case 178:case 179:case 49:case 50:case 168:case 169:case 175:case 170:case 171:case 172:case 97:case 76:case 32:case 173:case 35:return-1;
case 176:case 177:case 7:case 155:case 8:case 157:case 125:case 126:case 92:case 93:case 129:case 130:case 131:case 94:case 91:return 1;case 74:case 60:case 69:case 70:case 4:return 1024;case 31:case 42:case 72:return 32;case 87:case 26:case 33:return 2147483647;case 34:case 1:return 47839;case 38:case 36:return 99;case 43:case 37:return 2048;case 0:return 2097152;case 3:return 65536;case 28:return 32768;case 44:return 32767;case 75:return 16384;case 39:return 1E3;case 89:return 700;case 71:return 256;
case 40:return 255;case 2:return 100;case 180:return 64;case 25:return 20;case 5:return 16;case 6:return 6;case 73:return 4;case 84:return"object"===typeof navigator?navigator.hardwareConcurrency||1:1}eg(ca.EINVAL);return-1},___lock:function(){},_abort:function(){F.abort()},___syscall5:function(r,v){Ka.varargs=v;try{var A=Ka.getStr(),F=Ka.get(),S=Ka.get();return D.open(A,F,S).fd}catch(aa){return"undefined"!==typeof D&&aa instanceof D.ErrnoError||Vc(aa),-aa.errno}},___syscall4:function(r,v){Ka.varargs=
v;try{var A=Ka.getStreamFromFD(),F=Ka.get(),S=Ka.get();return D.write(A,Dd,F,S)}catch(aa){return"undefined"!==typeof D&&aa instanceof D.ErrnoError||Vc(aa),-aa.errno}},_time:function(r){var v=Date.now()/1E3|0;r&&(Sb[r>>2]=v);return v},_emscripten_longjmp:function(r,v){Zg(r,v)},___syscall140:function(r,v){Ka.varargs=v;try{var A=Ka.getStreamFromFD(),F=Ka.get(),S=Ka.get(),aa=Ka.get(),ca=Ka.get();fb(0===F);D.llseek(A,S,ca);Sb[aa>>2]=A.position;A.getdents&&0===S&&0===ca&&(A.getdents=null);return 0}catch(ra){return"undefined"!==
typeof D&&ra instanceof D.ErrnoError||Vc(ra),-ra.errno}},_exit:function(r){Qh(r)},___syscall146:function(r,v){Ka.varargs=v;try{var A=Ka.getStreamFromFD(),F=Ka.get(),S=Ka.get();return Ka.doWritev(A,F,S)}catch(aa){return"undefined"!==typeof D&&aa instanceof D.ErrnoError||Vc(aa),-aa.errno}},STACKTOP:se,STACK_MAX:vh,tempDoublePtr:ai,ABORT:xe,cttz_i8:ak};var ab=function(r,v,A){function D(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y;e=u;u=u+16|0;f=e+4|0;g=e;h=d+2|0;switch(N[h>>1]|0){case 12:case 11:case 10:case 5:case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:break;
default:return u=e,2}m=ra(b,d,f,8,g)|0;g=d=a[g>>2]|0;if(0!=(m|0)|0==(d|0))return a[c>>2]=0,u=e,m|0;if(12==(w[h>>1]|0))return a[b+12>>2]&128&&Ae(d,a[f>>2]|0),a[c>>2]=g,u=e,0;g=a[f>>2]|0;f=eb(g<<3)|0;if(!f)return ja(d),u=e,7;do switch(N[h>>1]|0){case 1:if(g)for(m=d,k=f,l=0;!(Hb[k>>3]=+(x[m>>0]|0),l=l+1|0,l>>>0>=g>>>0);)m=m+1|0,k=k+8|0;break;case 6:if(g)for(k=d,m=f,l=0;!(Hb[m>>3]=+(t[k>>0]|0),l=l+1|0,l>>>0>=g>>>0);)k=k+1|0,m=m+8|0;break;case 3:if(g)for(m=b+12|0,k=d,l=f,n=0;!(a[m>>2]&128&&ac(k),Hb[l>>
3]=+(N[k>>1]|0),n=n+1|0,n>>>0>=g>>>0);)k=k+2|0,l=l+8|0;break;case 8:if(g)for(l=b+12|0,k=d,n=f,m=0;!(a[l>>2]&128&&ac(k),Hb[n>>3]=+(w[k>>1]|0),m=m+1|0,m>>>0>=g>>>0);)k=k+2|0,n=n+8|0;break;case 4:if(g)for(n=b+12|0,k=d,m=f,l=0;!(a[n>>2]&128&&pb(k),Hb[m>>3]=+((a[k>>2]|0)>>>0),l=l+1|0,l>>>0>=g>>>0);)k=k+4|0,m=m+8|0;break;case 9:if(g)for(m=b+12|0,k=d,l=f,n=0;!(a[m>>2]&128&&pb(k),Hb[l>>3]=+(a[k>>2]|0),n=n+1|0,n>>>0>=g>>>0);)k=k+4|0,l=l+8|0;break;case 16:if(g)for(l=b+12|0,k=d,n=f,m=0;!(a[l>>2]&128&&kc(k),
p=k,Hb[n>>3]=+((a[p>>2]|0)>>>0)+4294967296*+((a[p+4>>2]|0)>>>0),m=m+1|0,m>>>0>=g>>>0);)k=k+8|0,n=n+8|0;break;case 17:if(g)for(n=b+12|0,k=d,m=f,l=0;!(a[n>>2]&128&&kc(k),p=k,Hb[m>>3]=+((a[p>>2]|0)>>>0)+4294967296*+(a[p+4>>2]|0),l=l+1|0,l>>>0>=g>>>0);)k=k+8|0,m=m+8|0;break;case 5:if(g)for(m=b+12|0,k=d,l=f,n=0;!(p=a[m>>2]|0,p&128?(pb(k),q=a[m>>2]|0):q=p,p=k+4|0,y=a[k>>2]|0,q&128&&pb(p),y=(q=a[p>>2]|0)?+(y>>>0)/+(q>>>0):0,Hb[l>>3]=y,n=n+1|0,n>>>0>=g>>>0);)k=k+8|0,l=l+8|0;break;case 10:if(g)for(l=b+12|
0,k=d,n=f,m=0;!(q=a[l>>2]|0,q&128?(pb(k),p=a[l>>2]|0):p=q,q=a[k>>2]|0,y=k+4|0,p&128&&pb(y),y=(p=a[y>>2]|0)?+(q|0)/+(p>>>0):0,Hb[n>>3]=y,m=m+1|0,m>>>0>=g>>>0);)k=k+8|0,n=n+8|0;break;case 11:if(a[b+12>>2]&128&&Id(d,g),g)for(n=d,k=f,m=0;!(Hb[k>>3]=+W[n>>2],m=m+1|0,m>>>0>=g>>>0);)n=n+4|0,k=k+8|0}while(0);ja(d);a[c>>2]=f;u=e;return 0}function F(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m;f=u;u=u+16|0;if(g=ca(b,d,f)|0)return m=(h=Lf(b,N[d>>1]|0)|0)?a[h+28>>2]|0:133413,wh(b,g,134332,m,0),u=f,0;d=m=d+8|0;if(0==
(a[d+4>>2]|0)&&(a[d>>2]|0)==(c|0))b=a[f>>2]|0;else{d=Mf(b,c,8,134352)|0;if(!d)return ja(a[f>>2]|0),u=f,0;b=m;g=a[b>>2]|0;h=a[b+4>>2]|0;b=a[f>>2]|0;0>h>>>0|0==(h|0)&g>>>0<c>>>0?(Ab(d,b,g<<3),g=a[m>>2]|0,$c(d+(g<<3)|0,0,c-g<<3)):Ab(d,b,c<<3);ja(b);b=a[f>>2]=d}a[e>>2]=b;u=f;return 1}function S(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,H,t;e=u;u=u+16|0;f=b+176|0;(g=a[f>>2]|0)&&ja(g);g=b+168|0;h=Mf(b,a[g>>2]|0,8,134235)|0;a[f>>2]=h;if(!h)return u=e,-1;do if(1==(w[b+88>>1]|0))if(a[b+12>>2]&1024){if(h=
b,h|=0,m=Kf(h,a[h+72>>2]|0)|0,n=U,h=a[g>>2]|0){k=a[f>>2]|0;l=0;do p=k+(l<<3)|0,a[p>>2]=m,a[p+4>>2]=n,l=l+1|0;while(l>>>0<h>>>0)}}else{if(h=Td(b)|0,m=a[g>>2]|0){k=Cf(((a[b+60>>2]|0)>>>0)/((a[b+164>>2]|0)>>>0)|0,0,h|0,U|0)|0;h=U;l=a[f>>2]|0;n=0;do p=l+(n<<3)|0,a[p>>2]=k,a[p+4>>2]=h,n=n+1|0;while(n>>>0<m>>>0)}}else{h=b+628|0;l=da[a[b+648>>2]&63](a[h>>2]|0)|0;n=U;m=b+12|0;k=c&65535;p=0==(a[m>>2]&524288|0)?(12*k|0)+14|0:(20*k|0)+32|0;a:do{if(c<<16>>16){k=p;y=0;q=d;for(B=c;;){H=q+2|0;p=Ne(N[H>>1]|0)|0;
if(!p){b=H;break}H=q+8|0;t=Cf(a[H>>2]|0,a[H+4>>2]|0,p|0,0)|0;p=U;H=0==(a[m>>2]&524288|0)?0>p>>>0|0==(p|0)&5>t>>>0:0>p>>>0|0==(p|0)&9>t>>>0;y=Qb((H?0:t)|0,(H?0:p)|0,k|0,y|0)|0;p=U;B=B+-1<<16>>16;if(B<<16>>16)k=y,y=p,q=q+24|0;else{q=y;y=p;break a}}q=a[h>>2]|0;a[e>>2]=N[b>>1];Y(q,134263,134287,e);u=e;return-1}q=p;y=0}while(0);h=Ic(l|0,n|0,q|0,y|0)|0;m=U;2==(w[b+126>>1]|0)?(B=p=pf(h|0,m|0,N[b+98>>1]|0,0)|0,k=U):(B=h,k=m);m=a[g>>2]|0;h=a[f>>2]|0;if(m){p=1<m>>>0;q=0;do y=h+(q<<3)|0,a[y>>2]=B,a[y+4>>2]=
k,q=q+1|0;while(q>>>0<m>>>0);m=p?m+-1|0:0}else m=-1;q=(a[b+172>>2]|0)+(m<<3)|0;y=a[q>>2]|0;k=a[q+4>>2]|0;B=q=h+(m<<3)|0;p=Qb(a[B>>2]|0,a[B+4>>2]|0,y|0,k|0)|0;B=U;B>>>0>n>>>0|(B|0)==(n|0)&p>>>0>l>>>0&&(p=Ic(l|0,n|0,y|0,k|0)|0,k=q,a[k>>2]=p,a[k+4>>2]=U)}while(0);m=b+40|0;k=a[m>>2]|0;a[m>>2]=k|16777216;if(k&131072)return u=e,1;a[b+100>>2]=a[b+60>>2];u=e;return 1}function ca(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y=0;e=u;u=u+16|0;f=e+4|0;g=e;h=d+2|0;switch(N[h>>1]|0){case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:break;
default:return u=e,2}m=ra(b,d,f,8,g)|0;g=d=a[g>>2]|0;if(0!=(m|0)|0==(d|0))return a[c>>2]=0,u=e,m|0;switch(N[h>>1]|0){case 16:a[c>>2]=d;if(!(a[b+12>>2]&128)){u=e;break}Ae(d,a[f>>2]|0);u=e;break;case 17:m=a[f>>2]|0;a:do if(m){k=b+12|0;l=d;for(n=0;;){a[k>>2]&128&&kc(l);p=l;q=a[p+4>>2]|0;if(!(-1<(q|0)|-1==(q|0)&4294967295<(a[p>>2]|0)>>>0))break;n=n+1|0;if(n>>>0>=m>>>0)break a;else l=l+8|0}ja(d);u=e;return 4}while(0);a[c>>2]=g;u=e;break;default:g=a[f>>2]|0;f=eb(g<<3)|0;if(!f)return ja(d),u=e,7;a:do switch(N[h>>
1]|0){case 1:if(g)for(m=d,l=f,n=0;;)if(k=l,a[k>>2]=x[m>>0],a[k+4>>2]=0,n=n+1|0,n>>>0>=g>>>0){m=46;break}else m=m+1|0,l=l+8|0;else m=46;break;case 6:if(g)for(l=d,m=f,n=0;;){k=t[l>>0]|0;if(-1>=k<<24>>24){y=4;m=45;break a}p=k<<24>>24;k=m;a[k>>2]=p;a[k+4>>2]=(0>(p|0))<<31>>31;n=n+1|0;if(n>>>0>=g>>>0){m=46;break}else l=l+1|0,m=m+8|0}else m=46;break;case 3:if(g)for(m=b+12|0,l=d,n=f,p=0;;)if(a[m>>2]&128&&ac(l),k=n,a[k>>2]=N[l>>1],a[k+4>>2]=0,p=p+1|0,p>>>0>=g>>>0){m=46;break}else l=l+2|0,n=n+8|0;else m=46;
break;case 8:if(g)for(n=b+12|0,l=d,p=f,m=0;;){a[n>>2]&128&&ac(l);k=w[l>>1]|0;if(-1>=k<<16>>16){y=4;m=45;break a}q=k<<16>>16;k=p;a[k>>2]=q;a[k+4>>2]=(0>(q|0))<<31>>31;m=m+1|0;if(m>>>0>=g>>>0){m=46;break}else l=l+2|0,p=p+8|0}else m=46;break;case 4:if(g)for(p=b+12|0,l=d,m=f,n=0;;)if(a[p>>2]&128&&pb(l),q=m,a[q>>2]=a[l>>2],a[q+4>>2]=0,n=n+1|0,n>>>0>=g>>>0){m=46;break}else l=l+4|0,m=m+8|0;else m=46;break;case 9:if(g)for(m=b+12|0,l=d,n=f,p=0;;){a[m>>2]&128&&pb(l);q=a[l>>2]|0;if(k=q>>31&4){y=k;m=45;break a}k=
n;a[k>>2]=q;a[k+4>>2]=(0>(q|0))<<31>>31;p=p+1|0;if(p>>>0>=g>>>0){m=46;break}else l=l+4|0,n=n+8|0}else m=46;break;default:m=46}while(0);if(45==(m|0))return ja(d),ja(f),u=e,y|0;46==(m|0)&&(ja(d),a[c>>2]=f,u=e)}return 0}function ra(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p;g=u;u=u+16|0;h=g+8|0;m=Ne(N[d+2>>1]|0)|0;k=d+8|0;l=a[k>>2]|0;n=a[k+4>>2]|0;if(0==(m|0)|0==(l|0)&0==(n|0))return a[f>>2]=0,u=g,0;k=2147483647/(m|0)|0;p=(0>(k|0))<<31>>31;if(p>>>0<n>>>0|(p|0)==(n|0)&k>>>0<l>>>0||0<n>>>0|
(0==(n|0)?(2147483647/(e>>>0)|0)>>>0<l>>>0:0))return u=g,6;a[c>>2]=l;c=E(l,m)|0;0>=(c|0)&&Z(134368,133171,790,134389);e=Mf(b,l,m,134411)|0;if(!e)return u=g,7;m=b+12|0;l=a[m>>2]|0;do if(l&524288)if(9>c>>>0)Ab(e,d+16|0,c);else{k=d+16|0;n=a[k>>2]|0;p=a[k+4>>2]|0;k=g;a[k>>2]=n;a[k+4>>2]=p;l&128?(kc(g),p=g,k=a[m>>2]|0,h=a[p>>2]|0,d=a[p+4>>2]|0):(k=l,h=n,d=p);if(k&2048){if(p=h+c|0,p>>>0<c>>>0|(h|0)!=(h|0)|0!=(d|0)|p>>>0<h>>>0?0:p>>>0<=(a[b+616>>2]|0)>>>0){Ab(e,(a[b+612>>2]|0)+h|0,c);break}}else if(p=b+
628|0,n=rb[a[b+640>>2]&63](a[p>>2]|0,h,d,0)|0,(n|0)==(h|0)&(U|0)==(d|0)&&(Aa[a[b+632>>2]&63](a[p>>2]|0,e,c)|0)==(c|0))break;ja(e);b=3;u=g;return b|0}else if(n=d+16|0,5>c>>>0)Ab(e,n,c);else{k=a[n>>2]|0;a[h>>2]=k;l&128?(pb(h),n=a[m>>2]|0,p=a[h>>2]|0):(n=l,p=k);if(n&2048){if(k=p+c|0,k>>>0<c>>>0|k>>>0<p>>>0?0:k>>>0<=(a[b+616>>2]|0)>>>0){Ab(e,(a[b+612>>2]|0)+p|0,c);break}}else if(k=b+628|0,n=rb[a[b+640>>2]&63](a[k>>2]|0,p,0,0)|0,(n|0)==(p|0)&0==(U|0)&&(Aa[a[b+632>>2]&63](a[k>>2]|0,e,c)|0)==(c|0))break;
ja(e);b=3;u=g;return b|0}while(0);a[f>>2]=e;u=g;return 0}function Ka(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B;e=u;u=u+16|0;f=e+4|0;g=d+2|0;switch(N[g>>1]|0){case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:case 7:case 2:break;default:return u=e,2}h=ra(b,d,f,1,e)|0;m=d=a[e>>2]|0;if(0!=(h|0)|0==(d|0))return a[c>>2]=0,u=e,h|0;switch(N[g>>1]|0){case 1:case 7:case 2:a[c>>2]=m;u=e;break;case 6:h=a[f>>2]|0;a:do if(h){k=d;for(l=0;!(-1>=(t[k>>0]|0));)if(l=l+1|0,l>>>0>=h>>>0)break a;else k=
k+1|0;ja(d);u=e;return 4}while(0);a[c>>2]=m;u=e;break;default:m=a[f>>2]|0;h=eb(m)|0;if(!h)return ja(d),u=e,7;a:do switch(N[g>>1]|0){case 3:if(m)for(k=b+12|0,l=d,n=h,p=0;;){a[k>>2]&128&&ac(l);q=w[l>>1]|0;if(256<=(q&65535)){k=50;break a}t[n>>0]=q;p=p+1|0;if(p>>>0>=(a[f>>2]|0)>>>0){k=51;break}else l=l+2|0,n=n+1|0}else k=51;break;case 8:if(m)for(n=b+12|0,l=d,p=h,k=0;;){a[n>>2]&128&&ac(l);q=w[l>>1]|0;if(256<=(q&65535)){k=50;break a}t[p>>0]=q;k=k+1|0;if(k>>>0>=(a[f>>2]|0)>>>0){k=51;break}else l=l+2|0,p=
p+1|0}else k=51;break;case 4:if(m)for(p=b+12|0,l=d,k=h,n=0;;){a[p>>2]&128&&pb(l);q=a[l>>2]|0;if(256<=q>>>0){k=50;break a}t[k>>0]=q;n=n+1|0;if(n>>>0>=(a[f>>2]|0)>>>0){k=51;break}else l=l+4|0,k=k+1|0}else k=51;break;case 9:if(m)for(k=b+12|0,l=d,n=h,p=0;;){a[k>>2]&128&&pb(l);q=a[l>>2]|0;if(256<=q>>>0){k=50;break a}t[n>>0]=q;p=p+1|0;if(p>>>0>=(a[f>>2]|0)>>>0){k=51;break}else l=l+4|0,n=n+1|0}else k=51;break;case 16:if(m)for(n=b+12|0,l=d,p=h,k=0;;){a[n>>2]&128&&kc(l);q=l;y=a[q>>2]|0;B=a[q+4>>2]|0;if(!(0>
B>>>0|0==(B|0)&256>y>>>0)){k=50;break a}t[p>>0]=y;k=k+1|0;if(k>>>0>=(a[f>>2]|0)>>>0){k=51;break}else l=l+8|0,p=p+1|0}else k=51;break;case 17:if(m)for(p=b+12|0,l=d,k=h,n=0;;){a[p>>2]&128&&kc(l);y=l;B=a[y>>2]|0;q=a[y+4>>2]|0;if(!(0>q>>>0|0==(q|0)&256>B>>>0)){k=50;break a}t[k>>0]=B;n=n+1|0;if(n>>>0>=(a[f>>2]|0)>>>0){k=51;break}else l=l+8|0,k=k+1|0}else k=51;break;default:k=51}while(0);if(50==(k|0))return ja(a[e>>2]|0),ja(h),u=e,4;51==(k|0)&&(ja(a[e>>2]|0),a[c>>2]=h,u=e)}return 0}function ab(b,d,c){b|=
0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B;e=u;u=u+16|0;f=e+4|0;g=e;h=d+2|0;switch(N[h>>1]|0){case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:break;default:return u=e,2}m=ra(b,d,f,4,g)|0;g=d=a[g>>2]|0;if(0!=(m|0)|0==(d|0))return a[c>>2]=0,u=e,m|0;switch(N[h>>1]|0){case 4:a[c>>2]=d;if(!(a[b+12>>2]&128)){u=e;break}Id(d,a[f>>2]|0);u=e;break;case 9:m=a[f>>2]|0;a:do if(m){k=b+12|0;l=d;for(n=0;;){a[k>>2]&128&&pb(l);if(p=a[l>>2]>>31&4){q=p;break}n=n+1|0;if(n>>>0>=m>>>0)break a;else l=l+4|0}ja(d);
b=q;u=e;return b|0}while(0);a[c>>2]=g;u=e;break;default:g=a[f>>2]|0;q=eb(g<<2)|0;if(!q)return ja(d),u=e,7;a:do switch(N[h>>1]|0){case 1:if(g)for(m=d,l=q,n=0;;)if(a[l>>2]=x[m>>0],n=n+1|0,n>>>0>=(a[f>>2]|0)>>>0){m=47;break}else m=m+1|0,l=l+4|0;else m=47;break;case 6:if(g)for(l=d,m=q,n=0;;){k=t[l>>0]|0;if(-1>=k<<24>>24){m=46;break a}a[m>>2]=k<<24>>24;n=n+1|0;if(n>>>0>=(a[f>>2]|0)>>>0){m=47;break}else l=l+1|0,m=m+4|0}else m=47;break;case 3:if(g)for(m=b+12|0,l=d,n=q,k=0;;)if(a[m>>2]&128&&ac(l),a[n>>2]=
N[l>>1],k=k+1|0,k>>>0>=(a[f>>2]|0)>>>0){m=47;break}else l=l+2|0,n=n+4|0;else m=47;break;case 8:if(g)for(n=b+12|0,l=d,k=q,m=0;;){a[n>>2]&128&&ac(l);p=w[l>>1]|0;if(-1>=p<<16>>16){m=46;break a}a[k>>2]=p<<16>>16;m=m+1|0;if(m>>>0>=(a[f>>2]|0)>>>0){m=47;break}else l=l+2|0,k=k+4|0}else m=47;break;case 16:if(g)for(k=b+12|0,l=d,m=q,n=0;;){a[k>>2]&128&&kc(l);p=l;y=a[p>>2]|0;B=a[p+4>>2]|0;if(!(1>B>>>0|1==(B|0)&0>y>>>0)){m=46;break a}a[m>>2]=y;n=n+1|0;if(n>>>0>=(a[f>>2]|0)>>>0){m=47;break}else l=l+8|0,m=m+4|
0}else m=47;break;case 17:if(g)for(m=b+12|0,l=d,n=q,k=0;;){a[m>>2]&128&&kc(l);y=l;B=a[y>>2]|0;p=a[y+4>>2]|0;if(!(1>p>>>0|1==(p|0)&0>B>>>0)){m=46;break a}a[n>>2]=B;k=k+1|0;if(k>>>0>=(a[f>>2]|0)>>>0){m=47;break}else l=l+8|0,n=n+4|0}else m=47;break;default:m=47}while(0);if(46==(m|0))return ja(d),ja(q),u=e,4;47==(m|0)&&(ja(d),a[c>>2]=q,u=e)}return 0}function fb(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y;e=u;u=u+16|0;f=e+4|0;g=e;h=d+2|0;switch(N[h>>1]|0){case 12:case 11:case 10:case 5:case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:break;
default:return u=e,2}m=ra(b,d,f,4,g)|0;g=d=a[g>>2]|0;if(0!=(m|0)|0==(d|0))return a[c>>2]=0,u=e,m|0;if(11==(w[h>>1]|0))return a[b+12>>2]&128&&Id(d,a[f>>2]|0),a[c>>2]=g,u=e,0;g=a[f>>2]|0;f=eb(g<<2)|0;if(!f)return ja(d),u=e,7;do switch(N[h>>1]|0){case 1:if(g)for(m=d,k=f,l=0;!(W[k>>2]=+(x[m>>0]|0),l=l+1|0,l>>>0>=g>>>0);)m=m+1|0,k=k+4|0;break;case 6:if(g)for(k=d,m=f,l=0;!(W[m>>2]=+(t[k>>0]|0),l=l+1|0,l>>>0>=g>>>0);)k=k+1|0,m=m+4|0;break;case 3:if(g)for(m=b+12|0,k=d,l=f,n=0;!(a[m>>2]&128&&ac(k),W[l>>2]=
+(N[k>>1]|0),n=n+1|0,n>>>0>=g>>>0);)k=k+2|0,l=l+4|0;break;case 8:if(g)for(l=b+12|0,k=d,n=f,m=0;!(a[l>>2]&128&&ac(k),W[n>>2]=+(w[k>>1]|0),m=m+1|0,m>>>0>=g>>>0);)k=k+2|0,n=n+4|0;break;case 4:if(g)for(n=b+12|0,k=d,m=f,l=0;!(a[n>>2]&128&&pb(k),W[m>>2]=+((a[k>>2]|0)>>>0),l=l+1|0,l>>>0>=g>>>0);)k=k+4|0,m=m+4|0;break;case 9:if(g)for(m=b+12|0,k=d,l=f,n=0;!(a[m>>2]&128&&pb(k),W[l>>2]=+(a[k>>2]|0),n=n+1|0,n>>>0>=g>>>0);)k=k+4|0,l=l+4|0;break;case 16:if(g)for(l=b+12|0,k=d,n=f,m=0;!(a[l>>2]&128&&kc(k),p=k,W[n>>
2]=+((a[p>>2]|0)>>>0)+4294967296*+((a[p+4>>2]|0)>>>0),m=m+1|0,m>>>0>=g>>>0);)k=k+8|0,n=n+4|0;break;case 17:if(g)for(n=b+12|0,k=d,m=f,l=0;!(a[n>>2]&128&&kc(k),p=k,W[m>>2]=+((a[p>>2]|0)>>>0)+4294967296*+(a[p+4>>2]|0),l=l+1|0,l>>>0>=g>>>0);)k=k+8|0,m=m+4|0;break;case 5:if(g)for(m=b+12|0,k=d,l=f,n=0;!(p=a[m>>2]|0,p&128?(pb(k),q=a[m>>2]|0):q=p,p=k+4|0,y=a[k>>2]|0,q&128&&pb(p),y=(q=a[p>>2]|0)?+(y>>>0)/+(q>>>0):0,W[l>>2]=y,n=n+1|0,n>>>0>=g>>>0);)k=k+8|0,l=l+4|0;break;case 10:if(g)for(l=b+12|0,k=d,n=f,m=
0;!(q=a[l>>2]|0,q&128?(pb(k),p=a[l>>2]|0):p=q,q=a[k>>2]|0,y=k+4|0,p&128&&pb(y),y=(p=a[y>>2]|0)?+(q|0)/+(p>>>0):0,W[n>>2]=y,m=m+1|0,m>>>0>=g>>>0);)k=k+8|0,n=n+4|0;break;case 12:if(a[b+12>>2]&128&&Ae(d,g),g)for(n=d,k=f,m=0;!(W[k>>2]=+Hb[n>>3],m=m+1|0,m>>>0>=g>>>0);)n=n+8|0,k=k+4|0}while(0);ja(d);a[c>>2]=f;u=e;return 0}function Lb(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l;e=u;u=u+16|0;f=e+4|0;g=e;h=d+2|0;switch(N[h>>1]|0){case 18:case 13:case 16:case 4:break;default:return u=e,2}m=ra(b,d,f,8,g)|0;d=a[g>>
2]|0;if(0!=(m|0)|0==(d|0))return a[c>>2]=0,u=e,m|0;switch(N[h>>1]|0){case 18:case 16:a[c>>2]=d;if(!(a[b+12>>2]&128))return u=e,0;Ae(d,a[f>>2]|0);u=e;return 0}m=a[f>>2]|0;f=eb(m<<3)|0;if(!f)return ja(d),u=e,7;switch(N[h>>1]|0){case 13:case 4:if(m)for(h=b+12|0,b=d,g=f,k=0;!(a[h>>2]&128&&pb(b),l=g,a[l>>2]=a[b>>2],a[l+4>>2]=0,k=k+1|0,k>>>0>=m>>>0);)b=b+4|0,g=g+8|0}ja(d);a[c>>2]=f;u=e;return 0}function Y(b,d,c,e){b|=0;d|=0;c|=0;var f;f=u;u=u+16|0;a[f>>2]=e|0;if(e=a[1934]|0)td[e&127](d,c,f);if(e=a[1910]|
0)Ud[e&31](b,d,c,f);u=f}function Sb(b){b|=0;var d,c,e,f,g,h,m,k,l;d=u;u=u+48|0;c=d+24|0;e=d+16|0;f=d+8|0;g=d+32|0;h=d+28|0;m=b+8|0;if(!(a[m>>2]|0))return u=d,1;k=b+12|0;l=a[k>>2]|0;if(l&64)if((0==(l&4096|0)||(a[k>>2]=l&-4097,0!=(da[a[b+528>>2]&63](b)|0)))&&Lc(b)|0)l=a[k>>2]|0;else return u=d,0;if(2097152==(l&2097160|0)&&2==(a[m>>2]|0))if(a[g>>2]=0,a[h>>2]=0,cd(b)|0){if(a[d>>2]=g,Pd(b,324,d)|0&&(a[f>>2]=h,Pd(b,325,f)|0&&(l=b+168|0,Ni(b,324,16,a[l>>2]|0,a[g>>2]|0)|0&&Ni(b,325,16,a[l>>2]|0,a[h>>2]|0)|
0)))return a[k>>2]&=-2097217,u=d,1}else if(a[e>>2]=g,Pd(b,273,e)|0&&(a[c>>2]=h,Pd(b,279,c)|0&&(l=b+168|0,Ni(b,273,16,a[l>>2]|0,a[g>>2]|0)|0&&Ni(b,279,16,a[l>>2]|0,a[h>>2]|0)|0)))return a[k>>2]&=-2097217,u=d,1;if(0!=(a[k>>2]&2097160|0)&&0==(Fj(b)|0))return u=d,0;u=d;return 1}function jc(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,Ra,V;c=u;u=u+160|0;e=c+136|0;f=c+120|0;g=c+112|0;h=c+104|0;m=c+88|0;k=c+80|0;l=c+72|0;n=c+64|0;p=c+56|0;q=c+48|0;y=c+24|0;B=c+16|0;H=c+8|0;ka=c;z=c+146|0;Q=c+
144|0;if(!(a[b+500>>2]|0)){C=d;Ra=135926;e=C+54|0;do t[C>>0]=t[Ra>>0]|0,C=C+1|0,Ra=Ra+1|0;while((C|0)<(e|0));u=c;return 0}Ra=b+84|0;C=N[Ra>>1]|0;switch(C|0){case 16:case 8:case 4:case 2:case 1:break;default:return a[ka>>2]=C,ad(d,135980,ka)|0,u=c,0}ka=b+98|0;C=(N[ka>>1]|0)-(N[b+156>>1]|0)|0;a[H>>2]=z;a:do if(Pd(b,262,H)|0)V=w[z>>1]|0;else switch(C|0){case 1:V=w[z>>1]=1;break a;case 3:V=w[z>>1]=2;break a;default:return a[B>>2]=130805,ad(d,136029,B)|0,C=0,u=c,C|0}while(0);z=V&65535;a:do{if(5>(z|0)){switch(z|
0){case 3:case 1:case 0:break;case 2:if(3<=(C|0))return C=1,u=c,C|0;a[q>>2]=136187;a[q+4>>2]=C;ad(d,136144,q)|0;C=0;u=c;return C|0;default:break a}if(1!=(w[b+126>>1]|0))return C=1,u=c,C|0;V=w[ka>>1]|0;if(1==V<<16>>16)return C=1,u=c,C|0;B=w[Ra>>1]|0;if(8<=(B&65535))return C=1,u=c,C|0;a[y>>2]=130805;a[y+4>>2]=z;a[y+8>>2]=136130;a[y+12>>2]=V&65535;a[y+16>>2]=B&65535;ad(d,136051,y)|0}else{if(8>(z|0)){switch(z|0){case 5:break;case 6:return C=1,u=c,C|0;default:break a}a[p>>2]=Q;ne(b,332,p)|0;B=w[Q>>1]|
0;if(1!=B<<16>>16)return a[n>>2]=136251,a[n+4>>2]=B&65535,ad(d,136202,n)|0,C=0,u=c,C|0;B=w[ka>>1]|0;if(4<=(B&65535))return C=1,u=c,C|0;a[l>>2]=136130;a[l+4>>2]=B&65535;ad(d,136202,l)|0;C=0;u=c;return C|0}if(32844>(z|0)){switch(z|0){case 8:break;default:break a}B=w[ka>>1]|0;V=w[Ra>>1]|0;if(3==B<<16>>16&8==V<<16>>16)return C=1,u=c,C|0;a[f>>2]=136130;a[f+4>>2]=B&65535;a[f+8>>2]=136499;a[f+12>>2]=V&65535;ad(d,136450,f)|0;C=0;u=c;return C|0}switch(z|0){case 32844:if(-30860==(w[b+88>>1]|0))return C=1,u=
c,C|0;a[k>>2]=136291;a[k+4>>2]=34676;ad(d,136258,k)|0;C=0;u=c;return C|0;case 32845:break;default:break a}if(-30860!=(w[b+88>>1]&-2)<<16>>16)return a[m>>2]=136291,a[m+4>>2]=34676,a[m+8>>2]=34677,ad(d,136303,m)|0,C=0,u=c,C|0;V=w[b+126>>1]|0;if(1!=V<<16>>16)return a[h>>2]=136391,a[h+4>>2]=V&65535,ad(d,136344,h)|0,C=0,u=c,C|0;V=w[ka>>1]|0;if(3==V<<16>>16)return C=1,u=c,C|0;a[g>>2]=136130;a[g+4>>2]=V&65535;ad(d,136411,g)|0}C=0;u=c;return C|0}while(0);a[e>>2]=130805;a[e+4>>2]=z;ad(d,136411,e)|0;u=c;return 0}
function lc(b,d,c,e){b|=0;d|=0;e|=0;var f,g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,Ra,V,Ed,r,x,G,L,K,v,fd,O,M,T,X,P,Oa,A,D,ba,F,Te,R,ga,Ha,ma,bc,ha,U,S,pc,Nb,da,fa,oa,sa,Kc,ua,Ia,Da,na,Na,hf=0,Ca=0,Ga,Ea,La,ca=0,aa,dh=0,ya,xb,Aa,ra=0,jb,mc,pa,Ta,Ya,Sa,mb=0,Db,cc,Za,ia,qa,Ja,ea,wa=0,Ma,xa,$a,la;f=u;u=u+384|0;g=f+344|0;h=f+336|0;m=f+328|0;k=f+320|0;l=f+312|0;n=f+296|0;p=f+288|0;q=f+280|0;y=f+272|0;B=f+264|0;H=f+256|0;ka=f+248|0;z=f+240|0;Q=f+224|0;C=f+216|0;Ra=f+208|0;V=f+200|0;Ed=f+192|0;r=f+176|0;x=f+168|0;
G=f+160|0;L=f+152|0;K=f+144|0;v=f+136|0;fd=f+128|0;O=f+120|0;M=f+96|0;T=f+80|0;X=f+72|0;P=f+64|0;Oa=f+56|0;A=f+48|0;D=f+40|0;ba=f+32|0;F=f+24|0;Te=f+16|0;R=f+8|0;ga=f;Ha=f+364|0;ma=f+374|0;bc=f+372|0;ha=f+370|0;U=f+360|0;S=f+356|0;pc=f+352|0;Nb=f+368|0;a[b+84>>2]=0;a[b+88>>2]=0;da=b+36|0;a[da>>2]=0;fa=b+40|0;a[fa>>2]=0;oa=b+44|0;a[oa>>2]=0;w[b+30>>1]=4;a[b>>2]=d;a[b+4>>2]=c|0;c=b+24|0;a[ga>>2]=c;ne(d,258,ga)|0;ga=N[c>>1]|0;a:do switch(ga|0){case 16:case 8:case 4:case 2:case 1:sa=b+12|0;a[sa>>2]=0;
Kc=b+26|0;a[Te>>2]=Kc;ne(d,277,Te)|0;a[F>>2]=ma;a[F+4>>2]=Ha;ne(d,338,F)|0;b:do if(w[ma>>1]|0){ua=N[a[Ha>>2]>>1]|0;switch(ua|0){case 0:break;case 2:case 1:a[sa>>2]=ua;break b;default:break b}3<(N[Kc>>1]|0)&&(a[sa>>2]=1)}while(0);ua=b+32|0;a[ba>>2]=ua;Pd(d,262,ba)|0||(w[ua>>1]=0);Ia=w[ma>>1]|0;Da=w[Kc>>1]|0;Ia<<16>>16?(na=Da,Na=Ia):4==Da<<16>>16?2==(w[ua>>1]|0)?(a[sa>>2]=1,w[ma>>1]=1,na=4,Na=1):(na=4,Na=0):(na=Da,Na=0);Ia=(na&65535)-(Na&65535)|0;a[D>>2]=ha;ne(d,259,D)|0;a[A>>2]=bc;ne(d,284,A)|0;a[Oa>>
2]=ua;b:do if(Pd(d,262,Oa)|0)Ca=w[ua>>1]|0;else switch(Ia|0){case 1:a[P>>2]=Oa;Pd(d,259,P)|0;Da=w[Oa>>1]|0;c:do if(3>Da<<16>>16)if(2>Da<<16>>16)switch(Da<<16>>16){case -32765:hf=18;break c;default:hf=19;break c}else switch(Da<<16>>16){case 2:hf=18;break c;default:hf=19;break c}else switch(Da<<16>>16){case 4:case 3:hf=18;break;default:hf=19}while(0);if(18==(hf|0)){Ca=w[ua>>1]=0;break b}else if(19==(hf|0)){Ca=w[ua>>1]=1;break b}break;case 3:Ca=w[ua>>1]=2;break b;default:a[X>>2]=130805;ad(e,136029,X)|
0;break a}while(0);Da=Ca&65535;b:do if(5>(Da|0)){switch(Da|0){case 3:hf=23;break;case 1:case 0:break;case 2:if(3<=(Ia|0))break b;a[fd>>2]=136187;a[fd+4>>2]=Ia;ad(e,136144,fd)|0;break a;default:hf=49;break b}do if(23==(hf|0)){a[T>>2]=U;a[T+4>>2]=S;a[T+8>>2]=pc;if(!(Pd(d,320,T)|0)){Ga=e;Ea=136511;La=Ga+32|0;do t[Ga>>0]=t[Ea>>0]|0,Ga=Ga+1|0,Ea=Ea+1|0;while((Ga|0)<(La|0));break a}ca=2<<N[c>>1];aa=eb(ca)|0;a[da>>2]=aa;aa=eb(ca)|0;a[fa>>2]=aa;aa=eb(ca)|0;a[oa>>2]=aa;dh=a[da>>2]|0;if(0==(dh|0)||0==(aa|0)|
0==(a[fa>>2]|0)){Ga=e;Ea=136543;La=Ga+32|0;do t[Ga>>0]=t[Ea>>0]|0,Ga=Ga+1|0,Ea=Ea+1|0;while((Ga|0)<(La|0));break a}else Ab(dh,a[U>>2]|0,ca),Ab(a[fa>>2]|0,a[S>>2]|0,ca),Ab(a[oa>>2]|0,a[pc>>2]|0,ca)}while(0);if(1==(w[bc>>1]|0)&&(ca=w[Kc>>1]|0,dh=ca&65535,1!=ca<<16>>16)&&(ca=w[c>>1]|0,8>(ca&65535))){aa=N[ua>>1]|0;a[M>>2]=130805;a[M+4>>2]=aa;a[M+8>>2]=136130;a[M+12>>2]=dh;a[M+16>>2]=ca&65535;ad(e,136051,M)|0;break a}}else{if(8>(Da|0)){switch(Da|0){case 6:if(!(1==(w[bc>>1]|0)&7==(w[ha>>1]|0)))break b;
a[O>>2]=1;lb(d,65538,O)|0;w[ua>>1]=2;break b;case 5:break;default:hf=49;break b}a[v>>2]=Nb;ne(d,332,v)|0;ca=w[Nb>>1]|0;if(1!=ca<<16>>16){a[K>>2]=136251;a[K+4>>2]=ca&65535;ad(e,136202,K)|0;break a}ca=w[Kc>>1]|0;if(4<=(ca&65535))break;a[L>>2]=136130;a[L+4>>2]=ca&65535;ad(e,136202,L)|0;break a}if(32844>(Da|0))switch(Da|0){case 8:break b;default:hf=49;break b}switch(Da|0){case 32844:if(-30860==(w[ha>>1]|0)){a[x>>2]=3;lb(d,65560,x)|0;w[ua>>1]=1;w[c>>1]=8;break b}else{a[G>>2]=136291;a[G+4>>2]=34676;ad(e,
136258,G)|0;break a}case 32845:break;default:hf=49;break b}if(-30860!=(w[ha>>1]&-2)<<16>>16){a[r>>2]=136291;a[r+4>>2]=34676;a[r+8>>2]=34677;ad(e,136303,r)|0;break a}ca=w[bc>>1]|0;if(1==ca<<16>>16)a[V>>2]=3,lb(d,65560,V)|0,w[ua>>1]=2,w[c>>1]=8;else return a[Ed>>2]=136391,a[Ed+4>>2]=ca&65535,ad(e,136344,Ed)|0,ya=0,u=f,ya|0}while(0);if(49==(hf|0)){a[Ra>>2]=130805;a[Ra+4>>2]=Da;ad(e,136411,Ra)|0;break a}Ia=b+56|0;ca=b+72|0;dh=b+76|0;aa=b+80|0;a[Ia>>2]=0;a[Ia+4>>2]=0;a[Ia+8>>2]=0;a[Ia+12>>2]=0;a[Ia+16>>
2]=0;a[Ia+20>>2]=0;a[Ia+24>>2]=0;a[C>>2]=b+16;Pd(d,256,C)|0;a[Q>>2]=b+20;Pd(d,257,Q)|0;a[z>>2]=b+28;ne(d,274,z)|0;if(2==(w[bc>>1]|0)){if(xb=2>(N[Kc>>1]|0),a[b+8>>2]=xb&1,!xb){xb=0!=(cd(a[b>>2]|0)|0);Aa=b+48|0;a[Aa>>2]=xb?3:4;xb=b+52|0;a[xb>>2]=0;b:do switch(N[ua>>1]|0){case 2:case 1:case 0:switch(N[c>>1]|0){case 8:switch(a[sa>>2]|0){case 1:a[xb>>2]=1;break b;case 2:a[dh>>2]|0&&Z(136575,136593,2728,136608);ra=eb(65536)|0;if(a[dh>>2]=ra)jb=0,mc=ra;else{Y(a[(a[b>>2]|0)+628>>2]|0,136608,150005,l);break b}for(;;){ra=
0;for(pa=mc;Ta=((((E(ra,jb)|0)+127|0)>>>0)/255|0)&255,t[pa>>0]=Ta,ra=ra+1|0,256!=(ra|0);)pa=pa+1|0;jb=jb+1|0;if(256==(jb|0))break;else mc=mc+256|0}a[xb>>2]=2;break b;default:a[xb>>2]=3;break b}case 16:break;default:break b}pa=a[sa>>2]|0;if(1==(pa|0)){a[aa>>2]|0&&Z(136623,136593,2750,136648);ra=eb(65536)|0;if(a[aa>>2]=ra)Ya=ra,Sa=0;else{Y(a[(a[b>>2]|0)+628>>2]|0,136648,150005,k);break b}for(;t[Ya>>0]=((Sa+128|0)>>>0)/257|0,Sa=Sa+1|0,65536!=(Sa|0);)Ya=Ya+1|0;a[xb>>2]=4;break b}ra=2==(pa|0);a[aa>>2]|
0&&Z(136623,136593,2750,136648);Ta=eb(65536)|0;if(a[aa>>2]=Ta)for(Db=Ta,Ta=0;;)if(t[Db>>0]=((Ta+128|0)>>>0)/257|0,Ta=Ta+1|0,65536==(Ta|0)){mb=1;break}else Db=Db+1|0;else Y(a[(a[b>>2]|0)+628>>2]|0,136648,150005,m),mb=0;if(!ra){if(!mb)break b;a[xb>>2]=6;break b}if(mb){a[dh>>2]|0&&Z(136575,136593,2728,136608);Db=eb(65536)|0;if(a[dh>>2]=Db)cc=0,Za=Db;else{Y(a[(a[b>>2]|0)+628>>2]|0,136608,150005,h);break b}for(;;){Db=0;for(Ta=Za;pa=((((E(Db,cc)|0)+127|0)>>>0)/255|0)&255,t[Ta>>0]=pa,Db=Db+1|0,256!=(Db|
0);)Ta=Ta+1|0;cc=cc+1|0;if(256==(cc|0))break;else Za=Za+256|0}a[xb>>2]=5}break;case 5:8==(w[c>>1]|0)&&4==(w[Kc>>1]|0)&&(a[sa>>2]=1,a[xb>>2]=7);break;case 6:8==(w[c>>1]|0)&&3==(w[Kc>>1]|0)&&0!=(Wc(b)|0)&&(ra=a[b>>2]|0,a[g>>2]=z,a[g+4>>2]=Q,ne(ra,530,g)|0,17==(N[z>>1]<<4|N[Q>>1]|0))&&(a[xb>>2]=8)}while(0);if(a[Aa>>2]|0&&a[xb>>2]|0)return ya=1,u=f,ya|0;Ga=e;Ea=136793;La=Ga+28|0;do t[Ga>>0]=t[Ea>>0]|0,Ga=Ga+1|0,Ea=Ea+1|0;while((Ga|0)<(La|0));break a}}else a[b+8>>2]=1;xb=0!=(cd(a[b>>2]|0)|0);Aa=b+48|0;
a[Aa>>2]=xb?1:2;xb=b+52|0;a[xb>>2]=0;b:do switch(N[ua>>1]|0){case 2:switch(N[c>>1]|0){case 8:switch(a[sa>>2]|0){case 1:a[xb>>2]=1;break b;case 2:a[dh>>2]|0&&Z(136575,136593,2728,136608);Da=eb(65536)|0;if(a[dh>>2]=Da)ia=0,qa=Da;else{Y(a[(a[b>>2]|0)+628>>2]|0,136608,150005,ka);break b}for(;;){Da=0;for(ra=qa;Ta=((((E(Da,ia)|0)+127|0)>>>0)/255|0)&255,t[ra>>0]=Ta,Da=Da+1|0,256!=(Da|0);)ra=ra+1|0;ia=ia+1|0;if(256==(ia|0))break;else qa=qa+256|0}a[xb>>2]=2;break b;default:a[xb>>2]=3;break b}case 16:break;
default:break b}ra=a[sa>>2]|0;if(1==(ra|0)){a[aa>>2]|0&&Z(136623,136593,2750,136648);Da=eb(65536)|0;if(a[aa>>2]=Da)Ja=Da,ea=0;else{Y(a[(a[b>>2]|0)+628>>2]|0,136648,150005,H);break b}for(;t[Ja>>0]=((ea+128|0)>>>0)/257|0,ea=ea+1|0,65536!=(ea|0);)Ja=Ja+1|0;a[xb>>2]=4;break b}Da=2==(ra|0);a[aa>>2]|0&&Z(136623,136593,2750,136648);Ta=eb(65536)|0;if(a[aa>>2]=Ta)for(Db=Ta,Ta=0;;)if(t[Db>>0]=((Ta+128|0)>>>0)/257|0,Ta=Ta+1|0,65536==(Ta|0)){wa=1;break}else Db=Db+1|0;else Y(a[(a[b>>2]|0)+628>>2]|0,136648,150005,
B),wa=0;if(!Da){if(!wa)break b;a[xb>>2]=6;break b}if(wa){a[dh>>2]|0&&Z(136575,136593,2728,136608);Db=eb(65536)|0;if(a[dh>>2]=Db)Ma=0,xa=Db;else{Y(a[(a[b>>2]|0)+628>>2]|0,136608,150005,y);break b}for(;;){Db=0;for(Ta=xa;ra=((((E(Db,Ma)|0)+127|0)>>>0)/255|0)&255,t[Ta>>0]=ra,Db=Db+1|0,256!=(Db|0);)Ta=Ta+1|0;Ma=Ma+1|0;if(256==(Ma|0))break;else xa=xa+256|0}a[xb>>2]=5}break;case 5:if(0!=(nc(b)|0)&&8==(w[c>>1]|0)){a[xb>>2]=a[Ia>>2]|0?8:7;break b}break;case 3:if(nc(b)|0)switch(N[c>>1]|0){case 8:a[xb>>2]=9;
break b;case 4:a[xb>>2]=10;break b;case 2:a[xb>>2]=11;break b;case 1:a[xb>>2]=12;break b;default:break b}break;case 1:case 0:if(nc(b)|0)switch(N[c>>1]|0){case 16:a[xb>>2]=13;break b;case 8:if(0!=(a[sa>>2]|0)&&2==(w[Kc>>1]|0)){a[xb>>2]=14;break b}a[xb>>2]=15;break b;case 4:a[xb>>2]=16;break b;case 2:a[xb>>2]=17;break b;case 1:a[xb>>2]=18;break b;default:break b}break;case 6:if(8==(w[c>>1]|0)&&3==(w[Kc>>1]|0)&&0!=(Wc(b)|0))switch(Da=a[b>>2]|0,a[q>>2]=C,a[q+4>>2]=Oa,ne(Da,530,q)|0,N[C>>1]<<4|N[Oa>>1]|
0){case 68:a[xb>>2]=19;break b;case 66:a[xb>>2]=20;break b;case 65:a[xb>>2]=21;break b;case 34:a[xb>>2]=22;break b;case 33:a[xb>>2]=23;break b;case 18:a[xb>>2]=24;break b;case 17:a[xb>>2]=25;break b;default:break b}break;case 8:if(0!=(nc(b)|0)&&8==(w[c>>1]|0)){if(0==(a[ca>>2]|0)&&(Da=eb(18124)|0,a[ca>>2]=Da,0==(Da|0)))Y(a[(a[b>>2]|0)+628>>2]|0,136670,136691,p),$a=0;else{Da=a[b>>2]|0;a[n>>2]=z;ne(Da,318,n)|0;W[Q+4>>2]=100;Da=a[z>>2]|0;Ta=Da+4|0;W[Q>>2]=+W[Da>>2]/+W[Ta>>2]*100;la=+W[Ta>>2];W[Q+8>>2]=
(1-+W[Da>>2]-la)/la*100;var Ba=a[ca>>2]|0,va=7644,za=Q,Ba=Ba|0,za=za|0,ta=void 0,nb=void 0,sc=void 0,gb=void 0,hb=void 0,ob=void 0,Bb=void 0,qb=void 0,kb=void 0,ib=void 0,Cb=void 0,fe=0,sb=void 0,Xa=void 0,Fa=void 0,Pa=0,Eb=void 0,vb=void 0,tb=void 0;a[Ba>>2]=1500;Ab(Ba+28|0,va|0,84);ta=1/+W[Ba+100>>2];va=Ba+64|0;nb=+W[va>>2];sc=Ba+88|0;gb=+W[sc>>2];hb=a[Ba>>2]|0;W[Ba+4>>2]=(nb-gb)/+(hb|0);if(0>(hb|0))ob=nb,Bb=gb,qb=hb;else{kb=Ba+76|0;ib=hb;for(hb=0;;)if(gb=+((a[kb>>2]|0)>>>0)*+Oi(+(+(hb|0)/+(ib|
0)),+ta),W[Ba+112+(hb<<2)>>2]=gb,Cb=a[Ba>>2]|0,(hb|0)<(Cb|0))ib=Cb,hb=hb+1|0;else{fe=Cb;break}ob=+W[va>>2];Bb=+W[sc>>2];qb=fe}ta=1/+W[Ba+104>>2];W[Ba+8>>2]=(ob-Bb)/+(qb|0);if(0>(qb|0))sb=ob,Xa=Bb,Fa=qb;else{fe=Ba+80|0;hb=qb;for(qb=0;;)if(Bb=+((a[fe>>2]|0)>>>0)*+Oi(+(+(qb|0)/+(hb|0)),+ta),W[Ba+6116+(qb<<2)>>2]=Bb,ib=a[Ba>>2]|0,(qb|0)<(ib|0))hb=ib,qb=qb+1|0;else{Pa=ib;break}sb=+W[va>>2];Xa=+W[sc>>2];Fa=Pa}ta=1/+W[Ba+108>>2];W[Ba+12>>2]=(sb-Xa)/+(Fa|0);if(!(0>(Fa|0)))for(Pa=Ba+84|0,sc=Fa,Fa=0;!(Xa=+((a[Pa>>
2]|0)>>>0)*+Oi(+(+(Fa|0)/+(sc|0)),+ta),W[Ba+12120+(Fa<<2)>>2]=Xa,sc=a[Ba>>2]|0,(Fa|0)>=(sc|0));)Fa=Fa+1|0;Eb=a[za>>2]|0;a[(Ba+16|0)>>2]=Eb;vb=a[(za+4|0)>>2]|0;a[(Ba+20|0)>>2]=vb;tb=a[(za+8|0)>>2]|0;a[(Ba+24|0)>>2]=tb;$a=26}a[xb>>2]=$a}}while(0);if(a[Aa>>2]|0&&a[xb>>2]|0)return ya=1,u=f,ya|0;Ga=e;Ea=136793;La=Ga+28|0;do t[Ga>>0]=t[Ea>>0]|0,Ga=Ga+1|0,Ea=Ea+1|0;while((Ga|0)<(La|0));break;default:a[R>>2]=ga,ad(e,135980,R)|0}while(0);ja(a[da>>2]|0);ja(a[fa>>2]|0);ja(a[oa>>2]|0);a[oa>>2]=0;a[fa>>2]=0;a[da>>
2]=0;u=f;return 0}function vc(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m,k,l,n;h=u;u=u+1136|0;m=h+16|0;k=h+8|0;l=h+112|0;n=h+20|0;Va(l|0,0,1024)|0;if(0!=(jc(b,l)|0)&&0!=(lc(n,b,g,l)|0)){w[n+30>>1]=f;f=a[n+20>>2]|0;g=e+((E(c-f|0,d)|0)<<2)|0;(c=a[n+48>>2]|0)?a[n+52>>2]|0?e=rb[c&63](n,g,d,f)|0:(e=a[n>>2]|0,b=a[e+628>>2]|0,Y(b,Bc(e)|0,136844,k),e=0):(e=a[n>>2]|0,b=a[e+628>>2]|0,Y(b,Bc(e)|0,136821,h),e=0);m=n|0;n=m+56|0;if(b=a[n>>2]|0)ja(b),a[n>>2]=0;n=m+60|0;if(b=a[n>>2]|0)ja(b),a[n>>2]=0;n=m+
64|0;if(b=a[n>>2]|0)ja(b),a[n>>2]=0;n=m+68|0;if(b=a[n>>2]|0)ja(b),a[n>>2]=0;n=m+72|0;if(b=a[n>>2]|0)ja(b),a[n>>2]=0;n=m+76|0;if(b=a[n>>2]|0)ja(b),a[n>>2]=0;n=m+80|0;if(b=a[n>>2]|0)ja(b),a[n>>2]=0;n=m+36|0;if(b=a[n>>2]|0)ja(b),b=m+40|0,ja(a[b>>2]|0),m=m+44|0,ja(a[m>>2]|0),a[m>>2]=0,a[b>>2]=0,a[n>>2]=0;u=h;return e|0}e=a[b+628>>2]|0;n=Bc(b)|0;a[m>>2]=l;Y(e,n,154321,m);u=h;return 0}function nc(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,H,ka;d=u;u=u+32|0;c=d+24|0;e=d+16|0;f=d+8|0;g=d;h=b+32|0;switch(N[h>>
1]|0){case 5:case 6:case 2:if(8==(w[b+24>>1]|0))return u=d,1;break;case 0:case 1:break;case 3:f=b+36|0;m=a[f>>2]|0;k=b+40|0;l=a[k>>2]|0;g=b+44|0;n=a[g>>2]|0;h=b+24|0;p=w[h>>1]|0;q=1<<(p&65535);y=n;B=l;H=q;for(ka=m;;){if(0>=(H|0)){y=36;break}if(255<(N[ka>>1]|0)){y=34;break}if(255<(N[B>>1]|0)){y=34;break}if(255<(N[y>>1]|0)){y=34;break}else y=y+2|0,B=B+2|0,H=H+-1|0,ka=ka+2|0}if(34==(y|0)){if(31==p<<16>>16)return u=d,1;p=q;do q=p,p=p+-1|0,ka=m+(p<<1)|0,w[ka>>1]=(N[ka>>1]|0)>>>8,ka=l+(p<<1)|0,w[ka>>1]=
(N[ka>>1]|0)>>>8,ka=n+(p<<1)|0,w[ka>>1]=(N[ka>>1]|0)>>>8;while(1<(q|0))}else 36==(y|0)&&(y=a[b>>2]|0,p=a[y+628>>2]|0,Wb(p,Bc(y)|0,137096,e));e=w[h>>1]|0;if(9<=(e&65535))return u=d,1;h=e&65535;e=a[f>>2]|0;f=a[k>>2]|0;k=a[g>>2]|0;g=eb(((8/(h>>>0)|0)<<10)+1024|0)|0;y=b+64|0;a[y>>2]=g;if(!g)return p=a[b>>2]|0,n=a[p+628>>2]|0,Y(n,Bc(p)|0,137120,c),u=d,0;c=g;p=0;for(n=g+1024|0;;){a[c+(p<<2)>>2]=n;switch(h|0){case 1:g=p>>>7&1;a[n>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;
g=p>>>6&1;a[n+4>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p>>>5&1;a[n+8>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p>>>4&1;a[n+12>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p>>>3&1;a[n+16>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p>>>2&1;a[n+20>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p>>>1&1;a[n+24>>2]=N[e+(g<<1)>>1]&255|
N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p&1;a[n+28>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;m=n+32|0;break;case 2:g=p>>>6&3;a[n>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p>>>4&3;a[n+4>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p>>>2&3;a[n+8>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p&3;a[n+12>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+
(g<<1)>>1]<<16|-16777216;m=n+16|0;break;case 4:g=p>>>4&15;a[n>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;g=p&15;a[n+4>>2]=N[e+(g<<1)>>1]&255|N[f+(g<<1)>>1]<<8&65280|N[k+(g<<1)>>1]<<16|-16777216;m=n+8|0;break;case 8:a[n>>2]=N[e+(p<<1)>>1]&255|N[f+(p<<1)>>1]<<8&65280|N[k+(p<<1)>>1]<<16|-16777216;m=n+4|0;break;default:m=n}g=p+1|0;if(256==(g|0))break;c=a[y>>2]|0;p=g;n=m}u=d;return 1;default:return u=d,1}m=b+24|0;n=w[m>>1]|0;p=16==n<<16>>16?255:(1<<(n&65535))+-1|0;n=p+
1|0;y=eb(n)|0;c=b+56|0;a[c>>2]=y;if(!y)return k=a[b>>2]|0,f=a[k+628>>2]|0,Y(f,Bc(k)|0,137023,g),u=d,0;g=0>(p|0);if(!(w[h>>1]|0)){if(g?0:(t[y>>0]=-1,0!=(p|0))){k=1;do t[(a[c>>2]|0)+k>>0]=(255*(p-k|0)|0)/(p|0)|0,k=k+1|0;while((k|0)!=(n|0))}}else if(g?0:(t[y>>0]=0,0!=(p|0))){y=1;do t[(a[c>>2]|0)+y>>0]=(255*y|0)/(p|0)|0,y=y+1|0;while((y|0)!=(n|0))}n=w[m>>1]|0;if(17<=(n&65535)||2<=(N[h>>1]|0))return u=d,1;h=a[c>>2]|0;m=n&65535;y=8/(m>>>0)|0;p=eb(0==(y|0)?2048:(y<<10)+1024|0)|0;y=b+60|0;a[y>>2]=p;if(!p)return g=
a[b>>2]|0,b=a[g+628>>2]|0,Y(b,Bc(g)|0,137065,f),u=d,0;f=p+1024|0;a:do switch(n<<16>>16){case 1:for(g=p,b=0,k=f;;){a[g+(b<<2)>>2]=k;f=x[h+(b>>7)>>0]|0;a[k>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b>>>6&1)>>0]|0;a[k+4>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b>>>5&1)>>0]|0;a[k+8>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b>>>4&1)>>0]|0;a[k+12>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b>>>3&1)>>0]|0;a[k+16>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b>>>2&1)>>0]|0;a[k+20>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b>>>1&1)>>0]|0;a[k+24>>2]=f|f<<8|f<<
16|-16777216;f=x[h+(b&1)>>0]|0;a[k+28>>2]=f|f<<8|f<<16|-16777216;f=b+1|0;if(256==(f|0))break a;g=a[y>>2]|0;b=f;k=k+32|0}case 2:for(k=p,b=0,g=f;;){a[k+(b<<2)>>2]=g;f=x[h+(b>>6)>>0]|0;a[g>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b>>>4&3)>>0]|0;a[g+4>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b>>>2&3)>>0]|0;a[g+8>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b&3)>>0]|0;a[g+12>>2]=f|f<<8|f<<16|-16777216;if(255==(b|0))break a;k=a[y>>2]|0;b=b+1|0;g=g+16|0}case 16:a[p>>2]=f;g=x[h>>0]|0;a[f>>2]=g|g<<8|g<<16|-16777216;g=1;b=f;do b=b+
4|0,a[(a[y>>2]|0)+(g<<2)>>2]=b,k=x[h+g>>0]|0,a[b>>2]=k|k<<8|k<<16|-16777216,g=g+1|0;while(256!=(g|0));break;default:for(g=p,b=0,k=f;;){a[g+(b<<2)>>2]=k;switch(m|0){case 8:case 16:f=x[h+b>>0]|0;a[k>>2]=f|f<<8|f<<16|-16777216;e=k+4|0;break;case 4:f=x[h+(b>>4)>>0]|0;a[k>>2]=f|f<<8|f<<16|-16777216;f=x[h+(b&15)>>0]|0;a[k+4>>2]=f|f<<8|f<<16|-16777216;e=k+8|0;break;default:e=k}f=b+1|0;if(256<=(f|0))break a;g=a[y>>2]|0;b=f;k=e}}while(0);ja(a[c>>2]|0);a[c>>2]=0;u=d;return 1}function Wc(b){b|=0;var d,c,e,f,
g,h,m,k=0;d=u;u=u+32|0;c=d+16|0;e=d+8|0;f=d;g=d+24|0;h=d+20|0;m=b+68|0;if(0==(a[m>>2]|0)&&(k=eb(6168)|0,a[m>>2]=k,0==(k|0)))return Y(a[(a[b>>2]|0)+628>>2]|0,136962,136982,f),u=d,0;f=a[b>>2]|0;a[e>>2]=g;ne(f,529,e)|0;e=a[b>>2]|0;a[c>>2]=h;ne(e,532,c)|0;b=a[m>>2]|0;g=a[g>>2]|0;var l=a[h>>2]|0;b|=0;g|=0;var l=l|0,n,p,q,y,B,H,ka;$c(b+24|0,0,256);h=b+280|0;a[b>>2]=h;c=0;do t[h+c>>0]=c,c=c+1|0;while(256!=(c|0));$c(h+256|0,255,512);a[b+4>>2]=h+768;a[b+8>>2]=h+1792;a[b+12>>2]=h+2816;a[b+16>>2]=h+3840;a[b+
20>>2]=h+4864;e=+W[g>>2];n=2-2*e;b=~~(65536*n+.5);f=+W[g+4>>2];c=0-~~(e*n/f*65536+.5)|0;n=+W[g+8>>2];e=2-2*n;g=~~(65536*e+.5);m=~~(n*e/f*65536+.5);f=+W[l+16>>2]+-128;k=~~f;e=+W[l+20>>2]+-128-f;f=0!=e?e:1;e=+W[l+8>>2]+-128;p=~~e;n=+W[l+12>>2]+-128-e;e=0!=n?n:1;n=+W[l>>2];q=~~n;l=+W[l+4>>2]-n;n=0!=l?l:1;l=0;for(y=-128;B=~~(127*+(y-k|0)/f),H=~~(127*+(y-p|0)/e),ka=(E(B,b)|0)+32768>>16,a[h+(l+192<<2)>>2]=ka,ka=(E(H,g)|0)+32768>>16,a[h+(l+448<<2)>>2]=ka,ka=E(B,c)|0,a[h+(l+704<<2)>>2]=ka,ka=32768-(E(H,m)|
0)|0,a[h+(l+960<<2)>>2]=ka,a[h+(l+1216<<2)>>2]=~~(255*+(y+128-q|0)/n),l=l+1|0,256!=(l|0);)y=y+1|0;u=d;return 1}function rd(b,d,c,e,f,g,h,m,k,l){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;h|=0;m|=0;k|=0;l|=0;var n,p,q,y,B,H,ka,z,Q,C,Ra,V,Ed,r,x,G,L,K,E,v=0,O,M,T,X=0,P=0;n=u;u=u+96|0;p=n+80|0;q=n+72|0;y=n+64|0;B=n+56|0;H=n+48|0;ka=n+40|0;z=n+32|0;Q=n+24|0;C=n+16|0;Ra=n+8|0;V=n;Ed=t[d>>0]|0;switch(Ed<<24>>24|0){case 114:r=43==(t[d+1>>0]|0)?2:0;break;case 97:case 119:r=119==Ed<<24>>24?578:66;break;default:return a[Ra>>
2]=d,Y(0,137231,137216,Ra),u=n,0}Ra=eb((bk(b)|0)+697|0)|0;if(!Ra)return a[C>>2]=b,Y(c,137231,137246,C),u=n,0;$c(Ra,0,696);C=Ra+696|0;a[Ra>>2]=C;C|=0;gj(C,b|0)|0;C|0;C=Ra+8|0;a[C>>2]=r&2;w[Ra+448>>1]=-1;Ed=Ra+456|0;a[Ed>>2]=0;a[Ed+4>>2]=0;a[Ra+452>>2]=-1;a[Ra+444>>2]=-1;Ed=Ra+628|0;a[Ed>>2]=c;if(!(0!=(e|0)&0!=(f|0)&0!=(g|0)&0!=(h|0)&0!=(m|0)))return Y(c,137231,137281,Q),u=n,0;Q=Ra+632|0;a[Q>>2]=e;e=Ra+636|0;a[e>>2]=f;f=Ra+640|0;a[f>>2]=g;a[Ra+644>>2]=h;a[Ra+648>>2]=m;m=Ra+620|0;a[m>>2]=0==(k|0)?7:
k;a[Ra+624>>2]=0==(l|0)?1:l;Ng(Ra);l=Ra+12|0;h=(k=0==(r|0))?2049:1;g=0==(r&576|0)?h|32768:h;a[l>>2]=g;h=t[d>>0]|0;a:do if(h<<24>>24){c=0==(r&64|0);if(k)k=h,K=h=L=G=x=g,E=d;else for(x=g,k=d;;){switch(h<<24>>24|0){case 98:c||(g=x|128,x=a[l>>2]=g);break;case 56:c||(g=x|524288,x=a[l>>2]=g);break;case 66:g=x&-4|1;x=a[l>>2]=g;break;case 76:g=x&-4|2;x=a[l>>2]=g;break;case 72:g=x&-4|2;x=a[l>>2]=g;break;case 104:g|=65536;x=a[l>>2]=g;break}k=k+1|0;h=t[k>>0]|0;if(!(h<<24>>24))break a}for(;;){do switch(k<<24>>
24|0){case 98:c?(v=K,O=h,M=L,T=G,g=x):(g=K|128,T=M=O=v=a[l>>2]=g);break;case 56:c?(v=K,O=h,M=L,T=G,g=x):(g=K|524288,T=M=O=v=a[l>>2]=g);break;case 66:g=K&-4|1;T=M=O=v=a[l>>2]=g;break;case 76:g=K&-4|2;T=M=O=v=a[l>>2]=g;break;case 72:g=K&-4|2;T=M=O=v=a[l>>2]=g;break;case 77:g=K|2048;T=M=O=v=a[l>>2]=g;break;case 109:g=h&-2049;T=M=O=v=a[l>>2]=g;break;case 67:g=L|32768;T=M=O=v=a[l>>2]=g;break;case 99:g=G&-32769;T=M=O=v=a[l>>2]=g;break;case 104:g=x|65536;T=M=O=v=a[l>>2]=g;break;default:v=K,O=h,M=L,T=G,g=
x}while(0);E=E+1|0;k=t[E>>0]|0;if(k<<24>>24)x=g,G=T,L=M,h=O,K=v;else break a}}while(0);a:do if(0==(r&512|0)&&(v=Ra+424|0,8==(Aa[a[Q>>2]&63](a[Ed>>2]|0,v,8)|0))){K=w[v>>1]|0;v=K&65535;switch(K<<16>>16){case 19789:a[l>>2]|=128;break;case 20549:case 18761:break;default:K=a[Ed>>2]|0;a[H>>2]=v;a[H+4>>2]=v;Y(K,b,137351,H);break a}K=Ra+426|0;a[l>>2]&128&&ac(K);v=w[K>>1]|0;K=v&65535;if(42!=(v&-2)<<16>>16)O=a[Ed>>2]|0,a[B>>2]=K,a[B+4>>2]=K,Y(O,b,137402,B);else{do if(42!=v<<16>>16){O=Ra+432|0;if(8!=(Aa[a[Q>>
2]&63](a[Ed>>2]|0,O,8)|0)){Y(a[Ed>>2]|0,b,137327,y);break a}K=Ra+428|0;a[l>>2]&128&&(ac(K),kc(O));O=w[K>>1]|0;K=O&65535;if(8!=O<<16>>16){O=a[Ed>>2]|0;a[q>>2]=K;a[q+4>>2]=K;Y(O,b,137448,q);break a}O=w[Ra+430>>1]|0;K=O&65535;if(O<<16>>16){O=a[Ed>>2]|0;a[p>>2]=K;a[p+4>>2]=K;Y(O,b,137498,p);break a}else w[Ra+440>>1]=16,O=a[l>>2]|524288,c=a[l>>2]=O}else O=a[l>>2]|0,O&128?(pb(Ra+428|0),c=a[l>>2]|0):c=O,w[Ra+440>>1]=8;while(0);v=c|512;a[l>>2]=v;O=Ra+588|0;a[O>>2]=0;a[O+4>>2]=0;a[O+8>>2]=0;a[O+12>>2]=0;a[O+
16>>2]=0;switch(t[d>>0]|0){case 114:break;case 97:if(Pi(Ra)|0)b=Ra;else break a;u=n;return b|0;default:break a}c&524288?(O=Ra+432|0,K=a[O+4>>2]|0,h=Ra+24|0,a[h>>2]=a[O>>2],a[h+4>>2]=K):(O=Ra+24|0,a[O>>2]=a[Ra+428>>2],a[O+4>>2]=0);c&2048?Aa[a[m>>2]&63](a[Ed>>2]|0,Ra+612|0,V)|0?(K=V,h=a[K>>2]|0,O=a[K+4>>2]|0,a[Ra+616>>2]=h,(h|0)==(h|0)&((0>(h|0))<<31>>31|0)==(O|0)?X=a[l>>2]|0:Z(137544,137569,449,137231)):(K=a[l>>2]&-2049,X=a[l>>2]=K):X=v;if(X&65536)return b=Ra,u=n,b|0;if(ck(Ra)|0)return a[Ra+608>>2]=
-1,a[l>>2]|=16,b=Ra,u=n,b|0}}else P=37;while(0);if(37==(P|0))if(a[C>>2]|0)if(X=a[l>>2]|0,V=X&128,m=Ra+424|0,w[m>>1]=0!=(V|0)?19789:18761,c=Ra+426|0,X&524288?(w[c>>1]=43,X=Ra+428|0,w[X>>1]=8,w[Ra+430>>1]=0,d=Ra+432|0,a[d>>2]=0,a[d+4>>2]=0,V&&(ac(c),ac(X)),X=Ra+440|0,w[X>>1]=16):(w[c>>1]=42,a[Ra+428>>2]=0,V&&ac(c),X=Ra+440|0,w[X>>1]=8),d=X,rb[a[f>>2]&63](a[Ed>>2]|0,0,0,0)|0,X=Aa[a[e>>2]&63](a[Ed>>2]|0,m,N[d>>1]|0)|0,(X|0)!=(N[d>>1]|0))Y(a[Ed>>2]|0,b,142082,ka);else{if(19789==(w[m>>1]|0)&&(a[l>>2]|=
128),Pi(Ra)|0)return m=Ra+16|0,a[m>>2]=0,a[m+4>>2]=0,a[Ra+32>>2]=0,w[Ra+36>>1]=0,w[Ra+38>>1]=0,u=n,Ra|0}else Y(a[Ed>>2]|0,b,137327,z);a[C>>2]=0;Ik(Ra);u=n;return 0}function Bc(b){return a[(b|0)>>2]|0}function cd(b){return(a[(b|0)+12>>2]|0)>>>10&1|0}function Vc(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k;f=u;u=u+32|0;g=f+16|0;if(1==(a[b+8>>2]|0))return Y(a[b+628>>2]|0,a[b>>2]|0,137580,f),u=f,-1;if(a[b+12>>2]&1024)return Y(a[b+628>>2]|0,a[b>>2]|0,137606,f+8|0),u=f,-1;h=a[b+168>>2]|0;if(h>>>0<=d>>>0)return m=
a[b+628>>2]|0,a[g>>2]=d,a[g+4>>2]=h,Y(m,137830,137851,g),u=f,-1;g=a[b+100>>2]|0;m=a[b+60>>2]|0;h=g>>>0>m>>>0?m:g;g=((m+-1+h|0)>>>0)/(h>>>0)|0;k=m-(E((d>>>0)%(g>>>0)|0,h)|0)|0;m=b|0;var l;l=u;u=u+16|0;h=Yd(m,(k>>>0>h>>>0?h:k)|0)|0;(h|0)==(h|0)&((0>(h|0))<<31>>31|0)==(U|0)?(u=l,h|=0):(Y(a[m+628>>2]|0,138858,139721,l),u=l,h=0);m=h|0;if(!m)return u=f,-1;k=-1!=(e|0)&(m|0)>(e|0)?e:m;if(!(Dd(b,d)|0)||1>(rb[a[b+540>>2]&63](b,c,k,((d>>>0)/(g>>>0)|0)&65535)|0))return u=f,-1;td[a[b+652>>2]&127](b,c,k);u=f;return k|
0}function Dd(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,y=0,B;c=u;u=u+64|0;e=c+48|0;f=c+40|0;g=c+16|0;h=b+176|0;m=a[h>>2]|0;if(!m)return u=c,0;k=b+12|0;l=a[k>>2]|0;do if(!(l&131072)){n=m+(d<<3)|0;p=a[n>>2]|0;q=a[n+4>>2]|0;if(0>(q|0)|0==(q|0)&1>p>>>0)return n=a[b+628>>2]|0,y=c,a[y>>2]=p,a[y+4>>2]=q,a[c+8>>2]=d,Y(n,137884,137898,c),h=0,u=c,h|0;if(0!=(l&2048|0)&&0!=((N[b+94>>1]|256)&l|0)){0!=(l&512|0)&&(n=b+588|0,y=a[n>>2]|0,0!=(y|0))?(ja(y),a[n>>2]=0,a[b+592>>2]=0,y=a[k>>2]|0):y=l;n=y&-513;a[k>>2]=n;
y=a[b+616>>2]|0;l=(0>(y|0))<<31>>31;e=(a[b+172>>2]|0)+(d<<3)|0;f=a[e>>2]|0;m=a[e+4>>2]|0;e=Ic(y|0,l|0,p|0,q|0)|0;B=U;if(!(l>>>0<q>>>0|(l|0)==(q|0)&y>>>0<p>>>0|m>>>0>B>>>0|(m|0)==(B|0)&f>>>0>e>>>0)){a[b+592>>2]=p;a[b+588>>2]=(a[b+612>>2]|0)+f;a[b+596>>2]=0;a[b+600>>2]=p;a[k>>2]=n|8388608;break}n=a[b+628>>2]|0;e=Ic(y|0,l|0,f|0,m|0)|0;a[g>>2]=d;m=g+8|0;a[m>>2]=e;a[m+4>>2]=U;m=g+16|0;a[m>>2]=p;a[m+4>>2]=q;Y(n,137884,137939,g);a[b+452>>2]=-1;h=0;u=c;return h|0}if(!((p|0)==(p|0)&((0>(p|0))<<31>>31|0)==
(q|0)))return Y(a[b+628>>2]|0,137884,139721,f),h=0,u=c,h|0;if((p|0)>(a[b+592>>2]|0)){a[b+452>>2]=-1;if(!(l&512))return q=a[b+628>>2]|0,a[e>>2]=d,Y(q,137884,137994,e),h=0,u=c,h|0;if(ld(b,0,p)|0)q=a[k>>2]|0;else return h=0,u=c,h|0}else q=l;if(0!=(q&8388608|0)&&(a[b+452>>2]=-1,0==(ld(b,0,p)|0)))return h=0,u=c,h|0;q=b+588|0;if((me(b,d,a[q>>2]|0,p,137884)|0)!=(p|0))return h=0,u=c,h|0;a[b+596>>2]=0;a[b+600>>2]=p;(N[b+94>>1]|256)&a[k>>2]||ye(a[q>>2]|0,p)}while(0);if(!(a[h>>2]|0))return u=c,0;q=a[k>>2]|0;
if(q&32)g=q;else if(da[a[b+508>>2]&63](b)|0)l=a[k>>2]|32,g=a[k>>2]=l;else return u=c,0;a[b+452>>2]=d;q=a[b+164>>2]|0;l=E(a[b+100>>2]|0,(d>>>0)%(q>>>0)|0)|0;a[b+444>>2]=l;a[k>>2]=g&-1048577;g&131072?h=a[b+604>>2]=0:(a[b+604>>2]=a[b+588>>2],h=a[(a[h>>2]|0)+(d<<3)>>2]|0);a[b+608>>2]=h;h=dd[a[b+512>>2]&127](b,((d>>>0)/(q>>>0)|0)&65535)|0;u=c;return h|0}function ld(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l;e=u;u=u+16|0;f=e+8|0;g=e;h=b+12|0;m=a[h>>2]|0;m&131072&&Z(137648,137683,918,137694);a[h>>2]=m&-8388609;
k=b+588|0;if(l=a[k>>2]|0)m&512&&ja(l),a[k>>2]=0,a[b+592>>2]=0;if(d)return a[b+592>>2]=c,a[k>>2]=d,a[h>>2]&=-513,u=e,1;d=c+1023&-1024;a[b+592>>2]=d;if(!d)return Y(a[b+628>>2]|0,137694,137714,g),u=e,0;g=eb(d)|0;a[k>>2]=g;a[h>>2]|=512;if(g)return u=e,1;g=a[b+628>>2]|0;a[f>>2]=a[b+444>>2];Y(g,137694,138034,f);a[b+592>>2]=0;u=e;return 0}function sd(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h;h=u;u=u+16|0;if(1==(a[b+8>>2]|0))return Y(a[b+628>>2]|0,a[b>>2]|0,137580,h),u=h,-1;if(!(a[b+12>>2]&1024))return Y(a[b+
628>>2]|0,a[b>>2]|0,138075,h+8|0),u=h,-1;if(!(yf(b,c,e,f,g)|0))return u=h,-1;var m=b;b|=0;c|=0;e|=0;g|=0;var k,l,n,p,q,y,B;k=a[b+68>>2]|0;l=a[b+72>>2]|0;n=a[b+76>>2]|0;p=a[b+64>>2]|0;f=1==(p|0)?0:f|0;k=-1==(k|0)?a[b+56>>2]|0:k;q=-1==(l|0)?a[b+60>>2]|0:l;l=-1==(n|0)?p:n;0!=(k|0)&0!=(q|0)&0!=(l|0)?(n=a[b+56>>2]|0,y=n>>>0<(0-k|0)>>>0?((k+-1+n|0)>>>0)/(k>>>0)|0:0,n=a[b+60>>2]|0,B=p>>>0<(0-l|0)>>>0?((l+-1+p|0)>>>0)/(l>>>0)|0:0,p=E(n>>>0<(0-q|0)>>>0?((q+-1+n|0)>>>0)/(q>>>0)|0:0,y)|0,b=2==(w[b+126>>1]|0)?
((c>>>0)/(k>>>0)|0)+(E((e>>>0)/(q>>>0)|0,y)|0)+(E(((f>>>0)/(l>>>0)|0)+(E(B,g&65535)|0)|0,p)|0)|0:(E((e>>>0)/(q>>>0)|0,y)|0)+(E((f>>>0)/(l>>>0)|0,p)|0)+((c>>>0)/(k>>>0)|0)|0,b|=0):b=1;d=Od(m,b|0,d,-1)|0;u=h;return d|0}function Od(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m;f=u;u=u+32|0;g=f+16|0;h=a[b+496>>2]|0;if(1==(a[b+8>>2]|0))return Y(a[b+628>>2]|0,a[b>>2]|0,137580,f),u=f,-1;if(!(a[b+12>>2]&1024))return Y(a[b+628>>2]|0,a[b>>2]|0,138075,f+8|0),u=f,-1;m=a[b+168>>2]|0;if(m>>>0<=d>>>0)return b=a[b+628>>
2]|0,a[g>>2]=d,a[g+4>>2]=m,Y(b,138116,138136,g),u=f,-1;g=-1==(e|0)|(h|0)<(e|0)?h:e;if(!(we(b,d)|0&&rb[a[b+548>>2]&63](b,c,g,((d>>>0)/((a[b+164>>2]|0)>>>0)|0)&65535)|0))return u=f,-1;td[a[b+652>>2]&127](b,c,g);u=f;return g|0}function we(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,y,B=0,H=0,t=0,z=0;c=u;u=u+48|0;e=c+40|0;f=c+32|0;g=c+24|0;h=c+16|0;m=b+176|0;k=a[m>>2]|0;if(!k)return u=c,0;l=b+12|0;n=a[l>>2]|0;do if(!(n&131072)){p=k+(d<<3)|0;q=a[p>>2]|0;y=a[p+4>>2]|0;if(0>(y|0)|0==(y|0)&1>q>>>0)return p=
a[b+628>>2]|0,B=c,a[B>>2]=q,a[B+4>>2]=y,a[c+8>>2]=d,Y(p,138168,138181,c),e=0,u=c,e|0;if(0!=(n&2048|0)&&0!=((N[b+94>>1]|256)&n|0)){0!=(n&512|0)&&(p=b+588|0,B=a[p>>2]|0,0!=(B|0))?(ja(B),a[p>>2]=0,a[b+592>>2]=0,h=a[l>>2]|0):h=n;p=h&-513;a[l>>2]=p;B=a[b+616>>2]|0;h=(0>(B|0))<<31>>31;if(h>>>0<y>>>0|(h|0)==(y|0)&B>>>0<q>>>0?0:(H=(a[b+172>>2]|0)+(d<<3)|0,t=a[H>>2]|0,z=a[H+4>>2]|0,H=Ic(B|0,h|0,q|0,y|0)|0,h=U,!(z>>>0>h>>>0|(z|0)==(h|0)&t>>>0>H>>>0))){a[b+592>>2]=q;a[b+588>>2]=(a[b+612>>2]|0)+t;a[b+596>>2]=
0;a[b+600>>2]=q;a[l>>2]=p|8388608;break}a[b+492>>2]=-1;e=0;u=c;return e|0}if(!((q|0)==(q|0)&((0>(q|0))<<31>>31|0)==(y|0)))return Y(a[b+628>>2]|0,138168,139721,h),e=0,u=c,e|0;if((q|0)>(a[b+592>>2]|0)){a[b+492>>2]=-1;if(!(n&512))return y=a[b+628>>2]|0,a[g>>2]=d,Y(y,138168,138221,g),e=0,u=c,e|0;if(ld(b,0,q)|0)y=a[l>>2]|0;else return e=0,u=c,e|0}else y=n;if(0!=(y&8388608|0)&&(a[b+492>>2]=-1,0==(ld(b,0,q)|0)))return e=0,u=c,e|0;y=b+588|0;if((xe(b,d,a[y>>2]|0,q,138168)|0)!=(q|0))return e=0,u=c,e|0;a[b+
596>>2]=0;a[b+600>>2]=q;(N[b+94>>1]|256)&a[l>>2]||ye(a[y>>2]|0,q)}while(0);if(!(a[m>>2]|0))return u=c,0;y=a[l>>2]|0;if(y&32)q=y;else if(da[a[b+508>>2]&63](b)|0)n=a[l>>2]|32,q=a[l>>2]=n;else return u=c,0;a[b+492>>2]=d;y=a[b+56>>2]|0;n=a[b+68>>2]|0;if(y>>>0<(0-n|0)>>>0&&(g=((y+-1+n|0)>>>0)/(n>>>0)|0,0!=(g|0))){y=a[b+72>>2]|0;h=E(y,(d>>>0)%(g>>>0)|0)|0;a[b+444>>2]=h;h=a[b+60>>2]|0;if(h>>>0<(0-y|0)>>>0&&(g=((y+-1+h|0)>>>0)/(y>>>0)|0,0!=(g|0)))return y=E((d>>>0)%(g>>>0)|0,n)|0,a[b+488>>2]=y,a[l>>2]=q&
-1048577,q&131072?e=a[b+604>>2]=0:(a[b+604>>2]=a[b+588>>2],e=a[(a[m>>2]|0)+(d<<3)>>2]|0),a[b+608>>2]=e,e=dd[a[b+512>>2]&127](b,((d>>>0)/((a[b+164>>2]|0)>>>0)|0)&65535)|0,u=c,e|0;Y(a[b+628>>2]|0,138260,138274,e);u=c;return 0}Y(a[b+628>>2]|0,138260,138274,f);u=c;return 0}function me(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p,q=p=0;g=u;u=u+64|0;h=g+32|0;m=g+8|0;k=g;l=a[b+12>>2]|0;l&131072&&Z(137648,137683,372,138609);if(!(l&2048)){l=b+628|0;h=b+172|0;n=(a[h>>2]|0)+(d<<3)|0;p=rb[a[b+640>>2]&
63](a[l>>2]|0,a[n>>2]|0,a[n+4>>2]|0,0)|0;n=(a[h>>2]|0)+(d<<3)|0;if((p|0)!=(a[n>>2]|0)||(U|0)!=(a[n+4>>2]|0))return n=a[l>>2]|0,a[k>>2]=a[b+444>>2],a[k+4>>2]=d,Y(n,f,137734,k),u=g,-1;k=Aa[a[b+632>>2]&63](a[l>>2]|0,c,e)|0;if((k|0)==(e|0))return u=g,e|0;n=a[l>>2]|0;a[m>>2]=a[b+444>>2];l=m+8|0;a[l>>2]=k;a[l+4>>2]=(0>(k|0))<<31>>31;k=m+16|0;a[k>>2]=e;a[k+4>>2]=(0>(e|0))<<31>>31;Y(n,f,137772,m);u=g;return-1}m=(a[b+172>>2]|0)+(d<<3)|0;n=a[m>>2]|0;k=n+e|0;(n|0)==(n|0)&&((0>(n|0))<<31>>31|0)==(a[m+4>>2]|0)&&
(m=a[b+616>>2]|0,(m|0)>=(n|0))?0>(n|e|0)|(k|0)>(m|0)&&(p=m-n|0,q=13):(p=0,q=13);if(13==(q|0)&&(p|0)!=(e|0))return q=a[b+628>>2]|0,a[h>>2]=a[b+444>>2],a[h+4>>2]=d,d=h+8|0,a[d>>2]=p,a[d+4>>2]=(0>(p|0))<<31>>31,p=h+16|0,a[p>>2]=e,a[p+4>>2]=(0>(e|0))<<31>>31,Y(q,f,138627,h),u=g,-1;Ab(c,(a[b+612>>2]|0)+n|0,e);u=g;return e|0}function xe(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p,q=p=0;g=u;u=u+80|0;h=g+40|0;m=g+16|0;k=g;l=a[b+12>>2]|0;l&131072&&Z(137648,137683,684,138417);if(!(l&2048)){l=b+628|
0;h=b+172|0;n=(a[h>>2]|0)+(d<<3)|0;p=rb[a[b+640>>2]&63](a[l>>2]|0,a[n>>2]|0,a[n+4>>2]|0,0)|0;n=(a[h>>2]|0)+(d<<3)|0;if((p|0)!=(a[n>>2]|0)||(U|0)!=(a[n+4>>2]|0))return n=a[l>>2]|0,p=a[b+488>>2]|0,a[k>>2]=a[b+444>>2],a[k+4>>2]=p,a[k+8>>2]=d,Y(n,f,138434,k),u=g,-1;k=Aa[a[b+632>>2]&63](a[l>>2]|0,c,e)|0;if((k|0)==(e|0))return u=g,e|0;n=a[l>>2]|0;l=a[b+488>>2]|0;a[m>>2]=a[b+444>>2];a[m+4>>2]=l;l=m+8|0;a[l>>2]=k;a[l+4>>2]=(0>(k|0))<<31>>31;k=m+16|0;a[k>>2]=e;a[k+4>>2]=(0>(e|0))<<31>>31;Y(n,f,138475,m);u=
g;return-1}m=(a[b+172>>2]|0)+(d<<3)|0;n=a[m>>2]|0;k=n+e|0;(n|0)==(n|0)&&((0>(n|0))<<31>>31|0)==(a[m+4>>2]|0)&&(m=a[b+616>>2]|0,(m|0)>=(n|0))?0>(n|e|0)|(k|0)>(m|0)&&(p=m-n|0,q=13):(p=0,q=13);if(13==(q|0)&&(p|0)!=(e|0))return q=a[b+628>>2]|0,m=a[b+488>>2]|0,a[h>>2]=a[b+444>>2],a[h+4>>2]=m,a[h+8>>2]=d,d=h+16|0,a[d>>2]=p,a[d+4>>2]=(0>(p|0))<<31>>31,p=h+24|0,a[p>>2]=e,a[p+4>>2]=(0>(e|0))<<31>>31,Y(q,f,138537,h),u=g,-1;Ab(c,(a[b+612>>2]|0)+n|0,e);u=g;return e|0}function Pc(b,d,c){b|=0;c|=0;var e,f,g;e=
u;u=u+16|0;f=((d|0)>>>0)/((a[b+100>>2]|0)>>>0)|0;if(2!=(w[b+126>>1]|0))return u=e,f|0;d=c&65535;g=w[b+98>>1]|0;if((g&65535)>(c&65535))return b=(E(a[b+164>>2]|0,d)|0)+f|0,u=e,b|0;f=a[b+628>>2]|0;a[e>>2]=d;a[e+4>>2]=g&65535;Y(f,138696,139539,e);u=e;return 0}function Yd(b,d){b|=0;d|=0;var c,e,f,g,h,m;c=u;u=u+32|0;e=c+16|0;f=c+8|0;g=c;h=c+24|0;m=-1==(d|0)?a[b+60>>2]|0:d;if(1==(w[b+126>>1]|0)&&6==(w[b+90>>1]|0)&&0==(a[b+12>>2]&16384|0)){if(3!=(w[b+98>>1]|0))return Y(a[b+628>>2]|0,138732,138749,g),U=0,
u=c,0;g=h+2|0;a[f>>2]=h;a[f+4>>2]=g;ne(b,530,f)|0;f=w[h>>1]|0;a:do switch(f<<16>>16){case 4:case 2:case 1:h=w[g>>1]|0;switch(h<<16>>16){case 4:case 2:case 1:break;default:break a}d=f&65535;g=h&65535;h=(E(g,d)|0)+2|0;e=a[b+56>>2]|0;e=e>>>0<(0-d|0)>>>0?((d+-1+e|0)>>>0)/(d>>>0)|0:0;m=m>>>0<(0-g|0)>>>0?((m+-1+g|0)>>>0)/(g>>>0)|0:0;g=pd(b,e,0,h&65535,0,138732)|0;h=U;d=b+84|0;e=pd(b,g,h,N[d>>1]|0,0,138732)|0;m=pd(b,Qb(Oe(pd(b,g,h,N[d>>1]|0,0,138732)|0,U|0,3)|0,U|0,(0!=(e&7|0)|0)&1|0,0)|0,U,m,0,138732)|
0;U=h=U;u=c;return m|0;default:h=w[g>>1]|0}while(0);g=a[b+628>>2]|0;a[e>>2]=f&65535;a[e+4>>2]=h&65535;Y(g,138732,139754,e);U=0;u=c;return 0}e=Td(b)|0;g=pd(b,m,0,e,U,138732)|0;U=h=U;u=c;return g|0}function Td(b){b|=0;var d,c,e,f,g,h;d=u;u=u+32|0;c=d+16|0;e=d+8|0;f=d+20|0;a:do{if(1==(w[b+126>>1]|0)){g=w[b+98>>1]|0;if(3==g<<16>>16&&6==(w[b+90>>1]|0))if(a[b+12>>2]&16384)g=3;else{g=f+2|0;a[d>>2]=f;a[d+4>>2]=g;ne(b,530,d)|0;h=w[f>>1]|0;b:do switch(h<<16>>16){case 4:case 2:case 1:f=w[g>>1]|0;switch(f<<16>>
16){case 4:case 2:case 1:break;default:break b}h&=65535;e=(E(f&65535,h)|0)+2|0;f=a[b+56>>2]|0;f=f>>>0<(0-h|0)>>>0?((h+-1+f|0)>>>0)/(h>>>0)|0:0;g=pf(Oe(Qb(pd(b,pd(b,f,0,e&65535,0,138782)|0,U,N[b+84>>1]|0,0,138782)|0,U|0,7,0)|0,U|0,3)|0,U|0,N[g>>1]|0,0)|0;h=U;break a}while(0);Y(a[b+628>>2]|0,138782,138801,e);U=0;u=d;return 0}g=pd(b,a[b+56>>2]|0,0,g&65535,0,138782)|0;h=pd(b,g,U,N[b+84>>1]|0,0,138782)|0}else h=pd(b,a[b+56>>2]|0,0,N[b+84>>1]|0,0,138782)|0;g=Qb(h|0,U|0,7,0)|0;g=h=Oe(g|0,U|0,3)|0;h=U}while(0);
if(!(0==(g|0)&0==(h|0)))return U=h,u=d,g|0;Y(a[b+628>>2]|0,138782,138827,c);U=0;u=d;return 0}function se(b){b|=0;var d,c,e;d=u;u=u+16|0;c=a[b+100>>2]|0;e=a[b+60>>2]|0;c=Yd(b,c>>>0>e>>>0?e:c)|0;if((c|0)==(c|0)&((0>(c|0))<<31>>31|0)==(U|0))return u=d,c|0;Y(a[b+628>>2]|0,138873,139721,d);u=d;return 0}function Pe(b){b|=0;var d,c;d=u;u=u+16|0;c=Td(b)|0;if((c|0)==(c|0)&((0>(c|0))<<31>>31|0)==(U|0))return u=d,c|0;Y(a[b+628>>2]|0,138887,138904,d);u=d;return 0}function ac(a){a|=0;var d,c;d=a+1|0;c=t[d>>0]|
0;t[d>>0]=t[a>>0]|0;t[a>>0]=c}function pb(a){a|=0;var d,c;d=a+3|0;c=t[d>>0]|0;t[d>>0]=t[a>>0]|0;t[a>>0]=c;c=a+2|0;d=t[c>>0]|0;a=a+1|0;t[c>>0]=t[a>>0]|0;t[a>>0]=d}function kc(a){a|=0;var d,c,e;d=a+7|0;c=t[d>>0]|0;t[d>>0]=t[a>>0]|0;t[a>>0]=c;c=a+6|0;d=t[c>>0]|0;e=a+1|0;t[c>>0]=t[e>>0]|0;t[e>>0]=d;d=a+5|0;e=t[d>>0]|0;c=a+2|0;t[d>>0]=t[c>>0]|0;t[c>>0]=e;e=a+4|0;c=t[e>>0]|0;d=a+3|0;t[e>>0]=t[d>>0]|0;t[d>>0]=c}function Vd(a,d){d|=0;var c,e;if(0<(d|0))for(c=d,e=a|0;;)if(a=e+1|0,d=t[a>>0]|0,t[a>>0]=t[e>>
0]|0,t[e>>0]=d,1<(c|0))c=c+-1|0,e=e+2|0;else break}function Id(a,d){d|=0;var c,e,f;if(0<(d|0))for(c=d,e=a|0;;)if(a=e+3|0,d=t[a>>0]|0,t[a>>0]=t[e>>0]|0,t[e>>0]=d,d=e+2|0,a=t[d>>0]|0,f=e+1|0,t[d>>0]=t[f>>0]|0,t[f>>0]=a,1<(c|0))c=c+-1|0,e=e+4|0;else break}function Ae(a,d){d|=0;var c,e,f;if(0<(d|0))for(c=d,e=a|0;;)if(a=e+7|0,d=t[a>>0]|0,t[a>>0]=t[e>>0]|0,t[e>>0]=d,d=e+6|0,a=t[d>>0]|0,f=e+1|0,t[d>>0]=t[f>>0]|0,t[f>>0]=a,a=e+5|0,f=t[a>>0]|0,d=e+2|0,t[a>>0]=t[d>>0]|0,t[d>>0]=f,f=e+4|0,d=t[f>>0]|0,a=e+3|
0,t[f>>0]=t[a>>0]|0,t[a>>0]=d,1<(c|0))c=c+-1|0,e=e+8|0;else break}function gf(a,d){d|=0;var c,e,f;if(0<(d|0))for(c=d,e=a|0;;)if(a=e+3|0,d=t[a>>0]|0,t[a>>0]=t[e>>0]|0,t[e>>0]=d,d=e+2|0,a=t[d>>0]|0,f=e+1|0,t[d>>0]=t[f>>0]|0,t[f>>0]=a,1<(c|0))c=c+-1|0,e=e+4|0;else break}function re(a,d){d|=0;var c,e,f;if(0<(d|0))for(c=d,e=a|0;;)if(a=e+7|0,d=t[a>>0]|0,t[a>>0]=t[e>>0]|0,t[e>>0]=d,d=e+6|0,a=t[d>>0]|0,f=e+1|0,t[d>>0]=t[f>>0]|0,t[f>>0]=a,a=e+5|0,f=t[a>>0]|0,d=e+2|0,t[a>>0]=t[d>>0]|0,t[d>>0]=f,f=e+4|0,d=t[f>>
0]|0,a=e+3|0,t[f>>0]=t[a>>0]|0,t[a>>0]=d,1<(c|0))c=c+-1|0,e=e+8|0;else break}function ye(a,d){a|=0;d|=0;var c,e,f,g;if(8<(d|0)){c=d+-9&-8;e=a;for(f=d;!(t[e>>0]=t[138932+(x[e>>0]|0)>>0]|0,g=e+1|0,t[g>>0]=t[138932+(x[g>>0]|0)>>0]|0,g=e+2|0,t[g>>0]=t[138932+(x[g>>0]|0)>>0]|0,g=e+3|0,t[g>>0]=t[138932+(x[g>>0]|0)>>0]|0,g=e+4|0,t[g>>0]=t[138932+(x[g>>0]|0)>>0]|0,g=e+5|0,t[g>>0]=t[138932+(x[g>>0]|0)>>0]|0,g=e+6|0,t[g>>0]=t[138932+(x[g>>0]|0)>>0]|0,g=e+7|0,t[g>>0]=t[138932+(x[g>>0]|0)>>0]|0,f=f+-8|0,8>=(f|
0));)e=e+8|0;e=d+-8-c|0;c=a+(c+8|0)|0}else e=d,c=a;if(0<(e|0))for(;;)if(t[c>>0]=t[138932+(x[c>>0]|0)>>0]|0,1<(e|0))c=c+1|0,e=e+-1|0;else break}function yf(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p,q;g=u;u=u+32|0;h=g+24|0;m=g+16|0;k=g+8|0;l=g;n=a[b+56>>2]|0;if(n>>>0<=d>>>0)return p=a[b+628>>2]|0,q=a[b>>2]|0,a[l>>2]=d,a[l+4>>2]=n+-1,Y(p,q,139444,l),u=g,0;l=a[b+60>>2]|0;if(l>>>0<=c>>>0)return q=a[b+628>>2]|0,p=a[b>>2]|0,a[k>>2]=c,a[k+4>>2]=l+-1,Y(q,p,139475,k),u=g,0;k=a[b+64>>2]|0;if(k>>>
0<=e>>>0)return p=a[b+628>>2]|0,q=a[b>>2]|0,a[m>>2]=e,a[m+4>>2]=k+-1,Y(p,q,139506,m),u=g,0;if(2!=(w[b+126>>1]|0))return u=g,1;m=w[b+98>>1]|0;if((m&65535)>(f&65535))return u=g,1;q=a[b+628>>2]|0;p=a[b>>2]|0;a[h>>2]=f&65535;a[h+4>>2]=(m&65535)+-1;Y(q,p,139539,h);u=g;return 0}function Uf(b){b|=0;var d,c,e,f,g,h;d=u;u=u+32|0;c=d+24|0;e=d+16|0;if(!(a[b+72>>2]|0))return Y(a[b+628>>2]|0,139591,139609,d),U=0,u=d,0;f=a[b+68>>2]|0;if(!f)return Y(a[b+628>>2]|0,139591,139629,d+8|0),U=0,u=d,0;g=pd(b,N[b+84>>1]|
0,0,f,0,139648)|0;f=U;if(1==(w[b+126>>1]|0))if(h=w[b+98>>1]|0,h<<16>>16)e=f=pd(b,g,f,h&65535,0,139648)|0,g=U;else return Y(a[b+628>>2]|0,139591,139664,e),U=0,u=d,0;else e=g,g=f;f=Oe(e|0,g|0,3)|0;g=Qb((0!=(e&7|0)|0)&1|0,0,f|0,U|0)|0;f=U;if(!(0==(g|0)&0==(f|0)))return U=f,u=d,g|0;Y(a[b+628>>2]|0,139591,139690,c);U=0;u=d;return 0}function tg(b){b|=0;var d,c;d=u;u=u+16|0;c=Uf(b)|0;if((c|0)==(c|0)&((0>(c|0))<<31>>31|0)==(U|0))return u=d,c|0;Y(a[b+628>>2]|0,139648,139721,d);u=d;return 0}function Kf(b,d){b|=
0;d|=0;var c,e,f,g,h,m;c=u;u=u+32|0;e=c+8|0;f=c;g=c+16|0;if(!(a[b+72>>2]|0))return U=0,u=c,0;h=b+68|0;if(!(a[h>>2]|0&&a[b+76>>2]|0))return U=0,u=c,0;if(1==(w[b+126>>1]|0)&&6==(w[b+90>>1]|0)&&3==(w[b+98>>1]|0)&&0==(a[b+12>>2]&16384|0)){m=g+2|0;a[f>>2]=g;a[f+4>>2]=m;ne(b,530,f)|0;f=w[g>>1]|0;a:do switch(f<<16>>16){case 4:case 2:case 1:g=w[m>>1]|0;switch(g<<16>>16){case 4:case 2:case 1:break;default:break a}e=f&65535;m=g&65535;g=(E(m,e)|0)+2|0;f=a[h>>2]|0;e=f>>>0<(0-e|0)>>>0?((e+-1+f|0)>>>0)/(e>>>0)|
0:0;h=d>>>0<(0-m|0)>>>0?((d+-1+m|0)>>>0)/(m>>>0)|0:0;m=pd(b,e,0,g&65535,0,139738)|0;g=U;e=b+84|0;f=pd(b,m,g,N[e>>1]|0,0,139738)|0;h=pd(b,Qb(Oe(pd(b,m,g,N[e>>1]|0,0,139738)|0,U|0,3)|0,U|0,(0!=(f&7|0)|0)&1|0,0)|0,U,h,0,139738)|0;U=g=U;u=c;return h|0;default:g=w[m>>1]|0}while(0);m=a[b+628>>2]|0;a[e>>2]=f&65535;a[e+4>>2]=g&65535;Y(m,139738,139754,e);U=0;u=c;return 0}e=Uf(b)|0;m=pd(b,d,0,e,U,139738)|0;U=g=U;u=c;return m|0}function Og(b){b|=0;var d,c;d=u;u=u+16|0;c=Kf(b,a[b+72>>2]|0)|0;if((c|0)==(c|0)&
((0>(c|0))<<31>>31|0)==(U|0))return u=d,c|0;Y(a[b+628>>2]|0,139788,139721,d);u=d;return 0}function Wb(b,d,c,e){b|=0;d|=0;c|=0;var f;f=u;u=u+16|0;a[f>>2]=e|0;if(e=a[1933]|0)td[e&127](d,c,f);if(e=a[1932]|0)Ud[e&31](b,d,c,f);u=f}function Lc(b){b|=0;var d,c,e,f,g;d=b+608|0;c=a[d>>2]|0;if(0>=(c|0))return 1;e=b+12|0;f=a[e>>2]|0;if(!(f&1048576))return 1;g=b+588|0;(N[b+94>>1]|256)&f?e=f:(ye(a[g>>2]|0,c),e=a[e>>2]|0,c=a[d>>2]|0);if(!(dg(b,a[(0==(e&1024|0)?b+452|0:b+492|0)>>2]|0,a[g>>2]|0,c)|0))return 0;a[d>>
2]=0;a[b+604>>2]=a[g>>2];return 1}function dg(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q=0,y=0,B=0,H=0,t;f=u;u=u+32|0;g=f+16|0;h=f+8|0;m=f;k=b+172|0;l=(a[k>>2]|0)+(d<<3)|0;n=a[l>>2]|0;p=a[l+4>>2]|0;if((l=0==(n|0)&0==(p|0))||(q=b+456|0,y=q,B=a[y>>2]|0,H=a[y+4>>2]|0,0==(B|0)&0==(H|0))){a[b+168>>2]|0||Z(139801,139820,690,139832);H=b+176|0;B=(a[H>>2]|0)+(d<<3)|0;q=a[B>>2]|0;y=a[B+4>>2]|0;if(0==(q|0)&0==(y|0)||(B=(0>(e|0))<<31>>31,y>>>0<B>>>0|(y|0)==(B|0)&q>>>0<e>>>0|l))m=rb[a[b+640>>2]&63](a[b+
628>>2]|0,0,0,2)|0,p=U,l=(a[k>>2]|0)+(d<<3)|0,a[l>>2]=m,a[l+4>>2]=p,l=b+12|0,a[l>>2]|=2097152,y=m,t=p;else if(l=b+628|0,q=rb[a[b+640>>2]&63](a[l>>2]|0,n,p,0)|0,p=U,n=(a[k>>2]|0)+(d<<3)|0,(q|0)==(a[n>>2]|0)&&(p|0)==(a[n+4>>2]|0))y=q,t=p;else return p=a[l>>2]|0,a[m>>2]=a[b+444>>2],Y(p,139832,139850,m),u=f,0;m=p=b+456|0;a[m>>2]=y;a[m+4>>2]=t;H=t=(a[H>>2]|0)+(d<<3)|0;m=a[H>>2]|0;y=a[H+4>>2]|0;H=t;a[H>>2]=0;a[H+4>>2]=0;k=H=p;B=a[H>>2]|0;l=a[H+4>>2]|0;n=m;q=y}else k=q,l=H,q=n=-1;y=(0>(e|0))<<31>>31;m=Qb(B|
0,l|0,e|0,y|0)|0;H=b+12|0;p=0==(a[H>>2]&524288|0);t=m;m=p?0:U;if(m>>>0<l>>>0|(m|0)==(l|0)&t>>>0<B>>>0|m>>>0<y>>>0|(m|0)==(y|0)&t>>>0<e>>>0)return Y(a[b+628>>2]|0,139832,142108,h),u=f,0;h=b+628|0;if((Aa[a[b+636>>2]&63](a[h>>2]|0,c,e)|0)!=(e|0))return c=a[h>>2]|0,a[g>>2]=a[b+444>>2],Y(c,139832,139877,g),u=f,0;g=k;a[g>>2]=t;a[g+4>>2]=m;d=m=(a[b+176>>2]|0)+(d<<3)|0;b=Qb(a[d>>2]|0,a[d+4>>2]|0,e|0,y|0)|0;y=U;e=m;a[e>>2]=b;a[e+4>>2]=y;if((b|0)==(n|0)&(y|0)==(q|0))return u=f,1;a[H>>2]|=2097152;u=f;return 1}
function eb(a){a|=0;return(a?Hc(a)|0:0)|0}function ja(a){Gc(a|0)}function nf(a,d){return qi(a|0,d|0)|0}function $c(a,d,c){Va(a|0,(d|0)&255|0,c|0)|0}function Ab(a,d,c){Ec(a|0,d|0,c|0)|0}function of(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g;f=u;u=u+16|0;g=E(c,d)|0;0!=(c|0)&&((g>>>0)/(c>>>0)|0)!=(d|0)?(d=a[b+628>>2]|0,a[f>>2]=e,Y(d,e,139955,f),b=0):b=g;u=f;return b|0}function pd(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m,k,l=0;h=u;u=u+16|0;m=Cf(e|0,f|0,d|0,c|0)|0;k=U;0==(e|0)&0==(f|0)||(l=pf(m|0,
k|0,e|0,f|0)|0,(l|0)==(d|0)&(U|0)==(c|0))?b=k:(c=a[b+628>>2]|0,a[h>>2]=g,Y(c,g,139955,h),m=b=0);U=b;u=h;return m|0}function Bf(b,d,c,e,f){b|=0;c|=0;e|=0;f|=0;var g,h=0;g=u;u=u+16|0;if(0!=(c|0)&0!=(e|0)&&(h=nf(d|0,E(e,c)|0)|0,0!=(h|0)))return u=g,h|0;h=a[b+628>>2]|0;d=a[b>>2]|0;a[g>>2]=f;a[g+4>>2]=c;a[g+8>>2]=e;Y(h,d,139978,g);u=g;return 0}function Mf(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g=0;f=u;u=u+16|0;if(0!=(d|0)&0!=(c|0)&&(g=nf(0,E(c,d)|0)|0,0!=(g|0)))return u=f,g|0;g=a[b+628>>2]|0;b=a[b>>2]|0;a[f>>
2]=e;a[f+4>>2]=d;a[f+8>>2]=c;Y(g,b,139978,f);u=f;return 0}function Se(b){b|=0;var d,c,e,f;d=4;c=Hc(40)|0;a[c>>2]=0;c=Xc(b+624|0,1,c|0,d|0)|0;d=U;Wa=e=Wa=0;0!=(e|0)&0!=(pa|0)?((f=db(a[e>>2]|0,c|0,d|0)|0)||Vb(e|0,pa|0),U=pa):f=-1;for(f=1==(f|0)?U:0;!f;)if(Wa=0,ri(12,b|0),f=Wa,Wa=0,0!=(f|0)&0!=(pa|0)?((e=db(a[f>>2]|0,c|0,d|0)|0)||Vb(f|0,pa|0),U=pa):e=-1,1==(e|0))f=U;else break;Gc(c|0)}function Re(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m=0,k=0,l=0;e=4;f=Hc(40)|0;a[f>>2]=0;f=Xc(b+624|0,1,f|0,e|0)|0;e=U;Wa=
g=Wa=0;0!=(g|0)&0!=(pa|0)?((h=db(a[g>>2]|0,f|0,e|0)|0)||Vb(g|0,pa|0),U=pa):h=-1;for(h=1==(h|0)?U:0;;){if(h){m=-1;k=6;break}Wa=0;l=Pg(16,b|0,d|0,c|0)|0;h=Wa;Wa=0;0!=(h|0)&0!=(pa|0)?((g=db(a[h>>2]|0,f|0,e|0)|0)||Vb(h|0,pa|0),U=pa):g=-1;if(1==(g|0))h=U;else break}if(6==(k|0))return Gc(f|0),m|0;m=l;Gc(f|0);return m|0}function uf(b,d){b|=0;d|=0;var c,e,f,g,h=0,m=0;c=4;e=Hc(40)|0;a[e>>2]=0;e=Xc(b+624|0,1,e|0,c|0)|0;c=U;Wa=f=Wa=0;0!=(f|0)&0!=(pa|0)?((g=db(a[f>>2]|0,e|0,c|0)|0)||Vb(f|0,pa|0),U=pa):g=-1;for(g=
1==(g|0)?U:0;;){if(g){h=0;m=6;break}Wa=0;dk(2,b|0,d|0);g=Wa;Wa=0;0!=(g|0)&0!=(pa|0)?((f=db(a[g>>2]|0,e|0,c|0)|0)||Vb(g|0,pa|0),U=pa):f=-1;if(1==(f|0))g=U;else break}if(6==(m|0))return Gc(e|0),h|0;h=1;Gc(e|0);return h|0}function mg(b,d){b|=0;d|=0;var c,e,f,g,h=0,m=0;c=4;e=Hc(40)|0;a[e>>2]=0;e=Xc(b+624|0,1,e|0,c|0)|0;c=U;Wa=f=Wa=0;0!=(f|0)&0!=(pa|0)?((g=db(a[f>>2]|0,e|0,c|0)|0)||Vb(f|0,pa|0),U=pa):g=-1;for(g=1==(g|0)?U:0;;){if(g){h=0;m=6;break}Wa=0;Qi(12,b|0,d|0,0);g=Wa;Wa=0;0!=(g|0)&0!=(pa|0)?((f=
db(a[g>>2]|0,e|0,c|0)|0)||Vb(g|0,pa|0),U=pa):f=-1;if(1==(f|0))g=U;else break}if(6==(m|0))return Gc(e|0),h|0;h=1;Gc(e|0);return h|0}function eg(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m=0,k=0,l=0;e=4;f=Hc(40)|0;a[f>>2]=0;f=Xc(b+624|0,1,f|0,e|0)|0;e=U;Wa=g=Wa=0;0!=(g|0)&0!=(pa|0)?((h=db(a[g>>2]|0,f|0,e|0)|0)||Vb(g|0,pa|0),U=pa):h=-1;for(h=1==(h|0)?U:0;;){if(h){m=0;k=6;break}Wa=0;l=Mj(a[(a[b+4>>2]|0)+8>>2]|0,b|0,1,d|0,c|0)|0;h=Wa;Wa=0;0!=(h|0)&0!=(pa|0)?((g=db(a[h>>2]|0,f|0,e|0)|0)||Vb(h|0,pa|0),U=pa):g=-1;
if(1==(g|0))h=U;else break}if(6==(k|0))return Gc(f|0),m|0;m=l;Gc(f|0);return m|0}function qg(b){b|=0;var d,c,e,f,g=0,h=0,m=0;d=4;c=Hc(40)|0;a[c>>2]=0;c=Xc(b+624|0,1,c|0,d|0)|0;d=U;Wa=e=Wa=0;0!=(e|0)&0!=(pa|0)?((f=db(a[e>>2]|0,c|0,d|0)|0)||Vb(e|0,pa|0),U=pa):f=-1;for(f=1==(f|0)?U:0;;){if(f){g=-1;h=6;break}Wa=0;m=si(20,b|0)|0;f=Wa;Wa=0;0!=(f|0)&0!=(pa|0)?((e=db(a[f>>2]|0,c|0,d|0)|0)||Vb(f|0,pa|0),U=pa):e=-1;if(1==(e|0))f=U;else break}if(6==(h|0))return Gc(c|0),g|0;g=m;Gc(c|0);return g|0}function fg(b,
d){b|=0;d|=0;var c,e,f,g,h=0,m=0,k=0;c=4;e=Hc(40)|0;a[e>>2]=0;e=Xc(b+624|0,1,e|0,c|0)|0;c=U;Wa=f=Wa=0;0!=(f|0)&0!=(pa|0)?((g=db(a[f>>2]|0,e|0,c|0)|0)||Vb(f|0,pa|0),U=pa):g=-1;for(g=1==(g|0)?U:0;;){if(g){h=-1;m=6;break}Wa=0;k=Jk(30,b|0,d|0)|0;g=Wa;Wa=0;0!=(g|0)&0!=(pa|0)?((f=db(a[g>>2]|0,e|0,c|0)|0)||Vb(g|0,pa|0),U=pa):f=-1;if(1==(f|0))g=U;else break}if(6==(m|0))return Gc(e|0),h|0;h=k;Gc(e|0);return h|0}function mf(a,d,c){a=+a;d=+d;c|=0;var e,f;if(.016939999535679817>d)return a=vf(a,d)|0,a|0;e=0==
(c|0);f=285.7142768952314*(d+-.016939999535679817);f=e?f:f+4.656612875245797E-10*+(Xe()|0)+-.5;c=~~f;if(162<(c|0))return a=vf(a,d)|0,a|0;f=+W[107752+(c<<3)>>2];if(f>a)return a=vf(a,d)|0,a|0;f=285.7142768952314*(a-f);e=~~(e?f:f+4.656612875245797E-10*+(Xe()|0)+-.5);a=(e|0)<(w[(c<<3)+107756>>1]|0)?(w[(c<<3)+107758>>1]|0)+e|0:vf(a,d)|0;return a|0}function tf(a,d){a|=0;d|=0;var c,e=0,f,g,h,m=0,k=0,l,n,p,q=0;f=0;c=a>>>14&1023;if(0==(c|0)||(e=+xh(+(.010830424696249145*(+(c|0)+.5)+-8.317766166719343)),0>=
e))W[d+8>>2]=0,W[d+4>>2]=0,W[d>>2]=0;else{c=a&16383;if(16288<c>>>0)c=.210526316,f=.473684211;else{a=0;g=163;a:for(;;){for(h=a;;){if(1>=(g-h|0)){m=h;k=9;break a}l=h+g>>1;n=w[(l<<3)+107758>>1]|0;p=c-(n<<16>>16)|0;if(0<(p|0))h=l;else{g=l;break}}if(0>(p|0))a=h;else{q=n;f=g;break}}9==(k|0)&&(q=w[(m<<3)+107758>>1]|0,f=m);c=+W[107752+(f<<3)>>2]+.0035000001080334187*(+(c-(q<<16>>16)|0)+.5);f=.0035000001080334187*(+(f|0)+.5)+.016939999535679817}m=1/(6*c-16*f+12);k=9*c*m;c=4*f*m;W[d>>2]=k/c*e;W[d+4>>2]=e;W[d+
8>>2]=(1-k-c)/c*e}}function vf(b,d){b=+b;d=+d;var c,e,f,g,h,m,k,l,n,p;c=u;u=u+800|0;if(a[27282]|0)return e=+ek(+(d+-.473684211),+(b+-.210526316)),e=109132+(~~(15.915494277358546*e+50)<<2)|0,e=a[e>>2]|0,u=c,e|0;for(f=99;;)if(Hb[c+(f<<3)>>3]=2,f)f=f+-1|0;else{e=162;g=163;break}for(;;){h=.0035000001080334187*(+(e|0)+.5)+.016939999535679817;f=(w[(e<<3)+107756>>1]|0)+-1|0;switch(g|0){case 1:case 163:m=1;break;default:m=f}g=+W[107752+(e<<3)>>2];k=h+-.473684211;l=(e<<3)+107758|0;n=f;do h=15.915494277358546*
+ek(+k,+(.0035000001080334187*(+(n|0)+.5)+g+-.210526316))+50,f=~~h,h=+Kk(+(h-(+(f|0)+.5))),p=c+(f<<3)|0,h<+Hb[p>>3]&&(a[109132+(f<<2)>>2]=(w[l>>1]|0)+n,Hb[p>>3]=h),n=n-m|0;while(-1<(n|0));if(e)n=e,e=e+-1|0,g=n;else{f=99;k=100;break}}for(;;){do if(1.5<+Hb[c+(f<<3)>>3]){for(g=1;;){if(1.5>+Hb[c+(((g+f|0)%100|0)<<3)>>3]){h=g;break}e=g+1|0;if(50>(e|0))g=e;else{h=e;break}}g=k+99|0;e=-1;for(m=1;!(1.5>+Hb[c+(((g+e|0)%100|0)<<3)>>3]);)if(n=m+1|0,l=~m,50>(n|0))e=l,m=n;else{m=n;e=l;break}a[109132+(f<<2)>>2]=
(h|0)<(m|0)?a[109132+(((h+f|0)%100|0)<<2)>>2]:a[109132+(((g+e|0)%100|0)<<2)>>2]}while(0);if(f)m=f,f=f+-1|0,k=m;else break}a[27282]=1;e=+ek(+(d+-.473684211),+(b+-.210526316));e=109132+(~~(15.915494277358546*e+50)<<2)|0;e=a[e>>2]|0;u=c;return e|0}function xf(b){b|=0;var d,c,e,f,g;d=u;u=u+32|0;c=d+16|0;e=d+8|0;(f=a[b+576>>2]|0)||Z(154187,146646,1335,147323);-32691!=(w[b+90>>1]|0)&&Z(147339,146646,1336,147323);if(1!=(w[b+126>>1]|0))return Y(a[b+628>>2]|0,147323,147380,d),u=d,0;g=a[f>>2]|0;if(-1==(g|0)){switch(N[b+
84>>1]<<3|N[b+86>>1]|0){case 259:g=0;break;case 258:case 257:case 260:g=2;break;case 129:case 130:case 132:g=1;break;case 65:case 68:g=3;break;default:g=-1}switch(N[b+98>>1]|0){case 1:g=2==(g|0)?2:-1;break;case 3:g=2==(g|0)?-1:g;break;default:g=-1}a[f>>2]=g}switch(g|0){case 0:a[f+8>>2]=12;break;case 1:a[f+8>>2]=6;break;case 2:a[f+8>>2]=4;break;case 3:a[f+8>>2]=3;break;default:return Y(a[b+628>>2]|0,147323,147433,e),u=d,0}g=a[b+12>>2]&1024?E(a[b+72>>2]|0,a[b+68>>2]|0)|0:E(a[b+100>>2]|0,a[b+56>>2]|
0)|0;a[f+16>>2]=g;if(0!=(g|0)&&(e=eb(g<<2)|0,a[f+12>>2]=e,0!=(e|0)))return u=d,1;Y(a[b+628>>2]|0,147323,147254,c);u=d;return 0}function Vf(b){b|=0;var d,c,e,f,g;d=u;u=u+16|0;c=d+8|0;e=d;(f=a[b+576>>2]|0)||Z(154187,146646,1243,147148);-32692!=(w[b+90>>1]|0)&&Z(147164,146646,1244,147148);g=a[f>>2]|0;if(-1==(g|0)){switch(N[b+86>>1]|N[b+84>>1]<<6|N[b+98>>1]<<3|0){case 2059:g=0;break;case 1033:case 1034:case 1036:g=1;break;case 521:case 524:g=3;break;default:g=-1}a[f>>2]=g}switch(g|0){case 0:a[f+8>>2]=
4;break;case 1:a[f+8>>2]=2;break;case 3:a[f+8>>2]=1;break;default:return Y(a[b+628>>2]|0,147148,147203,e),u=d,0}g=a[b+12>>2]&1024?E(a[b+72>>2]|0,a[b+68>>2]|0)|0:E(a[b+100>>2]|0,a[b+56>>2]|0)|0;a[f+16>>2]=g;if(0!=(g|0)&&(e=eb(g<<1)|0,a[f+12>>2]=e,0!=(e|0)))return u=d,1;Y(a[b+628>>2]|0,147148,147254,c);u=d;return 0}function Ig(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,H,ka;d=u;u=u+64|0;c=d+48|0;e=d+40|0;f=d+32|0;g=d+16|0;h=d+8|0;m=a[b+576>>2]|0;1;k=m+226|0;t[k>>0]|0&&Z(148839,148429,989,148870);a:do if(3==
(w[b+98>>1]|0)){switch(w[b+90>>1]|0){case 10:case 6:break;default:break a}t[k>>0]=1;l=m+228|0;n=t[l>>0]|0;p=m+229|0;q=t[p>>0]|0;y=m+225|0;t[y>>0]=1;Xg(b)|0;B=m+230|0;(H=0==(t[B>>0]|0))?ka=t[l>>0]|0:(t[l>>0]=1,ka=t[p>>0]=1);t[y>>0]=0;y=n&255;n=ka<<24>>24==n<<24>>24&&(t[p>>0]|0)==q<<24>>24?17:13;13==(n|0)&&(H?(n=a[b+628>>2]|0,H=ka&255,ka=x[p>>0]|0,t[m+227>>0]|0?(a[g>>2]=H,a[g+4>>2]=ka,a[g+8>>2]=y,a[g+12>>2]=q&255,Wb(n,148870,149125,g)):(a[h>>2]=H,a[h+4>>2]=ka,Wb(n,148870,148970,h)),n=17):n=18);17==
(n|0)&&0!=(t[B>>0]|0)&&(n=18);if(18==(n|0)&&(H=a[b+628>>2]|0,t[m+227>>0]|0?(a[e>>2]=y,a[e+4>>2]=q&255,Wb(H,148870,149488,e)):Wb(H,148870,149258,f),t[B>>0]|0)){t[k>>0]=1;u=d;return}H=t[l>>0]|0;n=t[p>>0]|0;if((H&255)>=(n&255)){t[k>>0]=1;u=d;return}ka=a[b+628>>2]|0;a[c>>2]=H&255;a[c+4>>2]=n&255;Wb(ka,148870,149696,c);t[k>>0]=1;u=d;return}while(0);t[m+227>>0]|0&&Wb(a[b+628>>2]|0,148870,148894,d);t[m+228>>0]=1;t[m+229>>0]=1;t[m+230>>0]=0;t[k>>0]=1;u=d}function pg(b,d){b|=0;var c,e,f,g,h,m,k,l,n,p,q,y,
B,H,ka,z,Q,C,Ra;c=a[b+124>>2]|0;e=a[b+56>>2]|0;f=a[b+108>>2]|0;g=e+f|0;h=a[b+120>>2]|0;m=a[b+144>>2]|0;k=(a[b+44>>2]|0)+-262|0;l=f>>>0>k>>>0?f-k|0:0;k=a[b+64>>2]|0;n=a[b+52>>2]|0;p=e+(f+258)|0;q=a[b+116>>2]|0;y=m>>>0>q>>>0?q:m;m=b+112|0;B=e+(f+1)|0;H=e+(f+2)|0;ka=f+257|0;z=d|0;d=h;Q=h>>>0<(a[b+140>>2]|0)>>>0?c:c>>>2;c=t[e+(h+f)>>0]|0;for(b=t[e+(f+-1+h)>>0]|0;;){h=e+z|0;if((t[e+(z+d)>>0]|0)==c<<24>>24&&(t[e+(d+-1+z)>>0]|0)==b<<24>>24&&(t[h>>0]|0)==(t[g>>0]|0)&&(t[e+(z+1)>>0]|0)==(t[B>>0]|0)){h=e+(z+
2)|0;for(C=H;;){Ra=C+1|0;if((t[Ra>>0]|0)!=(t[h+1>>0]|0)){C=Ra;break}Ra=C+2|0;if((t[Ra>>0]|0)!=(t[h+2>>0]|0)){C=Ra;break}Ra=C+3|0;if((t[Ra>>0]|0)!=(t[h+3>>0]|0)){C=Ra;break}Ra=C+4|0;if((t[Ra>>0]|0)!=(t[h+4>>0]|0)){C=Ra;break}Ra=C+5|0;if((t[Ra>>0]|0)!=(t[h+5>>0]|0)){C=Ra;break}Ra=C+6|0;if((t[Ra>>0]|0)!=(t[h+6>>0]|0)){C=Ra;break}Ra=C+7|0;if((t[Ra>>0]|0)!=(t[h+7>>0]|0)){C=Ra;break}Ra=C+8|0;h=h+8|0;if(Ra>>>0<p>>>0&&(t[Ra>>0]|0)==(t[h>>0]|0))C=Ra;else{C=Ra;break}}C=C-p|0;h=C+258|0;if((h|0)>(d|0)){a[m>>
2]=z;if((h|0)>=(y|0)){e=h;f=20;break}Ra=h;c=t[e+(h+f)>>0]|0;C=t[e+(ka+C)>>0]|0}else Ra=d,C=b}else Ra=d,C=b;z=N[k+((z&n)<<1)>>1]|0;if(z>>>0<=l>>>0){e=Ra;f=20;break}if(Q=Q+-1|0)d=Ra,b=C;else{e=Ra;f=20;break}}return 20==(f|0)?(e>>>0>q>>>0?q:e)|0:0}function If(b){b|=0;var d,c;if(!b)return-2;d=a[b+28>>2]|0;if(!d)return-2;a[d+40>>2]=0;a[d+44>>2]=0;a[d+48>>2]=0;a[d+28>>2]=0;a[b+20>>2]=0;a[b+8>>2]=0;a[b+24>>2]=0;(c=a[d+8>>2]|0)&&(a[b+48>>2]=c&1);a[d>>2]=0;a[d+4>>2]=0;a[d+12>>2]=0;a[d+20>>2]=32768;a[d+32>>
2]=0;a[d+56>>2]=0;a[d+60>>2]=0;c=d+1328|0;a[d+108>>2]=c;a[d+80>>2]=c;a[d+76>>2]=c;a[d+7104>>2]=1;a[d+7108>>2]=-1;return 0}function Ug(b,d,c){b|=0;d|=0;var e;if(!d||56!=(c|0)|49!=(t[d>>0]|0))return-6;if(!b)return-2;d=b+24|0;a[d>>2]=0;c=b+32|0;(e=a[c>>2]|0)?c=e:(a[c>>2]=29,a[b+40>>2]=0,c=29);e=b+36|0;a[e>>2]|0||(a[e>>2]=6);e=Aa[c&63](a[b+40>>2]|0,1,7116)|0;if(!e)return-4;a[b+28>>2]=e;a[e+52>>2]=0;a[e+8>>2]=1;a[e+36>>2]=15;a[e+40>>2]=0;a[e+44>>2]=0;a[e+48>>2]=0;a[e+28>>2]=0;a[b+20>>2]=0;a[b+8>>2]=0;
a[d>>2]=0;a[b+48>>2]=1;a[e>>2]=0;a[e+4>>2]=0;a[e+12>>2]=0;a[e+20>>2]=32768;a[e+32>>2]=0;a[e+56>>2]=0;a[e+60>>2]=0;b=e+1328|0;a[e+108>>2]=b;a[e+80>>2]=b;a[e+76>>2]=b;a[e+7104>>2]=1;a[e+7108>>2]=-1;return 0}function Ji(b,d){b|=0;d|=0;var c=0,e=0,f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0,z=0,Q=0,C=0,Ra=0,V=0,r=0,J=0,I=0,G=0,L=0,K=0,E=0,v=0,O=0,M=0,T=0,X=0,P=0,Oa=0,A=0,D=0,ba=0,F=0,Te=0,R=0,ga=0,Ha=0,ma=0,bc=0,ha=0,U=0,Y=0,S=0,da=0,Z=0,fa=0,oa=0,sa=0,Kc=0,ua=0,Ia=0,Da=0,na=0,Na=0,W=0,Ca=0,
Ga=0,Ea=0,La=0,ca=0,aa=0,ja=0,ya=0,Aa=0,ra=0,pa=0,jb=0,mc=0,Wa=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,fe=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Ka=0,Ua=0,Qa=0,Jb=0,Va=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,eb=0,ub=0,nd=0,Zd=0,wb=0,Ab=0,Qd=0,zb=0,Ob=0,Tb=0,jf=0,ab=0,rb=0,pb=0,Qb=0,Hb=0,fb=0,Gb=0,Kb=0,lb=0,Wb=0,hc=0,Lb=0,ac=0,kd=0,Yb=0,kc=0,Pb=0,zc=0,Sb=0,oc=0,fc=0,jc=0,Ie=0,ic=0,Wd=0,Jd=
0,bd=0,Vb=0,Rc=0,yc=0,Be=0,db=0,$b=0,ec=0,lc=0,gk=0,hd=0,Bd=0,xj=0,Rb=0,od=0,tc=0,Xb=0,rc=0,ed=0,gd=0,cf=0,Gc=0,Jc=0,Ic=0,Lc=0,Yc=0,wc=0,id=0,dc=0,Ac=0,Sc=0,Tc=0,nc=0,Bc=0,Ce=0,vd=0,wd=0,Hc=0,Nf=0,vc=0,ug=0,Fc=0,Cc=0,Qc=0,xc=0,ce=0,oe=0,Wc=0,Oc=0,Df=0,md=0,Uc=0,Vc=0,hk=0,he=0,te=0,de=0,He=0,ue=0,rd=0,Xc=0,ae=0,De=0,be=0,Fd=0,Rd=0,Gd=0,$d=0,ge=0,ud=0,xd=0,ie=0,je=0,cd=0,Of=0,Dc=0,yd=0,Ad=0,sd=0,ad=0,dd=0,Ye=0,ld=0,ve=0,Je=0,ze=0,Qe=0,$c=0,Ze=0,jd=0,td=0,kf=0,Id=0,df=0,Ud=0,ef=0,Ue=0,Ke=0,Pd=0,$e=0,
Dd=0,Vd=0,Nd=0,ne=0,Ld=0,Nc=0,Mc=0,qc=0,qd=0,pe=0,uc=0,Pc=0,Wf=0,Cd=0,Od=0,Pf=0,Xd=0,Xf=0,pd=0,Yf=0,zd=0,Td=0,Sd=0,we=0,se=0,Ne=0,me=0,Oe=0,Pe=0,Md=0,Yd=0,xe=0,re=0,ye=0,le=0,Ve=0,We=0,sf=0,gf=0,nf=0,of=0,Kf=0,Lf=0,Mf=0,Xe=0,Sf=0,rf=0,yj=0,eh=0,mh=0,nh=0,qh=0,fh=0,ik=0,jk=0,Uf=0,Se=0,gg=0,Ae=0,qe=0,ee=0,uf=0,vf=0,yf=0,Bf=0,pf=0,Me=0,jg=0,bg=0,oh=0,Hf=0,rh=0,vg=0,ij=0,Re=0,mf=0,dg=0,mg=0,kk=0,wg=0,xg=0,yg=0,zg=0,Zf=0,ag=0,Ag=0,eg=0,qg=0,hg=0,fg=0,sh=0,Cf=0,tg=0,gh=0,Dg=0,Tf=0,qf=0,tf=0,wf=0,xf=0,Vf=
0,Ig=0,pg=0,sg=0,Ng=0,Og=0,Gf=0,If=0,Ug=0,Vg=0,yh=0,Jf=0,zf=0,ng=0,Af=0,og=0,rg=0,Kg=0,ih=0,lh=0,cg=0,Tg=0,kg=0,lg=0,Gg=0,Yg=0,$g=0,vh=0,wh=0,Pg=0,xh=0,Ch=0,Eg=0,kh=0,ki=0,Fh=0,Gh=0,Hh=0,Ih=0,Jh=0,Kh=0,Fg=0,Lh=0,Mh=0,Hg=0,Wg=0,Xg=0,Nh=0,Oh=0,Ph=0,Qh=0,Zg=0,Rh=0,Sh=0,jj=0,Th=0,Jg=0,ah=0,Ri=0,c=u;u=u+16|0;e=c;if(!b)return f=-2,u=c,f|0;g=a[b+28>>2]|0;if(!g)return f=-2,u=c,f|0;h=b+12|0;m=a[h>>2]|0;if(!m)return f=-2,u=c,f|0;k=a[b>>2]|0;if(0==(k|0)&&0!=(a[b+4>>2]|0))return f=-2,u=c,f|0;l=a[g>>2]|0;n=11==
(l|0)?a[g>>2]=12:l;l=b+16|0;p=a[l>>2]|0;q=b+4|0;y=a[q>>2]|0;B=g+56|0;H=g+60|0;ka=g+8|0;z=g+24|0;Q=e+1|0;C=g+16|0;Ra=g+32|0;V=b+24|0;r=g+36|0;J=g+20|0;I=b+48|0;G=g+64|0;L=g+12|0;K=2>(d+-5|0)>>>0;E=g+4|0;v=g+76|0;O=g+84|0;M=g+80|0;T=g+88|0;X=6==(d|0);P=g+7108|0;Oa=g+72|0;A=g+7112|0;D=g+68|0;ba=g+44|0;F=g+7104|0;Te=g+48|0;R=g+52|0;ga=g+40|0;Ha=b+20|0;ma=g+28|0;bc=e+2|0;ha=e+3|0;U=g+104|0;Y=g+96|0;S=g+100|0;da=g+624|0;Z=g+1328|0;fa=g+108|0;oa=g+112|0;sa=g+752|0;Kc=g+92|0;ua=m;m=n;n=a[H>>2]|0;Ia=y;Da=
a[B>>2]|0;na=p;Na=k;k=p;p=0;a:for(;;){b:do switch(m|0){case 28:W=ua;Ca=na;Ga=n;Ea=Ia;La=Da;ca=Na;aa=k;ja=1;break a;case 29:ya=ua;Aa=n;ra=Ia;pa=Da;jb=na;mc=Na;Wa=k;Ta=281;break a;case 30:f=-4;Ta=296;break a;case 0:Ya=a[ka>>2]|0;if(!Ya){a[g>>2]=12;Sa=n;mb=Ia;Db=Da;cc=na;Za=Na;ia=k;qa=ua;Ja=p;break b}if(16>n>>>0)for(ea=n,wa=Ia,Ma=Da,xa=Na;;){if(!wa){W=ua;Ca=na;Ga=ea;Ea=0;La=Ma;ca=xa;aa=k;ja=p;break a}$a=wa+-1|0;la=xa+1|0;Ba=(x[xa>>0]<<ea)+Ma|0;va=ea+8|0;if(16>va>>>0)ea=va,wa=$a,Ma=Ba,xa=la;else{za=va;
ta=$a;nb=Ba;sc=la;break}}else za=n,ta=Ia,nb=Da,sc=Na;if(35615==(nb|0)&0!=(Ya&2|0)){xa=Kd(0,0,0)|0;a[z>>2]=xa;t[e>>0]=31;t[Q>>0]=-117;xa=Kd(a[z>>2]|0,e,2)|0;a[z>>2]=xa;a[g>>2]=1;Sa=0;mb=ta;Db=0;cc=na;Za=sc;ia=k;qa=ua;Ja=p;break b}a[C>>2]=0;(xa=a[Ra>>2]|0)&&(a[xa+48>>2]=-1);if(0!=(Ya&1|0)&&0==((((nb<<8&65280)+(nb>>>8)|0)>>>0)%31|0)){if(8!=(nb&15|0)){a[V>>2]=154515;a[g>>2]=29;Sa=za;mb=ta;Db=nb;cc=na;Za=sc;ia=k;qa=ua;Ja=p;break b}xa=nb>>>4;Ma=za+-4|0;wa=(xa&15)+8|0;if(ea=a[r>>2]|0){if(wa>>>0>ea>>>0){a[V>>
2]=154542;a[g>>2]=29;Sa=Ma;mb=ta;Db=xa;cc=na;Za=sc;ia=k;qa=ua;Ja=p;break b}}else a[r>>2]=wa;a[J>>2]=1<<wa;wa=Si(0,0,0)|0;a[z>>2]=wa;a[I>>2]=wa;a[g>>2]=nb>>>12&2^11;Sa=0;mb=ta;Db=0;cc=na;Za=sc;ia=k;qa=ua;Ja=p;break b}a[V>>2]=154492;a[g>>2]=29;Sa=za;mb=ta;Db=nb;cc=na;Za=sc;ia=k;qa=ua;Ja=p;break;case 1:if(16>n>>>0)for(wa=n,xa=Ia,Ma=Da,ea=Na;;){if(!xa){W=ua;Ca=na;Ga=wa;Ea=0;La=Ma;ca=ea;aa=k;ja=p;break a}la=xa+-1|0;Ba=ea+1|0;$a=(x[ea>>0]<<wa)+Ma|0;va=wa+8|0;if(16>va>>>0)wa=va,xa=la,Ma=$a,ea=Ba;else{gb=
$a;hb=va;ob=la;Bb=Ba;break}}else gb=Da,hb=n,ob=Ia,Bb=Na;a[C>>2]=gb;if(8!=(gb&255|0)){a[V>>2]=154515;a[g>>2]=29;Sa=hb;mb=ob;Db=gb;cc=na;Za=Bb;ia=k;qa=ua;Ja=p;break b}if(gb&57344){a[V>>2]=154562;a[g>>2]=29;Sa=hb;mb=ob;Db=gb;cc=na;Za=Bb;ia=k;qa=ua;Ja=p;break b}(ea=a[Ra>>2]|0)&&(a[ea>>2]=gb>>>8&1);gb&512&&(t[e>>0]=gb,t[Q>>0]=gb>>>8,ea=Kd(a[z>>2]|0,e,2)|0,a[z>>2]=ea);a[g>>2]=2;qb=0;kb=ob;ib=0;Cb=Bb;Ta=47;break;case 2:32>n>>>0?(qb=n,kb=Ia,ib=Da,Cb=Na,Ta=47):(fe=Ia,sb=Da,Xa=Na,Ta=49);break;case 3:16>n>>>
0?(Fa=n,Pa=Ia,Eb=Da,vb=Na,Ta=55):(tb=Ia,bb=Da,Ib=Na,Ta=57);break;case 4:Mb=n;Ka=Ia;Ua=Da;Qa=Na;Ta=62;break;case 5:Jb=n;Va=Ia;yb=Da;cb=Na;Ta=73;break;case 6:gc=n;Ub=Ia;Fb=Da;eb=Na;Ta=83;break;case 7:ub=n;nd=Ia;Zd=Da;wb=Na;Ta=96;break;case 8:Ab=n;Qd=Ia;zb=Da;Ob=Na;Ta=109;break;case 9:if(32>n>>>0)for(ea=n,Ma=Ia,xa=Da,wa=Na;;){if(!Ma){W=ua;Ca=na;Ga=ea;Ea=0;La=xa;ca=wa;aa=k;ja=p;break a}Ya=Ma+-1|0;Ba=wa+1|0;la=(x[wa>>0]<<ea)+xa|0;ea=ea+8|0;if(32<=ea>>>0){Tb=Ya;jf=la;ab=Ba;break}else Ma=Ya,xa=la,wa=Ba}else Tb=
Ia,jf=Da,ab=Na;wa=lk(jf|0)|0;a[z>>2]=wa;a[I>>2]=wa;a[g>>2]=10;rb=0;pb=Tb;Qb=0;Hb=ab;Ta=121;break;case 10:rb=n;pb=Ia;Qb=Da;Hb=Na;Ta=121;break;case 11:fb=n;Gb=Ia;Kb=Da;lb=Na;Ta=124;break;case 12:Wb=n;hc=Ia;Lb=Da;ac=Na;Ta=125;break;case 13:wa=n&7;xa=Da>>>wa;Ma=n-wa|0;if(32>Ma>>>0)for(wa=Ma,ea=Ia,Ba=xa,la=Na;;){if(!ea){W=ua;Ca=na;Ga=wa;Ea=0;La=Ba;ca=la;aa=k;ja=p;break a}Ya=ea+-1|0;va=la+1|0;$a=(x[la>>0]<<wa)+Ba|0;kd=wa+8|0;if(32>kd>>>0)wa=kd,ea=Ya,Ba=$a,la=va;else{Yb=kd;kc=Ya;Pb=$a;zc=va;break}}else Yb=
Ma,kc=Ia,Pb=xa,zc=Na;la=Pb&65535;if((la|0)==(Pb>>>16^65535|0))if(a[G>>2]=la,a[g>>2]=14,X){W=ua;Ca=na;Ga=0;Ea=kc;La=0;ca=zc;aa=k;ja=p;break a}else{Sb=0;oc=kc;fc=0;jc=zc;Ta=143;break b}else{a[V>>2]=154626;a[g>>2]=29;Sa=Yb;mb=kc;Db=Pb;cc=na;Za=zc;ia=k;qa=ua;Ja=p;break b}case 14:Sb=n;oc=Ia;fc=Da;jc=Na;Ta=143;break;case 15:Ie=n;ic=Ia;Wd=Da;Jd=Na;Ta=144;break;case 16:if(14>n>>>0)for(la=n,Ba=Ia,ea=Da,wa=Na;;){if(!Ba){W=ua;Ca=na;Ga=la;Ea=0;La=ea;ca=wa;aa=k;ja=p;break a}va=Ba+-1|0;$a=wa+1|0;Ya=(x[wa>>0]<<
la)+ea|0;kd=la+8|0;if(14>kd>>>0)la=kd,Ba=va,ea=Ya,wa=$a;else{bd=kd;Vb=va;Rc=Ya;yc=$a;break}}else bd=n,Vb=Ia,Rc=Da,yc=Na;wa=(Rc&31)+257|0;a[Y>>2]=wa;ea=(Rc>>>5&31)+1|0;a[S>>2]=ea;Ba=(Rc>>>10&15)+4|0;a[Kc>>2]=Ba;la=Rc>>>14;xa=bd+-14|0;286<wa>>>0|30<ea>>>0?(a[V>>2]=154655,a[g>>2]=29,Sa=xa,mb=Vb,Db=la,cc=na,Za=yc,ia=k,qa=ua,Ja=p):(a[U>>2]=0,a[g>>2]=17,Be=Ba,db=0,$b=xa,ec=Vb,lc=la,gk=yc,Ta=154);break b;case 17:la=a[U>>2]|0;xa=a[Kc>>2]|0;la>>>0<xa>>>0?(Be=xa,db=la,$b=n,ec=Ia,lc=Da,gk=Na,Ta=154):(hd=la,
Bd=n,xj=Ia,Rb=Da,od=Na,Ta=155);break;case 18:tc=a[U>>2]|0;Xb=n;rc=Ia;ed=Da;gd=Na;cf=p;Ta=165;break;case 19:Gc=n;Jc=Ia;Ic=Da;Lc=Na;Yc=p;Ta=199;break;case 20:wc=n;id=Ia;dc=Da;Ac=Na;Sc=p;Ta=200;break;case 21:Tc=a[Oa>>2]|0;nc=n;Bc=Ia;Ce=Da;vd=Na;wd=p;Ta=218;break;case 22:Hc=n;Nf=Ia;vc=Da;ug=Na;Fc=p;Ta=225;break;case 23:Cc=a[Oa>>2]|0;Qc=n;xc=Ia;ce=Da;oe=Na;Wc=p;Ta=237;break;case 24:Oc=n;Df=Ia;md=Da;Uc=Na;Vc=p;Ta=243;break;case 25:if(!na){W=ua;Ca=0;Ga=n;Ea=Ia;La=Da;ca=Na;aa=k;ja=p;break a}t[ua>>0]=a[G>>
2];a[g>>2]=20;Sa=n;mb=Ia;Db=Da;cc=na+-1|0;Za=Na;ia=k;qa=ua+1|0;Ja=p;break;case 26:if(a[ka>>2]|0){if(32>n>>>0)for(la=n,xa=Ia,Ba=Da,ea=Na;;){if(!xa){W=ua;Ca=na;Ga=la;Ea=0;La=Ba;ca=ea;aa=k;ja=p;break a}wa=xa+-1|0;Ma=ea+1|0;$a=(x[ea>>0]<<la)+Ba|0;Ya=la+8|0;if(32>Ya>>>0)la=Ya,xa=wa,Ba=$a,ea=Ma;else{hk=Ya;he=wa;te=$a;de=Ma;break}}else hk=n,he=Ia,te=Da,de=Na;ea=k-na|0;a[Ha>>2]=(a[Ha>>2]|0)+ea;a[ma>>2]=(a[ma>>2]|0)+ea;(k|0)==(na|0)?He=a[z>>2]|0:(Ba=a[z>>2]|0,xa=ua+(0-ea)|0,ue=a[C>>2]|0?Kd(Ba,xa,ea)|0:Si(Ba,
xa,ea)|0,a[z>>2]=ue,He=a[I>>2]=ue);ea=0==(a[C>>2]|0);xa=lk(te|0)|0;if(((ea?xa:te)|0)==(He|0))rd=0,Xc=he,ae=0,De=de,be=na;else{a[V>>2]=154829;a[g>>2]=29;Sa=hk;mb=he;Db=te;cc=na;Za=de;ia=na;qa=ua;Ja=p;break b}}else rd=n,Xc=Ia,ae=Da,De=Na,be=k;a[g>>2]=27;Fd=rd;Rd=Xc;Gd=ae;$d=De;ge=be;Ta=273;break;case 27:Fd=n;Rd=Ia;Gd=Da;$d=Na;ge=k;Ta=273;break;default:Ta=295;break a}while(0);if(47==(Ta|0))for(;;){Ta=0;if(!kb){W=ua;Ca=na;Ga=qb;Ea=0;La=ib;ca=Cb;aa=k;ja=p;break a}xa=kb+-1|0;ea=Cb+1|0;Ba=(x[Cb>>0]<<qb)+
ib|0;qb=qb+8|0;if(32<=qb>>>0){fe=xa;sb=Ba;Xa=ea;Ta=49;break}else kb=xa,ib=Ba,Cb=ea,Ta=47}else if(121==(Ta|0)){Ta=0;if(!(a[L>>2]|0)){ud=ua;xd=rb;ie=pb;je=Qb;cd=na;Of=Hb;Ta=122;break}ea=Si(0,0,0)|0;a[z>>2]=ea;a[I>>2]=ea;a[g>>2]=11;fb=rb;Gb=pb;Kb=Qb;lb=Hb;Ta=124}else if(143==(Ta|0))Ta=0,a[g>>2]=15,Ie=Sb,ic=oc,Wd=fc,Jd=jc,Ta=144;else if(154==(Ta|0))for(Ta=0,ea=db,Ba=$b,xa=ec,la=lc,Ma=gk;;){if(3>Ba>>>0)for($a=Ba,wa=xa,Ya=la,va=Ma;;){if(!wa){W=ua;Ca=na;Ga=$a;Ea=0;La=Ya;ca=va;aa=k;ja=p;break a}kd=wa+-1|
0;Dc=va+1|0;yd=(x[va>>0]<<$a)+Ya|0;Ad=$a+8|0;if(3>Ad>>>0)$a=Ad,wa=kd,Ya=yd,va=Dc;else{sd=Ad;ad=kd;dd=yd;Ye=Dc;break}}else sd=Ba,ad=xa,dd=la,Ye=Ma;va=ea+1|0;a[U>>2]=va;w[g+112+(N[127246+(ea<<1)>>1]<<1)>>1]=dd&7;Ya=dd>>>3;wa=sd+-3|0;if(va>>>0<Be>>>0)ea=va,Ba=wa,xa=ad,la=Ya,Ma=Ye;else{hd=va;Bd=wa;xj=ad;Rb=Ya;od=Ye;Ta=155;break}}else if(273==(Ta|0)){Ta=0;if(!(a[ka>>2]|0)){ld=ua;ve=Fd;Je=Rd;ze=Gd;Qe=na;$c=$d;Ze=ge;Ta=280;break}if(!(a[C>>2]|0)){ld=ua;ve=Fd;Je=Rd;ze=Gd;Qe=na;$c=$d;Ze=ge;Ta=280;break}if(32>
Fd>>>0)for(Ma=Fd,la=Rd,xa=Gd,Ba=$d;;){if(!la){W=ua;Ca=na;Ga=Ma;Ea=0;La=xa;ca=Ba;aa=ge;ja=p;break a}ea=la+-1|0;Ya=Ba+1|0;wa=(x[Ba>>0]<<Ma)+xa|0;va=Ma+8|0;if(32>va>>>0)Ma=va,la=ea,xa=wa,Ba=Ya;else{jd=va;td=ea;kf=wa;Id=Ya;break}}else jd=Fd,td=Rd,kf=Gd,Id=$d;if((kf|0)==(a[ma>>2]|0)){ld=ua;ve=0;Je=td;ze=0;Qe=na;$c=Id;Ze=ge;Ta=280;break}a[V>>2]=154850;a[g>>2]=29;Sa=jd;mb=td;Db=kf;cc=na;Za=Id;ia=ge;qa=ua;Ja=p}do if(49==(Ta|0))Ta=0,(Ba=a[Ra>>2]|0)&&(a[Ba+4>>2]=sb),a[C>>2]&512&&(t[e>>0]=sb,t[Q>>0]=sb>>>8,
t[bc>>0]=sb>>>16,t[ha>>0]=sb>>>24,Ba=Kd(a[z>>2]|0,e,4)|0,a[z>>2]=Ba),a[g>>2]=3,Fa=0,Pa=fe,Eb=0,vb=Xa,Ta=55;else if(124==(Ta|0))if(Ta=0,K){W=ua;Ca=na;Ga=fb;Ea=Gb;La=Kb;ca=lb;aa=k;ja=p;break a}else Wb=fb,hc=Gb,Lb=Kb,ac=lb,Ta=125;else if(144==(Ta|0)){Ta=0;if(Ba=a[G>>2]|0){xa=Ba>>>0>ic>>>0?ic:Ba;Ba=xa>>>0>na>>>0?na:xa;if(!Ba){W=ua;Ca=na;Ga=Ie;Ea=ic;La=Wd;ca=Jd;aa=k;ja=p;break a}Ec(ua|0,Jd|0,Ba|0)|0;a[G>>2]=(a[G>>2]|0)-Ba;Sa=Ie;mb=ic-Ba|0;Db=Wd;cc=na-Ba|0;Za=Jd+Ba|0;ia=k;qa=ua+Ba|0}else a[g>>2]=11,Sa=
Ie,mb=ic,Db=Wd,cc=na,Za=Jd,ia=k,qa=ua;Ja=p}else if(155==(Ta|0)){Ta=0;if(19>hd>>>0){Ba=hd;do w[g+112+(N[127246+(Ba<<1)>>1]<<1)>>1]=0,Ba=Ba+1|0;while(19!=(Ba|0));a[U>>2]=19}a[fa>>2]=Z;a[v>>2]=Z;a[O>>2]=7;(Ba=ni(0,oa,19,fa,O,sa)|0)?(a[V>>2]=154691,a[g>>2]=29,Sa=Bd,mb=xj,Db=Rb,cc=na,Za=od,ia=k,qa=ua,Ja=Ba):(a[U>>2]=0,a[g>>2]=18,tc=0,Xb=Bd,rc=xj,ed=Rb,gd=od,cf=0,Ta=165)}while(0);b:do if(55==(Ta|0))for(;;){Ta=0;if(!Pa){W=ua;Ca=na;Ga=Fa;Ea=0;La=Eb;ca=vb;aa=k;ja=p;break a}Ba=Pa+-1|0;xa=vb+1|0;la=(x[vb>>0]<<
Fa)+Eb|0;Fa=Fa+8|0;if(16<=Fa>>>0){tb=Ba;bb=la;Ib=xa;Ta=57;break}else Pa=Ba,Eb=la,vb=xa,Ta=55}else if(125==(Ta|0)){Ta=0;if(a[E>>2]|0)xa=Wb&7,a[g>>2]=26,Sa=Wb-xa|0,mb=hc,Db=Lb>>>xa,cc=na,Za=ac;else{if(3>Wb>>>0)for(xa=Wb,la=hc,Ba=Lb,Ma=ac;;){if(!la){W=ua;Ca=na;Ga=xa;Ea=0;La=Ba;ca=Ma;aa=k;ja=p;break a}Ya=la+-1|0;wa=Ma+1|0;ea=(x[Ma>>0]<<xa)+Ba|0;va=xa+8|0;if(3>va>>>0)xa=va,la=Ya,Ba=ea,Ma=wa;else{df=va;Ud=Ya;ef=ea;Ue=wa;break}}else df=Wb,Ud=hc,ef=Lb,Ue=ac;a[E>>2]=ef&1;switch(ef>>>1&3|0){case 0:a[g>>2]=
13;break;case 1:a[v>>2]=125070;a[O>>2]=9;a[M>>2]=127118;a[T>>2]=5;a[g>>2]=19;if(X){Ke=ua;Pd=df;$e=Ud;Dd=ef;Vd=na;Nd=Ue;ne=k;Ld=p;Ta=133;break a}break;case 2:a[g>>2]=16;break;case 3:a[V>>2]=154607,a[g>>2]=29}Sa=df+-3|0;mb=Ud;Db=ef>>>3;cc=na;Za=Ue}ia=k;qa=ua;Ja=p}else if(165==(Ta|0)){Ta=0;Ma=a[Y>>2]|0;Ba=a[S>>2]|0;do if(tc>>>0<(Ba+Ma|0)>>>0){la=tc;xa=Ba;wa=Ma;ea=Xb;Ya=rc;va=ed;$a=gd;c:for(;;){Dc=(1<<a[O>>2])+-1|0;yd=Dc&va;kd=a[v>>2]|0;Ad=x[kd+(yd<<2)+1>>0]|0;if(ea>>>0<Ad>>>0)for(Nc=ea,Mc=Ya,qc=va,qd=
$a;;){if(!Mc){W=ua;Ca=na;Ga=Nc;Ea=0;La=qc;ca=qd;aa=k;ja=cf;break a}pe=Mc+-1|0;uc=qd+1|0;Pc=(x[qd>>0]<<Nc)+qc|0;Wf=Nc+8|0;Cd=Dc&Pc;Od=x[kd+(Cd<<2)+1>>0]|0;if(Wf>>>0<Od>>>0)Nc=Wf,Mc=pe,qc=Pc,qd=uc;else{Pf=Od;Xd=Cd;Xf=Wf;pd=pe;Yf=Pc;zd=uc;break}}else Pf=Ad,Xd=yd,Xf=ea,pd=Ya,Yf=va,zd=$a;qd=w[kd+(Xd<<2)+2>>1]|0;if(16<=(qd&65535)){switch(qd<<16>>16){case 16:qc=Pf+2|0;if(Xf>>>0<qc>>>0)for(Mc=Xf,Nc=pd,Dc=Yf,uc=zd;;){if(!Nc){W=ua;Ca=na;Ga=Mc;Ea=0;La=Dc;ca=uc;aa=k;ja=cf;break a}Pc=Nc+-1|0;pe=uc+1|0;Wf=(x[uc>>
0]<<Mc)+Dc|0;Cd=Mc+8|0;if(Cd>>>0<qc>>>0)Mc=Cd,Nc=Pc,Dc=Wf,uc=pe;else{Td=Cd;Sd=Pc;we=Wf;se=pe;break}}else Td=Xf,Sd=pd,we=Yf,se=zd;uc=we>>>Pf;Dc=Td-Pf|0;if(!la){Ne=uc;me=Dc;Oe=Sd;Pe=se;Ta=179;break c}Md=Dc+-2|0;Yd=(uc&3)+3|0;xe=Sd;re=uc>>>2;ye=N[g+112+(la+-1<<1)>>1]|0;le=se;break;case 17:uc=Pf+3|0;if(Xf>>>0<uc>>>0)for(Dc=Xf,Nc=pd,Mc=Yf,qc=zd;;){if(!Nc){W=ua;Ca=na;Ga=Dc;Ea=0;La=Mc;ca=qc;aa=k;ja=cf;break a}kd=Nc+-1|0;yd=qc+1|0;Ad=(x[qc>>0]<<Dc)+Mc|0;pe=Dc+8|0;if(pe>>>0<uc>>>0)Dc=pe,Nc=kd,Mc=Ad,qc=yd;
else{Ve=pe;We=kd;sf=Ad;gf=yd;break}}else Ve=Xf,We=pd,sf=Yf,gf=zd;qc=sf>>>Pf;Md=-3-Pf+Ve|0;Yd=(qc&7)+3|0;xe=We;re=qc>>>3;ye=0;le=gf;break;default:qc=Pf+7|0;if(Xf>>>0<qc>>>0)for(Mc=Xf,Nc=pd,Dc=Yf,uc=zd;;){if(!Nc){W=ua;Ca=na;Ga=Mc;Ea=0;La=Dc;ca=uc;aa=k;ja=cf;break a}yd=Nc+-1|0;Ad=uc+1|0;kd=(x[uc>>0]<<Mc)+Dc|0;pe=Mc+8|0;if(pe>>>0<qc>>>0)Mc=pe,Nc=yd,Dc=kd,uc=Ad;else{nf=pe;of=yd;Kf=kd;Lf=Ad;break}}else nf=Xf,of=pd,Kf=Yf,Lf=zd;uc=Kf>>>Pf;Md=-7-Pf+nf|0;Yd=(uc&127)+11|0;xe=of;re=uc>>>7;ye=0;le=Lf}if((la+Yd|
0)>>>0>(xa+wa|0)>>>0){Mf=Md;Xe=xe;Sf=re;rf=le;Ta=189;break}uc=ye&65535;Dc=Yd+-1|0;a[U>>2]=la+1;w[g+112+(la<<1)>>1]=uc;if(Dc){Nc=Dc;do Dc=a[U>>2]|0,Nc=Nc+-1|0,a[U>>2]=Dc+1,w[g+112+(Dc<<1)>>1]=uc;while(0!=(Nc|0))}yj=Md;eh=xe;mh=re;nh=le}else a[U>>2]=la+1,w[g+112+(la<<1)>>1]=qd,yj=Xf-Pf|0,eh=pd,mh=Yf>>>Pf,nh=zd;la=a[U>>2]|0;Nc=a[Y>>2]|0;xa=a[S>>2]|0;if(la>>>0>=(xa+Nc|0)>>>0){qh=Nc;fh=yj;ik=eh;jk=mh;Uf=nh;Ta=191;break}else wa=Nc,ea=yj,Ya=eh,va=mh,$a=nh}if(179==(Ta|0)){Ta=0;a[V>>2]=154716;a[g>>2]=29;Sa=
me;mb=Oe;Db=Ne;cc=na;Za=Pe;ia=k;qa=ua;Ja=cf;break b}else if(189==(Ta|0)){Ta=0;a[V>>2]=154716;a[g>>2]=29;Sa=Mf;mb=Xe;Db=Sf;cc=na;Za=rf;ia=k;qa=ua;Ja=cf;break b}else if(191==(Ta|0))if(Ta=0,29==(a[g>>2]|0)){Sa=fh;mb=ik;Db=jk;cc=na;Za=Uf;ia=k;qa=ua;Ja=cf;break b}else Se=qh,gg=fh,Ae=ik,qe=jk,ee=Uf}else Se=Ma,gg=Xb,Ae=rc,qe=ed,ee=gd;while(0);if(w[da>>1]|0)if(a[fa>>2]=Z,a[v>>2]=Z,a[O>>2]=9,Ma=ni(1,oa,Se,fa,O,sa)|0)a[V>>2]=154779,a[g>>2]=29,Sa=gg,mb=Ae,Db=qe,cc=na,Za=ee,ia=k,qa=ua,Ja=Ma;else if(a[M>>2]=a[fa>>
2],a[T>>2]=6,Ma=ni(2,g+112+(a[Y>>2]<<1)|0,a[S>>2]|0,fa,T,sa)|0)a[V>>2]=154807,a[g>>2]=29,Sa=gg,mb=Ae,Db=qe,cc=na,Za=ee,ia=k,qa=ua,Ja=Ma;else if(a[g>>2]=19,X){W=ua;Ca=na;Ga=gg;Ea=Ae;La=qe;ca=ee;aa=k;ja=0;break a}else Gc=gg,Jc=Ae,Ic=qe,Lc=ee,Yc=0,Ta=199;else a[V>>2]=154742,a[g>>2]=29,Sa=gg,mb=Ae,Db=qe,cc=na,Za=ee,ia=k,qa=ua,Ja=cf}while(0);if(57==(Ta|0)){Ta=0;if(Ma=a[Ra>>2]|0)a[Ma+8>>2]=bb&255,a[Ma+12>>2]=bb>>>8;a[C>>2]&512&&(t[e>>0]=bb,t[Q>>0]=bb>>>8,Ma=Kd(a[z>>2]|0,e,2)|0,a[z>>2]=Ma);a[g>>2]=4;Mb=
0;Ka=tb;Ua=0;Qa=Ib;Ta=62}else 199==(Ta|0)&&(Ta=0,a[g>>2]=20,wc=Gc,id=Jc,dc=Ic,Ac=Lc,Sc=Yc,Ta=200);do if(62==(Ta|0)){Ta=0;Ma=a[C>>2]|0;if(Ma&1024){if(16>Mb>>>0)for(Ba=Mb,$a=Ka,va=Ua,Ya=Qa;;){if(!$a){W=ua;Ca=na;Ga=Ba;Ea=0;La=va;ca=Ya;aa=k;ja=p;break a}ea=$a+-1|0;wa=Ya+1|0;xa=(x[Ya>>0]<<Ba)+va|0;Ba=Ba+8|0;if(16<=Ba>>>0){pf=ea;Me=xa;jg=wa;break}else $a=ea,va=xa,Ya=wa}else pf=Ka,Me=Ua,jg=Qa;a[G>>2]=Me;(Ya=a[Ra>>2]|0)&&(a[Ya+20>>2]=Me);Ma&512&&(t[e>>0]=Me,t[Q>>0]=Me>>>8,Ya=Kd(a[z>>2]|0,e,2)|0,a[z>>2]=Ya);
uf=0;vf=pf;yf=0;Bf=jg}else(Ba=a[Ra>>2]|0)&&(a[Ba+16>>2]=0),uf=Mb,vf=Ka,yf=Ua,Bf=Qa;a[g>>2]=5;Jb=uf;Va=vf;yb=yf;cb=Bf;Ta=73}else if(200==(Ta|0))if(Ta=0,257<na>>>0&5<id>>>0){a[h>>2]=ua;a[l>>2]=na;a[b>>2]=Ac;a[q>>2]=id;a[B>>2]=dc;a[H>>2]=wc;var th=b,bh=k,th=th|0,bh=bh|0,Bg=0,Ee=0,Uh=0,Vh=0,Wh=0,hh=0,Xh=0,kj=0,Yh=0,pi=0,zh=0,ch=0,$h=0,ai=0,Ti=0,Ui=0,qi=0,ri=0,ti=0,si=0,ei=0,xi=0,yi=0,fi=0,Ai=0,Di=0,Vi=0,Dh=0,jh=0,hi=0,Eh=0,Wi=0,ii=0,lj=0,lf=0,oi=0,af=0,ff=0,Le=0,Ki=0,mj=0,Zh=0,Li=0,Mi=0,Ni=0,Oi=0,sj=
0,nj=0,ph=0,$f=0,ke=0,Qf=0,Ef=0,Ff=0,Pi=0,Qi=0,Zi=0,zi=0,Bi=0,Ci=0,Xi=0,gi=0,tj=0,Qg=0,Ei=0,ji=0,Fi=0,Gi=0,li=0,oj=0,$i=0,aj=0,bj=0,cj=0,ig=0,Rf=0,Fe=0,Rg=0,mi=0,Yi=0,Hi=0,Ii=0,zj=0,uj=0,bi=0,Sg=0,ui=0,vi=0,ci=0,di=0,dj=0,ej=0,fj=0,gj=0,Ah=0,uh=0,Bh=0,Cg=0,wi=0,Aj=0,Bj=0,vj=0,pj=0,wj=0,qj=0,rj=0,Bg=a[th+28>>2]|0,Ee=a[th>>2]|0,Uh=th+4|0,Vh=Ee+((a[Uh>>2]|0)+-6)|0,Wh=th+12|0,hh=a[Wh>>2]|0,Xh=th+16|0,kj=a[Xh>>2]|0,Yh=hh+(kj+-258)|0,pi=a[Bg+44>>2]|0,zh=a[Bg+48>>2]|0,ch=a[Bg+52>>2]|0,$h=Bg+56|0,ai=Bg+60|
0,Ti=a[Bg+76>>2]|0,Ui=a[Bg+80>>2]|0,qi=(1<<a[Bg+84>>2])+-1|0,ri=(1<<a[Bg+88>>2])+-1|0,ti=hh+(kj+~bh)|0,bh=Bg+7104|0,kj=ch+-1|0,si=0==(zh|0),ei=(a[Bg+40>>2]|0)+-1|0,xi=ei+zh|0,yi=zh+-1|0,fi=ti+-1|0,Ai=ti-zh|0,Di=ti+-2|0,Vi=a[ai>>2]|0,Dh=a[$h>>2]|0,jh=Ee+-1|0,Ee=hh+-1|0;b:for(;;){15>Vi>>>0?(hh=jh+2|0,hi=Vi+16|0,Eh=((x[jh+1>>0]|0)<<Vi)+Dh+((x[hh>>0]|0)<<Vi+8)|0,Wi=hh):(hi=Vi,Eh=Dh,Wi=jh);hh=Eh&qi;ii=t[Ti+(hh<<2)>>0]|0;lj=w[Ti+(hh<<2)+2>>1]|0;lf=x[Ti+(hh<<2)+1>>0]|0;hh=Eh>>>lf;oi=hi-lf|0;do if(ii<<24>>
24){lf=hh;af=oi;ff=ii&255;for(Le=lj;;){if(ff&16){Ki=ff;mj=af;Zh=lf;Li=Le;break}if(ff&64){Mi=ff;Ni=af;Oi=lf;sj=Wi;nj=Ee;ph=57;break b}$f=(lf&(1<<ff)+-1)+(Le&65535)|0;ke=t[Ti+($f<<2)>>0]|0;Qf=w[Ti+($f<<2)+2>>1]|0;Ef=x[Ti+($f<<2)+1>>0]|0;$f=lf>>>Ef;Ff=af-Ef|0;if(ke<<24>>24)lf=$f,af=Ff,ff=ke&255,Le=Qf;else{Pi=$f;Qi=Ff;Zi=Qf;ph=6;break}}if(6==(ph|0))ph=0,zi=Pi,Bi=Qi,Ci=Zi&255,ph=7;else{Le=Li&65535;(ff=Ki&15)?(mj>>>0<ff>>>0?(af=Wi+1|0,Ei=mj+8|0,ji=((x[af>>0]|0)<<mj)+Zh|0,Fi=af):(Ei=mj,ji=Zh,Fi=Wi),Xi=Ei-
ff|0,gi=ji>>>ff,tj=Fi,Qg=(ji&(1<<ff)+-1)+Le|0):(Xi=mj,gi=Zh,tj=Wi,Qg=Le);15>Xi>>>0?(Le=tj+2|0,Gi=Xi+16|0,li=((x[tj+1>>0]|0)<<Xi)+gi+((x[Le>>0]|0)<<Xi+8)|0,oj=Le):(Gi=Xi,li=gi,oj=tj);Le=li&ri;ff=w[Ui+(Le<<2)+2>>1]|0;af=x[Ui+(Le<<2)+1>>0]|0;lf=li>>>af;Qf=Gi-af|0;af=x[Ui+(Le<<2)>>0]|0;if(af&16)mi=lf,Yi=Qf,Hi=af,Ii=ff;else for(Le=af,ke=lf,Ff=Qf,$f=ff;;){if(Le&64){$i=Ff;aj=ke;bj=oj;cj=Ee;ph=54;break b}Ef=(ke&(1<<Le)+-1)+($f&65535)|0;ig=w[Ui+(Ef<<2)+2>>1]|0;Rf=x[Ui+(Ef<<2)+1>>0]|0;Fe=ke>>>Rf;Rg=Ff-Rf|0;
Rf=x[Ui+(Ef<<2)>>0]|0;if(Rf&16){mi=Fe;Yi=Rg;Hi=Rf;Ii=ig;break}else Le=Rf,ke=Fe,Ff=Rg,$f=ig}$f=Ii&65535;Ff=Hi&15;Yi>>>0<Ff>>>0?(ke=oj+1|0,Le=((x[ke>>0]|0)<<Yi)+mi|0,ig=Yi+8|0,ig>>>0<Ff>>>0?(Rf=oj+2|0,zj=Yi+16|0,uj=((x[Rf>>0]|0)<<ig)+Le|0,bi=Rf):(zj=ig,uj=Le,bi=ke)):(zj=Yi,uj=mi,bi=oj);ke=(uj&(1<<Ff)+-1)+$f|0;$f=uj>>>Ff;Le=zj-Ff|0;Ff=Ee;ig=Ff-ti|0;if(ke>>>0<=ig>>>0){Rf=2-Qg|0;Rg=Qg+(4294967293<Rf>>>0?Rf:-3)|0;Rf=Rg-((Rg>>>0)%3|0)|0;Rg=Rf-ke|0;Fe=Ee+(0-ke)|0;Ef=Qg;Sg=Ee;do t[Sg+1>>0]=t[Fe+1>>0]|0,t[Sg+
2>>0]=t[Fe+2>>0]|0,Fe=Fe+3|0,Sg=Sg+3|0,t[Sg>>0]=t[Fe>>0]|0,Ef=Ef+-3|0;while(2<Ef>>>0);Ef=Qg+-3|0;(Ef|0)==(Rf|0)?(ui=Le,vi=$f,ci=bi,di=Ee+(Rf+3)|0):(Fe=Ee+(Rf+4)|0,t[Fe>>0]=t[Ee+(Rg+4)>>0]|0,1>=(Ef-Rf|0)>>>0||(Fe=Ee+(Rf+5)|0,t[Fe>>0]=t[Ee+(Rg+5)>>0]|0),ui=Le,vi=$f,ci=bi,di=Fe)}else{Fe=ke-ig|0;if(Fe>>>0>pi>>>0&&0!=(a[bh>>2]|0)){dj=$f;ej=Le;fj=bi;gj=Ee;ph=22;break b}if(si)if(Ef=ch+(ei-Fe)|0,Qg>>>0>Fe>>>0){Sg=Qg-Fe|0;ff=ke-Ff|0;af=Ef;Qf=Fe;lf=Ee;do af=af+1|0,lf=lf+1|0,t[lf>>0]=t[af>>0]|0,Qf=Qf+-1|0;while(0!=
(Qf|0));Ah=Ee+(fi+ff+(1-ke))|0;uh=Sg;Bh=Ee+(ti+ff)|0}else Ah=Ef,uh=Qg,Bh=Ee;else if(Fe>>>0<=zh>>>0)if(Qf=ch+(yi-Fe)|0,Qg>>>0<=Fe>>>0)Ah=Qf,uh=Qg,Bh=Ee;else{af=Qg-Fe|0;lf=ke-Ff|0;Cg=Qf;Qf=Fe;wi=Ee;do Cg=Cg+1|0,wi=wi+1|0,t[wi>>0]=t[Cg>>0]|0,Qf=Qf+-1|0;while(0!=(Qf|0));Ah=Ee+(fi+lf+(1-ke))|0;uh=af;Bh=Ee+(ti+lf)|0}else if(Qf=ch+(xi-Fe)|0,Cg=Fe-zh|0,Qg>>>0>Cg>>>0){wi=Qg-Cg|0;Ef=ke-Ff|0;ff=Qf;Sg=Cg;Cg=Ee;do ff=ff+1|0,Cg=Cg+1|0,t[Cg>>0]=t[ff>>0]|0,Sg=Sg+-1|0;while(0!=(Sg|0));Sg=Ee+(Ai+Ef)|0;if(wi>>>0>zh>>>
0){ff=wi-zh|0;Cg=kj;lf=zh;af=Sg;do Cg=Cg+1|0,af=af+1|0,t[af>>0]=t[Cg>>0]|0,lf=lf+-1|0;while(0!=(lf|0));Ah=Ee+(Di+Ef+(2-ke))|0;uh=ff;Bh=Ee+(ti+Ef)|0}else Ah=kj,uh=wi,Bh=Sg}else Ah=Qf,uh=Qg,Bh=Ee;if(2<uh>>>0){ke=uh+-3|0;Ff=(ke>>>0)%3|0;Fe=ke-Ff|0;ke=Ah;ig=uh;Rg=Bh;do t[Rg+1>>0]=t[ke+1>>0]|0,t[Rg+2>>0]=t[ke+2>>0]|0,ke=ke+3|0,Rg=Rg+3|0,t[Rg>>0]=t[ke>>0]|0,ig=ig+-3|0;while(2<ig>>>0);Aj=Ah+(Fe+3)|0;Bj=Ff;vj=Bh+(Fe+3)|0}else Aj=Ah,Bj=uh,vj=Bh;Bj?(ig=vj+1|0,t[ig>>0]=t[Aj+1>>0]|0,1<Bj>>>0?(ke=vj+2|0,t[ke>>
0]=t[Aj+2>>0]|0,ui=Le,vi=$f,ci=bi,di=ke):(ui=Le,vi=$f,ci=bi,di=ig)):(ui=Le,vi=$f,ci=bi,di=vj)}}}else zi=hh,Bi=oi,Ci=lj&255,ph=7;while(0);7==(ph|0)&&(ph=0,lj=Ee+1|0,t[lj>>0]=Ci,ui=Bi,vi=zi,ci=Wi,di=lj);if(di>>>0<Yh>>>0&ci>>>0<Vh>>>0)Vi=ui,Dh=vi,jh=ci,Ee=di;else{pj=ui;wj=vi;qj=ci;rj=di;break}}22==(ph|0)?(a[th+24>>2]=155777,a[Bg>>2]=29,pj=ej,wj=dj,qj=fj,rj=gj):54==(ph|0)?(a[th+24>>2]=155807,a[Bg>>2]=29,pj=$i,wj=aj,qj=bj,rj=cj):57==(ph|0)&&(Mi&32?a[Bg>>2]=11:(a[th+24>>2]=155829,a[Bg>>2]=29),pj=Ni,wj=
Oi,qj=sj,rj=nj);nj=pj>>>3;sj=pj-(nj<<3)|0;a[th>>2]=qj+(1-nj);a[Wh>>2]=rj+1;a[Uh>>2]=Vh+5-(qj+(0-nj));a[Xh>>2]=Yh+257-rj;a[$h>>2]=(1<<sj)+-1&wj;a[ai>>2]=sj;Ya=a[h>>2]|0;va=a[l>>2]|0;$a=a[b>>2]|0;Ba=a[q>>2]|0;wa=a[B>>2]|0;xa=a[H>>2]|0;11==(a[g>>2]|0)&&(a[P>>2]=-1);Sa=xa;mb=Ba;Db=wa;cc=va;Za=$a;ia=k;qa=Ya;Ja=Sc}else{a[P>>2]=0;Ya=(1<<a[O>>2])+-1|0;$a=Ya&dc;va=a[v>>2]|0;wa=t[va+($a<<2)+1>>0]|0;Ba=wa&255;if(Ba>>>0>wc>>>0)for(xa=wc,ea=id,la=dc,Nc=Ac;;){if(!ea){W=ua;Ca=na;Ga=xa;Ea=0;La=la;ca=Nc;aa=k;ja=Sc;
break a}uc=ea+-1|0;Dc=Nc+1|0;Mc=(x[Nc>>0]<<xa)+la|0;qc=xa+8|0;Ad=Ya&Mc;kd=t[va+(Ad<<2)+1>>0]|0;yd=kd&255;if(yd>>>0>qc>>>0)xa=qc,ea=uc,la=Mc,Nc=Dc;else{bg=kd;oh=yd;Hf=Ad;rh=qc;vg=uc;ij=Mc;Re=Dc;break}}else bg=wa,oh=Ba,Hf=$a,rh=wc,vg=id,ij=dc,Re=Ac;Nc=t[va+(Hf<<2)>>0]|0;la=w[va+(Hf<<2)+2>>1]|0;ea=Nc&255;if(0!=Nc<<24>>24&0==(ea&240|0)){xa=la&65535;Ya=(1<<oh+ea)+-1|0;ea=((ij&Ya)>>>oh)+xa|0;Ma=t[va+(ea<<2)+1>>0]|0;if(((Ma&255)+oh|0)>>>0>rh>>>0)for(Dc=rh,Mc=vg,uc=ij,qc=Re;;){if(!Mc){W=ua;Ca=na;Ga=Dc;Ea=
0;La=uc;ca=qc;aa=k;ja=Sc;break a}Ad=Mc+-1|0;yd=qc+1|0;kd=(x[qc>>0]<<Dc)+uc|0;pe=Dc+8|0;Wf=((kd&Ya)>>>oh)+xa|0;Pc=t[va+(Wf<<2)+1>>0]|0;if(((Pc&255)+oh|0)>>>0>pe>>>0)Dc=pe,Mc=Ad,uc=kd,qc=yd;else{mf=Wf;dg=Pc;mg=pe;kk=Ad;wg=kd;xg=yd;break}}else mf=ea,dg=Ma,mg=rh,kk=vg,wg=ij,xg=Re;qc=w[va+(mf<<2)+2>>1]|0;uc=t[va+(mf<<2)>>0]|0;yg=a[P>>2]=oh;zg=mg-oh|0;Zf=kk;ag=uc;Ag=dg;eg=qc;qg=wg>>>oh;hg=xg}else yg=0,zg=rh,Zf=vg,ag=Nc,Ag=bg,eg=la,qg=ij,hg=Re;qc=Ag&255;uc=qg>>>qc;Mc=zg-qc|0;a[P>>2]=yg+qc;a[G>>2]=eg&65535;
qc=ag&255;ag<<24>>24?qc&32?(a[P>>2]=-1,a[g>>2]=11,Sa=Mc,mb=Zf,Db=uc,cc=na,Za=hg,ia=k,qa=ua,Ja=Sc):qc&64?(a[V>>2]=155829,a[g>>2]=29,Sa=Mc,mb=Zf,Db=uc,cc=na,Za=hg,ia=k,qa=ua,Ja=Sc):(Dc=qc&15,a[Oa>>2]=Dc,a[g>>2]=21,Tc=Dc,nc=Mc,Bc=Zf,Ce=uc,vd=hg,wd=Sc,Ta=218):(a[g>>2]=25,Sa=Mc,mb=Zf,Db=uc,cc=na,Za=hg,ia=k,qa=ua,Ja=Sc)}while(0);if(73==(Ta|0)){Ta=0;uc=a[C>>2]|0;if(uc&1024)if(Mc=a[G>>2]|0,(Dc=Mc>>>0>Va>>>0?Va:Mc)?(qc=a[Ra>>2]|0,0!=(qc|0)&&(xa=a[qc+16>>2]|0,0!=(xa|0))?(Ya=(a[qc+20>>2]|0)-Mc|0,Mc=a[qc+24>>
2]|0,Ec(xa+Ya|0,cb|0,((Ya+Dc|0)>>>0>Mc>>>0?Mc-Ya|0:Dc)|0)|0,tg=a[C>>2]|0):tg=uc,tg&512&&(uc=Kd(a[z>>2]|0,cb,Dc)|0,a[z>>2]=uc),uc=(a[G>>2]|0)-Dc|0,fg=a[G>>2]=uc,sh=Va-Dc|0,Cf=cb+Dc|0):(fg=Mc,sh=Va,Cf=cb),fg){W=ua;Ca=na;Ga=Jb;Ea=sh;La=yb;ca=Cf;aa=k;ja=p;break}else gh=sh,Dg=Cf;else gh=Va,Dg=cb;a[G>>2]=0;a[g>>2]=6;gc=Jb;Ub=gh;Fb=yb;eb=Dg;Ta=83}else if(218==(Ta|0)){Ta=0;if(Tc){if(nc>>>0<Tc>>>0)for(Dc=nc,uc=Bc,Ya=Ce,Mc=vd;;){if(!uc){W=ua;Ca=na;Ga=Dc;Ea=0;La=Ya;ca=Mc;aa=k;ja=wd;break a}xa=uc+-1|0;qc=Mc+
1|0;$a=(x[Mc>>0]<<Dc)+Ya|0;Ba=Dc+8|0;if(Ba>>>0<Tc>>>0)Dc=Ba,uc=xa,Ya=$a,Mc=qc;else{Vf=Ba;Ig=xa;pg=$a;sg=qc;break}}else Vf=nc,Ig=Bc,pg=Ce,sg=vd;Mc=(a[G>>2]|0)+((1<<Tc)+-1&pg)|0;a[G>>2]=Mc;a[P>>2]=(a[P>>2]|0)+Tc;Tf=Mc;qf=Vf-Tc|0;tf=Ig;wf=pg>>>Tc;xf=sg}else Tf=a[G>>2]|0,qf=nc,tf=Bc,wf=Ce,xf=vd;a[A>>2]=Tf;a[g>>2]=22;Hc=qf;Nf=tf;vc=wf;ug=xf;Fc=wd;Ta=225}do if(83==(Ta|0)){Ta=0;if(a[C>>2]&2048){if(Ub)Gf=0;else{W=ua;Ca=na;Ga=gc;Ea=0;La=Fb;ca=eb;aa=k;ja=p;break a}for(;;)if(Mc=Gf+1|0,Ya=t[eb+Gf>>0]|0,uc=a[Ra>>
2]|0,0!=(uc|0)&&(Dc=a[uc+28>>2]|0,0!=(Dc|0))&&(qc=a[G>>2]|0,qc>>>0<(a[uc+32>>2]|0)>>>0)&&(a[G>>2]=qc+1,t[Dc+qc>>0]=Ya),qc=0!=Ya<<24>>24,qc&Ub>>>0>Mc>>>0)Gf=Mc;else{If=Mc;Ug=qc;break}a[C>>2]&512&&(la=Kd(a[z>>2]|0,eb,If)|0,a[z>>2]=la);la=Ub-If|0;Nc=eb+If|0;if(Ug){W=ua;Ca=na;Ga=gc;Ea=la;La=Fb;ca=Nc;aa=k;ja=p;break a}else Ng=la,Og=Nc}else(Mc=a[Ra>>2]|0)&&(a[Mc+28>>2]=0),Ng=Ub,Og=eb;a[G>>2]=0;a[g>>2]=7;ub=gc;nd=Ng;Zd=Fb;wb=Og;Ta=96}else if(225==(Ta|0)){Ta=0;Nc=(1<<a[T>>2])+-1|0;la=Nc&vc;va=a[M>>2]|0;Ma=
t[va+(la<<2)+1>>0]|0;ea=Ma&255;if(ea>>>0>Hc>>>0)for(qc=Hc,Mc=Nf,Ya=vc,Dc=ug;;){if(!Mc){W=ua;Ca=na;Ga=qc;Ea=0;La=Ya;ca=Dc;aa=k;ja=Fc;break a}uc=Mc+-1|0;$a=Dc+1|0;xa=(x[Dc>>0]<<qc)+Ya|0;Ba=qc+8|0;wa=Nc&xa;yd=t[va+(wa<<2)+1>>0]|0;kd=yd&255;if(kd>>>0>Ba>>>0)qc=Ba,Mc=uc,Ya=xa,Dc=$a;else{Vg=yd;yh=kd;Jf=wa;zf=Ba;ng=uc;Af=xa;og=$a;break}}else Vg=Ma,yh=ea,Jf=la,zf=Hc,ng=Nf,Af=vc,og=ug;Dc=t[va+(Jf<<2)>>0]|0;Ya=w[va+(Jf<<2)+2>>1]|0;Mc=Dc&255;if(Mc&240)kg=a[P>>2]|0,lg=zf,Gg=ng,Yg=Dc,$g=Vg,vh=Ya,wh=Af,Pg=og;else{qc=
Ya&65535;Nc=(1<<yh+Mc)+-1|0;Mc=((Af&Nc)>>>yh)+qc|0;$a=t[va+(Mc<<2)+1>>0]|0;if((($a&255)+yh|0)>>>0>zf>>>0)for(xa=zf,uc=ng,Ba=Af,wa=og;;){if(!uc){W=ua;Ca=na;Ga=xa;Ea=0;La=Ba;ca=wa;aa=k;ja=Fc;break a}kd=uc+-1|0;yd=wa+1|0;Ad=(x[wa>>0]<<xa)+Ba|0;pe=xa+8|0;Pc=((Ad&Nc)>>>yh)+qc|0;Wf=t[va+(Pc<<2)+1>>0]|0;if(((Wf&255)+yh|0)>>>0>pe>>>0)xa=pe,uc=kd,Ba=Ad,wa=yd;else{rg=Pc;Kg=Wf;ih=pe;lh=kd;cg=Ad;Tg=yd;break}}else rg=Mc,Kg=$a,ih=zf,lh=ng,cg=Af,Tg=og;wa=w[va+(rg<<2)+2>>1]|0;Ba=t[va+(rg<<2)>>0]|0;uc=(a[P>>2]|0)+
yh|0;kg=a[P>>2]=uc;lg=ih-yh|0;Gg=lh;Yg=Ba;$g=Kg;vh=wa;wh=cg>>>yh;Pg=Tg}wa=$g&255;Ba=wh>>>wa;uc=lg-wa|0;a[P>>2]=kg+wa;wa=Yg&255;wa&64?(a[V>>2]=155807,a[g>>2]=29,Sa=uc,mb=Gg,Db=Ba,cc=na,Za=Pg,ia=k,qa=ua,Ja=Fc):(a[D>>2]=vh&65535,xa=wa&15,a[Oa>>2]=xa,a[g>>2]=23,Cc=xa,Qc=uc,xc=Gg,ce=Ba,oe=Pg,Wc=Fc,Ta=237)}while(0);if(96==(Ta|0)){Ta=0;if(a[C>>2]&4096){if(nd)Eg=0;else{W=ua;Ca=na;Ga=ub;Ea=0;La=Zd;ca=wb;aa=k;ja=p;break}for(;;)if(Ba=Eg+1|0,uc=t[wb+Eg>>0]|0,xa=a[Ra>>2]|0,0!=(xa|0)&&(wa=a[xa+36>>2]|0,0!=(wa|
0))&&(qc=a[G>>2]|0,qc>>>0<(a[xa+40>>2]|0)>>>0)&&(a[G>>2]=qc+1,t[wa+qc>>0]=uc),qc=0!=uc<<24>>24,qc&nd>>>0>Ba>>>0)Eg=Ba;else{kh=Ba;ki=qc;break}a[C>>2]&512&&(qc=Kd(a[z>>2]|0,wb,kh)|0,a[z>>2]=qc);qc=nd-kh|0;Ba=wb+kh|0;if(ki){W=ua;Ca=na;Ga=ub;Ea=qc;La=Zd;ca=Ba;aa=k;ja=p;break}else xh=qc,Ch=Ba}else(Ba=a[Ra>>2]|0)&&(a[Ba+36>>2]=0),xh=nd,Ch=wb;a[g>>2]=8;Ab=ub;Qd=xh;zb=Zd;Ob=Ch;Ta=109}else if(237==(Ta|0)){Ta=0;if(Cc){if(Qc>>>0<Cc>>>0)for(Ba=Qc,qc=xc,uc=ce,wa=oe;;){if(!qc){W=ua;Ca=na;Ga=Ba;Ea=0;La=uc;ca=wa;
aa=k;ja=Wc;break a}xa=qc+-1|0;Nc=wa+1|0;la=(x[wa>>0]<<Ba)+uc|0;ea=Ba+8|0;if(ea>>>0<Cc>>>0)Ba=ea,qc=xa,uc=la,wa=Nc;else{Jh=ea;Kh=xa;Fg=la;Lh=Nc;break}}else Jh=Qc,Kh=xc,Fg=ce,Lh=oe;a[D>>2]=(a[D>>2]|0)+((1<<Cc)+-1&Fg);a[P>>2]=(a[P>>2]|0)+Cc;Fh=Jh-Cc|0;Gh=Kh;Hh=Fg>>>Cc;Ih=Lh}else Fh=Qc,Gh=xc,Hh=ce,Ih=oe;a[g>>2]=24;Oc=Fh;Df=Gh;md=Hh;Uc=Ih;Vc=Wc;Ta=243}do if(109==(Ta|0)){Ta=0;wa=a[C>>2]|0;if(wa&512){if(16>Ab>>>0)for(uc=Ab,qc=Qd,Ba=zb,Nc=Ob;;){if(!qc){W=ua;Ca=na;Ga=uc;Ea=0;La=Ba;ca=Nc;aa=k;ja=p;break a}la=
qc+-1|0;xa=Nc+1|0;ea=(x[Nc>>0]<<uc)+Ba|0;Ma=uc+8|0;if(16>Ma>>>0)uc=Ma,qc=la,Ba=ea,Nc=xa;else{Mh=Ma;Hg=la;Wg=ea;Xg=xa;break}}else Mh=Ab,Hg=Qd,Wg=zb,Xg=Ob;if((Wg|0)==(a[z>>2]&65535|0))Nh=0,Oh=Hg,Ph=0,Qh=Xg;else{a[V>>2]=154587;a[g>>2]=29;Sa=Mh;mb=Hg;Db=Wg;cc=na;Za=Xg;ia=k;qa=ua;Ja=p;break}}else Nh=Ab,Oh=Qd,Ph=zb,Qh=Ob;if(Nc=a[Ra>>2]|0)a[Nc+44>>2]=wa>>>9&1,a[Nc+48>>2]=1;Nc=Kd(0,0,0)|0;a[z>>2]=Nc;a[I>>2]=Nc;a[g>>2]=11;Sa=Nh;mb=Oh;Db=Ph;cc=na;Za=Qh;ia=k;qa=ua;Ja=p}else if(243==(Ta|0)){Ta=0;if(!na){W=ua;
Ca=0;Ga=Oc;Ea=Df;La=md;ca=Uc;aa=k;ja=Vc;break a}Nc=k-na|0;Ba=a[D>>2]|0;if(Ba>>>0>Nc>>>0){qc=Ba-Nc|0;if(qc>>>0>(a[ba>>2]|0)>>>0&&0!=(a[F>>2]|0)){a[V>>2]=155777;a[g>>2]=29;Sa=Oc;mb=Df;Db=md;cc=na;Za=Uc;ia=k;qa=ua;Ja=Vc;break}Nc=a[Te>>2]|0;qc>>>0>Nc>>>0?(Zg=uc=qc-Nc|0,Rh=(a[R>>2]|0)+((a[ga>>2]|0)-uc)|0):(Zg=qc,Rh=(a[R>>2]|0)+(Nc-qc)|0);Sh=qc=a[G>>2]|0;jj=Zg>>>0>qc>>>0?qc:Zg;Th=Rh}else jj=Sh=qc=a[G>>2]|0,Th=ua+(0-Ba)|0;Ba=jj>>>0>na>>>0?na:jj;a[G>>2]=Sh-Ba;qc=jj>>>0>na>>>0?na:jj;Nc=Ba;uc=Th;for(Ya=ua;;)if(t[Ya>>
0]=t[uc>>0]|0,Nc=Nc+-1|0)uc=uc+1|0,Ya=Ya+1|0;else break;Ya=na-Ba|0;uc=ua+qc|0;a[G>>2]|0||(a[g>>2]=20);Sa=Oc;mb=Df;Db=md;cc=Ya;Za=Uc;ia=k;qa=uc;Ja=Vc}while(0);ua=qa;m=a[g>>2]|0;n=Sa;Ia=mb;Da=Db;na=cc;Na=Za;k=ia;p=Ja}if(122==(Ta|0))return a[h>>2]=ud,a[l>>2]=cd,a[b>>2]=Of,a[q>>2]=ie,a[B>>2]=je,a[H>>2]=xd,f=2,u=c,f|0;if(133==(Ta|0))W=Ke,Ca=Vd,Ga=Pd+-3|0,Ea=$e,La=Dd>>>3,ca=Nd,aa=ne,ja=Ld;else if(280==(Ta|0))a[g>>2]=28,W=ld,Ca=Qe,Ga=ve,Ea=Je,La=ze,ca=$c,aa=Ze,ja=1;else if(281==(Ta|0))W=ya,Ca=jb,Ga=Aa,Ea=
ra,La=pa,ca=mc,aa=Wa,ja=-3;else{if(295==(Ta|0))return f=-2,u=c,f|0;if(296==(Ta|0))return u=c,f|0}a[h>>2]=W;a[l>>2]=Ca;a[b>>2]=ca;a[q>>2]=Ea;a[B>>2]=La;a[H>>2]=Ga;a[ga>>2]|0?Ta=286:(aa|0)!=(Ca|0)&&(ga=a[g>>2]|0,29>ga>>>0)&&4!=(d|0)|26>ga>>>0?Ta=286:(Jg=Ea,ah=Ca);if(286==(Ta|0)){if(hj(b,W,aa-Ca|0)|0)return a[g>>2]=30,f=-4,u=c,f|0;Jg=a[q>>2]|0;ah=a[l>>2]|0}l=aa-ah|0;q=b+8|0;a[q>>2]=y-Jg+(a[q>>2]|0);a[Ha>>2]=(a[Ha>>2]|0)+l;a[ma>>2]=(a[ma>>2]|0)+l;(aa|0)!=(ah|0)&0!=(a[ka>>2]|0)&&(ka=a[z>>2]|0,ma=(a[h>>
2]|0)+(0-l)|0,Ri=a[C>>2]|0?Kd(ka,ma,l)|0:Si(ka,ma,l)|0,a[z>>2]=Ri,a[I>>2]=Ri);Ri=a[g>>2]|0;a[b+44>>2]=(0!=(a[E>>2]|0)?64:0)+(a[H>>2]|0)+(11==(Ri|0)?128:0)+(19==(Ri|0)|14==(Ri|0)?256:0);f=0==(ja|0)&(4==(d|0)|(y|0)==(Jg|0)&(aa|0)==(ah|0))?-5:ja;u=c;return f|0}function wf(b){b|=0;var d,c,e,f,g;if(!b)return-2;d=b+28|0;c=a[d>>2]|0;if(!c)return-2;e=b+36|0;f=a[e>>2]|0;if(!f)return-2;g=a[c+52>>2]|0;b=b+40|0;g?(ub[f&31](a[b>>2]|0,g),e=a[e>>2]|0,c=a[d>>2]|0):e=f;ub[e&31](a[b>>2]|0,c);return a[d>>2]=0}function ng(b){b|=
0;var d,c,e,f,g,h,m,k,l,n;d=u;u=u+16|0;if(!b)return u=d,-2;c=a[b+28>>2]|0;if(!c)return u=d,-2;e=b+4|0;f=a[e>>2]|0;if(0==(f|0)&&8>(a[c+60>>2]|0)>>>0)return u=d,-5;if(31==(a[c>>2]|0))h=g=c+104|0,m=a[g>>2]|0;else{a[c>>2]=31;g=c+60|0;f=a[g>>2]|0;k=c+56|0;l=a[k>>2]<<(f&7);a[k>>2]=l;m=f&-8;a[g>>2]=m;if(7<m>>>0){f=7-m|0;n=(m+(4294967288<f>>>0?f:-8)|0)>>>3;f=n<<3;h=n+1|0;n=l;for(l=0;t[d+l>>0]=n,l=l+1|0,n>>>=8,(l|0)!=(h|0););a[k>>2]=n;a[g>>2]=m+-8-f;f=c+104|0;for(g=m=a[f>>2]=0;;)if(k=t[d+g>>0]|0,k=(k&255|
0)==((2>m>>>0?0:255)|0)?m+1|0:0==k<<24>>24?4-m|0:0,g=g+1|0,g>>>0<h>>>0&4>k>>>0)m=k;else{l=f;g=k;break}}else k=c+104|0,a[k>>2]=0,l=k,g=0;a[l>>2]=g;h=l;f=a[e>>2]|0;m=g}g=a[b>>2]|0;if(0!=(f|0)&4>m>>>0)for(l=m,k=0;;)if(m=t[g+k>>0]|0,l=(m&255|0)==((2>l>>>0?0:255)|0)?l+1|0:0==m<<24>>24?4-l|0:0,m=k+1|0,m>>>0<f>>>0&4>l>>>0)k=m;else{f=l;break}else f=m,m=0;a[h>>2]=f;a[e>>2]=(a[e>>2]|0)-m;a[b>>2]=g+m;g=b+8|0;e=(a[g>>2]|0)+m|0;a[g>>2]=e;if(4!=(f|0))return u=d,-3;f=b+20|0;m=a[f>>2]|0;a[c+40>>2]=0;a[c+44>>2]=0;
a[c+48>>2]=0;a[c+28>>2]=0;a[f>>2]=0;a[g>>2]=0;a[b+24>>2]=0;(h=a[c+8>>2]|0)&&(a[b+48>>2]=h&1);a[c+4>>2]=0;a[c+12>>2]=0;a[c+20>>2]=32768;a[c+32>>2]=0;a[c+56>>2]=0;a[c+60>>2]=0;h=c+1328|0;a[c+108>>2]=h;a[c+80>>2]=h;a[c+76>>2]=h;a[c+7104>>2]=1;a[c+7108>>2]=-1;a[g>>2]=e;a[f>>2]=m;a[c>>2]=11;u=d;return 0}function hj(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k;e=a[b+28>>2]|0;f=e+52|0;if(g=a[f>>2]|0)m=g;else if(h=Aa[a[b+32>>2]&63](a[b+40>>2]|0,1<<a[e+36>>2],1)|0,a[f>>2]=h)m=h;else return 1;g=e+40|0;(h=a[g>>2]|
0)?k=h:(b=1<<a[e+36>>2],a[g>>2]=b,a[e+48>>2]=0,a[e+44>>2]=0,k=b);if(k>>>0<=c>>>0)return Ec(m|0,d+(0-k)|0,k|0)|0,a[e+48>>2]=0,a[e+44>>2]=a[g>>2],0;h=e+48|0;b=a[h>>2]|0;k=k-b|0;k=k>>>0>c>>>0?c:k;Ec(m+b|0,d+(0-c)|0,k|0)|0;b=c-k|0;if((k|0)!=(c|0))return Ec(a[f>>2]|0,d+(0-b)|0,b|0)|0,a[h>>2]=b,a[e+44>>2]=a[g>>2],0;b=(a[h>>2]|0)+c|0;d=a[g>>2]|0;a[h>>2]=(b|0)==(d|0)?0:b;b=e+44|0;e=a[b>>2]|0;if(e>>>0>=d>>>0)return 0;a[b>>2]=e+c;return 0}function ni(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m,k,l,n,
p,q=0,y,B=0,H=0,ka=0,z=0,Q=0,C=0,Ra=0,V=0,r,x,I,G,L,K,E,v,O,M,T,X=0,P=0,Oa=0,A=0;h=u;u=u+64|0;m=h+32|0;k=h;l=m;n=l+32|0;do w[l>>1]=0,l=l+2|0;while((l|0)<(n|0));if(l=0==(c|0))q=a[f>>2]|0,y=5;else{n=0;do p=m+(N[d+(n<<1)>>1]<<1)|0,w[p>>1]=(w[p>>1]|0)+1<<16>>16,n=n+1|0;while((n|0)!=(c|0));n=w[m+30>>1]|0;p=a[f>>2]|0;n<<16>>16?(B=p,H=n,ka=15,y=6):(q=p,y=5)}if(5==(y|0))if(w[m+28>>1]|0)B=q,H=0,ka=14,y=6;else if(w[m+26>>1]|0)B=q,H=0,ka=13,y=6;else if(w[m+24>>1]|0)B=q,H=0,ka=12,y=6;else if(w[m+22>>1]|0)B=q,
H=0,ka=11,y=6;else if(w[m+20>>1]|0)B=q,H=0,ka=10,y=6;else if(w[m+18>>1]|0)B=q,H=0,ka=9,y=6;else if(w[m+16>>1]|0)B=q,H=0,ka=8,y=6;else if(w[m+14>>1]|0)B=q,H=0,ka=7,y=6;else if(w[m+12>>1]|0)B=q,H=0,y=ka=6;else if(w[m+10>>1]|0)B=q,H=0,ka=5,y=6;else if(w[m+8>>1]|0)B=q,H=0,ka=4,y=6;else if(w[m+6>>1]|0)B=q,H=0,ka=3,y=6;else if(w[m+4>>1]|0)B=q,H=0,ka=2,y=6;else if(w[m+2>>1]|0)z=0,Q=1<q>>>0?1:q,Ra=C=1;else return n=a[e>>2]|0,a[e>>2]=n+4,t[n>>0]=64,t[n+1>>0]=1,w[n+2>>1]=0,n=a[e>>2]|0,a[e>>2]=n+4,t[n>>0]=64,
t[n+1>>0]=1,w[n+2>>1]=0,a[f>>2]=1,u=h,0;a:do if(6==(y|0))for(q=B>>>0>ka>>>0?ka:B,n=1;;){if(w[m+(n<<1)>>1]|0){z=H;Q=q;C=ka;Ra=n;break a}p=n+1|0;if(p>>>0<ka>>>0)n=p;else{z=H;Q=q;C=ka;Ra=p;break}}while(0);ka=Q>>>0<Ra>>>0?Ra:Q;Q=w[m+2>>1]|0;H=2-(Q&65535)|0;if(0>(H|0))return u=h,-1;B=(H<<1)-(N[m+4>>1]|0)|0;if(0>(B|0))return u=h,-1;H=(B<<1)-(N[m+6>>1]|0)|0;if(0>(H|0))return u=h,-1;B=(H<<1)-(N[m+8>>1]|0)|0;if(0>(B|0))return u=h,-1;H=(B<<1)-(N[m+10>>1]|0)|0;if(0>(H|0))return u=h,-1;B=(H<<1)-(N[m+12>>1]|0)|
0;if(0>(B|0))return u=h,-1;H=(B<<1)-(N[m+14>>1]|0)|0;if(0>(H|0))return u=h,-1;B=(H<<1)-(N[m+16>>1]|0)|0;if(0>(B|0))return u=h,-1;H=(B<<1)-(N[m+18>>1]|0)|0;if(0>(H|0))return u=h,-1;B=(H<<1)-(N[m+20>>1]|0)|0;if(0>(B|0))return u=h,-1;H=(B<<1)-(N[m+22>>1]|0)|0;if(0>(H|0))return u=h,-1;B=(H<<1)-(N[m+24>>1]|0)|0;if(0>(B|0))return u=h,-1;H=(B<<1)-(N[m+26>>1]|0)|0;if(0>(H|0))return u=h,-1;B=(H<<1)-(N[m+28>>1]|0)|0;if(0>(B|0))return u=h,-1;H=(B<<1)-(z&65535)|0;if(0>(H|0)||0<(H|0)&&0==(b|0)|1!=(C|0))return u=
h,-1;w[k+2>>1]=0;w[k+4>>1]=Q;H=(N[m+4>>1]|0)+(Q&65535)|0;w[k+6>>1]=H;Q=(N[m+6>>1]|0)+(H&65535)|0;w[k+8>>1]=Q;H=(N[m+8>>1]|0)+(Q&65535)|0;w[k+10>>1]=H;Q=(N[m+10>>1]|0)+(H&65535)|0;w[k+12>>1]=Q;H=(N[m+12>>1]|0)+(Q&65535)|0;w[k+14>>1]=H;Q=(N[m+14>>1]|0)+(H&65535)|0;w[k+16>>1]=Q;H=(N[m+16>>1]|0)+(Q&65535)|0;w[k+18>>1]=H;Q=(N[m+18>>1]|0)+(H&65535)|0;w[k+20>>1]=Q;H=(N[m+20>>1]|0)+(Q&65535)|0;w[k+22>>1]=H;Q=(N[m+22>>1]|0)+(H&65535)|0;w[k+24>>1]=Q;H=(N[m+24>>1]|0)+(Q&65535)|0;w[k+26>>1]=H;Q=(N[m+26>>1]|0)+
(H&65535)|0;w[k+28>>1]=Q;w[k+30>>1]=(N[m+28>>1]|0)+(Q&65535);if(!l){l=0;do Q=w[d+(l<<1)>>1]|0,Q<<16>>16&&(H=k+((Q&65535)<<1)|0,Q=w[H>>1]|0,w[H>>1]=Q+1<<16>>16,w[g+((Q&65535)<<1)>>1]=l),l=l+1|0;while((l|0)!=(c|0))}switch(b|0){case 0:x=r=0;I=g;G=19;L=g;break;case 1:if(9<ka>>>0)return u=h,1;r=0;x=1;I=126834;G=256;L=126960;break;default:c=2==(b|0);if(c&9<ka>>>0)return u=h,1;r=c;x=0;I=127284;G=-1;L=127410}c=1<<ka;b=c+-1|0;l=ka&255;k=ka;H=Q=0;z=Ra;Ra=-1;B=a[e>>2]|0;q=0;n=c;a:for(;;){c=1<<k;p=H;K=z;for(H=
q;;){E=K-Q|0;q=E&255;v=w[g+(H<<1)>>1]|0;k=v&65535;(k|0)<(G|0)?(O=0,M=v):(k|0)<=(G|0)?(O=96,M=0):(O=w[L+(k<<1)>>1]&255,M=w[I+(k<<1)>>1]|0);k=1<<E;v=p>>>Q;z=c;do T=z,z=z-k|0,E=z+v|0,t[B+(E<<2)>>0]=O,t[B+(E<<2)+1>>0]=q,w[B+(E<<2)+2>>1]=M;while((T|0)!=(k|0));for(k=1<<K+-1;;)if(k&p)k>>>=1;else break;p=k?(k+-1&p)+k|0:0;k=H+1|0;v=m+(K<<1)|0;z=(w[v>>1]|0)+-1<<16>>16;w[v>>1]=z;if(!(z<<16>>16)){if((K|0)==(C|0)){X=q;P=p;Oa=B;A=n;break a}K=N[d+(N[g+(k<<1)>>1]<<1)>>1]|0}if(K>>>0<=ka>>>0)H=k;else if(z=p&b,(z|0)==
(Ra|0))H=k;else{q=k;Ra=z;O=p;M=K;break}}H=0==(Q|0)?ka:Q;K=B+(c<<2)|0;p=M-H|0;b:do if(M>>>0<C>>>0)for(z=M,k=p,v=1<<p;;){E=v-(N[m+(z<<1)>>1]|0)|0;if(1>(E|0)){B=k;break b}T=k+1|0;z=T+H|0;if(z>>>0>=C>>>0){B=T;break}else k=T,v=E<<1}else B=p;while(0);p=(1<<B)+n|0;if(x&852<p>>>0|r&592<p>>>0){V=1;y=44;break}c=a[e>>2]|0;t[c+(Ra<<2)>>0]=B;t[c+(Ra<<2)+1>>0]=l;w[c+(Ra<<2)+2>>1]=(K-c|0)>>>2;k=B;Q=H;H=O;z=M;B=K;n=p}if(44==(y|0))return u=h,V|0;P&&(t[Oa+(P<<2)>>0]=64,t[Oa+(P<<2)+1>>0]=X,w[Oa+(P<<2)+2>>1]=0);a[e>>
2]=(a[e>>2]|0)+(A<<2);a[f>>2]=ka;u=h;return 0}function Af(b,d,c,e){b|=0;c|=0;var f,g,h,m,k,l,n;f=b+5820|0;g=a[f>>2]|0;h=(e|0)&65535;e=b+5816|0;m=N[e>>1]|0|h<<g;w[e>>1]=m;13<(g|0)?(k=b+20|0,l=a[k>>2]|0,a[k>>2]=l+1,n=b+8|0,t[(a[n>>2]|0)+l>>0]=m,l=(N[e>>1]|0)>>>8&255,g=a[k>>2]|0,a[k>>2]=g+1,t[(a[n>>2]|0)+g>>0]=l,l=a[f>>2]|0,g=h>>>(16-l|0),h=w[e>>1]=g,m=l+-13|0):(h=m,m=g+3|0);g=h&255;a[f>>2]=m;8>=(m|0)?(h=b+20|0,0<(m|0)?(m=a[h>>2]|0,a[h>>2]=m+1,l=b+8|0,t[(a[l>>2]|0)+m>>0]=g,b=l):b=b+8|0):(h=b+20|0,l=
a[h>>2]|0,a[h>>2]=l+1,m=b+8|0,t[(a[m>>2]|0)+l>>0]=g,l=(N[e>>1]|0)>>>8&255,g=a[h>>2]|0,a[h>>2]=g+1,t[(a[m>>2]|0)+g>>0]=l,b=m);w[e>>1]=0;a[f>>2]=0;f=a[h>>2]|0;a[h>>2]=f+1;t[(a[b>>2]|0)+f>>0]=c;f=a[h>>2]|0;a[h>>2]=f+1;t[(a[b>>2]|0)+f>>0]=c>>>8;f=c&65535^65535;e=a[h>>2]|0;a[h>>2]=e+1;t[(a[b>>2]|0)+e>>0]=f;e=a[h>>2]|0;a[h>>2]=e+1;t[(a[b>>2]|0)+e>>0]=f>>>8;if(c)for(e=c,f=d|0;;)if(e=e+-1|0,d=t[f>>0]|0,c=a[h>>2]|0,a[h>>2]=c+1,t[(a[b>>2]|0)+c>>0]=d,e)f=f+1|0;else break}function jd(b){b|=0;var d,c,e,f,g;d=
b+5820|0;c=a[d>>2]|0;16==(c|0)?(e=b+5816|0,f=w[e>>1]&255,c=b+20|0,g=a[c>>2]|0,a[c>>2]=g+1,b=b+8|0,t[(a[b>>2]|0)+g>>0]=f,f=(N[e>>1]|0)>>>8&255,g=a[c>>2]|0,a[c>>2]=g+1,t[(a[b>>2]|0)+g>>0]=f,w[e>>1]=0,a[d>>2]=0):7>=(c|0)||(c=b+5816|0,e=w[c>>1]&255,f=b+20|0,g=a[f>>2]|0,a[f>>2]=g+1,t[(a[b+8>>2]|0)+g>>0]=e,w[c>>1]=(N[c>>1]|0)>>>8,a[d>>2]=(a[d>>2]|0)+-8)}function zd(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m=0,k=0,l,n,p,q,y,B,H,ka,z,Q;if(0<(a[b+132>>2]|0)){f=(a[b>>2]|0)+44|0;if(2==(a[f>>2]|0)){g=-201342849;
for(h=0;;){if(0!=(g&1|0)&&0!=(w[b+148+(h<<2)>>1]|0)){m=0;break}h=h+1|0;if(32<=(h|0)){k=6;break}else g>>>=1}a:do if(6==(k|0))if(0==(w[b+184>>1]|0)&&0==(w[b+188>>1]|0)&&0==(w[b+200>>1]|0))for(g=32;;){if(w[b+148+(g<<2)>>1]|0){m=1;break a}g=g+1|0;if(256<=(g|0)){m=0;break}}else m=1;while(0);a[f>>2]=m}sg(b,b+2840|0);sg(b,b+2852|0);m=a[b+2844>>2]|0;f=w[b+150>>1]|0;k=0==f<<16>>16;w[b+148+(m+1<<2)+2>>1]=-1;g=b+2752|0;h=b+2756|0;l=b+2748|0;n=k?138:7;p=k?3:4;k=0;q=f&65535;f=-1;a:for(;;){y=0;for(B=k;;){if((B|
0)>(m|0))break a;H=B+1|0;ka=w[b+148+(H<<2)+2>>1]|0;z=ka&65535;k=y+1|0;Q=(q|0)==(z|0);if((k|0)<(n|0)&Q)y=k,B=H;else{n=k;break}}(n|0)>=(p|0)?q?((q|0)!=(f|0)&&(B=b+2684+(q<<2)|0,w[B>>1]=(w[B>>1]|0)+1<<16>>16),w[l>>1]=(w[l>>1]|0)+1<<16>>16):11>(n|0)?w[g>>1]=(w[g>>1]|0)+1<<16>>16:w[h>>1]=(w[h>>1]|0)+1<<16>>16:(B=b+2684+(q<<2)|0,w[B>>1]=(N[B>>1]|0)+n);B=0==ka<<16>>16;y=q;n=B?138:Q?6:7;p=B|Q?3:4;k=H;q=z;f=y}f=a[b+2856>>2]|0;z=w[b+2442>>1]|0;q=0==z<<16>>16;w[b+2440+(f+1<<2)+2>>1]=-1;H=q?138:7;k=q?3:4;q=0;
Q=z&65535;z=-1;a:for(;;){p=0;for(n=q;;){if((n|0)>(f|0))break a;ka=n+1|0;n=w[b+2440+(ka<<2)+2>>1]|0;m=n&65535;y=p+1|0;B=(Q|0)==(m|0);if((y|0)<(H|0)&B)p=y,n=ka;else{p=n;q=y;y=B;break}}(q|0)>=(k|0)?Q?((Q|0)!=(z|0)&&(n=b+2684+(Q<<2)|0,w[n>>1]=(w[n>>1]|0)+1<<16>>16),w[l>>1]=(w[l>>1]|0)+1<<16>>16):11>(q|0)?w[g>>1]=(w[g>>1]|0)+1<<16>>16:w[h>>1]=(w[h>>1]|0)+1<<16>>16:(n=b+2684+(Q<<2)|0,w[n>>1]=(N[n>>1]|0)+q);n=0==p<<16>>16;p=Q;H=n?138:y?6:7;k=n|y?3:4;q=ka;Q=m;z=p}sg(b,b+2864|0);B=w[b+2746>>1]|0?18:w[b+2690>>
1]|0?17:w[b+2742>>1]|0?16:w[b+2694>>1]|0?15:w[b+2738>>1]|0?14:w[b+2698>>1]|0?13:w[b+2734>>1]|0?12:w[b+2702>>1]|0?11:w[b+2730>>1]|0?10:w[b+2706>>1]|0?9:w[b+2726>>1]|0?8:w[b+2710>>1]|0?7:w[b+2722>>1]|0?6:w[b+2714>>1]|0?5:w[b+2718>>1]|0?4:0==(w[b+2686>>1]|0)?2:3;z=b+5800|0;m=(3*B|0)+17+(a[z>>2]|0)|0;a[z>>2]=m;z=(m+10|0)>>>3;m=((a[b+5804>>2]|0)+10|0)>>>3;f=B;g=m>>>0>z>>>0?z:m}else m=c+5|0,f=0,g=m;h=m;if(0!=(d|0)&(c+4|0)>>>0<=g>>>0)Af(b,d,c,e);else if(m=b+5820|0,z=a[m>>2]|0,B=13<(z|0),(h|0)==(g|0)||4==
(a[b+136>>2]|0))Q=e+2&65535,ka=b+5816|0,q=N[ka>>1]|Q<<z,w[ka>>1]=q,B?(y=b+20|0,k=a[y>>2]|0,a[y>>2]=k+1,H=b+8|0,t[(a[H>>2]|0)+k>>0]=q,q=(N[ka>>1]|0)>>>8&255,k=a[y>>2]|0,a[y>>2]=k+1,t[(a[H>>2]|0)+k>>0]=q,q=a[m>>2]|0,w[ka>>1]=Q>>>(16-q|0),z=q+-13|0):z=z+3|0,a[m>>2]=z,Kg(b,127536,128688);else{q=e+4&65535;Q=b+5816|0;ka=N[Q>>1]|q<<z;w[Q>>1]=ka;B?(B=b+20|0,k=a[B>>2]|0,a[B>>2]=k+1,H=b+8|0,t[(a[H>>2]|0)+k>>0]=ka,k=(N[Q>>1]|0)>>>8&255,y=a[B>>2]|0,a[B>>2]=y+1,t[(a[H>>2]|0)+y>>0]=k,k=a[m>>2]|0,y=q>>>(16-k|0),
H=w[Q>>1]=y,q=k+-13|0):(H=ka,q=z+3|0);a[m>>2]=q;z=a[b+2844>>2]|0;ka=a[b+2856>>2]|0;k=z+65280&65535;y=H&65535|k<<q;w[Q>>1]=y;11<(q|0)?(q=b+20|0,H=a[q>>2]|0,a[q>>2]=H+1,B=b+8|0,t[(a[B>>2]|0)+H>>0]=y,H=(N[Q>>1]|0)>>>8&255,p=a[q>>2]|0,a[q>>2]=p+1,t[(a[B>>2]|0)+p>>0]=H,H=a[m>>2]|0,p=k>>>(16-H|0),w[Q>>1]=p,q=H+-11|0,H=p):(q=q+5|0,H=y);a[m>>2]=q;y=ka&65535;p=y<<q|H&65535;w[Q>>1]=p;11<(q|0)?(H=b+20|0,k=a[H>>2]|0,a[H>>2]=k+1,B=b+8|0,t[(a[B>>2]|0)+k>>0]=p,k=(N[Q>>1]|0)>>>8&255,q=a[H>>2]|0,a[H>>2]=q+1,t[(a[B>>
2]|0)+q>>0]=k,k=a[m>>2]|0,q=y>>>(16-k|0),w[Q>>1]=q,H=k+-11|0):(H=q+5|0,q=p);a[m>>2]=H;p=f+65533&65535;q=p<<H|q&65535;w[Q>>1]=q;12<(H|0)?(k=b+20|0,y=a[k>>2]|0,a[k>>2]=y+1,B=b+8|0,t[(a[B>>2]|0)+y>>0]=q,y=(N[Q>>1]|0)>>>8&255,H=a[k>>2]|0,a[k>>2]=H+1,t[(a[B>>2]|0)+H>>0]=y,y=a[m>>2]|0,H=p>>>(16-y|0),w[Q>>1]=H,l=B,n=k,k=H,q=y+-12|0):(l=b+8|0,n=b+20|0,k=q,q=H+4|0);a[m>>2]=q;y=k;for(H=0;k=N[b+2684+(x[155641+H>>0]<<2)+2>>1]|0,B=k<<q|y&65535,w[Q>>1]=B,13<(q|0)?(p=a[n>>2]|0,a[n>>2]=p+1,t[(a[l>>2]|0)+p>>0]=B,
p=(N[Q>>1]|0)>>>8&255,q=a[n>>2]|0,a[n>>2]=q+1,t[(a[l>>2]|0)+q>>0]=p,p=a[m>>2]|0,q=k>>>(16-p|0),k=w[Q>>1]=q,q=p+-13|0):(k=B,q=q+3|0),a[m>>2]=q,(H|0)!=(f|0);)y=k,H=H+1|0;H=b+148|0;kg(b,H,z);y=b+2440|0;kg(b,y,ka);Kg(b,H,y)}og(b);e&&(e=b+5820|0,k=a[e>>2]|0,8>=(k|0)?(q=b+5816|0,0<(k|0)&&(k=w[q>>1]&255,f=b+20|0,l=a[f>>2]|0,a[f>>2]=l+1,t[(a[b+8>>2]|0)+l>>0]=k)):(q=b+5816|0,k=w[q>>1]&255,l=b+20|0,f=a[l>>2]|0,a[l>>2]=f+1,n=b+8|0,t[(a[n>>2]|0)+f>>0]=k,k=(N[q>>1]|0)>>>8&255,f=a[l>>2]|0,a[l>>2]=f+1,t[(a[n>>2]|
0)+f>>0]=k),w[q>>1]=0,a[e>>2]=0)}function og(b){b|=0;var d;d=0;do w[b+148+(d<<2)>>1]=0,d=d+1|0;while(286!=(d|0));w[b+2440>>1]=0;w[b+2444>>1]=0;w[b+2448>>1]=0;w[b+2452>>1]=0;w[b+2456>>1]=0;w[b+2460>>1]=0;w[b+2464>>1]=0;w[b+2468>>1]=0;w[b+2472>>1]=0;w[b+2476>>1]=0;w[b+2480>>1]=0;w[b+2484>>1]=0;w[b+2488>>1]=0;w[b+2492>>1]=0;w[b+2496>>1]=0;w[b+2500>>1]=0;w[b+2504>>1]=0;w[b+2508>>1]=0;w[b+2512>>1]=0;w[b+2516>>1]=0;w[b+2520>>1]=0;w[b+2524>>1]=0;w[b+2528>>1]=0;w[b+2532>>1]=0;w[b+2536>>1]=0;w[b+2540>>1]=
0;w[b+2544>>1]=0;w[b+2548>>1]=0;w[b+2552>>1]=0;w[b+2556>>1]=0;w[b+2684>>1]=0;w[b+2688>>1]=0;w[b+2692>>1]=0;w[b+2696>>1]=0;w[b+2700>>1]=0;w[b+2704>>1]=0;w[b+2708>>1]=0;w[b+2712>>1]=0;w[b+2716>>1]=0;w[b+2720>>1]=0;w[b+2724>>1]=0;w[b+2728>>1]=0;w[b+2732>>1]=0;w[b+2736>>1]=0;w[b+2740>>1]=0;w[b+2744>>1]=0;w[b+2748>>1]=0;w[b+2752>>1]=0;w[b+2756>>1]=0;w[b+1172>>1]=1;a[b+5804>>2]=0;a[b+5800>>2]=0;a[b+5808>>2]=0;a[b+5792>>2]=0}function sg(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,y,B=0,H=0,ka=0,z=0,Q=0,C,Ra,
V,r,J,I,G;c=u;u=u+32|0;e=a[d>>2]|0;f=d+8|0;g=a[f>>2]|0;h=a[g>>2]|0;m=a[g+12>>2]|0;g=b+5200|0;a[g>>2]=0;k=b+5204|0;a[k>>2]=573;if(0<(m|0)){l=-1;for(n=0;;)if(w[e+(n<<2)>>1]|0?(q=(a[g>>2]|0)+1|0,a[g>>2]=q,a[b+2908+(q<<2)>>2]=n,t[b+5208+n>>0]=0,p=n):(w[e+(n<<2)+2>>1]=0,p=l),n=n+1|0,(n|0)==(m|0)){y=p;break}else l=p;p=a[g>>2]|0;2>(p|0)?(B=p,H=y,ka=3):(z=p,Q=y)}else B=0,H=-1,ka=3;if(3==(ka|0))if(ka=b+5800|0,y=b+5804|0,h)for(l=B,B=H;;)if(H=2>(B|0),p=B+1|0,C=H?p:B,Ra=H?p:0,p=l+1|0,a[g>>2]=p,a[b+2908+(p<<2)>>
2]=Ra,w[e+(Ra<<2)>>1]=1,t[b+5208+Ra>>0]=0,a[ka>>2]=(a[ka>>2]|0)+-1,a[y>>2]=(a[y>>2]|0)-(N[h+(Ra<<2)+2>>1]|0),Ra=a[g>>2]|0,2>(Ra|0))l=Ra,B=C;else{z=Ra;Q=C;break}else for(p=B,l=H;;)if(n=2>(l|0),q=l+1|0,C=n?q:l,Ra=n?q:0,q=p+1|0,a[g>>2]=q,a[b+2908+(q<<2)>>2]=Ra,w[e+(Ra<<2)>>1]=1,t[b+5208+Ra>>0]=0,a[ka>>2]=(a[ka>>2]|0)+-1,Ra=a[g>>2]|0,2>(Ra|0))p=Ra,l=C;else{z=Ra;Q=C;break}B=d+4|0;a[B>>2]=Q;l=z;for(h=(z|0)/2|0;;){z=a[b+2908+(h<<2)>>2]|0;y=b+5208+z|0;ka=h<<1;a:do if((ka|0)>(l|0))V=h;else for(C=e+(z<<2)|
0,Ra=h,p=l,H=ka;;){do if((H|0)<(p|0)){q=H|1;n=a[b+2908+(q<<2)>>2]|0;r=w[e+(n<<2)>>1]|0;J=a[b+2908+(H<<2)>>2]|0;I=w[e+(J<<2)>>1]|0;if((r&65535)>=(I&65535)){if(r<<16>>16!=I<<16>>16){G=H;break}if((x[b+5208+n>>0]|0)>(x[b+5208+J>>0]|0)){G=H;break}}G=q}else G=H;while(0);q=w[C>>1]|0;J=a[b+2908+(G<<2)>>2]|0;n=w[e+(J<<2)>>1]|0;if((q&65535)<(n&65535)){V=Ra;break a}if(q<<16>>16==n<<16>>16&&(x[y>>0]|0)<=(x[b+5208+J>>0]|0)){V=Ra;break a}a[b+2908+(Ra<<2)>>2]=J;H=G<<1;p=a[g>>2]|0;if((H|0)>(p|0)){V=G;break}else Ra=
G}while(0);a[b+2908+(V<<2)>>2]=z;if(1>=(h|0))break;l=a[g>>2]|0;h=h+-1|0}h=b+2912|0;l=a[g>>2]|0;V=m;do{m=a[h>>2]|0;G=l+-1|0;a[g>>2]=G;y=a[b+2908+(l<<2)>>2]|0;a[h>>2]=y;ka=b+5208+y|0;a:do if(3>(l|0))p=1;else for(Ra=e+(y<<2)|0,p=1,H=G,C=2;;){do if((C|0)<(H|0)){J=C|1;n=a[b+2908+(J<<2)>>2]|0;q=w[e+(n<<2)>>1]|0;I=a[b+2908+(C<<2)>>2]|0;r=w[e+(I<<2)>>1]|0;if((q&65535)>=(r&65535)){if(q<<16>>16!=r<<16>>16){q=C;break}if((x[b+5208+n>>0]|0)>(x[b+5208+I>>0]|0)){q=C;break}}q=J}else q=C;while(0);J=w[Ra>>1]|0;I=a[b+
2908+(q<<2)>>2]|0;n=w[e+(I<<2)>>1]|0;if((J&65535)<(n&65535))break a;if(J<<16>>16==n<<16>>16&&(x[ka>>0]|0)<=(x[b+5208+I>>0]|0))break a;a[b+2908+(p<<2)>>2]=I;C=q<<1;H=a[g>>2]|0;if((C|0)>(H|0)){p=q;break}else p=q}while(0);a[b+2908+(p<<2)>>2]=y;ka=a[h>>2]|0;G=(a[k>>2]|0)+-1|0;a[k>>2]=G;a[b+2908+(G<<2)>>2]=m;G=(a[k>>2]|0)+-1|0;a[k>>2]=G;a[b+2908+(G<<2)>>2]=ka;G=e+(V<<2)|0;w[G>>1]=(N[e+(ka<<2)>>1]|0)+(N[e+(m<<2)>>1]|0);z=t[b+5208+m>>0]|0;p=t[b+5208+ka>>0]|0;H=b+5208+V|0;t[H>>0]=(((z&255)<(p&255)?p:z)&255)+
1;z=V&65535;w[e+(ka<<2)+2>>1]=z;w[e+(m<<2)+2>>1]=z;a[h>>2]=V;z=a[g>>2]|0;a:do if(2>(z|0))y=1;else for(ka=1,p=z,C=2;;){do if((C|0)<(p|0)){Ra=C|1;I=a[b+2908+(Ra<<2)>>2]|0;n=w[e+(I<<2)>>1]|0;J=a[b+2908+(C<<2)>>2]|0;r=w[e+(J<<2)>>1]|0;if((n&65535)>=(r&65535)){if(n<<16>>16!=r<<16>>16){n=C;break}if((x[b+5208+I>>0]|0)>(x[b+5208+J>>0]|0)){n=C;break}}n=Ra}else n=C;while(0);Ra=w[G>>1]|0;J=a[b+2908+(n<<2)>>2]|0;I=w[e+(J<<2)>>1]|0;if((Ra&65535)<(I&65535)){y=ka;break a}if(Ra<<16>>16==I<<16>>16&&(x[H>>0]|0)<=(x[b+
5208+J>>0]|0)){y=ka;break a}a[b+2908+(ka<<2)>>2]=J;C=n<<1;p=a[g>>2]|0;if((C|0)>(p|0)){y=n;break}else ka=n}while(0);a[b+2908+(y<<2)>>2]=V;V=V+1|0;l=a[g>>2]|0}while(1<(l|0));l=a[h>>2]|0;h=(a[k>>2]|0)+-1|0;a[k>>2]=h;a[b+2908+(h<<2)>>2]=l;l=a[d>>2]|0;d=a[B>>2]|0;B=a[f>>2]|0;f=a[B>>2]|0;h=a[B+4>>2]|0;g=a[B+8>>2]|0;V=a[B+16>>2]|0;B=b+2876|0;y=B+32|0;do w[B>>1]=0,B=B+2|0;while((B|0)<(y|0));B=a[k>>2]|0;w[l+(a[b+2908+(B<<2)>>2]<<2)+2>>1]=0;k=B+1|0;a:do if(573>(k|0)){B=b+5800|0;y=b+5804|0;if(f)for(p=k,n=0;G=
a[b+2908+(p<<2)>>2]|0,H=l+(G<<2)+2|0,m=N[l+(N[H>>1]<<2)+2>>1]|0,z=(q=(m|0)<(V|0))?m+1|0:V,m=(q&1^1)+n|0,w[H>>1]=z,(G|0)<=(d|0)&&(H=b+2876+(z<<1)|0,w[H>>1]=(w[H>>1]|0)+1<<16>>16,n=(G|0)<(g|0)?0:a[h+(G-g<<2)>>2]|0,H=N[l+(G<<2)>>1]|0,q=E(H,n+z|0)|0,a[B>>2]=q+(a[B>>2]|0),q=E((N[f+(G<<2)+2>>1]|0)+n|0,H)|0,a[y>>2]=q+(a[y>>2]|0)),p=p+1|0,573!=(p|0);)n=m;else for(n=k,p=0;;)if(q=a[b+2908+(n<<2)>>2]|0,H=l+(q<<2)+2|0,G=N[l+(N[H>>1]<<2)+2>>1]|0,m=(z=(G|0)<(V|0))?G+1|0:V,G=(z&1^1)+p|0,w[H>>1]=m,(q|0)<=(d|0)&&
(H=b+2876+(m<<1)|0,w[H>>1]=(w[H>>1]|0)+1<<16>>16,H=(q|0)<(g|0)?0:a[h+(q-g<<2)>>2]|0,H=E(N[l+(q<<2)>>1]|0,H+m|0)|0,a[B>>2]=H+(a[B>>2]|0)),n=n+1|0,573==(n|0)){m=G;break}else p=G;if(m){n=b+2876+(V<<1)|0;for(p=m;;){for(y=V;;)if(m=y+-1|0,q=b+2876+(m<<1)|0,H=w[q>>1]|0,H<<16>>16){m=q;G=y;break}else y=m;w[m>>1]=H+-1<<16>>16;y=b+2876+(G<<1)|0;w[y>>1]=(N[y>>1]|0)+2;y=(w[n>>1]|0)+-1<<16>>16;w[n>>1]=y;if(2<(p|0))p=p+-2|0;else{n=y;break}}if(V)for(p=n,n=V,y=573;;){H=n&65535;if(p<<16>>16)for(q=y,m=p&65535;;){for(G=
q;;)if(z=G+-1|0,y=a[b+2908+(z<<2)>>2]|0,(y|0)>(d|0))G=z;else{f=z;g=y;break}G=l+(g<<2)+2|0;y=N[G>>1]|0;(n|0)!=(y|0)&&(z=E(N[l+(g<<2)>>1]|0,n-y|0)|0,a[B>>2]=z+(a[B>>2]|0),w[G>>1]=H);if(m=m+-1|0)q=f;else{h=f;break}}else h=y;q=n+-1|0;if(!q)break a;p=w[b+2876+(q<<1)>>1]|0;n=q;y=h}}}while(0);h=1;f=0;do f=(N[b+2876+(h+-1<<1)>>1]|0)+(f&65534)<<1,w[c+(h<<1)>>1]=f,h=h+1|0;while(16!=(h|0));if(!(0>(Q|0)))for(l=0;;){h=w[e+(l<<2)+2>>1]|0;f=h&65535;if(h<<16>>16){h=c+(f<<1)|0;b=w[h>>1]|0;w[h>>1]=b+1<<16>>16;h=f;
f=b&65535;for(b=0;;)if(g=b|f&1,1<(h|0))h=h+-1|0,f>>>=1,b=g<<1;else{B=g;break}w[e+(l<<2)>>1]=B}if((l|0)==(Q|0))break;else l=l+1|0}u=c}function Kg(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C;e=b+5792|0;if(a[e>>2]|0){g=b+5796|0;f=b+5784|0;h=b+5820|0;m=b+5816|0;k=b+20|0;l=b+8|0;n=0;do p=w[(a[g>>2]|0)+(n<<1)>>1]|0,q=p&65535,y=x[(a[f>>2]|0)+n>>0]|0,n=n+1|0,p<<16>>16?(p=x[155385+y>>0]|0,z=(p|256)+1|0,B=N[d+(z<<2)+2>>1]|0,H=a[h>>2]|0,Q=N[d+(z<<2)>>1]|0,z=N[m>>1]|0|Q<<H,ka=z&65535,w[m>>1]=
ka,(H|0)>(16-B|0)?(C=a[k>>2]|0,a[k>>2]=C+1,t[(a[l>>2]|0)+C>>0]=z,z=(N[m>>1]|0)>>>8&255,C=a[k>>2]|0,a[k>>2]=C+1,t[(a[l>>2]|0)+C>>0]=z,z=a[h>>2]|0,C=Q>>>(16-z|0)&65535,ka=w[m>>1]=C,C=B+-16+z|0):C=H+B|0,a[h>>2]=C,B=a[110168+(p<<2)>>2]|0,20>(p+-8|0)>>>0?(H=y-(a[110284+(p<<2)>>2]|0)&65535,ka=H<<C|ka&65535,z=ka&65535,w[m>>1]=z,(C|0)>(16-B|0)?(C=a[k>>2]|0,a[k>>2]=C+1,t[(a[l>>2]|0)+C>>0]=ka,ka=(N[m>>1]|0)>>>8&255,C=a[k>>2]|0,a[k>>2]=C+1,t[(a[l>>2]|0)+C>>0]=ka,ka=a[h>>2]|0,C=H>>>(16-ka|0)&65535,w[m>>1]=C,
H=B+-16+ka|0,y=a[h>>2]=H,ka=C):(C=C+B|0,y=a[h>>2]=C,ka=z)):y=C,B=q+-1|0,p=x[154873+(256>B>>>0?B:(B>>>7)+256|0)>>0]|0,z=N[c+(p<<2)+2>>1]|0,C=N[c+(p<<2)>>1]|0,H=ka&65535|C<<y,ka=H&65535,w[m>>1]=ka,(y|0)>(16-z|0)?(Q=a[k>>2]|0,a[k>>2]=Q+1,t[(a[l>>2]|0)+Q>>0]=H,H=(N[m>>1]|0)>>>8&255,Q=a[k>>2]|0,a[k>>2]=Q+1,t[(a[l>>2]|0)+Q>>0]=H,H=a[h>>2]|0,Q=C>>>(16-H|0)&65535,w[m>>1]=Q,q=z+-16+H|0,y=Q):(q=y+z|0,y=ka),a[h>>2]=q,ka=a[110400+(p<<2)>>2]|0,26>(p+-4|0)>>>0?(z=B-(a[110520+(p<<2)>>2]|0)&65535,p=z<<q|y&65535,
B=p&65535,w[m>>1]=B,(q|0)>(16-ka|0)?(Q=a[k>>2]|0,a[k>>2]=Q+1,t[(a[l>>2]|0)+Q>>0]=p,p=(N[m>>1]|0)>>>8&255,Q=a[k>>2]|0,a[k>>2]=Q+1,t[(a[l>>2]|0)+Q>>0]=p,p=a[h>>2]|0,Q=z>>>(16-p|0)&65535,w[m>>1]=Q,z=ka+-16+p|0,a[h>>2]=z,B=Q):(z=q+ka|0,a[h>>2]=z),p=z):(B=y,p=q)):(B=N[d+(y<<2)+2>>1]|0,H=a[h>>2]|0,p=N[d+(y<<2)>>1]|0,ka=N[m>>1]|0|p<<H,z=ka&65535,w[m>>1]=z,(H|0)>(16-B|0)?(Q=a[k>>2]|0,a[k>>2]=Q+1,t[(a[l>>2]|0)+Q>>0]=ka,ka=(N[m>>1]|0)>>>8&255,Q=a[k>>2]|0,a[k>>2]=Q+1,t[(a[l>>2]|0)+Q>>0]=ka,ka=a[h>>2]|0,Q=p>>>
(16-ka|0)&65535,w[m>>1]=Q,p=B+-16+ka|0,a[h>>2]=p,B=Q):(p=H+B|0,a[h>>2]=p,B=z));while(n>>>0<(a[e>>2]|0)>>>0);c=m;e=h;h=p;g=B}else f=b+5820|0,c=g=b+5816|0,e=f,h=a[f>>2]|0,g=w[g>>1]|0;B=N[d+1026>>1]|0;p=N[d+1024>>1]|0;d=g&65535|p<<h;w[c>>1]=d;(h|0)>(16-B|0)?(g=b+20|0,h=a[g>>2]|0,a[g>>2]=h+1,m=b+8|0,t[(a[m>>2]|0)+h>>0]=d,d=(N[c>>1]|0)>>>8&255,h=a[g>>2]|0,a[g>>2]=h+1,t[(a[m>>2]|0)+h>>0]=d,d=a[e>>2]|0,w[c>>1]=p>>>(16-d|0),a[e>>2]=B+-16+d|0):a[e>>2]=h+B|0}function kg(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,
k,l,n,p,q,y,B,H,ka,z,Q,C,Ra,u,r,x,I,G,L,K,v,E;e=w[d+2>>1]|0;f=0==e<<16>>16;g=b+2754|0;h=b+5820|0;m=b+2752|0;k=b+5816|0;l=b+20|0;n=b+8|0;p=b+2758|0;q=b+2756|0;y=b+2750|0;B=b+2748|0;H=f?138:7;ka=f?3:4;f=0;z=e&65535;e=-1;a:for(;;){Q=0;for(C=f;;){if((C|0)>(c|0))break a;Ra=C+1|0;u=w[d+(Ra<<2)+2>>1]|0;r=u&65535;x=Q+1|0;I=(z|0)==(r|0);if((x|0)<(H|0)&I)Q=x,C=Ra;else{f=Ra;H=u;G=r;L=x;K=I;v=Q;break}}do if((L|0)>=(ka|0))z?((z|0)==(e|0)?(r=w[k>>1]|0,x=a[h>>2]|0,I=L):(Q=N[b+2684+(z<<2)+2>>1]|0,C=a[h>>2]|0,I=N[b+
2684+(z<<2)>>1]|0,x=N[k>>1]|0|I<<C,r=x&65535,w[k>>1]=r,(C|0)>(16-Q|0)?(u=a[l>>2]|0,a[l>>2]=u+1,t[(a[n>>2]|0)+u>>0]=x,x=(N[k>>1]|0)>>>8&255,u=a[l>>2]|0,a[l>>2]=u+1,t[(a[n>>2]|0)+u>>0]=x,x=a[h>>2]|0,u=I>>>(16-x|0)&65535,r=w[k>>1]=u,Q=Q+-16+x|0):Q=C+Q|0,x=a[h>>2]=Q,I=v),Q=N[y>>1]|0,C=N[B>>1]|0,r=r&65535|C<<x,w[k>>1]=r,(x|0)>(16-Q|0)?(x=a[l>>2]|0,a[l>>2]=x+1,t[(a[n>>2]|0)+x>>0]=r,x=(N[k>>1]|0)>>>8&255,u=a[l>>2]|0,a[l>>2]=u+1,t[(a[n>>2]|0)+u>>0]=x,x=a[h>>2]|0,u=C>>>(16-x|0),w[k>>1]=u,C=Q+-16+x|0,Q=u):
(C=x+Q|0,Q=r),a[h>>2]=C,r=I+65533&65535,Q=Q&65535|r<<C,w[k>>1]=Q,14<(C|0)?(u=a[l>>2]|0,a[l>>2]=u+1,t[(a[n>>2]|0)+u>>0]=Q,Q=(N[k>>1]|0)>>>8&255,u=a[l>>2]|0,a[l>>2]=u+1,t[(a[n>>2]|0)+u>>0]=Q,Q=a[h>>2]|0,w[k>>1]=r>>>(16-Q|0),a[h>>2]=Q+-14):a[h>>2]=C+2):11>(L|0)?(Q=N[g>>1]|0,r=a[h>>2]|0,u=N[m>>1]|0,x=N[k>>1]|0|u<<r,w[k>>1]=x,(r|0)>(16-Q|0)?(C=a[l>>2]|0,a[l>>2]=C+1,t[(a[n>>2]|0)+C>>0]=x,C=(N[k>>1]|0)>>>8&255,I=a[l>>2]|0,a[l>>2]=I+1,t[(a[n>>2]|0)+I>>0]=C,C=a[h>>2]|0,I=u>>>(16-C|0),w[k>>1]=I,C=Q+-16+C|0,
Q=I):(C=r+Q|0,Q=x),a[h>>2]=C,x=v+65534&65535,Q=Q&65535|x<<C,w[k>>1]=Q,13<(C|0)?(r=a[l>>2]|0,a[l>>2]=r+1,t[(a[n>>2]|0)+r>>0]=Q,Q=(N[k>>1]|0)>>>8&255,r=a[l>>2]|0,a[l>>2]=r+1,t[(a[n>>2]|0)+r>>0]=Q,Q=a[h>>2]|0,w[k>>1]=x>>>(16-Q|0),a[h>>2]=Q+-13):a[h>>2]=C+3):(Q=N[p>>1]|0,x=a[h>>2]|0,r=N[q>>1]|0,I=N[k>>1]|0|r<<x,w[k>>1]=I,(x|0)>(16-Q|0)?(C=a[l>>2]|0,a[l>>2]=C+1,t[(a[n>>2]|0)+C>>0]=I,C=(N[k>>1]|0)>>>8&255,u=a[l>>2]|0,a[l>>2]=u+1,t[(a[n>>2]|0)+u>>0]=C,C=a[h>>2]|0,u=r>>>(16-C|0),w[k>>1]=u,C=Q+-16+C|0,Q=u):
(C=x+Q|0,Q=I),a[h>>2]=C,I=v+65526&65535,Q=Q&65535|I<<C,w[k>>1]=Q,9<(C|0)?(x=a[l>>2]|0,a[l>>2]=x+1,t[(a[n>>2]|0)+x>>0]=Q,Q=(N[k>>1]|0)>>>8&255,x=a[l>>2]|0,a[l>>2]=x+1,t[(a[n>>2]|0)+x>>0]=Q,Q=a[h>>2]|0,w[k>>1]=I>>>(16-Q|0),a[h>>2]=Q+-9):a[h>>2]=C+7);else for(Q=b+2684+(z<<2)+2|0,I=b+2684+(z<<2)|0,x=a[h>>2]|0,u=w[k>>1]|0,C=L;;)if(r=N[Q>>1]|0,Ra=N[I>>1]|0,u=u&65535|Ra<<x,E=u&65535,w[k>>1]=E,(x|0)>(16-r|0)?(x=a[l>>2]|0,a[l>>2]=x+1,t[(a[n>>2]|0)+x>>0]=u,u=(N[k>>1]|0)>>>8&255,x=a[l>>2]|0,a[l>>2]=x+1,t[(a[n>>
2]|0)+x>>0]=u,u=a[h>>2]|0,x=Ra>>>(16-u|0)&65535,Ra=w[k>>1]=x,r=r+-16+u|0):(Ra=E,r=x+r|0),a[h>>2]=r,C=C+-1|0)x=r,u=Ra;else break;while(0);u=0==H<<16>>16;x=z;H=u?138:K?6:7;ka=u|K?3:4;z=G;e=x}}function Si(a,d,c){a|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C,u,V,r,w,I=0,G=0,L=0,K=0,v=0,E=0,O=0,M=0,T=0,X=0,P=0,Oa=0,A=0;e=a>>>16;f=a&65535;if(1==(c|0))return a=(x[d>>0]|0)+f|0,g=65520<a>>>0?a+-65521|0:a,a=g+e|0,(65520<a>>>0?a+15|0:a)<<16|g|0;if(!d)return 1;if(16>c>>>0){if(c)for(g=d,a=c,k=f,l=e;;)if(a=
a+-1|0,n=(x[g>>0]|0)+k|0,p=n+l|0,a)g=g+1|0,k=n,l=p;else{h=n;m=p;break}else h=f,m=e;return((m>>>0)%65521|0)<<16|(65520<h>>>0?h+-65521|0:h)|0}if(5551<c>>>0){h=c+-5552|0;m=(h>>>0)%5552|0;l=h-m+5552|0;h=d;k=c;g=f;for(a=e;;){k=k+-5552|0;p=h;n=g;q=347;for(y=a;;)if(e=(x[p>>0]|0)+n|0,f=e+(x[p+1>>0]|0)|0,c=f+(x[p+2>>0]|0)|0,B=c+(x[p+3>>0]|0)|0,g=B+(x[p+4>>0]|0)|0,n=g+(x[p+5>>0]|0)|0,H=n+(x[p+6>>0]|0)|0,t=H+(x[p+7>>0]|0)|0,z=t+(x[p+8>>0]|0)|0,Q=z+(x[p+9>>0]|0)|0,C=Q+(x[p+10>>0]|0)|0,u=C+(x[p+11>>0]|0)|0,V=
u+(x[p+12>>0]|0)|0,r=V+(x[p+13>>0]|0)|0,w=r+(x[p+14>>0]|0)|0,a=w+(x[p+15>>0]|0)|0,B=e+y+f+c+B+g+n+H+t+z+Q+C+u+V+r+w+a|0,q=q+-1|0)p=p+16|0,n=a,y=B;else{H=a;t=B;break}y=(H>>>0)%65521|0;n=(t>>>0)%65521|0;if(5551>=k>>>0){z=y;Q=n;break}else h=h+5552|0,g=y,a=n}a=d+l|0;m?15<m>>>0?(I=m,G=a,L=z,K=Q,v=15):(E=m,O=a,M=z,T=Q,v=18):(X=z,P=Q)}else I=c,G=d,L=f,K=e,v=15;if(15==(v|0)){e=I+-16|0;f=e&-16;d=G+(f+16)|0;c=I;I=G;G=L;for(L=K;;)if(c=c+-16|0,K=(x[I>>0]|0)+G|0,Q=K+(x[I+1>>0]|0)|0,z=Q+(x[I+2>>0]|0)|0,a=z+(x[I+
3>>0]|0)|0,m=a+(x[I+4>>0]|0)|0,l=m+(x[I+5>>0]|0)|0,g=l+(x[I+6>>0]|0)|0,h=g+(x[I+7>>0]|0)|0,k=h+(x[I+8>>0]|0)|0,t=k+(x[I+9>>0]|0)|0,H=t+(x[I+10>>0]|0)|0,n=H+(x[I+11>>0]|0)|0,y=n+(x[I+12>>0]|0)|0,p=y+(x[I+13>>0]|0)|0,q=p+(x[I+14>>0]|0)|0,B=q+(x[I+15>>0]|0)|0,a=K+L+Q+z+a+m+l+g+h+k+t+H+n+y+p+q+B|0,15>=c>>>0){h=B;m=a;break}else I=I+16|0,G=B,L=a;(e|0)==(f|0)?(Oa=h,A=m,v=19):(E=e-f|0,O=d,M=h,T=m,v=18)}if(18==(v|0))for(;;)if(E=E+-1|0,m=(x[O>>0]|0)+M|0,h=m+T|0,E)O=O+1|0,M=m,T=h;else{Oa=m;A=h;v=19;break}19==
(v|0)&&(X=(Oa>>>0)%65521|0,P=(A>>>0)%65521|0);return P<<16|X|0}function Kd(b,d,c){d|=0;c|=0;var e,f,g,h,m,k,l,n,p;if(!d)return 0;e=~(b|0);a:do if(c){b=d;f=c;for(g=e;;){if(!(b&3)){h=b;m=f;k=g;break}l=a[110756+(((x[b>>0]|0)^g&255)<<2)>>2]^g>>>8;if(f=f+-1|0)b=b+1|0,g=l;else{m=l;break a}}if(31<m>>>0){g=m+-32|0;b=g&-32;f=b+32|0;l=m;for(m=h;;)if(n=a[m>>2]^k,p=a[112804+((n>>>8&255)<<2)>>2]^a[113828+((n&255)<<2)>>2]^a[111780+((n>>>16&255)<<2)>>2]^a[110756+(n>>>24<<2)>>2]^a[m+4>>2],n=a[112804+((p>>>8&255)<<
2)>>2]^a[113828+((p&255)<<2)>>2]^a[111780+((p>>>16&255)<<2)>>2]^a[110756+(p>>>24<<2)>>2]^a[m+8>>2],p=a[112804+((n>>>8&255)<<2)>>2]^a[113828+((n&255)<<2)>>2]^a[111780+((n>>>16&255)<<2)>>2]^a[110756+(n>>>24<<2)>>2]^a[m+12>>2],n=a[112804+((p>>>8&255)<<2)>>2]^a[113828+((p&255)<<2)>>2]^a[111780+((p>>>16&255)<<2)>>2]^a[110756+(p>>>24<<2)>>2]^a[m+16>>2],p=a[112804+((n>>>8&255)<<2)>>2]^a[113828+((n&255)<<2)>>2]^a[111780+((n>>>16&255)<<2)>>2]^a[110756+(n>>>24<<2)>>2]^a[m+20>>2],n=a[112804+((p>>>8&255)<<2)>>
2]^a[113828+((p&255)<<2)>>2]^a[111780+((p>>>16&255)<<2)>>2]^a[110756+(p>>>24<<2)>>2]^a[m+24>>2],p=a[112804+((n>>>8&255)<<2)>>2]^a[113828+((n&255)<<2)>>2]^a[111780+((n>>>16&255)<<2)>>2]^a[110756+(n>>>24<<2)>>2]^a[m+28>>2],n=a[112804+((p>>>8&255)<<2)>>2]^a[113828+((p&255)<<2)>>2]^a[111780+((p>>>16&255)<<2)>>2]^a[110756+(p>>>24<<2)>>2],l=l+-32|0,31>=l>>>0){m=n;break}else m=m+32|0,k=n;p=g-b|0;f=h+f|0;h=m}else p=m,f=h,h=k;if(3<p>>>0){k=p+-4|0;m=k>>>2;l=m<<2;n=p;for(p=f;;)if(h^=a[p>>2],h=a[112804+((h>>>
8&255)<<2)>>2]^a[113828+((h&255)<<2)>>2]^a[111780+((h>>>16&255)<<2)>>2]^a[110756+(h>>>24<<2)>>2],n=n+-4|0,3>=n>>>0){p=h;break}else p=p+4|0;l=k-l|0;m=f+(m+1<<2)|0;k=p}else l=p,m=f,k=h;if(l)for(h=m,p=l,n=k;;)if(f=a[110756+(((x[h>>0]|0)^n&255)<<2)>>2]^n>>>8,p=p+-1|0)h=h+1|0,n=f;else{m=f;break}else m=k}else m=e;while(0);return~m|0}function lg(b,d){b|=0;d|=0;var c;(c=a[b+88>>2]|0)&&(a[c+128>>2]=d);(c=a[b+92>>2]|0)&&(a[c+128>>2]=d);(c=a[b+96>>2]|0)&&(a[c+128>>2]=d);(c=a[b+100>>2]|0)&&(a[c+128>>2]=d);(c=
a[b+120>>2]|0)&&(a[c+276>>2]=d);(c=a[b+136>>2]|0)&&(a[c+276>>2]=d);(c=a[b+124>>2]|0)&&(a[c+276>>2]=d);(c=a[b+140>>2]|0)&&(a[c+276>>2]=d);(c=a[b+128>>2]|0)&&(a[c+276>>2]=d);(c=a[b+144>>2]|0)&&(a[c+276>>2]=d);(c=a[b+132>>2]|0)&&(a[c+276>>2]=d);(c=a[b+148>>2]|0)&&(a[c+276>>2]=d)}function Gg(b){b|=0;var d;d=Aa[a[a[b+4>>2]>>2]&63](b,1,32)|0;a[b+408>>2]=d;a[d>>2]=30;a[d+4>>2]=31;a[d+8>>2]=32;a[d+12>>2]=33;a[d+16>>2]=34;a[d+20>>2]=44;a[d+24>>2]=8;a[d+28>>2]=0}function ei(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,
l,n,p,q;c=a[b+88+(d<<2)>>2]|0;c||(e=a[b>>2]|0,a[e+20>>2]=54,a[e+24>>2]=d,R[a[e>>2]&127](b));e=b+388|0;f=a[e>>2]|0;if(0>(f|0))g=0;else for(h=a[b+384>>2]|0,k=m=0;;)if(l=255<(N[c+(a[h+(m<<2)>>2]<<1)>>1]|0)?1:k,(m|0)<(f|0))m=m+1|0,k=l;else{g=l;break}k=c+128|0;if(a[k>>2]|0)return g|0;m=b+24|0;f=a[m>>2]|0;h=a[f>>2]|0;a[f>>2]=h+1;t[h>>0]=-1;h=f+4|0;l=(a[h>>2]|0)+-1|0;a[h>>2]=l;0==(l|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b));f=a[m>>2]|0;l=a[f>>2]|0;a[f>>2]=l+1;t[l>>0]=
-37;l=f+4|0;h=(a[l>>2]|0)+-1|0;a[l>>2]=h;0==(h|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b));f=0!=(g|0);h=a[e>>2]|0;l=(f?(h<<1)+2|0:h+1|0)+3|0;h=a[m>>2]|0;n=a[h>>2]|0;a[h>>2]=n+1;t[n>>0]=l>>>8;n=h+4|0;p=(a[n>>2]|0)+-1|0;a[n>>2]=p;0==(p|0)&&0==(da[a[h+12>>2]&63](b)|0)&&(h=a[b>>2]|0,a[h+20>>2]=25,R[a[h>>2]&127](b));h=a[m>>2]|0;p=a[h>>2]|0;a[h>>2]=p+1;t[p>>0]=l;l=h+4|0;p=(a[l>>2]|0)+-1|0;a[l>>2]=p;0==(p|0)&&0==(da[a[h+12>>2]&63](b)|0)&&(h=a[b>>2]|0,a[h+20>>2]=25,R[a[h>>
2]&127](b));h=a[m>>2]|0;p=a[h>>2]|0;a[h>>2]=p+1;t[p>>0]=(g<<4)+d;d=h+4|0;p=(a[d>>2]|0)+-1|0;a[d>>2]=p;0==(p|0)&&0==(da[a[h+12>>2]&63](b)|0)&&(h=a[b>>2]|0,a[h+20>>2]=25,R[a[h>>2]&127](b));a:do if(0<=(a[e>>2]|0)){h=b+384|0;if(f)q=0;else for(p=0;;)if(d=a[m>>2]|0,l=w[c+(a[(a[h>>2]|0)+(p<<2)>>2]<<1)>>1]&255,n=a[d>>2]|0,a[d>>2]=n+1,t[n>>0]=l,l=d+4|0,n=(a[l>>2]|0)+-1|0,a[l>>2]=n,0==(n|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),(p|0)<(a[e>>2]|0))p=p+1|0;else break a;for(;;)if(p=
w[c+(a[(a[h>>2]|0)+(q<<2)>>2]<<1)>>1]|0,d=a[m>>2]|0,n=a[d>>2]|0,a[d>>2]=n+1,t[n>>0]=(p&65535)>>>8,n=d+4|0,l=(a[n>>2]|0)+-1|0,a[n>>2]=l,0==(l|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[m>>2]|0,l=a[d>>2]|0,a[d>>2]=l+1,t[l>>0]=p,p=d+4|0,l=(a[p>>2]|0)+-1|0,a[p>>2]=l,0==(l|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),(q|0)<(a[e>>2]|0))q=q+1|0;else break}while(0);a[k>>2]=1;return g|0}function Me(b,d,c){b|=0;d|=0;var e,f,g,h,m,k,l;
c=(e=0==(c|0))?d:d+16|0;f=a[(e?b+120+(d<<2)|0:b+136+(d<<2)|0)>>2]|0;f||(d=a[b>>2]|0,a[d+20>>2]=52,a[d+24>>2]=c,R[a[d>>2]&127](b));d=f+276|0;if(!(a[d>>2]|0)){e=b+24|0;g=a[e>>2]|0;h=a[g>>2]|0;a[g>>2]=h+1;t[h>>0]=-1;h=g+4|0;m=(a[h>>2]|0)+-1|0;a[h>>2]=m;0==(m|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));g=a[e>>2]|0;m=a[g>>2]|0;a[g>>2]=m+1;t[m>>0]=-60;m=g+4|0;h=(a[m>>2]|0)+-1|0;a[m>>2]=h;0==(h|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));
g=(x[f+16>>0]|0)+((x[f+15>>0]|0)+((x[f+14>>0]|0)+((x[f+13>>0]|0)+((x[f+12>>0]|0)+((x[f+11>>0]|0)+((x[f+10>>0]|0)+((x[f+9>>0]|0)+((x[f+8>>0]|0)+((x[f+7>>0]|0)+((x[f+6>>0]|0)+((x[f+5>>0]|0)+((x[f+4>>0]|0)+((x[f+3>>0]|0)+((x[f+2>>0]|0)+(x[f+1>>0]|0)))))))))))))))|0;h=g+19|0;m=a[e>>2]|0;k=a[m>>2]|0;a[m>>2]=k+1;t[k>>0]=h>>>8;k=m+4|0;l=(a[k>>2]|0)+-1|0;a[k>>2]=l;0==(l|0)&&0==(da[a[m+12>>2]&63](b)|0)&&(m=a[b>>2]|0,a[m+20>>2]=25,R[a[m>>2]&127](b));m=a[e>>2]|0;l=a[m>>2]|0;a[m>>2]=l+1;t[l>>0]=h;h=m+4|0;l=(a[h>>
2]|0)+-1|0;a[h>>2]=l;0==(l|0)&&0==(da[a[m+12>>2]&63](b)|0)&&(m=a[b>>2]|0,a[m+20>>2]=25,R[a[m>>2]&127](b));m=a[e>>2]|0;l=a[m>>2]|0;a[m>>2]=l+1;t[l>>0]=c;c=m+4|0;l=(a[c>>2]|0)+-1|0;a[c>>2]=l;0==(l|0)&&0==(da[a[m+12>>2]&63](b)|0)&&(m=a[b>>2]|0,a[m+20>>2]=25,R[a[m>>2]&127](b));m=1;do l=t[f+m>>0]|0,c=a[e>>2]|0,h=a[c>>2]|0,a[c>>2]=h+1,t[h>>0]=l,l=c+4|0,h=(a[l>>2]|0)+-1|0,a[l>>2]=h,0==(h|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),m=m+1|0;while(17!=(m|0));if(0<(g|0)){m=
0;do c=t[f+17+m>>0]|0,h=a[e>>2]|0,l=a[h>>2]|0,a[h>>2]=l+1,t[l>>0]=c,c=h+4|0,l=(a[c>>2]|0)+-1|0,a[c>>2]=l,0==(l|0)&&0==(da[a[h+12>>2]&63](b)|0)&&(h=a[b>>2]|0,a[h+20>>2]=25,R[a[h>>2]&127](b)),m=m+1|0;while((m|0)!=(g|0))}a[d>>2]=1}}function xi(b,d){b|=0;d|=0;var c,e,f,g,h,m;c=b+24|0;e=a[c>>2]|0;f=a[e>>2]|0;a[e>>2]=f+1;t[f>>0]=-1;f=e+4|0;g=(a[f>>2]|0)+-1|0;a[f>>2]=g;0==(g|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b));e=a[c>>2]|0;g=a[e>>2]|0;a[e>>2]=g+1;t[g>>0]=d;d=e+4|
0;g=(a[d>>2]|0)+-1|0;a[d>>2]=g;0==(g|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b));e=b+76|0;g=(3*(a[e>>2]|0)|0)+8|0;d=a[c>>2]|0;f=a[d>>2]|0;a[d>>2]=f+1;t[f>>0]=g>>>8;f=d+4|0;h=(a[f>>2]|0)+-1|0;a[f>>2]=h;0==(h|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b));d=a[c>>2]|0;h=a[d>>2]|0;a[d>>2]=h+1;t[h>>0]=g;g=d+4|0;h=(a[g>>2]|0)+-1|0;a[g>>2]=h;0==(h|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b));d=b+68|0;65535>=
(a[d>>2]|0)&&65535>=(a[b+64>>2]|0)||(h=a[b>>2]|0,a[h+20>>2]=42,a[h+24>>2]=65535,R[a[h>>2]&127](b));h=a[c>>2]|0;g=a[b+72>>2]&255;f=a[h>>2]|0;a[h>>2]=f+1;t[f>>0]=g;g=h+4|0;f=(a[g>>2]|0)+-1|0;a[g>>2]=f;0==(f|0)&&0==(da[a[h+12>>2]&63](b)|0)&&(h=a[b>>2]|0,a[h+20>>2]=25,R[a[h>>2]&127](b));h=a[d>>2]|0;d=a[c>>2]|0;f=a[d>>2]|0;a[d>>2]=f+1;t[f>>0]=h>>>8;f=d+4|0;g=(a[f>>2]|0)+-1|0;a[f>>2]=g;0==(g|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b));d=a[c>>2]|0;g=a[d>>2]|0;a[d>>2]=g+
1;t[g>>0]=h;h=d+4|0;g=(a[h>>2]|0)+-1|0;a[h>>2]=g;0==(g|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b));d=a[b+64>>2]|0;g=a[c>>2]|0;h=a[g>>2]|0;a[g>>2]=h+1;t[h>>0]=d>>>8;h=g+4|0;f=(a[h>>2]|0)+-1|0;a[h>>2]=f;0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));g=a[c>>2]|0;f=a[g>>2]|0;a[g>>2]=f+1;t[f>>0]=d;d=g+4|0;f=(a[d>>2]|0)+-1|0;a[d>>2]=f;0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));g=a[c>>2]|0;
f=a[e>>2]&255;d=a[g>>2]|0;a[g>>2]=d+1;t[d>>0]=f;f=g+4|0;d=(a[f>>2]|0)+-1|0;a[f>>2]=d;0==(d|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));if(!(0>=(a[e>>2]|0)))for(g=0,d=a[b+84>>2]|0;!(f=a[c>>2]|0,h=a[d>>2]&255,m=a[f>>2]|0,a[f>>2]=m+1,t[m>>0]=h,h=f+4|0,m=(a[h>>2]|0)+-1|0,a[h>>2]=m,0==(m|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),f=a[c>>2]|0,m=(a[d+8>>2]<<4)+(a[d+12>>2]|0)&255,h=a[f>>2]|0,a[f>>2]=h+1,t[h>>0]=m,m=f+4|0,h=(a[m>>2]|0)+
-1|0,a[m>>2]=h,0==(h|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),f=a[c>>2]|0,h=a[d+16>>2]&255,m=a[f>>2]|0,a[f>>2]=m+1,t[m>>0]=h,h=f+4|0,m=(a[h>>2]|0)+-1|0,a[h>>2]=m,0==(m|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),g=g+1|0,(g|0)>=(a[e>>2]|0));)d=d+88|0}function Vg(b){b|=0;var d,c,e,f,g;if(d=a[b+204>>2]|0){c=a[(a[b+392>>2]|0)+32>>2]|0;e=a[d+(36*c|0)>>2]|0;a[b+292>>2]=e;if(0<(e|0)){g=b+84|0;f=0;do a[b+296+(f<<2)>>2]=(a[g>>2]|0)+(88*
(a[d+(36*c|0)+4+(f<<2)>>2]|0)|0),f=f+1|0;while((f|0)<(e|0))}if(a[b+268>>2]|0){a[b+364>>2]=a[d+(36*c|0)+20>>2];a[b+368>>2]=a[d+(36*c|0)+24>>2];a[b+372>>2]=a[d+(36*c|0)+28>>2];a[b+376>>2]=a[d+(36*c|0)+32>>2];return}}else if(c=b+76|0,e=a[c>>2]|0,4<(e|0)?(f=a[b>>2]|0,a[f+20>>2]=27,a[f+24>>2]=e,a[f+28>>2]=4,R[a[f>>2]&127](b),g=a[c>>2]|0):g=e,a[b+292>>2]=g,0<(g|0)){g=b+84|0;e=0;do a[b+296+(e<<2)>>2]=(a[g>>2]|0)+(88*e|0),e=e+1|0;while((e|0)<(a[c>>2]|0))}a[b+364>>2]=0;c=a[b+380>>2]|0;d=(E(c,c)|0)+-1|0;a[b+
368>>2]=d;a[b+372>>2]=0;a[b+376>>2]=0}function Jf(b){b|=0;var d,c,e,f,g,h,m,k,l;d=b+292|0;c=a[d>>2]|0;a:do if(1!=(c|0)){if(3<(c+-1|0)>>>0&&(e=a[b>>2]|0,a[e+20>>2]=27,a[e+24>>2]=c,a[e+28>>2]=4,R[a[e>>2]&127](b)),e=b+380|0,f=Gb(a[b+64>>2]|0,E(a[e>>2]|0,a[b+272>>2]|0)|0)|0,a[b+312>>2]=f,f=Gb(a[b+68>>2]|0,E(a[e>>2]|0,a[b+276>>2]|0)|0)|0,a[b+316>>2]=f,f=b+320|0,a[f>>2]=0,0<(a[d>>2]|0))for(g=e=0;;){c=a[b+296+(g<<2)>>2]|0;h=a[c+8>>2]|0;a[c+56>>2]=h;m=a[c+12>>2]|0;a[c+60>>2]=m;k=E(h,m)|0;a[c+64>>2]=k;l=E(a[c+
36>>2]|0,h)|0;a[c+68>>2]=l;l=((a[c+28>>2]|0)>>>0)%(h>>>0)|0;a[c+72>>2]=0==(l|0)?h:l;l=((a[c+32>>2]|0)>>>0)%(m>>>0)|0;a[c+76>>2]=0==(l|0)?m:l;10<(e+k|0)&&(l=a[b>>2]|0,a[l+20>>2]=14,R[a[l>>2]&127](b));if(0<(k|0))for(l=k;;)if(k=a[f>>2]|0,a[f>>2]=k+1,a[b+324+(k<<2)>>2]=g,1<(l|0))l=l+-1|0;else break;l=g+1|0;if((l|0)>=(a[d>>2]|0))break a;e=a[f>>2]|0;g=l}}else g=a[b+296>>2]|0,a[b+312>>2]=a[g+28>>2],f=a[g+32>>2]|0,a[b+316>>2]=f,a[g+56>>2]=1,a[g+60>>2]=1,a[g+64>>2]=1,a[g+68>>2]=a[g+36>>2],a[g+72>>2]=1,e=a[g+
12>>2]|0,l=(f>>>0)%(e>>>0)|0,a[g+76>>2]=0==(l|0)?e:l,a[b+320>>2]=1,a[b+324>>2]=0;while(0);d=a[b+240>>2]|0;0>=(d|0)||(c=E(a[b+312>>2]|0,d)|0,a[b+236>>2]=65535>(c|0)?c:65535)}function yi(b){b|=0;var d;if(d=a[b+4>>2]|0)ub[a[d+36>>2]&31](b,1),d=b+20|0,a[b+16>>2]|0?(a[d>>2]=200,a[b+312>>2]=0):a[d>>2]=100}function fi(b){b|=0;var d,c;d=b+4|0;if(c=a[d>>2]|0)R[a[c+40>>2]&127](b);a[d>>2]=0;a[b+20>>2]=0}function zf(b){b|=0;b=Aa[a[a[b+4>>2]>>2]&63](b,0,132)|0;a[b+128>>2]=0;return b|0}function Zi(b){b|=0;b=Aa[a[a[b+
4>>2]>>2]&63](b,0,280)|0;a[b+276>>2]=0;return b|0}function Yg(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m;e=b+20|0;f=a[e>>2]|0;100!=(f|0)&&(g=a[b>>2]|0,a[g+20>>2]=21,a[g+24>>2]=f,R[a[g>>2]&127](b));g=b+88|0;(f=a[g>>2]|0)?m=f:(h=zf(b)|0,m=a[g>>2]=h);if(f=0==(c|0)){c=0;do h=((E(a[118948+(c<<2)>>2]|0,d)|0)+50|0)/100|0,g=1>(h|0)?1:h,w[m+(c<<1)>>1]=32767<(g|0)?32767:g&65535,c=c+1|0;while(64!=(c|0))}else{c=0;do g=((E(a[118948+(c<<2)>>2]|0,d)|0)+50|0)/100|0,h=1>(g|0)?1:g,g=32767<(h|0)?32767:h,w[m+(c<<1)>>1]=255<
(g|0)?255:g&65535,c=c+1|0;while(64!=(c|0))}a[m+128>>2]=0;m=a[e>>2]|0;100!=(m|0)&&(e=a[b>>2]|0,a[e+20>>2]=21,a[e+24>>2]=m,R[a[e>>2]&127](b));e=b+92|0;(m=a[e>>2]|0)?b=m:(c=zf(b)|0,b=a[e>>2]=c);if(f){f=0;do m=((E(a[119204+(f<<2)>>2]|0,d)|0)+50|0)/100|0,c=1>(m|0)?1:m,w[b+(f<<1)>>1]=32767<(c|0)?32767:c&65535,f=f+1|0;while(64!=(f|0))}else{f=0;do c=((E(a[119204+(f<<2)>>2]|0,d)|0)+50|0)/100|0,m=1>(c|0)?1:c,c=32767<(m|0)?32767:m,w[b+(f<<1)>>1]=255<(c|0)?255:c&65535,f=f+1|0;while(64!=(f|0))}a[(b+128|0)>>2]=
0}function zi(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h;(f=a[d>>2]|0)?h=f:(g=Zi(b)|0,h=a[d>>2]=g);f=h;h=c;g=f+17|0;do t[f>>0]=t[h>>0]|0,f=f+1|0,h=h+1|0;while((f|0)<(g|0));h=(x[c+16>>0]|0)+((x[c+15>>0]|0)+((x[c+14>>0]|0)+((x[c+13>>0]|0)+((x[c+12>>0]|0)+((x[c+11>>0]|0)+((x[c+10>>0]|0)+((x[c+9>>0]|0)+((x[c+8>>0]|0)+((x[c+7>>0]|0)+((x[c+6>>0]|0)+((x[c+5>>0]|0)+((x[c+4>>0]|0)+((x[c+3>>0]|0)+((x[c+2>>0]|0)+(x[c+1>>0]|0)))))))))))))))|0;255>=(h+-1|0)>>>0||(c=a[b>>2]|0,a[c+20>>2]=9,R[a[c>>2]&127](b));Ec((a[d>>
2]|0)+17|0,e|0,h|0)|0;a[((a[d>>2]|0)+276|0)>>2]=0}function Nh(b){b|=0;var d,c,e,f,g,h;d=b+20|0;c=a[d>>2]|0;switch(c|0){case 200:e=b+460|0;R[a[(a[e>>2]|0)+4>>2]&127](b);R[a[(a[b+24>>2]|0)+8>>2]&127](b);a[d>>2]=201;f=e;break;case 201:f=b+460|0;break;case 210:case 208:case 207:case 206:case 205:case 204:case 203:return b=da[a[a[b+460>>2]>>2]&63](b)|0,b|0;case 202:return 1;default:return e=a[b>>2]|0,a[e+20>>2]=21,a[e+24>>2]=c,R[a[e>>2]&127](b),0}e=da[a[a[f>>2]>>2]&63](b)|0;if(1!=(e|0))return e|0;switch(a[b+
36>>2]|0){case 1:a[b+40>>2]=1;a[b+44>>2]=1;break;case 3:e=a[b+216>>2]|0;f=a[e>>2]|0;c=a[e+88>>2]|0;g=a[e+176>>2]|0;e=1==(f|0);a:do if(e&2==(c|0)&3==(g|0))a[b+40>>2]=3;else if(e&34==(c|0)&35==(g|0))a[b+40>>2]=7;else if(82==(f|0)&71==(c|0)&66==(g|0))a[b+40>>2]=2;else if(114==(f|0)&103==(c|0)&98==(g|0))a[b+40>>2]=6;else if(a[b+284>>2]|0)a[b+40>>2]=3;else if(a[b+296>>2]|0)switch(h=x[b+300>>0]|0,h|0){case 0:a[b+40>>2]=2;break a;case 1:a[b+40>>2]=3;break a;default:c=a[b>>2]|0;a[c+20>>2]=116;a[c+24>>2]=
h;ub[a[c+4>>2]&31](b,-1);a[b+40>>2]=3;break a}else h=a[b>>2]|0,a[h+24>>2]=f,a[h+28>>2]=c,a[h+32>>2]=g,a[h+20>>2]=113,ub[a[h+4>>2]&31](b,1),a[b+40>>2]=3;while(0);a[b+44>>2]=2;break;case 4:a:do if(a[b+296>>2]|0)switch(g=x[b+300>>0]|0,g|0){case 0:a[b+40>>2]=4;break a;case 2:a[b+40>>2]=5;break a;default:c=a[b>>2]|0;a[c+20>>2]=116;a[c+24>>2]=g;ub[a[c+4>>2]&31](b,-1);a[b+40>>2]=5;break a}else a[b+40>>2]=4;while(0);a[b+44>>2]=4;break;default:a[b+40>>2]=0,a[b+44>>2]=0}c=a[b+428>>2]|0;a[b+48>>2]=c;a[b+52>>
2]=c;Hb[b+56>>3]=1;a[b+64>>2]=0;a[b+68>>2]=0;a[b+72>>2]=0;a[b+76>>2]=1;a[b+80>>2]=1;a[b+84>>2]=0;a[b+88>>2]=2;a[b+92>>2]=1;a[b+96>>2]=256;a[b+136>>2]=0;a[b+100>>2]=0;a[b+104>>2]=0;a[b+108>>2]=0;a[d>>2]=202;return 1}function $g(b){b|=0;var d,c,e,f,g,h,m,k,l;d=b+340|0;c=a[d>>2]|0;if(1!=(c|0)){3<(c+-1|0)>>>0&&(e=a[b>>2]|0,a[e+20>>2]=27,a[e+24>>2]=c,a[e+28>>2]=4,R[a[e>>2]&127](b));e=b+428|0;c=Gb(a[b+28>>2]|0,E(a[e>>2]|0,a[b+316>>2]|0)|0)|0;a[b+360>>2]=c;c=Gb(a[b+32>>2]|0,E(a[e>>2]|0,a[b+320>>2]|0)|0)|
0;a[b+364>>2]=c;c=b+368|0;a[c>>2]=0;if(0>=(a[d>>2]|0)){d=a[(b+468|0)>>2]|0;d=a[d>>2]|0;R[d&127](b);d=b+452|0;e=a[d>>2]|0;e=a[e>>2]|0;R[e&127](b);d=a[d>>2]|0;d=a[(d+4|0)>>2]|0;b=a[(b+460|0)>>2]|0;a[b>>2]=d;return}for(f=e=0;;){g=a[b+344+(f<<2)>>2]|0;h=a[g+8>>2]|0;a[g+56>>2]=h;m=a[g+12>>2]|0;a[g+60>>2]=m;k=E(m,h)|0;a[g+64>>2]=k;l=E(a[g+36>>2]|0,h)|0;a[g+68>>2]=l;l=((a[g+28>>2]|0)>>>0)%(h>>>0)|0;a[g+72>>2]=0==(l|0)?h:l;l=((a[g+32>>2]|0)>>>0)%(m>>>0)|0;a[g+76>>2]=0==(l|0)?m:l;10<(k+e|0)&&(l=a[b>>2]|0,
a[l+20>>2]=14,R[a[l>>2]&127](b));if(0<(k|0))for(l=k;;)if(k=a[c>>2]|0,a[c>>2]=k+1,a[b+372+(k<<2)>>2]=f,1<(l|0))l=l+-1|0;else break;l=f+1|0;k=a[d>>2]|0;if((l|0)>=(k|0)){h=k;break}e=a[c>>2]|0;f=l}if(0<(h|0))g=h;else{d=a[(b+468|0)>>2]|0;d=a[d>>2]|0;R[d&127](b);d=b+452|0;e=a[d>>2]|0;e=a[e>>2]|0;R[e&127](b);d=a[d>>2]|0;d=a[(d+4|0)>>2]|0;b=a[(b+460|0)>>2]|0;a[b>>2]=d;return}}else h=a[b+344>>2]|0,a[b+360>>2]=a[h+28>>2],f=a[h+32>>2]|0,a[b+364>>2]=f,a[h+56>>2]=1,a[h+60>>2]=1,a[h+64>>2]=1,a[h+68>>2]=a[h+36>>
2],a[h+72>>2]=1,c=a[h+12>>2]|0,e=(f>>>0)%(c>>>0)|0,a[h+76>>2]=0==(e|0)?c:e,a[b+368>>2]=1,a[b+372>>2]=0,g=1;e=b+4|0;c=g;for(g=0;!(h=a[b+344+(g<<2)>>2]|0,f=h+80|0,a[f>>2]|0||(l=a[h+16>>2]|0,h=b+164+(l<<2)|0,3>=l>>>0&&0!=(a[h>>2]|0)||(k=a[b>>2]|0,a[k+20>>2]=54,a[k+24>>2]=l,R[a[k>>2]&127](b)),k=Aa[a[a[e>>2]>>2]&63](b,1,132)|0,Ec(k|0,a[h>>2]|0,132)|0,a[f>>2]=k,c=a[d>>2]|0),g=g+1|0,(g|0)>=(c|0)););d=a[(b+468|0)>>2]|0;d=a[d>>2]|0;R[d&127](b);d=b+452|0;e=a[d>>2]|0;e=a[e>>2]|0;R[e&127](b);d=a[d>>2]|0;d=a[(d+
4|0)>>2]|0;b=a[(b+460|0)>>2]|0;a[b>>2]=d}function rg(b){b|=0;var d,c,e,f,g,h,m=0,k,l,n,p=0,q=0,y=0,B=0;d=a[b+24>>2]|0;c=d+4|0;e=d+12|0;f=b+464|0;g=a[c>>2]|0;h=a[d>>2]|0;a:for(;;){if(!g){if(!(da[a[e>>2]&63](b)|0)){m=0;e=19;break}h=a[d>>2]|0;g=a[c>>2]|0}k=g+-1|0;l=h+1|0;if(-1==(t[h>>0]|0))h=l;else for(h=k,k=l;;){l=(a[f>>2]|0)+24|0;a[l>>2]=(a[l>>2]|0)+1;a[d>>2]=k;a[c>>2]=h;if(!h){if(!(da[a[e>>2]&63](b)|0)){m=0;e=19;break a}k=a[d>>2]|0;h=a[c>>2]|0}l=h+-1|0;g=k+1|0;if(-1==(t[k>>0]|0)){k=l;h=g;break}else h=
l,k=g}for(;;){if(k)l=k,g=h;else{if(!(da[a[e>>2]&63](b)|0)){m=0;e=19;break a}l=a[c>>2]|0;g=a[d>>2]|0}k=l+-1|0;h=g+1|0;g=t[g>>0]|0;if(-1!=g<<24>>24){l=h;n=g;break}}g=(a[f>>2]|0)+24|0;h=a[g>>2]|0;if(n<<24>>24){p=k;q=l;y=n;B=h;e=16;break}a[g>>2]=h+2;a[d>>2]=l;g=a[c>>2]=k;h=l}return 16==(e|0)?(l=y&255,B&&(y=a[b>>2]|0,a[y+20>>2]=119,a[y+24>>2]=B,a[y+28>>2]=l,ub[a[y+4>>2]&31](b,-1),a[(a[f>>2]|0)+24>>2]=0),a[b+440>>2]=l,a[d>>2]=q,a[c>>2]=p,1):19==(e|0)?m|0:0}function Uh(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,
m,k,l,n,p,q,y;l=0;f=(e|0)+c|0;if(13<c>>>0){if(74==(t[d>>0]|0)){if(70==(t[d+1>>0]|0)&&73==(t[d+2>>0]|0)&&70==(t[d+3>>0]|0)&&0==(t[d+4>>0]|0)){a[b+284>>2]=1;e=t[d+5>>0]|0;g=b+288|0;t[g>>0]=e;h=t[d+6>>0]|0;m=b+289|0;t[m>>0]=h;k=t[d+7>>0]|0;l=b+290|0;t[l>>0]=k;n=(x[d+8>>0]<<8|x[d+9>>0])&65535;p=b+292|0;w[p>>1]=n;q=(x[d+10>>0]<<8|x[d+11>>0])&65535;y=b+294|0;w[y>>1]=q;2>(e+-1&255)?c=b:(k=a[b>>2]|0,a[k+20>>2]=122,a[k+24>>2]=e&255,a[k+28>>2]=h&255,ub[a[k+4>>2]&31](b,-1),c=b,e=t[g>>0]|0,h=t[m>>0]|0,n=w[p>>
1]|0,q=w[y>>1]|0,k=t[l>>0]|0);l=a[b>>2]|0;a[l+24>>2]=e&255;a[l+28>>2]=h&255;a[l+32>>2]=n&65535;a[l+36>>2]=q&65535;a[l+40>>2]=k&255;a[l+20>>2]=89;ub[a[l+4>>2]&31](c,1);l=d+12|0;k=t[l>>0]|0;q=d+13|0;n=t[q>>0]|0;(n|k)<<24>>24?(n=a[b>>2]|0,a[n+20>>2]=92,a[n+24>>2]=x[l>>0],a[n+28>>2]=x[q>>0],ub[a[n+4>>2]&31](c,1),d=t[l>>0]|0,l=t[q>>0]|0):(d=k,l=n);q=f+-14|0;if((q|0)==(E(3*(d&255)|0,l&255)|0))return;l=a[b>>2]|0;a[l+20>>2]=90;a[l+24>>2]=q;ub[a[l+4>>2]&31](c,1);return}l=16}}else 5<c>>>0&&74==(t[d>>0]|0)&&
(l=16);if(16==(l|0)&&70==(t[d+1>>0]|0)&&88==(t[d+2>>0]|0)&&88==(t[d+3>>0]|0)&&0==(t[d+4>>0]|0))switch(l=d+5|0,x[l>>0]|0){case 16:d=a[b>>2]|0;a[d+20>>2]=110;a[d+24>>2]=f;ub[a[d+4>>2]&31](b,1);return;case 17:d=a[b>>2]|0;a[d+20>>2]=111;a[d+24>>2]=f;ub[a[d+4>>2]&31](b,1);return;case 19:d=a[b>>2]|0;a[d+20>>2]=112;a[d+24>>2]=f;ub[a[d+4>>2]&31](b,1);return;default:d=a[b>>2]|0;a[d+20>>2]=91;a[d+24>>2]=x[l>>0];a[d+28>>2]=f;ub[a[d+4>>2]&31](b,1);return}d=a[b>>2]|0;a[d+20>>2]=79;a[d+24>>2]=f;ub[a[d+4>>2]&31](b,
1)}function Ai(b,d,c,e){b|=0;var f,g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C=0,u=0;f=a[b+24>>2]|0;g=a[f>>2]|0;h=f+4|0;m=a[h>>2]|0;a[b+220>>2]=d|0;a[b+224>>2]=c|0;a[b+228>>2]=e|0;if(m)l=m,n=g;else if(da[a[f+12>>2]&63](b)|0)l=a[h>>2]|0,n=a[f>>2]|0;else return 0;g=l+-1|0;l=n+1|0;m=(x[n>>0]|0)<<8;if(g)n=g,p=l;else if(da[a[f+12>>2]&63](b)|0)n=a[h>>2]|0,p=a[f>>2]|0;else return 0;l=n+-1|0;n=p+1|0;g=x[p>>0]|0|m;if(l)m=l,q=n;else if(da[a[f+12>>2]&63](b)|0)m=a[h>>2]|0,q=a[f>>2]|0;else return 0;n=m+-1|0;m=q+1|0;a[b+212>>
2]=x[q>>0];if(n)y=n,k=m;else if(da[a[f+12>>2]&63](b)|0)y=a[h>>2]|0,k=a[f>>2]|0;else return 0;m=y+-1|0;y=k+1|0;n=(x[k>>0]|0)<<8;k=b+32|0;a[k>>2]=n;if(m)l=n,B=m,H=y;else if(da[a[f+12>>2]&63](b)|0)l=a[k>>2]|0,B=a[h>>2]|0,H=a[f>>2]|0;else return 0;y=B+-1|0;B=H+1|0;a[k>>2]=l+(x[H>>0]|0);if(y)d=y,H=B;else if(da[a[f+12>>2]&63](b)|0)d=a[h>>2]|0,H=a[f>>2]|0;else return 0;B=d+-1|0;d=H+1|0;y=(x[H>>0]|0)<<8;H=b+28|0;a[H>>2]=y;if(B)t=y,c=B,y=d;else if(da[a[f+12>>2]&63](b)|0)t=a[H>>2]|0,c=a[h>>2]|0,y=a[f>>2]|0;
else return 0;d=c+-1|0;c=y+1|0;a[H>>2]=t+(x[y>>0]|0);if(d)e=d,z=c;else if(da[a[f+12>>2]&63](b)|0)e=a[h>>2]|0,z=a[f>>2]|0;else return 0;c=b+36|0;a[c>>2]=x[z>>0];d=g+-8|0;g=a[b>>2]|0;a[g+24>>2]=a[b+440>>2];a[g+28>>2]=a[H>>2];a[g+32>>2]=a[k>>2];a[g+36>>2]=a[c>>2];a[g+20>>2]=102;ub[a[g+4>>2]&31](b,1);g=b+464|0;a[(a[g>>2]|0)+16>>2]|0&&(y=a[b>>2]|0,a[y+20>>2]=61,R[a[y>>2]&127](b));0!=(a[k>>2]|0)&&0!=(a[H>>2]|0)&&(H=a[c>>2]|0,1<=(H|0))?Q=H:(H=a[b>>2]|0,a[H+20>>2]=33,R[a[H>>2]&127](b),Q=a[c>>2]|0);(d|0)!=
(3*Q|0)&&(Q=a[b>>2]|0,a[Q+20>>2]=12,R[a[Q>>2]&127](b));Q=b+216|0;a[Q>>2]|0||(d=Aa[a[a[b+4>>2]>>2]&63](b,1,88*(a[c>>2]|0)|0)|0,a[Q>>2]=d);d=e+-1|0;e=z+1|0;a:do if(0<(a[c>>2]|0)){z=f+12|0;H=d;k=0;for(y=e;;){if(H)B=H;else{if(!(da[a[z>>2]&63](b)|0)){k=0;z=55;break}B=a[h>>2]|0;y=a[f>>2]|0}t=B+-1|0;B=y+1|0;y=x[y>>0]|0;H=a[Q>>2]|0;b:do if(0<(k|0)){l=H;for(m=0;(y|0)!=(a[l>>2]|0);)if(m=m+1|0,n=l+88|0,(m|0)>=(k|0)){l=y;m=n;break b}else l=n;l=a[H>>2]|0;m=H+88|0;if(1<(k|0)){n=H;q=l;l=m;for(m=1;;)if(p=a[n+88>>
2]|0,n=(p|0)>(q|0)?p:q,m=m+1|0,(m|0)==(k|0)){m=n;break}else p=l,q=n,l=l+88|0,n=p;l=m;m=H+(88*k|0)|0}l=l+1|0}else l=y,m=H;while(0);a[m>>2]=l;a[m+4>>2]=k;if(t)y=t;else{if(!(da[a[z>>2]&63](b)|0)){k=0;z=55;break}y=a[h>>2]|0;B=a[f>>2]|0}H=y+-1|0;y=B+1|0;n=x[B>>0]|0;l=m+8|0;a[l>>2]=n>>>4;q=m+12|0;a[q>>2]=n&15;if(H)B=H,t=y;else{if(!(da[a[z>>2]&63](b)|0)){k=0;z=55;break}B=a[h>>2]|0;t=a[f>>2]|0}y=m+16|0;a[y>>2]=x[t>>0];H=a[b>>2]|0;a[H+24>>2]=a[m>>2];a[H+28>>2]=a[l>>2];a[H+32>>2]=a[q>>2];a[H+36>>2]=a[y>>2];
a[H+20>>2]=103;ub[a[H+4>>2]&31](b,1);k=k+1|0;H=B+-1|0;y=t+1|0;if((k|0)>=(a[c>>2]|0)){C=H;u=y;break a}}if(55==(z|0))return k|0}else C=d,u=e;while(0);a[(a[g>>2]|0)+16>>2]=1;a[f>>2]=u;a[h>>2]=C;return 1}function vh(b){b|=0;var d,c;if(a[b+308>>2]|0)return 0;switch(a[b+40>>2]|0){case 7:case 3:break;default:return 0}if(3!=(a[b+36>>2]|0)||2!=(a[b+44>>2]|0)||3!=(a[b+120>>2]|0)||a[b+304>>2]|0)return 0;d=a[b+216>>2]|0;if(2!=(a[d+8>>2]|0)||1!=(a[d+96>>2]|0)||1!=(a[d+184>>2]|0)||2<(a[d+12>>2]|0)||1!=(a[d+100>>
2]|0)||1!=(a[d+188>>2]|0))return 0;c=a[d+36>>2]|0;if((c|0)!=(a[b+324>>2]|0)||(a[d+124>>2]|0)!=(c|0)||(a[d+212>>2]|0)!=(c|0))return 0;c=a[d+40>>2]|0;return(c|0)!=(a[b+328>>2]|0)?0:(a[d+128>>2]|0)==(c|0)?(a[d+216>>2]|0)==(c|0)|0:0}function Fg(b){b|=0;a[b>>2]=47;a[b+4>>2]=11;a[b+8>>2]=48;a[b+12>>2]=12;a[b+16>>2]=49;a[b+104>>2]=0;a[b+108>>2]=0;a[b+20>>2]=0;a[b+112>>2]=119460;a[b+116>>2]=126;a[b+120>>2]=0;a[b+124>>2]=0;a[b+128>>2]=0;return b|0}function Lh(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q;d=a[b+484>>
2]|0;c=1==(a[b+88>>2]|0);a[d+28>>2]=c&1;e=b+120|0;f=rb[a[(a[b+4>>2]|0)+8>>2]&63](b,1,c?766:256,a[e>>2]|0)|0;b=d+24|0;a[b>>2]=f;if(!(0>=(a[e>>2]|0))){f=a[d+20>>2]|0;g=0;do{h=a[d+32+(g<<2)>>2]|0;f=(f|0)/(h|0)|0;c&&(m=(a[b>>2]|0)+(g<<2)|0,a[m>>2]=(a[m>>2]|0)+255);m=a[(a[b>>2]|0)+(g<<2)>>2]|0;k=h+-1|0;l=k<<1;n=0;p=(h+254|0)/(l|0)|0;for(h=0;;){if((n|0)>(p|0))for(q=h;;)if(h=q+1|0,p=((255*(h<<1|1)|0)+k|0)/(l|0)|0,(n|0)>(p|0))q=h;else break;q=(E(h,f)|0)&255;t[m+n>>0]=q;n=n+1|0;if(256==(n|0))break}if(c){h=
m+255|0;p=1;do t[m+(0-p)>>0]=t[m>>0]|0,t[m+(p+255)>>0]=t[h>>0]|0,p=p+1|0;while(256!=(p|0))}g=g+1|0}while((g|0)<(a[e>>2]|0))}}function Mh(b){b|=0;var d,c,e;d=a[b+484>>2]|0;c=Aa[a[a[b+4>>2]>>2]&63](b,1,2044)|0;b=c+1020|0;a[d+40>>2]=b;a[b>>2]=0;a[c+1024>>2]=1;a[c+1016>>2]=-1;a[c+1028>>2]=2;a[c+1012>>2]=-2;a[c+1032>>2]=3;a[c+1008>>2]=-3;a[c+1036>>2]=4;a[c+1004>>2]=-4;a[c+1040>>2]=5;a[c+1E3>>2]=-5;a[c+1044>>2]=6;a[c+996>>2]=-6;a[c+1048>>2]=7;a[c+992>>2]=-7;a[c+1052>>2]=8;a[c+988>>2]=-8;a[c+1056>>2]=9;
a[c+984>>2]=-9;a[c+1060>>2]=10;a[c+980>>2]=-10;a[c+1064>>2]=11;a[c+976>>2]=-11;a[c+1068>>2]=12;a[c+972>>2]=-12;a[c+1072>>2]=13;a[c+968>>2]=-13;a[c+1076>>2]=14;a[c+964>>2]=-14;a[c+1080>>2]=15;a[c+960>>2]=-15;for(d=c=16;;)if(a[b+(c<<2)>>2]=d,a[b+(0-c<<2)>>2]=0-d,c=c+1|0,d=(c&1^1)+d|0,48==(c|0)){e=d;break}d=0-e|0;c=48;do a[b+(c<<2)>>2]=e,a[b+(0-c<<2)>>2]=d,c=c+1|0;while(256!=(c|0))}function Hg(b,d,c,e){b|=0;var f,g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,Ra,V,r,J,I,G,L,K,v,fd,O,M,T,X,P,Oa;f=u;u=u+1408|0;g=f+1152|
0;h=f+1024|0;m=a[(a[b+484>>2]|0)+24>>2]|0;k=(d|0)>>2;d=(c|0)>>3;c=(e|0)>>2;e=k<<5;l=e|4;n=d<<5;p=n|2;q=c<<5;y=q|4;B=a[b+132>>2]|0;H=e|28;e=H+l>>1;ka=n|30;n=ka+p>>1;z=q|28;q=z+y>>1;if(0<(B|0)){Q=a[b+136>>2]|0;C=a[Q>>2]|0;Ra=a[Q+4>>2]|0;V=a[Q+8>>2]|0;Q=0;for(r=2147483647;;)if(J=x[C+Q>>0]|0,(J|0)>=(l|0)?(J|0)>(H|0)?(I=J-H<<1,G=J-l<<1,L=E(G,G)|0,K=E(I,I)|0):(I=(J|0)>(e|0)?J-l<<1:J-H<<1,L=E(I,I)|0,K=0):(I=J-l<<1,G=J-H<<1,L=E(G,G)|0,K=E(I,I)|0),J=x[Ra+Q>>0]|0,(J|0)>=(p|0)?(J|0)>(ka|0)?(I=3*(J-ka|0)|0,G=
3*(J-p|0)|0,v=E(G,G)|0,fd=(E(I,I)|0)+K|0):(I=(J|0)>(n|0)?3*(J-p|0)|0:3*(J-ka|0)|0,v=E(I,I)|0,fd=K):(I=3*(J-p|0)|0,G=3*(J-ka|0)|0,v=E(G,G)|0,fd=(E(I,I)|0)+K|0),J=v+L|0,I=x[V+Q>>0]|0,(I|0)>=(y|0)?(I|0)>(z|0)?(G=I-z|0,O=I-y|0,M=E(O,O)|0,T=(E(G,G)|0)+fd|0):(G=(I|0)>(q|0)?I-y|0:I-z|0,M=E(G,G)|0,T=fd):(G=I-y|0,O=I-z|0,M=E(O,O)|0,T=(E(G,G)|0)+fd|0),I=J+M|0,a[f+(Q<<2)>>2]=T,G=(I|0)<(r|0)?I:r,Q=Q+1|0,(Q|0)==(B|0)){X=G;break}else r=G;for(Q=r=0;;)if((a[f+(r<<2)>>2]|0)>(X|0)?P=Q:(t[g+Q>>0]=r,P=Q+1|0),r=r+1|0,
(r|0)==(B|0)){Oa=P;break}else Q=P}else Oa=0;P=f;for(Q=127;;)if(a[P>>2]=2147483647,0<(Q|0))P=P+4|0,Q=Q+-1|0;else break;if(0<(Oa|0)){Q=b+136|0;b=h+32|0;P=f+128|0;B=h+64|0;r=f+256|0;X=h+96|0;T=f+384|0;M=0;do{fd=t[g+M>>0]|0;z=fd&255;q=a[Q>>2]|0;V=l-(x[(a[q>>2]|0)+z>>0]|0)|0;L=V<<1;v=E(L,L)|0;L=p-(x[(a[q+4>>2]|0)+z>>0]|0)|0;K=3*L|0;ka=(E(K,K)|0)+v|0;v=y-(x[(a[q+8>>2]|0)+z>>0]|0)|0;z=ka+(E(v,v)|0)|0;ka=V<<6;V=ka+256|0;q=(72*L|0)+144|0;L=v<<4;v=L+64|0;K=L+192|0;n=L+320|0;L=f;Ra=h;H=z;e=7;for(C=q;;)if((H|
0)<(a[L>>2]|0)&&(a[L>>2]=H,t[Ra>>0]=fd),G=v+H|0,I=L+4|0,(G|0)<(a[I>>2]|0)&&(a[I>>2]=G,t[Ra+1>>0]=fd),I=K+G|0,G=L+8|0,(I|0)<(a[G>>2]|0)&&(a[G>>2]=I,t[Ra+2>>0]=fd),G=n+I|0,I=L+12|0,(G|0)<(a[I>>2]|0)&&(a[I>>2]=G,t[Ra+3>>0]=fd),0<(e|0))L=L+16|0,Ra=Ra+4|0,H=H+C|0,e=e+-1|0,C=C+288|0;else break;C=z+V|0;e=ka+768|0;H=P;Ra=b;L=C;J=7;for(G=q;;)if((L|0)<(a[H>>2]|0)&&(a[H>>2]=L,t[Ra>>0]=fd),I=v+L|0,O=H+4|0,(I|0)<(a[O>>2]|0)&&(a[O>>2]=I,t[Ra+1>>0]=fd),O=K+I|0,I=H+8|0,(O|0)<(a[I>>2]|0)&&(a[I>>2]=O,t[Ra+2>>0]=fd),
I=n+O|0,O=H+12|0,(I|0)<(a[O>>2]|0)&&(a[O>>2]=I,t[Ra+3>>0]=fd),0<(J|0))H=H+16|0,Ra=Ra+4|0,L=L+G|0,J=J+-1|0,G=G+288|0;else break;G=C+e|0;J=ka+1280|0;L=r;Ra=B;H=G;V=7;for(z=q;;)if((H|0)<(a[L>>2]|0)&&(a[L>>2]=H,t[Ra>>0]=fd),I=v+H|0,O=L+4|0,(I|0)<(a[O>>2]|0)&&(a[O>>2]=I,t[Ra+1>>0]=fd),O=K+I|0,I=L+8|0,(O|0)<(a[I>>2]|0)&&(a[I>>2]=O,t[Ra+2>>0]=fd),I=n+O|0,O=L+12|0,(I|0)<(a[O>>2]|0)&&(a[O>>2]=I,t[Ra+3>>0]=fd),0<(V|0))L=L+16|0,Ra=Ra+4|0,H=H+z|0,V=V+-1|0,z=z+288|0;else break;z=T;V=X;H=G+J|0;Ra=7;for(L=q;;)if((H|
0)<(a[z>>2]|0)&&(a[z>>2]=H,t[V>>0]=fd),ka=v+H|0,e=z+4|0,(ka|0)<(a[e>>2]|0)&&(a[e>>2]=ka,t[V+1>>0]=fd),e=K+ka|0,ka=z+8|0,(e|0)<(a[ka>>2]|0)&&(a[ka>>2]=e,t[V+2>>0]=fd),ka=n+e|0,e=z+12|0,(ka|0)<(a[e>>2]|0)&&(a[e>>2]=ka,t[V+3>>0]=fd),0<(Ra|0))z=z+16|0,V=V+4|0,H=H+L|0,Ra=Ra+-1|0,L=L+288|0;else break;M=M+1|0}while((M|0)!=(Oa|0))}Oa=k<<2;k=d<<3;d=c<<2;c=a[m+(Oa<<2)>>2]|0;M=d|1;X=M+1|0;T=d|3;B=h;for(r=0;b=r+k|0,w[c+(b<<6)+(d<<1)>>1]=(x[B>>0]|0)+1,w[c+(b<<6)+(M<<1)>>1]=(x[B+1>>0]|0)+1,w[c+(b<<6)+(X<<1)>>1]=
(x[B+2>>0]|0)+1,w[c+(b<<6)+(T<<1)>>1]=(x[B+3>>0]|0)+1,r=r+1|0,8!=(r|0);)B=B+4|0;B=a[m+((Oa|1)<<2)>>2]|0;r=d|1;T=r+1|0;c=d|3;X=h+32|0;for(M=0;b=M+k|0,w[B+(b<<6)+(d<<1)>>1]=(x[X>>0]|0)+1,w[B+(b<<6)+(r<<1)>>1]=(x[X+1>>0]|0)+1,w[B+(b<<6)+(T<<1)>>1]=(x[X+2>>0]|0)+1,w[B+(b<<6)+(c<<1)>>1]=(x[X+3>>0]|0)+1,M=M+1|0,8!=(M|0);)X=X+4|0;X=a[m+((Oa|2)<<2)>>2]|0;M=d|1;c=M+1|0;B=d|3;T=h+64|0;for(r=0;b=r+k|0,w[X+(b<<6)+(d<<1)>>1]=(x[T>>0]|0)+1,w[X+(b<<6)+(M<<1)>>1]=(x[T+1>>0]|0)+1,w[X+(b<<6)+(c<<1)>>1]=(x[T+2>>0]|
0)+1,w[X+(b<<6)+(B<<1)>>1]=(x[T+3>>0]|0)+1,r=r+1|0,8!=(r|0);)T=T+4|0;T=a[m+((Oa|3)<<2)>>2]|0;Oa=d|1;m=Oa+1|0;r=d|3;B=h+96|0;for(h=0;X=h+k|0,w[T+(X<<6)+(d<<1)>>1]=(x[B>>0]|0)+1,w[T+(X<<6)+(Oa<<1)>>1]=(x[B+1>>0]|0)+1,w[T+(X<<6)+(m<<1)>>1]=(x[B+2>>0]|0)+1,w[T+(X<<6)+(r<<1)>>1]=(x[B+3>>0]|0)+1,h=h+1|0,8!=(h|0);)B=B+4|0;u=f}function mk(b,d){d|=0;var c,e,f,g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C;c=a[(a[(b|0)+484>>2]|0)+24>>2]|0;b=a[d>>2]|0;e=d+4|0;f=a[e>>2]|0;g=d+8|0;h=a[g>>2]|0;m=d+12|0;k=a[m>>2]|0;l=d+16|0;n=a[l>>
2]|0;p=d+20|0;q=a[p>>2]|0;a:do if((b|0)<(f|0)){y=(h|0)>(k|0);B=(n|0)>(q|0);H=b;b:for(;;){if(!y)for(t=a[c+(H<<2)>>2]|0,z=h;;){if(!B)for(Q=n,C=t+(z<<6)+(n<<1)|0;;){if(w[C>>1]|0){C=H;break b}if((Q|0)<(q|0))Q=Q+1|0,C=C+2|0;else break}if((z|0)<(k|0))z=z+1|0;else break}if((H|0)<(f|0))H=H+1|0;else{Q=b;break a}}Q=a[d>>2]=C}else Q=b;while(0);a:do if((f|0)>(Q|0)){b=(h|0)>(k|0);C=(n|0)>(q|0);H=f;b:for(;;){if(!b)for(B=a[c+(H<<2)>>2]|0,y=h;;){if(!C)for(z=n,t=B+(y<<6)+(n<<1)|0;;){if(w[t>>1]|0){B=H;break b}if((z|
0)<(q|0))z=z+1|0,t=t+2|0;else break}if((y|0)<(k|0))y=y+1|0;else break}if((H|0)>(Q|0))H=H+-1|0;else{y=f;break a}}y=a[e>>2]=B}else y=f;while(0);a:do if((h|0)<(k|0)){f=(y|0)<(Q|0);B=(n|0)>(q|0);e=h;b:for(;;){if(!f)for(H=Q;;){if(!B)for(C=n,b=(a[c+(H<<2)>>2]|0)+(e<<6)+(n<<1)|0;;){if(w[b>>1]|0){t=e;break b}if((C|0)<(q|0))C=C+1|0,b=b+2|0;else break}if((H|0)<(y|0))H=H+1|0;else break}if((e|0)<(k|0))e=e+1|0;else{H=h;break a}}H=a[g>>2]=t}else H=h;while(0);a:do if((k|0)>(H|0)){h=(y|0)<(Q|0);t=(n|0)>(q|0);g=k;
b:for(;;){if(!h)for(e=Q;;){if(!t)for(B=n,f=(a[c+(e<<2)>>2]|0)+(g<<6)+(n<<1)|0;;){if(w[f>>1]|0){f=g;break b}if((B|0)<(q|0))B=B+1|0,f=f+2|0;else break}if((e|0)<(y|0))e=e+1|0;else break}if((g|0)>(H|0))g=g+-1|0;else{e=k;break a}}e=a[m>>2]=f}else e=k;while(0);a:do if((n|0)<(q|0)){k=(y|0)<(Q|0);f=(e|0)<(H|0);m=n;b:for(;;){if(!k)for(g=Q;;){if(!f)for(t=H,h=(a[c+(g<<2)>>2]|0)+(H<<6)+(m<<1)|0;;){if(w[h>>1]|0){B=m;break b}if((t|0)<(e|0))t=t+1|0,h=h+64|0;else break}if((g|0)<(y|0))g=g+1|0;else break}if((m|0)<
(q|0))m=m+1|0;else{g=n;break a}}g=a[l>>2]=B}else g=n;while(0);a:do if((q|0)>(g|0)){n=(y|0)<(Q|0);B=(e|0)<(H|0);l=q;b:for(;;){c:do if(!n){if(B)for(m=Q;;)if((m|0)<(y|0))m=m+1|0;else break c;else h=Q;for(;;){m=H;for(f=(a[c+(h<<2)>>2]|0)+(H<<6)+(l<<1)|0;;){if(w[f>>1]|0){f=l;break b}if((m|0)<(e|0))m=m+1|0,f=f+64|0;else break}if((h|0)<(y|0))h=h+1|0;else break}}while(0);if((l|0)>(g|0))l=l+-1|0;else{m=q;break a}}m=a[p>>2]=f}else m=q;while(0);q=y-Q<<4;f=12*(e-H|0)|0;p=m-g<<3;h=(E(f,f)|0)+(E(q,q)|0)+(E(p,p)|
0)|0;a[d+24>>2]=h;if((y|0)<(Q|0))a[(d+28|0)>>2]=0;else if(h=(m|0)<(g|0),(e|0)<(H|0))a[(d+28|0)>>2]=0;else{k=Q;for(l=0;;){Q=a[c+(k<<2)>>2]|0;if(h)p=l;else for(p=H,q=l;;){f=g;l=q;for(B=Q+(p<<6)+(g<<1)|0;;)if(n=(0!=(w[B>>1]|0)&1)+l|0,(f|0)<(m|0))f=f+1|0,l=n,B=B+2|0;else{l=n;break}if((p|0)<(e|0))p=p+1|0,q=l;else{p=l;break}}if((k|0)<(y|0))k=k+1|0,l=p;else break}a[(d+28|0)>>2]=p}}function Gb(a,d){d|=0;return((a|0)+-1+d|0)/(d|0)|0}function Ch(a,d){d|=0;var c;c=(a|0)+-1+d|0;return c-((c|0)%(d|0)|0)|0}function Dg(b,
d,c,e,f,g){f|=0;g|=0;if(!(0>=(f|0)))for(c=(c|0)+((e|0)<<2)|0,e=(b|0)+((d|0)<<2)|0,d=f;;)if(Ec(a[c>>2]|0,a[e>>2]|0,g|0)|0,1<(d|0))c=c+4|0,e=e+4|0,d=d+-1|0;else break}function Wg(b){b|=0;var d,c,e,f,g,h,m;d=u;u=u+16|0;c=d+8|0;e=d+12|0;f=b+4|0;g=a[f>>2]=0;a[c>>2]=g;g=Hc(84)|0;g||(h=a[b>>2]|0,a[h+20>>2]=56,a[h+24>>2]=0,R[a[h>>2]&127](b));a[g>>2]=30;a[g+4>>2]=31;a[g+8>>2]=53;a[g+12>>2]=54;a[g+16>>2]=1;a[g+20>>2]=2;a[g+24>>2]=55;a[g+28>>2]=1;a[g+32>>2]=2;a[g+36>>2]=15;a[g+40>>2]=56;a[g+48>>2]=1E9;b=g+44|
0;a[b>>2]=a[c>>2];a[g+56>>2]=0;a[g+64>>2]=0;a[g+52>>2]=0;a[g+60>>2]=0;a[g+68>>2]=0;a[g+72>>2]=0;a[g+76>>2]=84;a[f>>2]=g;if(g=Xj(161233)|0){t[e>>0]=120;a[d>>2]=c;a[d+4>>2]=e;var k=g,l=d,n;n=u;u=u+16|0;a[n>>2]=l|0;var p=k|0,p=p|0,q,y,B;q=u;u=u+112|0;y=q;B=y+112|0;do a[y>>2]=0,y=y+4|0;while((y|0)<(B|0));a[q+32>>2]=32;a[q+44>>2]=p;a[q+76>>2]=-1;a[q+84>>2]=p;var H;var ka=q,z=161241,Q=n|0,ka=ka|0,z=z|0,Q=Q|0,C=0,Ra=0,V=0,r=0,J=0,I=0,G=0,L=0,K=0,v=0,E=0,O=0,M=0,T=0,X=0,P=0,Oa=0,A=0,D=0,ba=0,N=0,F=0,Mg=0,
ga=0,Ha=0,ma=0,bc=0,ha=0,Y=0,S=0,pc=0,da=0,Z=0,ca=0,oa=0,sa=0,aa=0,ua=0,Ia=0,Da=0,na=0,Na=0,fa=0,Ca=0,Ga=0,Ea=0,La=0,ja=0,ya=0,Aa=0,ra=0,xb=0,Zb=0,pa=0,jb=0,mc=0,Wa=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,fe=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Ka=0,Ua=0,Qa=0,Jb=0,eb=0,yb=0,cb=0,gc=0,C=u;u=u+304|0;Ra=C+16|0;V=C+8|0;r=C+33|0;J=C;I=C+32|0;G=t[z>>0]|0;b:do if(G<<24>>24){L=ka+
4|0;K=ka+100|0;v=ka+108|0;E=ka+8|0;O=r+10|0;M=r+33|0;T=V+4|0;X=r+46|0;P=r+94|0;Oa=G;A=0;D=z;F=N=ba=0;c:for(;;){d:do{if(Eg(Oa&255)|0){for(Y=D;;)if(S=Y+1|0,Eg(x[S>>0]|0)|0)Y=S;else{Ua=Y;break}Sf(ka,0);do Y=a[L>>2]|0,Y>>>0<(a[K>>2]|0)>>>0?(a[L>>2]=Y+1,Qa=x[Y>>0]|0):Qa=Jc(ka)|0;while(0!=(Eg(Qa)|0));Y=a[L>>2]|0;a[K>>2]|0?(Mg=Y+-1|0,Jb=a[L>>2]=Mg):Jb=Y;ra=A;xb=Ua;Zb=(a[v>>2]|0)+ba+Jb-(a[E>>2]|0)|0}else{Mg=37==(t[D>>0]|0);e:do if(Mg){ga=D+1|0;Ha=t[ga>>0]|0;f:do switch(Ha<<24>>24){case 37:break e;case 42:ma=
0;bc=D+2|0;break;default:ha=(Ha&255)+-48|0;if(10>ha>>>0&&36==(t[D+2>>0]|0)){a[Ra>>2]=a[Q>>2];for(Y=ha;;)if(ha=(a[Ra>>2]|0)+3&-4,S=a[ha>>2]|0,a[Ra>>2]=ha+4,1<Y>>>0)Y=Y+-1|0;else{pc=S;break}ma=pc;bc=D+3|0;break f}Y=(a[Q>>2]|0)+3&-4;S=a[Y>>2]|0;a[Q>>2]=Y+4;ma=S;bc=ga}while(0);ga=t[bc>>0]|0;Ha=ga&255;if(10>(Ha+-48|0)>>>0)for(S=Ha,Ha=bc,Y=0;;)if(ha=(10*Y|0)+-48+S|0,da=Ha+1|0,Z=t[da>>0]|0,S=Z&255,10<=(S+-48|0)>>>0){ca=Z;oa=da;sa=ha;break}else Ha=da,Y=ha;else ca=ga,oa=bc,sa=0;109==ca<<24>>24?(Y=oa+1|0,aa=
t[Y>>0]|0,ua=0!=(ma|0)&1,Ia=Y,na=Da=0):(aa=ca,ua=0,Ia=oa,Da=N,na=F);Y=Ia+1|0;switch(aa&255|0){case 104:Na=(Ha=104==(t[Y>>0]|0))?Ia+2|0:Y;fa=Ha?-2:-1;break;case 108:Na=(Ha=108==(t[Y>>0]|0))?Ia+2|0:Y;fa=Ha?3:1;break;case 106:Na=Y;fa=3;break;case 116:case 122:Na=Y;fa=1;break;case 76:Na=Y;fa=2;break;case 110:case 112:case 67:case 83:case 91:case 99:case 115:case 88:case 71:case 70:case 69:case 65:case 103:case 102:case 101:case 97:case 120:case 117:case 111:case 105:case 100:Na=Ia;fa=0;break;default:Ca=
ua;Ga=A;Ea=Da;La=na;ja=152;break c}Y=x[Na>>0]|0;S=(Ha=3==(Y&47|0))?Y|32:Y;Y=Ha?1:fa;switch(S|0){case 99:ya=ba;Aa=1>(sa|0)?1:sa;break;case 91:ya=ba;Aa=sa;break;case 110:if(!ma){ra=A;xb=Na;Zb=ba;pa=Da;jb=na;break d}switch(Y|0){case -2:t[ma>>0]=ba;ra=A;xb=Na;Zb=ba;pa=Da;jb=na;break d;case -1:w[ma>>1]=ba;ra=A;xb=Na;Zb=ba;pa=Da;jb=na;break d;case 0:a[ma>>2]=ba;ra=A;xb=Na;Zb=ba;pa=Da;jb=na;break d;case 1:a[ma>>2]=ba;ra=A;xb=Na;Zb=ba;pa=Da;jb=na;break d;case 3:Ha=ma;a[Ha>>2]=ba;a[Ha+4>>2]=(0>(ba|0))<<31>>
31;ra=A;xb=Na;Zb=ba;pa=Da;jb=na;break d;default:ra=A;xb=Na;Zb=ba;pa=Da;jb=na;break d}default:Sf(ka,0);do Ha=a[L>>2]|0,Ha>>>0<(a[K>>2]|0)>>>0?(a[L>>2]=Ha+1,mc=x[Ha>>0]|0):mc=Jc(ka)|0;while(0!=(Eg(mc)|0));ga=a[L>>2]|0;a[K>>2]|0?(Ha=ga+-1|0,Wa=a[L>>2]=Ha):Wa=ga;ya=(a[v>>2]|0)+ba+Wa-(a[E>>2]|0)|0;Aa=sa}Sf(ka,Aa);Ha=a[L>>2]|0;ga=a[K>>2]|0;if(Ha>>>0<ga>>>0)a[L>>2]=Ha+1,Ta=ga;else{if(0>(Jc(ka)|0)){Ca=ua;Ga=A;Ea=Da;La=na;ja=152;break c}Ta=a[K>>2]|0}Ta&&(a[L>>2]=(a[L>>2]|0)+-1);f:do switch(S|0){case 91:case 99:case 115:ga=
99==(S|0);g:do if(99==(S&239|0))Va(r|0,-1,257)|0,t[r>>0]=0,115==(S|0)&&(t[M>>0]=0,t[O>>0]=0,t[O+1>>0]=0,t[O+2>>0]=0,t[O+3>>0]=0,t[O+4>>0]=0),Ya=Na;else{Ha=Na+1|0;ha=94==(t[Ha>>0]|0);da=ha&1;Z=ha?Ha:Na;Sa=ha?Na+2|0:Ha;Va(r|0,ha&1|0,257)|0;t[r>>0]=0;switch(t[Sa>>0]|0){case 45:ha=(da^1)&255;mb=t[X>>0]=ha;Db=Z+2|0;break;case 93:ha=(da^1)&255;mb=t[P>>0]=ha;Db=Z+2|0;break;default:mb=(da^1)&255,Db=Sa}for(Sa=Db;;){da=t[Sa>>0]|0;h:do switch(da<<24>>24){case 0:Ca=ua;Ga=A;Ea=Da;La=na;ja=152;break c;case 93:Ya=
Sa;break g;case 45:Z=Sa+1|0;ha=t[Z>>0]|0;switch(ha<<24>>24){case 93:case 0:cc=45;Za=Sa;break h}Ha=t[Sa+-1>>0]|0;if((Ha&255)<(ha&255)){ia=Ha&255;do ia=ia+1|0,t[r+ia>>0]=mb,Ha=t[Z>>0]|0;while((ia|0)<(Ha&255|0));cc=Ha}else cc=ha;Za=Z;break;default:cc=da,Za=Sa}while(0);t[r+((cc&255)+1)>>0]=mb;Sa=Za+1|0}}while(0);Sa=ga?Aa+1|0:31;da=1==(Y|0);ia=0!=(ua|0);g:do if(da){if(ia)if(Ha=Hc(Sa<<2)|0)qa=Ha;else{Ca=ua;Ga=A;Ea=0;La=Ha;ja=152;break c}else qa=ma;a[V>>2]=0;Ha=a[T>>2]=0;Ja=Sa;ea=qa;h:for(;;){wa=0==(ea|
0);for(Ma=Ha;;){i:for(;;){xa=a[L>>2]|0;xa>>>0<(a[K>>2]|0)>>>0?(a[L>>2]=xa+1,$a=x[xa>>0]|0):$a=Jc(ka)|0;if(!(t[r+($a+1)>>0]|0)){la=Ma;Ba=ea;break h}t[I>>0]=$a;switch(Mi(J,I,1,V)|0){case -1:Ca=ua;Ga=A;Ea=0;La=ea;ja=152;break c;case -2:break;default:break i}}wa?va=Ma:(a[ea+(Ma<<2)>>2]=a[J>>2],va=Ma+1|0);if(ia&(va|0)==(Ja|0))break;else Ma=va}Ma=Ja<<1|1;wa=qi(ea,Ma<<2)|0;if(!wa){Ca=ua;Ga=A;Ea=0;La=ea;ja=152;break c}Z=Ja;Ja=Ma;ea=wa;Ha=Z}var Ub=V,Ub=Ub|0;if((Ub?0==(a[Ub>>2]|0):1)&1|0)za=la,ta=0,nb=Ba;else{Ca=
ua;Ga=A;Ea=0;La=Ba;ja=152;break c}}else{if(ia){if(Ha=Hc(Sa)|0)sc=0,gb=Sa,hb=Ha;else{Ca=ua;Ga=A;La=Ea=0;ja=152;break c}for(;;){Ha=sc;do{ea=a[L>>2]|0;ea>>>0<(a[K>>2]|0)>>>0?(a[L>>2]=ea+1,ob=x[ea>>0]|0):ob=Jc(ka)|0;if(!(t[r+(ob+1)>>0]|0)){za=Ha;ta=hb;nb=0;break g}t[hb+Ha>>0]=ob;Ha=Ha+1|0}while((Ha|0)!=(gb|0));Ha=gb<<1|1;if(ea=qi(hb,Ha)|0)Ja=gb,gb=Ha,hb=ea,sc=Ja;else{Ca=ua;Ga=A;Ea=hb;La=0;ja=152;break c}}}if(ma)for(Ja=Ta,ea=0;;){Ha=a[L>>2]|0;Ha>>>0<Ja>>>0?(a[L>>2]=Ha+1,qb=x[Ha>>0]|0):qb=Jc(ka)|0;if(!(t[r+
(qb+1)>>0]|0)){za=ea;ta=ma;nb=0;break g}t[ma+ea>>0]=qb;Ja=a[K>>2]|0;ea=ea+1|0}else for(Ja=Ta;;){ea=a[L>>2]|0;ea>>>0<Ja>>>0?(a[L>>2]=ea+1,Bb=x[ea>>0]|0):Bb=Jc(ka)|0;if(!(t[r+(Bb+1)>>0]|0)){nb=ta=za=0;break g}Ja=a[K>>2]|0}}while(0);Sa=a[L>>2]|0;a[K>>2]|0?(ea=Sa+-1|0,kb=a[L>>2]=ea):kb=Sa;ea=kb-(a[E>>2]|0)+(a[v>>2]|0)|0;if(!ea){ib=ua;Cb=A;fe=ta;sb=nb;break c}if(!((ea|0)==(Aa|0)|ga^1)){ib=ua;Cb=A;fe=ta;sb=nb;break c}ia&&(a[ma>>2]=da?nb:ta);if(!ga){nb&&(a[nb+(za<<2)>>2]=0);if(!ta){Xa=Ya;Fa=0;Pa=nb;break f}t[ta+
za>>0]=0}Xa=Ya;Fa=ta;Pa=nb;break;case 120:case 88:case 112:Eb=16;ja=134;break;case 111:Eb=8;ja=134;break;case 117:case 100:Eb=10;ja=134;break;case 105:Eb=0;ja=134;break;case 71:case 103:case 70:case 102:case 69:case 101:case 65:case 97:vb=+Ki(ka,Y,0);if((a[v>>2]|0)==((a[E>>2]|0)-(a[L>>2]|0)|0)){ib=ua;Cb=A;fe=Da;sb=na;break c}if(ma)switch(Y|0){case 0:W[ma>>2]=vb;Xa=Na;Fa=Da;Pa=na;break f;case 1:Hb[ma>>3]=vb;Xa=Na;Fa=Da;Pa=na;break f;case 2:Hb[ma>>3]=vb;Xa=Na;Fa=Da;Pa=na;break f;default:Xa=Na;Fa=Da;
Pa=na;break f}else Xa=Na,Fa=Da,Pa=na;break;default:Xa=Na,Fa=Da,Pa=na}while(0);f:do if(134==(ja|0)){ja=0;da=Zh(ka,Eb,0,-1,-1)|0;if((a[v>>2]|0)==((a[E>>2]|0)-(a[L>>2]|0)|0)){ib=ua;Cb=A;fe=Da;sb=na;break c}if(0!=(ma|0)&112==(S|0))a[ma>>2]=da,Xa=Na,Fa=Da,Pa=na;else if(ma)switch(Y|0){case -2:t[ma>>0]=da;Xa=Na;Fa=Da;Pa=na;break f;case -1:w[ma>>1]=da;Xa=Na;Fa=Da;Pa=na;break f;case 0:a[ma>>2]=da;Xa=Na;Fa=Da;Pa=na;break f;case 1:a[ma>>2]=da;Xa=Na;Fa=Da;Pa=na;break f;case 3:ia=ma;a[ia>>2]=da;a[ia+4>>2]=U;Xa=
Na;Fa=Da;Pa=na;break f;default:Xa=Na;Fa=Da;Pa=na;break f}else Xa=Na,Fa=Da,Pa=na}while(0);ra=(0!=(ma|0)&1)+A|0;xb=Xa;Zb=(a[v>>2]|0)+ya+(a[L>>2]|0)-(a[E>>2]|0)|0;pa=Fa;jb=Pa;break d}while(0);Y=D+(Mg&1)|0;Sf(ka,0);S=a[L>>2]|0;S>>>0<(a[K>>2]|0)>>>0?(a[L>>2]=S+1,tb=x[S>>0]|0):tb=Jc(ka)|0;if((tb|0)!=(x[Y>>0]|0)){bb=tb;Ib=A;Mb=N;Ka=F;ja=21;break c}ra=A;xb=Y;Zb=ba+1|0}pa=N;jb=F}while(0);D=xb+1|0;Oa=t[D>>0]|0;if(Oa<<24>>24)A=ra,ba=Zb,N=pa,F=jb;else{eb=ra;break b}}if(21==(ja|0))if(a[K>>2]|0&&(a[L>>2]=(a[L>>
2]|0)+-1),0!=(Ib|0)|-1<(bb|0)){eb=Ib;break}else yb=0,cb=Mb,gc=Ka,ja=153;else 152==(ja|0)&&(Ga?(ib=Ca,Cb=Ga,fe=Ea,sb=La):(yb=Ca,cb=Ea,gc=La,ja=153));153==(ja|0)&&(ib=yb,Cb=-1,fe=cb,sb=gc);ib&&(Gc(fe),Gc(sb));eb=Cb}else eb=0;while(0);u=C;H=eb|0;p=H|0;u=q;l=p|0;u=n;if(!(0>=(l|0))){switch(t[e>>0]|0){case 77:case 109:e=1E3*(a[c>>2]|0)|0;m=a[c>>2]=e;break;default:m=a[c>>2]|0}a[b>>2]=1E3*m}}u=d}function ih(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h=0,m=0,k,l=0,n,p;e=a[b+4>>2]|0;999999984<c>>>0&&(f=a[b>>2]|0,a[f+
20>>2]=56,a[f+24>>2]=1,R[a[f>>2]&127](b));f=c&7;g=(0==(f|0)?0:8-f|0)+c|0;1<d>>>0&&(c=a[b>>2]|0,a[c+20>>2]=15,a[c+24>>2]=d,R[a[c>>2]&127](b));c=e+52+(d<<2)|0;f=a[c>>2]|0;a:do if(f)for(k=f;;){if((a[k+8>>2]|0)>>>0>=g>>>0){l=k;break a}if(n=a[k>>2]|0)k=n;else{h=k;m=8;break}}else h=0,m=8;while(0);do if(8==(m|0)){f=g+16|0;k=0==(h|0);n=a[(k?121244:121252)+(d<<2)>>2]|0;p=999999984-g|0;l=n>>>0>p>>>0?p:n;n=f+l|0;if(p=Hc(n|0)|0)f=n,n=p;else for(p=l;;)if(l=p>>>1,100>p>>>0&&(p=a[b>>2]|0,a[p+20>>2]=56,a[p+24>>2]=
2,R[a[p>>2]&127](b)),p=f+l|0,n=Hc(p|0)|0){f=p;break}else p=l;p=e+76|0;a[p>>2]=(a[p>>2]|0)+f;a[n>>2]=0;a[n+4>>2]=0;a[n+8>>2]=l+g;k?a[c>>2]=n:a[h>>2]=n;l=n}while(0);n=l+4|0;h=a[n>>2]|0;a[n>>2]=h+g;n=l+8|0;a[n>>2]=(a[n>>2]|0)-g;return l+16+h|0}function nk(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;e=a[b+4>>2]|0;999999984<c>>>0&&(f=a[b>>2]|0,a[f+20>>2]=56,a[f+24>>2]=3,R[a[f>>2]&127](b));f=c&7;g=(0==(f|0)?0:8-f|0)+c|0;1<d>>>0&&(c=a[b>>2]|0,a[c+20>>2]=15,a[c+24>>2]=d,R[a[c>>2]&127](b));c=g+16|0;f=Hc(c|0)|0;f||(h=
a[b>>2]|0,a[h+20>>2]=56,a[h+24>>2]=4,R[a[h>>2]&127](b));b=e+76|0;a[b>>2]=(a[b>>2]|0)+c;c=e+60+(d<<2)|0;a[f>>2]=a[c>>2];a[f+4>>2]=g;a[f+8>>2]=0;a[c>>2]=f;return f+16|0}function Xg(b){b|=0;var d=0,c=0,e=0,f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0,z=0,Q=0,C=0,Ra=0,V=0,r=0,J=0,I=0,G=0,L=0,K=0,v=0,E=0,O=0,M=0,T=0,X=0,P=0,Oa=0,A=0,D=0,ba=0,F=0,Te=0,R=0,ga=0,Ha=0,ma=0,bc=0,ha=0,S=0,W=0,pc=0,Nb=0,ca=0,fa=0,oa=0,sa=0,aa=0,ua=0,Ia=0,Da=0,na=0,Na=0,hf=0,Ca=0,Ga=0,Ea=0,La=0,ya=0,ra=0,pa=0,Wa=0,xb=
0,Zb=0,Ka=0,jb=0,mc=0,Qa=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,fe=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Va=0,Ua=0,ub=0,Jb=0,ab=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,fk=0,pb=0,nd=0,Zd=0,wb=0,Hb=0,Qd=0,zb=0,Ob=0,Tb=0,jf=0,fb=0,Gb=0,Wb=0,Kb=0,lb=0,Lb=0,d=u;u=u+272|0;c=d+248|0;e=d+240|0;f=d+232|0;g=d+224|0;h=d+216|0;m=d+208|0;k=d+200|0;l=d+192|0;n=d+184|0;p=d+176|0;q=d+168|0;y=d+160|0;
B=d+152|0;H=d+144|0;ka=d+136|0;z=d+128|0;Q=d+120|0;C=d+112|0;Ra=d+104|0;V=d+96|0;r=d+88|0;J=d+80|0;I=d+72|0;G=d+64|0;L=d+56|0;K=d+48|0;v=d+40|0;E=d+32|0;O=d+24|0;M=d+16|0;T=d+8|0;X=d;P=d+256|0;Oa=b+576|0;A=a[Oa>>2]|0;ba=D=A+176|0;F=a[ba>>2]|0;Te=a[ba+4>>2]|0;0==(F|0)&0==(Te|0)?(ba=da[a[b+648>>2]&63](a[b+628>>2]|0)|0,R=U,ga=D,a[ga>>2]=ba,Ha=a[ga+4>>2]=R,ma=ba):(Ha=Te,ma=F);Te=F=A+208|0;ba=a[Te>>2]|0;R=a[Te+4>>2]|0;0==(ba|0)&0==(R|0)||(Ha>>>0>R>>>0|(Ha|0)==(R|0)&ma>>>0>ba>>>0?(ga=Te=A+216|0,D=a[ga>>
2]|0,bc=a[ga+4>>2]|0,ga=Qb(D|0,bc|0,ba|0,R|0)|0,ha=U,0==(D|0)&0==(bc|0)|ha>>>0>Ha>>>0|(ha|0)==(Ha|0)&ga>>>0>ma>>>0&&(ga=Ic(ma|0,Ha|0,ba|0,R|0)|0,ha=Te,a[ha>>2]=ga,a[ha+4>>2]=U)):(a[F>>2]=0,a[F+4>>2]=0,a[F+8>>2]=0,a[F+12>>2]=0));a[A+1220>>2]=0;a[A+1224>>2]=0;a[A+1228>>2]=a[b+168>>2];ba=R=A+1248|0;a[ba>>2]=0;a[ba+4>>2]=0;ba=A+1256|0;w[ba>>1]=0;Ha=A+1260|0;ma=A+1232|0;F=A+1240|0;ha=A+225|0;ga=A+205|0;Te=0;a:for(;;){if(Te<<16>>16)pc=Te;else{if(!(Fc(A)|0)){S=0;W=324;break}bc=w[ba>>1]|0;if(bc<<16>>16)pc=
bc;else{W=13;break}}bc=a[Ha>>2]|0;if(-1!=(t[bc>>0]|0)){W=252;break}D=bc+1|0;a[Ha>>2]=D;bc=pc+-1<<16>>16;w[ba>>1]=bc;Nb=D;for(D=bc;;){if(D<<16>>16)ca=D,fa=Nb;else{if(!(Fc(A)|0)){S=0;W=324;break a}bc=w[ba>>1]|0;if(!(bc<<16>>16)){W=20;break a}ca=bc;fa=a[Ha>>2]|0}bc=t[fa>>0]|0;oa=fa+1|0;a[Ha>>2]=oa;sa=ca+-1<<16>>16;w[ba>>1]=sa;if(-1==bc<<24>>24)Nb=oa,D=sa;else{aa=bc;ua=oa;Ia=sa;break}}D=aa&255;b:do switch(D|0){case 216:break;case 239:case 238:case 237:case 236:case 235:case 234:case 233:case 232:case 231:case 230:case 229:case 228:case 227:case 226:case 225:case 224:case 254:if(Ia<<
16>>16)Da=ua,na=Ia;else{if(!(Fc(A)|0)){S=0;W=324;break a}Nb=w[ba>>1]|0;if(!(Nb<<16>>16)){W=27;break a}Da=a[Ha>>2]|0;na=Nb}Nb=t[Da>>0]|0;sa=Da+1|0;a[Ha>>2]=sa;oa=na+-1<<16>>16;w[ba>>1]=oa;bc=(Nb&255)<<8;if(oa<<16>>16)Na=sa,hf=oa;else{if(!(Fc(A)|0)){S=0;W=324;break a}Nb=w[ba>>1]|0;if(!(Nb<<16>>16)){W=32;break a}Na=a[Ha>>2]|0;hf=Nb}oa=t[Na>>0]|0;a[Ha>>2]=Na+1;sa=hf+-1<<16>>16;w[ba>>1]=sa;Nb=oa&255|bc;bc=Nb&65535;if(2>(bc&65535)){W=34;break a}if(2<(bc&65535)&&(bc=Nb+65534|0,Nb=bc&65535,oa=((sa&65535)<
(Nb&65535)?sa:Nb)&65535,a[Ha>>2]=Na+(oa+1),Nb=(sa&65535)-oa|0,w[ba>>1]=Nb,sa=bc-oa|0,oa=sa&65535,bc=sa&65535,0!=(bc|0))){if(Nb&65535){W=39;break a}Nb=R;sa=a[Nb>>2]|0;Ca=a[Nb+4>>2]|0;Nb=(0>Ca>>>0|0==(Ca|0)&bc>>>0>sa>>>0?sa&65535:oa)&65535;oa=ma;bc=Qb(Nb|0,0,a[oa>>2]|0,a[oa+4>>2]|0)|0;oa=ma;a[oa>>2]=bc;a[oa+4>>2]=U;oa=Ic(sa|0,Ca|0,Nb|0,0)|0;Nb=R;a[Nb>>2]=oa;a[Nb+4>>2]=U;t[F>>0]=0}break;case 221:Nb=a[Oa>>2]|0;oa=Nb+1256|0;Ca=w[oa>>1]|0;if(Ca<<16>>16)Ga=Ca;else{if(!(Fc(Nb)|0)){S=0;W=324;break a}sa=w[oa>>
1]|0;if(sa<<16>>16)Ga=sa;else{W=44;break a}}Ca=Nb+1260|0;sa=a[Ca>>2]|0;bc=t[sa>>0]|0;Ea=sa+1|0;a[Ca>>2]=Ea;sa=Ga+-1<<16>>16;w[oa>>1]=sa;La=(bc&255)<<8;if(sa<<16>>16)ya=Ea,ra=sa;else{if(!(Fc(Nb)|0)){S=0;W=324;break a}bc=w[oa>>1]|0;if(!(bc<<16>>16)){W=49;break a}ya=a[Ca>>2]|0;ra=bc}sa=t[ya>>0]|0;Ea=ya+1|0;a[Ca>>2]=Ea;bc=ra+-1<<16>>16;w[oa>>1]=bc;if(4!=(sa&255|La|0)){W=51;break a}if(bc<<16>>16)pa=Ea,Wa=bc;else{if(!(Fc(Nb)|0)){S=0;W=324;break a}La=w[oa>>1]|0;if(!(La<<16>>16)){W=56;break a}pa=a[Ca>>2]|
0;Wa=La}bc=t[pa>>0]|0;Ea=pa+1|0;a[Ca>>2]=Ea;La=Wa+-1<<16>>16;w[oa>>1]=La;sa=(bc&255)<<8;if(La<<16>>16)xb=Ea,Zb=La;else{if(!(Fc(Nb)|0)){S=0;W=324;break a}bc=w[oa>>1]|0;if(!(bc<<16>>16)){W=61;break a}xb=a[Ca>>2]|0;Zb=bc}La=t[xb>>0]|0;a[Ca>>2]=xb+1;w[oa>>1]=Zb+-1<<16>>16;w[Nb+360>>1]=La&255|sa;break;case 219:sa=a[Oa>>2]|0;La=sa+1256|0;Nb=w[La>>1]|0;if(Nb<<16>>16)Ka=Nb;else{if(!(Fc(sa)|0)){S=0;W=324;break a}oa=w[La>>1]|0;if(oa<<16>>16)Ka=oa;else{W=66;break a}}Nb=sa+1260|0;oa=a[Nb>>2]|0;Ca=t[oa>>0]|0;
Ea=oa+1|0;a[Nb>>2]=Ea;oa=Ka+-1<<16>>16;w[La>>1]=oa;bc=(Ca&255)<<8;if(oa<<16>>16)jb=Ea,mc=oa;else{if(!(Fc(sa)|0)){S=0;W=324;break a}Ca=w[La>>1]|0;if(!(Ca<<16>>16)){W=71;break a}jb=a[Nb>>2]|0;mc=Ca}oa=t[jb>>0]|0;a[Nb>>2]=jb+1;Ea=mc+-1<<16>>16;w[La>>1]=Ea;Ca=oa&255|bc;Qa=0==(t[sa+225>>0]|0);if(3>(Ca&65535)){W=73;break a}bc=Ca+65534|0;Ca=bc&65535;if(Qa)Ta=Ca;else{oa=((Ea&65535)<(Ca&65535)?Ea:Ca)&65535;a[Nb>>2]=jb+(oa+1);Ca=(Ea&65535)-oa|0;w[La>>1]=Ca;Ea=bc-oa|0;oa=Ea&65535;if(!oa)break b;if(Ca&65535){W=
78;break a}bc=Ca=sa+1248|0;Ya=a[bc>>2]|0;Sa=a[bc+4>>2]|0;bc=(0>Sa>>>0|0==(Sa|0)&oa>>>0>Ya>>>0?Ya&65535:Ea&65535)&65535;oa=Ea=sa+1232|0;mb=Qb(bc|0,0,a[oa>>2]|0,a[oa+4>>2]|0)|0;oa=Ea;a[oa>>2]=mb;a[oa+4>>2]=U;oa=Ic(Ya|0,Sa|0,bc|0,0)|0;bc=Ca;a[bc>>2]=oa;a[bc+4>>2]=U;t[sa+1240>>0]=0;break b}for(;;){if(65>(Ta&65535)){W=81;break a}bc=eb(73)|0;if(!bc){W=83;break a}a[bc>>2]=73;t[bc+4>>0]=-1;t[bc+5>>0]=-37;t[bc+6>>0]=0;t[bc+7>>0]=67;oa=bc+8|0;Ca=w[La>>1]|0;Sa=65;for(Ya=oa;;){if(Ca<<16>>16)cc=Ca;else{if(!(Fc(sa)|
0)){Db=bc;W=90;break a}mb=w[La>>1]|0;if(mb<<16>>16)cc=mb;else{W=88;break a}}mb=((Sa&65535)>(cc&65535)?cc:Sa)&65535;Ab(Ya,a[Nb>>2]|0,mb);a[Nb>>2]=(a[Nb>>2]|0)+mb;Ca=(N[La>>1]|0)-mb&65535;w[La>>1]=Ca;Ea=(Sa&65535)-mb|0;if(Ea&65535)Sa=Ea&65535,Ya=Ya+mb|0;else break}Ya=x[oa>>0]&15;if(3<Ya>>>0){Za=bc;W=92;break a}Sa=sa+312+(Ya<<2)|0;(Ya=a[Sa>>2]|0)&&ja(Ya);a[Sa>>2]=bc;Sa=(Ta&65535)+65471|0;if(Sa&65535)Ta=Sa&65535;else break}break;case 196:sa=a[Oa>>2]|0;La=sa+1256|0;Nb=w[La>>1]|0;if(Nb<<16>>16)ia=Nb;else{if(!(Fc(sa)|
0)){S=0;W=324;break a}Sa=w[La>>1]|0;if(Sa<<16>>16)ia=Sa;else{W=99;break a}}Nb=sa+1260|0;Sa=a[Nb>>2]|0;Ya=t[Sa>>0]|0;Ca=Sa+1|0;a[Nb>>2]=Ca;Sa=ia+-1<<16>>16;w[La>>1]=Sa;mb=(Ya&255)<<8;if(Sa<<16>>16)qa=Ca,Ja=Sa;else{if(!(Fc(sa)|0)){S=0;W=324;break a}Ya=w[La>>1]|0;if(!(Ya<<16>>16)){W=104;break a}qa=a[Nb>>2]|0;Ja=Ya}Sa=t[qa>>0]|0;a[Nb>>2]=qa+1;Ca=Ja+-1<<16>>16;w[La>>1]=Ca;Ya=Sa&255|mb;mb=Ya&65535;ea=0==(t[sa+225>>0]|0);if(3>(mb&65535)){W=106;break a}if(!ea){Ea=Ya+65534|0;wa=Ea&65535;Ma=((Ca&65535)<(wa&
65535)?Ca:wa)&65535;a[Nb>>2]=qa+(Ma+1);wa=(Ca&65535)-Ma|0;w[La>>1]=wa;Ca=Ea-Ma|0;Ma=Ca&65535;if(!Ma)break b;if(wa&65535){W=111;break a}Ea=wa=sa+1248|0;xa=a[Ea>>2]|0;$a=a[Ea+4>>2]|0;Ea=(0>$a>>>0|0==($a|0)&Ma>>>0>xa>>>0?xa&65535:Ca&65535)&65535;Ma=Ca=sa+1232|0;la=Qb(Ea|0,0,a[Ma>>2]|0,a[Ma+4>>2]|0)|0;Ma=Ca;a[Ma>>2]=la;a[Ma+4>>2]=U;Ma=Ic(xa|0,$a|0,Ea|0,0)|0;Ea=wa;a[Ea>>2]=Ma;a[Ea+4>>2]=U;t[sa+1240>>0]=0;break b}Ea=Ya+6|0;Ma=eb(Ea)|0;if(!Ma){W=114;break a}a[Ma>>2]=Ea;t[Ma+4>>0]=-1;t[Ma+5>>0]=-60;t[Ma+
6>>0]=(mb&65535)>>>8;t[Ma+7>>0]=Sa;Sa=Ya+65534&65535;Ya=Ma+8|0;if(!(Sa<<16>>16)){W=117;break a}mb=w[La>>1]|0;Ea=Sa;for(Sa=Ya;;){if(mb<<16>>16)va=mb;else{if(!(Fc(sa)|0)){Ba=Ma;W=123;break a}wa=w[La>>1]|0;if(wa<<16>>16)va=wa;else{W=121;break a}}wa=((Ea&65535)>(va&65535)?va:Ea)&65535;Ab(Sa,a[Nb>>2]|0,wa);a[Nb>>2]=(a[Nb>>2]|0)+wa;mb=(N[La>>1]|0)-wa&65535;w[La>>1]=mb;$a=(Ea&65535)-wa|0;if($a&65535)Ea=$a&65535,Sa=Sa+wa|0;else break}Sa=t[Ya>>0]|0;Ea=Sa&255;switch(Ea&240|0){case 0:if(3<(Sa&255)){za=Ma;W=
126;break a}Sa=sa+328+(Ea<<2)|0;(mb=a[Sa>>2]|0)&&ja(mb);a[Sa>>2]=Ma;break b;case 16:Sa=Ea&15;if(3<Sa>>>0){ta=Ma;W=132;break a}Ea=sa+344+(Sa<<2)|0;(Sa=a[Ea>>2]|0)&&ja(Sa);a[Ea>>2]=Ma;break b;default:nb=Ma;W=130;break a}case 195:case 193:case 192:Ea=a[Oa>>2]|0;Sa=Ea+363|0;if(t[Sa>>0]|0){W=137;break a}mb=Ea+225|0;t[mb>>0]|0||(t[Ea+364>>0]=aa);La=Ea+1256|0;Nb=w[La>>1]|0;if(Nb<<16>>16)sc=Nb;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}wa=w[La>>1]|0;if(wa<<16>>16)sc=wa;else{W=143;break a}}Nb=Ea+1260|0;wa=a[Nb>>
2]|0;$a=t[wa>>0]|0;xa=wa+1|0;a[Nb>>2]=xa;wa=sc+-1<<16>>16;w[La>>1]=wa;la=($a&255)<<8;if(wa<<16>>16)gb=xa,hb=wa;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}$a=w[La>>1]|0;if(!($a<<16>>16)){W=148;break a}gb=a[Nb>>2]|0;hb=$a}wa=t[gb>>0]|0;xa=gb+1|0;a[Nb>>2]=xa;$a=hb+-1<<16>>16;w[La>>1]=$a;Ca=wa&255|la;if(11>(Ca&65535)){ob=mb;W=150;break a}la=Ca+65528&65535;if((la>>>0)%3|0){Bb=mb;W=153;break a}Ca=(la>>>0)/3|0;wa=t[mb>>0]|0;if(0==wa<<24>>24&&(Ca|0)!=(x[Ea+204>>0]|0)){W=157;break a}if($a<<16>>16)kb=xa,ib=$a,
Cb=wa;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}qb=w[La>>1]|0;if(!(qb<<16>>16)){W=162;break a}kb=a[Nb>>2]|0;ib=qb;Cb=t[mb>>0]|0}wa=t[kb>>0]|0;$a=kb+1|0;a[Nb>>2]=$a;xa=ib+-1<<16>>16;w[La>>1]=xa;fe=0==Cb<<24>>24;if(8!=wa<<24>>24){W=164;break a}if(fe){if(xa<<16>>16)Mb=$a,Va=xa;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}wa=w[La>>1]|0;if(!(wa<<16>>16)){W=175;break a}Mb=a[Nb>>2]|0;Va=wa}xa=t[Mb>>0]|0;$a=Mb+1|0;a[Nb>>2]=$a;wa=Va+-1<<16>>16;w[La>>1]=wa;sb=(xa&255)<<8;if(wa<<16>>16)Ua=$a,ub=wa;else{if(!(Fc(Ea)|0)){S=
0;W=324;break a}xa=w[La>>1]|0;if(!(xa<<16>>16)){W=180;break a}Ua=a[Nb>>2]|0;ub=xa}wa=t[Ua>>0]|0;$a=Ua+1|0;a[Nb>>2]=$a;xa=ub+-1<<16>>16;w[La>>1]=xa;Fa=wa&255|sb;if(Fa>>>0<(a[Ea+188>>2]|0)>>>0&&Fa>>>0<(a[Ea+200>>2]|0)>>>0){W=183;break a}a[Ea+372>>2]=Fa;if(xa<<16>>16)Jb=$a,ab=xa;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}Fa=w[La>>1]|0;if(!(Fa<<16>>16)){W=188;break a}Jb=a[Nb>>2]|0;ab=Fa}xa=t[Jb>>0]|0;$a=Jb+1|0;a[Nb>>2]=$a;Fa=ab+-1<<16>>16;w[La>>1]=Fa;sb=(xa&255)<<8;if(Fa<<16>>16)yb=$a,cb=Fa;else{if(!(Fc(Ea)|
0)){S=0;W=324;break a}xa=w[La>>1]|0;if(!(xa<<16>>16)){W=193;break a}yb=a[Nb>>2]|0;cb=xa}Fa=t[yb>>0]|0;$a=yb+1|0;a[Nb>>2]=$a;xa=cb+-1<<16>>16;w[La>>1]=xa;wa=Fa&255|sb;sb=a[Ea+192>>2]|0;if(wa>>>0<sb>>>0&&wa>>>0<(a[Ea+184>>2]|0)>>>0){W=195;break a}if(wa>>>0>sb>>>0){W=197;break a}a[Ea+368>>2]=wa;Eb=$a;vb=xa}else{wa=xa&65535;qb=4>(xa&65535)?wa:4;sb=kb+(qb+1)|0;a[Nb>>2]=sb;Xa=wa-qb|0;wa=Xa&65535;w[La>>1]=wa;Fa=4-qb|0;qb=Fa&65535;if(Pa=Fa&65535){if(Xa&65535){W=169;break a}Fa=Xa=Ea+1248|0;tb=a[Fa>>2]|0;bb=
a[Fa+4>>2]|0;Fa=(0>bb>>>0|0==(bb|0)&Pa>>>0>tb>>>0?tb&65535:qb)&65535;Pa=qb=Ea+1232|0;Ib=Qb(Fa|0,0,a[Pa>>2]|0,a[Pa+4>>2]|0)|0;Pa=qb;a[Pa>>2]=Ib;a[Pa+4>>2]=U;Pa=Ic(tb|0,bb|0,Fa|0,0)|0;Fa=Xa;a[Fa>>2]=Pa;a[Fa+4>>2]=U;t[Ea+1240>>0]=0}Eb=sb;vb=wa}if(vb<<16>>16)gc=Eb,Ub=vb;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}xa=w[La>>1]|0;if(!(xa<<16>>16)){W=203;break a}gc=a[Nb>>2]|0;Ub=xa}xa=t[gc>>0]|0;a[Nb>>2]=gc+1;$a=Ub+-1<<16>>16;w[La>>1]=$a;if((xa&255|0)!=(Ca|0)){Fb=mb;W=208;break a}c:do if(2<la>>>0)for(xa=Ea+230|
0,wa=Ea+228|0,sb=Ea+229|0,Fa=$a,Xa=Pa=0;;){if(Fa<<16>>16)fk=Fa;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}bb=w[La>>1]|0;if(bb<<16>>16)fk=bb;else{W=213;break a}}bb=a[Nb>>2]|0;tb=t[bb>>0]|0;a[Nb>>2]=bb+1;bb=fk+-1<<16>>16;w[La>>1]=bb;Ib=t[mb>>0]|0;Ib<<24>>24?pb=bb:(t[Ea+376+Pa>>0]=tb,pb=w[La>>1]|0);if(pb<<16>>16)nd=pb,Zd=Ib;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}bb=w[La>>1]|0;if(!(bb<<16>>16)){W=220;break a}nd=bb;Zd=t[mb>>0]|0}Ib=a[Nb>>2]|0;bb=t[Ib>>0]|0;a[Nb>>2]=Ib+1;w[La>>1]=nd+-1<<16>>16;d:do if(Zd<<
24>>24)if(Xa<<16>>16)17!=bb<<24>>24&&(t[xa>>0]=1);else{Ib=(bb&255)>>>4;t[wa>>0]=Ib;tb=bb&15;t[sb>>0]=tb;switch(Ib<<24>>24){case 4:case 2:case 1:switch(tb<<24>>24){case 4:case 2:case 1:break d}}t[xa>>0]=1}else if(t[Ea+379+Pa>>0]=bb,!(t[xa>>0]|0))if(!(Xa<<16>>16)){if((bb&255|0)!=(x[wa>>0]<<4|x[sb>>0]|0)){W=231;break a}}else if(17!=bb<<24>>24){W=233;break a}while(0);bb=w[La>>1]|0;if(bb<<16>>16)wb=bb,Hb=Zd;else{if(!(Fc(Ea)|0)){S=0;W=324;break a}tb=w[La>>1]|0;if(!(tb<<16>>16)){W=238;break a}wb=tb;Hb=t[mb>>
0]|0}bb=a[Nb>>2]|0;tb=t[bb>>0]|0;a[Nb>>2]=bb+1;w[La>>1]=wb+-1<<16>>16;Hb<<24>>24||(t[Ea+382+Pa>>0]=tb);tb=Xa+1<<16>>16;bb=tb&65535;if(bb>>>0>=Ca>>>0){Qd=Hb;break c}Fa=w[La>>1]|0;Pa=bb;Xa=tb}else Qd=t[mb>>0]|0;while(0);Qd<<24>>24||(t[Sa>>0]=1);if(t[ha>>0]|0){S=1;W=324;break a}break;case 218:if(t[ha>>0]|0){S=1;W=324;break a}if(t[ga>>0]|0){W=248;break a}if(!(Oh(b)|0)){S=0;W=324;break a}break;default:zb=D;W=250;break a}while(0);if(-38==aa<<24>>24){W=252;break}Te=w[ba>>1]|0}switch(W|0){case 13:Z(149747,
148429,2031,149768);break;case 20:Z(149747,148429,2016,149786);break;case 27:Z(149747,148429,2016,149786);break;case 32:Z(149747,148429,2016,149786);break;case 34:if(t[ha>>0]|0)return S=0,u=d,S|0;Y(a[b+628>>2]|0,149800,149823,X);S=0;u=d;return S|0;case 39:Z(149841,148429,2101,149863);break;case 44:Z(149747,148429,2016,149786);break;case 49:Z(149747,148429,2016,149786);break;case 51:return Y(a[b+628>>2]|0,149877,149909,T),S=0,u=d,S|0;case 56:Z(149747,148429,2016,149786);break;case 61:Z(149747,148429,
2016,149786);break;case 66:Z(149747,148429,2016,149786);break;case 71:Z(149747,148429,2016,149786);break;case 73:if(!Qa)return S=0,u=d,S|0;Y(a[b+628>>2]|0,149941,149973,M);S=0;u=d;return S|0;case 78:Z(149841,148429,2101,149863);break;case 81:return Y(a[b+628>>2]|0,149941,149973,O),S=0,u=d,S|0;case 83:return Y(a[b+628>>2]|0,149941,150005,E),S=0,u=d,S|0;case 88:Z(149747,148429,2073,150019);break;case 90:return ja(Db),S=0,u=d,S|0;case 92:return Y(a[b+628>>2]|0,149941,149973,v),ja(Za),S=0,u=d,S|0;case 99:Z(149747,
148429,2016,149786);break;case 104:Z(149747,148429,2016,149786);break;case 106:if(!ea)return S=0,u=d,S|0;Y(a[b+628>>2]|0,150034,150066,K);S=0;u=d;return S|0;case 111:Z(149841,148429,2101,149863);break;case 114:return Y(a[b+628>>2]|0,150034,150005,L),S=0,u=d,S|0;case 117:Z(150098,148429,2064,150019);break;case 121:Z(149747,148429,2073,150019);break;case 123:return ja(Ba),S=0,u=d,S|0;case 126:return Y(a[b+628>>2]|0,150034,150066,G),ja(za),S=0,u=d,S|0;case 130:return Y(a[b+628>>2]|0,150034,150066,I),
ja(nb),S=0,u=d,S|0;case 132:return Y(a[b+628>>2]|0,150034,150066,J),ja(ta),S=0,u=d,S|0;case 137:return Y(a[b+628>>2]|0,150104,149823,r),S=0,u=d,S|0;case 143:Z(149747,148429,2016,149786);break;case 148:Z(149747,148429,2016,149786);break;case 150:if(t[ob>>0]|0)return S=0,u=d,S|0;Y(a[b+628>>2]|0,150104,150136,V);S=0;u=d;return S|0;case 153:if(t[Bb>>0]|0)return S=0,u=d,S|0;Y(a[b+628>>2]|0,150104,150136,Ra);S=0;u=d;return S|0;case 157:return Y(a[b+628>>2]|0,150104,150168,C),S=0,u=d,S|0;case 162:Z(149747,
148429,2016,149786);break;case 164:if(!fe)return S=0,u=d,S|0;Y(a[b+628>>2]|0,150104,150228,Q);S=0;u=d;return S|0;case 169:Z(149841,148429,2101,149863);break;case 175:Z(149747,148429,2016,149786);break;case 180:Z(149747,148429,2016,149786);break;case 183:return Y(a[b+628>>2]|0,150104,150296,z),S=0,u=d,S|0;case 188:Z(149747,148429,2016,149786);break;case 193:Z(149747,148429,2016,149786);break;case 195:return Y(a[b+628>>2]|0,150104,150345,ka),S=0,u=d,S|0;case 197:return Y(a[b+628>>2]|0,150104,150393,
H),S=0,u=d,S|0;case 203:Z(149747,148429,2016,149786);break;case 208:if(t[Fb>>0]|0)return S=0,u=d,S|0;Y(a[b+628>>2]|0,150104,150136,B);S=0;u=d;return S|0;case 213:Z(149747,148429,2016,149786);break;case 220:Z(149747,148429,2016,149786);break;case 231:return Y(a[b+628>>2]|0,150104,150455,y),S=0,u=d,S|0;case 233:return Y(a[b+628>>2]|0,150104,150455,q),S=0,u=d,S|0;case 238:Z(149747,148429,2016,149786);break;case 248:Z(150516,148429,1347,149800);break;case 250:return q=a[b+628>>2]|0,a[p>>2]=zb,Y(q,149800,
150543,p),S=0,u=d,S|0;case 252:if(t[ha>>0]|0)return S=1,u=d,S|0;ha=A+363|0;if(t[ha>>0]|0)return S=1,u=d,S|0;p=a[Oa>>2]|0;q=p+240|0;zb=a[q>>2]|0;y=a[q+4>>2]|0;if(0==(zb|0)&0==(y|0))return Y(a[b+628>>2]|0,150579,150614,n),S=0,u=d,S|0;t[p+1240>>0]=0;n=p+204|0;q=t[n>>0]|0;a:do if(q<<24>>24){B=b+640|0;Fb=b+628|0;H=b+632|0;ka=q;z=0;Q=zb;fe=y;C=0;b:for(;;){Ra=p+240+(z<<3)|0;do if(0==(Q|0)&0==(fe|0))Ob=z+-1|0,W=270;else if(Bb=z+-1|0,0!=C<<24>>24&&(V=p+240+(Bb<<3)|0,(Q|0)==(a[V>>2]|0)?(fe|0)==(a[V+4>>2]|0):
0))Ob=Bb,W=270;else{if(1<z>>>0){ob=V=0;do{r=p+240+(V<<3)|0;ob=ob+1<<24>>24;if((Q|0)==(a[r>>2]|0)&&(fe|0)==(a[r+4>>2]|0)){W=265;break b}V=ob&255}while((V|0)<(Bb|0))}Bb=eb(73)|0;if(!Bb){W=267;break b}a[Bb>>2]=73;t[Bb+4>>0]=-1;t[Bb+5>>0]=-37;t[Bb+6>>0]=0;t[Bb+7>>0]=67;t[Bb+8>>0]=C;V=Ra;rb[a[B>>2]&63](a[Fb>>2]|0,a[V>>2]|0,a[V+4>>2]|0,0)|0;if(64!=(Aa[a[H>>2]&63](a[Fb>>2]|0,Bb+9|0,64)|0)){S=0;W=324;break b}a[p+312+(z<<2)>>2]=Bb;t[p+382+z>>0]=C;Tb=t[n>>0]|0}while(0);270==(W|0)&&(W=0,t[p+382+z>>0]=t[p+382+
Ob>>0]|0,Tb=ka);Ra=C+1<<24>>24;Sa=Ra&255;if((Ra&255)>=(Tb&255))break a;Bb=p+240+(Sa<<3)|0;ka=Tb;z=Sa;Q=a[Bb>>2]|0;fe=a[Bb+4>>2]|0;C=Ra}if(265==(W|0))return Y(a[Fb>>2]|0,150579,150634,l),S=0,u=d,S|0;if(267==(W|0))return Y(a[Fb>>2]|0,150579,150005,k),S=0,u=d,S|0;if(324==(W|0))return u=d,S|0}while(0);t[A+364>>0]=-64;k=A+204|0;l=t[k>>0]|0;if(l<<24>>24){Tb=l&255;l=0;do t[A+376+l>>0]=l,l=l+1|0;while(l>>>0<Tb>>>0);jf=t[k>>0]|0}else jf=0;t[A+379>>0]=x[A+228>>0]<<4|x[A+229>>0];if(1<(jf&255)){Tb=1;do t[(Tb&
255)+(A+379)>>0]=17,Tb=Tb+1<<24>>24;while((Tb&255)<(jf&255))}a[A+368>>2]=a[A+192>>2];a[A+372>>2]=a[A+200>>2];t[ha>>0]=1;ha=a[Oa>>2]|0;jf=ha+264|0;Tb=a[jf>>2]|0;l=a[jf+4>>2]|0;a:do if(0==(Tb|0)&0==(l|0))Y(a[b+628>>2]|0,150664,150614,m);else{t[ha+1240>>0]=0;jf=ha+204|0;p=t[jf>>0]|0;do if(p<<24>>24){Ob=b+640|0;n=b+628|0;y=b+632|0;zb=P+1|0;q=P+2|0;C=P+3|0;fe=P+4|0;Q=P+5|0;z=P+6|0;ka=P+7|0;H=P+8|0;B=P+9|0;Ra=P+10|0;Bb=P+11|0;Sa=P+12|0;V=P+13|0;ob=P+14|0;r=P+15|0;ta=p;J=Tb;nb=l;za=I=0;b:for(;;){do if(0==
(J|0)&0==(nb|0))fb=I+-1|0,W=296;else if(G=I+-1|0,0!=za<<24>>24&&(Ba=ha+264+(G<<3)|0,(J|0)==(a[Ba>>2]|0)?(nb|0)==(a[Ba+4>>2]|0):0))fb=G,W=296;else{if(1<I>>>0){L=Ba=0;do{K=ha+264+(Ba<<3)|0;L=L+1<<24>>24;if((J|0)==(a[K>>2]|0)&&(nb|0)==(a[K+4>>2]|0)){W=290;break b}Ba=L&255}while((Ba|0)<(G|0))}rb[a[Ob>>2]&63](a[n>>2]|0,J,nb,0)|0;if(16!=(Aa[a[y>>2]&63](a[n>>2]|0,P,16)|0))break a;G=(x[zb>>0]|0)+(x[P>>0]|0)+(x[q>>0]|0)+(x[C>>0]|0)+(x[fe>>0]|0)+(x[Q>>0]|0)+(x[z>>0]|0)+(x[ka>>0]|0)+(x[H>>0]|0)+(x[B>>0]|0)+
(x[Ra>>0]|0)+(x[Bb>>0]|0)+(x[Sa>>0]|0)+(x[V>>0]|0)+(x[ob>>0]|0)+(x[r>>0]|0)|0;Ba=G+25|0;L=eb(Ba)|0;if(!L){W=293;break b}a[L>>2]=Ba;t[L+4>>0]=-1;t[L+5>>0]=-60;Ba=G+19|0;t[L+6>>0]=Ba>>>8;t[L+7>>0]=Ba;t[L+8>>0]=za;t[L+9>>0]=t[P>>0]|0;t[L+10>>0]=t[zb>>0]|0;t[L+11>>0]=t[q>>0]|0;t[L+12>>0]=t[C>>0]|0;t[L+13>>0]=t[fe>>0]|0;t[L+14>>0]=t[Q>>0]|0;t[L+15>>0]=t[z>>0]|0;t[L+16>>0]=t[ka>>0]|0;t[L+17>>0]=t[H>>0]|0;t[L+18>>0]=t[B>>0]|0;t[L+19>>0]=t[Ra>>0]|0;t[L+20>>0]=t[Bb>>0]|0;t[L+21>>0]=t[Sa>>0]|0;t[L+22>>0]=t[V>>
0]|0;t[L+23>>0]=t[ob>>0]|0;t[L+24>>0]=t[r>>0]|0;if((Aa[a[y>>2]&63](a[n>>2]|0,L+25|0,G)|0)!=(G|0))break a;a[ha+328+(I<<2)>>2]=L;t[ha+388+I>>0]=I<<4;Gb=t[jf>>0]|0}while(0);296==(W|0)&&(W=0,t[ha+388+I>>0]=t[ha+388+fb>>0]|0,Gb=ta);L=za+1<<24>>24;G=L&255;if((L&255)>=(Gb&255)){W=300;break}Ba=ha+264+(G<<3)|0;ta=Gb;J=a[Ba>>2]|0;nb=a[Ba+4>>2]|0;I=G;za=L}if(290==(W|0)){Y(a[n>>2]|0,150664,150700,h);break a}else if(293==(W|0)){Y(a[n>>2]|0,150664,150005,g);break a}else 300==(W|0)&&(Wb=a[Oa>>2]|0)}else Wb=ha;while(0);
jf=Wb+288|0;p=a[jf>>2]|0;Fb=a[jf+4>>2]|0;b:do if(0==(p|0)&0==(Fb|0))Y(a[b+628>>2]|0,150731,150614,f);else{t[Wb+1240>>0]=0;jf=Wb+204|0;za=t[jf>>0]|0;c:do if(za<<24>>24){I=b+640|0;nb=b+628|0;J=b+632|0;ta=P+1|0;y=P+2|0;r=P+3|0;ob=P+4|0;V=P+5|0;Sa=P+6|0;Bb=P+7|0;Ra=P+8|0;B=P+9|0;H=P+10|0;ka=P+11|0;z=P+12|0;Q=P+13|0;fe=P+14|0;C=P+15|0;q=p;zb=Fb;Ob=0;L=za;G=0;d:for(;;){do if(0==(q|0)&0==(zb|0))Kb=Ob+-1|0,W=318;else if(Ba=Ob+-1|0,0!=G<<24>>24&&(K=Wb+288+(Ba<<3)|0,(q|0)==(a[K>>2]|0)?(zb|0)==(a[K+4>>2]|0):
0))Kb=Ba,W=318;else{if(1<Ob>>>0){ea=K=0;do{Za=Wb+288+(K<<3)|0;ea=ea+1<<24>>24;if((q|0)==(a[Za>>2]|0)&&(zb|0)==(a[Za+4>>2]|0)){W=312;break d}K=ea&255}while((K|0)<(Ba|0))}rb[a[I>>2]&63](a[nb>>2]|0,q,zb,0)|0;if(16!=(Aa[a[J>>2]&63](a[nb>>2]|0,P,16)|0))break b;Ba=(x[ta>>0]|0)+(x[P>>0]|0)+(x[y>>0]|0)+(x[r>>0]|0)+(x[ob>>0]|0)+(x[V>>0]|0)+(x[Sa>>0]|0)+(x[Bb>>0]|0)+(x[Ra>>0]|0)+(x[B>>0]|0)+(x[H>>0]|0)+(x[ka>>0]|0)+(x[z>>0]|0)+(x[Q>>0]|0)+(x[fe>>0]|0)+(x[C>>0]|0)|0;K=Ba+25|0;ea=eb(K)|0;if(!ea){W=315;break d}a[ea>>
2]=K;t[ea+4>>0]=-1;t[ea+5>>0]=-60;K=Ba+19|0;t[ea+6>>0]=K>>>8;t[ea+7>>0]=K;t[ea+8>>0]=Ob|16;t[ea+9>>0]=t[P>>0]|0;t[ea+10>>0]=t[ta>>0]|0;t[ea+11>>0]=t[y>>0]|0;t[ea+12>>0]=t[r>>0]|0;t[ea+13>>0]=t[ob>>0]|0;t[ea+14>>0]=t[V>>0]|0;t[ea+15>>0]=t[Sa>>0]|0;t[ea+16>>0]=t[Bb>>0]|0;t[ea+17>>0]=t[Ra>>0]|0;t[ea+18>>0]=t[B>>0]|0;t[ea+19>>0]=t[H>>0]|0;t[ea+20>>0]=t[ka>>0]|0;t[ea+21>>0]=t[z>>0]|0;t[ea+22>>0]=t[Q>>0]|0;t[ea+23>>0]=t[fe>>0]|0;t[ea+24>>0]=t[C>>0]|0;if((Aa[a[J>>2]&63](a[nb>>2]|0,ea+25|0,Ba)|0)!=(Ba|0))break b;
a[Wb+344+(Ob<<2)>>2]=ea;ea=Wb+388+Ob|0;t[ea>>0]|=G;lb=t[jf>>0]|0}while(0);318==(W|0)&&(W=0,ea=Wb+388+Ob|0,t[ea>>0]=x[Wb+388+Kb>>0]&15|x[ea>>0],lb=L);ea=G+1<<24>>24;Ba=ea&255;if((ea&255)>=(lb&255))break c;K=Wb+288+(Ba<<3)|0;q=a[K>>2]|0;zb=a[K+4>>2]|0;Ob=Ba;L=lb;G=ea}if(312==(W|0)){Y(a[nb>>2]|0,150731,150767,e);break b}else if(315==(W|0)){Y(a[nb>>2]|0,150731,150005,c);break b}}while(0);jf=t[k>>0]|0;if(1<(jf&255))Lb=1;else return S=1,u=d,S|0;do t[(Lb&255)+(A+385)>>0]=Lb,Lb=Lb+1<<24>>24;while((Lb&255)<
(jf&255));S=1;u=d;return S|0}while(0);S=0;u=d;return S|0}while(0);S=0;u=d;return S|0;case 324:return u=d,S|0}return 0}function Fc(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,u=0,V=0;c=d=b+1248|0;e=a[c>>2]|0;f=a[c+4>>2]|0;c=b+1240|0;a:do if(0==(e|0)&0==(f|0)){g=b+1220|0;h=b+208|0;m=b+1232|0;k=b+216|0;l=b+1224|0;n=b+1228|0;p=b+176|0;b:for(;;){t[c>>0]=0;c:do switch(a[g>>2]|0){case 0:q=h;y=a[q>>2]|0;B=a[q+4>>2]|0;0==(y|0)&0==(B|0)||(q=m,a[q>>2]=y,a[q+4>>2]=B,B=k,q=a[B+4>>2]|0,y=d,a[y>>2]=a[B>>
2],a[y+4>>2]=q);a[g>>2]=1;break;case 1:a[g>>2]=2;break;case 2:q=a[b>>2]|0;y=a[q+172>>2]|0;if(!y){g=0;h=32;break b}B=a[q+176>>2]|0;if(!B){g=0;h=32;break b}q=a[l>>2]|0;if((q|0)==(a[n>>2]|0)){a[g>>2]=3;break c}H=y+(q<<3)|0;y=a[H>>2]|0;ka=a[H+4>>2]|0;H=m;a[H>>2]=y;a[H+4>>2]=ka;0==(y|0)&0==(ka|0)||(H=p,z=a[H>>2]|0,Q=a[H+4>>2]|0,Q>>>0>ka>>>0|(Q|0)==(ka|0)&z>>>0>y>>>0?(H=B+(q<<3)|0,B=a[H>>2]|0,C=a[H+4>>2]|0,H=d,a[H>>2]=B,a[H+4>>2]=C,0==(B|0)&0==(C|0)?(H=m,a[H>>2]=0,a[H+4>>2]=0):(H=Qb(y|0,ka|0,B|0,C|0)|0,
C=U,C>>>0>Q>>>0|(C|0)==(Q|0)&H>>>0>z>>>0&&(H=Ic(z|0,Q|0,y|0,ka|0)|0,Q=d,a[Q>>2]=H,a[Q+4>>2]=U))):(H=m,a[H>>2]=0,a[H+4>>2]=0));a[l>>2]=q+1;break;default:g=0;h=32;break b}while(0);ka=d;y=a[ka>>2]|0;B=a[ka+4>>2]|0;if(!(0==(y|0)&0==(B|0))){u=y;V=B;break a}}if(32==(h|0))return g|0}else u=e,V=f;while(0);t[c>>0]|0?(e=V,f=u):(f=a[b>>2]|0,e=b+1232|0,rb[a[f+640>>2]&63](a[f+628>>2]|0,a[e>>2]|0,a[e+4>>2]|0,0)|0,t[c>>0]=1,c=d,e=a[c+4>>2]|0,f=a[c>>2]|0);u=a[b>>2]|0;V=b+1264|0;c=Aa[a[u+632>>2]&63](a[u+628>>2]|0,
V,0>e>>>0|0==(e|0)&2048>f>>>0?f&65535:2048)|0;if(!c)return 0;0>=(c|0)&&Z(150888,148429,1944,150892);2049<=(c|0)&&Z(150912,148429,1945,150892);f=(0>(c|0))<<31>>31;e=d;u=a[e>>2]|0;e=a[e+4>>2]|0;f>>>0>e>>>0|(f|0)==(e|0)&c>>>0>u>>>0&&Z(150928,148429,1947,150892);w[b+1256>>1]=c;a[b+1260>>2]=V;V=c&65535;c=Ic(u|0,e|0,V|0,0)|0;e=d;a[e>>2]=c;a[e+4>>2]=U;b=e=b+1232|0;c=Qb(a[b>>2]|0,a[b+4>>2]|0,V|0,0)|0;V=e;a[V>>2]=c;a[V+4>>2]=U;return 1}function Oh(b){b|=0;var d,c,e,f,g=0,h,m,k,l=0,n,p,q=0,y=0,B=0,H=0,ka=0,
z=0,Q=0,C=0;d=u;u=u+32|0;c=d+16|0;e=d+8|0;f=a[b+576>>2]|0;t[f+225>>0]|0&&Z(150798,148429,1701,150824);if(!(t[f+363>>0]|0))return Y(a[b+628>>2]|0,150824,150856,d),u=d,0;h=f+1256|0;m=w[h>>1]|0;if(m<<16>>16)l=m;else{if(!(Fc(f)|0))return u=d,0;k=w[h>>1]|0;k<<16>>16?l=k:Z(149747,148429,2016,149786)}m=f+1260|0;k=a[m>>2]|0;n=t[k>>0]|0;p=k+1|0;a[m>>2]=p;k=l+-1<<16>>16;w[h>>1]=k;l=(n&255)<<8;if(k<<16>>16)q=p,y=k;else{if(!(Fc(f)|0))return u=d,0;n=w[h>>1]|0;n<<16>>16?(q=a[m>>2]|0,y=n):Z(149747,148429,2016,149786)}k=
t[q>>0]|0;p=q+1|0;a[m>>2]=p;q=y+-1<<16>>16;w[h>>1]=q;y=f+206|0;n=t[y>>0]|0;if((k&255|l|0)!=(((n&255)<<1)+6|0))return Y(a[b+628>>2]|0,150824,150856,e),u=d,0;if(q<<16>>16)B=p,H=q,ka=n;else{if(!(Fc(f)|0))return u=d,0;e=w[h>>1]|0;e<<16>>16?(B=a[m>>2]|0,H=e,ka=t[y>>0]|0):Z(149747,148429,2016,149786)}n=t[B>>0]|0;q=B+1|0;a[m>>2]=q;B=H+-1<<16>>16;w[h>>1]=B;if(n<<24>>24!=ka<<24>>24)return Y(a[b+628>>2]|0,150824,150856,c),u=d,0;do if(ka<<24>>24){c=f+205|0;b=B;for(H=n=0;;){if(!(b<<16>>16)){if(!(Fc(f)|0)){g=
0;c=40;break}p=w[h>>1]|0;if(p<<16>>16)b=p;else{c=28;break}}p=a[m>>2]|0;e=t[p>>0]|0;a[m>>2]=p+1;w[h>>1]=b+-1<<16>>16;p=t[c>>0]|0;t[(p&255)+n+(f+385)>>0]=e;e=w[h>>1]|0;if(e<<16>>16)b=e,k=p;else{if(!(Fc(f)|0)){g=0;c=40;break}l=w[h>>1]|0;if(!(l<<16>>16)){c=33;break}b=l;k=t[c>>0]|0}p=a[m>>2]|0;e=t[p>>0]|0;a[m>>2]=p+1;w[h>>1]=b+-1<<16>>16;t[(k&255)+n+(f+388)>>0]=e;e=H+1<<24>>24;p=w[h>>1]|0;if((e&255)<(x[y>>0]|0))b=p,n=e&255,H=e;else{z=p;c=35;break}}if(28==(c|0))Z(149747,148429,2016,149786);else if(33==
(c|0))Z(149747,148429,2016,149786);else if(35==(c|0))Q=z,C=a[m>>2]|0;else if(40==(c|0))return u=d,g|0}else Q=B,C=q;while(0);q=Q&65535;B=3>(Q&65535)?q:3;a[m>>2]=C+B;C=q-B|0;w[h>>1]=C;h=3-B|0;B=h&65535;if(!B)return u=d,1;C&65535&&Z(149841,148429,2101,149863);q=C=f+1248|0;m=a[q>>2]|0;Q=a[q+4>>2]|0;q=(0>Q>>>0|0==(Q|0)&B>>>0>m>>>0?m&65535:h&65535)&65535;B=h=f+1232|0;c=Qb(q|0,0,a[B>>2]|0,a[B+4>>2]|0)|0;B=h;a[B>>2]=c;a[B+4>>2]=U;B=Ic(m|0,Q|0,q|0,0)|0;q=C;a[q>>2]=B;a[q+4>>2]=U;t[f+1240>>0]=0;u=d;return 1}
function ok(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m=0,k=0;f=4;g=Hc(40)|0;a[g>>2]=0;g=Xc(b+4|0,1,g|0,f|0)|0;f=U;Wa=b=Wa=0;0!=(b|0)&0!=(pa|0)?((h=db(a[b>>2]|0,g|0,f|0)|0)||Vb(b|0,pa|0),U=pa):h=-1;for(h=1==(h|0)?U:0;;){if(h){m=0;k=6;break}Wa=0;Pg(18,d|0,c|0,e|0)|0;h=Wa;Wa=0;0!=(h|0)&0!=(pa|0)?((b=db(a[h>>2]|0,g|0,f|0)|0)||Vb(h|0,pa|0),U=pa):b=-1;if(1==(b|0))h=U;else break}if(6==(k|0))return Gc(g|0),m|0;m=1;Gc(g|0);return m|0}function Ph(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h=0,m=0;e=4;f=Hc(40)|0;a[f>>2]=
0;f=Xc(b+4|0,1,f|0,e|0)|0;e=U;Wa=b=Wa=0;0!=(b|0)&0!=(pa|0)?((g=db(a[b>>2]|0,f|0,e|0)|0)||Vb(b|0,pa|0),U=pa):g=-1;for(g=1==(g|0)?U:0;;){if(g){h=0;m=6;break}Wa=0;Pg(17,d|0,c|0,1)|0;g=Wa;Wa=0;0!=(g|0)&0!=(pa|0)?((b=db(a[g>>2]|0,f|0,e|0)|0)||Vb(g|0,pa|0),U=pa):b=-1;if(1==(b|0))g=U;else break}if(6==(m|0))return Gc(f|0),h|0;h=1;Gc(f|0);return h|0}function Bi(b){Vb((a[(b|0)+576>>2]|0)+4|0,1)}function Qh(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,u,V,r=0,w=0,x=0,G=0,L=0,K=0,v=0,E=0,O=0,
M=0,T=0,X,P=0,Oa=0,A=0,D=0,ba=0,N=0,F=0,R=0,ga=0,S=0,ma=0,Y=0,ha=0,U=0,W=0,da=0;e=b+604|0;f=a[e>>2]|0;g=(a[b+588>>2]|0)+(a[b+592>>2]|0)|0;h=b+608|0;do if(0<(c|0)){m=c;k=d;l=0;n=f;p=0;a:for(;;){q=t[k>>0]|0;y=m+-1|0;k=k+1|0;b:do if(1<(m|0))for(B=y,H=k,ka=1;;){if(q<<24>>24!=(t[H>>0]|0)){z=B;Q=H;H=ka;break b}C=ka+1|0;u=B+-1|0;V=H+1|0;if(1<(B|0))B=u,H=V,ka=C;else{z=u;Q=V;H=C;break}}else z=y,Q=k,H=1;while(0);k=l;y=H;ka=n;H=p;b:for(;;){c:do if(1==(y|0)){do if((ka+2|0)>>>0>=g>>>0)if(1!=(H&-3|0)){a[h>>2]=
ka-(a[e>>2]|0)+(a[h>>2]|0);if(!(Lc(b)|0)){r=-1;w=48;break a}B=k;V=a[e>>2]|0}else{B=k;a[h>>2]=B-(a[e>>2]|0)+(a[h>>2]|0);if(!(Lc(b)|0)){r=-1;w=48;break a}C=ka;V=C-B|0;u=a[e>>2]|0;if(0<(V|0)){m=B+-1-C|0;l=C+(-2<(m|0)?m:-2)-B|0;B=k;m=u;for(C=V;;)if(t[m>>0]=t[B>>0]|0,1<(C|0))B=B+1|0,m=m+1|0,C=C+-1|0;else break;B=a[e>>2]|0;V=u+(l+2)|0}else V=B=u}else B=k,V=ka;while(0);switch(H|0){case 0:x=B;G=V;w=16;break c;case 1:L=B;K=V;w=21;break c;case 2:v=B;E=V;w=26;break c;case 3:break;default:O=B;M=V;T=H;break b}if(-1!=
(t[V+-2>>0]|0)){k=B;y=1;ka=V;H=2;continue b}C=t[B>>0]|0;if(126<=(C&255)){k=B;y=1;ka=V;H=2;continue b}m=(C&255)+2|0;t[B>>0]=m;t[V+-2>>0]=t[V+-1>>0]|0;k=B;y=1;ka=V;H=127!=(m&255|0)&1;continue b}else for(m=k,C=ka,B=H;;){do if((C+2|0)>>>0>=g>>>0)if(1!=(B&-3|0)){a[h>>2]=C-(a[e>>2]|0)+(a[h>>2]|0);if(!(Lc(b)|0)){r=-1;w=48;break a}V=m;u=a[e>>2]|0}else{V=m;a[h>>2]=V-(a[e>>2]|0)+(a[h>>2]|0);if(!(Lc(b)|0)){r=-1;w=48;break a}n=C;p=n-V|0;u=a[e>>2]|0;if(0<(p|0)){X=V+-1-n|0;l=n+(-2<(X|0)?X:-2)-V|0;V=m;X=u;for(n=
p;;)if(t[X>>0]=t[V>>0]|0,1<(n|0))V=V+1|0,X=X+1|0,n=n+-1|0;else break;V=a[e>>2]|0;u=u+(l+2)|0}else V=u}else V=m,u=C;while(0);switch(B|0){case 0:x=V;G=u;w=16;break c;case 1:L=V;K=u;w=21;break c;case 2:v=V;E=u;w=26;break c;case 3:m=V;C=u;B=2;break;default:O=V;M=u;T=B;break b}}while(0);if(16==(w|0)){w=0;if(1>=(y|0)){P=G;w=20;break}if(128>=(y|0)){Oa=x;A=y;D=G;w=19;break}t[G>>0]=-127;t[G+1>>0]=q;k=x;y=y+-128|0;ka=G+2|0;H=2}else if(21==(w|0)){w=0;if(1>=(y|0)){ba=L;N=K;w=25;break}if(128>=(y|0)){F=L;R=y;ga=
K;w=24;break}t[K>>0]=-127;t[K+1>>0]=q;k=L;y=y+-128|0;ka=K+2|0;H=3}else if(26==(w|0)){w=0;if(1>=(y|0)){S=E;w=31;break}if(128>=(y|0)){ma=v;Y=y;ha=E;w=29;break}t[E>>0]=-127;t[E+1>>0]=q;k=v;y=y+-128|0;ka=E+2|0;H=2}}19==(w|0)?(w=0,t[D>>0]=1-A,t[D+1>>0]=q,O=Oa,M=D+2|0,T=2):20==(w|0)?(w=0,t[P>>0]=0,t[P+1>>0]=q,O=P,M=P+2|0,T=1):24==(w|0)?(w=0,t[ga>>0]=1-R,t[ga+1>>0]=q,O=F,M=ga+2|0,T=3):25==(w|0)?(w=0,H=(t[ba>>0]|0)+1<<24>>24,t[ba>>0]=H,t[N>>0]=q,O=ba,M=N+1|0,T=127!=H<<24>>24&1):29==(w|0)?(w=0,t[ha>>0]=1-
Y,t[ha+1>>0]=q,O=ma,M=ha+2|0,T=2):31==(w|0)&&(w=0,t[S>>0]=0,t[S+1>>0]=q,O=S,M=S+2|0,T=1);if(0<(z|0))m=z,k=Q,l=O,n=M,p=T;else{U=M;w=46;break}}if(46==(w|0))W=a[e>>2]|0,da=U;else if(48==(w|0))return r|0}else da=W=f;while(0);a[h>>2]=da-W+(a[h>>2]|0);a[e>>2]=da;return 1}function Ci(b){b|=0;var d,c,e,f;d=u;u=u+16|0;(c=a[b+576>>2]|0)||Z(154168,152869,735,152883);if(qe(b,109868,1)|0)return e=b+668|0,f=b+672|0,a[c+44>>2]=a[f>>2],a[f>>2]=25,a[c+48>>2]=a[e>>2],a[e>>2]=26,e=b+676|0,a[c+52>>2]=a[e>>2],a[e>>2]=
31,e=b+508|0,a[c+56>>2]=a[e>>2],a[e>>2]=39,e=b+516|0,a[c+60>>2]=a[e>>2],a[e>>2]=40,a[c>>2]=1,a[c+24>>2]=0,a[c+40>>2]=0,u=d,1;Y(a[b+628>>2]|0,152883,152901,d);u=d;return 0}function pk(b){b|=0;var d;if(d=a[b+576>>2]|0)return a[b+672>>2]=a[d+44>>2],a[b+668>>2]=a[d+48>>2],a[b+676>>2]=a[d+52>>2],a[b+508>>2]=a[d+56>>2],a[b+516>>2]=a[d+60>>2],1;Z(154168,152869,776,152946);return 0}function Zg(b){b|=0;var d,c,e,f,g,h,m;d=u;u=u+32|0;c=d+16|0;e=d+8|0;f=a[b+576>>2]|0;g=a[f>>2]|0;a:do switch(g|0){case 2:h=w[b+
84>>1]|0;switch(h<<16>>16){case 32:case 16:case 8:break a}m=a[b+628>>2]|0;a[d>>2]=h&65535;Y(m,153261,153276,d);f=0;u=d;return f|0;case 3:m=w[b+86>>1]|0;if(3!=m<<16>>16)return h=a[b+628>>2]|0,a[e>>2]=m&65535,Y(h,153261,153346,e),f=0,u=d,f|0;break;case 1:return f=1,u=d,f|0;default:return h=a[b+628>>2]|0,a[c>>2]=g,Y(h,153261,153407,c),f=0,u=d,f|0}while(0);a[f+4>>2]=1==(w[b+126>>1]|0)?N[b+98>>1]|0:1;b=a[b+12>>2]&1024?tg(b)|0:Pe(b)|0;a[f+8>>2]=b;u=d;return 0!=(b|0)&1|0}function Rh(b,d,c){d|=0;c|=0;var e,
f,g,h,m,k=0,l=0,n=0,p=0,q=0,y=0;e=a[(a[(b|0)+576>>2]|0)+4>>2]|0;b=(c|0)/2|0;(c|0)%(e<<1|0)|0&&Z(153208,152869,517,153227);if(!((b|0)<=(e|0)))for(c=b-e|0,b=e+-4|0,f=4<(e|0),g=4-e|0,h=c,m=d+(c+-1<<1)|0;;){switch(e|0){case 4:k=m;l=9;break;case 3:n=m;l=10;break;case 2:p=m;l=11;break;case 1:q=m;l=12;break;case 0:y=m;break;default:if(f){c=b;for(d=m;;)if(k=d+(e<<1)|0,w[k>>1]=(N[k>>1]|0)-(N[d>>1]|0),1<(c|0))c=c+-1|0,d=d+-2|0;else break;k=m+(g<<1)|0}else k=m;l=9}9==(l|0)&&(d=k+(e<<1)|0,w[d>>1]=(N[d>>1]|0)-
(N[k>>1]|0),n=k+-2|0,l=10);10==(l|0)&&(d=n+(e<<1)|0,w[d>>1]=(N[d>>1]|0)-(N[n>>1]|0),p=n+-2|0,l=11);11==(l|0)&&(d=p+(e<<1)|0,w[d>>1]=(N[d>>1]|0)-(N[p>>1]|0),q=p+-2|0,l=12);12==(l|0)&&(l=0,d=q+(e<<1)|0,w[d>>1]=(N[d>>1]|0)-(N[q>>1]|0),y=q+-2|0);h=h-e|0;if(0>=(h|0))break;else m=y}}function Sh(b,d,c){d|=0;c|=0;var e,f,g,h,m,k=0,l=0,n=0,p=0,q=0,y=0;e=a[(a[(b|0)+576>>2]|0)+4>>2]|0;b=(c|0)/4|0;(c|0)%(e<<2|0)|0&&Z(153179,152869,548,153198);if(!((b|0)<=(e|0)))for(c=b-e|0,b=e+-4|0,f=4<(e|0),g=4-e|0,h=c,m=d+
(c+-1<<2)|0;;){switch(e|0){case 4:k=m;l=9;break;case 3:n=m;l=10;break;case 2:p=m;l=11;break;case 1:q=m;l=12;break;case 0:y=m;break;default:if(f){c=b;for(d=m;;)if(k=d+(e<<2)|0,a[k>>2]=(a[k>>2]|0)-(a[d>>2]|0),1<(c|0))c=c+-1|0,d=d+-4|0;else break;k=m+(g<<2)|0}else k=m;l=9}9==(l|0)&&(d=k+(e<<2)|0,a[d>>2]=(a[d>>2]|0)-(a[k>>2]|0),n=k+-4|0,l=10);10==(l|0)&&(d=n+(e<<2)|0,a[d>>2]=(a[d>>2]|0)-(a[n>>2]|0),p=n+-4|0,l=11);11==(l|0)&&(d=p+(e<<2)|0,a[d>>2]=(a[d>>2]|0)-(a[p>>2]|0),q=p+-4|0,l=12);12==(l|0)&&(l=0,
d=q+(e<<2)|0,a[d>>2]=(a[d>>2]|0)-(a[q>>2]|0),y=q+-4|0);h=h-e|0;if(0>=(h|0))break;else m=y}}function Th(b,d,c){d|=0;c|=0;var e,f,g,h=0,m=0,k=0,l=0,n=0,p=0,q;e=a[(a[(b|0)+576>>2]|0)+4>>2]|0;b=(c|0)/2|0;(c|0)%(e<<1|0)|0&&Z(153208,152869,334,153583);if(!((b|0)<=(e|0)))for(c=e+-4|0,f=4<(e|0),g=b-e|0,b=d;;){switch(e|0){case 4:h=b;m=9;break;case 3:k=b;m=10;break;case 2:l=b;m=11;break;case 1:n=b;m=12;break;case 0:p=b;break;default:if(f){d=c;for(q=b;;)if(h=q+(e<<1)|0,w[h>>1]=(N[q>>1]|0)+(N[h>>1]|0),1<(d|0))d=
d+-1|0,q=q+2|0;else break;h=b+(c<<1)|0}else h=b;m=9}9==(m|0)&&(q=h+(e<<1)|0,w[q>>1]=(N[h>>1]|0)+(N[q>>1]|0),k=h+2|0,m=10);10==(m|0)&&(q=k+(e<<1)|0,w[q>>1]=(N[k>>1]|0)+(N[q>>1]|0),l=k+2|0,m=11);11==(m|0)&&(q=l+(e<<1)|0,w[q>>1]=(N[l>>1]|0)+(N[q>>1]|0),n=l+2|0,m=12);12==(m|0)&&(m=0,q=n+(e<<1)|0,w[q>>1]=(N[n>>1]|0)+(N[q>>1]|0),p=n+2|0);g=g-e|0;if(0>=(g|0))break;else b=p}}function Jg(b,d,c){d|=0;c|=0;var e,f,g,h,m,k=0,l=g=0,n=0,p=0;e=a[(a[(b|0)+576>>2]|0)+4>>2]|0;b=(c|0)/4|0;(c|0)%(e<<2|0)|0&&Z(153179,
152869,362,153574);if(!((b|0)<=(e|0)))if(c=b-e|0,b=e+-4|0,f=4<(e|0),4==(e|0))for(b=c,g=d;;)if(d=g+16|0,a[d>>2]=(a[d>>2]|0)+(a[g>>2]|0),d=g+20|0,a[d>>2]=(a[d>>2]|0)+(a[g+4>>2]|0),d=g+24|0,a[d>>2]=(a[d>>2]|0)+(a[g+8>>2]|0),d=g+28|0,a[d>>2]=(a[d>>2]|0)+(a[g+12>>2]|0),4<(b|0))b=b+-4|0,g=g+16|0;else break;else for(h=c,m=d;;){switch(e|0){case 0:k=m;break;case 3:g=m;l=11;break;case 2:n=m;l=12;break;case 1:p=m;l=13;break;default:if(f){d=b;for(c=m;;)if(g=c+(e<<2)|0,a[g>>2]=(a[g>>2]|0)+(a[c>>2]|0),1<(d|0))d=
d+-1|0,c=c+4|0;else break;d=m+(b<<2)|0}else d=m;c=d+(e<<2)|0;a[c>>2]=(a[c>>2]|0)+(a[d>>2]|0);g=d+4|0;l=11}11==(l|0)&&(c=g+(e<<2)|0,a[c>>2]=(a[c>>2]|0)+(a[g>>2]|0),n=g+4|0,l=12);12==(l|0)&&(c=n+(e<<2)|0,a[c>>2]=(a[c>>2]|0)+(a[n>>2]|0),p=n+4|0,l=13);13==(l|0)&&(l=0,c=p+(e<<2)|0,a[c>>2]=(a[c>>2]|0)+(a[p>>2]|0),k=p+4|0);h=h-e|0;if(0>=(h|0))break;else m=k}}function ah(b,d,c,e,f,g,h,m){b|=0;d|=0;e|=0;f|=0;g|=0;h|=0;var k,l,n,p,q,y;if(!h||56!=(m|0)|49!=(t[h>>0]|0))return-6;if(!b)return-2;h=b+24|0;a[h>>2]=
0;m=b+32|0;(k=a[m>>2]|0)?l=k:(a[m>>2]=29,a[b+40>>2]=0,l=29);k=b+36|0;a[k>>2]|0||(a[k>>2]=6);n=-1==(d|0)?6:d;0>(e|0)?(p=0-e|0,q=0):(p=(d=15<(e|0))?e+-16|0:e,q=d?2:1);if(4<g>>>0|9<n>>>0|8!=(c|0)|8<(f+-1|0)>>>0|8!=(p&-8|0))return-2;c=8==(p|0)?9:p;p=b+40|0;d=Aa[l&63](a[p>>2]|0,1,5828)|0;if(!d)return-4;l=b+28|0;a[l>>2]=d;a[d>>2]=b;a[d+24>>2]=q;a[d+28>>2]=0;a[d+48>>2]=c;q=1<<c;c=d+44|0;a[c>>2]=q;a[d+52>>2]=q+-1;e=f+7|0;a[d+80>>2]=e;y=1<<e;e=d+76|0;a[e>>2]=y;a[d+84>>2]=y+-1;a[d+88>>2]=((f+9|0)>>>0)/3|0;
y=Aa[a[m>>2]&63](a[p>>2]|0,q,2)|0;q=d+56|0;a[q>>2]=y;y=Aa[a[m>>2]&63](a[p>>2]|0,a[c>>2]|0,2)|0;c=d+64|0;a[c>>2]=y;y=Aa[a[m>>2]&63](a[p>>2]|0,a[e>>2]|0,2)|0;e=d+68|0;a[e>>2]=y;a[d+5824>>2]=0;y=1<<f+6;f=d+5788|0;a[f>>2]=y;m=Aa[a[m>>2]&63](a[p>>2]|0,y,4)|0;a[d+8>>2]=m;y=a[f>>2]|0;a[d+12>>2]=y<<2;if(0!=(a[q>>2]|0)&&0!=(a[c>>2]|0)&&!(0==(a[e>>2]|0)|0==(m|0)))return a[d+5796>>2]=m+(y>>>1<<1),a[d+5784>>2]=m+(3*y|0),a[d+132>>2]=n,a[d+136>>2]=g,t[d+36>>0]=8,k=qk(b)|0,k|0;a[d+4>>2]=666;a[h>>2]=a[27685];h=a[l>>
2]|0;if(!h)return-4;switch(a[h+4>>2]|0){case 42:case 69:case 73:case 91:case 103:case 113:case 666:break;default:return-4}(d=a[h+8>>2]|0)?(ub[a[k>>2]&31](a[p>>2]|0,d),b=a[l>>2]|0):b=h;if(d=a[b+68>>2]|0)ub[a[k>>2]&31](a[p>>2]|0,d),b=a[l>>2]|0;if(d=a[b+64>>2]|0)ub[a[k>>2]&31](a[p>>2]|0,d),b=a[l>>2]|0;(d=a[b+56>>2]|0)?(ub[a[k>>2]&31](a[p>>2]|0,d),d=a[l>>2]|0):d=b;ub[a[k>>2]&31](a[p>>2]|0,d);a[l>>2]=0;return-4}function rk(b){b|=0;var d,c,e,f,g;if(!b)return-2;d=b+28|0;c=a[d>>2]|0;if(!c)return-2;e=a[c+
4>>2]|0;switch(e|0){case 42:case 69:case 73:case 91:case 103:case 113:case 666:break;default:return-2}if(f=a[c+8>>2]|0)ub[a[b+36>>2]&31](a[b+40>>2]|0,f),c=a[d>>2]|0;(f=a[c+68>>2]|0)?(ub[a[b+36>>2]&31](a[b+40>>2]|0,f),g=a[d>>2]|0):g=c;(f=a[g+64>>2]|0)?(ub[a[b+36>>2]&31](a[b+40>>2]|0,f),c=a[d>>2]|0):c=g;(f=a[c+56>>2]|0)?(c=b+36|0,g=b+40|0,ub[a[c>>2]&31](a[g>>2]|0,f),f=g,b=c,c=a[d>>2]|0):(f=b+40|0,b=b+36|0);ub[a[b>>2]&31](a[f>>2]|0,c);a[d>>2]=0;return(113==(e|0)?-3:0)|0}function qk(b){b|=0;var d,c,e,
f;if(!b)return-2;d=b+28|0;c=a[d>>2]|0;if(!(c&&a[b+32>>2]|0&&a[b+36>>2]|0))return-2;a[b+20>>2]=0;a[b+8>>2]=0;a[b+24>>2]=0;a[b+44>>2]=2;a[c+20>>2]=0;a[c+16>>2]=a[c+8>>2];e=c+24|0;f=a[e>>2]|0;0>(f|0)&&(f=0-f|0,a[e>>2]=f);e=f;a[c+4>>2]=0!=(e|0)?42:113;e=2==(e|0)?Kd(0,0,0)|0:Si(0,0,0)|0;a[b+48>>2]=e;a[c+40>>2]=0;b=c|0;a[b+2840>>2]=b+148;a[b+2848>>2]=110108;a[b+2852>>2]=b+2440;a[b+2860>>2]=110128;a[b+2864>>2]=b+2684;a[b+2872>>2]=110148;w[b+5816>>1]=0;a[b+5820>>2]=0;og(b);c=a[d>>2]|0;a[c+60>>2]=a[c+44>>
2]<<1;d=a[c+76>>2]|0;e=a[c+68>>2]|0;w[e+(d+-1<<1)>>1]=0;Va(e|0,0,(d<<1)+-2|0)|0;d=a[c+132>>2]|0;a[c+128>>2]=N[(12*d|0)+109990>>1];a[c+140>>2]=N[109988+(12*d|0)>>1];a[c+144>>2]=N[(12*d|0)+109992>>1];a[c+124>>2]=N[(12*d|0)+109994>>1];a[c+108>>2]=0;a[c+92>>2]=0;a[c+116>>2]=0;a[c+5812>>2]=0;a[c+120>>2]=2;a[c+96>>2]=2;a[c+104>>2]=0;return a[c+72>>2]=0}function bh(b,d,c){b|=0;d|=0;c|=0;var e,f,g;if(!b)return-2;e=a[b+28>>2]|0;if(!e)return-2;f=-1==(d|0)?6:d;if(4<c>>>0|9<f>>>0)return-2;d=e+132|0;g=e+136|0;
(a[g>>2]|0)==(c|0)&&(a[(12*(a[d>>2]|0)|0)+109996>>2]|0)==(a[(12*f|0)+109996>>2]|0)?b=0:a[b+8>>2]|0?(b=Di(b,5)|0,b=-5==(b|0)?0==(a[e+20>>2]|0)?0:-5:b):b=0;(a[d>>2]|0)!=(f|0)&&(a[d>>2]=f,a[e+128>>2]=N[(12*f|0)+109990>>1],a[e+140>>2]=N[109988+(12*f|0)>>1],a[e+144>>2]=N[(12*f|0)+109992>>1],a[e+124>>2]=N[(12*f|0)+109994>>1]);a[g>>2]=c;return b|0}function Di(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q=0,y,B=0;y=0;var H,ka=0,z=0,Q=0,C=0,u=0,V=0,r=0,J,I,G=0,L=0,K=0,v,E,O,M,T,X=0,P=0,Oa=0,A=0,D,ba=D=0,F=0,R=
0,S=0,ga=0;if(!b)return-2;c=b+28|0;e=a[c>>2]|0;if(5<d>>>0|0==(e|0))return-2;f=b+12|0;do if(a[f>>2]|0&&(0!=(a[b>>2]|0)||0==(a[b+4>>2]|0))&&(g=e+4|0,h=a[g>>2]|0,m=4!=(d|0),!(m&666==(h|0)))){k=b+16|0;if(!(a[k>>2]|0))return a[b+24>>2]=a[27686],c=-5,c|0;a[e>>2]=b;l=e+40|0;n=a[l>>2]|0;a[l>>2]=d;42==(h|0)?2!=(a[e+24>>2]|0)?(p=(a[e+48>>2]<<12)+-30720|0,y=1>=(a[e+136>>2]|0)&&(q=a[e+132>>2]|0,2<=(q|0))?6>(q|0)?64:6==(q|0)?128:192:0,q=y|p,p=e+108|0,B=0==(a[p>>2]|0)?q:q|32,a[g>>2]=113,q=e+20|0,y=a[q>>2]|0,a[q>>
2]=y+1,H=e+8|0,t[(a[H>>2]|0)+y>>0]=B>>>8,y=a[q>>2]|0,a[q>>2]=y+1,t[(a[H>>2]|0)+y>>0]=(B|(B>>>0)%31|0)^31,B=b+48|0,a[p>>2]|0&&(p=a[B>>2]|0,y=a[q>>2]|0,a[q>>2]=y+1,t[(a[H>>2]|0)+y>>0]=p>>>24,y=a[q>>2]|0,a[q>>2]=y+1,t[(a[H>>2]|0)+y>>0]=p>>>16,p=a[B>>2]|0,y=a[q>>2]|0,a[q>>2]=y+1,t[(a[H>>2]|0)+y>>0]=p>>>8,y=a[q>>2]|0,a[q>>2]=y+1,t[(a[H>>2]|0)+y>>0]=p),p=Si(0,0,0)|0,a[B>>2]=p,ka=a[g>>2]|0,z=30):(p=Kd(0,0,0)|0,B=b+48|0,a[B>>2]=p,p=e+20|0,y=a[p>>2]|0,a[p>>2]=y+1,H=e+8|0,t[(a[H>>2]|0)+y>>0]=31,y=a[p>>2]|0,
a[p>>2]=y+1,t[(a[H>>2]|0)+y>>0]=-117,y=a[p>>2]|0,a[p>>2]=y+1,t[(a[H>>2]|0)+y>>0]=8,y=e+28|0,(q=a[y>>2]|0)?(Q=((0!=(a[q+44>>2]|0)?2:0)|0!=(a[q>>2]|0)|(0==(a[q+16>>2]|0)?0:4)|(0==(a[q+28>>2]|0)?0:8)|(0==(a[q+36>>2]|0)?0:16))&255,q=a[p>>2]|0,a[p>>2]=q+1,t[(a[H>>2]|0)+q>>0]=Q,Q=a[(a[y>>2]|0)+4>>2]&255,q=a[p>>2]|0,a[p>>2]=q+1,t[(a[H>>2]|0)+q>>0]=Q,Q=(a[(a[y>>2]|0)+4>>2]|0)>>>8&255,q=a[p>>2]|0,a[p>>2]=q+1,t[(a[H>>2]|0)+q>>0]=Q,Q=(a[(a[y>>2]|0)+4>>2]|0)>>>16&255,q=a[p>>2]|0,a[p>>2]=q+1,t[(a[H>>2]|0)+q>>
0]=Q,Q=(a[(a[y>>2]|0)+4>>2]|0)>>>24&255,q=a[p>>2]|0,a[p>>2]=q+1,t[(a[H>>2]|0)+q>>0]=Q,Q=a[e+132>>2]|0,q=9==(Q|0)?2:2>(Q|0)||1<(a[e+136>>2]|0)?4:0,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=q,Q=a[(a[y>>2]|0)+12>>2]&255,q=a[p>>2]|0,a[p>>2]=q+1,t[(a[H>>2]|0)+q>>0]=Q,Q=a[y>>2]|0,a[Q+16>>2]|0?(q=a[Q+20>>2]&255,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=q,q=(a[(a[y>>2]|0)+20>>2]|0)>>>8&255,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=q,z=a[y>>2]|0):z=Q,a[z+44>>2]|0&&(q=Kd(a[B>>2]|0,a[H>>2]|0,a[p>>2]|0)|
0,a[B>>2]=q),a[e+32>>2]=0,a[g>>2]=69,C=y,z=32):(Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=0,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=0,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=0,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=0,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=0,Q=a[e+132>>2]|0,h=9==(Q|0)?2:2>(Q|0)||1<(a[e+136>>2]|0)?4:0,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=h,Q=a[p>>2]|0,a[p>>2]=Q+1,t[(a[H>>2]|0)+Q>>0]=3,a[g>>2]=113)):(ka=h,z=30);30==(z|0)&&(69==(ka|0)?(C=e+28|0,z=32):(u=ka,
z=53));do if(32==(z|0))if(h=a[C>>2]|0,a[h+16>>2]|0){y=e+20|0;q=a[y>>2]|0;B=e+32|0;p=a[B>>2]|0;a:do if(p>>>0<(a[h+20>>2]&65535)>>>0){H=e+12|0;Q=b+48|0;J=e+8|0;I=b+20|0;G=p;L=q;ka=h;for(K=q;;){if((L|0)==(a[H>>2]|0)){L>>>0>K>>>0&0!=(a[ka+44>>2]|0)&&(v=Kd(a[Q>>2]|0,(a[J>>2]|0)+K|0,L-K|0)|0,a[Q>>2]=v);v=a[c>>2]|0;jd(v);E=v+20|0;O=a[E>>2]|0;M=a[k>>2]|0;T=O>>>0>M>>>0?M:O;0!=(T|0)&&(O=v+16|0,Ec(a[f>>2]|0,a[O>>2]|0,T|0)|0,a[f>>2]=(a[f>>2]|0)+T,a[O>>2]=(a[O>>2]|0)+T,a[I>>2]=(a[I>>2]|0)+T,a[k>>2]=(a[k>>2]|0)-
T,M=a[E>>2]|0,a[E>>2]=M-T,(M|0)==(T|0))&&(a[O>>2]=a[v+8>>2]);v=a[y>>2]|0;if((v|0)==(a[H>>2]|0)){z=v;break}ka=a[C>>2]|0;O=a[B>>2]|0;z=E=v}else O=G,E=L,z=K;v=t[(a[ka+16>>2]|0)+O>>0]|0;a[y>>2]=E+1;t[(a[J>>2]|0)+E>>0]=v;v=(a[B>>2]|0)+1|0;a[B>>2]=v;O=a[C>>2]|0;if(v>>>0>=(a[O+20>>2]&65535)>>>0){H=O;break a}G=v;L=a[y>>2]|0;ka=O;K=z}H=a[C>>2]|0}else H=h,z=q;while(0);0!=(a[H+44>>2]|0)&&(q=a[y>>2]|0,q>>>0>z>>>0)?(h=b+48|0,p=Kd(a[h>>2]|0,(a[e+8>>2]|0)+z|0,q-z|0)|0,a[h>>2]=p,z=a[C>>2]|0):z=H;(a[B>>2]|0)==(a[z+
20>>2]|0)?(a[B>>2]=0,a[g>>2]=73,V=C,r=z,z=55):(u=a[g>>2]|0,z=53)}else a[g>>2]=73,V=C,r=h,z=55;while(0);53==(z|0)&&(73==(u|0)?(V=p=e+28|0,r=a[p>>2]|0,z=55):(X=u,z=73));do if(55==(z|0))if(a[r+28>>2]|0){p=e+20|0;h=a[p>>2]|0;q=e+12|0;K=b+48|0;ka=e+8|0;L=b+20|0;G=e+32|0;for(H=J=h;;){if((J|0)==(a[q>>2]|0))if(J>>>0>H>>>0&&0!=(a[(a[V>>2]|0)+44>>2]|0)&&(h=Kd(a[K>>2]|0,(a[ka>>2]|0)+H|0,J-H|0)|0,a[K>>2]=h),h=a[c>>2]|0,jd(h),I=h+20|0,Q=a[I>>2]|0,O=a[k>>2]|0,v=Q>>>0>O>>>0?O:Q,0!=(v|0)&&(Q=h+16|0,Ec(a[f>>2]|0,
a[Q>>2]|0,v|0)|0,a[f>>2]=(a[f>>2]|0)+v,a[Q>>2]=(a[Q>>2]|0)+v,a[L>>2]=(a[L>>2]|0)+v,a[k>>2]=(a[k>>2]|0)-v,O=a[I>>2]|0,a[I>>2]=O-v,(O|0)==(v|0))&&(a[Q>>2]=a[h+8>>2]),h=a[p>>2]|0,(h|0)==(a[q>>2]|0)){z=1;break}else z=O=h;else O=J,z=H;h=a[G>>2]|0;a[G>>2]=h+1;Q=t[(a[(a[V>>2]|0)+28>>2]|0)+h>>0]|0;a[p>>2]=O+1;t[(a[ka>>2]|0)+O>>0]=Q;if(!(Q<<24>>24)){h=z;z=Q&255;break}J=a[p>>2]|0;H=z}0!=(a[(a[V>>2]|0)+44>>2]|0)&&(H=a[p>>2]|0,H>>>0>h>>>0)&&(J=Kd(a[K>>2]|0,(a[ka>>2]|0)+h|0,H-h|0)|0,a[K>>2]=J);z?(X=a[g>>2]|0,
z=73):(a[G>>2]=0,a[g>>2]=91,P=V,z=75)}else a[g>>2]=91,P=V,z=75;while(0);73==(z|0)&&(91==(X|0)?(P=e+28|0,z=75):(Oa=X,z=93));do if(75==(z|0))if(a[(a[P>>2]|0)+36>>2]|0){J=e+20|0;H=a[J>>2]|0;q=e+12|0;L=b+48|0;B=e+8|0;y=b+20|0;Q=e+32|0;for(v=h=H;;){if((h|0)==(a[q>>2]|0))if(h>>>0>v>>>0&&0!=(a[(a[P>>2]|0)+44>>2]|0)&&(H=Kd(a[L>>2]|0,(a[B>>2]|0)+v|0,h-v|0)|0,a[L>>2]=H),H=a[c>>2]|0,jd(H),O=H+20|0,I=a[O>>2]|0,T=a[k>>2]|0,M=I>>>0>T>>>0?T:I,0!=(M|0)&&(I=H+16|0,Ec(a[f>>2]|0,a[I>>2]|0,M|0)|0,a[f>>2]=(a[f>>2]|0)+
M,a[I>>2]=(a[I>>2]|0)+M,a[y>>2]=(a[y>>2]|0)+M,a[k>>2]=(a[k>>2]|0)-M,T=a[O>>2]|0,a[O>>2]=T-M,(T|0)==(M|0))&&(a[I>>2]=a[H+8>>2]),H=a[J>>2]|0,(H|0)==(a[q>>2]|0)){z=H;p=1;break}else z=p=H;else p=h,z=v;H=a[Q>>2]|0;a[Q>>2]=H+1;I=t[(a[(a[P>>2]|0)+36>>2]|0)+H>>0]|0;a[J>>2]=p+1;t[(a[B>>2]|0)+p>>0]=I;if(!(I<<24>>24)){p=I&255;break}h=a[J>>2]|0;v=z}0!=(a[(a[P>>2]|0)+44>>2]|0)&&(v=a[J>>2]|0,v>>>0>z>>>0)&&(h=Kd(a[L>>2]|0,(a[B>>2]|0)+z|0,v-z|0)|0,a[L>>2]=h);p?(Oa=a[g>>2]|0,z=93):(a[g>>2]=103,A=P,z=95)}else a[g>>
2]=103,A=P,z=95;while(0);93==(z|0)&&103==(Oa|0)&&(A=e+28|0,z=95);95==(z|0)&&(a[(a[A>>2]|0)+44>>2]|0?(h=e+20|0,v=e+12|0,((a[h>>2]|0)+2|0)>>>0>(a[v>>2]|0)>>>0&&(Q=a[c>>2]|0,jd(Q),q=Q+20|0,y=a[q>>2]|0,G=a[k>>2]|0,K=y>>>0>G>>>0?G:y,0!=(K|0))&&(y=Q+16|0,Ec(a[f>>2]|0,a[y>>2]|0,K|0)|0,a[f>>2]=(a[f>>2]|0)+K,a[y>>2]=(a[y>>2]|0)+K,G=b+20|0,a[G>>2]=(a[G>>2]|0)+K,a[k>>2]=(a[k>>2]|0)-K,G=a[q>>2]|0,a[q>>2]=G-K,(G|0)==(K|0))&&(a[y>>2]=a[Q+8>>2]),Q=a[h>>2]|0,(Q+2|0)>>>0<=(a[v>>2]|0)>>>0&&(v=b+48|0,y=a[v>>2]&255,
a[h>>2]=Q+1,K=e+8|0,t[(a[K>>2]|0)+Q>>0]=y,y=(a[v>>2]|0)>>>8&255,Q=a[h>>2]|0,a[h>>2]=Q+1,t[(a[K>>2]|0)+Q>>0]=y,y=Kd(0,0,0)|0,a[v>>2]=y,a[g>>2]=113)):a[g>>2]=113);y=e+20|0;if(a[y>>2]|0){if(v=a[c>>2]|0,jd(v),Q=v+20|0,K=a[Q>>2]|0,h=a[k>>2]|0,(G=K>>>0>h>>>0?h:K)?(K=v+16|0,Ec(a[f>>2]|0,a[K>>2]|0,G|0)|0,a[f>>2]=(a[f>>2]|0)+G,a[K>>2]=(a[K>>2]|0)+G,q=b+20|0,a[q>>2]=(a[q>>2]|0)+G,q=(a[k>>2]|0)-G|0,a[k>>2]=q,ka=a[Q>>2]|0,a[Q>>2]=ka-G,(ka|0)==(G|0)&&(a[K>>2]=a[v+8>>2]),Q=q):Q=h,!Q)return a[l>>2]=-1,c=0,c|0}else if(0==
(a[b+4>>2]|0)&&m&((d<<1)-(4<(d|0)?9:0)|0)<=((n<<1)-(4<(n|0)?9:0)|0))return a[b+24>>2]=a[27686],c=-5,c|0;h=666==(a[g>>2]|0);q=0==(a[b+4>>2]|0);if(h)if(q)z=116;else return a[b+24>>2]=a[27686],c=-5,c|0;else z=q?116:117;116!=(z|0)||0==(a[e+116>>2]|0)&(0==(d|0)|h)||(z=117);do if(117==(z|0)){a:do switch(a[e+136>>2]|0){case 2:h=e+116|0;q=e+96|0;v=e+108|0;K=e+56|0;G=e+5792|0;ka=e+5796|0;Q=e+5784|0;p=e+5788|0;for(I=e+92|0;0!=(a[h>>2]|0)||(Dh(e),0!=(a[h>>2]|0));)if(a[q>>2]=0,H=t[(a[K>>2]|0)+(a[v>>2]|0)>>0]|
0,M=a[G>>2]|0,w[(a[ka>>2]|0)+(M<<1)>>1]=0,a[G>>2]=M+1,t[(a[Q>>2]|0)+M>>0]=H,M=e+148+((H&255)<<2)|0,w[M>>1]=(w[M>>1]|0)+1<<16>>16,M=(a[G>>2]|0)==((a[p>>2]|0)+-1|0),a[h>>2]=(a[h>>2]|0)+-1,H=(a[v>>2]|0)+1|0,a[v>>2]=H,M&&(M=a[I>>2]|0,n=-1<(M|0)?(a[K>>2]|0)+M|0:0,zd(e,n,H-M|0,0),a[I>>2]=a[v>>2],M=a[e>>2]|0,H=a[M+28>>2]|0,jd(H),T=H+20|0,O=a[T>>2]|0,E=M+16|0,n=a[E>>2]|0,P=O>>>0>n>>>0?n:O,0!=(P|0)&&(O=M+12|0,n=H+16|0,Ec(a[O>>2]|0,a[n>>2]|0,P|0)|0,a[O>>2]=(a[O>>2]|0)+P,a[n>>2]=(a[n>>2]|0)+P,O=M+20|0,a[O>>
2]=(a[O>>2]|0)+P,a[E>>2]=(a[E>>2]|0)-P,E=a[T>>2]|0,a[T>>2]=E-P,(E|0)==(P|0))&&(a[n>>2]=a[H+8>>2]),!(a[(a[e>>2]|0)+16>>2]|0))){z=191;break a}if(d){a[e+5812>>2]=0;if(4==(d|0)){h=a[I>>2]|0;D=-1<(h|0)?(a[K>>2]|0)+h|0:0;zd(e,D,(a[v>>2]|0)-h|0,1);a[I>>2]=a[v>>2];h=a[e>>2]|0;p=a[h+28>>2]|0;jd(p);Q=p+20|0;ka=a[Q>>2]|0;q=h+16|0;H=a[q>>2]|0;n=ka>>>0>H>>>0?H:ka;0!=(n|0)&&(ka=h+12|0,H=p+16|0,Ec(a[ka>>2]|0,a[H>>2]|0,n|0)|0,a[ka>>2]=(a[ka>>2]|0)+n,a[H>>2]=(a[H>>2]|0)+n,ka=h+20|0,a[ka>>2]=(a[ka>>2]|0)+n,a[q>>2]=
(a[q>>2]|0)-n,q=a[Q>>2]|0,a[Q>>2]=q-n,(q|0)==(n|0))&&(a[H>>2]=a[p+8>>2]);D=0==(a[(a[e>>2]|0)+16>>2]|0)?2:3;z=188;break a}a[G>>2]|0&&(p=a[I>>2]|0,Q=-1<(p|0)?(a[K>>2]|0)+p|0:0,zd(e,Q,(a[v>>2]|0)-p|0,0),a[I>>2]=a[v>>2],p=a[e>>2]|0,H=a[p+28>>2]|0,jd(H),n=H+20|0,q=a[n>>2]|0,Q=p+16|0,ka=a[Q>>2]|0,h=q>>>0>ka>>>0?ka:q,0!=(h|0)&&(q=p+12|0,ka=H+16|0,Ec(a[q>>2]|0,a[ka>>2]|0,h|0)|0,a[q>>2]=(a[q>>2]|0)+h,a[ka>>2]=(a[ka>>2]|0)+h,q=p+20|0,a[q>>2]=(a[q>>2]|0)+h,a[Q>>2]=(a[Q>>2]|0)-h,Q=a[n>>2]|0,a[n>>2]=Q-h,(Q|0)==
(h|0))&&(a[ka>>2]=a[H+8>>2]),a[(a[e>>2]|0)+16>>2]|0||(z=191))}else z=191;break;case 3:H=e+116|0;ka=0==(d|0);h=e+96|0;Q=e+108|0;n=e+5792|0;q=e+5796|0;p=e+5784|0;P=e+2440+(x[154873]<<2)|0;E=e+5788|0;T=e+56|0;for(O=e+92|0;;){M=a[H>>2]|0;if(259>M>>>0){Dh(e);G=a[H>>2]|0;if(ka&259>G>>>0){z=191;break a}if(!G)break;a[h>>2]=0;2<G>>>0?(ba=G,z=150):(F=a[Q>>2]|0,z=165)}else a[h>>2]=0,ba=M,z=150;if(150==(z|0))if(z=0,M=a[Q>>2]|0)if(G=a[T>>2]|0,K=t[G+(M+-1)>>0]|0,K<<24>>24==(t[G+M>>0]|0)&&K<<24>>24==(t[G+(M+1)>>
0]|0)&&(R=G+(M+2)|0,K<<24>>24==(t[R>>0]|0))){Oa=G+(M+258)|0;for(G=R;;){R=G+1|0;if(K<<24>>24!=(t[R>>0]|0)){G=R;break}R=G+2|0;if(K<<24>>24!=(t[R>>0]|0)){G=R;break}R=G+3|0;if(K<<24>>24!=(t[R>>0]|0)){G=R;break}R=G+4|0;if(K<<24>>24!=(t[R>>0]|0)){G=R;break}R=G+5|0;if(K<<24>>24!=(t[R>>0]|0)){G=R;break}R=G+6|0;if(K<<24>>24!=(t[R>>0]|0)){G=R;break}R=G+7|0;if(K<<24>>24!=(t[R>>0]|0)){G=R;break}R=G+8|0;if(R>>>0<Oa>>>0&&K<<24>>24==(t[R>>0]|0))G=R;else{G=R;break}}G=G-Oa+258|0;K=G>>>0>ba>>>0?ba:G;a[h>>2]=K;2<K>>>
0?(G=K+253|0,K=a[n>>2]|0,w[(a[q>>2]|0)+(K<<1)>>1]=1,a[n>>2]=K+1,t[(a[p>>2]|0)+K>>0]=G,K=e+148+((x[155385+(G&255)>>0]|256)+1<<2)|0,w[K>>1]=(w[K>>1]|0)+1<<16>>16,w[P>>1]=(w[P>>1]|0)+1<<16>>16,K=(a[n>>2]|0)==((a[E>>2]|0)+-1|0)&1,G=a[h>>2]|0,a[H>>2]=(a[H>>2]|0)-G,R=(a[Q>>2]|0)+G|0,a[Q>>2]=R,a[h>>2]=0,S=R,ga=K):(F=M,z=165)}else F=M,z=165;else F=0,z=165;165==(z|0)&&(z=0,K=t[(a[T>>2]|0)+F>>0]|0,R=a[n>>2]|0,w[(a[q>>2]|0)+(R<<1)>>1]=0,a[n>>2]=R+1,t[(a[p>>2]|0)+R>>0]=K,R=e+148+((K&255)<<2)|0,w[R>>1]=(w[R>>
1]|0)+1<<16>>16,R=(a[n>>2]|0)==((a[E>>2]|0)+-1|0)&1,a[H>>2]=(a[H>>2]|0)+-1,K=(a[Q>>2]|0)+1|0,S=a[Q>>2]=K,ga=R);if(ga&&(R=a[O>>2]|0,G=-1<(R|0)?(a[T>>2]|0)+R|0:0,zd(e,G,S-R|0,0),a[O>>2]=a[Q>>2],R=a[e>>2]|0,K=a[R+28>>2]|0,jd(K),G=K+20|0,Oa=a[G>>2]|0,A=R+16|0,V=a[A>>2]|0,r=Oa>>>0>V>>>0?V:Oa,0!=(r|0)&&(Oa=R+12|0,V=K+16|0,Ec(a[Oa>>2]|0,a[V>>2]|0,r|0)|0,a[Oa>>2]=(a[Oa>>2]|0)+r,a[V>>2]=(a[V>>2]|0)+r,Oa=R+20|0,a[Oa>>2]=(a[Oa>>2]|0)+r,a[A>>2]=(a[A>>2]|0)-r,A=a[G>>2]|0,a[G>>2]=A-r,(A|0)==(r|0))&&(a[V>>2]=a[K+
8>>2]),!(a[(a[e>>2]|0)+16>>2]|0))){z=191;break a}}a[e+5812>>2]=0;if(4==(d|0)){H=a[O>>2]|0;D=-1<(H|0)?(a[T>>2]|0)+H|0:0;zd(e,D,(a[Q>>2]|0)-H|0,1);a[O>>2]=a[Q>>2];H=a[e>>2]|0;E=a[H+28>>2]|0;jd(E);p=E+20|0;q=a[p>>2]|0;h=H+16|0;P=a[h>>2]|0;ka=q>>>0>P>>>0?P:q;0!=(ka|0)&&(q=H+12|0,P=E+16|0,Ec(a[q>>2]|0,a[P>>2]|0,ka|0)|0,a[q>>2]=(a[q>>2]|0)+ka,a[P>>2]=(a[P>>2]|0)+ka,q=H+20|0,a[q>>2]=(a[q>>2]|0)+ka,a[h>>2]=(a[h>>2]|0)-ka,h=a[p>>2]|0,a[p>>2]=h-ka,(h|0)==(ka|0))&&(a[P>>2]=a[E+8>>2]);D=0==(a[(a[e>>2]|0)+16>>
2]|0)?2:3;z=188;break a}a[n>>2]|0&&(E=a[O>>2]|0,q=-1<(E|0)?(a[T>>2]|0)+E|0:0,zd(e,q,(a[Q>>2]|0)-E|0,0),a[O>>2]=a[Q>>2],E=a[e>>2]|0,P=a[E+28>>2]|0,jd(P),ka=P+20|0,h=a[ka>>2]|0,p=E+16|0,q=a[p>>2]|0,H=h>>>0>q>>>0?q:h,0!=(H|0)&&(h=E+12|0,q=P+16|0,Ec(a[h>>2]|0,a[q>>2]|0,H|0)|0,a[h>>2]=(a[h>>2]|0)+H,a[q>>2]=(a[q>>2]|0)+H,h=E+20|0,a[h>>2]=(a[h>>2]|0)+H,a[p>>2]=(a[p>>2]|0)-H,p=a[ka>>2]|0,a[ka>>2]=p-H,(p|0)==(H|0))&&(a[q>>2]=a[P+8>>2]),a[(a[e>>2]|0)+16>>2]|0||(z=191));break;default:D=dd[a[(12*(a[e+132>>2]|
0)|0)+109996>>2]&127](e,d)|0,z=188}while(0);if(188==(z|0))if(2==(D&-2|0)&&(a[g>>2]=666),D&-3){if(1!=(D|0))break}else z=191;if(191==(z|0)){if(a[k>>2]|0)return c=0,c|0;a[l>>2]=-1;c=0;return c|0}switch(d|0){case 1:L=e;L|=0;B=L+5820|0;p=a[B>>2]|0;Q=L+5816|0;q=N[Q>>1]|0|2<<p;w[Q>>1]=q;13<(p|0)?(p=L+20|0,h=a[p>>2]|0,a[p>>2]=h+1,G=L+8|0,t[(a[G>>2]|0)+h>>0]=q,h=(N[Q>>1]|0)>>>8&255,H=a[p>>2]|0,a[p>>2]=H+1,t[(a[G>>2]|0)+H>>0]=h,h=a[B>>2]|0,H=2>>>(16-h|0),G=w[Q>>1]=H,h=h+-13|0):(G=q,h=p+3|0);p=G&255;a[B>>2]=
h;9<(h|0)?(G=L+20|0,q=a[G>>2]|0,a[G>>2]=q+1,h=L+8|0,t[(a[h>>2]|0)+q>>0]=p,q=(N[Q>>1]|0)>>>8&255,H=a[G>>2]|0,a[G>>2]=H+1,t[(a[h>>2]|0)+H>>0]=q,H=w[Q>>1]=0,q=(a[B>>2]|0)+-9|0):(H=p,q=h+7|0);a[B>>2]=q;16==(q|0)?(h=L+20|0,p=a[h>>2]|0,a[h>>2]=p+1,q=L+8|0,t[(a[q>>2]|0)+p>>0]=H,p=(N[Q>>1]|0)>>>8&255,H=a[h>>2]|0,a[h>>2]=H+1,t[(a[q>>2]|0)+H>>0]=p,w[Q>>1]=0,a[B>>2]=0):7>=(q|0)||(q=L+20|0,p=a[q>>2]|0,a[q>>2]=p+1,t[(a[L+8>>2]|0)+p>>0]=H,w[Q>>1]=(N[Q>>1]|0)>>>8,a[B>>2]=(a[B>>2]|0)+-8);break;case 5:break;default:Af(e,
0,0,0),3==(d|0)&&(L=a[e+76>>2]|0,B=a[e+68>>2]|0,w[B+(L+-1<<1)>>1]=0,Va(B|0,0,(L<<1)+-2|0)|0,0==(a[e+116>>2]|0))&&(a[e+108>>2]=0,a[e+92>>2]=0,a[e+5812>>2]=0)}L=a[c>>2]|0;jd(L);B=L+20|0;J=a[B>>2]|0;P=a[k>>2]|0;(q=J>>>0>P>>>0?P:J)?(J=L+16|0,Ec(a[f>>2]|0,a[J>>2]|0,q|0)|0,a[f>>2]=(a[f>>2]|0)+q,a[J>>2]=(a[J>>2]|0)+q,H=b+20|0,a[H>>2]=(a[H>>2]|0)+q,H=(a[k>>2]|0)-q|0,a[k>>2]=H,p=a[B>>2]|0,a[B>>2]=p-q,(p|0)==(q|0)&&(a[J>>2]=a[L+8>>2]),Q=H):Q=P;if(!Q)return a[l>>2]=-1,c=0,c|0}while(0);if(m)return c=0,c|0;l=
e+24|0;g=a[l>>2]|0;if(1>(g|0))return c=1,c|0;n=b+48|0;P=a[n>>2]|0;2==(g|0)?(g=a[y>>2]|0,a[y>>2]=g+1,H=e+8|0,t[(a[H>>2]|0)+g>>0]=P,g=(a[n>>2]|0)>>>8&255,L=a[y>>2]|0,a[y>>2]=L+1,t[(a[H>>2]|0)+L>>0]=g,g=(a[n>>2]|0)>>>16&255,L=a[y>>2]|0,a[y>>2]=L+1,t[(a[H>>2]|0)+L>>0]=g,g=(a[n>>2]|0)>>>24&255,L=a[y>>2]|0,a[y>>2]=L+1,t[(a[H>>2]|0)+L>>0]=g,g=b+8|0,L=a[g>>2]&255,J=a[y>>2]|0,a[y>>2]=J+1,t[(a[H>>2]|0)+J>>0]=L,L=(a[g>>2]|0)>>>8&255,J=a[y>>2]|0,a[y>>2]=J+1,t[(a[H>>2]|0)+J>>0]=L,L=(a[g>>2]|0)>>>16&255,J=a[y>>
2]|0,a[y>>2]=J+1,t[(a[H>>2]|0)+J>>0]=L,L=(a[g>>2]|0)>>>24&255,g=a[y>>2]|0,a[y>>2]=g+1,t[(a[H>>2]|0)+g>>0]=L):(L=a[y>>2]|0,a[y>>2]=L+1,g=e+8|0,t[(a[g>>2]|0)+L>>0]=P>>>24,L=a[y>>2]|0,a[y>>2]=L+1,t[(a[g>>2]|0)+L>>0]=P>>>16,P=a[n>>2]|0,n=a[y>>2]|0,a[y>>2]=n+1,t[(a[g>>2]|0)+n>>0]=P>>>8,n=a[y>>2]|0,a[y>>2]=n+1,t[(a[g>>2]|0)+n>>0]=P);P=a[c>>2]|0;jd(P);n=P+20|0;g=a[n>>2]|0;L=a[k>>2]|0;H=g>>>0>L>>>0?L:g;0!=(H|0)&&(g=P+16|0,Ec(a[f>>2]|0,a[g>>2]|0,H|0)|0,a[f>>2]=(a[f>>2]|0)+H,a[g>>2]=(a[g>>2]|0)+H,L=b+20|0,
a[L>>2]=(a[L>>2]|0)+H,a[k>>2]=(a[k>>2]|0)-H,L=a[n>>2]|0,a[n>>2]=L-H,(L|0)==(H|0))&&(a[g>>2]=a[P+8>>2]);P=a[l>>2]|0;0<(P|0)&&(a[l>>2]=0-P);c=0==(a[y>>2]|0)&1;return c|0}while(0);a[b+24>>2]=a[27683];return-2}function Dh(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C,u,V,r,J,I,G,L;d=b+44|0;c=a[d>>2]|0;e=b+60|0;f=b+116|0;g=b+108|0;h=c+-262|0;m=b+56|0;k=b+5812|0;l=b+72|0;n=b+88|0;p=b+84|0;q=b+68|0;y=b+52|0;B=b+64|0;H=b+112|0;t=b+92|0;z=b+76|0;Q=a[f>>2]|0;for(C=c;;){u=a[g>>2]|0;V=(a[e>>2]|0)-Q-u|0;if(u>>>
0<(h+C|0)>>>0)r=u,J=V;else{u=a[m>>2]|0;Ec(u|0,u+c|0,c|0)|0;a[H>>2]=(a[H>>2]|0)-c;u=(a[g>>2]|0)-c|0;a[g>>2]=u;a[t>>2]=(a[t>>2]|0)-c;Q=C=a[z>>2]|0;I=(a[q>>2]|0)+(C<<1)|0;do I=I+-2|0,C=N[I>>1]|0,w[I>>1]=C>>>0<c>>>0?0:C-c&65535,Q=Q+-1|0;while(0!=(Q|0));Q=c;I=(a[B>>2]|0)+(c<<1)|0;do I=I+-2|0,C=N[I>>1]|0,w[I>>1]=C>>>0<c>>>0?0:C-c&65535,Q=Q+-1|0;while(0!=(Q|0));r=u;J=V+c|0}Q=a[b>>2]|0;I=Q+4|0;C=a[I>>2]|0;if(!C)break;u=a[f>>2]|0;V=(a[m>>2]|0)+(u+r)|0;if(r=C>>>0>J>>>0?J:C){a[I>>2]=C-r;Ec(V|0,a[Q>>2]|0,r|0)|
0;switch(a[(a[Q+28>>2]|0)+24>>2]|0){case 1:C=Q+48|0;I=Si(a[C>>2]|0,V,r)|0;a[C>>2]=I;break;case 2:I=Q+48|0,C=Kd(a[I>>2]|0,V,r)|0,a[I>>2]=C}a[Q>>2]=(a[Q>>2]|0)+r;C=Q+8|0;a[C>>2]=(a[C>>2]|0)+r;C=r;Q=a[f>>2]|0}else C=0,Q=u;r=Q+C|0;a[f>>2]=r;C=a[k>>2]|0;a:do if(2<(r+C|0)>>>0)for(Q=(a[g>>2]|0)-C|0,I=a[m>>2]|0,V=x[I+Q>>0]|0,a[l>>2]=V,u=a[n>>2]|0,J=a[p>>2]|0,G=((x[I+(Q+1)>>0]|0)^V<<u)&J,a[l>>2]=G,V=C,L=G,G=Q;;){if(!V)break a;L=((x[I+(G+2)>>0]|0)^L<<u)&J;a[l>>2]=L;Q=(a[q>>2]|0)+(L<<1)|0;w[(a[B>>2]|0)+((a[y>>
2]&G)<<1)>>1]=w[Q>>1]|0;w[Q>>1]=G;V=V+-1|0;a[k>>2]=V;if(3>(r+V|0)>>>0)break;else G=G+1|0}while(0);if(262<=r>>>0)break;if(!(a[(a[b>>2]|0)+4>>2]|0))break;Q=r;C=a[d>>2]|0}d=b+5824|0;b=a[d>>2]|0;C=a[e>>2]|0;C>>>0<=b>>>0||(e=(a[f>>2]|0)+(a[g>>2]|0)|0,b>>>0<e>>>0?(g=C-e|0,f=258<g>>>0?258:g,Va((a[m>>2]|0)+e|0,0,f|0)|0,a[d>>2]=f+e):(f=e+258|0,f>>>0<=b>>>0||(e=f-b|0,f=C-b|0,C=e>>>0>f>>>0?f:e,Va((a[m>>2]|0)+b|0,0,C|0)|0,a[d>>2]=(a[d>>2]|0)+C)))}function sk(b,d){b|=0;d|=0;var c,e,f,g,h;c=a[b+4>>2]|0;if(1>=d>>>
0){if(1==(d|0)){e=c+68|0;if(f=a[e>>2]|0){g=f;do f=g+40|0,a[f>>2]|0&&(a[f>>2]=0,ub[a[g+56>>2]&31](b,g+48|0)),g=a[g+44>>2]|0;while(0!=(g|0))}a[e>>2]=0;e=c+72|0;if(g=a[e>>2]|0){f=g;do g=f+40|0,a[g>>2]|0&&(a[g>>2]=0,ub[a[f+56>>2]&31](b,f+48|0)),f=a[f+44>>2]|0;while(0!=(f|0))}a[e>>2]=0}}else e=a[b>>2]|0,a[e+20>>2]=15,a[e+24>>2]=d,R[a[e>>2]&127](b);e=c+60+(d<<2)|0;f=a[e>>2]|0;a[e>>2]=0;if(f){e=c+76|0;g=f;do f=g,g=a[g>>2]|0,h=(a[f+4>>2]|0)+16+(a[f+8>>2]|0)|0,Gc(f|0),a[e>>2]=(a[e>>2]|0)-h;while(0!=(g|0))}g=
c+52+(d<<2)|0;d=a[g>>2]|0;a[g>>2]=0;if(d){g=c+76|0;c=d;do d=c,c=a[c>>2]|0,e=(a[d+4>>2]|0)+16+(a[d+8>>2]|0)|0,Gc(d|0),a[g>>2]=(a[g>>2]|0)-e;while(0!=(c|0))}}function Vh(b,d,c){b|=0;c=a[b>>2]|0;a[c+20>>2]=51;R[a[c>>2]&127](b)}function Wh(b){b|=0;var d,c,e,f,g,h,m,k,l;d=a[b+424>>2]|0;c=d+12|0;e=a[c>>2]|0;f=(a[d+16>>2]|0)+-1+e&-65536;g=((f|0)<(e|0)?f|32768:f)<<a[d+28>>2];a[c>>2]=g;f=d+32|0;e=a[f>>2]|0;if(134217727>=g>>>0){if(e){if(-1<(e|0)){g=d+24|0;h=b+24|0;if(a[g>>2]|0){do k=a[h>>2]|0,e=a[k>>2]|0,a[k>>
2]=e+1,t[e>>0]=0,e=k+4|0,l=(a[e>>2]|0)+-1|0,a[e>>2]=l,0==(l|0)&&0==(da[a[k+12>>2]&63](b)|0)&&(k=a[b>>2]|0,a[k+20>>2]=25,R[a[k>>2]&127](b)),k=(a[g>>2]|0)+-1|0,a[g>>2]=k;while(0!=(k|0));m=a[f>>2]|0}else m=e;g=a[h>>2]|0;h=a[g>>2]|0;a[g>>2]=h+1;t[h>>0]=m;m=g+4|0;h=(a[m>>2]|0)+-1|0;a[m>>2]=h;0==(h|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b))}}else g=d+24|0,a[g>>2]=(a[g>>2]|0)+1;g=d+20|0;if(a[g>>2]|0){h=d+24|0;m=b+24|0;if(a[h>>2]|0){do k=a[m>>2]|0,l=a[k>>2]|0,a[k>>2]=l+
1,t[l>>0]=0,l=k+4|0,e=(a[l>>2]|0)+-1|0,a[l>>2]=e,0==(e|0)&&0==(da[a[k+12>>2]&63](b)|0)&&(k=a[b>>2]|0,a[k+20>>2]=25,R[a[k>>2]&127](b)),k=(a[h>>2]|0)+-1|0,a[h>>2]=k;while(0!=(k|0))}do h=a[m>>2]|0,k=a[h>>2]|0,a[h>>2]=k+1,t[k>>0]=-1,k=h+4|0,e=(a[k>>2]|0)+-1|0,a[k>>2]=e,0==(e|0)&&0==(da[a[h+12>>2]&63](b)|0)&&(h=a[b>>2]|0,a[h+20>>2]=25,R[a[h>>2]&127](b)),h=a[m>>2]|0,e=a[h>>2]|0,a[h>>2]=e+1,t[e>>0]=0,e=h+4|0,k=(a[e>>2]|0)+-1|0,a[e>>2]=k,0==(k|0)&&0==(da[a[h+12>>2]&63](b)|0)&&(h=a[b>>2]|0,a[h+20>>2]=25,R[a[h>>
2]&127](b)),h=(a[g>>2]|0)+-1|0,a[g>>2]=h;while(0!=(h|0))}}else{g=d+24|0;if(-1<(e|0)){m=b+24|0;if(a[g>>2]|0){do e=a[m>>2]|0,h=a[e>>2]|0,a[e>>2]=h+1,t[h>>0]=0,h=e+4|0,k=(a[h>>2]|0)+-1|0,a[h>>2]=k,0==(k|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=(a[g>>2]|0)+-1|0,a[g>>2]=e;while(0!=(e|0));h=a[f>>2]|0}else h=e;e=a[m>>2]|0;k=a[e>>2]|0;a[e>>2]=k+1;t[k>>0]=h+1;h=e+4|0;k=(a[h>>2]|0)+-1|0;a[h>>2]=k;0==(k|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>
2]&127](b));254==(a[f>>2]|0)&&(f=a[m>>2]|0,m=a[f>>2]|0,a[f>>2]=m+1,t[m>>0]=0,m=f+4|0,e=(a[m>>2]|0)+-1|0,a[m>>2]=e,0==(e|0))&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b))}f=d+20|0;a[g>>2]=(a[g>>2]|0)+(a[f>>2]|0);a[f>>2]=0}f=a[c>>2]|0;if(f&134215680){g=d+24|0;d=b+24|0;if(a[g>>2]|0){do f=a[d>>2]|0,e=a[f>>2]|0,a[f>>2]=e+1,t[e>>0]=0,e=f+4|0,m=(a[e>>2]|0)+-1|0,a[e>>2]=m,0==(m|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),f=(a[g>>2]|0)+-1|0,
a[g>>2]=f;while(0!=(f|0));m=a[c>>2]|0}else m=f;g=a[d>>2]|0;f=a[g>>2]|0;a[g>>2]=f+1;t[f>>0]=m>>>19;m=g+4|0;f=(a[m>>2]|0)+-1|0;a[m>>2]=f;0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));133693440==(a[c>>2]&133693440|0)&&(g=a[d>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=0,f=g+4|0,m=(a[f>>2]|0)+-1|0,a[f>>2]=m,0==(m|0))&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));g=a[c>>2]|0;g&522240&&(m=a[d>>2]|0,f=a[m>>2]|0,a[m>>2]=f+1,t[f>>0]=g>>>11,g=m+
4|0,f=(a[g>>2]|0)+-1|0,a[g>>2]=f,0==(f|0)&&0==(da[a[m+12>>2]&63](b)|0)&&(m=a[b>>2]|0,a[m+20>>2]=25,R[a[m>>2]&127](b)),522240==(a[c>>2]&522240|0)&&(c=a[d>>2]|0,d=a[c>>2]|0,a[c>>2]=d+1,t[d>>0]=0,d=c+4|0,m=(a[d>>2]|0)+-1|0,a[d>>2]=m,m||da[a[c+12>>2]&63](b)|0||(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b))))}}function jh(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l;c=a[b+424>>2]|0;Wh(b);e=b+24|0;f=a[e>>2]|0;g=a[f>>2]|0;a[f>>2]=g+1;t[g>>0]=-1;g=f+4|0;h=(a[g>>2]|0)+-1|0;a[g>>2]=h;0==(h|0)&&0==(da[a[f+12>>2]&63](b)|
0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b));f=a[e>>2]|0;e=a[f>>2]|0;a[f>>2]=e+1;t[e>>0]=d+208;d=f+4|0;e=(a[d>>2]|0)+-1|0;a[d>>2]=e;0==(e|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b));f=b+292|0;if(!(0>=(a[f>>2]|0))){e=b+364|0;d=b+372|0;h=b+368|0;g=0;do{m=a[b+296+(g<<2)>>2]|0;if(0==(a[e>>2]|0)&&0==(a[d>>2]|0)){k=a[c+76+(a[m+20>>2]<<2)>>2]|0;l=k+64|0;do t[k>>0]=0,k=k+1|0;while((k|0)<(l|0));a[c+36+(g<<2)>>2]=0;a[c+52+(g<<2)>>2]=0}a[h>>2]|0&&Va(a[c+140+(a[m+24>>2]<<
2)>>2]|0,0,256)|0;g=g+1|0}while((g|0)<(a[f>>2]|0))}a[(c+12|0)>>2]=0;a[(c+16|0)>>2]=65536;a[(c+20|0)>>2]=0;a[(c+24|0)>>2]=0;a[(c+28|0)>>2]=11;a[(c+32|0)>>2]=-1}function ec(b,d,c){b|=0;d|=0;var e,f,g,h,m,k,l,n,p;e=a[b+424>>2]|0;f=x[d>>0]|0;g=a[122136+((f&127)<<2)>>2]|0;h=g>>>8;m=g>>16;k=e+16|0;l=(a[k>>2]|0)-m|0;a[k>>2]=l;if((f>>>7|0)==(c|0)){if(32767<(l|0))return;(l|0)<(m|0)&&(c=e+12|0,a[c>>2]=(a[c>>2]|0)+l,a[k>>2]=m);n=f&128^h}else(l|0)>=(m|0)&&(h=e+12|0,a[h>>2]=(a[h>>2]|0)+l,a[k>>2]=m),n=f&128^g;
t[d>>0]=n;n=e+12|0;d=e+28|0;g=e+32|0;f=e+24|0;m=b+24|0;l=e+20|0;e=a[k>>2]|0;h=a[n>>2]|0;for(c=a[d>>2]|0;;){p=e<<1;a[k>>2]=p;e=h<<1;a[n>>2]=e;c=c+-1|0;if(a[d>>2]=c)h=p;else{e>>=19;if(255<(e|0)){c=a[g>>2]|0;if(-1<(c|0)){if(a[f>>2]|0){do c=a[m>>2]|0,h=a[c>>2]|0,a[c>>2]=h+1,t[h>>0]=0,h=c+4|0,p=(a[h>>2]|0)+-1|0,a[h>>2]=p,0==(p|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),c=(a[f>>2]|0)+-1|0,a[f>>2]=c;while(0!=(c|0));h=a[g>>2]|0}else h=c;c=a[m>>2]|0;p=a[c>>2]|0;a[c>>2]=
p+1;t[p>>0]=h+1;p=c+4|0;h=(a[p>>2]|0)+-1|0;a[p>>2]=h;0==(h|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));254==(a[g>>2]|0)&&(c=a[m>>2]|0,h=a[c>>2]|0,a[c>>2]=h+1,t[h>>0]=0,h=c+4|0,p=(a[h>>2]|0)+-1|0,a[h>>2]=p,0==(p|0))&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b))}a[f>>2]=(a[f>>2]|0)+(a[l>>2]|0);a[l>>2]=0;a[g>>2]=e&255}else if(255==(e|0))a[l>>2]=(a[l>>2]|0)+1;else{if(c=a[g>>2]|0){if(-1<(c|0)){if(a[f>>2]|0){do c=a[m>>2]|0,p=a[c>>2]|0,a[c>>
2]=p+1,t[p>>0]=0,p=c+4|0,h=(a[p>>2]|0)+-1|0,a[p>>2]=h,0==(h|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),c=(a[f>>2]|0)+-1|0,a[f>>2]=c;while(0!=(c|0));p=a[g>>2]|0}else p=c;c=a[m>>2]|0;h=a[c>>2]|0;a[c>>2]=h+1;t[h>>0]=p;h=c+4|0;p=(a[h>>2]|0)+-1|0;a[h>>2]=p;0==(p|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b))}}else a[f>>2]=(a[f>>2]|0)+1;if(a[l>>2]|0){if(a[f>>2]|0){do c=a[m>>2]|0,p=a[c>>2]|0,a[c>>2]=p+1,t[p>>0]=0,p=c+4|0,h=(a[p>>2]|0)+-1|
0,a[p>>2]=h,0==(h|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),c=(a[f>>2]|0)+-1|0,a[f>>2]=c;while(0!=(c|0))}do c=a[m>>2]|0,h=a[c>>2]|0,a[c>>2]=h+1,t[h>>0]=-1,h=c+4|0,p=(a[h>>2]|0)+-1|0,a[h>>2]=p,0==(p|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),c=a[m>>2]|0,p=a[c>>2]|0,a[c>>2]=p+1,t[p>>0]=0,p=c+4|0,h=(a[p>>2]|0)+-1|0,a[p>>2]=h,0==(h|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),c=(a[l>>2]|0)+-1|0,
a[l>>2]=c;while(0!=(c|0))}a[g>>2]=e&255}e=a[n>>2]&524287;a[n>>2]=e;c=(a[d>>2]|0)+8|0;a[d>>2]=c;h=a[k>>2]|0}p=e;if(32768>(h|0))e=h,h=p;else break}}function tk(b,d){b|=0;var c,e,f,g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C,Ra,V,r,w,x,G,L,K,v,fd,O=0,M=0,T=0;d=u;u=u+16|0;c=d;e=b+404|0;f=a[e>>2]|0;g=b+292|0;h=a[g>>2]|0;if(0<(h|0)){m=b+4|0;k=f+8|0;l=0;do n=a[b+296+(l<<2)>>2]|0,p=a[n+12>>2]|0,q=E(p,a[k>>2]|0)|0,y=jg[a[(a[m>>2]|0)+32>>2]&3](b,a[f+64+(a[n+4>>2]<<2)>>2]|0,q,p,0)|0,a[c+(l<<2)>>2]=y,l=l+1|0,y=a[g>>2]|0;while((l|
0)<(y|0));B=y}else B=h;h=f+16|0;l=a[h>>2]|0;m=f+20|0;k=a[m>>2]|0;do if((l|0)<(k|0)){y=f+12|0;p=b+312|0;q=b+424|0;n=f+24|0;H=k;t=a[y>>2]|0;z=a[p>>2]|0;Q=l;a:for(;;){if(t>>>0<z>>>0){for(H=t;;){t=a[g>>2]|0;if(0<(t|0))for(z=C=0;;){Ra=a[b+296+(z<<2)>>2]|0;V=a[Ra+56>>2]|0;r=E(V,H)|0;w=a[Ra+60>>2]|0;if(0<(w|0))for(Ra=a[c+(z<<2)>>2]|0,x=0<(V|0),G=1<(V|0)?V:1,L=C,C=0;;){if(x){K=L;v=(a[Ra+(C+Q<<2)>>2]|0)+(r<<7)|0;for(fd=0;!(a[f+24+(K<<2)>>2]=v,fd=fd+1|0,(fd|0)>=(V|0));)K=K+1|0,v=v+128|0;L=L+G|0}C=C+1|0;if((C|
0)>=(w|0)){Ra=L;break}}else Ra=C;z=z+1|0;if((z|0)>=(t|0))break;else C=Ra}if(!(dd[a[(a[q>>2]|0)+4>>2]&127](b,n)|0)){O=H;M=Q;break a}H=H+1|0;C=a[p>>2]|0;if(H>>>0>=C>>>0){H=C;break}}z=H;H=a[m>>2]|0}a[y>>2]=0;Q=Q+1|0;if((Q|0)>=(H|0)){T=21;break}else t=0}if(21==(T|0))n=a[g>>2]|0;else return a[h>>2]=M,a[y>>2]=O,u=d,0}else n=B;while(0);B=f+8|0;a[B>>2]=(a[B>>2]|0)+1;B=a[e>>2]|0;1>=(n|0)?(e=a[b+296>>2]|0,a[B+20>>2]=(a[B+8>>2]|0)>>>0<((a[b+288>>2]|0)+-1|0)>>>0?a[e+12>>2]:a[e+76>>2]):a[B+20>>2]=1;a[B+12>>2]=
0;a[B+16>>2]=0;u=d;return 1}function oi(b){b|=0;var d,c,e,f,g;d=Aa[a[a[b+4>>2]>>2]&63](b,1,12)|0;a[b+412>>2]=d;a[d>>2]=58;c=b+40|0;switch(a[c>>2]|0){case 1:1!=(a[b+36>>2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=10,R[a[e>>2]&127](b));break;case 6:case 2:3!=(a[b+36>>2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=10,R[a[e>>2]&127](b));break;case 7:case 3:3!=(a[b+36>>2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=10,R[a[e>>2]&127](b));break;case 5:case 4:4!=(a[b+36>>2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=10,R[a[e>>2]&127](b));break;default:1>(a[b+36>>
2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=10,R[a[e>>2]&127](b))}e=b+260|0;f=b+80|0;a:do if(a[e>>2]|0){switch(a[f>>2]|0){case 6:case 2:break a}g=a[b>>2]|0;a[g+20>>2]=28;R[a[g>>2]&127](b)}while(0);g=a[f>>2]|0;switch(g|0){case 1:switch(1!=(a[b+76>>2]|0)&&(g=a[b>>2]|0,a[g+20>>2]=11,R[a[g>>2]&127](b)),a[c>>2]|0){case 7:case 3:case 1:a[d+4>>2]=2;return;case 2:a[d>>2]=59;a[d+4>>2]=3;return;default:g=a[b>>2]|0;a[g+20>>2]=28;R[a[g>>2]&127](b);return}case 6:case 2:3==(a[b+76>>2]|0)?f=g:(g=a[b>>2]|0,a[g+20>>2]=11,R[a[g>>
2]&127](b),f=a[f>>2]|0);if((a[c>>2]|0)!=(f|0)){f=a[b>>2]|0;a[f+20>>2]=28;R[a[f>>2]&127](b);break}switch(a[e>>2]|0){case 0:a[d+4>>2]=4;return;case 1:a[d+4>>2]=5;return;default:e=a[b>>2]|0;a[e+20>>2]=28;R[a[e>>2]&127](b);return}case 3:switch(3!=(a[b+76>>2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=11,R[a[e>>2]&127](b)),a[c>>2]|0){case 2:a[d>>2]=59;a[d+4>>2]=6;return;case 3:a[d+4>>2]=7;return;default:e=a[b>>2]|0;a[e+20>>2]=28;R[a[e>>2]&127](b);return}case 7:3!=(a[b+76>>2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=11,R[a[e>>2]&
127](b));switch(a[c>>2]|0){case 2:e=a[b+84>>2]|0;a[e+140>>2]=1;a[e+228>>2]=1;a[d>>2]=59;a[d+4>>2]=6;return;case 3:e=a[b+84>>2]|0;a[e+140>>2]=1;a[e+228>>2]=1;break;case 7:break;default:e=a[b>>2]|0;a[e+20>>2]=28;R[a[e>>2]&127](b);return}a[d+4>>2]=7;break;case 4:4!=(a[b+76>>2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=11,R[a[e>>2]&127](b));4==(a[c>>2]|0)?a[d+4>>2]=7:(e=a[b>>2]|0,a[e+20>>2]=28,R[a[e>>2]&127](b));break;case 5:switch(4!=(a[b+76>>2]|0)&&(e=a[b>>2]|0,a[e+20>>2]=11,R[a[e>>2]&127](b)),a[c>>2]|0){case 4:a[d>>
2]=59;a[d+4>>2]=8;return;case 5:a[d+4>>2]=7;return;default:e=a[b>>2]|0;a[e+20>>2]=28;R[a[e>>2]&127](b);return}default:if((g|0)!=(a[c>>2]|0)||(a[b+76>>2]|0)!=(a[b+36>>2]|0))c=a[b>>2]|0,a[c+20>>2]=28,R[a[c>>2]&127](b);a[d+4>>2]=7}}function Xh(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,y,B;f=u;u=u+1296|0;g=f+1028|0;3<c>>>0&&(h=a[b>>2]|0,a[h+20>>2]=52,a[h+24>>2]=c,R[a[h>>2]&127](b));h=0!=(d|0);d=a[(h?b+120+(c<<2)|0:b+136+(c<<2)|0)>>2]|0;d||(m=a[b>>2]|0,a[m+20>>2]=52,a[m+24>>2]=c,R[a[m>>2]&127](b));
(m=a[e>>2]|0)?(k=b,l=m):(c=Aa[a[a[b+4>>2]>>2]&63](b,1,1280)|0,a[e>>2]=c,k=b,l=c);m=1;for(c=0;;)if(e=t[d+m>>0]|0,n=e&255,p=n+c|0,256<(p|0)&&(q=a[b>>2]|0,a[q+20>>2]=9,R[a[q>>2]&127](k)),e<<24>>24?(Va(g+c|0,m&255|0,n|0)|0,y=p):y=c,m=m+1|0,17==(m|0)){B=y;break}else c=y;t[g+B>>0]=0;y=t[g>>0]|0;if(y<<24>>24)for(c=y,p=m=0,n=y<<24>>24;;){if((c<<24>>24|0)==(n|0))for(y=m,e=p;;)if(q=e+1|0,a[f+(e<<2)>>2]=y,p=y+1|0,e=t[g+q>>0]|0,(e<<24>>24|0)==(n|0))y=p,e=q;else{c=e;m=p;break}else q=p;(m|0)>=(1<<n|0)&&(e=a[b>>
2]|0,a[e+20>>2]=9,R[a[e>>2]&127](k));if(c<<24>>24)m<<=1,p=q,n=n+1|0;else break}Va(l+1024|0,0,256)|0;n=h?15:255;if(0<(B|0)){e=0;do h=x[d+17+e>>0]|0,q=l+1024+h|0,h>>>0<=n>>>0&&0==(t[q>>0]|0)||(p=a[b>>2]|0,a[p+20>>2]=9,R[a[p>>2]&127](k)),a[l+(h<<2)>>2]=a[f+(e<<2)>>2],t[q>>0]=t[g+e>>0]|0,e=e+1|0;while((e|0)!=(B|0))}u=f}function gi(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n=0,p,q,y,B,H,ka,z,Q,C,u;c=b+128|0;if(e=a[c>>2]|0){f=0;for(g=e;;)if(g>>=1)f=f+1|0;else{h=f;break}14<(h|0)&&(f=a[b+120>>2]|0,g=a[f>>2]|0,a[g+
20>>2]=41,R[a[g>>2]&127](f));f=a[b+124>>2]|0;g=h<<4;e=b+108|0;do if(a[e>>2]|0)H=(a[b+92+(f<<2)>>2]|0)+(g<<2)|0,a[H>>2]=(a[H>>2]|0)+1;else if(m=a[b+60+(f<<2)>>2]|0,k=a[m+(g<<2)>>2]|0,l=t[m+1024+g>>0]|0,m=l<<24>>24,0!=l<<24>>24||(l=a[b+120>>2]|0,n=a[l>>2]|0,a[n+20>>2]=41,R[a[n>>2]&127](l),0==(a[e>>2]|0))){l=b+16|0;n=(a[l>>2]|0)+m|0;p=b+12|0;q=((1<<m)+-1&k)<<24-n|a[p>>2];if(7<(n|0)){k=b+112|0;m=b+116|0;y=b+120|0;B=n;for(H=q;;)if(ka=H>>>16,z=ka&255,Q=a[k>>2]|0,a[k>>2]=Q+1,t[Q>>0]=ka,ka=(a[m>>2]|0)+-1|
0,a[m>>2]=ka,ka||(ka=a[y>>2]|0,Q=a[ka+24>>2]|0,da[a[Q+12>>2]&63](ka)|0||(ka=a[y>>2]|0,C=a[ka>>2]|0,a[C+20>>2]=25,R[a[C>>2]&127](ka)),a[k>>2]=a[Q>>2],a[m>>2]=a[Q+4>>2]),255==(z|0)&&(z=a[k>>2]|0,a[k>>2]=z+1,t[z>>0]=0,z=(a[m>>2]|0)+-1|0,a[m>>2]=z,0==(z|0))&&(z=a[y>>2]|0,Q=a[z+24>>2]|0,da[a[Q+12>>2]&63](z)|0||(z=a[y>>2]|0,ka=a[z>>2]|0,a[ka+20>>2]=25,R[a[ka>>2]&127](z)),a[k>>2]=a[Q>>2],a[m>>2]=a[Q+4>>2]),Q=H<<8,B=B+-8|0,7>=(B|0)){ka=Q;break}else H=Q;u=n&7;q=ka}else u=n;a[p>>2]=q;a[l>>2]=u}while(0);if(0!=
(h|0)&&0==(a[e>>2]|0)){g=b+16|0;f=(a[g>>2]|0)+h|0;u=b+12|0;q=(a[c>>2]&(1<<h)+-1)<<24-f|a[u>>2];if(7<(f|0)){h=b+112|0;ka=b+116|0;H=b+120|0;B=f;for(m=q;!(k=m>>>16,y=k&255,Q=a[h>>2]|0,a[h>>2]=Q+1,t[Q>>0]=k,k=(a[ka>>2]|0)+-1|0,a[ka>>2]=k,k||(k=a[H>>2]|0,Q=a[k+24>>2]|0,da[a[Q+12>>2]&63](k)|0||(k=a[H>>2]|0,z=a[k>>2]|0,a[z+20>>2]=25,R[a[z>>2]&127](k)),a[h>>2]=a[Q>>2],a[ka>>2]=a[Q+4>>2]),255==(y|0)&&(y=a[h>>2]|0,a[h>>2]=y+1,t[y>>0]=0,y=(a[ka>>2]|0)+-1|0,a[ka>>2]=y,0==(y|0))&&(y=a[H>>2]|0,Q=a[y+24>>2]|0,da[a[Q+
12>>2]&63](y)|0||(y=a[H>>2]|0,k=a[y>>2]|0,a[k+20>>2]=25,R[a[k>>2]&127](y)),a[h>>2]=a[Q>>2],a[ka>>2]=a[Q+4>>2]),Q=m<<8,B=B+-8|0,7>=(B|0));)m=Q;l=f&7;p=Q}else l=f,p=q;a[u>>2]=p;a[g>>2]=l}a[c>>2]=0;l=b+132|0;g=a[l>>2]|0;a:do if(0!=(g|0)&0==(a[e>>2]|0))for(p=b+16|0,u=b+12|0,q=b+112|0,f=b+116|0,n=b+120|0,m=g,B=a[b+136>>2]|0,ka=0;;){if(!ka){h=a[p>>2]|0;H=h+1|0;Q=((x[B>>0]|0)&1)<<23-h|a[u>>2];if(7<(H|0)){h=H;for(y=Q;;)if(k=y>>>16,z=k&255,ka=a[q>>2]|0,a[q>>2]=ka+1,t[ka>>0]=k,k=(a[f>>2]|0)+-1|0,a[f>>2]=k,
k||(k=a[n>>2]|0,ka=a[k+24>>2]|0,da[a[ka+12>>2]&63](k)|0||(k=a[n>>2]|0,C=a[k>>2]|0,a[C+20>>2]=25,R[a[C>>2]&127](k)),a[q>>2]=a[ka>>2],a[f>>2]=a[ka+4>>2]),255==(z|0)&&(z=a[q>>2]|0,a[q>>2]=z+1,t[z>>0]=0,z=(a[f>>2]|0)+-1|0,a[f>>2]=z,0==(z|0))&&(z=a[n>>2]|0,ka=a[z+24>>2]|0,da[a[ka+12>>2]&63](z)|0||(z=a[n>>2]|0,k=a[z>>2]|0,a[k+20>>2]=25,R[a[k>>2]&127](z)),a[q>>2]=a[ka>>2],a[f>>2]=a[ka+4>>2]),ka=y<<8,h=h+-8|0,7>=(h|0)){h=ka;break}else y=ka;g=H&7}else g=H,h=Q;a[u>>2]=h;a[p>>2]=g}y=m+-1|0;if(!y)break a;m=y;
B=B+1|0;ka=a[e>>2]|0}while(0);a[l>>2]=0;f=e}else f=b+108|0;a[f>>2]|0||(Yh(b),f=b+112|0,e=a[f>>2]|0,a[f>>2]=e+1,t[e>>0]=-1,e=b+116|0,l=(a[e>>2]|0)+-1|0,(a[e>>2]=l)?m=a[f>>2]|0:(l=b+120|0,g=a[l>>2]|0,h=a[g+24>>2]|0,da[a[h+12>>2]&63](g)|0||(g=a[l>>2]|0,l=a[g>>2]|0,a[l+20>>2]=25,R[a[l>>2]&127](g)),g=a[h>>2]|0,a[f>>2]=g,a[e>>2]=a[h+4>>2],m=g),a[f>>2]=m+1,t[m>>0]=d+208,d=(a[e>>2]|0)+-1|0,a[e>>2]=d,d||(d=b+120|0,m=a[d>>2]|0,g=a[m+24>>2]|0,da[a[g+12>>2]&63](m)|0||(m=a[d>>2]|0,d=a[m>>2]|0,a[d+20>>2]=25,R[a[d>>
2]&127](m)),a[f>>2]=a[g>>2],a[e>>2]=a[g+4>>2]));g=b+120|0;e=a[g>>2]|0;if(a[e+364>>2]|0)a[c>>2]=0,a[b+132>>2]=0;else if(0<(a[e+292>>2]|0)){c=0;do a[b+20+(c<<2)>>2]=0,c=c+1|0;while((c|0)<(a[(a[g>>2]|0)+292>>2]|0))}}function Yh(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p;if(a[b+108>>2]|0)a[(b+12|0)>>2]=0,a[(b+16|0)>>2]=0;else{d=b+16|0;c=a[d>>2]|0;e=c+7|0;f=b+12|0;g=127<<17-c|a[f>>2];if(7<(e|0)){c=b+112|0;h=b+116|0;m=b+120|0;b=e;for(k=g;!(l=k>>>16,n=l&255,g=a[c>>2]|0,a[c>>2]=g+1,t[g>>0]=l,l=(a[h>>2]|0)+-1|0,a[h>>
2]=l,l||(l=a[m>>2]|0,g=a[l+24>>2]|0,da[a[g+12>>2]&63](l)|0||(l=a[m>>2]|0,p=a[l>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](l)),a[c>>2]=a[g>>2],a[h>>2]=a[g+4>>2]),255==(n|0)&&(n=a[c>>2]|0,a[c>>2]=n+1,t[n>>0]=0,n=(a[h>>2]|0)+-1|0,a[h>>2]=n,0==(n|0))&&(n=a[m>>2]|0,g=a[n+24>>2]|0,da[a[g+12>>2]&63](n)|0||(n=a[m>>2]|0,l=a[n>>2]|0,a[l+20>>2]=25,R[a[l>>2]&127](n)),a[c>>2]=a[g>>2],a[h>>2]=a[g+4>>2]),g=k<<8,b=b+-8|0,7>=(b|0));)k=g;b=e&7}else b=e;c=g;a[f>>2]=c;a[d>>2]=b;a[f>>2]=0;a[d>>2]=0}}function pi(b,d,c){b|=0;d|=
0;c|=0;var e,f,g,h,m,k,l,n,p,q;e=u;u=u+2096|0;f=e+2056|0;g=e+1028|0;h=e;m=f;k=m+33|0;do t[m>>0]=0,m=m+1|0;while((m|0)<(k|0));Va(g|0,0,1028)|0;Va(h|0,-1,1028)|0;a[c+1024>>2]=1;k=-1;l=0;m=1E9;a:for(;;)if(257>(l|0))n=a[c+(l<<2)>>2]|0,k=(p=0==(n|0)|(n|0)>(m|0))?k:l,l=l+1|0,m=p?m:n;else{m=-1;l=0;for(q=1E9;;)if(n=a[c+(l<<2)>>2]|0,m=(p=(l|0)==(k|0)|0==(n|0)|(n|0)>(q|0))?m:l,l=l+1|0,257==(l|0)){q=m;break}else q=p?q:n;if(0>(q|0))break;n=c+(q<<2)|0;p=c+(k<<2)|0;a[p>>2]=(a[p>>2]|0)+(a[n>>2]|0);a[n>>2]=0;n=g+
(k<<2)|0;a[n>>2]=(a[n>>2]|0)+1;n=h+(k<<2)|0;p=a[n>>2]|0;if(-1<(p|0)){m=p;do p=g+(m<<2)|0,a[p>>2]=(a[p>>2]|0)+1,p=h+(m<<2)|0,m=a[p>>2]|0;while(-1<(m|0));k=p}else k=n;a[k>>2]=q;m=g+(q<<2)|0;a[m>>2]=(a[m>>2]|0)+1;m=a[h+(q<<2)>>2]|0;if(-1<(m|0))for(n=m;;)if(m=g+(n<<2)|0,a[m>>2]=(a[m>>2]|0)+1,m=a[h+(n<<2)>>2]|0,-1<(m|0))n=m;else{k=-1;l=0;m=1E9;continue a}else k=-1,l=0,m=1E9}m=0;do{if(l=a[g+(m<<2)>>2]|0)32<(l|0)&&(k=a[b>>2]|0,a[k+20>>2]=40,R[a[k>>2]&127](b)),k=f+l|0,t[k>>0]=(t[k>>0]|0)+1<<24>>24;m=m+1|
0}while(257!=(m|0));for(h=32;;){m=f+h|0;b=t[m>>0]|0;if(b<<24>>24){k=h+-2|0;l=h+-1|0;n=f+l|0;h=b;do{for(b=k;;)if(q=f+b|0,t[q>>0]|0){c=q;break}else b=b+-1|0;t[m>>0]=(h&255)+254;t[n>>0]=(t[n>>0]|0)+1<<24>>24;b=f+(b+1)|0;t[b>>0]=(x[b>>0]|0)+2;t[c>>0]=(t[c>>0]|0)+-1<<24>>24;h=t[m>>0]|0}while(0!=h<<24>>24);b=l}else b=h+-1|0;if(16<(b|0))h=b;else{c=16;break}}for(;!(b=f+c|0,h=t[b>>0]|0,h<<24>>24);)c=c+-1|0;t[b>>0]=h+-1<<24>>24;m=d;b=f;k=m+17|0;do t[m>>0]=t[b>>0]|0,m=m+1|0,b=b+1|0;while((m|0)<(k|0));b=1;for(m=
0;;){k=0;for(f=m;;)if((a[g+(k<<2)>>2]|0)==(b|0)&&(t[d+17+f>>0]=k,f=f+1|0),k=k+1|0,256==(k|0)){h=f;break}f=b+1|0;if(33==(f|0))break;else b=f,m=h}a[d+276>>2]=0;u=e}function hi(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p;d=a[b+468>>2]|0;da[a[(a[b+464>>2]|0)+8>>2]&63](b)|0||(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));c=b+340|0;if(!(0>=(a[c>>2]|0))){e=b+224|0;f=b+436|0;g=b+412|0;h=b+420|0;m=0;do{k=a[b+344+(m<<2)>>2]|0;l=a[e>>2]|0?a[g>>2]|0?11:a[h>>2]|0?10:8:8;if(8==(l|0)){l=0;n=a[d+60+(a[k+20>>2]<<2)>>2]|0;p=
n+64|0;do t[n>>0]=0,n=n+1|0;while((n|0)<(p|0));a[d+24+(m<<2)>>2]=0;a[d+40+(m<<2)>>2]=0;a[e>>2]|0?l=10:a[f>>2]|0&&(l=11)}10==(l|0)&&(l=0,0!=(a[g>>2]|0))&&(l=11);11==(l|0)&&Va(a[d+124+(a[k+24>>2]<<2)>>2]|0,0,256)|0;m=m+1|0}while((m|0)<(a[c>>2]|0))}a[(d+12|0)>>2]=0;a[(d+16|0)>>2]=0;a[(d+20|0)>>2]=-16;a[(d+56|0)>>2]=a[(b+280|0)>>2]|0}function Cc(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n;c=a[b+468>>2]|0;e=c+16|0;f=a[e>>2]|0;g=c+20|0;if(32768>(f|0))for(f=b+440|0,h=b+24|0,m=c+12|0,k=a[g>>2]|0;;){c=k+-1|0;a[g>>
2]=c;if(1>(k|0)){a:do if(a[f>>2]|0)k=0;else if(k=a[h>>2]|0,l=k+4|0,0==(a[l>>2]|0)&&0==(da[a[k+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),a[l>>2]=(a[l>>2]|0)+-1,l=a[k>>2]|0,a[k>>2]=l+1,k=t[l>>0]|0,l=k&255,-1==k<<24>>24){b:for(;;)switch(k=a[h>>2]|0,c=k+4|0,0==(a[c>>2]|0)&&0==(da[a[k+12>>2]&63](b)|0)&&(l=a[b>>2]|0,a[l+20>>2]=25,R[a[l>>2]&127](b)),a[c>>2]=(a[c>>2]|0)+-1,c=a[k>>2]|0,a[k>>2]=c+1,k=x[c>>0]|0,k|0){case 0:k=255;break a;case 255:break;default:break b}a[f>>2]=k;k=0}else k=
l;while(0);a[m>>2]=a[m>>2]<<8|k;k=a[g>>2]|0;c=k+8|0;a[g>>2]=c;-8>(k|0)?(l=k+9|0,(a[g>>2]=l)?k=l:(a[e>>2]=32768,k=0)):k=c}else k=c;c=a[e>>2]<<1;a[e>>2]=c;if(!(32768>(c|0))){h=c;l=m;n=k;break}}else h=f,l=c+12|0,n=a[g>>2]|0;g=x[d>>0]|0;c=a[122136+((g&127)<<2)>>2]|0;f=c>>8;k=c>>16;m=h-k|0;a[e>>2]=m;h=m<<n;n=a[l>>2]|0;if((n|0)>=(h|0))return a[l>>2]=n-h,a[e>>2]=k,e=g&128,(m|0)<(k|0)?(t[d>>0]=e^f,e=g>>7):(t[d>>0]=e^c,e=(g^128)>>7),e|0;if(32768<=(m|0))return g>>7|0;e=g&128;(m|0)<(k|0)?(t[d>>0]=e^c,e=(g^128)>>
7):(t[d>>0]=e^f,e=g>>7);return e|0}function Eg(a){a|=0;return(32==(a|0)|5>(a+-9|0)>>>0)&1|0}function md(){var b;if(!(a[30648]|0))return 122848;b=(Wj()|0)+60|0;return a[b>>2]|0}function uk(a){a|=0;var d,c=0,e=0,f=0,g=0;for(d=0;;){if((x[161247+d>>0]|0)==(a|0)){c=d;e=2;break}d=d+1|0;if(87==(d|0)){f=87;g=161335;break}}if(2==(e|0))if(c)f=c,g=161335;else return 161335;for(;;){for(c=g;;)if(e=c+1|0,t[c>>0]|0)c=e;else{a=e;break}if(f=f+-1|0)g=a;else break}return a|0}function Ki(b,d,c){b|=0;d|=0;c|=0;var e=
0,f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0,z=0,Q=0,C=0,Ra=0,V=0,r=0,w=0,I=0,G=0,L=0,K=0,v=0,fd=0,O=0,M=0,T=0,X=0,P=0,A=0,D=0,N=0,ba=0,F=0,R=0,S=0,ga=0,Ha=0,ma=0,Y=0,ha=0,W=0,da=0,pc=0,Z=0,ca=0,fa=0,oa=0,sa=0,aa=0,ua=0,Ia=0,Da=0,na=0,Na=0,ja=0,Ca=0,Ga=0,Ea=0,La=0,ya=0,ra=0,Aa=0,pa=0,xb=0,Zb=0,Wa=0,jb=0,mc=0,Ka=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,Qa=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=
0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Va=0,Ua=0,eb=0,Jb=0,ub=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,Ab=0,ab=0,nd=0,Zd=0,wb=0,pb=0,Qd=0,zb=0,Ob=0,Tb=0,Hb=0,rb=0,Wb=0,fb=0,Gb=0,lb=0,Kb=0,Lb=0,ac=0,Yb=0,kc=0,hc=0,Pb=0,Sb=0,kd=0,fc=0,jc=0,Vb=0,zc=0,yc=0,oc=0,db=0,$b=0,Ie=0,ic=0,Wd=0,Jd=0,bd=0,ec=0,Rc=0,lc=0,Be=0,Ec=0,Gc=0,nc=0,Lc=0,Bc=0,hd=0,Bd=0,Hc=0,Rb=0,od=0,tc=0,Xb=0,rc=0,ed=0,gd=0,Cc=0,vc=0,Fc=0,Qc=0,xc=0,Yc=0,wc=0,id=0,dc=0,Ac=0,Sc=0,Tc=0,Wc=0,Uc=0,Ce=0,vd=0,wd=0,Vc=0,Nf=0,Pc=0,ug=0,rd=0,ad=0,dd=0,Xc=0,ce=0,oe=0,qd=0,
ld=0,Df=0,sd=0,$c=0,cd=0,td=0,he=0,e=u;u=u+512|0;f=e;switch(d|0){case 0:g=24;h=-149;break;case 1:g=53;h=-1074;break;case 2:g=53;h=-1074;break;default:return m=0,u=e,+m}d=b+4|0;k=b+100|0;do l=a[d>>2]|0,l>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=l+1,n=x[l>>0]|0):n=Jc(b)|0;while(0!=(Eg(n)|0));p=n;a:do switch(p|0){case 43:case 45:n=1-((45==(p|0)&1)<<1)|0;l=a[d>>2]|0;l>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=l+1,q=x[l>>0]|0):q=Jc(b)|0;y=n;break a;default:q=p,y=1}while(0);p=q;for(q=0;;){if((p|32)!=(t[163139+q>>0]|0)){B=p;H=q;
break}7>q>>>0?(n=a[d>>2]|0,n>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=n+1,ka=x[n>>0]|0):ka=Jc(b)|0):ka=p;n=q+1|0;if(8>n>>>0)p=ka,q=n;else{B=ka;H=n;break}}a:do switch(H|0){case 8:break;case 3:z=23;break;default:ka=0!=(c|0);if(ka&3<H>>>0){8!=(H|0)&&(z=23);break a}do if(!H){if(110==(B|32)){q=a[d>>2]|0;q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+1,Q=x[q>>0]|0):Q=Jc(b)|0;if(97!=(Q|32))break;q=a[d>>2]|0;q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+1,C=x[q>>0]|0):C=Jc(b)|0;if(110!=(C|32))break;q=a[d>>2]|0;q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+
1,Ra=x[q>>0]|0):Ra=Jc(b)|0;if(40==(Ra|0))V=1;else{if(!(a[k>>2]|0))return m=Eh,u=e,+m;a[d>>2]=(a[d>>2]|0)+-1;m=Eh;u=e;return+m}for(;;){q=a[d>>2]|0;q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+1,r=x[q>>0]|0):r=Jc(b)|0;if(10>(r+-48|0)>>>0|26>(r+-65|0)>>>0?0:!(95==(r|0)|26>(r+-97|0)>>>0)){w=r;I=V;break}V=V+1|0}if(41==(w|0))return m=Eh,u=e,+m;(q=0==(a[k>>2]|0))||(a[d>>2]=(a[d>>2]|0)+-1);if(!ka)return p=md()|0,a[p>>2]=22,Sf(b,0),m=0,u=e,+m;if(I)G=I;else return m=Eh,u=e,+m;do G=G+-1|0,q||(a[d>>2]=(a[d>>2]|0)+-1);while(0!=
(G|0));m=Eh;u=e;return+m}do if(48==(B|0))if(q=a[d>>2]|0,q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+1,L=x[q>>0]|0):L=Jc(b)|0,120!=(L|32))a[k>>2]|0&&(a[d>>2]=(a[d>>2]|0)+-1),K=48;else{q=a[d>>2]|0;q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+1,v=x[q>>0]|0):v=Jc(b)|0;fd=0;b:for(;;){switch(v|0){case 46:O=fd;z=72;break b;case 48:break;default:P=X=T=M=0;A=v;D=fd;ba=N=0;F=1;S=R=0;break b}q=a[d>>2]|0;q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+1,v=x[q>>0]|0):v=Jc(b)|0;fd=1}if(72==(z|0))if(q=a[d>>2]|0,q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+1,ga=
x[q>>0]|0):ga=Jc(b)|0,48==(ga|0))for(p=q=0;;)if(n=a[d>>2]|0,n>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=n+1,Ha=x[n>>0]|0):Ha=Jc(b)|0,n=Qb(q|0,p|0,-1,-1)|0,l=U,48==(Ha|0))q=n,p=l;else{T=M=0;X=n;P=l;A=Ha;N=D=1;ba=0;F=1;S=R=0;break}else P=X=T=M=0,A=ga,D=O,N=1,ba=0,F=1,S=R=0;for(;;){p=A+-48|0;q=A|32;if(10<=p>>>0){l=46==(A|0);if(!(l|6>(q+-97|0)>>>0)){ma=T;Y=X;ha=M;W=P;da=A;pc=D;Z=N;ca=R;fa=S;break}if(l)if(N){ma=T;Y=X;ha=M;W=P;da=46;pc=D;Z=N;ca=R;fa=S;break}else oa=T,sa=M,aa=T,ua=M,Ia=D,Da=1,na=ba,Na=F,ja=R,Ca=S;else z=
84}else z=84;84==(z|0)&&(z=0,l=57<(A|0)?q+-87|0:p,0>(M|0)|0==(M|0)&8>T>>>0?(Ea=ba,La=F,ya=l+(R<<4)|0,ra=S):0>(M|0)|0==(M|0)&14>T>>>0?(Ga=.0625*F,Ea=ba,La=Ga,ya=R,ra=S+Ga*+(l|0)):0!=(ba|0)|0==(l|0)?(Ea=ba,La=F,ya=R,ra=S):(Ea=1,La=F,ya=R,ra=S+.5*F),l=Qb(T|0,M|0,1,0)|0,oa=X,sa=P,aa=l,ua=U,Ia=1,Da=N,na=Ea,Na=La,ja=ya,Ca=ra);l=a[d>>2]|0;l>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=l+1,M=ua,T=aa,X=oa,P=sa,A=x[l>>0]|0):(M=ua,T=aa,X=oa,P=sa,A=Jc(b)|0);D=Ia;N=Da;ba=na;F=Na;R=ja;S=Ca}if(!pc){(l=0==(a[k>>2]|0))||(a[d>>2]=
(a[d>>2]|0)+-1);if(c){if(l?0:(l=a[d>>2]|0,a[d>>2]=l+-1,0!=(Z|0)))a[d>>2]=l+-2}else Sf(b,0);m=0*+(y|0);u=e;return+m}p=(l=0==(Z|0))?ma:Y;q=l?ha:W;if(0>(ha|0)|0==(ha|0)&8>ma>>>0)for(l=ma,n=ha,Aa=ca;;)if(pa=Aa<<4,l=Qb(l|0,n|0,1,0)|0,n=U,0>(n|0)|0==(n|0)&8>l>>>0)Aa=pa;else{xb=pa;break}else xb=ca;if(112==(da|32))if(Aa=Lk(b,c)|0,l=U,0==(Aa|0)&-2147483648==(l|0))if(c)a[k>>2]|0&&(a[d>>2]=(a[d>>2]|0)+-1),Wa=Zb=0;else return Sf(b,0),m=0,u=e,+m;else Zb=Aa,Wa=l;else a[k>>2]|0&&(a[d>>2]=(a[d>>2]|0)+-1),Wa=Zb=0;
l=Oc(p|0,q|0,2)|0;Aa=Qb(l|0,U|0,-32,-1)|0;l=Qb(Aa|0,U|0,Zb|0,Wa|0)|0;Aa=U;if(!xb)return m=0*+(y|0),u=e,+m;if(0<(Aa|0)|0==(Aa|0)&l>>>0>(0-h|0)>>>0)return n=md()|0,a[n>>2]=34,m=Infinity*+(y|0),u=e,+m;n=h+-106|0;pa=(0>(n|0))<<31>>31;if((Aa|0)<(pa|0)|(Aa|0)==(pa|0)&l>>>0<n>>>0)return n=md()|0,a[n>>2]=34,m=0*+(y|0),u=e,+m;if(-1<(xb|0))for(n=l,pa=Aa,jb=xb,Ga=fa;;)if(mc=!(.5<=Ga),Ka=mc&1|jb<<1,Ta=Ka^1,Ya=Ga+(mc?Ga:Ga+-1),mc=Qb(n|0,pa|0,-1,-1)|0,Sa=U,-1<(Ka|0))n=mc,pa=Sa,jb=Ta,Ga=Ya;else{mb=mc;Db=Sa;cc=Ta;
Za=Ya;break}else mb=l,Db=Aa,cc=xb,Za=fa;jb=Ic(32,0,h|0,(0>(h|0))<<31>>31|0)|0;pa=Qb(mb|0,Db|0,jb|0,U|0)|0;jb=U;0>(jb|0)|0==(jb|0)&g>>>0>pa>>>0?0>(pa|0)?(ia=0,z=125):(qa=pa,z=123):(qa=g,z=123);123==(z|0)&&(53>(qa|0)?(ia=qa,z=125):(Ja=qa,ea=+(y|0),wa=0));if(125==(z|0))var Ga=+(y|0),Ja=ia,ea=Ga,te=+ii(1,84-ia|0),wa=+ + +ch(+te,+Ga);pa=0==(cc&1|0)&0!=Za&32>(Ja|0);Ga=ea*(pa?0:Za)+(wa+ea*+(((pa&1)+cc|0)>>>0))-wa;0==Ga&&(pa=md()|0,a[pa>>2]=34);m=+ + +ii(+Ga,mb|0);u=e;return+m}else K=B;while(0);pa=h+g|0;
jb=0-pa|0;n=K;q=0;b:for(;;){switch(n|0){case 46:Ma=q;z=136;break b;case 48:break;default:xa=n;la=$a=0;Ba=q;va=0;break b}p=a[d>>2]|0;p>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=p+1,n=x[p>>0]|0):n=Jc(b)|0;q=1}if(136==(z|0))if(q=a[d>>2]|0,q>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=q+1,za=x[q>>0]|0):za=Jc(b)|0,48==(za|0))for(n=q=0;;)if(p=Qb(q|0,n|0,-1,-1)|0,Ta=U,Sa=a[d>>2]|0,Sa>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=Sa+1,ta=x[Sa>>0]|0):ta=Jc(b)|0,48==(ta|0))q=p,n=Ta;else{xa=ta;$a=p;la=Ta;va=Ba=1;break}else xa=za,la=$a=0,Ba=Ma,va=1;a[f>>
2]=0;n=xa+-48|0;q=46==(xa|0);b:do if(q|10>n>>>0){Ta=f+496|0;p=xa;mc=Sa=0;Ka=q;nb=n;sc=$a;gb=la;hb=Ba;ob=va;kb=qb=Bb=0;c:for(;;){do if(Ka)if(ob){tb=sc;bb=gb;Ib=Sa;Mb=mc;Va=hb;Ua=Bb;eb=qb;Jb=kb;break c}else ib=Sa,Cb=mc,Qa=Sa,sb=mc,Xa=hb,Fa=1,Pa=Bb,Eb=qb,vb=kb;else ub=Qb(Sa|0,mc|0,1,0)|0,yb=U,cb=48!=(p|0),125<=(qb|0)?(cb&&(a[Ta>>2]|=1),ib=sc,Cb=gb,Qa=ub,sb=yb,Xa=hb,Fa=ob,Pa=Bb,Eb=qb,vb=kb):(gc=f+(qb<<2)|0,Ub=Bb?p+-48+(10*(a[gc>>2]|0)|0)|0:nb,a[gc>>2]=Ub,gc=Bb+1|0,Fb=9==(gc|0),ib=sc,Cb=gb,Qa=ub,sb=yb,
Xa=1,Fa=ob,Pa=Fb?0:gc,Eb=(Fb&1)+qb|0,vb=cb?ub:kb);while(0);ub=a[d>>2]|0;ub>>>0<(a[k>>2]|0)>>>0?(a[d>>2]=ub+1,Ab=x[ub>>0]|0):Ab=Jc(b)|0;nb=Ab+-48|0;Ka=46==(Ab|0);if(Ka|10>nb>>>0)p=Ab,Sa=Qa,mc=sb,sc=ib,gb=Cb,hb=Xa,ob=Fa,Bb=Pa,qb=Eb,kb=vb;else{ab=Ab;nd=Qa;Zd=ib;wb=sb;pb=Cb;Qd=Xa;zb=Fa;Ob=Pa;Tb=Eb;Hb=vb;z=159;break b}}rb=Ib;Wb=Mb;fb=tb;Gb=bb;lb=0!=(Va|0);Kb=Ua;Lb=eb;ac=Jb;z=167}else ab=xa,nd=0,Zd=$a,wb=0,pb=la,Qd=Ba,zb=va,Hb=Tb=Ob=0,z=159;while(0);do if(159==(z|0))if(q=(n=0==(zb|0))?nd:Zd,kb=n?wb:pb,
n=0!=(Qd|0),101==(ab|32)&n){n=Lk(b,c)|0;qb=U;if(0==(n|0)&-2147483648==(qb|0)){if(!c){Sf(b,0);Vb=0;break}a[k>>2]|0&&(a[d>>2]=(a[d>>2]|0)+-1);yc=zc=0}else zc=n,yc=qb;oc=qb=Qb(zc|0,yc|0,q|0,kb|0)|0;db=nd;$b=U;Ie=wb;ic=Ob;Wd=Tb;Jd=Hb;z=171}else-1<(ab|0)?(rb=nd,Wb=wb,fb=q,Gb=kb,lb=n,Kb=Ob,Lb=Tb,ac=Hb,z=167):(Yb=nd,kc=wb,hc=n,Pb=q,Sb=kb,kd=Ob,fc=Tb,jc=Hb,z=169);while(0);167==(z|0)&&(a[k>>2]|0?(a[d>>2]=(a[d>>2]|0)+-1,lb?(oc=fb,db=rb,$b=Gb,Ie=Wb,ic=Kb,Wd=Lb,Jd=ac,z=171):z=170):(Yb=rb,kc=Wb,hc=lb,Pb=fb,Sb=
Gb,kd=Kb,fc=Lb,jc=ac,z=169));169==(z|0)&&(hc?(oc=Pb,db=Yb,$b=Sb,Ie=kc,ic=kd,Wd=fc,Jd=jc,z=171):z=170);do if(170==(z|0))qb=md()|0,a[qb>>2]=22,Sf(b,0),Vb=0;else if(171==(z|0))if(qb=a[f>>2]|0)if((0>(Ie|0)|0==(Ie|0)&10>db>>>0)&(oc|0)==(db|0)&($b|0)==(Ie|0)&&30<g>>>0|0==(qb>>>g|0))Vb=+(y|0)*+(qb>>>0);else if(qb=(h|0)/-2|0,kb=(0>(qb|0))<<31>>31,($b|0)>(kb|0)|($b|0)==(kb|0)&oc>>>0>qb>>>0)qb=md()|0,a[qb>>2]=34,Vb=Infinity*+(y|0);else if(qb=h+-106|0,kb=(0>(qb|0))<<31>>31,($b|0)<(kb|0)|($b|0)==(kb|0)&oc>>>
0<qb>>>0)qb=md()|0,a[qb>>2]=34,Vb=0*+(y|0);else{if(ic){if(9>(ic|0)){qb=f+(Wd<<2)|0;kb=a[qb>>2]|0;for(q=ic;;)if(n=10*kb|0,q=q+1|0,9==(q|0)){ec=n;break}else kb=n;a[qb>>2]=ec}bd=Wd+1|0}else bd=Wd;if(9>(Jd|0)&&(Jd|0)<=(oc|0)&18>(oc|0)){if(9==(oc|0)){Vb=+(y|0)*+((a[f>>2]|0)>>>0);break}if(9>(oc|0)){Vb=+(y|0)*+((a[f>>2]|0)>>>0)/+(a[122852+(8-oc<<2)>>2]|0);break}kb=g+27+(E(oc,-3)|0)|0;q=a[f>>2]|0;if(30<(kb|0)|0==(q>>>kb|0)){Vb=+(y|0)*+(q>>>0)*+(a[122852+(oc+-10<<2)>>2]|0);break}}if(q=(oc|0)%9|0){kb=-1<(oc|
0)?q:q+9|0;q=a[122852+(8-kb<<2)>>2]|0;if(bd){n=1E9/(q|0)|0;hb=ob=Bb=0;for(gb=oc;;)if(sc=f+(hb<<2)|0,mc=a[sc>>2]|0,Sa=((mc>>>0)/(q>>>0)|0)+ob|0,a[sc>>2]=Sa,sc=E((mc>>>0)%(q>>>0)|0,n)|0,mc=(hb|0)==(Bb|0)&0==(Sa|0),hb=hb+1|0,Sa=mc?gb+-9|0:gb,p=mc?hb&127:Bb,(hb|0)==(bd|0)){Gc=sc;nc=p;Lc=Sa;break}else Bb=p,ob=sc,gb=Sa;Gc?(a[f+(bd<<2)>>2]=Gc,Bc=nc,hd=Lc,Bd=bd+1|0):(Bc=nc,hd=Lc,Bd=bd)}else Bc=0,hd=oc,Bd=0;Rc=Bc;lc=0;Be=9-kb+hd|0;Ec=Bd}else lc=Rc=0,Be=oc,Ec=bd;b:for(;;){gb=18>(Be|0);ob=18==(Be|0);Bb=f+(Rc<<
2)|0;hb=lc;for(n=Ec;;){if(!gb){if(!ob){Hc=Rc;Rb=hb;od=Be;tc=n;break b}if(9007199<=(a[Bb>>2]|0)>>>0){Hc=Rc;Rb=hb;od=18;tc=n;break b}}q=0;qb=n+127|0;for(Sa=n;;)if(sc=qb&127,p=f+(sc<<2)|0,mc=Oc(a[p>>2]|0,0,29)|0,nb=Qb(mc|0,U|0,q|0,0)|0,mc=U,0<mc>>>0|0==(mc|0)&1E9<nb>>>0?(Ka=pf(nb|0,mc|0,1E9,0)|0,Xb=Ta=vk(nb|0,mc|0,1E9,0)|0,rc=Ka):(Xb=nb,rc=0),a[p>>2]=Xb,p=(sc|0)==(Rc|0),nb=(sc|0)!=(Sa+127&127|0)|p?Sa:0==(Xb|0)?sc:Sa,p){ed=rc;gd=nb;break}else q=rc,qb=sc+-1|0,Sa=nb;Sa=hb+-29|0;if(ed){Cc=Sa;vc=ed;Fc=gd;
break}else hb=Sa,n=gd}n=Rc+127&127;(n|0)==(Fc|0)?(hb=Fc+127&127,Bb=f+((Fc+126&127)<<2)|0,a[Bb>>2]|=a[f+(hb<<2)>>2],Qc=hb):Qc=Fc;a[f+(n<<2)>>2]=vc;Rc=n;lc=Cc;Be=Be+9|0;Ec=Qc}b:for(;;){xc=tc+1&127;kb=f+((tc+127&127)<<2)|0;n=Hc;hb=Rb;for(Bb=od;;){ob=18==(Bb|0);gb=27<(Bb|0)?9:1;Sa=ob^1;Yc=n;for(wc=hb;;){id=Yc&127;dc=(id|0)==(tc|0);do if(dc)z=217;else if(qb=a[f+(id<<2)>>2]|0,9007199>qb>>>0)z=217;else if(!(9007199<qb>>>0))if(qb=Yc+1&127,(qb|0)==(tc|0))z=217;else if(q=a[f+(qb<<2)>>2]|0,254740991>q>>>0)z=
217;else if(!(254740991<q>>>0|Sa)){Ac=id;Sc=Yc;Tc=wc;Wc=tc;break b}while(0);if(217==(z|0)&&(z=0,ob)){z=218;break b}q=wc+gb|0;if((Yc|0)==(tc|0))Yc=tc,wc=q;else{Uc=q;Ce=Yc;break}}ob=(1<<gb)+-1|0;Sa=1E9>>>gb;q=Ce;qb=0;nb=Ce;for(sc=Bb;;)if(p=f+(nb<<2)|0,Ka=a[p>>2]|0,Ta=(Ka>>>gb)+qb|0,a[p>>2]=Ta,p=E(Ka&ob,Sa)|0,Ka=(nb|0)==(q|0)&0==(Ta|0),nb=nb+1&127,Ta=Ka?sc+-9|0:sc,mc=Ka?nb:q,(nb|0)==(tc|0)){vd=p;wd=mc;Vc=Ta;break}else q=mc,qb=p,sc=Ta;if(vd){if((xc|0)!=(wd|0)){Nf=Uc;Pc=vd;ug=wd;rd=Vc;break}a[kb>>2]|=
1}n=wd;hb=Uc;Bb=Vc}a[f+(tc<<2)>>2]=Pc;Hc=ug;Rb=Nf;od=rd;tc=xc}218==(z|0)&&(dc?(a[f+(xc+-1<<2)>>2]=0,Ac=tc,Sc=Yc,Tc=wc,Wc=xc):(Ac=id,Sc=Yc,Tc=wc,Wc=tc));Ga=+((a[f+(Ac<<2)>>2]|0)>>>0);Bb=Sc+1&127;(Bb|0)==(Wc|0)?(hb=Sc+2&127,a[f+(hb+-1<<2)>>2]=0,ad=hb):ad=Wc;Ya=+(y|0);dd=Ya*(1E9*Ga+ +((a[f+(Bb<<2)>>2]|0)>>>0));Bb=Tc+53|0;hb=Bb-h|0;n=(hb|0)<(g|0);kb=n&1;sc=n?0>(hb|0)?0:hb:g;if(53>(sc|0))var de=+ii(1,105-sc|0),Ga=+ + +ch(+de,+dd),He=+ii(1,53-sc|0),Xc=+ + +$h(+dd,+He),ce=Ga,oe=Xc,qd=Ga+(dd-Xc);else oe=
ce=0,qd=dd;qb=Sc+2&127;(qb|0)==(ad|0)?ld=oe:(q=a[f+(qb<<2)>>2]|0,Df=5E8<=q>>>0?5E8<q>>>0?.75*Ya+oe:(Sc+3&127|0)==(ad|0)?.5*Ya+oe:.75*Ya+oe:0==(q|0)&&(Sc+3&127|0)==(ad|0)?oe:.25*Ya+oe,ld=1>=(53-sc|0)?Df:0!=+ + +$h(+Df,1)?Df:Df+1);Ya=qd+ld-ce;if((Bb&2147483647|0)>(-2-pa|0)){9007199254740992<=+Kk(+Ya)?(sd=n&(sc|0)==(hb|0)?0:kb,$c=Tc+1|0,cd=.5*Ya):(sd=kb,$c=Tc,cd=Ya);if(!(($c+50|0)<=(jb|0))||0!=ld&0!=(sd|0))qb=md()|0,a[qb>>2]=34;td=$c;he=cd}else td=Tc,he=Ya;Vb=+ + +ii(+he,td|0)}else Vb=0*+(y|0);while(0);
m=Vb;u=e;return+m}while(0);a[k>>2]|0&&(a[d>>2]=(a[d>>2]|0)+-1);ka=md()|0;a[ka>>2]=22;Sf(b,0);m=0;u=e;return+m}while(0);if(23==(z|0)&&((z=0==(a[k>>2]|0))||(a[d>>2]=(a[d>>2]|0)+-1),0!=(c|0)&3<H>>>0)){c=H;do z||(a[d>>2]=(a[d>>2]|0)+-1),c=c+-1|0;while(3<c>>>0)}m=+(y|0)*Kj;u=e;return+m}function Zh(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p=0,q=0,y,B=0,H=0,ka,z,Q,C=0,u=0,V=0,r=0,w=0,I=0,G=0;if(36<d>>>0)return g=md()|0,a[g>>2]=22,U=0;g=b+4|0;h=b+100|0;do m=a[g>>2]|0,m>>>0<(a[h>>2]|0)>>>0?(a[g>>
2]=m+1,k=x[m>>0]|0):k=Jc(b)|0;while(0!=(Eg(k)|0));l=k;a:do switch(l|0){case 43:case 45:k=(45==(l|0))<<31>>31;m=a[g>>2]|0;m>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=m+1,n=x[m>>0]|0):n=Jc(b)|0;m=k;break a;default:n=l,m=0}while(0);l=0==(d|0);if(0==(d&-17|0)&48==(n|0))if(k=a[g>>2]|0,k>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=k+1,k=x[k>>0]|0):k=Jc(b)|0,120!=(k|32))l?(p=8,q=k,y=46):(B=d,H=k,y=32);else{k=a[g>>2]|0;k>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=k+1,ka=x[k>>0]|0):ka=Jc(b)|0;if(15<(x[163148+(ka+1)>>0]|0)){(k=0==(a[h>>2]|0))||(a[g>>
2]=(a[g>>2]|0)+-1);if(!c)return Sf(b,0),U=0;if(k)return U=0;a[g>>2]=(a[g>>2]|0)+-1;return U=0}p=16;q=ka;y=46}else if(k=l?10:d,(x[163148+(n+1)>>0]|0)>>>0<k>>>0)B=k,H=n,y=32;else return a[h>>2]|0&&(a[g>>2]=(a[g>>2]|0)+-1),Sf(b,0),k=md()|0,a[k>>2]=22,U=0;if(32==(y|0))if(10==(B|0)){n=H+-48|0;if(10>n>>>0){d=n;for(n=0;;)if(l=(10*n|0)+d|0,ka=a[g>>2]|0,ka>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=ka+1,c=x[ka>>0]|0):c=Jc(b)|0,d=c+-48|0,10>d>>>0&429496729>l>>>0)n=l;else break;k=l;l=0;B=c}else l=k=0,B=H;z=B+-48|0;if(10>
z>>>0){H=k;n=l;c=z;for(z=B;;){B=Cf(H|0,n|0,10,0)|0;d=U;l=(0>(c|0))<<31>>31;ka=~l;if(d>>>0>ka>>>0|(d|0)==(ka|0)&B>>>0>~c>>>0){Q=c;d=H;c=n;n=z;break}ka=Qb(B|0,d|0,c|0,l|0)|0;l=U;d=a[g>>2]|0;d>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=d+1,k=x[d>>0]|0):k=Jc(b)|0;d=k+-48|0;if(10>d>>>0&(429496729>l>>>0|429496729==(l|0)&2576980378>ka>>>0))H=ka,n=l,c=d,z=k;else{Q=d;d=ka;c=l;n=k;break}}9<Q>>>0?(C=c,u=d,V=m):(r=10,w=d,I=c,G=n,y=72)}else C=l,u=k,V=m}else p=B,q=H,y=46;a:do if(46==(y|0)){if(!(p+-1&p)){H=t[163405+((23*p|0)>>>
5&7)>>0]|0;B=t[163148+(q+1)>>0]|0;k=B&255;if(k>>>0<p>>>0){l=k;for(k=0;;)if(n=l|k<<H,c=a[g>>2]|0,c>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=c+1,r=x[c>>0]|0):r=Jc(b)|0,c=t[163148+(r+1)>>0]|0,l=c&255,134217728>n>>>0&l>>>0<p>>>0)k=n;else{q=n;w=c;l=r;break}r=w;I=0;w=q;q=l}else r=B,w=I=0;k=Oe(-1,-1,H|0)|0;l=U;if((r&255)>>>0>=p>>>0|I>>>0>l>>>0|(I|0)==(l|0)&w>>>0>k>>>0){r=p;G=q;y=72;break}else q=r;for(;;)if(n=Oc(w|0,I|0,H|0)|0,c=U,d=q&255|n,n=a[g>>2]|0,n>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=n+1,B=x[n>>0]|0):B=Jc(b)|0,q=t[163148+
(B+1)>>0]|0,(q&255)>>>0>=p>>>0|c>>>0>l>>>0|(c|0)==(l|0)&d>>>0>k>>>0){r=p;w=d;I=c;G=B;y=72;break a}else w=d,I=c}k=t[163148+(q+1)>>0]|0;l=k&255;if(l>>>0<p>>>0){H=l;for(l=0;;)if(B=H+(E(l,p)|0)|0,c=a[g>>2]|0,c>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=c+1,r=x[c>>0]|0):r=Jc(b)|0,c=t[163148+(r+1)>>0]|0,H=c&255,119304647>B>>>0&H>>>0<p>>>0)l=B;else{H=B;w=c;l=r;break}r=w;w=H;I=0;G=l}else r=k,I=w=0,G=q;if((r&255)>>>0<p>>>0)for(l=pf(-1,-1,p|0,0)|0,H=U,B=I,c=w,d=r,n=G;;){if(B>>>0>H>>>0|(B|0)==(H|0)&c>>>0>l>>>0){r=p;w=c;I=
B;G=n;y=72;break a}Q=Cf(c|0,B|0,p|0,0)|0;k=U;z=d&255;if(4294967295<k>>>0|-1==(k|0)&Q>>>0>~z>>>0){r=p;w=c;I=B;G=n;y=72;break a}c=Qb(z|0,0,Q|0,k|0)|0;k=U;Q=a[g>>2]|0;Q>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=Q+1,G=x[Q>>0]|0):G=Jc(b)|0;d=t[163148+(G+1)>>0]|0;if((d&255)>>>0>=p>>>0){r=p;w=c;I=k;y=72;break}else B=k,n=G}else r=p,y=72}while(0);if(72==(y|0))if((x[163148+(G+1)>>0]|0)>>>0<r>>>0){do G=a[g>>2]|0,G>>>0<(a[h>>2]|0)>>>0?(a[g>>2]=G+1,p=x[G>>0]|0):p=Jc(b)|0;while((x[163148+(p+1)>>0]|0)>>>0<r>>>0);r=md()|0;a[r>>
2]=34;C=f;u=e;V=0==(e&1|0)&1?m:0}else C=I,u=w,V=m;a[h>>2]|0&&(a[g>>2]=(a[g>>2]|0)+-1);if(!(C>>>0<f>>>0|(C|0)==(f|0)&u>>>0<e>>>0)){if(!(0!=(e&1|0)|0|0!=(V|0)))return g=md()|0,a[g>>2]=34,g=Qb(e|0,f|0,-1,-1)|0,U=b=U,g|0;if(C>>>0>f>>>0|(C|0)==(f|0)&u>>>0>e>>>0)return g=md()|0,a[g>>2]=34,U=f,e|0}e=(0>(V|0))<<31>>31;f=Ic(u^V|0,C^e|0,V|0,e|0)|0;U=b=U;return f|0}function Sf(b,d){b|=0;d|=0;var c,e,f;a[b+104>>2]=d;c=a[b+4>>2]|0;e=a[b+8>>2]|0;f=e-c|0;a[b+108>>2]=f;a[b+100>>2]=0!=(d|0)&(f|0)>(d|0)?c+d:e}function Jc(b){b|=
0;var d,c,e=0,f,g,h,m=0,k=0,l=0;d=b+104|0;c=a[d>>2]|0;0!=(c|0)&&(a[b+108>>2]|0)>=(c|0)||(e=3);3==(e|0)?(g=b|0,f=u,u=u+16|0,g=0==(a[g+8>>2]|0)&&0!=(fj(g)|0)?-1:1==(Aa[a[g+32>>2]&63](g,f,1)|0)?x[f>>0]|0:-1,u=f,f=(c=g|0,0<=(c|0))):f=0;if(f){f=a[d>>2]|0;d=b+8|0;f?(d=a[d>>2]|0,g=a[b+4>>2]|0,h=d,f=f-(a[b+108>>2]|0)+-1|0,(h-g|0)>(f|0)?(a[b+100>>2]=g+f,m=d):(k=h,l=d,e=9)):(l=k=d=a[d>>2]|0,e=9);9==(e|0)&&(a[b+100>>2]=k,m=l);l=a[b+4>>2]|0;m&&(k=b+108|0,a[k>>2]=m+1-l+(a[k>>2]|0));k=l+-1|0;if((x[k>>0]|0)==(c|
0))return c|0;t[k>>0]=c;return c|0}a[b+100>>2]=0;return-1}function le(b){b|=0;var d;if(4294963200>=b>>>0)return b|0;d=md()|0;a[d>>2]=0-b;return-1}function ch(b,d){var c,e;Hb[Qc>>3]=+b;c=a[Qc>>2]|0;e=a[Qc+4>>2]|0;Hb[Qc>>3]=+d;e=a[Qc+4>>2]&-2147483648|e&2147483647;a[Qc>>2]=c;a[Qc+4>>2]=e;return+ +Hb[Qc>>3]}function $h(b,d){b=+b;d=+d;var c,e,f,g,h,m,k,l,n,p=0,q,y,B,H,t,z;Hb[Qc>>3]=b;c=a[Qc>>2]|0;e=a[Qc+4>>2]|0;Hb[Qc>>3]=d;f=a[Qc>>2]|0;g=a[Qc+4>>2]|0;h=Oe(c|0,e|0,52)|0;m=h&2047;h=Oe(f|0,g|0,52)|0;k=h&
2047;h=e&-2147483648;l=Oc(f|0,g|0,1)|0;n=U;if(0==(l|0)&0==(n|0)?0:(p=g&2147483647,!(2146435072<p>>>0|2146435072==(p|0)&0<f>>>0|2047==(m|0)))){p=Oc(c|0,e|0,1)|0;q=U;if(!(q>>>0>n>>>0|(q|0)==(n|0)&p>>>0>l>>>0))return+((p|0)==(l|0)&(q|0)==(n|0)?0*b:b);if(m)n=c,l=e&1048575|1048576,q=m;else{n=Oc(c|0,e|0,12)|0;q=U;if(-1<(q|0)|-1==(q|0)&4294967295<n>>>0)for(l=n,n=q,q=0;;)if(p=q+-1|0,l=Oc(l|0,n|0,1)|0,n=U,-1<(n|0)|-1==(n|0)&4294967295<l>>>0)q=p;else{y=p;break}else y=0;n=q=Oc(c|0,e|0,1-y|0)|0;l=U;q=y}if(k)H=
f,t=g&1048575|1048576,z=k;else{m=Oc(f|0,g|0,12)|0;e=U;if(-1<(e|0)|-1==(e|0)&4294967295<m>>>0)for(c=m,m=e,e=0;;)if(y=e+-1|0,c=Oc(c|0,m|0,1)|0,m=U,-1<(m|0)|-1==(m|0)&4294967295<c>>>0)e=y;else{B=y;break}else B=0;H=e=Oc(f|0,g|0,1-B|0)|0;t=U;z=B}k=Ic(n|0,l|0,H|0,t|0)|0;g=U;f=-1<(g|0)|-1==(g|0)&4294967295<k>>>0;a:do{if((q|0)>(z|0)){B=f;e=k;c=g;m=n;for(y=l;;){if(B)if((m|0)==(H|0)&(y|0)==(t|0))break;else f=e,g=c;else f=m,g=y;l=Oc(f|0,g|0,1)|0;n=U;p=q+-1|0;g=Ic(l|0,n|0,H|0,t|0)|0;f=U;k=-1<(f|0)|-1==(f|0)&
4294967295<g>>>0;if((p|0)>(z|0))B=k,e=g,c=f,m=l,y=n,q=p;else{B=k;c=l;e=n;m=g;y=f;break a}}h=0*b;return+h}B=f;c=n;e=l;m=k;y=g;p=q}while(0);if(B){if((c|0)==(H|0)&(e|0)==(t|0))return+(0*b);H=y;t=m}else H=e,t=c;if(1048576>H>>>0|1048576==(H|0)&0>t>>>0)for(c=t,e=H,m=p;;)if(y=Oc(c|0,e|0,1)|0,t=U,H=m+-1|0,1048576>t>>>0|1048576==(t|0)&0>y>>>0)c=y,e=t,m=H;else{z=y;f=H;break}else z=t,t=H,f=p;0<(f|0)?(p=Qb(z|0,t|0,0,-1048576)|0,H=U,t=Oc(f|0,0,52)|0,H|=U,t|=p):(t=Oe(z|0,t|0,1-f|0)|0,H=U);a[Qc>>2]=t;a[Qc+4>>2]=
H|h;h=+Hb[Qc>>3];return+h}h=b*d;return+(h/h)}function ai(b,d){b=+b;d|=0;var c,e,f;Hb[Qc>>3]=b;c=a[Qc>>2]|0;e=a[Qc+4>>2]|0;f=(Oe(c|0,e|0,52)|0)&2047;switch(f|0){case 0:return 0!=b?(c=+ai(1.8446744073709552E19*b,d),e=(a[d>>2]|0)+-64|0):(c=b,e=0),a[d>>2]=e,+c;case 2047:return+b;default:return a[d>>2]=f+-1022,a[Qc>>2]=c,a[Qc+4>>2]=e&-2146435073|1071644672,c=+Hb[Qc>>3],+c}}function ii(b,d){b=+b;d|=0;var c,e;1023<(d|0)?(c=8.98846567431158E307*b,e=d+-1023|0,1023<(e|0)&&(e=d+-2046|0,e=1023<(e|0)?1023:e,c*=
8.98846567431158E307)):-1022>(d|0)?(c=2.2250738585072014E-308*b,e=d+1022|0,-1022>(e|0)&&(e=d+2044|0,e=-1022>(e|0)?-1022:e,c*=2.2250738585072014E-308)):(e=d,c=b);d=Oc(e+1023|0,0,52)|0;e=U;a[Qc>>2]=d;a[Qc+4>>2]=e;return+(c*+Hb[Qc>>3])}function Li(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m;h=u;u=u+32|0;if(!(0==(g&4095|0)&0==((0>(g|0))<<31>>31&-4096|0)))return m=md()|0,a[m>>2]=22,u=h,-1;if(2147483646<d>>>0)return m=md()|0,a[m>>2]=12,u=h,-1;m=0!=(e&16|0);a[h>>2]=b;a[h+4>>2]=d;a[h+8>>2]=c;a[h+12>>
2]=e;a[h+16>>2]=f;a[h+20>>2]=g>>12;g=le(Rj(192,h|0)|0)|0;if(!m)return u=h,g|0;u=h;return g|0}function Mi(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k=0,l=0,n=0,p=0,q=0;f=u;u=u+16|0;g=0==(e|0)?122884:e;e=a[g>>2]|0;a:do{if(d){b=0==(b|0)?f:b;if(!c)return c=-2,u=f,c|0;do if(e)l=c,n=e,p=d,q=9;else if(h=t[d>>0]|0,m=h&255,-1>=h<<24>>24){h=m+-194|0;if(50<h>>>0)break a;m=a[122636+(h<<2)>>2]|0;(h=c+-1|0)?(l=h,n=m,p=d+1|0,q=9):k=m}else return a[b>>2]=m,c=0!=h<<24>>24&1,u=f,c|0;while(0);b:do if(9==(q|0)){h=t[p>>
0]|0;m=(h&255)>>>3;if(7<(m+-16|m+(n>>26))>>>0)break a;else d=l,e=h;for(;;){p=p+1|0;n=(e&255)+-128|n<<6;d=d+-1|0;if(0<=(n|0)){p=n;n=d;break}if(!d){k=n;break b}e=t[p>>0]|0;if(-128!=(e&-64)<<24>>24)break a}a[g>>2]=0;a[b>>2]=p;c=c-n|0;u=f;return c|0}while(0);a[g>>2]=k;c=-2;u=f;return c|0}if(!e)return c=0,u=f,c|0}while(0);a[g>>2]=0;g=md()|0;a[g>>2]=84;u=f;return-1}function dj(b,d,c){b|=0;d|=0;if(!b)return 1;if(128>d>>>0)return t[b>>0]=d,1;if(2048>d>>>0)return t[b>>0]=d>>>6|192,t[b+1>>0]=d&63|128,2;if(55296>
d>>>0|57344==(d&-8192|0))return t[b>>0]=d>>>12|224,t[b+1>>0]=d>>>6&63|128,t[b+2>>0]=d&63|128,3;if(1048576>(d+-65536|0)>>>0)return t[b>>0]=d>>>18|240,t[b+1>>0]=d>>>12&63|128,t[b+2>>0]=d>>>6&63|128,t[b+3>>0]=d&63|128,4;d=md()|0;a[d>>2]=84;return-1}function Mk(a,d){a|=0;return(a?dj(a,d|0,0)|0:0)|0}function Xe(){var b,d,c;b=72;d=Cf(a[b>>2]|0,a[b+4>>2]|0,1284865837,1481765933)|0;b=Qb(d|0,U|0,1,0)|0;d=U;c=72;a[c>>2]=b;a[c+4>>2]=d;c=Oe(b|0,d|0,33)|0;return c|0}function Nk(b,d){b|=0;d|=0;var c,e,f,g,h;c=
u;u=u+64|0;e=c+16|0;f=c+8|0;g=c+24|0;a[c>>2]=b;a[c+4>>2]=d;h=Sj(197,c|0)|0;if(-9==(h|0)&&(a[f>>2]=b,a[f+4>>2]=1,0<=(Vj(221,f|0)|0))){f=g|0;h=b|0;var m,k;t[f>>0]=47;t[f+1>>0]=112;t[f+2>>0]=114;t[f+3>>0]=111;t[f+4>>0]=99;t[f+5>>0]=47;t[f+6>>0]=115;t[f+7>>0]=101;t[f+8>>0]=108;t[f+9>>0]=102;t[f+10>>0]=47;t[f+11>>0]=102;t[f+12>>0]=100;t[f+13>>0]=47;m=f+14|0;t[m>>0]=0;if(h){m=14;for(k=h;!(m=m+1|0,10>k>>>0);)k=(k>>>0)/10|0;t[f+m>>0]=0;k=h;for(h=m;!(h=h+-1|0,t[f+h>>0]=(k>>>0)%10|48,10>k>>>0);)k=(k>>>0)/10|
0}else t[m>>0]=48,t[f+15>>0]=0;a[e>>2]=g;a[e+4>>2]=d;e=le(Uj(195,e|0)|0)|0;u=c;return e|0}e=le(h)|0;u=c;return e|0}function ej(b,d){b|=0;d|=0;var c,e,f,g,h;c=u;u=u+16|0;e=d&255;t[c>>0]=e;f=b+16|0;if(g=a[f>>2]|0)h=g;else{if(Ok(b)|0)return u=c,-1;h=a[f>>2]|0}g=b+20|0;f=a[g>>2]|0;if(f>>>0<h>>>0&&(h=d&255,(h|0)!=(t[b+75>>0]|0)))return a[g>>2]=f+1,t[f>>0]=e,u=c,h|0;if(1!=(Aa[a[b+36>>2]&63](b,c,1)|0))return u=c,-1;e=x[c>>0]|0;u=c;return e|0}function Pk(b,d,c){b|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y=0,B=0,H=
0,t;e=u;u=u+48|0;f=e+16|0;g=e+32|0;h=b+28|0;m=a[h>>2]|0;a[g>>2]=m;k=b+20|0;l=(a[k>>2]|0)-m|0;a[g+4>>2]=l;a[g+8>>2]=d|0;a[g+12>>2]=c;d=b+60|0;m=b+44|0;n=g;g=2;for(p=l+c|0;;){a[30648]|0?(Pj(71,b|0),a[e>>2]=a[d>>2],a[e+4>>2]=n,a[e+8>>2]=g,l=le(Qk(146,e|0)|0)|0,Nj(0),q=l):(a[f>>2]=a[d>>2],a[f+4>>2]=n,a[f+8>>2]=g,q=le(Qk(146,f|0)|0)|0);if((p|0)==(q|0)){y=6;break}if(0>(q|0)){B=n;H=g;break}l=p-q|0;t=a[n+4>>2]|0;q>>>0<=t>>>0?2==(g|0)?(a[h>>2]=(a[h>>2]|0)+q,p=t,g=2):p=t:(p=a[m>>2]|0,a[h>>2]=p,a[k>>2]=p,p=
a[n+12>>2]|0,q=q-t|0,n=n+8|0,g=g+-1|0);a[n>>2]=(a[n>>2]|0)+q;a[n+4>>2]=p-q;p=l}if(6==(y|0))return y=a[m>>2]|0,a[b+16>>2]=y+(a[b+48>>2]|0),m=y,a[h>>2]=m,a[k>>2]=m,u=e,c|0;a[b+16>>2]=0;a[h>>2]=0;a[k>>2]=0;a[b>>2]|=32;if(2==(H|0))return u=e,0;b=c-(a[B+4>>2]|0)|0;u=e;return b|0}function fj(b){b|=0;var d,c;d=b+74|0;c=t[d>>0]|0;t[d>>0]=c+255|c;c=b+20|0;d=b+44|0;(a[c>>2]|0)>>>0>(a[d>>2]|0)>>>0&&Aa[a[b+36>>2]&63](b,0,0)|0;a[b+16>>2]=0;a[b+28>>2]=0;a[c>>2]=0;c=a[b>>2]|0;if(!(c&20))return d=a[d>>2]|0,a[b+8>>
2]=d,a[b+4>>2]=d,0;if(!(c&4))return-1;a[b>>2]=c|32;return-1}function Ok(b){b|=0;var d,c;d=b+74|0;c=t[d>>0]|0;t[d>>0]=c+255|c;c=a[b>>2]|0;if(c&8)return a[b>>2]=c|32,-1;a[b+8>>2]=0;a[b+4>>2]=0;d=a[b+44>>2]|0;a[b+28>>2]=d;a[b+20>>2]=d;a[b+16>>2]=d+(a[b+48>>2]|0);return 0}function Rk(b){b|=0;var d,c;if(b){if(-1>=(a[b+76>>2]|0))return b=wk(b)|0,b|0;d=wk(b)|0;return d|0}c=a[30711]|0?Rk(a[30711]|0)|0:0;rl(122620);if(d=a[30654]|0)for(b=d,d=c;;){if(d=(a[b+20>>2]|0)>>>0>(a[b+28>>2]|0)>>>0?wk(b)|0|d:d,b=a[b+
56>>2]|0,!b){b=d;break}}else b=c;Yj(122620);return b|0}function Ld(b,d,c){var e;e=u;u=u+16|0;a[e>>2]=c|0;c=Ei(b|0,d|0,e)|0;u=e;return c|0}function xk(b,d){b|=0;d|=0;var c=0,e=0;return(t[d+75>>0]|0)!=(b|0)&&(e=d+20|0,c=a[e>>2]|0,c>>>0<(a[d+16>>2]|0)>>>0)?(a[e>>2]=c+1,t[c>>0]=b,b&255|0):ej(d,b)|0}function qd(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k;e=c+16|0;if(f=a[e>>2]|0)g=f;else{if(Ok(c)|0)return 0;g=a[e>>2]|0}f=c+20|0;e=a[f>>2]|0;if((g-e|0)>>>0<d>>>0)return b=Aa[a[c+36>>2]&63](c,b,d)|0,b|0;a:do if(-1<
(t[c+75>>0]|0)){for(g=d;;){if(!g){g=d;h=b;m=e;k=0;break a}h=g+-1|0;if(10==(t[b+h>>0]|0)){k=g;break}else g=h}if((Aa[a[c+36>>2]&63](c,b,k)|0)>>>0<k>>>0)return b=k,b|0;g=d-k|0;h=b+k|0;m=a[f>>2]|0}else g=d,h=b,m=e,k=0;while(0);Ec(m|0,h|0,g|0)|0;a[f>>2]=(a[f>>2]|0)+g;return k+g|0}function Sd(a,d,c,e){a|=0;d|=0;c|=0;e|=0;var f;f=E(c,d)|0;a=qd(a,f,e)|0;return(a|0)==(f|0)?c|0:(a>>>0)/(d>>>0)|0}function ad(b,d,c){var e;e=u;u=u+16|0;a[e>>2]=c|0;c=Sk(b|0,2147483647,d|0,e|0)|0;u=e;return c|0}function Ei(b,d,
c){b|=0;d|=0;var e,f,g,h,m,k,l,n,p,q;e=u;u=u+224|0;f=e+80|0;g=e+96|0;h=e+136|0;m=g;k=m+40|0;do a[m>>2]=0,m=m+4|0;while((m|0)<(k|0));a[f>>2]=a[(c|0)>>2];if(0>(yk(0,d,f,e,g)|0))return u=e,-1;c=a[b>>2]|0;m=c&32;1>(t[b+74>>0]|0)&&(a[b>>2]=c&-33);c=b+48|0;a[c>>2]|0?c=yk(b,d,f,e,g)|0:(k=b+44|0,l=a[k>>2]|0,a[k>>2]=h,n=b+28|0,a[n>>2]=h,p=b+20|0,a[p>>2]=h,a[c>>2]=80,q=b+16|0,a[q>>2]=h+80,h=yk(b,d,f,e,g)|0,l?(Aa[a[b+36>>2]&63](b,0,0)|0,g=0==(a[p>>2]|0)?-1:h,a[k>>2]=l,a[c>>2]=0,a[q>>2]=0,a[n>>2]=0,a[p>>2]=0,
c=g):c=h);g=a[b>>2]|0;a[b>>2]=g|m;u=e;return(0==(g&32|0)?c:-1)|0}function Sk(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k;f=u;u=u+128|0;g=f+112|0;h=f;m=122888;k=h+112|0;do a[h>>2]=a[m>>2],h=h+4|0,m=m+4|0;while((h|0)<(k|0));if(2147483646<(d+-1|0)>>>0){if(d)return g=md()|0,a[g>>2]=75,u=f,-1;h=1}else g=b,h=d;d=-2-g|0;b=h>>>0>d>>>0?d:h;a[f+48>>2]=b;h=f+20|0;a[h>>2]=g;a[f+44>>2]=g;d=g+b|0;g=f+16|0;a[g>>2]=d;a[f+28>>2]=d;d=Ei(f,c,e)|0;if(!b)return u=f,d|0;b=a[h>>2]|0;t[b+(((b|0)==(a[g>>2]|0))<<31>>31)>>0]=
0;u=f;return d|0}function zk(a,d,c,e,f){a|=0;c|=0;e|=0;f|=0;var g,h,m;if(c)g=d|0,h=c;else return 0;for(;;){c=h>>>1;d=g+(E(c,e)|0)|0;m=dd[f&127](a,d)|0;if(!m){a=d;d=5;break}if(1==(h|0)){a=0;d=5;break}if(h=(m=0>(m|0))?c:h-c|0)g=m?g:d;else{a=0;d=5;break}}return 5==(d|0)?a|0:0}function Tk(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k=0,l=0,n,p=0,q=0,y=0,B=0,H=0,ka,z=0,Q=0,C=ka=0;e=d&255;f=0!=(c|0);a:do if(f&0!=(b&3|0))for(g=d&255,h=c,m=b;;){if((t[m>>0]|0)==g<<24>>24){k=h;l=m;g=6;break a}m=m+1|0;h=h+-1|0;n=0!=
(h|0);if(!(n&0!=(m&3|0))){p=h;q=n;y=m;g=5;break}}else p=c,q=f,y=b,g=5;while(0);5==(g|0)&&(q?(k=p,l=y,g=6):(B=0,H=y));a:do if(6==(g|0))if(y=d&255,(t[l>>0]|0)==y<<24>>24)B=k,H=l;else{p=E(e,16843009)|0;b:do if(3<k>>>0){q=k;for(b=l;;){f=a[b>>2]^p;if((f&-2139062144^-2139062144)&f+-16843009){ka=q;break}f=b+4|0;c=q+-4|0;if(3<c>>>0)q=c,b=f;else{z=c;Q=f;g=11;break b}}C=b}else z=k,Q=l,g=11;while(0);if(11==(g|0))if(z)ka=z,C=Q;else{B=0;H=Q;break}for(;;){if((t[C>>0]|0)==y<<24>>24){B=ka;H=C;break a}p=C+1|0;if(ka=
ka+-1|0)C=p;else{B=0;H=p;break}}}while(0);return(0!=(B|0)?H:0)|0}function Ak(a,d,c){c|=0;var e=0,f,g,h=0,m=0,k=0;if(c)f=a|0,g=d|0;else return 0;for(;;){d=t[f>>0]|0;a=t[g>>0]|0;if(d<<24>>24!=a<<24>>24){h=d;m=a;break}if(c=c+-1|0)f=f+1|0,g=g+1|0;else{e=0;k=5;break}}return 5==(k|0)?e|0:(h&255)-(m&255)|0}function gj(b,d){b|=0;d|=0;var c,e,f,g;c=d;if((c^b)&3)g=d,e=b;else{a:do{if(c&3){f=b;for(g=d;;){e=t[g>>0]|0;t[f>>0]=e;if(!(e<<24>>24)){c=f;break}e=g+1|0;f=f+1|0;if(e&3)g=e;else break a}return c|0}e=d;f=
b}while(0);c=a[e>>2]|0;if((c&-2139062144^-2139062144)&c+-16843009)c=f,g=e;else for(g=c,c=f,f=e;;)if(e=f+4|0,f=c+4|0,a[c>>2]=g,g=a[e>>2]|0,(g&-2139062144^-2139062144)&g+-16843009){c=f;g=e;break}else c=f,f=e;e=c}b=t[g>>0]|0;t[e>>0]=b;if(b<<24>>24)c=g;else return e|0;for(;;)if(c=c+1|0,g=e+1|0,e=t[c>>0]|0,t[g>>0]=e,e<<24>>24)e=g;else break;return g|0}function Cj(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0;e=d;if((e^b)&3)l=d,n=b;else{f=0!=(c|0);a:do if(f&0!=(e&3|0))for(g=c,h=
d,m=b;;){k=t[h>>0]|0;t[m>>0]=k;if(!(k<<24>>24)){l=g;n=h;p=m;break a}k=g+-1|0;h=h+1|0;m=m+1|0;g=0!=(k|0);if(g&0!=(h&3|0))g=k;else{q=k;y=h;B=m;H=g;ka=5;break}}else q=c,y=d,B=b,H=f,ka=5;while(0);if(5==(ka|0))if(H)l=q,n=y,p=B;else return n=B,Va(n|0,0,0)|0,n|0;if(!(t[n>>0]|0))return n=p,Va(n|0,0,l|0)|0,n|0;a:do if(3<l>>>0)for(B=l,y=p,q=n;;){H=a[q>>2]|0;if((H&-2139062144^-2139062144)&H+-16843009){c=B;ka=y;f=q;break a}a[y>>2]=H;H=B+-4|0;f=q+4|0;e=y+4|0;if(3<H>>>0)B=H,y=e,q=f;else{c=H;ka=e;break}}else c=
l,ka=p,f=n;while(0);l=f;n=ka}if(p=c)c=p;else return Va(n|0,0,0)|0,n|0;for(;;){p=t[l>>0]|0;t[n>>0]=p;if(!(p<<24>>24)){l=c;ka=14;break}c=c+-1|0;p=n+1|0;if(c)l=l+1|0,n=p;else{n=p;l=0;ka=14;break}}return 14==(ka|0)?(Va(n|0,0,l|0)|0,n|0):0}function Uk(a,d){a|=0;d|=0;var c,e,f;c=t[a>>0]|0;e=t[d>>0]|0;if(0==c<<24>>24||c<<24>>24!=e<<24>>24)f=c,c=e;else{e=a;a=d;do e=e+1|0,a=a+1|0,d=t[e>>0]|0,c=t[a>>0]|0;while(0!=d<<24>>24&&d<<24>>24==c<<24>>24);f=d}return(f&255)-(c&255)|0}function bk(b){b|=0;var d,c;d=b;a:do{if(d&
3){for(c=d;t[b>>0]|0;)if(c=b=b+1|0,!(c&3)){c=b;break a}d=c-d|0;return d|0}c=b}while(0);for(b=c;!(c=a[b>>2]|0,(c&-2139062144^-2139062144)&c+-16843009);)b=b+4|0;if((c&255)<<24>>24)for(c=b;;)if(b=c+1|0,t[b>>0]|0)c=b;else{c=b;break}else c=b;return c-d|0}function Vk(a,d,c){a|=0;d|=0;c|=0;var e,f,g,h,m,k;if(!c)return 0;e=t[a>>0]|0;a:do if(e<<24>>24)for(f=c,h=e,m=a,g=d;;){f=f+-1|0;k=t[g>>0]|0;if(!(h<<24>>24==k<<24>>24&0!=(f|0)&0!=k<<24>>24)){f=h;break a}m=m+1|0;k=g+1|0;h=t[m>>0]|0;if(h<<24>>24)g=k;else{f=
0;g=k;break}}else f=0,g=d;while(0);return(f&255)-(x[g>>0]|0)|0}function Wk(a,d,c){a|=0;Cj(a,d|0,c|0)|0;return a|0}function Xk(b){var d,c;d=u;u=u+16|0;c=d;a[c>>2]=b|0;b=Yk(6,c|0)|0;c=le(-4==(b|0)?-115:b)|0;u=d;return c|0}function Lk(b,d){b|=0;d|=0;var c,e,f,g,h,m,k;c=b+4|0;e=a[c>>2]|0;f=b+100|0;e>>>0<(a[f>>2]|0)>>>0?(a[c>>2]=e+1,g=x[e>>0]|0):g=Jc(b)|0;switch(g|0){case 43:case 45:e=45==(g|0)&1;h=a[c>>2]|0;h>>>0<(a[f>>2]|0)>>>0?(a[c>>2]=h+1,m=x[h>>0]|0):m=Jc(b)|0;0!=(d|0)&9<(m+-48|0)>>>0&&0!=(a[f>>2]|
0)&&(a[c>>2]=(a[c>>2]|0)+-1);h=e;break;default:m=g,h=0}if(9<(m+-48|0)>>>0){if(!(a[f>>2]|0))return U=-2147483648,0;a[c>>2]=(a[c>>2]|0)+-1;U=-2147483648;return 0}k=m;for(g=0;;)if(m=k+-48+(10*g|0)|0,g=a[c>>2]|0,g>>>0<(a[f>>2]|0)>>>0?(a[c>>2]=g+1,k=x[g>>0]|0):k=Jc(b)|0,10>(k+-48|0)>>>0&214748364>(m|0))g=m;else{g=m;e=k;break}k=(0>(g|0))<<31>>31;if(10>(e+-48|0)>>>0)for(m=e;;)if(g=Cf(g|0,k|0,10,0)|0,e=U,m=Qb(m|0,(0>(m|0))<<31>>31|0,-48,-1)|0,d=Qb(m|0,U|0,g|0,e|0)|0,e=U,g=a[c>>2]|0,g>>>0<(a[f>>2]|0)>>>0?
(a[c>>2]=g+1,m=x[g>>0]|0):m=Jc(b)|0,10>(m+-48|0)>>>0&(21474836>(e|0)|21474836==(e|0)&2061584302>d>>>0))g=d,k=e;else{g=d;k=e;e=m;break}if(10>(e+-48|0)>>>0){do e=a[c>>2]|0,e>>>0<(a[f>>2]|0)>>>0?(a[c>>2]=e+1,e=x[e>>0]|0):e=Jc(b)|0;while(10>(e+-48|0)>>>0)}a[f>>2]|0&&(a[c>>2]=(a[c>>2]|0)+-1);c=0!=(h|0);h=Ic(0,0,g|0,k|0)|0;U=c?U:k;return(c?h:g)|0}function wk(b){b|=0;var d,c,e,f,g,h;d=b+20|0;c=b+28|0;if((a[d>>2]|0)>>>0>(a[c>>2]|0)>>>0&&(Aa[a[b+36>>2]&63](b,0,0)|0,0==(a[d>>2]|0)))return-1;e=b+4|0;f=a[e>>
2]|0;g=b+8|0;h=a[g>>2]|0;f>>>0<h>>>0&&Aa[a[b+40>>2]&63](b,f-h|0,1)|0;a[b+16>>2]=0;a[c>>2]=0;a[d>>2]=0;a[g>>2]=0;return a[e>>2]=0}function yk(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0,z=0,Q=0,C=0,Ra=0,r=0,Ed=0,J=0,I=0,G=0,L=0,K=0,v=0,fd=0,O=0,M=0,T=0,X=0,P=0,A=0,D=0,N=0,ba=0,F=0,R=0,S=0,ga=0,Ha=0,ma=0,Y=0,ha=0,W=0,da=0,pc=0,Z=0,ca=0,fa=0,oa=0,sa=0,aa=0,ua=0,Ia=0,Da=0,na=0,Na=0,ja=0,Ca=0,Ga=0,Ea=0,La=0,Aa=0,ya=0,ra=0,pa=0,xb=0,Zb=0,Ka=0,jb=0,mc=0,Wa=0,
Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,Qa=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Va=0,Ua=0,eb=0,Jb=0,ub=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,Ab=0,ab=0,nd=0,pb=0,wb=0,rb=0,Qd=0,zb=0,Ob=0,Tb=0,Wb=0,fb=0,Gb=0,lb=0,Kb=0,Lb=0,ac=0,Yb=0,kc=0,Vb=0,Pb=0,hc=0,Sb=0,fc=0,kd=0,jc=0,$b=0,db=0,zc=0,yc=0,oc=0,lc=0,ec=0,Ie=0,ic=0,Wd=0,Jd=0,bd=0,Ec=0,Rc=0,Gc=0,Be=0,nc=0,Bc=0,Lc=0,Hc=0,Fc=0,hd=0,Bd=0,Cc=
0,Rb=0,od=0,tc=0,Xb=0,rc=0,ed=0,gd=0,g=u;u=u+624|0;h=g+24|0;m=g+16|0;k=g+588|0;l=g+576|0;n=g;p=g+536|0;q=g+8|0;y=g+528|0;B=0!=(b|0);ka=H=p+40|0;z=p+39|0;p=q+4|0;Q=l+12|0;C=l+11|0;l=k;Ra=Q;r=Ra-l|0;Ed=-2-l|0;J=Ra+2|0;I=h+288|0;L=G=k+9|0;K=k+8|0;v=0;fd=d;O=d=0;a:for(;;){-1<(v|0)?(d|0)>(2147483647-v|0)?(M=md()|0,a[M>>2]=75,T=-1):T=d+v|0:T=v;M=t[fd>>0]|0;if(M<<24>>24)D=M,N=fd;else{X=T;P=O;A=245;break}b:for(;;){switch(D<<24>>24){case 37:F=ba=N;A=9;break b;case 0:S=R=N;break b}M=N+1|0;D=t[M>>0]|0;N=M}b:do if(9==
(A|0))for(;;){A=0;if(37!=(t[ba+1>>0]|0)){R=ba;S=F;break b}M=F+1|0;ga=ba+2|0;if(37==(t[ga>>0]|0))ba=ga,F=M,A=9;else{R=ga;S=M;break}}while(0);M=S-fd|0;B&&0==(a[b>>2]&32|0)&&qd(fd,M,b)|0;if((S|0)!=(fd|0))v=T,fd=R,d=M;else{ga=R+1|0;Ha=t[ga>>0]|0;ma=(Ha<<24>>24)+-48|0;10>ma>>>0?(ha=(Y=36==(t[R+2>>0]|0))?R+3|0:ga,W=t[ha>>0]|0,da=Y?ma:-1,pc=Y?1:O,Z=ha):(W=Ha,da=-1,pc=O,Z=ga);ga=W<<24>>24;b:do if(32==(ga&-32|0))for(Ha=ga,ha=W,Y=0,ma=Z;;){if(!(1<<Ha+-32&75913)){ca=ha;fa=Y;oa=ma;break b}sa=1<<(ha<<24>>24)+
-32|Y;aa=ma+1|0;ua=t[aa>>0]|0;Ha=ua<<24>>24;if(32!=(Ha&-32|0)){ca=ua;fa=sa;oa=aa;break}else ha=ua,Y=sa,ma=aa}else ca=W,fa=0,oa=Z;while(0);do if(42==ca<<24>>24){ga=oa+1|0;ma=(t[ga>>0]|0)+-48|0;if(10>ma>>>0&&36==(t[oa+2>>0]|0))a[f+(ma<<2)>>2]=10,Ia=1,Da=oa+3|0,na=a[e+((t[ga>>0]|0)+-48<<3)>>2]|0;else{if(pc){Na=-1;A=252;break a}if(!B){ja=fa;Ca=ga;Ea=Ga=0;break}ma=(a[c>>2]|0)+3&-4;Y=a[ma>>2]|0;a[c>>2]=ma+4;Ia=0;Da=ga;na=Y}0>(na|0)?(ja=fa|8192,Ca=Da,Ga=Ia,Ea=0-na|0):(ja=fa,Ca=Da,Ga=Ia,Ea=na)}else if(Y=
(ca<<24>>24)+-48|0,10>Y>>>0){ga=oa;ma=0;for(ha=Y;;)if(Y=(10*ma|0)+ha|0,Ha=ga+1|0,ha=(t[Ha>>0]|0)+-48|0,10<=ha>>>0){La=Y;Aa=Ha;break}else ga=Ha,ma=Y;if(0>(La|0)){Na=-1;A=252;break a}else ja=fa,Ca=Aa,Ga=pc,Ea=La}else ja=fa,Ca=oa,Ga=pc,Ea=0;while(0);b:do if(46==(t[Ca>>0]|0)){ma=Ca+1|0;ga=t[ma>>0]|0;if(42!=ga<<24>>24){ha=(ga<<24>>24)+-48|0;if(10>ha>>>0)ya=ma,ra=0,pa=ha;else{xb=ma;Zb=0;break}for(;;)if(ma=(10*ra|0)+pa|0,ha=ya+1|0,pa=(t[ha>>0]|0)+-48|0,10<=pa>>>0){xb=ha;Zb=ma;break b}else ya=ha,ra=ma}ma=
Ca+2|0;ha=(t[ma>>0]|0)+-48|0;if(10>ha>>>0&&36==(t[Ca+3>>0]|0))a[f+(ha<<2)>>2]=10,xb=Ca+4|0,Zb=a[e+((t[ma>>0]|0)+-48<<3)>>2]|0;else{if(Ga){Na=-1;A=252;break a}B?(ha=(a[c>>2]|0)+3&-4,ga=a[ha>>2]|0,a[c>>2]=ha+4,xb=ma,Zb=ga):(xb=ma,Zb=0)}}else xb=Ca,Zb=-1;while(0);ma=xb;for(ga=0;;){ha=(t[ma>>0]|0)+-65|0;if(57<ha>>>0){Na=-1;A=252;break a}Y=ma+1|0;Ha=t[164454+(58*ga|0)+ha>>0]|0;ha=Ha&255;if(8>(ha+-1|0)>>>0)ma=Y,ga=ha;else{Ka=Y;jb=Ha;mc=ha;Wa=ma;Ta=ga;break}}if(!(jb<<24>>24)){Na=-1;A=252;break}ga=-1<(da|
0);do if(19==jb<<24>>24)if(ga){Na=-1;A=252;break a}else A=52;else if(ga)a[f+(da<<2)>>2]=mc,ma=e+(da<<3)|0,ha=a[ma+4>>2]|0,Ha=n,a[Ha>>2]=a[ma>>2],a[Ha+4>>2]=ha,A=52;else{if(!B){Na=0;A=252;break a}bg(n,mc,c)}while(0);if(52!=(A|0)||(A=0,B)){ga=t[Wa>>0]|0;ha=0!=(Ta|0)&3==(ga&15|0)?ga&-33:ga;ga=ja&-65537;Ha=0==(ja&8192|0)?ja:ga;b:do switch(ha|0){case 110:switch(Ta|0){case 0:v=a[a[n>>2]>>2]=T;fd=Ka;d=M;O=Ga;continue a;case 1:v=a[a[n>>2]>>2]=T;fd=Ka;d=M;O=Ga;continue a;case 2:ma=a[n>>2]|0;a[ma>>2]=T;a[ma+
4>>2]=(0>(T|0))<<31>>31;v=T;fd=Ka;d=M;O=Ga;continue a;case 3:v=w[a[n>>2]>>1]=T;fd=Ka;d=M;O=Ga;continue a;case 4:v=t[a[n>>2]>>0]=T;fd=Ka;d=M;O=Ga;continue a;case 6:v=a[a[n>>2]>>2]=T;fd=Ka;d=M;O=Ga;continue a;case 7:ma=a[n>>2]|0;a[ma>>2]=T;a[ma+4>>2]=(0>(T|0))<<31>>31;v=T;fd=Ka;d=M;O=Ga;continue a;default:v=T;fd=Ka;d=M;O=Ga;continue a}case 112:Ya=Ha|8;Sa=8<Zb>>>0?Zb:8;mb=120;A=64;break;case 88:case 120:Ya=Ha;Sa=Zb;mb=ha;A=64;break;case 111:ma=n;Y=a[ma>>2]|0;aa=a[ma+4>>2]|0;if(0==(Y|0)&0==(aa|0))Db=
H;else for(ma=H,sa=Y,Y=aa;;)if(aa=ma+-1|0,t[aa>>0]=sa&7|48,sa=Oe(sa|0,Y|0,3)|0,Y=U,0==(sa|0)&0==(Y|0)){Db=aa;break}else ma=aa;Ha&8?(ma=ka-Db+1|0,cc=Db,Za=Ha,ia=(Zb|0)<(ma|0)?ma:Zb):(cc=Db,Za=Ha,ia=Zb);qa=0;Ja=164934;A=77;break;case 105:case 100:ma=n;Y=a[ma>>2]|0;sa=a[ma+4>>2]|0;if(0>(sa|0)){ma=Ic(0,0,Y|0,sa|0)|0;aa=U;ua=n;a[ua>>2]=ma;a[ua+4>>2]=aa;ea=ma;wa=aa;Ma=1;xa=164934;A=76;break b}Ha&2048?(ea=Y,wa=sa,Ma=1,xa=164935):(aa=Ha&1,ea=Y,wa=sa,Ma=aa,xa=0==(aa|0)?164934:164936);A=76;break;case 117:sa=
n;ea=a[sa>>2]|0;wa=a[sa+4>>2]|0;Ma=0;xa=164934;A=76;break;case 99:t[z>>0]=a[n>>2];$a=z;la=ga;Ba=1;va=0;za=164934;ta=H;break;case 109:sa=md()|0;nb=uk(a[sa>>2]|0)|0;A=82;break;case 115:sa=a[n>>2]|0;nb=0!=(sa|0)?sa:164944;A=82;break;case 67:a[q>>2]=a[n>>2];a[p>>2]=0;a[n>>2]=q;sc=-1;A=86;break;case 83:Zb?(sc=Zb,A=86):(Cd(b,32,Ea,0,Ha),gb=0,A=98);break;case 65:case 71:case 70:case 69:case 97:case 103:case 102:case 101:hb=+Hb[n>>3];a[m>>2]=0;Hb[Qc>>3]=hb;0<=(a[Qc+4>>2]|0)?Ha&2048?(ob=hb,Bb=1,qb=164954):
(sa=Ha&1,ob=hb,Bb=sa,qb=0==(sa|0)?164952:164957):(ob=-hb,Bb=1,qb=164951);Hb[Qc>>3]=ob;sa=a[Qc+4>>2]&2146435072;do if(2146435072>sa>>>0|2146435072==(sa|0)&0)if(hb=2*+ + +ai(+ob,m|0),(Y=0!=hb)&&(a[m>>2]=(a[m>>2]|0)+-1),aa=ha|32,97==(aa|0)){ma=ha&32;ua=0==(ma|0)?qb:qb+9|0;kb=Bb|2;ib=12-Zb|0;do if(11<Zb>>>0|0==(ib|0))Fa=hb;else{Cb=ib;for(Qa=8;;)if(Cb=Cb+-1|0,sb=16*Qa,Cb)Qa=sb;else{Xa=sb;break}Fa=45==(t[ua>>0]|0)?-(Xa+(-hb-Xa)):hb+Xa-Xa}while(0);ib=a[m>>2]|0;Cb=0>(ib|0)?0-ib|0:ib;Pa=kh(Cb,(0>(Cb|0))<<
31>>31,Q)|0;(Pa|0)==(Q|0)?(t[C>>0]=48,Eb=C):Eb=Pa;t[Eb+-1>>0]=(ib>>31&2)+43;ib=Eb+-2|0;t[ib>>0]=ha+15;Pa=1>(Zb|0);Cb=0==(Ha&8|0);Qa=Fa;for(vb=k;;)if(tb=~~Qa,bb=vb+1|0,t[vb>>0]=x[164918+tb>>0]|ma,Qa=16*(Qa-+(tb|0)),1==(bb-l|0)?Cb&Pa&0==Qa?Ib=bb:(t[bb>>0]=46,Ib=vb+2|0):Ib=bb,0==Qa){Mb=Ib;break}else vb=Ib;vb=Mb;Pa=0!=(Zb|0)&(Ed+vb|0)<(Zb|0)?J+Zb-ib|0:r-ib+vb|0;Cb=Pa+kb|0;Cd(b,32,Ea,Cb,Ha);a[b>>2]&32||qd(ua,kb,b)|0;Cd(b,48,Ea,Cb,Ha^65536);ma=vb-l|0;a[b>>2]&32||qd(k,ma,b)|0;vb=Ra-ib|0;Cd(b,48,Pa-(ma+vb)|
0,0,0);a[b>>2]&32||qd(ib,vb,b)|0;Cd(b,32,Ea,Cb,Ha^8192);Va=(Cb|0)<(Ea|0)?Ea:Cb}else{Cb=0>(Zb|0)?6:Zb;Y?(vb=(a[m>>2]|0)+-28|0,a[m>>2]=vb,Ua=268435456*hb,eb=vb):(Ua=hb,eb=a[m>>2]|0);ma=vb=0>(eb|0)?h:I;Qa=Ua;for(Pa=vb;;)if(bb=~~Qa>>>0,a[Pa>>2]=bb,tb=Pa+4|0,Qa=1E9*(Qa-+(bb>>>0)),0==Qa){Jb=tb;break}else Pa=tb;Pa=a[m>>2]|0;if(0<(Pa|0))for(Y=Pa,ib=vb,kb=Jb;;){ua=29<(Y|0)?29:Y;tb=kb+-4|0;do if(tb>>>0<ib>>>0)ub=ib;else{bb=0;for(yb=tb;;)if(cb=Oc(a[yb>>2]|0,0,ua|0)|0,gc=Qb(cb|0,U|0,bb|0,0)|0,cb=U,Ub=vk(gc|0,
cb|0,1E9,0)|0,a[yb>>2]=Ub,Ub=pf(gc|0,cb|0,1E9,0)|0,yb=yb+-4|0,yb>>>0<ib>>>0){Fb=Ub;break}else bb=Ub;Fb?(bb=ib+-4|0,a[bb>>2]=Fb,ub=bb):ub=ib}while(0);for(tb=kb;;){if(tb>>>0<=ub>>>0){Ab=tb;break}bb=tb+-4|0;if(a[bb>>2]|0){Ab=tb;break}else tb=bb}tb=(a[m>>2]|0)-ua|0;a[m>>2]=tb;if(0<(tb|0))Y=tb,ib=ub,kb=Ab;else{ab=tb;nd=ub;pb=Ab;break}}else ab=Pa,nd=vb,pb=Jb;if(0>(ab|0))for(kb=((Cb+25|0)/9|0)+1|0,ib=102==(aa|0),Y=ab,tb=nd,bb=pb;;){yb=0-Y|0;Ub=9<(yb|0)?9:yb;do if(tb>>>0<bb>>>0){yb=(1<<Ub)+-1|0;cb=1E9>>>
Ub;gc=0;for(wb=tb;;)if(rb=a[wb>>2]|0,a[wb>>2]=(rb>>>Ub)+gc,Qd=E(rb&yb,cb)|0,wb=wb+4|0,wb>>>0>=bb>>>0){zb=Qd;break}else gc=Qd;gc=0==(a[tb>>2]|0)?tb+4|0:tb;zb?(a[bb>>2]=zb,Ob=gc,Tb=bb+4|0):(Ob=gc,Tb=bb)}else Ob=0==(a[tb>>2]|0)?tb+4|0:tb,Tb=bb;while(0);ua=ib?vb:Ob;gc=(Tb-ua>>2|0)>(kb|0)?ua+(kb<<2)|0:Tb;Y=(a[m>>2]|0)+Ub|0;a[m>>2]=Y;if(0<=(Y|0)){Wb=Ob;fb=gc;break}else tb=Ob,bb=gc}else Wb=nd,fb=pb;do if(Wb>>>0<fb>>>0)if(bb=9*(ma-Wb>>2)|0,tb=a[Wb>>2]|0,10>tb>>>0)Gb=bb;else for(lb=bb,Kb=10;;)if(Kb=10*Kb|
0,bb=lb+1|0,tb>>>0<Kb>>>0){Gb=bb;break}else lb=bb;else Gb=0;while(0);tb=103==(aa|0);Ub=0!=(Cb|0);bb=Cb-(102!=(aa|0)?Gb:0)+((Ub&tb)<<31>>31)|0;if((bb|0)<((9*(fb-ma>>2)|0)+-9|0)){Y=bb+9216|0;bb=(Y|0)/9|0;kb=vb+(bb+-1023<<2)|0;ib=((Y|0)%9|0)+1|0;if(9>(ib|0))for(Y=10,Pa=ib;;)if(ib=10*Y|0,Pa=Pa+1|0,9==(Pa|0)){Lb=ib;break}else Y=ib;else Lb=10;Y=a[kb>>2]|0;Pa=(Y>>>0)%(Lb>>>0)|0;0==(Pa|0)&&(vb+(bb+-1022<<2)|0)==(fb|0)?(ac=Wb,Yb=kb,kc=Gb):A=163;do if(163==(A|0))if(A=0,Qa=0==(((Y>>>0)/(Lb>>>0)|0)&1|0)?9007199254740992:
9007199254740994,aa=(Lb|0)/2|0,Vb=Pa>>>0<aa>>>0?.5:(Pa|0)==(aa|0)&&(vb+(bb+-1022<<2)|0)==(fb|0)?1:1.5,Bb?45!=(t[qb>>0]|0)?(Pb=Qa,hc=Vb):(Pb=-Qa,hc=-Vb):(Pb=Qa,hc=Vb),aa=Y-Pa|0,a[kb>>2]=aa,Pb+hc==Pb)ac=Wb,Yb=kb,kc=Gb;else{ib=aa+Lb|0;a[kb>>2]=ib;if(999999999<ib>>>0)for(ib=Wb,aa=kb;;)if(gc=aa+-4|0,a[aa>>2]=0,gc>>>0<ib>>>0?(ua=ib+-4|0,a[ua>>2]=0,Sb=ua):Sb=ib,ua=(a[gc>>2]|0)+1|0,a[gc>>2]=ua,999999999<ua>>>0)ib=Sb,aa=gc;else{fc=Sb;kd=gc;break}else fc=Wb,kd=kb;aa=9*(ma-fc>>2)|0;ib=a[fc>>2]|0;if(10>ib>>>
0)ac=fc,Yb=kd,kc=aa;else for(jc=aa,$b=10;;)if($b=10*$b|0,aa=jc+1|0,ib>>>0<$b>>>0){ac=fc;Yb=kd;kc=aa;break}else jc=aa}while(0);kb=Yb+4|0;db=ac;zc=kc;yc=fb>>>0>kb>>>0?kb:fb}else db=Wb,zc=Gb,yc=fb;kb=0-zc|0;for(Pa=yc;;){if(Pa>>>0<=db>>>0){oc=0;lc=Pa;break}Y=Pa+-4|0;if(a[Y>>2]|0){oc=1;lc=Pa;break}else Pa=Y}do if(tb)if(Pa=(Ub&1^1)+Cb|0,(Pa|0)>(zc|0)&-5<(zc|0)?(ec=ha+-1|0,Ie=Pa+-1-zc|0):(ec=ha+-2|0,Ie=Pa+-1|0),Pa=Ha&8)ic=ec,Wd=Ie,Jd=Pa;else{do if(oc)if(Pa=a[lc+-4>>2]|0)if((Pa>>>0)%10|0)bd=0;else for(Ec=
10,Rc=0;;)if(Ec=10*Ec|0,Y=Rc+1|0,(Pa>>>0)%(Ec>>>0)|0){bd=Y;break}else Rc=Y;else bd=9;else bd=9;while(0);Pa=(9*(lc-ma>>2)|0)+-9|0;102==(ec|32)?(Y=Pa-bd|0,bb=0>(Y|0)?0:Y,ic=ec,Wd=(Ie|0)<(bb|0)?Ie:bb):(bb=Pa+zc-bd|0,Pa=0>(bb|0)?0:bb,ic=ec,Wd=(Ie|0)<(Pa|0)?Ie:Pa);Jd=0}else ic=ha,Wd=Cb,Jd=Ha&8;while(0);Cb=Wd|Jd;ma=0!=(Cb|0)&1;if(Ub=102==(ic|32))Gc=0<(zc|0)?zc:0,Be=0;else{tb=0>(zc|0)?kb:zc;Pa=kh(tb,(0>(tb|0))<<31>>31,Q)|0;if(2>(Ra-Pa|0))for(tb=Pa;;)if(bb=tb+-1|0,t[bb>>0]=48,2>(Ra-bb|0))tb=bb;else{nc=bb;
break}else nc=Pa;t[nc+-1>>0]=(zc>>31&2)+43;tb=nc+-2|0;t[tb>>0]=ic;Gc=Ra-tb|0;Be=tb}tb=Bb+1+Wd+ma+Gc|0;Cd(b,32,Ea,tb,Ha);a[b>>2]&32||qd(qb,Bb,b)|0;Cd(b,48,Ea,tb,Ha^65536);do if(Ub){for(bb=kb=db>>>0>vb>>>0?vb:db;;){Y=kh(a[bb>>2]|0,0,G)|0;do if((bb|0)==(kb|0))(Y|0)!=(G|0)?Bc=Y:(t[K>>0]=48,Bc=K);else if(Y>>>0>k>>>0)for(Lc=Y;;)if(ib=Lc+-1|0,t[ib>>0]=48,ib>>>0>k>>>0)Lc=ib;else{Bc=ib;break}else Bc=Y;while(0);a[b>>2]&32||qd(Bc,L-Bc|0,b)|0;Y=bb+4|0;if(Y>>>0>vb>>>0){Hc=Y;break}else bb=Y}!Cb||a[b>>2]&32||qd(164986,
1,b)|0;if(0<(Wd|0)&Hc>>>0<lc>>>0)for(bb=Wd,kb=Hc;;){Y=kh(a[kb>>2]|0,0,G)|0;if(Y>>>0>k>>>0)for(ib=Y;;)if(aa=ib+-1|0,t[aa>>0]=48,aa>>>0>k>>>0)ib=aa;else{Fc=aa;break}else Fc=Y;a[b>>2]&32||qd(Fc,9<(bb|0)?9:bb,b)|0;kb=kb+4|0;ib=bb+-9|0;if(9<(bb|0)&kb>>>0<lc>>>0)bb=ib;else{hd=ib;break}}else hd=Wd;Cd(b,48,hd+9|0,9,0)}else{bb=oc?lc:db+4|0;if(-1<(Wd|0))for(kb=0==(Jd|0),ib=Wd,aa=db;;){gc=kh(a[aa>>2]|0,0,G)|0;(gc|0)==(G|0)?(t[K>>0]=48,Bd=K):Bd=gc;do if((aa|0)==(db|0))gc=Bd+1|0,a[b>>2]&32||qd(Bd,1,b)|0,kb&1>
(ib|0)||a[b>>2]&32||qd(164986,1,b)|0,Cc=gc;else if(Bd>>>0>k>>>0)for(Rb=Bd;;)if(gc=Rb+-1|0,t[gc>>0]=48,gc>>>0>k>>>0)Rb=gc;else{Cc=gc;break}else Cc=Bd;while(0);Y=L-Cc|0;a[b>>2]&32||qd(Cc,(ib|0)>(Y|0)?Y:ib,b)|0;gc=ib-Y|0;aa=aa+4|0;if(aa>>>0<bb>>>0&-1<(gc|0))ib=gc;else{od=gc;break}}else od=Wd;Cd(b,48,od+18|0,18,0);a[b>>2]&32||qd(Be,Ra-Be|0,b)|0}while(0);Cd(b,32,Ea,tb,Ha^8192);Va=(tb|0)<(Ea|0)?Ea:tb}else Cb=0!=(ha&32|0),Ub=(vb=ob!=ob|0)?0:Bb,ma=Ub+3|0,Cd(b,32,Ea,ma,ga),Pa=a[b>>2]|0,Pa&32?tc=Pa:(qd(qb,
Ub,b)|0,tc=a[b>>2]|0),tc&32||qd(vb?Cb?164978:164982:Cb?164970:164974,3,b)|0,Cd(b,32,Ea,ma,Ha^8192),Va=(ma|0)<(Ea|0)?Ea:ma;while(0);v=T;fd=Ka;d=Va;O=Ga;continue a;default:$a=fd,la=Ha,Ba=Zb,va=0,za=164934,ta=H}while(0);b:do if(64==(A|0)){A=0;ha=n;M=a[ha>>2]|0;sa=a[ha+4>>2]|0;ha=mb&32;if(0==(M|0)&0==(sa|0))cc=H,Za=Ya,ia=Sa,qa=0,Ja=164934;else{ma=H;Cb=M;for(M=sa;;)if(sa=ma+-1|0,t[sa>>0]=x[164918+(Cb&15)>>0]|ha,Cb=Oe(Cb|0,M|0,4)|0,M=U,0==(Cb|0)&0==(M|0)){Xb=sa;break}else ma=sa;ma=n;0==(Ya&8|0)|0==(a[ma>>
2]|0)&0==(a[ma+4>>2]|0)?(cc=Xb,Za=Ya,ia=Sa,qa=0,Ja=164934):(cc=Xb,Za=Ya,ia=Sa,qa=2,Ja=164934+(mb>>4)|0)}A=77}else if(76==(A|0))A=0,cc=kh(ea,wa,H)|0,Za=Ha,ia=Zb,qa=Ma,Ja=xa,A=77;else if(82==(A|0))A=0,ma=Tk(nb,0,Zb)|0,M=0==(ma|0),$a=nb,la=ga,Ba=M?Zb:ma-nb|0,va=0,za=164934,ta=M?nb+Zb|0:ma;else if(86==(A|0)){M=ma=A=0;for(Cb=a[n>>2]|0;;){ha=a[Cb>>2]|0;if(!ha){rc=ma;ed=M;break}sa=Mk(y,ha)|0;if(0>(sa|0)|sa>>>0>(sc-ma|0)>>>0){rc=ma;ed=sa;break}ha=sa+ma|0;if(sc>>>0>ha>>>0)ma=ha,M=sa,Cb=Cb+4|0;else{rc=ha;ed=
sa;break}}if(0>(ed|0)){Na=-1;A=252;break a}Cd(b,32,Ea,rc,Ha);if(rc)for(Cb=0,M=a[n>>2]|0;;){ma=a[M>>2]|0;if(!ma){gb=rc;A=98;break b}sa=Mk(y,ma)|0;Cb=sa+Cb|0;if((Cb|0)>(rc|0)){gb=rc;A=98;break b}a[b>>2]&32||qd(y,sa,b)|0;if(Cb>>>0>=rc>>>0){gb=rc;A=98;break}else M=M+4|0}else gb=0,A=98}while(0);98==(A|0)?(A=0,Cd(b,32,Ea,gb,Ha^8192),v=T,fd=Ka,d=(Ea|0)>(gb|0)?Ea:gb):(77==(A|0)&&(A=0,ga=-1<(ia|0)?Za&-65537:Za,M=n,Cb=0!=(a[M>>2]|0)|0!=(a[M+4>>2]|0),0!=(ia|0)|Cb?(M=(Cb&1^1)+(ka-cc)|0,$a=cc,la=ga,Ba=(ia|0)>
(M|0)?ia:M):($a=H,la=ga,Ba=0),va=qa,za=Ja,ta=H),ga=ta-$a|0,M=(Ba|0)<(ga|0)?ga:Ba,Cb=va+M|0,sa=(Ea|0)<(Cb|0)?Cb:Ea,Cd(b,32,sa,Cb,la),a[b>>2]&32||qd(za,va,b)|0,Cd(b,48,sa,Cb,la^65536),Cd(b,48,M,ga,0),a[b>>2]&32||qd($a,ga,b)|0,Cd(b,32,sa,Cb,la^8192),v=T,fd=Ka,d=sa)}else v=T,fd=Ka,d=M;O=Ga}}if(245==(A|0)){if(b)return Na=X,u=g,Na|0;if(!P)return Na=0,u=g,Na|0;if(P=a[f+4>>2]|0)if(bg(e+8|0,P,c),P=a[f+8>>2]|0)if(bg(e+16|0,P,c),P=a[f+12>>2]|0)if(bg(e+24|0,P,c),P=a[f+16>>2]|0)if(bg(e+32|0,P,c),P=a[f+20>>2]|
0)if(bg(e+40|0,P,c),P=a[f+24>>2]|0)if(bg(e+48|0,P,c),P=a[f+28>>2]|0)if(bg(e+56|0,P,c),P=a[f+32>>2]|0){bg(e+64|0,P,c);if(P=a[f+36>>2]|0)return bg(e+72|0,P,c),Na=1,u=g,Na|0;gd=9}else gd=8;else gd=7;else gd=6;else gd=5;else gd=4;else gd=3;else gd=2;else gd=1;for(;;){if(a[f+(gd<<2)>>2]|0){Na=-1;A=252;break}gd=gd+1|0;if(10<=(gd|0)){Na=1;A=252;break}}}return 252==(A|0)?(u=g,Na|0):0}function Bk(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p;g=u;u=u+240|0;a[g>>2]=b;if(1>=(e|0))Ck(d,g,1),u=g;else{h=
0-d|0;m=e;k=e=b;for(b=1;;){l=e+h|0;n=m+-2|0;e=e+(0-((a[f+(n<<2)>>2]|0)+d))|0;if(-1<(dd[c&127](k,e)|0)&&-1<(dd[c&127](k,l)|0)){c=b;f=10;break}p=b+1|0;b=g+(b<<2)|0;-1<(dd[c&127](e,l)|0)?(l=a[b>>2]=e,m=m+-1|0):(a[b>>2]=l,m=n);if(1>=(m|0)){c=p;f=10;break}e=l;k=a[g>>2]|0;b=p}10==(f|0)&&(Ck(d,g,c),u=g)}}function ji(b,d,c,e,f,g,h){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;h|=0;var m,k,l,n=0,p,q,y,B,H,t,z,Q=0,C=0,Ra=0,r=0,w=0,x=0,I,G=0,L=0,K=0,v=0,E=0,O=0,M=0,T=0;m=u;u=u+240|0;k=a[e>>2]|0;l=a[e+4>>2]|0;a[m>>2]=b;e=0-
d|0;a:do if(0!=(l|0)|1!=(k|0)&&(n=b+(0-(a[h+(f<<2)>>2]|0))|0,1<=(dd[c&127](n,b)|0)))for(p=b,q=f,y=0==(g|0),B=n,n=k,H=l,t=1;;){if(y&1<(q|0)){z=a[h+(q+-2<<2)>>2]|0;if(-1<(dd[c&127](p+e|0,B)|0)){Q=p;C=q;Ra=t;break a}if(-1<(dd[c&127](p+(0-(z+d))|0,B)|0)){Q=p;C=q;Ra=t;break a}}z=t+1|0;a[m+(t<<2)>>2]=B;y=n+-1|0;do if(y){if(y&1)w=11;else{p=y;for(t=0;;)if(t=t+1|0,p>>>=1,p&1){p=t;break}p?r=p:w=11}if(11==(w|0)){w=0;if(!H){x=64;w=16;break}if(H&1){G=0;L=n;K=H;v=0;break}else I=H,p=0;for(;!(t=p+1|0,I>>>=1,I&1);)p=
t;if(t)r=p+33|0;else{G=0;L=n;K=H;v=0;break}}31<r>>>0?(x=r,w=16):(G=r,L=n,K=H,v=r)}else x=32,w=16;while(0);16==(w|0)&&(w=0,G=x+-32|0,L=H,K=0,v=x);n=K<<32-G|L>>>G;H=K>>>G;y=v+q|0;if(!(0!=(H|0)|1!=(n|0))){Q=B;C=y;Ra=z;break a}t=B+(0-(a[h+(y<<2)>>2]|0))|0;if(1>(dd[c&127](t,a[m>>2]|0)|0)){E=B;O=y;M=0;T=z;w=19;break}else p=B,q=y,y=1,B=t,t=z}else E=b,O=f,M=g,T=1,w=19;while(0);if(19==(w|0)){if(M){u=m;return}Q=E;C=O;Ra=T}Ck(d,m,Ra);Bk(Q,d,c,C,h);u=m}function Ck(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m;e=u;u=u+
256|0;f=e;if(!(2>(c|0))&&(g=d+(c<<2)|0,a[g>>2]=f,b))for(h=b,b=f;;){f=256<h>>>0?256:h;Ec(b|0,a[d>>2]|0,f|0)|0;b=0;do m=d+(b<<2)|0,b=b+1|0,Ec(a[m>>2]|0,a[d+(b<<2)>>2]|0,f|0)|0,a[m>>2]=(a[m>>2]|0)+f;while((b|0)!=(c|0));if((h|0)==(f|0))break;h=h-f|0;b=a[g>>2]|0}u=e}function bg(b,d,c){b|=0;d|=0;c|=0;var e,f;if(!(20<d>>>0))switch(d|0){case 9:d=(a[c>>2]|0)+3&-4;e=a[d>>2]|0;a[c>>2]=d+4;a[b>>2]=e;break;case 10:e=(a[c>>2]|0)+3&-4;d=a[e>>2]|0;a[c>>2]=e+4;e=b;a[e>>2]=d;a[e+4>>2]=(0>(d|0))<<31>>31;break;case 11:d=
(a[c>>2]|0)+3&-4;e=a[d>>2]|0;a[c>>2]=d+4;d=b;a[d>>2]=e;a[d+4>>2]=0;break;case 12:e=d=(a[c>>2]|0)+7&-8;f=a[e>>2]|0;e=a[e+4>>2]|0;a[c>>2]=d+8;d=b;a[d>>2]=f;a[d+4>>2]=e;break;case 13:e=(a[c>>2]|0)+3&-4;d=a[e>>2]|0;a[c>>2]=e+4;e=(d&65535)<<16>>16;d=b;a[d>>2]=e;a[d+4>>2]=(0>(e|0))<<31>>31;break;case 14:e=(a[c>>2]|0)+3&-4;d=a[e>>2]|0;a[c>>2]=e+4;e=b;a[e>>2]=d&65535;a[e+4>>2]=0;break;case 15:e=(a[c>>2]|0)+3&-4;d=a[e>>2]|0;a[c>>2]=e+4;e=(d&255)<<24>>24;d=b;a[d>>2]=e;a[d+4>>2]=(0>(e|0))<<31>>31;break;case 16:e=
(a[c>>2]|0)+3&-4;d=a[e>>2]|0;a[c>>2]=e+4;e=b;a[e>>2]=d&255;a[e+4>>2]=0;break;case 17:e=(a[c>>2]|0)+7&-8;d=+Hb[e>>3];a[c>>2]=e+8;Hb[b>>3]=d;break;case 18:e=(a[c>>2]|0)+7&-8,d=+Hb[e>>3],a[c>>2]=e+8,Hb[b>>3]=d}}function kh(a,d,c){a|=0;d|=0;c|=0;var e;if(0<d>>>0|0==(d|0)&4294967295<a>>>0)for(e=d;;)if(d=vk(a|0,e|0,10,0)|0,c=c+-1|0,t[c>>0]=d|48,d=pf(a|0,e|0,10,0)|0,9<e>>>0|9==(e|0)&4294967295<a>>>0)a=d,e=U;else break;else d=a;if(d)a=c,c=d;else return c|0;for(;!(d=a+-1|0,t[d>>0]=(c>>>0)%10|48,10>c>>>0);)a=
d,c=(c>>>0)/10|0;return d|0}function Cd(b,d,c,e,f){b|=0;c|=0;e|=0;var g,h,m;g=u;u=u+256|0;if((c|0)>(e|0)&0==((f|0)&73728|0)){f=c-e|0;Va(g|0,d|0,(256<f>>>0?256:f)|0)|0;d=a[b>>2]|0;h=0==(d&32|0);if(255<f>>>0){m=c-e|0;e=f;c=d;for(d=h;!(d&&(qd(g,256,b)|0,c=a[b>>2]|0),e=e+-256|0,d=0==(c&32|0),255>=e>>>0););if(d)d=m&255;else{u=g;return}}else if(h)d=f;else{u=g;return}qd(g,d,b)|0}u=g}function Fi(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,y,B,H;f=u;u=u+1296|0;g=f+1028|0;3<c>>>0&&(h=a[b>>2]|0,a[h+20>>
2]=52,a[h+24>>2]=c,R[a[h>>2]&127](b));h=0!=(d|0);d=a[(h?b+180+(c<<2)|0:b+196+(c<<2)|0)>>2]|0;d||(m=a[b>>2]|0,a[m+20>>2]=52,a[m+24>>2]=c,R[a[m>>2]&127](b));(m=a[e>>2]|0)?(k=b,l=m):(c=Aa[a[a[b+4>>2]>>2]&63](b,1,1424)|0,a[e>>2]=c,k=b,l=c);a[l+140>>2]=d;m=1;for(c=0;;)if(e=t[d+m>>0]|0,n=e&255,p=n+c|0,256<(p|0)&&(q=a[b>>2]|0,a[q+20>>2]=9,R[a[q>>2]&127](k)),e<<24>>24?(Va(g+c|0,m&255|0,n|0)|0,y=p):y=c,m=m+1|0,17==(m|0)){B=y;break}else c=y;t[g+B>>0]=0;y=t[g>>0]|0;if(y<<24>>24)for(c=y,p=m=0,n=y<<24>>24;;){if((c<<
24>>24|0)==(n|0))for(y=m,e=p;;)if(q=e+1|0,a[f+(e<<2)>>2]=y,m=y+1|0,p=t[g+q>>0]|0,(p<<24>>24|0)==(n|0))y=m,e=q;else{c=p;y=m;break}else y=m,q=p;(y|0)>=(1<<n|0)&&(e=a[b>>2]|0,a[e+20>>2]=9,R[a[e>>2]&127](k));if(c<<24>>24)m=y<<1,p=q,n=n+1|0;else{e=1;m=0;break}}else e=1,m=0;for(;n=d+e|0,t[n>>0]|0?(a[l+72+(e<<2)>>2]=m-(a[f+(m<<2)>>2]|0),q=(x[n>>0]|0)+m|0,H=a[f+(q+-1<<2)>>2]|0,g=q):(H=-1,g=m),a[l+(e<<2)>>2]=H,e=e+1|0,17!=(e|0);)m=g;a[l+68>>2]=1048575;Va(l+144|0,0,1024)|0;g=1;for(m=0;;){e=d+g|0;if(t[e>>0]|
0)for(H=8-g|0,q=1<<H,n=1,p=m;;){y=d+17+p|0;m=q;for(c=a[f+(p<<2)>>2]<<H;;)if(a[l+144+(c<<2)>>2]=g,t[l+1168+c>>0]=t[y>>0]|0,1<(m|0))m=m+-1|0,c=c+1|0;else break;c=p+1|0;if((n|0)<(x[e>>0]|0))n=n+1|0,p=c;else{n=c;break}}else n=m;g=g+1|0;if(9==(g|0))break;else m=n}if(h&0<(B|0)){l=0;do 15<(x[d+17+l>>0]|0)&&(h=a[b>>2]|0,a[h+20>>2]=9,R[a[h>>2]&127](k)),l=l+1|0;while((l|0)!=(B|0))}u=f}function Uc(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,y,B=0,H=0,ka,z,Q,C,u,r=0,w=0,x=0,I=0,G=0,L=0,K=0,v=0,E=0,O=0,
M=0,T=0,A=0;f=a[b>>2]|0;g=b+4|0;h=a[g>>2]|0;m=a[b+16>>2]|0;k=m+440|0;a:do if(a[k>>2]|0)O=d,M=c,T=h,A=f,H=14;else if(25>(c|0)){l=m+24|0;n=d;p=c;q=h;y=f;b:for(;;){if(q)ka=q;else{if(!(da[a[(a[l>>2]|0)+12>>2]&63](m)|0)){B=0;H=19;break}q=a[l>>2]|0;ka=a[q+4>>2]|0;y=a[q>>2]|0}q=ka+-1|0;ka=y+1|0;z=t[y>>0]|0;Q=z&255;c:do if(-1==z<<24>>24)for(y=q;;){if(y)q=y,y=ka;else{if(!(da[a[(a[l>>2]|0)+12>>2]&63](m)|0)){B=0;H=19;break b}ka=a[l>>2]|0;q=a[ka+4>>2]|0;y=a[ka>>2]|0}ka=q+-1|0;q=y+1|0;y=t[y>>0]|0;switch(y<<24>>
24){case 0:y=ka;C=255;u=q;break c;case -1:y=ka;ka=q;break;default:r=n;w=p;x=ka;I=q;G=y;H=12;break b}}else y=q,C=Q,u=ka;while(0);ka=C|n<<8;Q=p+8|0;if(25>(Q|0))n=ka,p=Q,q=y,y=u;else{L=ka;K=Q;v=y;E=u;break a}}if(12==(H|0))a[k>>2]=G&255,O=r,M=w,T=x,A=I,H=14;else if(19==(H|0))return B|0}else L=d,K=c,v=h,E=f;while(0);14==(H|0)&&((M|0)<(e|0)?(e=m+468|0,a[(a[e>>2]|0)+40>>2]|0||(H=a[m>>2]|0,a[H+20>>2]=120,ub[a[H+4>>2]&31](m,-1),a[(a[e>>2]|0)+40>>2]=1),L=O<<25-M,K=25):(L=O,K=M),v=T,E=A);a[b>>2]=E;a[g>>2]=v;
a[b+8>>2]=L;a[b+12>>2]=K;return 1}function Tf(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p;if((c|0)<(f|0))if(Uc(b,d,c,f)|0)g=a[b+8>>2]|0,h=a[b+12>>2]|0;else return-1;else g=d,h=c;c=h-f|0;h=g>>c&a[122072+(f<<2)>>2];d=b+8|0;m=b+12|0;a:do{if((h|0)>(a[e+(f<<2)>>2]|0)){k=g;l=c;c=h;for(h=f;;){f=c<<1;if(1>(l|0)){if(!(Uc(b,k,l,1)|0)){b=-1;break}k=a[d>>2]|0;l=a[m>>2]|0}l=l+-1|0;c=k>>>l&1|f;f=h+1|0;if((c|0)>(a[e+(f<<2)>>2]|0))h=f;else{n=c;p=f;break a}}return b|0}k=g;l=c;n=h;p=f}while(0);a[d>>2]=k;
a[m>>2]=l;if(16<(p|0))return l=a[b+16>>2]|0,b=a[l>>2]|0,a[b+20>>2]=121,ub[a[b+4>>2]&31](l,-1),0;b=x[(a[e+72+(p<<2)>>2]|0)+n+((a[e+140>>2]|0)+17)>>0]|0;return b|0}function Dj(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l=0,n=0,p=0,q,y;e=u;u=u+16|0;f=b|0;g=d|0;h=c|0;k=0;m=ki(f,g,0)|0;if((!m||65535>=g>>>0&&(k=w[m+24>>1]|0,0==(1<<(k&31)&a[f+40+(((k&65535)>>>5&65535)<<2)>>2]|0))?0:Aa[a[f+672>>2]&63](f,g,h)|0)|0)return u=e,1;if(318<=(d|0)){if(530>(d|0))switch(d|0){case 336:return f=(a[c>>2]|0)+3&-4,g=a[f>>2]|
0,a[c>>2]=f+4,w[g>>1]=0,g=(1<<N[b+84>>1])+65535&65535,f=(a[c>>2]|0)+3&-4,h=a[f>>2]|0,a[c>>2]=f+4,w[h>>1]=g,u=e,1;case 332:return g=(a[c>>2]|0)+3&-4,h=a[g>>2]|0,a[c>>2]=g+4,w[h>>1]=1,u=e,1;case 334:return h=(a[c>>2]|0)+3&-4,g=a[h>>2]|0,a[c>>2]=h+4,w[g>>1]=4,u=e,1;case 338:return g=w[b+156>>1]|0,h=(a[c>>2]|0)+3&-4,f=a[h>>2]|0,a[c>>2]=h+4,w[f>>1]=g,g=a[b+160>>2]|0,f=(a[c>>2]|0)+3&-4,h=a[f>>2]|0,a[c>>2]=f+4,a[h>>2]=g,u=e,1;case 339:return g=w[b+86>>1]|0,h=(a[c>>2]|0)+3&-4,f=a[h>>2]|0,a[c>>2]=h+4,w[f>>
1]=g,u=e,1;case 529:return g=(a[c>>2]|0)+3&-4,f=a[g>>2]|0,a[c>>2]=g+4,a[f>>2]=7740,u=e,1;case 318:return W[1938]=.3457419276237488,W[1939]=.3585604429244995,f=(a[c>>2]|0)+3&-4,g=a[f>>2]|0,a[c>>2]=f+4,a[g>>2]=7752,u=e,1;default:return u=e,0}if(32995<=(d|0))switch(d|0){case 32995:return m=1==(w[b+156>>1]|0)?1==(w[a[b+160>>2]>>1]|0)&1:0,g=(a[c>>2]|0)+3&-4,f=a[g>>2]|0,a[c>>2]=g+4,w[f>>1]=m,u=e,1;case 32998:return m=a[b+76>>2]|0,f=(a[c>>2]|0)+3&-4,g=a[f>>2]|0,a[c>>2]=f+4,a[g>>2]=m,u=e,1;case 32996:return m=
(N[b+86>>1]|0)+65535&65535,g=(a[c>>2]|0)+3&-4,f=a[g>>2]|0,a[c>>2]=g+4,w[f>>1]=m,u=e,1;case 32997:return m=a[b+64>>2]|0,f=(a[c>>2]|0)+3&-4,g=a[f>>2]|0,a[c>>2]=f+4,a[g>>2]=m,u=e,1;default:return u=e,0}switch(d|0){case 530:return m=w[b+192>>1]|0,g=(a[c>>2]|0)+3&-4,f=a[g>>2]|0,a[c>>2]=g+4,w[f>>1]=m,m=w[b+194>>1]|0,f=(a[c>>2]|0)+3&-4,g=a[f>>2]|0,a[c>>2]=f+4,w[g>>1]=m,u=e,1;case 531:return m=w[b+196>>1]|0,g=(a[c>>2]|0)+3&-4,f=a[g>>2]|0,a[c>>2]=g+4,w[f>>1]=m,u=e,1;case 532:m=b+212|0;if(g=f=a[m>>2]|0)d=g;
else{h=eb(24)|0;a[m>>2]=h;if(!h)return u=e,0;6==(w[b+90>>1]|0)?(W[h>>2]=0,W[h+20>>2]=255,W[h+12>>2]=255,W[h+4>>2]=255,W[h+16>>2]=128,W[h+8>>2]=128):(k=+((1<<N[b+84>>1])+-1|0),W[h>>2]=0,W[h+4>>2]=k,W[h+8>>2]=0,W[h+12>>2]=k,W[h+16>>2]=0,W[h+20>>2]=k);d=h}g=(a[c>>2]|0)+3&-4;m=a[g>>2]|0;a[c>>2]=g+4;a[m>>2]=d;u=e;return 1;default:return u=e,0}}do switch(d|0){case 254:return d=a[b+80>>2]|0,m=(a[c>>2]|0)+3&-4,g=a[m>>2]|0,a[c>>2]=m+4,a[g>>2]=d,b=1,u=e,b|0;case 258:return d=w[b+84>>1]|0,g=(a[c>>2]|0)+3&-4,
m=a[g>>2]|0,a[c>>2]=g+4,w[m>>1]=d,b=1,u=e,b|0;case 263:return d=w[b+92>>1]|0,m=(a[c>>2]|0)+3&-4,g=a[m>>2]|0,a[c>>2]=m+4,w[g>>1]=d,b=1,u=e,b|0;case 266:return d=w[b+94>>1]|0,g=(a[c>>2]|0)+3&-4,m=a[g>>2]|0,a[c>>2]=g+4,w[m>>1]=d,b=1,u=e,b|0;case 274:return d=w[b+96>>1]|0,m=(a[c>>2]|0)+3&-4,g=a[m>>2]|0,a[c>>2]=m+4,w[g>>1]=d,b=1,u=e,b|0;case 277:return d=w[b+98>>1]|0,g=(a[c>>2]|0)+3&-4,m=a[g>>2]|0,a[c>>2]=g+4,w[m>>1]=d,b=1,u=e,b|0;case 278:return d=a[b+100>>2]|0,m=(a[c>>2]|0)+3&-4,g=a[m>>2]|0,a[c>>2]=
m+4,a[g>>2]=d,b=1,u=e,b|0;case 280:return d=w[b+104>>1]|0,g=(a[c>>2]|0)+3&-4,m=a[g>>2]|0,a[c>>2]=g+4,w[m>>1]=d,b=1,u=e,b|0;case 281:return d=w[b+106>>1]|0,m=(a[c>>2]|0)+3&-4,g=a[m>>2]|0,a[c>>2]=m+4,w[g>>1]=d,b=1,u=e,b|0;case 284:return d=w[b+126>>1]|0,g=(a[c>>2]|0)+3&-4,m=a[g>>2]|0,a[c>>2]=g+4,w[m>>1]=d,b=1,u=e,b|0;case 296:return d=w[b+124>>1]|0,m=(a[c>>2]|0)+3&-4,g=a[m>>2]|0,a[c>>2]=m+4,w[g>>1]=d,b=1,u=e,b|0;case 317:return d=a[a[b+576>>2]>>2]&65535,g=(a[c>>2]|0)+3&-4,m=a[g>>2]|0,a[c>>2]=g+4,w[m>>
1]=d,b=1,u=e,b|0;case 301:d=b+200|0;m=a[d>>2]|0;do if(m)f=b+156|0,g=b+98|0,h=m;else{g=b+200|0;f=b+208|0;a[f>>2]=0;m=b+204|0;a[m>>2]=0;a[g>>2]=0;h=w[b+84>>1]|0;if(29>=(h&65535)&&(l=1<<(h&65535),h=l<<1,n=eb(h)|0,a[g>>2]=n,p=n,0!=(n|0))){w[n>>1]=0;if(1<(l|0)){k=+(l|0)+-1;q=1;do y=~~+Lj(+(65535*+Oi(+(+(q|0)/k),2.2)+.5))&65535,w[n+(q<<1)>>1]=y,q=q+1|0;while((q|0)!=(l|0))}l=b+98|0;q=b+156|0;if(1>=((N[l>>1]|0)-(N[q>>1]|0)|0)){f=q;g=l;h=p;break}n=eb(h)|0;a[m>>2]=n;if(0!=(n|0)&&(Ab(n,a[g>>2]|0,h),n=eb(h)|
0,a[f>>2]=n,0!=(n|0))){Ab(n,a[g>>2]|0,h);f=q;g=l;h=a[d>>2]|0;break}(l=a[g>>2]|0)&&ja(l);(l=a[m>>2]|0)&&ja(l);(l=a[f>>2]|0)&&ja(l);a[f>>2]=0;a[m>>2]=0;a[g>>2]=0}Y(a[b+628>>2]|0,a[b>>2]|0,140044,e);b=0;u=e;return b|0}while(0);m=(a[c>>2]|0)+3&-4;d=a[m>>2]|0;a[c>>2]=m+4;a[d>>2]=h;if(1>=((N[g>>1]|0)-(N[f>>1]|0)|0))return b=1,u=e,b|0;d=a[b+204>>2]|0;m=(a[c>>2]|0)+3&-4;l=a[m>>2]|0;a[c>>2]=m+4;a[l>>2]=d;d=a[b+208>>2]|0;l=(a[c>>2]|0)+3&-4;m=a[l>>2]|0;a[c>>2]=l+4;a[m>>2]=d;b=1;u=e;return b|0;default:return b=
0,u=e,b|0}while(0)}function ne(b,d,c){var e;e=u;u=u+16|0;a[e>>2]=c|0;c=Dj(b|0,d|0,e)|0;u=e;return c|0}function Kb(b,d,c,e,f,g,h){b|=0;d|=0;c|=0;e|=0;var m;m=0>(c|0)?0:255<(c|0)?255:c;c=0>(e|0)?0:255<(e|0)?255:e;e=(a[b+20>>2]|0)+((255<d>>>0?255:d)<<2)|0;d=(a[(a[b+4>>2]|0)+(c<<2)>>2]|0)+(a[e>>2]|0)|0;a[(f|0)>>2]=0>(d|0)?0:255<(d|0)?255:d;d=((a[(a[b+12>>2]|0)+(c<<2)>>2]|0)+(a[(a[b+16>>2]|0)+(m<<2)>>2]|0)>>16)+(a[e>>2]|0)|0;a[(g|0)>>2]=0>(d|0)?0:255<(d|0)?255:d;d=(a[(a[b+8>>2]|0)+(m<<2)>>2]|0)+(a[e>>
2]|0)|0;a[(h|0)>>2]=0>(d|0)?0:255<(d|0)?255:d}function Ng(b){b|=0;a[b+504>>2]=4;a[b+500>>2]=1;a[b+508>>2]=5;a[b+512>>2]=20;a[b+532>>2]=6;a[b+540>>2]=7;a[b+548>>2]=8;a[b+520>>2]=1;a[b+516>>2]=5;a[b+524>>2]=20;a[b+528>>2]=5;a[b+536>>2]=9;a[b+544>>2]=10;a[b+552>>2]=11;a[b+556>>2]=1;a[b+560>>2]=21;a[b+564>>2]=1;a[b+568>>2]=22;a[b+572>>2]=8;b=b+12|0;a[b>>2]&=-131329}function Ej(b){b|=0;var d,c;d=a[1940]|0;a:do if(d){for(;;){c=a[d+4>>2]|0;if((w[c+4>>1]|0)==b<<16>>16){b=c;break}d=a[d>>2]|0;if(!d)break a}return b|
0}while(0);if(a[1941]|0)d=7764;else return 0;for(;;){if((w[d+4>>1]|0)==b<<16>>16){b=d;d=7;break}d=d+12|0;if(!(a[d>>2]|0)){b=0;d=7;break}}return 7==(d|0)?b|0:0}function Fj(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C,Ra,r,w,x,I,G,L=0,K,v,E,O=0,M=0;d=u;u=u+112|0;c=d+88|0;e=d+80|0;f=d+72|0;g=d+64|0;h=d+56|0;m=d+48|0;k=d+40|0;l=d+32|0;n=d+24|0;p=d+100|0;q=d+96|0;y=d+92|0;B=d+16|0;H=d+8|0;z=t=b+16|0;Q=a[z>>2]|0;C=a[z+4>>2]|0;if(0==(Q|0)&0==(C|0))return b=Zk(b,1,1,0)|0,u=d,b|0;z=b+12|0;do if(a[z>>
2]&524288){x=I=b+432|0;r=a[x>>2]|0;G=a[x+4>>2]|0;if((r|0)==(Q|0)&(G|0)==(C|0)){x=I;a[x>>2]=0;a[x+4>>2]=0;x=t;a[x>>2]=0;a[x+4>>2]=0;x=b+628|0;rb[a[b+640>>2]&63](a[x>>2]|0,8,0,0)|0;if(8==(Aa[a[b+636>>2]&63](a[x>>2]|0,I,8)|0))break;Y(a[x>>2]|0,a[b>>2]|0,140316,h);b=0;u=d;return b|0}x=b+640|0;I=b+628|0;Ra=b+632|0;K=r;for(r=G;;){G=rb[a[x>>2]&63](a[I>>2]|0,K,r,0)|0;if(!((G|0)==(K|0)&(U|0)==(r|0))){G=27;break}if(8!=(Aa[a[Ra>>2]&63](a[I>>2]|0,B,8)|0)){G=27;break}a[z>>2]&128&&kc(B);G=B;w=a[G>>2]|0;v=a[G+4>>
2]|0;if(0<v>>>0|0==(v|0)&65535<w>>>0){G=31;break}v=a[x>>2]|0;G=a[I>>2]|0;r=Qb(K|0,r|0,8,0)|0;E=Qb(r|0,U|0,20*(w&65535)|0,0)|0;w=U;rb[v&63](G,E,w,0)|0;if(8!=(Aa[a[Ra>>2]&63](a[I>>2]|0,H,8)|0)){G=33;break}a[z>>2]&128&&kc(H);G=H;K=a[G>>2]|0;r=a[G+4>>2]|0;G=t;if((K|0)==(a[G>>2]|0)&&(r|0)==(a[G+4>>2]|0)){O=E;M=w;G=37;break}}if(27==(G|0))return Y(a[I>>2]|0,140343,140364,g),b=0,u=d,b|0;if(31==(G|0))return Y(a[I>>2]|0,140343,140454,f),b=0,u=d,b|0;if(33==(G|0))return Y(a[I>>2]|0,140343,140395,e),b=0,u=d,b|
0;if(37==(G|0))if(r=d,a[r>>2]=0,a[r+4>>2]=0,rb[a[x>>2]&63](a[I>>2]|0,O,M,0)|0,8==(Aa[a[b+636>>2]&63](a[I>>2]|0,d,8)|0))r=t,a[r>>2]=0,a[r+4>>2]=0;else return Y(a[I>>2]|0,140343,140425,c),b=0,u=d,b|0}else{Ra=b+428|0;r=a[Ra>>2]|0;if((r|0)==(Q|0)&0==(C|0)){a[Ra>>2]=0;w=t;a[w>>2]=0;a[w+4>>2]=0;w=b+628|0;rb[a[b+640>>2]&63](a[w>>2]|0,4,0,0)|0;if(4==(Aa[a[b+636>>2]&63](a[w>>2]|0,Ra,4)|0))break;Y(a[w>>2]|0,a[b>>2]|0,140316,n);b=0;u=d;return b|0}w=b+640|0;Ra=b+628|0;x=b+632|0;for(I=r;;){r=rb[a[w>>2]&63](a[Ra>>
2]|0,I,0,0)|0;if(!((r|0)==(I|0)&0==(U|0))){G=10;break}if(2!=(Aa[a[x>>2]&63](a[Ra>>2]|0,p,2)|0)){G=10;break}a[z>>2]&128&&ac(p);r=I+2|0;rb[a[w>>2]&63](a[Ra>>2]|0,(12*(N[p>>1]|0)|0)+r|0,0,0)|0;if(4!=(Aa[a[x>>2]&63](a[Ra>>2]|0,q,4)|0)){G=14;break}a[z>>2]&128&&pb(q);I=a[q>>2]|0;G=t;if((I|0)==(a[G>>2]|0)&&0==(a[G+4>>2]|0)){L=r;G=18;break}}if(10==(G|0))return Y(a[Ra>>2]|0,140343,140364,l),b=0,u=d,b|0;if(14==(G|0))return Y(a[Ra>>2]|0,140343,140395,k),b=0,u=d,b|0;if(18==(G|0))if(a[y>>2]=0,rb[a[w>>2]&63](a[Ra>>
2]|0,(12*(N[p>>1]|0)|0)+L|0,0,0)|0,4==(Aa[a[b+636>>2]&63](a[Ra>>2]|0,y,4)|0))I=t,a[I>>2]=0,a[I+4>>2]=0;else return Y(a[Ra>>2]|0,140343,140425,m),b=0,u=d,b|0}while(0);b=Zk(b,1,1,0)|0;u=d;return b|0}function Ni(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C,Ra,r,x,J,I,G,L,K,v,A,O,M,T,X,P=0,Oa=0,D=0,F=0,ba=0,R=0,S=0,W=0;g=u;u=u+176|0;h=g+128|0;m=g+120|0;k=g+112|0;l=g+104|0;n=g+96|0;p=g+88|0;q=g+80|0;y=g+72|0;B=g+64|0;H=g+56|0;t=g+48|0;z=g+40|0;Q=g+160|0;C=g+140|0;Ra=g+138|0;r=
g+136|0;x=g+16|0;J=g+8|0;I=g;G=g+132|0;w[Ra>>1]=0;w[r>>1]=0;L=x;a[L>>2]=0;a[L+4>>2]=0;L=J;a[L>>2]=0;a[L+4>>2]=0;L=d&65535;ki(b,L,0)|0;K=b+12|0;if(a[K>>2]&2048)return Y(a[b+628>>2]|0,140508,140523,g+24|0),u=g,0;A=v=b+16|0;O=a[A>>2]|0;M=a[A+4>>2]|0;if(0==(O|0)&0==(M|0))return Y(a[b+628>>2]|0,140508,140587,g+32|0),u=g,0;A=b+640|0;T=b+628|0;X=rb[a[A>>2]&63](a[T>>2]|0,O,M,0)|0;M=U;O=v;if((X|0)!=(a[O>>2]|0)||(M|0)!=(a[O+4>>2]|0))return O=a[T>>2]|0,a[z>>2]=a[b>>2],Y(O,140508,140644,z),u=g,0;z=b+632|0;O=
a[z>>2]|0;v=a[T>>2]|0;if(a[K>>2]&524288){if(8!=(Aa[O&63](v,I,8)|0))return v=a[T>>2]|0,a[H>>2]=a[b>>2],Y(v,140508,140684,H),u=g,0;a[K>>2]&128&&kc(I);H=a[I>>2]&65535;w[Q>>1]=H;I=Qb(X|0,M|0,8,0)|0;ba=H;R=I;S=U;W=20}else{if(2!=(Aa[O&63](v,Q,2)|0))return d=a[T>>2]|0,a[t>>2]=a[b>>2],Y(d,140508,140684,t),u=g,0;a[K>>2]&128&&ac(Q);P=t=Qb(X|0,M|0,2,0)|0;Oa=U;D=12;F=18}for(;;){18==(F|0)&&(F=0,ba=w[Q>>1]|0,R=P,S=Oa,W=D);if(!(ba<<16>>16)){F=26;break}if((Aa[a[z>>2]&63](a[T>>2]|0,C,W)|0)!=(W|0)){F=21;break}I=w[C>>
1]|0;w[Ra>>1]=I;a[K>>2]&128?(ac(Ra),t=w[Ra>>1]|0):t=I;if(t<<16>>16==d<<16>>16)break;P=I=Qb(R|0,S|0,W|0,0)|0;Oa=U;D=W;F=18}if(21==(F|0))return D=a[T>>2]|0,a[B>>2]=a[b>>2],Y(D,140508,140722,B),u=g,0;if(26==(F|0)&&(w[Ra>>1]|0)!=d<<16>>16)return d=a[T>>2]|0,a[y>>2]=a[b>>2],a[y+4>>2]=L,Y(d,140508,140761,y),u=g,0;y=C+2|0;w[r>>1]=w[y>>1]|0;d=a[K>>2]|0;d&128?(ac(r),B=a[K>>2]|0):B=d;d=C+4|0;B&524288?(Ra=L=d,F=L+4|0,L=N[F>>1]|N[F+2>>1]<<16,F=x,a[F>>2]=N[Ra>>1]|N[Ra+2>>1]<<16,a[F+4>>2]=L,B&128?(kc(x),t=a[K>>
2]|0):t=B,F=L=C+12|0,Ra=L+4|0,L=N[Ra>>1]|N[Ra+2>>1]<<16,Ra=J,a[Ra>>2]=N[F>>1]|N[F+2>>1]<<16,a[Ra+4>>2]=L,t&128&&kc(J)):(t=N[d>>1]|N[d+2>>1]<<16,a[G>>2]=t,B&128?(pb(G),L=a[G>>2]|0,F=a[K>>2]|0):(L=t,F=B),B=x,a[B>>2]=L,a[B+4>>2]=0,B=C+8|0,L=N[B>>1]|N[B+2>>1]<<16,a[G>>2]=L,F&128?(pb(G),t=a[G>>2]|0):t=L,G=J,a[G>>2]=t,a[G+4>>2]=0);a:do if(8==(Ne(c)|0)&&0==(a[K>>2]&524288|0))switch(c|0){case 16:Ra=4;break a;case 17:Ra=9;break a;case 18:Ra=13;break a;default:Ra=c;break a}else Ra=c;while(0);G=Mf(b,e,Ne(Ra)|
0,140788)|0;if(!G)return u=g,0;a:do if((Ra|0)==(c|0))Ec(G|0,f|0,E(Ne(c)|0,e)|0)|0;else{if(17==(c|0)&9==(Ra|0)){if(0>=(e|0))break;for(t=0;;){L=f+(t<<3)|0;F=a[L>>2]|0;B=a[L+4>>2]|0;a[G+(t<<2)>>2]=F;t=t+1|0;if(!((F|0)==(F|0)&((0>(F|0))<<31>>31|0)==(B|0)))break;if((t|0)>=(e|0))break a}ja(G);Y(a[T>>2]|0,140508,140806,q);b=0;u=g;return b|0}if(16==(c|0)&4==(Ra|0)){if(0>=(e|0))break}else if(!(18==(c|0)&13==(Ra|0)&0<(e|0)))break;for(t=0;;){B=f+(t<<3)|0;F=a[B>>2]|0;L=a[B+4>>2]|0;a[G+(t<<2)>>2]=F;t=t+1|0;if(!((F|
0)==(F|0)&0==(L|0)))break;if((t|0)>=(e|0))break a}ja(G);Y(a[T>>2]|0,140508,140806,p);b=0;u=g;return b|0}while(0);1<(Ne(Ra)|0)&&0!=(a[K>>2]&128|0)&&(2==(Ne(Ra)|0)?Vd(G,e):4==(Ne(Ra)|0)?Id(G,e):8==(Ne(Ra)|0)&&Ae(G,e));p=0==(a[K>>2]&524288|0);f=E(Ne(Ra)|0,e)|0;p?5>(f|0)?(p=Qb(R|0,S|0,8,0)|0,c=J,a[c>>2]=p,a[c+4>>2]=U,p=1):p=0:9>(f|0)?(f=Qb(R|0,S|0,12,0)|0,c=J,a[c>>2]=f,a[c+4>>2]=U,p=1):p=0;c=x;if((a[c>>2]|0)==(e|0)&&(a[c+4>>2]|0)==((0>(e|0))<<31>>31|0)&&(w[r>>1]|0)==(Ra&65535)<<16>>16){c=J;f=rb[a[A>>
2]&63](a[T>>2]|0,a[c>>2]|0,a[c+4>>2]|0,0)|0;c=J;if((f|0)!=(a[c>>2]|0)||(U|0)!=(a[c+4>>2]|0))return ja(G),c=a[T>>2]|0,a[n>>2]=a[b>>2],Y(c,140508,140644,n),u=g,0;n=a[b+636>>2]|0;c=a[T>>2]|0;f=E(Ne(Ra)|0,e)|0;p=Aa[n&63](c,G,f)|0;f=(p|0)==(E(Ne(Ra)|0,e)|0);ja(G);if(f)return u=g,1;Y(a[T>>2]|0,140508,140425,l);u=g;return 0}if(p)Ec(J|0,G|0,E(Ne(Ra)|0,e)|0)|0;else if(p=rb[a[A>>2]&63](a[T>>2]|0,0,0,2)|0,l=J,a[l>>2]=p,a[l+4>>2]=U,l=a[b+636>>2]|0,p=a[T>>2]|0,f=E(Ne(Ra)|0,e)|0,p=Aa[l&63](p,G,f)|0,(p|0)!=(E(Ne(Ra)|
0,e)|0))return ja(G),Y(a[T>>2]|0,140508,140425,k),u=g,0;ja(G);G=Ra&65535;w[r>>1]=G;w[y>>1]=G;G=a[K>>2]|0;G&128?(ac(y),c=a[K>>2]|0):c=G;c&524288?(G=x,x=a[G>>2]|0,e=a[G+4>>2]|0,y=G=d,w[y>>1]=x,w[y+2>>1]=x>>>16,x=G+4|0,w[x>>1]=e,w[x+2>>1]=e>>>16,c&128?(kc(d),y=a[K>>2]|0):y=c,K=C+12|0,d=J,J=a[d>>2]|0,c=a[d+4>>2]|0,e=d=K,w[e>>1]=J,w[e+2>>1]=J>>>16,J=d+4|0,w[J>>1]=c,w[J+2>>1]=c>>>16,y&128&&kc(K)):(y=a[x>>2]|0,w[d>>1]=y,w[d+2>>1]=y>>>16,c&128?(pb(d),e=a[K>>2]|0):e=c,y=a[J>>2]|0,G=C+8|0,w[G>>1]=y,w[G+2>>
1]=y>>>16,e&128&&pb(G));K=rb[a[A>>2]&63](a[T>>2]|0,R,S,0)|0;if(!((K|0)==(R|0)&(U|0)==(S|0)))return S=a[T>>2]|0,a[m>>2]=a[b>>2],Y(S,140508,140644,m),u=g,0;if((Aa[a[b+636>>2]&63](a[T>>2]|0,C,W)|0)==(W|0))return u=g,1;W=a[T>>2]|0;a[h>>2]=a[b>>2];Y(W,140508,140848,h);u=g;return 0}function Zk(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0,z=0,Q=0,C=0,Ra=0,r=0,x=0,J=0,I=0,G=0,L=0,K=0,v=0,E=0,O=0,M=0,T=0,A=0,P=0,Oa=0,D=0,F=0,ba=0,bf=0,S=0,Mg=0,ga=0,Ha=0,ma=0,aa=0,ha=
0,ca=0,fa=0,pc=0,Nb=0,Hd=0,Zc=0,oa=0,sa=0,Kc=0,ua=0,Ia=0,Da=0,na=0,Na=0,ya=0,Ca=0,Ga=0,Ea=0,La=0,ra=0,pa=0,Ka=0,Qa=0,xb=0,Zb=0,Wa=0,jb=0,mc=0,Va=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,ub=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,ab=0,Ua=0,Wb=0,Jb=0,fb=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,Hb=0,Gb=0,nd=0,Zd=0,wb=0,Lb=0,Qd=0,zb=0,Ob=0,Tb=0,Kb=0,lb=0,Pb=0,Vb=0,fc=0,Sb=0,db=0,$b=0,jc=0,yc=0,
lc=0,hc=0,ec=0,Ec=0,kd=0,Bc=0,nc=0,Gc=0,zc=0,Hc=0,oc=0,Cc=0,Fc=0,Ie=0,ic=0,Wd=0,Jd=0,bd=0,vc=0,Rc=0,Jc=0,Be=0,Ic=0,xc=0,Qc=0,Wc=0,Uc=0,hd=0,Bd=0,Vc=0,Rb=0,od=0,tc=0,Xb=0,rc=0,ed=0,gd=0,cf=0,ad=0,dd=0,Oc=0,Pc=0,Yc=0,wc=0,id=0,dc=0,Ac=0,Sc=0,Tc=0,ld=0,$c=0,Ce=0,vd=0,wd=0,Xc=0,Nf=0,qd=0,ug=0,rd=0,sd=0,md=0,cd=0,ce=0,oe=0,td=0,jd=0,Df=0,Ud=0,pd=0,zd=0,Cd=0,he=0,te=0,de=0,He=0,ue=0,Dd=0,Nd=0,ae=0,De=0,be=0,Fd=0,Rd=0,Gd=0,$d=0,ge=0,ud=0,xd=0,f=u;u=u+352|0;g=f+288|0;h=f+280|0;m=f+272|0;k=f+264|0;l=f+256|
0;n=f+248|0;p=f+240|0;q=f+232|0;y=f+224|0;B=f+216|0;H=f+208|0;ka=f+200|0;z=f+192|0;Q=f+184|0;C=f+176|0;Ra=f+168|0;r=f+160|0;x=f+152|0;J=f+144|0;I=f+136|0;G=f+128|0;L=f+120|0;K=f+112|0;v=f+104|0;E=f+96|0;O=f+88|0;M=f+80|0;T=f+72|0;A=f+64|0;P=f+56|0;Oa=f+48|0;D=f+40|0;F=f+32|0;ba=f+328|0;bf=f+24|0;S=f+324|0;Mg=f+336|0;ga=f+316|0;Ha=f+16|0;ma=f+8|0;aa=f;ha=f+320|0;ca=f+334|0;fa=f+312|0;pc=f+308|0;Nb=f+332|0;Hd=f+304|0;Zc=f+300|0;oa=f+296|0;sa=f+292|0;if(!(a[b+8>>2]|0))return Kc=1,u=f,Kc|0;1;ua=0!=(c|
0);c=b+12|0;if(ua){Ia=a[c>>2]|0;if(0!=(Ia&4096|0)&&(a[c>>2]=Ia&-4097,0==(da[a[b+528>>2]&63](b)|0)))return Y(a[b+628>>2]|0,140888,140910,F),Kc=0,u=f,Kc|0;R[a[b+556>>2]&127](b);F=b+608|0;if(0<(a[F>>2]|0)&&0!=(a[c>>2]&64|0)&&0==(Lc(b)|0))return Y(a[b+628>>2]|0,140888,140953,D),Kc=0,u=f,Kc|0;D=a[c>>2]|0;0!=(D&512|0)&&(Ia=b+588|0,Da=a[Ia>>2]|0,0!=(Da|0))?(ja(Da),a[F>>2]=0,a[Ia>>2]=0,a[Ia+4>>2]=0,a[Ia+8>>2]=0,a[Ia+12>>2]=0,na=a[c>>2]|0):na=D;a[c>>2]=na&-81}na=0!=(d|0);d=b+40|0;D=b+156|0;Ia=b+44|0;F=b+184|
0;Da=b+464|0;Na=b+188|0;ya=b+472|0;Ca=b+480|0;Ga=b+660|0;Ea=b+656|0;La=b+216|0;ra=b+220|0;pa=b+84|0;Ka=b+98|0;Qa=b+200|0;xb=b+204|0;Zb=b+208|0;Wa=b+212|0;jb=b+196|0;mc=b+192|0;Va=b+152|0;Ta=b+76|0;Ya=b+64|0;Sa=b+112|0;mb=b+108|0;Db=b+86|0;cc=b+140|0;Za=b+144|0;ia=b+148|0;qa=b+168|0;Ja=b+172|0;ea=b+176|0;wa=b+136|0;Ma=b+124|0;xa=b+126|0;$a=b+106|0;la=b+104|0;Ba=b+100|0;va=b+96|0;za=b+94|0;ta=b+92|0;nb=b+90|0;sc=b+88|0;gb=b+80|0;hb=b+128|0;ob=b+132|0;Bb=b+116|0;qb=b+120|0;kb=b+68|0;ib=b+72|0;Cb=b+56|
0;ub=b+60|0;sb=b+224|0;Xa=b+16|0;Fa=b+640|0;Pa=b+628|0;Eb=b+432|0;vb=b+636|0;tb=b+632|0;bb=b+428|0;Ib=0==(e|0);Mb=b+448|0;ab=b+228|0;Wb=Ua=0;a:for(;;){a[ha>>2]=0;do if(na){do if(a[d>>2]&2)if(Jb=a[Cb>>2]|0,Ua){65536>Jb>>>0?(w[ba>>1]=Jb,a[c>>2]&128&&ac(ba),fb=Yb(b,ha,Ua,256,3,1,2,ba)|0):(a[ba>>2]=Jb,a[c>>2]&128&&pb(ba),fb=Yb(b,ha,Ua,256,4,1,4,ba)|0);if(!fb){yb=Ua;cb=593;break a}Jb=a[ub>>2]|0;65536>Jb>>>0?(w[ba>>1]=Jb,a[c>>2]&128&&ac(ba),gc=Yb(b,ha,Ua,257,3,1,2,ba)|0):(a[ba>>2]=Jb,a[c>>2]&128&&pb(ba),
gc=Yb(b,ha,Ua,257,4,1,4,ba)|0);if(!gc){yb=Ua;cb=593;break a}}else a[ha>>2]=2;while(0);do if(a[d>>2]&4)if(Jb=a[kb>>2]|0,Ua){65536>Jb>>>0?(w[ba>>1]=Jb,a[c>>2]&128&&ac(ba),Ub=Yb(b,ha,Ua,322,3,1,2,ba)|0):(a[ba>>2]=Jb,a[c>>2]&128&&pb(ba),Ub=Yb(b,ha,Ua,322,4,1,4,ba)|0);if(!Ub){yb=Ua;cb=593;break a}Jb=a[ib>>2]|0;65536>Jb>>>0?(w[ba>>1]=Jb,a[c>>2]&128&&ac(ba),Fb=Yb(b,ha,Ua,323,3,1,2,ba)|0):(a[ba>>2]=Jb,a[c>>2]&128&&pb(ba),Fb=Yb(b,ha,Ua,323,4,1,4,ba)|0);if(!Fb){yb=Ua;cb=593;break a}}else a[ha>>2]=(a[ha>>2]|
0)+2;while(0);Jb=a[d>>2]|0;if(Jb&8){if(!(Gi(b,ha,Ua,282,+W[Bb>>2])|0)){yb=Ua;cb=593;break a}if(!(Gi(b,ha,Ua,283,+W[qb>>2])|0)){yb=Ua;cb=593;break a}Hb=a[d>>2]|0}else Hb=Jb;if(Hb&16){if(!(Gi(b,ha,Ua,286,+W[hb>>2])|0)){yb=Ua;cb=593;break a}if(!(Gi(b,ha,Ua,287,+W[ob>>2])|0)){yb=Ua;cb=593;break a}Gb=a[d>>2]|0}else Gb=Hb;do if(Gb&32)if(Ua){a[ba>>2]=a[gb>>2];a[c>>2]&128&&pb(ba);if(!(Yb(b,ha,Ua,254,4,1,4,ba)|0)){yb=Ua;cb=593;break a}nd=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,nd=Gb;else nd=Gb;while(0);do if(nd&
64)if(Jb=w[pa>>1]|0,Ua){wb=eb(N[Ka>>1]<<1)|0;if(!wb){Lb=Ua;cb=76;break a}if(w[Ka>>1]|0)for(zb=wb,Ob=0;;)if(w[zb>>1]=Jb,Ob=Ob+1<<16>>16,Tb=w[Ka>>1]|0,(Ob&65535)>=(Tb&65535)){Qd=Tb;break}else zb=zb+2|0;else Qd=0;zb=Qd&65535;a[c>>2]&128&&Vd(wb,zb);Ob=Yb(b,ha,Ua,258,3,zb,zb<<1,wb)|0;ja(wb);if(!Ob){yb=Ua;cb=593;break a}Zd=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Zd=nd;else Zd=nd;while(0);do if(Zd&128)if(Ua){w[ba>>1]=w[sc>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,ha,Ua,259,3,1,2,ba)|0)){yb=Ua;cb=593;break a}Kb=
a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Kb=Zd;else Kb=Zd;while(0);do if(Kb&256)if(Ua){w[ba>>1]=w[nb>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,ha,Ua,262,3,1,2,ba)|0)){yb=Ua;cb=593;break a}lb=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,lb=Kb;else lb=Kb;while(0);do if(lb&512)if(Ua){w[ba>>1]=w[ta>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,ha,Ua,263,3,1,2,ba)|0)){yb=Ua;cb=593;break a}Pb=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Pb=lb;else Pb=lb;while(0);do if(Pb&1024)if(Ua){w[ba>>1]=w[za>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,
ha,Ua,266,3,1,2,ba)|0)){yb=Ua;cb=593;break a}Vb=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Vb=Pb;else Vb=Pb;while(0);do if(Vb&32768)if(Ua){w[ba>>1]=w[va>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,ha,Ua,274,3,1,2,ba)|0)){yb=Ua;cb=593;break a}fc=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,fc=Vb;else fc=Vb;while(0);do if(fc&65536)if(Ua){w[ba>>1]=w[Ka>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,ha,Ua,277,3,1,2,ba)|0)){yb=Ua;cb=593;break a}Sb=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Sb=fc;else Sb=fc;while(0);do if(Sb&131072)if(Ob=
a[Ba>>2]|0,Ua){65536>Ob>>>0?(w[ba>>1]=Ob,a[c>>2]&128&&ac(ba),$b=Yb(b,ha,Ua,278,3,1,2,ba)|0):(a[ba>>2]=Ob,a[c>>2]&128&&pb(ba),$b=Yb(b,ha,Ua,278,4,1,4,ba)|0);if(!$b){yb=Ua;cb=593;break a}db=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,db=Sb;else db=Sb;while(0);do if(db&262144)if(Ob=w[la>>1]|0,Ua){zb=eb(N[Ka>>1]<<1)|0;if(!zb){yc=Ua;cb=141;break a}if(w[Ka>>1]|0)for(Jb=zb,Tb=0;;)if(w[Jb>>1]=Ob,Tb=Tb+1<<16>>16,hc=w[Ka>>1]|0,(Tb&65535)>=(hc&65535)){lc=hc;break}else Jb=Jb+2|0;else lc=0;Jb=lc&65535;a[c>>2]&128&&
Vd(zb,Jb);Tb=Yb(b,ha,Ua,280,3,Jb,Jb<<1,zb)|0;ja(zb);if(!Tb){yb=Ua;cb=593;break a}jc=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,jc=db;else jc=db;while(0);do if(jc&524288)if(Tb=w[$a>>1]|0,Ua){Jb=eb(N[Ka>>1]<<1)|0;if(!Jb){Ec=Ua;cb=152;break a}if(w[Ka>>1]|0)for(Ob=Jb,wb=0;;)if(w[Ob>>1]=Tb,wb=wb+1<<16>>16,hc=w[Ka>>1]|0,(wb&65535)>=(hc&65535)){kd=hc;break}else Ob=Ob+2|0;else kd=0;Ob=kd&65535;a[c>>2]&128&&Vd(Jb,Ob);wb=Yb(b,ha,Ua,281,3,Ob,Ob<<1,Jb)|0;ja(Jb);if(!wb){yb=Ua;cb=593;break a}ec=a[d>>2]|0}else a[ha>>
2]=(a[ha>>2]|0)+1,ec=jc;else ec=jc;while(0);do if(ec&1048576)if(Ua){w[ba>>1]=w[xa>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,ha,Ua,284,3,1,2,ba)|0)){yb=Ua;cb=593;break a}Bc=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Bc=ec;else Bc=ec;while(0);do if(Bc&4194304)if(Ua){w[ba>>1]=w[Ma>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,ha,Ua,296,3,1,2,ba)|0)){yb=Ua;cb=593;break a}nc=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,nc=Bc;else nc=Bc;while(0);do if(nc&8388608)if(Ua){a[c>>2]&128&&Vd(wa,2);if(!(Yb(b,ha,Ua,297,3,2,4,wa)|0)){yb=
Ua;cb=593;break a}Gc=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Gc=nc;else Gc=nc;while(0);do if(Gc&16777216)if(wb=a[qa>>2]|0,Ob=a[ea>>2]|0,!(a[c>>2]&1024)){if(!(li(b,ha,Ua,279,wb,Ob)|0)){yb=Ua;cb=593;break a}}else if(!(li(b,ha,Ua,325,wb,Ob)|0)){yb=Ua;cb=593;break a}while(0);do if(a[d>>2]&33554432)if(Ob=a[qa>>2]|0,wb=a[Ja>>2]|0,!(a[c>>2]&1024)){if(!(li(b,ha,Ua,273,Ob,wb)|0)){yb=Ua;cb=593;break a}}else if(!(li(b,ha,Ua,324,Ob,wb)|0)){yb=Ua;cb=593;break a}while(0);wb=a[d>>2]|0;do if(wb&67108864)if(Ua){Ob=
N[pa>>1]|0;Tb=1<<Ob;zb=3<<Ob;Ob=zb<<1;hc=eb(Ob)|0;if(!hc){Hc=Ua;cb=191;break a}oc=Tb<<1;Ab(hc,a[cc>>2]|0,oc);Ab(hc+(Tb<<1)|0,a[Za>>2]|0,oc);Ab(hc+(oc<<1)|0,a[ia>>2]|0,oc);if(-1>=(zb|0)){cb=193;break a}a[c>>2]&128&&Vd(hc,zb);oc=Yb(b,ha,Ua,320,3,zb,Ob,hc)|0;ja(hc);if(!oc){yb=Ua;cb=593;break a}zc=a[d>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,zc=wb;else zc=wb;while(0);do if(0>(zc|0)&&w[D>>1]|0)if(a[M>>2]=ca,a[M+4>>2]=fa,ne(b,338,M)|0,wb=N[ca>>1]|0,oc=a[fa>>2]|0,Ua){if(a[c>>2]&128&&Vd(oc,wb),!(Yb(b,ha,Ua,338,
3,wb,wb<<1,oc)|0)){yb=Ua;cb=593;break a}}else a[ha>>2]=(a[ha>>2]|0)+1;while(0);oc=a[Ia>>2]|0;do if(oc&1)if(wb=w[Db>>1]|0,Ua){hc=eb(N[Ka>>1]<<1)|0;if(!hc){Fc=Ua;cb=210;break a}if(w[Ka>>1]|0)for(Ob=hc,zb=0;;)if(w[Ob>>1]=wb,zb=zb+1<<16>>16,Tb=w[Ka>>1]|0,(zb&65535)>=(Tb&65535)){Ie=Tb;break}else Ob=Ob+2|0;else Ie=0;Ob=Ie&65535;a[c>>2]&128&&Vd(hc,Ob);zb=Yb(b,ha,Ua,339,3,Ob,Ob<<1,hc)|0;ja(hc);if(!zb){yb=Ua;cb=593;break a}Cc=a[Ia>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Cc=oc;else Cc=oc;while(0);if(Cc&2){if(!($k(b,
ha,Ua,340,N[Ka>>1]|0,a[mb>>2]|0)|0)){yb=Ua;cb=593;break a}ic=a[Ia>>2]|0}else ic=Cc;if(ic&4){if(!($k(b,ha,Ua,341,N[Ka>>1]|0,a[Sa>>2]|0)|0)){yb=Ua;cb=593;break a}Wd=a[Ia>>2]|0}else Wd=ic;do if(Wd&8)if(Ua){a[ba>>2]=a[Ya>>2];a[c>>2]&128&&pb(ba);if(!(Yb(b,ha,Ua,-32539,4,1,4,ba)|0)){yb=Ua;cb=593;break a}Jd=a[Ia>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Jd=Wd;else Jd=Wd;while(0);do if(Jd&16)if(Ua){a[ba>>2]=a[Ta>>2];a[c>>2]&128&&pb(ba);if(!(Yb(b,ha,Ua,-32538,4,1,4,ba)|0)){yb=Ua;cb=593;break a}bd=a[Ia>>2]|0}else a[ha>>
2]=(a[ha>>2]|0)+1,bd=Jd;else bd=Jd;while(0);do if(bd&32)if(Ua){a[c>>2]&128&&Vd(Va,2);if(!(Yb(b,ha,Ua,321,3,2,4,Va)|0)){yb=Ua;cb=593;break a}vc=a[Ia>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,vc=bd;else vc=bd;while(0);do if(vc&128)if(Ua){a[c>>2]&128&&Vd(mc,2);if(!(Yb(b,ha,Ua,530,3,2,4,mc)|0)){yb=Ua;cb=593;break a}Rc=a[Ia>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Rc=vc;else Rc=vc;while(0);do if(Rc&256)if(Ua){w[ba>>1]=w[jb>>1]|0;a[c>>2]&128&&ac(ba);if(!(Yb(b,ha,Ua,531,3,1,2,ba)|0)){yb=Ua;cb=593;break a}Jc=a[Ia>>2]|
0}else a[ha>>2]=(a[ha>>2]|0)+1,Jc=Rc;else Jc=Rc;while(0);if(Jc&512){if(!(al(b,ha,Ua,532,6,a[Wa>>2]|0)|0)){yb=Ua;cb=593;break a}Be=a[Ia>>2]|0}else Be=Jc;do if(Be&4096)if(Ua){oc=N[pa>>1]|0;zb=1<<oc;Ob=(N[Ka>>1]|0)-(N[D>>1]|0)|0;wb=3<(Ob&65532)>>>0?3:Ob&65535;switch(wb<<16>>16){case 3:Ob=zb<<1;Ak(a[Qa>>2]|0,a[Zb>>2]|0,Ob|0)|0?Qc=3:(xc=Ob,cb=266);break;case 2:xc=zb<<1;cb=266;break;default:Qc=wb}266==(cb|0)&&(cb=0,Qc=(wb=0==(Ak(a[Qa>>2]|0,a[xb>>2]|0,xc|0)|0))?1:2);wb=0==Qc<<16>>16?1:Qc;Ob=(wb&65535)<<
oc;oc=Ob<<1;Jb=eb(oc)|0;if(!Jb){Wc=Ua;cb=268;break a}Tb=zb<<1;Ab(Jb,a[Qa>>2]|0,Tb);1<(wb&65535)&&(Ab(Jb+(zb<<1)|0,a[xb>>2]|0,Tb),2>=(wb&65535)||Ab(Jb+(Tb<<1)|0,a[Zb>>2]|0,Tb));if(-1>=(Ob|0)){cb=273;break a}a[c>>2]&128&&Vd(Jb,Ob);Tb=Yb(b,ha,Ua,301,3,Ob,oc,Jb)|0;ja(Jb);if(!Tb){yb=Ua;cb=593;break a}Ic=a[Ia>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+1,Ic=Be;else Ic=Be;while(0);do if(Ic&16384)if(Tb=a[La>>2]|0,Ua){if(!(Yb(b,ha,Ua,333,2,Tb,Tb,a[ra>>2]|0)|0)){hd=Ua;break a}Uc=a[Ia>>2]|0}else a[ha>>2]=(a[ha>>2]|0)+
1,Uc=Ic;else Uc=Ic;while(0);do if(Uc&131072&&(Tb=w[F>>1]|0,wb=Tb&65535,Tb<<16>>16))if(Ua){Tb=Da;zb=a[Tb>>2]|0;hc=a[Tb+4>>2]|0;Tb=a[c>>2]|0;if(Tb&524288)Xb=a[Na>>2]|0,Tb&128&&Ae(Xb,wb),ad=Yb(b,ha,Ua,330,18,wb,wb<<3,Xb)|0;else{Bd=eb(wb<<2)|0;if(!Bd){Vc=Ua;cb=289;break a}Rb=w[F>>1]|0;if(Rb<<16>>16)for(tc=0,Xb=a[Na>>2]|0,rc=Bd;;){if(!Xb){cb=293;break a}ed=Xb;gd=a[ed>>2]|0;cf=a[ed+4>>2]|0;if(!(1>cf>>>0|1==(cf|0)&0>gd>>>0)){cb=295;break a}a[rc>>2]=gd;tc=tc+1<<16>>16;if((tc&65535)>=(Rb&65535)){od=Rb;break}else Xb=
Xb+8|0,rc=rc+4|0}else od=0;rc=od&65535;a[c>>2]&128&&Id(Bd,rc);Xb=Yb(b,ha,Ua,330,13,rc,rc<<2,Bd)|0;ja(Bd);ad=Xb}if(!ad){yb=Ua;cb=593;break a}a[c>>2]|=8192;Xb=w[F>>1]|0;w[ya>>1]=Xb;1==Xb<<16>>16?(Xb=Ca,a[Xb>>2]=0,a[Xb+4>>2]=0):(Xb=Ca,a[Xb>>2]=zb,a[Xb+4>>2]=hc)}else a[ha>>2]=(a[ha>>2]|0)+1;while(0);if(a[Ga>>2]|0){Xb=0==(Ua|0);rc=0;do{Rb=a[(a[Ea>>2]|0)+(rc<<2)>>2]|0;tc=w[Rb+24>>1]|0;b:do if(65<(tc&65535)&&a[b+40+(((tc&65535)>>>5&65535)<<2)>>2]&1<<(tc&31))switch(a[Rb+20>>2]|0){case 1:if(2!=(a[Rb+8>>2]|
0)){cb=313;break a}if(-1!=(w[Rb+4>>1]|0)){cb=315;break a}if(t[Rb+27>>0]|0){cb=317;break a}Jb=a[Rb>>2]|0;a[K>>2]=pc;Pd(b,Jb,K)|0;Jb=a[pc>>2]|0;oc=bk(Jb)|0;if(Xb){a[ha>>2]=(a[ha>>2]|0)+1;break b}else if(Yb(b,ha,Ua,a[Rb>>2]&65535,2,oc,oc,Jb)|0)break b;else{hd=Ua;break a}case 4:if(3!=(a[Rb+8>>2]|0)){cb=322;break a}if(1!=(w[Rb+4>>1]|0)){cb=324;break a}if(t[Rb+27>>0]|0){cb=326;break a}Jb=a[Rb>>2]|0;a[L>>2]=Nb;Pd(b,Jb,L)|0;Jb=a[Rb>>2]&65535;if(Xb){a[ha>>2]=(a[ha>>2]|0)+1;break b}w[ba>>1]=w[Nb>>1]|0;a[c>>
2]&128&&ac(ba);if(Yb(b,ha,Ua,Jb,3,1,2,ba)|0)break b;else{hd=Ua;break a}case 6:if(4!=(a[Rb+8>>2]|0)){cb=333;break a}if(1!=(w[Rb+4>>1]|0)){cb=335;break a}if(t[Rb+27>>0]|0){cb=337;break a}Jb=a[Rb>>2]|0;a[G>>2]=Hd;Pd(b,Jb,G)|0;Jb=a[Rb>>2]&65535;if(Xb){a[ha>>2]=(a[ha>>2]|0)+1;break b}a[ba>>2]=a[Hd>>2];a[c>>2]&128&&pb(ba);if(Yb(b,ha,Ua,Jb,4,1,4,ba)|0)break b;else{hd=Ua;break a}case 40:if(7!=(a[Rb+8>>2]|0)){cb=344;break a}if(-3!=(w[Rb+4>>1]|0)){cb=346;break a}if(1!=(t[Rb+27>>0]|0)){cb=348;break a}Jb=a[Rb>>
2]|0;a[I>>2]=Zc;a[I+4>>2]=oa;Pd(b,Jb,I)|0;Jb=a[Zc>>2]|0;if(Xb){a[ha>>2]=(a[ha>>2]|0)+1;break b}else if(Yb(b,ha,Ua,a[Rb>>2]&65535,7,Jb,Jb,a[oa>>2]|0)|0)break b;else{hd=Ua;break a}default:cb=352;break a}while(0);rc=rc+1|0}while(rc>>>0<(a[Ga>>2]|0)>>>0)}}while(0);b:do if(a[sb>>2]|0)for(rc=0==(Ua|0),Xb=0;;){Rb=a[ab>>2]|0;tc=a[Rb+(12*Xb|0)>>2]|0;c:do switch(a[tc+8>>2]|0){case 2:if(hc=a[Rb+(12*Xb|0)+4>>2]|0,rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}else if(Yb(b,ha,Ua,a[tc>>2]&65535,2,hc,hc,a[Rb+(12*Xb|0)+8>>
2]|0)|0)break c;else{hd=Ua;break a}case 7:if(hc=a[Rb+(12*Xb|0)+4>>2]|0,rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}else if(Yb(b,ha,Ua,a[tc>>2]&65535,7,hc,hc,a[Rb+(12*Xb|0)+8>>2]|0)|0)break c;else{hd=Ua;break a}case 1:if(hc=a[Rb+(12*Xb|0)+4>>2]|0,rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}else if(Yb(b,ha,Ua,a[tc>>2]&65535,1,hc,hc,a[Rb+(12*Xb|0)+8>>2]|0)|0)break c;else{hd=Ua;break a}case 6:if(hc=a[Rb+(12*Xb|0)+4>>2]|0,rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}else if(Yb(b,ha,Ua,a[tc>>2]&65535,6,hc,hc,a[Rb+(12*Xb|0)+8>>
2]|0)|0)break c;else{hd=Ua;break a}case 3:hc=a[tc>>2]&65535;zb=a[Rb+(12*Xb|0)+4>>2]|0;wb=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(-1>=(zb|0)){cb=370;break a}a[c>>2]&128&&Vd(wb,zb);if(!(Yb(b,ha,Ua,hc,3,zb,zb<<1,wb)|0)){yb=Ua;cb=593;break a}break;case 8:wb=a[tc>>2]&65535;zb=a[Rb+(12*Xb|0)+4>>2]|0;hc=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(-1>=(zb|0)){cb=377;break a}a[c>>2]&128&&Vd(hc,zb);if(!(Yb(b,ha,Ua,wb,8,zb,zb<<1,hc)|0)){yb=Ua;cb=593;break a}break;
case 4:hc=a[tc>>2]&65535;zb=a[Rb+(12*Xb|0)+4>>2]|0;wb=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(1073741824<=zb>>>0){cb=384;break a}a[c>>2]&128&&Id(wb,zb);if(!(Yb(b,ha,Ua,hc,4,zb,zb<<2,wb)|0)){yb=Ua;cb=593;break a}break;case 9:wb=a[tc>>2]&65535;zb=a[Rb+(12*Xb|0)+4>>2]|0;hc=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(1073741824<=zb>>>0){cb=391;break a}a[c>>2]&128&&Id(hc,zb);if(!(Yb(b,ha,Ua,wb,9,zb,zb<<2,hc)|0)){yb=Ua;cb=593;break a}break;case 16:hc=a[tc>>
2]&65535;zb=a[Rb+(12*Xb|0)+4>>2]|0;wb=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(536870912<=zb>>>0){cb=398;break a}Tb=a[c>>2]|0;if(!(Tb&524288)){cb=400;break a}Tb&128&&Ae(wb,zb);if(!(Yb(b,ha,Ua,hc,16,zb,zb<<3,wb)|0)){yb=Ua;cb=593;break a}break;case 17:wb=a[tc>>2]&65535;zb=a[Rb+(12*Xb|0)+4>>2]|0;hc=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(536870912<=zb>>>0){cb=407;break a}Tb=a[c>>2]|0;if(!(Tb&524288)){cb=409;break a}Tb&128&&Ae(hc,zb);if(!(Yb(b,ha,Ua,wb,
17,zb,zb<<3,hc)|0)){yb=Ua;cb=593;break a}break;case 5:if(!(al(b,ha,Ua,a[tc>>2]&65535,a[Rb+(12*Xb|0)+4>>2]|0,a[Rb+(12*Xb|0)+8>>2]|0)|0)){yb=Ua;cb=593;break a}break;case 10:hc=a[tc>>2]&65535;zb=a[Rb+(12*Xb|0)+4>>2]|0;wb=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}Tb=zb<<1;Bd=zb<<3;Jb=eb(Bd)|0;if(!Jb){dd=Ua;cb=418;break a}if(zb)for(oc=wb,wb=Jb,Ob=0;Oc=+W[oc>>2],gd=~~Oc,cf=Oc==+(gd|0),0>Oc?cf?(a[wb>>2]=gd,a[wb+4>>2]=1):-1<Oc?(a[wb>>2]=0-~~(-2147483648*Oc),a[wb+4>>2]=2147483647):(a[wb>>
2]=-2147483647,a[wb+4>>2]=~~(2147483648/-Oc)):cf?(a[wb>>2]=gd,a[wb+4>>2]=1):1>Oc?(a[wb>>2]=~~(2147483648*Oc),a[wb+4>>2]=2147483647):(a[wb>>2]=2147483647,a[wb+4>>2]=~~(2147483648/Oc)),Ob=Ob+1|0,(Ob|0)!=(zb|0);)oc=oc+4|0,wb=wb+8|0;a[c>>2]&128&&Id(Jb,Tb);wb=Yb(b,ha,Ua,hc,10,zb,Bd,Jb)|0;ja(Jb);if(!wb){yb=Ua;cb=593;break a}break;case 11:wb=a[tc>>2]&65535;oc=a[Rb+(12*Xb|0)+4>>2]|0;Ob=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(1073741824<=oc>>>0){cb=437;break a}a[c>>2]&128&&gf(Ob,oc);
if(!(Yb(b,ha,Ua,wb,11,oc,oc<<2,Ob)|0)){yb=Ua;cb=593;break a}break;case 12:Ob=a[tc>>2]&65535;oc=a[Rb+(12*Xb|0)+4>>2]|0;wb=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(536870912<=oc>>>0){cb=444;break a}a[c>>2]&128&&re(wb,oc);if(!(Yb(b,ha,Ua,Ob,12,oc,oc<<3,wb)|0)){yb=Ua;cb=593;break a}break;case 13:wb=a[tc>>2]&65535;oc=a[Rb+(12*Xb|0)+4>>2]|0;Ob=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}if(1073741824<=oc>>>0){cb=451;break a}a[c>>2]&128&&Id(Ob,oc);if(!(Yb(b,ha,Ua,
wb,13,oc,oc<<2,Ob)|0)){yb=Ua;cb=593;break a}break;case 18:Ob=a[tc>>2]&65535;oc=a[Rb+(12*Xb|0)+4>>2]|0;wb=a[Rb+(12*Xb|0)+8>>2]|0;if(rc){a[ha>>2]=(a[ha>>2]|0)+1;break c}gd=a[c>>2]|0;if(gd&524288){if(536870912<=oc>>>0){cb=459;break a}gd&128&&Ae(wb,oc);$c=Yb(b,ha,Ua,Ob,18,oc,oc<<3,wb)|0}else{cf=oc<<2;ed=eb(cf)|0;if(!ed){Pc=Ua;cb=465;break a}if(oc){Yc=wb;wc=0;for(id=ed;;){dc=Yc;Ac=a[dc>>2]|0;Sc=a[dc+4>>2]|0;if(0<Sc>>>0|0==(Sc|0)&4294967295<Ac>>>0){Tc=ed;ld=Ua;cb=467;break a}a[id>>2]=Ac;wc=wc+1|0;if(wc>>>
0>=oc>>>0)break;else Yc=Yc+8|0,id=id+4|0}if(1073741824<=oc>>>0){cb=470;break a}}a[c>>2]&128&&Id(ed,oc);id=Yb(b,ha,Ua,Ob,13,oc,cf,ed)|0;ja(ed);$c=id}if(!$c){yb=Ua;cb=593;break a}break;default:cb=475;break a}while(0);Xb=Xb+1|0;if(Xb>>>0>=(a[sb>>2]|0)>>>0)break b}while(0);if(Ua){Ce=Ua;vd=Wb;cb=548;break}Xb=eb(24*(a[ha>>2]|0)|0)|0;if(!Xb){wd=Xb;cb=479;break}if(na){if(rc=Xa,0==(a[rc>>2]|0)&0==(a[rc+4>>2]|0)){rc=rb[a[Fa>>2]&63](a[Pa>>2]|0,0,0,2)|0;Rb=Qb(rc|0,U|0,1,0)|0;rc=U;tc=Rb&-2;Rb=Xa;a[Rb>>2]=tc;a[Rb+
4>>2]=rc;Rb=a[c>>2]|0;id=0!=(Rb&524288|0);do if(Rb&8192)if(id){wc=bf;a[wc>>2]=tc;a[wc+4>>2]=rc;Rb&128&&kc(bf);wc=Ca;rb[a[Fa>>2]&63](a[Pa>>2]|0,a[wc>>2]|0,a[wc+4>>2]|0,0)|0;if(8!=(Aa[a[vb>>2]&63](a[Pa>>2]|0,bf,8)|0)){zd=Xb;cb=494;break a}wc=(w[ya>>1]|0)+-1<<16>>16;w[ya>>1]=wc;wc<<16>>16?(wc=Ca,Yc=Qb(a[wc>>2]|0,a[wc+4>>2]|0,8,0)|0,wc=Ca,a[wc>>2]=Yc,a[wc+4>>2]=U):a[c>>2]&=-8193}else{a[ba>>2]=tc;Rb&128&&pb(ba);wc=Ca;rb[a[Fa>>2]&63](a[Pa>>2]|0,a[wc>>2]|0,a[wc+4>>2]|0,0)|0;if(4!=(Aa[a[vb>>2]&63](a[Pa>>
2]|0,ba,4)|0)){Cd=Xb;cb=487;break a}wc=(w[ya>>1]|0)+-1<<16>>16;w[ya>>1]=wc;wc<<16>>16?(wc=Ca,Yc=Qb(a[wc>>2]|0,a[wc+4>>2]|0,4,0)|0,wc=Ca,a[wc>>2]=Yc,a[wc+4>>2]=U):a[c>>2]&=-8193}else{if(!id){a[S>>2]=tc;Rb&128&&pb(S);if(Yc=a[bb>>2]|0)Nf=Yc;else if(a[bb>>2]=a[Xa>>2],rb[a[Fa>>2]&63](a[Pa>>2]|0,4,0,0)|0,4==(Aa[a[vb>>2]&63](a[Pa>>2]|0,S,4)|0))break;else{Xc=Xb;cb=503;break a}for(;;){Yc=rb[a[Fa>>2]&63](a[Pa>>2]|0,Nf,0,0)|0;if(!((Yc|0)==(Nf|0)&0==(U|0))){qd=Xb;cb=506;break a}if(2!=(Aa[a[tb>>2]&63](a[Pa>>2]|
0,Mg,2)|0)){qd=Xb;cb=506;break a}a[c>>2]&128&&ac(Mg);Yc=Nf+2|0;rb[a[Fa>>2]&63](a[Pa>>2]|0,(12*(N[Mg>>1]|0)|0)+Yc|0,0,0)|0;if(4!=(Aa[a[tb>>2]&63](a[Pa>>2]|0,ga,4)|0)){ug=Xb;cb=510;break a}a[c>>2]&128&&pb(ga);Nf=a[ga>>2]|0;if(!Nf){rd=Yc;break}}rb[a[Fa>>2]&63](a[Pa>>2]|0,(12*(N[Mg>>1]|0)|0)+rd|0,0,0)|0;if(4==(Aa[a[vb>>2]&63](a[Pa>>2]|0,S,4)|0))break;else{sd=Xb;cb=515;break a}}Yc=Ha;a[Yc>>2]=tc;a[Yc+4>>2]=rc;Rb&128&&kc(Ha);Yc=Eb;wc=a[Yc>>2]|0;Jb=a[Yc+4>>2]|0;if(0==(wc|0)&0==(Jb|0))if(Yc=Xa,Bd=a[Yc+4>>
2]|0,zb=Eb,a[zb>>2]=a[Yc>>2],a[zb+4>>2]=Bd,rb[a[Fa>>2]&63](a[Pa>>2]|0,8,0,0)|0,8==(Aa[a[vb>>2]&63](a[Pa>>2]|0,Ha,8)|0))break;else{md=Xb;cb=520;break a}else cd=wc,ce=Jb;for(;;){Jb=rb[a[Fa>>2]&63](a[Pa>>2]|0,cd,ce,0)|0;if(!((Jb|0)==(cd|0)&(U|0)==(ce|0))){oe=Xb;cb=523;break a}if(8!=(Aa[a[tb>>2]&63](a[Pa>>2]|0,ma,8)|0)){oe=Xb;cb=523;break a}a[c>>2]&128&&kc(ma);Jb=ma;wc=a[Jb>>2]|0;Bd=a[Jb+4>>2]|0;if(0<Bd>>>0|0==(Bd|0)&65535<wc>>>0){td=Xb;cb=527;break a}Bd=a[Fa>>2]|0;Jb=a[Pa>>2]|0;zb=Qb(cd|0,ce|0,8,0)|
0;Yc=Qb(zb|0,U|0,20*(wc&65535)|0,0)|0;wc=U;rb[Bd&63](Jb,Yc,wc,0)|0;if(8!=(Aa[a[tb>>2]&63](a[Pa>>2]|0,aa,8)|0)){jd=Xb;cb=529;break a}a[c>>2]&128&&kc(aa);Jb=aa;cd=a[Jb>>2]|0;ce=a[Jb+4>>2]|0;if(0==(cd|0)&0==(ce|0)){Df=Yc;Ud=wc;break}}rb[a[Fa>>2]&63](a[Pa>>2]|0,Df,Ud,0)|0;if(8!=(Aa[a[vb>>2]&63](a[Pa>>2]|0,Ha,8)|0)){pd=Xb;cb=534;break a}}while(0)}}else Rb=rb[a[Fa>>2]&63](a[Pa>>2]|0,0,0,2)|0,tc=Qb(Rb|0,U|0,1,0)|0,Rb=Xa,a[Rb>>2]=tc&-2,a[Rb+4>>2]=U;Ib||(Rb=Xa,tc=a[Rb+4>>2]|0,rc=e,a[rc>>2]=a[Rb>>2],a[rc+4>>
2]=tc);tc=a[ha>>2]|0;a[c>>2]&524288?(rc=(20*tc|0)+16|0,tc=Xa,id=a[tc>>2]|0,wc=a[tc+4>>2]|0,he=tc=Qb(id|0,wc|0,rc|0,0)|0,te=U):(rc=(12*tc|2)+4|0,Rb=Xa,id=a[Rb>>2]|0,wc=a[Rb+4>>2]|0,he=Rb=Qb(id|0,wc|0,rc|0,0)|0,te=0);de=wc;He=id;ue=0;Nd=Dd=rc;rc=Da;a[rc>>2]=he;a[rc+4>>2]=te;if(te>>>0<ue>>>0|(te|0)==(ue|0)&he>>>0<Dd>>>0|te>>>0<de>>>0|(te|0)==(de|0)&he>>>0<He>>>0){ae=Xb;cb=543;break}0==(he&1|0)&1||(rc=Qb(he|0,te|0,1,0)|0,id=Da,a[id>>2]=rc,a[id+4>>2]=U);na&&(w[Mb>>1]=(w[Mb>>1]|0)+1<<16>>16);Ua=Xb;Wb=Nd}switch(cb|
0){case 76:Y(a[Pa>>2]|0,140996,150005,Oa);hd=Lb;break;case 141:Y(a[Pa>>2]|0,140996,150005,P);hd=yc;break;case 152:Y(a[Pa>>2]|0,140996,150005,A);hd=Ec;break;case 191:Y(a[Pa>>2]|0,141032,150005,T);hd=Hc;break;case 193:Z(141062,141079,1956,141094);break;case 210:Y(a[Pa>>2]|0,140996,150005,O);hd=Fc;break;case 268:Y(a[Pa>>2]|0,141133,150005,E);hd=Wc;break;case 273:Z(141062,141079,1956,141094);break;case 289:Y(a[Pa>>2]|0,141171,150005,v);hd=Vc;break;case 293:Z(141199,141079,1868,141171);break;case 295:Z(141207,
141079,1869,141171);break;case 313:Z(141227,141079,643,140888);break;case 315:Z(141253,141079,644,140888);break;case 317:Z(141287,141079,645,140888);break;case 322:Z(141309,141079,655,140888);break;case 324:Z(141335,141079,656,140888);break;case 326:Z(141287,141079,657,140888);break;case 333:Z(141357,141079,666,140888);break;case 335:Z(141335,141079,667,140888);break;case 337:Z(141287,141079,668,140888);break;case 344:Z(141382,141079,678,140888);break;case 346:Z(141412,141079,679,140888);break;case 348:Z(141447,
141079,680,140888);break;case 352:Z(141469,141079,687,140888);break;case 370:Z(141062,141079,1956,141094);break;case 377:Z(141062,141079,1979,141471);break;case 384:Z(141511,141079,2E3,141528);break;case 391:Z(141511,141079,2023,141566);break;case 398:Z(141605,141079,2047,141622);break;case 400:Z(141661,141079,2049,141622);break;case 407:Z(141605,141079,2072,141689);break;case 409:Z(141661,141079,2074,141689);break;case 418:Y(a[Pa>>2]|0,141729,150005,J);hd=dd;break;case 437:Z(141511,141079,2239,141772);
break;case 444:Z(141605,141079,2264,141811);break;case 451:Z(141511,141079,2275,141851);break;case 459:Z(141605,141079,2285,141888);break;case 465:Y(a[Pa>>2]|0,141926,150005,x);hd=Pc;break;case 467:Y(a[Pa>>2]|0,141926,141960,r);ja(Tc);yb=ld;cb=593;break;case 470:Z(141511,141079,2275,141851);break;case 475:Z(141469,141079,763,140888);break;case 479:Y(a[Pa>>2]|0,140888,150005,Ra);yb=wd;cb=593;break;case 487:Y(a[Pa>>2]|0,142028,142046,C);yb=Cd;cb=593;break;case 494:Y(a[Pa>>2]|0,142028,142046,Q);yb=zd;
cb=593;break;case 503:Y(a[Pa>>2]|0,a[b>>2]|0,142082,z);yb=Xc;cb=593;break;case 506:Y(a[Pa>>2]|0,142028,140364,ka);yb=qd;cb=593;break;case 510:Y(a[Pa>>2]|0,142028,140395,H);yb=ug;cb=593;break;case 515:Y(a[Pa>>2]|0,142028,140425,B);yb=sd;cb=593;break;case 520:Y(a[Pa>>2]|0,a[b>>2]|0,142082,y);yb=md;cb=593;break;case 523:Y(a[Pa>>2]|0,142028,140364,q);yb=oe;cb=593;break;case 527:Y(a[Pa>>2]|0,142028,140454,p);yb=td;cb=593;break;case 529:Y(a[Pa>>2]|0,142028,140395,n);yb=jd;cb=593;break;case 534:Y(a[Pa>>
2]|0,142028,140425,l);yb=pd;cb=593;break;case 543:Y(a[Pa>>2]|0,140888,142108,k);yb=ae;cb=593;break;case 548:do if(na&&0!=(a[Ia>>2]&131072|0)&&(ae=Ca,0==(a[ae>>2]|0)&0==(a[ae+4>>2]|0))){(ae=a[ha>>2]|0)?(De=0,be=Ce):Z(142140,141079,809,140888);for(;;){if(330==(w[be>>1]|0)){Fd=De;break}De=De+1|0;if(De>>>0>=ae>>>0){cb=552;break}else be=be+24|0}552==(cb|0)&&Z(142140,141079,809,140888);ae=Xa;Xb=a[ae>>2]|0;k=a[ae+4>>2]|0;a[c>>2]&524288?(ae=Qb(20*Fd|0,0,20,0)|0,pd=Qb(ae|0,U|0,Xb|0,k|0)|0,k=Ca,a[k>>2]=pd,
a[k+4>>2]=U):(ae=Qb(12*Fd|0,0,10,0)|0,pd=Qb(ae|0,U|0,Xb|0,k|0)|0,ae=Ca,a[ae>>2]=pd,a[ae+4>>2]=U)}while(0);if(Ca=eb(vd)|0){m=a[c>>2]|0;Fd=a[ha>>2]|0;if(m&524288){be=Ca;a[be>>2]=Fd;a[be+4>>2]=0;m&128?(kc(Ca),Rd=a[ha>>2]|0):Rd=Fd;be=Ca+8|0;if(Rd)for(Rd=Ca,De=0,Ia=be,be=Ce;;)if(w[Ia>>1]=w[be>>1]|0,na=a[c>>2]|0,na&128?(ac(Ia),$d=a[c>>2]|0):$d=na,na=Rd+10|0,w[na>>1]=w[be+2>>1]|0,$d&128&&ac(na),na=Rd+12|0,Ab(na,be+8|0,8),a[c>>2]&128&&kc(na),na=Rd,Rd=Rd+20|0,Ab(Rd,be+16|0,8),De=De+1|0,k=na+28|0,De>>>0>=(a[ha>>
2]|0)>>>0){Gd=k;break}else Ia=k,be=be+24|0;else Gd=be;Ab(Gd,b+24|0,8);a[c>>2]&128&&kc(Gd)}else{w[Ca>>1]=Fd;m&128?(ac(Ca),ge=a[ha>>2]|0):ge=Fd;Fd=Ca+2|0;if(ge)for(ge=0,m=Fd,Fd=Ce;;)if(w[m>>1]=w[Fd>>1]|0,Gd=a[c>>2]|0,Gd&128?(ac(m),xd=a[c>>2]|0):xd=Gd,Gd=m+2|0,w[Gd>>1]=w[Fd+2>>1]|0,xd&128&&ac(Gd),Gd=m+4|0,a[sa>>2]=a[Fd+8>>2],Ab(Gd,sa,4),a[c>>2]&128&&pb(Gd),Ab(m+8|0,Fd+16|0,4),Gd=m+12|0,ge=ge+1|0,ge>>>0>=(a[ha>>2]|0)>>>0){ud=Gd;break}else m=Gd,Fd=Fd+24|0;else ud=Fd;a[sa>>2]=a[b+24>>2];a[c>>2]&128&&pb(sa);
Ab(ud,sa,4)}ja(Ce);sa=Ce=Xa;if((rb[a[Fa>>2]&63](a[Pa>>2]|0,a[Ce>>2]|0,a[Ce+4>>2]|0,0)|0)==(a[sa>>2]|0)&&(U|0)==(a[sa+4>>2]|0))if((Aa[a[vb>>2]&63](a[Pa>>2]|0,Ca,vd)|0)!=(vd|0))Y(a[Pa>>2]|0,140888,142148,g);else{ja(Ca);if(!ua)return Kc=1,u=f,Kc|0;Dk(b);a[c>>2]&=-2097161;R[a[b+564>>2]&127](b);var ie=b,ie=ie|0,je=void 0,Kd=void 0;Pi(ie)|0;je=ie+16|0;Kd=ie+456|0;a[Kd>>2]=0;a[Kd+4>>2]=0;a[je>>2]=0;a[je+4>>2]=0;a[je+8>>2]=0;a[je+12>>2]=0;a[ie+444>>2]=-1;a[ie+452>>2]=-1;0;Kc=1;u=f;return Kc|0}else Y(a[Pa>>
2]|0,140888,142148,h);ja(Ca);Kc=0;u=f;return Kc|0}Y(a[Pa>>2]|0,140888,150005,m);yb=Ce;cb=593}if(593==(cb|0))if(yb)hd=yb;else return Kc=0,u=f,Kc|0;ja(hd);Kc=0;u=f;return Kc|0}function Yb(b,d,c,e,f,g,h,m){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;h|=0;m|=0;var k,l,n,p,q,y=0,B,H,t;k=u;u=u+32|0;l=k+16|0;n=k+8|0;p=k+20|0;q=a[d>>2]|0;a:do if(q){for(B=0;;){H=w[c+(24*B|0)>>1]|0;if(H<<16>>16==e<<16>>16)break;if((H&65535)>(e&65535)){y=B;break a}H=B+1|0;if(H>>>0<q>>>0)B=H;else{y=H;break a}}Z(142340,141079,2301,142361)}else y=
0;while(0);if(y>>>0<q>>>0){B=q;do q=c+(24*B|0)|0,B=B+-1|0,H=c+(24*B|0)|0,a[q>>2]=a[H>>2],a[q+4>>2]=a[H+4>>2],a[q+8>>2]=a[H+8>>2],a[q+12>>2]=a[H+12>>2],a[q+16>>2]=a[H+16>>2],a[q+20>>2]=a[H+20>>2];while(B>>>0>y>>>0)}w[c+(24*y|0)>>1]=e;w[c+(24*y|0)+2>>1]=f;f=c+(24*y|0)+8|0;a[f>>2]=g;a[f+4>>2]=0;y=f=c+(24*y|0)+16|0;a[y>>2]=0;a[y+4>>2]=0;y=b+12|0;c=a[y>>2]&524288;if(((c>>>17)+4|0)>>>0<h>>>0){g=0==(c|0);B=e=b+464|0;H=a[B>>2]|0;q=a[B+4>>2]|0;c=B=Qb(H|0,q|0,h|0,0)|0;B=g?0:U;if(B>>>0<q>>>0|(B|0)==(q|0)&c>>>
0<H>>>0|0>B>>>0|0==(B|0)&c>>>0<h>>>0)return Y(a[b+628>>2]|0,142361,142108,k),u=k,0;g=b+628|0;t=rb[a[b+640>>2]&63](a[g>>2]|0,H,q,0)|0;if(!((t|0)==(H|0)&(U|0)==(q|0)))return Y(a[g>>2]|0,142361,142387,n),u=k,0;-1>=(h|0)&&Z(142413,141079,2335,142361);if((Aa[a[b+636>>2]&63](a[g>>2]|0,m,h)|0)!=(h|0))return Y(a[g>>2]|0,142361,142387,l),u=k,0;g=Qb(c&1|0,0,c|0,B|0)|0;B=e;a[B>>2]=g;a[B+4>>2]=U;B=a[y>>2]|0;B&524288?(g=f,a[g>>2]=H,a[g+4>>2]=q,B&128&&kc(f)):(a[p>>2]=H,B&128&&pb(p),Ab(f,p,4))}else Ab(f,m,h);a[d>>
2]=(a[d>>2]|0)+1;u=k;return 1}function Gi(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f=+f;var g,h;g=u;u=u+16|0;if(!c)return a[d>>2]=(a[d>>2]|0)+1,u=g,1;0<=f||Z(142292,141079,2084,142303);0>=f?(a[g>>2]=0,a[g+4>>2]=1):(h=~~f>>>0,+(h>>>0)==f?(a[g>>2]=h,a[g+4>>2]=1):1>f?(a[g>>2]=~~(4294967295*f)>>>0,a[g+4>>2]=-1):(a[g>>2]=-1,a[g+4>>2]=~~(4294967295/f)>>>0));a[b+12>>2]&128&&(pb(g),pb(g+4|0));b=Yb(b,d,c,e,5,1,8,g)|0;u=g;return b|0}function li(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m,k,l,n,p,q,y,B,H;h=u;u=
u+16|0;m=h+8|0;k=h;if(!c)return a[d>>2]=(a[d>>2]|0)+1,u=h,1;l=b+12|0;n=a[l>>2]|0;if(n&524288)return 536870912<=f>>>0&&Z(141605,141079,2047,141622),n&128&&Ae(g,f),b=Yb(b,d,c,e,16,f,f<<3,g)|0,u=h,b|0;n=f<<2;p=eb(n)|0;if(!p)return Y(a[b+628>>2]|0,142256,150005,k),u=h,0;do if(f){k=g;q=0;for(y=p;;){B=k;H=a[B>>2]|0;B=a[B+4>>2]|0;if(0<B>>>0|0==(B|0)&4294967295<H>>>0){k=13;break}a[y>>2]=H;q=q+1|0;if(q>>>0>=f>>>0){k=15;break}else k=k+8|0,y=y+4|0}if(13==(k|0))return Y(a[b+628>>2]|0,142256,141960,m),ja(p),b=
0,u=h,b|0;15!=(k|0)||1073741824>f>>>0||Z(141511,141079,2E3,141528)}while(0);a[l>>2]&128&&Id(p,f);l=Yb(b,d,c,e,4,f,n,p)|0;ja(p);u=h;return l|0}function $k(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m,k,l;h=u;u=u+16|0;m=f<<3;k=eb(m)|0;if(!k)return Y(a[b+628>>2]|0,142217,150005,h),u=h,0;a:do switch(N[b+86>>1]|0){case 3:if(33<=(N[b+84>>1]|0)){if(!c){a[d>>2]=(a[d>>2]|0)+1;l=1;break a}536870912<=f>>>0&&Z(141605,141079,2264,141811);a[b+12>>2]&128&&re(g,f);l=Yb(b,d,c,e,12,f,m,g)|0;break a}if(f){l=0;
do W[k+(l<<2)>>2]=+Hb[g+(l<<3)>>3],l=l+1|0;while((l|0)!=(f|0))}if(!c){a[d>>2]=(a[d>>2]|0)+1;l=1;break a}1073741824<=f>>>0&&Z(141511,141079,2239,141772);a[b+12>>2]&128&&gf(k,f);l=Yb(b,d,c,e,11,f,f<<2,k)|0;break;case 2:l=w[b+84>>1]|0;if(9>(l&65535)){if(f){m=0;do t[k+m>>0]=~~+Hb[g+(m<<3)>>3],m=m+1|0;while((m|0)!=(f|0))}c?l=Yb(b,d,c,e,6,f,f,k)|0:(a[d>>2]=(a[d>>2]|0)+1,l=1);break a}m=0==(f|0);if(17>(l&65535)){if(!m){l=0;do w[k+(l<<1)>>1]=~~+Hb[g+(l<<3)>>3],l=l+1|0;while((l|0)!=(f|0))}if(!c){a[d>>2]=(a[d>>
2]|0)+1;l=1;break a}-1>=(f|0)&&Z(141062,141079,1979,141471);a[b+12>>2]&128&&Vd(k,f);l=Yb(b,d,c,e,8,f,f<<1,k)|0}else{if(!m){l=0;do a[k+(l<<2)>>2]=~~+Hb[g+(l<<3)>>3],l=l+1|0;while((l|0)!=(f|0))}if(!c){a[d>>2]=(a[d>>2]|0)+1;l=1;break a}1073741824<=f>>>0&&Z(141511,141079,2023,141566);a[b+12>>2]&128&&Id(k,f);l=Yb(b,d,c,e,9,f,f<<2,k)|0}break a;case 1:l=w[b+84>>1]|0;if(9>(l&65535)){if(f){m=0;do t[k+m>>0]=~~+Hb[g+(m<<3)>>3],m=m+1|0;while((m|0)!=(f|0))}c?l=Yb(b,d,c,e,1,f,f,k)|0:(a[d>>2]=(a[d>>2]|0)+1,l=1);
break a}m=0==(f|0);if(17>(l&65535)){if(!m){l=0;do w[k+(l<<1)>>1]=~~+Hb[g+(l<<3)>>3],l=l+1|0;while((l|0)!=(f|0))}if(!c){a[d>>2]=(a[d>>2]|0)+1;l=1;break a}-1>=(f|0)&&Z(141062,141079,1956,141094);a[b+12>>2]&128&&Vd(k,f);l=Yb(b,d,c,e,3,f,f<<1,k)|0}else{if(!m){l=0;do a[k+(l<<2)>>2]=~~+Hb[g+(l<<3)>>3]>>>0,l=l+1|0;while((l|0)!=(f|0))}if(!c){a[d>>2]=(a[d>>2]|0)+1;l=1;break a}1073741824<=f>>>0&&Z(141511,141079,2E3,141528);a[b+12>>2]&128&&Id(k,f);l=Yb(b,d,c,e,4,f,f<<2,k)|0}break a;default:l=0}while(0);ja(k);
u=h;return l|0}function al(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m,k,l,n,p,q,y;h=u;u=u+16|0;if(!c)return a[d>>2]=(a[d>>2]|0)+1,u=h,1;m=f<<1;k=f<<3;l=eb(k)|0;if(!l)return Y(a[b+628>>2]|0,142175,150005,h),u=h,0;if(f)for(n=g,g=l,p=0;q=+W[n>>2],0>=q?(a[g>>2]=0,a[g+4>>2]=1):(y=~~q>>>0,q==+(y>>>0)?(a[g>>2]=y,a[g+4>>2]=1):1>q?(a[g>>2]=~~(4294967296*q)>>>0,a[g+4>>2]=-1):(a[g>>2]=-1,a[g+4>>2]=~~(4294967296/q)>>>0)),p=p+1|0,(p|0)!=(f|0);)n=n+4|0,g=g+8|0;a[b+12>>2]&128&&Id(l,m);m=Yb(b,d,c,e,5,f,k,
l)|0;ja(l);u=h;return m|0}function $i(b){b|=0;var d,c,e,f,g,h,m;d=u;u=u+32|0;c=d+16|0;if(!(qe(b,8100,5)|0))return Y(a[b+628>>2]|0,143889,143903,d),u=d,0;e=eb(96)|0;f=b+576|0;a[f>>2]=e;if(!e)return Y(a[b+628>>2]|0,143889,143955,d+8|0),u=d,0;g=a[b+8>>2]|0;a[e>>2]=g;h=b+668|0;m=b+672|0;a[e+32>>2]=a[m>>2];a[m>>2]=11;a[e+36>>2]=a[h>>2];a[h>>2]=12;h=b+676|0;a[e+40>>2]=a[h>>2];a[h>>2]=9;a[e+28>>2]=0;g||(g=b+12|0,a[g>>2]|=256);a[e+64>>2]=0;a[c>>2]=3;lb(b,65540,c)|0;a[(a[f>>2]|0)+80>>2]=0;a[b+504>>2]=9;a[b+
508>>2]=10;a[b+512>>2]=24;a[b+532>>2]=17;a[b+540>>2]=17;a[b+548>>2]=17;a[b+516>>2]=10;a[b+524>>2]=25;a[b+528>>2]=11;a[b+536>>2]=18;a[b+544>>2]=18;a[b+552>>2]=18;a[b+556>>2]=2;a[b+564>>2]=3;u=d;return 1}function qf(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m=0,k=0,l=0,n,p;e=a[b+576>>2]|0;f=e+52|0;g=a[f>>2]|0;h=e+48|0;e=a[h>>2]|0;if(g>>>0>=c>>>0)9>c>>>0?(m=c,k=g,l=e):Z(143169,142823,609,143180);else for(m=b+608|0,k=b+592|0,n=b+604|0,p=c,c=a[m>>2]|0,l=g,g=e;;)if(e=p-l|0,(c|0)>=(a[k>>2]|0)&&Lc(b)|0,c=a[n>>2]|
0,a[n>>2]=c+1,t[c>>0]=d>>>e|g,c=(a[m>>2]|0)+1|0,a[m>>2]=c,8>=e>>>0){m=e;k=8;l=0;break}else p=e,l=8,g=0;g=k-m|0;l|=(a[8064+(m<<2)>>2]&d)<<g;(k|0)!=(m|0)?(a[h>>2]=l,a[f>>2]=g):(g=b+608|0,(a[g>>2]|0)>=(a[b+592>>2]|0)&&Lc(b)|0,m=b+604|0,b=a[m>>2]|0,a[m>>2]=b+1,t[b>>0]=l,a[g>>2]=(a[g>>2]|0)+1,a[h>>2]=0,a[f>>2]=8)}function bl(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h=0,m=0,k=0,l=0,n,p,q,y,B,H=0,ka=0,z=0,Q,C,u=0,r=0,w=0,J=0,I=0,G=0;f=t[d>>0]|0;g=0<(e|0);a:do if(g&-1<f<<24>>24){if(63<(e|0)){b:do if(d&3){c:do if(f<<
24>>24)n=f,y=0;else{n=d;p=e;for(q=0;;){y=q+8|0;p=p+-8|0;n=n+1|0;if(!(n&3))break;B=t[n>>0]|0;if(B<<24>>24){n=B;break c}else q=y}31<(p|0)?(h=p,m=n,k=y,l=10):(H=p,ka=n,z=y);break b}while(0);n=(x[143242+(n&255)>>0]|0)+y|0;break a}else h=e,m=d,k=0,l=10;while(0);b:do if(10==(l|0))for(;;){l=0;if(a[m>>2]|0){H=h;ka=m;z=k;break b}q=k+32|0;n=h+-32|0;p=m+4|0;if(31<(n|0))h=n,m=p,k=q;else{H=n;ka=p;z=q;break}}while(0);Q=ka;B=H;C=z}else Q=d,B=e,C=0;b:do if(7<(B|0)){q=Q;p=B;for(n=C;;){y=t[q>>0]|0;if(y<<24>>24){h=
y;f=n;break}y=n+8|0;B=p+-8|0;n=q+1|0;if(7<(B|0))q=n,p=B,n=y;else{q=n;p=B;break b}}n=(x[143242+(h&255)>>0]|0)+f|0;break a}else q=Q,p=B,y=C;while(0);0<(p|0)?(n=x[143242+(x[q>>0]|0)>>0]|0,n=((n|0)>(p|0)?p:n)+y|0):n=y}else n=0;while(0);y=t[c>>0]|0;a:do if(g&-1<y<<24>>24){if(63<(e|0)){b:do if(c&3){c:do if(y<<24>>24)z=y,p=0;else{p=c;q=e;for(C=0;;){B=C+8|0;q=q+-8|0;p=p+1|0;if(!(p&3)){f=q;h=p;break}Q=t[p>>0]|0;if(Q<<24>>24){z=Q;p=B;break c}else C=B}31<(f|0)?(u=f,r=h,w=B,l=28):(J=f,I=h,G=B);break b}while(0);
z=(x[143242+(z&255)>>0]|0)+p|0;break a}else u=e,r=c,w=0,l=28;while(0);b:do if(28==(l|0))for(;;){l=0;if(a[r>>2]|0){J=u;I=r;G=w;break b}C=w+32|0;p=u+-32|0;q=r+4|0;if(31<(p|0))u=p,r=q,w=C;else{J=p;I=q;G=C;break}}while(0);ka=I;k=J;f=G}else ka=c,k=e,f=0;b:do if(7<(k|0)){C=ka;q=k;for(p=f;;){B=t[C>>0]|0;if(B<<24>>24){w=B;y=p;break}B=p+8|0;Q=q+-8|0;f=C+1|0;if(7<(Q|0))C=f,q=Q,p=B;else{h=f;m=Q;H=B;break b}}z=(x[143242+(w&255)>>0]|0)+y|0;break a}else h=ka,m=k,H=f;while(0);0<(m|0)?(p=x[143242+(x[h>>0]|0)>>0]|
0,z=((p|0)>(m|0)?m:p)+H|0):z=H}else z=0;while(0);H=b+576|0;m=b+608|0;h=b+592|0;f=b+604|0;k=0;ka=n;for(n=z;;){n>>>0<e>>>0?(w=(x[c+(n>>>3)>>0]|0)&1<<(n&7^7)?Fh(c,n,e)|0:Gh(c,n,e)|0,g=w+n|0):g=e;do if(g>>>0<ka>>>0){z=a[H>>2]|0;y=z+52|0;w=a[y>>2]|0;G=z+48|0;z=a[G>>2]|0;if(4>w>>>0)for(J=4,I=a[m>>2]|0,l=w,w=z;;)if(r=J-l|0,(I|0)>=(a[h>>2]|0)&&Lc(b)|0,u=a[f>>2]|0,a[f>>2]=u+1,t[u>>0]=1>>>r|w,I=(a[m>>2]|0)+1|0,a[m>>2]=I,8>=r>>>0){I=r;J=8;l=0;break}else J=r,l=8,w=0;else I=4,J=w,l=z;w=J-I|0;l|=(a[8064+(I<<2)>>
2]&1)<<w;(J|0)==(I|0)?((a[m>>2]|0)>=(a[h>>2]|0)&&Lc(b)|0,J=a[f>>2]|0,a[f>>2]=J+1,t[J>>0]=l,a[m>>2]=(a[m>>2]|0)+1,w=8,I=0):I=l;a[G>>2]=I;a[y>>2]=w;w=g}else if(l=n-ka+3|0,7>l>>>0)qf(b,N[(6*l|0)+125030>>1]|0,N[125028+(6*l|0)>>1]|0),w=ka;else{ka>>>0<e>>>0?(w=(x[d+(ka>>>3)>>0]|0)&1<<(ka&7^7)?Fh(d,ka,e)|0:Gh(d,ka,e)|0,G=w+ka|0):G=e;l=a[H>>2]|0;w=l+52|0;J=a[w>>2]|0;I=l+48|0;l=a[I>>2]|0;if(3>J>>>0)for(r=3,u=a[m>>2]|0,p=J,z=l;;)if(y=r-p|0,(u|0)>=(a[h>>2]|0)&&Lc(b)|0,B=a[f>>2]|0,a[f>>2]=B+1,t[B>>0]=1>>>y|z,
u=(a[m>>2]|0)+1|0,a[m>>2]=u,8>=y>>>0){u=y;J=8;l=0;break}else r=y,p=8,z=0;else u=3;z=J-u|0;p=(a[8064+(u<<2)>>2]&1)<<z|l;(J|0)==(u|0)?((a[m>>2]|0)>=(a[h>>2]|0)&&Lc(b)|0,r=a[f>>2]|0,a[f>>2]=r+1,t[r>>0]=p,a[m>>2]=(a[m>>2]|0)+1,l=8,J=0):(l=z,J=p);a[I>>2]=J;a[w>>2]=l;(k|0)!=(0-ka|0)&&0!=((x[d+(k>>>3)>>0]|0)&1<<(k&7^7)|0)?(Hh(b,ka-k|0,124374),Hh(b,G-ka|0,123720)):(Hh(b,ka-k|0,123720),Hh(b,G-ka|0,124374));w=G}while(0);if(w>>>0>=e>>>0)break;(x[d+(w>>>3)>>0]|0)&1<<(w&7^7)?(z=Fh(d,w,e)|0,p=(Gh(c,w,e)|0)+w|0,
l=z,I=Fh(c,p,e)|0,G=p):(p=Gh(d,w,e)|0,z=(Fh(c,w,e)|0)+w|0,l=p,I=Gh(c,z,e)|0,G=z);k=w;ka=l+w|0;n=I+G|0}}function Fh(b,d,c){b|=0;d|=0;var e,f,g,h,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0,z=0;g=0;e=(c|0)-d|0;c=d>>3;f=b+c|0;if(0>=(e|0))return 0;if(h=d&7){d=x[143533+((x[f>>0]|0)<<h&255)>>0]|0;f=8-h|0;d=d>>>0>f>>>0?f:d;d=(d|0)>(e|0)?e:d;if(8>(d+h|0))return d|0;c=b+(c+1)|0;b=e-d|0}else c=f,b=e,d=0;if(63<(b|0)){do{if(c&3){e=c;f=b;for(c=d;;){b=t[e>>0]|0;if(-1!=b<<24>>24){p=b;q=c;break}b=c+8|0;h=f+-8|0;d=e+
1|0;if(d&3)e=d,f=h,c=b;else{y=b;B=h;H=d;n=11;break}}if(11==(n|0)){31<(B|0)?(m=B,k=H,l=y,n=12):(ka=B,z=H,g=y);break}g=(x[143533+(p&255)>>0]|0)+q|0;return g|0}m=b;k=c;l=d;n=12}while(0);a:do if(12==(n|0))for(;;){n=0;if(-1!=(a[k>>2]|0)){ka=m;z=k;g=l;break a}q=l+32|0;p=m+-32|0;y=k+4|0;if(31<(p|0))m=p,k=y,l=q;else{ka=p;z=y;g=q;break}}while(0);e=z}else e=c,ka=b,g=d;a:do{if(7<(ka|0)){d=e;b=ka;for(c=g;;){g=t[d>>0]|0;if(-1!=g<<24>>24){ka=c;break}g=c+8|0;ka=b+-8|0;z=d+1|0;if(7<(ka|0))d=z,b=ka,c=g;else{m=z;k=
ka;l=g;break a}}g=(x[143533+(g&255)>>0]|0)+ka|0;return g|0}m=e;k=ka;l=g}while(0);if(0>=(k|0))return l|0;g=x[143533+(x[m>>0]|0)>>0]|0;return((g|0)>(k|0)?k:g)+l|0}function Gh(b,d,c){b|=0;d|=0;var e,f,g,h,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0,z=0;g=0;e=(c|0)-d|0;c=d>>3;f=b+c|0;if(0>=(e|0))return 0;if(h=d&7){d=x[143242+((x[f>>0]|0)<<h&255)>>0]|0;f=8-h|0;d=d>>>0>f>>>0?f:d;d=(d|0)>(e|0)?e:d;if(8>(d+h|0))return d|0;c=b+(c+1)|0;b=e-d|0}else c=f,b=e,d=0;if(63<(b|0)){do{if(c&3){e=c;f=b;for(c=d;;){b=t[e>>
0]|0;if(b<<24>>24){p=b;q=c;break}b=c+8|0;h=f+-8|0;d=e+1|0;if(d&3)e=d,f=h,c=b;else{y=b;B=h;H=d;n=11;break}}if(11==(n|0)){31<(B|0)?(m=B,k=H,l=y,n=12):(ka=B,z=H,g=y);break}g=(x[143242+(p&255)>>0]|0)+q|0;return g|0}m=b;k=c;l=d;n=12}while(0);a:do if(12==(n|0))for(;;){n=0;if(a[k>>2]|0){ka=m;z=k;g=l;break a}q=l+32|0;p=m+-32|0;y=k+4|0;if(31<(p|0))m=p,k=y,l=q;else{ka=p;z=y;g=q;break}}while(0);e=z}else e=c,ka=b,g=d;a:do{if(7<(ka|0)){d=e;b=ka;for(c=g;;){g=t[d>>0]|0;if(g<<24>>24){ka=c;break}g=c+8|0;ka=b+-8|0;
z=d+1|0;if(7<(ka|0))d=z,b=ka,c=g;else{m=z;k=ka;l=g;break a}}g=(x[143242+(g&255)>>0]|0)+ka|0;return g|0}m=e;k=ka;l=g}while(0);if(0>=(k|0))return l|0;g=x[143242+(x[m>>0]|0)>>0]|0;return((g|0)>(k|0)?k:g)+l|0}function Hh(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,u,r=0,x=0,J=0,I=0,G=0,L=0,K=0,v=0,E=0;e=a[b+576>>2]|0;f=e+52|0;g=a[f>>2]|0;h=e+48|0;e=a[h>>2]|0;a:do if(2623<(d|0)){m=c+620|0;k=c+618|0;l=b+608|0;n=b+592|0;p=b+604|0;q=c+622|0;y=d;B=g;for(H=e;;){ka=N[m>>1]|0;z=w[k>>1]|0;Q=z&
65535;if(Q>>>0<=B>>>0)if(9>(z&65535))z=B,C=H;else break;else for(z=a[l>>2]|0,C=B,B=Q;;)if(Q=B-C|0,(z|0)>=(a[n>>2]|0)&&Lc(b)|0,z=a[p>>2]|0,a[p>>2]=z+1,t[z>>0]=ka>>>Q|H,z=(a[l>>2]|0)+1|0,a[l>>2]=z,8>=Q>>>0){z=8;C=0;break}else C=8,H=0,B=Q;B=z-Q|0;H=(a[8064+(Q<<2)>>2]&ka)<<B|C;(z|0)==(Q|0)?((a[l>>2]|0)>=(a[n>>2]|0)&&Lc(b)|0,C=a[p>>2]|0,a[p>>2]=C+1,t[C>>0]=H,a[l>>2]=(a[l>>2]|0)+1,ka=8,u=0):(ka=B,u=H);H=y-(w[q>>1]|0)|0;if(2623<(H|0))y=H,B=ka,H=u;else{r=H;x=ka;J=u;break a}}Z(143169,142823,651,143498)}else r=
d,x=g,J=e;while(0);if(63<(r|0)){e=r>>6;g=e+63|0;d=c+(6*g|0)+4|0;(w[d>>1]|0)!=(e<<6|0)&&Z(143506,142823,656,143498);e=N[c+(6*g|0)+2>>1]|0;u=w[c+(6*g|0)>>1]|0;g=u&65535;if(g>>>0<=x>>>0)9>(u&65535)?(I=x,G=J,L=g):Z(143169,142823,661,143498);else for(u=b+608|0,ka=b+592|0,Q=b+604|0,z=a[u>>2]|0,C=x,H=J,B=g;;)if(g=B-C|0,(z|0)>=(a[ka>>2]|0)&&Lc(b)|0,y=a[Q>>2]|0,a[Q>>2]=y+1,t[y>>0]=e>>>g|H,z=(a[u>>2]|0)+1|0,a[u>>2]=z,8>=g>>>0){I=8;G=0;L=g;break}else C=8,H=0,B=g;B=I-L|0;H=(a[8064+(L<<2)>>2]&e)<<B|G;(I|0)==(L|
0)?(L=b+608|0,(a[L>>2]|0)>=(a[b+592>>2]|0)&&Lc(b)|0,I=b+604|0,G=a[I>>2]|0,a[I>>2]=G+1,t[G>>0]=H,a[L>>2]=(a[L>>2]|0)+1,e=8,g=0):(e=B,g=H);m=r-(w[d>>1]|0)|0;k=e;d=g}else m=r,k=x,d=J;J=N[c+(6*m|0)+2>>1]|0;x=w[c+(6*m|0)>>1]|0;m=x&65535;if(m>>>0<=k>>>0)9>(x&65535)?(K=k,v=d,E=m):Z(143169,142823,668,143498);else for(x=b+608|0,c=b+592|0,r=b+604|0,g=a[x>>2]|0,e=k,k=d,d=m;;)if(m=d-e|0,(g|0)>=(a[c>>2]|0)&&Lc(b)|0,d=a[r>>2]|0,a[r>>2]=d+1,t[d>>0]=J>>>m|k,g=(a[x>>2]|0)+1|0,a[x>>2]=g,8>=m>>>0){K=8;v=0;E=m;break}else e=
8,k=0,d=m;d=K-E|0;k=(a[8064+(E<<2)>>2]&J)<<d|v;(K|0)!=(E|0)?(a[h>>2]=k,a[f>>2]=d):(d=b+608|0,(a[d>>2]|0)>=(a[b+592>>2]|0)&&Lc(b)|0,E=b+604|0,b=a[E>>2]|0,a[E>>2]=b+1,t[b>>0]=k,a[d>>2]=(a[d>>2]|0)+1,a[h>>2]=0,a[f>>2]=8)}function cl(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k;e=a[b+576>>2]|0;f=0;do{g=Gh(d,f,c)|0;Hh(b,g,123720);h=g+f|0;if(h>>>0>=c>>>0)break;g=Fh(d,h,c)|0;Hh(b,g,124374);f=g+h|0}while(f>>>0<c>>>0);c=e+4|0;f=a[c>>2]|0;f&12&&(d=e+52|0,8!=(a[d>>2]|0)&&(f=b+608|0,(a[f>>2]|0)>=(a[b+592>>2]|0)&&Lc(b)|
0,h=e+48|0,g=a[h>>2]&255,m=b+604|0,k=a[m>>2]|0,a[m>>2]=k+1,t[k>>0]=g,a[f>>2]=(a[f>>2]|0)+1,a[h>>2]=0,a[d>>2]=8,f=a[c>>2]|0),f&8&&(f=b+604|0,c=a[f>>2]|0,c&1&&(h=b+608|0,(a[h>>2]|0)<(a[b+592>>2]|0)||(Lc(b)|0,c=a[f>>2]|0),b=e+48|0,e=a[b>>2]&255,a[f>>2]=c+1,t[c>>0]=e,a[h>>2]=(a[h>>2]|0)+1,a[b>>2]=0,a[d>>2]=8)))}function Ik(b){b|=0;var d,c,e,f=0,g,h,m=0,k;a[b+8>>2]|0&&Sb(b)|0;R[a[b+564>>2]&127](b);Dk(b);(d=a[b+32>>2]|0)&&ja(d);d=b+680|0;if(c=a[d>>2]|0){e=c;do a[d>>2]=a[e>>2],ja(a[e+8>>2]|0),ja(e),e=a[d>>
2]|0;while(0!=(e|0))}e=a[b+588>>2]|0;d=b+12|0;0!=(e|0)&&0!=(a[d>>2]&512|0)&&ja(e);a[d>>2]&2048&&(d=a[b+616>>2]|0,Ud[a[b+624>>2]&31](a[b+628>>2]|0,a[b+612>>2]|0,d,(0>(d|0))<<31>>31));d=b+656|0;e=a[d>>2]|0;if(0!=(e|0)&&(c=b+660|0,f=a[c>>2]|0,0!=(f|0))){g=e;e=f;for(f=0;;){h=a[g+(f<<2)>>2]|0;65==(w[h+24>>1]|0)&&(m=a[h+28>>2]|0,0==(Vk(129700,m,4)|0))?(ja(m),ja(h),k=a[c>>2]|0):k=e;h=f+1|0;if(h>>>0>=k>>>0)break;g=a[d>>2]|0;e=k;f=h}ja(a[d>>2]|0)}d=b+688|0;if(f=a[d>>2]|0){k=b+684|0;e=f;for(f=0;!(g=a[k>>2]|
0,a[g+(f<<4)+4>>2]|0?(ja(a[g+(f<<4)+12>>2]|0),c=a[d>>2]|0):c=e,f=f+1|0,f>>>0>=c>>>0);)e=c;ja(a[k>>2]|0)}ja(b)}function lb(b,d,c){b|=0;d|=0;var e,f,g,h;e=u;u=u+48|0;f=e+16|0;g=e;h=e+24|0;a[h>>2]=c|0;c=ki(b,d,0)|0;if(!c)return c=a[b+628>>2]|0,a[g>>2]=a[b>>2],a[g+4>>2]=65535<d>>>0?128936:155687,a[g+8>>2]=d,Y(c,128944,128957,g),u=e,0;if(257!=(d|0)&&0!=(a[b+12>>2]&64|0)&&0==(t[c+26>>0]|0))return g=a[b+628>>2]|0,c=a[c+28>>2]|0,a[f>>2]=a[b>>2],a[f+4>>2]=c,Y(g,128944,128978,f),u=e,0;b=Aa[a[b+668>>2]&63](b,
d,h)|0;u=e;return b|0}function Pd(b,d,c){b|=0;d|=0;var e,f=0;e=u;u=u+16|0;a[e>>2]=c|0;c=ki(b,d,0)|0;if(!c||65535>=d>>>0&&(f=w[c+24>>1]|0,0==(1<<(f&31)&a[b+40+(((f&65535)>>>5&65535)<<2)>>2]|0)))return u=e,0;b=Aa[a[b+672>>2]&63](b,d,e)|0;u=e;return b|0}function Dk(b){b|=0;var d,c,e,f;$c(b+40|0,0,4);d=b+108|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+112|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+140|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+144|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+148|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=
0;d=b+160|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+188|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+220|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+212|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+200|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+204|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+208|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+172|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+176|0;if(c=a[d>>2]|0)ja(c),a[d>>2]=0;d=b+44|0;a[d>>2]&=-385;d=b+224|0;c=a[d>>2]|0;e=b+228|0;if(0<(c|0))for(b=c,c=0;;){if(f=a[(a[e>>2]|0)+(12*c|0)+8>>2]|0)ja(f),b=a[d>>
2]|0;c=c+1|0;if((c|0)>=(b|0))break}a[d>>2]=0;if(d=a[e>>2]|0)ja(d),a[e>>2]=0}function Pi(b){b|=0;var d,c,e,f,g,h;d=u;u=u+16|0;c=b|0;e=84;var m=0,k=0,l,n,p=0;f=u;u=u+16|0;g=c+656|0;h=a[g>>2]|0;if(0!=(h|0)&&(m=c+660|0,k=a[m>>2]|0,0!=(k|0))){l=k;k=h;for(h=0;;){n=a[k+(h<<2)>>2]|0;65==(w[n+24>>1]|0)&&(p=a[n+28>>2]|0,0==(Vk(129700,p,4)|0))?(ja(p),ja(n),k=a[m>>2]|0):k=l;n=h+1|0;if(n>>>0>=k>>>0)break;l=k;k=a[g>>2]|0;h=n}ja(a[g>>2]|0);a[g>>2]=0;a[m>>2]=0}qe(c,a[e+12>>2]|0,a[e+8>>2]|0)|0||Y(a[c+628>>2]|0,129705,
129722,f);u=f;$c(b+40|0,0,192);w[b+94>>1]=1;w[b+84>>1]=1;w[b+92>>1]=1;w[b+96>>1]=1;w[b+98>>1]=1;a[b+100>>2]=-1;a[b+68>>2]=0;a[b+72>>2]=0;a[b+76>>2]=1;a[b+180>>2]=1;w[b+124>>1]=2;w[b+86>>1]=1;a[b+64>>2]=1;w[b+192>>1]=2;w[b+194>>1]=2;w[b+196>>1]=1;a[b+652>>2]=3;a[b+664>>2]=0;a[b+668>>2]=5;a[b+672>>2]=6;a[b+676>>2]=0;c=b+688|0;if(e=a[c>>2]|0){f=b+684|0;g=e;for(e=0;!(h=a[f>>2]|0,a[h+(e<<4)+4>>2]|0&&(ja(a[h+(e<<4)+12>>2]|0),g=a[c>>2]|0),e=e+1|0,e>>>0>=g>>>0););ja(a[f>>2]|0);a[c>>2]=0;a[f>>2]=0}f=a[20]|
0;if(!f)return a[d>>2]=1,lb(b,259,d)|0,b=b+12|0,c=a[b>>2]|0,a[b>>2]=c&-1033,u=d,1;R[f&127](b);a[d>>2]=1;lb(b,259,d)|0;b=b+12|0;c=a[b>>2]|0;a[b>>2]=c&-1033;u=d;return 1}function Gj(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C,r,w,x;e=u;u=u+112|0;f=e+88|0;g=e+80|0;h=e+72|0;m=e+64|0;k=e+56|0;l=e+48|0;n=e+40|0;p=e+32|0;q=e+24|0;y=e+16|0;B=e+102|0;H=e+96|0;t=e+8|0;z=e+100|0;Q=e+92|0;C=e;r=b+12|0;w=a[r>>2]|0;if(!(w&2048)){q=b+640|0;x=b+628|0;B=d;H=rb[a[q>>2]&63](a[x>>2]|0,a[B>>2]|0,a[B+4>>
2]|0,0)|0;B=d;l=(H|0)==(a[B>>2]|0)?(U|0)==(a[B+4>>2]|0):0;if(!(w&524288)){if(l&&(B=b+632|0,2==(Aa[a[B>>2]&63](a[x>>2]|0,z,2)|0))){a[r>>2]&128&&ac(z);H=rb[a[q>>2]&63](a[x>>2]|0,12*(N[z>>1]|0)|0,0,1)|0;c&&(z=c,a[z>>2]=H,a[z+4>>2]=U);if(4!=(Aa[a[B>>2]&63](a[x>>2]|0,Q,4)|0))return B=a[x>>2]|0,a[m>>2]=a[b>>2],Y(B,129029,129124,m),u=e,0;a[r>>2]&128&&pb(Q);m=d;a[m>>2]=a[Q>>2];a[m+4>>2]=0;u=e;return 1}m=a[x>>2]|0;a[k>>2]=a[b>>2];Y(m,129029,129089,k);u=e;return 0}if(l&&(l=b+632|0,8==(Aa[a[l>>2]&63](a[x>>2]|
0,C,8)|0))){a[r>>2]&128&&kc(C);k=C;C=a[k>>2]|0;m=a[k+4>>2]|0;if(0<m>>>0|0==(m|0)&65535<C>>>0)return Y(a[x>>2]|0,129029,140364,g),u=e,0;g=rb[a[q>>2]&63](a[x>>2]|0,20*(C&65535)|0,0,1)|0;c&&(C=c,a[C>>2]=g,a[C+4>>2]=U);if(8!=(Aa[a[l>>2]&63](a[x>>2]|0,d,8)|0))return l=a[x>>2]|0,a[f>>2]=a[b>>2],Y(l,129029,129124,f),u=e,0;if(!(a[r>>2]&128))return u=e,1;kc(d);u=e;return 1}f=a[x>>2]|0;a[h>>2]=a[b>>2];Y(f,129029,129089,h);u=e;return 0}h=d;f=a[h>>2]|0;x=a[h+4>>2]|0;if(!(w&524288)){w=f+2|0;if((f|0)==(f|0)&((0>
(f|0))<<31>>31|0)==(x|0)&&!(2147483645<(f|0)|2>(w|0))&&(h=b+616|0,(w|0)<=(a[h>>2]|0))){l=b+612|0;Ab(B,(a[l>>2]|0)+f|0,2);a[r>>2]&128&&ac(B);C=(12*(N[B>>1]|0)|0)+w|0;B=C+4|0;if(0<=(w|0)&&!(2147483643<(C|0)|4>(B|0))&&(B|0)<=(a[h>>2]|0))return c&&(h=c,a[h>>2]=C,a[h+4>>2]=(0>(C|0))<<31>>31),Ab(H,(a[l>>2]|0)+C|0,4),a[r>>2]&128&&pb(H),C=d,a[C>>2]=a[H>>2],a[C+4>>2]=0,u=e,1;Y(a[b+628>>2]|0,129029,140395,q);u=e;return 0}Y(a[b+628>>2]|0,129029,140364,y);y=d;a[y>>2]=0;a[y+4>>2]=0;u=e;return 0}y=f+8|0;if((f|
0)==(f|0)&((0>(f|0))<<31>>31|0)==(x|0)&&!(2147483639<(f|0)|8>(y|0))&&(x=b+616|0,(y|0)<=(a[x>>2]|0))){q=b+612|0;Ab(t,(a[q>>2]|0)+f|0,8);a[r>>2]&128&&kc(t);f=t;t=a[f>>2]|0;C=a[f+4>>2]|0;if(0<C>>>0|0==(C|0)&65535<t>>>0)return Y(a[b+628>>2]|0,129029,129050,n),u=e,0;n=(20*(t&65535)|0)+y|0;t=n+8|0;if(0<=(y|0)&&!(2147483639<(n|0)|8>(t|0))&&(t|0)<=(a[x>>2]|0)){c&&(x=c,a[x>>2]=n,a[x+4>>2]=(0>(n|0))<<31>>31);Ab(d,(a[q>>2]|0)+n|0,8);if(!(a[r>>2]&128))return u=e,1;kc(d);u=e;return 1}Y(a[b+628>>2]|0,129029,140395,
l);u=e;return 0}Y(a[b+628>>2]|0,129029,140364,p);u=e;return 0}function qe(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n=0,p,q,y,B=0;e=u;u=u+48|0;f=e;g=e+8|0;h=e+4|0;m=b+664|0;a[m>>2]=0;k=b+656|0;l=a[k>>2]|0;p=0!=(l|0)&&(n=a[b+660>>2]|0,0!=(n|0))?Bf(b,l,n+c|0,4,129751)|0:Mf(b,c,4,129751)|0;q=a[k>>2]=p;if(!q)return Y(a[b+628>>2]|0,129768,129785,f),u=e,0;if(c){q=b+660|0;b=g+8|0;f=0;do{p=d+(36*f|0)|0;n=a[p>>2]|0;l=g;y=l+36|0;do a[l>>2]=0,l=l+4|0;while((l|0)<(y|0));a[h>>2]=g;l=a[m>>2]|0;if(0==(l|0)||(a[l>>
2]|0)!=(n|0))B=13;a:do if(13==(B|0)){B=0;l=a[k>>2]|0;do if(l)if(a[g>>2]=n,a[b>>2]=0,y=zk(h,l,a[q>>2]|0,4,19)|0){if(y=a[y>>2]|0,a[m>>2]=y)break a}else a[m>>2]=0;while(0);l=a[q>>2]|0;a[(a[k>>2]|0)+(l<<2)>>2]=p;a[q>>2]=l+1}while(0);f=f+1|0}while((f|0)!=(c|0));b=q;k=a[k>>2]|0}else b=b+660|0,k=q;var H,t=a[b>>2]|0;H=k|0;k=4;q=19;var z,Q,C,r,w;l=m=h=0;var x,J;y=B=p=n=0;b=u;u=u+208|0;d=b+8|0;z=E(k,t|0)|0;t=b;a[t>>2]=1;a[t+4>>2]=0;if(z){t=z-k|0;a[d+4>>2]=k;g=f=a[d>>2]=k;for(Q=2;;)if(C=g+k+f|0,a[d+(Q<<2)>>
2]=C,C>>>0<z>>>0)r=f,f=C,Q=Q+1|0,g=r;else break;g=0-k|0;Q=H+t|0;f=b+4|0;if(0<(t|0))for(t=Q,z=1,r=H,C=1;;)if(3==(z&3|0)?(Bk(r,k,q,C,d),z=a[f>>2]|0,H=z<<30|(a[b>>2]|0)>>>2,a[b>>2]=H,a[f>>2]=z>>>2,C=C+2|0):(H=C+-1|0,(a[d+(H<<2)>>2]|0)>>>0<(t-r|0)>>>0?Bk(r,k,q,C,d):ji(r,k,q,b,C,0,d),1==(C|0)?(z=a[b>>2]|0,a[f>>2]=z>>>31|a[f>>2]<<1,z<<=1,H=a[b>>2]=z,C=0):(31<H>>>0?(z=a[b>>2]|0,a[f>>2]=z,a[b>>2]=0,H=C+-33|0,C=z,z=0):(C=a[f>>2]|0,z=a[b>>2]|0),a[f>>2]=z>>>(32-H|0)|C<<H,H=z<<H,a[b>>2]=H,C=1)),z=H|1,a[b>>2]=
z,H=r+k|0,H>>>0>=Q>>>0){w=H;z=C;break}else r=H;else w=H,z=1;ji(w,k,q,b,z,0,d);H=b+4|0;C=a[b>>2]|0;if(!(1==(z|0)&1==(C|0)&0==(a[H>>2]|0)))for(t=C,Q=w,r=z;;){if(2>(r|0)){z=t+-1|0;do if(z){if(z&1)m=24;else{w=z;for(C=0;!(C=C+1|0,w>>>=1,w&1););C?h=C:m=24}if(24==(m|0)){m=0;C=a[f>>2]|0;if(!C){l=64;m=30;break}if(C&1){n=0;p=t;B=C;y=0;break}else x=C,J=0;for(;!(w=J+1|0,x>>>=1,x&1);)J=w;if(w)h=J+33|0;else{n=0;p=t;B=C;y=0;break}}31<h>>>0?(l=h,m=30):(n=h,p=t,B=a[f>>2]|0,y=h)}else l=32,m=30;while(0);30==(m|0)&&
(m=0,z=a[f>>2]|0,a[b>>2]=z,a[f>>2]=0,n=l+-32|0,p=z,B=0,y=l);a[b>>2]=B<<32-n|p>>>n;a[f>>2]=B>>>n;Q=Q+g|0;C=y+r|0}else z=t>>>30,w=z|a[f>>2]<<2,C=r+-2|0,a[b>>2]=(t<<1&2147483646|z<<31)^3,a[f>>2]=w>>>1,ji(Q+(0-((a[d+(C<<2)>>2]|0)+k))|0,k,q,b,r+-1|0,1,d),w=a[b>>2]|0,a[f>>2]=w>>>31|a[f>>2]<<1,a[b>>2]=w<<1|1,w=Q+g|0,ji(w,k,q,b,C,1,d),Q=w;t=a[b>>2]|0;if(1==(C|0)&1==(t|0)&0==(a[H>>2]|0))break;else r=C}}u=b;u=e;return c|0}function ki(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;e=u;u=u+48|0;g=f=e+4|0;h=g+36|0;do a[g>>
2]=0,g=g+4|0;while((g|0)<(h|0));a[e>>2]=f;g=b+664|0;h=a[g>>2]|0;if(0!=(h|0)&&(a[h>>2]|0)==(d|0)&&(!c||(a[h+8>>2]|0)==(c|0)))return u=e,h|0;h=a[b+656>>2]|0;if(!h)return u=e,0;a[f>>2]=d;a[f+8>>2]=c;b=(c=zk(e,h,a[b+660>>2]|0,4,19)|0)?a[c>>2]|0:0;a[g>>2]=b;u=e;return b|0}function Ne(a){switch(a|0){case 7:case 6:case 2:case 1:case 0:a=1;break;case 8:case 3:a=2;break;case 13:case 11:case 9:case 4:a=4;break;case 18:case 17:case 16:case 12:case 10:case 5:a=8;break;default:a=0}return a|0}function Lf(b,d){b|=
0;d|=0;var c,e,f,g,h;c=u;u=u+48|0;e=c+8|0;f=c+4|0;g=e;h=g+36|0;do a[g>>2]=0,g=g+4|0;while((g|0)<(h|0));a[f>>2]=e;g=b+664|0;h=a[g>>2]|0;if(0!=(h|0)&&(a[h>>2]|0)==(d|0))return u=c,h|0;if(h=a[b+656>>2]|0)if(a[e>>2]=d,a[e+8>>2]=0,e=zk(f,h,a[b+660>>2]|0,4,19)|0){if(e=a[e>>2]|0,a[g>>2]=e)return u=c,e|0}else a[g>>2]=0;g=a[b+628>>2]|0;a[c>>2]=d;Y(g,129817,129834,c);u=c;return 0}function Hj(b,d,c){d|=0;c|=0;var e,f;b=u;u=u+16|0;e=b;f=eb(36)|0;if(!f)return u=b,0;$c(f,0,36);a[f>>2]=d;w[f+4>>1]=-3;w[f+6>>1]=
-3;a[f+8>>2]=c;a[f+12>>2]=0;do switch(c|0){case 7:case 1:a[f+16>>2]=40;a[f+20>>2]=40;break;case 2:a[f+16>>2]=39;a[f+20>>2]=39;break;case 3:a[f+16>>2]=42;a[f+20>>2]=42;break;case 4:a[f+16>>2]=44;a[f+20>>2]=44;break;case 11:case 10:case 5:a[f+16>>2]=48;a[f+20>>2]=48;break;case 6:a[f+16>>2]=41;a[f+20>>2]=41;break;case 8:a[f+16>>2]=43;a[f+20>>2]=43;break;case 9:a[f+16>>2]=45;a[f+20>>2]=45;break;case 12:a[f+16>>2]=49;a[f+20>>2]=49;break;case 18:case 13:a[f+16>>2]=50;a[f+20>>2]=50;break;case 16:a[f+16>>
2]=46;a[f+20>>2]=46;break;case 17:a[f+16>>2]=47;a[f+20>>2]=47;break;default:a[f+16>>2]=0,a[f+20>>2]=0}while(0);w[f+24>>1]=65;t[f+26>>0]=1;t[f+27>>0]=1;c=eb(32)|0;if(a[f+28>>2]=c)return a[f+32>>2]=0,a[e>>2]=d,d=u,u=u+16|0,a[d>>2]=e|0,c=Sk(c|0,32,129867,d)|0,u=d,c|0,u=b,f|0;ja(f);u=b;return 0}function ck(b){b|=0;var d=0,c=0,e=0,f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,t=0,z=0,Q=0,C=0,r=0,x=0,Ed=0,J=0,I=0,G=0,L=0,K=0,v=0,A=0,O=0,M=0,T=0,X=0,P=0,Oa=0,Ge=0,Lg=0,ba=0,bf=0,Te=0,W=0,ga=0,Ha=0,ma=0,
bc=0,ha=0,ca=0,ya=0,pc=0,Nb=0,Hd=0,Zc=0,oa=0,sa=0,Kc=0,ua=0,Ia=0,Da=0,na=0,Na=0,Aa=0,Ca=0,Ga=0,Ea=0,La=0,ra=0,pa=0,Ka=0,Qa=0,xb=0,Zb=0,Wa=0,jb=0,mc=0,Va=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,ub=0,sb=0,Xa=0,d=u;u=u+320|0;c=d+288|0;e=d+280|0;f=d+272|0;g=d+264|0;h=d+256|0;m=d+248|0;k=d+240|0;l=d+232|0;n=d+224|0;p=d+216|0;q=d+208|0;y=d+200|0;B=d+192|0;H=d+184|0;t=d+176|0;z=d+168|0;Q=d+160|
0;C=d+152|0;r=d+144|0;x=d+136|0;Ed=d+120|0;J=d+112|0;I=d+104|0;G=d+96|0;L=d+88|0;K=d+80|0;v=d+72|0;A=d+64|0;O=d+56|0;M=d+48|0;T=d+40|0;X=d+32|0;P=d+24|0;Oa=d+16|0;Ge=d+8|0;Lg=d+300|0;ba=d+308|0;bf=d+306|0;Te=d+296|0;W=d+292|0;ga=d+304|0;ma=Ha=b+24|0;bc=a[ma>>2]|0;ha=a[ma+4>>2]|0;ma=b+16|0;a[ma>>2]=bc;a[ma+4>>2]=ha;if(0==(bc|0)&0==(ha|0))return ca=0,u=d,ca|0;ma=b+38|0;ya=w[ma>>1]|0;switch(ya<<16>>16){case -1:return Y(a[b+628>>2]|0,132827,132846,d),ca=0,u=d,ca|0;case 0:break;default:pc=3}a:do if(3==
(pc|0)&&(Nb=a[b+32>>2]|0,0!=(Nb|0))){for(Zc=Hd=0;;){oa=Nb+(Hd<<3)|0;sa=(Zc&65535)+1<<16>>16;if((a[oa>>2]|0)==(bc|0)&&(a[oa+4>>2]|0)==(ha|0)){ca=0;break}if((sa&65535)<(ya&65535))Hd=sa&65535,Zc=Zc+1|0;else break a}u=d;return ca|0}while(0);Zc=ya+1<<16>>16;w[ma>>1]=Zc;ya=b+36|0;if((Zc&65535)>(N[ya>>1]|0)){Hd=b+32|0;Nb=Bf(b,a[Hd>>2]|0,Zc&65535,16,132893)|0;if(!Nb)return ca=0,u=d,ca|0;sa=w[ma>>1]|0;Kc=0>sa<<16>>16?-1:(sa&65535)<<1&65535;w[ya>>1]=Kc;a[Hd>>2]=Nb;ua=sa;Ia=Nb}else ua=Zc,Ia=a[b+32>>2]|0;Zc=
Ia+((ua&65535)+-1<<3)|0;a[Zc>>2]=bc;a[Zc+4>>2]=ha;R[a[b+564>>2]&127](b);ha=b+448|0;w[ha>>1]=(w[ha>>1]|0)+1<<16>>16;ha=Ha;Zc=a[ha>>2]|0;bc=a[ha+4>>2]|0;ha=Ij(b,Zc,bc,Lg,Ha)|0;if(!(ha<<16>>16))return Ha=a[b+628>>2]|0,ua=Ge,a[ua>>2]=Zc,a[ua+4>>2]=bc,Y(Ha,132906,132924,Ge),ca=0,u=d,ca|0;Ha=Ge=0;for(bc=a[Lg>>2]|0;;){ua=N[bc>>1]|0;if(ua>>>0<(Ge&65535)>>>0){pc=17;break}Ha=Ha+1<<16>>16;if((Ha&65535)>=(ha&65535))break;else Ge=ua+1|0,bc=bc+24|0}17==(pc|0)&&Wb(a[b+628>>2]|0,132963,132991,Oa);Oa=0;bc=a[Lg>>2]|
0;do if(Ge=bc,bc=bc+24|0,Oa=Oa+1|0,Ha=Oa&65535,(Ha&65535)<(ha&65535))for(ua=Ge,Zc=bc,Ia=Ha;!(Nb=ua+24|0,(w[Ge>>1]|0)==(w[Nb>>1]|0)&&(w[Nb>>1]=0),Ia=Ia+1<<16>>16,(Ia&65535)>=(ha&65535));)Nb=Zc,Zc=Zc+24|0,ua=Nb;while(Ha<<16>>16!=ha<<16>>16);bc=b+12|0;a[bc>>2]&=-1048641;Dk(b);Pi(b)|0;a[P>>2]=1;lb(b,284,P)|0;Oa=a[Lg>>2]|0;for(ua=0;;){if(277==(w[Oa>>1]|0)){na=Da=Oa;pc=29;break}ua=ua+1<<16>>16;if((ua&65535)>=(ha&65535)){pc=32;break}else Oa=Oa+24|0}29==(pc|0)&&(na?Ek(b,na,0)|0&&(w[Da>>1]=0,pc=32):pc=32);
a:do if(32==(pc|0)){Da=a[Lg>>2]|0;for(na=0;;){if(259==(w[Da>>1]|0)){Aa=Na=Da;pc=35;break}na=na+1<<16>>16;if((na&65535)>=(ha&65535)){pc=48;break}else Da=Da+24|0}if(35==(pc|0))if(Aa){Da=aj(b,Aa,ba)|0;if(1==(Da|0)){na=Aa+8|0;Ha=a[na+4>>2]|0;Oa=b+98|0;if(0>Ha>>>0|(0==(Ha|0)?(a[na>>2]|0)>>>0<(N[Oa>>1]|0)>>>0:0))Ga=1;else if(na=lh(b,Aa,P)|0)Ga=na;else{Ha=a[P>>2]|0;ua=w[Oa>>1]|0;Oa=w[Ha>>1]|0;w[ba>>1]=Oa;Zc=Ha;for(Ia=ua;;){Ia=Ia+-1<<16>>16;Zc=Zc+2|0;if(!(Ia<<16>>16)){Ca=0;break}if((w[Zc>>1]|0)!=Oa<<16>>
16){Ca=5;break}}ja(Ha);Ga=Ca}Ea=Ga}else Ea=Da;if(Ea){wh(b,Ea,132906,136291,0);break}a[X>>2]=N[ba>>1];if(!(lb(b,259,X)|0))break;w[Na>>1]=0}else pc=48;if(48!=(pc|0)||(a[T>>2]=1,0!=(lb(b,259,T)|0))){Oa=b+660|0;Zc=b+628|0;Ia=b+656|0;ua=0;Ge=a[Lg>>2]|0;b:for(;;){Nb=w[Ge>>1]|0;c:do if(Nb<<16>>16){sa=a[Oa>>2]|0;d:do if(sa){Hd=a[Ia>>2]|0;Kc=Nb&65535;ya=-1;for(ma=sa;;){oa=(ya+ma|0)/2|0;La=a[a[Hd+(oa<<2)>>2]>>2]|0;if((La|0)==(Kc|0)){ra=oa;break}ya=(pa=La>>>0<Kc>>>0)?oa:ya;ma=pa?ma:oa;if((ya+1|0)==(ma|0)){Ka=
Kc;pc=59;break d}}for(;;){if(!ra){Qa=0;xb=Nb;Zb=Hd;break d}ma=ra+-1|0;if((a[a[Hd+(ma<<2)>>2]>>2]|0)==(Kc|0))ra=ma;else{Wa=ra;break}}-1==(Wa|0)?(Ka=Kc,pc=59):(Qa=Wa,xb=Nb,Zb=Hd)}else Ka=Nb&65535,pc=59;while(0);d:do if(59==(pc|0)){pc=0;sa=a[Zc>>2]|0;a[M>>2]=Ka;a[M+4>>2]=Ka;Wb(sa,132906,133054,M);if(!(qe(b,Hj(b,N[Ge>>1]|0,N[Ge+2>>1]|0)|0,1)|0)){sa=a[Zc>>2]|0;ma=N[Ge>>1]|0;a[O>>2]=ma;a[O+4>>2]=ma;Wb(sa,132906,133099,O);w[Ge>>1]=0;break c}sa=a[Oa>>2]|0;if(!sa){pc=68;break b}ma=w[Ge>>1]|0;ya=a[Ia>>2]|0;
oa=ma&65535;pa=-1;for(La=sa;;){sa=(pa+La|0)/2|0;jb=a[a[ya+(sa<<2)>>2]>>2]|0;if((jb|0)==(oa|0)){mc=sa;break}pa=(Va=jb>>>0<oa>>>0)?sa:pa;La=Va?La:sa;if((pa+1|0)==(La|0)){pc=68;break b}}for(;;){if(!mc){Qa=0;xb=ma;Zb=ya;break d}La=mc+-1|0;if((a[a[ya+(La<<2)>>2]>>2]|0)==(oa|0))mc=La;else{Ta=mc;break}}if(-1==(Ta|0)){pc=68;break b}else Qa=Ta,xb=ma,Zb=ya}while(0);oa=xb&65535;if(xb<<16>>16)if(La=w[(a[Zb+(Qa<<2)>>2]|0)+24>>1]|0,La<<16>>16){d:do if(322<=(oa|0)){if(325>(oa|0))switch(oa|0){case 324:pc=73;break d;
case 322:case 323:break d;default:break c}if(32997>(oa|0))switch(oa|0){case 325:pc=73;break d;case 338:break d;default:break c}else switch(oa|0){case 32998:case 32997:break d;default:break c}}else switch(oa|0){case 279:case 273:pc=73;break;case 278:case 284:case 257:case 256:break;default:break c}while(0);if(73==(pc|0))pc=0,oa=b+40+(((La&65535)>>>5&65535)<<2)|0,a[oa>>2]|=1<<(La&31);else{if(!(Ek(b,Ge,0)|0))break a;w[Ge>>1]=0}}else w[Ge>>1]=0}while(0);ua=ua+1<<16>>16;if((ua&65535)>=(ha&65535)){pc=77;
break}else Ge=Ge+24|0}if(68==(pc|0))Z(133153,133171,3535,132906);else if(77==(pc|0)){Ge=b+88|0;b:do if(6==(w[Ge>>1]|0)&&(ua=b+126|0,2==(w[ua>>1]|0))){Oa=Ia=a[Lg>>2]|0;for(Zc=0;;){if(273==(w[Oa>>1]|0)){Ya=Oa;break}Zc=Zc+1<<16>>16;if((Zc&65535)>=(ha&65535))break b;else Oa=Oa+24|0}if(0!=(Ya|0)&&(Oa=Ya+8|0,1==(a[Oa>>2]|0)&0==(a[Oa+4>>2]|0))){Oa=Ia;for(Zc=0;;){if(279==(w[Oa>>1]|0)){Sa=Oa;break}Zc=Zc+1<<16>>16;if((Zc&65535)>=(ha&65535))break b;else Oa=Oa+24|0}0!=(Sa|0)&&(Oa=Sa+8|0,1==(a[Oa>>2]|0)&0==(a[Oa+
4>>2]|0))&&(w[ua>>1]=1,Wb(a[b+628>>2]|0,132906,133185,A))}}while(0);Oa=b+40|0;Zc=a[Oa>>2]|0;if(Zc&2){if(Zc&4){var Fa;var Pa=b,Pa=Pa|0,Eb=void 0,vb=void 0,tb=void 0,bb=void 0,Ib=void 0,Mb=void 0,eb=void 0,Ua=void 0,ab=void 0,Jb=void 0,Ab=void 0,Eb=a[Pa+68>>2]|0,vb=a[Pa+72>>2]|0,tb=a[Pa+76>>2]|0,bb=-1==(Eb|0)?a[Pa+56>>2]|0:Eb,Ib=-1==(vb|0)?a[Pa+60>>2]|0:vb,Mb=-1==(tb|0)?a[Pa+64>>2]|0:tb;0==(bb|0)|0==(Ib|0)|0==(Mb|0)?eb=0:(tb=a[Pa+56>>2]|0,Ua=tb>>>0<(0-bb|0)>>>0?((bb+-1+tb|0)>>>0)/(bb>>>0)|0:0,bb=a[Pa+
60>>2]|0,ab=bb>>>0<(0-Ib|0)>>>0?((Ib+-1+bb|0)>>>0)/(Ib>>>0)|0:0,Ib=of(Pa,Ua,ab,139573)|0,ab=a[Pa+64>>2]|0,Jb=ab>>>0<(0-Mb|0)>>>0?((Mb+-1+ab|0)>>>0)/(Mb>>>0)|0:0,eb=of(Pa,Ib,Jb,139573)|0);2!=(w[Pa+126>>1]|0)?Fa=eb|0:(Ab=of(Pa,eb,N[Pa+98>>1]|0,139573)|0,Fa=Ab|0);mb=Zc=Fa|0;Db=a[bc>>2]|1024}else{var yb;var cb=b,cb=cb|0,gc=void 0,Ub=void 0,Fb=void 0,pb=void 0,gc=a[cb+100>>2]|0;-1!=(gc|0)?(Ub=a[cb+60>>2]|0,Fb=Ub>>>0<(0-gc|0)>>>0?((gc+-1+Ub|0)>>>0)/(gc>>>0)|0:0):Fb=1;2!=(w[cb+126>>1]|0)?yb=Fb|0:(pb=of(cb,
Fb,N[cb+98>>1]|0,138713)|0,yb=pb|0);Zc=yb|0;a[b+68>>2]=a[b+56>>2];a[b+72>>2]=a[b+100>>2];a[b+76>>2]=a[b+64>>2];mb=Zc;Db=a[bc>>2]&-1025}Zc=b+168|0;a[Zc>>2]=mb;a[bc>>2]=Db;if(mb){Ia=b+164|0;a[Ia>>2]=mb;Da=b+126|0;2==(w[Da>>1]|0)&&(a[Ia>>2]=(mb>>>0)/((N[b+98>>1]|0)>>>0)|0);na=a[Oa>>2]|0;do if(!(na&33554432)){Ha=Db&1024;if(6==(w[Ge>>1]|0)&0==(Ha|0))if(1==(mb|0)){a[Oa>>2]=na|33554432;break}else cc=0;else cc=Ha;Ha=a[b+628>>2]|0;a[L>>2]=0!=(cc|0)?133388:133400;Y(Ha,133269,133285,L);break a}while(0);na=b+
98|0;Ha=b+172|0;Nb=b+176|0;oa=b+628|0;pa=b+84|0;Kc=Hd=0;sa=a[Lg>>2]|0;b:for(;;){Va=w[sa>>1]|0;jb=Va&65535;c:do if(301>(jb|0)){switch(jb|0){case 0:Za=Hd;break c;case 258:case 281:case 280:pc=105;break c;case 273:pc=126;break c;case 279:pc=127;break c;case 255:break;default:pc=141;break c}0==(aj(b,sa,ga)|0)&&(ia=w[ga>>1]|0,qa=2==ia<<16>>16?1:3==ia<<16>>16?2:0,0!=(qa|0))&&(a[x>>2]=qa,lb(b,254,x)|0);Za=Hd}else{if(339<=(jb|0)){d:do if(341<=(jb|0))if(32996>(jb|0))switch(jb|0){case 341:break d;default:pc=
141;break c}else switch(jb|0){case 32996:pc=105;break c;default:pc=141;break c}else switch(jb|0){case 339:pc=105;break c;case 340:break;default:pc=141;break c}while(0);La=sa+8|0;if(0!=(a[La+4>>2]|0)||(a[La>>2]|0)!=(N[na>>1]|0)){Ja=Va;ea=1;break b}if(La=D(b,sa,Te)|0){wa=La;Ma=sa;pc=121;break b}La=a[bc>>2]|0;a[bc>>2]=La|4194304;qa=N[sa>>1]|0;ia=a[Te>>2]|0;a[I>>2]=ia;xa=lb(b,qa,I)|0;a[bc>>2]=La;ja(ia);if(xa){Za=Hd;break}else break a}switch(jb|0){case 324:pc=126;break c;case 325:pc=127;break c;case 301:case 320:break;
default:pc=141;break c}a[W>>2]=0;if(Hd){ia=N[pa>>1]|0;xa=1<<ia;La=sa+8|0;qa=a[La>>2]|0;la=a[La+4>>2]|0;Ba=(La=301==Va<<16>>16&(qa|0)==(xa|0)&0==(la|0))?0:xa;if(0==(la|0)&&(qa|0)==((La?xa:3<<ia)|0))if(ia=lh(b,sa,W)|0,xa=N[sa>>1]|0,ia)va=xa,za=ia;else{La=a[W>>2]|0;a[Ed>>2]=La;a[Ed+4>>2]=La+(Ba<<1);a[Ed+8>>2]=La+(Ba<<1<<1);lb(b,xa,Ed)|0;ja(La);Za=Hd;break}else va=jb,za=1;ta=(ia=Lf(b,va)|0)?a[ia+28>>2]|0:133413;wh(b,za,132906,ta,1);Za=Hd}else xa=Lf(b,jb)|0,ia=a[oa>>2]|0,$a=xa?a[xa+28>>2]|0:133413,a[J>>
2]=$a,Wb(ia,132906,133429,J),Za=0}while(0);if(105==(pc|0)){pc=0;jb=aj(b,sa,bf)|0;if(1==(jb|0)){Va=sa+8|0;ua=a[Va+4>>2]|0;if(0>ua>>>0|(0==(ua|0)?(a[Va>>2]|0)>>>0<(N[na>>1]|0)>>>0:0))sc=1;else if(Va=lh(b,sa,P)|0)sc=Va;else{ua=a[P>>2]|0;ia=w[na>>1]|0;xa=w[ua>>1]|0;w[bf>>1]=xa;La=ua;for(Ba=ia;;){Ba=Ba+-1<<16>>16;La=La+2|0;if(!(Ba<<16>>16)){nb=0;break}if((w[La>>1]|0)!=xa<<16>>16){nb=5;break}}ja(ua);sc=nb}gb=sc}else gb=jb;xa=N[sa>>1]|0;if(gb){hb=xa;ob=gb;pc=114;break}a[G>>2]=N[bf>>1];if(!(lb(b,xa,G)|0))break a;
Za=258==(w[sa>>1]|0)?1:Hd}else if(126==(pc|0))if(pc=0,F(b,sa,a[Zc>>2]|0,Ha)|0)Za=Hd;else break a;else if(127==(pc|0))if(pc=0,F(b,sa,a[Zc>>2]|0,Nb)|0)Za=Hd;else break a;else 141==(pc|0)&&(pc=0,Ek(b,sa,1)|0,Za=Hd);Kc=Kc+1<<16>>16;if((Kc&65535)>=(ha&65535)){pc=143;break}else Hd=Za,sa=sa+24|0}if(114==(pc|0))Bb=(sa=Lf(b,hb)|0)?a[sa+28>>2]|0:133413,wh(b,ob,132906,Bb,0);else{if(121==(pc|0))Ja=w[Ma>>1]|0,ea=wa;else if(143==(pc|0)){b:do if(6==(w[Ge>>1]|0)){if(a[Oa>>2]&256)sa=b+90|0,2==(w[sa>>1]|0)&&(w[sa>>
1]=6,Wb(a[b+628>>2]|0,132906,133526,Q));else if(Wb(a[b+628>>2]|0,132906,133475,r),a[C>>2]=6,!(lb(b,262,C)|0))break a;sa=a[Oa>>2]|0;if(sa&64)qb=sa;else{Wb(a[b+628>>2]|0,132906,133605,z);a[t>>2]=8;if(!(lb(b,258,t)|0))break a;qb=a[Oa>>2]|0}if(!(qb&65536)){sa=b+90|0;Hd=w[sa>>1]|0;if(2==Hd<<16>>16){Wb(a[b+628>>2]|0,132906,133662,H);a[B>>2]=3;if(!(lb(b,277,B)|0))break a;kb=w[sa>>1]|0}else kb=Hd;switch(kb<<16>>16){case 6:if(Wb(a[b+628>>2]|0,132906,133738,y),a[q>>2]=3,lb(b,277,q)|0)break b;else break a;case 1:case 0:if(a[p>>
2]=1,lb(b,277,p)|0)break b;else break a;default:break b}}}while(0);Hd=b+90|0;do if(3==(w[Hd>>1]|0)&&0==(a[Oa>>2]&67108864|0)){if(7>=(N[b+84>>1]|0)){sa=a[b+628>>2]|0;a[n>>2]=133814;Y(sa,133269,133285,n);break a}w[Hd>>1]=3==(w[b+98>>1]|0)?2:1}while(0);sa=w[Ge>>1]|0;b:do if(6!=sa<<16>>16){if(!(a[Oa>>2]&16777216)){switch(w[Da>>1]|0){case 1:pc=1<(a[Zc>>2]|0)>>>0?170:171;break;case 2:pc=(a[Zc>>2]|0)==(N[b+98>>1]|0)?171:170;break;default:pc=171}if(170==(pc|0)){Kc=a[b+628>>2]|0;a[l>>2]=133823;Y(Kc,133269,
133285,l);break a}else if(171==(pc|0))if(Wb(a[b+628>>2]|0,132906,133839,k),0>(S(b,a[Lg>>2]|0,ha)|0))break a;else break}c:do if(1==(a[Zc>>2]|0)&&(Kc=b+172|0,Nb=a[Kc>>2]|0,!(0==(a[Nb>>2]|0)&0==(a[Nb+4>>2]|0)))){Nb=b+176|0;Ha=a[Nb>>2]|0;na=a[Ha>>2]|0;pa=a[Ha+4>>2]|0;do if(!(0==(na|0)&0==(pa|0)||1==sa<<16>>16&&(Ha=da[a[b+648>>2]&63](a[b+628>>2]|0)|0,oa=a[Kc>>2]|0,xa=Ic(Ha|0,U|0,a[oa>>2]|0,a[oa+4>>2]|0)|0,oa=U,pa>>>0>oa>>>0|(pa|0)==(oa|0)&na>>>0>xa>>>0))){if(a[b+8>>2]|0)break c;if(1!=(w[Ge>>1]|0))break c;
xa=a[Nb>>2]|0;oa=a[xa>>2]|0;Ha=a[xa+4>>2]|0;xa=Td(b)|0;La=Cf(a[b+60>>2]|0,0,xa|0,U|0)|0;xa=U;if(!(Ha>>>0<xa>>>0|(Ha|0)==(xa|0)&oa>>>0<La>>>0))break c}while(0);Wb(a[b+628>>2]|0,132906,133928,m);if(0>(S(b,a[Lg>>2]|0,ha)|0))break a;else break b}while(0);if(1==(w[Da>>1]|0)&&2<(a[Zc>>2]|0)>>>0&&1==(w[Ge>>1]|0)&&(Va=jb=a[b+176>>2]|0,ua=a[Va>>2]|0,Nb=a[Va+4>>2]|0,Va=jb+8|0,jb=a[Va>>2]|0,na=a[Va+4>>2]|0,!(0==(jb|0)&0==(na|0)|0==(ua|0)&0==(Nb|0)|(ua|0)==(jb|0)&(Nb|0)==(na|0))&&(Wb(a[b+628>>2]|0,132906,134001,
h),0>(S(b,a[Lg>>2]|0,ha)|0))))break a}while(0);if(sa=a[Lg>>2]|0)ja(sa),a[Lg>>2]=0;a[Oa>>2]&524288||(sa=w[b+84>>1]|0,w[b+106>>1]=15<(sa&65535)?-1:(1<<(sa&65535))+65535);Oa=a[Zc>>2]|0;b:do if(1<Oa>>>0){sa=b+180|0;a[sa>>2]=1;Nb=na=a[b+172>>2]|0;jb=a[Nb+4>>2]|0;ua=a[Nb>>2]|0;for(Nb=1;;){Va=na+(Nb<<3)|0;pa=ua;ua=a[Va>>2]|0;Kc=jb;jb=a[Va+4>>2]|0;Nb=Nb+1|0;if(Kc>>>0>jb>>>0|(Kc|0)==(jb|0)&pa>>>0>ua>>>0)break;if(Nb>>>0>=Oa>>>0)break b}a[sa>>2]=0}while(0);da[a[b+504>>2]&63](b)|0;do if(1==(w[Da>>1]|0)&&1==(a[Zc>>
2]|0)&&1==(w[Ge>>1]|0)&&(Oa=a[bc>>2]|0,32768==(Oa&33792|0))){Nb=b+176|0;ua=a[Nb>>2]|0;if(!ua)return ca=0,u=d,ca|0;jb=ua;ua=a[jb>>2]|0;na=a[jb+4>>2]|0;jb=b+172|0;pa=a[jb>>2]|0;Kc=a[pa>>2]|0;Va=a[pa+4>>2]|0;ib=0==(Oa&16384|0)&6==(w[Hd>>1]|0)?N[b+194>>1]|0:1;Oa=Kf(b,ib)|0;pa=U;if(0<pa>>>0|0==(pa|0)&8192<Oa>>>0)Cb=Oa,ub=pa,sb=ib;else{if(0==(Oa|0)&0==(pa|0))break;La=pf(8192,0,Oa|0,pa|0)|0;oa=E(La,ib)|0;Cb=xa=Cf(La|0,U|0,Oa|0,pa|0)|0;ub=U;sb=oa}if(!(sb>>>0>=(a[b+100>>2]|0)>>>0||(oa=Qb(ua|0,na|0,-1,-1)|
0,xa=Qb(oa|0,U|0,Cb|0,ub|0)|0,oa=pf(xa|0,U|0,Cb|0,ub|0)|0,xa=Qb(oa|0,U|0,-1,-1)|0,pa=U,0<pa>>>0|0==(pa|0)&4294967294<xa>>>0)))if(xa=Mf(b,oa,8,134074)|0,pa=Mf(b,oa,8,134110)|0,Oa=0==(xa|0),La=0==(pa|0),Oa|La)Oa||ja(xa),La||ja(pa);else{if(oa)for(Ha=ub,Ba=na,na=Cb,ia=ua,ua=Kc,Kc=Va,Va=0;na=(qa=Ha>>>0>Ba>>>0|(Ha|0)==(Ba|0)&na>>>0>ia>>>0)?ia:na,Ha=qa?Ba:Ha,qa=xa+(Va<<3)|0,a[qa>>2]=na,a[qa+4>>2]=Ha,qa=pa+(Va<<3)|0,a[qa>>2]=ua,a[qa+4>>2]=Kc,ua=Qb(na|0,Ha|0,ua|0,Kc|0)|0,Kc=U,ia=Ic(ia|0,Ba|0,na|0,Ha|0)|0,
Va=Va+1|0,(Va|0)!=(oa|0);)Ba=U;a[Zc>>2]=oa;a[Ia>>2]=oa;a[g>>2]=sb;lb(b,278,g)|0;ja(a[Nb>>2]|0);ja(a[jb>>2]|0);a[Nb>>2]=xa;a[jb>>2]=pa;a[b+180>>2]=1}}while(0);a[bc>>2]&=-2097161;a[b+444>>2]=-1;a[b+452>>2]=-1;a[b+488>>2]=-1;a[b+492>>2]=-1;Ia=b+496|0;a[Ia>>2]=-1;Zc=Pe(b)|0;a[b+580>>2]=Zc;if(!Zc)return Y(a[b+628>>2]|0,132906,134143,f),ca=0,u=d,ca|0;if(a[bc>>2]&1024){Zc=Og(b)|0;if(a[Ia>>2]=Zc)return ca=1,u=d,ca|0;Y(a[b+628>>2]|0,132906,134176,e)}else{if(se(b)|0)return ca=1,u=d,ca|0;Y(a[b+628>>2]|0,132906,
134205,c)}ca=0;u=d;return ca|0}Xa=(Zc=Lf(b,Ja&65535)|0)?a[Zc+28>>2]|0:133413;wh(b,ea,132906,Xa,0)}}else Ia=a[b+628>>2]|0,a[K>>2]=0!=(Db&1024|0)?133343:133349,Y(Ia,132906,133356,K)}else Ia=a[b+628>>2]|0,a[v>>2]=133331,Y(Ia,133269,133285,v)}}}while(0);Xa=a[Lg>>2]|0;if(!Xa)return ca=0,u=d,ca|0;ja(Xa);ca=0;u=d;return ca|0}function Ij(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,r,V,Ed,J,I,G,L,K,v,A,O,M;g=u;u=u+128|0;h=g+112|0;m=g+104|0;k=g+96|0;l=g+88|0;n=g+80|0;p=g+72|0;q=g+
64|0;y=g+56|0;B=g+48|0;H=g+40|0;ka=g+32|0;z=g+24|0;Q=g+16|0;C=g+124|0;r=g+8|0;V=g+120|0;Ed=g;J=g+116|0;e||Z(135626,133171,4453,135631);G=I=b+16|0;a[G>>2]=d;a[G+4>>2]=c;if(c=0!=(f|0))G=f,a[G>>2]=0,a[G+4>>2]=0;G=b+12|0;d=a[G>>2]|0;do if(d&2048){A=I;v=a[A>>2]|0;if((v|0)!=(v|0)||((0>(v|0))<<31>>31|0)!=(a[A+4>>2]|0))return Y(a[b+628>>2]|0,135631,135789,q),e=0,u=g,e|0;do{if(d&524288){A=v+8|0;if(2147483639<(v|0)|8>(A|0)?0:(A|0)<=(a[b+616>>2]|0)){Ab(Ed,(a[b+612>>2]|0)+v|0,8);a[G>>2]&128&&kc(Ed);O=Ed;M=a[O>>
2]|0;O=a[O+4>>2]|0;if(!(0<O>>>0|0==(O|0)&4096<M>>>0)){O=M&65535;K=w[C>>1]=O;M=20;O=A;break}Y(a[b+628>>2]|0,135631,135650,k);e=0;u=g;return e|0}Y(a[b+628>>2]|0,135631,135789,l)}else{A=v+2|0;if(2147483645<(v|0)|2>(A|0)?0:(A|0)<=(a[b+616>>2]|0)){Ab(C,(a[b+612>>2]|0)+v|0,2);a[G>>2]&128&&ac(C);O=w[C>>1]|0;if(4096>=(O&65535)){K=O;M=12;O=A;break}Y(a[b+628>>2]|0,135631,135650,n);e=0;u=g;return e|0}Y(a[b+628>>2]|0,135631,135789,p)}e=0;u=g;return e|0}while(0);if(!(K<<16>>16))return Y(a[b+628>>2]|0,135631,135823,
m),e=0,u=g,e|0;v=Mf(b,K&65535,M,135730)|0;if(!v)return e=0,u=g,e|0;L=E(N[C>>1]|0,M)|0;K=L+O|0;if((K|0)<(O|0)|(K|0)<(L|0)?0:(A=b+616|0,(K|0)<=(a[A>>2]|0)))K=b+612|0,Ab(v,(a[K>>2]|0)+O|0,L),c&&(L=(E(N[C>>1]|0,M)|0)+O|0,O=a[G>>2]|0,O&524288?(M=L+8|0,(2147483639<(L|0)|8>(M|0)?0:(M|0)<=(a[A>>2]|0))?(Ab(f,(a[K>>2]|0)+L|0,8),A=a[G>>2]|0):(M=f,a[M>>2]=0,a[M+4>>2]=0,A=O),A&128&&kc(f)):(M=L+4|0,(2147483643<(L|0)|4>(M|0)?0:(M|0)<=(a[A>>2]|0))?(Ab(J,(a[K>>2]|0)+L|0,4),L=a[G>>2]|0):(a[J>>2]=0,L=O),L&128&&pb(J),
O=f,a[O>>2]=a[J>>2],a[O+4>>2]=0));else return Y(a[b+628>>2]|0,135631,135898,h),ja(v),e=0,u=g,e|0}else{L=b+628|0;K=I;v=rb[a[b+640>>2]&63](a[L>>2]|0,a[K>>2]|0,a[K+4>>2]|0,0)|0;K=I;if((v|0)!=(a[K>>2]|0)||(U|0)!=(a[K+4>>2]|0))return K=a[L>>2]|0,a[Q>>2]=a[b>>2],Y(K,135631,140644,Q),e=0,u=g,e|0;K=b+632|0;v=a[K>>2]|0;A=a[L>>2]|0;if(a[G>>2]&524288){if(8!=(Aa[v&63](A,r,8)|0))return O=a[L>>2]|0,a[H>>2]=a[b>>2],Y(O,135631,140684,H),e=0,u=g,e|0;a[G>>2]&128&&kc(r);O=r;M=a[O>>2]|0;O=a[O+4>>2]|0;if(0<O>>>0|0==(O|
0)&4096<M>>>0)return Y(a[L>>2]|0,135631,135650,B),e=0,u=g,e|0;O=M&65535;v=w[C>>1]=O;M=20}else{if(2!=(Aa[v&63](A,C,2)|0))return O=a[L>>2]|0,a[z>>2]=a[b>>2],Y(O,135631,140684,z),e=0,u=g,e|0;a[G>>2]&128&&ac(C);O=w[C>>1]|0;if(4096<(O&65535))return Y(a[L>>2]|0,135631,135650,ka),e=0,u=g,e|0;v=O;M=12}A=Mf(b,v&65535,M,135730)|0;if(!A)return e=0,u=g,e|0;v=E(N[C>>1]|0,M)|0;O=Aa[a[K>>2]&63](a[L>>2]|0,A,v)|0;if((O|0)!=(E(N[C>>1]|0,M)|0))return O=a[L>>2]|0,a[y>>2]=a[b>>2],Y(O,135631,135753,y),ja(A),e=0,u=g,e|
0;c&&(O=a[K>>2]|0,v=a[L>>2]|0,a[G>>2]&524288?(8!=(Aa[O&63](v,f,8)|0)&&(M=f,a[M>>2]=0,a[M+4>>2]=0),a[G>>2]&128&&kc(f)):(4!=(Aa[O&63](v,V,4)|0)&&(a[V>>2]=0),a[G>>2]&128&&pb(V),v=f,a[v>>2]=a[V>>2],a[v+4>>2]=0));v=A}while(0);h=Mf(b,N[C>>1]|0,24,135730)|0;if(!h)return ja(v),u=g,0;if(w[C>>1]|0)for(b=v,J=h,f=0;!(L=a[G>>2]|0,L&128?(ac(b),d=a[G>>2]|0):d=L,w[J>>1]=w[b>>1]|0,L=b+2|0,d&128&&(ac(L),d=a[G>>2]|0),w[J+2>>1]=w[L>>1]|0,L=b+4|0,A=0!=(d&128|0),d&524288?(A&&kc(L),A=t[L>>0]|0,L=t[b+5>>0]|0,O=t[b+6>>0]|
0,M=t[b+7>>0]|0,c=t[b+8>>0]|0,K=t[b+9>>0]|0,m=t[b+10>>0]|0,l=Oc(x[b+11>>0]|0,0,56)|0,k=U,Ed=Oc(m&255|0,0,48)|0,m=U,p=Oc(K&255|0,0,40)|0,K=U,n=Oc(M&255|0,0,24)|0,M=U,d=Oc(O&255|0,0,16)|0,O=U,q=Oc(L&255|0,0,8)|0,L=J+8|0,a[L>>2]=q|A&255|d|n|p|Ed|l,a[L+4>>2]=U|O|M|c&255|K|m|k,k=t[b+12>>0]|0,m=t[b+13>>0]|0,K=t[b+14>>0]|0,c=t[b+15>>0]|0,M=t[b+16>>0]|0,O=t[b+17>>0]|0,L=t[b+18>>0]|0,l=Oc(x[b+19>>0]|0,0,56)|0,Ed=U,p=Oc(L&255|0,0,48)|0,L=U,n=Oc(O&255|0,0,40)|0,O=U,d=Oc(c&255|0,0,24)|0,c=U,A=Oc(K&255|0,0,16)|
0,K=U,q=Oc(m&255|0,0,8)|0,m=J+16|0,a[m>>2]=q|k&255|A|d|n|p|l,a[m+4>>2]=U|K|c|M&255|O|L|Ed,b=b+20|0):(A&&pb(L),O=J+8|0,a[O>>2]=a[L>>2],a[O+4>>2]=0,a[J+16>>2]=a[b+8>>2],b=b+12|0),f=f+1<<16>>16,(f&65535)>=(N[C>>1]|0));)J=J+24|0;ja(v);a[e>>2]=h;e=w[C>>1]|0;u=g;return e|0}function Ek(b,d,c){b|=0;d|=0;c|=0;var e=0,f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,ka=0,z=0,Q=0,C=0,r=0,V=0,v=0,J=0,I=0,G=0,L=0,K=0,E=0,A=0,O=0,M=0,T=0,X=0,P=0,Oa=0,F=0,R=0,ba=0,bf=0,S=0,Mg=0,ga=0,Ha=0,ma=0,da=0,ha=0,aa=0,pa=0,
pc=0,Nb=0,Hd=0,Zc=0,oa=0,sa=0,Kc=0,ua=0,Ia=0,Da=0,na=0,Na=0,hf=0,Ca=0,Ga=0,Ea=0,La=0,Qa=0,Va=0,Wa=0,ub=0,xb=0,Zb=0,Gb=0,jb=0,mc=0,Kb=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,fe=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Pb=0,Ua=0,Vb=0,Jb=0,Yb=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,fc=0,Sb=0,nd=0,Zd=0,wb=0,db=0,Qd=0,zb=0,Ob=0,Tb=0,jc=0,$b=0,ec=0,lc=0,yc=0,Bc=0,Ec=0,nc=0,Gc=0,Cc=0,Hc=0,hc=0,Fc=
0,vc=0,kd=0,Lc=0,Ic=0,Jc=0,zc=0,xc=0,oc=0,Oc=0,Wc=0,Ie=0,ic=0,Wd=0,Jd=0,bd=0,Uc=0,Rc=0,ad=0,Be=0,Vc=0,cd=0,dd=0,Pc=0,$c=0,hd=0,Bd=0,qd=0,Rb=0,od=0,tc=0,Xb=0,rc=0,ed=0,gd=0,cf=0,ld=0,Xc=0,rd=0,sd=0,Yc=0,wc=0,id=0,dc=0,Ac=0,Sc=0,Tc=0,md=0,td=0,Ce=0,vd=0,wd=0,pd=0,Nf=0,jd=0,ug=0,Ud=0,e=u;u=u+496|0;f=e+376|0;g=e+368|0;h=e+360|0;m=e+352|0;k=e+344|0;l=e+336|0;n=e+328|0;p=e+320|0;q=e+312|0;y=e+304|0;B=e+296|0;H=e+288|0;ka=e+280|0;z=e+272|0;Q=e+264|0;C=e+256|0;r=e+248|0;V=e+240|0;v=e+232|0;J=e+224|0;I=e+
216|0;G=e+208|0;L=e+200|0;K=e+192|0;E=e+176|0;A=e+168|0;O=e+160|0;M=e+152|0;T=e+144|0;X=e+136|0;P=e+128|0;Oa=e+120|0;F=e+112|0;R=e+104|0;ba=e+96|0;bf=e+88|0;S=e+80|0;Mg=e+72|0;ga=e+64|0;Ha=e+484|0;ma=e+488|0;da=e+456|0;ha=e+32|0;aa=e+24|0;pa=e+16|0;pc=e+8|0;Nb=e;Hd=e+480|0;Zc=e+490|0;oa=e+476|0;sa=e+56|0;Kc=e+472|0;ua=e+48|0;Ia=e+40|0;Da=e+468|0;na=e+464|0;Na=e+460|0;hf=e+452|0;Ca=e+448|0;Ga=e+444|0;Ea=e+440|0;La=e+436|0;Qa=e+432|0;Va=e+428|0;Wa=e+424|0;ub=e+420|0;xb=e+416|0;Zb=e+412|0;Gb=e+408|0;
jb=e+404|0;mc=e+400|0;Kb=e+396|0;Ta=e+392|0;Ya=e+388|0;Sa=e+384|0;mb=a[b+660>>2]|0;Db=w[d>>1]|0;a:do if(mb){cc=a[b+656>>2]|0;Za=Db&65535;ia=-1;for(qa=mb;;){Ja=(ia+qa|0)/2|0;ea=a[a[cc+(Ja<<2)>>2]>>2]|0;if((ea|0)==(Za|0)){wa=Ja;break}ia=(Ma=ea>>>0<Za>>>0)?Ja:ia;qa=Ma?qa:Ja;if((ia+1|0)==(qa|0))break a}for(;;){if(!wa){xa=0;break}qa=wa+-1|0;if((a[a[cc+(qa<<2)>>2]>>2]|0)==(Za|0))wa=qa;else{$a=wa;la=7;break}}if(7==(la|0))if(-1==($a|0))break;else xa=$a;(Za=a[cc+(xa<<2)>>2]|0)||Z(135060,133171,4711,135010);
b:do switch(a[Za+16>>2]|0){case 51:Z(135072,133171,4712,135010);break;case 13:Z(135111,133171,4713,135010);break;case 0:la=835;break;case 1:t[Za+27>>0]|0&&Z(135148,133171,4722,135010);if(qa=Ka(b,d,Hd)|0)hb=qa,la=837;else{ia=d+8|0;Ja=a[ia>>2]|0;c:do if(Ja)for(Ma=a[Hd>>2]|0,ea=0;;){if(!(t[Ma>>0]|0)){Ba=ea;break c}va=ea+1|0;if(va>>>0<Ja>>>0)Ma=Ma+1|0,ea=va;else{Ba=va;break}}else Ba=0;while(0);ea=Ba+1|0;do{if(ea>>>0>=Ja>>>0){if(ea>>>0>Ja>>>0){Ma=a[b+628>>2]|0;a[bf>>2]=a[Za+28>>2];Wb(Ma,135010,135303,
bf);Ma=ia;va=a[Ma>>2]|0;za=va+1|0;ta=Qb(va|0,a[Ma+4>>2]|0,1,0)|0;if((za|0)==(ta|0)&0==(U|0))if(ta=eb(za)|0,za=a[Hd>>2]|0,ta){Ab(ta,za,a[ia>>2]|0);t[ta+(a[ia>>2]|0)>>0]=0;za&&ja(za);sc=a[Hd>>2]=ta;break}else nb=za;else nb=a[Hd>>2]|0;if(!nb)return gb=0,u=e,gb|0;ja(nb);gb=0;u=e;return gb|0}}else ta=a[b+628>>2]|0,a[S>>2]=a[Za+28>>2],Wb(ta,135010,135172,S);la=32}while(0);32==(la|0)&&(sc=a[Hd>>2]|0);ia=N[d>>1]|0;a[ba>>2]=sc;Ja=lb(b,ia,ba)|0;sc&&ja(sc);if(Ja)la=836;else return gb=0,u=e,gb|0}break;case 2:1!=
(w[Za+4>>1]|0)&&Z(135354,133171,4771,135010);t[Za+27>>0]|0&&Z(135148,133171,4772,135010);Ja=d+8|0;c:do if(1==(a[Ja>>2]|0)&0==(a[Ja+4>>2]|0))switch(N[d+2>>1]|0){case 1:ob=0;Bb=t[d+16>>0]|0;break c;case 6:ia=t[d+16>>0]|0;ob=(ea=-1<ia<<24>>24)?0:4;Bb=ea?ia:0;break c;case 3:ia=a[b+12>>2]|0;ea=w[d+16>>1]|0;w[Ha>>1]=ea;ia&128?(ac(Ha),qb=w[Ha>>1]|0):qb=ea;ob=(ea=256>(qb&65535))?0:4;Bb=ea?qb&255:0;break c;case 8:ea=a[b+12>>2]|0;ia=w[d+16>>1]|0;w[ma>>1]=ia;ea&128?(ac(ma),kb=w[ma>>1]|0):kb=ia;ob=(ia=256>(kb&
65535))?0:4;Bb=ia?kb&255:0;break c;case 4:ia=a[d+16>>2]|0;a[da>>2]=ia;a[b+12>>2]&128?(pb(da),ib=a[da>>2]|0):ib=ia;ob=(ia=256>ib>>>0)?0:4;Bb=ia?ib&255:0;break c;case 9:ia=a[d+16>>2]|0;a[ha>>2]=ia;a[b+12>>2]&128?(pb(ha),Cb=a[ha>>2]|0):Cb=ia;ob=(ia=256>Cb>>>0)?0:4;Bb=ia?Cb&255:0;break c;case 16:ia=b+12|0;ea=a[ia>>2]|0;ta=d+16|0;do if(ea&524288)za=ta,Ma=a[za+4>>2]|0,va=aa,a[va>>2]=a[za>>2],a[va+4>>2]=Ma,Xa=ea;else if(za=a[ta>>2]|0,a[ga>>2]=za,ea&128?(pb(ga),fe=a[ia>>2]|0,sb=a[ga>>2]|0):(fe=ea,sb=za),
fe&2048?4294967287>=sb>>>0&&(sb+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(aa,(a[b+612>>2]|0)+sb|0,8),la=65):la=69:(za=b+628|0,Ma=rb[a[b+640>>2]&63](a[za>>2]|0,sb,0,0)|0,la=(Ma|0)==(sb|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[za>>2]|0,aa,8)|0)?65:69),65==(la|0))Xa=a[ia>>2]|0;else if(69==(la|0)){ob=3;Bb=0;break c}while(0);Xa&128&&kc(aa);ea=aa;ta=a[ea>>2]|0;ia=a[ea+4>>2]|0;ob=(ea=0>ia>>>0|0==(ia|0)&256>ta>>>0)?0:4;Bb=ea?ta&255:0;break c;case 17:ta=b+12|0;ea=a[ta>>2]|0;ia=d+16|0;do if(ea&524288)Ma=ia,va=a[Ma+4>>
2]|0,za=pa,a[za>>2]=a[Ma>>2],a[za+4>>2]=va,Eb=ea;else if(Ma=a[ia>>2]|0,a[ga>>2]=Ma,ea&128?(pb(ga),Fa=a[ta>>2]|0,Pa=a[ga>>2]|0):(Fa=ea,Pa=Ma),Fa&2048?4294967287>=Pa>>>0&&(Pa+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(pa,(a[b+612>>2]|0)+Pa|0,8),la=80):la=84:(Ma=b+628|0,va=rb[a[b+640>>2]&63](a[Ma>>2]|0,Pa,0,0)|0,la=(va|0)==(Pa|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[Ma>>2]|0,pa,8)|0)?80:84),80==(la|0))Eb=a[ta>>2]|0;else if(84==(la|0)){ob=3;Bb=0;break c}while(0);Eb&128&&kc(pa);ea=pa;ia=a[ea>>2]|0;ta=a[ea+4>>2]|
0;ob=(ea=0>ta>>>0|0==(ta|0)&256>ia>>>0)?0:4;Bb=ea?ia&255:0;break c;default:ob=2;Bb=0;break c}else ob=1,Bb=0;while(0);if(ob)hb=ob,la=837;else if(Ja=N[d>>1]|0,a[R>>2]=Bb&255,lb(b,Ja,R)|0)la=835;else return gb=0,u=e,gb|0;break;case 4:1!=(w[Za+4>>1]|0)&&Z(135354,133171,4784,135010);t[Za+27>>0]|0&&Z(135148,133171,4785,135010);if(Ja=aj(b,d,Zc)|0)hb=Ja,la=837;else if(qa=N[d>>1]|0,a[F>>2]=N[Zc>>1],lb(b,qa,F)|0)la=835;else return gb=0,u=e,gb|0;break;case 6:1!=(w[Za+4>>1]|0)&&Z(135354,133171,4797,135010);t[Za+
27>>0]|0&&Z(135148,133171,4798,135010);Ja=d+8|0;c:do if(1==(a[Ja>>2]|0)&0==(a[Ja+4>>2]|0))switch(N[d+2>>1]|0){case 1:a[oa>>2]=x[d+16>>0];vb=0;break c;case 6:qa=t[d+16>>0]|0;if(-1>=qa<<24>>24){vb=4;break c}a[oa>>2]=qa<<24>>24;vb=0;break c;case 3:qa=a[b+12>>2]|0;ia=w[d+16>>1]|0;w[Ha>>1]=ia;qa&128?(ac(Ha),tb=w[Ha>>1]|0):tb=ia;a[oa>>2]=tb&65535;vb=0;break c;case 8:ia=a[b+12>>2]|0;qa=w[d+16>>1]|0;w[ma>>1]=qa;ia&128?(ac(ma),bb=w[ma>>1]|0):bb=qa;if(-1>=bb<<16>>16){vb=4;break c}a[oa>>2]=bb<<16>>16;vb=0;break c;
case 4:a[oa>>2]=a[d+16>>2];if(!(a[b+12>>2]&128)){vb=0;break c}pb(oa);vb=0;break c;case 9:qa=a[d+16>>2]|0;a[da>>2]=qa;a[b+12>>2]&128?(pb(da),Ib=a[da>>2]|0):Ib=qa;if(qa=Ib>>31&4){vb=qa;break c}a[oa>>2]=Ib;vb=0;break c;case 16:qa=b+12|0;ia=a[qa>>2]|0;ea=d+16|0;do if(ia&524288)ta=ea,va=a[ta+4>>2]|0,za=ha,a[za>>2]=a[ta>>2],a[za+4>>2]=va,Ua=ia;else if(ta=a[ea>>2]|0,a[ga>>2]=ta,ia&128?(pb(ga),Mb=a[qa>>2]|0,Pb=a[ga>>2]|0):(Mb=ia,Pb=ta),Mb&2048?4294967287>=Pb>>>0&&(Pb+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(ha,
(a[b+612>>2]|0)+Pb|0,8),la=125):la=129:(ta=b+628|0,va=rb[a[b+640>>2]&63](a[ta>>2]|0,Pb,0,0)|0,la=(va|0)==(Pb|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[ta>>2]|0,ha,8)|0)?125:129),125==(la|0))Ua=a[qa>>2]|0;else if(129==(la|0)){vb=3;break c}while(0);Ua&128&&kc(ha);ia=ha;ea=a[ia>>2]|0;qa=a[ia+4>>2]|0;if(!(1>qa>>>0|1==(qa|0)&0>ea>>>0)){vb=4;break c}a[oa>>2]=ea;vb=0;break c;case 17:ea=b+12|0;qa=a[ea>>2]|0;ia=d+16|0;do if(qa&524288)va=ia,za=a[va+4>>2]|0,ta=aa,a[ta>>2]=a[va>>2],a[ta+4>>2]=za,Yb=qa;else if(va=
a[ia>>2]|0,a[ga>>2]=va,qa&128?(pb(ga),Vb=a[ea>>2]|0,Jb=a[ga>>2]|0):(Vb=qa,Jb=va),Vb&2048?4294967287>=Jb>>>0&&(Jb+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(aa,(a[b+612>>2]|0)+Jb|0,8),la=141):la=145:(va=b+628|0,za=rb[a[b+640>>2]&63](a[va>>2]|0,Jb,0,0)|0,la=(za|0)==(Jb|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[va>>2]|0,aa,8)|0)?141:145),141==(la|0))Yb=a[ea>>2]|0;else if(145==(la|0)){vb=3;break c}while(0);Yb&128&&kc(aa);qa=aa;ia=a[qa>>2]|0;ea=a[qa+4>>2]|0;if(!(1>ea>>>0|1==(ea|0)&0>ia>>>0)){vb=4;break c}a[oa>>2]=
ia;vb=0;break c;default:vb=2;break c}else vb=1;while(0);if(vb)hb=vb,la=837;else if(Ja=N[d>>1]|0,a[Oa>>2]=a[oa>>2],lb(b,Ja,Oa)|0)la=835;else return gb=0,u=e,gb|0;break;case 8:1!=(w[Za+4>>1]|0)&&Z(135354,133171,4810,135010);t[Za+27>>0]|0&&Z(135148,133171,4811,135010);Ja=d+8|0;c:do if(1==(a[Ja>>2]|0)&0==(a[Ja+4>>2]|0))switch(N[d+2>>1]|0){case 1:ia=sa;a[ia>>2]=x[d+16>>0];yb=a[ia+4>>2]=0;break c;case 6:ia=t[d+16>>0]|0;if(-1>=ia<<24>>24){yb=4;break c}ea=ia<<24>>24;ia=sa;a[ia>>2]=ea;a[ia+4>>2]=(0>(ea|0))<<
31>>31;yb=0;break c;case 3:ea=a[b+12>>2]|0;ia=w[d+16>>1]|0;w[Ha>>1]=ia;ea&128?(ac(Ha),cb=w[Ha>>1]|0):cb=ia;ia=sa;a[ia>>2]=cb&65535;yb=a[ia+4>>2]=0;break c;case 8:ia=a[b+12>>2]|0;ea=w[d+16>>1]|0;w[ma>>1]=ea;ia&128?(ac(ma),gc=w[ma>>1]|0):gc=ea;if(-1>=gc<<16>>16){yb=4;break c}ea=gc<<16>>16;ia=sa;a[ia>>2]=ea;a[ia+4>>2]=(0>(ea|0))<<31>>31;yb=0;break c;case 4:ea=a[d+16>>2]|0;a[da>>2]=ea;a[b+12>>2]&128?(pb(da),Ub=a[da>>2]|0):Ub=ea;ea=sa;a[ea>>2]=Ub;yb=a[ea+4>>2]=0;break c;case 9:ea=a[d+16>>2]|0;a[ha>>2]=
ea;a[b+12>>2]&128?(pb(ha),Fb=a[ha>>2]|0):Fb=ea;if(ea=Fb>>31&4){yb=ea;break c}ea=sa;a[ea>>2]=Fb;a[ea+4>>2]=(0>(Fb|0))<<31>>31;yb=0;break c;case 16:ea=b+12|0;ia=a[ea>>2]|0;qa=d+16|0;do{if(ia&524288)za=qa,ta=a[za+4>>2]|0,va=sa,a[va>>2]=a[za>>2],a[va+4>>2]=ta,Zd=ia;else{za=a[qa>>2]|0;a[ga>>2]=za;ia&128?(pb(ga),fc=a[ea>>2]|0,Sb=a[ga>>2]|0):(fc=ia,Sb=za);if(fc&2048){if(4294967287<Sb>>>0){nd=3;break}if((Sb+8|0)>>>0>(a[b+616>>2]|0)>>>0){nd=3;break}Ab(sa,(a[b+612>>2]|0)+Sb|0,8)}else{za=b+628|0;ta=rb[a[b+640>>
2]&63](a[za>>2]|0,Sb,0,0)|0;if(!((ta|0)==(Sb|0)&0==(U|0))){nd=3;break}if(8!=(Aa[a[b+632>>2]&63](a[za>>2]|0,sa,8)|0)){nd=3;break}}Zd=a[ea>>2]|0}la=184}while(0);184==(la|0)&&(Zd&128&&kc(sa),nd=0);yb=nd;break c;case 17:ia=b+12|0;qa=a[ia>>2]|0;ea=d+16|0;do if(qa&524288)ta=ea,va=a[ta+4>>2]|0,za=aa,a[za>>2]=a[ta>>2],a[za+4>>2]=va,Qd=qa;else if(ta=a[ea>>2]|0,a[ga>>2]=ta,qa&128?(pb(ga),wb=a[ia>>2]|0,db=a[ga>>2]|0):(wb=qa,db=ta),wb&2048?4294967287>=db>>>0&&(db+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(aa,(a[b+612>>
2]|0)+db|0,8),la=196):la=200:(ta=b+628|0,va=rb[a[b+640>>2]&63](a[ta>>2]|0,db,0,0)|0,la=(va|0)==(db|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[ta>>2]|0,aa,8)|0)?196:200),196==(la|0))Qd=a[ia>>2]|0;else if(200==(la|0)){yb=3;break c}while(0);Qd&128&&kc(aa);qa=aa;ea=a[qa>>2]|0;ia=a[qa+4>>2]|0;if(!(-1<(ia|0)|-1==(ia|0)&4294967295<ea>>>0)){yb=4;break c}qa=sa;a[qa>>2]=ea;a[qa+4>>2]=ia;yb=0;break c;default:yb=2;break c}else yb=1;while(0);if(yb)hb=yb,la=837;else if(Ja=N[d>>1]|0,ia=sa,qa=a[ia+4>>2]|0,ea=P,a[ea>>
2]=a[ia>>2],a[ea+4>>2]=qa,lb(b,Ja,P)|0)la=835;else return gb=0,u=e,gb|0;break;case 10:1!=(w[Za+4>>1]|0)&&Z(135354,133171,4823,135010);t[Za+27>>0]|0&&Z(135148,133171,4824,135010);Ja=d+8|0;c:do if(1==(a[Ja>>2]|0)&0==(a[Ja+4>>2]|0)){do switch(N[d+2>>1]|0){case 1:W[Kc>>2]=+(x[d+16>>0]|0);zb=0;break c;case 6:W[Kc>>2]=+(t[d+16>>0]|0);zb=0;break c;case 3:qa=a[b+12>>2]|0;ea=w[d+16>>1]|0;w[ma>>1]=ea;qa&128?(ac(ma),Ob=w[ma>>1]|0):Ob=ea;W[Kc>>2]=+(Ob&65535);zb=0;break c;case 8:ea=a[b+12>>2]|0;qa=w[d+16>>1]|
0;w[da>>1]=qa;ea&128?(ac(da),Tb=w[da>>1]|0):Tb=qa;W[Kc>>2]=+(Tb<<16>>16);zb=0;break c;case 4:qa=a[d+16>>2]|0;a[ha>>2]=qa;a[b+12>>2]&128?(pb(ha),jc=a[ha>>2]|0):jc=qa;W[Kc>>2]=+(jc>>>0);zb=0;break c;case 9:qa=a[d+16>>2]|0;a[aa>>2]=qa;a[b+12>>2]&128?(pb(aa),$b=a[aa>>2]|0):$b=qa;W[Kc>>2]=+($b|0);zb=0;break c;case 16:qa=b+12|0;ea=a[qa>>2]|0;ia=d+16|0;do if(ea&524288)va=ia,za=a[va+4>>2]|0,ta=pa,a[ta>>2]=a[va>>2],a[ta+4>>2]=za,yc=ea;else if(va=a[ia>>2]|0,a[ga>>2]=va,ea&128?(pb(ga),ec=a[qa>>2]|0,lc=a[ga>>
2]|0):(ec=ea,lc=va),ec&2048?4294967287>=lc>>>0&&(lc+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(pa,(a[b+612>>2]|0)+lc|0,8),la=234):la=238:(va=b+628|0,za=rb[a[b+640>>2]&63](a[va>>2]|0,lc,0,0)|0,la=(za|0)==(lc|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[va>>2]|0,pa,8)|0)?234:238),234==(la|0))yc=a[qa>>2]|0;else if(238==(la|0)){zb=3;break c}while(0);yc&128&&kc(pa);ea=pa;W[Kc>>2]=+((a[ea>>2]|0)>>>0)+4294967296*+((a[ea+4>>2]|0)>>>0);zb=0;break c;case 17:ea=b+12|0;ia=a[ea>>2]|0;qa=d+16|0;do if(ia&524288)za=qa,ta=a[za+4>>
2]|0,va=pc,a[va>>2]=a[za>>2],a[va+4>>2]=ta,nc=ia;else if(za=a[qa>>2]|0,a[ga>>2]=za,ia&128?(pb(ga),Bc=a[ea>>2]|0,Ec=a[ga>>2]|0):(Bc=ia,Ec=za),Bc&2048?4294967287>=Ec>>>0&&(Ec+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(pc,(a[b+612>>2]|0)+Ec|0,8),la=249):la=253:(za=b+628|0,ta=rb[a[b+640>>2]&63](a[za>>2]|0,Ec,0,0)|0,la=(ta|0)==(Ec|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[za>>2]|0,pc,8)|0)?249:253),249==(la|0))nc=a[ea>>2]|0;else if(253==(la|0)){zb=3;break c}while(0);nc&128&&kc(pc);ia=pc;W[Kc>>2]=+((a[ia>>2]|0)>>>0)+
4294967296*+(a[ia+4>>2]|0);zb=0;break c;case 5:ia=b+12|0;qa=a[ia>>2]|0;ea=d+16|0;do if(qa&524288)ta=ea,va=a[ta+4>>2]|0,za=ga,a[za>>2]=a[ta>>2],a[za+4>>2]=va,Hc=qa;else if(ta=a[ea>>2]|0,a[Ha>>2]=ta,qa&128?(pb(Ha),Gc=a[ia>>2]|0,Cc=a[Ha>>2]|0):(Gc=qa,Cc=ta),Gc&2048?4294967287>=Cc>>>0&&(Cc+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(ga,(a[b+612>>2]|0)+Cc|0,8),la=264):la=270:(ta=b+628|0,va=rb[a[b+640>>2]&63](a[ta>>2]|0,Cc,0,0)|0,la=(va|0)==(Cc|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[ta>>2]|0,ga,8)|0)?264:270),264==
(la|0))Hc=a[ia>>2]|0;else if(270==(la|0)){zb=3;break c}while(0);Hc&128&&Id(ga,2);hc=(qa=a[ga>>2]|0)?+(qa>>>0)/+((a[ga+4>>2]|0)>>>0):0;W[Kc>>2]=hc;zb=0;break c;case 10:qa=b+12|0;ea=a[qa>>2]|0;ia=d+16|0;do if(ea&524288)va=ia,za=a[va+4>>2]|0,ta=ga,a[ta>>2]=a[va>>2],a[ta+4>>2]=za,kd=ea;else if(va=a[ia>>2]|0,a[Ha>>2]=va,ea&128?(pb(Ha),Fc=a[qa>>2]|0,vc=a[Ha>>2]|0):(Fc=ea,vc=va),Fc&2048?4294967287>=vc>>>0&&(vc+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(ga,(a[b+612>>2]|0)+vc|0,8),la=281):la=287:(va=b+628|0,za=rb[a[b+
640>>2]&63](a[va>>2]|0,vc,0,0)|0,la=(za|0)==(vc|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[va>>2]|0,ga,8)|0)?281:287),281==(la|0))kd=a[qa>>2]|0;else if(287==(la|0)){zb=3;break c}while(0);kd&128&&Id(ga,2);Lc=(ea=a[ga>>2]|0)?+(ea|0)/+((a[ga+4>>2]|0)>>>0):0;W[Kc>>2]=Lc;zb=0;break c;case 11:ea=a[b+12>>2]|0;a[Kc>>2]=a[d+16>>2];if(!(ea&128)){zb=0;break c}pb(Kc);zb=0;break c;case 12:ea=b+12|0;ia=a[ea>>2]|0;qa=d+16|0;do if(ia&524288)Hb[Nb>>3]=+Hb[qa>>3],zc=ia;else if(za=a[qa>>2]|0,a[ga>>2]=za,ia&128?(pb(ga),Ic=
a[ea>>2]|0,Jc=a[ga>>2]|0):(Ic=ia,Jc=za),Ic&2048?4294967287>=Jc>>>0&&(Jc+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(Nb,(a[b+612>>2]|0)+Jc|0,8),la=300):la=304:(za=b+628|0,ta=rb[a[b+640>>2]&63](a[za>>2]|0,Jc,0,0)|0,la=(ta|0)==(Jc|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[za>>2]|0,Nb,8)|0)?300:304),300==(la|0))zc=a[ea>>2]|0;else if(304==(la|0)){zb=3;break c}while(0);zc&128&&kc(Nb);W[Kc>>2]=+Hb[Nb>>3];zb=0;break c;default:zb=2;break c}while(0)}else zb=1;while(0);if(zb)hb=zb,la=837;else if(Ja=N[d>>1]|0,Hb[X>>3]=+W[Kc>>
2],lb(b,Ja,X)|0)la=835;else return gb=0,u=e,gb|0;break;case 11:1!=(w[Za+4>>1]|0)&&Z(135354,133171,4836,135010);t[Za+27>>0]|0&&Z(135148,133171,4837,135010);Ja=d+8|0;c:do if(1==(a[Ja>>2]|0)&0==(a[Ja+4>>2]|0)){do switch(N[d+2>>1]|0){case 1:Hb[ua>>3]=+(x[d+16>>0]|0);xc=0;break c;case 6:Hb[ua>>3]=+(t[d+16>>0]|0);xc=0;break c;case 3:ia=a[b+12>>2]|0;qa=w[d+16>>1]|0;w[ma>>1]=qa;ia&128?(ac(ma),oc=w[ma>>1]|0):oc=qa;Hb[ua>>3]=+(oc&65535);xc=0;break c;case 8:qa=a[b+12>>2]|0;ia=w[d+16>>1]|0;w[da>>1]=ia;qa&128?
(ac(da),Oc=w[da>>1]|0):Oc=ia;Hb[ua>>3]=+(Oc<<16>>16);xc=0;break c;case 4:ia=a[d+16>>2]|0;a[ha>>2]=ia;a[b+12>>2]&128?(pb(ha),Wc=a[ha>>2]|0):Wc=ia;Hb[ua>>3]=+(Wc>>>0);xc=0;break c;case 9:ia=a[d+16>>2]|0;a[aa>>2]=ia;a[b+12>>2]&128?(pb(aa),Ie=a[aa>>2]|0):Ie=ia;Hb[ua>>3]=+(Ie|0);xc=0;break c;case 16:ia=b+12|0;qa=a[ia>>2]|0;ea=d+16|0;do if(qa&524288)za=ea,ta=a[za+4>>2]|0,va=pa,a[va>>2]=a[za>>2],a[va+4>>2]=ta,Jd=qa;else if(za=a[ea>>2]|0,a[ga>>2]=za,qa&128?(pb(ga),ic=a[ia>>2]|0,Wd=a[ga>>2]|0):(ic=qa,Wd=za),
ic&2048?4294967287>=Wd>>>0&&(Wd+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(pa,(a[b+612>>2]|0)+Wd|0,8),la=337):la=341:(za=b+628|0,ta=rb[a[b+640>>2]&63](a[za>>2]|0,Wd,0,0)|0,la=(ta|0)==(Wd|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[za>>2]|0,pa,8)|0)?337:341),337==(la|0))Jd=a[ia>>2]|0;else if(341==(la|0)){xc=3;break c}while(0);Jd&128&&kc(pa);qa=pa;Hb[ua>>3]=+((a[qa>>2]|0)>>>0)+4294967296*+((a[qa+4>>2]|0)>>>0);xc=0;break c;case 17:qa=b+12|0;ea=a[qa>>2]|0;ia=d+16|0;do if(ea&524288)ta=ia,va=a[ta+4>>2]|0,za=pc,a[za>>
2]=a[ta>>2],a[za+4>>2]=va,Rc=ea;else if(ta=a[ia>>2]|0,a[ga>>2]=ta,ea&128?(pb(ga),bd=a[qa>>2]|0,Uc=a[ga>>2]|0):(bd=ea,Uc=ta),bd&2048?4294967287>=Uc>>>0&&(Uc+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(pc,(a[b+612>>2]|0)+Uc|0,8),la=352):la=356:(ta=b+628|0,va=rb[a[b+640>>2]&63](a[ta>>2]|0,Uc,0,0)|0,la=(va|0)==(Uc|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[ta>>2]|0,pc,8)|0)?352:356),352==(la|0))Rc=a[qa>>2]|0;else if(356==(la|0)){xc=3;break c}while(0);Rc&128&&kc(pc);ea=pc;Hb[ua>>3]=+((a[ea>>2]|0)>>>0)+4294967296*+(a[ea+
4>>2]|0);xc=0;break c;case 5:ea=b+12|0;ia=a[ea>>2]|0;qa=d+16|0;do{if(ia&524288)va=qa,za=a[va+4>>2]|0,ta=ga,a[ta>>2]=a[va>>2],a[ta+4>>2]=za,cd=ia;else{va=a[qa>>2]|0;a[Ha>>2]=va;ia&128?(pb(Ha),ad=a[ea>>2]|0,Be=a[Ha>>2]|0):(ad=ia,Be=va);if(ad&2048){if(4294967287<Be>>>0){Vc=3;break}if((Be+8|0)>>>0>(a[b+616>>2]|0)>>>0){Vc=3;break}Ab(ga,(a[b+612>>2]|0)+Be|0,8)}else{va=b+628|0;za=rb[a[b+640>>2]&63](a[va>>2]|0,Be,0,0)|0;if(!((za|0)==(Be|0)&0==(U|0))){Vc=3;break}if(8!=(Aa[a[b+632>>2]&63](a[va>>2]|0,ga,8)|
0)){Vc=3;break}}cd=a[ea>>2]|0}la=369}while(0);369==(la|0)&&(cd&128&&Id(ga,2),dd=(ia=a[ga>>2]|0)?+(ia>>>0)/+((a[ga+4>>2]|0)>>>0):0,Hb[ua>>3]=dd,Vc=0);xc=Vc;break c;case 10:ia=b+12|0;qa=a[ia>>2]|0;ea=d+16|0;do{if(qa&524288)za=ea,ta=a[za+4>>2]|0,va=ga,a[va>>2]=a[za>>2],a[va+4>>2]=ta,Bd=qa;else{za=a[ea>>2]|0;a[Ha>>2]=za;qa&128?(pb(Ha),Pc=a[ia>>2]|0,$c=a[Ha>>2]|0):(Pc=qa,$c=za);if(Pc&2048){if(4294967287<$c>>>0){hd=3;break}if(($c+8|0)>>>0>(a[b+616>>2]|0)>>>0){hd=3;break}Ab(ga,(a[b+612>>2]|0)+$c|0,8)}else{za=
b+628|0;ta=rb[a[b+640>>2]&63](a[za>>2]|0,$c,0,0)|0;if(!((ta|0)==($c|0)&0==(U|0))){hd=3;break}if(8!=(Aa[a[b+632>>2]&63](a[za>>2]|0,ga,8)|0)){hd=3;break}}Bd=a[ia>>2]|0}la=386}while(0);386==(la|0)&&(Bd&128&&Id(ga,2),qd=(qa=a[ga>>2]|0)?+(qa|0)/+((a[ga+4>>2]|0)>>>0):0,Hb[ua>>3]=qd,hd=0);xc=hd;break c;case 11:qa=a[b+12>>2]|0;ea=a[d+16>>2]|0;a[Nb>>2]=ea;qa&128?(pb(Nb),Rb=+W[Nb>>2]):Rb=(a[Qc>>2]=ea,+W[Qc>>2]);Hb[ua>>3]=Rb;xc=0;break c;case 12:ea=b+12|0;qa=a[ea>>2]|0;ia=d+16|0;do{if(qa&524288)Hb[ua>>3]=+Hb[ia>>
3],rc=qa;else{ta=a[ia>>2]|0;a[ga>>2]=ta;qa&128?(pb(ga),od=a[ea>>2]|0,tc=a[ga>>2]|0):(od=qa,tc=ta);if(od&2048){if(4294967287<tc>>>0){Xb=3;break}if((tc+8|0)>>>0>(a[b+616>>2]|0)>>>0){Xb=3;break}Ab(ua,(a[b+612>>2]|0)+tc|0,8)}else{ta=b+628|0;va=rb[a[b+640>>2]&63](a[ta>>2]|0,tc,0,0)|0;if(!((va|0)==(tc|0)&0==(U|0))){Xb=3;break}if(8!=(Aa[a[b+632>>2]&63](a[ta>>2]|0,ua,8)|0)){Xb=3;break}}rc=a[ea>>2]|0}la=406}while(0);406==(la|0)&&(rc&128&&kc(ua),Xb=0);xc=Xb;break c;default:xc=2;break c}while(0)}else xc=1;while(0);
if(xc)hb=xc,la=837;else if(Ja=N[d>>1]|0,Hb[T>>3]=+Hb[ua>>3],lb(b,Ja,T)|0)la=835;else return gb=0,u=e,gb|0;break;case 12:1!=(w[Za+4>>1]|0)&&Z(135354,133171,4849,135010);t[Za+27>>0]|0&&Z(135148,133171,4850,135010);Ja=d+8|0;c:do{if(1==(a[Ja>>2]|0)&0==(a[Ja+4>>2]|0)){switch(N[d+2>>1]|0){case 13:case 4:qa=a[d+16>>2]|0;a[Ha>>2]=qa;a[b+12>>2]&128?(pb(Ha),ed=a[Ha>>2]|0):ed=qa;qa=Ia;a[qa>>2]=ed;a[qa+4>>2]=0;gd=ed;cf=0;break;case 18:case 16:qa=b+12|0;ia=a[qa>>2]|0;ea=d+16|0;do if(ia&524288)ta=ea,va=a[ta+4>>
2]|0,za=Ia,a[za>>2]=a[ta>>2],a[za+4>>2]=va,rd=ia;else if(ta=a[ea>>2]|0,a[ga>>2]=ta,ia&128?(pb(ga),ld=a[qa>>2]|0,Xc=a[ga>>2]|0):(ld=ia,Xc=ta),ld&2048?4294967287>=Xc>>>0&&(Xc+8|0)>>>0<=(a[b+616>>2]|0)>>>0?(Ab(Ia,(a[b+612>>2]|0)+Xc|0,8),la=429):la=434:(ta=b+628|0,va=rb[a[b+640>>2]&63](a[ta>>2]|0,Xc,0,0)|0,la=(va|0)==(Xc|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[ta>>2]|0,Ia,8)|0)?429:434),429==(la|0))rd=a[qa>>2]|0;else if(434==(la|0)){hb=3;la=837;break b}while(0);rd&128&&kc(Ia);ia=Ia;gd=a[ia>>2]|0;cf=a[ia+
4>>2]|0;break;default:sd=2;break c}ia=N[d>>1]|0;ea=M;a[ea>>2]=gd;a[ea+4>>2]=cf;if(lb(b,ia,M)|0){la=835;break b}else gb=0;u=e;return gb|0}sd=1}while(0);hb=sd;la=837;break;case 14:2!=(w[Za+4>>1]|0)&&Z(135378,133171,4862,135010);t[Za+27>>0]|0&&Z(135148,133171,4863,135010);Ja=d+8|0;ia=a[Ja>>2]|0;if(!(2==(ia|0)&0==(a[Ja+4>>2]|0)))return Ja=a[b+628>>2]|0,a[O>>2]=a[Za+28>>2],a[O+4>>2]=ia,Wb(Ja,135010,135402,O),gb=0,u=e,gb|0;if(Ja=lh(b,d,Da)|0)hb=Ja,la=837;else if(ia=N[d>>1]|0,ea=a[Da>>2]|0,qa=N[ea+2>>1]|
0,a[A>>2]=N[ea>>1],a[A+4>>2]=qa,qa=lb(b,ia,A)|0,ja(ea),qa)la=835;else return gb=0,u=e,gb|0;break;case 16:Ja=w[Za+4>>1]|0;0>=Ja<<16>>16&&Z(135453,133171,4884,135010);t[Za+27>>0]|0&&Z(135148,133171,4885,135010);qa=d+8|0;ea=a[qa>>2]|0;ia=Ja<<16>>16;if((ea|0)!=(ia|0)||(a[qa+4>>2]|0)!=((0>(ia|0))<<31>>31|0))return ia=a[b+628>>2]|0,a[E>>2]=a[Za+28>>2],a[E+4>>2]=Ja<<16>>16,a[E+8>>2]=ea,Wb(ia,135010,135477,E),gb=0,u=e,gb|0;if(ia=Ka(b,d,na)|0)hb=ia,la=837;else if(ea=N[d>>1]|0,Ja=a[na>>2]|0,a[K>>2]=Ja,qa=lb(b,
ea,K)|0,Ja&&ja(Ja),qa)la=836;else return gb=0,u=e,gb|0;break;case 18:ia=w[Za+4>>1]|0;0>=ia<<16>>16&&Z(135453,133171,4910,135010);t[Za+27>>0]|0&&Z(135148,133171,4911,135010);qa=d+8|0;Ja=ia<<16>>16;if((a[qa>>2]|0)==(Ja|0)&&(a[qa+4>>2]|0)==((0>(Ja|0))<<31>>31|0))if(Ja=lh(b,d,Na)|0)hb=Ja,la=837;else if(qa=N[d>>1]|0,ia=a[Na>>2]|0,a[L>>2]=ia,ea=lb(b,qa,L)|0,ia&&ja(ia),ea)la=836;else return gb=0,u=e,gb|0;else la=835;break;case 20:Ja=w[Za+4>>1]|0;0>=Ja<<16>>16&&Z(135453,133171,4932,135010);t[Za+27>>0]|0&&
Z(135148,133171,4933,135010);ea=d+8|0;ia=Ja<<16>>16;if((a[ea>>2]|0)==(ia|0)&&(a[ea+4>>2]|0)==((0>(ia|0))<<31>>31|0))if(ia=ab(b,d,hf)|0)hb=ia,la=837;else if(ea=N[d>>1]|0,Ja=a[hf>>2]|0,a[G>>2]=Ja,qa=lb(b,ea,G)|0,Ja&&ja(Ja),qa)la=836;else return gb=0,u=e,gb|0;else la=835;break;case 24:ia=w[Za+4>>1]|0;0>=ia<<16>>16&&Z(135453,133171,4954,135010);t[Za+27>>0]|0&&Z(135148,133171,4955,135010);qa=d+8|0;Ja=ia<<16>>16;if((a[qa>>2]|0)==(Ja|0)&&(a[qa+4>>2]|0)==((0>(Ja|0))<<31>>31|0))if(Ja=fb(b,d,Ca)|0)hb=Ja,la=
837;else if(qa=N[d>>1]|0,ia=a[Ca>>2]|0,a[I>>2]=ia,ea=lb(b,qa,I)|0,ia&&ja(ia),ea)la=836;else return gb=0,u=e,gb|0;else la=835;break;case 27:-1!=(w[Za+4>>1]|0)&&Z(135529,133171,4976,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,4977,135010);ea=Ja=d+8|0;ia=a[ea+4>>2]|0;if(0<ia>>>0|0==(ia|0)&65535<(a[ea>>2]|0)>>>0)hb=1,la=837;else if(ea=Ka(b,d,Ga)|0)hb=ea,la=837;else if(ia=N[d>>1]|0,qa=a[Ga>>2]|0,a[J>>2]=a[Ja>>2]&65535,a[J+4>>2]=qa,Ja=lb(b,ia,J)|0,qa&&ja(qa),Ja)la=836;else return gb=0,u=e,gb|0;break;case 28:-1!=
(w[Za+4>>1]|0)&&Z(135529,133171,4998,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,4999,135010);Ja=ea=d+8|0;qa=a[Ja+4>>2]|0;if(0<qa>>>0|0==(qa|0)&65535<(a[Ja>>2]|0)>>>0)hb=1,la=837;else if(Ja=Ka(b,d,Ea)|0)hb=Ja,la=837;else if(qa=N[d>>1]|0,ia=a[Ea>>2]|0,a[v>>2]=a[ea>>2]&65535,a[v+4>>2]=ia,ea=lb(b,qa,v)|0,ia&&ja(ia),ea)la=836;else return gb=0,u=e,gb|0;break;case 30:-1!=(w[Za+4>>1]|0)&&Z(135529,133171,5020,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5021,135010);ea=Ja=d+8|0;ia=a[ea+4>>2]|0;if(0<ia>>>0|
0==(ia|0)&65535<(a[ea>>2]|0)>>>0)hb=1,la=837;else if(ea=lh(b,d,La)|0)hb=ea,la=837;else if(ia=N[d>>1]|0,qa=a[La>>2]|0,a[V>>2]=a[Ja>>2]&65535,a[V+4>>2]=qa,Ja=lb(b,ia,V)|0,qa&&ja(qa),Ja)la=836;else return gb=0,u=e,gb|0;break;case 32:-1!=(w[Za+4>>1]|0)&&Z(135529,133171,5042,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5043,135010);Ja=ea=d+8|0;qa=a[Ja+4>>2]|0;if(0<qa>>>0|0==(qa|0)&65535<(a[Ja>>2]|0)>>>0)hb=1,la=837;else if(Ja=ab(b,d,Qa)|0)hb=Ja,la=837;else if(qa=N[d>>1]|0,ia=a[Qa>>2]|0,a[r>>2]=a[ea>>2]&
65535,a[r+4>>2]=ia,ea=lb(b,qa,r)|0,ia&&ja(ia),ea)la=836;else return gb=0,u=e,gb|0;break;case 34:-1!=(w[Za+4>>1]|0)&&Z(135529,133171,5064,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5065,135010);ea=Ja=d+8|0;ia=a[ea+4>>2]|0;if(0<ia>>>0|0==(ia|0)&65535<(a[ea>>2]|0)>>>0)hb=1,la=837;else if(ea=ca(b,d,Va)|0)hb=ea,la=837;else if(ia=N[d>>1]|0,qa=a[Va>>2]|0,a[C>>2]=a[Ja>>2]&65535,a[C+4>>2]=qa,Ja=lb(b,ia,C)|0,qa&&ja(qa),Ja)la=836;else return gb=0,u=e,gb|0;break;case 36:-1!=(w[Za+4>>1]|0)&&Z(135529,133171,5086,
135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5087,135010);Ja=ea=d+8|0;qa=a[Ja+4>>2]|0;if(0<qa>>>0|0==(qa|0)&65535<(a[Ja>>2]|0)>>>0)hb=1,la=837;else if(Ja=fb(b,d,Wa)|0)hb=Ja,la=837;else if(qa=N[d>>1]|0,ia=a[Wa>>2]|0,a[Q>>2]=a[ea>>2]&65535,a[Q+4>>2]=ia,ea=lb(b,qa,Q)|0,ia&&ja(ia),ea)la=836;else return gb=0,u=e,gb|0;break;case 37:-1!=(w[Za+4>>1]|0)&&Z(135529,133171,5108,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5109,135010);ea=Ja=d+8|0;ia=a[ea+4>>2]|0;if(0<ia>>>0|0==(ia|0)&65535<(a[ea>>2]|0)>>>0)hb=
1,la=837;else if(ea=D(b,d,ub)|0)hb=ea,la=837;else if(ia=N[d>>1]|0,qa=a[ub>>2]|0,a[z>>2]=a[Ja>>2]&65535,a[z+4>>2]=qa,Ja=lb(b,ia,z)|0,qa&&ja(qa),Ja)la=836;else return gb=0,u=e,gb|0;break;case 38:-1!=(w[Za+4>>1]|0)&&Z(135529,133171,5130,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5131,135010);Ja=ea=d+8|0;qa=a[Ja+4>>2]|0;if(0<qa>>>0|0==(qa|0)&65535<(a[Ja>>2]|0)>>>0)hb=1,la=837;else if(Ja=Lb(b,d,xb)|0)hb=Ja,la=837;else if(qa=N[d>>1]|0,ia=a[xb>>2]|0,a[ka>>2]=a[ea>>2]&65535,a[ka+4>>2]=ia,ea=lb(b,qa,ka)|
0,ia&&ja(ia),ea)la=836;else return gb=0,u=e,gb|0;break;case 39:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5152,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5153,135010);if(Ja=Ka(b,d,Zb)|0)hb=Ja,la=837;else if(ea=N[d>>1]|0,ia=a[Zb>>2]|0,a[H>>2]=a[d+8>>2],a[H+4>>2]=ia,qa=lb(b,ea,H)|0,ia&&ja(ia),qa)la=836;else return gb=0,u=e,gb|0;break;case 40:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5169,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5170,135010);if(Ja=Ka(b,d,Gb)|0)hb=Ja,la=837;else if(qa=N[d>>1]|0,ia=a[Gb>>2]|0,
a[B>>2]=a[d+8>>2],a[B+4>>2]=ia,ea=lb(b,qa,B)|0,ia&&ja(ia),ea)la=836;else return gb=0,u=e,gb|0;break;case 41:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5186,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5187,135010);Ja=d+2|0;c:do switch(N[Ja>>1]|0){case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:case 7:ea=ra(b,d,ga,1,Ha)|0;qa=ia=a[Ha>>2]|0;if(0!=(ea|0)|0==(ia|0))if(ea){hb=ea;la=837;break b}else Yc=0;else{d:do switch(N[Ja>>1]|0){case 1:case 7:if(ea=a[ga>>2]|0){va=ia;for(za=0;!(-1>=(t[va>>0]|0));)if(za=
za+1|0,za>>>0>=ea>>>0){wc=qa;break d}else va=va+1|0;ja(ia);id=4;break c}else wc=qa;break;case 6:wc=qa;break;default:va=a[ga>>2]|0;ea=eb(va)|0;if(!ea){ja(ia);id=7;break c}e:do switch(N[Ja>>1]|0){case 3:if(va)for(za=b+12|0,ta=ia,Ma=ea,dc=0;;){a[za>>2]&128&&ac(ta);Ac=w[ta>>1]|0;if(128<=(Ac&65535)){la=620;break e}t[Ma>>0]=Ac;dc=dc+1|0;if(dc>>>0>=(a[ga>>2]|0)>>>0){la=621;break}else ta=ta+2|0,Ma=Ma+1|0}else la=621;break;case 8:if(va)for(Ma=b+12|0,ta=ia,dc=ea,za=0;;){a[Ma>>2]&128&&ac(ta);Ac=w[ta>>1]|0;if(256<=
(Ac+128&65535)){la=620;break e}t[dc>>0]=Ac;za=za+1|0;if(za>>>0>=(a[ga>>2]|0)>>>0){la=621;break}else ta=ta+2|0,dc=dc+1|0}else la=621;break;case 4:if(va)for(dc=b+12|0,ta=ia,za=ea,Ma=0;;){a[dc>>2]&128&&pb(ta);Ac=a[ta>>2]|0;if(128<=Ac>>>0){la=620;break e}t[za>>0]=Ac;Ma=Ma+1|0;if(Ma>>>0>=(a[ga>>2]|0)>>>0){la=621;break}else ta=ta+4|0,za=za+1|0}else la=621;break;case 9:if(va)for(za=b+12|0,ta=ia,Ma=ea,dc=0;;){a[za>>2]&128&&pb(ta);Ac=a[ta>>2]|0;if(256<=(Ac+128|0)>>>0){la=620;break e}t[Ma>>0]=Ac;dc=dc+1|0;
if(dc>>>0>=(a[ga>>2]|0)>>>0){la=621;break}else ta=ta+4|0,Ma=Ma+1|0}else la=621;break;case 16:if(va)for(Ma=b+12|0,ta=ia,dc=ea,za=0;;){a[Ma>>2]&128&&kc(ta);Ac=ta;Sc=a[Ac>>2]|0;Tc=a[Ac+4>>2]|0;if(!(0>Tc>>>0|0==(Tc|0)&128>Sc>>>0)){la=620;break e}t[dc>>0]=Sc;za=za+1|0;if(za>>>0>=(a[ga>>2]|0)>>>0){la=621;break}else ta=ta+8|0,dc=dc+1|0}else la=621;break;case 17:if(va)for(dc=b+12|0,ta=ia,za=ea,Ma=0;;){a[dc>>2]&128&&kc(ta);Sc=ta;Tc=a[Sc>>2]|0;Ac=Qb(Tc|0,a[Sc+4>>2]|0,128,0)|0;Sc=U;if(!(0>Sc>>>0|0==(Sc|0)&256>
Ac>>>0)){la=620;break e}t[za>>0]=Tc;Ma=Ma+1|0;if(Ma>>>0>=(a[ga>>2]|0)>>>0){la=621;break}else ta=ta+8|0,za=za+1|0}else la=621;break;default:la=621}while(0);if(620==(la|0)){ja(a[Ha>>2]|0);ja(ea);id=4;break c}else if(621==(la|0)){ja(a[Ha>>2]|0);wc=ea;break d}}while(0);Yc=wc}ia=N[d>>1]|0;qa=Yc;a[y>>2]=a[d+8>>2];a[y+4>>2]=qa;va=lb(b,ia,y)|0;Yc&&ja(qa);if(va){la=836;break b}else gb=0;u=e;return gb|0;default:id=2}while(0);hb=id;la=837;break;case 42:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5203,135010);1!=(t[Za+
27>>0]|0)&&Z(135565,133171,5204,135010);if(Ja=lh(b,d,jb)|0)hb=Ja,la=837;else if(va=N[d>>1]|0,qa=a[jb>>2]|0,a[q>>2]=a[d+8>>2],a[q+4>>2]=qa,ia=lb(b,va,q)|0,qa&&ja(qa),ia)la=836;else return gb=0,u=e,gb|0;break;case 43:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5220,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5221,135010);Ja=d+2|0;c:do switch(N[Ja>>1]|0){case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:ia=ra(b,d,ga,2,Ha)|0;va=qa=a[Ha>>2]|0;if(0!=(ia|0)|0==(qa|0))if(ia){hb=ia;la=837;break b}else md=
0;else{d:do switch(N[Ja>>1]|0){case 3:if(ia=a[ga>>2]|0){za=b+12|0;ta=qa;for(Ma=0;;){a[za>>2]&128&&ac(ta);if(-1>=(w[ta>>1]|0))break;Ma=Ma+1|0;if(Ma>>>0>=ia>>>0){td=va;break d}else ta=ta+2|0}ja(qa);Ce=4;break c}else td=va;break;case 8:a[b+12>>2]&128&&Vd(qa,a[ga>>2]|0);td=va;break;default:ta=a[ga>>2]|0;ia=eb(ta<<1)|0;if(!ia){ja(qa);Ce=7;break c}e:do switch(N[Ja>>1]|0){case 1:if(ta)for(Ma=qa,za=ia,ea=0;;)if(w[za>>1]=x[Ma>>0]|0,ea=ea+1|0,(ea|0)==(ta|0)){la=684;break}else Ma=Ma+1|0,za=za+2|0;else la=684;
break;case 6:if(ta)for(za=qa,Ma=ia,ea=0;;)if(w[Ma>>1]=t[za>>0]|0,ea=ea+1|0,(ea|0)==(ta|0)){la=684;break}else za=za+1|0,Ma=Ma+2|0;else la=684;break;case 4:if(ta)for(Ma=b+12|0,za=qa,ea=ia,dc=0;;){a[Ma>>2]&128&&pb(za);Tc=a[za>>2]|0;if(32768<=Tc>>>0){la=683;break e}w[ea>>1]=Tc;dc=dc+1|0;if(dc>>>0>=ta>>>0){la=684;break}else za=za+4|0,ea=ea+2|0}else la=684;break;case 9:if(ta)for(ea=b+12|0,za=qa,dc=ia,Ma=0;;){a[ea>>2]&128&&pb(za);Tc=a[za>>2]|0;if(65536<=(Tc+32768|0)>>>0){la=683;break e}w[dc>>1]=Tc;Ma=Ma+
1|0;if(Ma>>>0>=ta>>>0){la=684;break}else za=za+4|0,dc=dc+2|0}else la=684;break;case 16:if(ta)for(dc=b+12|0,za=qa,Ma=ia,ea=0;;){a[dc>>2]&128&&kc(za);Tc=za;Ac=a[Tc>>2]|0;Sc=a[Tc+4>>2]|0;if(!(0>Sc>>>0|0==(Sc|0)&32768>Ac>>>0)){la=683;break e}w[Ma>>1]=Ac;ea=ea+1|0;if(ea>>>0>=ta>>>0){la=684;break}else za=za+8|0,Ma=Ma+2|0}else la=684;break;case 17:if(ta)for(Ma=b+12|0,za=qa,ea=ia,dc=0;;){a[Ma>>2]&128&&kc(za);Ac=za;Sc=a[Ac>>2]|0;Tc=Qb(Sc|0,a[Ac+4>>2]|0,32768,0)|0;Ac=U;if(!(0>Ac>>>0|0==(Ac|0)&65536>Tc>>>0)){la=
683;break e}w[ea>>1]=Sc;dc=dc+1|0;if(dc>>>0>=ta>>>0){la=684;break}else za=za+8|0,ea=ea+2|0}else la=684;break;default:la=684}while(0);if(683==(la|0)){ja(qa);ja(ia);Ce=4;break c}else if(684==(la|0)){ja(qa);td=ia;break d}}while(0);md=td}qa=N[d>>1]|0;a[p>>2]=a[d+8>>2];a[p+4>>2]=md;va=lb(b,qa,p)|0;md&&ja(md);if(va){la=836;break b}else gb=0;u=e;return gb|0;default:Ce=2}while(0);hb=Ce;la=837;break;case 44:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5237,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5238,135010);if(Ja=
ab(b,d,mc)|0)hb=Ja,la=837;else if(va=N[d>>1]|0,qa=a[mc>>2]|0,a[n>>2]=a[d+8>>2],a[n+4>>2]=qa,ta=lb(b,va,n)|0,qa&&ja(qa),ta)la=836;else return gb=0,u=e,gb|0;break;case 45:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5254,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5255,135010);Ja=d+2|0;c:do switch(N[Ja>>1]|0){case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:ta=ra(b,d,ga,4,Ha)|0;va=qa=a[Ha>>2]|0;if(0!=(ta|0)|0==(qa|0))if(ta){hb=ta;la=837;break b}else vd=0;else{d:do switch(N[Ja>>1]|0){case 4:if(ta=a[ga>>
2]|0){ea=b+12|0;za=qa;for(dc=0;;){a[ea>>2]&128&&pb(za);if(Ma=a[za>>2]>>31&4){pd=Ma;break}dc=dc+1|0;if(dc>>>0>=ta>>>0){wd=va;break d}else za=za+4|0}ja(qa);Nf=pd;break c}else wd=va;break;case 9:a[b+12>>2]&128&&Id(qa,a[ga>>2]|0);wd=va;break;default:za=a[ga>>2]|0;ta=eb(za<<2)|0;if(!ta){ja(qa);Nf=7;break c}e:do switch(N[Ja>>1]|0){case 1:if(za)for(dc=qa,ea=ta,ia=0;;)if(a[ea>>2]=x[dc>>0],ia=ia+1|0,ia>>>0>=(a[ga>>2]|0)>>>0){la=745;break}else dc=dc+1|0,ea=ea+4|0;else la=745;break;case 6:if(za)for(ea=qa,dc=
ta,ia=0;;)if(a[dc>>2]=t[ea>>0],ia=ia+1|0,ia>>>0>=(a[ga>>2]|0)>>>0){la=745;break}else ea=ea+1|0,dc=dc+4|0;else la=745;break;case 3:if(za)for(dc=b+12|0,ea=qa,ia=ta,Ma=0;;)if(a[dc>>2]&128&&ac(ea),a[ia>>2]=N[ea>>1],Ma=Ma+1|0,Ma>>>0>=(a[ga>>2]|0)>>>0){la=745;break}else ea=ea+2|0,ia=ia+4|0;else la=745;break;case 8:if(za)for(ia=b+12|0,ea=qa,Ma=ta,dc=0;;)if(a[ia>>2]&128&&ac(ea),a[Ma>>2]=w[ea>>1],dc=dc+1|0,dc>>>0>=(a[ga>>2]|0)>>>0){la=745;break}else ea=ea+2|0,Ma=Ma+4|0;else la=745;break;case 16:if(za)for(Ma=
b+12|0,ea=qa,dc=ta,ia=0;;){a[Ma>>2]&128&&kc(ea);Sc=ea;Tc=a[Sc>>2]|0;Ac=a[Sc+4>>2]|0;if(!(0>Ac>>>0|0==(Ac|0)&2147483648>Tc>>>0)){la=744;break e}a[dc>>2]=Tc;ia=ia+1|0;if(ia>>>0>=(a[ga>>2]|0)>>>0){la=745;break}else ea=ea+8|0,dc=dc+4|0}else la=745;break;case 17:if(za)for(dc=b+12|0,ea=qa,ia=ta,Ma=0;;){a[dc>>2]&128&&kc(ea);Tc=ea;Ac=a[Tc>>2]|0;Sc=Qb(Ac|0,a[Tc+4>>2]|0,-2147483648,0)|0;Tc=U;if(!(1>Tc>>>0|1==(Tc|0)&0>Sc>>>0)){la=744;break e}a[ia>>2]=Ac;Ma=Ma+1|0;if(Ma>>>0>=(a[ga>>2]|0)>>>0){la=745;break}else ea=
ea+8|0,ia=ia+4|0}else la=745;break;default:la=745}while(0);if(744==(la|0)){ja(qa);ja(ta);Nf=4;break c}else if(745==(la|0)){ja(qa);wd=ta;break d}}while(0);vd=wd}qa=N[d>>1]|0;a[l>>2]=a[d+8>>2];a[l+4>>2]=vd;va=lb(b,qa,l)|0;vd&&ja(vd);if(va){la=836;break b}else gb=0;u=e;return gb|0;default:Nf=2}while(0);hb=Nf;la=837;break;case 46:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5271,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5272,135010);if(Ja=ca(b,d,Kb)|0)hb=Ja,la=837;else if(va=N[d>>1]|0,qa=a[Kb>>2]|0,a[k>>2]=
a[d+8>>2],a[k+4>>2]=qa,za=lb(b,va,k)|0,qa&&ja(qa),za)la=836;else return gb=0,u=e,gb|0;break;case 47:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5288,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5289,135010);Ja=d+2|0;c:do switch(N[Ja>>1]|0){case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:za=ra(b,d,ga,8,Ha)|0;va=qa=a[Ha>>2]|0;if(0!=(za|0)|0==(qa|0))if(za){hb=za;la=837;break b}else jd=0;else{d:do switch(N[Ja>>1]|0){case 16:if(za=a[ga>>2]|0){ia=b+12|0;ea=qa;for(Ma=0;;){a[ia>>2]&128&&kc(ea);dc=ea;Ac=
a[dc+4>>2]|0;if(!(-1<(Ac|0)|-1==(Ac|0)&4294967295<(a[dc>>2]|0)>>>0))break;Ma=Ma+1|0;if(Ma>>>0>=za>>>0){ug=va;break d}else ea=ea+8|0}ja(qa);Ud=4;break c}else ug=va;break;case 17:a[b+12>>2]&128&&Ae(qa,a[ga>>2]|0);ug=va;break;default:ea=a[ga>>2]|0;za=eb(ea<<3)|0;if(!za){ja(qa);Ud=7;break c}switch(N[Ja>>1]|0){case 1:if(ea)for(Ma=qa,ia=za,ta=0;dc=ia,a[dc>>2]=x[Ma>>0],a[dc+4>>2]=0,ta=ta+1|0,(ta|0)!=(ea|0);)Ma=Ma+1|0,ia=ia+8|0;break;case 6:if(ea)for(ia=qa,Ma=za,ta=0;dc=t[ia>>0]|0,Ac=Ma,a[Ac>>2]=dc,a[Ac+
4>>2]=(0>(dc|0))<<31>>31,ta=ta+1|0,(ta|0)!=(ea|0);)ia=ia+1|0,Ma=Ma+8|0;break;case 3:if(ea)for(Ma=b+12|0,ia=qa,ta=za,dc=0;a[Ma>>2]&128&&ac(ia),Ac=ta,a[Ac>>2]=N[ia>>1],a[Ac+4>>2]=0,dc=dc+1|0,(dc|0)!=(ea|0);)ia=ia+2|0,ta=ta+8|0;break;case 8:if(ea)for(ta=b+12|0,ia=qa,dc=za,Ma=0;a[ta>>2]&128&&ac(ia),Ac=w[ia>>1]|0,Sc=dc,a[Sc>>2]=Ac,a[Sc+4>>2]=(0>(Ac|0))<<31>>31,Ma=Ma+1|0,(Ma|0)!=(ea|0);)ia=ia+2|0,dc=dc+8|0;break;case 4:if(ea)for(dc=b+12|0,ia=qa,Ma=za,ta=0;a[dc>>2]&128&&pb(ia),Ac=Ma,a[Ac>>2]=a[ia>>2],a[Ac+
4>>2]=0,ta=ta+1|0,(ta|0)!=(ea|0);)ia=ia+4|0,Ma=Ma+8|0;break;case 9:if(ea)for(Ma=b+12|0,ia=qa,ta=za,dc=0;a[Ma>>2]&128&&pb(ia),Ac=a[ia>>2]|0,Sc=ta,a[Sc>>2]=Ac,a[Sc+4>>2]=(0>(Ac|0))<<31>>31,dc=dc+1|0,(dc|0)!=(ea|0);)ia=ia+4|0,ta=ta+8|0}ja(qa);ug=za}while(0);jd=ug}qa=N[d>>1]|0;a[m>>2]=a[d+8>>2];a[m+4>>2]=jd;va=lb(b,qa,m)|0;jd&&ja(jd);if(va){la=836;break b}else gb=0;u=e;return gb|0;default:Ud=2}while(0);hb=Ud;la=837;break;case 48:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5305,135010);1!=(t[Za+27>>0]|0)&&Z(135565,
133171,5306,135010);if(Ja=fb(b,d,Ta)|0)hb=Ja,la=837;else if(va=N[d>>1]|0,qa=a[Ta>>2]|0,a[h>>2]=a[d+8>>2],a[h+4>>2]=qa,ta=lb(b,va,h)|0,qa&&ja(qa),ta)la=836;else return gb=0,u=e,gb|0;break;case 49:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,5322,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5323,135010);if(Ja=D(b,d,Ya)|0)hb=Ja,la=837;else if(ta=N[d>>1]|0,qa=a[Ya>>2]|0,a[g>>2]=a[d+8>>2],a[g+4>>2]=qa,va=lb(b,ta,g)|0,qa&&ja(qa),va)la=836;else return gb=0,u=e,gb|0;break;case 50:-3!=(w[Za+4>>1]|0)&&Z(135589,133171,
5339,135010);1!=(t[Za+27>>0]|0)&&Z(135565,133171,5340,135010);if(Ja=Lb(b,d,Sa)|0)hb=Ja,la=837;else if(va=N[d>>1]|0,qa=a[Sa>>2]|0,a[f>>2]=a[d+8>>2],a[f+4>>2]=qa,ta=lb(b,va,f)|0,qa&&ja(qa),ta)la=836;else return gb=0,u=e,gb|0;break;default:Z(141469,133171,5354,135010)}while(0);if(835==(la|0)||836==(la|0))return gb=1,u=e,gb|0;if(837==(la|0))return wh(b,hb,135010,a[Za+28>>2]|0,c),gb=0,u=e,gb|0}while(0);c=a[b+628>>2]|0;a[Mg>>2]=Db&65535;Y(c,135010,135029,Mg);gb=0;u=e;return gb|0}function aj(b,d,c){b|=0;
d|=0;c|=0;var e,f,g,h,m,k,l,n,p=0;e=u;u=u+32|0;f=e+24|0;g=e+28|0;h=e+20|0;m=e+16|0;k=e+8|0;l=e;n=d+8|0;if(!(1==(a[n>>2]|0)&0==(a[n+4>>2]|0)))return u=e,1;switch(N[d+2>>1]|0){case 1:return w[c>>1]=x[d+16>>0]|0,u=e,0;case 6:n=t[d+16>>0]|0;if(-1>=n<<24>>24)return u=e,4;w[c>>1]=n<<24>>24;u=e;return 0;case 3:n=a[b+12>>2]|0;w[c>>1]=w[d+16>>1]|0;if(!(n&128))return u=e,0;ac(c);u=e;return 0;case 8:n=a[b+12>>2]|0;b=w[d+16>>1]|0;w[g>>1]=b;n&128?(ac(g),l=w[g>>1]|0):l=b;if(-1>=l<<16>>16)return u=e,4;w[c>>1]=l;
u=e;return 0;case 4:l=a[d+16>>2]|0;a[h>>2]=l;a[b+12>>2]&128?(pb(h),h=a[h>>2]|0):h=l;if(65536<=h>>>0)return u=e,4;w[c>>1]=h;u=e;return 0;case 9:h=a[d+16>>2]|0;a[m>>2]=h;a[b+12>>2]&128?(pb(m),g=a[m>>2]|0):g=h;if(65536<=g>>>0)return u=e,4;w[c>>1]=g;u=e;return 0;case 16:g=b+12|0;m=a[g>>2]|0;h=d+16|0;if(m&524288)l=a[h+4>>2]|0,g=k,a[g>>2]=a[h>>2],a[g+4>>2]=l,d=m;else if(h=a[h>>2]|0,a[f>>2]=h,m&128?(pb(f),l=a[g>>2]|0,f=a[f>>2]|0):(l=m,f=h),l&2048?4294967287>=f>>>0&&(f+8|0)>>>0<=(a[b+616>>2]|0)>>>0&&(Ab(k,
(a[b+612>>2]|0)+f|0,8),p=29):(h=b+628|0,l=rb[a[b+640>>2]&63](a[h>>2]|0,f,0,0)|0,(l|0)==(f|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[h>>2]|0,k,8)|0)&&(p=29)),29==(p|0))d=a[g>>2]|0;else return u=e,3;d&128&&kc(k);d=k;k=a[d>>2]|0;m=a[d+4>>2]|0;if(!(0>m>>>0|0==(m|0)&65536>k>>>0))return u=e,4;w[c>>1]=k;u=e;return 0;case 17:k=b+12|0;m=a[k>>2]|0;d=d+16|0;if(m&524288)h=a[d+4>>2]|0,g=l,a[g>>2]=a[d>>2],a[g+4>>2]=h,b=m;else if(d=a[d>>2]|0,a[f>>2]=d,m&128?(pb(f),h=a[k>>2]|0,f=a[f>>2]|0):(h=m,f=d),h&2048?4294967287>=
f>>>0&&(f+8|0)>>>0<=(a[b+616>>2]|0)>>>0&&(Ab(l,(a[b+612>>2]|0)+f|0,8),p=45):(d=b+628|0,h=rb[a[b+640>>2]&63](a[d>>2]|0,f,0,0)|0,(h|0)==(f|0)&0==(U|0)&&8==(Aa[a[b+632>>2]&63](a[d>>2]|0,l,8)|0)&&(p=45)),45==(p|0))b=a[k>>2]|0;else return u=e,3;b&128&&kc(l);b=l;l=a[b>>2]|0;m=a[b+4>>2]|0;if(!(0>m>>>0|0==(m|0)&65536>l>>>0))return u=e,4;w[c>>1]=l;u=e;return 0;default:return u=e,2}}function lh(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y;e=u;u=u+16|0;f=e+4|0;g=e;h=d+2|0;switch(N[h>>1]|0){case 17:case 16:case 9:case 4:case 8:case 3:case 6:case 1:break;
default:return u=e,2}m=ra(b,d,f,2,g)|0;g=d=a[g>>2]|0;if(0!=(m|0)|0==(d|0))return a[c>>2]=0,u=e,m|0;switch(N[h>>1]|0){case 3:a[c>>2]=d;if(!(a[b+12>>2]&128)){u=e;break}Vd(d,a[f>>2]|0);u=e;break;case 8:m=a[f>>2]|0;a:do if(m){k=b+12|0;l=d;for(n=0;;){a[k>>2]&128&&ac(l);if(-1>=(w[l>>1]|0))break;n=n+1|0;if(n>>>0>=m>>>0)break a;else l=l+2|0}ja(d);u=e;return 4}while(0);a[c>>2]=g;u=e;break;default:g=a[f>>2]|0;f=eb(g<<1)|0;if(!f)return ja(d),u=e,7;a:do switch(N[h>>1]|0){case 1:if(g)for(m=d,l=f,n=0;;)if(w[l>>
1]=x[m>>0]|0,n=n+1|0,n>>>0>=g>>>0){m=48;break}else m=m+1|0,l=l+2|0;else m=48;break;case 6:if(g)for(l=d,m=f,n=0;;){k=t[l>>0]|0;if(-1>=k<<24>>24){m=47;break a}w[m>>1]=k<<24>>24;n=n+1|0;if(n>>>0>=g>>>0){m=48;break}else l=l+1|0,m=m+2|0}else m=48;break;case 4:if(g)for(m=b+12|0,l=d,n=f,k=0;;){a[m>>2]&128&&pb(l);p=a[l>>2]|0;if(65536<=p>>>0){m=47;break a}w[n>>1]=p;k=k+1|0;if(k>>>0>=g>>>0){m=48;break}else l=l+4|0,n=n+2|0}else m=48;break;case 9:if(g)for(n=b+12|0,l=d,k=f,m=0;;){a[n>>2]&128&&pb(l);p=a[l>>2]|
0;if(65536<=p>>>0){m=47;break a}w[k>>1]=p;m=m+1|0;if(m>>>0>=g>>>0){m=48;break}else l=l+4|0,k=k+2|0}else m=48;break;case 16:if(g)for(k=b+12|0,l=d,m=f,n=0;;){a[k>>2]&128&&kc(l);p=l;q=a[p>>2]|0;y=a[p+4>>2]|0;if(!(0>y>>>0|0==(y|0)&65536>q>>>0)){m=47;break a}w[m>>1]=q;n=n+1|0;if(n>>>0>=g>>>0){m=48;break}else l=l+8|0,m=m+2|0}else m=48;break;case 17:if(g)for(m=b+12|0,l=d,n=f,k=0;;){a[m>>2]&128&&kc(l);q=l;y=a[q>>2]|0;p=a[q+4>>2]|0;if(!(0>p>>>0|0==(p|0)&65536>y>>>0)){m=47;break a}w[n>>1]=y;k=k+1|0;if(k>>>
0>=g>>>0){m=48;break}else l=l+8|0,n=n+2|0}else m=48;break;default:m=48}while(0);if(47==(m|0))return ja(d),ja(f),u=e,4;48==(m|0)&&(ja(d),a[c>>2]=f,u=e)}return 0}function wh(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;var g,h,m,k,l,n,p,q,y,B,H,t,z,Q,C;g=u;u=u+112|0;h=g+104|0;m=g+96|0;k=g+88|0;l=g+80|0;n=g+72|0;p=g+64|0;q=g+56|0;y=g+48|0;B=g+40|0;H=g+32|0;t=g+24|0;z=g+16|0;Q=g+8|0;C=g;if(f|0)switch(d|0){case 1:d=a[b+628>>2]|0;a[q>>2]=e;Wb(d,c,134687,q);u=g;break;case 2:q=a[b+628>>2]|0;a[p>>2]=e;Wb(q,c,134725,p);
u=g;break;case 3:p=a[b+628>>2]|0;a[n>>2]=e;Wb(p,c,134765,n);u=g;break;case 4:n=a[b+628>>2]|0;a[l>>2]=e;Wb(n,c,134810,l);u=g;break;case 5:l=a[b+628>>2]|0;a[k>>2]=e;Wb(l,c,134848,k);u=g;break;case 6:k=a[b+628>>2]|0;a[m>>2]=e;Wb(k,c,134912,m);u=g;break;case 7:m=a[b+628>>2]|0;a[h>>2]=e;Wb(m,c,134967,h);u=g;break;default:Z(141469,133171,3386,134661)}else switch(d|0){case 1:f=a[b+628>>2]|0;a[C>>2]=e;Y(f,c,134429,C);u=g;break;case 2:C=a[b+628>>2]|0;a[Q>>2]=e;Y(C,c,134454,Q);u=g;break;case 3:Q=a[b+628>>2]|
0;a[z>>2]=e;Y(Q,c,134481,z);u=g;break;case 4:z=a[b+628>>2]|0;a[t>>2]=e;Y(z,c,134513,t);u=g;break;case 5:t=a[b+628>>2]|0;a[H>>2]=e;Y(t,c,134538,H);u=g;break;case 6:H=a[b+628>>2]|0;a[B>>2]=e;Y(H,c,134589,B);u=g;break;case 7:B=a[b+628>>2]|0;a[y>>2]=e;Y(B,c,134631,y);u=g;break;default:Z(141469,133171,3345,134661)}}function Hc(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B=0,H=0,t=0,z=0,Q,C,u=0,r=0,w,x=0,I=0,G=0,v=n=0,K=0,E=0,A=0,O=0,M=0,T=0,X=0,P=0,Oa=0,D=g=l=0,F=Q=0,ba=0,N=C=0,R=0,S=0,ga=0,Y=0,ma=0,W=0,ha=
0,U=0,da=0,aa=0,ca=0,Z=0,fa=0,oa=0;do if(245>b>>>0){d=11>b>>>0?16:b+11&-8;c=d>>>3;e=a[30806]|0;f=e>>>c;if(f&3)return g=(f&1^1)+c|0,d=g<<1,h=123264+(d<<2)|0,m=123264+(d+2<<2)|0,d=a[m>>2]|0,k=d+8|0,l=a[k>>2]|0,(h|0)!=(l|0)?(l>>>0<(a[30810]|0)>>>0&&Qa(),n=l+12|0,(a[n>>2]|0)==(d|0)?(a[n>>2]=h,a[m>>2]=l):Qa()):a[30806]=e&~(1<<g),l=g<<3,a[d+4>>2]=l|3,m=d+(l|4)|0,a[m>>2]|=1,l=k,l|0;m=a[30808]|0;if(d>>>0>m>>>0){if(f)return l=2<<c,h=f<<c&(l|0-l),l=(h&0-h)+-1|0,h=l>>>12&16,n=l>>>h,l=n>>>5&8,k=n>>>l,n=k>>>2&
4,p=k>>>n,k=p>>>1&2,q=p>>>k,p=q>>>1&1,y=(l|h|n|k|p)+(q>>>p)|0,p=y<<1,q=123264+(p<<2)|0,k=123264+(p+2<<2)|0,p=a[k>>2]|0,n=p+8|0,h=a[n>>2]|0,(q|0)!=(h|0)?(h>>>0<(a[30810]|0)>>>0&&Qa(),l=h+12|0,(a[l>>2]|0)==(p|0)?(a[l>>2]=q,a[k>>2]=h,B=a[30808]|0):Qa()):(a[30806]=e&~(1<<y),B=m),m=y<<3,e=m-d|0,a[p+4>>2]=d|3,h=p+d|0,a[p+(d|4)>>2]=e|1,a[p+m>>2]=e,B&&(m=a[30811]|0,k=B>>>3,q=k<<1,c=123264+(q<<2)|0,f=a[30806]|0,k=1<<k,f&k?(k=123264+(q+2<<2)|0,d=a[k>>2]|0,d>>>0<(a[30810]|0)>>>0?Qa():(H=k,t=d)):(a[30806]=f|
k,H=123264+(q+2<<2)|0,t=c),a[H>>2]=m,a[t+12>>2]=m,a[m+8>>2]=t,a[m+12>>2]=c),a[30808]=e,a[30811]=h,l=n,l|0;if(h=a[30807]|0){e=(h&0-h)+-1|0;h=e>>>12&16;c=e>>>h;e=c>>>5&8;m=c>>>e;c=m>>>2&4;q=m>>>c;m=q>>>1&2;k=q>>>m;q=k>>>1&1;f=a[123528+((e|h|c|m|q)+(k>>>q)<<2)>>2]|0;q=(a[f+4>>2]&-8)-d|0;for(m=k=f;;){if(f=a[k+16>>2]|0)l=f;else if(c=a[k+20>>2]|0)l=c;else{l=q;g=m;break}f=(a[l+4>>2]&-8)-d|0;q=(c=f>>>0<q>>>0)?f:q;k=l;m=c?l:m}m=a[30810]|0;g>>>0<m>>>0&&Qa();k=g+d|0;g>>>0>=k>>>0&&Qa();q=a[g+24>>2]|0;n=a[g+12>>
2]|0;do if((n|0)==(g|0)){p=g+20|0;if(y=a[p>>2]|0)Q=y,C=p;else if(c=g+16|0,f=a[c>>2]|0)Q=f,C=c;else{z=0;break}for(;;)if(p=Q+20|0,y=a[p>>2]|0)Q=y,C=p;else if(p=Q+16|0,y=a[p>>2]|0)Q=y,C=p;else break;C>>>0<m>>>0?Qa():(a[C>>2]=0,z=Q)}else p=a[g+8>>2]|0,p>>>0<m>>>0&&Qa(),y=p+12|0,(a[y>>2]|0)!=(g|0)&&Qa(),c=n+8|0,(a[c>>2]|0)==(g|0)?(a[y>>2]=n,a[c>>2]=p,z=n):Qa();while(0);do if(q){n=a[g+28>>2]|0;m=123528+(n<<2)|0;if((g|0)==(a[m>>2]|0)){if(a[m>>2]=z,!z){a[30807]&=~(1<<n);break}}else if(q>>>0<(a[30810]|0)>>>
0&&Qa(),n=q+16|0,(a[n>>2]|0)==(g|0)?a[n>>2]=z:a[q+20>>2]=z,!z)break;n=a[30810]|0;z>>>0<n>>>0&&Qa();a[z+24>>2]=q;if(m=a[g+16>>2]|0)m>>>0<n>>>0?Qa():(a[z+16>>2]=m,a[m+24>>2]=z);if(m=a[g+20>>2]|0)m>>>0<(a[30810]|0)>>>0?Qa():(a[z+20>>2]=m,a[m+24>>2]=z)}while(0);if(16>l>>>0)q=l+d|0,a[g+4>>2]=q|3,m=g+(q+4)|0,a[m>>2]|=1;else{a[g+4>>2]=d|3;a[g+(d|4)>>2]=l|1;a[g+(l+d)>>2]=l;if(m=a[30808]|0)q=a[30811]|0,n=m>>>3,m=n<<1,p=123264+(m<<2)|0,c=a[30806]|0,y=1<<n,c&y?(n=123264+(m+2<<2)|0,f=a[n>>2]|0,f>>>0<(a[30810]|
0)>>>0?Qa():(u=n,r=f)):(a[30806]=c|y,u=123264+(m+2<<2)|0,r=p),a[u>>2]=q,a[r+12>>2]=q,a[q+8>>2]=r,a[q+12>>2]=p;a[30808]=l;a[30811]=k}l=g+8|0;return l|0}}m=d}else if(4294967231>=b>>>0){p=b+11|0;q=p&-8;if(m=a[30807]|0){y=0-q|0;(c=p>>>8)?16777215<q>>>0?w=31:(p=(c+1048320|0)>>>16&8,f=c<<p,c=(f+520192|0)>>>16&4,n=f<<c,f=(n+245760|0)>>>16&2,h=14-(c|p|f)+(n<<f>>>15)|0,w=q>>>(h+7|0)&1|h<<1):w=0;h=a[123528+(w<<2)>>2]|0;a:do if(h)for(f=y,n=0,p=q<<(31==(w|0)?0:25-(w>>>1)|0),c=h,e=0;;){d=a[c+4>>2]&-8;k=d-q|0;
if(k>>>0<f>>>0)if((d|0)==(q|0)){v=k;E=K=c;n=90;break a}else f=k,e=c;k=a[c+20>>2]|0;c=a[c+16+(p>>>31<<2)>>2]|0;d=0==(k|0)|(k|0)==(c|0)?n:k;if(c)n=d,p<<=1;else{x=f;I=d;G=e;n=86;break}}else x=y,G=I=0,n=86;while(0);if(86==(n|0)){if(0==(I|0)&0==(G|0)){h=2<<w;y=m&(h|0-h);if(!y){m=q;break}h=(y&0-y)+-1|0;y=h>>>12&16;d=h>>>y;h=d>>>5&8;k=d>>>h;d=k>>>2&4;e=k>>>d;k=e>>>1&2;p=e>>>k;e=p>>>1&1;m=a[123528+((h|y|d|k|e)+(p>>>e)<<2)>>2]|0;p=0}else m=I,p=G;m?(v=x,K=m,E=p,n=90):(A=x,O=p)}if(90==(n|0))for(;;)if(n=0,e=
(a[K+4>>2]&-8)-q|0,k=(p=e>>>0<v>>>0)?e:v,e=p?K:E,p=a[K+16>>2]|0)v=k,K=p,E=e;else if(K=a[K+20>>2]|0)v=k,E=e;else{A=k;O=e;break}if(0!=(O|0)&&A>>>0<((a[30808]|0)-q|0)>>>0){m=a[30810]|0;O>>>0<m>>>0&&Qa();e=O+q|0;O>>>0>=e>>>0&&Qa();k=a[O+24>>2]|0;p=a[O+12>>2]|0;do if((p|0)==(O|0)){d=O+20|0;if(y=a[d>>2]|0)l=y,g=d;else if(h=O+16|0,n=a[h>>2]|0)l=n,g=h;else{M=0;break}for(;;)if(d=l+20|0,y=a[d>>2]|0)l=y,g=d;else if(d=l+16|0,y=a[d>>2]|0)l=y,g=d;else{u=l;l=g;break}l>>>0<m>>>0?Qa():(a[l>>2]=0,M=u)}else d=a[O+8>>
2]|0,d>>>0<m>>>0&&Qa(),y=d+12|0,(a[y>>2]|0)!=(O|0)&&Qa(),h=p+8|0,(a[h>>2]|0)==(O|0)?(a[y>>2]=p,a[h>>2]=d,M=p):Qa();while(0);do if(k){p=a[O+28>>2]|0;m=123528+(p<<2)|0;if((O|0)==(a[m>>2]|0)){if(a[m>>2]=M,!M){a[30807]&=~(1<<p);break}}else if(k>>>0<(a[30810]|0)>>>0&&Qa(),p=k+16|0,(a[p>>2]|0)==(O|0)?a[p>>2]=M:a[k+20>>2]=M,!M)break;p=a[30810]|0;M>>>0<p>>>0&&Qa();a[M+24>>2]=k;if(m=a[O+16>>2]|0)m>>>0<p>>>0?Qa():(a[M+16>>2]=m,a[m+24>>2]=M);if(m=a[O+20>>2]|0)m>>>0<(a[30810]|0)>>>0?Qa():(a[M+20>>2]=m,a[m+24>>
2]=M)}while(0);a:do if(16<=A>>>0)if(a[O+4>>2]=q|3,a[O+(q|4)>>2]=A|1,a[O+(A+q)>>2]=A,k=A>>>3,256>A>>>0)m=k<<1,p=123264+(m<<2)|0,d=a[30806]|0,h=1<<k,d&h?(k=123264+(m+2<<2)|0,y=a[k>>2]|0,y>>>0<(a[30810]|0)>>>0?Qa():(T=k,X=y)):(a[30806]=d|h,T=123264+(m+2<<2)|0,X=p),a[T>>2]=e,a[X+12>>2]=e,a[O+(q+8)>>2]=X,a[O+(q+12)>>2]=p;else if((p=A>>>8)?16777215<A>>>0?z=31:(m=(p+1048320|0)>>>16&8,h=p<<m,p=(h+520192|0)>>>16&4,d=h<<p,h=(d+245760|0)>>>16&2,y=14-(p|m|h)+(d<<h>>>15)|0,z=A>>>(y+7|0)&1|y<<1):z=0,y=123528+(z<<
2)|0,a[O+(q+28)>>2]=z,a[O+(q+20)>>2]=0,a[O+(q+16)>>2]=0,h=a[30807]|0,d=1<<z,h&d){d=a[y>>2]|0;b:do if((a[d+4>>2]&-8|0)!=(A|0)){y=A<<(31==(z|0)?0:25-(z>>>1)|0);for(h=d;;){m=h+16+(y>>>31<<2)|0;p=a[m>>2]|0;if(!p){p=m;k=h;break}if((a[p+4>>2]&-8|0)==(A|0)){P=p;break b}else y<<=1,h=p}if(p>>>0<(a[30810]|0)>>>0)Qa();else{a[p>>2]=e;a[O+(q+24)>>2]=k;a[O+(q+12)>>2]=e;a[O+(q+8)>>2]=e;break a}}else P=d;while(0);d=P+8|0;h=a[d>>2]|0;y=a[30810]|0;h>>>0>=y>>>0&P>>>0>=y>>>0?(a[h+12>>2]=e,a[d>>2]=e,a[O+(q+8)>>2]=h,a[O+
(q+12)>>2]=P,a[O+(q+24)>>2]=0):Qa()}else a[30807]=h|d,a[y>>2]=e,a[O+(q+24)>>2]=y,a[O+(q+12)>>2]=e,a[O+(q+8)>>2]=e;else h=A+q|0,a[O+4>>2]=h|3,d=O+(h+4)|0,a[d>>2]|=1;while(0);l=O+8|0;return l|0}}m=q}else m=-1;while(0);O=a[30808]|0;if(O>>>0>=m>>>0)return A=O-m|0,P=a[30811]|0,15<A>>>0?(a[30811]=P+m,a[30808]=A,a[P+(m+4)>>2]=A|1,a[P+O>>2]=A,a[P+4>>2]=m|3):(a[30808]=0,a[30811]=0,a[P+4>>2]=O|3,A=P+(O+4)|0,a[A>>2]|=1),P+8|0;P=a[30809]|0;if(P>>>0>m>>>0)return A=P-m|0,a[30809]=A,P=a[30812]|0,a[30812]=P+m,a[P+
(m+4)>>2]=A|1,a[P+4>>2]=m|3,P+8|0;a[30924]|0||(P=ak(30)|0,P+-1&P?Qa():(a[30926]=P,a[30925]=P,a[30927]=-1,a[30928]=-1,a[30929]=0,a[30917]=0,P=(sl(0)|0)&-16^1431655768,a[30924]=P));P=m+48|0;A=a[30926]|0;O=m+47|0;k=A+O|0;p=0-A|0;A=k&p;if(A>>>0<=m>>>0)return 0;z=a[30916]|0;if(0!=(z|0)&&(X=a[30914]|0,T=X+A|0,T>>>0<=X>>>0|T>>>0>z>>>0))return 0;a:do{if(a[30917]&4)C=0;else{z=a[30812]|0;b:do if(z){for(T=123672;;){X=a[T>>2]|0;if(X>>>0<=z>>>0&&(M=T+4|0,(X+(a[M>>2]|0)|0)>>>0>z>>>0)){X=T;q=M;break}T=a[T+8>>2]|
0;if(!T){n=174;break b}}T=k-(a[30809]|0)&p;if(2147483647>T>>>0)if(M=cg(T|0)|0,u=(X=(M|0)==((a[X>>2]|0)+(a[q>>2]|0)|0))?T:0,X)if(-1==(M|0))Oa=u;else{l=M;g=u;n=194;break a}else D=M,Q=T,F=u,n=184;else Oa=0}else n=174;while(0);do if(174==(n|0))if(z=cg(0)|0,-1!=(z|0))if(q=z,u=a[30925]|0,T=u+-1|0,r=T&q?A-q+(T+q&0-u)|0:A,u=a[30914]|0,q=u+r|0,r>>>0>m>>>0&2147483647>r>>>0)if(T=a[30916]|0,0!=(T|0)&&q>>>0<=u>>>0|q>>>0>T>>>0)Oa=0;else if(T=cg(r|0)|0,u=(q=(T|0)==(z|0))?r:0,q){l=z;g=u;n=194;break a}else D=T,Q=
r,F=u,n=184;else Oa=0;else Oa=0;while(0);b:do if(184==(n|0)){u=0-Q|0;do if(P>>>0>Q>>>0&2147483647>Q>>>0&-1!=(D|0)&&(T=a[30926]|0,z=O-Q+T&0-T,2147483647>z>>>0))if(-1==(cg(z|0)|0)){cg(u|0)|0;Oa=F;break b}else ba=z+Q|0;else ba=Q;while(0);if(-1==(D|0))Oa=F;else{l=D;g=ba;n=194;break a}}while(0);a[30917]|=4;C=Oa}n=191}while(0);191==(n|0)&&2147483647>A>>>0&&(Oa=cg(A|0)|0,A=cg(0)|0,Oa>>>0<A>>>0&-1!=(Oa|0)&-1!=(A|0))&&(ba=A-Oa|0,A=ba>>>0>(m+40|0)>>>0,A)&&(l=Oa,g=A?ba:C,n=194);if(194==(n|0)){C=(a[30914]|0)+
g|0;a[30914]=C;C>>>0>(a[30915]|0)>>>0&&(a[30915]=C);C=a[30812]|0;a:do if(C){ba=123672;do{A=a[ba>>2]|0;Oa=ba+4|0;D=a[Oa>>2]|0;if((l|0)==(A+D|0)){N=A;R=Oa;S=D;ga=ba;n=204;break}ba=a[ba+8>>2]|0}while(0!=(ba|0));if(204==(n|0)&&0==(a[ga+12>>2]&8|0)&&C>>>0<l>>>0&C>>>0>=N>>>0)a[R>>2]=S+g,ba=(a[30809]|0)+g|0,D=C+8|0,Oa=0==(D&7|0)?0:0-D&7,D=ba-Oa|0,a[30812]=C+Oa,a[30809]=D,a[C+(Oa+4)>>2]=D|1,a[C+(ba+4)>>2]=40,a[30813]=a[30928];else{ba=a[30810]|0;M=l>>>0<ba>>>0?a[30810]=l:ba;ba=l+g|0;for(D=123672;;){if((a[D>>
2]|0)==(ba|0)){ma=Y=D;n=212;break}D=a[D+8>>2]|0;if(!D){W=123672;break}}if(212==(n|0))if(a[ma+12>>2]&8)W=123672;else{a[Y>>2]=l;D=ma+4|0;a[D>>2]=(a[D>>2]|0)+g;D=l+8|0;ba=0==(D&7|0)?0:0-D&7;D=l+(g+8)|0;Oa=0==(D&7|0)?0:0-D&7;D=l+(Oa+g)|0;A=ba+m|0;F=l+A|0;Q=D-(l+ba)-m|0;a[l+(ba+4)>>2]=m|3;b:do if((D|0)!=(C|0))if((D|0)==(a[30811]|0))O=(a[30808]|0)+Q|0,a[30808]=O,a[30811]=F,a[l+(A+4)>>2]=O|1,a[l+(O+A)>>2]=O;else{O=g+4|0;P=a[l+(O+Oa)>>2]|0;if(1==(P&3|0)){r=P&-8;q=P>>>3;c:do if(256<=P>>>0){X=a[l+((Oa|24)+
g)>>2]|0;p=a[l+(g+12+Oa)>>2]|0;do if((p|0)==(D|0)){k=Oa|16;u=l+(O+k)|0;if(z=a[u>>2]|0)N=z,R=u;else if(T=l+(k+g)|0,k=a[T>>2]|0)N=k,R=T;else{ha=0;break}for(;;)if(u=N+20|0,z=a[u>>2]|0)N=z,R=u;else if(u=N+16|0,z=a[u>>2]|0)N=z,R=u;else break;R>>>0<M>>>0?Qa():(a[R>>2]=0,ha=N)}else u=a[l+((Oa|8)+g)>>2]|0,u>>>0<M>>>0&&Qa(),z=u+12|0,(a[z>>2]|0)!=(D|0)&&Qa(),T=p+8|0,(a[T>>2]|0)==(D|0)?(a[z>>2]=p,a[T>>2]=u,ha=p):Qa();while(0);if(X){p=a[l+(g+28+Oa)>>2]|0;u=123528+(p<<2)|0;do if((D|0)!=(a[u>>2]|0)){if(X>>>0<(a[30810]|
0)>>>0&&Qa(),T=X+16|0,(a[T>>2]|0)==(D|0)?a[T>>2]=ha:a[X+20>>2]=ha,!ha)break c}else if(a[u>>2]=ha,!ha){a[30807]&=~(1<<p);break c}while(0);p=a[30810]|0;ha>>>0<p>>>0&&Qa();a[ha+24>>2]=X;u=Oa|16;if(T=a[l+(u+g)>>2]|0)T>>>0<p>>>0?Qa():(a[ha+16>>2]=T,a[T+24>>2]=ha);if(T=a[l+(O+u)>>2]|0)T>>>0<(a[30810]|0)>>>0?Qa():(a[ha+20>>2]=T,a[T+24>>2]=ha)}}else T=a[l+((Oa|8)+g)>>2]|0,p=a[l+(g+12+Oa)>>2]|0,X=123264+(q<<1<<2)|0,(T|0)!=(X|0)&&(T>>>0<M>>>0&&Qa(),(a[T+12>>2]|0)!=(D|0)&&Qa()),(p|0)==(T|0)?a[30806]&=~(1<<q):
((p|0)==(X|0)?U=p+8|0:(p>>>0<M>>>0&&Qa(),u=p+8|0,(a[u>>2]|0)==(D|0)?U=u:Qa()),a[T+12>>2]=p,a[U>>2]=T);while(0);O=l+((r|Oa)+g)|0;N=r+Q|0}else O=D,N=Q;q=O+4|0;a[q>>2]&=-2;a[l+(A+4)>>2]=N|1;a[l+(N+A)>>2]=N;q=N>>>3;if(256>N>>>0)O=q<<1,P=123264+(O<<2)|0,X=a[30806]|0,u=1<<q,X&u?(q=123264+(O+2<<2)|0,z=a[q>>2]|0,z>>>0>=(a[30810]|0)>>>0?(da=q,aa=z):Qa()):(a[30806]=X|u,da=123264+(O+2<<2)|0,aa=P),a[da>>2]=F,a[aa+12>>2]=F,a[l+(A+8)>>2]=aa,a[l+(A+12)>>2]=P;else if((O=N>>>8)?16777215<N>>>0?R=31:(u=(O+1048320|0)>>>
16&8,X=O<<u,r=(X+520192|0)>>>16&4,z=X<<r,X=(z+245760|0)>>>16&2,q=14-(r|u|X)+(z<<X>>>15)|0,R=N>>>(q+7|0)&1|q<<1):R=0,O=123528+(R<<2)|0,a[l+(A+28)>>2]=R,a[l+(A+20)>>2]=0,a[l+(A+16)>>2]=0,P=a[30807]|0,q=1<<R,P&q){q=a[O>>2]|0;c:do if((a[q+4>>2]&-8|0)!=(N|0)){O=N<<(31==(R|0)?0:25-(R>>>1)|0);for(P=q;;){X=P+16+(O>>>31<<2)|0;z=a[X>>2]|0;if(!z){O=X;break}if((a[z+4>>2]&-8|0)==(N|0)){ca=z;break c}else O<<=1,P=z}if(O>>>0<(a[30810]|0)>>>0)Qa();else{a[O>>2]=F;a[l+(A+24)>>2]=P;a[l+(A+12)>>2]=F;a[l+(A+8)>>2]=F;break b}}else ca=
q;while(0);q=ca+8|0;P=a[q>>2]|0;O=a[30810]|0;P>>>0>=O>>>0&ca>>>0>=O>>>0?(a[P+12>>2]=F,a[q>>2]=F,a[l+(A+8)>>2]=P,a[l+(A+12)>>2]=ca,a[l+(A+24)>>2]=0):Qa()}else a[30807]=P|q,a[O>>2]=F,a[l+(A+24)>>2]=O,a[l+(A+12)>>2]=F,a[l+(A+8)>>2]=F}else P=(a[30809]|0)+Q|0,a[30809]=P,a[30812]=F,a[l+(A+4)>>2]=P|1;while(0);l=l+(ba|8)|0;return l|0}for(;;){A=a[W>>2]|0;if(A>>>0<=C>>>0&&(F=a[W+4>>2]|0,Q=A+F|0,Q>>>0>C>>>0)){O=Q;break}W=a[W+8>>2]|0}ba=A+(F+-39)|0;Q=A+(F+-47+(0==(ba&7|0)?0:0-ba&7))|0;ba=C+16|0;F=Q>>>0<ba>>>
0?C:Q;Q=F+8|0;A=l+8|0;D=0==(A&7|0)?0:0-A&7;A=g+-40-D|0;a[30812]=l+D;a[30809]=A;a[l+(D+4)>>2]=A|1;a[l+(g+-36)>>2]=40;a[30813]=a[30928];A=F+4|0;a[A>>2]=27;a[Q>>2]=a[30918];a[Q+4>>2]=a[30919];a[Q+8>>2]=a[30920];a[Q+12>>2]=a[30921];a[30918]=l;a[30919]=g;a[30921]=0;a[30920]=Q;Q=F+28|0;a[Q>>2]=7;if((F+32|0)>>>0<O>>>0){D=Q;do Q=D,D=D+4|0,a[D>>2]=7;while((Q+8|0)>>>0<O>>>0)}if((F|0)!=(C|0))if(D=F-C|0,a[A>>2]&=-2,a[C+4>>2]=D|1,a[F>>2]=D,Q=D>>>3,256>D>>>0)Oa=Q<<1,P=123264+(Oa<<2)|0,q=a[30806]|0,O=1<<Q,q&O?(Q=
123264+(Oa+2<<2)|0,T=a[Q>>2]|0,T>>>0<(a[30810]|0)>>>0?Qa():(Z=Q,fa=T)):(a[30806]=q|O,Z=123264+(Oa+2<<2)|0,fa=P),a[Z>>2]=C,a[fa+12>>2]=C,a[C+8>>2]=fa,a[C+12>>2]=P;else if((P=D>>>8)?16777215<D>>>0?A=31:(Oa=(P+1048320|0)>>>16&8,O=P<<Oa,P=(O+520192|0)>>>16&4,q=O<<P,O=(q+245760|0)>>>16&2,T=14-(P|Oa|O)+(q<<O>>>15)|0,A=D>>>(T+7|0)&1|T<<1):A=0,T=123528+(A<<2)|0,a[C+28>>2]=A,a[C+20>>2]=0,a[ba>>2]=0,O=a[30807]|0,q=1<<A,O&q){q=a[T>>2]|0;b:do if((a[q+4>>2]&-8|0)!=(D|0)){T=D<<(31==(A|0)?0:25-(A>>>1)|0);for(O=
q;;){Oa=O+16+(T>>>31<<2)|0;P=a[Oa>>2]|0;if(!P){ba=Oa;break}if((a[P+4>>2]&-8|0)==(D|0)){oa=P;break b}else T<<=1,O=P}if(ba>>>0<(a[30810]|0)>>>0)Qa();else{a[ba>>2]=C;a[C+24>>2]=O;a[C+12>>2]=C;a[C+8>>2]=C;break a}}else oa=q;while(0);q=oa+8|0;D=a[q>>2]|0;ba=a[30810]|0;D>>>0>=ba>>>0&oa>>>0>=ba>>>0?(a[D+12>>2]=C,a[q>>2]=C,a[C+8>>2]=D,a[C+12>>2]=oa,a[C+24>>2]=0):Qa()}else a[30807]=O|q,a[T>>2]=C,a[C+24>>2]=T,a[C+12>>2]=C,a[C+8>>2]=C}}else{D=a[30810]|0;0==(D|0)|l>>>0<D>>>0&&(a[30810]=l);a[30918]=l;a[30919]=
g;a[30921]=0;a[30815]=a[30924];a[30814]=-1;D=0;do q=D<<1,ba=123264+(q<<2)|0,a[123264+(q+3<<2)>>2]=ba,a[123264+(q+2<<2)>>2]=ba,D=D+1|0;while(32!=(D|0));D=l+8|0;ba=0==(D&7|0)?0:0-D&7;D=g+-40-ba|0;a[30812]=l+ba;a[30809]=D;a[l+(ba+4)>>2]=D|1;a[l+(g+-36)>>2]=40;a[30813]=a[30928]}while(0);g=a[30809]|0;if(g>>>0>m>>>0)return l=g-m|0,a[30809]=l,g=a[30812]|0,a[30812]=g+m,a[g+(m+4)>>2]=l|1,a[g+4>>2]=m|3,g+8|0}g=md()|0;a[g>>2]=12;return 0}function Gc(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y=0,B=0,H,t=0,z,Q,u=0,
r=0,w=0,x=0,J=0,I=0;if(b){d=b+-8|0;c=a[30810]|0;d>>>0<c>>>0&&Qa();e=a[b+-4>>2]|0;f=e&3;1==(f|0)&&Qa();g=e&-8;h=b+(g+-8)|0;do if(e&1)y=d,B=g;else{m=a[d>>2]|0;if(!f)return;k=-8-m|0;l=b+k|0;n=m+g|0;l>>>0<c>>>0&&Qa();if((l|0)==(a[30811]|0)){p=b+(g+-4)|0;q=a[p>>2]|0;if(3!=(q&3|0)){y=l;B=n;break}a[30808]=n;a[p>>2]=q&-2;a[b+(k+4)>>2]=n|1;a[h>>2]=n;return}q=m>>>3;if(256>m>>>0)m=a[b+(k+8)>>2]|0,p=a[b+(k+12)>>2]|0,H=123264+(q<<1<<2)|0,(m|0)!=(H|0)&&(m>>>0<c>>>0&&Qa(),(a[m+12>>2]|0)!=(l|0)&&Qa()),(p|0)==(m|
0)?a[30806]&=~(1<<q):((p|0)!=(H|0)?(p>>>0<c>>>0&&Qa(),H=p+8|0,(a[H>>2]|0)==(l|0)?t=H:Qa()):t=p+8|0,a[m+12>>2]=p,a[t>>2]=m),y=l,B=n;else{m=a[b+(k+24)>>2]|0;p=a[b+(k+12)>>2]|0;do if((p|0)==(l|0)){H=b+(k+20)|0;if(q=a[H>>2]|0)Q=q,z=H;else if(z=b+(k+16)|0,Q=a[z>>2]|0,!Q){u=0;break}for(;;)if(H=Q+20|0,q=a[H>>2]|0)Q=q,z=H;else if(H=Q+16|0,q=a[H>>2]|0)Q=q,z=H;else{q=Q;H=z;break}H>>>0<c>>>0?Qa():(a[H>>2]=0,u=q)}else H=a[b+(k+8)>>2]|0,H>>>0<c>>>0&&Qa(),q=H+12|0,(a[q>>2]|0)!=(l|0)&&Qa(),z=p+8|0,(a[z>>2]|0)==
(l|0)?(a[q>>2]=p,a[z>>2]=H,u=p):Qa();while(0);if(m){p=a[b+(k+28)>>2]|0;H=123528+(p<<2)|0;if((l|0)==(a[H>>2]|0)){if(a[H>>2]=u,!u){a[30807]&=~(1<<p);y=l;B=n;break}}else if(m>>>0<(a[30810]|0)>>>0&&Qa(),p=m+16|0,(a[p>>2]|0)==(l|0)?a[p>>2]=u:a[m+20>>2]=u,!u){y=l;B=n;break}p=a[30810]|0;u>>>0<p>>>0&&Qa();a[u+24>>2]=m;if(H=a[b+(k+16)>>2]|0)H>>>0<p>>>0?Qa():(a[u+16>>2]=H,a[H+24>>2]=u);(H=a[b+(k+20)>>2]|0)?H>>>0<(a[30810]|0)>>>0?Qa():(a[u+20>>2]=H,a[H+24>>2]=u,y=l,B=n):(y=l,B=n)}else y=l,B=n}}while(0);y>>>
0>=h>>>0&&Qa();d=b+(g+-4)|0;u=a[d>>2]|0;u&1||Qa();if(u&2)a[d>>2]=u&-2,a[y+4>>2]=B|1,b=a[y+B>>2]=B;else{if((h|0)==(a[30812]|0)){c=(a[30809]|0)+B|0;a[30809]=c;a[30812]=y;a[y+4>>2]=c|1;if((y|0)!=(a[30811]|0))return;a[30811]=0;a[30808]=0;return}if((h|0)==(a[30811]|0)){c=(a[30808]|0)+B|0;a[30808]=c;a[30811]=y;a[y+4>>2]=c|1;a[y+c>>2]=c;return}c=(u&-8)+B|0;q=u>>>3;do if(256<=u>>>0){H=a[b+(g+16)>>2]|0;z=a[b+(g|4)>>2]|0;do if((z|0)==(h|0)){Q=b+(g+12)|0;if(t=a[Q>>2]|0)d=t,B=Q;else if(f=b+(g+8)|0,e=a[f>>2]|
0)d=e,B=f;else{r=0;break}for(;;)if(Q=d+20|0,t=a[Q>>2]|0)d=t,B=Q;else if(Q=d+16|0,t=a[Q>>2]|0)d=t,B=Q;else break;B>>>0<(a[30810]|0)>>>0?Qa():(a[B>>2]=0,r=d)}else Q=a[b+g>>2]|0,Q>>>0<(a[30810]|0)>>>0&&Qa(),t=Q+12|0,(a[t>>2]|0)!=(h|0)&&Qa(),f=z+8|0,(a[f>>2]|0)==(h|0)?(a[t>>2]=z,a[f>>2]=Q,r=z):Qa();while(0);if(H){z=a[b+(g+20)>>2]|0;n=123528+(z<<2)|0;if((h|0)==(a[n>>2]|0)){if(a[n>>2]=r,!r){a[30807]&=~(1<<z);break}}else if(H>>>0<(a[30810]|0)>>>0&&Qa(),z=H+16|0,(a[z>>2]|0)==(h|0)?a[z>>2]=r:a[H+20>>2]=r,
!r)break;z=a[30810]|0;r>>>0<z>>>0&&Qa();a[r+24>>2]=H;if(n=a[b+(g+8)>>2]|0)n>>>0<z>>>0?Qa():(a[r+16>>2]=n,a[n+24>>2]=r);if(n=a[b+(g+12)>>2]|0)n>>>0<(a[30810]|0)>>>0?Qa():(a[r+20>>2]=n,a[n+24>>2]=r)}}else n=a[b+g>>2]|0,z=a[b+(g|4)>>2]|0,H=123264+(q<<1<<2)|0,(n|0)!=(H|0)&&(n>>>0<(a[30810]|0)>>>0&&Qa(),(a[n+12>>2]|0)!=(h|0)&&Qa()),(z|0)==(n|0)?a[30806]&=~(1<<q):((z|0)!=(H|0)?(z>>>0<(a[30810]|0)>>>0&&Qa(),H=z+8|0,(a[H>>2]|0)==(h|0)?w=H:Qa()):w=z+8|0,a[n+12>>2]=z,a[w>>2]=n);while(0);a[y+4>>2]=c|1;a[y+c>>
2]=c;if((y|0)==(a[30811]|0)){a[30808]=c;return}b=c}B=b>>>3;if(256>b>>>0)u=B<<1,d=123264+(u<<2)|0,c=a[30806]|0,w=1<<B,c&w?(B=123264+(u+2<<2)|0,h=a[B>>2]|0,h>>>0<(a[30810]|0)>>>0?Qa():(x=B,J=h)):(a[30806]=c|w,x=123264+(u+2<<2)|0,J=d),a[x>>2]=y,a[J+12>>2]=y,a[y+8>>2]=J,a[y+12>>2]=d;else{(d=b>>>8)?16777215<b>>>0?g=31:(J=(d+1048320|0)>>>16&8,x=d<<J,d=(x+520192|0)>>>16&4,u=x<<d,x=(u+245760|0)>>>16&2,w=14-(d|J|x)+(u<<x>>>15)|0,g=b>>>(w+7|0)&1|w<<1):g=0;w=123528+(g<<2)|0;a[y+28>>2]=g;a[y+20>>2]=0;a[y+16>>
2]=0;x=a[30807]|0;u=1<<g;a:do if(x&u){J=a[w>>2]|0;b:do if((a[J+4>>2]&-8|0)!=(b|0)){d=b<<(31==(g|0)?0:25-(g>>>1)|0);for(c=J;;){h=c+16+(d>>>31<<2)|0;B=a[h>>2]|0;if(!B)break;if((a[B+4>>2]&-8|0)==(b|0)){I=B;break b}else d<<=1,c=B}if(h>>>0<(a[30810]|0)>>>0)Qa();else{a[h>>2]=y;a[y+24>>2]=c;a[y+12>>2]=y;a[y+8>>2]=y;break a}}else I=J;while(0);J=I+8|0;c=a[J>>2]|0;d=a[30810]|0;c>>>0>=d>>>0&I>>>0>=d>>>0?(a[c+12>>2]=y,a[J>>2]=y,a[y+8>>2]=c,a[y+12>>2]=I,a[y+24>>2]=0):Qa()}else a[30807]=x|u,a[w>>2]=y,a[y+24>>2]=
w,a[y+12>>2]=y,a[y+8>>2]=y;while(0);y=(a[30814]|0)+-1|0;a[30814]=y;if(!y){for(y=123680;;)if(y=a[y>>2]|0)y=y+8|0;else break;a[30814]=-1}}}}function qi(b,d){b|=0;d|=0;var c,e;if(!b)return c=Hc(d)|0,c|0;if(4294967231<d>>>0)return c=md()|0,a[c>>2]=12,0;if(c=Jj(b+-8|0,11>d>>>0?16:d+11&-8)|0)return c+8|0;c=Hc(d)|0;if(!c)return 0;e=a[b+-4>>2]|0;e=(e&-8)-(0==(e&3|0)?8:4)|0;Ec(c|0,b|0,(e>>>0<d>>>0?e:d)|0)|0;Gc(b);return c|0}function Jj(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,y,B,H,t=0,z,Q=0;c=b+4|0;e=a[c>>
2]|0;f=e&-8;g=b+f|0;h=a[30810]|0;m=e&3;1!=(m|0)&b>>>0>=h>>>0&b>>>0<g>>>0||Qa();k=b+(f|4)|0;l=a[k>>2]|0;l&1||Qa();if(!m)return 256>d>>>0?0:f>>>0>=(d+4|0)>>>0&&(f-d|0)>>>0<=a[30926]<<1>>>0?b|0:0;if(f>>>0>=d>>>0){m=f-d|0;if(15>=m>>>0)return b|0;a[c>>2]=e&1|d|2;a[b+(d+4)>>2]=m|3;a[k>>2]|=1;dl(b+d|0,m);return b|0}if((g|0)==(a[30812]|0)){m=(a[30809]|0)+f|0;if(m>>>0<=d>>>0)return 0;k=m-d|0;a[c>>2]=e&1|d|2;a[b+(d+4)>>2]=k|1;a[30812]=b+d;a[30809]=k;return b|0}if((g|0)==(a[30811]|0)){k=(a[30808]|0)+f|0;if(k>>>
0<d>>>0)return 0;m=k-d|0;15<m>>>0?(a[c>>2]=e&1|d|2,a[b+(d+4)>>2]=m|1,a[b+k>>2]=m,n=b+(k+4)|0,a[n>>2]&=-2,p=b+d|0,q=m):(a[c>>2]=e&1|k|2,m=b+(k+4)|0,a[m>>2]|=1,q=p=0);a[30808]=q;a[30811]=p;return b|0}if(l&2)return 0;p=(l&-8)+f|0;if(p>>>0<d>>>0)return 0;q=p-d|0;m=l>>>3;do if(256<=l>>>0){k=a[b+(f+24)>>2]|0;n=a[b+(f+12)>>2]|0;do if((n|0)==(g|0)){y=b+(f+20)|0;if(B=a[y>>2]|0)z=B,H=y;else if(H=b+(f+16)|0,y=a[H>>2]|0)z=y;else{t=0;break}for(;;)if(y=z+20|0,B=a[y>>2]|0)z=B,H=y;else if(y=z+16|0,B=a[y>>2]|0)z=
B,H=y;else{y=z;B=H;break}B>>>0<h>>>0?Qa():(a[B>>2]=0,t=y)}else y=a[b+(f+8)>>2]|0,y>>>0<h>>>0&&Qa(),B=y+12|0,(a[B>>2]|0)!=(g|0)&&Qa(),H=n+8|0,(a[H>>2]|0)==(g|0)?(a[B>>2]=n,a[H>>2]=y,t=n):Qa();while(0);if(k){n=a[b+(f+28)>>2]|0;y=123528+(n<<2)|0;if((g|0)==(a[y>>2]|0)){if(a[y>>2]=t,!t){a[30807]&=~(1<<n);break}}else if(k>>>0<(a[30810]|0)>>>0&&Qa(),n=k+16|0,(a[n>>2]|0)==(g|0)?a[n>>2]=t:a[k+20>>2]=t,!t)break;n=a[30810]|0;t>>>0<n>>>0&&Qa();a[t+24>>2]=k;if(y=a[b+(f+16)>>2]|0)y>>>0<n>>>0?Qa():(a[t+16>>2]=y,
a[y+24>>2]=t);if(y=a[b+(f+20)>>2]|0)y>>>0<(a[30810]|0)>>>0?Qa():(a[t+20>>2]=y,a[y+24>>2]=t)}}else y=a[b+(f+8)>>2]|0,n=a[b+(f+12)>>2]|0,k=123264+(m<<1<<2)|0,(y|0)!=(k|0)&&(y>>>0<h>>>0&&Qa(),(a[y+12>>2]|0)!=(g|0)&&Qa()),(n|0)==(y|0)?a[30806]&=~(1<<m):((n|0)!=(k|0)?(n>>>0<h>>>0&&Qa(),k=n+8|0,(a[k>>2]|0)==(g|0)?Q=k:Qa()):Q=n+8|0,a[y+12>>2]=n,a[Q>>2]=y);while(0);16>q>>>0?(a[c>>2]=p|e&1|2,Q=b+(p|4)|0,a[Q>>2]|=1):(a[c>>2]=e&1|d|2,a[b+(d+4)>>2]=q|3,e=b+(p|4)|0,a[e>>2]|=1,dl(b+d|0,q));return b|0}function dl(b,
d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n=0,p=0,q,y,B=0,H,t,z=0,Q=0,u=0,r=0,w=0;c=b+d|0;e=a[b+4>>2]|0;do if(e&1)n=b,p=d;else{f=a[b>>2]|0;if(!(e&3))return;g=b+(0-f)|0;h=f+d|0;m=a[30810]|0;g>>>0<m>>>0&&Qa();if((g|0)==(a[30811]|0)){k=b+(d+4)|0;l=a[k>>2]|0;if(3!=(l&3|0)){n=g;p=h;break}a[30808]=h;a[k>>2]=l&-2;a[b+(4-f)>>2]=h|1;a[c>>2]=h;return}l=f>>>3;if(256>f>>>0)k=a[b+(8-f)>>2]|0,q=a[b+(12-f)>>2]|0,y=123264+(l<<1<<2)|0,(k|0)!=(y|0)&&(k>>>0<m>>>0&&Qa(),(a[k+12>>2]|0)!=(g|0)&&Qa()),(q|0)==(k|0)?a[30806]&=~(1<<
l):((q|0)!=(y|0)?(q>>>0<m>>>0&&Qa(),y=q+8|0,(a[y>>2]|0)==(g|0)?B=y:Qa()):B=q+8|0,a[k+12>>2]=q,a[B>>2]=k),n=g,p=h;else{k=a[b+(24-f)>>2]|0;q=a[b+(12-f)>>2]|0;do if((q|0)==(g|0)){y=16-f|0;l=b+(y+4)|0;if(H=a[l>>2]|0)y=H,t=l;else if(t=b+y|0,y=a[t>>2]|0,!y){z=0;break}for(;;)if(l=y+20|0,H=a[l>>2]|0)y=H,t=l;else if(l=y+16|0,H=a[l>>2]|0)y=H,t=l;else{H=t;break}H>>>0<m>>>0?Qa():(a[H>>2]=0,z=y)}else l=a[b+(8-f)>>2]|0,l>>>0<m>>>0&&Qa(),H=l+12|0,(a[H>>2]|0)!=(g|0)&&Qa(),t=q+8|0,(a[t>>2]|0)==(g|0)?(a[H>>2]=q,a[t>>
2]=l,z=q):Qa();while(0);if(k){q=a[b+(28-f)>>2]|0;m=123528+(q<<2)|0;if((g|0)==(a[m>>2]|0)){if(a[m>>2]=z,!z){a[30807]&=~(1<<q);n=g;p=h;break}}else if(k>>>0<(a[30810]|0)>>>0&&Qa(),q=k+16|0,(a[q>>2]|0)==(g|0)?a[q>>2]=z:a[k+20>>2]=z,!z){n=g;p=h;break}q=a[30810]|0;z>>>0<q>>>0&&Qa();a[z+24>>2]=k;m=16-f|0;if(l=a[b+m>>2]|0)l>>>0<q>>>0?Qa():(a[z+16>>2]=l,a[l+24>>2]=z);(l=a[b+(m+4)>>2]|0)?l>>>0<(a[30810]|0)>>>0?Qa():(a[z+20>>2]=l,a[l+24>>2]=z,n=g,p=h):(n=g,p=h)}else n=g,p=h}}while(0);z=a[30810]|0;c>>>0<z>>>
0&&Qa();y=b+(d+4)|0;H=a[y>>2]|0;if(H&2)a[y>>2]=H&-2,a[n+4>>2]=p|1,c=a[n+p>>2]=p;else{if((c|0)==(a[30812]|0)){t=(a[30809]|0)+p|0;a[30809]=t;a[30812]=n;a[n+4>>2]=t|1;if((n|0)!=(a[30811]|0))return;a[30811]=0;a[30808]=0;return}if((c|0)==(a[30811]|0)){t=(a[30808]|0)+p|0;a[30808]=t;a[30811]=n;a[n+4>>2]=t|1;a[n+t>>2]=t;return}t=(H&-8)+p|0;y=H>>>3;do if(256<=H>>>0){B=a[b+(d+24)>>2]|0;e=a[b+(d+12)>>2]|0;do if((e|0)==(c|0)){l=b+(d+20)|0;if(q=a[l>>2]|0)p=q,f=l;else if(f=b+(d+16)|0,k=a[f>>2]|0)p=k;else{Q=0;break}for(;;)if(l=
p+20|0,q=a[l>>2]|0)p=q,f=l;else if(l=p+16|0,q=a[l>>2]|0)p=q,f=l;else{q=p;break}f>>>0<z>>>0?Qa():(a[f>>2]=0,Q=q)}else l=a[b+(d+8)>>2]|0,l>>>0<z>>>0&&Qa(),q=l+12|0,(a[q>>2]|0)!=(c|0)&&Qa(),f=e+8|0,(a[f>>2]|0)==(c|0)?(a[q>>2]=e,a[f>>2]=l,Q=e):Qa();while(0);if(B){e=a[b+(d+28)>>2]|0;h=123528+(e<<2)|0;if((c|0)==(a[h>>2]|0)){if(a[h>>2]=Q,!Q){a[30807]&=~(1<<e);break}}else if(B>>>0<(a[30810]|0)>>>0&&Qa(),e=B+16|0,(a[e>>2]|0)==(c|0)?a[e>>2]=Q:a[B+20>>2]=Q,!Q)break;e=a[30810]|0;Q>>>0<e>>>0&&Qa();a[Q+24>>2]=
B;if(h=a[b+(d+16)>>2]|0)h>>>0<e>>>0?Qa():(a[Q+16>>2]=h,a[h+24>>2]=Q);if(h=a[b+(d+20)>>2]|0)h>>>0<(a[30810]|0)>>>0?Qa():(a[Q+20>>2]=h,a[h+24>>2]=Q)}}else h=a[b+(d+8)>>2]|0,e=a[b+(d+12)>>2]|0,B=123264+(y<<1<<2)|0,(h|0)!=(B|0)&&(h>>>0<z>>>0&&Qa(),(a[h+12>>2]|0)!=(c|0)&&Qa()),(e|0)==(h|0)?a[30806]&=~(1<<y):((e|0)!=(B|0)?(e>>>0<z>>>0&&Qa(),B=e+8|0,(a[B>>2]|0)==(c|0)?u=B:Qa()):u=e+8|0,a[h+12>>2]=e,a[u>>2]=h);while(0);a[n+4>>2]=t|1;a[n+t>>2]=t;if((n|0)==(a[30811]|0)){a[30808]=t;return}c=t}p=c>>>3;if(256>
c>>>0)H=p<<1,y=123264+(H<<2)|0,t=a[30806]|0,u=1<<p,t&u?(p=123264+(H+2<<2)|0,c=a[p>>2]|0,c>>>0<(a[30810]|0)>>>0?Qa():(r=p,w=c)):(a[30806]=t|u,r=123264+(H+2<<2)|0,w=y),a[r>>2]=n,a[w+12>>2]=n,a[n+8>>2]=w,a[n+12>>2]=y;else if((y=c>>>8)?16777215<c>>>0?w=31:(w=(y+1048320|0)>>>16&8,r=y<<w,y=(r+520192|0)>>>16&4,H=r<<y,r=(H+245760|0)>>>16&2,u=14-(y|w|r)+(H<<r>>>15)|0,w=c>>>(u+7|0)&1|u<<1):w=0,u=123528+(w<<2)|0,a[n+28>>2]=w,a[n+20>>2]=0,a[n+16>>2]=0,r=a[30807]|0,H=1<<w,r&H){H=a[u>>2]|0;a:do if((a[H+4>>2]&-8|
0)==(c|0))r=H;else{u=c<<(31==(w|0)?0:25-(w>>>1)|0);for(r=H;;){w=r+16+(u>>>31<<2)|0;y=a[w>>2]|0;if(!y){u=w;w=r;break}if((a[y+4>>2]&-8|0)==(c|0)){r=y;break a}else u<<=1,r=y}u>>>0<(a[30810]|0)>>>0&&Qa();a[u>>2]=n;a[n+24>>2]=w;a[n+12>>2]=n;a[n+8>>2]=n;return}while(0);w=r+8|0;u=a[w>>2]|0;c=a[30810]|0;u>>>0>=c>>>0&r>>>0>=c>>>0||Qa();a[u+12>>2]=n;a[w>>2]=n;a[n+8>>2]=u;a[n+12>>2]=r;a[n+24>>2]=0}else a[30807]=r|H,a[u>>2]=n,a[n+24>>2]=u,a[n+12>>2]=n,a[n+8>>2]=n}function Ic(a,d,c,e){a|=0;c|=0;return(U=(d|0)-
(e|0)-(c>>>0>a>>>0|0)>>>0,a-c>>>0|0)|0}function Va(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;e=b+c|0;if(20<=(c|0)){d&=255;f=b&3;g=d|d<<8|d<<16|d<<24;h=e&-4;if(f)for(f=b+4-f|0;(b|0)<(f|0);)t[b>>0]=d,b=b+1|0;for(;(b|0)<(h|0);)a[b>>2]=g,b=b+4|0}for(;(b|0)<(e|0);)t[b>>0]=d,b=b+1|0;return b-c|0}function Oc(a,d,c){a|=0;c|=0;if(32>(c|0))return U=(d|0)<<c|(a&(1<<c)-1<<32-c)>>>32-c,a<<c;U=a<<c-32;return 0}function Qb(a,d,c,e){a|=0;c=a+(c|0)>>>0;return(U=(d|0)+(e|0)+(c>>>0<a>>>0|0)>>>0,c|0)|0}function Xc(b,d,c,e){b|=
0;d|=0;c|=0;e|=0;var f=0;bj=bj+1|0;for(a[b>>2]=bj;(f|0)<(e|0);){if(!(a[c+(f<<3)>>2]|0))return a[c+(f<<3)>>2]=bj,a[c+((f<<3)+4)>>2]=d,a[c+((f<<3)+8)>>2]=0,U=e,c|0;f=f+1|0}e=2*e|0;c=qi(c|0,8*(e+1|0)|0)|0;c=Xc(b|0,d|0,c|0,e|0)|0;U=e;return c|0}function Oe(a,d,c){d|=0;c|=0;if(32>(c|0))return U=d>>>c,(a|0)>>>c|(d&(1<<c)-1)<<32-c;U=0;return d>>>c-32|0}function db(b,d,c){b|=0;d|=0;c|=0;for(var e=0,f;(e|0)<(c|0);){f=a[d+(e<<3)>>2]|0;if(!f)break;if((f|0)==(b|0))return a[d+((e<<3)+4)>>2]|0;e=e+1|0}return 0}
function Ec(b,d,c){b|=0;d|=0;c|=0;var e;if(4096<=(c|0))return Tj(b|0,d|0,c|0)|0;e=b|0;if((b&3)==(d&3)){for(;b&3;){if(!c)return e|0;t[b>>0]=t[d>>0]|0;b=b+1|0;d=d+1|0;c=c-1|0}for(;4<=(c|0);)a[b>>2]=a[d>>2],b=b+4|0,d=d+4|0,c=c-4|0}for(;0<(c|0);)t[b>>0]=t[d>>0]|0,b=b+1|0,d=d+1|0,c=c-1|0;return e|0}function lk(a){a|=0;return(a&255)<<24|(a>>8&255)<<16|(a>>16&255)<<8|a>>>24|0}function el(a){a|=0;var d;d=t[cj+(a&255)>>0]|0;if(8>(d|0))return d|0;d=t[cj+(a>>8&255)>>0]|0;if(8>(d|0))return d+8|0;d=t[cj+(a>>16&
255)>>0]|0;return 8>(d|0)?d+16|0:(t[cj+(a>>>24)>>0]|0)+24|0}function Cf(a,d,c,e){d|=0;e|=0;var f,g;f=a|0;a=c|0;c=f|0;g=a|0;var h,m,k,l;h=c&65535;m=g&65535;k=E(m,h)|0;l=c>>>16;c=(k>>>16)+(E(m,l)|0)|0;m=g>>>16;g=E(m,h)|0;c=(U=(c>>>16)+(E(m,l)|0)+(((c&65535)+g|0)>>>16)|0,c+g<<16|k&65535|0)|0;g=U;return(U=(E(d,a)|0)+(E(e,f)|0)+g|g&0,c|0)|0}function pf(a,d,c,e){return fl(a|0,d|0,c|0,e|0,0)|0}function vk(b,d,c,e){var f,g;f=u;u=u+16|0;g=f|0;fl(b|0,d|0,c|0,e|0,g)|0;u=f;return(U=a[g+4>>2]|0,a[g>>2]|0)|0}function fl(b,
d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,t,z,u,C,r;g=b;m=h=d;k=c;n=l=e;if(!m){p=0!=(f|0);if(n){if(!p)return(U=0,0)|0;a[f>>2]=b|0;a[f+4>>2]=d&0;return(U=0,0)|0}p&&(a[f>>2]=(g>>>0)%(k>>>0),a[f+4>>2]=0);return(U=0,(g>>>0)/(k>>>0)>>>0)|0}p=0==(n|0);do if(k){if(!p){y=(Ih(n|0)|0)-(Ih(m|0)|0)|0;if(31>=y>>>0){B=y+1|0;H=31-y|0;t=y-31>>31;q=B;z=g>>>(B>>>0)&t|m<<H;u=m>>>(B>>>0)&t;C=0;y=g<<H;break}if(!f)return q=f=0,(U=f,q)|0;a[f>>2]=b|0;a[f+4>>2]=h|d&0;q=f=0;return(U=f,q)|0}H=k-1|0;if(H&k)t=
(Ih(k|0)|0)+33-(Ih(m|0)|0)|0,B=64-t|0,y=32-t|0,H=y>>31,r=t-32|0,u=r>>31,q=t,z=y-1>>31&m>>>(r>>>0)|(m<<y|g>>>(t>>>0))&u,u&=m>>>(t>>>0),C=g<<B&H,y=(m<<B|g>>>(r>>>0))&H|g<<y&t-33>>31;else return f&&(a[f>>2]=H&g,a[f+4>>2]=0),1==(k|0)?(f=h|d&0,q=b|0):(H=el(k|0)|0,f=m>>>(H>>>0)|0,q=m<<32-H|g>>>(H>>>0)|0),(U=f,q)|0}else{if(p)return f&&(a[f>>2]=(m>>>0)%(k>>>0),a[f+4>>2]=0),f=0,q=(m>>>0)/(k>>>0)>>>0,(U=f,q)|0;if(!g)return f&&(a[f>>2]=0,a[f+4>>2]=(m>>>0)%(n>>>0)),f=0,q=(m>>>0)/(n>>>0)>>>0,(U=f,q)|0;H=n-1|0;
if(!(H&n))return f&&(a[f>>2]=b|0,a[f+4>>2]=H&m|d&0),f=0,q=m>>>((el(n|0)|0)>>>0),(U=f,q)|0;H=(Ih(n|0)|0)-(Ih(m|0)|0)|0;if(30>=H>>>0)t=H+1|0,y=31-H|0,q=t,z=m<<y|g>>>(t>>>0),u=m>>>(t>>>0),C=0,y=g<<y;else{if(!f)return q=f=0,(U=f,q)|0;a[f>>2]=b|0;a[f+4>>2]=h|d&0;q=f=0;return(U=f,q)|0}}while(0);if(q){d=c|0;c=l|e&0;e=Qb(d|0,c|0,-1,-1)|0;l=U;h=y;y=C;C=u;u=z;z=q;q=0;do b=h,h=y>>>31|h<<1,y=q|y<<1,g=u<<1|b>>>31|0,b=u>>>31|C<<1|0,Ic(e,l,g,b)|0,m=U,n=m>>31|(0>(m|0)?-1:0)<<1,q=n&1,u=Ic(g,b,n&d,((0>(m|0)?-1:0)>>
31|(0>(m|0)?-1:0)<<1)&c)|0,C=U,z=z-1|0;while(0!=(z|0));b=h;g=y;m=C;z=u;u=0;k=q}else b=y,g=C,m=u,k=u=0;q=g;g=0;f&&(a[f>>2]=z,a[f+4>>2]=m);return(U=(q|0)>>>31|(b|g)<<1|(g<<1|q>>>31)&0|u,(q<<1|0)&-2|k)|0}function xc(a,d,c){Md(0);return 0}function Jh(a,d,c,e,f,g,h){Md(1)}function Ve(a,d,c,e,f){Md(2)}function fc(a){Md(3)}function We(a,d){Md(4)}function gl(a,d,c,e,f,g){Md(5);return 0}function Gf(a,d,c,e,f,g,h,m,k,l,n,p){Md(6)}function rf(a){Md(7);return 0}function $b(a,d,c){Md(8)}function Kh(a,d,c,e,f,
g,h,m,k){Md(9)}function Hf(a,d,c,e){Md(10);return 0}function Pb(a,d){Md(11);return 0}function hl(a,d,c,e,f){Md(12);return 0}function mi(a,d,c,e){Md(13)}"use asm";var il=r.Int8Array,jl=r.Int16Array,kl=r.Int32Array,ll=r.Uint8Array,ml=r.Uint16Array,nl=r.Uint32Array,ol=r.Float32Array,pl=r.Float64Array,t=new il(A),w=new jl(A),a=new kl(A),x=new ll(A),N=new ml(A);new nl(A);var W=new ol(A),Hb=new pl(A),Fk=r.byteLength,u=v.STACKTOP|0,Qc=v.tempDoublePtr|0,cj=v.cttz_i8|0,Wa=0,pa=0,bj=0,Eh=r.NaN,Kj=r.Infinity,
U=0,Lj=r.Math.floor,Kk=r.Math.abs,Tg=r.Math.sqrt,Oi=r.Math.pow,ek=r.Math.atan2,xh=r.Math.exp,Nd=r.Math.log,E=r.Math.imul,Ih=r.Math.clz32,Md=v.abort,Pg=v.invoke_iiii,ri=v.invoke_vi,dk=v.invoke_vii,si=v.invoke_ii,Qi=v.invoke_viii,Mj=v.invoke_iiiii,Jk=v.invoke_iii,Nj=v._pthread_cleanup_pop,Oj=v.___syscall54,Pj=v._pthread_cleanup_push,Yk=v.___syscall6,Z=v.___assert_fail,Vb=v._longjmp,Qj=v.___syscall91,cg=v._sbrk,Rj=v.___syscall192,Sj=v.___syscall197,Tj=v._emscripten_memcpy_big,Uj=v.___syscall195,Vj=v.___syscall221,
Wj=v._pthread_self,Xj=v._getenv,Yj=v.___unlock,Zj=v.___syscall3,ak=v._sysconf,rl=v.___lock,Qa=v._abort,tl=v.___syscall5,ul=v.___syscall4,sl=v._time,ql=v.___syscall140,vl=v._exit,Qk=v.___syscall146,Aa=[xc,function(b,d,c){b|=0;c|=0;var e,f;e=b+20|0;f=a[e>>2]|0;b=(a[b+16>>2]|0)-f|0;b=b>>>0>c>>>0?c:b;Ec(f|0,d|0,b|0)|0;a[e>>2]=(a[e>>2]|0)+b;return c|0},Pk,function(b,d,c){var e,f;e=u;u=u+32|0;f=e+20|0;a[e>>2]=a[(b|0)+60>>2];a[e+4>>2]=0;a[e+8>>2]=d|0;a[e+12>>2]=f;a[e+16>>2]=c|0;if(0>(le(ql(140,e|0)|0)|0))return a[f>>
2]=-1,u=e,-1;b=a[f>>2]|0;u=e;return b|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f;e=u;u=u+80|0;f=e;a[b+36>>2]=2;0==(a[b>>2]&64|0)&&(a[f>>2]=a[b+60>>2],a[f+4>>2]=21505,a[f+8>>2]=e+12,0!=(Oj(54,f|0)|0))&&(t[b+75>>0]=-1);f=Pk(b,d,c)|0;u=e;return f|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,r,V,v,J,I,G,L,K,A,D,O,M,T=0,X=0,P,Oa=0,F=0,S=0,ba=0,bf,Te=0,U=0,ga=0,Ha=0,ma=0,da=0,ha=0,aa=0,ca=0,pc=0,fa=0;e=u;u=u+208|0;f=e+160|0;g=e+144|0;h=e+128|0;m=e+104|0;k=e+88|0;l=e+80|0;n=e+
64|0;p=e+48|0;q=e+40|0;y=e+32|0;B=e+24|0;H=e+204|0;ka=e+200|0;z=e+207|0;Q=e+206|0;C=e+198|0;r=e+196|0;V=e+192|0;v=e+188|0;J=e+16|0;I=e+8|0;G=e+184|0;L=b+40|0;K=ki(b,d,0)|0;if(!K)return u=e,0;D=(A=65==(w[K+24>>1]|0))?0:d;a:do{if(297>(D|0)){do switch(D|0){case 254:O=(a[c>>2]|0)+3&-4;M=a[O>>2]|0;a[c>>2]=O+4;a[b+80>>2]=M;T=1;X=219;break a;case 256:M=(a[c>>2]|0)+3&-4;O=a[M>>2]|0;a[c>>2]=M+4;a[b+56>>2]=O;T=1;X=219;break a;case 257:O=(a[c>>2]|0)+3&-4;M=a[O>>2]|0;a[c>>2]=O+4;a[b+60>>2]=M;T=1;X=219;break a;
case 258:M=(a[c>>2]|0)+3&-4;O=a[M>>2]|0;a[c>>2]=M+4;w[b+84>>1]=O;if(!(a[b+12>>2]&128)){T=1;X=219;break a}switch(O&65535|0){case 8:a[b+652>>2]=3;T=1;X=219;break a;case 16:a[b+652>>2]=4;T=1;X=219;break a;case 24:a[b+652>>2]=5;T=1;X=219;break a;case 32:a[b+652>>2]=6;T=1;X=219;break a;case 64:a[b+652>>2]=7;T=1;X=219;break a;case 128:a[b+652>>2]=7;T=1;X=219;break a;default:T=1;X=219;break a}case 259:O=(a[c>>2]|0)+3&-4;M=a[O>>2]|0;a[c>>2]=O+4;O=M&65535;if(a[L>>2]&128){if((w[b+88>>1]|0)==(M&65535)<<16>>
16){T=1;X=219;break a}R[a[b+564>>2]&127](b);P=b+12|0;a[P>>2]&=-33}P=b;p=O;P|=0;p|=0;L=B=0;O=p&65535;q=a[1940]|0;c:do if(q)for(y=q;;){f=a[y+4>>2]|0;if((w[f+4>>1]|0)==O<<16>>16){L=f;break c}y=a[y>>2]|0;if(!y){B=3;break}}else B=3;while(0);c:do if(3==(B|0))if(a[1941]|0)for(q=7764;;){if((w[q+4>>1]|0)==O<<16>>16){L=q;break c}q=q+12|0;if(!(a[q>>2]|0)){L=0;break}}else L=0;while(0);a[P+504>>2]=4;a[P+500>>2]=1;a[P+508>>2]=5;a[P+512>>2]=20;a[P+532>>2]=6;a[P+540>>2]=7;a[P+548>>2]=8;a[P+520>>2]=1;a[P+516>>2]=
5;a[P+524>>2]=20;a[P+528>>2]=5;a[P+536>>2]=9;a[P+544>>2]=10;a[P+552>>2]=11;a[P+556>>2]=1;a[P+560>>2]=21;a[P+564>>2]=1;a[P+568>>2]=22;a[P+572>>2]=8;O=P+12|0;a[O>>2]&=-131329;L?(P=dd[a[L+8>>2]&127](P,p)|0,P|=0):P=1;P|=0;if(!P){Oa=0;break a}w[b+88>>1]=M;T=P;X=219;break a;case 262:P=(a[c>>2]|0)+3&-4;M=a[P>>2]|0;a[c>>2]=P+4;w[b+90>>1]=M;T=1;X=219;break a;case 263:M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;w[b+92>>1]=P;T=1;X=219;break a;case 266:P=(a[c>>2]|0)+3&-4;M=a[P>>2]|0;a[c>>2]=P+4;P=M&65535;if(1<
(P+-1|0)>>>0){F=P;X=223;break a}w[b+94>>1]=M;T=1;X=219;break a;case 274:M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;M=P&65535;if(7<(M+-1|0)>>>0){F=M;X=223;break a}w[b+96>>1]=P;T=1;X=219;break a;case 277:P=(a[c>>2]|0)+3&-4;M=a[P>>2]|0;a[c>>2]=P+4;if(!(M&65535)){F=0;X=223;break a}w[b+98>>1]=M;T=1;X=219;break a;case 278:M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;if(!P){S=0;X=226;break a}a[b+100>>2]=P;if(a[L>>2]&4){T=1;X=219;break a}a[b+72>>2]=P;a[b+68>>2]=a[b+56>>2];T=1;X=219;break a;case 280:P=(a[c>>
2]|0)+3&-4;M=a[P>>2]|0;a[c>>2]=P+4;w[b+104>>1]=M;T=1;X=219;break a;case 281:M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;w[b+106>>1]=P;T=1;X=219;break a;case 282:P=(a[c>>2]|0)+7&-8;p=+Hb[P>>3];a[c>>2]=P+8;if(!(0>p)){W[b+116>>2]=p;T=1;X=219;break a}break;case 283:P=(a[c>>2]|0)+7&-8;p=+Hb[P>>3];a[c>>2]=P+8;if(!(0>p)){W[b+120>>2]=p;T=1;X=219;break a}break;case 284:P=(a[c>>2]|0)+3&-4;M=a[P>>2]|0;a[c>>2]=P+4;P=M&65535;if(1<(P+-1|0)>>>0){F=P;X=223;break a}w[b+126>>1]=M;T=1;X=219;break a;case 286:M=(a[c>>
2]|0)+7&-8;p=+Hb[M>>3];a[c>>2]=M+8;W[b+128>>2]=p;T=1;X=219;break a;case 287:M=(a[c>>2]|0)+7&-8;p=+Hb[M>>3];a[c>>2]=M+8;W[b+132>>2]=p;T=1;X=219;break a;case 296:M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;M=P&65535;if(2<(M+-1|0)>>>0){F=M;X=223;break a}w[b+124>>1]=P;T=1;X=219;break a;default:X=163;break a}while(0);P=Lf(b,d)|0;M=a[b+628>>2]|0;g=P?a[P+28>>2]|0:129632;a[f>>2]=a[b>>2];Hb[f+8>>3]=p;a[f+16>>2]=g;Y(M,129317,129670,f);b=0;u=e;return b|0}if(340<=(D|0)){if(32995<=(D|0))if(32997<=(D|0)){if(32998>
(D|0)){switch(D|0){case 32997:break;default:X=163;break a}M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;a[b+64>>2]=P;T=1;X=219;break}if(65563>(D|0)){switch(D|0){case 32998:break;default:X=163;break a}P=(a[c>>2]|0)+3&-4;M=a[P>>2]|0;a[c>>2]=P+4;if(!M){S=0;X=226;break}a[b+76>>2]=M;T=1;X=219;break}switch(D|0){case 65563:break;default:X=163;break a}M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;M=b+12|0;O=a[M>>2]|0;a[M>>2]=1==(P&65535|0)?O|4194304:O&-4194305;T=1;X=219;break}else switch(D|0){case 32995:O=(a[c>>
2]|0)+3&-4;M=a[O>>2]|0;a[c>>2]=O+4;O=0!=(M&65535|0);w[b+156>>1]=O&1;if(!O){T=1;X=219;break a}w[H>>1]=1;O=b+160|0;if(M=a[O>>2]|0)ja(M),a[O>>2]=0;M=eb(2)|0;a[O>>2]=M;if(!M){T=1;X=219;break a}Ab(M,H,2);T=1;X=219;break a;case 32996:M=(a[c>>2]|0)+3&-4;O=a[M>>2]|0;a[c>>2]=M+4;M=O&65535;switch(M|0){case 0:T=4;break;case 1:T=2;break;case 2:T=1;break;case 3:T=3;break;default:F=M;X=223;break a}w[b+86>>1]=T;T=1;X=219;break a;default:X=163;break a}switch(D|0){case 340:M=b+108|0;if(!(a[b+12>>2]&4194304)){O=(a[c>>
2]|0)+7&-8;p=+Hb[O>>3];a[c>>2]=O+8;O=w[b+98>>1]|0;P=O&65535;(B=a[M>>2]|0)&&ja(B);B=eb(P<<3)|0;a[M>>2]=B;if(0==O<<16>>16|0==(B|0)){T=1;X=219;break a}else T=P;for(;;)if(T=T+-1|0,Hb[B+(T<<3)>>3]=p,!T){T=1;X=219;break a}}B=(a[c>>2]|0)+3&-4;P=a[B>>2]|0;a[c>>2]=B+4;B=N[b+98>>1]|0;if(O=a[M>>2]|0)ja(O),a[M>>2]=0;if(!P){T=1;X=219;break a}O=B<<3;B=eb(O)|0;a[M>>2]=B;if(!B){T=1;X=219;break a}Ab(B,P,O);T=1;X=219;break a;case 341:O=b+112|0;if(!(a[b+12>>2]&4194304)){P=(a[c>>2]|0)+7&-8;p=+Hb[P>>3];a[c>>2]=P+8;P=
w[b+98>>1]|0;B=P&65535;(q=a[O>>2]|0)&&ja(q);q=eb(B<<3)|0;a[O>>2]=q;if(0==P<<16>>16|0==(q|0)){T=1;X=219;break a}else T=B;for(;;)if(T=T+-1|0,Hb[q+(T<<3)>>3]=p,!T){T=1;X=219;break a}}q=(a[c>>2]|0)+3&-4;M=a[q>>2]|0;a[c>>2]=q+4;q=N[b+98>>1]|0;if(B=a[O>>2]|0)ja(B),a[O>>2]=0;if(!M){T=1;X=219;break a}B=q<<3;q=eb(B)|0;a[O>>2]=q;if(!q){T=1;X=219;break a}Ab(q,M,B);T=1;X=219;break a;case 531:B=(a[c>>2]|0)+3&-4;M=a[B>>2]|0;a[c>>2]=B+4;w[b+196>>1]=M;T=1;X=219;break a;case 530:M=(a[c>>2]|0)+3&-4;B=a[M>>2]|0;a[c>>
2]=M+4;w[b+192>>1]=B;B=(a[c>>2]|0)+3&-4;M=a[B>>2]|0;a[c>>2]=B+4;w[b+194>>1]=M;T=1;X=219;break a;case 532:M=b+212|0;B=(a[c>>2]|0)+3&-4;q=a[B>>2]|0;a[c>>2]=B+4;if(B=a[M>>2]|0)ja(B),a[M>>2]=0;if(!q){T=1;X=219;break a}B=eb(24)|0;a[M>>2]=B;if(!B){T=1;X=219;break a}Ab(B,q,24);T=1;X=219;break a;default:X=163;break a}}do switch(D|0){case 297:q=(a[c>>2]|0)+3&-4;B=a[q>>2]|0;a[c>>2]=q+4;w[b+136>>1]=B;B=(a[c>>2]|0)+3&-4;q=a[B>>2]|0;a[c>>2]=B+4;w[b+138>>1]=q;T=1;X=219;break a;case 321:q=(a[c>>2]|0)+3&-4;B=a[q>>
2]|0;a[c>>2]=q+4;w[b+152>>1]=B;B=(a[c>>2]|0)+3&-4;q=a[B>>2]|0;a[c>>2]=B+4;w[b+154>>1]=q;T=1;X=219;break a;case 320:q=1<<N[b+84>>1];B=b+140|0;M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;if(M=a[B>>2]|0)ja(M),a[B>>2]=0;0!=(P|0)&&(M=q<<1,(q&2147483647|0)==(q|0))&&(ba=eb(M)|0,a[B>>2]=ba,0!=(ba|0))&&Ab(ba,P,M);M=b+144|0;P=(a[c>>2]|0)+3&-4;ba=a[P>>2]|0;a[c>>2]=P+4;if(P=a[M>>2]|0)ja(P),a[M>>2]=0;0!=(ba|0)&&(P=q<<1,(q&2147483647|0)==(q|0))&&(B=eb(P)|0,a[M>>2]=B,0!=(B|0))&&Ab(B,ba,P);P=b+148|0;ba=(a[c>>2]|0)+
3&-4;B=a[ba>>2]|0;a[c>>2]=ba+4;if(ba=a[P>>2]|0)ja(ba),a[P>>2]=0;if(!B){T=1;X=219;break a}ba=q<<1;if((q&2147483647|0)!=(q|0)){T=1;X=219;break a}q=eb(ba)|0;a[P>>2]=q;if(!q){T=1;X=219;break a}Ab(q,B,ba);T=1;X=219;break a;case 338:ba=(a[c>>2]|0)+3&-4;B=a[ba>>2]|0;a[c>>2]=ba+4;ba=B&65535;if(ba>>>0>(N[b+98>>1]|0)>>>0){F=ba;X=223;break a}B=(a[c>>2]|0)+3&-4;q=a[B>>2]|0;a[c>>2]=B+4;B=0==(q|0);if(B&0!=(ba|0)){F=ba;X=223;break a}if(ba)for(P=0;;){M=q+(P<<1)|0;O=w[M>>1]|0;if(2<(O&65535)){if(999!=O<<16>>16){F=
ba;X=223;break a}w[M>>1]=2}P=P+1|0;if(P>>>0>=ba>>>0){T=ba;break}}else T=0;w[b+156>>1]=T;ba=b+160|0;if(P=a[ba>>2]|0)ja(P),a[ba>>2]=0;if(B){T=1;X=219;break a}P=T<<1;M=eb(P)|0;a[ba>>2]=M;if(!M){T=1;X=219;break a}Ab(M,q,P);T=1;X=219;break a;case 322:P=(a[c>>2]|0)+3&-4;M=a[P>>2]|0;a[c>>2]=P+4;if(M&15){if(a[b+8>>2]|0){S=M;X=226;break a}P=a[b+628>>2]|0;ba=a[b>>2]|0;a[B>>2]=M;Wb(P,ba,129236,B)}a[b+68>>2]=M;M=b+12|0;a[M>>2]|=1024;T=1;X=219;break a;case 323:M=(a[c>>2]|0)+3&-4;ba=a[M>>2]|0;a[c>>2]=M+4;if(ba&
15){if(a[b+8>>2]|0){S=ba;X=226;break a}M=a[b+628>>2]|0;P=a[b>>2]|0;a[y>>2]=ba;Wb(M,P,129276,y)}a[b+72>>2]=ba;ba=b+12|0;a[ba>>2]|=1024;T=1;X=219;break a;case 339:ba=(a[c>>2]|0)+3&-4;P=a[ba>>2]|0;a[c>>2]=ba+4;ba=P&65535;if(5<(ba+-1|0)>>>0){F=ba;X=223;break a}M=P&65535;w[b+86>>1]=M;if(5==(ba|0)&&32==(w[b+84>>1]|0)&&(ba=b+652|0,6==(a[ba>>2]|0))){a[ba>>2]=4;T=1;X=219;break a}if(2<=(M+-5&65535)){T=1;X=219;break a}if(64!=(w[b+84>>1]|0)){T=1;X=219;break a}M=b+652|0;if(7!=(a[M>>2]|0)){T=1;X=219;break a}a[M>>
2]=6;T=1;X=219;break a;case 330:if(a[b+12>>2]&8192){M=a[b+628>>2]|0;a[q>>2]=a[b>>2];Y(M,129317,129332,q);Oa=0;break a}M=(a[c>>2]|0)+3&-4;ba=a[M>>2]|0;a[c>>2]=M+4;M=b+184|0;w[M>>1]=ba;ba=b+188|0;P=(a[c>>2]|0)+3&-4;O=a[P>>2]|0;a[c>>2]=P+4;P=N[M>>1]|0;if(M=a[ba>>2]|0)ja(M),a[ba>>2]=0;if(!O){T=1;X=219;break a}M=P<<3;P=eb(M)|0;a[ba>>2]=P;if(!P){T=1;X=219;break a}Ab(P,O,M);T=1;X=219;break a;case 301:M=1<((N[b+98>>1]|0)-(N[b+156>>1]|0)|0)?3:1;O=b+84|0;P=0;do{ba=b+200+(P<<2)|0;X=(a[c>>2]|0)+3&-4;T=a[X>>2]|
0;a[c>>2]=X+4;X=1<<N[O>>1];if(bf=a[ba>>2]|0)ja(bf),a[ba>>2]=0;0!=(T|0)&&(bf=X<<1,(X&2147483647|0)==(X|0))&&(X=eb(bf)|0,a[ba>>2]=X,0!=(X|0))&&Ab(X,T,bf);P=P+1|0}while((P|0)!=(M|0));T=1;X=219;break;case 333:M=(a[c>>2]|0)+3&-4;P=a[M>>2]|0;a[c>>2]=M+4;M=P&65535;P=(a[c>>2]|0)+3&-4;O=a[P>>2]|0;a[c>>2]=P+4;P=w[b+98>>1]|0;b:do if(M){q=O+M|0;if(P<<16>>16)ba=O,M=P;else{Oa=0;break a}for(;;){for(B=ba;;){if(B>>>0>=q>>>0){f=M;break b}bf=B+1|0;if(t[B>>0]|0)B=bf;else{B=bf;break}}M=M+-1<<16>>16;if(M<<16>>16)ba=B;
else{L=B;break}}q=L-O|0;B=(L|0)!=(O|0);bf=B&1;if(!B){Oa=0;break a}B=b+220|0;if(T=a[B>>2]|0)ja(T),a[B>>2]=0;0!=(O|0)&&(T=eb(q)|0,a[B>>2]=T,0!=(T|0))&&Ab(T,O,q);a[b+216>>2]=q;T=bf;X=219;break a}else f=P;while(0);O=a[b+628>>2]|0;M=P&65535;a[p>>2]=a[b>>2];a[p+4>>2]=M;a[p+8>>2]=M-(f&65535);Y(O,128944,129363,p);Oa=0;break a;default:X=163;break a}while(0)}while(0);a:do if(163==(X|0))if(A){p=b+224|0;f=a[p>>2]|0;L=b+228|0;do if(0<(f|0)){B=a[L>>2]|0;for(ba=0;;){M=B+(12*ba|0)|0;if((a[a[M>>2]>>2]|0)==(d|0)){Te=
M;U=ba;break}ba=ba+1|0;if((ba|0)>=(f|0)){X=172;break}}if(172==(X|0))ga=L,Ha=B,X=173;else{ba=B+(12*U|0)+8|0;if(P=a[ba>>2]|0)ja(P),a[ba>>2]=0;ma=Te}}else ga=L,Ha=a[L>>2]|0,X=173;while(0);do if(173==(X|0))if(L=f+1|0,a[p>>2]=L,ba=nf(Ha,12*L|0)|0)a[ga>>2]=ba,L=(a[p>>2]|0)+-1|0,P=ba+(12*L|0)|0,a[P>>2]=K,a[ba+(12*L|0)+8>>2]=0,a[ba+(12*L|0)+4>>2]=0,ma=P;else{L=a[b+628>>2]|0;a[l>>2]=a[b>>2];Y(L,129317,129420,l);Oa=0;break a}while(0);p=K+8|0;switch(a[p>>2]|0){case 7:case 2:case 6:case 1:M=1;break;case 8:case 3:M=
2;break;case 10:case 5:case 13:case 11:case 9:case 4:M=4;break;case 18:case 17:case 16:case 12:M=8;break;default:M=0}if(f=M|0)if(P=K+27|0,ba=0!=(t[P>>0]|0),2==(a[p>>2]|0)){ba?-3==(w[K+6>>1]|0)?(L=(a[c>>2]|0)+3&-4,M=a[L>>2]|0,a[c>>2]=L+4,L=(a[c>>2]|0)+3&-4,q=a[L>>2]|0,a[c>>2]=L+4,da=M,ha=q):Z(129506,129019,529,129317):(q=(a[c>>2]|0)+3&-4,M=a[q>>2]|0,a[c>>2]=q+4,da=(bk(M)|0)+1|0,ha=M);a[ma+4>>2]=da;M=ma+8|0;if(q=a[M>>2]|0)ja(q),a[M>>2]=0;ha&&(q=eb(da)|0,(a[M>>2]=q)&&Ab(q,ha,da));T=1;X=219}else{q=K+
6|0;M=w[q>>1]|0;L=M<<16>>16;b:do if(ba)y=(a[c>>2]|0)+3&-4,B=a[y>>2]|0,a[c>>2]=y+4,y=ma+4|0,a[y>>2]=B,aa=y,ca=B,X=195;else switch(M<<16>>16){case -3:case -1:B=ma+4|0;a[B>>2]=1;pc=B;fa=1;break b;case -2:B=N[b+98>>1]|0;y=ma+4|0;a[y>>2]=B;aa=y;ca=B;X=195;break b;default:B=ma+4|0;a[B>>2]=L;aa=B;ca=L;X=195;break b}while(0);if(195==(X|0))if(ca)pc=aa,fa=ca;else{L=a[b+628>>2]|0;M=a[K+28>>2]|0;ba=a[p>>2]|0;B=w[q>>1]|0;y=x[P>>0]|0;a[m>>2]=a[b>>2];a[m+4>>2]=M;a[m+8>>2]=ba;a[m+12>>2]=B;a[m+16>>2]=y;Y(L,129317,
129544,m);Oa=0;break}L=Mf(b,fa,f,129607)|0;y=ma+8|0;if(a[y>>2]=L){if(336==(a[K>>2]|0)&&0==(Uk(a[K+28>>2]|0,131343)|0))B=(a[c>>2]|0)+3&-4,ba=a[B>>2]|0,a[c>>2]=B+4,w[ka>>1]=ba,ba=(a[c>>2]|0)+3&-4,B=a[ba>>2]|0,a[c>>2]=ba+4,w[ka+2>>1]=B,Ab(a[y>>2]|0,ka,4);else{if(0==(t[P>>0]|0)&&65532>=(N[q>>1]|0)&&(y=a[pc>>2]|0,1>=(y|0))){1!=(y|0)&&Z(129221,129019,597,129317);do switch(a[p>>2]|0){case 7:case 1:y=(a[c>>2]|0)+3&-4;B=a[y>>2]|0;a[c>>2]=y+4;t[z>>0]=B;Ab(L,z,f);T=1;X=219;break a;case 6:B=(a[c>>2]|0)+3&-4;
y=a[B>>2]|0;a[c>>2]=B+4;t[Q>>0]=y;Ab(L,Q,f);T=1;X=219;break a;case 3:y=(a[c>>2]|0)+3&-4;B=a[y>>2]|0;a[c>>2]=y+4;w[C>>1]=B;Ab(L,C,f);T=1;X=219;break a;case 8:B=(a[c>>2]|0)+3&-4;y=a[B>>2]|0;a[c>>2]=B+4;w[r>>1]=y;Ab(L,r,f);T=1;X=219;break a;case 13:case 4:y=(a[c>>2]|0)+3&-4;B=a[y>>2]|0;a[c>>2]=y+4;a[V>>2]=B;Ab(L,V,f);T=1;X=219;break a;case 9:B=(a[c>>2]|0)+3&-4;y=a[B>>2]|0;a[c>>2]=B+4;a[v>>2]=y;Ab(L,v,f);T=1;X=219;break a;case 18:case 16:B=y=(a[c>>2]|0)+7&-8;ba=a[B>>2]|0;M=a[B+4>>2]|0;a[c>>2]=y+8;y=J;
a[y>>2]=ba;a[y+4>>2]=M;Ab(L,J,f);T=1;X=219;break a;case 17:y=M=(a[c>>2]|0)+7&-8;ba=a[y>>2]|0;B=a[y+4>>2]|0;a[c>>2]=M+8;M=I;a[M>>2]=ba;a[M+4>>2]=B;Ab(L,I,f);T=1;X=219;break a;case 11:case 10:case 5:B=(a[c>>2]|0)+7&-8;p=+Hb[B>>3];a[c>>2]=B+8;W[G>>2]=p;Ab(L,G,f);T=1;X=219;break a;case 12:B=(a[c>>2]|0)+7&-8;p=+Hb[B>>3];a[c>>2]=B+8;Hb[e>>3]=p;Ab(L,e,f);T=1;X=219;break a;default:$c(L,0,f);Oa=0;break a}while(0)}p=(a[c>>2]|0)+3&-4;q=a[p>>2]|0;a[c>>2]=p+4;Ab(L,q,E(a[pc>>2]|0,f)|0)}T=1;X=219}else Oa=0}else P=
a[b+628>>2]|0,L=a[p>>2]|0,ba=a[K+28>>2]|0,a[k>>2]=a[b>>2],a[k+4>>2]=L,a[k+8>>2]=ba,Y(P,129317,129475,k),Oa=0}else p=a[b+628>>2]|0,f=a[K+28>>2]|0,a[n>>2]=a[b>>2],a[n+4>>2]=65535<d>>>0?128936:155687,a[n+8>>2]=f,Y(p,129317,129173,n),Oa=0;else{if(223==(X|0))return q=Lf(b,d)|0,p=a[b+628>>2]|0,g=q?a[q+28>>2]|0:129632,a[h>>2]=a[b>>2],a[h+4>>2]=F,a[h+8>>2]=g,Y(p,129317,129640,h),b=0,u=e,b|0;if(226==(X|0))return p=Lf(b,d)|0,q=a[b+628>>2]|0,h=p?a[p+28>>2]|0:129632,a[g>>2]=a[b>>2],a[g+4>>2]=S,a[g+8>>2]=h,Y(q,
129317,129640,g),b=0,u=e,b|0}while(0);if(219==(X|0)){if(X=Lf(b,d)|0)d=w[X+24>>1]|0,X=b+40+(((d&65535)>>>5&65535)<<2)|0,a[X>>2]|=1<<(d&31);X=b+12|0;a[X>>2]|=8;Oa=T}u=e;return Oa|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h=0,m,k,l,n=0;e=u;u=u+16|0;f=e;g=ki(b,d,0)|0;if(!g)return u=e,0;k=(m=65==(w[g+24>>1]|0))?0:d;a:do if(297>(k|0)){do switch(k|0){case 273:l=37;break a;case 279:l=38;break a;case 254:return k=a[b+80>>2]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,a[g>>2]=k,h=1,u=e,h|0;case 256:return k=
a[b+56>>2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,h=1,u=e,h|0;case 257:return k=a[b+60>>2]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,a[g>>2]=k,h=1,u=e,h|0;case 258:return k=w[b+84>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=k,h=1,u=e,h|0;case 259:return k=w[b+88>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;case 262:return k=w[b+90>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=k,h=1,u=e,h|0;case 263:return k=w[b+92>>1]|0,l=(a[c>>
2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;case 266:return k=w[b+94>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=k,h=1,u=e,h|0;case 274:return k=w[b+96>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;case 277:return k=w[b+98>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=k,h=1,u=e,h|0;case 278:return k=a[b+100>>2]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,a[g>>2]=k,h=1,u=e,h|0;case 280:return k=w[b+104>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|
0,a[c>>2]=g+4,w[l>>1]=k,h=1,u=e,h|0;case 281:return k=w[b+106>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;case 282:return k=a[b+116>>2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,h=1,u=e,h|0;case 283:return k=a[b+120>>2]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,a[g>>2]=k,h=1,u=e,h|0;case 284:return k=w[b+126>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=k,h=1,u=e,h|0;case 286:return k=a[b+128>>2]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,a[g>>
2]=k,h=1,u=e,h|0;case 287:return k=a[b+132>>2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,h=1,u=e,h|0;case 296:return k=w[b+124>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;default:l=60;break a}while(0)}else{if(338>(k|0))switch(k|0){case 324:l=37;break a;case 325:l=38;break a;case 297:return k=w[b+136>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=k,k=w[b+138>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;case 321:return k=w[b+
152>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=k,k=w[b+154>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;case 320:return k=a[b+140>>2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,k=a[b+144>>2]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,a[g>>2]=k,k=a[b+148>>2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,h=1,u=e,h|0;case 322:return k=a[b+68>>2]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,a[g>>2]=k,h=1,u=e,h|0;case 323:return k=a[b+72>>
2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,h=1,u=e,h|0;case 330:return k=w[b+184>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,k=a[b+188>>2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,h=1,u=e,h|0;case 301:k=a[b+200>>2]|0;l=(a[c>>2]|0)+3&-4;g=a[l>>2]|0;a[c>>2]=l+4;a[g>>2]=k;if(1>=((N[b+98>>1]|0)-(N[b+156>>1]|0)|0))return h=1,u=e,h|0;k=a[b+204>>2]|0;g=(a[c>>2]|0)+3&-4;l=a[g>>2]|0;a[c>>2]=g+4;a[l>>2]=k;k=a[b+208>>2]|0;l=(a[c>>2]|0)+3&-4;g=a[l>>2]|0;a[c>>2]=l+4;
a[g>>2]=k;h=1;u=e;return h|0;case 333:return k=a[b+220>>2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,h=1,u=e,h|0;default:l=60;break a}if(531>(k|0))switch(k|0){case 340:k=a[b+108>>2]|0;if(a[b+12>>2]&4194304)return l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,a[g>>2]=k,h=1,u=e,h|0;d=+Hb[k>>3];g=w[b+98>>1]|0;if(1<(g&65535))for(l=g&65535,g=1;;){if(b=+Hb[k+(g<<3)>>3],d=b<d?b:d,g=g+1|0,g>>>0>=l>>>0){b=d;break}}else b=d;l=(a[c>>2]|0)+3&-4;g=a[l>>2]|0;a[c>>2]=l+4;Hb[g>>3]=b;h=1;u=e;return h|0;
case 341:g=a[b+112>>2]|0;if(a[b+12>>2]&4194304)return l=(a[c>>2]|0)+3&-4,k=a[l>>2]|0,a[c>>2]=l+4,a[k>>2]=g,h=1,u=e,h|0;d=+Hb[g>>3];k=w[b+98>>1]|0;if(1<(k&65535))for(l=k&65535,k=1;!(b=+Hb[g+(k<<3)>>3],b=b>d?b:d,k=k+1|0,k>>>0>=l>>>0);)d=b;else b=d;l=(a[c>>2]|0)+3&-4;k=a[l>>2]|0;a[c>>2]=l+4;Hb[k>>3]=b;h=1;u=e;return h|0;case 338:return k=w[b+156>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,k=a[b+160>>2]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,a[l>>2]=k,h=1,u=e,h|0;case 339:return k=
w[b+86>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;case 530:return k=w[b+192>>1]|0,g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=k,k=w[b+194>>1]|0,l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=k,h=1,u=e,h|0;default:l=60;break a}if(32996>(k|0)){if(532>(k|0)){switch(k|0){case 531:break;default:l=60;break a}k=w[b+196>>1]|0;g=(a[c>>2]|0)+3&-4;l=a[g>>2]|0;a[c>>2]=g+4;w[l>>1]=k;h=1;u=e;return h|0}if(32995>(k|0)){switch(k|0){case 532:break;default:l=60;break a}k=a[b+
212>>2]|0;l=(a[c>>2]|0)+3&-4;g=a[l>>2]|0;a[c>>2]=l+4;a[g>>2]=k;h=1;u=e;return h|0}switch(k|0){case 32995:break;default:l=60;break a}b=1==(w[b+156>>1]|0)?1==(w[a[b+160>>2]>>1]|0)&1:0;k=(a[c>>2]|0)+3&-4;g=a[k>>2]|0;a[c>>2]=k+4;w[g>>1]=b;h=1;u=e;return h|0}switch(k|0){case 32998:return g=a[b+76>>2]|0,k=(a[c>>2]|0)+3&-4,l=a[k>>2]|0,a[c>>2]=k+4,a[l>>2]=g,h=1,u=e,h|0;case 32996:switch(N[b+86>>1]|0){case 1:return g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=2,h=1,u=e,h|0;case 2:return l=(a[c>>2]|0)+
3&-4,g=a[l>>2]|0,a[c>>2]=l+4,h=w[g>>1]=1,u=e,h|0;case 3:return g=(a[c>>2]|0)+3&-4,l=a[g>>2]|0,a[c>>2]=g+4,w[l>>1]=3,h=1,u=e,h|0;case 4:return l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,w[g>>1]=0,h=1,u=e,h|0;default:return h=1,u=e,h|0}case 32997:return g=a[b+64>>2]|0,l=(a[c>>2]|0)+3&-4,k=a[l>>2]|0,a[c>>2]=l+4,a[k>>2]=g,h=1,u=e,h|0;default:l=60;break a}}while(0);if(37==(l|0))return 1,k=a[b+172>>2]|0,b=(a[c>>2]|0)+3&-4,g=a[b>>2]|0,a[c>>2]=b+4,a[g>>2]=k,u=e,1;if(38==(l|0))return 1,k=a[b+176>>2]|0,g=(a[c>>
2]|0)+3&-4,b=a[g>>2]|0,a[c>>2]=g+4,a[b>>2]=k,u=e,1;if(60==(l|0)){if(!m)return m=a[b+628>>2]|0,k=a[g+28>>2]|0,a[f>>2]=a[b>>2],a[f+4>>2]=65535<d>>>0?128936:155687,a[f+8>>2]=k,Y(m,129158,129173,f),u=e,0;f=a[b+224>>2]|0;if(0>=(f|0))return u=e,0;m=a[b+228>>2]|0;for(b=0;;){if((a[a[m+(12*b|0)>>2]>>2]|0)==(d|0)){n=b;break}b=b+1|0;if((b|0)>=(f|0)){h=0;l=91;break}}if(91==(l|0))return u=e,h|0;if(t[g+27>>0]|0)return l=a[m+(12*n|0)+4>>2]|0,-3==(w[g+4>>1]|0)?(f=(a[c>>2]|0)+3&-4,b=a[f>>2]|0,a[c>>2]=f+4,a[b>>2]=
l):(b=(a[c>>2]|0)+3&-4,f=a[b>>2]|0,a[c>>2]=b+4,w[f>>1]=l),l=a[m+(12*n|0)+8>>2]|0,f=(a[c>>2]|0)+3&-4,b=a[f>>2]|0,a[c>>2]=f+4,a[b>>2]=l,u=e,1;if(336==(a[g>>2]|0)&&0==(Uk(a[g+28>>2]|0,131343)|0))return l=m+(12*n|0)+8|0,b=w[a[l>>2]>>1]|0,f=(a[c>>2]|0)+3&-4,d=a[f>>2]|0,a[c>>2]=f+4,w[d>>1]=b,b=w[(a[l>>2]|0)+2>>1]|0,l=(a[c>>2]|0)+3&-4,d=a[l>>2]|0,a[c>>2]=l+4,w[d>>1]=b,u=e,1;b=a[g+8>>2]|0;if(2!=(b|0)&&65532>=(N[g+4>>1]|0)&&(g=a[m+(12*n|0)+4>>2]|0,1>=(g|0)))switch(d=a[m+(12*n|0)+8>>2]|0,1!=(g|0)&&Z(129221,
129019,1077,129158),b|0){case 7:case 1:return g=t[d>>0]|0,l=(a[c>>2]|0)+3&-4,f=a[l>>2]|0,a[c>>2]=l+4,t[f>>0]=g,u=e,1;case 6:return g=t[d>>0]|0,f=(a[c>>2]|0)+3&-4,l=a[f>>2]|0,a[c>>2]=f+4,t[l>>0]=g,u=e,1;case 3:return g=w[d>>1]|0,l=(a[c>>2]|0)+3&-4,f=a[l>>2]|0,a[c>>2]=l+4,w[f>>1]=g,u=e,1;case 8:return g=w[d>>1]|0,f=(a[c>>2]|0)+3&-4,l=a[f>>2]|0,a[c>>2]=f+4,w[l>>1]=g,u=e,1;case 13:case 4:return g=a[d>>2]|0,l=(a[c>>2]|0)+3&-4,f=a[l>>2]|0,a[c>>2]=l+4,a[f>>2]=g,u=e,1;case 9:return g=a[d>>2]|0,f=(a[c>>2]|
0)+3&-4,l=a[f>>2]|0,a[c>>2]=f+4,a[l>>2]=g,u=e,1;case 18:case 16:return g=d,l=a[g>>2]|0,f=a[g+4>>2]|0,g=(a[c>>2]|0)+3&-4,k=a[g>>2]|0,a[c>>2]=g+4,g=k,a[g>>2]=l,a[g+4>>2]=f,u=e,1;case 17:return f=d,g=a[f>>2]|0,l=a[f+4>>2]|0,f=(a[c>>2]|0)+3&-4,k=a[f>>2]|0,a[c>>2]=f+4,f=k,a[f>>2]=g,a[f+4>>2]=l,u=e,1;case 11:case 10:case 5:return l=a[d>>2]|0,f=(a[c>>2]|0)+3&-4,g=a[f>>2]|0,a[c>>2]=f+4,a[g>>2]=l,u=e,1;case 12:return b=+Hb[d>>3],l=(a[c>>2]|0)+3&-4,g=a[l>>2]|0,a[c>>2]=l+4,Hb[g>>3]=b,u=e,1;default:return u=
e,0}d=a[m+(12*n|0)+8>>2]|0;n=(a[c>>2]|0)+3&-4;m=a[n>>2]|0;a[c>>2]=n+4;a[m>>2]=d;u=e;return 1}return 0},function(a,d,c){return 0},function(b,d,c){d|=0;c|=0;var e,f,g;e=b|0;if(c)f=0;else return-1;for(;;){b=c-f|0;g=e;var h=d+f|0;b=0>(b|0)?2147483647:b;var m,k;m=u;u=u+16|0;k=m;a[k>>2]=g|0;a[k+4>>2]=h|0;a[k+8>>2]=b|0;b=le(Zj(3,k|0)|0)|0;u=m;g=b|0;if(1>(g|0)){d=g;break}b=g+f|0;if(b>>>0<c>>>0)f=b;else{d=g;f=b;break}}return(0>(d|0)?-1:f)|0},function(b,d,c){d|=0;c|=0;var e,f,g;e=b|0;if(c)f=0;else return-1;
for(;;){b=c-f|0;g=e;var h=d+f|0;b=0>(b|0)?2147483647:b;var m,k;m=u;u=u+16|0;k=m;a[k>>2]=g|0;a[k+4>>2]=h|0;a[k+8>>2]=b|0;b=le(ul(4,k|0)|0)|0;u=m;g=b|0;if(1>(g|0)){d=g;break}b=g+f|0;if(b>>>0<c>>>0)f=b;else{d=g;f=b;break}}return(0>(d|0)?-1:f)|0},function(b,d,c){d|=0;c|=0;var e,f,g,h;e=u;u=u+80|0;f=e;g=b|0;b=0>(Nk(g,f)|0);h=a[f+36>>2]|0;f=b?0:h;b=b?0:(0>(h|0))<<31>>31;if(!((f|0)==(f|0)&((0>(f|0))<<31>>31|0)==(b|0)))return u=e,0;h=Li(0,f,1,1,g,0)|0;a[d>>2]=h;if(-1==(h|0))return u=e,0;h=c;a[h>>2]=f;a[h+
4>>2]=b;u=e;return 1},function(b,d,c){b|=0;d|=0;c|=0;var e;(e=a[b+576>>2]|0)||Z(154168,142823,1199,144538);a:do if(327<=(d|0))if(65536>(d|0))switch(d|0){case 327:return b=w[e+16>>1]|0,d=(a[c>>2]|0)+3&-4,e=a[d>>2]|0,a[c>>2]=d+4,w[e>>1]=b,c=1,c|0;case 328:return b=a[e+20>>2]|0,e=(a[c>>2]|0)+3&-4,d=a[e>>2]|0,a[c>>2]=e+4,a[d>>2]=b,c=1,c|0;default:break a}else switch(d|0){case 65536:return b=a[e+4>>2]|0,d=(a[c>>2]|0)+3&-4,e=a[d>>2]|0,a[c>>2]=d+4,a[e>>2]=b,c=1,c|0;case 65540:return b=a[e+60>>2]|0,e=(a[c>>
2]|0)+3&-4,d=a[e>>2]|0,a[c>>2]=e+4,a[d>>2]=b,c=1,c|0;default:break a}else switch(d|0){case 293:case 292:return b=a[e+28>>2]|0,d=(a[c>>2]|0)+3&-4,e=a[d>>2]|0,a[c>>2]=d+4,a[e>>2]=b,c=1,c|0;case 326:return b=a[e+24>>2]|0,e=(a[c>>2]|0)+3&-4,d=a[e>>2]|0,a[c>>2]=e+4,a[d>>2]=b,c=1,c|0;default:break a}while(0);c=Aa[a[e+32>>2]&63](b,d,c)|0;return c|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k=0;e=b+576|0;(f=a[e>>2]|0)||Z(154168,142823,1152,144504);(g=a[f+36>>2]|0)||Z(144518,142823,1153,144504);a:do if(327>
(d|0))switch(d|0){case 292:if(3!=(w[b+88>>1]|0))break a;h=(a[c>>2]|0)+3&-4;m=a[h>>2]|0;a[c>>2]=h+4;a[f+28>>2]=m;break a;case 293:if(4!=(w[b+88>>1]|0))break a;m=(a[c>>2]|0)+3&-4;h=a[m>>2]|0;a[c>>2]=m+4;a[f+28>>2]=h;break a;case 326:h=(a[c>>2]|0)+3&-4;m=a[h>>2]|0;a[c>>2]=h+4;a[f+24>>2]=m;break a;default:k=15;break a}else{if(65536>(d|0))switch(d|0){case 327:m=(a[c>>2]|0)+3&-4;h=a[m>>2]|0;a[c>>2]=m+4;w[f+16>>1]=h;break a;case 328:h=(a[c>>2]|0)+3&-4;m=a[h>>2]|0;a[c>>2]=h+4;a[f+20>>2]=m;break a;default:k=
15;break a}switch(d|0){case 65536:return m=(a[c>>2]|0)+3&-4,h=a[m>>2]|0,a[c>>2]=m+4,a[f+4>>2]=h,b=1,b|0;case 65540:return h=(a[c>>2]|0)+3&-4,m=a[h>>2]|0,a[c>>2]=h+4,a[(a[e>>2]|0)+60>>2]=m,b=1,b|0;default:k=15;break a}}while(0);if(15==(k|0))return b=Aa[g&63](b,d,c)|0,b|0;c=Lf(b,d)|0;if(!c)return 0;d=w[c+24>>1]|0;c=b+40+(((d&65535)>>>5&65535)<<2)|0;a[c>>2]|=1<<(d&31);c=b+12|0;a[c>>2]|=8;return 1},function(b,d,c){b|=0;d|=0;c|=0;var e,f;(e=a[b+576>>2]|0)||Z(154187,144647,2186,146558);a:do{if(65538>(d|
0)){if(65537>(d|0)){switch(d|0){case 347:break;default:break a}b=a[e+916>>2]|0;d=(a[c>>2]|0)+3&-4;f=a[d>>2]|0;a[c>>2]=d+4;a[f>>2]=b;b=a[e+912>>2]|0;f=(a[c>>2]|0)+3&-4;d=a[f>>2]|0;a[c>>2]=f+4;a[d>>2]=b}else{switch(d|0){case 65537:break;default:break a}b=a[e+920>>2]|0;d=(a[c>>2]|0)+3&-4;f=a[d>>2]|0;a[c>>2]=d+4;a[f>>2]=b}c=1;return c|0}switch(d|0){case 65538:return b=a[e+924>>2]|0,f=(a[c>>2]|0)+3&-4,d=a[f>>2]|0,a[c>>2]=f+4,a[d>>2]=b,c=1,c|0;case 65539:return b=a[e+928>>2]|0,d=(a[c>>2]|0)+3&-4,f=a[d>>
2]|0,a[c>>2]=d+4,a[f>>2]=b,c=1,c|0;default:break a}}while(0);c=Aa[a[e+892>>2]&63](b,d,c)|0;return c|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g;e=b+576|0;(f=a[e>>2]|0)||Z(154187,144647,2132,146544);a:do if(65537>(d|0))switch(d|0){case 347:e=(a[c>>2]|0)+3&-4;d=a[e>>2]|0;a[c>>2]=e+4;if(!d)return b=0,b|0;e=(a[c>>2]|0)+3&-4;g=a[e>>2]|0;a[c>>2]=e+4;e=f+912|0;c=d;e|=0;g|=0;c|=0;var h;if(h=a[e>>2]|0)ja(h),a[e>>2]=0;g&&(h=eb(c)|0,(a[e>>2]=h)&&Ab(h,g,c));a[f+916>>2]=d;d=b+48|0;a[d>>2]|=4;d=Lf(b,347)|0;if(!d)return b=
0,b|0;g=w[d+24>>1]|0;d=b+40+(((g&65535)>>>5&65535)<<2)|0;a[d>>2]|=1<<(g&31);d=b+12|0;a[d>>2]|=8;b=1;return b|0;case 262:d=Aa[a[f+896>>2]&63](b,262,c)|0;g=a[e>>2]|0;e=b+12|0;c=a[e>>2]|0;f=c&-16385;a[e>>2]=f;1==(w[b+126>>1]|0)&&6==(w[b+90>>1]|0)&&1==(a[g+924>>2]|0)?(g=c|16384,e=a[e>>2]=g):e=f;f=b+496|0;0<(a[f>>2]|0)&&(e=e&1024?Og(b)|0:-1,a[f>>2]=e);f=b+580|0;if(0>=(a[f>>2]|0))return b=d,b|0;g=Pe(b)|0;a[f>>2]=g;b=d;return b|0;case 530:return a[f+932>>2]=1,b=Aa[a[f+896>>2]&63](b,530,c)|0,b|0;default:break a}else switch(d|
0){case 65537:return d=(a[c>>2]|0)+3&-4,g=a[d>>2]|0,a[c>>2]=d+4,a[f+920>>2]=g,b=1,b|0;case 65538:g=(a[c>>2]|0)+3&-4;d=a[g>>2]|0;a[c>>2]=g+4;a[f+924>>2]=d;d=a[e>>2]|0;g=b+12|0;f=a[g>>2]|0;e=f&-16385;a[g>>2]=e;1==(w[b+126>>1]|0)&&6==(w[b+90>>1]|0)&&1==(a[d+924>>2]|0)?(d=f|16384,a[g>>2]=d):d=e;e=b+496|0;0<(a[e>>2]|0)&&(d=d&1024?Og(b)|0:-1,a[e>>2]=d);e=b+580|0;if(0>=(a[e>>2]|0))return b=1,b|0;d=Pe(b)|0;a[e>>2]=d;b=1;return b|0;case 65539:return d=(a[c>>2]|0)+3&-4,e=a[d>>2]|0,a[c>>2]=d+4,a[f+928>>2]=e,
b=1,b|0;default:break a}while(0);b=Aa[a[f+896>>2]&63](b,d,c)|0;return b|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;e=u;u=u+16|0;f=a[b+20>>2]|0;101!=(f|0)&&(g=a[b>>2]|0,a[g+20>>2]=21,a[g+24>>2]=f,R[a[g>>2]&127](b));g=b+264|0;f=b+32|0;(a[g>>2]|0)>>>0>=(a[f>>2]|0)>>>0&&(h=a[b>>2]|0,a[h+20>>2]=126,ub[a[h+4>>2]&31](b,-1));if(h=a[b+8>>2]|0)a[h+4>>2]=a[g>>2],a[h+8>>2]=a[f>>2],R[a[h>>2]&127](b);h=a[b+392>>2]|0;if(a[h+12>>2]|0)R[a[h+4>>2]&127](b);h=(a[f>>2]|0)-(a[g>>2]|0)|0;a[e>>2]=0;Ud[a[(a[b+396>>2]|
0)+4>>2]&31](b,d,e,h>>>0<c>>>0?h:c);c=a[e>>2]|0;a[g>>2]=(a[g>>2]|0)+c;u=e;return c|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;e=a[b+20>>2]|0;102!=(e|0)&&(f=a[b>>2]|0,a[f+20>>2]=21,a[f+24>>2]=e,R[a[f>>2]&127](b));f=b+264|0;e=a[f>>2]|0;g=a[b+32>>2]|0;if(e>>>0>=g>>>0)return h=a[b>>2]|0,a[h+20>>2]=126,ub[a[h+4>>2]&31](b,-1),0;if(h=a[b+8>>2]|0)a[h+4>>2]=e,a[h+8>>2]=g,R[a[h>>2]&127](b);h=a[b+392>>2]|0;if(a[h+12>>2]|0)R[a[h+4>>2]&127](b);h=E(a[b+284>>2]|0,a[b+276>>2]|0)|0;h>>>0>c>>>0&&(c=a[b>>2]|0,a[c+
20>>2]=24,R[a[c>>2]&127](b));if(!(dd[a[(a[b+404>>2]|0)+4>>2]&127](b,d)|0))return 0;a[f>>2]=(a[f>>2]|0)+h;return h|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m;e=u;u=u+16|0;f=a[b+20>>2]|0;205!=(f|0)&&(g=a[b>>2]|0,a[g+20>>2]=21,a[g+24>>2]=f,R[a[g>>2]&127](b));g=b+140|0;f=a[g>>2]|0;h=a[b+116>>2]|0;if(f>>>0>=h>>>0)return m=a[b>>2]|0,a[m+20>>2]=126,ub[a[m+4>>2]&31](b,-1),u=e,0;if(m=a[b+8>>2]|0)a[m+4>>2]=f,a[m+8>>2]=h,R[a[m>>2]&127](b);a[e>>2]=0;Ud[a[(a[b+448>>2]|0)+4>>2]&31](b,d,e,c);c=a[e>>2]|0;a[g>>
2]=(a[g>>2]|0)+c;u=e;return c|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;e=a[b+20>>2]|0;206!=(e|0)&&(f=a[b>>2]|0,a[f+20>>2]=21,a[f+24>>2]=e,R[a[f>>2]&127](b));f=b+140|0;e=a[f>>2]|0;g=a[b+116>>2]|0;if(e>>>0>=g>>>0)return h=a[b>>2]|0,a[h+20>>2]=126,ub[a[h+4>>2]&31](b,-1),0;if(h=a[b+8>>2]|0)a[h+4>>2]=e,a[h+8>>2]=g,R[a[h>>2]&127](b);h=E(a[b+328>>2]|0,a[b+320>>2]|0)|0;h>>>0>c>>>0&&(c=a[b>>2]|0,a[c+20>>2]=24,R[a[c>>2]&127](b));if(!(dd[a[(a[b+452>>2]|0)+12>>2]&127](b,d)|0))return 0;a[f>>2]=(a[f>>2]|0)+
h;return h|0},function(b,d,c){b|=0;d|=0;c|=0;var e;e=a[b+576>>2]|0;return 65560==(d|0)?(b=a[e>>2]|0,d=(a[c>>2]|0)+3&-4,e=a[d>>2]|0,a[c>>2]=d+4,a[e>>2]=b,1):Aa[a[e+24>>2]&63](b,d,c)|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l;e=u;u=u+48|0;f=e+32|0;g=e+24|0;h=e+16|0;m=e+8|0;k=e;l=a[b+576>>2]|0;switch(d|0){case 65560:f=(a[c>>2]|0)+3&-4;d=a[f>>2]|0;a[c>>2]=f+4;a[l>>2]=d;switch(d|0){case 0:c=32;l=3;break;case 1:c=16;l=2;break;case 2:a[k>>2]=1;lb(b,277,k)|0;c=32;l=1;break;case 3:c=8;l=1;break;default:return k=
a[b+628>>2]|0,f=a[b>>2]|0,a[m>>2]=d,Y(k,f,146749,m),u=e,0}a[h>>2]=c;lb(b,258,h)|0;a[g>>2]=l;lb(b,339,g)|0;h=a[b+12>>2]&1024?Og(b)|0:-1;a[b+496>>2]=h;h=Pe(b)|0;a[b+580>>2]=h;u=e;return 1;case 65561:h=(a[c>>2]|0)+3&-4;g=a[h>>2]|0;a[c>>2]=h+4;a[l+4>>2]=g;if(2>g>>>0)return u=e,1;h=a[b+628>>2]|0;a[f>>2]=g;Y(h,146795,146811,f);u=e;return 0;default:return b=Aa[a[l+28>>2]&63](b,d,c)|0,u=e,b|0}},function(b,d,c){b|=0;d|=0;c|=0;var e,f;e=a[b+576>>2]|0;switch(d|0){case 513:return b=e+208|0,d=a[b>>2]|0,f=a[b+
4>>2]|0,b=(a[c>>2]|0)+3&-4,e=a[b>>2]|0,a[c>>2]=b+4,b=e,a[b>>2]=d,a[b+4>>2]=f,1;case 514:return f=e+216|0,b=a[f>>2]|0,d=a[f+4>>2]|0,f=(a[c>>2]|0)+3&-4,e=a[f>>2]|0,a[c>>2]=f+4,f=e,a[f>>2]=b,a[f+4>>2]=d,1;case 530:return t[e+226>>0]|0||Ig(b),d=x[e+228>>0]|0,f=(a[c>>2]|0)+3&-4,b=a[f>>2]|0,a[c>>2]=f+4,w[b>>1]=d,d=x[e+229>>0]|0,b=(a[c>>2]|0)+3&-4,f=a[b>>2]|0,a[c>>2]=b+4,w[f>>1]=d,1;case 519:return d=x[e+231>>0]|0,f=(a[c>>2]|0)+3&-4,b=a[f>>2]|0,a[c>>2]=f+4,a[b>>2]=d,d=(a[c>>2]|0)+3&-4,b=a[d>>2]|0,a[c>>2]=
d+4,a[b>>2]=e+240,1;case 520:return b=x[e+232>>0]|0,d=(a[c>>2]|0)+3&-4,f=a[d>>2]|0,a[c>>2]=d+4,a[f>>2]=b,b=(a[c>>2]|0)+3&-4,f=a[b>>2]|0,a[c>>2]=b+4,a[f>>2]=e+264,1;case 521:return f=x[e+233>>0]|0,b=(a[c>>2]|0)+3&-4,d=a[b>>2]|0,a[c>>2]=b+4,a[d>>2]=f,f=(a[c>>2]|0)+3&-4,d=a[f>>2]|0,a[c>>2]=f+4,a[d>>2]=e+288,1;case 512:return d=x[e+224>>0]|0,f=(a[c>>2]|0)+3&-4,b=a[f>>2]|0,a[c>>2]=f+4,w[b>>1]=d,1;case 515:return d=w[e+360>>1]|0,b=(a[c>>2]|0)+3&-4,f=a[b>>2]|0,a[c>>2]=b+4,w[f>>1]=d,1;default:return c=Aa[a[e+
160>>2]&63](b,d,c)|0,c|0}},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l;e=u;u=u+32|0;f=e+16|0;g=e+8|0;h=e;m=a[b+576>>2]|0;switch(d|0){case 513:l=k=(a[c>>2]|0)+7&-8;f=a[l>>2]|0;g=a[l+4>>2]|0;a[c>>2]=k+8;k=m+208|0;a[k>>2]=f;a[k+4>>2]=g;break;case 514:k=g=(a[c>>2]|0)+7&-8;f=a[k>>2]|0;l=a[k+4>>2]|0;a[c>>2]=g+8;g=m+216|0;a[g>>2]=f;a[g+4>>2]=l;break;case 530:t[m+227>>0]=1;l=(a[c>>2]|0)+3&-4;g=a[l>>2]|0;a[c>>2]=l+4;l=m+228|0;t[l>>0]=g;g=(a[c>>2]|0)+3&-4;f=a[g>>2]|0;a[c>>2]=g+4;t[m+229>>0]=f;w[b+192>>
1]=x[l>>0]|0;w[b+194>>1]=f&255;break;case 519:f=(a[c>>2]|0)+3&-4;l=a[f>>2]|0;a[c>>2]=f+4;if(l){if(3<l>>>0)return Y(a[b+628>>2]|0,148714,148729,h),u=e,0;t[m+231>>0]=l;h=(a[c>>2]|0)+3&-4;f=a[h>>2]|0;a[c>>2]=h+4;h=0;do g=f+(h<<3)|0,k=a[g+4>>2]|0,c=m+240+(h<<3)|0,a[c>>2]=a[g>>2],a[c+4>>2]=k,h=h+1|0;while((h|0)!=(l|0))}break;case 520:l=(a[c>>2]|0)+3&-4;h=a[l>>2]|0;a[c>>2]=l+4;if(h){if(3<h>>>0)return Y(a[b+628>>2]|0,148714,148765,g),u=e,0;t[m+232>>0]=h;g=(a[c>>2]|0)+3&-4;l=a[g>>2]|0;a[c>>2]=g+4;g=0;do f=
l+(g<<3)|0,k=a[f+4>>2]|0,c=m+264+(g<<3)|0,a[c>>2]=a[f>>2],a[c+4>>2]=k,g=g+1|0;while((g|0)!=(h|0))}break;case 521:h=(a[c>>2]|0)+3&-4;g=a[h>>2]|0;a[c>>2]=h+4;if(g){if(3<g>>>0)return Y(a[b+628>>2]|0,148714,148802,f),u=e,0;t[m+233>>0]=g;f=(a[c>>2]|0)+3&-4;h=a[f>>2]|0;a[c>>2]=f+4;f=0;do l=h+(f<<3)|0,k=a[l+4>>2]|0,c=m+288+(f<<3)|0,a[c>>2]=a[l>>2],a[c+4>>2]=k,f=f+1|0;while((f|0)!=(g|0))}break;case 512:g=(a[c>>2]|0)+3&-4;f=a[g>>2]|0;a[c>>2]=g+4;t[m+224>>0]=f;break;case 515:f=(a[c>>2]|0)+3&-4;g=a[f>>2]|0;
a[c>>2]=f+4;w[m+360>>1]=g;break;default:return b=Aa[a[m+164>>2]&63](b,d,c)|0,u=e,b|0}c=Lf(b,d)|0;if(!c)return u=e,0;d=w[c+24>>1]|0;c=b+40+(((d&65535)>>>5&65535)<<2)|0;a[c>>2]|=1<<(d&31);c=b+12|0;a[c>>2]|=8;u=e;return 1},function(b,d,c){b|=0;d|=0;c|=0;var e;e=a[b+576>>2]|0;switch(d|0){case 65558:return b=a[e+136>>2]|0,d=(a[c>>2]|0)+3&-4,e=a[d>>2]|0,a[c>>2]=d+4,a[e>>2]=b,1;case 65549:return b=a[e+132>>2]|0,e=(a[c>>2]|0)+3&-4,d=a[e>>2]|0,a[c>>2]=e+4,a[d>>2]=b,1;default:return c=Aa[a[e+140>>2]&63](b,
d,c)|0,c|0}},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,H;e=u;u=u+96|0;f=e+80|0;g=e+72|0;h=e+64|0;m=e+56|0;k=e+48|0;l=e+40|0;n=e+32|0;p=e+24|0;q=e+16|0;y=e+8|0;B=e;H=a[b+576>>2]|0;switch(d|0){case 65558:f=(a[c>>2]|0)+3&-4;d=a[f>>2]|0;a[c>>2]=f+4;a[H+136>>2]=d;if(!(a[b+8>>2]|0&&a[H+128>>2]&1&&bh(H+64|0,d,0)|0))return u=e,1;d=a[b+628>>2]|0;a[B>>2]=a[H+88>>2];Y(d,152397,154272,B);u=e;return 0;case 65549:B=(a[c>>2]|0)+3&-4;d=a[B>>2]|0;a[c>>2]=B+4;a[H+132>>2]=d;switch(d|0){case 1:case 0:a[y>>
2]=8;lb(b,258,y)|0;a[q>>2]=1;lb(b,339,q)|0;break;case 2:a[p>>2]=16;lb(b,258,p)|0;a[n>>2]=1;lb(b,339,n)|0;break;case 3:a[l>>2]=16;lb(b,258,l)|0;a[k>>2]=2;lb(b,339,k)|0;break;case 4:a[m>>2]=16;lb(b,258,m)|0;a[h>>2]=1;lb(b,339,h)|0;break;case 5:a[g>>2]=32,lb(b,258,g)|0,a[f>>2]=3,lb(b,339,f)|0}c=a[b+12>>2]&1024?Og(b)|0:-1;a[b+496>>2]=c;c=Pe(b)|0;a[b+580>>2]=c;u=e;return 1;default:return b=Aa[a[H+144>>2]&63](b,d,c)|0,u=e,b|0}},function(b,d,c){b|=0;d|=0;c|=0;var e,f;(e=a[b+576>>2]|0)||Z(154187,152869,698,
153724);(f=a[e+44>>2]|0)||Z(153743,152869,699,153724);return 317==(d|0)?(b=a[e>>2]&65535,e=(a[c>>2]|0)+3&-4,d=a[e>>2]|0,a[c>>2]=e+4,w[d>>1]=b,1):Aa[f&63](b,d,c)|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f;(e=a[b+576>>2]|0)||Z(154187,152869,678,153682);(f=a[e+48>>2]|0)||Z(153701,152869,679,153682);return 317==(d|0)?(d=(a[c>>2]|0)+3&-4,f=a[d>>2]|0,a[c>>2]=d+4,a[e>>2]=f&65535,f=b+48|0,a[f>>2]|=4,f=b+12|0,a[f>>2]|=8,1):Aa[f&63](b,d,c)|0},function(b,d,c){b|=0;d|=0;c|=0;var e;e=a[b+576>>2]|0;return 65557==
(d|0)?(b=a[e+120>>2]|0,d=(a[c>>2]|0)+3&-4,e=a[d>>2]|0,a[c>>2]=d+4,a[e>>2]=b,1):Aa[a[e+128>>2]&63](b,d,c)|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g;e=u;u=u+16|0;f=a[b+576>>2]|0;if(65557!=(d|0))return b=Aa[a[f+132>>2]&63](b,d,c)|0,u=e,b|0;d=(a[c>>2]|0)+3&-4;g=a[d>>2]|0;a[c>>2]=d+4;a[f+120>>2]=g;if(!(a[f+124>>2]&2&&bh(f+64|0,g,0)|0))return u=e,1;g=a[b+628>>2]|0;b=a[f+88>>2]|0;a[e>>2]=0==(b|0)?155687:b;Y(g,154479,154272,e);u=e;return 0},function(a,d,c){return Hc(E(c|0,d|0)|0)|0},ih,nk,function(b,d,
c){b|=0;d|=0;c|=0;var e,f,g,h;e=b+84|0;f=a[e>>2]|0;g=c+256|0;h=Tk(f,0,g)|0;g=0==(h|0)?g:h-f|0;h=g>>>0<c>>>0?g:c;Ec(d|0,f|0,h|0)|0;a[b+4>>2]=f+h;d=f+g|0;a[b+8>>2]=d;a[e>>2]=d;return h|0},xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc,xc],ee=[Jh,function(b,d,c,e,f,g,h){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;h|=0;var m,k,l,n,p,q,y,B,H,t,z,u,C,r,w,x,J,I,G,v,K=0,E=0;m=a[b+400>>2]|0;k=b+276|0;l=3*(a[k>>2]|0)|0;n=m+48|0;if(!((a[g>>2]|0)>>>0>=h>>>0))for(p=m+60|0,q=m+52|0,
y=b+412|0,B=m+8|0,H=b+32|0,t=b+76|0,z=b+28|0,u=b+416|0,C=m+56|0;;){r=a[c>>2]|0;if(r>>>0>=e>>>0){if(a[n>>2]|0)break;w=a[q>>2]|0;x=a[p>>2]|0;if((w|0)<(x|0)){J=a[t>>2]|0;if(0<(J|0)){I=J;for(J=0;;){G=a[m+8+(J<<2)>>2]|0;v=a[z>>2]|0;if((w|0)<(x|0)){I=w+-1|0;r=w;do Dg(G,I,G,r,1,v),r=r+1|0;while((r|0)!=(x|0));I=a[t>>2]|0}r=J+1|0;if((r|0)>=(I|0))break;w=a[q>>2]|0;x=a[p>>2]|0;J=r}w=a[p>>2]|0}else w=x;a[q>>2]=w;w=25}else K=w,E=x,w=24}else{J=e-r|0;I=a[q>>2]|0;x=(a[p>>2]|0)-I|0;w=x>>>0<J>>>0?x:J;sf[a[(a[y>>2]|
0)+4>>2]&63](b,d+(r<<2)|0,B,I,w);if((a[n>>2]|0)==(a[H>>2]|0)&&(I=a[t>>2]|0,0<(I|0)))for(J=a[k>>2]|0,x=I,I=0;;){if(1>(J|0))K=x,E=J;else{r=m+8+(I<<2)|0;for(v=1;;)if(G=a[r>>2]|0,Dg(G,0,G,0-v|0,1,a[z>>2]|0),G=a[k>>2]|0,(v|0)<(G|0))v=v+1|0;else{E=G;break}K=a[t>>2]|0}I=I+1|0;if((I|0)>=(K|0))break;else J=E,x=K}a[c>>2]=(a[c>>2]|0)+w;x=(a[q>>2]|0)+w|0;a[q>>2]=x;a[n>>2]=(a[n>>2]|0)-w;K=x;E=a[p>>2]|0;w=24}24==(w|0)&&(w=0,(K|0)==(E|0))&&(w=25);25==(w|0)&&(sf[a[(a[u>>2]|0)+4>>2]&63](b,B,a[C>>2]|0,f,a[g>>2]|0),
a[g>>2]=(a[g>>2]|0)+1,x=a[k>>2]|0,J=(a[C>>2]|0)+x|0,a[C>>2]=(J|0)<(l|0)?J:0,J=a[q>>2]|0,w=(J|0)<(l|0)?J:a[q>>2]=0,a[p>>2]=x+w);if((a[g>>2]|0)>>>0>=h>>>0)break}},function(b,d,c,e,f,g,h){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;h|=0;var m,k,l,n,p,q,y,B,H,t,z,u=0,C,r,w,x,J=0;m=a[b+400>>2]|0;k=a[c>>2]|0;if(!(k>>>0>=e>>>0)){l=b+276|0;n=m+52|0;p=b+412|0;q=m+8|0;y=m+48|0;B=b+76|0;H=b+28|0;t=b+416|0;for(z=k;;){if((a[g>>2]|0)>>>0>=h>>>0){u=28;break}k=e-z|0;C=a[n>>2]|0;r=(a[l>>2]|0)-C|0;w=r>>>0<k>>>0?r:k;sf[a[(a[p>>2]|
0)+4>>2]&63](b,d+(z<<2)|0,q,C,w);a[c>>2]=(a[c>>2]|0)+w;C=(a[n>>2]|0)+w|0;a[n>>2]=C;k=a[y>>2]|0;a[y>>2]=k-w;r=a[l>>2]|0;if((k|0)==(w|0)&(C|0)<(r|0)){w=a[B>>2]|0;if(0<(w|0)){k=C;C=r;x=w;for(w=0;;){u=a[m+8+(w<<2)>>2]|0;r=a[H>>2]|0;if((k|0)<(C|0)){x=k+-1|0;z=k;do Dg(u,x,u,z,1,r),z=z+1|0;while((z|0)!=(C|0));u=a[B>>2]|0}else u=x;z=w+1|0;if((z|0)>=(u|0))break;k=a[n>>2]|0;C=a[l>>2]|0;x=u;w=z}k=a[l>>2]|0}else k=r;a[n>>2]=k;u=15}else(C|0)==(r|0)&&(u=15);15==(u|0)&&(u=0,sf[a[(a[t>>2]|0)+4>>2]&63](b,q,0,f,a[g>>
2]|0),a[n>>2]=0,a[g>>2]=(a[g>>2]|0)+1);if(0==(a[y>>2]|0)&&(w=a[g>>2]|0,w>>>0<h>>>0)){J=w;u=19;break}z=a[c>>2]|0;if(z>>>0>=e>>>0){u=28;break}}if(19==(u|0)){e=a[B>>2]|0;a:do if(0<(e|0))for(z=b+284|0,c=J,y=e,n=0,q=a[b+84>>2]|0;;){t=E(a[q+40>>2]|0,a[q+12>>2]|0)|0;k=(t|0)/(a[z>>2]|0)|0;t=a[f+(n<<2)>>2]|0;l=E(a[q+36>>2]|0,a[q+28>>2]|0)|0;u=E(c,k)|0;H=E(k,h)|0;if((u|0)<(H|0)){k=u+-1|0;m=u;do Dg(t,k,t,m,1,l),m=m+1|0;while((m|0)!=(H|0));b=a[B>>2]|0}else b=y;H=n+1|0;if((H|0)>=(b|0))break a;c=a[g>>2]|0;y=b;
n=H;q=q+88|0}while(0);a[g>>2]=h}}},function(b,d,c,e,f,g,h){b|=0;d|=0;c|=0;f|=0;g|=0;h|=0;var m,k,l,n,p,q;e=u;u=u+16|0;m=e;k=a[b+476>>2]|0;l=k+36|0;if(a[l>>2]|0)Dg(k+32|0,0,f+(a[g>>2]<<2)|0,0,1,a[k+40>>2]|0),a[l>>2]=0,l=k+44|0,a[g>>2]=(a[g>>2]|0)+1,a[l>>2]=(a[l>>2]|0)+-1;else if(n=k+44|0,p=a[n>>2]|0,q=2>p>>>0?p:2,p=a[g>>2]|0,h=h-p|0,h=q>>>0>h>>>0?h:q,a[m>>2]=a[f+(p<<2)>>2],1<h>>>0?a[m+4>>2]=a[f+(p+1<<2)>>2]:(a[m+4>>2]=a[k+32>>2],a[l>>2]=1),Ud[a[k+12>>2]&31](b,d,a[c>>2]|0,m),m=0==(a[l>>2]|0),a[g>>2]=
(a[g>>2]|0)+h,a[n>>2]=(a[n>>2]|0)-h,!m){u=e;return}a[c>>2]=(a[c>>2]|0)+1;u=e},function(b,d,c,e,f,g,h){b|=0;c|=0;g|=0;Ud[a[(a[b+476>>2]|0)+12>>2]&31](b,d|0,a[c>>2]|0,(f|0)+(a[g>>2]<<2)|0);a[g>>2]=(a[g>>2]|0)+1;a[c>>2]=(a[c>>2]|0)+1},function(b,d,c,e,f,g,h){b|=0;f|=0;g|=0;var m,k,l;m=u;u=u+16|0;k=a[b+456>>2]|0;l=(h|0)-(a[g>>2]|0)|0;h=a[k+16>>2]|0;a[m>>2]=0;k=k+12|0;ee[a[(a[b+476>>2]|0)+4>>2]&15](b,d|0,c|0,e|0,a[k>>2]|0,m,l>>>0>h>>>0?h:l);Ud[a[(a[b+484>>2]|0)+4>>2]&31](b,a[k>>2]|0,f+(a[g>>2]<<2)|0,a[m>>
2]|0);a[g>>2]=(a[g>>2]|0)+(a[m>>2]|0);u=m},function(b,d,c,e,f,g,h){b|=0;d|=0;c|=0;e|=0;g|=0;var m,k,l,n;h=a[b+456>>2]|0;f=h+24|0;(m=a[f>>2]|0)?(l=h+12|0,k=h+16|0,n=l,l=a[l>>2]|0):(k=h+16|0,l=jg[a[(a[b+4>>2]|0)+28>>2]&3](b,a[h+8>>2]|0,a[h+20>>2]|0,a[k>>2]|0,1)|0,n=h+12|0,a[n>>2]=l,m=a[f>>2]|0);ee[a[(a[b+476>>2]|0)+4>>2]&15](b,d,c,e,l,f,a[k>>2]|0);l=a[f>>2]|0;l>>>0>m>>>0?(e=l-m|0,Ud[a[(a[b+484>>2]|0)+4>>2]&31](b,(a[n>>2]|0)+(m<<2)|0,0,e),a[g>>2]=(a[g>>2]|0)+e,b=a[f>>2]|0):b=l;l=a[k>>2]|0;b>>>0<l>>>
0||(b=h+20|0,a[b>>2]=(a[b>>2]|0)+l,a[f>>2]=0)},function(b,d,c,e,f,g,h){b|=0;f|=0;g|=0;h|=0;var m,k,l,n,p;e=a[b+456>>2]|0;c=e+24|0;(d=a[c>>2]|0)?(m=e+20|0,l=e+16|0,n=d,p=a[e+12>>2]|0):(m=e+20|0,d=e+16|0,k=jg[a[(a[b+4>>2]|0)+28>>2]&3](b,a[e+8>>2]|0,a[m>>2]|0,a[d>>2]|0,0)|0,a[e+12>>2]=k,l=d,n=a[c>>2]|0,p=k);e=(a[l>>2]|0)-n|0;d=a[g>>2]|0;k=h-d|0;h=e>>>0>k>>>0?k:e;e=(a[b+116>>2]|0)-(a[m>>2]|0)|0;k=h>>>0>e>>>0?e:h;Ud[a[(a[b+484>>2]|0)+4>>2]&31](b,p+(n<<2)|0,f+(d<<2)|0,k);a[g>>2]=(a[g>>2]|0)+k;g=(a[c>>2]|
0)+k|0;a[c>>2]=g;k=a[l>>2]|0;g>>>0<k>>>0||(a[m>>2]=(a[m>>2]|0)+k,a[c>>2]=0)},function(b,d,c,e,f,g,h){b|=0;d|=0;c|=0;f|=0;g|=0;h|=0;var m,k,l,n,p,q;e=a[b+476>>2]|0;m=e+92|0;k=a[m>>2]|0;l=b+320|0;n=a[l>>2]|0;if((k|0)<(n|0))d=n;else{k=b+36|0;if(0<(a[k>>2]|0)){n=0;for(p=a[b+216>>2]|0;!(q=(a[d+(n<<2)>>2]|0)+((E(a[e+100+(n<<2)>>2]|0,a[c>>2]|0)|0)<<2)|0,Ud[a[e+52+(n<<2)>>2]&31](b,p,q,e+12+(n<<2)|0),n=n+1|0,(n|0)>=(a[k>>2]|0));)p=p+88|0;q=a[l>>2]|0}else q=n;a[m>>2]=0;d=q;k=0}q=d-k|0;d=e+96|0;n=a[d>>2]|0;
p=q>>>0>n>>>0?n:q;q=a[g>>2]|0;n=h-q|0;h=p>>>0>n>>>0?n:p;sf[a[(a[b+480>>2]|0)+4>>2]&63](b,e+12|0,k,f+(q<<2)|0,h);a[g>>2]=(a[g>>2]|0)+h;a[d>>2]=(a[d>>2]|0)-h;d=(a[m>>2]|0)+h|0;a[m>>2]=d;(d|0)<(a[l>>2]|0)||(a[c>>2]=(a[c>>2]|0)+1)},function(b,d,c,e,f,g,h){d|=0;e|=0;h|=0;var m,k,l,n,p,q;m=u;u=u+256|0;k=a[(a[(b|0)+420>>2]|0)+44+(a[d+4>>2]<<2)>>2]|0;b=a[d+84>>2]|0;l=(c|0)+((f|0)<<2)|0;if(h)for(f=d+36|0,d=g|0,g=0;;){td[k&127](m,l,d);c=0;do n=a[b+(c<<2)>>2]|0,p=a[m+(c<<2)>>2]|0,q=n>>1,0<=(p|0)?(p=p+q|0,n=
(p|0)<(n|0)?0:(p|0)/(n|0)|0):(p=q-p|0,n=(p|0)<(n|0)?0:(p|0)/(n|0)|0,n=0-n|0),w[e+(g<<7)+(c<<1)>>1]=n,c=c+1|0;while(64!=(c|0));g=g+1|0;if((g|0)==(h|0))break;else d=(a[f>>2]|0)+d|0}u=m},function(b,d,c,e,f,g,h){d|=0;e|=0;h|=0;var m,k,l;m=u;u=u+256|0;k=a[(a[(b|0)+420>>2]|0)+84+(a[d+4>>2]<<2)>>2]|0;b=a[d+84>>2]|0;l=(c|0)+((f|0)<<2)|0;if(h)for(f=d+36|0,d=g|0,g=0;;){td[k&127](m,l,d);c=0;do w[e+(g<<7)+(c<<1)>>1]=~~(+W[m+(c<<2)>>2]*+W[b+(c<<2)>>2]+16384.5)+49152,c=c+1|0;while(64!=(c|0));g=g+1|0;if((g|0)==
(h|0))break;else d=(a[f>>2]|0)+d|0}u=m},Jh,Jh,Jh,Jh,Jh],sf=[Ve,function(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k,l;g=a[b+416>>2]|0;h=b+76|0;if(!(0>=(a[h>>2]|0)))for(m=0,k=a[b+84>>2]|0;!(l=(a[e+(m<<2)>>2]|0)+((E(a[g+52+(m<<2)>>2]|0,f)|0)<<2)|0,Ud[a[g+12+(m<<2)>>2]&31](b,k,(a[d+(m<<2)>>2]|0)+(c<<2)|0,l),m=m+1|0,(m|0)>=(a[h>>2]|0));)k=k+88|0},function(b,d,c,e,f){b|=0;c|=0;f|=0;var g,h,m,k,l;g=a[b+36>>2]|0;h=a[b+28>>2]|0;if(!(1>(f|0)|0==(h|0))){m=e|0;k=d|0;l=f;do for(f=l,l=l+-1|0,d=k,k=k+4|0,e=
a[(a[c>>2]|0)+(m<<2)>>2]|0,m=m+1|0,b=0,d=a[d>>2]|0;t[e+b>>0]=t[d>>0]|0,b=b+1|0,(b|0)!=(h|0);)d=d+g|0;while(1<(f|0))}},function(b,d,c,e,f){b|=0;c|=0;f|=0;var g,h,m,k,l;g=a[(a[b+412>>2]|0)+8>>2]|0;h=a[b+28>>2]|0;if(!(1>(f|0)|0==(h|0))){m=e|0;k=d|0;l=f;do for(f=l,l=l+-1|0,d=k,k=k+4|0,e=a[(a[c>>2]|0)+(m<<2)>>2]|0,m=m+1|0,b=0,d=a[d>>2]|0;t[e+b>>0]=((a[g+((x[d+1>>0]|256)<<2)>>2]|0)+(a[g+((x[d>>0]|0)<<2)>>2]|0)+(a[g+((x[d+2>>0]|512)<<2)>>2]|0)|0)>>>16,b=b+1|0,(b|0)!=(h|0);)d=d+3|0;while(1<(f|0))}},function(b,
d,c,e,f){c|=0;f|=0;var g,h,m,k,l,n,p,q;g=a[(b|0)+28>>2]|0;if(!(0>=(f|0))&&(b=c+4|0,h=c+8|0,g)){m=e|0;k=d|0;l=f;do for(f=l,l=l+-1|0,d=k,k=k+4|0,e=a[(a[c>>2]|0)+(m<<2)>>2]|0,n=a[(a[b>>2]|0)+(m<<2)>>2]|0,p=a[(a[h>>2]|0)+(m<<2)>>2]|0,m=m+1|0,q=0,d=a[d>>2]|0;t[e+q>>0]=t[d>>0]|0,t[n+q>>0]=t[d+1>>0]|0,t[p+q>>0]=t[d+2>>0]|0,q=q+1|0,(q|0)!=(g|0);)d=d+3|0;while(1<(f|0))}},function(b,d,c,e,f){c|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H;g=a[(b|0)+28>>2]|0;if(!(0>=(f|0))&&(b=c+4|0,h=c+8|0,g)){m=e|0;k=d|0;l=f;do for(f=
l,l=l+-1|0,d=k,k=k+4|0,e=a[(a[c>>2]|0)+(m<<2)>>2]|0,n=a[(a[b>>2]|0)+(m<<2)>>2]|0,p=a[(a[h>>2]|0)+(m<<2)>>2]|0,m=m+1|0,q=0,y=a[d>>2]|0;d=t[y+1>>0]|0,B=d&255,H=x[y+2>>0]|0,t[e+q>>0]=(x[y>>0]|0)+128-B,t[n+q>>0]=d,t[p+q>>0]=128-B+H,q=q+1|0,(q|0)!=(g|0);)y=y+3|0;while(1<(f|0))}},function(b,d,c,e,f){b|=0;c|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,u,z;g=a[(a[b+412>>2]|0)+8>>2]|0;h=a[b+28>>2]|0;if(!(0>=(f|0))){b=c+4|0;m=c+8|0;k=0==(h|0);l=e|0;e=d|0;d=f;do if(f=d,d=d+-1|0,n=e,e=e+4|0,p=a[(a[c>>2]|0)+(l<<2)>>2]|0,
q=a[(a[b>>2]|0)+(l<<2)>>2]|0,y=a[(a[m>>2]|0)+(l<<2)>>2]|0,l=l+1|0,!k)for(B=0,H=a[n>>2]|0;n=x[H>>0]|0,u=x[H+1>>0]|0,z=x[H+2>>0]|0,t[p+B>>0]=((a[g+((u|256)<<2)>>2]|0)+(a[g+(n<<2)>>2]|0)+(a[g+((z|512)<<2)>>2]|0)|0)>>>16,t[q+B>>0]=((a[g+((u|1024)<<2)>>2]|0)+(a[g+((n|768)<<2)>>2]|0)+(a[g+((z|1280)<<2)>>2]|0)|0)>>>16,t[y+B>>0]=((a[g+((u|1536)<<2)>>2]|0)+(a[g+((n|1280)<<2)>>2]|0)+(a[g+((z|1792)<<2)>>2]|0)|0)>>>16,B=B+1|0,(B|0)!=(h|0);)H=H+3|0;while(1<(f|0))}},function(b,d,c,e,f){b|=0;c|=0;f|=0;var g,h,m,
k,l,n,p,q;g=a[b+76>>2]|0;h=a[b+28>>2]|0;if(!(0>=(f|0)))for(b=0<(g|0),m=0==(h|0),k=d|0,d=e|0,e=f;;){f=e;e=e+-1|0;if(b){l=0;do{if(!m)for(n=0,p=(a[k>>2]|0)+l|0,q=a[(a[c+(l<<2)>>2]|0)+(d<<2)>>2]|0;t[q>>0]=t[p>>0]|0,n=n+1|0,(n|0)!=(h|0);)p=p+g|0,q=q+1|0;l=l+1|0}while((l|0)!=(g|0))}if(1>=(f|0))break;else k=k+4|0,d=d+1|0}},function(b,d,c,e,f){b|=0;c|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,u,z,Q,C;g=a[(a[b+412>>2]|0)+8>>2]|0;h=a[b+28>>2]|0;if(!(0>=(f|0))){b=c+4|0;m=c+8|0;k=c+12|0;l=0==(h|0);n=e|0;e=d|0;d=f;do if(f=
d,d=d+-1|0,p=e,e=e+4|0,q=a[(a[c>>2]|0)+(n<<2)>>2]|0,y=a[(a[b>>2]|0)+(n<<2)>>2]|0,B=a[(a[m>>2]|0)+(n<<2)>>2]|0,H=a[(a[k>>2]|0)+(n<<2)>>2]|0,n=n+1|0,!l)for(u=0,z=a[p>>2]|0;p=(x[z>>0]|0)^255,Q=(x[z+1>>0]|0)^255,C=(x[z+2>>0]|0)^255,t[H+u>>0]=t[z+3>>0]|0,t[q+u>>0]=((a[g+((Q|256)<<2)>>2]|0)+(a[g+(p<<2)>>2]|0)+(a[g+((C|512)<<2)>>2]|0)|0)>>>16,t[y+u>>0]=((a[g+((Q|1024)<<2)>>2]|0)+(a[g+((p|768)<<2)>>2]|0)+(a[g+((C|1280)<<2)>>2]|0)|0)>>>16,t[B+u>>0]=((a[g+((Q|1536)<<2)>>2]|0)+(a[g+((p|1280)<<2)>>2]|0)+(a[g+
((C|1792)<<2)>>2]|0)|0)>>>16,u=u+1|0,(u|0)!=(h|0);)z=z+4|0;while(1<(f|0))}},function(b,d,c,e,f){Dg(a[(d|0)>>2]|0,c|0,e|0,0,f|0,a[(b|0)+112>>2]|0)},function(b,d,c,e,f){b|=0;d|=0;f|=0;var g,h,m,k,l,n,p,q,y;g=a[(a[b+480>>2]|0)+24>>2]|0;h=a[b+112>>2]|0;if(!(0>=(f|0))&&(b=d+4|0,m=d+8|0,h)){k=e|0;l=c|0;n=f;do{f=n;n=n+-1|0;c=a[(a[d>>2]|0)+(l<<2)>>2]|0;e=a[(a[b>>2]|0)+(l<<2)>>2]|0;p=a[(a[m>>2]|0)+(l<<2)>>2]|0;l=l+1|0;q=a[k>>2]|0;k=k+4|0;y=0;do t[q+y>>0]=((a[g+((x[e+y>>0]|256)<<2)>>2]|0)+(a[g+((x[c+y>>0]|
0)<<2)>>2]|0)+(a[g+((x[p+y>>0]|512)<<2)>>2]|0)|0)>>>16,y=y+1|0;while((y|0)!=(h|0))}while(1<(f|0))}},function(b,d,c,e,f){b|=0;d|=0;f|=0;var g,h,m,k,l,n,p,q,y,B;g=a[(a[b+480>>2]|0)+24>>2]|0;h=a[b+112>>2]|0;if(!(0>=(f|0))&&(b=d+4|0,m=d+8|0,h)){k=e|0;l=c|0;n=f;do{f=n;n=n+-1|0;c=a[(a[d>>2]|0)+(l<<2)>>2]|0;e=a[(a[b>>2]|0)+(l<<2)>>2]|0;p=a[(a[m>>2]|0)+(l<<2)>>2]|0;l=l+1|0;q=a[k>>2]|0;k=k+4|0;y=0;do B=x[e+y>>0]|0,t[q+y>>0]=((a[g+((B|256)<<2)>>2]|0)+(a[g+(((x[c+y>>0]|0)+128+B&255)<<2)>>2]|0)+(a[g+((B+128+
(x[p+y>>0]|0)&255|512)<<2)>>2]|0)|0)>>>16,y=y+1|0;while((y|0)!=(h|0))}while(1<(f|0))}},function(b,d,c,e,f){d|=0;f|=0;var g,h,m,k,l;g=a[(b|0)+112>>2]|0;if(!(1>(f|0)|0==(g|0))){h=e|0;m=c|0;k=f;do for(f=k,k=k+-1|0,c=a[(a[d>>2]|0)+(m<<2)>>2]|0,m=m+1|0,e=0,b=a[h>>2]|0,h=h+4|0;l=t[c+e>>0]|0,t[b+2>>0]=l,t[b+1>>0]=l,t[b>>0]=l,e=e+1|0,(e|0)!=(g|0);)b=b+3|0;while(1<(f|0))}},function(b,d,c,e,f){b|=0;d|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,u,z,Q,C,r;g=a[b+480>>2]|0;h=a[b+112>>2]|0;m=a[b+336>>2]|0;b=a[g+8>>2]|0;k=
a[g+12>>2]|0;l=a[g+16>>2]|0;n=a[g+20>>2]|0;if(!(0>=(f|0))&&(g=d+4|0,p=d+8|0,h)){q=e|0;y=c|0;B=f;do for(f=B,B=B+-1|0,c=a[(a[d>>2]|0)+(y<<2)>>2]|0,e=a[(a[g>>2]|0)+(y<<2)>>2]|0,H=a[(a[p>>2]|0)+(y<<2)>>2]|0,y=y+1|0,u=0,z=a[q>>2]|0,q=q+4|0;Q=x[c+u>>0]|0,C=x[e+u>>0]|0,r=x[H+u>>0]|0,t[z>>0]=t[m+((a[b+(r<<2)>>2]|0)+Q)>>0]|0,t[z+1>>0]=t[m+(((a[l+(r<<2)>>2]|0)+(a[n+(C<<2)>>2]|0)>>16)+Q)>>0]|0,t[z+2>>0]=t[m+((a[k+(C<<2)>>2]|0)+Q)>>0]|0,u=u+1|0,(u|0)!=(h|0);)z=z+3|0;while(1<(f|0))}},function(b,d,c,e,f){d|=0;
f|=0;var g,h,m,k,l,n,p,q,y;g=a[(b|0)+112>>2]|0;if(!(0>=(f|0))){b=d+4|0;h=d+8|0;m=0==(g|0);k=e|0;e=c|0;c=f;do{f=c;c=c+-1|0;l=a[(a[d>>2]|0)+(e<<2)>>2]|0;n=a[(a[b>>2]|0)+(e<<2)>>2]|0;p=a[(a[h>>2]|0)+(e<<2)>>2]|0;e=e+1|0;if(!m)for(q=0,y=a[k>>2]|0;t[y>>0]=t[l+q>>0]|0,t[y+1>>0]=t[n+q>>0]|0,t[y+2>>0]=t[p+q>>0]|0,q=q+1|0,(q|0)!=(g|0);)y=y+3|0;k=k+4|0}while(1<(f|0))}},function(b,d,c,e,f){d|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,u;g=a[(b|0)+112>>2]|0;if(!(0>=(f|0))){b=d+4|0;h=d+8|0;m=0==(g|0);k=e|0;e=c|0;c=f;do{f=
c;c=c+-1|0;l=a[(a[d>>2]|0)+(e<<2)>>2]|0;n=a[(a[b>>2]|0)+(e<<2)>>2]|0;p=a[(a[h>>2]|0)+(e<<2)>>2]|0;e=e+1|0;if(!m)for(q=0,y=a[k>>2]|0;B=t[n+q>>0]|0,H=B&255,u=x[p+q>>0]|0,t[y>>0]=(x[l+q>>0]|0)+128+H,t[y+1>>0]=B,t[y+2>>0]=H+128+u,q=q+1|0,(q|0)!=(g|0);)y=y+3|0;k=k+4|0}while(1<(f|0))}},function(b,d,c,e,f){b|=0;d|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,u,z,Q,C,r,w,v,J;g=a[b+480>>2]|0;h=a[b+112>>2]|0;m=a[b+336>>2]|0;b=a[g+8>>2]|0;k=a[g+12>>2]|0;l=a[g+16>>2]|0;n=a[g+20>>2]|0;if(!(0>=(f|0))){g=d+4|0;p=d+8|0;q=d+
12|0;y=0==(h|0);B=e|0;e=c|0;c=f;do{f=c;c=c+-1|0;H=a[(a[d>>2]|0)+(e<<2)>>2]|0;u=a[(a[g>>2]|0)+(e<<2)>>2]|0;z=a[(a[p>>2]|0)+(e<<2)>>2]|0;Q=a[(a[q>>2]|0)+(e<<2)>>2]|0;e=e+1|0;if(!y)for(C=0,r=a[B>>2]|0;w=x[u+C>>0]|0,v=x[z+C>>0]|0,J=(x[H+C>>0]|0)^255,t[r>>0]=t[m+(J-(a[b+(v<<2)>>2]|0))>>0]|0,t[r+1>>0]=t[m+(J-((a[l+(v<<2)>>2]|0)+(a[n+(w<<2)>>2]|0)>>16))>>0]|0,t[r+2>>0]=t[m+(J-(a[k+(w<<2)>>2]|0))>>0]|0,t[r+3>>0]=t[Q+C>>0]|0,C=C+1|0,(C|0)!=(h|0);)r=r+4|0;B=B+4|0}while(1<(f|0))}},function(b,d,c,e,f){b|=0;d|=
0;f|=0;var g,h,m,k,l,n,p,q;g=a[b+36>>2]|0;h=a[b+112>>2]|0;if(!(0>=(f|0)))for(b=0<(g|0),m=0==(h|0),k=c|0,c=e|0,e=f;;){f=e;e=e+-1|0;if(b){l=0;do{if(!m)for(n=0,p=a[(a[d+(l<<2)>>2]|0)+(k<<2)>>2]|0,q=(a[c>>2]|0)+l|0;t[q>>0]=t[p>>0]|0,n=n+1|0,(n|0)!=(h|0);)p=p+1|0,q=q+g|0;l=l+1|0}while((l|0)!=(g|0))}if(1>=(f|0))break;else k=k+1|0,c=c+4|0}},function(b,d,c,e,f){e|=0;f|=0;b=(a[(b|0)+336>>2]|0)+((((E(w[(c|0)>>1]|0,a[a[(d|0)+84>>2]>>2]|0)|0)+4100|0)>>>3&1023)+-384)|0;t[(a[e>>2]|0)+f>>0]=t[b>>0]|0},function(b,
d,c,e,f){c|=0;e|=0;f|=0;var g,h,m,k;g=a[(b|0)+336>>2]|0;b=a[(d|0)+84>>2]|0;d=E(w[c>>1]|0,a[b>>2]|0)|0;h=E(w[c+16>>1]|0,a[b+32>>2]|0)|0;m=d+4100|0;d=h+m|0;k=m-h|0;h=E(w[c+2>>1]|0,a[b+4>>2]|0)|0;m=E(w[c+18>>1]|0,a[b+36>>2]|0)|0;b=m+h|0;c=h-m|0;m=a[e>>2]|0;t[m+f>>0]=t[g+(((b+d|0)>>>3&1023)+-384)>>0]|0;h=f+1|0;t[m+h>>0]=t[g+(((d-b|0)>>>3&1023)+-384)>>0]|0;b=a[e+4>>2]|0;t[b+f>>0]=t[g+(((c+k|0)>>>3&1023)+-384)>>0]|0;t[b+h>>0]=t[g+(((k-c|0)>>>3&1023)+-384)>>0]|0},function(b,d,c,e,f){c|=0;e|=0;f|=0;var g,
h,m,k,l,n,p,q,y,B;g=u;u=u+48|0;h=a[(b|0)+336>>2]|0;b=a[(d|0)+84>>2]|0;d=E(a[b>>2]<<13,w[c>>1]|0)|1024;m=E(5793*(a[b+64>>2]|0)|0,w[c+32>>1]|0)|0;k=m+d|0;l=(E(m,-2)|0)+d|0;d=E(10033*(a[b+32>>2]|0)|0,w[c+16>>1]|0)|0;m=d+k>>11;a[g>>2]=m;a[g+24>>2]=k-d>>11;d=g+12|0;a[d>>2]=l>>11;l=E(a[b+4>>2]<<13,w[c+2>>1]|0)|1024;k=E(5793*(a[b+68>>2]|0)|0,w[c+34>>1]|0)|0;n=k+l|0;p=(E(k,-2)|0)+l|0;l=E(10033*(a[b+36>>2]|0)|0,w[c+18>>1]|0)|0;k=l+n>>11;a[g+4>>2]=k;a[g+28>>2]=n-l>>11;l=p>>11;a[g+16>>2]=l;p=E(a[b+8>>2]<<13,
w[c+4>>1]|0)|1024;n=E(5793*(a[b+72>>2]|0)|0,w[c+36>>1]|0)|0;q=n+p|0;y=(E(n,-2)|0)+p|0;p=E(10033*(a[b+40>>2]|0)|0,w[c+20>>1]|0)|0;c=p+q>>11;a[g+8>>2]=c;b=q-p>>11;a[g+32>>2]=b;p=y>>11;a[g+20>>2]=p;y=f+2|0;q=f+1|0;n=a[e>>2]|0;B=(m<<13)+134348800|0;m=B+(5793*c|0)|0;c=(E(c,-11586)|0)+B|0;B=10033*k|0;t[n+f>>0]=t[h+(((m+B|0)>>>18&1023)+-384)>>0]|0;t[n+y>>0]=t[h+(((m-B|0)>>>18&1023)+-384)>>0]|0;t[n+q>>0]=t[h+((c>>>18&1023)+-384)>>0]|0;c=a[e+4>>2]|0;n=(a[d>>2]<<13)+134348800|0;d=n+(5793*p|0)|0;B=(E(p,-11586)|
0)+n|0;n=10033*l|0;t[c+f>>0]=t[h+(((d+n|0)>>>18&1023)+-384)>>0]|0;t[c+y>>0]=t[h+(((d-n|0)>>>18&1023)+-384)>>0]|0;t[c+q>>0]=t[h+((B>>>18&1023)+-384)>>0]|0;B=a[e+8>>2]|0;e=(a[g+24>>2]<<13)+134348800|0;c=e+(5793*b|0)|0;n=(E(b,-11586)|0)+e|0;e=10033*(a[g+28>>2]|0)|0;t[B+f>>0]=t[h+(((c+e|0)>>>18&1023)+-384)>>0]|0;t[B+y>>0]=t[h+(((c-e|0)>>>18&1023)+-384)>>0]|0;t[B+q>>0]=t[h+((n>>>18&1023)+-384)>>0]|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H;g=u;u=u+64|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=
c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(w[k>>1]|0,a[c>>2]|0)|0,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=n+l<<2,q=l-n<<2,n=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,l=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,y=(4433*(l+n|0)|0)+1024|0,B=y+(6270*n|0)>>11,n=y+(E(l,-15137)|0)>>11,a[d>>2]=B+p,a[d+48>>2]=p-B,a[d+16>>2]=n+q,a[d+32>>2]=q-n,b=b+1|0,4!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+3|0;c=f+1|0;k=f+2|0;b=0;for(n=h;h=a[e+(b<<2)>>2]|0,q=(a[n>>2]|0)+16400|0,B=a[n+8>>2]|0,p=q+B<<13,l=q-B<<13,B=a[n+4>>2]|0,q=a[n+12>>2]|0,y=4433*(q+B|0)|0,H=
y+(6270*B|0)|0,B=y+(E(q,-15137)|0)|0,t[h+f>>0]=t[m+(((H+p|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((p-H|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((B+l|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((l-B|0)>>>18&1023)+-384)>>0]|0,b=b+1|0,4!=(b|0);)n=n+16|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,ka,z;g=u;u=u+112|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,q=6476*(p+
n|0)|0,y=n-p|0,p=(2896*y|0)+l|0,n=p+q|0,B=p-q|0,q=l+(E(y,-11584)|0)|0,y=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,l=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,p=6810*(l+y|0)|0,H=p+(4209*y|0)|0,y=p+(E(l,-17828)|0)|0,a[d>>2]=H+n>>11,a[d+80>>2]=n-H>>11,a[d+20>>2]=y+B>>11,a[d+60>>2]=B-y>>11,a[d+40>>2]=q>>11,b=b+1|0,5!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+4|0;c=f+1|0;k=f+3|0;b=f+2|0;q=0;for(y=h;h=a[e+(q<<2)>>2]|0,B=(a[y>>2]<<13)+134348800|0,H=a[y+8>>2]|0,n=a[y+16>>2]|0,l=6476*(n+H|0)|0,p=H-n|0,n=(2896*p|0)+B|0,H=n+l|0,ka=n-l|
0,l=B+(E(p,-11584)|0)|0,p=a[y+4>>2]|0,B=a[y+12>>2]|0,n=6810*(B+p|0)|0,z=n+(4209*p|0)|0,p=n+(E(B,-17828)|0)|0,t[h+f>>0]=t[m+(((z+H|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((H-z|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((p+ka|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((ka-p|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+((l>>>18&1023)+-384)>>0]|0,q=q+1|0,5!=(q|0);)y=y+20|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,r;g=u;u=u+144|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>
2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(5793*(a[c+128>>2]|0)|0,w[k+64>>1]|0)|0,p=n+l|0,q=(E(n,-2)|0)+l>>11,l=E(10033*(a[c+64>>2]|0)|0,w[k+32>>1]|0)|0,n=l+p|0,y=p-l|0,l=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,p=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,B=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,H=2998*(B+l|0)|0,ka=H+(p+l<<13)|0,z=H+(B-p<<13)|0,H=l-p-B<<2,a[d>>2]=ka+n>>11,a[d+120>>2]=n-ka>>11,a[d+24>>2]=H+q,a[d+96>>2]=q-H,a[d+48>>2]=z+y>>11,a[d+72>>2]=y-z>>11,b=b+1|0,6!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+5|0;c=f+1|0;k=
f+4|0;b=f+2|0;z=f+3|0;y=0;for(H=h;h=a[e+(y<<2)>>2]|0,q=(a[H>>2]<<13)+134348800|0,ka=5793*(a[H+16>>2]|0)|0,n=q+ka|0,B=q-ka-ka|0,ka=10033*(a[H+8>>2]|0)|0,q=n+ka|0,p=n-ka|0,ka=a[H+4>>2]|0,n=a[H+12>>2]|0,l=a[H+20>>2]|0,Q=2998*(l+ka|0)|0,C=Q+(n+ka<<13)|0,r=Q+(l-n<<13)|0,Q=ka-n-l<<13,t[h+f>>0]=t[m+(((C+q|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((q-C|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((Q+B|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((B-Q|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((r+p|0)>>>18&1023)+
-384)>>0]|0,t[h+z>>0]=t[m+(((p-r|0)>>>18&1023)+-384)>>0]|0,y=y+1|0,6!=(y|0);)H=H+24|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,r,x,v,J,I,G;g=u;u=u+208|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,q=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,y=7223*(p-q|0)|0,B=2578*(n-p|0)|0,H=l+(B+y)+(E(p,-15083)|0)|0,ka=q+n|0,z=(10438*ka|0)+l|0,Q=z+(E(q,-637)|0)+y|0,y=z+(E(n,-20239)|
0)+B|0,B=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,n=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,z=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,q=7663*(n+B|0)|0,C=1395*(B-n|0)|0,r=E(z+n|0,-11295)|0,n=q+C+r|0,x=5027*(z+B|0)|0,B=x+(q-C)|0,C=x+(15326*z|0)+r|0,a[d>>2]=B+Q>>11,a[d+168>>2]=Q-B>>11,a[d+28>>2]=n+H>>11,a[d+140>>2]=H-n>>11,a[d+56>>2]=C+y>>11,a[d+112>>2]=y-C>>11,a[d+84>>2]=(11585*(p-ka|0)|0)+l>>11,b=b+1|0,7!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+6|0;c=f+1|0;k=f+5|0;b=f+2|0;l=f+4|0;ka=f+3|0;p=0;for(C=h;h=a[e+(p<<2)>>2]|0,y=(a[C>>2]<<
13)+134348800|0,n=a[C+8>>2]|0,H=a[C+16>>2]|0,B=a[C+24>>2]|0,Q=7223*(H-B|0)|0,r=2578*(n-H|0)|0,z=y+(r+Q)+(E(H,-15083)|0)|0,x=B+n|0,q=(10438*x|0)+y|0,v=q+(E(B,-637)|0)+Q|0,Q=q+(E(n,-20239)|0)+r|0,r=a[C+4>>2]|0,n=a[C+12>>2]|0,q=a[C+20>>2]|0,B=7663*(n+r|0)|0,J=1395*(r-n|0)|0,I=E(q+n|0,-11295)|0,n=B+J+I|0,G=5027*(q+r|0)|0,r=B-J+G|0,J=G+(15326*q|0)+I|0,t[h+f>>0]=t[m+(((r+v|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((v-r|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((n+z|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+
(((z-n|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((J+Q|0)>>>18&1023)+-384)>>0]|0,t[h+l>>0]=t[m+(((Q-J|0)>>>18&1023)+-384)>>0]|0,t[h+ka>>0]=t[m+((((11585*(H-x|0)|0)+y|0)>>>18&1023)+-384)>>0]|0,p=p+1|0,7!=(p|0);)C=C+28|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,r,x,v,J,I,G,L,K,A;g=u;u=u+288|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,q=E(5793*(a[c+192>>2]|
0)|0,w[k+96>>1]|0)|0,y=q+l|0,B=l-q-q|0,q=n-p|0,l=B+(5793*q|0)|0,H=(E(q,-11586)|0)+B|0,B=10887*(p+n|0)|0,q=8875*n|0,n=2012*p|0,p=B-n+y|0,ka=y-B+q|0,B=y-q+n|0,n=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,q=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,y=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,z=E(E(a[c+96>>2]|0,-10033)|0,w[k+48>>1]|0)|0,Q=7447*(q+n|0)|0,C=3962*(y+n|0)|0,r=Q-z+C|0,x=11409*(q-y|0)|0,v=z-x+Q|0,Q=x+z+C|0,C=10033*(n-q-y|0)|0,a[d>>2]=r+p>>11,a[d+256>>2]=p-r>>11,a[d+32>>2]=C+l>>11,a[d+224>>2]=l-C>>11,a[d+64>>2]=v+ka>>11,
a[d+192>>2]=ka-v>>11,a[d+96>>2]=Q+B>>11,a[d+160>>2]=B-Q>>11,a[d+128>>2]=H>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+8|0;c=f+1|0;k=f+7|0;b=f+2|0;H=f+6|0;Q=f+3|0;B=f+5|0;v=f+4|0;ka=0;for(C=h;h=a[e+(ka<<2)>>2]|0,l=(a[C>>2]<<13)+134348800|0,r=a[C+8>>2]|0,p=a[C+16>>2]|0,y=5793*(a[C+24>>2]|0)|0,q=y+l|0,n=l-y-y|0,y=r-p|0,l=n+(5793*y|0)|0,z=(E(y,-11586)|0)+n|0,n=10887*(p+r|0)|0,y=8875*r|0,r=2012*p|0,p=n-r+q|0,x=q-n+y|0,n=q-y+r|0,r=a[C+4>>2]|0,y=a[C+20>>2]|0,q=a[C+28>>2]|0,J=E(a[C+12>>2]|0,-10033)|
0,I=7447*(y+r|0)|0,G=3962*(q+r|0)|0,L=I-J+G|0,K=11409*(y-q|0)|0,A=J-K+I|0,I=K+J+G|0,G=10033*(r-y-q|0)|0,t[h+f>>0]=t[m+(((L+p|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((p-L|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((G+l|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((l-G|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((A+x|0)>>>18&1023)+-384)>>0]|0,t[h+H>>0]=t[m+(((x-A|0)>>>18&1023)+-384)>>0]|0,t[h+Q>>0]=t[m+(((I+n|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((n-I|0)>>>18&1023)+-384)>>0]|0,t[h+v>>0]=t[m+((z>>>18&
1023)+-384)>>0]|0,ka=ka+1|0,9!=(ka|0);)C=C+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,ka,z,Q,C,r,x,v,J,I,G,L,K,A;g=u;u=u+320|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,p=(9373*n|0)+l|0,q=l+(E(n,-3580)|0)|0,y=l+(E(n,-11586)|0)>>11,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,l=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,B=6810*(l+n|0)|0,H=B+(4209*n|0)|0,n=B+(E(l,-17828)|0)|0,l=H+p|0,B=p-H|0,H=n+q|0,p=q-n|0,n=E(w[k+
16>>1]|0,a[c+32>>2]|0)|0,q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,ka=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,z=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,Q=z+q|0,C=q-z|0,z=2531*C|0,q=ka<<13,r=7791*Q|0,x=z+q|0,v=r+(11443*n|0)+x|0,J=(1812*n|0)-r+x|0,x=4815*Q|0,Q=q-z-(C<<12)|0,z=n-ka-C<<2,C=(10323*n|0)-x-Q|0,ka=Q+((5260*n|0)-x)|0,a[d>>2]=v+l>>11,a[d+288>>2]=l-v>>11,a[d+32>>2]=C+H>>11,a[d+256>>2]=H-C>>11,a[d+64>>2]=z+y,a[d+224>>2]=y-z,a[d+96>>2]=ka+p>>11,a[d+192>>2]=p-ka>>11,a[d+128>>2]=J+B>>11,a[d+160>>2]=B-J>>11,b=b+1|0,8!=
(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+9|0;c=f+1|0;k=f+8|0;b=f+2|0;J=f+7|0;B=f+3|0;ka=f+6|0;p=f+4|0;z=f+5|0;y=0;for(C=h;h=a[e+(y<<2)>>2]|0,H=(a[C>>2]<<13)+134348800|0,v=a[C+16>>2]|0,l=H+(9373*v|0)|0,x=H+(E(v,-3580)|0)|0,n=H+(E(v,-11586)|0)|0,v=a[C+8>>2]|0,H=a[C+24>>2]|0,Q=6810*(H+v|0)|0,q=Q+(4209*v|0)|0,v=Q+(E(H,-17828)|0)|0,H=q+l|0,Q=l-q|0,q=v+x|0,l=x-v|0,v=a[C+4>>2]|0,x=a[C+12>>2]|0,r=a[C+20>>2]<<13,I=a[C+28>>2]|0,G=I+x|0,L=x-I|0,I=2531*L|0,x=7791*G|0,K=I+r|0,A=x+(11443*v|0)+K|0,x=(1812*v|0)-x+K|0,
K=4815*G|0,G=r-I-(L<<12)|0,I=(v-L<<13)-r|0,r=(10323*v|0)-K-G|0,L=G+((5260*v|0)-K)|0,t[h+f>>0]=t[m+(((A+H|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((H-A|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((r+q|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((q-r|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((I+n|0)>>>18&1023)+-384)>>0]|0,t[h+J>>0]=t[m+(((n-I|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((L+l|0)>>>18&1023)+-384)>>0]|0,t[h+ka>>0]=t[m+(((l-L|0)>>>18&1023)+-384)>>0]|0,t[h+p>>0]=t[m+(((x+Q|0)>>>18&1023)+-384)>>
0]|0,t[h+z>>0]=t[m+(((Q-x|0)>>>18&1023)+-384)>>0]|0,y=y+1|0,10!=(y|0);)C=C+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T;g=u;u=u+352|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,q=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,y=20862*(p-q|0)|0,B=3529*(p-n|0)|0,H=q+n|0,r=H-p|0,z=(11116*r|0)+l|0,Q=B+y+z+(E(p,-14924)|0)|0,C=y+(17333*q|0)+z|0,y=z+
(E(n,-12399)|0)+B|0,B=z+(E(H,-9467)|0)|0,H=B+(E(q,-6461)|0)|0,q=B+((15929*p|0)+(E(n,-11395)|0))|0,n=l+(E(r,-11585)|0)|0,r=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,l=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,p=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,B=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,z=l+r|0,x=3264*(p+z+B|0)|0,V=7274*z|0,z=5492*(p+r|0)|0,v=x+(3E3*(B+r|0)|0)|0,J=V+z+v+(E(r,-7562)|0)|0,r=x+(E(p+l|0,-9527)|0)|0,I=r+(E(p,-9766)|0)+z|0,z=E(B+l|0,-14731)|0,G=V+(16984*l|0)+z+r|0,r=z+(17223*B|0)+v|0,v=x+((E(l,-12019)|0)+(8203*p|0)+(E(B,
-13802)|0))|0,a[d>>2]=J+C>>11,a[d+320>>2]=C-J>>11,a[d+32>>2]=G+Q>>11,a[d+288>>2]=Q-G>>11,a[d+64>>2]=I+H>>11,a[d+256>>2]=H-I>>11,a[d+96>>2]=r+y>>11,a[d+224>>2]=y-r>>11,a[d+128>>2]=v+q>>11,a[d+192>>2]=q-v>>11,a[d+160>>2]=n>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+10|0;c=f+1|0;k=f+9|0;b=f+2|0;n=f+8|0;v=f+3|0;q=f+7|0;r=f+4|0;y=f+6|0;I=f+5|0;H=0;for(G=h;h=a[e+(H<<2)>>2]|0,Q=(a[G>>2]<<13)+134348800|0,J=a[G+8>>2]|0,C=a[G+16>>2]|0,B=a[G+24>>2]|0,p=20862*(C-B|0)|0,l=3529*(C-J|0)|0,x=B+J|0,z=x-C|0,
V=(11116*z|0)+Q|0,L=l+p+V+(E(C,-14924)|0)|0,K=p+(17333*B|0)+V|0,p=V+(E(J,-12399)|0)+l|0,l=V+(E(x,-9467)|0)|0,x=l+(E(B,-6461)|0)|0,B=l+((15929*C|0)+(E(J,-11395)|0))|0,J=Q+(E(z,-11585)|0)|0,z=a[G+4>>2]|0,Q=a[G+12>>2]|0,C=a[G+20>>2]|0,l=a[G+28>>2]|0,V=Q+z|0,A=3264*(V+C+l|0)|0,D=7274*V|0,V=5492*(C+z|0)|0,O=A+(3E3*(l+z|0)|0)|0,M=D+V+O+(E(z,-7562)|0)|0,z=A+(E(C+Q|0,-9527)|0)|0,T=z+(E(C,-9766)|0)+V|0,V=E(l+Q|0,-14731)|0,D=D+(16984*Q|0)+V+z|0,z=V+(17223*l|0)+O|0,O=A+((E(Q,-12019)|0)+(8203*C|0)+(E(l,-13802)|
0))|0,t[h+f>>0]=t[m+(((M+K|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((K-M|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((D+L|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((L-D|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((T+x|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((x-T|0)>>>18&1023)+-384)>>0]|0,t[h+v>>0]=t[m+(((z+p|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((p-z|0)>>>18&1023)+-384)>>0]|0,t[h+r>>0]=t[m+(((O+B|0)>>>18&1023)+-384)>>0]|0,t[h+y>>0]=t[m+(((B-O|0)>>>18&1023)+-384)>>0]|0,t[h+I>>0]=t[m+((J>>>18&1023)+
-384)>>0]|0,H=H+1|0,11!=(H|0);)G=G+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T,X,P;g=u;u=u+384|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(10033*(a[c+128>>2]|0)|0,w[k+64>>1]|0)|0,p=n+l|0,q=l-n|0,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,y=E(a[c+192>>2]<<13,w[k+96>>1]|0)|0,B=(n<<13)-y|0,H=B+l|0,r=l-B|0,B=y+(11190*n|0)|0,l=B+p|0,z=p-B|0,B=(2998*n|0)-y|0,y=B+q|0,n=q-B|0,B=E(w[k+16>>1]|0,a[c+32>>2]|0)|
0,q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,p=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,Q=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,C=10703*q|0,x=E(q,-4433)|0,V=p+B|0,v=7053*(Q+V|0)|0,J=v+(2139*V|0)|0,V=C+(2295*B|0)+J|0,I=E(Q+p|0,-8565)|0,G=x+I+(E(p,-12112)|0)+J|0,J=(12998*Q|0)-C+v+I|0,I=v+((E(B,-5540)|0)+x+(E(Q,-16244)|0))|0,x=B-Q|0,Q=q-p|0,p=4433*(x+Q|0)|0,q=p+(6270*x|0)|0,x=p+(E(Q,-15137)|0)|0,a[d>>2]=V+l>>11,a[d+352>>2]=l-V>>11,a[d+32>>2]=q+H>>11,a[d+320>>2]=H-q>>11,a[d+64>>2]=G+y>>11,a[d+288>>2]=y-G>>11,a[d+96>>2]=J+n>>
11,a[d+256>>2]=n-J>>11,a[d+128>>2]=x+r>>11,a[d+224>>2]=r-x>>11,a[d+160>>2]=I+z>>11,a[d+192>>2]=z-I>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+11|0;c=f+1|0;k=f+10|0;b=f+2|0;I=f+9|0;z=f+3|0;x=f+8|0;r=f+4|0;J=f+7|0;n=f+5|0;G=f+6|0;y=0;for(q=h;h=a[e+(y<<2)>>2]|0,H=(a[q>>2]<<13)+134348800|0,V=10033*(a[q+16>>2]|0)|0,l=H+V|0,Q=H-V|0,V=a[q+8>>2]|0,p=a[q+24>>2]<<13,B=(V<<13)-p|0,v=B+H|0,C=H-B|0,B=p+(11190*V|0)|0,H=B+l|0,L=l-B|0,B=(2998*V|0)-p|0,p=B+Q|0,V=Q-B|0,B=a[q+4>>2]|0,Q=a[q+12>>2]|0,l=a[q+20>>
2]|0,K=a[q+28>>2]|0,A=10703*Q|0,D=E(Q,-4433)|0,O=l+B|0,M=7053*(O+K|0)|0,T=M+(2139*O|0)|0,O=A+(2295*B|0)+T|0,X=E(K+l|0,-8565)|0,P=D+X+(E(l,-12112)|0)+T|0,T=(12998*K|0)-A+M+X|0,X=M+((E(B,-5540)|0)+D+(E(K,-16244)|0))|0,D=B-K|0,K=Q-l|0,l=4433*(D+K|0)|0,Q=l+(6270*D|0)|0,D=l+(E(K,-15137)|0)|0,t[h+f>>0]=t[m+(((O+H|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((H-O|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((Q+v|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((v-Q|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((P+p|0)>>>
18&1023)+-384)>>0]|0,t[h+I>>0]=t[m+(((p-P|0)>>>18&1023)+-384)>>0]|0,t[h+z>>0]=t[m+(((T+V|0)>>>18&1023)+-384)>>0]|0,t[h+x>>0]=t[m+(((V-T|0)>>>18&1023)+-384)>>0]|0,t[h+r>>0]=t[m+(((D+C|0)>>>18&1023)+-384)>>0]|0,t[h+J>>0]=t[m+(((C-D|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((X+L|0)>>>18&1023)+-384)>>0]|0,t[h+G>>0]=t[m+(((L-X|0)>>>18&1023)+-384)>>0]|0,y=y+1|0,12!=(y|0);)q=q+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T,X,P,Oa,F,N,ba,R;g=u;u=u+416|
0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,q=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,y=q+p|0,B=p-q|0,q=9465*y|0,p=(793*B|0)+l|0,H=q+(11249*n|0)+p|0,r=(4108*n|0)-q+p|0,p=2592*y|0,q=(3989*B|0)+l|0,z=(8672*n|0)-p+q|0,Q=p+(E(n,-10258)|0)+q|0,q=3570*y|0,y=l+(E(B,-7678)|0)|0,p=(E(n,-1396)|0)-q+y|0,C=q+(E(n,-6581)|0)+y|0,y=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,x=E(w[k+
80>>1]|0,a[c+160>>2]|0)|0,V=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,v=10832*(q+y|0)|0,J=9534*(x+y|0)|0,I=V+y|0,G=7682*I|0,L=v+J+G+(E(y,-16549)|0)|0,K=E(x+q|0,-2773)|0,A=E(V+q|0,-9534)|0,D=v+(6859*q|0)+K+A|0,v=E(V+x|0,-5384)|0,O=K+(E(x,-12879)|0)+J+v|0,J=A+(18068*V|0)+G+v|0,v=2773*I|0,I=7682*(x-q|0)|0,G=(2611*y|0)+v+(E(q,-3818)|0)+I|0,q=v+((3150*x|0)+I+(E(V,-14273)|0))|0,a[d>>2]=L+H>>11,a[d+384>>2]=H-L>>11,a[d+32>>2]=D+z>>11,a[d+352>>2]=z-D>>11,a[d+64>>2]=O+r>>11,a[d+320>>2]=r-O>>11,a[d+96>>2]=J+p>>11,a[d+
288>>2]=p-J>>11,a[d+128>>2]=G+C>>11,a[d+256>>2]=C-G>>11,a[d+160>>2]=q+Q>>11,a[d+224>>2]=Q-q>>11,a[d+192>>2]=(11585*(B-n|0)|0)+l>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+12|0;c=f+1|0;k=f+11|0;b=f+2|0;l=f+10|0;n=f+3|0;B=f+9|0;q=f+4|0;Q=f+8|0;G=f+5|0;C=f+7|0;J=f+6|0;p=0;for(O=h;h=a[e+(p<<2)>>2]|0,r=(a[O>>2]<<13)+134348800|0,D=a[O+8>>2]|0,z=a[O+16>>2]|0,L=a[O+24>>2]|0,H=L+z|0,V=z-L|0,L=9465*H|0,z=(793*V|0)+r|0,I=L+(11249*D|0)+z|0,x=(4108*D|0)-L+z|0,z=2592*H|0,L=(3989*V|0)+r|0,v=(8672*D|0)-z+
L|0,y=z+(E(D,-10258)|0)+L|0,L=3570*H|0,H=r+(E(V,-7678)|0)|0,z=(E(D,-1396)|0)-L+H|0,A=L+(E(D,-6581)|0)+H|0,H=a[O+4>>2]|0,L=a[O+12>>2]|0,K=a[O+20>>2]|0,M=a[O+28>>2]|0,T=10832*(L+H|0)|0,X=9534*(K+H|0)|0,P=M+H|0,Oa=7682*P|0,F=T+X+Oa+(E(H,-16549)|0)|0,N=E(K+L|0,-2773)|0,ba=E(M+L|0,-9534)|0,R=T+(6859*L|0)+N+ba|0,T=E(M+K|0,-5384)|0,N=N+(E(K,-12879)|0)+X+T|0,X=ba+(18068*M|0)+Oa+T|0,T=2773*P|0,P=7682*(K-L|0)|0,Oa=(2611*H|0)+T+(E(L,-3818)|0)+P|0,L=(3150*K|0)+P+(E(M,-14273)|0)+T|0,t[h+f>>0]=t[m+(((F+I|0)>>>
18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((I-F|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((R+v|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((v-R|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((N+x|0)>>>18&1023)+-384)>>0]|0,t[h+l>>0]=t[m+(((x-N|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((X+z|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((z-X|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((Oa+A|0)>>>18&1023)+-384)>>0]|0,t[h+Q>>0]=t[m+(((A-Oa|0)>>>18&1023)+-384)>>0]|0,t[h+G>>0]=t[m+(((L+y|0)>>>18&1023)+-384)>>0]|0,t[h+C>>0]=
t[m+(((y-L|0)>>>18&1023)+-384)>>0]|0,t[h+J>>0]=t[m+((((11585*(V-D|0)|0)+r|0)>>>18&1023)+-384)>>0]|0,p=p+1|0,13!=(p|0);)O=O+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T,X,P,Oa,F,N,ba;g=u;u=u+448|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,p=(10438*n|0)+l|0,q=(2578*n|0)+l|0,y=l+(E(n,-7223)|0)|0,B=l+(E(n,-11586)|0)>>11,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,l=E(w[k+96>>
1]|0,a[c+192>>2]|0)|0,H=9058*(l+n|0)|0,r=H+(2237*n|0)|0,z=H+(E(l,-14084)|0)|0,H=(5027*n|0)+(E(l,-11295)|0)|0,l=r+p|0,n=p-r|0,r=z+q|0,p=q-z|0,z=H+y|0,q=y-H|0,H=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,y=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,Q=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,C=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,x=C<<13,V=Q+H|0,v=10935*(y+H|0)|0,J=9810*V|0,I=v+J+x+(E(H,-9232)|0)|0,G=6164*V|0,V=H-y|0,L=(3826*V|0)-x|0,K=L+(G+(E(H,-8693)|0))|0,H=(E(Q+y|0,-1297)|0)-x|0,A=H+(E(y,-3474)|0)+v|0,v=H+(E(Q,-19447)|0)+J|0,J=11512*
(Q-y|0)|0,H=J+x+(E(Q,-13850)|0)+G|0,G=J+(5529*y|0)+L|0,L=V-Q+C<<2,a[d>>2]=I+l>>11,a[d+416>>2]=l-I>>11,a[d+32>>2]=A+r>>11,a[d+384>>2]=r-A>>11,a[d+64>>2]=v+z>>11,a[d+352>>2]=z-v>>11,a[d+96>>2]=L+B,a[d+320>>2]=B-L,a[d+128>>2]=H+q>>11,a[d+288>>2]=q-H>>11,a[d+160>>2]=G+p>>11,a[d+256>>2]=p-G>>11,a[d+192>>2]=K+n>>11,a[d+224>>2]=n-K>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+13|0;c=f+1|0;k=f+12|0;b=f+2|0;K=f+11|0;n=f+3|0;G=f+10|0;p=f+4|0;H=f+9|0;q=f+5|0;L=f+8|0;B=f+6|0;v=f+7|0;z=0;for(A=h;h=a[e+(z<<
2)>>2]|0,r=(a[A>>2]<<13)+134348800|0,I=a[A+16>>2]|0,l=r+(10438*I|0)|0,C=r+(2578*I|0)|0,Q=r+(E(I,-7223)|0)|0,V=r+(E(I,-11586)|0)|0,I=a[A+8>>2]|0,r=a[A+24>>2]|0,y=9058*(r+I|0)|0,J=y+(2237*I|0)|0,x=y+(E(r,-14084)|0)|0,y=(5027*I|0)+(E(r,-11295)|0)|0,r=J+l|0,I=l-J|0,J=x+C|0,l=C-x|0,x=y+Q|0,C=Q-y|0,y=a[A+4>>2]|0,Q=a[A+12>>2]|0,D=a[A+20>>2]|0,O=a[A+28>>2]<<13,M=D+y|0,T=10935*(Q+y|0)|0,X=9810*M|0,P=O+(T+X)+(E(y,-9232)|0)|0,Oa=6164*M|0,M=y-Q|0,F=(3826*M|0)-O|0,N=Oa+(E(y,-8693)|0)+F|0,y=(E(D+Q|0,-1297)|0)-
O|0,ba=y+(E(Q,-3474)|0)+T|0,T=y+(E(D,-19447)|0)+X|0,X=11512*(D-Q|0)|0,y=X+O+(E(D,-13850)|0)+Oa|0,Oa=X+(5529*Q|0)+F|0,F=(M-D<<13)+O|0,t[h+f>>0]=t[m+(((P+r|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((r-P|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((ba+J|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((J-ba|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((T+x|0)>>>18&1023)+-384)>>0]|0,t[h+K>>0]=t[m+(((x-T|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((F+V|0)>>>18&1023)+-384)>>0]|0,t[h+G>>0]=t[m+(((V-F|0)>>>18&1023)+-384)>>
0]|0,t[h+p>>0]=t[m+(((y+C|0)>>>18&1023)+-384)>>0]|0,t[h+H>>0]=t[m+(((C-y|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((Oa+l|0)>>>18&1023)+-384)>>0]|0,t[h+L>>0]=t[m+(((l-Oa|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((N+I|0)>>>18&1023)+-384)>>0]|0,t[h+v>>0]=t[m+(((I-N|0)>>>18&1023)+-384)>>0]|0,z=z+1|0,14!=(z|0);)A=A+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T,X,P,Oa,F,N,ba,R;g=u;u=u+480|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=
h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,q=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,y=l+(E(q,-3580)|0)|0,B=(9373*q|0)+l|0,H=l+(E(q,-11586)|0)|0,q=n-p|0,l=p+n|0,p=10958*l|0,r=374*q|0,z=11795*n|0,n=r+p+B|0,Q=z-p+r+y|0,r=4482*l|0,p=E(q,-3271)|0,C=B-r+p|0,x=r-z+p+y|0,p=6476*l|0,l=2896*q|0,z=l+p+y|0,y=B-p+l|0,l=H+(5792*q|0)|0,p=(E(q,-11584)|0)+H|0,H=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,B=E(10033*(a[c+160>>2]|0)|0,w[k+80>>1]|
0)|0,r=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,V=q-r|0,v=6810*(V+H|0)|0,J=v+(4209*H|0)|0,I=v+(E(V,-17828)|0)|0,V=E(q,-6810)|0,v=E(q,-11018)|0,q=H-r|0,G=(11522*q|0)+B|0,L=(20131*r|0)-v+G|0,K=G+(E(H,-9113)|0)+V|0,G=(10033*q|0)-B|0,q=4712*(r+H|0)|0,A=V+(3897*H|0)-B+q|0,H=B+v+(E(r,-7121)|0)+q|0,a[d>>2]=L+n>>11,a[d+448>>2]=n-L>>11,a[d+32>>2]=J+z>>11,a[d+416>>2]=z-J>>11,a[d+64>>2]=G+l>>11,a[d+384>>2]=l-G>>11,a[d+96>>2]=A+Q>>11,a[d+352>>2]=Q-A>>11,a[d+128>>2]=I+y>>11,a[d+320>>2]=y-I>>11,a[d+160>>2]=H+C>>11,a[d+
288>>2]=C-H>>11,a[d+192>>2]=K+x>>11,a[d+256>>2]=x-K>>11,a[d+224>>2]=p>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+14|0;c=f+1|0;k=f+13|0;b=f+2|0;p=f+12|0;K=f+3|0;x=f+11|0;H=f+4|0;C=f+10|0;I=f+5|0;y=f+9|0;A=f+6|0;Q=f+8|0;G=f+7|0;l=0;for(J=h;h=a[e+(l<<2)>>2]|0,z=(a[J>>2]<<13)+134348800|0,L=a[J+8>>2]|0,n=a[J+16>>2]|0,q=a[J+24>>2]|0,r=z+(E(q,-3580)|0)|0,v=(9373*q|0)+z|0,B=z+(E(q,-11586)|0)|0,q=L-n|0,z=n+L|0,n=10958*z|0,V=374*q|0,D=11795*L|0,L=V+n+v|0,O=D-n+V+r|0,V=4482*z|0,n=E(q,-3271)|0,M=v-V+n|
0,T=V-D+n+r|0,n=6476*z|0,z=2896*q|0,D=z+n+r|0,r=v-n+z|0,z=B+(5792*q|0)|0,n=(E(q,-11584)|0)+B|0,B=a[J+4>>2]|0,q=a[J+12>>2]|0,v=10033*(a[J+20>>2]|0)|0,V=a[J+28>>2]|0,X=q-V|0,P=6810*(X+B|0)|0,Oa=P+(4209*B|0)|0,F=P+(E(X,-17828)|0)|0,X=E(q,-6810)|0,P=E(q,-11018)|0,q=B-V|0,N=(11522*q|0)+v|0,ba=(20131*V|0)-P+N|0,R=N+(E(B,-9113)|0)+X|0,N=(10033*q|0)-v|0,q=4712*(V+B|0)|0,X=X+(3897*B|0)-v+q|0,B=v+P+(E(V,-7121)|0)+q|0,t[h+f>>0]=t[m+(((ba+L|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((L-ba|0)>>>18&1023)+-384)>>
0]|0,t[h+c>>0]=t[m+(((Oa+D|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((D-Oa|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((N+z|0)>>>18&1023)+-384)>>0]|0,t[h+p>>0]=t[m+(((z-N|0)>>>18&1023)+-384)>>0]|0,t[h+K>>0]=t[m+(((X+O|0)>>>18&1023)+-384)>>0]|0,t[h+x>>0]=t[m+(((O-X|0)>>>18&1023)+-384)>>0]|0,t[h+H>>0]=t[m+(((F+r|0)>>>18&1023)+-384)>>0]|0,t[h+C>>0]=t[m+(((r-F|0)>>>18&1023)+-384)>>0]|0,t[h+I>>0]=t[m+(((B+M|0)>>>18&1023)+-384)>>0]|0,t[h+y>>0]=t[m+(((M-B|0)>>>18&1023)+-384)>>0]|0,t[h+A>>0]=t[m+(((R+T|0)>>>
18&1023)+-384)>>0]|0,t[h+Q>>0]=t[m+(((T-R|0)>>>18&1023)+-384)>>0]|0,t[h+G>>0]=t[m+((n>>>18&1023)+-384)>>0]|0,l=l+1|0,15!=(l|0);)J=J+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T,X,P,Oa,F,N,ba,R,S,Y,ga,Ha,ma,W;g=u;u=u+512|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,p=10703*n|0,q=4433*n|0,n=p+l|0,y=l-p|0,p=q+l|0,B=l-q|0,q=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,l=E(w[k+96>>
1]|0,a[c+192>>2]|0)|0,H=q-l|0,r=2260*H|0,z=11363*H|0,H=z+(20995*l|0)|0,Q=r+(7373*q|0)|0,C=z+(E(q,-4926)|0)|0,q=r+(E(l,-4176)|0)|0,l=H+n|0,r=n-H|0,H=Q+p|0,n=p-Q|0,Q=C+B|0,p=B-C|0,C=q+y|0,B=y-q|0,q=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,y=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,z=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,x=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,V=z+q|0,v=11086*(y+q|0)|0,J=10217*V|0,I=8956*(x+q|0)|0,G=7350*(q-x|0)|0,L=5461*V|0,V=3363*(q-y|0)|0,K=v+J+I+(E(q,-18730)|0)|0,A=V+(L+G)+(E(q,-15038)|0)|0,q=1136*(z+y|0)|0,D=
11529*(z-y|0)|0,O=x+y|0,M=E(O,-5461)|0,T=v+(589*y|0)+q+M|0,v=E(O,-10217)|0,O=V+(16154*y|0)+D+v|0,y=E(x+z|0,-11086)|0,V=q+(E(z,-9222)|0)+J+y|0,J=M+(8728*x|0)+I+y|0,y=3363*(x-z|0)|0,I=v+(25733*x|0)+G+y|0,G=D+(E(z,-6278)|0)+L+y|0,a[d>>2]=K+l>>11,a[d+480>>2]=l-K>>11,a[d+32>>2]=T+H>>11,a[d+448>>2]=H-T>>11,a[d+64>>2]=V+Q>>11,a[d+416>>2]=Q-V>>11,a[d+96>>2]=J+C>>11,a[d+384>>2]=C-J>>11,a[d+128>>2]=I+B>>11,a[d+352>>2]=B-I>>11,a[d+160>>2]=G+p>>11,a[d+320>>2]=p-G>>11,a[d+192>>2]=O+n>>11,a[d+288>>2]=n-O>>11,a[d+
224>>2]=A+r>>11,a[d+256>>2]=r-A>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+15|0;c=f+1|0;k=f+14|0;b=f+2|0;A=f+13|0;r=f+3|0;O=f+12|0;n=f+4|0;G=f+11|0;p=f+5|0;I=f+10|0;B=f+6|0;J=f+9|0;C=f+7|0;V=f+8|0;Q=0;for(T=h;h=a[e+(Q<<2)>>2]|0,H=(a[T>>2]<<13)+134348800|0,K=a[T+16>>2]|0,l=10703*K|0,y=4433*K|0,K=H+l|0,L=H-l|0,l=H+y|0,z=H-y|0,y=a[T+8>>2]|0,H=a[T+24>>2]|0,D=y-H|0,x=2260*D|0,v=11363*D|0,D=v+(20995*H|0)|0,M=x+(7373*y|0)|0,q=v+(E(y,-4926)|0)|0,y=x+(E(H,-4176)|0)|0,H=D+K|0,x=K-D|0,D=M+l|0,K=l-M|0,
M=q+z|0,l=z-q|0,q=y+L|0,z=L-y|0,y=a[T+4>>2]|0,L=a[T+12>>2]|0,v=a[T+20>>2]|0,X=a[T+28>>2]|0,P=v+y|0,Oa=11086*(L+y|0)|0,F=10217*P|0,N=8956*(X+y|0)|0,ba=7350*(y-X|0)|0,R=5461*P|0,P=3363*(y-L|0)|0,S=Oa+F+N+(E(y,-18730)|0)|0,Y=P+(R+ba)+(E(y,-15038)|0)|0,y=1136*(v+L|0)|0,ga=11529*(v-L|0)|0,Ha=X+L|0,ma=E(Ha,-5461)|0,W=Oa+(589*L|0)+y+ma|0,Oa=E(Ha,-10217)|0,Ha=P+(16154*L|0)+ga+Oa|0,L=E(X+v|0,-11086)|0,P=y+(E(v,-9222)|0)+F+L|0,F=ma+(8728*X|0)+N+L|0,L=3363*(X-v|0)|0,N=Oa+(25733*X|0)+ba+L|0,ba=ga+(E(v,-6278)|
0)+R+L|0,t[h+f>>0]=t[m+(((S+H|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((H-S|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((W+D|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((D-W|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((P+M|0)>>>18&1023)+-384)>>0]|0,t[h+A>>0]=t[m+(((M-P|0)>>>18&1023)+-384)>>0]|0,t[h+r>>0]=t[m+(((F+q|0)>>>18&1023)+-384)>>0]|0,t[h+O>>0]=t[m+(((q-F|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((N+z|0)>>>18&1023)+-384)>>0]|0,t[h+G>>0]=t[m+(((z-N|0)>>>18&1023)+-384)>>0]|0,t[h+p>>0]=t[m+(((ba+l|
0)>>>18&1023)+-384)>>0]|0,t[h+I>>0]=t[m+(((l-ba|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((Ha+K|0)>>>18&1023)+-384)>>0]|0,t[h+J>>0]=t[m+(((K-Ha|0)>>>18&1023)+-384)>>0]|0,t[h+C>>0]=t[m+(((Y+x|0)>>>18&1023)+-384)>>0]|0,t[h+V>>0]=t[m+(((x-Y|0)>>>18&1023)+-384)>>0]|0,Q=Q+1|0,16!=(Q|0);)T=T+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q=0,y=0,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T,X,P,Oa,F,N,ba,R,S,Y,ga,Ha,ma,W;g=u;u=u+256|0;h=g;m=a[(b|0)+336>>2]|0;b=8;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;;)if(l=
w[k+16>>1]|0,n=w[k+32>>1]|0,(l|n)<<16>>16?(q=n,y=10):0==(w[k+48>>1]|0)&&0==(w[k+64>>1]|0)&&0==(w[k+80>>1]|0)&&0==(w[k+96>>1]|0)&&0==(w[k+112>>1]|0)?(p=E(a[c>>2]<<2,w[k>>1]|0)|0,a[d>>2]=p,a[d+32>>2]=p,a[d+64>>2]=p,a[d+96>>2]=p,a[d+128>>2]=p,a[d+160>>2]=p,a[d+192>>2]=p,a[d+224>>2]=p):(q=0,y=10),10==(y|0)&&(y=0,n=E(q<<16>>16,a[c+64>>2]|0)|0,p=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,B=4433*(p+n|0)|0,H=B+(6270*n|0)|0,n=B+(E(p,-15137)|0)|0,p=E(a[c+128>>2]<<13,w[k+64>>1]|0)|0,B=E(a[c>>2]<<13,w[k>>1]|0)|1024,r=p+
B|0,z=B-p|0,p=r+H|0,B=r-H|0,H=z+n|0,r=z-n|0,n=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,z=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,Q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,C=E(l<<16>>16,a[c+32>>2]|0)|0,l=Q+n|0,x=C+z|0,V=9633*(x+l|0)|0,v=V+(E(l,-16069)|0)|0,l=V+(E(x,-3196)|0)|0,x=E(C+n|0,-7373)|0,V=x+(2446*n|0)+v|0,n=x+(12299*C|0)+l|0,C=E(Q+z|0,-20995)|0,x=C+(16819*z|0)+l|0,l=C+(25172*Q|0)+v|0,a[d>>2]=n+p>>11,a[d+224>>2]=p-n>>11,a[d+32>>2]=l+H>>11,a[d+192>>2]=H-l>>11,a[d+64>>2]=x+r>>11,a[d+160>>2]=r-x>>11,a[d+96>>2]=V+B>>11,
a[d+128>>2]=B-V>>11),1<(b|0))b=b+-1|0,k=k+2|0,c=c+4|0,d=d+4|0;else break;d=f+15|0;c=f+1|0;k=f+14|0;b=f+2|0;q=f+13|0;y=f+3|0;V=f+12|0;B=f+4|0;x=f+11|0;r=f+5|0;l=f+10|0;H=f+6|0;n=f+9|0;p=f+7|0;v=f+8|0;Q=0;for(C=h;h=a[e+(Q<<2)>>2]|0,z=(a[C>>2]<<13)+134348800|0,J=a[C+16>>2]|0,I=10703*J|0,G=4433*J|0,J=z+I|0,L=z-I|0,I=z+G|0,K=z-G|0,G=a[C+8>>2]|0,z=a[C+24>>2]|0,A=G-z|0,D=2260*A|0,O=11363*A|0,A=O+(20995*z|0)|0,M=D+(7373*G|0)|0,T=O+(E(G,-4926)|0)|0,G=D+(E(z,-4176)|0)|0,z=A+J|0,D=J-A|0,A=M+I|0,J=I-M|0,M=T+
K|0,I=K-T|0,T=G+L|0,K=L-G|0,G=a[C+4>>2]|0,L=a[C+12>>2]|0,O=a[C+20>>2]|0,X=a[C+28>>2]|0,P=O+G|0,Oa=11086*(L+G|0)|0,F=10217*P|0,N=8956*(X+G|0)|0,ba=7350*(G-X|0)|0,R=5461*P|0,P=3363*(G-L|0)|0,S=Oa+F+N+(E(G,-18730)|0)|0,Y=P+(R+ba)+(E(G,-15038)|0)|0,G=1136*(O+L|0)|0,ga=11529*(O-L|0)|0,Ha=X+L|0,ma=E(Ha,-5461)|0,W=Oa+(589*L|0)+G+ma|0,Oa=E(Ha,-10217)|0,Ha=P+(16154*L|0)+ga+Oa|0,L=E(X+O|0,-11086)|0,P=G+(E(O,-9222)|0)+F+L|0,F=ma+(8728*X|0)+N+L|0,L=3363*(X-O|0)|0,N=Oa+(25733*X|0)+ba+L|0,ba=ga+(E(O,-6278)|0)+
R+L|0,t[h+f>>0]=t[m+(((S+z|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((z-S|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((W+A|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((A-W|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((P+M|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((M-P|0)>>>18&1023)+-384)>>0]|0,t[h+y>>0]=t[m+(((F+T|0)>>>18&1023)+-384)>>0]|0,t[h+V>>0]=t[m+(((T-F|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((N+K|0)>>>18&1023)+-384)>>0]|0,t[h+x>>0]=t[m+(((K-N|0)>>>18&1023)+-384)>>0]|0,t[h+r>>0]=t[m+(((ba+I|0)>>>
18&1023)+-384)>>0]|0,t[h+l>>0]=t[m+(((I-ba|0)>>>18&1023)+-384)>>0]|0,t[h+H>>0]=t[m+(((Ha+J|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((J-Ha|0)>>>18&1023)+-384)>>0]|0,t[h+p>>0]=t[m+(((Y+D|0)>>>18&1023)+-384)>>0]|0,t[h+v>>0]=t[m+(((D-Y|0)>>>18&1023)+-384)>>0]|0,Q=Q+1|0,8!=(Q|0);)C=C+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T,X,P,Oa,F,N,ba;g=u;u=u+224|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,
n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,q=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,y=7223*(p-q|0)|0,B=2578*(n-p|0)|0,H=l+(B+y)+(E(p,-15083)|0)|0,r=q+n|0,z=(10438*r|0)+l|0,Q=z+(E(q,-637)|0)+y|0,y=z+(E(n,-20239)|0)+B|0,B=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,n=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,z=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,q=7663*(n+B|0)|0,C=1395*(B-n|0)|0,x=E(z+n|0,-11295)|0,n=q+C+x|0,V=5027*(z+B|0)|0,B=V+(q-C)|0,C=V+(15326*z|0)+x|0,a[d>>2]=B+Q>>11,a[d+192>>2]=Q-B>>11,a[d+32>>2]=n+H>>11,
a[d+160>>2]=H-n>>11,a[d+64>>2]=C+y>>11,a[d+128>>2]=y-C>>11,a[d+96>>2]=(11585*(p-r|0)|0)+l>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+13|0;c=f+1|0;k=f+12|0;b=f+2|0;l=f+11|0;r=f+3|0;p=f+10|0;C=f+4|0;y=f+9|0;n=f+5|0;H=f+8|0;B=f+6|0;Q=f+7|0;x=0;for(z=h;h=a[e+(x<<2)>>2]|0,V=(a[z>>2]<<13)+134348800|0,q=a[z+16>>2]|0,v=V+(10438*q|0)|0,J=V+(2578*q|0)|0,I=V+(E(q,-7223)|0)|0,G=V+(E(q,-11586)|0)|0,q=a[z+8>>2]|0,V=a[z+24>>2]|0,L=9058*(V+q|0)|0,K=L+(2237*q|0)|0,A=L+(E(V,-14084)|0)|0,L=(5027*q|0)+(E(V,-11295)|
0)|0,V=K+v|0,q=v-K|0,K=A+J|0,v=J-A|0,A=L+I|0,J=I-L|0,L=a[z+4>>2]|0,I=a[z+12>>2]|0,D=a[z+20>>2]|0,O=a[z+28>>2]<<13,M=D+L|0,T=10935*(I+L|0)|0,X=9810*M|0,P=O+(T+X)+(E(L,-9232)|0)|0,Oa=6164*M|0,M=L-I|0,F=(3826*M|0)-O|0,N=Oa+(E(L,-8693)|0)+F|0,L=(E(D+I|0,-1297)|0)-O|0,ba=L+(E(I,-3474)|0)+T|0,T=L+(E(D,-19447)|0)+X|0,X=11512*(D-I|0)|0,L=X+O+(E(D,-13850)|0)+Oa|0,Oa=X+(5529*I|0)+F|0,F=(M-D<<13)+O|0,t[h+f>>0]=t[m+(((P+V|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((V-P|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+
(((ba+K|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((K-ba|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((T+A|0)>>>18&1023)+-384)>>0]|0,t[h+l>>0]=t[m+(((A-T|0)>>>18&1023)+-384)>>0]|0,t[h+r>>0]=t[m+(((F+G|0)>>>18&1023)+-384)>>0]|0,t[h+p>>0]=t[m+(((G-F|0)>>>18&1023)+-384)>>0]|0,t[h+C>>0]=t[m+(((L+J|0)>>>18&1023)+-384)>>0]|0,t[h+y>>0]=t[m+(((J-L|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((Oa+v|0)>>>18&1023)+-384)>>0]|0,t[h+H>>0]=t[m+(((v-Oa|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((N+q|0)>>>18&1023)+-384)>>
0]|0,t[h+Q>>0]=t[m+(((q-N|0)>>>18&1023)+-384)>>0]|0,x=x+1|0,7!=(x|0);)z=z+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T,X,P;g=u;u=u+192|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(5793*(a[c+128>>2]|0)|0,w[k+64>>1]|0)|0,p=n+l|0,q=(E(n,-2)|0)+l>>11,l=E(10033*(a[c+64>>2]|0)|0,w[k+32>>1]|0)|0,n=l+p|0,y=p-l|0,l=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,p=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,B=E(w[k+80>>1]|0,a[c+
160>>2]|0)|0,H=2998*(B+l|0)|0,r=H+(p+l<<13)|0,z=H+(B-p<<13)|0,H=l-p-B<<2,a[d>>2]=r+n>>11,a[d+160>>2]=n-r>>11,a[d+32>>2]=H+q,a[d+128>>2]=q-H,a[d+64>>2]=z+y>>11,a[d+96>>2]=y-z>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+11|0;c=f+1|0;k=f+10|0;b=f+2|0;z=f+9|0;y=f+3|0;H=f+8|0;q=f+4|0;r=f+7|0;n=f+5|0;B=f+6|0;p=0;for(l=h;h=a[e+(p<<2)>>2]|0,Q=(a[l>>2]<<13)+134348800|0,C=10033*(a[l+16>>2]|0)|0,x=Q+C|0,V=Q-C|0,C=a[l+8>>2]|0,v=a[l+24>>2]<<13,J=(C<<13)-v|0,I=J+Q|0,G=Q-J|0,J=v+(11190*C|0)|0,Q=J+x|0,L=x-
J|0,J=(2998*C|0)-v|0,v=J+V|0,C=V-J|0,J=a[l+4>>2]|0,V=a[l+12>>2]|0,x=a[l+20>>2]|0,K=a[l+28>>2]|0,A=10703*V|0,D=E(V,-4433)|0,O=x+J|0,M=7053*(O+K|0)|0,T=M+(2139*O|0)|0,O=A+(2295*J|0)+T|0,X=E(K+x|0,-8565)|0,P=D+X+(E(x,-12112)|0)+T|0,T=(12998*K|0)-A+M+X|0,X=M+((E(J,-5540)|0)+D+(E(K,-16244)|0))|0,D=J-K|0,K=V-x|0,x=4433*(D+K|0)|0,V=x+(6270*D|0)|0,D=x+(E(K,-15137)|0)|0,t[h+f>>0]=t[m+(((O+Q|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((Q-O|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((V+I|0)>>>18&1023)+-384)>>0]|
0,t[h+k>>0]=t[m+(((I-V|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((P+v|0)>>>18&1023)+-384)>>0]|0,t[h+z>>0]=t[m+(((v-P|0)>>>18&1023)+-384)>>0]|0,t[h+y>>0]=t[m+(((T+C|0)>>>18&1023)+-384)>>0]|0,t[h+H>>0]=t[m+(((C-T|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((D+G|0)>>>18&1023)+-384)>>0]|0,t[h+r>>0]=t[m+(((G-D|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((X+L|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((L-X|0)>>>18&1023)+-384)>>0]|0,p=p+1|0,6!=(p|0);)l=l+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,
n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A;g=u;u=u+160|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,q=6476*(p+n|0)|0,y=n-p|0,p=(2896*y|0)+l|0,n=p+q|0,B=p-q|0,q=l+(E(y,-11584)|0)|0,y=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,l=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,p=6810*(l+y|0)|0,H=p+(4209*y|0)|0,y=p+(E(l,-17828)|0)|0,a[d>>2]=H+n>>11,a[d+128>>2]=n-H>>11,a[d+32>>2]=y+B>>11,a[d+96>>2]=B-y>>11,a[d+64>>2]=q>>
11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+9|0;c=f+1|0;k=f+8|0;b=f+2|0;q=f+7|0;y=f+3|0;B=f+6|0;H=f+4|0;n=f+5|0;l=0;for(p=h;h=a[e+(l<<2)>>2]|0,r=(a[p>>2]<<13)+134348800|0,z=a[p+16>>2]|0,Q=r+(9373*z|0)|0,C=r+(E(z,-3580)|0)|0,x=r+(E(z,-11586)|0)|0,z=a[p+8>>2]|0,r=a[p+24>>2]|0,V=6810*(r+z|0)|0,v=V+(4209*z|0)|0,z=V+(E(r,-17828)|0)|0,r=v+Q|0,V=Q-v|0,v=z+C|0,Q=C-z|0,z=a[p+4>>2]|0,C=a[p+12>>2]|0,J=a[p+20>>2]<<13,I=a[p+28>>2]|0,G=I+C|0,L=C-I|0,I=2531*L|0,C=7791*G|0,K=I+J|0,A=C+(11443*z|0)+K|0,C=(1812*
z|0)-C+K|0,K=4815*G|0,G=J-I-(L<<12)|0,I=(z-L<<13)-J|0,J=(10323*z|0)-K-G|0,L=G+((5260*z|0)-K)|0,t[h+f>>0]=t[m+(((A+r|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((r-A|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((J+v|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((v-J|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((I+x|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((x-I|0)>>>18&1023)+-384)>>0]|0,t[h+y>>0]=t[m+(((L+Q|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((Q-L|0)>>>18&1023)+-384)>>0]|0,t[h+H>>0]=t[m+(((C+V|0)>>>18&1023)+
-384)>>0]|0,t[h+n>>0]=t[m+(((V-C|0)>>>18&1023)+-384)>>0]|0,l=l+1|0,5!=(l|0);)p=p+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G;g=u;u=u+128|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(w[k>>1]|0,a[c>>2]|0)|0,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,p=n+l<<2,q=l-n<<2,n=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,l=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,y=(4433*(l+n|0)|0)+1024|0,B=y+(6270*n|0)>>11,n=y+(E(l,-15137)|0)>>11,a[d>>2]=B+p,a[d+96>>2]=p-B,a[d+32>>2]=n+q,a[d+
64>>2]=q-n,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+7|0;c=f+1|0;k=f+6|0;b=f+2|0;n=f+5|0;q=f+3|0;B=f+4|0;p=0;for(l=h;h=a[e+(p<<2)>>2]|0,y=(a[l>>2]|0)+16400|0,H=a[l+16>>2]|0,r=y+H<<13,z=y-H<<13,H=a[l+8>>2]|0,y=a[l+24>>2]|0,Q=4433*(y+H|0)|0,C=Q+(6270*H|0)|0,H=Q+(E(y,-15137)|0)|0,y=C+r|0,Q=r-C|0,C=H+z|0,r=z-H|0,H=a[l+28>>2]|0,z=a[l+20>>2]|0,x=a[l+12>>2]|0,V=a[l+4>>2]|0,v=x+H|0,J=V+z|0,I=9633*(J+v|0)|0,G=I+(E(v,-16069)|0)|0,v=I+(E(J,-3196)|0)|0,J=E(V+H|0,-7373)|0,I=J+(2446*H|0)+G|0,H=J+(12299*V|0)+
v|0,V=E(x+z|0,-20995)|0,J=V+(16819*z|0)+v|0,v=V+(25172*x|0)+G|0,t[h+f>>0]=t[m+(((H+y|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((y-H|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((v+C|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((C-v|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((J+r|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+(((r-J|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((I+Q|0)>>>18&1023)+-384)>>0]|0,t[h+B>>0]=t[m+(((Q-I|0)>>>18&1023)+-384)>>0]|0,p=p+1|0,4!=(p|0);)l=l+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;
var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x;g=u;u=u+80|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(5793*(a[c+64>>2]|0)|0,w[k+32>>1]|0)|0,p=n+l|0,q=(E(n,-2)|0)+l|0,l=E(10033*(a[c+32>>2]|0)|0,w[k+16>>1]|0)|0,a[d>>2]=l+p>>11,a[d+48>>2]=p-l>>11,a[d+24>>2]=q>>11,b=b+1|0,6!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+5|0;c=f+1|0;k=f+4|0;b=f+2|0;q=f+3|0;l=0;for(p=h;h=a[e+(l<<2)>>2]|0,n=(a[p>>2]<<13)+134348800|0,y=5793*(a[p+16>>2]|0)|0,B=n+y|0,H=n-y-y|0,y=10033*(a[p+
8>>2]|0)|0,n=B+y|0,r=B-y|0,y=a[p+4>>2]|0,B=a[p+12>>2]|0,z=a[p+20>>2]|0,Q=2998*(z+y|0)|0,C=Q+(B+y<<13)|0,x=Q+(z-B<<13)|0,Q=y-B-z<<13,t[h+f>>0]=t[m+(((C+n|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((n-C|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((Q+H|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((H-Q|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((x+r|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((r-x|0)>>>18&1023)+-384)>>0]|0,l=l+1|0,3!=(l|0);)p=p+24|0;u=g},function(b,d,c,e,f){c|=0;e|=0;f|=0;var g,h,m,k,l,n,p,q,
y,B,H,r,z;g=u;u=u+32|0;h=g;m=a[(b|0)+336>>2]|0;b=a[(d|0)+84>>2]|0;d=E(w[c>>1]|0,a[b>>2]|0)|0;k=E(w[c+16>>1]|0,a[b+32>>2]|0)|0;l=k+d|0;a[h>>2]=l;n=h+16|0;a[n>>2]=d-k;k=E(w[c+2>>1]|0,a[b+4>>2]|0)|0;d=E(w[c+18>>1]|0,a[b+36>>2]|0)|0;p=d+k|0;a[h+4>>2]=p;q=k-d|0;a[h+20>>2]=q;d=E(w[c+4>>1]|0,a[b+8>>2]|0)|0;k=E(w[c+20>>1]|0,a[b+40>>2]|0)|0;y=k+d|0;a[h+8>>2]=y;B=d-k|0;a[h+24>>2]=B;k=E(w[c+6>>1]|0,a[b+12>>2]|0)|0;d=E(w[c+22>>1]|0,a[b+44>>2]|0)|0;b=d+k|0;a[h+12>>2]=b;c=k-d|0;a[h+28>>2]=c;h=f+3|0;d=f+1|0;k=f+
2|0;H=a[e>>2]|0;r=l+4100|0;l=r+y<<13;z=r-y<<13;y=4433*(b+p|0)|0;r=y+(6270*p|0)|0;p=y+(E(b,-15137)|0)|0;t[H+f>>0]=t[m+(((r+l|0)>>>16&1023)+-384)>>0]|0;t[H+h>>0]=t[m+(((l-r|0)>>>16&1023)+-384)>>0]|0;t[H+d>>0]=t[m+(((p+z|0)>>>16&1023)+-384)>>0]|0;t[H+k>>0]=t[m+(((z-p|0)>>>16&1023)+-384)>>0]|0;p=a[e+4>>2]|0;e=(a[n>>2]|0)+4100|0;n=e+B<<13;z=e-B<<13;B=4433*(c+q|0)|0;e=B+(6270*q|0)|0;q=B+(E(c,-15137)|0)|0;t[p+f>>0]=t[m+(((e+n|0)>>>16&1023)+-384)>>0]|0;t[p+h>>0]=t[m+(((n-e|0)>>>16&1023)+-384)>>0]|0;t[p+d>>
0]=t[m+(((q+z|0)>>>16&1023)+-384)>>0]|0;t[p+k>>0]=t[m+(((z-q|0)>>>16&1023)+-384)>>0]|0;u=g},function(b,d,c,e,f){c|=0;f|=0;var g;g=a[(b|0)+336>>2]|0;b=a[(d|0)+84>>2]|0;d=a[(e|0)>>2]|0;e=(E(w[c>>1]|0,a[b>>2]|0)|0)+4100|0;b=E(w[c+2>>1]|0,a[b+4>>2]|0)|0;t[d+f>>0]=t[g+(((b+e|0)>>>3&1023)+-384)>>0]|0;t[d+(f+1)>>0]=t[g+(((e-b|0)>>>3&1023)+-384)>>0]|0},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A,D,O,M,T;g=u;u=u+512|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|
0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,p=10703*n|0,q=4433*n|0,n=p+l|0,y=l-p|0,p=q+l|0,B=l-q|0,q=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,l=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,H=q-l|0,r=2260*H|0,z=11363*H|0,H=z+(20995*l|0)|0,Q=r+(7373*q|0)|0,C=z+(E(q,-4926)|0)|0,q=r+(E(l,-4176)|0)|0,l=H+n|0,r=n-H|0,H=Q+p|0,n=p-Q|0,Q=C+B|0,p=B-C|0,C=q+y|0,B=y-q|0,q=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,y=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,z=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,x=E(w[k+112>>1]|0,a[c+224>>2]|0)|
0,V=z+q|0,v=11086*(y+q|0)|0,J=10217*V|0,I=8956*(x+q|0)|0,G=7350*(q-x|0)|0,L=5461*V|0,V=3363*(q-y|0)|0,K=v+J+I+(E(q,-18730)|0)|0,A=V+(L+G)+(E(q,-15038)|0)|0,q=1136*(z+y|0)|0,D=11529*(z-y|0)|0,O=x+y|0,M=E(O,-5461)|0,T=v+(589*y|0)+q+M|0,v=E(O,-10217)|0,O=V+(16154*y|0)+D+v|0,y=E(x+z|0,-11086)|0,V=q+(E(z,-9222)|0)+J+y|0,J=M+(8728*x|0)+I+y|0,y=3363*(x-z|0)|0,I=v+(25733*x|0)+G+y|0,G=D+(E(z,-6278)|0)+L+y|0,a[d>>2]=K+l>>11,a[d+480>>2]=l-K>>11,a[d+32>>2]=T+H>>11,a[d+448>>2]=H-T>>11,a[d+64>>2]=V+Q>>11,a[d+416>>
2]=Q-V>>11,a[d+96>>2]=J+C>>11,a[d+384>>2]=C-J>>11,a[d+128>>2]=I+B>>11,a[d+352>>2]=B-I>>11,a[d+160>>2]=G+p>>11,a[d+320>>2]=p-G>>11,a[d+192>>2]=O+n>>11,a[d+288>>2]=n-O>>11,a[d+224>>2]=A+r>>11,a[d+256>>2]=r-A>>11,b=b+1|0,8!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+7|0;c=f+1|0;k=f+6|0;b=f+2|0;A=f+5|0;r=f+3|0;O=f+4|0;n=0;for(G=h;h=a[e+(n<<2)>>2]|0,p=(a[G>>2]|0)+16400|0,I=a[G+16>>2]|0,B=p+I<<13,J=p-I<<13,I=a[G+8>>2]|0,p=a[G+24>>2]|0,C=4433*(p+I|0)|0,V=C+(6270*I|0)|0,I=C+(E(p,-15137)|0)|0,p=V+B|0,C=B-V|0,V=I+
J|0,B=J-I|0,I=a[G+28>>2]|0,J=a[G+20>>2]|0,Q=a[G+12>>2]|0,T=a[G+4>>2]|0,H=Q+I|0,K=T+J|0,l=9633*(K+H|0)|0,y=l+(E(H,-16069)|0)|0,H=l+(E(K,-3196)|0)|0,K=E(T+I|0,-7373)|0,l=K+(2446*I|0)+y|0,I=K+(12299*T|0)+H|0,T=E(Q+J|0,-20995)|0,K=T+(16819*J|0)+H|0,H=T+(25172*Q|0)+y|0,t[h+f>>0]=t[m+(((I+p|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((p-I|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((H+V|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((V-H|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((K+B|0)>>>18&1023)+-384)>>0]|0,t[h+
A>>0]=t[m+(((B-K|0)>>>18&1023)+-384)>>0]|0,t[h+r>>0]=t[m+(((l+C|0)>>>18&1023)+-384)>>0]|0,t[h+O>>0]=t[m+(((C-l|0)>>>18&1023)+-384)>>0]|0,n=n+1|0,16!=(n|0);)G=G+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G,L,K,A;g=u;u=u+400|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,p=(10438*n|0)+l|0,q=(2578*n|0)+l|0,y=l+(E(n,-7223)|0)|0,B=l+(E(n,-11586)|0)>>11,n=E(w[k+32>>1]|0,a[c+64>>2]|
0)|0,l=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,H=9058*(l+n|0)|0,r=H+(2237*n|0)|0,z=H+(E(l,-14084)|0)|0,H=(5027*n|0)+(E(l,-11295)|0)|0,l=r+p|0,n=p-r|0,r=z+q|0,p=q-z|0,z=H+y|0,q=y-H|0,H=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,y=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,Q=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,C=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,x=C<<13,V=Q+H|0,v=10935*(y+H|0)|0,J=9810*V|0,I=v+J+x+(E(H,-9232)|0)|0,G=6164*V|0,V=H-y|0,L=(3826*V|0)-x|0,K=L+(G+(E(H,-8693)|0))|0,H=(E(Q+y|0,-1297)|0)-x|0,A=H+(E(y,-3474)|0)+v|0,v=H+(E(Q,-19447)|
0)+J|0,J=11512*(Q-y|0)|0,H=J+x+(E(Q,-13850)|0)+G|0,G=J+(5529*y|0)+L|0,L=V-Q+C<<2,a[d>>2]=I+l>>11,a[d+364>>2]=l-I>>11,a[d+28>>2]=A+r>>11,a[d+336>>2]=r-A>>11,a[d+56>>2]=v+z>>11,a[d+308>>2]=z-v>>11,a[d+84>>2]=L+B,a[d+280>>2]=B-L,a[d+112>>2]=H+q>>11,a[d+252>>2]=q-H>>11,a[d+140>>2]=G+p>>11,a[d+224>>2]=p-G>>11,a[d+168>>2]=K+n>>11,a[d+196>>2]=n-K>>11,b=b+1|0,7!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+6|0;c=f+1|0;k=f+5|0;b=f+2|0;K=f+4|0;n=f+3|0;G=0;for(p=h;h=a[e+(G<<2)>>2]|0,H=(a[p>>2]<<13)+134348800|0,q=a[p+
8>>2]|0,L=a[p+16>>2]|0,B=a[p+24>>2]|0,v=7223*(L-B|0)|0,z=2578*(q-L|0)|0,A=H+(z+v)+(E(L,-15083)|0)|0,r=B+q|0,I=(10438*r|0)+H|0,l=I+(E(B,-637)|0)+v|0,v=I+(E(q,-20239)|0)+z|0,z=a[p+4>>2]|0,q=a[p+12>>2]|0,I=a[p+20>>2]|0,B=7663*(q+z|0)|0,C=1395*(z-q|0)|0,Q=E(I+q|0,-11295)|0,q=B+C+Q|0,V=5027*(I+z|0)|0,z=B-C+V|0,C=V+(15326*I|0)+Q|0,t[h+f>>0]=t[m+(((z+l|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((l-z|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((q+A|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((A-q|0)>>>18&1023)+
-384)>>0]|0,t[h+b>>0]=t[m+(((C+v|0)>>>18&1023)+-384)>>0]|0,t[h+K>>0]=t[m+(((v-C|0)>>>18&1023)+-384)>>0]|0,t[h+n>>0]=t[m+((((11585*(L-r|0)|0)+H|0)>>>18&1023)+-384)>>0]|0,G=G+1|0,14!=(G|0);)p=p+28|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v,J,I,G;g=u;u=u+288|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(10033*(a[c+128>>2]|0)|0,w[k+64>>1]|0)|0,p=n+l|0,q=l-n|0,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,y=E(a[c+192>>2]<<13,w[k+
96>>1]|0)|0,B=(n<<13)-y|0,H=B+l|0,r=l-B|0,B=y+(11190*n|0)|0,l=B+p|0,z=p-B|0,B=(2998*n|0)-y|0,y=B+q|0,n=q-B|0,B=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,p=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,Q=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,C=10703*q|0,x=E(q,-4433)|0,V=p+B|0,v=7053*(Q+V|0)|0,J=v+(2139*V|0)|0,V=C+(2295*B|0)+J|0,I=E(Q+p|0,-8565)|0,G=x+I+(E(p,-12112)|0)+J|0,J=(12998*Q|0)-C+v+I|0,I=v+((E(B,-5540)|0)+x+(E(Q,-16244)|0))|0,x=B-Q|0,Q=q-p|0,p=4433*(x+Q|0)|0,q=p+(6270*x|0)|0,x=p+(E(Q,-15137)|
0)|0,a[d>>2]=V+l>>11,a[d+264>>2]=l-V>>11,a[d+24>>2]=q+H>>11,a[d+240>>2]=H-q>>11,a[d+48>>2]=G+y>>11,a[d+216>>2]=y-G>>11,a[d+72>>2]=J+n>>11,a[d+192>>2]=n-J>>11,a[d+96>>2]=x+r>>11,a[d+168>>2]=r-x>>11,a[d+120>>2]=I+z>>11,a[d+144>>2]=z-I>>11,b=b+1|0,6!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+5|0;c=f+1|0;k=f+4|0;b=f+2|0;I=f+3|0;z=0;for(x=h;h=a[e+(z<<2)>>2]|0,r=(a[x>>2]<<13)+134348800|0,J=5793*(a[x+16>>2]|0)|0,n=r+J|0,G=r-J-J|0,J=10033*(a[x+8>>2]|0)|0,r=n+J|0,y=n-J|0,J=a[x+4>>2]|0,n=a[x+12>>2]|0,q=a[x+20>>2]|
0,H=2998*(q+J|0)|0,V=H+(n+J<<13)|0,l=H+(q-n<<13)|0,H=J-n-q<<13,t[h+f>>0]=t[m+(((V+r|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((r-V|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((H+G|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((G-H|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((l+y|0)>>>18&1023)+-384)>>0]|0,t[h+I>>0]=t[m+(((y-l|0)>>>18&1023)+-384)>>0]|0,z=z+1|0,12!=(z|0);)x=x+24|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z,Q,C,x,V,v;g=u;u=u+208|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|
0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,p=(9373*n|0)+l|0,q=l+(E(n,-3580)|0)|0,y=l+(E(n,-11586)|0)>>11,n=E(w[k+32>>1]|0,a[c+64>>2]|0)|0,l=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,B=6810*(l+n|0)|0,H=B+(4209*n|0)|0,n=B+(E(l,-17828)|0)|0,l=H+p|0,B=p-H|0,H=n+q|0,p=q-n|0,n=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,r=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,z=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,Q=z+q|0,C=q-z|0,z=2531*C|0,q=r<<13,x=7791*Q|0,V=z+q|0,v=x+(11443*
n|0)+V|0,x=(1812*n|0)-x+V|0,V=4815*Q|0,Q=q-z-(C<<12)|0,z=n-r-C<<2,C=(10323*n|0)-V-Q|0,r=Q+((5260*n|0)-V)|0,a[d>>2]=v+l>>11,a[d+180>>2]=l-v>>11,a[d+20>>2]=C+H>>11,a[d+160>>2]=H-C>>11,a[d+40>>2]=z+y,a[d+140>>2]=y-z,a[d+60>>2]=r+p>>11,a[d+120>>2]=p-r>>11,a[d+80>>2]=x+B>>11,a[d+100>>2]=B-x>>11,b=b+1|0,5!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+4|0;c=f+1|0;k=f+3|0;b=f+2|0;x=0;for(B=h;h=a[e+(x<<2)>>2]|0,r=(a[B>>2]<<13)+134348800|0,p=a[B+8>>2]|0,z=a[B+16>>2]|0,y=6476*(z+p|0)|0,C=p-z|0,z=(2896*C|0)+r|0,p=z+y|
0,H=z-y|0,y=r+(E(C,-11584)|0)|0,C=a[B+4>>2]|0,r=a[B+12>>2]|0,z=6810*(r+C|0)|0,v=z+(4209*C|0)|0,C=z+(E(r,-17828)|0)|0,t[h+f>>0]=t[m+(((v+p|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((p-v|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((C+H|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((H-C|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+((y>>>18&1023)+-384)>>0]|0,x=x+1|0,10!=(x|0);)B=B+20|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q=0,y=0,B,H,r,z,Q,C,x,V,v;g=u;u=u+128|0;h=g;m=a[(b|0)+336>>2]|0;b=4;k=c|0;
c=a[(d|0)+84>>2]|0;for(d=h;;)if(l=w[k+16>>1]|0,n=w[k+32>>1]|0,(l|n)<<16>>16?(q=n,y=10):0==(w[k+48>>1]|0)&&0==(w[k+64>>1]|0)&&0==(w[k+80>>1]|0)&&0==(w[k+96>>1]|0)&&0==(w[k+112>>1]|0)?(p=E(a[c>>2]<<2,w[k>>1]|0)|0,a[d>>2]=p,a[d+16>>2]=p,a[d+32>>2]=p,a[d+48>>2]=p,a[d+64>>2]=p,a[d+80>>2]=p,a[d+96>>2]=p,a[d+112>>2]=p):(q=0,y=10),10==(y|0)&&(y=0,n=E(q<<16>>16,a[c+64>>2]|0)|0,p=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,B=4433*(p+n|0)|0,H=B+(6270*n|0)|0,n=B+(E(p,-15137)|0)|0,p=E(a[c+128>>2]<<13,w[k+64>>1]|0)|0,B=E(a[c>>
2]<<13,w[k>>1]|0)|1024,r=p+B|0,z=B-p|0,p=r+H|0,B=r-H|0,H=z+n|0,r=z-n|0,n=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,z=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,Q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,C=E(l<<16>>16,a[c+32>>2]|0)|0,l=Q+n|0,x=C+z|0,V=9633*(x+l|0)|0,v=V+(E(l,-16069)|0)|0,l=V+(E(x,-3196)|0)|0,x=E(C+n|0,-7373)|0,V=x+(2446*n|0)+v|0,n=x+(12299*C|0)+l|0,C=E(Q+z|0,-20995)|0,x=C+(16819*z|0)+l|0,l=C+(25172*Q|0)+v|0,a[d>>2]=n+p>>11,a[d+112>>2]=p-n>>11,a[d+16>>2]=l+H>>11,a[d+96>>2]=H-l>>11,a[d+32>>2]=x+r>>11,a[d+80>>2]=
r-x>>11,a[d+48>>2]=V+B>>11,a[d+64>>2]=B-V>>11),1<(b|0))b=b+-1|0,k=k+2|0,c=c+4|0,d=d+4|0;else break;d=f+3|0;c=f+1|0;k=f+2|0;b=0;for(q=h;h=a[e+(b<<2)>>2]|0,y=(a[q>>2]|0)+16400|0,V=a[q+8>>2]|0,B=y+V<<13,x=y-V<<13,V=a[q+4>>2]|0,y=a[q+12>>2]|0,r=4433*(y+V|0)|0,l=r+(6270*V|0)|0,V=r+(E(y,-15137)|0)|0,t[h+f>>0]=t[m+(((l+B|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((B-l|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((V+x|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((x-V|0)>>>18&1023)+-384)>>0]|0,b=b+1|0,8!=(b|0);)q=
q+16|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q,y,B,H,r,z;g=u;u=u+80|0;h=g;m=a[(b|0)+336>>2]|0;b=0;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;l=E(a[c>>2]<<13,w[k>>1]|0)|1024,n=E(5793*(a[c+128>>2]|0)|0,w[k+64>>1]|0)|0,p=n+l|0,q=(E(n,-2)|0)+l>>11,l=E(10033*(a[c+64>>2]|0)|0,w[k+32>>1]|0)|0,n=l+p|0,y=p-l|0,l=E(w[k+16>>1]|0,a[c+32>>2]|0)|0,p=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,B=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,H=2998*(B+l|0)|0,r=H+(p+l<<13)|0,z=H+(B-p<<13)|0,H=l-p-B<<2,a[d>>2]=r+n>>11,a[d+60>>2]=n-r>>11,
a[d+12>>2]=H+q,a[d+48>>2]=q-H,a[d+24>>2]=z+y>>11,a[d+36>>2]=y-z>>11,b=b+1|0,3!=(b|0);)k=k+2|0,c=c+4|0,d=d+4|0;d=f+2|0;c=f+1|0;k=0;for(b=h;h=a[e+(k<<2)>>2]|0,z=(a[b>>2]<<13)+134348800|0,y=a[b+8>>2]|0,H=z+(5793*y|0)|0,q=(E(y,-11586)|0)+z|0,z=10033*(a[b+4>>2]|0)|0,t[h+f>>0]=t[m+(((H+z|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((H-z|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+((q>>>18&1023)+-384)>>0]|0,k=k+1|0,6!=(k|0);)b=b+12|0;u=g},function(b,d,c,e,f){c|=0;e|=0;f|=0;var g,h,m,k,l,n,p,q;g=u;u=u+32|0;h=a[(b|
0)+336>>2]|0;b=a[(d|0)+84>>2]|0;d=E(w[c>>1]|0,a[b>>2]|0)|0;m=E(w[c+32>>1]|0,a[b+64>>2]|0)|0;k=m+d<<13;l=d-m<<13;m=E(w[c+16>>1]|0,a[b+32>>2]|0)|0;d=E(w[c+48>>1]|0,a[b+96>>2]|0)|0;n=4433*(d+m|0)|0;p=n+(6270*m|0)|0;m=n+(E(d,-15137)|0)|0;d=p+k|0;a[g>>2]=d;a[g+24>>2]=k-p;p=m+l|0;a[g+8>>2]=p;k=l-m|0;a[g+16>>2]=k;m=E(w[c+2>>1]|0,a[b+4>>2]|0)|0;l=E(w[c+34>>1]|0,a[b+68>>2]|0)|0;n=l+m<<13;q=m-l<<13;l=E(w[c+18>>1]|0,a[b+36>>2]|0)|0;m=E(w[c+50>>1]|0,a[b+100>>2]|0)|0;b=4433*(m+l|0)|0;c=b+(6270*l|0)|0;l=b+(E(m,
-15137)|0)|0;m=c+n|0;a[g+4>>2]=m;b=n-c|0;a[g+28>>2]=b;c=l+q|0;a[g+12>>2]=c;n=q-l|0;a[g+20>>2]=n;l=f+1|0;q=a[e>>2]|0;d=d+33587200|0;t[q+f>>0]=t[h+(((d+m|0)>>>16&1023)+-384)>>0]|0;t[q+l>>0]=t[h+(((d-m|0)>>>16&1023)+-384)>>0]|0;m=a[e+4>>2]|0;d=p+33587200|0;t[m+f>>0]=t[h+(((d+c|0)>>>16&1023)+-384)>>0]|0;t[m+l>>0]=t[h+(((d-c|0)>>>16&1023)+-384)>>0]|0;c=a[e+8>>2]|0;d=k+33587200|0;t[c+f>>0]=t[h+(((d+n|0)>>>16&1023)+-384)>>0]|0;t[c+l>>0]=t[h+(((d-n|0)>>>16&1023)+-384)>>0]|0;n=a[e+12>>2]|0;e=(a[g+24>>2]|0)+
33587200|0;t[n+f>>0]=t[h+(((e+b|0)>>>16&1023)+-384)>>0]|0;t[n+l>>0]=t[h+(((e-b|0)>>>16&1023)+-384)>>0]|0;u=g},function(b,d,c,e,f){c|=0;e|=0;f|=0;var g;g=a[(b|0)+336>>2]|0;b=a[(d|0)+84>>2]|0;d=(E(w[c>>1]|0,a[b>>2]|0)|0)+4100|0;b=E(w[c+16>>1]|0,a[b+32>>2]|0)|0;t[(a[e>>2]|0)+f>>0]=t[g+(((b+d|0)>>>3&1023)+-384)>>0]|0;t[(a[e+4>>2]|0)+f>>0]=t[g+(((d-b|0)>>>3&1023)+-384)>>0]|0},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q=0,y=0,B,H,r,z,Q,C,x,V,v,J=0,I,G,L,K,A;g=u;u=u+256|0;h=g;m=a[(b|0)+336>>2]|0;b=
8;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;;)if(l=w[k+16>>1]|0,n=w[k+32>>1]|0,(l|n)<<16>>16?(q=n,y=10):0==(w[k+48>>1]|0)&&0==(w[k+64>>1]|0)&&0==(w[k+80>>1]|0)&&0==(w[k+96>>1]|0)&&0==(w[k+112>>1]|0)?(p=E(a[c>>2]<<2,w[k>>1]|0)|0,a[d>>2]=p,a[d+32>>2]=p,a[d+64>>2]=p,a[d+96>>2]=p,a[d+128>>2]=p,a[d+160>>2]=p,a[d+192>>2]=p,a[d+224>>2]=p):(q=0,y=10),10==(y|0)&&(y=0,n=E(a[c+128>>2]<<13,w[k+64>>1]|0)|0,p=E(a[c>>2]<<13,w[k>>1]|0)|1024,B=n+p|0,H=p-n|0,n=E(q<<16>>16,a[c+64>>2]|0)|0,p=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,r=
4433*(p+n|0)|0,z=r+(6270*n|0)|0,n=r+(E(p,-15137)|0)|0,p=z+B|0,r=B-z|0,z=n+H|0,B=H-n|0,n=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,H=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,Q=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,C=E(l<<16>>16,a[c+32>>2]|0)|0,l=Q+n|0,x=C+H|0,V=9633*(x+l|0)|0,v=V+(E(l,-16069)|0)|0,l=V+(E(x,-3196)|0)|0,x=E(C+n|0,-7373)|0,V=x+(2446*n|0)+v|0,n=x+(12299*C|0)+l|0,C=E(Q+H|0,-20995)|0,x=C+(16819*H|0)+l|0,l=C+(25172*Q|0)+v|0,a[d>>2]=n+p>>11,a[d+224>>2]=p-n>>11,a[d+32>>2]=l+z>>11,a[d+192>>2]=z-l>>11,a[d+64>>2]=x+B>>
11,a[d+160>>2]=B-x>>11,a[d+96>>2]=V+r>>11,a[d+128>>2]=r-V>>11),1<(b|0))b=b+-1|0,k=k+2|0,c=c+4|0,d=d+4|0;else break;d=f+1|0;c=f+2|0;k=f+3|0;b=f+4|0;q=f+5|0;V=f+6|0;r=f+7|0;x=0;for(B=h;h=a[e+(x<<2)>>2]|0,l=h+f|0,z=(a[B>>2]|0)+16400|0,n=a[B+4>>2]|0,p=a[B+8>>2]|0,n|p?(J=p,y=19):0==(a[B+12>>2]|0)&&0==(a[B+16>>2]|0)&&0==(a[B+20>>2]|0)&&0==(a[B+24>>2]|0)&&0==(a[B+28>>2]|0)?(v=t[m+((z>>>5&1023)+-384)>>0]|0,t[l>>0]=v,t[h+d>>0]=v,t[h+c>>0]=v,t[h+k>>0]=v,t[h+b>>0]=v,t[h+q>>0]=v,t[h+V>>0]=v,t[h+r>>0]=v):(J=0,
y=19),19==(y|0)&&(y=0,p=a[B+16>>2]|0,v=p+z<<13,Q=z-p<<13,p=a[B+24>>2]|0,z=4433*(p+J|0)|0,C=z+(6270*J|0)|0,H=z+(E(p,-15137)|0)|0,p=C+v|0,z=v-C|0,C=H+Q|0,v=Q-H|0,H=a[B+28>>2]|0,Q=a[B+20>>2]|0,I=a[B+12>>2]|0,G=I+H|0,L=n+Q|0,K=9633*(L+G|0)|0,A=K+(E(G,-16069)|0)|0,G=K+(E(L,-3196)|0)|0,L=E(n+H|0,-7373)|0,K=L+(2446*H|0)+A|0,H=L+(12299*n|0)+G|0,n=E(I+Q|0,-20995)|0,L=n+(16819*Q|0)+G|0,G=n+(25172*I|0)+A|0,t[l>>0]=t[m+(((H+p|0)>>>18&1023)+-384)>>0]|0,t[h+r>>0]=t[m+(((p-H|0)>>>18&1023)+-384)>>0]|0,t[h+d>>0]=
t[m+(((G+C|0)>>>18&1023)+-384)>>0]|0,t[h+V>>0]=t[m+(((C-G|0)>>>18&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((L+v|0)>>>18&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((v-L|0)>>>18&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((K+z|0)>>>18&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((z-K|0)>>>18&1023)+-384)>>0]|0),x=x+1|0,8!=(x|0);)B=B+32|0;u=g},function(b,d,c,e,f){e|=0;f|=0;var g,h,m,k,l,n,p,q=0,y=0,B,H,r,z,Q,C,x,V,v=0,J,I,G,L,K;g=u;u=u+256|0;h=g;m=a[(b|0)+336>>2]|0;b=8;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;;)if(l=w[k+16>>1]|0,n=w[k+32>>1]|0,
(l|n)<<16>>16?(q=n,y=10):0==(w[k+48>>1]|0)&&0==(w[k+64>>1]|0)&&0==(w[k+80>>1]|0)&&0==(w[k+96>>1]|0)&&0==(w[k+112>>1]|0)?(p=E(w[k>>1]|0,a[c>>2]|0)|0,a[d>>2]=p,a[d+32>>2]=p,a[d+64>>2]=p,a[d+96>>2]=p,a[d+128>>2]=p,a[d+160>>2]=p,a[d+192>>2]=p,a[d+224>>2]=p):(q=0,y=10),10==(y|0)&&(y=0,n=E(w[k>>1]|0,a[c>>2]|0)|0,p=E(q<<16>>16,a[c+64>>2]|0)|0,B=E(w[k+64>>1]|0,a[c+128>>2]|0)|0,H=E(w[k+96>>1]|0,a[c+192>>2]|0)|0,r=B+n|0,z=n-B|0,B=H+p|0,n=(362*(p-H|0)>>8)-B|0,H=B+r|0,p=r-B|0,B=n+z|0,r=z-n|0,n=E(l<<16>>16,a[c+
32>>2]|0)|0,l=E(w[k+48>>1]|0,a[c+96>>2]|0)|0,z=E(w[k+80>>1]|0,a[c+160>>2]|0)|0,Q=E(w[k+112>>1]|0,a[c+224>>2]|0)|0,C=z+l|0,x=z-l|0,l=Q+n|0,z=n-Q|0,Q=l+C|0,n=473*(z+x|0)>>8,V=n-(669*x>>8)-Q|0,x=(362*(l-C|0)>>8)-V|0,C=n-(277*z>>8)-x|0,a[d>>2]=Q+H,a[d+224>>2]=H-Q,a[d+32>>2]=V+B,a[d+192>>2]=B-V,a[d+64>>2]=x+r,a[d+160>>2]=r-x,a[d+96>>2]=C+p,a[d+128>>2]=p-C),1<(b|0))b=b+-1|0,k=k+2|0,c=c+4|0,d=d+4|0;else break;d=f+1|0;c=f+2|0;k=f+3|0;b=f+4|0;q=f+5|0;C=f+6|0;p=f+7|0;x=0;for(r=h;h=a[e+(x<<2)>>2]|0,V=h+f|0,
B=(a[r>>2]|0)+16400|0,Q=a[r+4>>2]|0,H=a[r+8>>2]|0,Q|H?(v=H,y=19):0==(a[r+12>>2]|0)&&0==(a[r+16>>2]|0)&&0==(a[r+20>>2]|0)&&0==(a[r+24>>2]|0)&&0==(a[r+28>>2]|0)?(z=t[m+((B>>>5&1023)+-384)>>0]|0,t[V>>0]=z,t[h+d>>0]=z,t[h+c>>0]=z,t[h+k>>0]=z,t[h+b>>0]=z,t[h+q>>0]=z,t[h+C>>0]=z,t[h+p>>0]=z):(v=0,y=19),19==(y|0)&&(y=0,H=a[r+16>>2]|0,z=H+B|0,n=B-H|0,H=a[r+24>>2]|0,B=H+v|0,l=(362*(v-H|0)>>8)-B|0,H=B+z|0,J=z-B|0,B=l+n|0,z=n-l|0,l=a[r+20>>2]|0,n=a[r+12>>2]|0,I=n+l|0,G=l-n|0,n=a[r+28>>2]|0,l=n+Q|0,L=Q-n|0,n=
l+I|0,Q=473*(L+G|0)>>8,K=Q-(669*G>>8)-n|0,G=(362*(l-I|0)>>8)-K|0,I=Q-(277*L>>8)-G|0,t[V>>0]=t[m+(((n+H|0)>>>5&1023)+-384)>>0]|0,t[h+p>>0]=t[m+(((H-n|0)>>>5&1023)+-384)>>0]|0,t[h+d>>0]=t[m+(((K+B|0)>>>5&1023)+-384)>>0]|0,t[h+C>>0]=t[m+(((B-K|0)>>>5&1023)+-384)>>0]|0,t[h+c>>0]=t[m+(((G+z|0)>>>5&1023)+-384)>>0]|0,t[h+q>>0]=t[m+(((z-G|0)>>>5&1023)+-384)>>0]|0,t[h+k>>0]=t[m+(((I+J|0)>>>5&1023)+-384)>>0]|0,t[h+b>>0]=t[m+(((J-I|0)>>>5&1023)+-384)>>0]|0),x=x+1|0,8!=(x|0);)r=r+32|0;u=g},function(b,d,c,e,f){e|=
0;f|=0;var g,h,m,k,l,n,p,q=0,y=0,B,H,r,z,Q,C,x,V,v,J,I;g=u;u=u+256|0;h=g;m=a[(b|0)+336>>2]|0;b=8;k=c|0;c=a[(d|0)+84>>2]|0;for(d=h;;)if(l=w[k+16>>1]|0,n=w[k+32>>1]|0,(l|n)<<16>>16?(q=n,y=10):0==(w[k+48>>1]|0)&&0==(w[k+64>>1]|0)&&0==(w[k+80>>1]|0)&&0==(w[k+96>>1]|0)&&0==(w[k+112>>1]|0)?(p=+(w[k>>1]|0)*+W[c>>2],W[d>>2]=p,W[d+32>>2]=p,W[d+64>>2]=p,W[d+96>>2]=p,W[d+128>>2]=p,W[d+160>>2]=p,W[d+192>>2]=p,W[d+224>>2]=p):(q=0,y=10),10==(y|0)&&(y=0,p=+(w[k>>1]|0)*+W[c>>2],B=+(q<<16>>16)*+W[c+64>>2],H=+(w[k+
64>>1]|0)*+W[c+128>>2],r=+(w[k+96>>1]|0)*+W[c+192>>2],z=p+H,Q=p-H,H=B+r,p=1.4142135381698608*(B-r)-H,r=z+H,B=z-H,H=Q+p,z=Q-p,p=+(l<<16>>16)*+W[c+32>>2],Q=+(w[k+48>>1]|0)*+W[c+96>>2],C=+(w[k+80>>1]|0)*+W[c+160>>2],x=+(w[k+112>>1]|0)*+W[c+224>>2],V=Q+C,v=C-Q,Q=p+x,C=p-x,x=V+Q,p=1.8477590084075928*(v+C),J=p-2.613126039505005*v-x,v=1.4142135381698608*(Q-V)-J,V=p-1.0823922157287598*C-v,W[d>>2]=r+x,W[d+224>>2]=r-x,W[d+32>>2]=H+J,W[d+192>>2]=H-J,W[d+64>>2]=z+v,W[d+160>>2]=z-v,W[d+96>>2]=B+V,W[d+128>>2]=
B-V),1<(b|0))b=b+-1|0,k=k+2|0,c=c+4|0,d=d+4|0;else break;d=f+7|0;c=f+1|0;k=f+6|0;b=f+2|0;q=f+5|0;y=f+3|0;l=f+4|0;n=0;for(I=h;h=a[e+(n<<2)>>2]|0,V=+W[I>>2]+512.5,B=+W[I+16>>2],v=V+B,z=V-B,B=+W[I+8>>2],V=+W[I+24>>2],J=B+V,H=1.4142135381698608*(B-V)-J,V=v+J,B=v-J,J=z+H,v=z-H,H=+W[I+20>>2],z=+W[I+12>>2],x=H+z,r=H-z,z=+W[I+4>>2],H=+W[I+28>>2],C=z+H,p=z-H,H=x+C,z=1.8477590084075928*(r+p),Q=z-2.613126039505005*r-H,r=1.4142135381698608*(C-x)-Q,x=z-1.0823922157287598*p-r,t[h+f>>0]=t[m+((~~(V+H)&1023)+-384)>>
0]|0,t[h+d>>0]=t[m+((~~(V-H)&1023)+-384)>>0]|0,t[h+c>>0]=t[m+((~~(J+Q)&1023)+-384)>>0]|0,t[h+k>>0]=t[m+((~~(J-Q)&1023)+-384)>>0]|0,t[h+b>>0]=t[m+((~~(v+r)&1023)+-384)>>0]|0,t[h+q>>0]=t[m+((~~(v-r)&1023)+-384)>>0]|0,t[h+y>>0]=t[m+((~~(B+x)&1023)+-384)>>0]|0,t[h+l>>0]=t[m+((~~(B-x)&1023)+-384)>>0]|0,n=n+1|0,8!=(n|0);)I=I+32|0;u=g},Ve,Ve,Ve,Ve,Ve,Ve,Ve,Ve,Ve,Ve,Ve,Ve],R=[fc,function(a){},function(b){b|=0;var d,c,e,f,g;d=a[b+576>>2]|0;a[d+4>>2]&1||(a[d+28>>2]&1?(c=0==(a[d+76>>2]|0)|2,e=13):(c=1,e=12),
qf(b,c,e),qf(b,c,e),qf(b,c,e),qf(b,c,e),qf(b,c,e),qf(b,c,e),e=b+608|0,(a[e>>2]|0)>=(a[b+592>>2]|0)&&Lc(b)|0,c=d+48|0,f=a[c>>2]&255,g=b+604|0,b=a[g>>2]|0,a[g>>2]=b+1,t[b>>0]=f,a[e>>2]=(a[e>>2]|0)+1,a[c>>2]=0,a[d+52>>2]=8)},function(b){b|=0;var d,c,e;d=b+576|0;(c=a[d>>2]|0)||Z(154168,142823,1110,143980);a[b+672>>2]=a[c+32>>2];a[b+668>>2]=a[c+36>>2];a[b+676>>2]=a[c+40>>2];(e=a[c+64>>2]|0)&&ja(e);(e=a[c+80>>2]|0)&&ja(e);ja(a[d>>2]|0);a[d>>2]=0;Ng(b)},function(b){b|=0;var d,c;d=b+576|0;(c=a[d>>2]|0)||
Z(154168,144647,2075,144783);a[b+672>>2]=a[c+892>>2];a[b+668>>2]=a[c+896>>2];a[b+676>>2]=a[c+900>>2];a[c+488>>2]|0&&Se(c);(c=a[c+912>>2]|0)&&ja(c);ja(a[d>>2]|0);a[d>>2]=0;Ng(b)},function(a){},function(b){b|=0;var d;d=b+800|0;a[d>>2]=a[b+912>>2];a[d+4>>2]=a[b+916>>2]},function(b){b|=0;var d;d=a[b+828>>2]|0;b=b+800|0;a[b>>2]=a[d+588>>2];a[b+4>>2]=a[d+608>>2]},function(b){b|=0;a[b+780>>2]=a[b+912>>2];a[b+784>>2]=a[b+916>>2]},function(b){b|=0;var d;d=b+916|0;a[d>>2]=(a[d>>2]|0)-(a[b+784>>2]|0)},function(b){b|=
0;var d;d=a[b+828>>2]|0;a[b+780>>2]=a[d+588>>2];a[b+784>>2]=a[d+592>>2]},function(b){b|=0;var d;d=a[b+828>>2]|0;a[d+604>>2]=a[b+780>>2];a[d+608>>2]=(a[d+592>>2]|0)-(a[b+784>>2]|0)},fi,function(b){b|=0;var d,c,e,f,g,h,m;d=a[b+20>>2]|0;switch(d|0){case 102:case 101:(a[b+264>>2]|0)>>>0<(a[b+32>>2]|0)>>>0&&(c=a[b>>2]|0,a[c+20>>2]=69,R[a[c>>2]&127](b));R[a[(a[b+392>>2]|0)+8>>2]&127](b);break;case 103:break;default:c=a[b>>2]|0,a[c+20>>2]=21,a[c+24>>2]=d,R[a[c>>2]&127](b)}c=b+392|0;d=a[c>>2]|0;if(!(a[d+
16>>2]|0)){e=b+288|0;f=b+8|0;g=b+404|0;do{R[a[d>>2]&127](b);if(d=a[e>>2]|0){h=d;d=0;do{if(m=a[f>>2]|0)a[m+4>>2]=d,a[m+8>>2]=h,R[a[m>>2]&127](b);dd[a[(a[g>>2]|0)+4>>2]&127](b,0)|0||(m=a[b>>2]|0,a[m+20>>2]=25,R[a[m>>2]&127](b));d=d+1|0;h=a[e>>2]|0}while(d>>>0<h>>>0)}R[a[(a[c>>2]|0)+8>>2]&127](b);d=a[c>>2]|0}while(0==(a[d+16>>2]|0))}c=b;R[(a[((a[(b+408|0)>>2]|0)+12|0)>>2]|0)&127](b);R[(a[((a[(b+24|0)>>2]|0)+16|0)>>2]|0)&127](b);yi(c)},function(b){b|=0;var d,c,e;d=u;u=u+208|0;c=d;e=d+8|0;ub[a[(a[b>>2]|
0)+12>>2]&31](b,e);d=a[(a[b+828>>2]|0)+628>>2]|0;a[c>>2]=e;Y(d,145235,154321,c);yi(b);Vb(b+624|0,1)},function(b){b|=0;var d,c;d=u;u=u+208|0;c=d+8|0;ub[a[(a[b>>2]|0)+12>>2]&31](b,c);b=a[(a[b+828>>2]|0)+628>>2]|0;a[d>>2]=c;Wb(b,145235,154321,d);u=d},function(b){b|=0;var d,c;d=a[b+20>>2]|0;100!=(d|0)&&(c=a[b>>2]|0,a[c+20>>2]=21,a[c+24>>2]=d,R[a[c>>2]&127](b));c=b+84|0;a[c>>2]|0||(d=Aa[a[a[b+4>>2]>>2]&63](b,0,880)|0,a[c>>2]=d);a[b+56>>2]=1;a[b+60>>2]=1;d=b+72|0;a[d>>2]=8;Yg(b,50,1);zi(b,b+120|0,155857,
155874);zi(b,b+136|0,155886,155903);zi(b,b+124|0,156065,156082);zi(b,b+140|0,156094,156111);t[b+152>>0]=0;t[b+168>>0]=1;t[b+184>>0]=5;t[b+153>>0]=0;t[b+169>>0]=1;t[b+185>>0]=5;t[b+154>>0]=0;t[b+170>>0]=1;t[b+186>>0]=5;t[b+155>>0]=0;t[b+171>>0]=1;t[b+187>>0]=5;t[b+156>>0]=0;t[b+172>>0]=1;t[b+188>>0]=5;t[b+157>>0]=0;t[b+173>>0]=1;t[b+189>>0]=5;t[b+158>>0]=0;t[b+174>>0]=1;t[b+190>>0]=5;t[b+159>>0]=0;t[b+175>>0]=1;t[b+191>>0]=5;t[b+160>>0]=0;t[b+176>>0]=1;t[b+192>>0]=5;t[b+161>>0]=0;t[b+177>>0]=1;t[b+
193>>0]=5;t[b+162>>0]=0;t[b+178>>0]=1;t[b+194>>0]=5;t[b+163>>0]=0;t[b+179>>0]=1;t[b+195>>0]=5;t[b+164>>0]=0;t[b+180>>0]=1;t[b+196>>0]=5;t[b+165>>0]=0;t[b+181>>0]=1;t[b+197>>0]=5;t[b+166>>0]=0;t[b+182>>0]=1;t[b+198>>0]=5;t[b+167>>0]=0;t[b+183>>0]=1;t[b+199>>0]=5;a[b+204>>2]=0;a[b+200>>2]=0;a[b+208>>2]=0;a[b+212>>2]=8<(a[d>>2]|0)&1;a[b+216>>2]=0;a[b+220>>2]=0;a[b+224>>2]=1;d=b+228|0;a[d>>2]=0;a[d+4>>2]=0;a[d+8>>2]=0;a[d+12>>2]=0;t[b+248>>0]=1;t[b+249>>0]=1;t[b+250>>0]=0;w[b+252>>1]=1;w[b+254>>1]=1;
a[b+260>>2]=0;b|=0;var e;switch(a[b+40>>2]|0){case 0:d=a[b+20>>2]|0;100!=(d|0)&&(c=a[b>>2]|0,a[c+20>>2]=21,a[c+24>>2]=d,R[a[c>>2]&127](b));a[b+80>>2]=0;a[b+244>>2]=0;a[b+256>>2]=0;c=a[b+36>>2]|0;d=b+76|0;a[d>>2]=c;9<(c+-1|0)>>>0?(e=a[b>>2]|0,a[e+20>>2]=27,a[e+24>>2]=c,a[e+28>>2]=10,R[a[e>>2]&127](b),e=a[d>>2]|0):e=c;if(0>=(e|0))break;c=a[b+84>>2]|0;d=0;do a[c+(88*d|0)>>2]=d,a[c+(88*d|0)+8>>2]=1,a[c+(88*d|0)+12>>2]=1,a[c+(88*d|0)+16>>2]=0,a[c+(88*d|0)+20>>2]=0,a[c+(88*d|0)+24>>2]=0,d=d+1|0;while((d|
0)!=(e|0));break;case 1:e=a[b+20>>2]|0;100!=(e|0)&&(d=a[b>>2]|0,a[d+20>>2]=21,a[d+24>>2]=e,R[a[d>>2]&127](b));a[b+80>>2]=1;a[b+256>>2]=0;a[b+244>>2]=1;a[b+76>>2]=1;d=a[b+84>>2]|0;a[d>>2]=1;a[d+8>>2]=1;a[d+12>>2]=1;a[d+16>>2]=0;a[d+20>>2]=0;a[d+24>>2]=0;break;case 2:d=a[b+20>>2]|0;100!=(d|0)&&(e=a[b>>2]|0,a[e+20>>2]=21,a[e+24>>2]=d,R[a[e>>2]&127](b));a[b+80>>2]=3;a[b+256>>2]=0;a[b+244>>2]=1;a[b+76>>2]=3;e=a[b+84>>2]|0;a[e>>2]=1;a[e+8>>2]=2;a[e+12>>2]=2;a[e+16>>2]=0;a[e+20>>2]=0;a[e+24>>2]=0;a[e+88>>
2]=2;a[e+96>>2]=1;a[e+100>>2]=1;a[e+104>>2]=1;a[e+108>>2]=1;a[e+112>>2]=1;a[e+176>>2]=3;a[e+184>>2]=1;a[e+188>>2]=1;a[e+192>>2]=1;a[e+196>>2]=1;a[e+200>>2]=1;break;case 3:e=a[b+20>>2]|0;100!=(e|0)&&(d=a[b>>2]|0,a[d+20>>2]=21,a[d+24>>2]=e,R[a[d>>2]&127](b));a[b+80>>2]=3;a[b+256>>2]=0;a[b+244>>2]=1;a[b+76>>2]=3;d=a[b+84>>2]|0;a[d>>2]=1;a[d+8>>2]=2;a[d+12>>2]=2;a[d+16>>2]=0;a[d+20>>2]=0;a[d+24>>2]=0;a[d+88>>2]=2;a[d+96>>2]=1;a[d+100>>2]=1;a[d+104>>2]=1;a[d+108>>2]=1;a[d+112>>2]=1;a[d+176>>2]=3;a[d+184>>
2]=1;a[d+188>>2]=1;a[d+192>>2]=1;a[d+196>>2]=1;a[d+200>>2]=1;break;case 4:d=a[b+20>>2]|0;100!=(d|0)&&(e=a[b>>2]|0,a[e+20>>2]=21,a[e+24>>2]=d,R[a[e>>2]&127](b));a[b+80>>2]=4;a[b+244>>2]=0;a[b+256>>2]=1;a[b+76>>2]=4;e=a[b+84>>2]|0;a[e>>2]=67;a[e+8>>2]=1;a[e+12>>2]=1;a[e+16>>2]=0;a[e+20>>2]=0;a[e+24>>2]=0;a[e+88>>2]=77;a[e+96>>2]=1;a[e+100>>2]=1;a[e+104>>2]=0;a[e+108>>2]=0;a[e+112>>2]=0;a[e+176>>2]=89;a[e+184>>2]=1;a[e+188>>2]=1;a[e+192>>2]=0;a[e+196>>2]=0;a[e+200>>2]=0;a[e+264>>2]=75;a[e+272>>2]=1;
a[e+276>>2]=1;a[e+280>>2]=0;a[e+284>>2]=0;a[e+288>>2]=0;break;case 5:e=a[b+20>>2]|0;100!=(e|0)&&(d=a[b>>2]|0,a[d+20>>2]=21,a[d+24>>2]=e,R[a[d>>2]&127](b));a[b+80>>2]=5;a[b+244>>2]=0;a[b+256>>2]=1;a[b+76>>2]=4;d=a[b+84>>2]|0;a[d>>2]=1;a[d+8>>2]=2;a[d+12>>2]=2;a[d+16>>2]=0;a[d+20>>2]=0;a[d+24>>2]=0;a[d+88>>2]=2;a[d+96>>2]=1;a[d+100>>2]=1;a[d+104>>2]=1;a[d+108>>2]=1;a[d+112>>2]=1;a[d+176>>2]=3;a[d+184>>2]=1;a[d+188>>2]=1;a[d+192>>2]=1;a[d+196>>2]=1;a[d+200>>2]=1;a[d+264>>2]=4;a[d+272>>2]=2;a[d+276>>
2]=2;a[d+280>>2]=0;a[d+284>>2]=0;a[d+288>>2]=0;break;case 6:d=a[b+20>>2]|0;100!=(d|0)&&(e=a[b>>2]|0,a[e+20>>2]=21,a[e+24>>2]=d,R[a[e>>2]&127](b));a[b+80>>2]=6;a[b+256>>2]=0;a[b+244>>2]=1;t[b+248>>0]=2;a[b+76>>2]=3;e=a[b+84>>2]|0;a[e>>2]=114;a[e+8>>2]=1;a[e+12>>2]=1;a[e+16>>2]=0;d=1==(a[b+260>>2]|0)&1;a[e+20>>2]=d;a[e+24>>2]=d;a[e+88>>2]=103;a[e+96>>2]=1;a[e+100>>2]=1;a[e+104>>2]=0;a[e+108>>2]=0;a[e+112>>2]=0;a[e+176>>2]=98;a[e+184>>2]=1;a[e+188>>2]=1;a[e+192>>2]=0;a[e+196>>2]=d;a[e+200>>2]=d;break;
case 7:d=a[b+20>>2]|0;100!=(d|0)&&(e=a[b>>2]|0,a[e+20>>2]=21,a[e+24>>2]=d,R[a[e>>2]&127](b));a[b+80>>2]=7;a[b+256>>2]=0;a[b+244>>2]=1;t[b+248>>0]=2;a[b+76>>2]=3;e=a[b+84>>2]|0;a[e>>2]=1;a[e+8>>2]=2;a[e+12>>2]=2;a[e+16>>2]=0;a[e+20>>2]=0;a[e+24>>2]=0;a[e+88>>2]=34;a[e+96>>2]=1;a[e+100>>2]=1;a[e+104>>2]=1;a[e+108>>2]=1;a[e+112>>2]=1;a[e+176>>2]=35;a[e+184>>2]=1;a[e+188>>2]=1;a[e+192>>2]=1;a[e+196>>2]=1;a[e+200>>2]=1;break;default:e=a[b>>2]|0,a[e+20>>2]=10,R[a[e>>2]&127](b)}},function(b){b|=0;var d,
c;d=a[b+20>>2]|0;100!=(d|0)&&(c=a[b>>2]|0,a[c+20>>2]=21,a[c+24>>2]=d,R[a[c>>2]&127](b));R[a[(a[b>>2]|0)+16>>2]&127](b);d=b+24|0;R[a[(a[d>>2]|0)+8>>2]&127](b);Gg(b);R[a[(a[b+408>>2]|0)+16>>2]&127](b);R[a[(a[d>>2]|0)+16>>2]&127](b)},yi,function(a){a|=0;w[a+98>>1]=-32692==(w[a+90>>1]|0)?1:3;w[a+84>>1]=16;w[a+86>>1]=2},function(b){b|=0;var d,c,e;d=b+576|0;(c=a[d>>2]|0)||Z(154168,146646,1537,146854);a[b+672>>2]=a[c+24>>2];a[b+668>>2]=a[c+28>>2];(e=a[c+12>>2]|0)&&ja(e);ja(c);a[d>>2]=0;Ng(b)},function(b){b|=
0;var d,c,e,f;pk(b)|0;d=b+576|0;(c=a[d>>2]|0)||Z(147733,147682,1092,147752);(e=a[c+124>>2]|0)?(ja(e),c=f=e=a[d>>2]|0):f=c;if(e=a[c+152>>2]|0)ja(e),f=a[d>>2]|0;ja(f);a[d>>2]=0;Ng(b)},function(b){b|=0;var d,c,e,f;d=b+576|0;if(c=a[d>>2]|0)a[b+672>>2]=a[c+160>>2],a[b+668>>2]=a[c+164>>2],a[b+676>>2]=a[c+168>>2],(e=a[c+312>>2]|0)&&ja(e),(e=a[c+316>>2]|0)&&ja(e),(e=a[c+320>>2]|0)&&ja(e),(e=a[c+324>>2]|0)&&ja(e),(e=a[c+328>>2]|0)&&ja(e),(e=a[c+332>>2]|0)&&ja(e),(e=a[c+336>>2]|0)&&ja(e),(e=a[c+340>>2]|0)&&
ja(e),(e=a[c+344>>2]|0)&&ja(e),(e=a[c+348>>2]|0)&&ja(e),(e=a[c+352>>2]|0)&&ja(e),(e=a[c+356>>2]|0)&&ja(e),t[c+496>>0]|0&&(e=a[d>>2]|0,f=e+496|0,t[f>>0]|0?(fi(e+632|0),t[f>>0]=0):Z(150963,148429,1245,150993)),(f=a[c+1180>>2]|0)&&ja(f),(f=a[c+1200>>2]|0)&&ja(f),(f=a[c+5364>>2]|0)&&ja(f),ja(c),a[d>>2]=0,Ng(b)},function(b){b|=0;var d,c;d=u;u=u+208|0;c=d+8|0;ub[a[(a[b>>2]|0)+12>>2]&31](b,c);b=a[(a[b+12>>2]|0)+628>>2]|0;a[d>>2]=c;Wb(b,151596,154321,d);u=d},function(b){b|=0;var d,c,e;d=u;u=u+208|0;c=d;e=
d+8|0;ub[a[(a[b>>2]|0)+12>>2]&31](b,e);d=b+12|0;b=a[(a[d>>2]|0)+628>>2]|0;a[c>>2]=e;Y(b,151596,154321,c);Bi(a[d>>2]|0)},function(a){},function(a){},function(a){a|=0;w[a+84>>1]=8;w[a+86>>1]=1},function(b){b|=0;var d,c,e;d=b+576|0;(c=a[d>>2]|0)||Z(154168,152287,1247,152415);pk(b)|0;a[b+672>>2]=a[c+140>>2];a[b+668>>2]=a[c+144>>2];(e=a[c+160>>2]|0)&&ja(e);(e=a[c+164>>2]|0)&&ja(e);(e=a[c+168>>2]|0)&&ja(e);(e=a[c+148>>2]|0)&&ja(e);(e=a[c+152>>2]|0)&&ja(e);(e=a[c+156>>2]|0)&&ja(e);a[c+128>>2]&1&&(e=c+64|
0,a[b+8>>2]|0?rk(e)|0:wf(e)|0);(e=a[c+120>>2]|0)&&ja(e);ja(c);a[d>>2]=0;Ng(b)},function(b){b|=0;var d,c,e,f;d=b+576|0;(c=a[d>>2]|0)||Z(154168,154074,332,154176);pk(b)|0;a[b+672>>2]=a[c+128>>2];a[b+668>>2]=a[c+132>>2];e=c+124|0;f=a[e>>2]|0;f&2?(rk(c+64|0)|0,a[e>>2]=0):f&1&&(wf(c+64|0)|0,a[e>>2]=0);ja(c);a[d>>2]=0;Ng(b)},function(b){b|=0;var d,c,e,f,g;d=a[b+408>>2]|0;c=b+24|0;e=a[c>>2]|0;f=a[e>>2]|0;a[e>>2]=f+1;t[f>>0]=-1;f=e+4|0;g=(a[f>>2]|0)+-1|0;a[f>>2]=g;0==(g|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=
a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b));e=a[c>>2]|0;g=a[e>>2]|0;a[e>>2]=g+1;t[g>>0]=-40;g=e+4|0;f=(a[g>>2]|0)+-1|0;a[g>>2]=f;0==(f|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b));a[d+28>>2]=0;a[b+244>>2]|0&&(d=a[c>>2]|0,e=a[d>>2]|0,a[d>>2]=e+1,t[e>>0]=-1,e=d+4|0,f=(a[e>>2]|0)+-1|0,a[e>>2]=f,0==(f|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[c>>2]|0,f=a[d>>2]|0,a[d>>2]=f+1,t[f>>0]=-32,f=d+4|0,e=(a[f>>2]|0)+-1|0,a[f>>2]=e,0==(e|
0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[c>>2]|0,e=a[d>>2]|0,a[d>>2]=e+1,t[e>>0]=0,e=d+4|0,f=(a[e>>2]|0)+-1|0,a[e>>2]=f,0==(f|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[c>>2]|0,f=a[d>>2]|0,a[d>>2]=f+1,t[f>>0]=16,f=d+4|0,e=(a[f>>2]|0)+-1|0,a[f>>2]=e,0==(e|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[c>>2]|0,e=a[d>>2]|0,a[d>>2]=e+1,t[e>>0]=74,e=d+4|0,f=(a[e>>2]|0)+-1|0,a[e>>2]=f,0==
(f|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[c>>2]|0,f=a[d>>2]|0,a[d>>2]=f+1,t[f>>0]=70,f=d+4|0,e=(a[f>>2]|0)+-1|0,a[f>>2]=e,0==(e|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[c>>2]|0,e=a[d>>2]|0,a[d>>2]=e+1,t[e>>0]=73,e=d+4|0,f=(a[e>>2]|0)+-1|0,a[e>>2]=f,0==(f|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[c>>2]|0,f=a[d>>2]|0,a[d>>2]=f+1,t[f>>0]=70,f=d+4|0,e=(a[f>>2]|0)+-1|0,a[f>>2]=
e,0==(e|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=a[c>>2]|0,e=a[d>>2]|0,a[d>>2]=e+1,t[e>>0]=0,e=d+4|0,f=(a[e>>2]|0)+-1|0,a[e>>2]=f,0==(f|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=t[b+248>>0]|0,f=a[c>>2]|0,e=a[f>>2]|0,a[f>>2]=e+1,t[e>>0]=d,d=f+4|0,e=(a[d>>2]|0)+-1|0,a[d>>2]=e,0==(e|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),f=t[b+249>>0]|0,e=a[c>>2]|0,d=a[e>>2]|0,a[e>>2]=d+1,t[d>>0]=f,
f=e+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,0==(d|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=t[b+250>>0]|0,d=a[c>>2]|0,f=a[d>>2]|0,a[d>>2]=f+1,t[f>>0]=e,e=d+4|0,f=(a[e>>2]|0)+-1|0,a[e>>2]=f,0==(f|0)&&0==(da[a[d+12>>2]&63](b)|0)&&(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),d=w[b+252>>1]|0,f=a[c>>2]|0,e=a[f>>2]|0,a[f>>2]=e+1,t[e>>0]=(d&65535)>>>8,e=f+4|0,g=(a[e>>2]|0)+-1|0,a[e>>2]=g,0==(g|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),
f=a[c>>2]|0,g=a[f>>2]|0,a[f>>2]=g+1,t[g>>0]=d,d=f+4|0,g=(a[d>>2]|0)+-1|0,a[d>>2]=g,0==(g|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),f=w[b+254>>1]|0,g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=(f&65535)>>>8,d=g+4|0,e=(a[d>>2]|0)+-1|0,a[d>>2]=e,e||da[a[g+12>>2]&63](b)|0||(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),g=a[c>>2]|0,e=a[g>>2]|0,a[g>>2]=e+1,t[e>>0]=f,e=g+4|0,d=(a[e>>2]|0)+-1|0,a[e>>2]=d,d||da[a[g+12>>2]&63](b)|0||(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),
g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=0,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,f||da[a[g+12>>2]&63](b)|0||(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),g=a[c>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=0,f=g+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,d||da[a[g+12>>2]&63](b)|0||(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)));if(a[b+256>>2]|0)switch(g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=-1,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),
g=a[c>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=-18,f=g+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,0==(d|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=0,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=14,f=g+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,0==(d|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),
g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=65,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=100,f=g+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,0==(d|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=111,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),
g=a[c>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=98,f=g+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,0==(d|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=101,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=0,f=g+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,0==(d|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),
g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=100,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=0,f=g+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,0==(d|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=0,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,0==(f|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),
g=a[c>>2]|0,f=a[g>>2]|0,a[g>>2]=f+1,t[f>>0]=0,f=g+4|0,d=(a[f>>2]|0)+-1|0,a[f>>2]=d,0==(d|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b)),g=a[c>>2]|0,d=a[g>>2]|0,a[g>>2]=d+1,t[d>>0]=0,d=g+4|0,f=(a[d>>2]|0)+-1|0,a[d>>2]=f,f||da[a[g+12>>2]&63](b)|0||(d=a[b>>2]|0,a[d+20>>2]=25,R[a[d>>2]&127](b)),a[b+80>>2]|0){case 3:g=a[c>>2]|0;f=a[g>>2]|0;a[g>>2]=f+1;t[f>>0]=1;f=g+4|0;d=(a[f>>2]|0)+-1|0;if(a[f>>2]=d)break;if(da[a[g+12>>2]&63](b)|0)break;g=a[b>>2]|0;a[g+20>>2]=25;R[a[g>>
2]&127](b);break;case 5:g=a[c>>2]|0;d=a[g>>2]|0;a[g>>2]=d+1;t[d>>0]=2;d=g+4|0;f=(a[d>>2]|0)+-1|0;if(a[d>>2]=f)break;if(da[a[g+12>>2]&63](b)|0)break;g=a[b>>2]|0;a[g+20>>2]=25;R[a[g>>2]&127](b);break;default:g=a[c>>2]|0,c=a[g>>2]|0,a[g>>2]=c+1,t[c>>0]=0,c=g+4|0,f=(a[c>>2]|0)+-1|0,a[c>>2]=f,f||da[a[g+12>>2]&63](b)|0||(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b))}},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p=0;d=b+84|0;c=b+76|0;e=a[c>>2]|0;if(0<(e|0))for(f=0,g=a[d>>2]|0,h=0;;)if(m=(ei(b,a[g+16>>2]|0)|
0)+h|0,f=f+1|0,k=a[c>>2]|0,(f|0)>=(k|0)){l=k;n=m;break}else g=g+88|0,h=m;else l=e,n=0;e=b+212|0;h=b+268|0;g=0==(a[h>>2]|0);a:do if(a[e>>2]|0)p=g?19:18;else{b:do if(g){do if(8==(a[b+72>>2]|0)&&8==(a[b+380>>2]|0)){if(0<(l|0))for(f=0,m=a[d>>2]|0,k=1;;)if(k=1>=(a[m+20>>2]|0)&&1>=(a[m+24>>2]|0)?k:0,f=f+1|0,(f|0)>=(l|0)){f=k;break}else m=m+88|0;else f=1;if(!(0!=(n|0)&0!=(f|0))){if(!f)break;xi(b,192);break a}k=a[b>>2]|0;a[k+20>>2]=77;ub[a[k+4>>2]&31](b,0);k=0!=(a[h>>2]|0);if(a[e>>2]|0){p=k?18:19;break a}else if(k)break b}while(0);
xi(b,193);break a}while(0);xi(b,194)}while(0);18==(p|0)?xi(b,202):19==(p|0)&&xi(b,201);switch(a[b+260>>2]|0){case 0:break;case 1:p=3>(a[c>>2]|0)?27:28;break;default:p=27}27==(p|0)&&(c=a[b>>2]|0,a[c+20>>2]=28,R[a[c>>2]&127](b),p=28);28==(p|0)&&(c=b+24|0,e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=-1,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,0==(n|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=-8,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>
2]=f,0==(f|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=0,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,0==(n|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=24,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,0==(f|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=13,f=e+4|0,n=(a[f>>2]|0)+-1|0,
a[f>>2]=n,0==(n|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=0,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,0==(f|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=-1,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,0==(n|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=3,n=e+4|0,f=(a[n>>2]|0)+-1|
0,a[n>>2]=f,0==(f|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,f=a[(a[d>>2]|0)+88>>2]&255,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=f,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,0==(n|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,n=a[a[d>>2]>>2]&255,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=n,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,0==(f|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,f=a[(a[d>>
2]|0)+176>>2]&255,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=f,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,0==(n|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=-128,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,0==(f|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=0,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,0==(n|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>
2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=0,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,0==(f|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=0,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,0==(n|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=0,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,f||da[a[e+12>>2]&63](b)|0||(n=a[b>>2]|0,a[n+20>>2]=25,R[a[n>>2]&127](b)),
e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=0,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,n||da[a[e+12>>2]&63](b)|0||(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=0,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,f||da[a[e+12>>2]&63](b)|0||(n=a[b>>2]|0,a[n+20>>2]=25,R[a[n>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=1,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,n||da[a[e+12>>2]&63](b)|0||(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+
1,t[n>>0]=0,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,f||da[a[e+12>>2]&63](b)|0||(n=a[b>>2]|0,a[n+20>>2]=25,R[a[n>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=0,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,n||da[a[e+12>>2]&63](b)|0||(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=0,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,f||da[a[e+12>>2]&63](b)|0||(n=a[b>>2]|0,a[n+20>>2]=25,R[a[n>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=0,f=e+4|0,n=(a[f>>2]|0)+
-1|0,a[f>>2]=n,n||da[a[e+12>>2]&63](b)|0||(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=1,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,f||da[a[e+12>>2]&63](b)|0||(n=a[b>>2]|0,a[n+20>>2]=25,R[a[n>>2]&127](b)),e=a[c>>2]|0,f=a[e>>2]|0,a[e>>2]=f+1,t[f>>0]=0,f=e+4|0,n=(a[f>>2]|0)+-1|0,a[f>>2]=n,n||da[a[e+12>>2]&63](b)|0||(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b)),e=a[c>>2]|0,n=a[e>>2]|0,a[e>>2]=n+1,t[n>>0]=0,n=e+4|0,f=(a[n>>2]|0)+-1|0,a[n>>2]=f,f||da[a[e+12>>2]&63](b)|
0||(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)));a[h>>2]|0&&(h=b+380|0,8!=(a[h>>2]|0)&&(d=b+24|0,p=a[d>>2]|0,e=a[p>>2]|0,a[p>>2]=e+1,t[e>>0]=-1,e=p+4|0,f=(a[e>>2]|0)+-1|0,a[e>>2]=f,0==(f|0)&&0==(da[a[p+12>>2]&63](b)|0)&&(p=a[b>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](b)),p=a[d>>2]|0,f=a[p>>2]|0,a[p>>2]=f+1,t[f>>0]=-38,f=p+4|0,e=(a[f>>2]|0)+-1|0,a[f>>2]=e,0==(e|0)&&0==(da[a[p+12>>2]&63](b)|0)&&(p=a[b>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](b)),p=a[d>>2]|0,e=a[p>>2]|0,a[p>>2]=e+1,t[e>>0]=0,e=p+4|0,f=(a[e>>2]|
0)+-1|0,a[e>>2]=f,0==(f|0)&&0==(da[a[p+12>>2]&63](b)|0)&&(p=a[b>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](b)),p=a[d>>2]|0,f=a[p>>2]|0,a[p>>2]=f+1,t[f>>0]=6,f=p+4|0,e=(a[f>>2]|0)+-1|0,a[f>>2]=e,0==(e|0)&&0==(da[a[p+12>>2]&63](b)|0)&&(p=a[b>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](b)),p=a[d>>2]|0,e=a[p>>2]|0,a[p>>2]=e+1,t[e>>0]=0,e=p+4|0,f=(a[e>>2]|0)+-1|0,a[e>>2]=f,0==(f|0)&&0==(da[a[p+12>>2]&63](b)|0)&&(p=a[b>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](b)),p=a[d>>2]|0,f=a[p>>2]|0,a[p>>2]=f+1,t[f>>0]=0,f=p+4|0,e=(a[f>>
2]|0)+-1|0,a[f>>2]=e,0==(e|0)&&0==(da[a[p+12>>2]&63](b)|0)&&(p=a[b>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](b)),p=a[h>>2]|0,h=(E(p,p)|0)+255|0,p=a[d>>2]|0,e=a[p>>2]|0,a[p>>2]=e+1,t[e>>0]=h,h=p+4|0,e=(a[h>>2]|0)+-1|0,a[h>>2]=e,0==(e|0)&&0==(da[a[p+12>>2]&63](b)|0)&&(p=a[b>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](b)),p=a[d>>2]|0,d=a[p>>2]|0,a[p>>2]=d+1,t[d>>0]=0,d=p+4|0,e=(a[d>>2]|0)+-1|0,a[d>>2]=e,e||da[a[p+12>>2]&63](b)|0||(p=a[b>>2]|0,a[p+20>>2]=25,R[a[p>>2]&127](b))))},function(b){b|=0;var d,c,e,f,g,h,m,k,
l,n,p,q,y,B,H,r,z,Q,C,w,V,v,J,I,G,L,K,E,A,O,M,T,D,P,Oa,F,N;d=u;u=u+32|0;c=d+16|0;e=d;f=a[b+408>>2]|0;if(a[b+212>>2]|0){g=e;k=g+16|0;do t[g>>0]=0,g=g+1|0;while((g|0)<(k|0));g=c;k=g+16|0;do t[g>>0]=0,g=g+1|0;while((g|0)<(k|0));g=a[b+292>>2]|0;if(0<(g|0)){k=0==(a[b+368>>2]|0);if(a[b+364>>2]|0){if(!k){m=0;do t[e+(a[(a[b+296+(m<<2)>>2]|0)+24>>2]|0)>>0]=1,m=m+1|0;while((m|0)!=(g|0))}v=V=w=C=Q=z=r=H=B=y=q=p=g=n=m=l=0}else{m=0==(a[b+372>>2]|0);if(k){k=0;do m&&(t[c+(a[(a[b+296+(k<<2)>>2]|0)+20>>2]|0)>>0]=
1),k=k+1|0;while((k|0)!=(g|0))}else{k=0;do h=a[b+296+(k<<2)>>2]|0,m&&(t[c+(a[h+20>>2]|0)>>0]=1),t[e+(a[h+24>>2]|0)>>0]=1,k=k+1|0;while((k|0)!=(g|0))}l=t[c+13>>0]|0;m=t[c>>0]|0;n=t[c+14>>0]|0;g=t[c+15>>0]|0;p=t[c+1>>0]|0;q=t[c+2>>0]|0;y=t[c+3>>0]|0;B=t[c+4>>0]|0;H=t[c+5>>0]|0;r=t[c+6>>0]|0;z=t[c+7>>0]|0;Q=t[c+8>>0]|0;C=t[c+9>>0]|0;w=t[c+10>>0]|0;V=t[c+11>>0]|0;v=t[c+12>>0]|0}h=t[e+15>>0]|0;k=t[e>>0]|0;J=t[e+1>>0]|0;I=t[e+2>>0]|0;G=t[e+3>>0]|0;L=t[e+4>>0]|0;K=t[e+5>>0]|0;E=t[e+6>>0]|0;A=t[e+7>>0]|0;
O=t[e+8>>0]|0;M=t[e+9>>0]|0;T=t[e+10>>0]|0;D=t[e+11>>0]|0;P=t[e+12>>0]|0;Oa=l;F=t[e+13>>0]|0;l=t[e+14>>0]|0;N=g}else N=l=n=F=Oa=P=v=D=V=T=w=M=C=O=Q=A=z=E=r=K=H=L=B=G=y=I=q=J=p=k=m=h=0;if(g=(v<<24>>24)+(P<<24>>24)+(D<<24>>24)+(V<<24>>24)+(T<<24>>24)+(w<<24>>24)+(M<<24>>24)+(C<<24>>24)+(O<<24>>24)+(Q<<24>>24)+(A<<24>>24)+(z<<24>>24)+(E<<24>>24)+(r<<24>>24)+(K<<24>>24)+(H<<24>>24)+(L<<24>>24)+(B<<24>>24)+(G<<24>>24)+(y<<24>>24)+(I<<24>>24)+(q<<24>>24)+(J<<24>>24)+(p<<24>>24)+(k<<24>>24)+(m<<24>>24)+
(Oa<<24>>24)+(F<<24>>24)+(n<<24>>24)+(l<<24>>24)+(N<<24>>24)+(h<<24>>24)|0){h=b+24|0;N=a[h>>2]|0;l=a[N>>2]|0;a[N>>2]=l+1;t[l>>0]=-1;l=N+4|0;n=(a[l>>2]|0)+-1|0;a[l>>2]=n;0==(n|0)&&0==(da[a[N+12>>2]&63](b)|0)&&(N=a[b>>2]|0,a[N+20>>2]=25,R[a[N>>2]&127](b));N=a[h>>2]|0;n=a[N>>2]|0;a[N>>2]=n+1;t[n>>0]=-52;n=N+4|0;l=(a[n>>2]|0)+-1|0;a[n>>2]=l;0==(l|0)&&0==(da[a[N+12>>2]&63](b)|0)&&(N=a[b>>2]|0,a[N+20>>2]=25,R[a[N>>2]&127](b));N=(g<<1)+2|0;g=a[h>>2]|0;l=a[g>>2]|0;a[g>>2]=l+1;t[l>>0]=N>>>8;l=g+4|0;n=(a[l>>
2]|0)+-1|0;a[l>>2]=n;0==(n|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));g=a[h>>2]|0;n=a[g>>2]|0;a[g>>2]=n+1;t[n>>0]=N;N=g+4|0;n=(a[N>>2]|0)+-1|0;a[N>>2]=n;0==(n|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));g=0;do t[c+g>>0]|0&&(n=a[h>>2]|0,N=a[n>>2]|0,a[n>>2]=N+1,t[N>>0]=g,N=n+4|0,l=(a[N>>2]|0)+-1|0,a[N>>2]=l,0==(l|0)&&0==(da[a[n+12>>2]&63](b)|0)&&(n=a[b>>2]|0,a[n+20>>2]=25,R[a[n>>2]&127](b)),n=a[h>>2]|0,l=(x[b+168+g>>0]<<4)+(x[b+
152+g>>0]|0)&255,N=a[n>>2]|0,a[n>>2]=N+1,t[N>>0]=l,l=n+4|0,N=(a[l>>2]|0)+-1|0,a[l>>2]=N,0==(N|0)&&0==(da[a[n+12>>2]&63](b)|0)&&(n=a[b>>2]|0,a[n+20>>2]=25,R[a[n>>2]&127](b))),t[e+g>>0]|0&&(n=a[h>>2]|0,N=a[n>>2]|0,a[n>>2]=N+1,t[N>>0]=g+16,N=n+4|0,l=(a[N>>2]|0)+-1|0,a[N>>2]=l,0==(l|0)&&0==(da[a[n+12>>2]&63](b)|0)&&(n=a[b>>2]|0,a[n+20>>2]=25,R[a[n>>2]&127](b)),n=t[b+184+g>>0]|0,l=a[h>>2]|0,N=a[l>>2]|0,a[l>>2]=N+1,t[N>>0]=n,n=l+4|0,N=(a[n>>2]|0)+-1|0,a[n>>2]=N,0==(N|0)&&0==(da[a[l+12>>2]&63](b)|0)&&(l=
a[b>>2]|0,a[l+20>>2]=25,R[a[l>>2]&127](b))),g=g+1|0;while(16!=(g|0))}}else if(g=b+292|0,0<(a[g>>2]|0)){c=b+364|0;h=b+372|0;m=b+368|0;k=0;do e=a[b+296+(k<<2)>>2]|0,0==(a[c>>2]|0)&&0==(a[h>>2]|0)&&Me(b,a[e+20>>2]|0,0),a[m>>2]|0&&Me(b,a[e+24>>2]|0,1),k=k+1|0;while((k|0)<(a[g>>2]|0))}g=b+236|0;h=f+28|0;f=b+24|0;(a[g>>2]|0)!=(a[h>>2]|0)&&(e=a[f>>2]|0,c=a[e>>2]|0,a[e>>2]=c+1,t[c>>0]=-1,c=e+4|0,l=(a[c>>2]|0)+-1|0,a[c>>2]=l,0==(l|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),
e=a[f>>2]|0,l=a[e>>2]|0,a[e>>2]=l+1,t[l>>0]=-35,l=e+4|0,c=(a[l>>2]|0)+-1|0,a[l>>2]=c,0==(c|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[f>>2]|0,c=a[e>>2]|0,a[e>>2]=c+1,t[c>>0]=0,c=e+4|0,l=(a[c>>2]|0)+-1|0,a[c>>2]=l,0==(l|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),e=a[f>>2]|0,l=a[e>>2]|0,a[e>>2]=l+1,t[l>>0]=4,l=e+4|0,c=(a[l>>2]|0)+-1|0,a[l>>2]=c,0==(c|0)&&0==(da[a[e+12>>2]&63](b)|0)&&(e=a[b>>2]|0,a[e+20>>2]=25,R[a[e>>2]&127](b)),
e=a[g>>2]|0,c=a[f>>2]|0,l=a[c>>2]|0,a[c>>2]=l+1,t[l>>0]=e>>>8,l=c+4|0,N=(a[l>>2]|0)+-1|0,a[l>>2]=N,0==(N|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),c=a[f>>2]|0,N=a[c>>2]|0,a[c>>2]=N+1,t[N>>0]=e,e=c+4|0,N=(a[e>>2]|0)+-1|0,a[e>>2]=N,0==(N|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b)),a[h>>2]=a[g>>2]);g=a[f>>2]|0;h=a[g>>2]|0;a[g>>2]=h+1;t[h>>0]=-1;h=g+4|0;c=(a[h>>2]|0)+-1|0;a[h>>2]=c;0==(c|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|
0,a[g+20>>2]=25,R[a[g>>2]&127](b));g=a[f>>2]|0;c=a[g>>2]|0;a[g>>2]=c+1;t[c>>0]=-38;c=g+4|0;h=(a[c>>2]|0)+-1|0;a[c>>2]=h;0==(h|0)&&0==(da[a[g+12>>2]&63](b)|0)&&(g=a[b>>2]|0,a[g+20>>2]=25,R[a[g>>2]&127](b));g=b+292|0;h=(a[g>>2]<<1)+6|0;c=a[f>>2]|0;N=a[c>>2]|0;a[c>>2]=N+1;t[N>>0]=h>>>8;N=c+4|0;e=(a[N>>2]|0)+-1|0;a[N>>2]=e;0==(e|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));c=a[f>>2]|0;e=a[c>>2]|0;a[c>>2]=e+1;t[e>>0]=h;h=c+4|0;e=(a[h>>2]|0)+-1|0;a[h>>2]=e;0==(e|0)&&0==
(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));c=a[f>>2]|0;e=a[g>>2]&255;h=a[c>>2]|0;a[c>>2]=h+1;t[h>>0]=e;e=c+4|0;h=(a[e>>2]|0)+-1|0;a[e>>2]=h;0==(h|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));if(0<(a[g>>2]|0)){c=b+364|0;h=b+372|0;e=b+368|0;N=0;do l=a[b+296+(N<<2)>>2]|0,n=a[f>>2]|0,F=a[l>>2]&255,Oa=a[n>>2]|0,a[n>>2]=Oa+1,t[Oa>>0]=F,F=n+4|0,Oa=(a[F>>2]|0)+-1|0,a[F>>2]=Oa,0==(Oa|0)&&0==(da[a[n+12>>2]&63](b)|0)&&(n=a[b>>2]|0,a[n+20>>2]=25,
R[a[n>>2]&127](b)),m=0==(a[c>>2]|0)&&0==(a[h>>2]|0)?a[l+20>>2]|0:0,k=a[e>>2]|0?a[l+24>>2]|0:0,l=a[f>>2]|0,n=a[l>>2]|0,a[l>>2]=n+1,t[n>>0]=k+(m<<4),n=l+4|0,Oa=(a[n>>2]|0)+-1|0,a[n>>2]=Oa,0==(Oa|0)&&0==(da[a[l+12>>2]&63](b)|0)&&(l=a[b>>2]|0,a[l+20>>2]=25,R[a[l>>2]&127](b)),N=N+1|0;while((N|0)<(a[g>>2]|0));e=c}else e=b+364|0;c=a[f>>2]|0;g=a[e>>2]&255;e=a[c>>2]|0;a[c>>2]=e+1;t[e>>0]=g;g=c+4|0;e=(a[g>>2]|0)+-1|0;a[g>>2]=e;0==(e|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));
c=a[f>>2]|0;e=a[b+368>>2]&255;g=a[c>>2]|0;a[c>>2]=g+1;t[g>>0]=e;e=c+4|0;g=(a[e>>2]|0)+-1|0;a[e>>2]=g;0==(g|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));c=a[f>>2]|0;f=(a[b+372>>2]<<4)+(a[b+376>>2]|0)&255;g=a[c>>2]|0;a[c>>2]=g+1;t[g>>0]=f;f=c+4|0;g=(a[f>>2]|0)+-1|0;a[f>>2]=g;g||da[a[c+12>>2]&63](b)|0||(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));u=d},function(b){b|=0;var d,c,e,f;d=b+24|0;c=a[d>>2]|0;e=a[c>>2]|0;a[c>>2]=e+1;t[e>>0]=-1;e=c+4|0;f=(a[e>>2]|0)+-1|0;a[e>>
2]=f;0==(f|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));c=a[d>>2]|0;d=a[c>>2]|0;a[c>>2]=d+1;t[d>>0]=-39;d=c+4|0;f=(a[d>>2]|0)+-1|0;a[d>>2]=f;f||da[a[c+12>>2]&63](b)|0||(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b))},function(b){b|=0;var d,c,e,f;d=b+24|0;c=a[d>>2]|0;e=a[c>>2]|0;a[c>>2]=e+1;t[e>>0]=-1;e=c+4|0;f=(a[e>>2]|0)+-1|0;a[e>>2]=f;0==(f|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));c=a[d>>2]|0;f=a[c>>2]|0;a[c>>2]=f+1;t[f>>0]=-40;
f=c+4|0;e=(a[f>>2]|0)+-1|0;a[f>>2]=e;0==(e|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));a[b+88>>2]|0&&ei(b,0)|0;a[b+92>>2]|0&&ei(b,1)|0;a[b+96>>2]|0&&ei(b,2)|0;a[b+100>>2]|0&&ei(b,3)|0;a[b+212>>2]|0||(a[b+120>>2]|0&&Me(b,0,0),a[b+136>>2]|0&&Me(b,0,1),a[b+124>>2]|0&&Me(b,1,0),a[b+140>>2]|0&&Me(b,1,1),a[b+128>>2]|0&&Me(b,2,0),a[b+144>>2]|0&&Me(b,2,1),a[b+132>>2]|0&&Me(b,3,0),a[b+148>>2]|0&&Me(b,3,1));c=a[d>>2]|0;e=a[c>>2]|0;a[c>>2]=e+1;t[e>>0]=-1;e=c+4|0;f=(a[e>>2]|
0)+-1|0;a[e>>2]=f;0==(f|0)&&0==(da[a[c+12>>2]&63](b)|0)&&(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));c=a[d>>2]|0;d=a[c>>2]|0;a[c>>2]=d+1;t[d>>0]=-39;d=c+4|0;f=(a[d>>2]|0)+-1|0;a[d>>2]=f;f||da[a[c+12>>2]&63](b)|0||(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b))},function(b){b|=0;var d,c,e,f=0;d=a[b+392>>2]|0;c=d+20|0;a:do switch(a[c>>2]|0){case 0:Vg(b);Jf(b);a[b+208>>2]|0||(R[a[a[b+412>>2]>>2]&127](b),R[a[a[b+416>>2]>>2]&127](b),ub[a[a[b+400>>2]>>2]&31](b,0));R[a[a[b+420>>2]>>2]&127](b);c=b+216|0;
ub[a[a[b+424>>2]>>2]&31](b,a[c>>2]|0);ub[a[a[b+404>>2]>>2]&31](b,1<(a[d+28>>2]|0)?3:0);ub[a[a[b+396>>2]>>2]&31](b,0);e=d+12|0;a[e>>2]=a[c>>2]|0?0:1;break a;case 1:Vg(b);Jf(b);if(0==(a[b+364>>2]|0)&&0!=(a[b+372>>2]|0)){a[c>>2]=2;e=d+24|0;a[e>>2]=(a[e>>2]|0)+1;f=11;break a}ub[a[a[b+424>>2]>>2]&31](b,1);ub[a[a[b+404>>2]>>2]&31](b,2);a[d+12>>2]=0;break;case 2:f=11;break;default:e=a[b>>2]|0,a[e+20>>2]=49,R[a[e>>2]&127](b)}while(0);if(11==(f|0)){a[b+216>>2]|0||(Vg(b),Jf(b));ub[a[a[b+424>>2]>>2]&31](b,0);
ub[a[a[b+404>>2]>>2]&31](b,2);f=b+408|0;if(!(a[d+32>>2]|0))R[a[(a[f>>2]|0)+4>>2]&127](b);R[a[(a[f>>2]|0)+8>>2]&127](b);a[d+12>>2]=0}f=a[d+24>>2]|0;c=a[d+28>>2]|0;a[d+16>>2]=(f|0)==(c+-1|0)&1;if(d=a[b+8>>2]|0)a[d+12>>2]=f,a[d+16>>2]=c},function(b){b|=0;var d;a[(a[b+392>>2]|0)+12>>2]=0;d=b+408|0;R[a[(a[d>>2]|0)+4>>2]&127](b);R[a[(a[d>>2]|0)+8>>2]&127](b)},function(b){b|=0;var d,c;d=a[b+392>>2]|0;R[a[(a[b+424>>2]|0)+8>>2]&127](b);c=d+20|0;switch(a[c>>2]|0){case 0:a[c>>2]=2;a[b+216>>2]|0||(b=d+32|0,a[b>>
2]=(a[b>>2]|0)+1);break;case 1:a[c>>2]=2;break;case 2:a[b+216>>2]|0&&(a[c>>2]=1),c=d+32|0,a[c>>2]=(a[c>>2]|0)+1}c=d+24|0;a[c>>2]=(a[c>>2]|0)+1},function(a){},function(b){b|=0;var d;d=a[b+460>>2]|0;a[d>>2]=46;a[d+16>>2]=0;a[d+20>>2]=0;a[d+24>>2]=1;R[a[(a[b>>2]|0)+16>>2]&127](b);R[a[a[b+464>>2]>>2]&127](b);a[b+160>>2]=0},$g,function(b){b|=0;R[a[(a[b+468>>2]|0)+8>>2]&127](b);a[a[b+460>>2]>>2]=46},function(b){b|=0;var d;d=a[b+464>>2]|0;a[b+216>>2]=0;a[b+144>>2]=0;a[b+440>>2]=0;a[d+12>>2]=0;a[d+16>>2]=
0;a[d+24>>2]=0;a[d+164>>2]=0},function(b){b|=0;var d,c,e,f;d=a[b+444>>2]|0;c=d+8|0;if(a[c>>2]|0)a[c>>2]=0,ub[a[a[b+484>>2]>>2]&31](b,0),ub[a[a[b+456>>2]>>2]&31](b,2),ub[a[a[b+448>>2]>>2]&31](b,2);else if(e=b+84|0,0!=(a[e>>2]|0)&&0==(a[b+136>>2]|0)&&(0!=(a[b+92>>2]|0)&&0!=(a[b+108>>2]|0)?(a[b+484>>2]=a[d+24>>2],a[c>>2]=1):a[b+100>>2]|0?a[b+484>>2]=a[d+20>>2]:(f=a[b>>2]|0,a[f+20>>2]=47,R[a[f>>2]&127](b))),R[a[a[b+472>>2]>>2]&127](b),R[a[(a[b+452>>2]|0)+8>>2]&127](b),!(a[b+68>>2]|0)){if(!(a[d+16>>2]|
0))R[a[a[b+480>>2]>>2]&127](b);R[a[a[b+476>>2]>>2]&127](b);if(a[e>>2]|0)ub[a[a[b+484>>2]>>2]&31](b,a[c>>2]|0);ub[a[a[b+456>>2]>>2]&31](b,0!=(a[c>>2]|0)?3:0);ub[a[a[b+448>>2]>>2]&31](b,0)}if(e=a[b+8>>2]|0)f=a[d+12>>2]|0,a[e+12>>2]=f,d=(0!=(a[c>>2]|0)?2:1)+f|0,f=e+16|0,a[f>>2]=d,a[b+64>>2]|0&&(a[(a[b+460>>2]|0)+20>>2]|0||(a[f>>2]=d+(0!=(a[b+108>>2]|0)?2:1)))},function(b){b|=0;var d;d=a[b+444>>2]|0;if(a[b+84>>2]|0)R[a[(a[b+484>>2]|0)+8>>2]&127](b);b=d+12|0;a[b>>2]=(a[b>>2]|0)+1},function(b){b|=0;var d;
d=a[b+476>>2]|0;a[d+36>>2]=0;a[d+44>>2]=a[b+116>>2]},function(b){b|=0;var d;d=a[b+476>>2]|0;a[d+92>>2]=a[b+320>>2];a[d+96>>2]=a[b+116>>2]},function(b){b|=0;R[a[(a[b>>2]|0)+8>>2]&127](b);fi(b);vl(1)},function(b){b|=0;var d,c;d=u;u=u+208|0;c=d+8|0;ub[a[(a[b>>2]|0)+12>>2]&31](b,c);b=a[30710]|0;a[d>>2]=c;Ld(b,160973,d)|0;u=d},function(b){b=a[(b|0)>>2]|0;a[b+108>>2]=0;a[b+20>>2]=0},function(a){},function(b){b|=0;var d;d=a[b>>2]|0;a[d+20>>2]=47;R[a[d>>2]&127](b)},function(b){a[(a[(b|0)+484>>2]|0)+28>>2]=
1},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,H,r,z,u,C,x,V,v,J,I,G,L,K;d=b+484|0;c=a[d>>2]|0;e=b+136|0;a[e>>2]=a[c+16>>2];f=a[c+20>>2]|0;g=Aa[a[a[b+4>>2]>>2]&63](b,1,f<<5)|0;a[g>>2]=0;a[g+4>>2]=31;a[g+8>>2]=0;a[g+12>>2]=63;a[g+16>>2]=0;a[g+20>>2]=31;mk(b,g);if(1<(f|0)){for(h=1;;){if((h<<1|0)>(f|0))for(m=g,n=l=k=0;;)if(p=a[m+24>>2]|0,y=(q=(p|0)>(l|0))?m:n,k=k+1|0,(k|0)==(h|0)){B=y;break}else m=m+32|0,l=q?p:l,n=y;else for(n=g,k=m=l=0;;)if(y=a[n+28>>2]|0,(y|0)>(m|0)?(H=(p=0<(a[n+24>>2]|0))?y:
m,r=p?n:k):(H=m,r=k),l=l+1|0,(l|0)==(h|0)){B=r;break}else n=n+32|0,m=H,k=r;if(!B){z=h;break}k=g+(h<<5)|0;m=B+4|0;a[g+(h<<5)+4>>2]=a[m>>2];n=B+12|0;a[g+(h<<5)+12>>2]=a[n>>2];l=B+20|0;a[g+(h<<5)+20>>2]=a[l>>2];a[k>>2]=a[B>>2];p=B+8|0;y=g+(h<<5)+8|0;a[y>>2]=a[p>>2];q=B+16|0;u=g+(h<<5)+16|0;a[u>>2]=a[q>>2];C=a[m>>2]|0;x=a[B>>2]|0;V=C-x<<4;v=a[n>>2]|0;J=a[p>>2]|0;p=12*(v-J|0)|0;I=a[l>>2]|0;G=a[q>>2]|0;q=(V|0)>(p|0);switch(((I-G<<3|0)>((q?V:p)|0)?2:q&1^1)|0){case 0:q=(x+C|0)/2|0;a[m>>2]=q;a[k>>2]=q+1;break;
case 1:q=(J+v|0)/2|0;a[n>>2]=q;a[y>>2]=q+1;break;case 2:q=(G+I|0)/2|0,a[l>>2]=q,a[u>>2]=q+1}mk(b,B);mk(b,k);k=h+1|0;if((k|0)<(f|0))h=k;else{z=k;break}}if(0<(z|0))L=z;else{d=z;a[(b+132|0)>>2]=d;e=a[b>>2]|0;a[(e+20|0)>>2]=98;a[(e+24|0)>>2]=d;d=a[(e+4|0)>>2]|0;ub[d&31](b,1);a[(c+28|0)>>2]=1;return}}else L=1;z=0;do{h=a[(a[d>>2]|0)+24>>2]|0;f=a[g+(z<<5)>>2]|0;B=a[g+(z<<5)+4>>2]|0;r=a[g+(z<<5)+8>>2]|0;H=a[g+(z<<5)+12>>2]|0;k=a[g+(z<<5)+16>>2]|0;q=a[g+(z<<5)+20>>2]|0;if((f|0)>(B|0))q=l=k=h=0;else for(u=
(r|0)>(H|0),l=(k|0)>(q|0),I=f,n=y=G=f=0;;){if(u)C=f,v=G,J=y,V=n;else for(v=a[h+(I<<2)>>2]|0,J=I<<3|4,m=f,C=r,x=G,p=y,V=n;;){if(l)n=m;else for(n=C<<2|2,f=x,x=k,y=p,p=v+(C<<6)+(k<<1)|0,G=V;;)if(V=w[p>>1]|0,K=V&65535,V<<16>>16?(m=(E(K,J)|0)+m|0,f=(E(K,n)|0)+f|0,V=(E(K,x<<3|4)|0)+y|0,G=K+G|0):V=y,(x|0)<(q|0))x=x+1|0,y=V,p=p+2|0;else{n=m;x=f;p=V;V=G;break}if((C|0)<(H|0))m=n,C=C+1|0;else{C=n;v=x;J=p;break}}if((I|0)<(B|0))I=I+1|0,f=C,G=v,y=J,n=V;else{h=C;k=v;l=J;q=V;break}}n=q>>1;t[(a[a[e>>2]>>2]|0)+z>>
0]=(n+h|0)/(q|0)|0;t[(a[(a[e>>2]|0)+4>>2]|0)+z>>0]=(n+k|0)/(q|0)|0;t[(a[(a[e>>2]|0)+8>>2]|0)+z>>0]=(n+l|0)/(q|0)|0;z=z+1|0}while((z|0)!=(L|0));d=L;a[(b+132|0)>>2]=d;e=a[b>>2]|0;a[(e+20|0)>>2]=98;a[(e+24|0)>>2]=d;d=a[(e+4|0)>>2]|0;ub[d&31](b,1);a[(c+28|0)>>2]=1},function(a){},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,u,C;d=b+4|0;c=a[d>>2]|0;e=c+68|0;if(f=a[e>>2]|0)for(k=m=0,l=f;;)if(a[l>>2]|0?(p=m,q=k):(f=a[l+8>>2]|0,n=(E(f,a[l+12>>2]|0)|0)+k|0,p=(E(a[l+4>>2]|0,f)|0)+m|0,q=n),l=a[l+44>>
2]|0)m=p,k=q;else{g=p;h=q;break}else h=g=0;q=c+72|0;if(k=a[q>>2]|0)for(p=k,k=g,g=h;;)if(a[p>>2]|0?(t=k,r=g):(h=a[p+8>>2]|0,m=(E(a[p+12>>2]<<7,h)|0)+g|0,t=(E(h<<7,a[p+4>>2]|0)|0)+k|0,r=m),p=a[p+44>>2]|0)k=t,g=r;else{y=t;B=r;break}else y=g,B=h;if(!(1>(B|0))){r=y|0;(r|0)<(y|0)?(y=(r|0)/(B|0)|0,z=1>(y|0)?1:y):z=1E9;if(y=a[e>>2]|0){e=c+80|0;B=y;do{if(!(a[B>>2]|0)){y=a[B+4>>2]|0;r=a[B+12>>2]|0;((((y+-1|0)>>>0)/(r>>>0)|0)+1|0)>(z|0)?(g=E(r,z)|0,r=B+16|0,a[r>>2]=g,g=B+8|0,Vh(b,B+48|0,E(a[g>>2]|0,y)|0),a[B+
40>>2]=1,n=g,u=a[r>>2]|0):(a[B+16>>2]=y,n=B+8|0,u=y);y=a[n>>2]|0;r=a[d>>2]|0;g=999999984/(y>>>0)|0;g||(t=a[b>>2]|0,a[t+20>>2]=72,R[a[t>>2]&127](b));t=(g|0)<(u|0)?g:u;a[r+80>>2]=t;r=ih(b,1,u<<2)|0;if(u)for(g=~u,k=0,p=t;;){t=u-k|0;m=p;p=p>>>0<t>>>0?p:t;t=E(p,y)|0;h=a[d>>2]|0;999999984<t>>>0&&(l=a[b>>2]|0,a[l+20>>2]=56,a[l+24>>2]=3,R[a[l>>2]&127](b));l=t&7;n=(0==(l|0)?0:8-l|0)+t|0;t=n+16|0;l=Hc(t|0)|0;l||(f=a[b>>2]|0,a[f+20>>2]=56,a[f+24>>2]=4,R[a[f>>2]&127](b));f=h+76|0;a[f>>2]=(a[f>>2]|0)+t;t=h+64|
0;a[l>>2]=a[t>>2];a[l+4>>2]=n;a[l+8>>2]=0;a[t>>2]=l;if(p){t=k+g|0;n=~m;m=t>>>0>n>>>0;h=k;f=p;for(C=l+16|0;;)if(a[r+(h<<2)>>2]=C,f=f+-1|0)h=h+1|0,C=C+y|0;else break;m=k+-1-(m?t:n)|0}else m=k;if(m>>>0>=u>>>0)break;else k=m}a[B>>2]=r;a[B+20>>2]=a[e>>2];a[B+24>>2]=0;a[B+28>>2]=0;a[B+36>>2]=0}B=a[B+44>>2]|0}while(0!=(B|0))}if(B=a[q>>2]|0){q=c+80|0;c=B;do{if(!(a[c>>2]|0)){B=a[c+4>>2]|0;e=a[c+12>>2]|0;((((B+-1|0)>>>0)/(e>>>0)|0)+1|0)>(z|0)?(m=E(e,z)|0,e=c+16|0,a[e>>2]=m,m=c+8|0,Vh(b,c+48|0,E(B<<7,a[m>>2]|
0)|0),a[c+40>>2]=1,y=m,r=a[e>>2]|0):(a[c+16>>2]=B,y=c+8|0,r=B);B=a[y>>2]|0;e=a[d>>2]|0;m=B<<7;u=999999984/(m>>>0)|0;u||(n=a[b>>2]|0,a[n+20>>2]=72,R[a[n>>2]&127](b));n=(u|0)<(r|0)?u:r;a[e+80>>2]=n;e=ih(b,1,r<<2)|0;if(r)for(u=~r,k=0,y=n;;){n=r-k|0;p=y;y=y>>>0<n>>>0?y:n;n=E(y,m)|0;g=a[d>>2]|0;999999984<n>>>0&&(C=a[b>>2]|0,a[C+20>>2]=56,a[C+24>>2]=3,R[a[C>>2]&127](b));C=n|16;h=Hc(C|0)|0;h||(f=a[b>>2]|0,a[f+20>>2]=56,a[f+24>>2]=4,R[a[f>>2]&127](b));f=g+76|0;a[f>>2]=(a[f>>2]|0)+C;C=g+64|0;a[h>>2]=a[C>>
2];a[h+4>>2]=n;a[h+8>>2]=0;a[C>>2]=h;if(y){C=k+u|0;n=~p;p=C>>>0>n>>>0;g=k;f=y;for(l=h+16|0;;)if(a[e+(g<<2)>>2]=l,f=f+-1|0)g=g+1|0,l=l+(B<<7)|0;else break;f=k+-1-(p?C:n)|0}else f=k;if(f>>>0>=r>>>0)break;else k=f}a[c>>2]=e;a[c+20>>2]=a[q>>2];a[c+24>>2]=0;a[c+28>>2]=0;a[c+36>>2]=0}c=a[c+44>>2]|0}while(0!=(c|0))}}},function(b){b|=0;sk(b,1);sk(b,0);b=b+4|0;Gc(a[b>>2]|0);a[b>>2]=0},Wh,function(a){},function(b){b|=0;var d,c;d=a[b+412>>2]|0;c=Aa[a[a[b+4>>2]>>2]&63](b,1,8192)|0;a[d+8>>2]=c;d=0;do a[c+(d<<
2)>>2]=19595*d,a[c+(d+256<<2)>>2]=38470*d,a[c+(d+512<<2)>>2]=(7471*d|0)+32768,b=E(d,-11058)|0,a[c+(d+768<<2)>>2]=b,b=E(d,-21710)|0,a[c+(d+1024<<2)>>2]=b,a[c+(d+1280<<2)>>2]=(d<<15)+8421375,b=E(d,-27439)|0,a[c+(d+1536<<2)>>2]=b,b=E(d,-5329)|0,a[c+(d+1792<<2)>>2]=b,d=d+1|0;while(256!=(d|0))},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n=0,p,q,y,B;d=a[b+420>>2]|0;c=b+76|0;if(!(0>=(a[c>>2]|0)))for(e=b+232|0,f=0,g=a[b+84>>2]|0,h=0;;){m=a[g+36>>2]|0;k=g+40|0;a:do switch((m<<8)+(a[k>>2]|0)|0){case 257:a[d+44+
(f<<2)>>2]=45;l=0;break;case 514:a[d+44+(f<<2)>>2]=46;l=0;break;case 771:a[d+44+(f<<2)>>2]=47;l=0;break;case 1028:a[d+44+(f<<2)>>2]=48;l=0;break;case 1285:a[d+44+(f<<2)>>2]=49;l=0;break;case 1542:a[d+44+(f<<2)>>2]=50;l=0;break;case 1799:a[d+44+(f<<2)>>2]=51;l=0;break;case 2313:a[d+44+(f<<2)>>2]=52;l=0;break;case 2570:a[d+44+(f<<2)>>2]=53;l=0;break;case 2827:a[d+44+(f<<2)>>2]=54;l=0;break;case 3084:a[d+44+(f<<2)>>2]=55;l=0;break;case 3341:a[d+44+(f<<2)>>2]=56;l=0;break;case 3598:a[d+44+(f<<2)>>2]=
57;l=0;break;case 3855:a[d+44+(f<<2)>>2]=58;l=0;break;case 4112:a[d+44+(f<<2)>>2]=59;l=0;break;case 4104:a[d+44+(f<<2)>>2]=60;l=0;break;case 3591:a[d+44+(f<<2)>>2]=61;l=0;break;case 3078:a[d+44+(f<<2)>>2]=62;l=0;break;case 2565:a[d+44+(f<<2)>>2]=63;l=0;break;case 2052:a[d+44+(f<<2)>>2]=64;l=0;break;case 1539:a[d+44+(f<<2)>>2]=65;l=0;break;case 1026:a[d+44+(f<<2)>>2]=66;l=0;break;case 513:a[d+44+(f<<2)>>2]=67;l=0;break;case 2064:a[d+44+(f<<2)>>2]=68;l=0;break;case 1806:a[d+44+(f<<2)>>2]=69;l=0;break;
case 1548:a[d+44+(f<<2)>>2]=70;l=0;break;case 1290:a[d+44+(f<<2)>>2]=71;l=0;break;case 1032:a[d+44+(f<<2)>>2]=72;l=0;break;case 774:a[d+44+(f<<2)>>2]=73;l=0;break;case 516:a[d+44+(f<<2)>>2]=74;l=0;break;case 258:a[d+44+(f<<2)>>2]=75;l=0;break;case 2056:switch(a[e>>2]|0){case 0:a[d+44+(f<<2)>>2]=76;l=0;break a;case 1:a[d+44+(f<<2)>>2]=77;l=1;break a;case 2:a[d+84+(f<<2)>>2]=78;l=2;break a;default:n=a[b>>2]|0;a[n+20>>2]=49;R[a[n>>2]&127](b);l=h;break a}default:n=a[b>>2]|0,a[n+20>>2]=7,a[n+24>>2]=m,
a[n+28>>2]=a[k>>2],R[a[n>>2]&127](b),l=h}while(0);k=a[g+16>>2]|0;m=b+88+(k<<2)|0;3>=k>>>0&&(n=a[m>>2]|0,0!=(n|0))?h=n:(n=a[b>>2]|0,a[n+20>>2]=54,a[n+24>>2]=k,R[a[n>>2]&127](b),h=a[m>>2]|0);switch(l|0){case 0:m=a[g+84>>2]|0;n=0!=(a[g+52>>2]|0)?4:3;k=0;do a[m+(k<<2)>>2]=N[h+(k<<1)>>1]<<n,k=k+1|0;while(64!=(k|0));a[d+4+(f<<2)>>2]=9;break;case 1:k=a[g+84>>2]|0;n=0!=(a[g+52>>2]|0)?10:11;m=1<<n+-1;p=0;do q=m+(E(w[128808+(p<<1)>>1]|0,N[h+(p<<1)>>1]|0)|0)>>n,a[k+(p<<2)>>2]=q,p=p+1|0;while(64!=(p|0));a[d+
4+(f<<2)>>2]=9;break;case 2:p=a[g+84>>2]|0;y=0!=(a[g+52>>2]|0)?16:8;for(n=k=0;B=+Hb[8+(n<<3)>>3],W[p+(k<<2)>>2]=1/(+(N[h+(k<<1)>>1]|0)*B*y),m=k|1,W[p+(m<<2)>>2]=1/(+(N[h+(m<<1)>>1]|0)*B*1.387039845*y),q=m+1|0,W[p+(q<<2)>>2]=1/(+(N[h+(q<<1)>>1]|0)*B*1.306562965*y),q=k|3,W[p+(q<<2)>>2]=1/(+(N[h+(q<<1)>>1]|0)*B*1.175875602*y),m=q+1|0,W[p+(m<<2)>>2]=1/(+(N[h+(m<<1)>>1]|0)*B*y),m=q+2|0,W[p+(m<<2)>>2]=1/(+(N[h+(m<<1)>>1]|0)*B*.785694958*y),m=q+3|0,W[p+(m<<2)>>2]=1/(+(N[h+(m<<1)>>1]|0)*B*.5411961*y),m=k|
7,W[p+(m<<2)>>2]=1/(+(N[h+(m<<1)>>1]|0)*B*.275899379*y),n=n+1|0,8!=(n|0);)k=k+8|0;a[d+4+(f<<2)>>2]=10;break;default:k=a[b>>2]|0,a[k+20>>2]=49,R[a[k>>2]&127](b)}f=f+1|0;if((f|0)>=(a[c>>2]|0))break;else g=g+88|0,h=l}},function(b){b|=0;var d,c,e,f=0,g=0,h,m,k,l=0,n,p,q=0,y,B,H,r=0,z,Q,C,w,v,E;d=u;u=u+32|0;c=d+16|0;e=a[b+424>>2]|0;if(0!=(a[b+268>>2]|0)&&(f=e+128|0,g=a[f>>2]|0,0!=(g|0))){h=0;for(m=g;;)if(m>>=1)h=h+1|0;else{k=h;break}14<(k|0)&&(h=a[e+120>>2]|0,m=a[h>>2]|0,a[m+20>>2]=41,R[a[m>>2]&127](h));
h=a[e+124>>2]|0;m=k<<4;g=e+108|0;do if(a[g>>2]|0)z=(a[e+92+(h<<2)>>2]|0)+(m<<2)|0,a[z>>2]=(a[z>>2]|0)+1;else if(l=a[e+60+(h<<2)>>2]|0,n=a[l+(m<<2)>>2]|0,p=t[l+1024+m>>0]|0,l=p<<24>>24,0!=p<<24>>24||(p=a[e+120>>2]|0,q=a[p>>2]|0,a[q+20>>2]=41,R[a[q>>2]&127](p),0==(a[g>>2]|0))){p=e+16|0;q=(a[p>>2]|0)+l|0;y=e+12|0;B=((1<<l)+-1&n)<<24-q|a[y>>2];if(7<(q|0)){n=e+112|0;l=e+116|0;H=e+120|0;r=q;for(z=B;;)if(Q=z>>>16,C=Q&255,w=a[n>>2]|0,a[n>>2]=w+1,t[w>>0]=Q,Q=(a[l>>2]|0)+-1|0,a[l>>2]=Q,Q||(Q=a[H>>2]|0,w=a[Q+
24>>2]|0,da[a[w+12>>2]&63](Q)|0||(Q=a[H>>2]|0,v=a[Q>>2]|0,a[v+20>>2]=25,R[a[v>>2]&127](Q)),a[n>>2]=a[w>>2],a[l>>2]=a[w+4>>2]),255==(C|0)&&(C=a[n>>2]|0,a[n>>2]=C+1,t[C>>0]=0,C=(a[l>>2]|0)+-1|0,a[l>>2]=C,0==(C|0))&&(C=a[H>>2]|0,w=a[C+24>>2]|0,da[a[w+12>>2]&63](C)|0||(C=a[H>>2]|0,Q=a[C>>2]|0,a[Q+20>>2]=25,R[a[Q>>2]&127](C)),a[n>>2]=a[w>>2],a[l>>2]=a[w+4>>2]),w=z<<8,r=r+-8|0,7>=(r|0)){E=w;break}else z=w;v=q&7;B=E}else v=q;a[y>>2]=B;a[p>>2]=v}while(0);if(0!=(k|0)&&0==(a[g>>2]|0)){m=e+16|0;h=(a[m>>2]|0)+
k|0;v=e+12|0;B=(a[f>>2]&(1<<k)+-1)<<24-h|a[v>>2];if(7<(h|0)){k=e+112|0;E=e+116|0;z=e+120|0;r=h;for(l=B;!(n=l>>>16,H=n&255,w=a[k>>2]|0,a[k>>2]=w+1,t[w>>0]=n,n=(a[E>>2]|0)+-1|0,a[E>>2]=n,n||(n=a[z>>2]|0,w=a[n+24>>2]|0,da[a[w+12>>2]&63](n)|0||(n=a[z>>2]|0,C=a[n>>2]|0,a[C+20>>2]=25,R[a[C>>2]&127](n)),a[k>>2]=a[w>>2],a[E>>2]=a[w+4>>2]),255==(H|0)&&(H=a[k>>2]|0,a[k>>2]=H+1,t[H>>0]=0,H=(a[E>>2]|0)+-1|0,a[E>>2]=H,0==(H|0))&&(H=a[z>>2]|0,w=a[H+24>>2]|0,da[a[w+12>>2]&63](H)|0||(H=a[z>>2]|0,n=a[H>>2]|0,a[n+
20>>2]=25,R[a[n>>2]&127](H)),a[k>>2]=a[w>>2],a[E>>2]=a[w+4>>2]),w=l<<8,r=r+-8|0,7>=(r|0));)l=w;k=h&7;q=w}else k=h,q=B;a[v>>2]=q;a[m>>2]=k}a[f>>2]=0;f=e+132|0;k=a[f>>2]|0;a:do if(0!=(k|0)&0==(a[g>>2]|0))for(m=e+16|0,q=e+12|0,v=e+112|0,B=e+116|0,h=e+120|0,p=k,l=a[e+136>>2]|0,r=0;;){if(!r){E=a[m>>2]|0;k=E+1|0;z=((x[l>>0]|0)&1)<<23-E|a[q>>2];if(7<(k|0)){E=k;for(w=z;;)if(H=w>>>16,n=H&255,C=a[v>>2]|0,a[v>>2]=C+1,t[C>>0]=H,H=(a[B>>2]|0)+-1|0,a[B>>2]=H,H||(H=a[h>>2]|0,C=a[H+24>>2]|0,da[a[C+12>>2]&63](H)|
0||(H=a[h>>2]|0,Q=a[H>>2]|0,a[Q+20>>2]=25,R[a[Q>>2]&127](H)),a[v>>2]=a[C>>2],a[B>>2]=a[C+4>>2]),255==(n|0)&&(n=a[v>>2]|0,a[v>>2]=n+1,t[n>>0]=0,n=(a[B>>2]|0)+-1|0,a[B>>2]=n,0==(n|0))&&(n=a[h>>2]|0,C=a[n+24>>2]|0,da[a[C+12>>2]&63](n)|0||(n=a[h>>2]|0,H=a[n>>2]|0,a[H+20>>2]=25,R[a[H>>2]&127](n)),a[v>>2]=a[C>>2],a[B>>2]=a[C+4>>2]),C=w<<8,E=E+-8|0,7>=(E|0)){n=C;break}else w=C;H=k&7;z=n}else H=k;a[q>>2]=z;a[m>>2]=H}w=p+-1|0;if(!w)break a;p=w;l=l+1|0;r=a[g>>2]|0}while(0);a[f>>2]=0}a[c>>2]=0;a[c+4>>2]=0;a[c+
8>>2]=0;a[c+12>>2]=0;a[d>>2]=0;a[d+4>>2]=0;a[d+8>>2]=0;a[d+12>>2]=0;f=b+292|0;if(!(0>=(a[f>>2]|0))){g=b+364|0;H=b+372|0;z=b+368|0;n=0;do k=a[b+296+(n<<2)>>2]|0,0==(a[g>>2]|0)&&0==(a[H>>2]|0)&&(r=a[k+20>>2]|0,l=c+(r<<2)|0,0==(a[l>>2]|0))&&(p=b+120+(r<<2)|0,(m=a[p>>2]|0)?h=m:(q=Zi(b)|0,h=a[p>>2]=q),pi(b,h,a[e+76+(r<<2)>>2]|0),a[l>>2]=1),0!=(a[z>>2]|0)&&(l=a[k+24>>2]|0,k=d+(l<<2)|0,0==(a[k>>2]|0))&&(r=b+136+(l<<2)|0,(m=a[r>>2]|0)?h=m:(q=Zi(b)|0,h=a[r>>2]=q),pi(b,h,a[e+92+(l<<2)>>2]|0),a[k>>2]=1),n=n+
1|0;while((n|0)<(a[f>>2]|0))}u=d},function(b){b|=0;var d,c,e,f,g,h,m=0,k,l,n,p,q,y,B,H,r,z,Q,C,w,v;d=u;u=u+16|0;c=d;e=a[b+424>>2]|0;f=b+24|0;g=a[f>>2]|0;h=a[g>>2]|0;if(a[b+268>>2]|0){c=e+112|0;a[c>>2]=h;h=e+116|0;a[h>>2]=a[g+4>>2];g=e+128|0;if(q=a[g>>2]|0){H=0;for(n=q;;)if(n>>=1)H=H+1|0;else{z=H;break}14<(z|0)&&(H=a[e+120>>2]|0,n=a[H>>2]|0,a[n+20>>2]=41,R[a[n>>2]&127](H));H=a[e+124>>2]|0;n=z<<4;q=e+108|0;do if(a[q>>2]|0)l=(a[e+92+(H<<2)>>2]|0)+(n<<2)|0,a[l>>2]=(a[l>>2]|0)+1;else if(w=a[e+60+(H<<2)>>
2]|0,k=a[w+(n<<2)>>2]|0,C=t[w+1024+n>>0]|0,w=C<<24>>24,0!=C<<24>>24||(C=a[e+120>>2]|0,m=a[C>>2]|0,a[m+20>>2]=41,R[a[m>>2]&127](C),0==(a[q>>2]|0))){C=e+16|0;m=(a[C>>2]|0)+w|0;Q=e+12|0;p=((1<<w)+-1&k)<<24-m|a[Q>>2];if(7<(m|0)){k=e+120|0;w=m;for(l=p;;)if(y=l>>>16,b=y&255,r=a[c>>2]|0,a[c>>2]=r+1,t[r>>0]=y,y=(a[h>>2]|0)+-1|0,a[h>>2]=y,y||(y=a[k>>2]|0,r=a[y+24>>2]|0,da[a[r+12>>2]&63](y)|0||(y=a[k>>2]|0,B=a[y>>2]|0,a[B+20>>2]=25,R[a[B>>2]&127](y)),a[c>>2]=a[r>>2],a[h>>2]=a[r+4>>2]),255==(b|0)&&(b=a[c>>2]|
0,a[c>>2]=b+1,t[b>>0]=0,b=(a[h>>2]|0)+-1|0,a[h>>2]=b,0==(b|0))&&(b=a[k>>2]|0,r=a[b+24>>2]|0,da[a[r+12>>2]&63](b)|0||(b=a[k>>2]|0,y=a[b>>2]|0,a[y+20>>2]=25,R[a[y>>2]&127](b)),a[c>>2]=a[r>>2],a[h>>2]=a[r+4>>2]),r=l<<8,w=w+-8|0,7>=(w|0)){v=r;break}else l=r;B=m&7;p=v}else B=m;a[Q>>2]=p;a[C>>2]=B}while(0);if(0!=(z|0)&&0==(a[q>>2]|0)){n=e+16|0;H=(a[n>>2]|0)+z|0;B=e+12|0;p=(a[g>>2]&(1<<z)+-1)<<24-H|a[B>>2];if(7<(H|0)){z=e+120|0;v=H;for(l=p;!(w=l>>>16,k=w&255,r=a[c>>2]|0,a[c>>2]=r+1,t[r>>0]=w,w=(a[h>>2]|
0)+-1|0,a[h>>2]=w,w||(w=a[z>>2]|0,r=a[w+24>>2]|0,da[a[r+12>>2]&63](w)|0||(w=a[z>>2]|0,b=a[w>>2]|0,a[b+20>>2]=25,R[a[b>>2]&127](w)),a[c>>2]=a[r>>2],a[h>>2]=a[r+4>>2]),255==(k|0)&&(k=a[c>>2]|0,a[c>>2]=k+1,t[k>>0]=0,k=(a[h>>2]|0)+-1|0,a[h>>2]=k,0==(k|0))&&(k=a[z>>2]|0,r=a[k+24>>2]|0,da[a[r+12>>2]&63](k)|0||(k=a[z>>2]|0,w=a[k>>2]|0,a[w+20>>2]=25,R[a[w>>2]&127](k)),a[c>>2]=a[r>>2],a[h>>2]=a[r+4>>2]),r=l<<8,v=v+-8|0,7>=(v|0));)l=r;b=H&7;m=r}else b=H,m=p;a[B>>2]=m;a[n>>2]=b}a[g>>2]=0;g=e+132|0;b=a[g>>2]|
0;a:do if(0!=(b|0)&0==(a[q>>2]|0))for(n=e+16|0,m=e+12|0,B=e+120|0,p=b,H=a[e+136>>2]|0,b=0;;){if(!b){l=a[n>>2]|0;v=l+1|0;z=((x[H>>0]|0)&1)<<23-l|a[m>>2];if(7<(v|0)){l=v;for(r=z;;)if(k=r>>>16,w=k&255,b=a[c>>2]|0,a[c>>2]=b+1,t[b>>0]=k,k=(a[h>>2]|0)+-1|0,a[h>>2]=k,k||(k=a[B>>2]|0,b=a[k+24>>2]|0,da[a[b+12>>2]&63](k)|0||(k=a[B>>2]|0,y=a[k>>2]|0,a[y+20>>2]=25,R[a[y>>2]&127](k)),a[c>>2]=a[b>>2],a[h>>2]=a[b+4>>2]),255==(w|0)&&(w=a[c>>2]|0,a[c>>2]=w+1,t[w>>0]=0,w=(a[h>>2]|0)+-1|0,a[h>>2]=w,0==(w|0))&&(w=a[B>>
2]|0,b=a[w+24>>2]|0,da[a[b+12>>2]&63](w)|0||(w=a[B>>2]|0,k=a[w>>2]|0,a[k+20>>2]=25,R[a[k>>2]&127](w)),a[c>>2]=a[b>>2],a[h>>2]=a[b+4>>2]),b=r<<8,l=l+-8|0,7>=(l|0)){k=b;break}else r=b;b=v&7}else b=v,k=z;a[m>>2]=k;a[n>>2]=b}r=p+-1|0;if(!r)break a;p=r;H=H+1|0;b=a[q>>2]|0}while(0);a[g>>2]=0}Yh(e);e=a[f>>2]|0;a[e>>2]=a[c>>2];a[e+4>>2]=a[h>>2]}else{m=a[g+4>>2]|0;k=e+12|0;l=a[k>>2]|0;n=e+16|0;p=a[n>>2]|0;q=e+20|0;a[c>>2]=a[q>>2];a[c+4>>2]=a[q+4>>2];a[c+8>>2]=a[q+8>>2];a[c+12>>2]=a[q+12>>2];a:do if(0<(p|0)){y=
h;B=m;g=p+7|0;for(e=127<<17-p|l;;){H=e>>>16;r=H&255;z=y+1|0;t[y>>0]=H;if(H=B+-1|0)B=z,y=H;else{y=a[f>>2]|0;if(!(da[a[y+12>>2]&63](b)|0)){y=z;break}B=a[y>>2]|0;y=a[y+4>>2]|0}if(255==(r|0))if(r=B,H=r+1|0,t[r>>0]=0,r=y+-1|0)B=H;else{z=a[f>>2]|0;if(!(da[a[z+12>>2]&63](b)|0)){y=H;break}r=a[z+4>>2]|0;B=a[z>>2]|0}else r=y;g=g+-8|0;if(7>=(g|0)){Q=B;C=r;H=w=0;break a}else y=B,B=r,e<<=8}e=a[b>>2]|0;a[e+20>>2]=25;R[a[e>>2]&127](b);Q=y;C=0;w=l;H=p}else Q=h,C=m,H=w=0;while(0);m=a[f>>2]|0;a[m>>2]=Q;a[m+4>>2]=C;
a[k>>2]=w;a[n>>2]=H;a[q>>2]=a[c>>2];a[q+4>>2]=a[c+4>>2];a[q+8>>2]=a[c+8>>2];a[q+12>>2]=a[c+12>>2]}u=d},function(b){b|=0;var d,c,e,f,g,h,m,k=0,l,n,p,q,y,B,H,r,z;d=a[b+468>>2]|0;c=b+224|0;e=b+412|0;f=a[e>>2]|0;g=0==(f|0);do if(a[c>>2]|0){h=b+416|0;m=a[h>>2]|0;k=g?m?11:7:(m|0)>=(f|0)&&(m|0)<=(a[b+436>>2]|0)&&1==(a[b+340>>2]|0)?7:11;do if(7==(k|0)){if(m=a[b+420>>2]|0){if(l=m+-1|0,(l|0)!=(a[b+424>>2]|0)){k=11;break}}else l=a[b+424>>2]|0;13<(l|0)&&(k=11)}while(0);11==(k|0)&&(l=a[b>>2]|0,a[l+20>>2]=17,a[l+
24>>2]=f,a[l+28>>2]=a[h>>2],a[l+32>>2]=a[b+420>>2],a[l+36>>2]=a[b+424>>2],R[a[l>>2]&127](b));l=b+340|0;m=a[l>>2]|0;if(0<(m|0)){n=b+160|0;p=b+420|0;q=b+424|0;m=0;do{y=a[(a[b+344+(m<<2)>>2]|0)+4>>2]|0;B=a[n>>2]|0;(H=a[e>>2]|0)?0>(a[B+(y<<8)>>2]|0)&&(r=a[b>>2]|0,a[r+20>>2]=118,a[r+24>>2]=y,a[r+28>>2]=0,ub[a[r+4>>2]&31](b,-1),H=a[e>>2]|0):H=0;if((H|0)<=(a[h>>2]|0))for(;;)if(r=B+(y<<8)+(H<<2)|0,z=a[r>>2]|0,(a[p>>2]|0)!=((0>(z|0)?0:z)|0)&&(z=a[b>>2]|0,a[z+20>>2]=118,a[z+24>>2]=y,a[z+28>>2]=H,ub[a[z+4>>
2]&31](b,-1)),a[r>>2]=a[q>>2],(H|0)<(a[h>>2]|0))H=H+1|0;else break;m=m+1|0;H=a[l>>2]|0}while((m|0)<(H|0));h=p;n=H}else h=b+420|0,n=m;p=0==(a[e>>2]|0);m=d+4|0;a[m>>2]=a[h>>2]|0?p?58:59:p?56:57;p=l;q=n}else g&&0==(a[b+420>>2]|0)&&0==(a[b+424>>2]|0)?(m=a[b+416>>2]|0,64>(m|0)&&(m|0)!=(a[b+436>>2]|0)&&(k=35)):k=35,35==(k|0)&&(m=a[b>>2]|0,a[m+20>>2]=125,ub[a[m+4>>2]&31](b,-1)),a[d+4>>2]=60,p=m=b+340|0,q=a[m>>2]|0;while(0);if(!(0>=(q|0))){q=b+4|0;g=b+436|0;n=b+420|0;h=0;do{H=a[b+344+(h<<2)>>2]|0;k=a[c>>
2]|0?a[e>>2]|0?49:a[n>>2]|0?48:42:42;if(42==(k|0)){k=0;f=a[H+20>>2]|0;15<f>>>0&&(l=a[b>>2]|0,a[l+20>>2]=50,a[l+24>>2]=f,R[a[l>>2]&127](b));l=d+60+(f<<2)|0;f=a[l>>2]|0;f||(m=Aa[a[a[q>>2]>>2]&63](b,1,64)|0,f=a[l>>2]=m);m=f+64|0;do t[f>>0]=0,f=f+1|0;while((f|0)<(m|0));a[d+24+(h<<2)>>2]=0;a[d+40+(h<<2)>>2]=0;a[c>>2]|0?k=48:a[g>>2]|0&&(k=49)}48==(k|0)&&(k=0,0!=(a[e>>2]|0))&&(k=49);49==(k|0)&&(f=a[H+24>>2]|0,15<f>>>0&&(m=a[b>>2]|0,a[m+20>>2]=50,a[m+24>>2]=f,R[a[m>>2]&127](b)),m=d+124+(f<<2)|0,(f=a[m>>2]|
0)?k=f:(l=Aa[a[a[q>>2]>>2]&63](b,1,256)|0,k=a[m>>2]=l),Va(k|0,0,256)|0);h=h+1|0}while((h|0)<(a[p>>2]|0))}a[(d+12|0)>>2]=0;a[(d+16|0)>>2]=0;a[(d+20|0)>>2]=-16;a[(d+56|0)>>2]=a[(b+280|0)>>2]|0},function(a){},function(b){b|=0;var d,c;a[b+148>>2]=0;d=a[b+452>>2]|0;1>=(a[b+340>>2]|0)?(c=a[b+344>>2]|0,a[d+28>>2]=1==(a[b+332>>2]|0)?a[c+76>>2]:a[c+12>>2]):a[d+28>>2]=1;a[d+20>>2]=0;a[d+24>>2]=0},function(b){b|=0;var d,c=0,e,f,g,h,m,k,l,n;d=a[b+452>>2]|0;if(a[d+16>>2]|0){a:do if(0!=(a[b+80>>2]|0)&&0!=(a[b+
224>>2]|0)&&(c=b+160|0,0!=(a[c>>2]|0))&&(e=d+112|0,(f=a[e>>2]|0)?(m=b+36|0,e=f):(g=b+36|0,h=Aa[a[a[b+4>>2]>>2]&63](b,1,24*(a[g>>2]|0)|0)|0,a[e>>2]=h,m=g,e=h),0<(a[m>>2]|0))){f=0;h=e;g=a[b+216>>2]|0;for(e=0;;){k=a[g+80>>2]|0;if(!k)break a;if(!(w[k>>1]|0))break a;if(!(w[k+2>>1]|0))break a;if(!(w[k+16>>1]|0))break a;if(!(w[k+32>>1]|0))break a;if(!(w[k+18>>1]|0))break a;if(!(w[k+4>>1]|0))break a;k=a[c>>2]|0;if(0>(a[k+(f<<8)>>2]|0))break a;l=k+(f<<8)+4|0;a[h+4>>2]=a[l>>2];n=a[l>>2]|0;l=k+(f<<8)+8|0;a[h+
8>>2]=a[l>>2];l=a[l>>2]|n;n=k+(f<<8)+12|0;a[h+12>>2]=a[n>>2];l|=a[n>>2];n=k+(f<<8)+16|0;a[h+16>>2]=a[n>>2];l|=a[n>>2];n=k+(f<<8)+20|0;a[h+20>>2]=a[n>>2];k=0==(l|a[n>>2]|0)?e:1;f=f+1|0;if((f|0)>=(a[m>>2]|0)){f=k;break}else h=h+24|0,g=g+88|0,e=k}if(f){a[d+12>>2]=63;b=b+156|0;a[b>>2]=0;return}}while(0);a[d+12>>2]=61}a[(b+156|0)>>2]=0},function(a){},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B;d=a[b+472>>2]|0;c=b+36|0;if(!(0>=(a[c>>2]|0)))for(e=b+72|0,f=0,g=a[b+216>>2]|0,m=h=0;;){k=a[g+36>>2]|0;l=
g+40|0;a:do switch((k<<8)+(a[l>>2]|0)|0){case 257:n=0;p=18;break;case 514:n=0;p=19;break;case 771:n=0;p=20;break;case 1028:n=0;p=21;break;case 1285:n=0;p=22;break;case 1542:n=0;p=23;break;case 1799:n=0;p=24;break;case 2313:n=0;p=25;break;case 2570:n=0;p=26;break;case 2827:n=0;p=27;break;case 3084:n=0;p=28;break;case 3341:n=0;p=29;break;case 3598:n=0;p=30;break;case 3855:n=0;p=31;break;case 4112:n=0;p=32;break;case 4104:n=0;p=33;break;case 3591:n=0;p=34;break;case 3078:n=0;p=35;break;case 2565:n=0;
p=36;break;case 2052:n=0;p=37;break;case 1539:n=0;p=38;break;case 1026:n=0;p=39;break;case 513:n=0;p=40;break;case 2064:n=0;p=41;break;case 1806:n=0;p=42;break;case 1548:n=0;p=43;break;case 1290:n=0;p=44;break;case 1032:n=0;p=45;break;case 774:n=0;p=46;break;case 516:n=0;p=47;break;case 258:n=0;p=48;break;case 2056:switch(q=a[e>>2]|0,q|0){case 0:n=0;p=49;break a;case 1:n=q;p=50;break a;case 2:n=q;p=51;break a;default:q=a[b>>2]|0;a[q+20>>2]=49;R[a[q>>2]&127](b);n=h;p=m;break a}default:q=a[b>>2]|0,
a[q+20>>2]=7,a[q+24>>2]=k,a[q+28>>2]=a[l>>2],R[a[q>>2]&127](b),n=h,p=m}while(0);a[d+4+(f<<2)>>2]=p;a:do if(0!=(a[g+52>>2]|0)&&(l=d+44+(f<<2)|0,(a[l>>2]|0)!=(n|0))&&(k=a[g+80>>2]|0,0!=(k|0)))switch(a[l>>2]=n,n|0){case 0:l=a[g+84>>2]|0;q=0;do a[l+(q<<2)>>2]=N[k+(q<<1)>>1],q=q+1|0;while(64!=(q|0));break;case 1:q=a[g+84>>2]|0;l=0;do h=(E(w[128808+(l<<1)>>1]|0,N[k+(l<<1)>>1]|0)|0)+2048>>12,a[q+(l<<2)>>2]=h,l=l+1|0;while(64!=(l|0));break;case 2:l=a[g+84>>2]|0;for(h=q=0;m=+Hb[8+(h<<3)>>3],W[l+(q<<2)>>2]=
+(N[k+(q<<1)>>1]|0)*m*.125,y=q|1,W[l+(y<<2)>>2]=+(N[k+(y<<1)>>1]|0)*m*.173379980625,B=y+1|0,W[l+(B<<2)>>2]=+(N[k+(B<<1)>>1]|0)*m*.163320370625,B=q|3,W[l+(B<<2)>>2]=+(N[k+(B<<1)>>1]|0)*m*.14698445025,y=B+1|0,W[l+(y<<2)>>2]=+(N[k+(y<<1)>>1]|0)*m*.125,y=B+2|0,W[l+(y<<2)>>2]=+(N[k+(y<<1)>>1]|0)*m*.09821186975,y=B+3|0,W[l+(y<<2)>>2]=+(N[k+(y<<1)>>1]|0)*m*.0676495125,y=q|7,W[l+(y<<2)>>2]=+(N[k+(y<<1)>>1]|0)*m*.034487422375,h=h+1|0,8!=(h|0);)q=q+8|0;break;default:q=a[b>>2]|0;a[q+20>>2]=49;R[a[q>>2]&127](b);
break a}while(0);f=f+1|0;if((f|0)>=(a[c>>2]|0))break;else g=g+88|0,h=n,m=p}},function(b){b|=0;var d,c,e,f,g,h=0,m,k,l,n,p,q,y;d=a[b+468>>2]|0;c=b+412|0;e=a[c>>2]|0;f=0==(e|0);if(a[b+224>>2]|0){m=b+416|0;n=a[m>>2]|0;h=f?n?11:7:(n|0)>=(e|0)&&(n|0)<=(a[b+436>>2]|0)&&1==(a[b+340>>2]|0)?7:11;do if(7==(h|0)){if(n=a[b+420>>2]|0)if(f=n+-1|0,(f|0)==(a[b+424>>2]|0))y=f;else{h=11;break}else y=a[b+424>>2]|0;13<(y|0)&&(h=11)}while(0);11==(h|0)&&(h=a[b>>2]|0,a[h+20>>2]=17,a[h+24>>2]=e,a[h+28>>2]=a[m>>2],a[h+32>>
2]=a[b+420>>2],a[h+36>>2]=a[b+424>>2],R[a[h>>2]&127](b));h=b+340|0;e=a[h>>2]|0;if(0<(e|0)){y=b+160|0;f=b+420|0;n=b+424|0;g=0;do{e=a[(a[b+344+(g<<2)>>2]|0)+4>>2]|0;l=a[y>>2]|0;(p=a[c>>2]|0)?0>(a[l+(e<<8)>>2]|0)&&(k=a[b>>2]|0,a[k+20>>2]=118,a[k+24>>2]=e,a[k+28>>2]=0,ub[a[k+4>>2]&31](b,-1),p=a[c>>2]|0):p=0;if((p|0)<=(a[m>>2]|0))for(;;)if(k=l+(e<<8)+(p<<2)|0,q=a[k>>2]|0,(a[f>>2]|0)!=((0>(q|0)?0:q)|0)&&(q=a[b>>2]|0,a[q+20>>2]=118,a[q+24>>2]=e,a[q+28>>2]=p,ub[a[q+4>>2]&31](b,-1)),a[k>>2]=a[n>>2],(p|0)<
(a[m>>2]|0))p=p+1|0;else break;g=g+1|0;p=a[h>>2]|0}while((g|0)<(p|0));y=f;g=p}else y=b+420|0,g=e;e=a[c>>2]|0;f=0==(e|0);a[(d+4|0)>>2]=a[y>>2]|0?f?66:67:f?64:65;a:do if(0<(g|0))for(g=d+64|0,f=e,m=0;;){n=a[b+344+(m<<2)>>2]|0;f?(p=a[n+24>>2]|0,n=d+48+(p<<2)|0,Fi(b,0,p,n),a[g>>2]=a[n>>2]):a[y>>2]|0||(p=a[n+20>>2]|0,Fi(b,1,p,d+48+(p<<2)|0));a[d+24+(m<<2)>>2]=0;n=m+1|0;if((n|0)>=(a[h>>2]|0))break a;f=a[c>>2]|0;m=n}while(0);a[d+20>>2]=0}else{f&&0==(a[b+420>>2]|0)&&0==(a[b+424>>2]|0)?(g=a[b+416>>2]|0,0!=
(a[b+220>>2]|0)|64>(g|0)&&(g|0)!=(a[b+436>>2]|0)&&(h=44)):h=44;44==(h|0)&&(g=a[b>>2]|0,a[g+20>>2]=125,ub[a[g+4>>2]&31](b,-1));g=b+436|0;a[d+4>>2]=63==(a[g>>2]|0)?68:69;m=b+340|0;if(0<(a[m>>2]|0)){e=0;do k=a[b+344+(e<<2)>>2]|0,l=a[k+20>>2]|0,Fi(b,1,l,d+68+(l<<2)|0),a[g>>2]|0&&(l=a[k+24>>2]|0,Fi(b,0,l,d+84+(l<<2)|0)),a[d+24+(e<<2)>>2]=0,e=e+1|0;while((e|0)<(a[m>>2]|0))}m=b+368|0;if(0<(a[m>>2]|0)){n=0;do{e=a[b+344+(a[b+372+(n<<2)>>2]<<2)>>2]|0;a[d+100+(n<<2)>>2]=a[d+68+(a[e+20>>2]<<2)>>2];a[d+140+(n<<
2)>>2]=a[d+84+(a[e+24>>2]<<2)>>2];a:do if(a[e+52>>2]|0)switch(l=a[e+40>>2]|0,k=a[e+36>>2]|0,a[g>>2]|0){case 0:a[d+180+(n<<2)>>2]=1;break a;case 3:p=l+-1|0;q=k+-1|0;a[d+180+(n<<2)>>2]=(a[121260+((1<p>>>0?1:p)<<3)+((1<q>>>0?1:q)<<2)>>2]|0)+1;break a;case 8:q=l+-1|0;p=k+-1|0;a[d+180+(n<<2)>>2]=(a[121276+(12*(2<q>>>0?2:q)|0)+((2<p>>>0?2:p)<<2)>>2]|0)+1;break a;case 15:p=l+-1|0;q=k+-1|0;a[d+180+(n<<2)>>2]=(a[121312+((3<p>>>0?3:p)<<4)+((3<q>>>0?3:q)<<2)>>2]|0)+1;break a;case 24:q=l+-1|0;p=k+-1|0;a[d+180+
(n<<2)>>2]=(a[121376+(20*(4<q>>>0?4:q)|0)+((4<p>>>0?4:p)<<2)>>2]|0)+1;break a;case 35:p=l+-1|0;q=k+-1|0;a[d+180+(n<<2)>>2]=(a[121476+(24*(5<p>>>0?5:p)|0)+((5<q>>>0?5:q)<<2)>>2]|0)+1;break a;case 48:q=l+-1|0;p=k+-1|0;a[d+180+(n<<2)>>2]=(a[121620+(28*(6<q>>>0?6:q)|0)+((6<p>>>0?6:p)<<2)>>2]|0)+1;break a;default:p=l+-1|0;l=k+-1|0;a[d+180+(n<<2)>>2]=(a[121816+((7<p>>>0?7:p)<<5)+((7<l>>>0?7:l)<<2)>>2]|0)+1;break a}else a[d+180+(n<<2)>>2]=0;while(0);n=n+1|0}while((n|0)<(a[m>>2]|0))}}a[(d+16|0)>>2]=0;a[(d+
12|0)>>2]=0;a[(d+40|0)>>2]=0;a[(d+44|0)>>2]=a[(b+280|0)>>2]|0},function(b){b|=0;var d;d=(a[b+468>>2]|0)+16|0;b=(a[b+464>>2]|0)+24|0;a[b>>2]=(a[b>>2]|0)+((a[d>>2]|0)/8|0);a[d>>2]=0},function(a){},fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc,fc],ub=[We,function(b,d){b|=0;d|=0;var c,e,f;0>=(d|0)||(c=b+800|0,e=c+4|0,f=a[e>>2]|0,f>>>0<d>>>0?(f=a[b>>2]|0,a[f+20>>2]=123,ub[a[f+4>>2]&31](b,
-1),a[c>>2]=145943,a[e>>2]=2):(a[c>>2]=(a[c>>2]|0)+d,a[e>>2]=f-d))},function(b,d){b|=0;d|=0;var c,e;c=a[b+20>>2]|0;100!=(c|0)&&(e=a[b>>2]|0,a[e+20>>2]=21,a[e+24>>2]=c,R[a[e>>2]&127](b));a[b+80>>2]=d;e=b+244|0;a[e>>2]=0;c=b+256|0;a[c>>2]=0;switch(d|0){case 0:d=a[b+36>>2]|0;e=b+76|0;a[e>>2]=d;9<(d+-1|0)>>>0?(c=a[b>>2]|0,a[c+20>>2]=27,a[c+24>>2]=d,a[c+28>>2]=10,R[a[c>>2]&127](b),c=a[e>>2]|0):c=d;if(0>=(c|0))break;d=a[b+84>>2]|0;e=0;do a[d+(88*e|0)>>2]=e,a[d+(88*e|0)+8>>2]=1,a[d+(88*e|0)+12>>2]=1,a[d+
(88*e|0)+16>>2]=0,a[d+(88*e|0)+20>>2]=0,a[d+(88*e|0)+24>>2]=0,e=e+1|0;while((e|0)<(c|0));break;case 1:a[e>>2]=1;a[b+76>>2]=1;c=a[b+84>>2]|0;a[c>>2]=1;a[c+8>>2]=1;a[c+12>>2]=1;a[c+16>>2]=0;a[c+20>>2]=0;a[c+24>>2]=0;break;case 2:a[c>>2]=1;a[b+76>>2]=3;c=a[b+84>>2]|0;a[c>>2]=82;a[c+8>>2]=1;a[c+12>>2]=1;a[c+16>>2]=0;e=1==(a[b+260>>2]|0)&1;a[c+20>>2]=e;a[c+24>>2]=e;a[c+88>>2]=71;a[c+96>>2]=1;a[c+100>>2]=1;a[c+104>>2]=0;a[c+108>>2]=0;a[c+112>>2]=0;a[c+176>>2]=66;a[c+184>>2]=1;a[c+188>>2]=1;a[c+192>>2]=
0;a[c+196>>2]=e;a[c+200>>2]=e;break;case 3:a[e>>2]=1;a[b+76>>2]=3;e=a[b+84>>2]|0;a[e>>2]=1;a[e+8>>2]=2;a[e+12>>2]=2;a[e+16>>2]=0;a[e+20>>2]=0;a[e+24>>2]=0;a[e+88>>2]=2;a[e+96>>2]=1;a[e+100>>2]=1;a[e+104>>2]=1;a[e+108>>2]=1;a[e+112>>2]=1;a[e+176>>2]=3;a[e+184>>2]=1;a[e+188>>2]=1;a[e+192>>2]=1;a[e+196>>2]=1;a[e+200>>2]=1;break;case 4:a[c>>2]=1;a[b+76>>2]=4;e=a[b+84>>2]|0;a[e>>2]=67;a[e+8>>2]=1;a[e+12>>2]=1;a[e+16>>2]=0;a[e+20>>2]=0;a[e+24>>2]=0;a[e+88>>2]=77;a[e+96>>2]=1;a[e+100>>2]=1;a[e+104>>2]=0;
a[e+108>>2]=0;a[e+112>>2]=0;a[e+176>>2]=89;a[e+184>>2]=1;a[e+188>>2]=1;a[e+192>>2]=0;a[e+196>>2]=0;a[e+200>>2]=0;a[e+264>>2]=75;a[e+272>>2]=1;a[e+276>>2]=1;a[e+280>>2]=0;a[e+284>>2]=0;a[e+288>>2]=0;break;case 5:a[c>>2]=1;a[b+76>>2]=4;c=a[b+84>>2]|0;a[c>>2]=1;a[c+8>>2]=2;a[c+12>>2]=2;a[c+16>>2]=0;a[c+20>>2]=0;a[c+24>>2]=0;a[c+88>>2]=2;a[c+96>>2]=1;a[c+100>>2]=1;a[c+104>>2]=1;a[c+108>>2]=1;a[c+112>>2]=1;a[c+176>>2]=3;a[c+184>>2]=1;a[c+188>>2]=1;a[c+192>>2]=1;a[c+196>>2]=1;a[c+200>>2]=1;a[c+264>>2]=
4;a[c+272>>2]=2;a[c+276>>2]=2;a[c+280>>2]=0;a[c+284>>2]=0;a[c+288>>2]=0;break;case 6:a[e>>2]=1;t[b+248>>0]=2;a[b+76>>2]=3;c=a[b+84>>2]|0;a[c>>2]=114;a[c+8>>2]=1;a[c+12>>2]=1;a[c+16>>2]=0;e=1==(a[b+260>>2]|0)&1;a[c+20>>2]=e;a[c+24>>2]=e;a[c+88>>2]=103;a[c+96>>2]=1;a[c+100>>2]=1;a[c+104>>2]=0;a[c+108>>2]=0;a[c+112>>2]=0;a[c+176>>2]=98;a[c+184>>2]=1;a[c+188>>2]=1;a[c+192>>2]=0;a[c+196>>2]=e;a[c+200>>2]=e;break;case 7:a[e>>2]=1;t[b+248>>0]=2;a[b+76>>2]=3;e=a[b+84>>2]|0;a[e>>2]=1;a[e+8>>2]=2;a[e+12>>2]=
2;a[e+16>>2]=0;a[e+20>>2]=0;a[e+24>>2]=0;a[e+88>>2]=34;a[e+96>>2]=1;a[e+100>>2]=1;a[e+104>>2]=1;a[e+108>>2]=1;a[e+112>>2]=1;a[e+176>>2]=35;a[e+184>>2]=1;a[e+188>>2]=1;a[e+192>>2]=1;a[e+196>>2]=1;a[e+200>>2]=1;break;default:e=a[b>>2]|0,a[e+20>>2]=11,R[a[e>>2]&127](b)}},function(b,d){b|=0;d|=0;var c,e,f;c=b+20|0;e=a[c>>2]|0;100!=(e|0)&&(f=a[b>>2]|0,a[f+20>>2]=21,a[f+24>>2]=e,R[a[f>>2]&127](b));d&&lg(b,0);R[a[(a[b>>2]|0)+16>>2]&127](b);R[a[(a[b+24>>2]|0)+8>>2]&127](b);var g=b,g=g|0,h,m;h=a[g+72>>2]|
0;8!=(h|0)&&(m=a[g>>2]|0,a[m+20>>2]=16,a[m+24>>2]=h,R[a[m>>2]&127](g));0!=(a[g+32>>2]|0)&&0!=(a[g+28>>2]|0)&&1<=(a[g+36>>2]|0)||(m=a[g>>2]|0,a[m+20>>2]=33,R[a[m>>2]&127](g));var k=g,l=0,k=k|0,l=l|0,n,p,q,y,B,H,r,z,Q,C,x,w,v,J,I,G,L,K,A,D=0,O,M,T,X,P,Oa,N,F,ba,S,Y,W,ga,Ha,ma,U,ha,da,aa,ca,Z,fa,ja;n=u;u=u+2608|0;p=n+2560|0;q=n;y=Aa[a[a[k+4>>2]>>2]&63](k,1,36)|0;a[k+392>>2]=y;a[y>>2]=35;a[y+4>>2]=36;a[y+8>>2]=37;a[y+16>>2]=0;if(B=0==(l|0)){var oa=k,oa=oa|0,sa,pa,ua,Ia,Da,na;sa=oa+28|0;16777215>=(a[sa>>
2]|0)>>>0&&16777215>=(a[oa+32>>2]|0)>>>0||(pa=a[oa>>2]|0,a[pa+20>>2]=42,a[pa+24>>2]=65500,R[a[pa>>2]&127](oa));pa=a[oa+56>>2]|0;ua=oa+380|0;Ia=a[ua>>2]|0;Da=E(Ia,a[oa+60>>2]|0)|0;pa>>>0>=Da>>>0?(na=E(a[sa>>2]|0,Ia)|0,a[oa+64>>2]=na,na=E(Ia,a[oa+32>>2]|0)|0,a[oa+68>>2]=na,a[oa+280>>2]=1,a[oa+284>>2]=1):pa<<1>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,2)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,2)|0,a[oa+68>>2]=na,a[oa+280>>2]=2,a[oa+284>>2]=2):(3*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,
3)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,3)|0,a[oa+68>>2]=na,a[oa+280>>2]=3,a[oa+284>>2]=3):pa<<2>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,4)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,4)|0,a[oa+68>>2]=na,a[oa+280>>2]=4,a[oa+284>>2]=4):(5*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,5)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,5)|0,a[oa+68>>2]=na,a[oa+280>>2]=5,a[oa+284>>2]=5):(6*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,6)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+
32>>2]|0)|0,6)|0,a[oa+68>>2]=na,a[oa+280>>2]=6,a[oa+284>>2]=6):(7*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,7)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,7)|0,a[oa+68>>2]=na,a[oa+280>>2]=7,a[oa+284>>2]=7):pa<<3>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,8)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,8)|0,a[oa+68>>2]=na,a[oa+280>>2]=8,a[oa+284>>2]=8):(9*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,9)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,9)|0,a[oa+68>>2]=na,a[oa+280>>
2]=9,a[oa+284>>2]=9):(10*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,10)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,10)|0,a[oa+68>>2]=na,a[oa+280>>2]=10,a[oa+284>>2]=10):(11*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,11)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,11)|0,a[oa+68>>2]=na,a[oa+280>>2]=11,a[oa+284>>2]=11):(12*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,12)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,12)|0,a[oa+68>>2]=na,a[oa+280>>2]=12,a[oa+284>>2]=12):(13*
pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,13)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,13)|0,a[oa+68>>2]=na,a[oa+280>>2]=13,a[oa+284>>2]=13):(14*pa|0)>>>0>=Da>>>0?(na=Gb(E(a[sa>>2]|0,Ia)|0,14)|0,a[oa+64>>2]=na,na=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,14)|0,a[oa+68>>2]=na,a[oa+280>>2]=14,a[oa+284>>2]=14):(na=E(a[sa>>2]|0,Ia)|0,(15*pa|0)>>>0<Da>>>0?(Da=Gb(na,16)|0,a[oa+64>>2]=Da,Da=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,16)|0,a[oa+68>>2]=Da,a[oa+280>>2]=16,a[oa+284>>2]=16):(Da=Gb(na,15)|0,a[oa+64>>
2]=Da,Da=Gb(E(a[ua>>2]|0,a[oa+32>>2]|0)|0,15)|0,a[oa+68>>2]=Da,a[oa+280>>2]=15,a[oa+284>>2]=15));H=l=k+380|0;r=a[l>>2]|0}else l=k+280|0,z=a[l>>2]|0,Q=k+284|0,(z|0)==(a[Q>>2]|0)?C=z:(x=a[k>>2]|0,a[x+20>>2]=7,a[x+24>>2]=z,a[x+28>>2]=a[Q>>2],R[a[x>>2]&127](k),C=a[l>>2]|0),l=k+380|0,a[l>>2]=C,H=l,r=C;15<(r+-1|0)>>>0?(C=a[k>>2]|0,a[C+20>>2]=7,a[C+24>>2]=r,a[C+28>>2]=a[H>>2],R[a[C>>2]&127](k),w=a[H>>2]|0):w=r;switch(w|0){case 2:a[k+384>>2]=121164;break;case 3:a[k+384>>2]=121064;break;case 4:a[k+384>>2]=
120936;break;case 5:a[k+384>>2]=120772;break;case 6:a[k+384>>2]=120564;break;case 7:a[k+384>>2]=120304;break;default:a[k+384>>2]=119984}w=a[H>>2]|0;r=(E(w,w)|0)+-1|0;C=k+388|0;a[C>>2]=8>(w|0)?r:63;r=k+68|0;w=a[r>>2]|0;0!=(w|0)&&0!=(a[k+64>>2]|0)&&1<=(a[k+76>>2]|0)?v=w:(w=a[k>>2]|0,a[w+20>>2]=33,R[a[w>>2]&127](k),v=a[r>>2]|0);65500>=(v|0)&&65500>=(a[k+64>>2]|0)||(v=a[k>>2]|0,a[v+20>>2]=42,a[v+24>>2]=65500,R[a[v>>2]&127](k));v=a[k+72>>2]|0;4<(v+-8|0)>>>0&&(w=a[k>>2]|0,a[w+20>>2]=16,a[w+24>>2]=v,R[a[w>>
2]&127](k));w=k+76|0;v=a[w>>2]|0;10<(v|0)?(l=a[k>>2]|0,a[l+20>>2]=27,a[l+24>>2]=v,a[l+28>>2]=10,R[a[l>>2]&127](k),J=a[w>>2]|0):J=v;v=k+272|0;a[v>>2]=1;l=k+276|0;a[l>>2]=1;x=k+84|0;if(0<(J|0)){Q=J;z=J=1;I=0;for(G=a[x>>2]|0;;)if(L=G+8|0,K=a[L>>2]|0,A=G+12|0,3>=(K+-1|0)>>>0&&(D=a[A>>2]|0,3>=(D+-1|0)>>>0)?(O=Q,M=z,T=K,X=J,P=D):(D=a[k>>2]|0,a[D+20>>2]=19,R[a[D>>2]&127](k),O=a[w>>2]|0,M=a[v>>2]|0,T=a[L>>2]|0,X=a[l>>2]|0,P=a[A>>2]|0),z=(M|0)>(T|0)?M:T,a[v>>2]=z,A=(X|0)>(P|0)?X:P,a[l>>2]=A,I=I+1|0,(I|0)>=
(O|0)){Oa=O;N=A;break}else Q=O,J=A,G=G+88|0;if(0<(Oa|0)){Oa=k+280|0;G=k+224|0;J=k+284|0;O=k+64|0;Q=0;for(I=a[x>>2]|0;;){a[I+4>>2]=Q;x=a[Oa>>2]|0;P=0!=(a[G>>2]|0)?8:4;a:do if((x|0)>(P|0))F=1;else for(X=a[v>>2]|0,z=a[I+8>>2]|0,T=1;;){M=T<<1;if((X|0)%(E(M,z)|0)|0){F=T;break a}if((E(M,x)|0)>(P|0)){F=M;break}else T=M}while(0);T=E(F,x)|0;z=I+36|0;a[z>>2]=T;X=a[J>>2]|0;a:do if((X|0)>(P|0))ba=1;else for(M=a[l>>2]|0,A=a[I+12>>2]|0,L=1;;){D=L<<1;if((M|0)%(E(D,A)|0)|0){ba=L;break a}if((E(D,X)|0)>(P|0)){ba=D;
break}else L=D}while(0);P=E(ba,X)|0;x=I+40|0;a[x>>2]=P;L=P<<1;(T|0)<=(L|0)?(A=T<<1,(P|0)>(A|0)&&(a[x>>2]=A)):a[z>>2]=L;L=I+8|0;A=E(a[L>>2]|0,a[O>>2]|0)|0;P=Gb(A,E(a[H>>2]|0,a[v>>2]|0)|0)|0;a[I+28>>2]=P;P=I+12|0;A=E(a[P>>2]|0,a[r>>2]|0)|0;M=Gb(A,E(a[H>>2]|0,a[l>>2]|0)|0)|0;a[I+32>>2]=M;M=E(E(a[L>>2]|0,a[O>>2]|0)|0,a[z>>2]|0)|0;L=Gb(M,E(a[H>>2]|0,a[v>>2]|0)|0)|0;a[I+44>>2]=L;L=E(E(a[P>>2]|0,a[r>>2]|0)|0,a[x>>2]|0)|0;x=Gb(L,E(a[H>>2]|0,a[l>>2]|0)|0)|0;a[I+48>>2]=x;a[I+52>>2]=0;Q=Q+1|0;if((Q|0)>=(a[w>>
2]|0))break;else I=I+88|0}S=a[l>>2]|0}else S=N}else S=1;N=Gb(a[r>>2]|0,E(a[H>>2]|0,S)|0)|0;a[k+288>>2]=N;N=k+204|0;if(S=a[N>>2]|0){H=k+200|0;1>(a[H>>2]|0)?(r=a[k>>2]|0,a[r+20>>2]=20,a[r+24>>2]=0,R[a[r>>2]&127](k),Y=a[N>>2]|0):Y=S;0==(a[Y+20>>2]|0)&&63==(a[Y+24>>2]|0)?(a[k+268>>2]=0,S=a[w>>2]|0,0<(S|0)&&Va(p|0,0,(1<(S|0)?S<<2:4)|0)|0,W=S,ga=0):(a[k+268>>2]=1,S=a[w>>2]|0,0<(S|0)&&Va(q|0,-1,S<<8|0)|0,W=S,ga=1);if(1>(a[H>>2]|0))Ha=ga,ma=W;else{W=k+268|0;ga=1;for(S=Y;;){Y=a[S>>2]|0;3<(Y+-1|0)>>>0&&(r=
a[k>>2]|0,a[r+20>>2]=27,a[r+24>>2]=Y,a[r+28>>2]=4,R[a[r>>2]&127](k));if(r=0<(Y|0)){l=0;do I=a[S+4+(l<<2)>>2]|0,0<=(I|0)&&(I|0)<(a[w>>2]|0)||(Q=a[k>>2]|0,a[Q+20>>2]=20,a[Q+24>>2]=ga,R[a[Q>>2]&127](k)),0<(l|0)&&!((I|0)>(a[S+4+(l+-1<<2)>>2]|0))&&(Q=a[k>>2]|0,a[Q+20>>2]=20,a[Q+24>>2]=ga,R[a[Q>>2]&127](k)),l=l+1|0;while((l|0)!=(Y|0))}l=a[S+20>>2]|0;z=a[S+24>>2]|0;T=a[S+28>>2]|0;X=a[S+32>>2]|0;do if(a[W>>2]|0){if(!(63>=l>>>0)||10<X>>>0|10<T>>>0|(z|0)<(l|0)|63<(z|0))I=a[k>>2]|0,a[I+20>>2]=18,a[I+24>>2]=
ga,R[a[I>>2]&127](k);(I=0==(l|0))?z&&(Q=a[k>>2]|0,a[Q+20>>2]=18,a[Q+24>>2]=ga,R[a[Q>>2]&127](k)):1!=(Y|0)&&(Q=a[k>>2]|0,a[Q+20>>2]=18,a[Q+24>>2]=ga,R[a[Q>>2]&127](k));if(r){Q=0==(T|0);v=(X|0)==(T+-1|0);O=0;do{ba=a[S+4+(O<<2)>>2]|0;I?U=0:(0<=(a[q+(ba<<8)>>2]|0)||(J=a[k>>2]|0,a[J+20>>2]=18,a[J+24>>2]=ga,R[a[J>>2]&127](k)),U=l);a:do if((U|0)<=(z|0)){if(!v){if(Q)ha=U;else for(J=U;;)if(F=a[k>>2]|0,a[F+20>>2]=18,a[F+24>>2]=ga,R[a[F>>2]&127](k),a[q+(ba<<8)+(J<<2)>>2]=X,(J|0)<(z|0))J=J+1|0;else break a;for(;;)if(J=
q+(ba<<8)+(ha<<2)|0,0<=(a[J>>2]|0)&&(F=a[k>>2]|0,a[F+20>>2]=18,a[F+24>>2]=ga,R[a[F>>2]&127](k)),a[J>>2]=X,(ha|0)<(z|0))ha=ha+1|0;else break a}if(Q)for(J=U;;)if(F=q+(ba<<8)+(J<<2)|0,1<=(a[F>>2]|0)&&(G=a[k>>2]|0,a[G+20>>2]=18,a[G+24>>2]=ga,R[a[G>>2]&127](k)),a[F>>2]=X,(J|0)<(z|0))J=J+1|0;else break a;else da=U;for(;;)if(J=q+(ba<<8)+(da<<2)|0,F=a[J>>2]|0,0>(F|0)?(G=a[k>>2]|0,a[G+20>>2]=18,a[G+24>>2]=ga,R[a[G>>2]&127](k)):(T|0)!=(F|0)&&(G=a[k>>2]|0,a[G+20>>2]=18,a[G+24>>2]=ga,R[a[G>>2]&127](k)),a[J>>
2]=X,(da|0)<(z|0))da=da+1|0;else break}while(0);O=O+1|0}while((O|0)!=(Y|0))}}else if(63!=(z|0)|0!=(T|l|X|0)&&(I=a[k>>2]|0,a[I+20>>2]=18,a[I+24>>2]=ga,R[a[I>>2]&127](k)),r){I=0;do Q=p+(a[S+4+(I<<2)>>2]<<2)|0,a[Q>>2]|0&&(v=a[k>>2]|0,a[v+20>>2]=20,a[v+24>>2]=ga,R[a[v>>2]&127](k)),a[Q>>2]=1,I=I+1|0;while((I|0)!=(Y|0))}while(0);if((ga|0)<(a[H>>2]|0))ga=ga+1|0,S=S+36|0;else break}Ha=a[W>>2]|0;ma=a[w>>2]|0}W=0<(ma|0);if(!Ha){if(W)for(Ha=ma,S=0;!(a[p+(S<<2)>>2]|0?aa=Ha:(ga=a[k>>2]|0,a[ga+20>>2]=46,R[a[ga>>
2]&127](k),aa=a[w>>2]|0),S=S+1|0,(S|0)>=(aa|0));)Ha=aa}else if(W)for(W=ma,ma=0;!(0>(a[q+(ma<<8)>>2]|0)?(aa=a[k>>2]|0,a[aa+20>>2]=46,R[a[aa>>2]&127](k),ca=a[w>>2]|0):ca=W,ma=ma+1|0,(ma|0)>=(ca|0));)W=ca;if(8>(a[k+380>>2]|0)){ca=a[N>>2]|0;if(0<(a[H>>2]|0))for(W=N=0;;){if((N|0)!=(W|0)){ma=ca+(36*W|0)|0;w=ca+(36*N|0)|0;q=ma+36|0;do a[ma>>2]=a[w>>2],ma=ma+4|0,w=w+4|0;while((ma|0)<(q|0))}w=a[C>>2]|0;(a[ca+(36*W|0)+20>>2]|0)>(w|0)?Z=W:(ma=ca+(36*W|0)+24|0,(a[ma>>2]|0)>(w|0)&&(a[ma>>2]=w),Z=W+1|0);N=N+1|
0;if((N|0)>=(a[H>>2]|0)){fa=Z;break}else W=Z}else fa=0;a[H>>2]=fa}}else a[k+268>>2]=0,a[k+200>>2]=1;fa=k+216|0;H=a[fa>>2]|0;Z=k+212|0;H?(a[Z>>2]=0,ja=H):ja=a[Z>>2]|0?0:0==(a[k+268>>2]|0)&&6<=((a[k+380>>2]|0)+-2|0)>>>0?0:a[fa>>2]=1;B?a[y+20>>2]=0:(H=y+20|0,a[H>>2]=ja?1:2);a[y+32>>2]=0;a[y+24>>2]=0;B=a[k+200>>2]|0;a[y+28>>2]=ja?B<<1:B;u=n;if(!(a[g+208>>2]|0)){oi(g);var Na=g,Na=Na|0,ya,Ca,Ga,Ea,La,ra,Ka,Qa,Wa,xb,Zb,eb,jb,mc,ab,Ta,Ya,Sa,mb,Db,cc;ya=Aa[a[a[Na+4>>2]>>2]&63](Na,1,112)|0;a[Na+416>>2]=ya;
a[ya>>2]=38;a[ya+4>>2]=1;Ca=ya+8|0;a[Ca>>2]=0;a[Na+220>>2]|0&&(Ga=a[Na>>2]|0,a[Ga+20>>2]=26,R[a[Ga>>2]&127](Na));Ga=Na+76|0;if(!(0>=(a[Ga>>2]|0))){Ea=Na+280|0;La=Na+284|0;ra=Na+272|0;Ka=Na+276|0;Qa=ya+52|0;Wa=Na+228|0;xb=ya+12|0;Zb=0;eb=a[Na+84>>2]|0;for(jb=1;;)if(mc=E(a[eb+36>>2]|0,a[eb+8>>2]|0)|0,ab=(mc|0)/(a[Ea>>2]|0)|0,mc=E(a[eb+40>>2]|0,a[eb+12>>2]|0)|0,Ta=(mc|0)/(a[La>>2]|0)|0,mc=a[ra>>2]|0,Ya=a[Ka>>2]|0,a[Qa+(Zb<<2)>>2]=Ta,Sa=(Ya|0)==(Ta|0),(mc|0)==(ab|0)&Sa?(mb=xb+(Zb<<2)|0,a[Wa>>2]|0?(a[mb>>
2]=5,a[Ca>>2]=1):a[mb>>2]=6,Db=jb):(mb=(mc|0)==(ab<<1|0),mb&Sa?(a[xb+(Zb<<2)>>2]=7,Db=0):mb&(Ya|0)==(Ta<<1|0)?(mb=xb+(Zb<<2)|0,a[Wa>>2]|0?(a[mb>>2]=8,a[Ca>>2]=1):a[mb>>2]=9,Db=jb):0==((mc|0)%(ab|0)|0)&&0==((Ya|0)%(Ta|0)|0)?(a[xb+(Zb<<2)>>2]=10,t[ya+(Zb+92)>>0]=(mc|0)/(ab|0)|0,t[ya+(Zb+102)>>0]=(Ya|0)/(Ta|0)|0,Db=0):(mb=a[Na>>2]|0,a[mb+20>>2]=39,R[a[mb>>2]&127](Na),Db=jb)),Zb=Zb+1|0,(Zb|0)>=(a[Ga>>2]|0)){cc=Db;break}else eb=eb+88|0,jb=Db;0!=(cc|0)|0==(a[Wa>>2]|0)||(Wa=a[Na>>2]|0,a[Wa+20>>2]=101,ub[a[Wa+
4>>2]&31](Na,0))}var Za=g,ia=0,Za=Za|0,qa,Ja,ea,wa,Ma,xa,$a,la,Ba,va,za,ta,nb,sc,gb,hb,ob,Bb;ia|0&&(ia=a[Za>>2]|0,a[ia+20>>2]=3,R[a[ia>>2]&127](Za));qa=Za;ia=Za+4|0;Ja=Aa[a[a[ia>>2]>>2]&63](qa,1,64)|0;a[Za+400>>2]=Ja;a[Ja>>2]=9;ea=Ja+4|0;if(a[(a[Za+416>>2]|0)+8>>2]|0){if(a[ea>>2]=1,ea=a[Za+276>>2]|0,va=Za+76|0,wa=E(20*ea|0,a[va>>2]|0)|0,Ba=Aa[a[a[ia>>2]>>2]&63](qa,1,wa)|0,wa=a[Za+84>>2]|0,!(0>=(a[va>>2]|0)))if(la=Za+280|0,$a=Za+272|0,Za=3*ea|0,xa=12*ea|0,Ma=5*ea|0,za=ea<<1,ta=ea<<2,0<(ea|0))for(nb=
0,sc=wa,gb=Ba;;){wa=E(a[la>>2]|0,a[sc+28>>2]|0)|0;ob=E(wa,a[$a>>2]|0)|0;wa=rb[a[(a[ia>>2]|0)+8>>2]&63](qa,1,(ob|0)/(a[sc+8>>2]|0)|0,Za)|0;ob=gb+(ea<<2)|0;Ec(ob|0,wa|0,xa|0)|0;hb=0;do a[gb+(hb<<2)>>2]=a[wa+(hb+za<<2)>>2],a[gb+(hb+ta<<2)>>2]=a[wa+(hb<<2)>>2],hb=hb+1|0;while((hb|0)!=(ea|0));a[Ja+8+(nb<<2)>>2]=ob;nb=nb+1|0;if((nb|0)>=(a[va>>2]|0))break;else sc=sc+88|0,gb=gb+(Ma<<2)|0}else for(hb=0,ob=wa,wa=Ba;!(Ba=E(a[la>>2]|0,a[ob+28>>2]|0)|0,Bb=E(Ba,a[$a>>2]|0)|0,Ba=wa+(ea<<2)|0,Ec(Ba|0,rb[a[(a[ia>>
2]|0)+8>>2]&63](qa,1,(Bb|0)/(a[ob+8>>2]|0)|0,Za)|0,xa|0)|0,a[Ja+8+(hb<<2)>>2]=Ba,hb=hb+1|0,(hb|0)>=(a[va>>2]|0));)ob=ob+88|0,wa=wa+(Ma<<2)|0}else if(a[ea>>2]=2,wa=Za+76|0,!(0>=(a[wa>>2]|0)))for(Ma=Za+280|0,xa=Za+272|0,$a=Za+276|0,la=Ja+8|0,Ba=0,va=a[Za+84>>2]|0;!(za=E(a[Ma>>2]|0,a[va+28>>2]|0)|0,ta=E(za,a[xa>>2]|0)|0,za=rb[a[(a[ia>>2]|0)+8>>2]&63](qa,1,(ta|0)/(a[va+8>>2]|0)|0,a[$a>>2]|0)|0,a[la+(Ba<<2)>>2]=za,Ba=Ba+1|0,(Ba|0)>=(a[wa>>2]|0));)va=va+88|0}var qb=g,qb=qb|0,kb,ib,Cb,Ab,sb;kb=qb+4|0;ib=
Aa[a[a[kb>>2]>>2]&63](qb,1,124)|0;a[qb+420>>2]=ib;a[ib>>2]=60;ib=qb+76|0;if(!(0>=(a[ib>>2]|0)))for(Cb=0,Ab=a[qb+84>>2]|0;!(sb=Aa[a[a[kb>>2]>>2]&63](qb,1,256)|0,a[Ab+84>>2]=sb,Cb=Cb+1|0,(Cb|0)>=(a[ib>>2]|0));)Ab=Ab+88|0;if(a[g+212>>2]|0){var Xa=g,Xa=Xa|0,Fa;Fa=Aa[a[a[Xa+4>>2]>>2]&63](Xa,1,208)|0;a[Xa+424>>2]=Fa;a[Fa>>2]=16;a[Fa+8>>2]=57;a[Fa+76>>2]=0;a[Fa+140>>2]=0;a[Fa+80>>2]=0;a[Fa+144>>2]=0;a[Fa+84>>2]=0;a[Fa+148>>2]=0;a[Fa+88>>2]=0;a[Fa+152>>2]=0;a[Fa+92>>2]=0;a[Fa+156>>2]=0;a[Fa+96>>2]=0;a[Fa+
160>>2]=0;a[Fa+100>>2]=0;a[Fa+164>>2]=0;a[Fa+104>>2]=0;a[Fa+168>>2]=0;a[Fa+108>>2]=0;a[Fa+172>>2]=0;a[Fa+112>>2]=0;a[Fa+176>>2]=0;a[Fa+116>>2]=0;a[Fa+180>>2]=0;a[Fa+120>>2]=0;a[Fa+184>>2]=0;a[Fa+124>>2]=0;a[Fa+188>>2]=0;a[Fa+128>>2]=0;a[Fa+192>>2]=0;a[Fa+132>>2]=0;a[Fa+196>>2]=0;a[Fa+136>>2]=0;a[Fa+200>>2]=0;t[Fa+204>>0]=113}else{var Pa=g,Pa=Pa|0,Eb;Eb=Aa[a[a[Pa+4>>2]>>2]&63](Pa,1,140)|0;a[Pa+424>>2]=Eb;a[Eb>>2]=18;a[Eb+60>>2]=0;a[Eb+44>>2]=0;a[Eb+92>>2]=0;a[Eb+76>>2]=0;a[Eb+64>>2]=0;a[Eb+48>>2]=
0;a[Eb+96>>2]=0;a[Eb+80>>2]=0;a[Eb+68>>2]=0;a[Eb+52>>2]=0;a[Eb+100>>2]=0;a[Eb+84>>2]=0;a[Eb+72>>2]=0;a[Eb+56>>2]=0;a[Eb+104>>2]=0;a[Eb+88>>2]=0;a[Pa+268>>2]|0&&(a[Eb+136>>2]=0)}var vb=g,tb=(1<(a[g+200>>2]|0)?1:0!=(a[g+216>>2]|0))&1,vb=vb|0,tb=tb|0,bb,Ib,Mb,pb,Ua,Wb,Jb,fb,yb;bb=vb+4|0;Ib=Aa[a[a[bb>>2]>>2]&63](vb,1,104)|0;a[vb+404>>2]=Ib;a[Ib>>2]=17;if(tb){if(tb=vb+76|0,!(0>=(a[tb>>2]|0)))for(Mb=Ib+64|0,Ib=0,pb=a[vb+84>>2]|0;!(Ua=a[(a[bb>>2]|0)+20>>2]|0,Wb=Ch(a[pb+28>>2]|0,a[pb+8>>2]|0)|0,Jb=pb+12|
0,fb=Ch(a[pb+32>>2]|0,a[Jb>>2]|0)|0,yb=Hi[Ua&3](vb,1,0,Wb,fb,a[Jb>>2]|0)|0,a[Mb+(Ib<<2)>>2]=yb,Ib=Ib+1|0,(Ib|0)>=(a[tb>>2]|0));)pb=pb+88|0}else tb=Aa[a[(a[bb>>2]|0)+4>>2]&63](vb,1,1280)|0,a[Ib+24>>2]=tb,a[Ib+28>>2]=tb+128,a[Ib+32>>2]=tb+256,a[Ib+36>>2]=tb+384,a[Ib+40>>2]=tb+512,a[Ib+44>>2]=tb+640,a[Ib+48>>2]=tb+768,a[Ib+52>>2]=tb+896,a[Ib+56>>2]=tb+1024,a[Ib+60>>2]=tb+1152,a[Ib+64>>2]=0;var cb=g,gc=0,cb=cb|0,gc=gc|0,Ub,Fb,Hb,Kb,nd,Zd,wb;Ub=cb+4|0;Fb=Aa[a[a[Ub>>2]>>2]&63](cb,1,64)|0;a[cb+396>>2]=Fb;
a[Fb>>2]=7;if(!(a[cb+208>>2]|0))if(gc)gc=a[cb>>2]|0,a[gc+20>>2]=3,R[a[gc>>2]&127](cb);else if(gc=cb+76|0,!(0>=(a[gc>>2]|0)))for(Hb=Fb+24|0,Fb=0,Kb=a[cb+84>>2]|0;!(nd=E(a[Kb+36>>2]|0,a[Kb+28>>2]|0)|0,Zd=E(a[Kb+40>>2]|0,a[Kb+12>>2]|0)|0,wb=rb[a[(a[Ub>>2]|0)+8>>2]&63](cb,1,nd,Zd)|0,a[Hb+(Fb<<2)>>2]=wb,Fb=Fb+1|0,(Fb|0)>=(a[gc>>2]|0));)Kb=Kb+88|0;Gg(g);R[a[(a[g+4>>2]|0)+24>>2]&127](g);R[a[a[g+408>>2]>>2]&127](g);R[a[a[b+392>>2]>>2]&127](b);a[b+264>>2]=0;a[c>>2]=0!=(a[b+208>>2]|0)?102:101},lg,function(b,
d){var c;d=u;u=u+16|0;c=a[(b|0)+12>>2]|0;Y(a[c+628>>2]|0,151596,151604,d);Bi(c)},function(a,d){Gc(d|0)},function(b,d){b|=0;d|=0;var c;c=a[b+396>>2]|0;a[b+208>>2]|0||(a[c+8>>2]=0,a[c+12>>2]=0,a[c+16>>2]=0,(a[c+20>>2]=d)?(c=a[b>>2]|0,a[c+20>>2]=3,R[a[c>>2]&127](b)):a[c+4>>2]=4)},function(b,d){b|=0;var c,e;c=a[b+24>>2]|0;e=a[c>>2]|0;a[c>>2]=e+1;t[e>>0]=d|0;d=c+4|0;e=(a[d>>2]|0)+-1|0;a[d>>2]=e;e||da[a[c+12>>2]&63](b)|0||(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b))},function(b,d){b|=0;var c;c=a[b+400>>
2]|0;d|0&&(d=a[b>>2]|0,a[d+20>>2]=3,R[a[d>>2]&127](b));a[c+48>>2]=a[b+32>>2];a[c+52>>2]=0;a[c+56>>2]=0;a[c+60>>2]=a[b+276>>2]<<1},function(b,d){b|=0;d|=0;var c,e,f;c=a[b+456>>2]|0;a:do switch(d|0){case 0:if(!(a[b+84>>2]|0)){a[c+4>>2]=a[(a[b+476>>2]|0)+4>>2];break a}a[c+4>>2]=5;e=c+12|0;a[e>>2]|0||(f=jg[a[(a[b+4>>2]|0)+28>>2]&3](b,a[c+8>>2]|0,0,a[c+16>>2]|0,1)|0,a[e>>2]=f);break;case 3:a[c+8>>2]|0||(f=a[b>>2]|0,a[f+20>>2]=3,R[a[f>>2]&127](b));a[c+4>>2]=6;break;case 2:a[c+8>>2]|0||(f=a[b>>2]|0,a[f+
20>>2]=3,R[a[f>>2]&127](b));a[c+4>>2]=7;break;default:f=a[b>>2]|0,a[f+20>>2]=3,R[a[f>>2]&127](b)}while(0);a[c+24>>2]=0;a[c+20>>2]=0},function(b,d){b|=0;d|=0;var c,e;c=a[b>>2]|0;if(0<=(d|0)){if(!((a[c+104>>2]|0)<(d|0)))R[a[c+8>>2]&127](b)}else d=c+108|0,e=a[d>>2]|0,0!=(e|0)&&2>=(a[c+104>>2]|0)?c=e:(R[a[c+8>>2]&127](b),c=a[d>>2]|0),a[d>>2]=c+1},function(b,d){d|=0;var c,e,f,g,h=0,m,k,l=0,n=0,p=0;c=u;u=u+48|0;e=c+8|0;f=c;g=a[(b|0)>>2]|0;b=a[g+20>>2]|0;0<(b|0)&&(b|0)<=(a[g+116>>2]|0)?(h=(a[g+112>>2]|0)+
(b<<2)|0,m=8):(k=a[g+120>>2]|0,0!=(k|0)&&(l=a[g+124>>2]|0,(b|0)>=(l|0))&&(b|0)<=(a[g+128>>2]|0)?(h=k+(b-l<<2)|0,m=8):m=9);8==(m|0)&&((l=a[h>>2]|0)?n=l:m=9);9==(m|0)&&(a[g+24>>2]=b,n=a[a[g+112>>2]>>2]|0);b=n;a:for(;;)switch(l=b+1|0,t[b>>0]|0){case 0:break a;case 37:p=l;m=12;break a;default:b=l}12==(m|0)&&115==(t[p>>0]|0)?(a[f>>2]=g+24,ad(d,n,f)|0):(f=a[g+28>>2]|0,p=a[g+32>>2]|0,m=a[g+36>>2]|0,b=a[g+40>>2]|0,l=a[g+44>>2]|0,h=a[g+48>>2]|0,k=a[g+52>>2]|0,a[e>>2]=a[g+24>>2],a[e+4>>2]=f,a[e+8>>2]=p,a[e+
12>>2]=m,a[e+16>>2]=b,a[e+20>>2]=l,a[e+24>>2]=h,a[e+28>>2]=k,ad(d,n,e)|0);u=c},function(b,d){b|=0;var c,e,f,g,h,m,k=0,l=0,n=0,p;d=b+484|0;c=a[d>>2]|0;a[b+136>>2]=a[c+16>>2];a[b+132>>2]=a[c+20>>2];switch(a[b+88>>2]|0){case 0:a[(c+4|0)>>2]=3==(a[b+120>>2]|0)?18:19;break;case 1:e=b+120|0;a[c+4>>2]=3==(a[e>>2]|0)?20:21;a[c+48>>2]=0;a[c+28>>2]|0||Lh(b);if(a[c+52>>2]|0)break;f=a[d>>2]|0;d=a[e>>2]|0;if(0>=(d|0))break;c=b+4|0;g=d;for(d=0;;){h=a[f+32+(d<<2)>>2]|0;a:do if(0<(d|0)){for(m=0;(h|0)!=(a[f+32+(m<<
2)>>2]|0);)if(m=m+1|0,(m|0)>=(d|0)){k=14;break a}(m=a[f+52+(m<<2)>>2]|0)?(l=g,n=m):k=14}else k=14;while(0);if(14==(k|0)){k=0;m=Aa[a[a[c>>2]>>2]&63](b,1,1024)|0;l=(h<<9)+-512|0;g=0;do{n=0;do h=255-((x[160977+(g<<4)+n>>0]|0)<<1)|0,p=255*h|0,h=0>(h|0)?0-((0-p|0)/(l|0)|0)|0:(p|0)/(l|0)|0,a[m+(g<<6)+(n<<2)>>2]=h,n=n+1|0;while(16!=(n|0));g=g+1|0}while(16!=(g|0));l=a[e>>2]|0;n=m}a[f+52+(d<<2)>>2]=n;d=d+1|0;if((d|0)>=(l|0))break;else g=l}break;case 2:a[c+4>>2]=22;a[c+84>>2]=0;if(a[c+68>>2]|0)f=l=b+120|0,
k=b+112|0,e=a[l>>2]|0;else{l=b+112|0;g=(a[l>>2]<<1)+4|0;d=b+120|0;if(0>=(a[d>>2]|0))break;n=b+4|0;f=0;do e=Aa[a[(a[n>>2]|0)+4>>2]&63](b,1,g)|0,a[c+68+(f<<2)>>2]=e,f=f+1|0,e=a[d>>2]|0;while((f|0)<(e|0));f=d;k=l}l=(a[k>>2]<<1)+4|0;if(0<(e|0))e=0;else break;do Va(a[c+68+(e<<2)>>2]|0,0,l|0)|0,e=e+1|0;while((e|0)<(a[f>>2]|0));break;default:f=a[b>>2]|0,a[f+20>>2]=49,R[a[f>>2]&127](b)}},function(b,d){b|=0;var c,e,f,g,h;c=a[b+484>>2]|0;e=a[c+24>>2]|0;f=b+88|0;g=a[f>>2]|0?a[f>>2]=2:0;d|0?(a[c+4>>2]=23,a[c+
8>>2]=53,a[c+28>>2]=1):(a[c+4>>2]=2==(g|0)?24:25,a[c+8>>2]=54,g=a[b+132>>2]|0,1<=(g|0)?256<(g|0)&&(g=a[b>>2]|0,a[g+20>>2]=59,a[g+24>>2]=256,R[a[g>>2]&127](b)):(g=a[b>>2]|0,a[g+20>>2]=58,a[g+24>>2]=1,R[a[g>>2]&127](b)),2==(a[f>>2]|0)&&(f=(6*(a[b+112>>2]|0)|0)+12|0,g=c+32|0,(d=a[g>>2]|0)?g=d:(h=Aa[a[(a[b+4>>2]|0)+4>>2]&63](b,1,f)|0,g=a[g>>2]=h),Va(g|0,0,f|0)|0,a[c+40>>2]|0||Mh(b),a[c+36>>2]=0));b=c+28|0;a[b>>2]|0&&(Va(a[e>>2]|0,0,4096)|0,Va(a[e+4>>2]|0,0,4096)|0,Va(a[e+8>>2]|0,0,4096)|0,Va(a[e+12>>
2]|0,0,4096)|0,Va(a[e+16>>2]|0,0,4096)|0,Va(a[e+20>>2]|0,0,4096)|0,Va(a[e+24>>2]|0,0,4096)|0,Va(a[e+28>>2]|0,0,4096)|0,Va(a[e+32>>2]|0,0,4096)|0,Va(a[e+36>>2]|0,0,4096)|0,Va(a[e+40>>2]|0,0,4096)|0,Va(a[e+44>>2]|0,0,4096)|0,Va(a[e+48>>2]|0,0,4096)|0,Va(a[e+52>>2]|0,0,4096)|0,Va(a[e+56>>2]|0,0,4096)|0,Va(a[e+60>>2]|0,0,4096)|0,Va(a[e+64>>2]|0,0,4096)|0,Va(a[e+68>>2]|0,0,4096)|0,Va(a[e+72>>2]|0,0,4096)|0,Va(a[e+76>>2]|0,0,4096)|0,Va(a[e+80>>2]|0,0,4096)|0,Va(a[e+84>>2]|0,0,4096)|0,Va(a[e+88>>2]|0,0,
4096)|0,Va(a[e+92>>2]|0,0,4096)|0,Va(a[e+96>>2]|0,0,4096)|0,Va(a[e+100>>2]|0,0,4096)|0,Va(a[e+104>>2]|0,0,4096)|0,Va(a[e+108>>2]|0,0,4096)|0,Va(a[e+112>>2]|0,0,4096)|0,Va(a[e+116>>2]|0,0,4096)|0,Va(a[e+120>>2]|0,0,4096)|0,Va(a[e+124>>2]|0,0,4096)|0,a[b>>2]=0)},sk,function(b,d){b|=0;var c,e,f,g,h,m,k,l,n,p;c=a[b+424>>2]|0;d|0&&(d=a[b>>2]|0,a[d+20>>2]=49,R[a[d>>2]&127](b));a[b+268>>2]|0?(d=0==(a[b+364>>2]|0),a[(c+4|0)>>2]=a[b+372>>2]|0?d?44:45:d?42:43):a[c+4>>2]=46;e=b+292|0;if(!(0>=(a[e>>2]|0))){d=
b+364|0;f=b+372|0;g=b+4|0;h=b+368|0;m=0;do{k=a[b+296+(m<<2)>>2]|0;if(0==(a[d>>2]|0)&&0==(a[f>>2]|0)){l=a[k+20>>2]|0;15<l>>>0&&(n=a[b>>2]|0,a[n+20>>2]=50,a[n+24>>2]=l,R[a[n>>2]&127](b));n=c+76+(l<<2)|0;l=a[n>>2]|0;l||(p=Aa[a[a[g>>2]>>2]&63](b,1,64)|0,l=a[n>>2]=p);p=l+64|0;do t[l>>0]=0,l=l+1|0;while((l|0)<(p|0));a[c+36+(m<<2)>>2]=0;a[c+52+(m<<2)>>2]=0}a[h>>2]|0&&(l=a[k+24>>2]|0,15<l>>>0&&(p=a[b>>2]|0,a[p+20>>2]=50,a[p+24>>2]=l,R[a[p>>2]&127](b)),p=c+140+(l<<2)|0,(l=a[p>>2]|0)?k=l:(n=Aa[a[a[g>>2]>>2]&
63](b,1,256)|0,k=a[p>>2]=n),Va(k|0,0,256)|0);m=m+1|0}while((m|0)<(a[e>>2]|0))}a[(c+12|0)>>2]=0;a[(c+16|0)>>2]=65536;a[(c+20|0)>>2]=0;a[(c+24|0)>>2]=0;a[(c+28|0)>>2]=11;a[(c+32|0)>>2]=-1;a[(c+68|0)>>2]=a[(b+236|0)>>2]|0;a[(c+72|0)>>2]=0},function(b,d){b|=0;var c,e;c=a[b+404>>2]|0;a[c+8>>2]=0;1>=(a[b+292>>2]|0)?(e=a[b+296>>2]|0,a[c+20>>2]=1==(a[b+288>>2]|0)?a[e+76>>2]:a[e+12>>2]):a[c+20>>2]=1;a[c+12>>2]=0;a[c+16>>2]=0;switch(d|0){case 0:a[c+64>>2]|0&&(d=a[b>>2]|0,a[d+20>>2]=3,R[a[d>>2]&127](b));a[c+
4>>2]=47;break;case 3:a[c+64>>2]|0||(d=a[b>>2]|0,a[d+20>>2]=3,R[a[d>>2]&127](b));a[c+4>>2]=48;break;case 2:a[c+64>>2]|0||(d=a[b>>2]|0,a[d+20>>2]=3,R[a[d>>2]&127](b));a[c+4>>2]=49;break;default:c=a[b>>2]|0,a[c+20>>2]=3,R[a[c>>2]&127](b)}},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n;c=a[b+424>>2]|0;e=0!=(d|0);a[c+8>>2]=e?61:62;a[b+268>>2]|0?(a[c+120>>2]=b,a[c+108>>2]=d,f=0==(a[b+364>>2]|0),g=c+4|0,a[b+372>>2]|0?f?a[g>>2]=52:(a[g>>2]=53,h=c+136|0,a[h>>2]|0||(m=Aa[a[a[b+4>>2]>>2]&63](b,1,1E3)|0,a[h>>
2]=m)):a[g>>2]=f?50:51,a[c+124>>2]=a[(a[b+296>>2]|0)+24>>2],a[c+128>>2]=0,a[c+132>>2]=0):a[(c+4|0)>>2]=e?54:55;d=b+292|0;if(!(0>=(a[d>>2]|0)))if(g=b+364|0,f=b+372|0,m=b+4|0,h=b+368|0,e){k=0;do e=a[b+296+(k<<2)>>2]|0,0==(a[g>>2]|0)&&0==(a[f>>2]|0)&&(n=a[e+20>>2]|0,3<n>>>0&&(l=a[b>>2]|0,a[l+20>>2]=52,a[l+24>>2]=n,R[a[l>>2]&127](b)),l=c+76+(n<<2)|0,n=a[l>>2]|0,n||(n=Aa[a[a[m>>2]>>2]&63](b,1,1028)|0,a[l>>2]=n),l=n,Va(l|0,0,1028)|0,a[c+20+(k<<2)>>2]=0),a[h>>2]|0&&(n=a[e+24>>2]|0,3<n>>>0&&(e=a[b>>2]|0,
a[e+20>>2]=52,a[e+24>>2]=n,R[a[e>>2]&127](b)),e=c+92+(n<<2)|0,n=a[e>>2]|0,n||(n=Aa[a[a[m>>2]>>2]&63](b,1,1028)|0,a[e>>2]=n),e=n,Va(e|0,0,1028)|0),k=k+1|0;while((k|0)<(a[d>>2]|0))}else{e=0;do l=a[b+296+(e<<2)>>2]|0,0==(a[g>>2]|0)&&0==(a[f>>2]|0)&&(n=a[l+20>>2]|0,Xh(b,1,n,c+44+(n<<2)|0),a[c+20+(e<<2)>>2]=0),a[h>>2]|0&&(n=a[l+24>>2]|0,Xh(b,0,n,c+60+(n<<2)|0)),e=e+1|0;while((e|0)<(a[d>>2]|0))}a[(c+12|0)>>2]=0;a[(c+16|0)>>2]=0;a[(c+36|0)>>2]=a[(b+236|0)>>2]|0;a[(c+40|0)>>2]=0},function(b,d){b|=0;var c,
e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,u,C;c=a[b+448>>2]|0;switch(d|0){case 0:d=c+4|0;if(a[(a[b+476>>2]|0)+8>>2]|0){a[d>>2]=26;d=a[b+328>>2]|0;e=a[b+36>>2]|0;if(0<(e|0))for(f=c+56|0,g=c+60|0,h=d+2|0,m=d+-2|0,k=0,l=a[b+216>>2]|0;;){n=(E(a[l+40>>2]|0,a[l+12>>2]|0)|0)/(d|0)|0;p=a[(a[f>>2]|0)+(k<<2)>>2]|0;q=a[(a[g>>2]|0)+(k<<2)>>2]|0;y=a[c+8+(k<<2)>>2]|0;B=E(n,h)|0;if(0<(B|0)){t=0;do r=a[y+(t<<2)>>2]|0,a[q+(t<<2)>>2]=r,a[p+(t<<2)>>2]=r,t=t+1|0;while((t|0)!=(B|0))}B=n<<1;if(0<(n|0)){t=E(n,d)|0;r=E(n,m)|0;z=0;do u=
z+t|0,C=z+r|0,a[q+(C<<2)>>2]=a[y+(u<<2)>>2],a[q+(u<<2)>>2]=a[y+(C<<2)>>2],z=z+1|0;while((z|0)<(B|0));B=0;do a[p+(B-n<<2)>>2]=a[p>>2],B=B+1|0;while((B|0)!=(n|0))}k=k+1|0;if((k|0)==(e|0))break;else l=l+88|0}a[c+64>>2]=0;a[c+68>>2]=0;a[c+76>>2]=0}else a[d>>2]=27;a[c+48>>2]=0;a[c+52>>2]=0;break;case 2:a[c+4>>2]=28;break;default:c=a[b>>2]|0,a[c+20>>2]=3,R[a[c>>2]&127](b)}},We,We,We,We,We,We,We,We,We,We,We,We],Hi=[gl,function(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m;h=a[b+4>>2]|0;1!=(d|0)&&(m=
a[b>>2]|0,a[m+20>>2]=15,a[m+24>>2]=d,R[a[m>>2]&127](b));m=ih(b,d,128)|0;a[m>>2]=0;a[m+4>>2]=f;a[m+8>>2]=e;a[m+12>>2]=g;a[m+32>>2]=c;a[m+40>>2]=0;c=h+68|0;a[m+44>>2]=a[c>>2];a[c>>2]=m;return m|0},function(b,d,c,e,f,g){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;var h,m;h=a[b+4>>2]|0;1!=(d|0)&&(m=a[b>>2]|0,a[m+20>>2]=15,a[m+24>>2]=d,R[a[m>>2]&127](b));m=ih(b,d,128)|0;a[m>>2]=0;a[m+4>>2]=f;a[m+8>>2]=e;a[m+12>>2]=g;a[m+32>>2]=c;a[m+40>>2]=0;c=h+72|0;a[m+44>>2]=a[c>>2];a[c>>2]=m;return m|0},gl],Gk=[Gf,function(b,d,
c,e,f,g,h,m,k,l,n,p){f|=0;g|=0;h|=0;m|=0;var q,y,B,t,r,z,u=0,C=0,w=0,v=0,E=0,J=0,I=0,G=0,L=0,K=0,A=0,D=0,O=0,M=0,T=0,X=0,P=0,Oa=0,F=0,N=0,ba=0,R=0,S=0,Y=0,ga=0,W=0,ma=0,U=0,ha=0,da=0,aa=0,ca=0,Z=0,fa=0,ja=0,oa=0;if(g)for(e=7<f>>>0,c=f+-8|0,b=c&-8,q=c-b|0,c=b+8|0,b=l|0,l=n|0,n=k|0,k=d|0,d=p|0,p=g;;){p=p+-1|0;if(e){g=d+c|0;y=b+c|0;B=n;t=l;r=k;for(z=f;!(a[r>>2]=(x[b>>0]|0)<<8|x[B>>0]|0|(x[t>>0]|0)<<16|(x[d>>0]|0)<<24,a[r+4>>2]=(x[b+1>>0]|0)<<8|x[B+1>>0]|0|(x[t+1>>0]|0)<<16|(x[d+1>>0]|0)<<24,a[r+8>>2]=
(x[b+2>>0]|0)<<8|x[B+2>>0]|0|(x[t+2>>0]|0)<<16|(x[d+2>>0]|0)<<24,a[r+12>>2]=(x[b+3>>0]|0)<<8|x[B+3>>0]|0|(x[t+3>>0]|0)<<16|(x[d+3>>0]|0)<<24,a[r+16>>2]=(x[b+4>>0]|0)<<8|x[B+4>>0]|0|(x[t+4>>0]|0)<<16|(x[d+4>>0]|0)<<24,a[r+20>>2]=(x[b+5>>0]|0)<<8|x[B+5>>0]|0|(x[t+5>>0]|0)<<16|(x[d+5>>0]|0)<<24,a[r+24>>2]=(x[b+6>>0]|0)<<8|x[B+6>>0]|0|(x[t+6>>0]|0)<<16|(x[d+6>>0]|0)<<24,a[r+28>>2]=(x[b+7>>0]|0)<<8|x[B+7>>0]|0|(x[t+7>>0]|0)<<16|(x[d+7>>0]|0)<<24,z=z+-8|0,7>=z>>>0);)b=b+8|0,B=B+8|0,t=t+8|0,r=r+32|0,d=d+
8|0;l=l+c|0;n=n+c|0;k=k+(c<<2)|0;b=q}else g=d,y=b,b=f;switch(b|0){case 1:u=g;C=y;w=n;v=k;E=l;J=14;break;case 7:a[k>>2]=(x[y>>0]|0)<<8|x[n>>0]|0|(x[l>>0]|0)<<16|(x[g>>0]|0)<<24;I=g+1|0;G=y+1|0;L=n+1|0;K=l+1|0;A=k+4|0;J=9;break;case 6:I=g;G=y;L=n;K=l;A=k;J=9;break;case 5:D=g;O=y;M=n;T=k;X=l;J=10;break;case 4:P=g;Oa=y;F=n;N=k;ba=l;J=11;break;case 3:R=g;S=y;Y=n;ga=k;W=l;J=12;break;case 2:ma=g;U=y;ha=n;da=k;aa=l;J=13;break;default:ca=g,Z=y,fa=n,ja=k,oa=l}9==(J|0)&&(a[A>>2]=(x[G>>0]|0)<<8|x[L>>0]|0|(x[K>>
0]|0)<<16|(x[I>>0]|0)<<24,D=I+1|0,O=G+1|0,M=L+1|0,T=A+4|0,X=K+1|0,J=10);10==(J|0)&&(a[T>>2]=(x[O>>0]|0)<<8|x[M>>0]|0|(x[X>>0]|0)<<16|(x[D>>0]|0)<<24,P=D+1|0,Oa=O+1|0,F=M+1|0,N=T+4|0,ba=X+1|0,J=11);11==(J|0)&&(a[N>>2]=(x[Oa>>0]|0)<<8|x[F>>0]|0|(x[ba>>0]|0)<<16|(x[P>>0]|0)<<24,R=P+1|0,S=Oa+1|0,Y=F+1|0,ga=N+4|0,W=ba+1|0,J=12);12==(J|0)&&(a[ga>>2]=(x[S>>0]|0)<<8|x[Y>>0]|0|(x[W>>0]|0)<<16|(x[R>>0]|0)<<24,ma=R+1|0,U=S+1|0,ha=Y+1|0,da=ga+4|0,aa=W+1|0,J=13);13==(J|0)&&(a[da>>2]=(x[U>>0]|0)<<8|x[ha>>0]|0|
(x[aa>>0]|0)<<16|(x[ma>>0]|0)<<24,u=ma+1|0,C=U+1|0,w=ha+1|0,v=da+4|0,E=aa+1|0,J=14);14==(J|0)&&(J=0,a[v>>2]=(x[C>>0]|0)<<8|x[w>>0]|0|(x[E>>0]|0)<<16|(x[u>>0]|0)<<24,ca=u+1|0,Z=C+1|0,fa=w+1|0,ja=v+4|0,oa=E+1|0);if(p)b=Z+h|0,l=oa+h|0,n=fa+h|0,k=ja+(m<<2)|0,d=ca+h|0;else break}},function(b,d,c,e,f,g,h,m,k,l,n,p){f|=0;g|=0;h|=0;m|=0;var q,y,B,t,r,z,u,C;if(g)for(e=0==(f|0),c=(b|0)+76|0,b=d|0,d=k|0,k=l|0,l=p|0,p=n|0,n=g;;){n=n+-1|0;if(e)g=p,q=d;else{g=p+f|0;q=d+f|0;y=a[c>>2]|0;B=f;t=b;r=k;for(z=l;;)if(B=
B+-1|0,u=x[z>>0]|0,C=u<<8,a[t>>2]=x[y+(x[d>>0]|0|C)>>0]|0|u<<24|(x[y+(x[r>>0]|0|C)>>0]|0)<<8|(x[y+(x[p>>0]|0|C)>>0]|0)<<16,B)p=p+1|0,t=t+4|0,d=d+1|0,r=r+1|0,z=z+1|0;else break;b=b+(f<<2)|0;k=k+f|0;l=l+f|0}if(n)b=b+(m<<2)|0,d=q+h|0,k=k+h|0,l=l+h|0,p=g+h|0;else break}},function(b,d,c,e,f,g,h,m,k,l,n,p){f|=0;g|=0;h|=0;m|=0;var q,y,B,t,r=0,z=0,u=0,C=0,w=0,v=0,E=0,J=0,I=0,G=0,L=0,K=0,A=0,D=0,O=0,M=0,T=0,X=0,P=0,Oa=0,F=0,N=0,ba=0,R=0,S=0,Y=0,ga=0,W=0,ma=0;if(g)for(p=7<f>>>0,e=f+-8|0,c=e&-8,b=e-c|0,e=c+
8|0,c=l|0,l=n|0,n=k|0,k=d|0,d=g;;){d=d+-1|0;if(p){g=k+(e<<2)|0;q=c+e|0;y=n;B=l;for(t=f;!(a[k>>2]=x[y>>0]|0|(x[c>>0]|0)<<8|(x[B>>0]|0)<<16|-16777216,a[k+4>>2]=x[y+1>>0]|0|(x[c+1>>0]|0)<<8|(x[B+1>>0]|0)<<16|-16777216,a[k+8>>2]=x[y+2>>0]|0|(x[c+2>>0]|0)<<8|(x[B+2>>0]|0)<<16|-16777216,a[k+12>>2]=x[y+3>>0]|0|(x[c+3>>0]|0)<<8|(x[B+3>>0]|0)<<16|-16777216,a[k+16>>2]=x[y+4>>0]|0|(x[c+4>>0]|0)<<8|(x[B+4>>0]|0)<<16|-16777216,a[k+20>>2]=x[y+5>>0]|0|(x[c+5>>0]|0)<<8|(x[B+5>>0]|0)<<16|-16777216,a[k+24>>2]=x[y+
6>>0]|0|(x[c+6>>0]|0)<<8|(x[B+6>>0]|0)<<16|-16777216,a[k+28>>2]=x[y+7>>0]|0|(x[c+7>>0]|0)<<8|(x[B+7>>0]|0)<<16|-16777216,t=t+-8|0,7>=t>>>0);)c=c+8|0,y=y+8|0,B=B+8|0,k=k+32|0;l=l+e|0;n=n+e|0;c=b}else g=k,q=c,c=f;switch(c|0){case 1:r=g;z=q;u=n;C=l;w=14;break;case 7:a[g>>2]=x[n>>0]|0|(x[q>>0]|0)<<8|(x[l>>0]|0)<<16|-16777216;v=g+4|0;E=q+1|0;J=n+1|0;I=l+1|0;w=9;break;case 6:v=g;E=q;J=n;I=l;w=9;break;case 5:G=g;L=q;K=n;A=l;w=10;break;case 4:D=g;O=q;M=n;T=l;w=11;break;case 3:X=g;P=q;Oa=n;F=l;w=12;break;
case 2:N=g;ba=q;R=n;S=l;w=13;break;default:Y=g,ga=q,W=n,ma=l}9==(w|0)&&(a[v>>2]=x[J>>0]|0|(x[E>>0]|0)<<8|(x[I>>0]|0)<<16|-16777216,G=v+4|0,L=E+1|0,K=J+1|0,A=I+1|0,w=10);10==(w|0)&&(a[G>>2]=x[K>>0]|0|(x[L>>0]|0)<<8|(x[A>>0]|0)<<16|-16777216,D=G+4|0,O=L+1|0,M=K+1|0,T=A+1|0,w=11);11==(w|0)&&(a[D>>2]=x[M>>0]|0|(x[O>>0]|0)<<8|(x[T>>0]|0)<<16|-16777216,X=D+4|0,P=O+1|0,Oa=M+1|0,F=T+1|0,w=12);12==(w|0)&&(a[X>>2]=x[Oa>>0]|0|(x[P>>0]|0)<<8|(x[F>>0]|0)<<16|-16777216,N=X+4|0,ba=P+1|0,R=Oa+1|0,S=F+1|0,w=13);13==
(w|0)&&(a[N>>2]=x[R>>0]|0|(x[ba>>0]|0)<<8|(x[S>>0]|0)<<16|-16777216,r=N+4|0,z=ba+1|0,u=R+1|0,C=S+1|0,w=14);14==(w|0)&&(w=0,a[r>>2]=x[u>>0]|0|(x[z>>0]|0)<<8|(x[C>>0]|0)<<16|-16777216,Y=r+4|0,ga=z+1|0,W=u+1|0,ma=C+1|0);if(d)c=ga+h|0,l=ma+h|0,n=W+h|0,k=Y+(m<<2)|0;else break}},function(b,d,c,e,f,g,h,m,k,l,n,p){f|=0;g|=0;h|=0;m|=0;var q,y,B,t,r,z;if(g)for(e=0==(f|0),c=(b|0)+80|0,b=d|0,d=g,g=p|0,p=n|0,n=l|0,l=k|0;;){d=d+-1|0;if(e)k=g,q=n;else{k=g+(f<<1)|0;q=n+(f<<1)|0;y=a[c>>2]|0;B=0;t=b;r=p;for(z=l;a[t>>
2]=(x[y+(N[n>>1]|0)>>0]|0)<<8|x[y+(N[z>>1]|0)>>0]|0|(x[y+(N[r>>1]|0)>>0]|0)<<16|(x[y+(N[g>>1]|0)>>0]|0)<<24,B=B+1|0,(B|0)!=(f|0);)t=t+4|0,g=g+2|0,r=r+2|0,n=n+2|0,z=z+2|0;b=b+(f<<2)|0;p=p+(f<<1)|0;l=l+(f<<1)|0}if(d)b=b+(m<<2)|0,g=k+(h<<1)|0,p=p+(h<<1)|0,n=q+(h<<1)|0,l=l+(h<<1)|0;else break}},function(b,d,c,e,f,g,h,m,k,l,n,p){b|=0;f|=0;g|=0;h|=0;m|=0;var q,y,B,t,r,z,u,C,w,v;if(g)for(e=0==(f|0),c=b+80|0,q=b+76|0,b=d|0,d=g,g=p|0,p=n|0,n=l|0,l=k|0;;){d=d+-1|0;if(e)k=p,y=l;else{k=p+(f<<1)|0;y=l+(f<<1)|
0;B=a[c>>2]|0;t=a[q>>2]|0;r=f;z=b;u=g;for(C=n;;)if(r=r+-1|0,w=x[B+(N[u>>1]|0)>>0]|0,v=w<<8,a[z>>2]=x[t+(x[B+(N[l>>1]|0)>>0]|0|v)>>0]|0|w<<24|(x[t+(x[B+(N[C>>1]|0)>>0]|0|v)>>0]|0)<<8|(x[t+(x[B+(N[p>>1]|0)>>0]|0|v)>>0]|0)<<16,r)z=z+4|0,u=u+2|0,p=p+2|0,C=C+2|0,l=l+2|0;else break;b=b+(f<<2)|0;g=g+(f<<1)|0;n=n+(f<<1)|0}if(d)b=b+(m<<2)|0,g=g+(h<<1)|0,p=k+(h<<1)|0,n=n+(h<<1)|0,l=y+(h<<1)|0;else break}},function(b,d,c,e,f,g,h,m,k,l,n,p){f|=0;g|=0;h|=0;m|=0;var q,y,B,t;if(g)for(p=0==(f|0),e=(b|0)+80|0,b=d|
0,d=g,g=n|0,n=l|0,l=k|0;;){d=d+-1|0;if(p)k=b,c=n;else{k=b+(f<<2)|0;c=n+(f<<1)|0;q=a[e>>2]|0;y=0;B=g;for(t=l;a[b>>2]=x[q+(N[t>>1]|0)>>0]|0|(x[q+(N[n>>1]|0)>>0]|0)<<8|(x[q+(N[B>>1]|0)>>0]|0)<<16|-16777216,y=y+1|0,(y|0)!=(f|0);)b=b+4|0,B=B+2|0,n=n+2|0,t=t+2|0;g=g+(f<<1)|0;l=l+(f<<1)|0}if(d)b=k+(m<<2)|0,g=g+(h<<1)|0,n=c+(h<<1)|0,l=l+(h<<1)|0;else break}},function(b,d,c,e,f,g,h,m,k,l,n,p){f|=0;g|=0;h|=0;m|=0;var q,y,B,t,r,z,u;if(g)for(e=0==(f|0),c=d|0,d=k|0,k=p|0,p=n|0,n=l|0,l=g;;){l=l+-1|0;if(e)b=d,g=
p;else{g=p+f|0;b=d+f|0;q=f;y=n;B=c;for(t=k;;)if(q=q+-1|0,r=(x[t>>0]|0)^255,z=((E((x[d>>0]|0)^255,r)|0)>>>0)/255|0,u=((E((x[y>>0]|0)^255,r)|0)>>>0)/255|0,r=z|u<<8|(((E((x[p>>0]|0)^255,r)|0)>>>0)/255|0)<<16|-16777216,a[B>>2]=r,q)y=y+1|0,B=B+4|0,d=d+1|0,t=t+1|0,p=p+1|0;else break;c=c+(f<<2)|0;n=n+f|0;k=k+f|0}if(l)c=c+(m<<2)|0,d=b+h|0,k=k+h|0,p=g+h|0,n=n+h|0;else break}},function(b,d,c,e,f,g,h,m,k,l,n,p){f|=0;g|=0;h|=0;var q,y,B,t,r,z,Q,C;p=u;u=u+16|0;e=p+8|0;c=p+4|0;q=p;if(g)for(y=(b|0)+68|0,b=f+h|0,
B=f+h|0,t=f+h|0,h=f+(m|0)|0,m=n|0,n=d|0,d=l|0,l=k|0,k=g;;){g=f;r=n;z=m;Q=d;for(C=l;;)if(Kb(a[y>>2]|0,x[C>>0]|0,x[Q>>0]|0,x[z>>0]|0,e,c,q),a[r>>2]=a[e>>2]|a[c>>2]<<8|a[q>>2]<<16|-16777216,g=g+-1|0)r=r+4|0,z=z+1|0,Q=Q+1|0,C=C+1|0;else break;if(k=k+-1|0)m=m+t|0,n=n+(h<<2)|0,d=d+B|0,l=l+b|0;else break}u=p},Gf,Gf,Gf,Gf,Gf,Gf,Gf],da=[rf,function(b){var d;d=u;u=u+16|0;a[d>>2]=a[(b|0)+60>>2];b=le(Yk(6,d|0)|0)|0;u=d;return b|0},function(a){return Xk(a|0)|0},function(b){var d,c;d=u;u=u+80|0;c=0>(Nk(b|0,d)|
0);b=a[d+36>>2]|0;U=c?0:(0>(b|0))<<31>>31;u=d;return(c?0:b)|0},function(a){return 1},function(a){return 1},function(b){b|=0;var d,c,e,f,g,h;d=u;u=u+32|0;c=d+8|0;e=d;f=d+12|0;g=b+88|0;h=Ej(w[g>>1]|0)|0;a[e>>2]=N[g>>1];ad(f,142602,e)|0;e=a[b+628>>2]|0;g=a[b>>2]|0;a[c>>2]=h?a[h>>2]|0:f;Y(e,g,142605,c);u=d;return 0},function(a){return 1},function(b){b|=0;var d,c,e,f,g;d=a[b+576>>2]|0;qf(b,1,12);qf(b,1,12);c=d+52|0;if(8==(a[c>>2]|0))return 1;e=b+608|0;(a[e>>2]|0)>=(a[b+592>>2]|0)&&Lc(b)|0;f=d+48|0;d=a[f>>
2]&255;g=b+604|0;b=a[g>>2]|0;a[g>>2]=b+1;t[b>>0]=d;a[e>>2]=(a[e>>2]|0)+1;a[f>>2]=0;a[c>>2]=8;return 1},function(a){return 1},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q=0,y=0,B=0,t=0,r=0,z=0,Q=0;d=u;u=u+32|0;c=d+16|0;e=d+8|0;f=b+576|0;g=a[f>>2]|0;if(1!=(w[b+84>>1]|0))return Y(a[b+628>>2]|0,144065,144080,d),u=d,0;a[b+12>>2]&1024?(h=tg(b)|0,m=b+68|0):(h=Pe(b)|0,m=b+56|0);k=a[m>>2]|0;a[g+8>>2]=h;a[g+12>>2]=k;m=g+28|0;a[m>>2]&1?(p=g+64|0,a[p>>2]=0,q=4294967264>k>>>0?k+31&-32:0,B=y=p,l=9):(l=4==(w[b+
88>>1]|0),n=g+64|0,a[n>>2]=0,p=4294967264>k>>>0?k+31&-32:0,l?(q=p,B=y=n,l=9):(r=t=n,z=0,Q=p,l=10));9==(l|0)&&(q&2147483616|0)==(q|0)&&(t=B,r=y,z=1,Q=q<<1,l=10);if(10==(l|0)&&0!=(Q|0)&&(l=Q<<1,!(0==(l|0)|(Q&2147483647|0)!=(Q|0)))){q=Mf(b,l,4,144177)|0;a[t>>2]=q;if(!q)return u=d,0;Va(q|0,0,Q<<3|0)|0;a[g+72>>2]=a[t>>2];a[g+68>>2]=z?(a[r>>2]|0)+(Q<<2):0;3==(w[b+88>>1]|0)&&0!=(a[m>>2]&1|0)&&(a[b+532>>2]=19,a[b+540>>2]=19,a[b+548>>2]=19);m=a[f>>2]|0;if(!z)return a[m+80>>2]=0,u=d,1;z=eb(h)|0;if(a[m+80>>
2]=z)return u=d,1;Y(a[b+628>>2]|0,144065,144202,c);u=d;return 0}c=a[b+628>>2]|0;z=a[b>>2]|0;a[e>>2]=k;Y(c,z,144134,e);u=d;return 0},function(b){b|=0;var d,c,e,f,g;d=a[b+576>>2]|0;c=d+52|0;if(8==(a[c>>2]|0))return 1;e=b+608|0;(a[e>>2]|0)>=(a[b+592>>2]|0)&&Lc(b)|0;f=d+48|0;d=a[f>>2]&255;g=b+604|0;b=a[g>>2]|0;a[g>>2]=b+1;t[b>>0]=d;a[e>>2]=(a[e>>2]|0)+1;a[f>>2]=0;a[c>>2]=8;return 1},function(b){b|=0;var d=0,c=0,e=0,f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,r=0,z=0,Q=0,C=0,v=0,V=0,E=0,J=0,I=0,G=
0,L=0,K=0,A=0,D=0,O=0,M=0,T=0,X=0,P=0,Oa=0,F=0,R=0,ba=0,S=0,Y=0,W=0,ga=0,Ha=0,ma=0,da=0,ha=0,aa=0,ca=0,fa=0,Nb=0,pa=0,ya=0,oa=0,sa=0,ra=0,ua=0,Ia=0,Da=0,na=0,Na=0,Ka=0,Ca=0,Ga=0,Ea=0,La=0,Qa=0,Va=0,Wa=0,ub=0,xb=0,Zb=0,ab=0,jb=0,mc=0,Ab=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,pb=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,fb=0,Ua=0,Hb=0,Jb=0,Gb=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,Kb=0,lb=
0,nd=0,Zd=0,wb=0,Lb=0,Qd=0,zb=0,Ob=0,Tb=0,Pb=0,Sb=0,db=0,Vb=0,Yb=0,ac=0,fc=0,jc=0,lc=0,$b=0,kc=0,hc=0,ec=0,yc=0,d=u;u=u+48|0;c=d+40|0;e=d+24|0;f=d+16|0;g=d+8|0;if(6!=(w[b+90>>1]|0)||1!=(w[b+126>>1]|0))return u=d,1;h=b+98|0;if(3!=(w[h>>1]|0))return u=d,1;1;m=b+176|0;k=a[m>>2]|0;if(!k)return u=d,1;l=b+172|0;if(!(a[l>>2]|0))return u=d,1;n=k;if(0==(a[n>>2]|0)&0==(a[n+4>>2]|0))return u=d,1;n=eb(2048)|0;if(!n)return Wb(a[b+628>>2]|0,145945,145970,d),u=d,1;k=a[l>>2]|0;l=a[k>>2]|0;p=a[k+4>>2]|0;k=a[m>>2]|
0;m=a[k>>2]|0;q=a[k+4>>2]|0;a:do if(0==(m|0)&0==(q|0))P=b+628|0,Oa=114;else if(k=b+640|0,y=b+628|0,rb[a[k>>2]&63](a[y>>2]|0,l,p,0)|0,B=0>q>>>0|0==(q|0)&2048>m>>>0?m:2048,-1>=(B|0)&&Z(146063,144647,902,146078),H=b+632|0,(Aa[a[H>>2]&63](a[y>>2]|0,n,B)|0)==(B|0)){r=Qb(B|0,0,l|0,p|0)|0;z=U;Q=Ic(m|0,q|0,B|0,0)|0;C=B;v=B=n;V=1;E=Q;Q=U;J=r;r=z;b:for(;;){I=z=v+1|0;G=C+-1|0;c:do if(-1==(t[B>>0]|0)){L=G;K=I;A=E;D=Q;O=V;M=J;T=r;for(X=z;;){if(L)W=K,ga=X,Ha=L,ma=O,da=A,ha=D,aa=M,ca=T;else{if(0==(A|0)&0==(D|0)){P=
y;Oa=114;break a}O<<24>>24?F=O:(rb[a[k>>2]&63](a[y>>2]|0,M,T,0)|0,F=1);R=0>D>>>0|0==(D|0)&2048>A>>>0?A:2048;if(-1>=(R|0)){Oa=31;break b}if((Aa[a[H>>2]&63](a[y>>2]|0,n,R)|0)!=(R|0)){P=y;Oa=114;break a}ba=Qb(R|0,0,M|0,T|0)|0;S=U;Y=Ic(A|0,D|0,R|0,0)|0;ga=W=n;Ha=R;ma=F;da=Y;ha=U;aa=ba;ca=S}S=t[W>>0]|0;ba=ga+1|0;Y=Ha+-1|0;R=ba;if(-1==S<<24>>24)L=Y,K=R,A=da,D=ha,O=ma,M=aa,T=ca,X=ba;else{fa=ma;Nb=S;pa=ba;ya=Y;oa=R;sa=da;ra=ha;ua=aa;Ia=ca;break}}switch(Nb&255|0){case 202:case 201:case 194:case 193:case 192:Da=
fa;na=pa;Na=ya;Ka=sa;Ca=ra;Ga=ua;Ea=Ia;Oa=58;break b;case 216:La=pa;Qa=fa;Va=sa;Wa=ra;ub=ua;xb=Ia;Zb=ya;ab=oa;Oa=16;break c;case 221:case 196:case 218:case 219:case 239:case 238:case 237:case 236:case 235:case 234:case 233:case 232:case 231:case 230:case 229:case 228:case 227:case 226:case 225:case 224:case 254:break;default:P=y;Oa=114;break a}if(ya)mc=pa,Ab=ya,Ta=sa,Ya=ra,Sa=fa,mb=ua,Db=Ia;else{if(0==(sa|0)&0==(ra|0)){P=y;Oa=114;break a}fa<<24>>24?jb=fa:(rb[a[k>>2]&63](a[y>>2]|0,ua,Ia,0)|0,jb=1);
X=0>ra>>>0|0==(ra|0)&2048>sa>>>0?sa:2048;if(-1>=(X|0)){Oa=41;break b}if((Aa[a[H>>2]&63](a[y>>2]|0,n,X)|0)!=(X|0)){P=y;Oa=114;break a}T=Qb(X|0,0,ua|0,Ia|0)|0;M=U;O=Ic(sa|0,ra|0,X|0,0)|0;mc=n;Ab=X;Ta=O;Ya=U;Sa=jb;mb=T;Db=M}M=t[mc>>0]|0;T=mc+1|0;if(O=Ab+-1|0)Za=T,ia=O,qa=Ya,Ja=Ta,ea=mb,wa=Db,Ma=Sa;else{if(0==(Ta|0)&0==(Ya|0)){P=y;Oa=114;break a}Sa<<24>>24?cc=Sa:(rb[a[k>>2]&63](a[y>>2]|0,mb,Db,0)|0,cc=1);X=0>Ya>>>0|0==(Ya|0)&2048>Ta>>>0?Ta:2048;if(-1>=(X|0)){Oa=49;break b}if((Aa[a[H>>2]&63](a[y>>2]|0,
n,X)|0)!=(X|0)){P=y;Oa=114;break a}D=Qb(X|0,0,mb|0,Db|0)|0;A=U;K=Ic(Ta|0,Ya|0,X|0,0)|0;Za=n;ia=X;qa=U;Ja=K;ea=D;wa=A;Ma=cc}O=Za+1|0;T=ia+-1|0;A=x[Za>>0]|(M&255)<<8;if(2>(A&65535)){P=y;Oa=114;break a}M=A+65534|0;if(A=M&65535)if(T>>>0>=A>>>0)La=O=Za+(A+1)|0,Qa=Ma,Va=Ja,Wa=qa,ub=ea,xb=wa,Zb=T-A|0,ab=O,Oa=16;else{O=M-T&65535;if(0>qa>>>0|0==(qa|0)&Ja>>>0<O>>>0){P=y;Oa=114;break a}T=Qb(O|0,0,ea|0,wa|0)|0;M=U;xa=A=Ic(Ja|0,qa|0,O|0,0)|0;$a=U;la=0;Ba=T;va=M}else La=O,Qa=Ma,Va=Ja,Wa=qa,ub=ea,xb=wa,Zb=T,ab=
O,Oa=16}else La=z,Qa=V,Va=E,Wa=Q,ub=J,xb=r,Zb=G,ab=I,Oa=16;while(0);if(16==(Oa|0))if(Oa=0,Zb){C=Zb;B=ab;v=La;V=Qa;E=Va;Q=Wa;J=ub;r=xb;continue}else xa=Va,$a=Wa,la=Qa,Ba=ub,va=xb;if(0==(xa|0)&0==($a|0)){P=y;Oa=114;break a}la<<24>>24?za=la:(rb[a[k>>2]&63](a[y>>2]|0,Ba,va,0)|0,za=1);I=0>$a>>>0|0==($a|0)&2048>xa>>>0?xa:2048;if(-1>=(I|0)){Oa=22;break}if((Aa[a[H>>2]&63](a[y>>2]|0,n,I)|0)!=(I|0)){P=y;Oa=114;break a}G=Qb(I|0,0,Ba|0,va|0)|0;z=U;M=Ic(xa|0,$a|0,I|0,0)|0;C=I;v=B=n;V=za;E=M;Q=U;J=G;r=z}if(22==
(Oa|0))Z(146063,144647,902,146078);else if(31==(Oa|0))Z(146063,144647,902,146078);else if(41==(Oa|0))Z(146063,144647,902,146078);else if(49==(Oa|0))Z(146063,144647,902,146078);else if(58==(Oa|0)){if(Na)nb=na,sc=Na,gb=Ka,hb=Ca,ob=Da,Bb=Ga,qb=Ea;else{if(0==(Ka|0)&0==(Ca|0)){P=y;Oa=114;break}Da<<24>>24?ta=Da:(rb[a[k>>2]&63](a[y>>2]|0,Ga,Ea,0)|0,ta=1);r=0>Ca>>>0|0==(Ca|0)&2048>Ka>>>0?Ka:2048;-1>=(r|0)&&Z(146063,144647,902,146078);if((Aa[a[H>>2]&63](a[y>>2]|0,n,r)|0)!=(r|0)){P=y;Oa=114;break}J=Qb(r|0,
0,Ga|0,Ea|0)|0;Q=U;E=Ic(Ka|0,Ca|0,r|0,0)|0;nb=n;sc=r;gb=E;hb=U;ob=ta;Bb=J;qb=Q}Q=t[nb>>0]|0;J=nb+1|0;if(E=sc+-1|0)ib=J,Cb=E,pb=hb,sb=gb,Xa=Bb,Fa=qb,Pa=ob;else{if(0==(gb|0)&0==(hb|0)){P=y;Oa=114;break}ob<<24>>24?kb=ob:(rb[a[k>>2]&63](a[y>>2]|0,Bb,qb,0)|0,kb=1);r=0>hb>>>0|0==(hb|0)&2048>gb>>>0?gb:2048;-1>=(r|0)&&Z(146063,144647,902,146078);if((Aa[a[H>>2]&63](a[y>>2]|0,n,r)|0)!=(r|0)){P=y;Oa=114;break}V=Qb(r|0,0,Bb|0,qb|0)|0;v=U;B=Ic(gb|0,hb|0,r|0,0)|0;ib=n;Cb=r;pb=U;sb=B;Xa=V;Fa=v;Pa=kb}if((x[ib>>0]|
(Q&255)<<8|0)!=((3*(N[h>>1]|0)|0)+8|0))P=y,Oa=114;else{if(7<=(Cb+-1|0)>>>0)(Q=Cb+-8|0)?(Mb=ib+8|0,fb=Q,Ua=sb,Hb=pb,Jb=Xa,Gb=Fa,yb=Pa):(Eb=sb,vb=pb,tb=Pa,bb=Xa,Ib=Fa,Oa=79);else{Q=8-Cb&65535;if(0>pb>>>0|0==(pb|0)&sb>>>0<Q>>>0){P=y;Oa=114;break}E=Qb(Q|0,0,Xa|0,Fa|0)|0;J=U;Eb=v=Ic(sb|0,pb|0,Q|0,0)|0;vb=U;tb=0;bb=E;Ib=J;Oa=79}if(79==(Oa|0)){if(0==(Eb|0)&0==(vb|0)){P=y;Oa=114;break}tb<<24>>24?cb=tb:(rb[a[k>>2]&63](a[y>>2]|0,bb,Ib,0)|0,cb=1);J=0>vb>>>0|0==(vb|0)&2048>Eb>>>0?Eb:2048;-1>=(J|0)&&Z(146063,
144647,902,146078);if((Aa[a[H>>2]&63](a[y>>2]|0,n,J)|0)!=(J|0)){P=y;Oa=114;break}E=Qb(J|0,0,bb|0,Ib|0)|0;v=U;Q=Ic(Eb|0,vb|0,J|0,0)|0;Mb=n;fb=J;Ua=Q;Hb=U;Jb=E;Gb=v;yb=cb}v=t[Mb>>0]|0;E=(v&255)>>>4;Q=v&15;v=Mb+1|0;1==(fb|0)?(0==(Ua|0)&0==(Hb|0)?(gc=v,Ub=yb,Kb=Fb=0,lb=Jb,nd=Gb):(J=Qb(Jb|0,Gb|0,1,0)|0,V=U,B=Qb(Ua|0,Hb|0,-1,-1)|0,gc=v,Ub=0,Fb=B,Kb=U,lb=J,nd=V),Zd=0):(gc=Mb+2|0,Ub=yb,Fb=Ua,Kb=Hb,lb=Jb,nd=Gb,Zd=fb+-2|0);b:do if(1<(N[h>>1]|0)){V=Zd;J=Fb;B=Kb;v=lb;r=nd;C=gc;z=Ub;for(G=1;;){if(V)(M=V+-1|0)?
(Tb=C+1|0,Pb=M,Sb=J,db=B,Vb=v,Yb=r,ac=z):(wb=J,Lb=B,Qd=z,zb=v,Ob=r,Oa=95);else{if(0==(J|0)&0==(B|0)){P=y;Oa=114;break a}M=Qb(v|0,r|0,1,0)|0;I=U;wb=T=Qb(J|0,B|0,-1,-1)|0;Lb=U;Qd=0;zb=M;Ob=I;Oa=95}if(95==(Oa|0)){Oa=0;if(0==(wb|0)&0==(Lb|0)){P=y;Oa=114;break a}Qd<<24>>24?fc=Qd:(rb[a[k>>2]&63](a[y>>2]|0,zb,Ob,0)|0,fc=1);I=0>Lb>>>0|0==(Lb|0)&2048>wb>>>0?wb:2048;if(-1>=(I|0)){Oa=99;break}if((Aa[a[H>>2]&63](a[y>>2]|0,n,I)|0)!=(I|0)){P=y;Oa=114;break a}M=Qb(I|0,0,zb|0,Ob|0)|0;T=U;A=Ic(wb|0,Lb|0,I|0,0)|0;
Tb=n;Pb=I;Sb=A;db=U;Vb=M;Yb=T;ac=fc}T=Tb+1|0;if(17!=(t[Tb>>0]|0)){Oa=103;break}1==(Pb|0)?(0==(Sb|0)&0==(db|0)?(jc=T,lc=ac,kc=$b=0,hc=Vb,ec=Yb):(M=Qb(Vb|0,Yb|0,1,0)|0,A=U,I=Qb(Sb|0,db|0,-1,-1)|0,jc=T,lc=0,$b=I,kc=U,hc=M,ec=A),yc=0):(jc=Tb+2|0,lc=ac,$b=Sb,kc=db,hc=Vb,ec=Yb,yc=Pb+-2|0);G=G+1<<16>>16;if((G&65535)>=(N[h>>1]|0))break b;else V=yc,J=$b,B=kc,v=hc,r=ec,C=jc,z=lc}if(99==(Oa|0))Z(146063,144647,902,146078);else if(103==(Oa|0)){Wb(a[y>>2]|0,146111,146139,g);break a}}while(0);H=E&255;b:do switch(E<<
24>>24){case 4:case 2:case 1:switch(Q|0){case 4:case 2:case 1:break;default:break b}k=b+192|0;z=N[k>>1]|0;C=b+194|0;r=N[C>>1]|0;if((H|0)==(z|0)&(Q|0)==(r|0))break a;v=a[y>>2]|0;a[e>>2]=z;a[e+4>>2]=r;a[e+8>>2]=H;a[e+12>>2]=Q;Wb(v,146111,146261,e);w[k>>1]=E&255;w[C>>1]=Q;break a}while(0);Wb(a[y>>2]|0,146111,146139,f)}}}else P=y,Oa=114;while(0);114==(Oa|0)&&Wb(a[P>>2]|0,145945,146379,c);ja(n);u=d;return 1},function(b){b|=0;var d,c,e,f,g=0;d=u;u=u+16|0;c=d;e=a[b+576>>2]|0;f=e+488|0;a[f>>2]|0?a[e+16>>
2]|0||(Se(e),a[f>>2]=0,g=4):g=4;do if(4==(g|0)){var h;h=e;h|=0;var m,k,l,n,p,q,y=0,B=0;m=4;k=Hc(40)|0;a[k>>2]=0;l=h+492|0;Wa=0;n=si(19,l|0)|0;p=Wa;Wa=0;0!=(p|0)&0!=(pa|0)?((q=db(a[p>>2]|0,k|0,m|0)|0)||Vb(p|0,pa|0),U=pa):q=-1;1!=(q|0)?(a[h>>2]=n,a[l>>2]=14,a[h+500>>2]=15,a[h+12>>2]=0,k=Xc(h+624|0,1,k|0,m|0)|0,m=U,Wa=l=Wa=0,0!=(l|0)&0!=(pa|0)?((n=db(a[l>>2]|0,k|0,m|0)|0)||Vb(l|0,pa|0),U=pa):n=-1,l=1!=(n|0)?0:U):l=U;for(;;){if(l){y=0;B=7;break}Wa=0;Qi(14,h|0,90,488);n=Wa;Wa=0;0!=(n|0)&0!=(pa|0)?((l=
db(a[n>>2]|0,k|0,m|0)|0)||Vb(n|0,pa|0),U=pa):l=-1;if(1==(l|0))l=U;else break}7!=(B|0)&&(y=1);Gc(k|0);h=y|0;h|0?a[f>>2]=1:e||Z(154187,144647,972,145904)}while(0);a[e+16>>2]|0||Z(145286,144647,973,145904);if(0!=(a[b+48>>2]&4|0)&&(f=e+800|0,a[e+24>>2]=f,a[e+812>>2]=16,a[e+816>>2]=1,a[e+820>>2]=29,a[e+824>>2]=5,a[e+804>>2]=0,a[f>>2]=0,a[e+808>>2]=6,2!=(fg(e,0)|0)))return Y(a[b+628>>2]|0,145904,145920,c),u=d,0;c=w[b+90>>1]|0;w[e+832>>1]=c;6==c<<16>>16?(w[e+834>>1]=w[b+192>>1]|0,c=w[b+194>>1]|0):c=w[e+
834>>1]=1;w[e+836>>1]=c;c=e+800|0;a[e+24>>2]=c;a[e+808>>2]=7;a[e+812>>2]=16;a[e+816>>2]=1;a[e+820>>2]=29;a[e+824>>2]=5;a[e+804>>2]=0;a[c>>2]=0;a[b+652>>2]=3;u=d;return 1},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,t=0,r;d=u;u=u+96|0;c=d+56|0;e=d+48|0;f=d+40|0;g=d+32|0;h=d+24|0;m=d+16|0;k=d+8|0;l=d;n=d+88|0;p=d+64|0;q=b+576|0;y=a[q>>2]|0;B=y+488|0;a[B>>2]|0?a[y+16>>2]|0&&(Se(y),a[B>>2]=0,t=4):t=4;do if(4==(t|0)){r=y;r|=0;var z,Q,C,x,v,E,J=0,I=0;z=4;Q=Hc(40)|0;a[Q>>2]=0;C=r+492|0;Wa=0;x=si(19,
C|0)|0;v=Wa;Wa=0;0!=(v|0)&0!=(pa|0)?((E=db(a[v>>2]|0,Q|0,z|0)|0)||Vb(v|0,pa|0),U=pa):E=-1;1!=(E|0)?(a[r>>2]=x,a[C>>2]=14,a[r+500>>2]=15,a[r+12>>2]=0,Q=Xc(r+624|0,1,Q|0,z|0)|0,z=U,Wa=C=Wa=0,0!=(C|0)&0!=(pa|0)?((x=db(a[C>>2]|0,Q|0,z|0)|0)||Vb(C|0,pa|0),U=pa):x=-1,C=1!=(x|0)?0:U):C=U;for(;;){if(C){J=0;I=7;break}Wa=0;Qi(13,r|0,90,440);x=Wa;Wa=0;0!=(x|0)&0!=(pa|0)?((C=db(a[x>>2]|0,Q|0,z|0)|0)||Vb(x|0,pa|0),U=pa):C=-1;if(1==(C|0))C=U;else break}7!=(I|0)&&(J=1);Gc(Q|0);r=J|0;r|0?a[B>>2]=1:y||Z(154187,144647,
1590,144952)}while(0);a[y+16>>2]|0&&Z(144876,144647,1591,144952);B=w[b+90>>1]|0;t=y+832|0;w[t>>1]=B;a:do{if(1==(w[b+126>>1]|0)){r=w[b+98>>1]|0;a[y+36>>2]=r&65535;if(6==B<<16>>16){B=y+40|0;a[B>>2]=1==(a[y+924>>2]|0)?2:3;break}b:do if(2>(B&65535)){if(1==r<<16>>16){a[y+40>>2]=1;break a}}else switch(B<<16>>16){case 2:if(3!=r<<16>>16)break b;a[y+40>>2]=2;break a;case 5:if(4!=r<<16>>16)break b;a[y+40>>2]=4;break a;default:break b}while(0)}else a[y+36>>2]=1;a[y+40>>2]=0}while(0);B=y|0;J=Q=0;r=4;z=Hc(40)|
0;a[z>>2]=0;z=Xc(B+624|0,1,z|0,r|0)|0;r=U;Wa=C=Wa=0;0!=(C|0)&0!=(pa|0)?((I=db(a[C>>2]|0,z|0,r|0)|0)||Vb(C|0,pa|0),U=pa):I=-1;for(I=1==(I|0)?U:0;;){if(I){Q=0;J=6;break}Wa=0;ri(16,B|0);I=Wa;Wa=0;0!=(I|0)&0!=(pa|0)?((C=db(a[I>>2]|0,z|0,r|0)|0)||Vb(I|0,pa|0),U=pa):C=-1;if(1==(C|0))I=U;else break}6!=(J|0)&&(Q=1);Gc(z|0);if(!(Q|0))return u=d,0;B=N[t>>1]|0;switch(B|0){case 6:w[y+834>>1]=w[b+192>>1]|0;w[y+836>>1]=w[b+194>>1]|0;a[l>>2]=n;Pd(b,532,l)|0||(l=1<<N[b+84>>1],W[p>>2]=0,m=+(l+-1|0),W[p+4>>2]=m,l=
+(l>>1|0),W[p+8>>2]=l,W[p+12>>2]=m,W[p+16>>2]=l,W[p+20>>2]=m,a[k>>2]=p,lb(b,532,k)|0);break;case 4:case 3:return k=a[b+628>>2]|0,a[m>>2]=B,Y(k,144952,144968,m),u=d,0;default:w[y+834>>1]=1,w[y+836>>1]=1}m=w[b+84>>1]|0;k=m&65535;if(8!=m<<16>>16)return m=a[b+628>>2]|0,a[h>>2]=k,Y(m,144952,145018,h),u=d,0;a[y+72>>2]=k;k=b+12|0;if(a[k>>2]&1024){e=N[y+836>>1]<<3;if(((a[b+72>>2]|0)>>>0)%(e>>>0)|0)return h=a[b+628>>2]|0,a[g>>2]=e,Y(h,144952,145056,g),u=d,0;g=N[y+834>>1]<<3;if(((a[b+68>>2]|0)>>>0)%(g>>>0)|
0)return h=a[b+628>>2]|0,a[f>>2]=g,Y(h,144952,145096,f),u=d,0}else if(h=a[b+100>>2]|0,h>>>0<(a[b+60>>2]|0)>>>0&&(m=N[y+836>>1]<<3,0!=((h>>>0)%(m>>>0)|0)))return h=a[b+628>>2]|0,a[e>>2]=m,Y(h,144952,145135,e),u=d,0;do if(a[y+928>>2]&3){if(f=a[y+912>>2]|0,0==(f|0)||0==(Ak(f,145180,8)|0)){f=a[q>>2]|0;if(!(mg(f,a[f+920>>2]|0)|0))return b=0,u=d,b|0;e=f;e|=0;l=p=0;g=4;h=Hc(40)|0;a[h>>2]=0;h=Xc(e+624|0,1,h|0,g|0)|0;g=U;Wa=n=Wa=0;0!=(n|0)&0!=(pa|0)?((m=db(a[n>>2]|0,h|0,g|0)|0)||Vb(n|0,pa|0),U=pa):m=-1;for(m=
1==(m|0)?U:0;;){if(m){p=0;l=6;break}Wa=0;dk(4,e|0,1);m=Wa;Wa=0;0!=(m|0)&0!=(pa|0)?((n=db(a[m>>2]|0,h|0,g|0)|0)||Vb(m|0,pa|0),U=pa):n=-1;if(1==(n|0))m=U;else break}6!=(l|0)&&(p=1);Gc(h|0);e=p|0;if(!(e|0))return b=0,u=d,b|0;h=a[f+928>>2]|0;h&1&&(g=f+88|0,(e=a[g>>2]|0)&&(a[e+128>>2]=0),6==(w[f+832>>1]|0)&&(e=a[g+4>>2]|0,0!=(e|0))&&(a[e+128>>2]=0));h&2&&(h=f+120|0,(e=a[h>>2]|0)&&(a[e+276>>2]=0),e=f+136|0,(g=a[e>>2]|0)&&(a[g+276>>2]=0),6==(w[f+832>>1]|0)&&((g=a[h+4>>2]|0)&&(a[g+276>>2]=0),(g=a[e+4>>2]|
0)&&(a[g+276>>2]=0)));g=f+912|0;(e=a[g>>2]|0)&&ja(e);e=f+916|0;a[e>>2]=1E3;h=eb(1E3)|0;a[g>>2]=h;if(!h)return a[e>>2]=0,Y(a[(a[f+828>>2]|0)+628>>2]|0,145190,145211,c),b=0,u=d,b|0;a[f+24>>2]=f+780;a[f+788>>2]=8;a[f+792>>2]=17;a[f+796>>2]=9;f|=0;p=h=0;e=4;g=Hc(40)|0;a[g>>2]=0;g=Xc(f+624|0,1,g|0,e|0)|0;e=U;Wa=m=Wa=0;0!=(m|0)&0!=(pa|0)?((l=db(a[m>>2]|0,g|0,e|0)|0)||Vb(m|0,pa|0),U=pa):l=-1;for(l=1==(l|0)?U:0;;){if(l){h=0;p=6;break}Wa=0;ri(17,f|0);l=Wa;Wa=0;0!=(l|0)&0!=(pa|0)?((m=db(a[l>>2]|0,g|0,e|0)|
0)||Vb(l|0,pa|0),U=pa):m=-1;if(1==(m|0))l=U;else break}6!=(p|0)&&(h=1);Gc(g|0);f=h|0;if(f|0)a[k>>2]|=8,f=b+48|0,a[f>>2]|=4;else return b=0,u=d,b|0}}else f=b+48|0,a[f>>2]&=-5;while(0);a[y+24>>2]=y+780;a[y+788>>2]=10;a[y+792>>2]=18;a[y+796>>2]=11;u=d;return 1},function(b){var d,c,e,f,g,h,m,k,l,n,p;d=(b|0)+576|0;b=a[d>>2]|0;c=b+884|0;e=a[c>>2]|0;do if(0<(e|0)){f=b+76|0;g=a[f>>2]|0;a:do if(0<(g|0))for(h=e,m=g,g=0,k=a[b+84>>2]|0;;){l=a[k+12>>2]|0;n=a[k+28>>2]<<3;h=E(h,l)|0;if((h|0)<(l<<3|0)){m=b+844+(g<<
2)|0;p=l<<3;l=h;do h=a[m>>2]|0,Ab(a[h+(l<<2)>>2]|0,a[h+(l+-1<<2)>>2]|0,n),l=l+1|0;while((l|0)!=(p|0));l=a[f>>2]|0}else l=m;p=g+1|0;if((p|0)>=(l|0))break a;h=a[c>>2]|0;m=l;g=p;k=k+88|0}while(0);f=a[b+276>>2]<<3;if((Re(b,b+844|0,f)|0)==(f|0))f=a[d>>2]|0;else return b=0,b|0}else f=b;while(0);b=f|0;f=e=0;d=4;c=Hc(40)|0;a[c>>2]=0;c=Xc(b+624|0,1,c|0,d|0)|0;d=U;Wa=k=Wa=0;0!=(k|0)&0!=(pa|0)?((g=db(a[k>>2]|0,c|0,d|0)|0)||Vb(k|0,pa|0),U=pa):g=-1;for(g=1==(g|0)?U:0;;){if(g){e=0;f=6;break}Wa=0;ri(13,b|0);g=Wa;
Wa=0;0!=(g|0)&0!=(pa|0)?((k=db(a[g>>2]|0,c|0,d|0)|0)||Vb(g|0,pa|0),U=pa):k=-1;if(1==(k|0))g=U;else break}6!=(f|0)&&(e=1);Gc(c|0);b=e|0;return b|0},function(b){b|=0;var d;d=a[b>>2]|0;a[d+20>>2]=123;ub[a[d+4>>2]&31](b,-1);d=b+800|0;a[d>>2]=145943;a[d+4>>2]=2;return 1},function(b){b|=0;var d,c,e,f;d=b+912|0;c=b+916|0;e=nf(a[d>>2]|0,(a[c>>2]|0)+1E3|0)|0;e||(f=a[b>>2]|0,a[f+20>>2]=56,a[f+24>>2]=100,R[a[f>>2]&127](b));f=a[c>>2]|0;a[b+780>>2]=e+f;a[b+784>>2]=1E3;a[d>>2]=e;a[c>>2]=f+1E3;return 1},function(b){b|=
0;var d,c;d=a[b+828>>2]|0;c=d+592|0;a[d+608>>2]=a[c>>2];Lc(d)|0;a[b+780>>2]=a[d+588>>2];a[b+784>>2]=a[c>>2];return 1},Fg,function(b){b|=0;var d,c,e,f=0,g=0;d=b+20|0;c=a[d>>2]|0;2>(c+-205|0)>>>0&&0==(a[b+64>>2]|0)?((a[b+140>>2]|0)>>>0<(a[b+116>>2]|0)>>>0&&(e=a[b>>2]|0,a[e+20>>2]=69,R[a[e>>2]&127](b)),R[a[(a[b+444>>2]|0)+4>>2]&127](b),a[d>>2]=210):f=6;a:do if(6==(f|0))switch(c|0){case 210:break a;case 207:a[d>>2]=210;break a;default:e=a[b>>2]|0;a[e+20>>2]=21;a[e+24>>2]=c;R[a[e>>2]&127](b);break a}while(0);
for(c=b+460|0;;){d=a[c>>2]|0;if(a[d+20>>2]|0)break;if(!(da[a[d>>2]&63](b)|0)){g=0;f=13;break}}if(13==(f|0))return g|0;R[a[(a[b+24>>2]|0)+24>>2]&127](b);yi(b);return 1},function(b){b|=0;var d,c,e=0,f,g=0,h,m,k,l,n,p,q,y;d=b+20|0;c=a[d>>2]|0;a:do switch(c|0){case 202:var B=b,B=B|0,H=void 0,r=void 0,z=void 0,u=void 0,C=void 0,x=void 0,w=void 0,v=void 0,J=void 0,I=void 0,H=B+4|0,r=Aa[a[a[H>>2]>>2]&63](B,1,28)|0;a[B+444>>2]=r;a[r>>2]=43;a[r+4>>2]=44;a[r+8>>2]=0;z=a[B+212>>2]|0;8!=(z|0)&&(u=a[B>>2]|0,a[u+
20>>2]=16,a[u+24>>2]=z,R[a[u>>2]&127](B));var G=B,G=G|0,L=void 0,K=void 0,A=void 0,D=void 0,O=void 0,M=void 0,T=void 0,X=void 0,P=void 0,F=void 0,N=void 0,S=void 0,ba=void 0,Y=0,W=void 0,U=void 0,ga=void 0,Ha=void 0,ma=0,aa=0,ha=0,ca=void 0,fa=void 0,L=a[G+20>>2]|0;202!=(L|0)&&(K=a[G>>2]|0,a[K+20>>2]=21,a[K+24>>2]=L,R[a[K>>2]&127](G));var Z=G,Z=Z|0,ja=void 0,pa=void 0,ya=void 0,oa=void 0,sa=void 0,ra=void 0,ua=void 0,ja=Z+428|0,pa=a[ja>>2]|0,ya=E(pa,a[Z+48>>2]|0)|0,oa=a[Z+52>>2]|0;ya>>>0>oa>>>0?ya>>>
0<=oa<<1>>>0?(sa=Gb(a[Z+28>>2]<<1,pa)|0,a[Z+112>>2]=sa,sa=Gb(a[Z+32>>2]<<1,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=2,ra=a[Z+328>>2]=2):ya>>>0<=(3*oa|0)>>>0?(sa=Gb(3*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(3*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=3,ra=a[Z+328>>2]=3):ya>>>0<=oa<<2>>>0?(sa=Gb(a[Z+28>>2]<<2,pa)|0,a[Z+112>>2]=sa,sa=Gb(a[Z+32>>2]<<2,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=4,ra=a[Z+328>>2]=4):ya>>>0<=(5*oa|0)>>>0?(sa=Gb(5*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=
Gb(5*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=5,ra=a[Z+328>>2]=5):ya>>>0<=(6*oa|0)>>>0?(sa=Gb(6*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(6*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=6,ra=a[Z+328>>2]=6):ya>>>0<=(7*oa|0)>>>0?(sa=Gb(7*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(7*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=7,ra=a[Z+328>>2]=7):ya>>>0<=oa<<3>>>0?(sa=Gb(a[Z+28>>2]<<3,pa)|0,a[Z+112>>2]=sa,sa=Gb(a[Z+32>>2]<<3,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+
324>>2]=8,ra=a[Z+328>>2]=8):ya>>>0<=(9*oa|0)>>>0?(sa=Gb(9*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(9*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=9,ra=a[Z+328>>2]=9):ya>>>0<=(10*oa|0)>>>0?(sa=Gb(10*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(10*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=10,ra=a[Z+328>>2]=10):ya>>>0<=(11*oa|0)>>>0?(sa=Gb(11*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(11*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=11,ra=a[Z+328>>2]=11):ya>>>
0<=(12*oa|0)>>>0?(sa=Gb(12*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(12*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=12,ra=a[Z+328>>2]=12):ya>>>0<=(13*oa|0)>>>0?(sa=Gb(13*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(13*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=13,ra=a[Z+328>>2]=13):ya>>>0<=(14*oa|0)>>>0?(sa=Gb(14*(a[Z+28>>2]|0)|0,pa)|0,a[Z+112>>2]=sa,sa=Gb(14*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=sa,a[Z+324>>2]=14,ra=a[Z+328>>2]=14):(sa=a[Z+28>>2]|0,ya>>>0>(15*oa|
0)>>>0?(ua=Gb(sa<<4,pa)|0,a[Z+112>>2]=ua,ua=Gb(a[Z+32>>2]<<4,a[ja>>2]|0)|0,a[Z+116>>2]=ua,a[Z+324>>2]=16,ra=a[Z+328>>2]=16):(ua=Gb(15*sa|0,pa)|0,a[Z+112>>2]=ua,ua=Gb(15*(a[Z+32>>2]|0)|0,a[ja>>2]|0)|0,a[Z+116>>2]=ua,a[Z+324>>2]=15,ra=a[Z+328>>2]=15)):(ua=Gb(a[Z+28>>2]|0,pa)|0,a[Z+112>>2]=ua,ua=Gb(a[Z+32>>2]|0,a[ja>>2]|0)|0,a[Z+116>>2]=ua,a[Z+324>>2]=1,ra=a[Z+328>>2]=1);ja=a[Z+36>>2]|0;if(!(0>=(ja|0)))for(pa=0,oa=a[Z+216>>2]|0;!(a[oa+36>>2]=ra,a[oa+40>>2]=ra,pa=pa+1|0,(pa|0)>=(ja|0));)oa=oa+88|0;K=
a[G+216>>2]|0;L=G+36|0;A=a[L>>2]|0;if(D=0<(A|0)){O=a[G+324>>2]|0;M=0!=(a[G+76>>2]|0)?8:4;T=G+320|0;X=a[G+328>>2]|0;if((O|0)>(M|0))for(P=(X|0)>(M|0),F=O<<1,N=0,S=K;;){ba=S+36|0;a[ba>>2]=O;c:do if(P)Y=1;else for(W=a[T>>2]|0,U=a[S+12>>2]|0,ga=1;;){Ha=ga<<1;if((W|0)%(E(Ha,U)|0)|0){Y=ga;break c}if((E(X,Ha)|0)>(M|0)){Y=Ha;break}else ga=Ha}while(0);ga=E(X,Y)|0;U=S+40|0;a[U>>2]=ga;W=ga<<1;(O|0)<=(W|0)?(ga|0)>(F|0)&&(a[U>>2]=F):a[ba>>2]=W;N=N+1|0;if((N|0)>=(A|0))break;else S=S+88|0}else for(S=a[G+316>>2]|
0,N=(X|0)>(M|0),F=0,Y=K;;){P=a[Y+8>>2]|0;for(W=1;;){U=W<<1;if((S|0)%(E(U,P)|0)|0){ma=W;break}if((E(O,U)|0)>(M|0)){ma=U;break}else W=U}W=E(O,ma)|0;P=Y+36|0;a[P>>2]=W;c:do if(N)aa=1;else for(ba=a[T>>2]|0,U=a[Y+12>>2]|0,ga=1;;){Ha=ga<<1;if((ba|0)%(E(Ha,U)|0)|0){aa=ga;break c}if((E(X,Ha)|0)>(M|0)){aa=Ha;break}else ga=Ha}while(0);ga=E(X,aa)|0;U=Y+40|0;a[U>>2]=ga;ba=ga<<1;(W|0)<=(ba|0)?(Ha=W<<1,(ga|0)>(Ha|0)&&(a[U>>2]=Ha)):a[P>>2]=ba;F=F+1|0;if((F|0)>=(A|0))break;else Y=Y+88|0}if(D)for(D=G+28|0,Y=G+316|
0,F=G+428|0,aa=G+32|0,X=G+320|0,M=0,T=K;;)if(K=E(E(a[T+8>>2]|0,a[D>>2]|0)|0,a[T+36>>2]|0)|0,N=Gb(K,E(a[F>>2]|0,a[Y>>2]|0)|0)|0,a[T+44>>2]=N,N=E(E(a[T+12>>2]|0,a[aa>>2]|0)|0,a[T+40>>2]|0)|0,K=Gb(N,E(a[F>>2]|0,a[X>>2]|0)|0)|0,a[T+48>>2]=K,M=M+1|0,K=a[L>>2]|0,(M|0)>=(K|0)){ha=K;break}else T=T+88|0;else ha=A}else ha=A;switch(a[G+44>>2]|0){case 1:ca=a[G+120>>2]=1;break;case 6:case 2:ca=a[G+120>>2]=3;break;case 7:case 3:ca=a[G+120>>2]=3;break;case 5:case 4:ca=a[G+120>>2]=4;break;default:ca=a[G+120>>2]=
ha}a[G+124>>2]=0==(a[G+84>>2]|0)?ca:1;vh(G)|0?(fa=a[G+320>>2]|0,a[(G+128|0)>>2]=fa):a[(G+128|0)>>2]=1;u=Aa[a[a[H>>2]>>2]&63](B,1,1280)|0;Va(u|0,0,512)|0;a[B+336>>2]=u+512;z=0;do t[u+(z+512)>>0]=z,z=z+1|0;while(256!=(z|0));Va(u+768|0,-1,512)|0;0!=(a[B+116>>2]|0)&&0!=(a[B+112>>2]|0)&&(u=B+120|0,1<=(a[u>>2]|0))?C=u:(u=a[B>>2]|0,a[u+20>>2]=33,R[a[u>>2]&127](B),C=B+120|0);u=r+12|0;a[u>>2]=0;z=vh(B)|0;x=r+16|0;a[x>>2]=z;z=r+20|0;a[z>>2]=0;w=r+24|0;a[w>>2]=0;if(a[B+84>>2]|0){a[B+64>>2]|0||(a[B+100>>2]=0,
a[B+104>>2]=0,a[B+108>>2]=0);r=B+68|0;a[r>>2]|0&&(J=a[B>>2]|0,a[J+20>>2]=48,R[a[J>>2]&127](B));3==(a[C>>2]|0)?a[B+136>>2]|0?a[B+104>>2]=1:a[B+92>>2]|0?a[B+108>>2]=1:a[B+100>>2]=1:(a[B+100>>2]=1,a[B+104>>2]=0,a[B+108>>2]=0,a[B+136>>2]=0);if(a[B+100>>2]|0){var Ia=B,Ia=Ia|0,Da=void 0,na=void 0,Na=void 0,Ka=void 0,Ca=void 0,Ga=void 0,Ea=void 0,La=void 0,Qa=void 0,Wa=void 0,eb=void 0,ab=void 0,xb=void 0,Zb=void 0,pb=void 0,jb=void 0,mc=void 0,Ab=void 0,Ta=void 0,Ya=void 0,Sa=void 0,mb=void 0,Db=void 0,
cc=void 0,Za=void 0,ia=void 0,qa=void 0,Da=Ia+4|0,na=Aa[a[a[Da>>2]>>2]&63](Ia,1,88)|0,Na=Ia+484|0;a[Na>>2]=na;a[na>>2]=13;a[na+8>>2]=50;a[na+12>>2]=51;a[na+68>>2]=0;a[na+52>>2]=0;na=Ia+120|0;4<(a[na>>2]|0)&&(Ka=a[Ia>>2]|0,a[Ka+20>>2]=57,a[Ka+24>>2]=4,R[a[Ka>>2]&127](Ia));Ka=Ia+96|0;Ca=a[Ka>>2]|0;256<(Ca|0)?(Ga=a[Ia>>2]|0,a[Ga+20>>2]=59,a[Ga+24>>2]=256,R[a[Ga>>2]&127](Ia),Ea=a[Ka>>2]|0):Ea=Ca;Ca=a[Na>>2]|0;Ka=Ca+32|0;Ga=a[na>>2]|0;if(1<(Ga|0))for(La=1;;){Qa=La+1|0;Wa=1;for(eb=Qa;;)if(ab=E(eb,Qa)|0,
Wa=Wa+1|0,(Wa|0)==(Ga|0)){xb=ab;break}else eb=ab;if((xb|0)>(Ea|0)){Zb=La;pb=xb;break}else La=Qa}else Zb=La=1<(Ea|0)?Ea:1,pb=La+1|0;2>(Zb|0)&&(La=a[Ia>>2]|0,a[La+20>>2]=58,a[La+24>>2]=pb,R[a[La>>2]&127](Ia));if(0<(Ga|0))for(La=0,pb=1;;)if(a[Ca+32+(La<<2)>>2]=Zb,xb=E(pb,Zb)|0,La=La+1|0,(La|0)==(Ga|0)){jb=xb;break}else pb=xb;else jb=1;pb=Ia+44|0;Zb=La=0;xb=jb;b:for(;;){jb=La;for(eb=Zb;;){if((eb|0)<(Ga|0)&&(mc=2==(a[pb>>2]|0)?a[119972+(eb<<2)>>2]|0:eb,Wa=Ca+32+(mc<<2)|0,ab=a[Wa>>2]|0,Ab=ab+1|0,Ta=E((xb|
0)/(ab|0)|0,Ab)|0,(Ta|0)<=(Ea|0))){Ya=Wa;Sa=Ab;mb=Ta;Db=eb;break}if(jb)eb=jb=0;else{cc=xb;break b}}a[Ya>>2]=Sa;La=1;Zb=Db+1|0;xb=mb}mb=a[Ia>>2]|0;xb=a[mb+4>>2]|0;3==(a[na>>2]|0)?(a[mb+24>>2]=cc,a[mb+28>>2]=a[Ka>>2],a[mb+32>>2]=a[Ca+36>>2],a[mb+36>>2]=a[Ca+40>>2],a[mb+20>>2]=96):(a[mb+20>>2]=97,a[mb+24>>2]=cc);ub[xb&31](Ia,1);xb=rb[a[(a[Da>>2]|0)+8>>2]&63](Ia,1,cc,a[na>>2]|0)|0;mb=a[na>>2]|0;if(0<(mb|0))for(Ka=mb,mb=cc,Db=0;;){Zb=a[Ca+32+(Db<<2)>>2]|0;La=mb;mb=(mb|0)/(Zb|0)|0;b:do if(0<(Zb|0)){Sa=
Zb+-1|0;Ya=(Sa|0)/2|0;Ea=xb+(Db<<2)|0;if(0<(mb|0))Za=0;else for(mc=0;;){pb=E(mc,mb)|0;if((pb|0)<(cc|0)){Ga=pb;do Ga=Ga+La|0;while((Ga|0)<(cc|0))}mc=mc+1|0;if((mc|0)==(Zb|0)){ia=Ka;break b}}do{mc=E(Za,mb)|0;if((mc|0)<(cc|0)){Ga=(((255*Za|0)+Ya|0)/(Sa|0)|0)&255;pb=mc;do{mc=0;do t[(a[Ea>>2]|0)+(mc+pb)>>0]=Ga,mc=mc+1|0;while((mc|0)!=(mb|0));pb=pb+La|0}while((pb|0)<(cc|0))}Za=Za+1|0}while((Za|0)!=(Zb|0));ia=a[na>>2]|0}else ia=Ka;while(0);Db=Db+1|0;if((Db|0)>=(ia|0))break;else Ka=ia}a[Ca+16>>2]=xb;a[Ca+
20>>2]=cc;Lh(Ia);if(2==(a[Ia+88>>2]|0)&&(cc=a[Na>>2]|0,Na=(a[Ia+112>>2]<<1)+4|0,0<(a[na>>2]|0))){qa=0;do Ca=Aa[a[(a[Da>>2]|0)+4>>2]&63](Ia,1,Na)|0,a[cc+68+(qa<<2)>>2]=Ca,qa=qa+1|0;while((qa|0)<(a[na>>2]|0))}a[z>>2]=a[B+484>>2]}if(0!=(a[B+108>>2]|0)||0!=(a[B+104>>2]|0)){var Ja=B,Ja=Ja|0,ea=void 0,wa=void 0,Ma=void 0,xa=void 0,$a=void 0,la=void 0,ea=Ja+4|0,wa=Aa[a[a[ea>>2]>>2]&63](Ja,1,44)|0;a[Ja+484>>2]=wa;a[wa>>2]=14;a[wa+12>>2]=52;Ma=wa+32|0;a[Ma>>2]=0;a[wa+40>>2]=0;3!=(a[Ja+120>>2]|0)&&(xa=a[Ja>>
2]|0,a[xa+20>>2]=48,R[a[xa>>2]&127](Ja));xa=Aa[a[a[ea>>2]>>2]&63](Ja,1,128)|0;$a=wa+24|0;a[$a>>2]=xa;xa=0;do la=Aa[a[(a[ea>>2]|0)+4>>2]&63](Ja,1,4096)|0,a[(a[$a>>2]|0)+(xa<<2)>>2]=la,xa=xa+1|0;while(32!=(xa|0));a[wa+28>>2]=1;a[Ja+108>>2]|0?(xa=a[Ja+96>>2]|0,8<=(xa|0)?256<(xa|0)&&($a=a[Ja>>2]|0,a[$a+20>>2]=59,a[$a+24>>2]=256,R[a[$a>>2]&127](Ja)):($a=a[Ja>>2]|0,a[$a+20>>2]=58,a[$a+24>>2]=8,R[a[$a>>2]&127](Ja)),$a=rb[a[(a[ea>>2]|0)+8>>2]&63](Ja,1,xa,3)|0,a[wa+16>>2]=$a,a[wa+20>>2]=xa):a[wa+16>>2]=0;
xa=Ja+88|0;a[xa>>2]|0&&(a[xa>>2]=2,xa=Aa[a[(a[ea>>2]|0)+4>>2]&63](Ja,1,(6*(a[Ja+112>>2]|0)|0)+12|0)|0,a[Ma>>2]=xa,Mh(Ja));a[w>>2]=a[B+484>>2]}v=r}else a[B+100>>2]=0,a[B+104>>2]=0,a[B+108>>2]=0,v=B+68|0;if(!(a[v>>2]|0)){if(a[x>>2]|0){var Ba=B,Ba=Ba|0,va=void 0,za=void 0,ta=void 0,nb=void 0,sc=void 0,gb=void 0,hb=void 0,va=Ba+4|0,za=Aa[a[a[va>>2]>>2]&63](Ba,1,48)|0,ta=Ba+476|0;a[ta>>2]=za;a[za>>2]=45;a[za+8>>2]=0;nb=E(a[Ba+120>>2]|0,a[Ba+112>>2]|0)|0;a[za+40>>2]=nb;sc=za+4|0;2==(a[Ba+320>>2]|0)?(a[sc>>
2]=3,a[za+12>>2]=11,gb=Aa[a[(a[va>>2]|0)+4>>2]&63](Ba,1,nb)|0,a[za+32>>2]=gb,hb=a[ta>>2]|0):(a[sc>>2]=4,a[za+12>>2]=12,a[za+32>>2]=0,hb=za);za=7==(a[Ba+40>>2]|0);sc=Aa[a[a[va>>2]>>2]&63](Ba,1,1024)|0;ta=hb+16|0;a[ta>>2]=sc;sc=Aa[a[a[va>>2]>>2]&63](Ba,1,1024)|0;gb=hb+20|0;a[gb>>2]=sc;sc=Aa[a[a[va>>2]>>2]&63](Ba,1,1024)|0;nb=hb+24|0;a[nb>>2]=sc;sc=Aa[a[a[va>>2]>>2]&63](Ba,1,1024)|0;a[hb+28>>2]=sc;hb=a[ta>>2]|0;ta=a[gb>>2]|0;gb=a[nb>>2]|0;if(za)for(za=0,nb=-128;a[hb+(za<<2)>>2]=(183763*nb|0)+32768>>
16,a[ta+(za<<2)>>2]=(232260*nb|0)+32768>>16,Ba=E(nb,-93603)|0,a[gb+(za<<2)>>2]=Ba,Ba=(E(nb,-45107)|0)+32768|0,a[sc+(za<<2)>>2]=Ba,za=za+1|0,256!=(za|0);)nb=nb+1|0;else for(nb=0,za=-128;a[hb+(nb<<2)>>2]=(91881*za|0)+32768>>16,a[ta+(nb<<2)>>2]=(116130*za|0)+32768>>16,Ba=E(za,-46802)|0,a[gb+(nb<<2)>>2]=Ba,Ba=(E(za,-22553)|0)+32768|0,a[sc+(nb<<2)>>2]=Ba,nb=nb+1|0,256!=(nb|0);)za=za+1|0}else{var ob=B,ob=ob|0,Bb=void 0,qb=void 0,kb=void 0,ib=void 0,Cb=void 0,Hb=void 0,sb=void 0,Xa=void 0,Fa=void 0,Pa=void 0,
Eb=void 0,vb=void 0,tb=void 0,bb=void 0,Bb=ob+4|0,qb=Aa[a[a[Bb>>2]>>2]&63](ob,1,28)|0,kb=ob+480|0;a[kb>>2]=qb;a[qb>>2]=67;ib=ob+40|0;switch(a[ib>>2]|0){case 1:1!=(a[ob+36>>2]|0)&&(Cb=a[ob>>2]|0,a[Cb+20>>2]=11,R[a[Cb>>2]&127](ob));break;case 7:case 6:case 3:case 2:3!=(a[ob+36>>2]|0)&&(Cb=a[ob>>2]|0,a[Cb+20>>2]=11,R[a[Cb>>2]&127](ob));break;case 5:case 4:4!=(a[ob+36>>2]|0)&&(Cb=a[ob>>2]|0,a[Cb+20>>2]=11,R[a[Cb>>2]&127](ob));break;default:1>(a[ob+36>>2]|0)&&(Cb=a[ob>>2]|0,a[Cb+20>>2]=11,R[a[Cb>>2]&127](ob))}Cb=
ob+304|0;c:do if(a[Cb>>2]|0){switch(a[ib>>2]|0){case 6:case 2:break c}Hb=a[ob>>2]|0;a[Hb+20>>2]=28;R[a[Hb>>2]&127](ob)}while(0);Hb=a[ob+44>>2]|0;c:do switch(Hb|0){case 1:a[ob+120>>2]=1;switch(a[ib>>2]|0){case 7:case 3:case 1:a[qb+4>>2]=9;sb=a[ob+36>>2]|0;if(1>=(sb|0))break c;Xa=a[ob+216>>2]|0;Fa=1;do a[Xa+(88*Fa|0)+52>>2]=0,Fa=Fa+1|0;while((Fa|0)<(sb|0));break;case 2:switch(a[Cb>>2]|0){case 0:a[qb+4>>2]=10;break;case 1:a[qb+4>>2]=11;break;default:sb=a[ob>>2]|0,a[sb+20>>2]=28,R[a[sb>>2]&127](ob)}sb=
a[kb>>2]|0;Fa=Aa[a[a[Bb>>2]>>2]&63](ob,1,3072)|0;a[sb+24>>2]=Fa;sb=0;do a[Fa+(sb<<2)>>2]=19595*sb,a[Fa+(sb+256<<2)>>2]=38470*sb,a[Fa+(sb+512<<2)>>2]=(7471*sb|0)+32768,sb=sb+1|0;while(256!=(sb|0));break;default:sb=a[ob>>2]|0;a[sb+20>>2]=28;R[a[sb>>2]&127](ob);break c}break;case 2:a[ob+120>>2]=3;switch(a[ib>>2]|0){case 1:a[qb+4>>2]=12;break c;case 3:a[qb+4>>2]=13;sb=a[kb>>2]|0;Fa=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;Xa=sb+8|0;a[Xa>>2]=Fa;Fa=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;Pa=sb+12|0;a[Pa>>2]=Fa;Fa=
Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;Eb=sb+16|0;a[Eb>>2]=Fa;Fa=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;a[sb+20>>2]=Fa;sb=a[Xa>>2]|0;Xa=a[Pa>>2]|0;Pa=a[Eb>>2]|0;Eb=0;for(vb=-128;a[sb+(Eb<<2)>>2]=(91881*vb|0)+32768>>16,a[Xa+(Eb<<2)>>2]=(116130*vb|0)+32768>>16,tb=E(vb,-46802)|0,a[Pa+(Eb<<2)>>2]=tb,tb=(E(vb,-22553)|0)+32768|0,a[Fa+(Eb<<2)>>2]=tb,Eb=Eb+1|0,256!=(Eb|0);)vb=vb+1|0;break;case 7:a[qb+4>>2]=13;vb=a[kb>>2]|0;Eb=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;Fa=vb+8|0;a[Fa>>2]=Eb;Eb=Aa[a[a[Bb>>2]>>2]&63](ob,1,
1024)|0;Pa=vb+12|0;a[Pa>>2]=Eb;Eb=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;Xa=vb+16|0;a[Xa>>2]=Eb;Eb=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;a[vb+20>>2]=Eb;vb=a[Fa>>2]|0;Fa=a[Pa>>2]|0;Pa=a[Xa>>2]|0;Xa=0;for(sb=-128;a[vb+(Xa<<2)>>2]=(183763*sb|0)+32768>>16,a[Fa+(Xa<<2)>>2]=(232260*sb|0)+32768>>16,tb=E(sb,-93603)|0,a[Pa+(Xa<<2)>>2]=tb,tb=(E(sb,-45107)|0)+32768|0,a[Eb+(Xa<<2)>>2]=tb,Xa=Xa+1|0,256!=(Xa|0);)sb=sb+1|0;break;case 2:switch(a[Cb>>2]|0){case 0:a[qb+4>>2]=14;break c;case 1:a[qb+4>>2]=15;break c;default:sb=
a[ob>>2]|0;a[sb+20>>2]=28;R[a[sb>>2]&127](ob);break c}default:sb=a[ob>>2]|0;a[sb+20>>2]=28;R[a[sb>>2]&127](ob);break c}break;case 6:a[ob+120>>2]=3;if(6!=(a[ib>>2]|0)){sb=a[ob>>2]|0;a[sb+20>>2]=28;R[a[sb>>2]&127](ob);break c}switch(a[Cb>>2]|0){case 0:a[qb+4>>2]=14;break c;case 1:a[qb+4>>2]=15;break c;default:sb=a[ob>>2]|0;a[sb+20>>2]=28;R[a[sb>>2]&127](ob);break c}case 4:a[ob+120>>2]=4;switch(a[ib>>2]|0){case 5:a[qb+4>>2]=16;sb=a[kb>>2]|0;Xa=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;Eb=sb+8|0;a[Eb>>2]=Xa;
Xa=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;Pa=sb+12|0;a[Pa>>2]=Xa;Xa=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;Fa=sb+16|0;a[Fa>>2]=Xa;Xa=Aa[a[a[Bb>>2]>>2]&63](ob,1,1024)|0;a[sb+20>>2]=Xa;sb=a[Eb>>2]|0;Eb=a[Pa>>2]|0;Pa=a[Fa>>2]|0;Fa=0;for(vb=-128;a[sb+(Fa<<2)>>2]=(91881*vb|0)+32768>>16,a[Eb+(Fa<<2)>>2]=(116130*vb|0)+32768>>16,tb=E(vb,-46802)|0,a[Pa+(Fa<<2)>>2]=tb,tb=(E(vb,-22553)|0)+32768|0,a[Xa+(Fa<<2)>>2]=tb,Fa=Fa+1|0,256!=(Fa|0);)vb=vb+1|0;break;case 4:a[qb+4>>2]=17;break c;default:vb=a[ob>>2]|0;a[vb+20>>2]=
28;R[a[vb>>2]&127](ob);break c}break;default:(Hb|0)==(a[ib>>2]|0)?(a[ob+120>>2]=a[ob+36>>2],a[qb+4>>2]=17):(vb=a[ob>>2]|0,a[vb+20>>2]=28,R[a[vb>>2]&127](ob));break c}while(0);a[ob+84>>2]|0?a[(ob+124|0)>>2]=1:(bb=a[ob+120>>2]|0,a[(ob+124|0)>>2]=bb);var Ib=B,Ib=Ib|0,Mb=void 0,fb=void 0,Ua=void 0,Wb=void 0,Jb=void 0,Kb=void 0,yb=void 0,cb=void 0,gc=void 0,Ub=void 0,Fb=void 0,Lb=void 0,lb=void 0,nd=void 0,Zd=void 0,wb=void 0,Pb=void 0,Qd=void 0,zb=void 0,Ob=void 0,Mb=Ib+4|0,fb=Aa[a[a[Mb>>2]>>2]&63](Ib,
1,160)|0;a[Ib+476>>2]=fb;a[fb>>2]=46;a[fb+4>>2]=8;a[fb+8>>2]=0;a[Ib+308>>2]|0&&(Ua=a[Ib>>2]|0,a[Ua+20>>2]=26,R[a[Ua>>2]&127](Ib));Ua=Ib+36|0;if(!(0>=(a[Ua>>2]|0)))for(Wb=Ib+324|0,Jb=Ib+328|0,Kb=Ib+316|0,yb=Ib+320|0,cb=fb+100|0,gc=fb+52|0,Ub=Ib+112|0,Fb=fb+12|0,Lb=0,lb=a[Ib+216>>2]|0;!(nd=E(a[lb+36>>2]|0,a[lb+8>>2]|0)|0,Zd=(nd|0)/(a[Wb>>2]|0)|0,nd=E(a[lb+40>>2]|0,a[lb+12>>2]|0)|0,wb=(nd|0)/(a[Jb>>2]|0)|0,nd=a[Kb>>2]|0,Pb=a[yb>>2]|0,a[cb+(Lb<<2)>>2]=wb,a[lb+52>>2]|0?(Qd=(wb|0)==(Pb|0),(Zd|0)==(nd|0)&
Qd?a[gc+(Lb<<2)>>2]=14:(zb=(Zd<<1|0)==(nd|0),zb&Qd?a[gc+(Lb<<2)>>2]=15:zb&(wb<<1|0)==(Pb|0)?a[gc+(Lb<<2)>>2]=16:0==((nd|0)%(Zd|0)|0)&&0==((Pb|0)%(wb|0)|0)?(a[gc+(Lb<<2)>>2]=17,t[fb+(Lb+140)>>0]=(nd|0)/(Zd|0)|0,t[fb+(Lb+150)>>0]=(Pb|0)/(wb|0)|0):(Ob=a[Ib>>2]|0,a[Ob+20>>2]=39,R[a[Ob>>2]&127](Ib)),zb=a[(a[Mb>>2]|0)+8>>2]|0,Qd=Ch(a[Ub>>2]|0,a[Kb>>2]|0)|0,Ob=rb[zb&63](Ib,1,Qd,a[yb>>2]|0)|0,a[Fb+(Lb<<2)>>2]=Ob)):a[gc+(Lb<<2)>>2]=13,Lb=Lb+1|0,(Lb|0)>=(a[Ua>>2]|0));)lb=lb+88|0}var Tb=B,Qb=a[B+108>>2]|0,Tb=
Tb|0,Qb=Qb|0,Sb=void 0,db=void 0,Vb=void 0,Yb=void 0,ac=void 0,fc=void 0,jc=void 0,lc=void 0,Sb=Tb+4|0,db=Aa[a[a[Sb>>2]>>2]&63](Tb,1,28)|0;a[Tb+456>>2]=db;a[db>>2]=10;Vb=db+8|0;a[Vb>>2]=0;Yb=db+12|0;a[Yb>>2]=0;a[Tb+84>>2]|0&&(ac=a[Tb+320>>2]|0,fc=db+16|0,a[fc>>2]=ac,db=a[Sb>>2]|0,Sb=a[Tb+112>>2]|0,jc=a[Tb+120>>2]|0,Qb?(lc=a[db+16>>2]|0,db=E(jc,Sb)|0,Sb=Ch(a[Tb+116>>2]|0,ac)|0,ac=Hi[lc&3](Tb,1,0,db,Sb,a[fc>>2]|0)|0,a[Vb>>2]=ac):(Qb=E(jc,Sb)|0,lc=rb[a[db+8>>2]&63](Tb,1,Qb,ac)|0,a[Yb>>2]=lc))}var $b=
B,$b=$b|0,kc=void 0,hc=void 0,ec=void 0,yc=void 0,kd=void 0,Ec=void 0,kc=$b+4|0,hc=Aa[a[a[kc>>2]>>2]&63]($b,1,84)|0;a[$b+472>>2]=hc;a[hc>>2]=68;ec=$b+36|0;if(!(0>=(a[ec>>2]|0)))for(yc=hc+44|0,hc=0,kd=a[$b+216>>2]|0;!(Ec=Aa[a[a[kc>>2]>>2]&63]($b,1,256)|0,a[kd+84>>2]=Ec,Va(Ec|0,0,256)|0,a[yc+(hc<<2)>>2]=-1,hc=hc+1|0,(hc|0)>=(a[ec>>2]|0));)kd=kd+88|0;if(a[B+228>>2]|0){var xc=B,xc=xc|0,Bc=void 0,zc=void 0,Cc=void 0,oc=void 0,Bc=xc+4|0,zc=Aa[a[a[Bc>>2]>>2]&63](xc,1,192)|0;a[xc+468>>2]=zc;a[zc>>2]=63;a[zc+
8>>2]=64;a[zc+60>>2]=0;a[zc+124>>2]=0;a[zc+64>>2]=0;a[zc+128>>2]=0;a[zc+68>>2]=0;a[zc+132>>2]=0;a[zc+72>>2]=0;a[zc+136>>2]=0;a[zc+76>>2]=0;a[zc+140>>2]=0;a[zc+80>>2]=0;a[zc+144>>2]=0;a[zc+84>>2]=0;a[zc+148>>2]=0;a[zc+88>>2]=0;a[zc+152>>2]=0;a[zc+92>>2]=0;a[zc+156>>2]=0;a[zc+96>>2]=0;a[zc+160>>2]=0;a[zc+100>>2]=0;a[zc+164>>2]=0;a[zc+104>>2]=0;a[zc+168>>2]=0;a[zc+108>>2]=0;a[zc+172>>2]=0;a[zc+112>>2]=0;a[zc+176>>2]=0;a[zc+116>>2]=0;a[zc+180>>2]=0;a[zc+120>>2]=0;a[zc+184>>2]=0;t[zc+188>>0]=113;if(a[xc+
224>>2]|0&&(zc=xc+36|0,Cc=Aa[a[a[Bc>>2]>>2]&63](xc,1,a[zc>>2]<<8)|0,a[xc+160>>2]=Cc,0<(a[zc>>2]|0))){oc=0;do Va(Cc+(oc<<8)|0,-1,256)|0,oc=oc+1|0;while((oc|0)<(a[zc>>2]|0))}}else{var nc=B,nc=nc|0,Gc=void 0,vc=void 0,ic=void 0,Hc=void 0,Gc=nc+4|0,vc=Aa[a[a[Gc>>2]>>2]&63](nc,1,220)|0;a[nc+468>>2]=vc;a[vc>>2]=69;a[vc+8>>2]=70;if(a[nc+224>>2]|0){ic=nc+36|0;Hc=Aa[a[a[Gc>>2]>>2]&63](nc,1,a[ic>>2]<<8)|0;a[nc+160>>2]=Hc;if(0<(a[ic>>2]|0)){nc=0;do Va(Hc+(nc<<8)|0,-1,256)|0,nc=nc+1|0;while((nc|0)<(a[ic>>2]|
0))}ic=vc+48|0;a[ic>>2]=0;a[ic+4>>2]=0;a[ic+8>>2]=0;a[ic+12>>2]=0}else a[vc+84>>2]=0,a[vc+68>>2]=0,a[vc+88>>2]=0,a[vc+72>>2]=0,a[vc+92>>2]=0,a[vc+76>>2]=0,a[vc+96>>2]=0,a[vc+80>>2]=0}x=B+460|0;I=a[(a[x>>2]|0)+16>>2]|0?1:0!=(a[B+64>>2]|0);var Jd=B,bd=I&1,Jd=Jd|0,bd=bd|0,Jc=void 0,Rc=void 0,Fc=void 0,Ic=void 0,Lc=void 0,Oc=void 0,Uc=void 0,Wc=void 0,Qc=void 0,hd=void 0,Bd=void 0,Vc=0,Jc=Jd+4|0,Rc=Aa[a[a[Jc>>2]>>2]&63](Jd,1,116)|0;a[Jd+452>>2]=Rc;a[Rc>>2]=65;a[Rc+8>>2]=66;a[Rc+112>>2]=0;if(bd){bd=Jd+
36|0;if(0<(a[bd>>2]|0))for(Fc=Jd+224|0,Ic=Rc+72|0,Lc=0,Oc=a[Jd+216>>2]|0;;)if(Uc=Oc+12|0,Wc=a[Uc>>2]|0,Qc=0==(a[Fc>>2]|0)?Wc:3*Wc|0,Wc=a[(a[Jc>>2]|0)+20>>2]|0,hd=Ch(a[Oc+28>>2]|0,a[Oc+8>>2]|0)|0,Bd=Ch(a[Oc+32>>2]|0,a[Uc>>2]|0)|0,Uc=Hi[Wc&3](Jd,1,1,hd,Bd,Qc)|0,a[Ic+(Lc<<2)>>2]=Uc,Lc=Lc+1|0,(Lc|0)>=(a[bd>>2]|0)){Vc=Ic;break}else Oc=Oc+88|0;else Vc=Rc+72|0;a[Rc+4>>2]=51;a[Rc+12>>2]=61;a[Rc+16>>2]=Vc}else bd=Aa[a[(a[Jc>>2]|0)+4>>2]&63](Jd,1,1280)|0,a[Rc+32>>2]=bd,a[Rc+36>>2]=bd+128,a[Rc+40>>2]=bd+256,
a[Rc+44>>2]=bd+384,a[Rc+48>>2]=bd+512,a[Rc+52>>2]=bd+640,a[Rc+56>>2]=bd+768,a[Rc+60>>2]=bd+896,a[Rc+64>>2]=bd+1024,a[Rc+68>>2]=bd+1152,a[Jd+436>>2]|0||Va(bd|0,0,1280)|0,a[Rc+4>>2]=52,a[Rc+12>>2]=62,a[Rc+16>>2]=0;if(!(a[v>>2]|0)){var Rb=B,od=0,Rb=Rb|0,od=od|0,tc=void 0,Xb=void 0,rc=void 0,ed=void 0,gd=void 0,$c=void 0,Xc=void 0,ad=void 0,cd=void 0,Pc=void 0,Yc=void 0,wc=void 0,id=void 0,dc=void 0,Ac=void 0,Sc=void 0,Tc=0,tc=Rb+4|0,Xb=Aa[a[a[tc>>2]>>2]&63](Rb,1,80)|0,rc=Rb+448|0;a[rc>>2]=Xb;a[Xb>>2]=
19;od&&(od=a[Rb>>2]|0,a[od+20>>2]=3,R[a[od>>2]&127](Rb));od=Rb+328|0;ed=a[od>>2]|0;if(a[(a[Rb+476>>2]|0)+8>>2]|0){2>(ed|0)?(gd=a[Rb>>2]|0,a[gd+20>>2]=48,R[a[gd>>2]&127](Rb),Pc=a[od>>2]|0):Pc=ed;ed=a[rc>>2]|0;rc=Rb+36|0;gd=Aa[a[a[tc>>2]>>2]&63](Rb,1,a[rc>>2]<<3)|0;Yc=ed+56|0;a[Yc>>2]=gd;wc=a[rc>>2]|0;id=ed+60|0;a[id>>2]=gd+(wc<<2);if(0<(wc|0))for(gd=Pc+4|0,Pc=0,ed=a[Rb+216>>2]|0;;)if(dc=E(a[ed+40>>2]|0,a[ed+12>>2]|0)|0,Ac=(dc|0)/(a[od>>2]|0)|0,dc=E(Ac,gd)|0,Sc=Aa[a[a[tc>>2]>>2]&63](Rb,1,dc<<3)|0,a[(a[Yc>>
2]|0)+(Pc<<2)>>2]=Sc+(Ac<<2),a[(a[id>>2]|0)+(Pc<<2)>>2]=Sc+(dc+Ac<<2),Pc=Pc+1|0,Ac=a[rc>>2]|0,(Pc|0)>=(Ac|0)){Tc=Ac;break}else ed=ed+88|0;else Tc=wc;wc=a[od>>2]|0;$c=rc;Xc=Tc;ad=wc;cd=wc+2|0}else $c=gd=Rb+36|0,Xc=a[gd>>2]|0,cd=ad=ed;if(!(0>=(Xc|0)))for(Xc=Xb+8|0,Xb=ad,ad=0,wc=a[Rb+216>>2]|0;;){Tc=(E(a[wc+40>>2]|0,a[wc+12>>2]|0)|0)/(Xb|0)|0;rc=E(a[wc+36>>2]|0,a[wc+28>>2]|0)|0;ed=E(Tc,cd)|0;Tc=rb[a[(a[tc>>2]|0)+8>>2]&63](Rb,1,rc,ed)|0;a[Xc+(ad<<2)>>2]=Tc;Tc=ad+1|0;if((Tc|0)>=(a[$c>>2]|0))break;Xb=a[od>>
2]|0;ad=Tc;wc=wc+88|0}}R[a[(a[H>>2]|0)+24>>2]&127](B);R[a[(a[x>>2]|0)+8>>2]&127](B);(H=a[B+8>>2]|0)&&!(a[B+64>>2]|0)&&a[(a[x>>2]|0)+16>>2]|0&&(x=a[B+36>>2]|0,v=0==(a[B+224>>2]|0)?x:(3*x|0)+2|0,a[H+4>>2]=0,x=E(v,a[B+332>>2]|0)|0,a[H+8>>2]=x,a[H+12>>2]=0,a[H+16>>2]=0!=(a[B+108>>2]|0)?3:2,a[u>>2]=(a[u>>2]|0)+1);if(!(a[b+64>>2]|0)){a[d>>2]=203;e=6;break a}a[d>>2]=207;f=1;return f|0;case 203:e=6;break;case 204:g=b+444|0;break;default:h=a[b>>2]|0,a[h+20>>2]=21,a[h+24>>2]=c,R[a[h>>2]&127](b),e=16}while(0);
if(6==(e|0)){c=b+460|0;a:do if(a[(a[c>>2]|0)+16>>2]|0){h=b+8|0;m=b+332|0;k=a[h>>2]|0;b:for(;;){if(k)R[a[k>>2]&127](b);l=da[a[a[c>>2]>>2]&63](b)|0;switch(l|0){case 2:break a;case 0:f=0;break b}n=a[h>>2]|0;1==(l&-3|0)&0!=(n|0)&&(l=n+4|0,p=(a[l>>2]|0)+1|0,a[l>>2]=p,l=n+8|0,q=a[l>>2]|0,(p|0)<(q|0)||(a[l>>2]=(a[m>>2]|0)+q));k=n}return f|0}while(0);a[b+152>>2]=a[b+144>>2];e=16}16==(e|0)&&(e=b+444|0,204!=(a[d>>2]|0)&&(R[a[a[e>>2]>>2]&127](b),a[b+140>>2]=0,a[d>>2]=204),g=e);a:do if(a[(a[g>>2]|0)+8>>2]|0){e=
b+140|0;c=b+116|0;k=b+8|0;m=b+448|0;for(h=a[e>>2]|0;;){n=a[c>>2]|0;if(h>>>0>=n>>>0)if(R[a[(a[g>>2]|0)+4>>2]&127](b),R[a[a[g>>2]>>2]&127](b),a[e>>2]=0,a[(a[g>>2]|0)+8>>2]|0){h=0;continue}else break a;(q=a[k>>2]|0)?(a[q+4>>2]=h,a[q+8>>2]=n,R[a[q>>2]&127](b),y=a[e>>2]|0):y=h;Ud[a[(a[m>>2]|0)+4>>2]&31](b,0,e,0);h=a[e>>2]|0;if((h|0)==(y|0)){f=0;break}}return f|0}while(0);a[d>>2]=0!=(a[b+68>>2]|0)?206:205;return 1},function(a){return 1},function(b){b|=0;var d,c,e,f;d=u;u=u+16|0;c=a[b+576>>2]|0;a[b+652>>
2]=3;e=N[b+90>>1]|0;a:do switch(e|0){case 32845:if(xf(b)|0)if(f=b+532|0,-30859==(w[b+88>>1]|0))switch(a[f>>2]=29,a[c>>2]|0){case 0:a[c+20>>2]=16;f=1;break a;case 1:a[c+20>>2]=17;f=1;break a;case 3:a[c+20>>2]=18;f=1;break a;default:f=1;break a}else switch(a[f>>2]=30,a[c>>2]|0){case 0:a[c+20>>2]=19;f=1;break a;case 1:a[c+20>>2]=20;f=1;break a;case 3:a[c+20>>2]=21;f=1;break a;default:f=1;break a}else f=0;break;case 32844:if(Vf(b)|0)switch(a[b+532>>2]=31,a[c>>2]|0){case 0:a[c+20>>2]=22;f=1;break a;case 3:a[c+
20>>2]=23;f=1;break a;default:f=1;break a}else f=0;break;default:f=a[b+628>>2]|0,a[d>>2]=e,a[d+4>>2]=147007,Y(f,147521,146936,d),f=0}while(0);u=d;return f|0},function(b){b|=0;var d,c,e,f,g,h,m=0,k=0;d=u;u=u+16|0;c=d+8|0;e=a[b+576>>2]|0;f=b+90|0;g=N[f>>1]|0;a:do switch(g|0){case 32845:if(xf(b)|0)if(h=b+536|0,-30859==(w[b+88>>1]|0))switch(a[h>>2]=32,a[e>>2]|0){case 2:m=1;break a;case 0:a[e+20>>2]=24;m=1;break a;case 1:a[e+20>>2]=25;m=1;break a;default:k=14;break a}else switch(a[h>>2]=33,a[e>>2]|0){case 2:m=
1;break a;case 0:a[e+20>>2]=26;m=1;break a;case 1:a[e+20>>2]=27;m=1;break a;default:k=14;break a}else m=1;break;case 32844:if(Vf(b)|0){a[b+536>>2]=34;switch(a[e>>2]|0){case 1:m=1;break a;case 0:break;default:k=14;break a}a[e+20>>2]=28}m=1;break;default:h=a[b+628>>2]|0,a[d>>2]=g,a[d+4>>2]=147007,Y(h,146918,146936,d),m=1}while(0);14==(k|0)&&(k=a[b+628>>2]|0,a[c>>2]=-32692==(w[f>>1]|0)?147037:147042,Y(k,146918,147051,c),m=0);u=d;return m|0},function(a){return 1},function(b){b|=0;var d,c,e,f,g=0;d=u;
u=u+16|0;c=d+8|0;e=b+576|0;if(f=a[e>>2]|0)g=f;else if(f=eb(160)|0,a[e>>2]=f)a[f+124>>2]=0,a[f+104>>2]=0,Ci(b)|0,(f=a[e>>2]|0)?g=f:Z(154187,147682,229,148271);else return Y(a[b+628>>2]|0,148271,147704,d),u=d,0;f=g+124|0;if(a[f>>2]|0)return u=d,1;g=eb(40952)|0;if(a[f>>2]=g)b=255;else return Y(a[b+628>>2]|0,148271,148286,c),u=d,0;for(;;)if(c=b&255,t[g+(b<<3)+6>>0]=c,t[g+(b<<3)+7>>0]=c,w[g+(b<<3)+4>>1]=1,a[g+(b<<3)>>2]=0,b)b=b+-1|0;else break;$c(g+2048|0,0,16);u=d;return 1},function(b){b|=0;var d,c,e;
d=u;u=u+16|0;(c=a[b+576>>2]|0)||Z(154187,147682,788,147828);e=eb(72008)|0;if(a[c+152>>2]=e)return u=d,1;Y(a[b+628>>2]|0,147828,147843,d);u=d;return 0},function(b){b|=0;var d,c,e,f,g,h,m;d=a[b+576>>2]|0;c=a[b+604>>2]|0;e=a[d+76>>2]|0;f=a[d+72>>2]|0;g=N[d+64>>1]|0;c>>>0>(a[d+148>>2]|0)>>>0?(h=b+588|0,a[b+608>>2]=c-(a[h>>2]|0),Lc(b)|0,m=a[h>>2]|0):m=c;c=d+128|0;d=a[c>>2]|0;65535==(d|0)?(c=e,h=f):(h=d|f<<g,f=g+e|0,e=f+-8|0,d=m+1|0,t[m>>0]=h>>>e,7<(e|0)?(f=f+-16|0,t[d>>0]=h>>>f,m=m+2|0):(f=e,m=d),a[c>>
2]=65535,c=f);f=m;m=h<<g|257;h=c+g|0;g=h+-8|0;c=f+1|0;t[f>>0]=m>>>g;7<(g|0)?(h=h+-16|0,t[c>>0]=m>>>h,d=c,g=h,h=f+2|0):(d=f,h=c);if(0>=(g|0))return g=a[(b+588|0)>>2]|0,g=h-g|0,a[(b+608|0)>>2]=g,1;t[h>>0]=m<<8-g;g=a[(b+588|0)>>2]|0;g=(d+2|0)-g|0;a[(b+608|0)>>2]=g;return 1},function(a){return 1},function(b){var d;d=u;u=u+16|0;Wb(a[(b|0)+628>>2]|0,151837,151854,d);u=d;return 1},function(b){var d;d=u;u=u+16|0;Y(a[(b|0)+628>>2]|0,151130,151030,d);u=d;return 0},function(b){var d;d=u;u=u+16|0;Y(a[(b|0)+628>>
2]|0,151099,151030,d);u=d;return 0},function(b){var d,c,e,f,g,h,m,k,l,n,p,q,y,B=0,H=0,r=0;d=u;u=u+16|0;c=a[(b|0)+12>>2]|0;b=c+576|0;e=a[b>>2]|0;f=e+3312|0;h=g=0;a:for(;;){m=a[f>>2]|0;if(19<=m>>>0){h=4;break}do switch(m|0){case 0:h=5;break a;case 14:h=45;break a;case 15:h=51;break a;case 16:h=57;break a;case 17:h=67;break a;case 18:h=68;break a;case 1:k=a[b>>2]|0;(l=a[k+312>>2]|0)?(q=(a[l>>2]|0)+-4|0,n=l+4|0,p=l=q):(n=g,l=h,p=0);q=k+3312|0;a[q>>2]=(a[q>>2]|0)+1;k=p;q=n;y=l;break;case 2:q=a[b>>2]|0;
(k=a[q+316>>2]|0)?(l=(a[k>>2]|0)+-4|0,p=k+4|0,k=n=l):(p=g,n=h,k=0);l=q+3312|0;a[l>>2]=(a[l>>2]|0)+1;q=p;y=n;break;case 3:l=a[b>>2]|0;(q=a[l+320>>2]|0)?(k=(a[q>>2]|0)+-4|0,q=q+4|0,p=n=k):(q=g,n=h,p=0);k=l+3312|0;a[k>>2]=(a[k>>2]|0)+1;k=p;y=n;break;case 4:k=a[b>>2]|0;(l=a[k+324>>2]|0)?(q=(a[l>>2]|0)+-4|0,n=l+4|0,p=l=q):(n=g,l=h,p=0);q=k+3312|0;a[q>>2]=(a[q>>2]|0)+1;k=p;q=n;y=l;break;case 5:q=a[b>>2]|0;(k=a[q+328>>2]|0)?(l=(a[k>>2]|0)+-4|0,p=k+4|0,k=n=l):(p=g,n=h,k=0);l=q+3312|0;a[l>>2]=(a[l>>2]|0)+
1;q=p;y=n;break;case 6:l=a[b>>2]|0;(q=a[l+332>>2]|0)?(k=(a[q>>2]|0)+-4|0,q=q+4|0,p=n=k):(q=g,n=h,p=0);k=l+3312|0;a[k>>2]=(a[k>>2]|0)+1;k=p;y=n;break;case 7:k=a[b>>2]|0;(l=a[k+336>>2]|0)?(q=(a[l>>2]|0)+-4|0,n=l+4|0,p=l=q):(n=g,l=h,p=0);q=k+3312|0;a[q>>2]=(a[q>>2]|0)+1;k=p;q=n;y=l;break;case 8:q=a[b>>2]|0;(k=a[q+340>>2]|0)?(l=(a[k>>2]|0)+-4|0,p=k+4|0,k=n=l):(p=g,n=h,k=0);l=q+3312|0;a[l>>2]=(a[l>>2]|0)+1;q=p;y=n;break;case 9:l=a[b>>2]|0;(q=a[l+344>>2]|0)?(k=(a[q>>2]|0)+-4|0,q=q+4|0,p=n=k):(q=g,n=h,p=
0);k=l+3312|0;a[k>>2]=(a[k>>2]|0)+1;k=p;y=n;break;case 10:k=a[b>>2]|0;(l=a[k+348>>2]|0)?(q=(a[l>>2]|0)+-4|0,n=l+4|0,p=l=q):(n=g,l=h,p=0);q=k+3312|0;a[q>>2]=(a[q>>2]|0)+1;k=p;q=n;y=l;break;case 11:q=a[b>>2]|0;(k=a[q+352>>2]|0)?(l=(a[k>>2]|0)+-4|0,p=k+4|0,k=n=l):(p=g,n=h,k=0);l=q+3312|0;a[l>>2]=(a[l>>2]|0)+1;q=p;y=n;break;case 12:l=a[b>>2]|0;(q=a[l+356>>2]|0)?(k=(a[q>>2]|0)+-4|0,q=q+4|0,p=n=k):(q=g,n=h,p=0);k=l+3312|0;a[k>>2]=(a[k>>2]|0)+1;k=p;y=n;break;case 13:k=a[b>>2]|0;l=w[k+360>>1]|0;l<<16>>16?
(q=k+3316|0,t[q>>0]=-1,t[k+3317>>0]=-35,t[k+3318>>0]=0,t[k+3319>>0]=4,t[k+3320>>0]=(l&65535)>>>8,t[k+3321>>0]=l,l=q,p=n=6):(l=g,n=h,p=0);q=k+3312|0;a[q>>2]=(a[q>>2]|0)+1;k=p;q=l;y=n;break;default:h=72;break a}while(0);if(k){B=q;H=y;h=71;break}else g=q,h=y}if(4==(h|0))Z(151621,148429,2124,151644);else{if(5==(h|0))return y=a[b>>2]|0,q=y+3316|0,t[q>>0]=-1,t[y+3317>>0]=-40,h=y+3312|0,a[h>>2]=(a[h>>2]|0)+1,a[(e+1124|0)>>2]=2,a[(e+1120|0)>>2]=q,u=d,1;if(45==(h|0)){q=a[b>>2]|0;h=t[q+206>>0]|0;y=(3*(h&255)|
0)+8|0;256<=y>>>0&&Z(151661,148429,2263,151702);g=q+3316|0;t[g>>0]=-1;t[q+3317>>0]=t[q+364>>0]|0;t[q+3318>>0]=0;t[q+3319>>0]=y;t[q+3320>>0]=8;y=a[q+372>>2]|0;t[q+3321>>0]=y>>>8;t[q+3322>>0]=y;y=a[q+368>>2]|0;t[q+3323>>0]=y>>>8;t[q+3324>>0]=y;t[q+3325>>0]=h;if(h<<24>>24){y=x[q+205>>0]|0;k=0;do n=k+y|0,l=3*k|0,t[l+10+(q+3316)>>0]=t[q+376+n>>0]|0,t[l+11+(q+3316)>>0]=t[q+379+n>>0]|0,t[l+12+(q+3316)>>0]=t[q+382+n>>0]|0,k=k+1|0;while((k&255)<<24>>24!=h<<24>>24);b=h}else b=0;h=q+3312|0;a[h>>2]=(a[h>>2]|
0)+1;a[(e+1124|0)>>2]=(3*(b&255)|0)+10|0;a[(e+1120|0)>>2]=g;u=d;return 1}if(51==(h|0)){b=a[b>>2]|0;g=t[b+206>>0]|0;h=(g&255)<<1;q=h+6|0;256<=q>>>0&&Z(151722,148429,2299,151763);k=b+3316|0;t[k>>0]=-1;t[b+3317>>0]=-38;t[b+3318>>0]=0;t[b+3319>>0]=q;t[b+3320>>0]=g;if(g<<24>>24){y=x[b+205>>0]|0;n=0;do l=n+y|0,p=n<<1,t[p+5+(b+3316)>>0]=t[b+385+l>>0]|0,t[p+6+(b+3316)>>0]=t[b+388+l>>0]|0,n=n+1|0;while((n&255)<<24>>24!=g<<24>>24);c=g}else c=0;t[((c&255)<<1)+5+(b+3316)>>0]=0;t[b+3316+q>>0]=63;t[h+7+(b+3316)>>
0]=0;q=b+3312|0;a[q>>2]=(a[q>>2]|0)+1;a[(e+1124|0)>>2]=h+8|0;a[(e+1120|0)>>2]=k;u=d;return 1}if(57==(h|0)){h=a[b>>2]|0;k=h+1256|0;q=w[k>>1]|0;q<<16>>16?r=q:(Fc(h)|0||(Y(a[c+628>>2]|0,151596,151810,d),Bi(c)),c=w[k>>1]|0,c<<16>>16?r=c:Z(149747,148429,2333,151783));q=r&65535;r=a[h+1260>>2]|0;w[k>>1]=0;k=h+1248|0;if(!(0==(a[k>>2]|0)&0==(a[k+4>>2]|0)))return a[(e+1124|0)>>2]=q,a[(e+1120|0)>>2]=r,u=d,1;switch(a[h+1220>>2]|0){case 2:return a[(h+3312|0)>>2]=(a[h+1224>>2]|0)>>>0<(a[h+1228>>2]|0)>>>0?17:18,
a[(e+1124|0)>>2]=q,a[(e+1120|0)>>2]=r,u=d,1;case 3:return a[h+3312>>2]=18,a[(e+1124|0)>>2]=q,a[(e+1120|0)>>2]=r,u=d,1;default:return a[(e+1124|0)>>2]=q,a[(e+1120|0)>>2]=r,u=d,1}}else{if(67==(h|0))return q=a[b>>2]|0,r=q+3316|0,t[r>>0]=-1,h=q+362|0,k=t[h>>0]|0,t[q+3317>>0]=(k&255)+208,c=k+1<<24>>24,t[h>>0]=8==c<<24>>24?0:c,a[q+3312>>2]=16,a[(e+1124|0)>>2]=2,a[(e+1120|0)>>2]=r,u=d,1;if(68==(h|0))return r=a[b>>2]|0,b=r+3316|0,t[b>>0]=-1,t[r+3317>>0]=-39,a[(e+1124|0)>>2]=2,a[(e+1120|0)>>2]=b,u=d,1;if(71==
(h|0))return a[(e+1124|0)>>2]=H,a[(e+1120|0)>>2]=B,u=d,1;if(72==(h|0))for(;;);}}return 0},function(b){b=a[(b|0)+576>>2]|0;if(!b)return 1;ja(b);return 1},function(a){return 1},function(b){b|=0;var d,c,e,f,g,h,m,k=0,l=0;d=u;u=u+16|0;c=d+8|0;e=d;(f=a[b+576>>2]|0)||Z(154187,152287,676,152768);a[b+652>>2]=3;g=1==(w[b+126>>1]|0)?w[b+98>>1]|0:1;w[f+124>>1]=g;h=g&65535;m=E(a[b+56>>2]|0,h)|0;m=E(m,a[b+100>>2]|0)|0;if(0==g<<16>>16|0==(m|0))return u=d,0;g=m+h|0;if(1>(m|0)|0==(g|0))return u=d,0;m=eb(g<<1)|0;
a[f+120>>2]=m;if(!m)return u=d,0;m=f+132|0;do if(-1==(a[m>>2]|0)){g=w[b+86>>1]|0;h=N[b+84>>1]|0;switch(h|0){case 32:3==g<<16>>16&&(k=5,l=15);break;case 16:switch(g<<16>>16){case 1:case 4:k=4,l=15}break;case 12:switch(g<<16>>16){case 2:case 4:k=3,l=15}break;case 11:switch(g<<16>>16){case 1:case 4:k=2,l=15}break;case 8:switch(g<<16>>16){case 1:case 4:k=0,l=15}}if(15==(l|0))a[m>>2]=k;else return a[m>>2]=-1,g=a[b+628>>2]|0,a[e>>2]=h,Y(g,152768,152788,e),u=d,0}while(0);if(Ug(f+64|0,154315,56)|0)return e=
a[b+628>>2]|0,a[c>>2]=a[f+88>>2],Y(e,152768,154321,c),u=d,0;e=f+128|0;a[e>>2]|=1;u=d;return 1},function(b){b|=0;var d,c,e,f,g,h,m,k=0,l=0;d=u;u=u+16|0;c=d+8|0;e=d;(f=a[b+576>>2]|0)||Z(154187,152287,880,152562);g=1==(w[b+126>>1]|0)?w[b+98>>1]|0:1;w[f+124>>1]=g;h=E(a[b+56>>2]|0,g&65535)|0;g=E(h,a[b+100>>2]|0)|0;if(!g)return u=d,0;h=eb(g<<1)|0;a[f+120>>2]=h;if(!h)return u=d,0;h=f+132|0;do if(-1==(a[h>>2]|0)){g=w[b+86>>1]|0;m=N[b+84>>1]|0;switch(m|0){case 32:3==g<<16>>16&&(k=5,l=14);break;case 16:switch(g<<
16>>16){case 1:case 4:k=4,l=14}break;case 12:switch(g<<16>>16){case 2:case 4:k=3,l=14}break;case 11:switch(g<<16>>16){case 1:case 4:k=2,l=14}break;case 8:switch(g<<16>>16){case 1:case 4:k=0,l=14}}if(14==(l|0))a[h>>2]=k;else return a[h>>2]=-1,g=a[b+628>>2]|0,a[e>>2]=m,Y(g,152562,152582,e),u=d,0}while(0);if(ah(f+64|0,a[f+136>>2]|0,8,15,8,0,154315,56)|0)return e=a[b+628>>2]|0,a[c>>2]=a[f+88>>2],Y(e,152562,154321,c),u=d,0;e=f+128|0;a[e>>2]|=1;u=d;return 1},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q=
0,y=0;d=u;u=u+16|0;c=a[b+576>>2]|0;e=c+64|0;a[c+68>>2]=0;f=c+80|0;g=b+592|0;h=b+608|0;m=b+588|0;for(k=c+76|0;;){l=Di(e,4)|0;if(2<=l>>>0)break;n=a[f>>2]|0;p=a[g>>2]|0;(p|0)!=(n|0)&&(a[h>>2]=p-n,Lc(b)|0,a[k>>2]=a[m>>2],a[f>>2]=a[g>>2]);if(1==(l|0)){q=1;y=7;break}}if(7==(y|0))return u=d,q|0;y=a[b+628>>2]|0;a[d>>2]=a[c+88>>2];Y(y,152525,154272,d);u=d;return 0},function(b){b|=0;var d,c,e;d=a[b+576>>2]|0;if(!(da[a[d+56>>2]&63](b)|0&&Zg(b)|0))return 0;switch(a[d>>2]|0){case 2:switch(N[b+84>>1]|0){case 8:a[d+
40>>2]=32;break;case 16:a[d+40>>2]=33;break;case 32:a[d+40>>2]=34}c=b+532|0;e=a[c>>2]|0;46!=(e|0)&&(a[d+28>>2]=e,a[c>>2]=46,c=b+540|0,a[d+32>>2]=a[c>>2],a[c>>2]=47,c=b+548|0,a[d+36>>2]=a[c>>2],a[c>>2]=47);if(!(a[b+12>>2]&128))return 1;c=d+40|0;e=a[c>>2]|0;if(33==(e|0))return a[c>>2]=35,a[b+652>>2]=3,1;if(34!=(e|0))return 1;a[c>>2]=36;a[b+652>>2]=3;return 1;case 3:a[d+40>>2]=37;c=b+532|0;e=a[c>>2]|0;46!=(e|0)&&(a[d+28>>2]=e,a[c>>2]=46,c=b+540|0,a[d+32>>2]=a[c>>2],a[c>>2]=47,c=b+548|0,a[d+36>>2]=a[c>>
2],a[c>>2]=47);if(!(a[b+12>>2]&128))return 1;a[b+652>>2]=3;return 1;default:return 1}},function(b){b|=0;var d,c,e;d=a[b+576>>2]|0;if(!(da[a[d+60>>2]&63](b)|0&&Zg(b)|0))return 0;switch(a[d>>2]|0){case 2:switch(N[b+84>>1]|0){case 8:a[d+24>>2]=38;break;case 16:a[d+24>>2]=39;break;case 32:a[d+24>>2]=40}c=b+536|0;e=a[c>>2]|0;48!=(e|0)&&(a[d+12>>2]=e,a[c>>2]=48,c=b+544|0,a[d+16>>2]=a[c>>2],a[c>>2]=49,c=b+552|0,a[d+20>>2]=a[c>>2],a[c>>2]=49);if(!(a[b+12>>2]&128))return 1;c=d+24|0;e=a[c>>2]|0;if(39==(e|0))return a[c>>
2]=41,a[b+652>>2]=3,1;if(40!=(e|0))return 1;a[c>>2]=42;a[b+652>>2]=3;return 1;case 3:a[d+24>>2]=43;c=b+536|0;e=a[c>>2]|0;if(48==(e|0))return 1;a[d+12>>2]=e;a[c>>2]=48;c=b+544|0;a[d+16>>2]=a[c>>2];a[c>>2]=49;c=b+552|0;a[d+20>>2]=a[c>>2];a[c>>2]=49;return 1;default:return 1}},function(b){b|=0;var d,c;d=u;u=u+16|0;c=w[b+84>>1]|0;if(4==c<<16>>16)return u=d,1;b=a[b+628>>2]|0;a[d>>2]=c&65535;Y(b,153902,153921,d);u=d;return 0},function(a){return 1},function(b){b|=0;var d,c,e,f;d=u;u=u+16|0;(c=a[b+576>>2]|
0)||Z(154187,154074,102,154464);e=c+124|0;f=c+64|0;a[e>>2]&2&&(rk(f)|0,a[e>>2]=0);if(Ug(f,154315,56)|0)return e=a[b+628>>2]|0,b=a[c+88>>2]|0,a[d>>2]=0==(b|0)?155687:b,Y(e,154464,154321,d),u=d,0;a[e>>2]|=1;u=d;return 1},function(b){b|=0;var d,c,e,f;d=u;u=u+16|0;(c=a[b+576>>2]|0)||Z(154187,154074,209,154300);e=c+124|0;f=c+64|0;a[e>>2]&1&&(wf(f)|0,a[e>>2]=0);if(ah(f|0,a[c+120>>2]|0,8,15,8,0,154315,56)|0)return e=a[b+628>>2]|0,b=a[c+88>>2]|0,a[d>>2]=0==(b|0)?155687:b,Y(e,154300,154321,d),u=d,0;a[e>>2]|=
2;u=d;return 1},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q=0,y=0;d=u;u=u+16|0;c=a[b+576>>2]|0;e=c+64|0;a[c+68>>2]=0;f=c+80|0;g=b+592|0;h=b+608|0;m=b+588|0;for(k=c+76|0;;){l=Di(e,4)|0;if(2<=l>>>0)break;n=a[f>>2]|0;p=a[g>>2]|0;(p|0)!=(n|0)&&(a[h>>2]=p-n,Lc(b)|0,a[k>>2]=a[m>>2],a[f>>2]=a[g>>2]);if(1==(l|0)){q=1;y=7;break}}if(7==(y|0))return u=d,q|0;y=a[b+628>>2]|0;b=a[c+88>>2]|0;a[d>>2]=0==(b|0)?155687:b;Y(y,154258,154272,d);u=d;return 0},function(b){b|=0;var d,c,e,f=0,g,h,m,k,l,n,p,q,y,B,t,r,z,u,
C,x,w,v,J,I,G,L,K,A=0,D,O,M,T,X,P,F,N=0,S=0,ba=0;d=b+460|0;c=a[d>>2]|0;e=c+20|0;if(a[e>>2]|0)return 2;g=b+464|0;h=c+24|0;m=b+340|0;k=c+16|0;c=b+32|0;l=b+212|0;n=b+36|0;p=b+316|0;q=b+320|0;y=b+216|0;B=b+220|0;t=b+224|0;r=b+416|0;z=b+412|0;u=b+420|0;C=b+424|0;x=b+428|0;w=b+432|0;v=b+436|0;J=b+324|0;I=b+328|0;G=b+28|0;L=b+332|0;a:for(;;){K=da[a[(a[g>>2]|0)+4>>2]&63](b)|0;switch(K|0){case 2:A=57;break a;case 1:break;default:f=K;A=62;break a}b:do switch(a[h>>2]|0){case 0:if(a[k>>2]|0||(K=a[b>>2]|0,a[K+
20>>2]=36,R[a[K>>2]&127](b)),a[m>>2]|0){A=56;break a}else continue a;case 1:65500>=(a[c>>2]|0)&&65500>=(a[G>>2]|0)||(K=a[b>>2]|0,a[K+20>>2]=42,a[K+24>>2]=65500,R[a[K>>2]&127](b));K=a[l>>2]|0;4<(K+-8|0)>>>0&&(D=a[b>>2]|0,a[D+20>>2]=16,a[D+24>>2]=K,R[a[D>>2]&127](b));D=a[n>>2]|0;10<(D|0)?(K=a[b>>2]|0,a[K+20>>2]=27,a[K+24>>2]=D,a[K+28>>2]=10,R[a[K>>2]&127](b),O=a[n>>2]|0):O=D;a[p>>2]=1;a[q>>2]=1;if(0<(O|0))for(D=O,M=K=1,T=0,O=a[y>>2]|0;;)if(X=O+8|0,P=a[X>>2]|0,F=O+12|0,3>=(P+-1|0)>>>0&&(N=a[F>>2]|0,
3>=(N+-1|0)>>>0)?(X=P,F=N):(N=a[b>>2]|0,a[N+20>>2]=19,R[a[N>>2]&127](b),M=a[p>>2]|0,X=a[X>>2]|0,K=a[q>>2]|0,F=a[F>>2]|0,D=a[n>>2]|0),M=(M|0)>(X|0)?M:X,a[p>>2]=M,K=(K|0)>(F|0)?K:F,a[q>>2]=K,T=T+1|0,(T|0)>=(D|0)){T=D;break}else O=O+88|0;else T=O;c:do if(a[B>>2]|0)A=22;else if(0!=(a[t>>2]|0)&&0!=(a[m>>2]|0))A=22;else{do switch(a[r>>2]|0){case 0:a[x>>2]=1;a[w>>2]=119984;a[v>>2]=0;S=1;ba=T;break c;case 3:a[x>>2]=2;a[w>>2]=121164;a[v>>2]=3;S=2;ba=T;break c;case 8:a[x>>2]=3;a[w>>2]=121064;a[v>>2]=8;S=3;
ba=T;break c;case 15:a[x>>2]=4;a[w>>2]=120936;a[v>>2]=15;S=4;ba=T;break c;case 24:a[x>>2]=5;a[w>>2]=120772;a[v>>2]=24;S=5;ba=T;break c;case 35:a[x>>2]=6;a[w>>2]=120564;a[v>>2]=35;S=6;ba=T;break c;case 48:a[x>>2]=7;a[w>>2]=120304;a[v>>2]=48;S=7;ba=T;break c;case 63:a[x>>2]=8;a[w>>2]=119984;a[v>>2]=63;S=8;ba=T;break c;case 80:a[x>>2]=9;a[w>>2]=119984;a[v>>2]=63;S=9;ba=T;break c;case 99:a[x>>2]=10;a[w>>2]=119984;a[v>>2]=63;S=10;ba=T;break c;case 120:a[x>>2]=11;a[w>>2]=119984;a[v>>2]=63;S=11;ba=T;break c;
case 143:a[x>>2]=12;a[w>>2]=119984;a[v>>2]=63;S=12;ba=T;break c;case 168:a[x>>2]=13;a[w>>2]=119984;a[v>>2]=63;S=13;ba=T;break c;case 195:a[x>>2]=14;a[w>>2]=119984;a[v>>2]=63;S=14;ba=T;break c;case 224:a[x>>2]=15;a[w>>2]=119984;a[v>>2]=63;S=15;ba=T;break c;case 255:a[x>>2]=16;a[w>>2]=119984;a[v>>2]=63;S=16;ba=T;break c;default:O=a[b>>2]|0;a[O+20>>2]=17;a[O+24>>2]=a[z>>2];a[O+28>>2]=a[r>>2];a[O+32>>2]=a[u>>2];a[O+36>>2]=a[C>>2];R[a[O>>2]&127](b);S=a[x>>2]|0;ba=a[n>>2]|0;break c}while(0)}while(0);22==
(A|0)&&(A=0,a[x>>2]=8,a[w>>2]=119984,a[v>>2]=63,S=8,ba=T);a[J>>2]=S;a[I>>2]=S;if(0<(ba|0)){O=S;D=0;for(T=a[y>>2]|0;;){a[T+36>>2]=O;a[T+40>>2]=O;K=T+8|0;M=E(a[K>>2]|0,a[G>>2]|0)|0;F=Gb(M,E(a[p>>2]|0,O)|0)|0;a[T+28>>2]=F;F=T+12|0;M=E(a[F>>2]|0,a[c>>2]|0)|0;X=Gb(M,E(a[x>>2]|0,a[q>>2]|0)|0)|0;a[T+32>>2]=X;X=E(a[K>>2]|0,a[G>>2]|0)|0;K=Gb(X,a[p>>2]|0)|0;a[T+44>>2]=K;K=E(a[F>>2]|0,a[c>>2]|0)|0;F=Gb(K,a[q>>2]|0)|0;a[T+48>>2]=F;a[T+52>>2]=1;a[T+80>>2]=0;F=D+1|0;if((F|0)>=(a[n>>2]|0))break;O=a[x>>2]|0;D=F;
T=T+88|0}O=a[x>>2]|0}else O=S;T=Gb(a[c>>2]|0,E(O,a[q>>2]|0)|0)|0;a[L>>2]=T;T=a[m>>2]|0;if((T|0)>=(a[n>>2]|0)&&0==(a[t>>2]|0)){a[(a[d>>2]|0)+16>>2]=0;O=T;break b}a[(a[d>>2]|0)+16>>2]=1;O=T;break;default:O=a[m>>2]|0}while(0);if(O){A=52;break}a[h>>2]=2}if(52==(A|0))return a[h>>2]=0,1;if(56==(A|0))return $g(b),1;if(57==(A|0)){a[e>>2]=1;if(a[h>>2]|0){if(!(a[(a[g>>2]|0)+16>>2]|0))return 2;g=a[b>>2]|0;a[g+20>>2]=62;R[a[g>>2]&127](b)}else{h=b+152|0;e=a[b+144>>2]|0;if((a[h>>2]|0)<=(e|0))return 2;a[h>>2]=e}return 2}return 62==
(A|0)?f|0:0},function(b){b|=0;var d=0,c=0,e=0,f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,y=0,B=0,H=0,r=0,z=0,Q=0,C=0,v=0,V=0,E=0,J=0,I=0,G=0,L=0,K=0,A=0,D=0,O=0,M=0,T=0,X=0,P=0,F=0,S=0,Y=0,ba=0,W=0,U=0,Z=0,ga=0,Ha=0,ma=0,aa=0,ha=0,ca=0,fa=0,ja=0,pa=0,ya=0,ra=0,oa=0,sa=0,Aa=0,ua=0,Ia=0,Da=0,na=0,Na=0,Ka=0,Ca=0,Ga=0,Ea=0,La=0,Qa=0,Wa=0,eb=0,pb=0,xb=0,Zb=0,ab=0,jb=0,mc=0,Ab=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,sc=0,gb=0,hb=0,ob=0,Bb=0,qb=
0,kb=0,ib=0,Cb=0,fb=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Hb=0,Ua=0,Kb=0,Jb=0,Wb=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,Gb=0,Lb=0,lb=0,rb=0,wb=0,db=0,Qd=0,zb=0,Ob=0,Tb=0,Sb=0,Pb=0,Qb=0,ac=0,Vb=0,Yb=0,fc=0,$b=0,jc=0,lc=0,kc=0,hc=0,ec=0,nc=0,yc=0,xc=0,vc=0,Bc=0,zc=0,Cc=0,oc=0,Gc=0,Jc=0,Hc=0,ic=0,Lc=0,Fc=0,bd=0,Ic=0,Rc=0,Oc=0,Uc=0,Wc=0,Pc=0,ad=0,Qc=0,Xc=0,hd=0,Bd=0,Vc=0,Rb=0,od=0,tc=0,Xb=0,rc=0,ed=0,gd=0,$c=0,cd=0,dd=0,md=0,ld=0,Yc=0,wc=0,id=0,dc=0,Ac=0,Sc=0,Tc=0,td=0,qd=0,Ce=0,vd=0,wd=0,rd=0,sd=0,
pd=0,jd=0,Ud=0,zd=0,Cd=0,Dd=0,ce=0,oe=0,Id=0,Kd=0,Df=0,Nd=0,Pd=0,Vd=0,ne=0,he=0,te=0,de=0,He=0,ue=0,Ld=0,Od=0,ae=0,De=0,be=0,Fd=0,Rd=0,Gd=0,$d=0,ge=0,ud=0,xd=0,ie=0,je=0,Xd=0,Of=0,Dc=0,yd=0,Ad=0,Sd=0,Td=0,se=0,Ye=0,Md=0,ve=0,Je=0,ze=0,Qe=0,Yd=0,Ze=0,we=0,xe=0,kf=0,re=0,df=0,Ae=0,ef=0,Ue=0,Ke=0,qe=0,$e=0,le=0,d=u;u=u+288|0;c=d+256|0;e=d;f=b+440|0;g=b+464|0;h=b+24|0;m=b+232|0;k=b+248|0;l=b+264|0;n=b+233|0;p=b+249|0;q=b+265|0;y=b+234|0;B=b+250|0;H=b+266|0;r=b+235|0;z=b+251|0;Q=b+267|0;C=b+236|0;v=b+
252|0;V=b+268|0;E=b+237|0;J=b+253|0;I=b+269|0;G=b+238|0;L=b+254|0;K=b+270|0;A=b+239|0;D=b+255|0;O=b+271|0;M=b+240|0;T=b+256|0;X=b+272|0;P=b+241|0;F=b+257|0;S=b+273|0;Y=b+242|0;ba=b+258|0;W=b+274|0;U=b+243|0;Z=b+259|0;ga=b+275|0;Ha=b+244|0;ma=b+260|0;aa=b+276|0;ha=b+245|0;ca=b+261|0;fa=b+277|0;ja=b+246|0;pa=b+262|0;ya=b+278|0;ra=b+247|0;oa=b+263|0;sa=b+279|0;Aa=b+280|0;ua=b+40|0;Ia=b+304|0;Da=b+308|0;na=b+284|0;Na=b+288|0;Ka=b+289|0;Ca=b+290|0;Ga=b+292|0;Ea=b+294|0;La=b+296|0;Qa=b+300|0;Wa=c+1|0;eb=
c+2|0;pb=c+3|0;xb=c+4|0;Zb=c+5|0;ab=c+6|0;jb=c+7|0;mc=c+8|0;Ab=c+9|0;Ta=c+10|0;Ya=c+11|0;Sa=c+12|0;mb=c+13|0;Db=c+14|0;cc=c+15|0;Za=c+16|0;ia=b+36|0;qa=b+216|0;Ja=a[f>>2]|0;a:for(;;){do if(Ja)Ma=Ja;else if(a[(a[g>>2]|0)+12>>2]|0){if(!(rg(b)|0)){ea=0;wa=303;break a}Ma=a[f>>2]|0}else{xa=a[h>>2]|0;$a=xa+4|0;if(la=a[$a>>2]|0)Ba=la;else{if(!(da[a[xa+12>>2]&63](b)|0)){ea=0;wa=303;break a}Ba=a[$a>>2]|0}la=a[xa>>2]|0;va=Ba+-1|0;za=la+1|0;ta=t[la>>0]|0;la=ta&255;if(va)nb=va,sc=za;else{if(!(da[a[xa+12>>2]&
63](b)|0)){ea=0;wa=303;break a}nb=a[$a>>2]|0;sc=a[xa>>2]|0}za=t[sc>>0]|0;va=za&255;-1!=ta<<24>>24|-40!=za<<24>>24&&(za=a[b>>2]|0,a[za+20>>2]=55,a[za+24>>2]=la,a[za+28>>2]=va,R[a[za>>2]&127](b));a[f>>2]=va;a[xa>>2]=sc+1;a[$a>>2]=nb+-1;Ma=va}while(0);do switch(Ma|0){case 218:wa=25;break a;case 217:wa=72;break a;case 216:va=a[b>>2]|0;a[va+20>>2]=104;ub[a[va+4>>2]&31](b,1);va=a[g>>2]|0;a[va+12>>2]|0?(va=a[b>>2]|0,a[va+20>>2]=64,R[a[va>>2]&127](b),gb=a[g>>2]|0):gb=va;t[m>>0]=0;t[k>>0]=1;t[l>>0]=5;t[n>>
0]=0;t[p>>0]=1;t[q>>0]=5;t[y>>0]=0;t[B>>0]=1;t[H>>0]=5;t[r>>0]=0;t[z>>0]=1;t[Q>>0]=5;t[C>>0]=0;t[v>>0]=1;t[V>>0]=5;t[E>>0]=0;t[J>>0]=1;t[I>>0]=5;t[G>>0]=0;t[L>>0]=1;t[K>>0]=5;t[A>>0]=0;t[D>>0]=1;t[O>>0]=5;t[M>>0]=0;t[T>>0]=1;t[X>>0]=5;t[P>>0]=0;t[F>>0]=1;t[S>>0]=5;t[Y>>0]=0;t[ba>>0]=1;t[W>>0]=5;t[U>>0]=0;t[Z>>0]=1;t[ga>>0]=5;t[Ha>>0]=0;t[ma>>0]=1;t[aa>>0]=5;t[ha>>0]=0;t[ca>>0]=1;t[fa>>0]=5;t[ja>>0]=0;t[pa>>0]=1;t[ya>>0]=5;t[ra>>0]=0;t[oa>>0]=1;t[sa>>0]=5;a[Aa>>2]=0;a[ua>>2]=0;a[Ia>>2]=0;a[Da>>2]=
0;a[na>>2]=0;t[Na>>0]=1;t[Ka>>0]=1;t[Ca>>0]=0;w[Ga>>1]=1;w[Ea>>1]=1;a[La>>2]=0;t[Qa>>0]=0;a[gb+12>>2]=1;break;case 192:if(!(Ai(b,1,0,0)|0)){ea=0;wa=303;break a}break;case 193:if(!(Ai(b,0,0,0)|0)){ea=0;wa=303;break a}break;case 194:if(!(Ai(b,0,1,0)|0)){ea=0;wa=303;break a}break;case 201:if(!(Ai(b,0,0,1)|0)){ea=0;wa=303;break a}break;case 202:if(!(Ai(b,0,1,1)|0)){ea=0;wa=303;break a}break;case 207:case 206:case 205:case 203:case 200:case 199:case 198:case 197:case 195:va=a[b>>2]|0;a[va+20>>2]=63;a[va+
24>>2]=Ma;R[a[va>>2]&127](b);break;case 204:va=a[h>>2]|0;$a=va+4|0;if(xa=a[$a>>2]|0)hb=xa;else{if(!(da[a[va+12>>2]&63](b)|0)){ea=0;wa=303;break a}hb=a[$a>>2]|0}xa=a[va>>2]|0;za=hb+-1|0;la=xa+1|0;ta=x[xa>>0]<<8;if(za)ob=za,Bb=la;else{if(!(da[a[va+12>>2]&63](b)|0)){ea=0;wa=303;break a}ob=a[$a>>2]|0;Bb=a[va>>2]|0}la=ob+-1|0;za=Bb+1|0;xa=x[Bb>>0]|ta;ta=xa+-2|0;if(2<xa>>>0)for(xa=va+12|0,qb=la,kb=ta,ib=za;;){if(qb)Cb=qb,fb=ib;else{if(!(da[a[xa>>2]&63](b)|0)){ea=0;wa=303;break a}Cb=a[$a>>2]|0;fb=a[va>>
2]|0}sb=Cb+-1|0;Xa=fb+1|0;Fa=t[fb>>0]|0;Pa=Fa&255;if(sb)Eb=sb,vb=Xa;else{if(!(da[a[xa>>2]&63](b)|0)){ea=0;wa=303;break a}Eb=a[$a>>2]|0;vb=a[va>>2]|0}Xa=Eb+-1|0;sb=vb+1|0;tb=t[vb>>0]|0;bb=tb&255;Ib=kb+-2|0;Mb=a[b>>2]|0;a[Mb+20>>2]=81;a[Mb+24>>2]=Pa;a[Mb+28>>2]=bb;ub[a[Mb+4>>2]&31](b,1);31>=(Fa&255)?15>=(Fa&255)?(Fa=bb&15,t[b+232+Pa>>0]=Fa,Mb=(tb&255)>>>4,t[b+248+Pa>>0]=Mb,(Fa&255)>(Mb&255)&&(Mb=a[b>>2]|0,a[Mb+20>>2]=30,a[Mb+24>>2]=bb,R[a[Mb>>2]&127](b))):wa=90:(Mb=a[b>>2]|0,a[Mb+20>>2]=29,a[Mb+24>>
2]=Pa,R[a[Mb>>2]&127](b),wa=90);90==(wa|0)&&(wa=0,t[Pa+-16+(b+264)>>0]=tb);if(2<(kb|0))qb=Xa,kb=Ib,ib=sb;else{Hb=Xa;Ua=Ib;Kb=sb;break}}else Hb=la,Ua=ta,Kb=za;Ua&&(ib=a[b>>2]|0,a[ib+20>>2]=12,R[a[ib>>2]&127](b));a[va>>2]=Kb;a[$a>>2]=Hb;break;case 196:ib=a[h>>2]|0;kb=ib+4|0;if(qb=a[kb>>2]|0)Jb=qb;else{if(!(da[a[ib+12>>2]&63](b)|0)){wa=127;break a}Jb=a[kb>>2]|0}qb=a[ib>>2]|0;xa=Jb+-1|0;sb=qb+1|0;Ib=x[qb>>0]<<8;if(xa)Wb=xa,yb=sb;else{if(!(da[a[ib+12>>2]&63](b)|0)){wa=127;break a}Wb=a[kb>>2]|0;yb=a[ib>>
2]|0}sb=Wb+-1|0;xa=yb+1|0;qb=(x[yb>>0]|Ib)+-2|0;if(16<(qb|0))for(Ib=ib+12|0,Xa=sb,tb=qb,Pa=xa;;){if(Xa)cb=Xa,gc=Pa;else{if(!(da[a[Ib>>2]&63](b)|0)){wa=127;break a}cb=a[kb>>2]|0;gc=a[ib>>2]|0}Mb=x[gc>>0]|0;bb=a[b>>2]|0;a[bb+20>>2]=82;a[bb+24>>2]=Mb;ub[a[bb+4>>2]&31](b,1);t[c>>0]=0;bb=cb+-1|0;Fa=0;Ub=1;for(Fb=gc+1|0;;){if(bb)Gb=bb,Lb=Fb;else{if(!(da[a[Ib>>2]&63](b)|0)){wa=127;break a}Gb=a[kb>>2]|0;Lb=a[ib>>2]|0}lb=t[Lb>>0]|0;t[c+Ub>>0]=lb;rb=(lb&255)+Fa|0;Ub=Ub+1|0;lb=Gb+-1|0;wb=Lb+1|0;if(17<=(Ub|0)){db=
rb;Qd=lb;zb=wb;break}else bb=lb,Fa=rb,Fb=wb}Fb=tb+-17|0;Fa=a[b>>2]|0;a[Fa+24>>2]=x[Wa>>0];a[Fa+28>>2]=x[eb>>0];a[Fa+32>>2]=x[pb>>0];a[Fa+36>>2]=x[xb>>0];a[Fa+40>>2]=x[Zb>>0];a[Fa+44>>2]=x[ab>>0];a[Fa+48>>2]=x[jb>>0];a[Fa+52>>2]=x[mc>>0];a[Fa+20>>2]=88;ub[a[Fa+4>>2]&31](b,2);Fa=a[b>>2]|0;a[Fa+24>>2]=x[Ab>>0];a[Fa+28>>2]=x[Ta>>0];a[Fa+32>>2]=x[Ya>>0];a[Fa+36>>2]=x[Sa>>0];a[Fa+40>>2]=x[mb>>0];a[Fa+44>>2]=x[Db>>0];a[Fa+48>>2]=x[cc>>0];a[Fa+52>>2]=x[Za>>0];a[Fa+20>>2]=88;ub[a[Fa+4>>2]&31](b,2);256<(db|
0)|(Fb|0)<(db|0)&&(Fa=a[b>>2]|0,a[Fa+20>>2]=9,R[a[Fa>>2]&127](b));Va(e|0,0,256)|0;if(0<(db|0))for(Fa=Qd,bb=0,Ub=zb;;){if(Fa)Ob=Fa,Tb=Ub;else{if(!(da[a[Ib>>2]&63](b)|0)){wa=127;break a}Ob=a[kb>>2]|0;Tb=a[ib>>2]|0}wb=Ob+-1|0;rb=Tb+1|0;t[e+bb>>0]=t[Tb>>0]|0;bb=bb+1|0;if((bb|0)>=(db|0)){Sb=wb;Pb=rb;break}else Fa=wb,Ub=rb}else Sb=Qd,Pb=zb;Ub=Fb-db|0;Fa=0==(Mb&16|0);bb=Mb+-16|0;rb=Fa?Mb:bb;wb=Fa?b+180+(Mb<<2)|0:b+196+(bb<<2)|0;3<rb>>>0&&(bb=a[b>>2]|0,a[bb+20>>2]=31,a[bb+24>>2]=rb,R[a[bb>>2]&127](b));(bb=
a[wb>>2]|0)?Qb=bb:(rb=Zi(b)|0,Qb=a[wb>>2]=rb);bb=Qb;rb=c;Fa=bb+17|0;do t[bb>>0]=t[rb>>0]|0,bb=bb+1|0,rb=rb+1|0;while((bb|0)<(Fa|0));Ec((a[wb>>2]|0)+17|0,e|0,256)|0;if(16<(Ub|0))Xa=Sb,tb=Ub,Pa=Pb;else{ac=Sb;Vb=Ub;Yb=Pb;break}}else ac=sb,Vb=qb,Yb=xa;Vb&&(Pa=a[b>>2]|0,a[Pa+20>>2]=12,R[a[Pa>>2]&127](b));a[ib>>2]=Yb;a[kb>>2]=ac;break;case 219:Pa=a[h>>2]|0;tb=Pa+4|0;if(Xa=a[tb>>2]|0)fc=Xa;else{if(!(da[a[Pa+12>>2]&63](b)|0)){ea=0;wa=303;break a}fc=a[tb>>2]|0}Xa=a[Pa>>2]|0;Ib=fc+-1|0;$a=Xa+1|0;va=x[Xa>>0]<<
8;if(Ib)$b=Ib,jc=$a;else{if(!(da[a[Pa+12>>2]&63](b)|0)){ea=0;wa=303;break a}$b=a[tb>>2]|0;jc=a[Pa>>2]|0}$a=$b+-1|0;Ib=jc+1|0;Xa=x[jc>>0]|va;va=Xa+-2|0;if(2<Xa>>>0)for(Xa=Pa+12|0,za=$a,ta=va,la=Ib;;){rb=ta+-1|0;if(za)lc=za,kc=la;else{if(!(da[a[Xa>>2]&63](b)|0)){ea=0;wa=303;break a}lc=a[tb>>2]|0;kc=a[Pa>>2]|0}bb=x[kc>>0]|0;Fa=bb>>>4;Mb=bb&15;bb=a[b>>2]|0;a[bb+20>>2]=83;a[bb+24>>2]=Mb;a[bb+28>>2]=Fa;ub[a[bb+4>>2]&31](b,1);3<Mb>>>0&&(bb=a[b>>2]|0,a[bb+20>>2]=32,a[bb+24>>2]=Mb,R[a[bb>>2]&127](b));bb=b+
164+(Mb<<2)|0;(Mb=a[bb>>2]|0)?hc=Mb:(Fb=zf(b)|0,hc=a[bb>>2]=Fb);if(Mb=0!=(Fa|0))if(129>(ta|0)){Fa=0;do w[hc+(Fa<<1)>>1]=1,Fa=Fa+1|0;while(64!=(Fa|0));ec=rb>>1;wa=150}else wa=157;else if(65>(ta|0)){Fa=0;do w[hc+(Fa<<1)>>1]=1,Fa=Fa+1|0;while(64!=(Fa|0));ec=rb;wa=150}else wa=157;b:do if(150==(wa|0)){wa=0;switch(ec|0){case 4:nc=4;yc=121164;break;case 9:nc=ec;yc=121064;break;case 16:nc=ec;yc=120936;break;case 25:nc=ec;yc=120772;break;case 36:nc=ec;yc=120564;break;case 49:nc=ec;yc=120304;break;default:Fa=
lc+-1|0;Ub=kc+1|0;0<(ec|0)?(xc=Fa,vc=ec,Bc=119984,zc=Ub,wa=159):(Cc=Fa,oc=ec,Gc=Ub);break b}xc=lc+-1|0;vc=nc;Bc=yc;zc=kc+1|0;wa=159}else 157==(wa|0)&&(wa=0,xc=lc+-1|0,vc=64,Bc=119984,zc=kc+1|0,wa=159);while(0);if(159==(wa|0))for(wa=0,Ub=xc,Fa=0,wb=zc;;){Fb=0==(Ub|0);if(Mb){if(Fb){if(!(da[a[Xa>>2]&63](b)|0)){ea=0;wa=303;break a}Jc=a[tb>>2]|0;Hc=a[Pa>>2]|0}else Jc=Ub,Hc=wb;bb=Jc+-1|0;lb=Hc+1|0;ic=x[Hc>>0]<<8;if(bb)Lc=bb,Fc=lb;else{if(!(da[a[Xa>>2]&63](b)|0)){ea=0;wa=303;break a}Lc=a[tb>>2]|0;Fc=a[Pa>>
2]|0}bd=Lc;Ic=Fc;Rc=x[Fc>>0]|ic}else{if(Fb){if(!(da[a[Xa>>2]&63](b)|0)){ea=0;wa=303;break a}Oc=a[tb>>2]|0;Uc=a[Pa>>2]|0}else Oc=Ub,Uc=wb;bd=Oc;Ic=Uc;Rc=x[Uc>>0]|0}w[hc+(a[Bc+(Fa<<2)>>2]<<1)>>1]=Rc;Fa=Fa+1|0;Fb=bd+-1|0;ic=Ic+1|0;if((Fa|0)>=(vc|0)){Cc=Fb;oc=vc;Gc=ic;break}else Ub=Fb,wb=ic}wb=a[b>>2]|0;b:do if(1<(a[wb+104>>2]|0))for(Ub=wb,Fa=0;;){a[Ub+24>>2]=N[hc+(Fa<<1)>>1];a[Ub+28>>2]=N[hc+((Fa|1)<<1)>>1];a[Ub+32>>2]=N[hc+((Fa|2)<<1)>>1];a[Ub+36>>2]=N[hc+((Fa|3)<<1)>>1];a[Ub+40>>2]=N[hc+((Fa|4)<<1)>>
1];a[Ub+44>>2]=N[hc+((Fa|5)<<1)>>1];a[Ub+48>>2]=N[hc+((Fa|6)<<1)>>1];a[Ub+52>>2]=N[hc+((Fa|7)<<1)>>1];a[Ub+20>>2]=95;ub[a[Ub+4>>2]&31](b,2);ic=Fa+8|0;if(64<=(ic|0))break b;Ub=a[b>>2]|0;Fa=ic}while(0);wb=rb-oc+(Mb?0-oc|0:0)|0;if(0<(wb|0))za=Cc,ta=wb,la=Gc;else{Wc=Cc;Pc=wb;ad=Gc;break}}else Wc=$a,Pc=va,ad=Ib;Pc&&(la=a[b>>2]|0,a[la+20>>2]=12,R[a[la>>2]&127](b));a[Pa>>2]=ad;a[tb>>2]=Wc;break;case 221:la=a[h>>2]|0;ta=la+4|0;if(za=a[ta>>2]|0)Qc=za;else{if(!(da[a[la+12>>2]&63](b)|0)){ea=0;wa=303;break a}Qc=
a[ta>>2]|0}za=a[la>>2]|0;Xa=Qc+-1|0;kb=za+1|0;ib=x[za>>0]<<8;if(Xa)Xc=Xa,hd=kb;else{if(!(da[a[la+12>>2]&63](b)|0)){ea=0;wa=303;break a}Xc=a[ta>>2]|0;hd=a[la>>2]|0}kb=Xc+-1|0;Xa=hd+1|0;4!=(x[hd>>0]|ib|0)&&(ib=a[b>>2]|0,a[ib+20>>2]=12,R[a[ib>>2]&127](b));if(kb)Bd=kb,Vc=Xa;else{if(!(da[a[la+12>>2]&63](b)|0)){ea=0;wa=303;break a}Bd=a[ta>>2]|0;Vc=a[la>>2]|0}Xa=Bd+-1|0;kb=Vc+1|0;ib=x[Vc>>0]<<8;if(Xa)Rb=Xa,od=kb;else{if(!(da[a[la+12>>2]&63](b)|0)){ea=0;wa=303;break a}Rb=a[ta>>2]|0;od=a[la>>2]|0}kb=x[od>>
0]|ib;ib=a[b>>2]|0;a[ib+20>>2]=84;a[ib+24>>2]=kb;ub[a[ib+4>>2]&31](b,1);a[Aa>>2]=kb;a[la>>2]=od+1;a[ta>>2]=Rb+-1;break;case 248:ta=a[h>>2]|0;la=a[ta>>2]|0;kb=ta+4|0;ib=a[kb>>2]|0;a[(a[g>>2]|0)+16>>2]|0||(Xa=a[b>>2]|0,a[Xa+20>>2]=60,Wk(Xa+24|0,156277,80)|0,R[a[a[b>>2]>>2]&127](b));do if(3<=(a[ia>>2]|0)){if(ib)tc=ib,Xb=la;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}tc=a[kb>>2]|0;Xb=a[ta>>2]|0}Xa=tc+-1|0;za=Xb+1|0;xa=x[Xb>>0]<<8;if(Xa)rc=Xa,ed=za;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;
wa=303;break a}rc=a[kb>>2]|0;ed=a[ta>>2]|0}za=rc+-1|0;Xa=ed+1|0;24!=(x[ed>>0]|xa|0)&&(xa=a[b>>2]|0,a[xa+20>>2]=12,R[a[xa>>2]&127](b));if(za)gd=za,$c=Xa;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}gd=a[kb>>2]|0;$c=a[ta>>2]|0}Xa=gd+-1|0;za=$c+1|0;13!=(t[$c>>0]|0)&&(xa=a[b>>2]|0,a[xa+20>>2]=70,a[xa+24>>2]=a[f>>2],R[a[xa>>2]&127](b));if(Xa)cd=Xa,dd=za;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}cd=a[kb>>2]|0;dd=a[ta>>2]|0}za=cd+-1|0;Xa=dd+1|0;xa=x[dd>>0]<<8;if(za)md=za,ld=Xa;else{if(!(da[a[ta+
12>>2]&63](b)|0)){ea=0;wa=303;break a}md=a[kb>>2]|0;ld=a[ta>>2]|0}Xa=md+-1|0;za=ld+1|0;if(255==(x[ld>>0]|xa|0)){if(Xa)Yc=Xa,wc=za;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}Yc=a[kb>>2]|0;wc=a[ta>>2]|0}xa=Yc+-1|0;qb=wc+1|0;if(3==(t[wc>>0]|0)){if(xa)id=xa,dc=qb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}id=a[kb>>2]|0;dc=a[ta>>2]|0}sb=id+-1|0;wb=dc+1|0;Fa=a[qa>>2]|0;if((x[dc>>0]|0)==(a[Fa+88>>2]|0)){if(sb)Ac=Fa,Sc=sb,Tc=wb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}Ac=
a[qa>>2]|0;Sc=a[kb>>2]|0;Tc=a[ta>>2]|0}Fa=Sc+-1|0;Ub=Tc+1|0;if((x[Tc>>0]|0)==(a[Ac>>2]|0)){if(Fa)td=Ac,qd=Fa,Ce=Ub;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}td=a[qa>>2]|0;qd=a[kb>>2]|0;Ce=a[ta>>2]|0}ic=qd+-1|0;Fb=Ce+1|0;if((x[Ce>>0]|0)!=(a[td+176>>2]|0))vd=ic,wd=Fb,wa=288;else{if(ic)rd=ic,sd=Fb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}rd=a[kb>>2]|0;sd=a[ta>>2]|0}Fb=rd+-1|0;ic=sd+1|0;if(-128!=(t[sd>>0]|0))vd=Fb,wd=ic,wa=288;else{if(Fb)pd=Fb,jd=ic;else{if(!(da[a[ta+12>>
2]&63](b)|0)){ea=0;wa=303;break a}pd=a[kb>>2]|0;jd=a[ta>>2]|0}ic=pd+-1|0;Fb=jd+1|0;lb=x[jd>>0]<<8;if(ic)Ud=ic,zd=Fb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}Ud=a[kb>>2]|0;zd=a[ta>>2]|0}Fb=Ud+-1|0;ic=zd+1|0;if(x[zd>>0]|lb)vd=Fb,wd=ic,wa=288;else{if(Fb)Cd=Fb,Dd=ic;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}Cd=a[kb>>2]|0;Dd=a[ta>>2]|0}ic=Cd+-1|0;Fb=Dd+1|0;lb=x[Dd>>0]<<8;if(ic)ce=ic,oe=Fb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}ce=a[kb>>2]|0;oe=a[ta>>2]|0}Fb=
ce+-1|0;ic=oe+1|0;if(x[oe>>0]|lb)vd=Fb,wd=ic,wa=288;else{if(Fb)Id=Fb,Kd=ic;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}Id=a[kb>>2]|0;Kd=a[ta>>2]|0}ic=Id+-1|0;Fb=Kd+1|0;if(t[Kd>>0]|0)vd=ic,wd=Fb,wa=288;else{if(ic)Df=ic,Nd=Fb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}Df=a[kb>>2]|0;Nd=a[ta>>2]|0}Fb=Df+-1|0;ic=Nd+1|0;lb=x[Nd>>0]<<8;if(Fb)Pd=Fb,Vd=ic;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}Pd=a[kb>>2]|0;Vd=a[ta>>2]|0}ic=Pd+-1|0;Fb=Vd+1|0;if(1!=(x[Vd>>0]|lb|0))vd=
ic,wd=Fb,wa=288;else{if(ic)ne=ic,he=Fb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}ne=a[kb>>2]|0;he=a[ta>>2]|0}Fb=ne+-1|0;ic=he+1|0;lb=x[he>>0]<<8;if(Fb)te=Fb,de=ic;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}te=a[kb>>2]|0;de=a[ta>>2]|0}ic=te+-1|0;Fb=de+1|0;if(x[de>>0]|lb)vd=ic,wd=Fb,wa=288;else{if(ic)He=ic,ue=Fb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}He=a[kb>>2]|0;ue=a[ta>>2]|0}Fb=He+-1|0;ic=ue+1|0;if(t[ue>>0]|0)vd=Fb,wd=ic,wa=288;else{if(Fb)Ld=Fb,Od=ic;else{if(!(da[a[ta+
12>>2]&63](b)|0)){ea=0;wa=303;break a}Ld=a[kb>>2]|0;Od=a[ta>>2]|0}ic=Ld+-1|0;Fb=Od+1|0;lb=x[Od>>0]<<8;if(ic)ae=ic,De=Fb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}ae=a[kb>>2]|0;De=a[ta>>2]|0}Fb=ae+-1|0;ic=De+1|0;if(1!=(x[De>>0]|lb|0))vd=Fb,wd=ic,wa=288;else{if(Fb)be=Fb,Fd=ic;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}be=a[kb>>2]|0;Fd=a[ta>>2]|0}ic=be+-1|0;Fb=Fd+1|0;lb=x[Fd>>0]<<8;if(ic)Rd=ic,Gd=Fb;else{if(!(da[a[ta+12>>2]&63](b)|0)){ea=0;wa=303;break a}Rd=a[kb>>2]|0;Gd=a[ta>>
2]|0}Fb=Rd+-1|0;ic=Gd+1|0;x[Gd>>0]|lb?(vd=Fb,wd=ic,wa=288):($d=Fb,ge=ic)}}}}}}}}}}else vd=Fa,wd=Ub,wa=288}else vd=sb,wd=wb,wa=288}else vd=xa,wd=qb,wa=288}else vd=Xa,wd=za,wa=288}else vd=ib,wd=la,wa=288;while(0);288==(wa|0)&&(wa=0,la=a[b>>2]|0,a[la+20>>2]=28,R[a[la>>2]&127](b),$d=vd,ge=wd);a[Ia>>2]=1;a[ta>>2]=ge;a[kb>>2]=$d;break;case 239:case 238:case 237:case 236:case 235:case 234:case 233:case 232:case 231:case 230:case 229:case 228:case 227:case 226:case 225:case 224:if(!(da[a[(a[g>>2]|0)+32+(Ma+
-224<<2)>>2]&63](b)|0)){ea=0;wa=303;break a}break;case 254:if(!(da[a[(a[g>>2]|0)+28>>2]&63](b)|0)){ea=0;wa=303;break a}break;case 1:case 215:case 214:case 213:case 212:case 211:case 210:case 209:case 208:la=a[b>>2]|0;a[la+20>>2]=94;a[la+24>>2]=Ma;ub[a[la+4>>2]&31](b,1);break;case 220:la=a[h>>2]|0;ib=la+4|0;if(tb=a[ib>>2]|0)ud=tb;else{if(!(da[a[la+12>>2]&63](b)|0)){ea=0;wa=303;break a}ud=a[ib>>2]|0}tb=a[la>>2]|0;Pa=ud+-1|0;Ib=tb+1|0;va=x[tb>>0]<<8;if(Pa)xd=Pa,ie=Ib;else{if(!(da[a[la+12>>2]&63](b)|
0)){ea=0;wa=303;break a}xd=a[ib>>2]|0;ie=a[la>>2]|0}Ib=x[ie>>0]|va;va=Ib+-2|0;Pa=a[b>>2]|0;a[Pa+20>>2]=93;a[Pa+24>>2]=a[f>>2];a[Pa+28>>2]=va;ub[a[Pa+4>>2]&31](b,1);a[la>>2]=ie+1;a[ib>>2]=xd+-1;if(2<Ib>>>0)ub[a[(a[h>>2]|0)+16>>2]&31](b,va);break;default:va=a[b>>2]|0,a[va+20>>2]=70,a[va+24>>2]=Ma,R[a[va>>2]&127](b)}while(0);Ja=a[f>>2]=0}if(25==(wa|0)){Ja=a[h>>2]|0;h=a[Ja>>2]|0;Ma=Ja+4|0;xd=a[Ma>>2]|0;a[(a[g>>2]|0)+16>>2]|0||(ie=a[b>>2]|0,a[ie+20>>2]=60,Wk(ie+24|0,156273,80)|0,R[a[a[b>>2]>>2]&127](b));
if(xd)je=xd,Xd=h;else if(da[a[Ja+12>>2]&63](b)|0)je=a[Ma>>2]|0,Xd=a[Ja>>2]|0;else return ea=0,u=d,ea|0;h=je+-1|0;je=Xd+1|0;xd=x[Xd>>0]<<8;if(h)Of=h,Dc=je;else if(da[a[Ja+12>>2]&63](b)|0)Of=a[Ma>>2]|0,Dc=a[Ja>>2]|0;else return ea=0,u=d,ea|0;je=Of+-1|0;Of=Dc+1|0;h=x[Dc>>0]|xd;if(je)yd=je,Ad=Of;else if(da[a[Ja+12>>2]&63](b)|0)yd=a[Ma>>2]|0,Ad=a[Ja>>2]|0;else return ea=0,u=d,ea|0;Of=t[Ad>>0]|0;je=Of&255;xd=a[b>>2]|0;a[xd+20>>2]=105;a[xd+24>>2]=je;ub[a[xd+4>>2]&31](b,1);4<(Of&255)|(h|0)!=((je<<1)+6|0)?
wa=41:Of<<24>>24?(a[b+340>>2]=je,xd=yd+-1|0,Sd=0==(xd|0),Td=xd,se=Ad+1|0,wa=42):a[b+224>>2]|0?(a[b+340>>2]=je,(xd=yd+-1|0)?(Md=1,ve=xd,Je=Ad+1|0):(Ye=1,wa=61)):wa=41;41==(wa|0)&&(h=a[b>>2]|0,a[h+20>>2]=12,R[a[h>>2]&127](b),a[b+340>>2]=je,h=yd+-1|0,yd=Ad+1|0,Ad=0==(h|0),Of<<24>>24?(Sd=Ad,Td=h,se=yd,wa=42):(ze=Ad,Qe=1,Yd=h,Ze=yd,wa=60));a:do if(42==(wa|0)){yd=Ja+12|0;h=b+344|0;Ad=Sd;Of=Td;xd=0;for(Dc=se;;){if(Ad){if(!(da[a[yd>>2]&63](b)|0)){ea=0;wa=303;break}we=a[Ma>>2]|0;xe=a[Ja>>2]|0}else we=Of,xe=
Dc;Xd=we+-1|0;ie=xe+1|0;ud=x[xe>>0]|0;b:do if(0<(xd|0)){for($d=0;(ud|0)!=(a[a[b+344+($d<<2)>>2]>>2]|0);)if($d=$d+1|0,($d|0)>=(xd|0)){kf=ud;break b}$d=a[a[h>>2]>>2]|0;if(1<(xd|0))for(Mb=$d,rb=1;;)if(ge=a[a[b+344+(rb<<2)>>2]>>2]|0,Ia=(ge|0)>(Mb|0)?ge:Mb,rb=rb+1|0,(rb|0)==(xd|0)){re=Ia;break}else Mb=Ia;else re=$d;kf=re+1|0}else kf=ud;while(0);ud=a[qa>>2]|0;kb=a[ia>>2]|0;b:do if(0<(kb|0))for(ta=0,Mb=ud;;){if((kf|0)==(a[Mb>>2]|0)){df=Mb;break b}ta=ta+1|0;rb=Mb+88|0;if((ta|0)>=(kb|0)){Ae=rb;wa=55;break}else Mb=
rb}else Ae=ud,wa=55;while(0);55==(wa|0)&&(wa=0,ud=a[b>>2]|0,a[ud+20>>2]=4,a[ud+24>>2]=kf,R[a[ud>>2]&127](b),df=Ae);a[b+344+(xd<<2)>>2]=df;if(Xd)ef=Xd,Ue=ie;else{if(!(da[a[yd>>2]&63](b)|0)){ea=0;wa=303;break}ef=a[Ma>>2]|0;Ue=a[Ja>>2]|0}ud=x[Ue>>0]|0;kb=df+20|0;a[kb>>2]=ud>>>4;Mb=df+24|0;a[Mb>>2]=ud&15;ud=a[b>>2]|0;a[ud+24>>2]=a[df>>2];a[ud+28>>2]=a[kb>>2];a[ud+32>>2]=a[Mb>>2];a[ud+20>>2]=106;ub[a[ud+4>>2]&31](b,1);xd=xd+1|0;ud=ef+-1|0;Mb=Ue+1|0;kb=0==(ud|0);if((xd|0)>=(je|0)){ze=kb;Qe=0;Yd=ud;Ze=Mb;
wa=60;break a}else Ad=kb,Of=ud,Dc=Mb}if(303==(wa|0))return u=d,ea|0}while(0);60==(wa|0)&&(ze?(Ye=Qe,wa=61):(Md=Qe,ve=Yd,Je=Ze));if(61==(wa|0))if(da[a[Ja+12>>2]&63](b)|0)Md=Ye,ve=a[Ma>>2]|0,Je=a[Ja>>2]|0;else return ea=0,u=d,ea|0;Ye=ve+-1|0;ve=Je+1|0;Ze=b+412|0;a[Ze>>2]=x[Je>>0];if(Ye)Ke=Ye,qe=ve;else if(da[a[Ja+12>>2]&63](b)|0)Ke=a[Ma>>2]|0,qe=a[Ja>>2]|0;else return ea=0,u=d,ea|0;ve=Ke+-1|0;Ke=qe+1|0;Ye=b+416|0;a[Ye>>2]=x[qe>>0];if(ve)$e=ve,le=Ke;else if(da[a[Ja+12>>2]&63](b)|0)$e=a[Ma>>2]|0,le=a[Ja>>
2]|0;else return ea=0,u=d,ea|0;Ke=x[le>>0]|0;ve=b+420|0;a[ve>>2]=Ke>>>4;qe=b+424|0;a[qe>>2]=Ke&15;Ke=a[b>>2]|0;a[Ke+24>>2]=a[Ze>>2];a[Ke+28>>2]=a[Ye>>2];a[Ke+32>>2]=a[ve>>2];a[Ke+36>>2]=a[qe>>2];a[Ke+20>>2]=107;ub[a[Ke+4>>2]&31](b,1);a[(a[g>>2]|0)+20>>2]=0;Md||(Md=b+144|0,a[Md>>2]=(a[Md>>2]|0)+1);a[Ja>>2]=le+1;a[Ma>>2]=$e+-1;a[f>>2]=0;ea=1;u=d;return ea|0}return 72==(wa|0)?($e=a[b>>2]|0,a[$e+20>>2]=87,ub[a[$e+4>>2]&31](b,1),a[f>>2]=0,ea=2,u=d,ea|0):127==(wa|0)?(ea=0,u=d,ea|0):303==(wa|0)?(u=d,ea|
0):0},function(b){b|=0;var d,c,e,f;d=b+440|0;if(c=a[d>>2]|0)e=c;else if(rg(b)|0)e=a[d>>2]|0;else return 0;c=b+464|0;f=a[(a[c>>2]|0)+20>>2]|0;if((e|0)!=(f+208|0)){if(!(dd[a[(a[b+24>>2]|0)+20>>2]&127](b,f)|0))return 0}else e=a[b>>2]|0,a[e+20>>2]=100,a[e+24>>2]=f,ub[a[e+4>>2]&31](b,3),a[d>>2]=0;d=(a[c>>2]|0)+20|0;a[d>>2]=(a[d>>2]|0)+1&7;return 1},function(b){b|=0;var d,c,e,f,g,h,m,k;d=b+24|0;c=a[d>>2]|0;e=c+4|0;if(f=a[e>>2]|0)g=f;else if(da[a[c+12>>2]&63](b)|0)g=a[e>>2]|0;else return 0;f=a[c>>2]|0;h=
g+-1|0;g=f+1|0;f=(x[f>>0]|0)<<8;if(h)m=h,k=g;else if(da[a[c+12>>2]&63](b)|0)m=a[e>>2]|0,k=a[c>>2]|0;else return 0;g=x[k>>0]|0|f;f=g+-2|0;h=a[b>>2]|0;a[h+20>>2]=93;a[h+24>>2]=a[b+440>>2];a[h+28>>2]=f;ub[a[h+4>>2]&31](b,1);a[c>>2]=k+1;a[e>>2]=m+-1;if(2>=g>>>0)return 1;ub[a[(a[d>>2]|0)+16>>2]&31](b,f);return 1},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y;d=u;u=u+16|0;c=b+24|0;e=a[c>>2]|0;f=e+4|0;if(g=a[f>>2]|0)h=g;else if(da[a[e+12>>2]&63](b)|0)h=a[f>>2]|0;else return u=d,0;g=a[e>>2]|0;m=h+-1|0;h=
g+1|0;k=x[g>>0]<<8;if(m)l=m,n=h;else if(da[a[e+12>>2]&63](b)|0)l=a[f>>2]|0,n=a[e>>2]|0;else return u=d,0;h=x[n>>0]|k;k=h+-2|0;m=13<(k|0)?14:2<h>>>0?k:0;h=l+-1|0;l=n+1|0;a:do{if(m){n=e+12|0;g=h;h=0;for(q=l;;){if(g)y=q;else{if(!(da[a[n>>2]&63](b)|0)){b=0;break}g=a[f>>2]|0;y=a[e>>2]|0}t[d+h>>0]=t[y>>0]|0;h=h+1|0;g=g+-1|0;y=y+1|0;if(h>>>0>=m>>>0){n=g;p=y;break a}else q=y}u=d;return b|0}n=h;p=l}while(0);y=k-m|0;g=a[b+440>>2]|0;a:do switch(g|0){case 224:Uh(b,d,m,y);break;case 238:if(11<m>>>0&65==(t[d>>
0]|0)&&100==(t[d+1>>0]|0)&&111==(t[d+2>>0]|0)&&98==(t[d+3>>0]|0)&&101==(t[d+4>>0]|0)){l=x[d+7>>0]<<8|x[d+8>>0];h=x[d+9>>0]<<8|x[d+10>>0];q=t[d+11>>0]|0;g=a[b>>2]|0;a[g+24>>2]=x[d+5>>0]<<8|x[d+6>>0];a[g+28>>2]=l;a[g+32>>2]=h;a[g+36>>2]=q&255;a[g+20>>2]=78;ub[a[g+4>>2]&31](b,1);a[b+296>>2]=1;t[b+300>>0]=q;break a}q=a[b>>2]|0;a[q+20>>2]=80;a[q+24>>2]=k;ub[a[q+4>>2]&31](b,1);break;default:q=a[b>>2]|0,a[q+20>>2]=70,a[q+24>>2]=g,R[a[q>>2]&127](b)}while(0);a[e>>2]=p;a[f>>2]=n;if(0>=(y|0))return u=d,1;ub[a[(a[c>>
2]|0)+16>>2]&31](b,y);u=d;return 1},function(b){b|=0;var d,c,e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,x,C,w,v,A,J,I;d=u;u=u+16|0;c=b+452|0;e=a[c>>2]|0;f=b+340|0;if(0<(a[f>>2]|0)){g=b+4|0;h=b+148|0;m=0;do k=a[b+344+(m<<2)>>2]|0,l=a[k+12>>2]|0,n=E(l,a[h>>2]|0)|0,p=jg[a[(a[g>>2]|0)+32>>2]&3](b,a[e+72+(a[k+4>>2]<<2)>>2]|0,n,l,1)|0,a[d+(m<<2)>>2]=p,m=m+1|0;while((m|0)<(a[f>>2]|0))}m=e+24|0;g=a[m>>2]|0;h=e+28|0;p=a[h>>2]|0;a:do if((g|0)<(p|0)){l=e+20|0;n=b+360|0;k=b+468|0;q=e+32|0;y=a[l>>2]|0;B=a[n>>2]|0;b:for(;;){if(y>>>
0<B>>>0){for(p=y;;){y=a[f>>2]|0;if(0<(y|0))for(B=t=0;;){r=a[b+344+(B<<2)>>2]|0;z=a[r+56>>2]|0;x=E(z,p)|0;C=a[r+60>>2]|0;if(0<(C|0)&&(r=a[d+(B<<2)>>2]|0,0<(z|0)))for(w=1<(z|0)?z:1,v=0;;){A=t;J=(a[r+(v+g<<2)>>2]|0)+(x<<7)|0;for(I=0;!(a[e+32+(A<<2)>>2]=J,I=I+1|0,(I|0)>=(z|0));)A=A+1|0,J=J+128|0;J=t+w|0;v=v+1|0;if((v|0)>=(C|0)){r=J;break}else t=J}else r=t;B=B+1|0;if((B|0)>=(y|0))break;else t=r}if(!(dd[a[(a[k>>2]|0)+4>>2]&127](b,q)|0)){e=p;h=g;break b}p=p+1|0;t=a[n>>2]|0;if(p>>>0>=t>>>0){p=t;break}}B=
p;p=a[h>>2]|0}a[l>>2]=0;g=g+1|0;if((g|0)>=(p|0))break a;else y=0}a[m>>2]=h;a[l>>2]=e;u=d;return 0}while(0);e=b+148|0;h=(a[e>>2]|0)+1|0;a[e>>2]=h;e=a[b+332>>2]|0;if(h>>>0>=e>>>0)return R[a[(a[b+460>>2]|0)+12>>2]&127](b),u=d,4;m=a[c>>2]|0;1>=(a[f>>2]|0)?(c=a[b+344>>2]|0,a[m+28>>2]=h>>>0<(e+-1|0)>>>0?a[c+12>>2]:a[c+76>>2]):a[m+28>>2]=1;a[m+20>>2]=0;a[m+24>>2]=0;u=d;return 3},function(a){return 0},rf,rf,rf,rf,rf,rf,rf,rf,rf,rf,rf],td=[$b,function(b,d,c){b|=0;d|=0;c|=0;var e,f;e=u;u=u+16|0;f=a[30710]|
0;b&&(a[e>>2]=b,Ld(f,139937,e)|0);Sd(139945,9,1,f)|0;Ei(f,d,c)|0;Sd(139942,2,1,f)|0;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f;e=u;u=u+16|0;f=a[30710]|0;b&&(a[e>>2]=b,Ld(f,139937,e)|0);Ei(f,d,c)|0;Sd(139942,2,1,f)|0;u=e},function(a,d,c){},function(a,d,c){d|=0;c|=0;c&1?Z(138285,137683,1059,138299):Vd(d,(c|0)/2|0)},function(a,d,c){d|=0;c|=0;if((c|0)%3|0)Z(138318,137683,1067,138332);else{a=(c|0)/3|0;var e;if(0<(a|0))for(c=a,e=d|0;;)if(d=e+2|0,a=t[d>>0]|0,t[d>>0]=t[e>>0]|0,t[e>>0]=a,1<(c|0))c=c+-1|0,
e=e+3|0;else break}},function(a,d,c){d|=0;c|=0;c&3?Z(138351,137683,1075,138365):Id(d,(c|0)/4|0)},function(a,d,c){d|=0;c|=0;c&7?Z(138384,137683,1083,138398):re(d,(c|0)/8|0)},function(b,d,c){d|=0;c|=0;var e;b=a[d>>2]|0;e=1>(b|0)?a[d>>2]=256:b;b=a[c>>2]|0;1>(b|0)&&(b=a[c>>2]=256,e=a[d>>2]|0);e&15?(a[d>>2]=4294967280>e>>>0?e+15&-16:0,d=a[c>>2]|0):d=b;d&15&&(a[c>>2]=4294967280>d>>>0?d+15&-16:0)},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B;e=u;u=u+64|0;f=e+56|0;g=e+48|0;h=e+40|0;m=e+32|0;
k=e+24|0;l=e+16|0;n=e+8|0;p=e;(q=a[b+576>>2]|0)||Z(154168,142823,1232,144253);y=b+48|0;B=a[y>>2]|0;B&512?(4==(w[b+88>>1]|0)?(Sd(144266,18,1,d)|0,B=q+28|0,a[B>>2]&2&&(a[p>>2]=144305,Ld(d,144285,p)|0)):(Sd(144307,18,1,d)|0,B=q+28|0,p=a[B>>2]|0,p&1?(a[n>>2]=144305,Ld(d,144326,n)|0,p=a[B>>2]|0,n=144341):n=144305,p&4?(a[l>>2]=n,Ld(d,144343,l)|0,l=a[B>>2]|0,n=144341):l=p,l&2&&(a[k>>2]=n,Ld(d,144285,k)|0)),B=a[B>>2]|0,a[m>>2]=B,a[m+4>>2]=B,Ld(d,144357,m)|0,m=a[y>>2]|0):m=B;if(m&8){Sd(144373,11,1,d)|0;m=
q+16|0;switch(N[m>>1]|0){case 0:Sd(144385,6,1,d)|0;break;case 1:Sd(144392,21,1,d)|0;break;case 2:Sd(144414,19,1,d)|0}m=N[m>>1]|0;a[h>>2]=m;a[h+4>>2]=m;Ld(d,144434,h)|0;h=a[y>>2]|0}else h=m;h&4?(a[g>>2]=a[q+24>>2],Ld(d,144448,g)|0,g=a[y>>2]|0):g=h;g&16&&(a[f>>2]=a[q+20>>2],Ld(d,144470,f)|0);if(f=a[q+40>>2]|0)td[f&127](b,d,c);u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g;e=u;u=u+16|0;f=e;(g=a[b+576>>2]|0)||Z(154187,144647,2213,146503);a[b+48>>2]&4&&(a[f>>2]=a[g+916>>2],Ld(d,146516,f)|0);if(f=a[g+900>>
2]|0)td[f&127](b,d,c);u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g;td[a[(a[b+576>>2]|0)+908>>2]&127](b,d,c);e=a[d>>2]|0;f=N[b+192>>1]|0;g=f<<3;g=E(e>>>0<(0-g|0)>>>0?(((e+-1+g|0)>>>0)/(g>>>0)|0)<<3:0,f)|0;a[d>>2]=g;g=a[c>>2]|0;d=N[b+194>>1]|0;b=d<<3;b=g>>>0>=(0-b|0)>>>0?E(0,d)|0:E((((g+-1+b|0)>>>0)/(b>>>0)|0)<<3,d)|0;a[c>>2]=b},function(a,d,c){d|=0;d=1>(d|0)?1:d;d=100<(d|0)?100:d;Yg(a|0,50>(d|0)?5E3/(d|0)|0:200-(d<<1)|0,c|0)},function(b,d,c){b|=0;d|=0;c|=0;var e,f;a[b+4>>2]=0;90!=(d|0)&&(e=a[b>>2]|
0,a[e+20>>2]=13,a[e+24>>2]=90,a[e+28>>2]=d,R[a[e>>2]&127](b));440!=(c|0)&&(e=a[b>>2]|0,a[e+20>>2]=22,a[e+24>>2]=440,a[e+28>>2]=c,R[a[e>>2]&127](b));f=b;e=a[b>>2]|0;c=b+12|0;d=a[c>>2]|0;Va(b|0,0,440)|0;a[b>>2]=e;a[c>>2]=d;a[b+16>>2]=0;Wg(f);a[b+8>>2]=0;a[b+24>>2]=0;a[b+84>>2]=0;a[b+88>>2]=0;a[b+104>>2]=100;a[b+92>>2]=0;a[b+108>>2]=100;a[b+96>>2]=0;a[b+112>>2]=100;a[b+100>>2]=0;a[b+116>>2]=100;f=b+120|0;a[f>>2]=0;a[f+4>>2]=0;a[f+8>>2]=0;a[f+12>>2]=0;a[f+16>>2]=0;a[f+20>>2]=0;a[f+24>>2]=0;a[f+28>>2]=
0;a[b+380>>2]=8;a[b+384>>2]=119984;a[b+388>>2]=63;a[b+428>>2]=0;Hb[b+48>>3]=1;a[b+20>>2]=100},function(b,d,c){b|=0;d|=0;c|=0;var e,f;a[b+4>>2]=0;90!=(d|0)&&(e=a[b>>2]|0,a[e+20>>2]=13,a[e+24>>2]=90,a[e+28>>2]=d,R[a[e>>2]&127](b));488!=(c|0)&&(e=a[b>>2]|0,a[e+20>>2]=22,a[e+24>>2]=488,a[e+28>>2]=c,R[a[e>>2]&127](b));f=b;e=a[b>>2]|0;c=b+12|0;d=a[c>>2]|0;Va(b|0,0,488)|0;a[b>>2]=e;a[c>>2]=d;a[b+16>>2]=1;Wg(f);a[b+8>>2]=0;a[b+24>>2]=0;a[b+312>>2]=0;f=b+164|0;d=f+48|0;do a[f>>2]=0,f=f+4|0;while((f|0)<(d|
0));d=b|0;c=Aa[a[a[d+4>>2]>>2]&63](d,0,172)|0;e=d+464|0;a[e>>2]=c;a[c>>2]=42;a[c+4>>2]=47;a[c+8>>2]=48;a[c+28>>2]=49;a[c+96>>2]=0;a[c+100>>2]=0;a[c+36>>2]=49;a[c+104>>2]=0;a[c+40>>2]=49;a[c+108>>2]=0;a[c+44>>2]=49;a[c+112>>2]=0;a[c+48>>2]=49;a[c+116>>2]=0;a[c+52>>2]=49;a[c+120>>2]=0;a[c+56>>2]=49;a[c+124>>2]=0;a[c+60>>2]=49;a[c+128>>2]=0;a[c+64>>2]=49;a[c+132>>2]=0;a[c+68>>2]=49;a[c+136>>2]=0;a[c+72>>2]=49;a[c+140>>2]=0;a[c+76>>2]=49;a[c+144>>2]=0;a[c+80>>2]=49;a[c+148>>2]=0;a[c+84>>2]=49;a[c+152>>
2]=0;a[c+156>>2]=0;a[c+92>>2]=49;a[c+160>>2]=0;a[c+32>>2]=50;a[c+88>>2]=50;c=a[e>>2]|0;a[d+216>>2]=0;a[d+144>>2]=0;a[d+440>>2]=0;a[c+12>>2]=0;a[c+16>>2]=0;a[c+24>>2]=0;a[c+164>>2]=0;d=b|0;c=Aa[a[a[d+4>>2]>>2]&63](d,0,28)|0;a[d+460>>2]=c;a[c>>2]=46;a[c+4>>2]=39;a[c+8>>2]=40;a[c+12>>2]=41;a[c+16>>2]=0;a[c+20>>2]=0;a[c+24>>2]=1;a[b+20>>2]=200},function(a,d,c){},function(b,d,c){c|=0;var e;if(!(0>=(c|0)))for(e=c,c=a[(b|0)+12>>2]|0,b=d|0;;)if(tf(a[c>>2]|0,b),1<(e|0))e=e+-1|0,c=c+4|0,b=b+12|0;else break},
function(b,d,c){c|=0;var e,f,g,h,m,k=0,l=0,n,p,q,y=0,B=0;if(!(0>=(c|0)))for(e=c,c=a[(b|0)+12>>2]|0,b=d|0;;){d=e;e=e+-1|0;f=a[c>>2]|0;g=b+2|0;w[b>>1]=(f>>>12&4093)+13314;h=f&16383;if(16288<h>>>0)h=.210526316,f=.473684211;else{f=0;m=163;a:for(;;){for(;;){if(1>=(m-f|0)){k=f;l=8;break a}n=f+m>>1;p=w[(n<<3)+107758>>1]|0;q=h-(p<<16>>16)|0;if(0<(q|0))f=n;else{m=n;break}}if(!(0>(q|0))){y=p;B=m;break}}8==(l|0)&&(l=0,y=w[(k<<3)+107758>>1]|0,B=k);h=+W[107752+(B<<3)>>2]+.0035000001080334187*(+(h-(y<<16>>16)|
0)+.5);f=.0035000001080334187*(+(B|0)+.5)+.016939999535679817}w[g>>1]=~~(32768*h);w[b+4>>1]=~~(32768*f);if(1>=(d|0))break;else c=c+4|0,b=b+6|0}},function(b,d,c){c|=0;var e,f,g,h,m,k,l,n,p;e=u;u=u+16|0;if(!(0>=(c|0)))for(f=e+4|0,g=e+8|0,h=c,c=a[(b|0)+12>>2]|0,b=d|0;!(d=h,h=h+-1|0,tf(a[c>>2]|0,e),c=c+4|0,m=+W[e>>2],k=+W[f>>2],l=+W[g>>2],n=2.69*m-1.276*k-.414*l,p=1.978*k-1.022*m+.044*l,m=.061*m-.224*k+1.163*l,n=0>=n?0:1<=n?-1:~~(256*+Tg(+n))&255,t[b>>0]=n,p=0>=p?0:1<=p?-1:~~(256*+Tg(+p))&255,t[b+1>>
0]=p,p=0>=m?0:1<=m?-1:~~(256*+Tg(+m))&255,t[b+2>>0]=p,1>=(d|0));)b=b+3|0;u=e},function(b,d,c){c|=0;var e,f,g,h,m=0,k=0;if(!(0>=(c|0)))for(e=c,c=a[(b|0)+12>>2]|0,b=d|0;!(d=e,e=e+-1|0,f=a[c>>2]|0,c=c+4|0,g=f>>16,h=g&32767,0==(h|0)||(m=+xh(+(.0027076061740622863*(+(h|0)+.5)+-44.3614195558365)),k=0!=(g&32768|0)?-m:m,0>=k)?(W[b+8>>2]=0,W[b+4>>2]=0,W[b>>2]=0):(m=.0024390243902439024*(+((f>>>8&255)>>>0)+.5),f=.0024390243902439024*(+((f&255)>>>0)+.5),g=1/(6*m-16*f+12),h=9*m*g,m=4*f*g,W[b>>2]=h/m*k,W[b+4>>
2]=k,W[b+8>>2]=(1-h-m)/m*k),1>=(d|0));)b=b+12|0},function(b,d,c){c|=0;var e;if(!(0>=(c|0)))for(e=c,c=a[(b|0)+12>>2]|0,b=d|0;;)if(d=a[c>>2]|0,w[b>>1]=d>>>16,w[b+2>>1]=~~(79.9219512195122*(+((d>>>8&255)>>>0)+.5)),w[b+4>>1]=~~(79.9219512195122*(+((d&255)>>>0)+.5)),1<(e|0))e=e+-1|0,c=c+4|0,b=b+6|0;else break},function(b,d,c){c|=0;var e,f,g,h,m=0,k=0;if(!(0>=(c|0)))for(e=c,c=a[(b|0)+12>>2]|0,b=d|0;!(d=e,e=e+-1|0,f=a[c>>2]|0,c=c+4|0,g=f>>16,h=g&32767,0==(h|0)||(m=+xh(+(.0027076061740622863*(+(h|0)+.5)+
-44.3614195558365)),k=0!=(g&32768|0)?-m:m,0>=k)?k=h=g=0:(m=.0024390243902439024*(+((f>>>8&255)>>>0)+.5),g=.0024390243902439024*(+((f&255)>>>0)+.5),h=1/(6*m-16*g+12),f=9*m*h,m=4*g*h,g=f/m*k,h=k,k*=(1-f-m)/m),m=g,f=h,h=2.69*m-1.276*f-.414*k,g=.044*k+(1.978*f-1.022*m),f=1.163*k+(.061*m-.224*f),h=0>=h?0:1<=h?-1:~~(256*+Tg(+h))&255,t[b>>0]=h,g=0>=g?0:1<=g?-1:~~(256*+Tg(+g))&255,t[b+1>>0]=g,f=0>=f?0:1<=f?-1:~~(256*+Tg(+f))&255,t[b+2>>0]=f,1>=(d|0));)b=b+3|0},function(b,d,c){c|=0;var e,f;if(!(0>=(c|0)))for(e=
c,c=a[(b|0)+12>>2]|0,b=d|0;;)if(d=w[c>>1]|0,(f=d&32767)?(f=+xh(+(.0027076061740622863*(+(f|0)+.5)+-44.3614195558365)),d=0!=(d&32768|0)?-f:f):d=0,W[b>>2]=d,1<(e|0))e=e+-1|0,c=c+2|0,b=b+4|0;else break},function(b,d,c){c|=0;var e,f,g,h=0,m=0;if(!(0>=(c|0)))for(e=c,c=d|0,d=a[(b|0)+12>>2]|0;!(b=e,e=e+-1|0,f=w[d>>1]|0,d=d+2|0,g=f&32767,f=0==(g|0)||(h=+xh(+(.0027076061740622863*(+(g|0)+.5)+-44.3614195558365)),m=0!=(f&32768|0)?-h:h,0>=m)?0:1<=m?255:~~(256*+Tg(+m)),t[c>>0]=f,1>=(b|0));)c=c+1|0},function(b,
d,c){b|=0;c|=0;var e,f;if(!(0>=(c|0)))for(e=b+4|0,f=c,c=a[b+12>>2]|0,b=d|0;;){d=b;var g=a[e>>2]|0;d|=0;var g=g|0,h,m,k,l;h=d+4|0;k=m=+W[h>>2];15.742<=k?(k=1023,l=m):2.4283E-4>=k?(k=0,l=m):(k=64*(1.4426950408889634*+Nd(+k)+12),g?(k=k+4.656612875245797E-10*+(Xe()|0)+-.5,h=+W[h>>2]):h=m,m=k,k=~~m,l=h);m=+W[d>>2];h=l;l=m+15*h+3*+W[d+8>>2];d=0==(k|0)|0>=l?mf(.210526316,.473684211,g)|0:mf(4*m/l,9*h/l,g)|0;d=(0>(d|0)?12266:d)|k<<14|0;d|=0;a[c>>2]=d;if(1<(f|0))f=f+-1|0,c=c+4|0,b=b+12|0;else break}},function(b,
d,c){b|=0;c|=0;var e,f,g,h;if(!(0>=(c|0)))for(e=b+4|0,f=c,c=a[b+12>>2]|0,b=d|0;!(d=f,f=f+-1|0,g=w[b>>1]|0,h=g<<16>>16,h=1<=g<<16>>16?7409>=g<<16>>16?a[e>>2]|0?~~(.25*(+(g<<16>>16)+-3314)+4.656612875245797E-10*+(Xe()|0)+-.5):h+-3314>>2:1023:0,g=mf(3.0517578125E-5*(+(w[b+2>>1]|0)+.5),3.0517578125E-5*(+(w[b+4>>1]|0)+.5),a[e>>2]|0)|0,a[c>>2]=(0>(g|0)?12266:g)|h<<14,1>=(d|0));)c=c+4|0,b=b+6|0},function(b,d,c){b|=0;c|=0;var e,f;if(!(0>=(c|0)))for(e=b+4|0,f=c,c=a[b+12>>2]|0,b=d|0;;){var g=b,h=a[e>>2]|0,
g=g|0,h=h|0,m,k,l,n,p,q=0,y=0,B=0,t=0,r=0;m=g+4|0;k=+W[m>>2];1.8371976E19<=k?d=32767:-1.8371976E19>=k?d=65535:5.4136769E-20<k?(l=256*(1.4426950408889634*+Nd(+k)+64),n=h?l+4.656612875245797E-10*+(Xe()|0)+-.5:l,d=~~n):-5.4136769E-20>k?(l=256*(1.4426950408889634*+Nd(+-k)+64),p=h?l+4.656612875245797E-10*+(Xe()|0)+-.5:l,d=~~p|-32768):d=0;p=+W[g>>2];k=+W[m>>2];n=p+15*k+3*+W[g+8>>2];0==(d|0)|0>=n?(q=.210526316,y=.473684211,B=13):(l=4*p/n,p=9*k/n,0>=l?(t=0,r=p):(q=l,y=p,B=13));13==(B|0)&&(p=410*q,B=h?p+4.656612875245797E-10*
+(Xe()|0)+-.5:p,t=~~B,r=y);B=255<t>>>0;0>=r?h=0:(y=410*r,h=h?y+4.656612875245797E-10*+(Xe()|0)+-.5:y,h=~~h);d=(B?65280:t<<8)|d<<16|(255<h>>>0?255:h)|0;d|=0;a[c>>2]=d;if(1<(f|0))f=f+-1|0,c=c+4|0,b=b+12|0;else break}},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m;e=a[b+12>>2]|0;f=b+4|0;b=a[f>>2]|0;g=0<(c|0);if(!b){if(g)for(f=c,c=e;;)if(a[c>>2]=(410*(w[d+2>>1]|0)|0)>>>7&65280|N[d>>1]<<16|(410*(w[d+4>>1]|0)|0)>>>15&255,1<(f|0))f=f+-1|0,c=c+4|0,d=d+6|0;else break}else if(g)for(g=b,b=d;;){d=N[b>>1]<<16;
h=.01251220703125*+(w[b+2>>1]|0);g?(g=m=h+4.656612875245797E-10*+(Xe()|0)+-.5,h=a[f>>2]|0):(g=h,h=0);m=.01251220703125*+(w[b+4>>1]|0);h=h?m+4.656612875245797E-10*+(Xe()|0)+-.5:m;a[e>>2]=~~g<<8&65280|d|~~h&255;if(1>=(c|0))break;c=c+-1|0;g=a[f>>2]|0;e=e+4|0;b=b+6|0}},function(b,d,c){b|=0;c|=0;var e,f,g,h;if(!(0>=(c|0)))for(e=b+4|0,f=c,c=a[b+12>>2]|0,b=d|0;!(d=f,f=f+-1|0,g=+W[b>>2],b=b+4|0,h=a[e>>2]|0,1.8371976E19<=g?h=32767:-1.8371976E19>=g?h=65535:5.4136769E-20<g?(g=256*(1.4426950408889634*+Nd(+g)+
64),h=h?g+4.656612875245797E-10*+(Xe()|0)+-.5:g,h=~~h):-5.4136769E-20>g?(g=256*(1.4426950408889634*+Nd(+-g)+64),h=h?g+4.656612875245797E-10*+(Xe()|0)+-.5:g,h=~~h|-32768):h=0,w[c>>1]=h,1>=(d|0));)c=c+2|0},function(b,d,c){b|=0;var e;c=a[b+576>>2]|0;d=c+492|0;e=(a[d>>2]|0)+1|0;a[d>>2]=e;(e>>>0)%((a[b+164>>2]|0)>>>0)|0||(b=c+496|0,t[b>>0]|0||Z(150963,148429,891,151217),fi(c+632|0),t[b>>0]=0,t[c+489>>0]=0)},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q;e=u;u=u+64|0;f=e+48|0;g=e+40|0;h=e+32|0;
m=e+24|0;k=e+16|0;l=e+8|0;(n=a[b+576>>2]|0)||Z(148530,148429,616,148539);p=b+48|0;q=a[p>>2]|0;q&4&&(a[e>>2]=a[n+208>>2],Ld(d,148553,e)|0,q=a[p>>2]|0);q&8&&(a[l>>2]=a[n+216>>2],Ld(d,148583,l)|0,q=a[p>>2]|0);if(q&16){Sd(148619,14,1,d)|0;q=n+231|0;if(t[q>>0]|0){l=0;do a[k>>2]=a[n+240+((l&255)<<3)>>2],Ld(d,148634,k)|0,l=l+1<<24>>24;while((l&255)<(x[q>>0]|0))}xk(10,d)|0;k=a[p>>2]|0}else k=q;if(k&32){Sd(148639,15,1,d)|0;k=n+232|0;if(t[k>>0]|0){q=0;do a[m>>2]=a[n+264+((q&255)<<3)>>2],Ld(d,148634,m)|0,q=
q+1<<24>>24;while((q&255)<(x[k>>0]|0))}xk(10,d)|0;m=a[p>>2]|0}else m=k;if(m&64){Sd(148655,15,1,d)|0;m=n+233|0;if(t[m>>0]|0){k=0;do a[h>>2]=a[n+288+((k&255)<<3)>>2],Ld(d,148634,h)|0,k=k+1<<24>>24;while((k&255)<(x[m>>0]|0))}xk(10,d)|0;h=a[p>>2]|0}else h=m;h&128?(a[g>>2]=x[n+224>>0],Ld(d,148671,g)|0,g=a[p>>2]|0):g=h;g&256&&(a[f>>2]=N[n+360>>1],Ld(d,148687,f)|0);if(f=a[n+168>>2]|0)td[f&127](b,d,c);u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;e=u;u=u+16|0;f=e;g=a[b+576>>2]|0;if(a[b+48>>2]&4){Sd(153600,
13,1,d)|0;switch(a[g>>2]|0){case 1:Sd(153614,5,1,d)|0;break;case 2:Sd(153620,24,1,d)|0;break;case 3:Sd(153645,25,1,d)|0}h=a[g>>2]|0;a[f>>2]=h;a[f+4>>2]=h;Ld(d,153671,f)|0}if(f=a[g+52>>2]|0)td[f&127](b,d,c);u=e},function(b,d,c){d|=0;c|=0;var e,f,g,h,m,k,l=m=k=0,n=0,p=0;e=a[(a[(b|0)+576>>2]|0)+4>>2]|0;(c|0)%(e|0)|0&&Z(153237,152869,273,153592);if(!((e|0)>=(c|0)))switch(e|0){case 3:if(3>=(c|0))break;b=c;f=x[d+2>>0]|0;g=x[d+1>>0]|0;e=d;h=x[d>>0]|0;do d=e,e=e+3|0,b=b+-3|0,h=(x[e>>0]|0)+h|0,t[e>>0]=h,m=
d+4|0,g=(x[m>>0]|0)+g|0,t[m>>0]=g,m=d+5|0,f=(x[m>>0]|0)+f|0,t[m>>0]=f;while(3<(b|0));break;case 4:if(4>=(c|0))break;b=c;f=x[d+3>>0]|0;g=x[d+2>>0]|0;h=x[d+1>>0]|0;e=d;m=x[d>>0]|0;do d=e,e=e+4|0,b=b+-4|0,m=(x[e>>0]|0)+m|0,t[e>>0]=m,k=d+5|0,h=(x[k>>0]|0)+h|0,t[k>>0]=h,k=d+6|0,g=(x[k>>0]|0)+g|0,t[k>>0]=g,k=d+7|0,f=(x[k>>0]|0)+f|0,t[k>>0]=f;while(4<(b|0));break;default:for(b=e+-4|0,f=4<(e|0),g=c-e|0,c=d;;){switch(e|0){case 0:k=c;break;case 3:m=c;l=17;break;case 2:n=c;l=18;break;case 1:p=c;l=19;break;default:if(f){d=
c;for(h=b;;)if(m=d+e|0,t[m>>0]=(x[d>>0]|0)+(x[m>>0]|0),1<(h|0))d=d+1|0,h=h+-1|0;else break;d=c+b|0}else d=c;h=d+e|0;t[h>>0]=(x[d>>0]|0)+(x[h>>0]|0);m=d+1|0;l=17}17==(l|0)&&(h=m+e|0,t[h>>0]=(x[m>>0]|0)+(x[h>>0]|0),n=m+1|0,l=18);18==(l|0)&&(h=n+e|0,t[h>>0]=(x[n>>0]|0)+(x[h>>0]|0),p=n+1|0,l=19);19==(l|0)&&(l=0,h=p+e|0,t[h>>0]=(x[p>>0]|0)+(x[h>>0]|0),k=p+1|0);g=g-e|0;if(0>=(g|0))break;else c=k}}},Th,Jg,function(a,d,c){a|=0;d|=0;c|=0;Vd(d,(c|0)/2|0);Th(a,d,c)},function(a,d,c){a|=0;d|=0;c|=0;Id(d,(c|0)/
4|0);Jg(a,d,c)},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p=0,q=0,y=0,B=0,H=0,r=0,z;e=a[(a[b+576>>2]|0)+4>>2]|0;f=(N[b+84>>1]|0)>>>3;b=f&65535;g=(c>>>0)/(b>>>0)|0;h=eb(c)|0;(c>>>0)%((E(b,e)|0)>>>0)|0&&Z(152967,152869,386,153442);if(h){a:do if((e|0)<(c|0))for(m=e+-4|0,k=4<(e|0),l=c,n=d;;){switch(e|0){case 4:p=n;q=10;break;case 3:y=n;q=11;break;case 2:B=n;q=12;break;case 1:H=n;q=13;break;case 0:r=n;break;default:if(k){p=n;for(z=m;;)if(q=p+e|0,t[q>>0]=(x[p>>0]|0)+(x[q>>0]|0),1<(z|0))p=p+1|0,
z=z+-1|0;else break;p=n+m|0}else p=n;q=10}10==(q|0)&&(z=p+e|0,t[z>>0]=(x[p>>0]|0)+(x[z>>0]|0),y=p+1|0,q=11);11==(q|0)&&(z=y+e|0,t[z>>0]=(x[y>>0]|0)+(x[z>>0]|0),B=y+1|0,q=12);12==(q|0)&&(z=B+e|0,t[z>>0]=(x[B>>0]|0)+(x[z>>0]|0),H=B+1|0,q=13);13==(q|0)&&(q=0,z=H+e|0,t[z>>0]=(x[H>>0]|0)+(x[z>>0]|0),r=H+1|0);l=l-e|0;if((l|0)<=(e|0))break a;else n=r}while(0);Ab(h,d,c);if(0<(g|0)){c=0==f<<16>>16;f=b+-1|0;r=0;do{if(!c){e=E(r,b)|0;H=0;do q=h+((E(f-H|0,g)|0)+r)|0,t[d+(H+e)>>0]=t[q>>0]|0,H=H+1|0;while((H|0)!=
(b|0))}r=r+1|0}while((r|0)<(g|0))}ja(h)}},function(b,d,c){d|=0;c|=0;var e,f,g,h,m,k,l=m=0,n=0,p=0,q=0,y=0;e=a[(a[(b|0)+576>>2]|0)+4>>2]|0;(c|0)%(e|0)|0&&Z(153237,152869,469,153252);if(!((e|0)>=(c|0)))switch(b=c-e|0,e|0){case 3:c=b;f=x[d+2>>0]|0;g=d;h=x[d+1>>0]|0;for(m=x[d>>0]|0;!(k=g,g=g+3|0,b=m,m=x[g>>0]|0,t[g>>0]=m-b,b=k+4|0,d=h,h=x[b>>0]|0,t[b>>0]=h-d,d=k+5|0,k=f,f=x[d>>0]|0,t[d>>0]=f-k,3>=(c|0));)c=c+-3|0;break;case 4:c=b;f=x[d+3>>0]|0;h=x[d+2>>0]|0;m=d;g=x[d+1>>0]|0;for(k=x[d>>0]|0;!(d=m,m=m+
4|0,b=k,k=x[m>>0]|0,t[m>>0]=k-b,b=d+5|0,e=g,g=x[b>>0]|0,t[b>>0]=g-e,e=d+6|0,b=h,h=x[e>>0]|0,t[e>>0]=h-b,b=d+7|0,d=f,f=x[b>>0]|0,t[b>>0]=f-d,4>=(c|0));)c=c+-4|0;break;default:for(c=e+-4|0,f=4<(e|0),h=4-e|0,g=b,k=d+(b+-1)|0;;){switch(e|0){case 4:m=k;l=14;break;case 3:n=k;l=15;break;case 2:p=k;l=16;break;case 1:q=k;l=17;break;case 0:y=k;break;default:if(f){b=k;for(d=c;;)if(m=b+e|0,t[m>>0]=(x[m>>0]|0)-(x[b>>0]|0),1<(d|0))b=b+-1|0,d=d+-1|0;else break;m=k+h|0}else m=k;l=14}14==(l|0)&&(d=m+e|0,t[d>>0]=(x[d>>
0]|0)-(x[m>>0]|0),n=m+-1|0,l=15);15==(l|0)&&(d=n+e|0,t[d>>0]=(x[d>>0]|0)-(x[n>>0]|0),p=n+-1|0,l=16);16==(l|0)&&(d=p+e|0,t[d>>0]=(x[d>>0]|0)-(x[p>>0]|0),q=p+-1|0,l=17);17==(l|0)&&(l=0,d=q+e|0,t[d>>0]=(x[d>>0]|0)-(x[q>>0]|0),y=q+-1|0);g=g-e|0;if(0>=(g|0))break;else k=y}}},Rh,Sh,function(a,d,c){d|=0;c|=0;Rh(a|0,d,c);Vd(d,(c|0)/2|0)},function(a,d,c){d|=0;c|=0;Sh(a|0,d,c);Id(d,(c|0)/4|0)},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q=0,y=0,B=0,H=0,r=0,z=0;e=a[(a[b+576>>2]|0)+4>>2]|0;f=(N[b+84>>
1]|0)>>>3;b=f&65535;g=(c>>>0)/(b>>>0)|0;h=eb(c)|0;(c>>>0)%((E(b,e)|0)>>>0)|0&&Z(152967,152869,584,152988);if(h){Ab(h,d,c);if(0<(g|0)){m=0==f<<16>>16;f=b+-1|0;k=0;do{if(!m){l=E(k,b)|0;n=0;do p=d+((E(f-n|0,g)|0)+k)|0,t[p>>0]=t[h+(n+l)>>0]|0,n=n+1|0;while((n|0)!=(b|0))}k=k+1|0}while((k|0)<(g|0))}ja(h);if(!((e|0)>=(c|0)))for(h=e+-4|0,g=4<(e|0),k=4-e|0,b=c,f=d+(c+-1-e)|0;;){switch(e|0){case 4:q=f;y=16;break;case 3:B=f;y=17;break;case 2:H=f;y=18;break;case 1:r=f;y=19;break;case 0:z=f;break;default:if(g){c=
f;for(d=h;;)if(m=c+e|0,t[m>>0]=(x[m>>0]|0)-(x[c>>0]|0),1<(d|0))c=c+-1|0,d=d+-1|0;else break;q=f+k|0}else q=f;y=16}16==(y|0)&&(d=q+e|0,t[d>>0]=(x[d>>0]|0)-(x[q>>0]|0),B=q+-1|0,y=17);17==(y|0)&&(d=B+e|0,t[d>>0]=(x[d>>0]|0)-(x[B>>0]|0),H=B+-1|0,y=18);18==(y|0)&&(d=H+e|0,t[d>>0]=(x[d>>0]|0)-(x[H>>0]|0),r=H+-1|0,y=19);19==(y|0)&&(y=0,d=r+e|0,t[d>>0]=(x[d>>0]|0)-(x[r>>0]|0),z=r+-1|0);b=b-e|0;if((b|0)<=(e|0))break;else f=z}}},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;65533<c>>>0&&(e=a[b>>2]|0,a[e+20>>2]=
12,R[a[e>>2]&127](b));e=b+24|0;f=a[e>>2]|0;g=a[f>>2]|0;a[f>>2]=g+1;t[g>>0]=-1;g=f+4|0;h=(a[g>>2]|0)+-1|0;a[g>>2]=h;0==(h|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b));f=a[e>>2]|0;h=a[f>>2]|0;a[f>>2]=h+1;t[h>>0]=d;d=f+4|0;h=(a[d>>2]|0)+-1|0;a[d>>2]=h;0==(h|0)&&0==(da[a[f+12>>2]&63](b)|0)&&(f=a[b>>2]|0,a[f+20>>2]=25,R[a[f>>2]&127](b));f=c+2|0;c=a[e>>2]|0;h=a[c>>2]|0;a[c>>2]=h+1;t[h>>0]=f>>>8;h=c+4|0;d=(a[h>>2]|0)+-1|0;a[h>>2]=d;0==(d|0)&&0==(da[a[c+12>>2]&63](b)|0)&&
(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b));c=a[e>>2]|0;e=a[c>>2]|0;a[c>>2]=e+1;t[e>>0]=f;f=c+4|0;e=(a[f>>2]|0)+-1|0;a[f>>2]=e;e||da[a[c+12>>2]&63](b)|0||(c=a[b>>2]|0,a[c+20>>2]=25,R[a[c>>2]&127](b))},function(b,d,c){b|=0;d|=0;c|=0;Va(b|0,0,256)|0;a[b>>2]=((x[(a[d>>2]|0)+c>>0]|0)<<6)+-8192},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h;Va(b|0,0,256)|0;e=a[d>>2]|0;f=x[e+c>>0]|0;g=c+1|0;h=x[e+g>>0]|0;e=h+f|0;f=f-h|0;h=a[d+4>>2]|0;d=x[h+c>>0]|0;c=x[h+g>>0]|0;g=c+d|0;h=d-c|0;a[b>>2]=(g+e<<4)+-8192;a[b+
32>>2]=e-g<<4;a[b+4>>2]=h+f<<4;a[b+36>>2]=f-h<<4},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y;Va(b|0,0,256)|0;e=c+2|0;f=c+1|0;g=a[d>>2]|0;h=x[g+c>>0]|0;m=x[g+e>>0]|0;k=m+h|0;l=x[g+f>>0]|0;g=(k+l<<4)+-6144|0;a[b>>2]=g;n=(5793*((E(l,-2)|0)+k|0)|0)+256>>9;a[b+8>>2]=n;n=(10033*(h-m|0)|0)+256>>9;m=b+4|0;a[m>>2]=n;h=b+32|0;k=a[d+4>>2]|0;l=x[k+c>>0]|0;p=x[k+e>>0]|0;q=p+l|0;y=x[k+f>>0]|0;k=(q+y<<4)+-6144|0;a[h>>2]=k;y=(5793*((E(y,-2)|0)+q|0)|0)+256>>9;a[b+40>>2]=y;q=(10033*(l-p|0)|0)+256>>9;
a[b+36>>2]=q;p=a[d+8>>2]|0;d=x[p+c>>0]|0;c=x[p+e>>0]|0;e=c+d|0;l=x[p+f>>0]|0;f=(e+l<<4)+-6144|0;p=(5793*((E(l,-2)|0)+e|0)|0)+256>>9;e=(10033*(d-c|0)|0)+256>>9;c=f+g|0;a[b>>2]=(14564*(c+k|0)|0)+16384>>15;d=(10298*((E(k,-2)|0)+c|0)|0)+16384>>15;a[b+64>>2]=d;a[h>>2]=(17837*(g-f|0)|0)+16384>>15;f=e+n|0;a[m>>2]=(14564*(f+q|0)|0)+16384>>15;m=(10298*((E(q,-2)|0)+f|0)|0)+16384>>15;a[b+68>>2]=m;a[b+36>>2]=(17837*(n-e|0)|0)+16384>>15;e=b+8|0;n=a[e>>2]|0;m=p+n|0;a[e>>2]=(14564*(m+y|0)|0)+16384>>15;e=(10298*
((E(y,-2)|0)+m|0)|0)+16384>>15;a[b+72>>2]=e;a[b+40>>2]=(17837*(n-p|0)|0)+16384>>15},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B;Va(b|0,0,256)|0;e=c+3|0;f=c+1|0;g=c+2|0;h=a[d>>2]|0;m=x[h+c>>0]|0;k=x[h+e>>0]|0;l=k+m|0;n=x[h+f>>0]|0;p=x[h+g>>0]|0;h=p+n|0;q=m-k|0;k=n-p|0;a[b>>2]=(h+l<<4)+-8192;a[b+8>>2]=l-h<<4;h=(4433*(k+q|0)|0)+256|0;l=b+4|0;a[l>>2]=h+(6270*q|0)>>9;q=h+(E(k,-15137)|0)>>9;a[b+12>>2]=q;q=b+32|0;k=a[d+4>>2]|0;h=x[k+c>>0]|0;p=x[k+e>>0]|0;n=p+h|0;m=x[k+f>>0]|0;y=x[k+g>>0]|
0;k=y+m|0;B=h-p|0;p=m-y|0;a[q>>2]=(k+n<<4)+-8192;a[b+40>>2]=n-k<<4;k=(4433*(p+B|0)|0)+256|0;a[b+36>>2]=k+(6270*B|0)>>9;B=k+(E(p,-15137)|0)>>9;a[b+44>>2]=B;B=a[d+8>>2]|0;p=x[B+c>>0]|0;k=x[B+e>>0]|0;n=k+p|0;y=x[B+f>>0]|0;m=x[B+g>>0]|0;B=m+y|0;h=p-k|0;k=y-m|0;m=(B+n<<4)+-8192|0;a[b+64>>2]=m;a[b+72>>2]=n-B<<4;B=(4433*(k+h|0)|0)+256|0;n=B+(6270*h|0)>>9;a[b+68>>2]=n;h=B+(E(k,-15137)|0)>>9;a[b+76>>2]=h;h=a[d+12>>2]|0;d=x[h+c>>0]|0;c=x[h+e>>0]|0;e=c+d|0;k=x[h+f>>0]|0;f=x[h+g>>0]|0;g=f+k|0;h=d-c|0;c=k-f|0;
f=(g+e<<4)+-8192|0;k=e-g<<4;g=(4433*(c+h|0)|0)+256|0;e=g+(6270*h|0)>>9;h=g+(E(c,-15137)|0)>>9;a[b+108>>2]=h;c=a[b>>2]|0;g=c+2+f|0;d=a[q>>2]|0;B=m+d|0;y=c-f|0;f=d-m|0;a[b>>2]=B+g>>2;a[b+64>>2]=g-B>>2;B=(4433*(f+y|0)|0)+16384|0;a[q>>2]=B+(6270*y|0)>>15;y=B+(E(f,-15137)|0)>>15;a[b+96>>2]=y;y=a[l>>2]|0;f=y+2+e|0;B=b+36|0;q=a[B>>2]|0;g=n+q|0;m=y-e|0;e=q-n|0;a[l>>2]=g+f>>2;a[b+68>>2]=f-g>>2;g=(4433*(e+m|0)|0)+16384|0;a[B>>2]=g+(6270*m|0)>>15;m=g+(E(e,-15137)|0)>>15;a[b+100>>2]=m;m=b+8|0;e=a[m>>2]|0;g=e+
2+k|0;B=b+40|0;f=a[B>>2]|0;l=b+72|0;n=a[l>>2]|0;q=n+f|0;y=e-k|0;k=f-n|0;a[m>>2]=q+g>>2;a[l>>2]=g-q>>2;q=(4433*(k+y|0)|0)+16384|0;a[B>>2]=q+(6270*y|0)>>15;y=q+(E(k,-15137)|0)>>15;a[b+104>>2]=y;y=b+12|0;k=a[y>>2]|0;q=k+2+h|0;B=b+44|0;g=a[B>>2]|0;l=b+76|0;m=a[l>>2]|0;n=m+g|0;f=k-h|0;h=g-m|0;a[y>>2]=n+q>>2;a[l>>2]=q-n>>2;n=(4433*(h+f|0)|0)+16384|0;a[B>>2]=n+(6270*f|0)>>15;f=n+(E(h,-15137)|0)>>15;a[b+108>>2]=f},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r;Va(b|0,0,256)|0;e=c+4|0;f=c+
1|0;g=c+3|0;h=c+2|0;m=0;for(k=b;;)if(l=a[d+(m<<2)>>2]|0,n=x[l+c>>0]|0,p=x[l+e>>0]|0,q=p+n|0,y=x[l+f>>0]|0,B=x[l+g>>0]|0,t=B+y|0,r=x[l+h>>0]|0,l=t+q|0,n=n-p|0,p=y-B|0,a[k>>2]=(l+r<<3)+-5120,B=2896*(l-(r<<2)|0)|0,r=(6476*(q-t|0)|0)+512|0,a[k+8>>2]=r+B>>10,a[k+16>>2]=r-B>>10,B=6810*(p+n|0)|0,a[k+4>>2]=(4209*n|0)+512+B>>10,n=(E(p,-17828)|0)+512+B>>10,a[k+12>>2]=n,m=m+1|0,5==(m|0)){l=0;q=b;break}else k=k+32|0;for(;k=a[q>>2]|0,b=q+128|0,m=a[b>>2]|0,h=m+k|0,g=q+32|0,f=a[g>>2]|0,e=q+96|0,c=a[e>>2]|0,d=c+
f|0,n=q+64|0,B=a[n>>2]|0,p=d+h|0,r=k-m|0,m=f-c|0,a[q>>2]=(10486*(p+B|0)|0)+16384>>15,c=3707*(p-(B<<2)|0)|0,B=(8290*(h-d|0)|0)+16384|0,a[n>>2]=B+c>>15,a[b>>2]=B-c>>15,c=8716*(m+r|0)|0,a[g>>2]=(5387*r|0)+16384+c>>15,r=(E(m,-22820)|0)+16384+c>>15,a[e>>2]=r,l=l+1|0,5!=(l|0);)q=q+4|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,u,C;Va(b|0,0,256)|0;e=c+5|0;f=c+1|0;g=c+4|0;h=c+2|0;m=c+3|0;k=0;for(l=b;;)if(n=a[d+(k<<2)>>2]|0,p=x[n+c>>0]|0,q=x[n+e>>0]|0,y=q+p|0,B=x[n+f>>0]|0,t=x[n+g>>
0]|0,r=t+B|0,z=x[n+h>>0]|0,u=x[n+m>>0]|0,n=u+z|0,C=n+y|0,p=p-q|0,q=B-t|0,t=z-u|0,a[l>>2]=(C+r<<2)+-3072,a[l+8>>2]=(10033*(y-n|0)|0)+1024>>11,n=(5793*((E(r,-2)|0)+C|0)|0)+1024>>11,a[l+16>>2]=n,n=(2998*(t+p|0)|0)+1024>>11,a[l+4>>2]=n+(q+p<<2),a[l+12>>2]=p-q-t<<2,a[l+20>>2]=n+(t-q<<2),k=k+1|0,6==(k|0)){y=0;B=b;break}else l=l+32|0;for(;l=a[B>>2]|0,b=B+160|0,k=a[b>>2]|0,m=k+l|0,h=B+32|0,g=a[h>>2]|0,f=B+128|0,e=a[f>>2]|0,c=e+g|0,d=B+64|0,q=a[d>>2]|0,t=B+96|0,n=a[t>>2]|0,p=n+q|0,C=p+m|0,r=l-k|0,k=g-e|0,
e=q-n|0,a[B>>2]=(14564*(C+c|0)|0)+16384>>15,a[d>>2]=(17837*(m-p|0)|0)+16384>>15,p=(10298*((E(c,-2)|0)+C|0)|0)+16384>>15,a[f>>2]=p,p=5331*(e+r|0)|0,a[h>>2]=(14564*(k+r|0)|0)+16384+p>>15,a[t>>2]=(14564*(r-k-e|0)|0)+16384>>15,a[b>>2]=(14564*(e-k|0)|0)+16384+p>>15,y=y+1|0,6!=(y|0);)B=B+4|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,u,C,w,v;Va(b|0,0,256)|0;e=c+6|0;f=c+1|0;g=c+5|0;h=c+2|0;m=c+4|0;k=c+3|0;l=0;for(n=b;;)if(p=a[d+(l<<2)>>2]|0,q=x[p+c>>0]|0,y=x[p+e>>0]|0,B=y+q|0,t=x[p+
f>>0]|0,r=x[p+g>>0]|0,z=r+t|0,u=x[p+h>>0]|0,C=x[p+m>>0]|0,w=C+u|0,v=x[p+k>>0]|0,p=q-y|0,y=t-r|0,r=u-C|0,C=w+B|0,a[n>>2]=(v+z+C<<2)+-3584,u=2896*((E(v,-4)|0)+C|0)|0,C=7542*(B-w|0)|0,t=2578*(z-w|0)|0,a[n+8>>2]=C+1024+t+u>>11,w=(7223*(B-z|0)|0)+1024|0,B=w+t+(E(z-(v<<1)|0,-5793)|0)>>11,a[n+16>>2]=B,a[n+24>>2]=w-C+u>>11,u=7663*(y+p|0)|0,C=1395*(p-y|0)|0,w=E(r+y|0,-11295)|0,y=5027*(r+p|0)|0,a[n+4>>2]=1024-C+u+y>>11,a[n+12>>2]=C+1024+u+w>>11,a[n+20>>2]=(15326*r|0)+1024+y+w>>11,l=l+1|0,7==(l|0)){q=0;B=b;
break}else n=n+32|0;for(;n=a[B>>2]|0,b=B+192|0,l=a[b>>2]|0,k=l+n|0,m=B+32|0,h=a[m>>2]|0,g=B+160|0,f=a[g>>2]|0,e=f+h|0,c=B+64|0,d=a[c>>2]|0,w=B+128|0,y=a[w>>2]|0,r=y+d|0,u=B+96|0,C=a[u>>2]|0,p=n-l|0,l=h-f|0,f=d-y|0,y=r+k|0,a[B>>2]=(10700*(C+e+y|0)|0)+16384>>15,d=3783*((E(C,-4)|0)+y|0)|0,y=9850*(k-r|0)|0,h=3367*(e-r|0)|0,a[c>>2]=y+16384+h+d>>15,c=(9434*(k-e|0)|0)+16384|0,k=c+h+(E(e-(C<<1)|0,-7566)|0)>>15,a[w>>2]=k,a[b>>2]=c-y+d>>15,d=10009*(l+p|0)|0,y=1822*(p-l|0)|0,c=E(f+l|0,-14752)|0,l=6565*(f+p|
0)|0,a[m>>2]=16384-y+d+l>>15,a[u>>2]=y+16384+d+c>>15,a[g>>2]=(20017*f|0)+16384+l+c>>15,q=q+1|0,7!=(q|0);)B=B+4|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D;e=u;u=u+32|0;f=e;g=c+8|0;h=c+1|0;m=c+7|0;k=c+2|0;l=c+6|0;n=c+3|0;p=c+5|0;q=c+4|0;y=0;B=b;a:for(;;){t=a[d+(y<<2)>>2]|0;r=x[t+c>>0]|0;z=x[t+g>>0]|0;w=z+r|0;C=x[t+h>>0]|0;v=x[t+m>>0]|0;V=v+C|0;A=x[t+k>>0]|0;J=x[t+l>>0]|0;I=J+A|0;G=x[t+n>>0]|0;L=x[t+p>>0]|0;K=L+G|0;D=x[t+q>>0]|0;t=r-z|0;z=A-J|0;J=G-L|0;
L=I+w+K|0;G=D+V|0;a[B>>2]=(L+G<<1)+-2304;A=(5793*((E(G,-2)|0)+L|0)|0)+2048>>12;a[B+24>>2]=A;A=5793*((E(D,-2)|0)+V|0)|0;V=(10887*(w-I|0)|0)+2048|0;a[B+8>>2]=V+(8875*(I-K|0)|0)+A>>12;a[B+16>>2]=V+(2012*(K-w|0)|0)-A>>12;a[B+12>>2]=(10033*(t-z-J|0)|0)+2048>>12;A=10033*(C-v|0)|0;v=7447*(z+t|0)|0;C=3962*(J+t|0)|0;a[B+4>>2]=A+2048+v+C>>12;t=11409*(z-J|0)|0;J=2048-A|0;a[B+20>>2]=J+v-t>>12;a[B+28>>2]=J+C+t>>12;switch(y|0){case 7:y=8;B=f;continue a;case 8:r=7;V=b;I=f;break a}y=y+1|0;B=B+32|0}for(;;)if(B=a[V>>
2]|0,y=a[I>>2]|0,f=y+B|0,b=V+32|0,q=a[b>>2]|0,p=V+224|0,n=a[p>>2]|0,l=n+q|0,k=V+64|0,m=a[k>>2]|0,h=V+192|0,g=a[h>>2]|0,c=g+m|0,d=V+96|0,t=a[d>>2]|0,C=V+160|0,J=a[C>>2]|0,v=J+t|0,A=V+128|0,z=a[A>>2]|0,w=B-y|0,y=m-g|0,g=t-J|0,J=c+f+v|0,t=z+l|0,a[V>>2]=(12945*(J+t|0)|0)+16384>>15,m=(9154*((E(t,-2)|0)+J|0)|0)+16384>>15,a[h>>2]=m,m=9154*((E(z,-2)|0)+l|0)|0,l=(17203*(f-c|0)|0)+16384|0,a[k>>2]=l+(14024*(c-v|0)|0)+m>>15,a[A>>2]=l+(3179*(v-f|0)|0)-m>>15,a[d>>2]=(15855*(w-y-g|0)|0)+16384>>15,d=15855*(q-n|0)|
0,n=11768*(y+w|0)|0,q=6262*(g+w|0)|0,a[b>>2]=d+16384+n+q>>15,b=18029*(y-g|0)|0,g=16384-d|0,a[C>>2]=g+n-b>>15,a[p>>2]=g+q+b>>15,0<(r|0))r=r+-1|0,V=V+4|0,I=I+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T;e=u;u=u+64|0;f=e;g=c+9|0;h=c+1|0;m=c+8|0;k=c+2|0;l=c+7|0;n=c+3|0;p=c+6|0;q=c+4|0;y=c+5|0;B=0;t=b;a:for(;;){r=a[d+(B<<2)>>2]|0;z=x[r+c>>0]|0;w=x[r+g>>0]|0;C=w+z|0;v=x[r+h>>0]|0;V=x[r+m>>0]|0;A=V+v|0;J=x[r+k>>0]|0;I=x[r+l>>0]|0;G=I+
J|0;L=x[r+n>>0]|0;K=x[r+p>>0]|0;D=K+L|0;F=x[r+q>>0]|0;O=x[r+y>>0]|0;r=O+F|0;M=r+C|0;T=C-r|0;r=D+A|0;C=A-D|0;D=z-w|0;w=v-V|0;V=J-I|0;I=L-K|0;K=F-O|0;a[t>>2]=(r+G+M<<1)+-2560;O=G<<1;G=(E(r-O|0,-3580)|0)+2048+(9373*(M-O|0)|0)>>12;a[t+16>>2]=G;G=6810*(T+C|0)|0;a[t+8>>2]=(4209*T|0)+2048+G>>12;T=(E(C,-17828)|0)+2048+G>>12;a[t+24>>2]=T;T=K+D|0;G=w-I|0;a[t+20>>2]=T-(G+V)<<1;C=V<<13;a[t+4>>2]=(11443*D|0)+2048+(10323*w|0)+C+(5260*I|0)+(1812*K|0)>>12;V=(G<<12)-C+(2531*(T+G|0)|0)|0;G=(7791*(D-K|0)|0)+(E(I+w|
0,-4815)|0)+2048|0;a[t+12>>2]=G+V>>12;a[t+28>>2]=G-V>>12;switch(B|0){case 7:B=8;t=f;continue a;case 9:r=7;z=b;v=f;break a}B=B+1|0;t=t+32|0}for(;;)if(t=a[z>>2]|0,B=a[v+32>>2]|0,f=B+t|0,b=z+32|0,y=a[b>>2]|0,q=a[v>>2]|0,p=q+y|0,n=z+64|0,l=a[n>>2]|0,k=z+224|0,m=a[k>>2]|0,h=m+l|0,g=z+96|0,c=a[g>>2]|0,d=z+192|0,V=a[d>>2]|0,G=V+c|0,w=z+128|0,I=a[w>>2]|0,K=z+160|0,D=a[K>>2]|0,T=D+I|0,C=T+f|0,O=f-T|0,T=G+p|0,f=p-G|0,G=t-B|0,B=y-q|0,q=l-m|0,m=c-V|0,V=I-D|0,a[z>>2]=(10486*(T+h+C|0)|0)+16384>>15,D=h<<1,h=(E(T-
D|0,-4582)|0)+16384+(11997*(C-D|0)|0)>>15,a[w>>2]=h,h=8716*(O+f|0)|0,a[n>>2]=(5387*O|0)+16384+h>>15,O=(E(f,-22820)|0)+16384+h>>15,a[d>>2]=O,O=V+G|0,d=B-m|0,a[K>>2]=(10486*(O-(d+q)|0)|0)+16384>>15,K=10486*q|0,a[b>>2]=(14647*G|0)+16384+(13213*B|0)+K+(6732*m|0)+(2320*V|0)>>15,b=(5243*d|0)-K+(3240*(O+d|0)|0)|0,d=(9973*(G-V|0)|0)+(E(m+B|0,-6163)|0)+16384|0,a[g>>2]=d+b>>15,a[k>>2]=d-b>>15,0<(r|0))r=r+-1|0,z=z+4|0,v=v+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,
C,v,V,A,J,I,G,L,K,D,F,O,M,T,X;e=u;u=u+96|0;f=e;g=c+10|0;h=c+1|0;m=c+9|0;k=c+2|0;l=c+8|0;n=c+3|0;p=c+7|0;q=c+4|0;y=c+6|0;B=c+5|0;t=0;r=b;a:for(;;){z=a[d+(t<<2)>>2]|0;w=x[z+c>>0]|0;C=x[z+g>>0]|0;v=C+w|0;V=x[z+h>>0]|0;A=x[z+m>>0]|0;J=A+V|0;I=x[z+k>>0]|0;G=x[z+l>>0]|0;L=G+I|0;K=x[z+n>>0]|0;D=x[z+p>>0]|0;F=D+K|0;O=x[z+q>>0]|0;M=x[z+y>>0]|0;T=M+O|0;X=x[z+B>>0]|0;z=w-C|0;C=V-A|0;A=I-G|0;G=K-D|0;D=O-M|0;a[r>>2]=(J+v+L+F+T+X<<1)+-2816;M=X<<1;X=v-M|0;v=J-M|0;J=L-M|0;L=F-M|0;F=T-M|0;M=(11116*(X+L|0)|0)+(1649*
(J+F|0)|0)|0;T=7587*(v-L|0)|0;O=9746*(X-v|0)|0;K=(E(L,-8342)|0)+2048+(E(F,-11395)|0)+T+M>>12;a[r+8>>2]=K;K=(511*v|0)+2048+(E(J,-11116)|0)+(4813*F|0)+O+T>>12;a[r+16>>2]=K;K=(E(X,-13275)|0)+2048+(E(J,-6461)|0)+O+M>>12;a[r+24>>2]=K;K=10538*(C+z|0)|0;M=8756*(A+z|0)|0;O=6263*(G+z|0)|0;J=E(A+C|0,-6263)|0;X=E(G+C|0,-11467)|0;T=E(D,-8756)|0;F=3264*(G+A|0)|0;v=E(A,-16294)|0;A=E(D,-10538)|0;L=(E(z,-14090)|0)+2048+K+M+O+(3264*D|0)>>12;a[r+4>>2]=L;a[r+12>>2]=(10456*C|0)+2048+K+J+X+T>>12;a[r+20>>2]=v+2048+J+M+
F+(11467*D|0)>>12;a[r+28>>2]=(10695*G|0)+2048+F+X+O+A>>12;switch(t|0){case 7:t=8;r=f;continue a;case 10:z=7;w=b;C=f;break a}t=t+1|0;r=r+32|0}for(;;)if(r=a[w>>2]|0,t=a[C+64>>2]|0,f=t+r|0,b=w+32|0,B=a[b>>2]|0,y=a[C+32>>2]|0,q=y+B|0,p=w+64|0,n=a[p>>2]|0,l=a[C>>2]|0,k=l+n|0,m=w+96|0,h=a[m>>2]|0,g=w+224|0,c=a[g>>2]|0,d=c+h|0,A=w+128|0,O=a[A>>2]|0,X=w+192|0,F=a[X>>2]|0,G=F+O|0,D=w+160|0,M=a[D>>2]|0,J=r-t|0,t=B-y|0,y=n-l|0,l=h-c|0,c=O-F|0,a[w>>2]=(8666*(q+f+k+d+G+M|0)|0)+16384>>15,F=M<<1,M=f-F|0,f=q-F|0,
q=k-F|0,k=d-F|0,d=G-F|0,F=(11759*(M+k|0)|0)+(1744*(q+d|0)|0)|0,G=8026*(f-k|0)|0,O=10310*(M-f|0)|0,h=(E(k,-8825)|0)+16384+(E(d,-12054)|0)+G+F>>15,a[p>>2]=h,h=(540*f|0)+16384+(E(q,-11759)|0)+(5091*d|0)+O+G>>15,a[A>>2]=h,h=(E(M,-14043)|0)+16384+(E(q,-6835)|0)+O+F>>15,a[X>>2]=h,h=11148*(t+J|0)|0,X=9262*(y+J|0)|0,F=6626*(l+J|0)|0,O=E(y+t|0,-6626)|0,q=E(l+t|0,-12131)|0,M=E(c,-9262)|0,A=3453*(l+y|0)|0,G=E(y,-17237)|0,y=E(c,-11148)|0,d=(E(J,-14905)|0)+16384+h+X+F+(3453*c|0)>>15,a[b>>2]=d,a[m>>2]=(11061*t|
0)+16384+h+O+q+M>>15,a[D>>2]=G+16384+O+X+A+(12131*c|0)>>15,a[g>>2]=(11314*l|0)+16384+A+q+F+y>>15,0<(z|0))z=z+-1|0,w=w+4|0,C=C+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N,R,S;e=u;u=u+128|0;f=e;g=c+11|0;h=c+1|0;m=c+10|0;k=c+2|0;l=c+9|0;n=c+3|0;p=c+8|0;q=c+4|0;y=c+7|0;B=c+5|0;t=c+6|0;r=0;z=b;a:for(;;){w=a[d+(r<<2)>>2]|0;C=x[w+c>>0]|0;v=x[w+g>>0]|0;V=v+C|0;A=x[w+h>>0]|0;J=x[w+m>>0]|0;I=J+A|0;G=x[w+k>>0]|0;L=x[w+l>>0]|0;K=L+G|
0;D=x[w+n>>0]|0;F=x[w+p>>0]|0;O=F+D|0;M=x[w+q>>0]|0;T=x[w+y>>0]|0;X=T+M|0;P=x[w+B>>0]|0;N=x[w+t>>0]|0;w=N+P|0;R=w+V|0;S=V-w|0;w=I-X|0;V=O+K|0;K=K-O|0;O=C-v|0;v=A-J|0;J=G-L|0;L=D-F|0;F=M-T|0;T=P-N|0;a[z>>2]=(I|-1536)+V+X+R;a[z+24>>2]=S-(w+K);a[z+16>>2]=(10033*(R-V|0)|0)+4096>>13;a[z+8>>2]=4096-K+w+(11190*(S+K|0)|0)>>13;K=4433*(F+v|0)|0;S=K+(6270*v|0)|0;v=K+(E(F,-15137)|0)|0;F=9191*(J+O|0)|0;K=7053*(L+O|0)|0;w=E(L+J|0,-1512)|0;V=E(J,-19165)|0;R=E(T,-9191)|0;X=E(T+J|0,-4433)|0;J=(E(O,-4758)|0)+4096+
F+K+S+(1512*T|0)>>13;a[z+4>>2]=J;a[z+12>>2]=(10703*(O-L|0)|0)+4096+v+X>>13;a[z+20>>2]=V+4096+F+w-v+(7053*T|0)>>13;a[z+28>>2]=(5946*L|0)+4096+w+K-S+R>>13;switch(r|0){case 7:r=8;z=f;continue a;case 11:C=7;A=b;J=f;break a}r=r+1|0;z=z+32|0}for(;;)if(z=a[A>>2]|0,r=a[J+96>>2]|0,f=r+z|0,b=A+32|0,t=a[b>>2]|0,B=a[J+64>>2]|0,y=B+t|0,q=A+64|0,p=a[q>>2]|0,n=a[J+32>>2]|0,l=n+p|0,k=A+96|0,m=a[k>>2]|0,h=a[J>>2]|0,g=h+m|0,c=A+128|0,d=a[c>>2]|0,R=A+224|0,S=a[R>>2]|0,K=S+d|0,w=A+160|0,L=a[w>>2]|0,T=A+192|0,v=a[T>>
2]|0,F=v+L|0,V=F+f|0,X=f-F|0,F=y-K|0,f=g+l|0,O=l-g|0,g=z-r|0,r=t-B|0,B=p-n|0,n=m-h|0,h=d-S|0,S=L-v|0,a[A>>2]=(7282*(f+y+K+V|0)|0)+8192>>14,a[T>>2]=(7282*(X-(F+O)|0)|0)+8192>>14,a[c>>2]=(8918*(V-f|0)|0)+8192>>14,a[q>>2]=(7282*(F-O|0)|0)+8192+(9947*(X+O|0)|0)>>14,O=3941*(h+r|0)|0,X=O+(5573*r|0)|0,r=O+(E(h,-13455)|0)|0,h=8170*(B+g|0)|0,O=6269*(n+g|0)|0,F=E(n+B|0,-1344)|0,q=E(B,-17036)|0,f=E(S,-8170)|0,V=E(S+B|0,-3941)|0,B=(E(g,-4229)|0)+8192+h+O+X+(1344*S|0)>>14,a[b>>2]=B,a[k>>2]=(9514*(g-n|0)|0)+8192+
r+V>>14,a[w>>2]=q+8192+h+F-r+(6269*S|0)>>14,a[R>>2]=(5285*n|0)+8192+F+O-X+f>>14,0<(C|0))C=C+-1|0,A=A+4|0,J=J+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N,R,S,ba;e=u;u=u+160|0;f=e;g=c+12|0;h=c+1|0;m=c+11|0;k=c+2|0;l=c+10|0;n=c+3|0;p=c+9|0;q=c+4|0;y=c+8|0;B=c+5|0;t=c+7|0;r=c+6|0;z=0;w=b;a:for(;;){C=a[d+(z<<2)>>2]|0;v=x[C+c>>0]|0;V=x[C+g>>0]|0;A=V+v|0;J=x[C+h>>0]|0;I=x[C+m>>0]|0;G=I+J|0;L=x[C+k>>0]|0;K=x[C+l>>0]|0;D=K+L|0;F=
x[C+n>>0]|0;O=x[C+p>>0]|0;M=O+F|0;T=x[C+q>>0]|0;X=x[C+y>>0]|0;P=X+T|0;N=x[C+B>>0]|0;R=x[C+t>>0]|0;S=R+N|0;ba=x[C+r>>0]|0;C=v-V|0;V=J-I|0;I=L-K|0;K=F-O|0;O=T-X|0;X=N-R|0;a[w>>2]=A+-1664+G+D+M+P+S+ba;R=ba<<1;ba=A-R|0;A=G-R|0;G=D-R|0;D=M-R|0;M=P-R|0;P=S-R|0;R=(8672*A|0)+4096+(11249*ba|0)+(4108*G|0)+(E(D,-1396)|0)+(E(M,-6581)|0)+(E(P,-10258)|0)>>13;a[w+8>>2]=R;R=(9465*(ba-G|0)|0)+(E(D-M|0,-3570)|0)+(E(A-P|0,-2592)|0)|0;S=(793*(ba+G|0)|0)+(E(D+M|0,-7678)|0)+(3989*(A+P|0)|0)|0;a[w+16>>2]=S+4096+R>>13;a[w+
24>>2]=4096-S+R>>13;R=10832*(V+C|0)|0;S=9534*(I+C|0)|0;P=(2773*(X+O|0)|0)+(7682*(K+C|0)|0)|0;A=(7682*(O-X|0)|0)+(E(I+V|0,-2773)|0)|0;M=E(K+V|0,-9534)|0;D=E(O,-19183)|0;G=E(K+I|0,-5384)|0;ba=E(I,-12879)|0;I=E(X,-14273)|0;N=(E(C,-16549)|0)+4096+R+S+(2611*O|0)+P>>13;a[w+4>>2]=N;a[w+12>>2]=(6859*V|0)+4096+R+M+D+A>>13;a[w+20>>2]=ba+4096+S+G+(18515*X|0)+A>>13;a[w+28>>2]=(18068*K|0)+4096+G+M+I+P>>13;switch(z|0){case 7:z=8;w=f;continue a;case 12:C=7;v=b;V=f;break a}z=z+1|0;w=w+32|0}for(;;)if(w=a[v>>2]|0,
z=a[V+128>>2]|0,f=z+w|0,b=v+32|0,r=a[b>>2]|0,t=a[V+96>>2]|0,B=t+r|0,y=v+64|0,q=a[y>>2]|0,p=a[V+64>>2]|0,n=p+q|0,l=v+96|0,k=a[l>>2]|0,m=a[V+32>>2]|0,h=m+k|0,g=v+128|0,c=a[g>>2]|0,d=a[V>>2]|0,P=d+c|0,I=v+160|0,M=a[I>>2]|0,G=v+224|0,K=a[G>>2]|0,A=K+M|0,X=v+192|0,S=a[X>>2]|0,ba=w-z|0,z=r-t|0,t=q-p|0,p=k-m|0,m=c-d|0,d=M-K|0,a[v>>2]=(6205*(B+f+n+h+P+A+S|0)|0)+8192>>14,K=S<<1,S=f-K|0,f=B-K|0,B=n-K|0,n=h-K|0,h=P-K|0,P=A-K|0,K=(6568*f|0)+8192+(8520*S|0)+(3112*B|0)+(E(n,-1058)|0)+(E(h,-4985)|0)+(E(P,-7770)|
0)>>14,a[y>>2]=K,K=(7169*(S-B|0)|0)+(E(n-h|0,-2704)|0)+(E(f-P|0,-1963)|0)|0,y=(601*(S+B|0)|0)+(E(n+h|0,-5816)|0)+(3021*(f+P|0)|0)|0,a[g>>2]=y+8192+K>>14,a[X>>2]=8192-y+K>>14,K=8204*(z+ba|0)|0,y=7221*(t+ba|0)|0,X=(2100*(d+m|0)|0)+(5819*(p+ba|0)|0)|0,g=(5819*(m-d|0)|0)+(E(t+z|0,-2100)|0)|0,P=E(p+z|0,-7221)|0,f=E(m,-14529)|0,h=E(p+t|0,-4078)|0,n=E(t,-9754)|0,t=E(d,-10811)|0,B=(E(ba,-12534)|0)+8192+K+y+(1978*m|0)+X>>14,a[b>>2]=B,a[l>>2]=(5195*z|0)+8192+K+P+f+g>>14,a[I>>2]=n+8192+y+h+(14023*d|0)+g>>14,
a[G>>2]=(13685*p|0)+8192+h+P+t+X>>14,0<(C|0))C=C+-1|0,v=v+4|0,V=V+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N,R,S,ba,Y,W,U,ga;e=u;u=u+192|0;f=e;g=c+13|0;h=c+1|0;m=c+12|0;k=c+2|0;l=c+11|0;n=c+3|0;p=c+10|0;q=c+4|0;y=c+9|0;B=c+5|0;t=c+8|0;r=c+6|0;z=c+7|0;w=0;C=b;a:for(;;){v=a[d+(w<<2)>>2]|0;V=x[v+c>>0]|0;A=x[v+g>>0]|0;J=A+V|0;I=x[v+h>>0]|0;G=x[v+m>>0]|0;L=G+I|0;K=x[v+k>>0]|0;D=x[v+l>>0]|0;F=D+K|0;O=x[v+n>>0]|0;M=x[v+p>>0]|0;
T=M+O|0;X=x[v+q>>0]|0;P=x[v+y>>0]|0;N=P+X|0;R=x[v+B>>0]|0;S=x[v+t>>0]|0;ba=S+R|0;Y=x[v+r>>0]|0;W=x[v+z>>0]|0;v=W+Y|0;U=v+J|0;ga=J-v|0;v=ba+L|0;J=L-ba|0;ba=N+F|0;L=F-N|0;N=V-A|0;A=I-G|0;G=K-D|0;D=O-M|0;M=X-P|0;P=R-S|0;S=Y-W|0;a[C>>2]=T+-1792+ba+v+U;W=T<<1;T=(E(ba-W|0,-7223)|0)+4096+(2578*(v-W|0)|0)+(10438*(U-W|0)|0)>>13;a[C+16>>2]=T;T=9058*(ga+J|0)|0;a[C+8>>2]=(5027*L|0)+4096+(2237*ga|0)+T>>13;ga=(E(L,-11295)|0)+4096+(E(J,-14084)|0)+T>>13;a[C+24>>2]=ga;ga=G+A|0;T=P-M|0;a[C+28>>2]=N-ga+D-T-S;J=D<<13;
D=(11512*T|0)-J+(E(ga,-1297)|0)|0;ga=(6164*(S+M|0)|0)+(9810*(G+N|0)|0)|0;T=(E(G,-19447)|0)+4096+(9175*M|0)+D+ga>>13;a[C+20>>2]=T;T=(3826*(P-S|0)|0)+(10935*(A+N|0)|0)|0;M=(E(A,-3474)|0)+4096+(E(P,-25148)|0)+D+T>>13;a[C+12>>2]=M;M=(J|4096)+S+(E(S+N|0,-9232)|0)+T+ga>>13;a[C+4>>2]=M;switch(w|0){case 7:w=8;C=f;continue a;case 13:v=7;V=b;I=f;break a}w=w+1|0;C=C+32|0}for(;;)if(C=a[V>>2]|0,w=a[I+160>>2]|0,f=w+C|0,b=V+32|0,z=a[b>>2]|0,r=a[I+128>>2]|0,t=r+z|0,B=V+64|0,y=a[B>>2]|0,q=a[I+96>>2]|0,p=q+y|0,n=V+
96|0,l=a[n>>2]|0,k=a[I+64>>2]|0,m=k+l|0,h=V+128|0,g=a[h>>2]|0,c=a[I+32>>2]|0,d=c+g|0,M=V+160|0,ga=a[M>>2]|0,T=a[I>>2]|0,N=T+ga|0,S=V+192|0,J=a[S>>2]|0,D=V+224|0,P=a[D>>2]|0,A=P+J|0,G=A+f|0,L=f-A|0,A=N+t|0,f=t-N|0,N=d+p|0,t=p-d|0,d=C-w|0,w=z-r|0,r=y-q|0,q=l-k|0,k=g-c|0,c=ga-T|0,T=J-P|0,a[V>>2]=(5350*(N+m+A+G|0)|0)+8192>>14,P=m<<1,m=(E(N-P|0,-4717)|0)+8192+(1684*(A-P|0)|0)+(6817*(G-P|0)|0)>>14,a[h>>2]=m,m=5915*(L+f|0)|0,a[B>>2]=(3283*t|0)+8192+(1461*L|0)+m>>14,L=(E(t,-7376)|0)+8192+(E(f,-9198)|0)+m>>
14,a[S>>2]=L,L=r+w|0,S=c-k|0,a[D>>2]=(5350*(d-L+q-S-T|0)|0)+8192>>14,D=5350*q|0,q=(7518*S|0)-D+(E(L,-847)|0)|0,L=(4025*(T+k|0)|0)+(6406*(r+d|0)|0)|0,S=(E(r,-12700)|0)+8192+(5992*k|0)+q+L>>14,a[M>>2]=S,S=(2499*(c-T|0)|0)+(7141*(w+d|0)|0)|0,M=(E(w,-2269)|0)+8192+(E(c,-16423)|0)+q+S>>14,a[n>>2]=M,M=(E(d,-6029)|0)+8192+D+(E(T,-679)|0)+S+L>>14,a[b>>2]=M,0<(v|0))v=v+-1|0,V=V+4|0,I=I+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N,
R,S,ba,Y,W,U,ga,Ha;e=u;u=u+224|0;f=e;g=c+14|0;h=c+1|0;m=c+13|0;k=c+2|0;l=c+12|0;n=c+3|0;p=c+11|0;q=c+4|0;y=c+10|0;B=c+5|0;t=c+9|0;r=c+6|0;z=c+8|0;w=c+7|0;C=0;v=b;a:for(;;){V=a[d+(C<<2)>>2]|0;A=x[V+c>>0]|0;J=x[V+g>>0]|0;I=J+A|0;G=x[V+h>>0]|0;L=x[V+m>>0]|0;K=L+G|0;D=x[V+k>>0]|0;F=x[V+l>>0]|0;O=F+D|0;M=x[V+n>>0]|0;T=x[V+p>>0]|0;X=T+M|0;P=x[V+q>>0]|0;N=x[V+y>>0]|0;R=N+P|0;S=x[V+B>>0]|0;ba=x[V+t>>0]|0;Y=ba+S|0;W=x[V+r>>0]|0;U=x[V+z>>0]|0;ga=U+W|0;Ha=x[V+w>>0]|0;V=A-J|0;J=G-L|0;L=D-F|0;F=M-T|0;T=P-N|0;
N=S-ba|0;ba=W-U|0;U=R+I+Y|0;W=X+K+ga|0;S=Ha+O|0;a[v>>2]=U+-1920+W+S;P=S<<1;S=(E(W-P|0,-3580)|0)+4096+(9373*(U-P|0)|0)>>13;a[v+24>>2]=S;S=((R+K|0)>>>1)+O+(E(Ha,-2)|0)|0;Ha=E(I-S|0,-748)|0;O=(6476*(K-R|0)|0)+(11332*(I-X|0)|0)+(7752*(ga-Y|0)|0)+4096|0;I=O+(E(ga-S|0,-18336)|0)+(12543*(X-S|0)|0)>>13;a[v+8>>2]=I;a[v+16>>2]=O+Ha+(6541*(Y-S|0)|0)>>13;S=10033*L|0;Y=(4712*(N+F|0)|0)+(11018*(T+J|0)|0)+(11522*(V-ba|0)|0)|0;Ha=E(V,-2912)|0;O=E(N,-7121)|0;I=S+4096+(3897*F|0)+(E(T,-4209)|0)+(13930*ba|0)+Y>>13;a[v+
4>>2]=I;a[v+12>>2]=(11018*(V-T-N|0)|0)+4096+(6810*(J-F-ba|0)|0)>>13;a[v+20>>2]=(10033*(V-L-F+N+ba|0)|0)+4096>>13;ba=Ha+4096+(E(J,-17828)|0)-S+O+Y>>13;a[v+28>>2]=ba;switch(C|0){case 7:C=8;v=f;continue a;case 14:A=7;I=b;G=f;break a}C=C+1|0;v=v+32|0}for(;;)if(v=a[I>>2]|0,C=a[G+192>>2]|0,f=C+v|0,b=I+32|0,w=a[b>>2]|0,z=a[G+160>>2]|0,r=z+w|0,t=I+64|0,B=a[t>>2]|0,y=a[G+128>>2]|0,q=y+B|0,p=I+96|0,n=a[p>>2]|0,l=a[G+96>>2]|0,k=l+n|0,m=I+128|0,h=a[m>>2]|0,g=a[G+64>>2]|0,c=g+h|0,d=I+160|0,ba=a[d>>2]|0,Y=a[G+
32>>2]|0,O=Y+ba|0,S=I+192|0,J=a[S>>2]|0,Ha=a[G>>2]|0,N=Ha+J|0,F=I+224|0,L=a[F>>2]|0,V=v-C|0,C=w-z|0,z=B-y|0,y=n-l|0,l=h-g|0,g=ba-Y|0,Y=J-Ha|0,Ha=c+f+O|0,J=k+r+N|0,ba=L+q|0,a[I>>2]=(9321*(J+Ha+ba|0)|0)+16384>>15,h=ba<<1,ba=(E(J-h|0,-4073)|0)+16384+(10664*(Ha-h|0)|0)>>15,a[S>>2]=ba,ba=(c+r>>1)+q+(E(L,-2)|0)|0,L=E(f-ba|0,-852)|0,q=(7369*(r-c|0)|0)+(12893*(f-k|0)|0)+(8820*(N-O|0)|0)+16384|0,f=q+(E(N-ba|0,-20862)|0)+(14271*(k-ba|0)|0)>>15,a[t>>2]=f,a[m>>2]=q+L+(7442*(O-ba|0)|0)>>15,ba=11415*z|0,O=(5361*
(g+y|0)|0)+(12536*(l+C|0)|0)+(13109*(V-Y|0)|0)|0,L=E(V,-3314)|0,q=E(g,-8102)|0,m=ba+16384+(4434*y|0)+(E(l,-4788)|0)+(15850*Y|0)+O>>15,a[b>>2]=m,a[p>>2]=(12536*(V-l-g|0)|0)+16384+(7748*(C-y-Y|0)|0)>>15,a[d>>2]=(11415*(V-z-y+g+Y|0)|0)+16384>>15,Y=L+16384+(E(C,-20284)|0)-ba+q+O>>15,a[F>>2]=Y,0<(A|0))A=A+-1|0,I=I+4|0,G=G+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N,R,S,ba,Y,W,U,ga,Ha,ma,Z,ha,da;e=u;u=u+256|0;f=e;g=c+15|0;h=c+
1|0;m=c+14|0;k=c+2|0;l=c+13|0;n=c+3|0;p=c+12|0;q=c+4|0;y=c+11|0;B=c+5|0;t=c+10|0;r=c+6|0;z=c+9|0;w=c+7|0;C=c+8|0;v=0;V=b;a:for(;;){A=a[d+(v<<2)>>2]|0;J=x[A+c>>0]|0;I=x[A+g>>0]|0;G=I+J|0;L=x[A+h>>0]|0;K=x[A+m>>0]|0;D=K+L|0;F=x[A+k>>0]|0;O=x[A+l>>0]|0;M=O+F|0;T=x[A+n>>0]|0;X=x[A+p>>0]|0;P=X+T|0;N=x[A+q>>0]|0;R=x[A+y>>0]|0;S=R+N|0;ba=x[A+B>>0]|0;Y=x[A+t>>0]|0;W=Y+ba|0;U=x[A+r>>0]|0;ga=x[A+z>>0]|0;Ha=ga+U|0;ma=x[A+w>>0]|0;Z=x[A+C>>0]|0;A=Z+ma|0;ha=A+G|0;da=G-A|0;A=Ha+D|0;G=D-Ha|0;Ha=W+M|0;D=M-W|0;W=S+
P|0;M=P-S|0;S=J-I|0;I=L-K|0;K=F-O|0;O=T-X|0;X=N-R|0;R=ba-Y|0;Y=U-ga|0;ga=ma-Z|0;a[V>>2]=(Ha+W+A+ha<<2)+-8192;a[V+16>>2]=(4433*(A-Ha|0)|0)+1024+(10703*(ha-W|0)|0)>>11;W=(11363*(da-D|0)|0)+(2260*(M-G|0)|0)|0;a[V+8>>2]=(17799*D|0)+1024+(11893*G|0)+W>>11;G=(E(M,-8697)|0)+1024+(E(da,-1730)|0)+W>>11;a[V+24>>2]=G;G=(3363*(Y-ga|0)|0)+(11086*(I+S|0)|0)|0;W=(5461*(ga+R|0)|0)+(10217*(K+S|0)|0)|0;da=(7350*(X-ga|0)|0)+(8956*(O+S|0)|0)|0;M=(11529*(Y-R|0)|0)+(1136*(K+I|0)|0)|0;D=(E(Y+X|0,-10217)|0)+(E(O+I|0,-5461)|
0)|0;ha=(3363*(R-X|0)|0)+(E(O+K|0,-11086)|0)|0;Ha=E(Y,-13631)|0;Y=E(K,-9222)|0;K=(E(S,-18730)|0)+1024+(6387*ga|0)+W+G+da>>11;a[V+4>>2]=K;a[V+12>>2]=(589*I|0)+1024+Ha+D+M+G>>11;a[V+20>>2]=Y+1024+(10055*R|0)+ha+M+W>>11;a[V+28>>2]=(8728*O|0)+1024+(17760*X|0)+ha+D+da>>11;switch(v|0){case 7:v=8;V=f;continue a;case 15:A=7;J=b;L=f;break a}v=v+1|0;V=V+32|0}for(;;)if(V=a[J>>2]|0,v=a[L+224>>2]|0,f=v+V|0,b=J+32|0,C=a[b>>2]|0,w=a[L+192>>2]|0,z=w+C|0,r=J+64|0,t=a[r>>2]|0,B=a[L+160>>2]|0,y=B+t|0,q=J+96|0,p=a[q>>
2]|0,n=a[L+128>>2]|0,l=n+p|0,k=J+128|0,m=a[k>>2]|0,h=a[L+96>>2]|0,g=h+m|0,c=J+160|0,d=a[c>>2]|0,da=a[L+64>>2]|0,D=da+d|0,ha=J+192|0,X=a[ha>>2]|0,O=a[L+32>>2]|0,W=O+X|0,M=J+224|0,R=a[M>>2]|0,Y=a[L>>2]|0,G=Y+R|0,Ha=G+f|0,I=f-G|0,G=W+z|0,f=z-W|0,W=D+y|0,z=y-D|0,D=g+l|0,y=l-g|0,g=V-v|0,v=C-w|0,w=t-B|0,B=p-n|0,n=m-h|0,h=d-da|0,da=X-O|0,O=R-Y|0,a[J>>2]=D+8+W+G+Ha>>4,a[k>>2]=(4433*(G-W|0)|0)+65536+(10703*(Ha-D|0)|0)>>17,D=(11363*(I-z|0)|0)+(2260*(y-f|0)|0)|0,a[r>>2]=(17799*z|0)+65536+(11893*f|0)+D>>17,f=
(E(y,-8697)|0)+65536+(E(I,-1730)|0)+D>>17,a[ha>>2]=f,f=(3363*(da-O|0)|0)+(11086*(v+g|0)|0)|0,ha=(5461*(O+h|0)|0)+(10217*(w+g|0)|0)|0,D=(7350*(n-O|0)|0)+(8956*(B+g|0)|0)|0,I=(11529*(da-h|0)|0)+(1136*(w+v|0)|0)|0,y=(E(da+n|0,-10217)|0)+(E(B+v|0,-5461)|0)|0,z=(3363*(h-n|0)|0)+(E(B+w|0,-11086)|0)|0,r=E(da,-13631)|0,da=E(w,-9222)|0,w=(E(g,-18730)|0)+65536+(6387*O|0)+ha+f+D>>17,a[b>>2]=w,a[q>>2]=(589*v|0)+65536+r+y+I+f>>17,a[c>>2]=da+65536+(10055*h|0)+z+I+ha>>17,a[M>>2]=(8728*B|0)+65536+(17760*n|0)+z+y+
D>>17,0<(A|0))A=A+-1|0,J=J+4|0,L=L+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,u,w,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N,R,S,ba,Y,W,U,ga,Ha,ma,Z;e=c+15|0;f=c+1|0;g=c+14|0;h=c+2|0;m=c+13|0;k=c+3|0;l=c+12|0;n=c+4|0;p=c+11|0;q=c+5|0;y=c+10|0;B=c+6|0;t=c+9|0;r=c+7|0;z=c+8|0;u=0;for(w=b;;)if(v=a[d+(u<<2)>>2]|0,V=x[v+c>>0]|0,A=x[v+e>>0]|0,J=A+V|0,I=x[v+f>>0]|0,G=x[v+g>>0]|0,L=G+I|0,K=x[v+h>>0]|0,D=x[v+m>>0]|0,F=D+K|0,O=x[v+k>>0]|0,M=x[v+l>>0]|0,T=M+O|0,X=x[v+n>>0]|0,P=
x[v+p>>0]|0,N=P+X|0,R=x[v+q>>0]|0,S=x[v+y>>0]|0,ba=S+R|0,Y=x[v+B>>0]|0,W=x[v+t>>0]|0,U=W+Y|0,ga=x[v+r>>0]|0,Ha=x[v+z>>0]|0,v=Ha+ga|0,ma=v+J|0,Z=J-v|0,v=U+L|0,J=L-U|0,U=ba+F|0,L=F-ba|0,ba=N+T|0,F=T-N|0,N=V-A|0,A=I-G|0,G=K-D|0,D=O-M|0,M=X-P|0,P=R-S|0,S=Y-W|0,W=ga-Ha|0,a[w>>2]=(U+ba+v+ma<<2)+-8192,a[w+16>>2]=(4433*(v-U|0)|0)+1024+(10703*(ma-ba|0)|0)>>11,ba=(11363*(Z-L|0)|0)+(2260*(F-J|0)|0)|0,a[w+8>>2]=(17799*L|0)+1024+(11893*J|0)+ba>>11,J=(E(F,-8697)|0)+1024+(E(Z,-1730)|0)+ba>>11,a[w+24>>2]=J,J=(3363*
(S-W|0)|0)+(11086*(A+N|0)|0)|0,ba=(5461*(W+P|0)|0)+(10217*(G+N|0)|0)|0,Z=(7350*(M-W|0)|0)+(8956*(D+N|0)|0)|0,F=(11529*(S-P|0)|0)+(1136*(G+A|0)|0)|0,L=(E(S+M|0,-10217)|0)+(E(D+A|0,-5461)|0)|0,ma=(3363*(P-M|0)|0)+(E(D+G|0,-11086)|0)|0,U=E(S,-13631)|0,S=E(G,-9222)|0,G=(E(N,-18730)|0)+1024+(6387*W|0)+ba+J+Z>>11,a[w+4>>2]=G,a[w+12>>2]=(589*A|0)+1024+U+L+F+J>>11,a[w+20>>2]=S+1024+(10055*P|0)+ma+F+ba>>11,a[w+28>>2]=(8728*D|0)+1024+(17760*M|0)+ma+L+Z>>11,u=u+1|0,8==(u|0)){v=7;V=b;break}else w=w+32|0;for(;;)if(w=
a[V>>2]|0,b=V+224|0,u=a[b>>2]|0,z=u+w|0,r=V+32|0,t=a[r>>2]|0,B=V+192|0,y=a[B>>2]|0,q=y+t|0,p=V+64|0,n=a[p>>2]|0,l=V+160|0,k=a[l>>2]|0,m=k+n|0,h=V+96|0,g=a[h>>2]|0,f=V+128|0,e=a[f>>2]|0,c=e+g|0,d=c+z|0,Z=z-c|0,c=m+q|0,z=q-m|0,m=w-u|0,u=t-y|0,y=n-k|0,k=g-e|0,a[V>>2]=c+4+d>>3,a[f>>2]=4-c+d>>3,d=4433*(Z+z|0)|0,a[p>>2]=(6270*Z|0)+32768+d>>16,Z=(E(z,-15137)|0)+32768+d>>16,a[B>>2]=Z,Z=y+m|0,B=k+u|0,d=9633*(B+Z|0)|0,z=d+(E(Z,-3196)|0)|0,Z=d+(E(B,-16069)|0)|0,B=E(k+m|0,-7373)|0,d=E(y+u|0,-20995)|0,a[r>>2]=
(12299*m|0)+32768+B+z>>16,a[h>>2]=(25172*u|0)+32768+d+Z>>16,a[l>>2]=(16819*y|0)+32768+d+z>>16,a[b>>2]=(2446*k|0)+32768+B+Z>>16,0<(v|0))v=v+-1|0,V=V+4|0;else break},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,r,u,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N,R,S,ba,Y,W;e=b+224|0;f=e+32|0;do t[e>>0]=0,e=e+1|0;while((e|0)<(f|0));e=c+13|0;f=c+1|0;g=c+12|0;h=c+2|0;m=c+11|0;k=c+3|0;l=c+10|0;n=c+4|0;p=c+9|0;q=c+5|0;y=c+8|0;B=c+6|0;r=c+7|0;u=0;for(z=b;;)if(w=a[d+(u<<2)>>2]|0,C=x[w+c>>0]|0,v=x[w+e>>
0]|0,V=v+C|0,A=x[w+f>>0]|0,J=x[w+g>>0]|0,I=J+A|0,G=x[w+h>>0]|0,L=x[w+m>>0]|0,K=L+G|0,D=x[w+k>>0]|0,F=x[w+l>>0]|0,O=F+D|0,M=x[w+n>>0]|0,T=x[w+p>>0]|0,X=T+M|0,P=x[w+q>>0]|0,N=x[w+y>>0]|0,R=N+P|0,S=x[w+B>>0]|0,ba=x[w+r>>0]|0,w=ba+S|0,Y=w+V|0,W=V-w|0,w=R+I|0,V=I-R|0,R=X+K|0,I=K-X|0,X=C-v|0,v=A-J|0,J=G-L|0,L=D-F|0,F=M-T|0,T=P-N|0,N=S-ba|0,a[z>>2]=(R+O+w+Y<<2)+-7168,ba=O<<1,O=(E(R-ba|0,-7223)|0)+1024+(2578*(w-ba|0)|0)+(10438*(Y-ba|0)|0)>>11,a[z+16>>2]=O,O=9058*(W+V|0)|0,a[z+8>>2]=(5027*I|0)+1024+(2237*
W|0)+O>>11,W=(E(I,-11295)|0)+1024+(E(V,-14084)|0)+O>>11,a[z+24>>2]=W,W=J+v|0,O=T-F|0,a[z+28>>2]=X-W+L-O-N<<2,V=L<<13,L=(11512*O|0)-V+(E(W,-1297)|0)|0,W=(6164*(N+F|0)|0)+(9810*(J+X|0)|0)|0,O=(E(J,-19447)|0)+1024+(9175*F|0)+L+W>>11,a[z+20>>2]=O,O=(3826*(T-N|0)|0)+(10935*(v+X|0)|0)|0,F=(E(v,-3474)|0)+1024+(E(T,-25148)|0)+L+O>>11,a[z+12>>2]=F,F=(V|1024)+N+(E(N+X|0,-9232)|0)+O+W>>11,a[z+4>>2]=F,u=u+1|0,7==(u|0)){d=7;w=b;break}else z=z+32|0;for(;;)if(z=a[w>>2]|0,b=w+192|0,u=a[b>>2]|0,r=u+z|0,B=w+32|0,y=
a[B>>2]|0,q=w+160|0,p=a[q>>2]|0,n=p+y|0,l=w+64|0,k=a[l>>2]|0,m=w+128|0,h=a[m>>2]|0,g=h+k|0,f=w+96|0,e=a[f>>2]|0,c=z-u|0,u=y-p|0,p=k-h|0,h=g+r|0,a[w>>2]=(10700*(e+n+h|0)|0)+32768>>16,k=3783*((E(e,-4)|0)+h|0)|0,h=9850*(r-g|0)|0,y=3367*(n-g|0)|0,a[l>>2]=h+32768+y+k>>16,l=(9434*(r-n|0)|0)+32768|0,r=l+y+(E(n-(e<<1)|0,-7566)|0)>>16,a[m>>2]=r,a[b>>2]=l-h+k>>16,k=10009*(u+c|0)|0,h=1822*(c-u|0)|0,l=E(p+u|0,-14752)|0,u=6565*(p+c|0)|0,a[B>>2]=32768-h+k+u>>16,a[f>>2]=h+32768+k+l>>16,a[q>>2]=(20017*p|0)+32768+
u+l>>16,0<(d|0))d=d+-1|0,w=w+4|0;else break},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,r,u,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N;e=b+192|0;f=e+64|0;do t[e>>0]=0,e=e+1|0;while((e|0)<(f|0));e=c+11|0;f=c+1|0;g=c+10|0;h=c+2|0;m=c+9|0;k=c+3|0;l=c+8|0;n=c+4|0;p=c+7|0;q=c+5|0;y=c+6|0;B=0;for(r=b;;)if(u=a[d+(B<<2)>>2]|0,z=x[u+c>>0]|0,w=x[u+e>>0]|0,C=w+z|0,v=x[u+f>>0]|0,V=x[u+g>>0]|0,A=V+v|0,J=x[u+h>>0]|0,I=x[u+m>>0]|0,G=I+J|0,L=x[u+k>>0]|0,K=x[u+l>>0]|0,D=K+L|0,F=x[u+n>>0]|0,O=x[u+p>>0]|
0,M=O+F|0,T=x[u+q>>0]|0,X=x[u+y>>0]|0,u=X+T|0,P=u+C|0,N=C-u|0,u=A-M|0,C=D+G|0,G=G-D|0,D=z-w|0,w=v-V|0,V=J-I|0,I=L-K|0,K=F-O|0,O=T-X|0,a[r>>2]=(C+A+M+P<<2)+-6144,a[r+24>>2]=N-(u+G)<<2,a[r+16>>2]=(10033*(P-C|0)|0)+1024>>11,a[r+8>>2]=1024-G+u+(11190*(N+G|0)|0)>>11,G=4433*(K+w|0)|0,N=G+(6270*w|0)|0,w=G+(E(K,-15137)|0)|0,K=9191*(V+D|0)|0,G=7053*(I+D|0)|0,u=E(I+V|0,-1512)|0,C=E(V,-19165)|0,P=E(O,-9191)|0,M=E(O+V|0,-4433)|0,V=(E(D,-4758)|0)+1024+K+G+N+(1512*O|0)>>11,a[r+4>>2]=V,a[r+12>>2]=(10703*(D-I|0)|
0)+1024+w+M>>11,a[r+20>>2]=C+1024+K+u-w+(7053*O|0)>>11,a[r+28>>2]=(5946*I|0)+1024+u+G-N+P>>11,B=B+1|0,6==(B|0)){u=7;z=b;break}else r=r+32|0;for(;;)if(r=a[z>>2]|0,b=z+160|0,B=a[b>>2]|0,y=B+r|0,q=z+32|0,p=a[q>>2]|0,n=z+128|0,l=a[n>>2]|0,k=l+p|0,m=z+64|0,h=a[m>>2]|0,g=z+96|0,f=a[g>>2]|0,e=f+h|0,c=e+y|0,d=r-B|0,B=p-l|0,l=h-f|0,a[z>>2]=(14564*(c+k|0)|0)+32768>>16,a[m>>2]=(17837*(y-e|0)|0)+32768>>16,e=(10298*((E(k,-2)|0)+c|0)|0)+32768>>16,a[n>>2]=e,e=5331*(l+d|0)|0,a[q>>2]=(14564*(B+d|0)|0)+32768+e>>16,
a[g>>2]=(14564*(d-B-l|0)|0)+32768>>16,a[b>>2]=(14564*(l-B|0)|0)+32768+e>>16,0<(u|0))u=u+-1|0,z=z+4|0;else break},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,r,u,z,w,C,v,V,A,J,I,G,L,K,D,F,O;e=b+160|0;f=e+96|0;do t[e>>0]=0,e=e+1|0;while((e|0)<(f|0));e=c+9|0;f=c+1|0;g=c+8|0;h=c+2|0;m=c+7|0;k=c+3|0;l=c+6|0;n=c+4|0;p=c+5|0;q=0;for(y=b;;)if(B=a[d+(q<<2)>>2]|0,r=x[B+c>>0]|0,u=x[B+e>>0]|0,z=u+r|0,w=x[B+f>>0]|0,C=x[B+g>>0]|0,v=C+w|0,V=x[B+h>>0]|0,A=x[B+m>>0]|0,J=A+V|0,I=x[B+k>>0]|0,G=x[B+l>>
0]|0,L=G+I|0,K=x[B+n>>0]|0,D=x[B+p>>0]|0,B=D+K|0,F=B+z|0,O=z-B|0,B=L+v|0,z=v-L|0,L=r-u|0,u=w-C|0,C=V-A|0,A=I-G|0,G=K-D|0,a[y>>2]=(B+J+F<<2)+-5120,D=J<<1,J=(E(B-D|0,-3580)|0)+1024+(9373*(F-D|0)|0)>>11,a[y+16>>2]=J,J=6810*(O+z|0)|0,a[y+8>>2]=(4209*O|0)+1024+J>>11,O=(E(z,-17828)|0)+1024+J>>11,a[y+24>>2]=O,O=G+L|0,J=u-A|0,a[y+20>>2]=O-(J+C)<<2,z=C<<13,a[y+4>>2]=(11443*L|0)+1024+(10323*u|0)+z+(5260*A|0)+(1812*G|0)>>11,C=(J<<12)-z+(2531*(O+J|0)|0)|0,J=(7791*(L-G|0)|0)+(E(A+u|0,-4815)|0)+1024|0,a[y+12>>
2]=J+C>>11,a[y+28>>2]=J-C>>11,q=q+1|0,5==(q|0)){d=7;B=b;break}else y=y+32|0;for(;;)if(y=a[B>>2]|0,b=B+128|0,q=a[b>>2]|0,p=q+y|0,n=B+32|0,l=a[n>>2]|0,k=B+96|0,m=a[k>>2]|0,h=m+l|0,g=B+64|0,f=a[g>>2]|0,e=h+p|0,c=y-q|0,q=l-m|0,a[B>>2]=(10486*(e+f|0)|0)+16384>>15,m=3707*(e-(f<<2)|0)|0,f=(8290*(p-h|0)|0)+16384|0,a[g>>2]=f+m>>15,a[b>>2]=f-m>>15,m=8716*(q+c|0)|0,a[n>>2]=(5387*c|0)+16384+m>>15,c=(E(q,-22820)|0)+16384+m>>15,a[k>>2]=c,0<(d|0))d=d+-1|0,B=B+4|0;else break},function(b,d,c){b|=0;d|=0;c|=0;var e,
f,g,h,m,k,l,n,p,q,y,B,r,u,z,w,C,v,V,A,J,I,G;e=b+128|0;f=e+128|0;do t[e>>0]=0,e=e+1|0;while((e|0)<(f|0));e=c+7|0;f=c+1|0;g=c+6|0;h=c+2|0;m=c+5|0;k=c+3|0;l=c+4|0;n=0;for(p=b;;)if(q=a[d+(n<<2)>>2]|0,y=x[q+c>>0]|0,B=x[q+e>>0]|0,r=B+y|0,u=x[q+f>>0]|0,z=x[q+g>>0]|0,w=z+u|0,C=x[q+h>>0]|0,v=x[q+m>>0]|0,V=v+C|0,A=x[q+k>>0]|0,J=x[q+l>>0]|0,q=J+A|0,I=q+r|0,G=r-q|0,q=V+w|0,r=w-V|0,V=y-B|0,B=u-z|0,z=C-v|0,v=A-J|0,a[p>>2]=(I+q<<3)+-8192,a[p+16>>2]=I-q<<3,q=(4433*(G+r|0)|0)+512|0,a[p+8>>2]=q+(6270*G|0)>>10,G=q+
(E(r,-15137)|0)>>10,a[p+24>>2]=G,G=z+V|0,r=v+B|0,q=(9633*(r+G|0)|0)+512|0,I=q+(E(G,-3196)|0)|0,G=q+(E(r,-16069)|0)|0,r=E(v+V|0,-7373)|0,q=E(z+B|0,-20995)|0,a[p+4>>2]=r+(12299*V|0)+I>>10,a[p+12>>2]=q+(25172*B|0)+G>>10,a[p+20>>2]=q+(16819*z|0)+I>>10,a[p+28>>2]=r+(2446*v|0)+G>>10,n=n+1|0,4==(n|0)){d=7;c=b;break}else p=p+32|0;for(;;)if(p=a[c>>2]|0,b=c+96|0,n=a[b>>2]|0,l=p+2+n|0,k=c+32|0,m=a[k>>2]|0,h=c+64|0,g=a[h>>2]|0,f=g+m|0,e=p-n|0,n=m-g|0,a[c>>2]=f+l>>2,a[h>>2]=l-f>>2,f=(4433*(n+e|0)|0)+16384|0,a[k>>
2]=f+(6270*e|0)>>15,e=f+(E(n,-15137)|0)>>15,a[b>>2]=e,0<(d|0))d=d+-1|0,c=c+4|0;else break},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,u,w,C;Va(b|0,0,256)|0;e=c+5|0;f=c+1|0;g=c+4|0;h=c+2|0;m=c+3|0;k=0;for(l=b;n=a[d+(k<<2)>>2]|0,p=x[n+c>>0]|0,q=x[n+e>>0]|0,y=q+p|0,B=x[n+f>>0]|0,t=x[n+g>>0]|0,r=t+B|0,u=x[n+h>>0]|0,w=x[n+m>>0]|0,n=w+u|0,C=n+y|0,p=p-q|0,q=B-t|0,t=u-w|0,a[l>>2]=(C+r<<3)+-6144,a[l+8>>2]=(10033*(y-n|0)|0)+512>>10,n=(5793*((E(r,-2)|0)+C|0)|0)+512>>10,a[l+16>>2]=n,n=(2998*
(t+p|0)|0)+512>>10,a[l+4>>2]=n+(q+p<<3),a[l+12>>2]=p-q-t<<3,a[l+20>>2]=n+(t-q<<3),k=k+1|0,3!=(k|0);)l=l+32|0;l=a[b>>2]|0;k=b+64|0;m=a[k>>2]|0;h=m+l|0;g=b+32|0;f=a[g>>2]|0;a[b>>2]=(14564*(h+f|0)|0)+16384>>15;e=(10298*((E(f,-2)|0)+h|0)|0)+16384>>15;a[k>>2]=e;a[g>>2]=(17837*(l-m|0)|0)+16384>>15;m=b+4|0;l=a[m>>2]|0;g=b+68|0;e=a[g>>2]|0;k=e+l|0;h=b+36|0;f=a[h>>2]|0;a[m>>2]=(14564*(k+f|0)|0)+16384>>15;m=(10298*((E(f,-2)|0)+k|0)|0)+16384>>15;a[g>>2]=m;a[h>>2]=(17837*(l-e|0)|0)+16384>>15;e=b+8|0;l=a[e>>2]|
0;h=b+72|0;m=a[h>>2]|0;g=m+l|0;k=b+40|0;f=a[k>>2]|0;a[e>>2]=(14564*(g+f|0)|0)+16384>>15;e=(10298*((E(f,-2)|0)+g|0)|0)+16384>>15;a[h>>2]=e;a[k>>2]=(17837*(l-m|0)|0)+16384>>15;m=b+12|0;l=a[m>>2]|0;k=b+76|0;e=a[k>>2]|0;h=e+l|0;g=b+44|0;f=a[g>>2]|0;a[m>>2]=(14564*(h+f|0)|0)+16384>>15;m=(10298*((E(f,-2)|0)+h|0)|0)+16384>>15;a[k>>2]=m;a[g>>2]=(17837*(l-e|0)|0)+16384>>15;e=b+16|0;l=a[e>>2]|0;g=b+80|0;m=a[g>>2]|0;k=m+l|0;h=b+48|0;f=a[h>>2]|0;a[e>>2]=(14564*(k+f|0)|0)+16384>>15;e=(10298*((E(f,-2)|0)+k|0)|
0)+16384>>15;a[g>>2]=e;a[h>>2]=(17837*(l-m|0)|0)+16384>>15;m=b+20|0;l=a[m>>2]|0;h=b+84|0;e=a[h>>2]|0;g=e+l|0;k=b+52|0;b=a[k>>2]|0;a[m>>2]=(14564*(g+b|0)|0)+16384>>15;m=(10298*((E(b,-2)|0)+g|0)|0)+16384>>15;a[h>>2]=m;a[k>>2]=(17837*(l-e|0)|0)+16384>>15},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q;Va(b|0,0,256)|0;e=c+3|0;f=c+1|0;g=c+2|0;h=a[d>>2]|0;m=x[h+c>>0]|0;k=x[h+e>>0]|0;l=k+m|0;n=x[h+f>>0]|0;p=x[h+g>>0]|0;h=p+n|0;q=m-k|0;k=n-p|0;p=h+l<<5;a[b>>2]=p+-16384;n=l-h<<5;a[b+8>>2]=n;h=(4433*
(k+q|0)|0)+128|0;l=h+(6270*q|0)>>8;q=b+4|0;a[q>>2]=l;m=h+(E(k,-15137)|0)>>8;a[b+12>>2]=m;k=a[d+4>>2]|0;d=x[k+c>>0]|0;c=x[k+e>>0]|0;e=c+d|0;h=x[k+f>>0]|0;f=x[k+g>>0]|0;g=f+h|0;k=d-c|0;c=h-f|0;f=(g+e<<5)+-16384|0;h=e-g<<5;g=(4433*(c+k|0)|0)+128|0;e=g+(6270*k|0)>>8;k=g+(E(c,-15137)|0)>>8;c=p+-16382|0;a[b>>2]=c+f>>2;a[b+32>>2]=c-f>>2;f=l+2|0;a[q>>2]=f+e>>2;a[b+36>>2]=f-e>>2;e=n|2;a[b+8>>2]=e+h>>2;a[b+40>>2]=e-h>>2;h=m+2|0;a[b+12>>2]=h+k>>2;a[b+44>>2]=h-k>>2},function(b,d,c){b|=0;d|=0;c|=0;var e;Va(b|
0,0,256)|0;e=a[d>>2]|0;d=x[e+c>>0]|0;c=x[e+(c+1)>>0]|0;a[b>>2]=(c+d<<5)+-8192;a[b+4>>2]=d-c<<5},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X,P,N,R;e=u;u=u+256|0;f=e;g=c+7|0;h=c+1|0;m=c+6|0;k=c+2|0;l=c+5|0;n=c+3|0;p=c+4|0;q=0;y=b;a:for(;;){B=a[d+(q<<2)>>2]|0;t=x[B+c>>0]|0;r=x[B+g>>0]|0;z=r+t|0;w=x[B+h>>0]|0;C=x[B+m>>0]|0;v=C+w|0;V=x[B+k>>0]|0;A=x[B+l>>0]|0;J=A+V|0;I=x[B+n>>0]|0;G=x[B+p>>0]|0;B=G+I|0;L=B+z|0;K=z-B|0;B=J+v|0;z=v-J|0;J=t-r|0;r=w-C|0;
C=V-A|0;A=I-G|0;a[y>>2]=(L+B<<2)+-4096;a[y+16>>2]=L-B<<2;B=4433*(K+z|0)|0;a[y+8>>2]=(6270*K|0)+1024+B>>11;K=(E(z,-15137)|0)+1024+B>>11;a[y+24>>2]=K;K=C+J|0;B=A+r|0;z=9633*(B+K|0)|0;L=z+(E(K,-3196)|0)|0;K=z+(E(B,-16069)|0)|0;B=E(A+J|0,-7373)|0;z=E(C+r|0,-20995)|0;a[y+4>>2]=(12299*J|0)+1024+B+L>>11;a[y+12>>2]=(25172*r|0)+1024+z+K>>11;a[y+20>>2]=(16819*C|0)+1024+z+L>>11;a[y+28>>2]=(2446*A|0)+1024+B+K>>11;switch(q|0){case 7:q=8;y=f;continue a;case 15:D=7;F=b;O=f;break a}q=q+1|0;y=y+32|0}for(;;)if(y=a[F>>
2]|0,q=a[O+224>>2]|0,f=q+y|0,b=F+32|0,p=a[b>>2]|0,n=a[O+192>>2]|0,l=n+p|0,k=F+64|0,m=a[k>>2]|0,h=a[O+160>>2]|0,g=h+m|0,c=F+96|0,d=a[c>>2]|0,K=a[O+128>>2]|0,B=K+d|0,A=F+128|0,L=a[A>>2]|0,z=a[O+96>>2]|0,C=z+L|0,r=F+160|0,J=a[r>>2]|0,G=a[O+64>>2]|0,I=G+J|0,V=F+192|0,w=a[V>>2]|0,t=a[O+32>>2]|0,v=t+w|0,M=F+224|0,T=a[M>>2]|0,X=a[O>>2]|0,P=X+T|0,N=P+f|0,R=f-P|0,P=v+l|0,f=l-v|0,v=I+g|0,l=g-I|0,I=C+B|0,g=B-C|0,C=y-q|0,q=p-n|0,n=m-h|0,h=d-K|0,K=L-z|0,z=J-G|0,G=w-t|0,t=T-X|0,a[F>>2]=I+4+v+P+N>>3,a[A>>2]=(4433*
(P-v|0)|0)+32768+(10703*(N-I|0)|0)>>16,I=(11363*(R-l|0)|0)+(2260*(g-f|0)|0)|0,a[k>>2]=(17799*l|0)+32768+(11893*f|0)+I>>16,f=(E(g,-8697)|0)+32768+(E(R,-1730)|0)+I>>16,a[V>>2]=f,f=(3363*(G-t|0)|0)+(11086*(q+C|0)|0)|0,V=(5461*(t+z|0)|0)+(10217*(n+C|0)|0)|0,I=(7350*(K-t|0)|0)+(8956*(h+C|0)|0)|0,R=(11529*(G-z|0)|0)+(1136*(n+q|0)|0)|0,g=(E(G+K|0,-10217)|0)+(E(h+q|0,-5461)|0)|0,l=(3363*(z-K|0)|0)+(E(h+n|0,-11086)|0)|0,k=E(G,-13631)|0,G=E(n,-9222)|0,n=(E(C,-18730)|0)+32768+(6387*t|0)+V+f+I>>16,a[b>>2]=n,
a[c>>2]=(589*q|0)+32768+k+g+R+f>>16,a[r>>2]=G+32768+(10055*z|0)+l+R+V>>16,a[M>>2]=(8728*h|0)+32768+(17760*K|0)+l+g+I>>16,0<(D|0))D=D+-1|0,F=F+4|0,O=O+4|0;else break;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,B,t,r,z,w,C,v,V,A,J,I,G,L,K,D,F,O,M,T,X;e=u;u=u+192|0;f=e;Va(b|0,0,256)|0;g=c+6|0;h=c+1|0;m=c+5|0;k=c+2|0;l=c+4|0;n=c+3|0;p=0;q=b;a:for(;;){y=a[d+(p<<2)>>2]|0;B=x[y+c>>0]|0;t=x[y+g>>0]|0;r=t+B|0;z=x[y+h>>0]|0;w=x[y+m>>0]|0;C=w+z|0;v=x[y+k>>0]|0;V=x[y+l>>0]|0;A=V+v|0;J=x[y+n>>
0]|0;y=B-t|0;t=z-w|0;w=v-V|0;V=A+r|0;a[q>>2]=(J+C+V<<2)+-3584;v=2896*((E(J,-4)|0)+V|0)|0;V=7542*(r-A|0)|0;z=2578*(C-A|0)|0;a[q+8>>2]=V+1024+z+v>>11;A=(7223*(r-C|0)|0)+1024|0;r=A+z+(E(C-(J<<1)|0,-5793)|0)>>11;a[q+16>>2]=r;a[q+24>>2]=A-V+v>>11;v=7663*(t+y|0)|0;V=1395*(y-t|0)|0;A=E(w+t|0,-11295)|0;t=5027*(w+y|0)|0;a[q+4>>2]=1024-V+v+t>>11;a[q+12>>2]=V+1024+v+A>>11;a[q+20>>2]=(15326*w|0)+1024+t+A>>11;switch(p|0){case 7:p=8;q=f;continue a;case 13:I=0;G=b;L=f;break a}p=p+1|0;q=q+32|0}for(;q=a[G>>2]|0,p=
a[L+160>>2]|0,f=p+q|0,b=G+32|0,n=a[b>>2]|0,l=a[L+128>>2]|0,k=l+n|0,m=G+64|0,h=a[m>>2]|0,g=a[L+96>>2]|0,c=g+h|0,d=G+96|0,A=a[d>>2]|0,t=a[L+64>>2]|0,w=t+A|0,v=G+128|0,V=a[v>>2]|0,y=a[L+32>>2]|0,r=y+V|0,J=G+160|0,C=a[J>>2]|0,z=a[L>>2]|0,B=z+C|0,K=G+192|0,D=a[K>>2]|0,F=G+224|0,O=a[F>>2]|0,M=O+D|0,T=M+f|0,X=f-M|0,M=B+k|0,f=k-B|0,B=r+c|0,k=c-r|0,r=q-p|0,p=n-l|0,l=h-g|0,g=A-t|0,t=V-y|0,y=C-z|0,z=D-O|0,a[G>>2]=(5350*(B+w+M+T|0)|0)+16384>>15,O=w<<1,w=(E(B-O|0,-4717)|0)+16384+(1684*(M-O|0)|0)+(6817*(T-O|0)|
0)>>15,a[v>>2]=w,w=5915*(X+f|0)|0,a[m>>2]=(3283*k|0)+16384+(1461*X|0)+w>>15,X=(E(k,-7376)|0)+16384+(E(f,-9198)|0)+w>>15,a[K>>2]=X,X=l+p|0,K=y-t|0,a[F>>2]=(5350*(r-X+g-K-z|0)|0)+16384>>15,F=5350*g|0,g=(7518*K|0)-F+(E(X,-847)|0)|0,X=(4025*(z+t|0)|0)+(6406*(l+r|0)|0)|0,K=(E(l,-12700)|0)+16384+(5992*t|0)+g+X>>15,a[J>>2]=K,K=(2499*(y-z|0)|0)+(7141*(p+r|0)|0)|0,J=(E(p,-2269)|0)+16384+(E(y,-16423)|0)+g+K>>15,a[d>>2]=J,J=(E(r,-6029)|0)+16384+F+(E(z,-679)|0)+K+X>>15,a[b>>2]=J,I=I+1|0,7!=(I|0);)G=G+4|0,L=L+
4|0;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,t,r,w,z,v,C,A,V,D,J,I,G,L,K,F,N,O;e=u;u=u+128|0;f=e;Va(b|0,0,256)|0;g=c+5|0;h=c+1|0;m=c+4|0;k=c+2|0;l=c+3|0;n=0;p=b;a:for(;;){q=a[d+(n<<2)>>2]|0;y=x[q+c>>0]|0;t=x[q+g>>0]|0;r=t+y|0;w=x[q+h>>0]|0;z=x[q+m>>0]|0;v=z+w|0;C=x[q+k>>0]|0;A=x[q+l>>0]|0;q=A+C|0;V=q+r|0;D=y-t|0;t=w-z|0;z=C-A|0;a[p>>2]=(V+v<<2)+-3072;a[p+8>>2]=(10033*(r-q|0)|0)+1024>>11;q=(5793*((E(v,-2)|0)+V|0)|0)+1024>>11;a[p+16>>2]=q;q=(2998*(z+D|0)|0)+1024>>11;a[p+4>>2]=q+
(t+D<<2);a[p+12>>2]=D-t-z<<2;a[p+20>>2]=q+(z-t<<2);switch(n|0){case 7:n=8;p=f;continue a;case 11:J=0;I=b;G=f;break a}n=n+1|0;p=p+32|0}for(;p=a[I>>2]|0,n=a[G+96>>2]|0,f=n+p|0,b=I+32|0,l=a[b>>2]|0,k=a[G+64>>2]|0,m=k+l|0,h=I+64|0,g=a[h>>2]|0,c=a[G+32>>2]|0,d=c+g|0,t=I+96|0,z=a[t>>2]|0,q=a[G>>2]|0,D=q+z|0,V=I+128|0,v=a[V>>2]|0,r=I+224|0,A=a[r>>2]|0,C=A+v|0,w=I+160|0,y=a[w>>2]|0,L=I+192|0,K=a[L>>2]|0,F=K+y|0,N=F+f|0,O=f-F|0,F=m-C|0,f=D+d|0,d=d-D|0,D=p-n|0,n=l-k|0,k=g-c|0,c=z-q|0,q=v-A|0,A=y-K|0,a[I>>2]=
(7282*(f+m+C+N|0)|0)+16384>>15,a[L>>2]=(7282*(O-(F+d)|0)|0)+16384>>15,a[V>>2]=(8918*(N-f|0)|0)+16384>>15,a[h>>2]=(7282*(F-d|0)|0)+16384+(9947*(O+d|0)|0)>>15,d=3941*(q+n|0)|0,O=d+(5573*n|0)|0,n=d+(E(q,-13455)|0)|0,q=8170*(k+D|0)|0,d=6269*(c+D|0)|0,F=E(c+k|0,-1344)|0,h=E(k,-17036)|0,f=E(A,-8170)|0,N=E(A+k|0,-3941)|0,k=(E(D,-4229)|0)+16384+q+d+O+(1344*A|0)>>15,a[b>>2]=k,a[t>>2]=(9514*(D-c|0)|0)+16384+n+N>>15,a[w>>2]=h+16384+q+F-n+(6269*A|0)>>15,a[r>>2]=(5285*c|0)+16384+F+d-O+f>>15,J=J+1|0,6!=(J|0);)I=
I+4|0,G=G+4|0;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,t,r,w,z,v,C,A,V,D,J,I,G,L,K;e=u;u=u+64|0;f=e;Va(b|0,0,256)|0;g=c+4|0;h=c+1|0;m=c+3|0;k=c+2|0;l=0;n=b;a:for(;;){p=a[d+(l<<2)>>2]|0;q=x[p+c>>0]|0;y=x[p+g>>0]|0;t=y+q|0;r=x[p+h>>0]|0;w=x[p+m>>0]|0;z=w+r|0;v=x[p+k>>0]|0;p=z+t|0;C=q-y|0;y=r-w|0;a[n>>2]=(p+v<<2)+-2560;w=2896*(p-(v<<2)|0)|0;v=(6476*(t-z|0)|0)+1024|0;a[n+8>>2]=v+w>>11;a[n+16>>2]=v-w>>11;w=6810*(y+C|0)|0;a[n+4>>2]=(4209*C|0)+1024+w>>11;C=(E(y,-17828)|0)+1024+w>>11;
a[n+12>>2]=C;switch(l|0){case 7:l=8;n=f;continue a;case 9:A=0;V=b;D=f;break a}l=l+1|0;n=n+32|0}for(;n=a[V>>2]|0,l=a[D+32>>2]|0,f=l+n|0,b=V+32|0,k=a[b>>2]|0,m=a[D>>2]|0,h=m+k|0,g=V+64|0,c=a[g>>2]|0,d=V+224|0,C=a[d>>2]|0,w=C+c|0,y=V+96|0,v=a[y>>2]|0,z=V+192|0,t=a[z>>2]|0,p=t+v|0,r=V+128|0,q=a[r>>2]|0,J=V+160|0,I=a[J>>2]|0,G=I+q|0,L=G+f|0,K=f-G|0,G=p+h|0,f=h-p|0,p=n-l|0,l=k-m|0,m=c-C|0,C=v-t|0,t=q-I|0,a[V>>2]=(10486*(G+w+L|0)|0)+16384>>15,I=w<<1,w=(E(G-I|0,-4582)|0)+16384+(11997*(L-I|0)|0)>>15,a[r>>
2]=w,w=8716*(K+f|0)|0,a[g>>2]=(5387*K|0)+16384+w>>15,K=(E(f,-22820)|0)+16384+w>>15,a[z>>2]=K,K=t+p|0,z=l-C|0,a[J>>2]=(10486*(K-(z+m)|0)|0)+16384>>15,J=10486*m|0,a[b>>2]=(14647*p|0)+16384+(13213*l|0)+J+(6732*C|0)+(2320*t|0)>>15,b=(5243*z|0)-J+(3240*(K+z|0)|0)|0,z=(9973*(p-t|0)|0)+(E(C+l|0,-6163)|0)+16384|0,a[y>>2]=z+b>>15,a[d>>2]=z-b>>15,A=A+1|0,5!=(A|0);)V=V+4|0,D=D+4|0;u=e},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,t,r,u,z,w,C,v,A,D;Va(b|0,0,256)|0;e=c+3|0;f=c+1|0;g=c+2|0;h=0;for(m=
b;;)if(k=a[d+(h<<2)>>2]|0,l=x[k+c>>0]|0,n=x[k+e>>0]|0,p=n+l|0,q=x[k+f>>0]|0,y=x[k+g>>0]|0,k=y+q|0,t=l-n|0,n=q-y|0,a[m>>2]=(k+p<<3)+-4096,a[m+8>>2]=p-k<<3,k=(4433*(n+t|0)|0)+512|0,a[m+4>>2]=k+(6270*t|0)>>10,t=k+(E(n,-15137)|0)>>10,a[m+12>>2]=t,h=h+1|0,8==(h|0)){r=0;u=b;break}else m=m+32|0;for(;m=a[u>>2]|0,b=u+224|0,h=a[b>>2]|0,g=h+m|0,f=u+32|0,e=a[f>>2]|0,c=u+192|0,d=a[c>>2]|0,t=d+e|0,n=u+64|0,k=a[n>>2]|0,p=u+160|0,y=a[p>>2]|0,q=y+k|0,l=u+96|0,z=a[l>>2]|0,w=u+128|0,C=a[w>>2]|0,v=C+z|0,A=g+2+v|0,D=
g-v|0,v=q+t|0,g=t-q|0,q=m-h|0,h=e-d|0,d=k-y|0,y=z-C|0,a[u>>2]=A+v>>2,a[w>>2]=A-v>>2,v=(4433*(D+g|0)|0)+16384|0,a[n>>2]=v+(6270*D|0)>>15,D=v+(E(g,-15137)|0)>>15,a[c>>2]=D,D=d+q|0,c=y+h|0,g=(9633*(c+D|0)|0)+16384|0,v=g+(E(D,-3196)|0)|0,D=g+(E(c,-16069)|0)|0,c=E(y+q|0,-7373)|0,g=E(d+h|0,-20995)|0,a[f>>2]=c+(12299*q|0)+v>>15,a[l>>2]=g+(25172*h|0)+D>>15,a[p>>2]=g+(16819*d|0)+v>>15,a[b>>2]=c+(2446*y|0)+D>>15,r=r+1|0,4!=(r|0);)u=u+4|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,t,r,u;Va(b|
0,0,256)|0;e=c+2|0;f=c+1|0;g=0;for(h=b;;)if(m=a[d+(g<<2)>>2]|0,k=x[m+c>>0]|0,l=x[m+e>>0]|0,n=l+k|0,p=x[m+f>>0]|0,a[h>>2]=(n+p<<3)+-3072,m=(5793*((E(p,-2)|0)+n|0)|0)+512>>10,a[h+8>>2]=m,a[h+4>>2]=(10033*(k-l|0)|0)+512>>10,g=g+1|0,6==(g|0)){q=0;y=b;break}else h=h+32|0;for(;h=a[y>>2]|0,b=y+160|0,g=a[b>>2]|0,f=g+h|0,e=y+32|0,c=a[e>>2]|0,d=y+128|0,l=a[d>>2]|0,k=l+c|0,m=y+64|0,n=a[m>>2]|0,p=y+96|0,t=a[p>>2]|0,r=t+n|0,u=r+f|0,h=h-g|0,g=c-l|0,l=n-t|0,a[y>>2]=(14564*(u+k|0)|0)+16384>>15,a[m>>2]=(17837*(f-
r|0)|0)+16384>>15,r=(10298*((E(k,-2)|0)+u|0)|0)+16384>>15,a[d>>2]=r,r=5331*(l+h|0)|0,a[e>>2]=(14564*(g+h|0)|0)+16384+r>>15,a[p>>2]=(14564*(h-g-l|0)|0)+16384>>15,a[b>>2]=(14564*(l-g|0)|0)+16384+r>>15,q=q+1|0,3!=(q|0);)y=y+4|0},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y;Va(b|0,0,256)|0;e=c+1|0;f=a[d>>2]|0;g=x[f+c>>0]|0;h=x[f+e>>0]|0;f=(h+g<<3)+-2048|0;a[b>>2]=f;m=g-h<<3;h=b+4|0;a[h>>2]=m;g=b+32|0;k=a[d+4>>2]|0;l=x[k+c>>0]|0;n=x[k+e>>0]|0;k=(n+l<<3)+-2048|0;a[g>>2]=k;p=l-n<<3;a[b+36>>2]=
p;n=a[d+8>>2]|0;l=x[n+c>>0]|0;q=x[n+e>>0]|0;n=(q+l<<3)+-2048|0;a[b+64>>2]=n;y=l-q<<3;a[b+68>>2]=y;q=a[d+12>>2]|0;d=x[q+c>>0]|0;c=x[q+e>>0]|0;e=(c+d<<3)+-2048|0;q=d-c<<3;c=e+f|0;d=n+k|0;l=f-e|0;e=k-n|0;a[b>>2]=d+c;a[b+64>>2]=c-d;d=(4433*(e+l|0)|0)+4096|0;a[g>>2]=d+(6270*l|0)>>13;l=d+(E(e,-15137)|0)>>13;a[b+96>>2]=l;l=q+m|0;e=y+p|0;d=m-q|0;q=p-y|0;a[h>>2]=e+l;a[b+68>>2]=l-e;e=(4433*(q+d|0)|0)+4096|0;a[b+36>>2]=e+(6270*d|0)>>13;d=e+(E(q,-15137)|0)>>13;a[b+100>>2]=d},function(b,d,c){b|=0;d|=0;c|=0;var e;
Va(b|0,0,256)|0;e=x[(a[d>>2]|0)+c>>0]|0;d=x[(a[d+4>>2]|0)+c>>0]|0;a[b>>2]=(d+e<<5)+-8192;a[b+32>>2]=e-d<<5},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,t,r,u,z,w,C,v,A,D,J,I,G;e=c+7|0;f=c+1|0;g=c+6|0;h=c+2|0;m=c+5|0;k=c+3|0;l=c+4|0;n=0;for(p=b;;)if(q=a[d+(n<<2)>>2]|0,y=x[q+c>>0]|0,t=x[q+e>>0]|0,r=t+y|0,u=x[q+f>>0]|0,z=x[q+g>>0]|0,w=z+u|0,C=x[q+h>>0]|0,v=x[q+m>>0]|0,A=v+C|0,D=x[q+k>>0]|0,J=x[q+l>>0]|0,q=J+D|0,I=q+r|0,G=r-q|0,q=A+w|0,r=w-A|0,A=y-t|0,t=u-z|0,z=C-v|0,v=D-J|0,a[p>>2]=(I+q<<
2)+-4096,a[p+16>>2]=I-q<<2,q=(4433*(G+r|0)|0)+1024|0,a[p+8>>2]=q+(6270*G|0)>>11,G=q+(E(r,-15137)|0)>>11,a[p+24>>2]=G,G=z+A|0,r=v+t|0,q=(9633*(r+G|0)|0)+1024|0,I=q+(E(G,-3196)|0)|0,G=q+(E(r,-16069)|0)|0,r=E(v+A|0,-7373)|0,q=E(z+t|0,-20995)|0,a[p+4>>2]=r+(12299*A|0)+I>>11,a[p+12>>2]=q+(25172*t|0)+G>>11,a[p+20>>2]=q+(16819*z|0)+I>>11,a[p+28>>2]=r+(2446*v|0)+G>>11,n=n+1|0,8==(n|0)){y=7;u=b;break}else p=p+32|0;for(;;)if(p=a[u>>2]|0,b=u+224|0,n=a[b>>2]|0,l=n+p|0,k=u+32|0,m=a[k>>2]|0,h=u+192|0,g=a[h>>2]|
0,f=g+m|0,e=u+64|0,c=a[e>>2]|0,d=u+160|0,G=a[d>>2]|0,v=G+c|0,r=u+96|0,I=a[r>>2]|0,z=u+128|0,q=a[z>>2]|0,t=q+I|0,A=l+2+t|0,J=l-t|0,t=v+f|0,l=f-v|0,v=p-n|0,n=m-g|0,g=c-G|0,G=I-q|0,a[u>>2]=A+t>>2,a[z>>2]=A-t>>2,t=(4433*(J+l|0)|0)+16384|0,a[e>>2]=t+(6270*J|0)>>15,J=t+(E(l,-15137)|0)>>15,a[h>>2]=J,J=g+v|0,h=G+n|0,l=(9633*(h+J|0)|0)+16384|0,t=l+(E(J,-3196)|0)|0,J=l+(E(h,-16069)|0)|0,h=E(G+v|0,-7373)|0,l=E(g+n|0,-20995)|0,a[k>>2]=h+(12299*v|0)+t>>15,a[r>>2]=l+(25172*n|0)+J>>15,a[d>>2]=l+(16819*g|0)+t>>15,
a[b>>2]=h+(2446*G|0)+J>>15,0<(y|0))y=y+-1|0,u=u+4|0;else break},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,t,r,u,z,w,C,v,A;e=c+7|0;f=c+1|0;g=c+6|0;h=c+2|0;m=c+5|0;k=c+3|0;l=c+4|0;n=0;for(p=b;;)if(q=a[d+(n<<2)>>2]|0,y=x[q+c>>0]|0,t=x[q+e>>0]|0,r=t+y|0,u=y-t|0,t=x[q+f>>0]|0,y=x[q+g>>0]|0,z=y+t|0,w=t-y|0,y=x[q+h>>0]|0,t=x[q+m>>0]|0,C=t+y|0,v=y-t|0,t=x[q+k>>0]|0,y=x[q+l>>0]|0,q=y+t|0,A=q+r|0,r=r-q|0,q=C+z|0,a[p>>2]=(q|-1024)+A,a[p+16>>2]=A-q,q=181*(z-C+r|0)>>8,a[p+8>>2]=q+r,a[p+24>>2]=r-
q,q=t-y+v|0,y=w+u|0,t=98*(q-y|0)>>8,r=t+(139*q>>8)|0,q=t+(334*y>>8)|0,y=181*(v+w|0)>>8,w=y+u|0,v=u-y|0,a[p+20>>2]=r+v,a[p+12>>2]=v-r,a[p+4>>2]=q+w,a[p+28>>2]=w-q,n=n+1|0,8==(n|0)){t=7;z=b;break}else p=p+32|0;for(;;)if(p=a[z>>2]|0,b=z+224|0,n=a[b>>2]|0,l=n+p|0,k=p-n|0,n=z+32|0,p=a[n>>2]|0,m=z+192|0,h=a[m>>2]|0,g=h+p|0,f=p-h|0,h=z+64|0,p=a[h>>2]|0,e=z+160|0,c=a[e>>2]|0,d=c+p|0,q=p-c|0,c=z+96|0,p=a[c>>2]|0,w=z+128|0,r=a[w>>2]|0,v=r+p|0,y=v+l|0,u=l-v|0,v=d+g|0,a[z>>2]=y+v,a[w>>2]=y-v,v=181*(g-d+u|0)>>
8,a[h>>2]=v+u,a[m>>2]=u-v,v=p-r+q|0,r=f+k|0,p=98*(v-r|0)>>8,u=p+(139*v>>8)|0,v=p+(334*r>>8)|0,r=181*(q+f|0)>>8,f=r+k|0,q=k-r|0,a[e>>2]=u+q,a[c>>2]=q-u,a[n>>2]=v+f,a[b>>2]=f-v,0<(t|0))t=t+-1|0,z=z+4|0;else break},function(b,d,c){b|=0;d|=0;c|=0;var e,f,g,h,m,k,l,n,p,q,y,t,r,u,z,w,C,v,A,E,J;e=c+7|0;f=c+1|0;g=c+6|0;h=c+2|0;m=c+5|0;k=c+3|0;l=c+4|0;n=0;for(p=b;;)if(q=a[d+(n<<2)>>2]|0,y=x[q+c>>0]|0,t=x[q+e>>0]|0,r=+(t+y|0),u=y-t|0,z=+(u|0),t=x[q+f>>0]|0,y=x[q+g>>0]|0,w=+(y+t|0),C=t-y|0,y=x[q+h>>0]|0,t=x[q+
m>>0]|0,v=+(t+y|0),A=y-t|0,t=x[q+k>>0]|0,y=x[q+l>>0]|0,q=+(y+t|0),E=r+q,J=r-q,q=w+v,W[p>>2]=q+E+-1024,W[p+16>>2]=E-q,q=.7071067690849304*(w-v+J),W[p+8>>2]=J+q,W[p+24>>2]=J-q,q=+(A+t-y|0),J=+(C+u|0),v=.3826834261417389*(q-J),w=.5411961078643799*q+v,q=1.3065630197525024*J+v,v=.7071067690849304*+(A+C|0),J=z+v,E=z-v,W[p+20>>2]=E+w,W[p+12>>2]=E-w,W[p+4>>2]=J+q,W[p+28>>2]=J-q,n=n+1|0,8==(n|0)){d=7;c=b;break}else p=p+32|0;for(;;)if(q=+W[c>>2],p=c+224|0,J=+W[p>>2],w=q+J,E=q-J,b=c+32|0,J=+W[b>>2],n=c+192|
0,q=+W[n>>2],v=J+q,z=J-q,l=c+64|0,q=+W[l>>2],k=c+160|0,J=+W[k>>2],r=q+J,e=q-J,m=c+96|0,J=+W[m>>2],h=c+128|0,q=+W[h>>2],f=J+q,g=w+f,w-=f,f=v+r,W[c>>2]=f+g,W[h>>2]=g-f,f=.7071067690849304*(v-r+w),W[l>>2]=w+f,W[n>>2]=w-f,f=e+(J-q),q=E+z,J=.3826834261417389*(f-q),w=.5411961078643799*f+J,f=1.3065630197525024*q+J,J=.7071067690849304*(z+e),e=E+J,z=E-J,W[k>>2]=z+w,W[m>>2]=z-w,W[b>>2]=e+f,W[p>>2]=e-f,0<(d|0))d=d+-1|0,c=c+4|0;else break},$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,
$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b,$b],Ii=[Kh,function(b,d,c,e,f,g,h,m,k){d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,y,t,r,u,z,w,C,v,A,D,J,I,G,L,K,F,R,O,M,T,X,P,Oa,S,Y,ba,W,U,Z,ga=0,Ha=0,ma=0,da=0,ha=0,aa=0,ca=0,fa=0,ja=0,pa=0,ya=0,oa=0,sa=0,ra=0,ua=0;e=N[(b|0)+26>>1]|0;b=E(e,h|0)|0;if(g)for(h=7<f>>>0,c=e+1|0,l=e+2|0,n=e+3|0,p=e<<1,q=p|1,y=p+2|0,t=p+3|0,r=3*e|0,u=r+1|0,z=r+2|0,w=r+3|0,C=e<<2,v=C|1,A=C|2,D=C|3,J=5*e|0,I=J+1|0,G=J+2|0,L=J+3|0,K=6*e|0,F=K|1,R=K+2|0,
O=K+3|0,M=7*e|0,T=M+1|0,X=M+2|0,P=M+3|0,Oa=e<<3,S=f+-8|0,Y=S&-8,ba=S-Y|0,S=Y+8|0,Y=E(S,e)|0,W=k,k=d,d=g;;){d=d+-1|0;if(h){g=W+Y|0;U=k;for(Z=f;!(a[U>>2]=(x[W+1>>0]|0)<<8|x[W>>0]|0|(x[W+2>>0]|0)<<16|(x[W+3>>0]|0)<<24,a[U+4>>2]=(x[W+c>>0]|0)<<8|x[W+e>>0]|0|(x[W+l>>0]|0)<<16|(x[W+n>>0]|0)<<24,a[U+8>>2]=(x[W+q>>0]|0)<<8|x[W+p>>0]|0|(x[W+y>>0]|0)<<16|(x[W+t>>0]|0)<<24,a[U+12>>2]=(x[W+u>>0]|0)<<8|x[W+r>>0]|0|(x[W+z>>0]|0)<<16|(x[W+w>>0]|0)<<24,a[U+16>>2]=(x[W+v>>0]|0)<<8|x[W+C>>0]|0|(x[W+A>>0]|0)<<16|(x[W+
D>>0]|0)<<24,a[U+20>>2]=(x[W+I>>0]|0)<<8|x[W+J>>0]|0|(x[W+G>>0]|0)<<16|(x[W+L>>0]|0)<<24,a[U+24>>2]=(x[W+F>>0]|0)<<8|x[W+K>>0]|0|(x[W+R>>0]|0)<<16|(x[W+O>>0]|0)<<24,a[U+28>>2]=(x[W+T>>0]|0)<<8|x[W+M>>0]|0|(x[W+X>>0]|0)<<16|(x[W+P>>0]|0)<<24,Z=Z+-8|0,7>=Z>>>0);)W=W+Oa|0,U=U+32|0;k=k+(S<<2)|0;W=ba}else g=W,W=f;switch(W|0){case 1:ga=k;Ha=g;ma=14;break;case 7:a[k>>2]=(x[g+1>>0]|0)<<8|x[g>>0]|0|(x[g+2>>0]|0)<<16|(x[g+3>>0]|0)<<24;da=k+4|0;ha=g+e|0;ma=9;break;case 6:da=k;ha=g;ma=9;break;case 5:aa=k;ca=
g;ma=10;break;case 4:fa=k;ja=g;ma=11;break;case 3:pa=k;ya=g;ma=12;break;case 2:oa=k;sa=g;ma=13;break;default:ra=k,ua=g}9==(ma|0)&&(a[da>>2]=(x[ha+1>>0]|0)<<8|x[ha>>0]|0|(x[ha+2>>0]|0)<<16|(x[ha+3>>0]|0)<<24,aa=da+4|0,ca=ha+e|0,ma=10);10==(ma|0)&&(a[aa>>2]=(x[ca+1>>0]|0)<<8|x[ca>>0]|0|(x[ca+2>>0]|0)<<16|(x[ca+3>>0]|0)<<24,fa=aa+4|0,ja=ca+e|0,ma=11);11==(ma|0)&&(a[fa>>2]=(x[ja+1>>0]|0)<<8|x[ja>>0]|0|(x[ja+2>>0]|0)<<16|(x[ja+3>>0]|0)<<24,pa=fa+4|0,ya=ja+e|0,ma=12);12==(ma|0)&&(a[pa>>2]=(x[ya+1>>0]|0)<<
8|x[ya>>0]|0|(x[ya+2>>0]|0)<<16|(x[ya+3>>0]|0)<<24,oa=pa+4|0,sa=ya+e|0,ma=13);13==(ma|0)&&(a[oa>>2]=(x[sa+1>>0]|0)<<8|x[sa>>0]|0|(x[sa+2>>0]|0)<<16|(x[sa+3>>0]|0)<<24,ga=oa+4|0,Ha=sa+e|0,ma=14);14==(ma|0)&&(ma=0,a[ga>>2]=(x[Ha+1>>0]|0)<<8|x[Ha>>0]|0|(x[Ha+2>>0]|0)<<16|(x[Ha+3>>0]|0)<<24,ra=ga+4|0,ua=Ha+e|0);if(d)W=ua+b|0,k=ra+(m<<2)|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,y,t,r;e=N[b+26>>1]|0;c=E(e,h|0)|0;if(g)for(h=0==(f|0),l=b+76|0,b=E(e,f)|0,n=d,d=k,
k=g;;){k=k+-1|0;if(h)g=d;else{g=d+b|0;p=a[l>>2]|0;q=f;for(y=n;;)if(q=q+-1|0,t=x[d+3>>0]|0,r=t<<8,a[y>>2]=x[p+(x[d>>0]|0|r)>>0]|0|t<<24|(x[p+(x[d+1>>0]|0|r)>>0]|0)<<8|(x[p+(x[d+2>>0]|0|r)>>0]|0)<<16,q)d=d+e|0,y=y+4|0;else break;n=n+(f<<2)|0}if(k)n=n+(m<<2)|0,d=g+c|0;else break}},function(b,d,c,e,f,g,h,m,k){d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,y,t,r,u,z,w,C,v,A,D,J,I,G,L,K,F,R,O,M,T,X,P,S=0,Y=0,W=0,ba=0,U=0,Z=0,da=0,ga=0,Ha=0,ma=0,aa=0,ha=0,ca=0,fa=0,ja=0;e=N[(b|0)+26>>1]|0;b=E(e,h|0)|0;if(g)for(h=
7<f>>>0,c=e+1|0,l=e+2|0,n=e<<1,p=n|1,q=n+2|0,y=3*e|0,t=y+1|0,r=y+2|0,u=e<<2,z=u|1,w=u|2,C=5*e|0,v=C+1|0,A=C+2|0,D=6*e|0,J=D|1,I=D+2|0,G=7*e|0,L=G+1|0,K=G+2|0,F=e<<3,R=f+-8|0,O=R&-8,M=R-O|0,R=O+8|0,O=E(R,e)|0,T=k,k=d,d=g;;){d=d+-1|0;if(h){g=T+O|0;X=k;for(P=f;!(a[X>>2]=x[T>>0]|0|(x[T+1>>0]|0)<<8|(x[T+2>>0]|0)<<16|-16777216,a[X+4>>2]=x[T+e>>0]|0|(x[T+c>>0]|0)<<8|(x[T+l>>0]|0)<<16|-16777216,a[X+8>>2]=x[T+n>>0]|0|(x[T+p>>0]|0)<<8|(x[T+q>>0]|0)<<16|-16777216,a[X+12>>2]=x[T+y>>0]|0|(x[T+t>>0]|0)<<8|(x[T+
r>>0]|0)<<16|-16777216,a[X+16>>2]=x[T+u>>0]|0|(x[T+z>>0]|0)<<8|(x[T+w>>0]|0)<<16|-16777216,a[X+20>>2]=x[T+C>>0]|0|(x[T+v>>0]|0)<<8|(x[T+A>>0]|0)<<16|-16777216,a[X+24>>2]=x[T+D>>0]|0|(x[T+J>>0]|0)<<8|(x[T+I>>0]|0)<<16|-16777216,a[X+28>>2]=x[T+G>>0]|0|(x[T+L>>0]|0)<<8|(x[T+K>>0]|0)<<16|-16777216,P=P+-8|0,7>=P>>>0);)T=T+F|0,X=X+32|0;k=k+(R<<2)|0;T=M}else g=T,T=f;switch(T|0){case 1:S=k;Y=g;W=14;break;case 7:a[k>>2]=x[g>>0]|0|(x[g+1>>0]|0)<<8|(x[g+2>>0]|0)<<16|-16777216;ba=k+4|0;U=g+e|0;W=9;break;case 6:ba=
k;U=g;W=9;break;case 5:Z=k;da=g;W=10;break;case 4:ga=k;Ha=g;W=11;break;case 3:ma=k;aa=g;W=12;break;case 2:ha=k;ca=g;W=13;break;default:fa=k,ja=g}9==(W|0)&&(a[ba>>2]=x[U>>0]|0|(x[U+1>>0]|0)<<8|(x[U+2>>0]|0)<<16|-16777216,Z=ba+4|0,da=U+e|0,W=10);10==(W|0)&&(a[Z>>2]=x[da>>0]|0|(x[da+1>>0]|0)<<8|(x[da+2>>0]|0)<<16|-16777216,ga=Z+4|0,Ha=da+e|0,W=11);11==(W|0)&&(a[ga>>2]=x[Ha>>0]|0|(x[Ha+1>>0]|0)<<8|(x[Ha+2>>0]|0)<<16|-16777216,ma=ga+4|0,aa=Ha+e|0,W=12);12==(W|0)&&(a[ma>>2]=x[aa>>0]|0|(x[aa+1>>0]|0)<<8|
(x[aa+2>>0]|0)<<16|-16777216,ha=ma+4|0,ca=aa+e|0,W=13);13==(W|0)&&(a[ha>>2]=x[ca>>0]|0|(x[ca+1>>0]|0)<<8|(x[ca+2>>0]|0)<<16|-16777216,S=ha+4|0,Y=ca+e|0,W=14);14==(W|0)&&(W=0,a[S>>2]=x[Y>>0]|0|(x[Y+1>>0]|0)<<8|(x[Y+2>>0]|0)<<16|-16777216,fa=S+4|0,ja=Y+e|0);if(d)T=ja+b|0,k=fa+(m<<2)|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,y;e=N[b+26>>1]|0;c=E(e,h|0)|0;if(g)for(h=0==(f|0),l=b+80|0,b=E(e,f)|0,n=d,d=g,g=k;;){d=d+-1|0;if(h)k=g;else{k=g+(b<<1)|0;p=a[l>>2]|0;q=
f;for(y=n;;)if(q=q+-1|0,a[y>>2]=(x[p+(N[g+2>>1]|0)>>0]|0)<<8|x[p+(N[g>>1]|0)>>0]|0|(x[p+(N[g+4>>1]|0)>>0]|0)<<16|(x[p+(N[g+6>>1]|0)>>0]|0)<<24,q)y=y+4|0,g=g+(e<<1)|0;else break;n=n+(f<<2)|0}if(d)n=n+(m<<2)|0,g=k+(c<<1)|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,y,t,r,u,z;e=N[b+26>>1]|0;c=E(e,h|0)|0;if(g)for(h=0==(f|0),l=b+80|0,n=b+76|0,b=E(e,f)|0,p=d,d=g,g=k;;){d=d+-1|0;if(h)k=g;else{k=g+(b<<1)|0;q=a[l>>2]|0;y=a[n>>2]|0;t=f;for(r=p;;)if(t=t+-1|0,u=x[q+(N[g+
6>>1]|0)>>0]|0,z=u<<8,a[r>>2]=x[y+(x[q+(N[g>>1]|0)>>0]|0|z)>>0]|0|u<<24|(x[y+(x[q+(N[g+2>>1]|0)>>0]|0|z)>>0]|0)<<8|(x[y+(x[q+(N[g+4>>1]|0)>>0]|0|z)>>0]|0)<<16,t)r=r+4|0,g=g+(e<<1)|0;else break;p=p+(f<<2)|0}if(d)p=p+(m<<2)|0,g=k+(c<<1)|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,y;e=N[b+26>>1]|0;c=E(e,h|0)|0;if(g)for(h=0==(f|0),l=b+80|0,b=E(e,f)|0,n=d,d=g,g=k;;){d=d+-1|0;if(h)k=g;else{k=g+(b<<1)|0;p=a[l>>2]|0;q=f;for(y=n;;)if(q=q+-1|0,a[y>>2]=x[p+(N[g>>1]|0)>>
0]|0|(x[p+(N[g+2>>1]|0)>>0]|0)<<8|(x[p+(N[g+4>>1]|0)>>0]|0)<<16|-16777216,q)y=y+4|0,g=g+(e<<1)|0;else break;n=n+(f<<2)|0}if(d)n=n+(m<<2)|0,g=k+(c<<1)|0;else break}},function(b,d,c,e,f,g,h,m,k){d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,y,t,r,u,z,w,C,v,A,D,J,I,G,L,K,F,R,O,M,T,X,P,S,Y,W,ba,U,Z,da,ga,Ha,ma,aa,ha=0,ca=0,fa=0,ja=0,pa=0,ya=0,ra=0,oa=0,sa=0,Aa=0,ua=0,Ia=0,Da=0,na=0,Na=0;e=N[(b|0)+26>>1]|0;b=E(e,h|0)|0;if(g)for(h=7<f>>>0,c=e+3|0,l=e+1|0,n=e+2|0,p=e<<1,q=p+3|0,y=p|1,t=p+2|0,r=3*e|0,u=r+3|0,z=r+
1|0,w=r+2|0,C=e<<2,v=C|3,A=C|1,D=C|2,J=5*e|0,I=J+3|0,G=J+1|0,L=J+2|0,K=6*e|0,F=K+3|0,R=K|1,O=K+2|0,M=7*e|0,T=M+3|0,X=M+1|0,P=M+2|0,S=e<<3,Y=f+-8|0,W=Y&-8,ba=Y-W|0,Y=W+8|0,W=E(Y,e)|0,U=k,k=d,d=g;;){d=d+-1|0;if(h){g=U+W|0;Z=k;for(da=f;!(ga=(x[U+3>>0]|0)^255,Ha=((E((x[U>>0]|0)^255,ga)|0)>>>0)/255|0,ma=((E((x[U+1>>0]|0)^255,ga)|0)>>>0)/255|0,aa=Ha|ma<<8|(((E((x[U+2>>0]|0)^255,ga)|0)>>>0)/255|0)<<16|-16777216,a[Z>>2]=aa,aa=(x[U+c>>0]|0)^255,ga=((E((x[U+e>>0]|0)^255,aa)|0)>>>0)/255|0,ma=((E((x[U+l>>0]|
0)^255,aa)|0)>>>0)/255|0,Ha=ga|ma<<8|(((E((x[U+n>>0]|0)^255,aa)|0)>>>0)/255|0)<<16|-16777216,a[Z+4>>2]=Ha,Ha=(x[U+q>>0]|0)^255,aa=((E((x[U+p>>0]|0)^255,Ha)|0)>>>0)/255|0,ma=((E((x[U+y>>0]|0)^255,Ha)|0)>>>0)/255|0,ga=aa|ma<<8|(((E((x[U+t>>0]|0)^255,Ha)|0)>>>0)/255|0)<<16|-16777216,a[Z+8>>2]=ga,ga=(x[U+u>>0]|0)^255,Ha=((E((x[U+r>>0]|0)^255,ga)|0)>>>0)/255|0,ma=((E((x[U+z>>0]|0)^255,ga)|0)>>>0)/255|0,aa=Ha|ma<<8|(((E((x[U+w>>0]|0)^255,ga)|0)>>>0)/255|0)<<16|-16777216,a[Z+12>>2]=aa,aa=(x[U+v>>0]|0)^255,
ga=((E((x[U+C>>0]|0)^255,aa)|0)>>>0)/255|0,ma=((E((x[U+A>>0]|0)^255,aa)|0)>>>0)/255|0,Ha=ga|ma<<8|(((E((x[U+D>>0]|0)^255,aa)|0)>>>0)/255|0)<<16|-16777216,a[Z+16>>2]=Ha,Ha=(x[U+I>>0]|0)^255,aa=((E((x[U+J>>0]|0)^255,Ha)|0)>>>0)/255|0,ma=((E((x[U+G>>0]|0)^255,Ha)|0)>>>0)/255|0,ga=aa|ma<<8|(((E((x[U+L>>0]|0)^255,Ha)|0)>>>0)/255|0)<<16|-16777216,a[Z+20>>2]=ga,ga=(x[U+F>>0]|0)^255,Ha=((E((x[U+K>>0]|0)^255,ga)|0)>>>0)/255|0,ma=((E((x[U+R>>0]|0)^255,ga)|0)>>>0)/255|0,aa=Ha|ma<<8|(((E((x[U+O>>0]|0)^255,ga)|
0)>>>0)/255|0)<<16|-16777216,a[Z+24>>2]=aa,aa=(x[U+T>>0]|0)^255,ga=((E((x[U+M>>0]|0)^255,aa)|0)>>>0)/255|0,ma=((E((x[U+X>>0]|0)^255,aa)|0)>>>0)/255|0,Ha=ga|ma<<8|(((E((x[U+P>>0]|0)^255,aa)|0)>>>0)/255|0)<<16|-16777216,a[Z+28>>2]=Ha,da=da+-8|0,7>=da>>>0);)U=U+S|0,Z=Z+32|0;k=k+(Y<<2)|0;U=ba}else g=U,U=f;switch(U|0){case 1:ha=k;ca=g;fa=14;break;case 7:Z=(x[g+3>>0]|0)^255;U=((E((x[g>>0]|0)^255,Z)|0)>>>0)/255|0;da=U|(((E((x[g+1>>0]|0)^255,Z)|0)>>>0)/255|0)<<8|(((E((x[g+2>>0]|0)^255,Z)|0)>>>0)/255|0)<<
16|-16777216;a[k>>2]=da;ja=k+4|0;pa=g+e|0;fa=9;break;case 6:ja=k;pa=g;fa=9;break;case 5:ya=k;ra=g;fa=10;break;case 4:oa=k;sa=g;fa=11;break;case 3:Aa=k;ua=g;fa=12;break;case 2:Ia=k;Da=g;fa=13;break;default:na=k,Na=g}9==(fa|0)&&(da=(x[pa+3>>0]|0)^255,Z=((E((x[pa>>0]|0)^255,da)|0)>>>0)/255|0,U=((E((x[pa+1>>0]|0)^255,da)|0)>>>0)/255|0,Ha=Z|U<<8|(((E((x[pa+2>>0]|0)^255,da)|0)>>>0)/255|0)<<16|-16777216,a[ja>>2]=Ha,ya=ja+4|0,ra=pa+e|0,fa=10);10==(fa|0)&&(Ha=(x[ra+3>>0]|0)^255,da=((E((x[ra>>0]|0)^255,Ha)|
0)>>>0)/255|0,U=((E((x[ra+1>>0]|0)^255,Ha)|0)>>>0)/255|0,Z=da|U<<8|(((E((x[ra+2>>0]|0)^255,Ha)|0)>>>0)/255|0)<<16|-16777216,a[ya>>2]=Z,oa=ya+4|0,sa=ra+e|0,fa=11);11==(fa|0)&&(Z=(x[sa+3>>0]|0)^255,Ha=((E((x[sa>>0]|0)^255,Z)|0)>>>0)/255|0,U=((E((x[sa+1>>0]|0)^255,Z)|0)>>>0)/255|0,da=Ha|U<<8|(((E((x[sa+2>>0]|0)^255,Z)|0)>>>0)/255|0)<<16|-16777216,a[oa>>2]=da,Aa=oa+4|0,ua=sa+e|0,fa=12);12==(fa|0)&&(da=(x[ua+3>>0]|0)^255,Z=((E((x[ua>>0]|0)^255,da)|0)>>>0)/255|0,U=((E((x[ua+1>>0]|0)^255,da)|0)>>>0)/255|
0,Ha=Z|U<<8|(((E((x[ua+2>>0]|0)^255,da)|0)>>>0)/255|0)<<16|-16777216,a[Aa>>2]=Ha,Ia=Aa+4|0,Da=ua+e|0,fa=13);13==(fa|0)&&(Ha=(x[Da+3>>0]|0)^255,da=((E((x[Da>>0]|0)^255,Ha)|0)>>>0)/255|0,U=((E((x[Da+1>>0]|0)^255,Ha)|0)>>>0)/255|0,Z=da|U<<8|(((E((x[Da+2>>0]|0)^255,Ha)|0)>>>0)/255|0)<<16|-16777216,a[Ia>>2]=Z,ha=Ia+4|0,ca=Da+e|0,fa=14);14==(fa|0)&&(fa=0,Z=(x[ca+3>>0]|0)^255,Ha=((E((x[ca>>0]|0)^255,Z)|0)>>>0)/255|0,U=((E((x[ca+1>>0]|0)^255,Z)|0)>>>0)/255|0,da=Ha|U<<8|(((E((x[ca+2>>0]|0)^255,Z)|0)>>>0)/
255|0)<<16|-16777216,a[ha>>2]=da,na=ha+4|0,Na=ca+e|0);if(d)U=Na+b|0,k=na+(m<<2)|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,y,t,r;e=N[b+26>>1]|0;c=a[b+56>>2]|0;b=E(e,h|0)|0;if(g)for(h=0==(f|0),l=E(e,f)|0,n=d,d=k,k=g;;){k=k+-1|0;if(h)g=d;else{g=d+l|0;p=f;for(q=n;;)if(p=p+-1|0,y=(x[d+3>>0]|0)^255,t=((E((x[d>>0]|0)^255,y)|0)>>>0)/255|0,r=((E((x[d+1>>0]|0)^255,y)|0)>>>0)/255|0,y=((E((x[d+2>>0]|0)^255,y)|0)>>>0)/255|0,a[q>>2]=x[c+t>>0]|0|(x[c+r>>0]|0)<<8|(x[c+y>>
0]|0)<<16|-16777216,p)d=d+e|0,q=q+4|0;else break;n=n+(f<<2)|0}if(k)n=n+(m<<2)|0,d=g+b|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;h|=0;m|=0;k|=0;var l,n,p,q;e=a[b+64>>2]|0;c=N[b+26>>1]|0;if(g)for(b=0==(f|0),l=E(c,f)|0,n=d,d=k,k=g;;){k=k+-1|0;if(b)g=d;else{g=d+l|0;p=f;for(q=n;;)if(p=p+-1|0,a[q>>2]=a[a[e+((x[d>>0]|0)<<2)>>2]>>2],p)d=d+c|0,q=q+4|0;else break;n=n+(f<<2)|0}if(k)n=n+(m<<2)|0,d=g+h|0;else break}},function(b,d,c,e,f,g,h,m,k){f|=0;g|=0;m|=0;var l,n,p,q,y,t;e=a[(b|0)+64>>
2]|0;b=(h|0)/2|0;if(g)for(h=1<f>>>0,c=f+-2|0,l=c>>>1,n=l<<1,p=c-n|0,c=n+2|0,n=l+1|0,l=d|0,d=k|0,k=g;;){k=k+-1|0;if(h){g=l+(c<<2)|0;q=d;for(y=f;!(t=a[e+((x[q>>0]|0)<<2)>>2]|0,a[l>>2]=a[t>>2],a[l+4>>2]=a[t+4>>2],y=y+-2|0,1>=y>>>0);)q=q+1|0,l=l+8|0;d=d+n|0;q=p}else g=l,q=f;q&&(a[g>>2]=a[a[e+((x[d>>0]|0)<<2)>>2]>>2],g=g+4|0,d=d+1|0);if(k)l=g+(m<<2)|0,d=d+b|0;else break}},function(b,d,c,e,f,g,h,m,k){f|=0;g|=0;m|=0;var l,n,p,q,y,t,r=0,u=0,z=0,w=0,C=0;e=a[(b|0)+64>>2]|0;b=(h|0)/4|0;if(g)for(h=3<f>>>0,c=
f+-4|0,l=c>>>2,n=l<<2,p=c-n|0,c=n+4|0,n=l+1|0,l=d|0,d=k|0,k=g;;){k=k+-1|0;if(h){g=l+(c<<2)|0;q=d;for(y=f;!(t=a[e+((x[q>>0]|0)<<2)>>2]|0,a[l>>2]=a[t>>2],a[l+4>>2]=a[t+4>>2],a[l+8>>2]=a[t+8>>2],a[l+12>>2]=a[t+12>>2],y=y+-4|0,3>=y>>>0);)q=q+1|0,l=l+16|0;d=d+n|0;y=p}else g=l,y=f;a:do if(y){l=d+1|0;q=a[e+((x[d>>0]|0)<<2)>>2]|0;switch(y|0){case 3:a[g>>2]=a[q>>2];r=g+4|0;u=q+4|0;z=10;break;case 2:r=g;u=q;z=10;break;case 1:w=g;C=q;break;default:q=l;l=g;break a}10==(z|0)&&(z=0,a[r>>2]=a[u>>2],w=r+4|0,C=u+
4|0);a[w>>2]=a[C>>2];q=l;l=w+4|0}else q=d,l=g;while(0);if(k)l=l+(m<<2)|0,d=q+b|0;else break}},function(b,d,c,e,f,g,h,m,k){f|=0;g|=0;m|=0;var l,n,p,q,y,t,r=0,u=0,z=0,w=0,C=0,v=0,A=0,E=0,J=0,I=0,G=0,L=0,K=0;e=a[(b|0)+64>>2]|0;b=(h|0)/8|0;if(g)for(h=7<f>>>0,c=f+-8|0,l=c>>>3,n=l<<3,p=c-n|0,c=n+8|0,n=l+1|0,l=d|0,d=k|0,k=g;;){k=k+-1|0;if(h){g=l+(c<<2)|0;q=d;for(y=f;!(t=a[e+((x[q>>0]|0)<<2)>>2]|0,a[l>>2]=a[t>>2],a[l+4>>2]=a[t+4>>2],a[l+8>>2]=a[t+8>>2],a[l+12>>2]=a[t+12>>2],a[l+16>>2]=a[t+16>>2],a[l+20>>
2]=a[t+20>>2],a[l+24>>2]=a[t+24>>2],a[l+28>>2]=a[t+28>>2],y=y+-8|0,7>=y>>>0);)q=q+1|0,l=l+32|0;d=d+n|0;y=p}else g=l,y=f;a:do if(y){l=d+1|0;q=a[e+((x[d>>0]|0)<<2)>>2]|0;switch(y|0){case 7:a[g>>2]=a[q>>2];r=g+4|0;u=q+4|0;z=10;break;case 6:r=g;u=q;z=10;break;case 5:w=g;C=q;z=11;break;case 4:v=g;A=q;z=12;break;case 3:E=g;J=q;z=13;break;case 2:I=g;G=q;z=14;break;case 1:L=g;K=q;break;default:q=l;l=g;break a}10==(z|0)&&(a[r>>2]=a[u>>2],w=r+4|0,C=u+4|0,z=11);11==(z|0)&&(a[w>>2]=a[C>>2],v=w+4|0,A=C+4|0,z=
12);12==(z|0)&&(a[v>>2]=a[A>>2],E=v+4|0,J=A+4|0,z=13);13==(z|0)&&(a[E>>2]=a[J>>2],I=E+4|0,G=J+4|0,z=14);14==(z|0)&&(z=0,a[I>>2]=a[G>>2],L=I+4|0,K=G+4|0);a[L>>2]=a[K>>2];q=l;l=L+4|0}else q=d,l=g;while(0);if(k)l=l+(m<<2)|0,d=q+b|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;h|=0;m|=0;k|=0;var l,n,p,q;e=N[b+26>>1]|0;c=a[b+60>>2]|0;if(g)for(b=0==(f|0),l=(E(e,f)|0)<<1,n=d,d=k,k=g;;){k=k+-1|0;if(b)g=d;else{g=d+l|0;p=f;for(q=n;;)if(p=p+-1|0,a[q>>2]=a[a[c+((N[d>>1]|0)>>>8<<2)>>2]>>2],p)q=
q+4|0,d=d+(e<<1)|0;else break;n=n+(f<<2)|0}if(k)n=n+(m<<2)|0,d=g+h|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;h|=0;m|=0;k|=0;var l,n,p,q;e=N[b+26>>1]|0;c=a[b+60>>2]|0;if(g)for(b=0==(f|0),l=E(e,f)|0,n=d,d=k,k=g;;){k=k+-1|0;if(b)g=d;else{g=d+l|0;p=f;for(q=n;;)if(p=p+-1|0,a[q>>2]=((x[d+1>>0]|0)<<24|16777215)&a[a[c+((x[d>>0]|0)<<2)>>2]>>2],p)d=d+e|0,q=q+4|0;else break;n=n+(f<<2)|0}if(k)n=n+(m<<2)|0,d=g+h|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;h|=0;m|=0;k|=0;
var l,n,p,q;e=N[b+26>>1]|0;c=a[b+60>>2]|0;if(g)for(b=0==(f|0),l=E(e,f)|0,n=d,d=k,k=g;;){k=k+-1|0;if(b)g=d;else{g=d+l|0;p=f;for(q=n;;)if(p=p+-1|0,a[q>>2]=a[a[c+((x[d>>0]|0)<<2)>>2]>>2],p)d=d+e|0,q=q+4|0;else break;n=n+(f<<2)|0}if(k)n=n+(m<<2)|0,d=g+h|0;else break}},function(b,d,c,e,f,g,h,m,k){f|=0;g|=0;m|=0;var l,n,p,q,t,r;e=a[(b|0)+60>>2]|0;b=(h|0)/2|0;if(g)for(h=1<f>>>0,c=f+-2|0,l=c>>>1,n=l<<1,p=c-n|0,c=n+2|0,n=l+1|0,l=d|0,d=k|0,k=g;;){k=k+-1|0;if(h){g=l+(c<<2)|0;q=d;for(t=f;!(r=a[e+((x[q>>0]|0)<<
2)>>2]|0,a[l>>2]=a[r>>2],a[l+4>>2]=a[r+4>>2],t=t+-2|0,1>=t>>>0);)q=q+1|0,l=l+8|0;d=d+n|0;q=p}else g=l,q=f;q&&(a[g>>2]=a[a[e+((x[d>>0]|0)<<2)>>2]>>2],g=g+4|0,d=d+1|0);if(k)l=g+(m<<2)|0,d=d+b|0;else break}},function(b,d,c,e,f,g,h,m,k){f|=0;g|=0;m|=0;var l,n,p,q,t,r,u=0,w=0,z=0,v=0,C=0;e=a[(b|0)+60>>2]|0;b=(h|0)/4|0;if(g)for(h=3<f>>>0,c=f+-4|0,l=c>>>2,n=l<<2,p=c-n|0,c=n+4|0,n=l+1|0,l=d|0,d=k|0,k=g;;){k=k+-1|0;if(h){g=l+(c<<2)|0;q=d;for(t=f;!(r=a[e+((x[q>>0]|0)<<2)>>2]|0,a[l>>2]=a[r>>2],a[l+4>>2]=a[r+
4>>2],a[l+8>>2]=a[r+8>>2],a[l+12>>2]=a[r+12>>2],t=t+-4|0,3>=t>>>0);)q=q+1|0,l=l+16|0;d=d+n|0;t=p}else g=l,t=f;a:do if(t){l=d+1|0;q=a[e+((x[d>>0]|0)<<2)>>2]|0;switch(t|0){case 3:a[g>>2]=a[q>>2];u=g+4|0;w=q+4|0;z=10;break;case 2:u=g;w=q;z=10;break;case 1:v=g;C=q;break;default:q=l;l=g;break a}10==(z|0)&&(z=0,a[u>>2]=a[w>>2],v=u+4|0,C=w+4|0);a[v>>2]=a[C>>2];q=l;l=v+4|0}else q=d,l=g;while(0);if(k)l=l+(m<<2)|0,d=q+b|0;else break}},function(b,d,c,e,f,g,h,m,k){f|=0;g|=0;m|=0;var l,n,p,q,t,r,u=0,w=0,z=0,v=
0,C=0,A=0,V=0,E=0,J=0,I=0,G=0,L=0,K=0;e=a[(b|0)+60>>2]|0;b=(h|0)/8|0;if(g)for(h=7<f>>>0,c=f+-8|0,l=c>>>3,n=l<<3,p=c-n|0,c=n+8|0,n=l+1|0,l=d|0,d=k|0,k=g;;){k=k+-1|0;if(h){g=l+(c<<2)|0;q=d;for(t=f;!(r=a[e+((x[q>>0]|0)<<2)>>2]|0,a[l>>2]=a[r>>2],a[l+4>>2]=a[r+4>>2],a[l+8>>2]=a[r+8>>2],a[l+12>>2]=a[r+12>>2],a[l+16>>2]=a[r+16>>2],a[l+20>>2]=a[r+20>>2],a[l+24>>2]=a[r+24>>2],a[l+28>>2]=a[r+28>>2],t=t+-8|0,7>=t>>>0);)q=q+1|0,l=l+32|0;d=d+n|0;t=p}else g=l,t=f;a:do if(t){l=d+1|0;q=a[e+((x[d>>0]|0)<<2)>>2]|0;
switch(t|0){case 7:a[g>>2]=a[q>>2];u=g+4|0;w=q+4|0;z=10;break;case 6:u=g;w=q;z=10;break;case 5:v=g;C=q;z=11;break;case 4:A=g;V=q;z=12;break;case 3:E=g;J=q;z=13;break;case 2:I=g;G=q;z=14;break;case 1:L=g;K=q;break;default:q=l;l=g;break a}10==(z|0)&&(a[u>>2]=a[w>>2],v=u+4|0,C=w+4|0,z=11);11==(z|0)&&(a[v>>2]=a[C>>2],A=v+4|0,V=C+4|0,z=12);12==(z|0)&&(a[A>>2]=a[V>>2],E=A+4|0,J=V+4|0,z=13);13==(z|0)&&(a[E>>2]=a[J>>2],I=E+4|0,G=J+4|0,z=14);14==(z|0)&&(z=0,a[I>>2]=a[G>>2],L=I+4|0,K=G+4|0);a[L>>2]=a[K>>2];
q=l;l=L+4|0}else q=d,l=g;while(0);if(k)l=l+(m<<2)|0,d=q+b|0;else break}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;c|=0;e|=0;f|=0;g|=0;h|=0;m|=0;k|=0;var l=0,n=0,p=0,q=0,t=0,r=0,w=0,v=0,z=0,Q=0,C=0,A=0,V=0,E=0,J=0,I=0,G=0,L=0,K=0,D=0,F=0,O=0,M=0,T=0,X=0,P=0,N=0,R=0,S=0,ba=0,Y=0,W=0,U=0,ga=0,Z=0,ma=0,da=0,ha=0,aa=0,ca=0,fa=0,ja=0,pa=0,ya=0,oa=0,sa=0,ra=0,ua=0,Ia=0,Da=0,na=0,Na=0,Aa=0,Ca=0,Ga=0,Ea=0,La=0,Ka=0,Qa=0,Wa=0,Va=0,xb=0,Zb=0,eb=0,jb=0,mc=0,pb=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,
ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,ub=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,ab=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,rb=0,Ua=0,fb=0,Jb=0,Ab=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,lb=0,Hb=0,Wb=0,Lb=0,wb=0,Gb=0,db=0,zb=0,Ob=0,Tb=0,Sb=0,Pb=0,Qb=0;e=u;u=u+384|0;c=e+380|0;l=e+376|0;n=e+372|0;p=e+368|0;q=e+364|0;t=e+360|0;r=e+356|0;w=e+352|0;v=e+348|0;z=e+344|0;Q=e+340|0;C=e+336|0;A=e+332|0;V=e+328|0;E=e+324|0;J=e+320|0;I=e+316|0;G=e+312|0;L=e+308|0;K=e+304|0;D=e+300|0;F=e+296|
0;O=e+292|0;M=e+288|0;T=e+284|0;X=e+280|0;P=e+276|0;N=e+272|0;R=e+268|0;S=e+264|0;ba=e+260|0;Y=e+256|0;W=e+252|0;U=e+248|0;ga=e+244|0;Z=e+240|0;ma=e+236|0;da=e+232|0;ha=e+228|0;aa=e+224|0;ca=e+220|0;fa=e+216|0;ja=e+212|0;pa=e+208|0;ya=e+204|0;oa=e+200|0;sa=e+196|0;ra=e+192|0;ua=e+188|0;Ia=e+184|0;Da=e+180|0;na=e+176|0;Na=e+172|0;Aa=e+168|0;Ca=e+164|0;Ga=e+160|0;Ea=e+156|0;La=e+152|0;Ka=e+148|0;Qa=e+144|0;Wa=e+140|0;Va=e+136|0;xb=e+132|0;Zb=e+128|0;eb=e+124|0;jb=e+120|0;mc=e+116|0;pb=e+112|0;Ta=e+
108|0;Ya=e+104|0;Sa=e+100|0;mb=e+96|0;Db=e+92|0;cc=e+88|0;Za=e+84|0;ia=e+80|0;qa=e+76|0;Ja=e+72|0;ea=e+68|0;wa=e+64|0;Ma=e+60|0;xa=e+56|0;$a=e+52|0;la=e+48|0;Ba=e+44|0;va=e+40|0;za=e+36|0;ta=e+32|0;nb=e+28|0;ub=e+24|0;gb=e+20|0;hb=e+16|0;ob=e+12|0;Bb=e+8|0;qb=e+4|0;kb=e;ib=m+f|0;Cb=d+(ib<<2)|0;ab=d+(ib<<1<<2)|0;sb=d+(3*ib<<2)|0;ib=(m<<2)+(3*f|0)|0;m=(18*h|0)/4|0;if((g|f)&3)if(g){tb=0==(f|0);fb=b+68|0;b=g;g=d;d=k;k=Cb;Cb=ab;for(ab=sb;;){a:do if(tb)Hb=g,Wb=d,Lb=k,wb=Cb,Gb=ab;else{sb=f;vb=g;Ua=d;Eb=
k;rb=Cb;for(Fa=ab;;){Mb=x[Ua+16>>0]|0;Pa=x[Ua+17>>0]|0;switch(sb|0){case 3:db=16;break;case 2:db=21;break;case 1:break;default:switch(b|0){case 3:db=13;break;case 2:db=14;break;case 1:break;default:Kb(a[fb>>2]|0,x[Ua+15>>0]|0,Mb,Pa,ua,Ia,Da),a[Fa+12>>2]=a[ua>>2]|a[Ia>>2]<<8|a[Da>>2]<<16|-16777216,db=13}13==(db|0)&&(db=0,Kb(a[fb>>2]|0,x[Ua+11>>0]|0,Mb,Pa,na,Na,Aa),a[rb+12>>2]=a[na>>2]|a[Na>>2]<<8|a[Aa>>2]<<16|-16777216,db=14);14==(db|0)&&(db=0,Kb(a[fb>>2]|0,x[Ua+7>>0]|0,Mb,Pa,Ca,Ga,Ea),a[Eb+12>>2]=
a[Ca>>2]|a[Ga>>2]<<8|a[Ea>>2]<<16|-16777216);Kb(a[fb>>2]|0,x[Ua+3>>0]|0,Mb,Pa,La,Ka,Qa);a[vb+12>>2]=a[La>>2]|a[Ka>>2]<<8|a[Qa>>2]<<16|-16777216;db=16}if(16==(db|0)){db=0;switch(b|0){case 3:db=18;break;case 2:db=19;break;case 1:break;default:Kb(a[fb>>2]|0,x[Ua+14>>0]|0,Mb,Pa,Wa,Va,xb),a[Fa+8>>2]=a[Wa>>2]|a[Va>>2]<<8|a[xb>>2]<<16|-16777216,db=18}18==(db|0)&&(db=0,Kb(a[fb>>2]|0,x[Ua+10>>0]|0,Mb,Pa,Zb,eb,jb),a[rb+8>>2]=a[Zb>>2]|a[eb>>2]<<8|a[jb>>2]<<16|-16777216,db=19);19==(db|0)&&(db=0,Kb(a[fb>>2]|0,
x[Ua+6>>0]|0,Mb,Pa,mc,pb,Ta),a[Eb+8>>2]=a[mc>>2]|a[pb>>2]<<8|a[Ta>>2]<<16|-16777216);Kb(a[fb>>2]|0,x[Ua+2>>0]|0,Mb,Pa,Ya,Sa,mb);a[vb+8>>2]=a[Ya>>2]|a[Sa>>2]<<8|a[mb>>2]<<16|-16777216;db=21}if(21==(db|0)){db=0;switch(b|0){case 3:db=23;break;case 2:db=24;break;case 1:break;default:Kb(a[fb>>2]|0,x[Ua+13>>0]|0,Mb,Pa,Db,cc,Za),a[Fa+4>>2]=a[Db>>2]|a[cc>>2]<<8|a[Za>>2]<<16|-16777216,db=23}23==(db|0)&&(db=0,Kb(a[fb>>2]|0,x[Ua+9>>0]|0,Mb,Pa,ia,qa,Ja),a[rb+4>>2]=a[ia>>2]|a[qa>>2]<<8|a[Ja>>2]<<16|-16777216,
db=24);24==(db|0)&&(db=0,Kb(a[fb>>2]|0,x[Ua+5>>0]|0,Mb,Pa,ea,wa,Ma),a[Eb+4>>2]=a[ea>>2]|a[wa>>2]<<8|a[Ma>>2]<<16|-16777216);Kb(a[fb>>2]|0,x[Ua+1>>0]|0,Mb,Pa,xa,$a,la);a[vb+4>>2]=a[xa>>2]|a[$a>>2]<<8|a[la>>2]<<16|-16777216}switch(b|0){case 3:db=28;break;case 2:db=29;break;case 1:break;default:Kb(a[fb>>2]|0,x[Ua+12>>0]|0,Mb,Pa,Ba,va,za),a[Fa>>2]=a[Ba>>2]|a[va>>2]<<8|a[za>>2]<<16|-16777216,db=28}28==(db|0)&&(db=0,Kb(a[fb>>2]|0,x[Ua+8>>0]|0,Mb,Pa,ta,nb,ub),a[rb>>2]=a[ta>>2]|a[nb>>2]<<8|a[ub>>2]<<16|-16777216,
db=29);29==(db|0)&&(db=0,Kb(a[fb>>2]|0,x[Ua+4>>0]|0,Mb,Pa,gb,hb,ob),a[Eb>>2]=a[gb>>2]|a[hb>>2]<<8|a[ob>>2]<<16|-16777216);Kb(a[fb>>2]|0,x[Ua>>0]|0,Mb,Pa,Bb,qb,kb);a[vb>>2]=a[Bb>>2]|a[qb>>2]<<8|a[kb>>2]<<16|-16777216;if(4>sb>>>0){zb=sb;Ob=vb;Tb=Ua;Sb=Eb;Pb=rb;Qb=Fa;break}Pa=vb+16|0;Mb=Eb+16|0;bb=rb+16|0;Ib=Fa+16|0;sb=sb+-4|0;ra=Ua+18|0;if(sb)vb=Pa,Ua=ra,Eb=Mb,rb=bb,Fa=Ib;else{Hb=Pa;Wb=ra;Lb=Mb;wb=bb;Gb=Ib;break a}}Hb=Ob+(zb<<2)|0;Wb=Tb+18|0;Lb=Sb+(zb<<2)|0;wb=Pb+(zb<<2)|0;Gb=Qb+(zb<<2)|0}while(0);
if(5>b>>>0){db=35;break}if(b=b+-4|0)g=Hb+(ib<<2)|0,d=Wb+m|0,k=Lb+(ib<<2)|0,Cb=wb+(ib<<2)|0,ab=Gb+(ib<<2)|0;else{db=35;break}}35==(db|0)&&(u=e)}else u=e;else{if(!(3>=g>>>0))for(h=f>>>2,Xa=b+68|0,Fa=h<<2,Pa=Fa+ib|0,Eb=Fa+ib|0,vb=Fa+ib|0,tb=Fa+ib|0,Fa=(18*h|0)+m|0,bb=d,Ib=g,Mb=k,rb=Cb,Ua=ab,fb=sb;;){Jb=h;Ab=bb;yb=Mb;cb=rb;gc=Ua;for(Ub=fb;;)if(Fb=x[yb+16>>0]|0,lb=x[yb+17>>0]|0,Kb(a[Xa>>2]|0,x[yb>>0]|0,Fb,lb,c,l,n),a[Ab>>2]=a[c>>2]|a[l>>2]<<8|a[n>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+1>>0]|0,Fb,lb,p,q,
t),a[Ab+4>>2]=a[p>>2]|a[q>>2]<<8|a[t>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+2>>0]|0,Fb,lb,r,w,v),a[Ab+8>>2]=a[r>>2]|a[w>>2]<<8|a[v>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+3>>0]|0,Fb,lb,z,Q,C),a[Ab+12>>2]=a[z>>2]|a[Q>>2]<<8|a[C>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+4>>0]|0,Fb,lb,A,V,E),a[cb>>2]=a[A>>2]|a[V>>2]<<8|a[E>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+5>>0]|0,Fb,lb,J,I,G),a[cb+4>>2]=a[J>>2]|a[I>>2]<<8|a[G>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+6>>0]|0,Fb,lb,L,K,D),a[cb+8>>2]=a[L>>2]|a[K>>2]<<8|a[D>>2]<<
16|-16777216,Kb(a[Xa>>2]|0,x[yb+7>>0]|0,Fb,lb,F,O,M),a[cb+12>>2]=a[F>>2]|a[O>>2]<<8|a[M>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+8>>0]|0,Fb,lb,T,X,P),a[gc>>2]=a[T>>2]|a[X>>2]<<8|a[P>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+9>>0]|0,Fb,lb,N,R,S),a[gc+4>>2]=a[N>>2]|a[R>>2]<<8|a[S>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+10>>0]|0,Fb,lb,ba,Y,W),a[gc+8>>2]=a[ba>>2]|a[Y>>2]<<8|a[W>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+11>>0]|0,Fb,lb,U,ga,Z),a[gc+12>>2]=a[U>>2]|a[ga>>2]<<8|a[Z>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+12>>
0]|0,Fb,lb,ma,da,ha),a[Ub>>2]=a[ma>>2]|a[da>>2]<<8|a[ha>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+13>>0]|0,Fb,lb,aa,ca,fa),a[Ub+4>>2]=a[aa>>2]|a[ca>>2]<<8|a[fa>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+14>>0]|0,Fb,lb,ja,pa,ya),a[Ub+8>>2]=a[ja>>2]|a[pa>>2]<<8|a[ya>>2]<<16|-16777216,Kb(a[Xa>>2]|0,x[yb+15>>0]|0,Fb,lb,oa,sa,ra),a[Ub+12>>2]=a[oa>>2]|a[sa>>2]<<8|a[ra>>2]<<16|-16777216,Jb=Jb+-1|0)Ab=Ab+16|0,yb=yb+18|0,cb=cb+16|0,gc=gc+16|0,Ub=Ub+16|0;else break;Ib=Ib+-4|0;if(3>=Ib>>>0)break;else bb=bb+(Pa<<2)|0,Mb=
Mb+Fa|0,rb=rb+(Eb<<2)|0,Ua=Ua+(vb<<2)|0,fb=fb+(tb<<2)|0}u=e}},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,t,r,w,v,z,Q,C,A,V,E,J,I,G,L,K,D,F,O,M,T,N,P,R,S,Y,ba,W,U,Z,ga,da,ma,aa,ha,ca,fa,ja,pa,ya,ra,oa,sa,Aa,ua,Ia,Da,na,Na,Ka,Ca,Ga=0;e=u;u=u+192|0;c=e+188|0;l=e+184|0;n=e+180|0;p=e+176|0;q=e+172|0;t=e+168|0;r=e+164|0;w=e+160|0;v=e+156|0;z=e+152|0;Q=e+148|0;C=e+144|0;A=e+140|0;V=e+136|0;E=e+132|0;J=e+128|0;I=e+124|0;G=e+120|0;L=e+116|0;K=e+112|0;D=e+108|0;F=e+104|0;O=e+100|
0;M=e+96|0;T=e+92|0;N=e+88|0;P=e+84|0;R=e+80|0;S=e+76|0;Y=e+72|0;ba=e+68|0;W=e+64|0;U=e+60|0;Z=e+56|0;ga=e+52|0;da=e+48|0;ma=e+44|0;aa=e+40|0;ha=e+36|0;ca=e+32|0;fa=e+28|0;ja=e+24|0;pa=e+20|0;ya=e+16|0;ra=e+12|0;oa=e+8|0;sa=e+4|0;Aa=e;ua=d+(m+f<<2)|0;Ia=(m<<1)+f|0;m=(10*(h|0)|0)/4|0;if(g&1|f&3)if(g){Na=0==(f|0);Ca=b+68|0;b=g;g=k;k=d;for(d=ua;;){a:do if(Na)c=k,F=g,h=d;else for(ua=1==(b|0),Da=f,na=k,Ka=d;;){d=x[g+8>>0]|0;M=x[g+9>>0]|0;switch(Da|0){case 3:Ga=15;break;case 2:Ga=18;break;case 1:break;
default:ua||(Kb(a[Ca>>2]|0,x[g+7>>0]|0,d,M,T,N,P),a[Ka+12>>2]=a[T>>2]|a[N>>2]<<8|a[P>>2]<<16|-16777216),Kb(a[Ca>>2]|0,x[g+3>>0]|0,d,M,R,S,Y),a[na+12>>2]=a[R>>2]|a[S>>2]<<8|a[Y>>2]<<16|-16777216,Ga=15}15==(Ga|0)&&(ua||(Kb(a[Ca>>2]|0,x[g+6>>0]|0,d,M,ba,W,U),a[Ka+8>>2]=a[ba>>2]|a[W>>2]<<8|a[U>>2]<<16|-16777216),Kb(a[Ca>>2]|0,x[g+2>>0]|0,d,M,Z,ga,da),a[na+8>>2]=a[Z>>2]|a[ga>>2]<<8|a[da>>2]<<16|-16777216,Ga=18);18==(Ga|0)&&(Ga=0,ua||(Kb(a[Ca>>2]|0,x[g+5>>0]|0,d,M,ma,aa,ha),a[Ka+4>>2]=a[ma>>2]|a[aa>>2]<<
8|a[ha>>2]<<16|-16777216),Kb(a[Ca>>2]|0,x[g+1>>0]|0,d,M,ca,fa,ja),a[na+4>>2]=a[ca>>2]|a[fa>>2]<<8|a[ja>>2]<<16|-16777216);ua||(Kb(a[Ca>>2]|0,x[g+4>>0]|0,d,M,pa,ya,ra),a[Ka>>2]=a[pa>>2]|a[ya>>2]<<8|a[ra>>2]<<16|-16777216);Kb(a[Ca>>2]|0,x[g>>0]|0,d,M,oa,sa,Aa);a[na>>2]=a[oa>>2]|a[sa>>2]<<8|a[Aa>>2]<<16|-16777216;d=(M=4>Da>>>0)?Ka+(Da<<2)|0:Ka+16|0;O=M?na+(Da<<2)|0:na+16|0;F=g+10|0;if(Da=M?0:Da+-4|0)g=F,na=O,Ka=d;else{c=O;h=d;break a}}while(0);if(3>b>>>0){Ga=26;break}if(b=b+-2|0)g=F+m|0,k=c+(Ia<<2)|
0,d=h+(Ia<<2)|0;else{Ga=26;break}}26==(Ga|0)&&(u=e)}else u=e;else{if(!(1>=g>>>0))for(h=f>>>2,b=b+68|0,Da=h<<2,na=Da+Ia|0,Na=Da+Ia|0,Da=(10*h|0)+m|0,Ka=d,d=g,g=k,Ca=ua;;){m=h;k=Ka;Ia=g;for(f=Ca;;)if(T=x[Ia+8>>0]|0,N=x[Ia+9>>0]|0,Kb(a[b>>2]|0,x[Ia>>0]|0,T,N,c,l,n),a[k>>2]=a[c>>2]|a[l>>2]<<8|a[n>>2]<<16|-16777216,Kb(a[b>>2]|0,x[Ia+1>>0]|0,T,N,p,q,t),a[k+4>>2]=a[p>>2]|a[q>>2]<<8|a[t>>2]<<16|-16777216,Kb(a[b>>2]|0,x[Ia+2>>0]|0,T,N,r,w,v),a[k+8>>2]=a[r>>2]|a[w>>2]<<8|a[v>>2]<<16|-16777216,Kb(a[b>>2]|0,
x[Ia+3>>0]|0,T,N,z,Q,C),a[k+12>>2]=a[z>>2]|a[Q>>2]<<8|a[C>>2]<<16|-16777216,Kb(a[b>>2]|0,x[Ia+4>>0]|0,T,N,A,V,E),a[f>>2]=a[A>>2]|a[V>>2]<<8|a[E>>2]<<16|-16777216,Kb(a[b>>2]|0,x[Ia+5>>0]|0,T,N,J,I,G),a[f+4>>2]=a[J>>2]|a[I>>2]<<8|a[G>>2]<<16|-16777216,Kb(a[b>>2]|0,x[Ia+6>>0]|0,T,N,L,K,D),a[f+8>>2]=a[L>>2]|a[K>>2]<<8|a[D>>2]<<16|-16777216,Kb(a[b>>2]|0,x[Ia+7>>0]|0,T,N,F,O,M),a[f+12>>2]=a[F>>2]|a[O>>2]<<8|a[M>>2]<<16|-16777216,m=m+-1|0)k=k+16|0,Ia=Ia+10|0,f=f+16|0;else break;d=d+-2|0;if(1>=d>>>0)break;
else Ka=Ka+(na<<2)|0,g=g+Da|0,Ca=Ca+(Na<<2)|0}u=e}},function(b,d,c,e,f,g,h,m,k){f|=0;h|=0;m|=0;var l,n,p,q,t,r,w,v,z,Q,C,A,V,E,J,I,G,L,K,D,F,O,M,T,N,P,R,S,Y,ba,W=0;e=u;u=u+96|0;c=e+80|0;l=e+76|0;n=e+72|0;p=e+68|0;q=e+64|0;t=e+60|0;r=e+56|0;w=e+52|0;v=e+48|0;z=e+44|0;Q=e+40|0;C=e+36|0;A=e+32|0;V=e+28|0;E=e+24|0;J=e+20|0;I=e+16|0;G=e+12|0;L=e+8|0;K=e+4|0;D=e;F=f>>>2;O=0==(F|0);M=f&3;f=0==(M|0);T=(b|0)+68|0;b=6*F|0;N=F<<2;P=d|0;d=g|0;for(g=k|0;;){if(O)k=g;else{k=g+b|0;R=F;for(S=P;;)if(Y=x[g+4>>0]|0,
ba=x[g+5>>0]|0,Kb(a[T>>2]|0,x[g>>0]|0,Y,ba,c,l,n),a[S>>2]=a[c>>2]|a[l>>2]<<8|a[n>>2]<<16|-16777216,Kb(a[T>>2]|0,x[g+1>>0]|0,Y,ba,p,q,t),a[S+4>>2]=a[p>>2]|a[q>>2]<<8|a[t>>2]<<16|-16777216,Kb(a[T>>2]|0,x[g+2>>0]|0,Y,ba,r,w,v),a[S+8>>2]=a[r>>2]|a[w>>2]<<8|a[v>>2]<<16|-16777216,Kb(a[T>>2]|0,x[g+3>>0]|0,Y,ba,z,Q,C),a[S+12>>2]=a[z>>2]|a[Q>>2]<<8|a[C>>2]<<16|-16777216,R=R+-1|0)S=S+16|0,g=g+6|0;else break;P=P+(N<<2)|0}if(f)S=P;else{g=x[k+4>>0]|0;S=x[k+5>>0]|0;switch(M|0){case 3:Kb(a[T>>2]|0,x[k+2>>0]|0,g,
S,A,V,E);a[P+8>>2]=a[A>>2]|a[V>>2]<<8|a[E>>2]<<16|-16777216;W=9;break;case 2:W=9;break;case 1:W=10}9==(W|0)&&(Kb(a[T>>2]|0,x[k+1>>0]|0,g,S,J,I,G),a[P+4>>2]=a[J>>2]|a[I>>2]<<8|a[G>>2]<<16|-16777216,W=10);10==(W|0)&&(W=0,Kb(a[T>>2]|0,x[k>>0]|0,g,S,L,K,D),a[P>>2]=a[L>>2]|a[K>>2]<<8|a[D>>2]<<16|-16777216);S=P+(M<<2)|0;k=k+6|0}if(d=d+-1|0)P=S+(m<<2)|0,g=k+h|0;else break}u=e},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;m|=0;k|=0;var l,n,p,q,t,r,w,v,z,Q,C,A,V,E,J,I,G,L,K,D,F,O,M,T,N,P,S,R,Y,ba,W,U,Z,
ga,da,ma,aa,ha,ca;e=u;u=u+112|0;c=e+104|0;l=e+100|0;n=e+96|0;p=e+92|0;q=e+88|0;t=e+84|0;r=e+80|0;w=e+76|0;v=e+72|0;z=e+68|0;Q=e+64|0;C=e+60|0;A=e+56|0;V=e+52|0;E=e+48|0;J=e+44|0;I=e+40|0;G=e+36|0;L=e+32|0;K=e+28|0;D=e+24|0;F=e+20|0;O=e+16|0;M=e+12|0;T=e+8|0;N=e+4|0;P=e;S=(m<<1)+f|0;R=6*((h|0)/2|0)|0;if(1<g>>>0){h=1<f>>>0;Y=b+68|0;ba=f+-2|0;W=ba>>>1;U=W<<1;Z=ba-U|0;ba=(6*W|0)+6|0;W=U+2|0;U=d;ga=g;da=k;for(ma=d+(m+f<<2)|0;;){if(h){m=ma+(W<<2)|0;k=f;aa=U;for(d=da;!(ha=x[d+4>>0]|0,ca=x[d+5>>0]|0,Kb(a[Y>>
2]|0,x[d>>0]|0,ha,ca,c,l,n),a[aa>>2]=a[c>>2]|a[l>>2]<<8|a[n>>2]<<16|-16777216,Kb(a[Y>>2]|0,x[d+1>>0]|0,ha,ca,p,q,t),a[aa+4>>2]=a[p>>2]|a[q>>2]<<8|a[t>>2]<<16|-16777216,Kb(a[Y>>2]|0,x[d+2>>0]|0,ha,ca,r,w,v),a[ma>>2]=a[r>>2]|a[w>>2]<<8|a[v>>2]<<16|-16777216,Kb(a[Y>>2]|0,x[d+3>>0]|0,ha,ca,z,Q,C),a[ma+4>>2]=a[z>>2]|a[Q>>2]<<8|a[C>>2]<<16|-16777216,k=k+-2|0,1>=k>>>0);)aa=aa+8|0,d=d+6|0,ma=ma+8|0;d=Z;U=U+(W<<2)|0;da=da+ba|0}else d=f,m=ma;1==(d|0)?(ma=x[da+4>>0]|0,d=x[da+5>>0]|0,Kb(a[Y>>2]|0,x[da>>0]|0,
ma,d,A,V,E),a[U>>2]=a[A>>2]|a[V>>2]<<8|a[E>>2]<<16|-16777216,Kb(a[Y>>2]|0,x[da+2>>0]|0,ma,d,J,I,G),a[m>>2]=a[J>>2]|a[I>>2]<<8|a[G>>2]<<16|-16777216,ma=U+4|0,da=da+6|0,m=m+4|0):ma=U;d=ma+(S<<2)|0;ma=da+R|0;ga=ga+-2|0;if(1>=ga>>>0)break;else U=d,da=ma,ma=m+(S<<2)|0}h=d;n=g&1;l=ma}else h=d,n=g,l=k;if(1==(n|0)){if(1<f>>>0){n=b+68|0;k=f+-2|0;g=k>>>1;d=g<<1;c=(6*g|0)+6|0;g=d+2|0;S=h;for(m=l;!(ma=x[m+4>>0]|0,da=x[m+5>>0]|0,Kb(a[n>>2]|0,x[m>>0]|0,ma,da,L,K,D),a[S>>2]=a[L>>2]|a[K>>2]<<8|a[D>>2]<<16|-16777216,
Kb(a[n>>2]|0,x[m+1>>0]|0,ma,da,F,O,M),a[S+4>>2]=a[F>>2]|a[O>>2]<<8|a[M>>2]<<16|-16777216,f=f+-2|0,1>=f>>>0);)S=S+8|0,m=m+6|0;L=k-d|0;g=h+(g<<2)|0;K=l+c|0}else L=f,g=h,K=l;1==(L|0)&&(Kb(a[b+68>>2]|0,x[K>>0]|0,x[K+4>>0]|0,x[K+5>>0]|0,T,N,P),a[g>>2]=a[T>>2]|a[N>>2]<<8|a[P>>2]<<16|-16777216)}u=e},function(b,d,c,e,f,g,h,m,k){f|=0;m|=0;var l,n,p,q,t,r,w,v,z,Q,C,A,V,E,J,I,G;e=u;u=u+48|0;c=e+32|0;l=e+28|0;n=e+24|0;p=e+20|0;q=e+16|0;t=e+12|0;r=e+8|0;w=e+4|0;v=e;z=(h|0)<<1;h=f>>>1;Q=0==(h|0);C=0==(f&1|0);f=
(b|0)+68|0;b=h<<2;A=h<<1;V=d|0;d=g|0;for(g=k|0;;){if(Q)k=g;else{k=g+b|0;E=h;for(J=V;;)if(I=x[g+2>>0]|0,G=x[g+3>>0]|0,Kb(a[f>>2]|0,x[g>>0]|0,I,G,c,l,n),a[J>>2]=a[c>>2]|a[l>>2]<<8|a[n>>2]<<16|-16777216,Kb(a[f>>2]|0,x[g+1>>0]|0,I,G,p,q,t),a[J+4>>2]=a[p>>2]|a[q>>2]<<8|a[t>>2]<<16|-16777216,E=E+-1|0)g=g+4|0,J=J+8|0;else break;V=V+(A<<2)|0}C||(Kb(a[f>>2]|0,x[k>>0]|0,x[k+2>>0]|0,x[k+3>>0]|0,r,w,v),a[V>>2]=a[r>>2]|a[w>>2]<<8|a[v>>2]<<16|-16777216,V=V+4|0,k=k+4|0);if(d=d+-1|0)V=V+(m<<2)|0,g=k+z|0;else break}u=
e},function(b,d,c,e,f,g,h,m,k){b|=0;d|=0;f|=0;g|=0;h|=0;m|=0;k|=0;var l,n,p,q,t,r,w,v,z,Q,C,A,V,D,J,I,G,L,K,F,N,O,M;e=u;u=u+48|0;c=e+32|0;l=e+28|0;n=e+24|0;p=e+20|0;q=e+16|0;t=e+12|0;r=e+8|0;w=e+4|0;v=e;if(1<g>>>0){z=m+f|0;Q=(h|0)/2|0;h=b+68|0;C=f+1+(m<<1)|0;A=f+-1|0;V=f<<2;D=g+-2|0;J=D>>>1;I=J<<1;G=Q<<2;L=(E(J,G+V|0)|0)+G+V|0;G=(E(J,z)|0)+m+f<<1;m=A+C|0;J=A+C|0;C=V+(Q<<2)|0;Q=d;V=g;A=k;for(g=d+(z<<2)|0;;){z=f;K=Q;F=A;for(N=g;;)if(O=x[F+2>>0]|0,M=x[F+3>>0]|0,Kb(a[h>>2]|0,x[F>>0]|0,O,M,c,l,n),a[K>>
2]=a[c>>2]|a[l>>2]<<8|a[n>>2]<<16|-16777216,Kb(a[h>>2]|0,x[F+1>>0]|0,O,M,p,q,t),a[N>>2]=a[p>>2]|a[q>>2]<<8|a[t>>2]<<16|-16777216,z=z+-1|0)K=K+4|0,F=F+4|0,N=N+4|0;else break;V=V+-2|0;if(1>=V>>>0)break;else Q=Q+(m<<2)|0,A=A+C|0,g=g+(J<<2)|0}d=d+(G<<2)|0;D=D-I|0;k=k+L|0}else D=g;if(1==(D|0))for(D=b+68|0,b=f,f=d,d=k;;)if(Kb(a[D>>2]|0,x[d>>0]|0,x[d+2>>0]|0,x[d+3>>0]|0,r,w,v),a[f>>2]=a[r>>2]|a[w>>2]<<8|a[v>>2]<<16|-16777216,b=b+-1|0)f=f+4|0,d=d+4|0;else break;u=e},function(b,d,c,e,f,g,h,m,k){f|=0;var l,
n,p,q,t;e=u;u=u+16|0;c=e+8|0;l=e+4|0;n=e;p=(b|0)+68|0;b=f+(m|0)|0;m=3*(f+(h|0)|0)|0;h=d|0;d=k|0;for(k=g|0;;){g=f;q=h;for(t=d;;)if(Kb(a[p>>2]|0,x[t>>0]|0,x[t+1>>0]|0,x[t+2>>0]|0,c,l,n),a[q>>2]=a[c>>2]|a[l>>2]<<8|a[n>>2]<<16|-16777216,g=g+-1|0)q=q+4|0,t=t+3|0;else break;if(k=k+-1|0)h=h+(b<<2)|0,d=d+m|0;else break}u=e},function(b,d,c,e,f,g,h,m,k){f|=0;g|=0;m|=0;var l,n,p,q,y,r,w,v,z,Q;e=u;u=u+32|0;c=e+20|0;l=e+16|0;n=e+12|0;p=e+8|0;q=e+4|0;y=e;r=3*(h|0)|0;if(g)for(h=0==(f|0),w=(b|0)+72|0,b=3*f|0,v=k|
0,k=d|0,d=g;;){d=d+-1|0;if(h)g=v;else{g=v+b|0;z=f;for(Q=k;;){z=z+-1|0;var C=a[w>>2]|0,A=x[v>>0]|0,V=t[v+1>>0]|0,E=t[v+2>>0]|0,J=c,I=l,G=n,C=C|0,I=I|0,G=G|0,L,K;L=100*+((A|0)>>>0)/255;8.855999946594238>L?(A=C+20|0,K=L*+W[A>>2]/903.2919921875,W[I>>2]=K,A=K/+W[A>>2]*7.7870001792907715+.13793103396892548):(K=(L+16)/116,W[I>>2]=K*K*K*+W[C+20>>2],A=K);K=A+ +(V|0)/500;L=+W[C+16>>2];V=.2069000005722046>K?L*(K+-.1379300057888031)/7.7870001792907715:K*K*L*K;W[(J|0)>>2]=V;V=A-+(E|0)/200;A=+W[C+24>>2];W[G>>2]=
.2069000005722046>V?A*(V+-.1379300057888031)/7.7870001792907715:V*V*A*V;var C=a[w>>2]|0,E=+W[c>>2],D=+W[l>>2],F=+W[n>>2],J=p,G=q,V=y,C=C|0,E=+E,D=+D,F=+F,J=J|0,G=G|0,V=V|0,O,M;L=+W[C+28>>2]*E+ +W[C+32>>2]*D+ +W[C+36>>2]*F;K=+W[C+40>>2]*E+ +W[C+44>>2]*D+ +W[C+48>>2]*F;O=+W[C+52>>2]*E+ +W[C+56>>2]*D+ +W[C+60>>2]*F;F=+W[C+88>>2];D=L>F?L:F;L=+W[C+92>>2];E=K>L?K:L;K=+W[C+96>>2];A=O>K?O:K;O=+W[C+64>>2];I=+W[C+68>>2];M=+W[C+72>>2];D=~~(((D<O?D:O)-F)/+W[C+4>>2]);F=a[C>>2]|0;F=+W[C+112+(((F|0)<(D|0)?F:D)<<
2)>>2];a[J>>2]=~~(F+(0<F?.5:-.5))>>>0;D=~~(((E<I?E:I)-L)/+W[C+8>>2]);F=a[C>>2]|0;L=+W[C+6116+(((F|0)<(D|0)?F:D)<<2)>>2];a[G>>2]=~~(L+(0<L?.5:-.5))>>>0;D=~~(((A<M?A:M)-K)/+W[C+12>>2]);F=a[C>>2]|0;K=+W[C+12120+(((F|0)<(D|0)?F:D)<<2)>>2];a[V>>2]=~~(K+(0<K?.5:-.5))>>>0;D=a[J>>2]|0;F=a[C+76>>2]|0;a[J>>2]=D>>>0<F>>>0?D:F;F=a[G>>2]|0;D=a[C+80>>2]|0;a[G>>2]=F>>>0<D>>>0?F:D;D=a[V>>2]|0;F=a[C+84>>2]|0;a[V>>2]=D>>>0<F>>>0?D:F;a[Q>>2]=a[p>>2]|a[q>>2]<<8|a[y>>2]<<16|-16777216;if(z)Q=Q+4|0,v=v+3|0;else break}k=
k+(f<<2)|0}if(d)v=g+r|0,k=k+(m<<2)|0;else break}u=e},Kh,Kh,Kh,Kh,Kh],rb=[Hf,function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,t,r,H=0,x,z=0,v=0,C=0,A=0,V=0,D=0,J,I,G,L,K,F,S,O,M,T,X;f=u;u=u+32|0;g=f+16|0;h=f+8|0;m=f;k=f+24|0;l=f+20|0;n=a[b>>2]|0;p=a[b+52>>2]|0;q=eb(Og(n)|0)|0;if(!q)return t=a[n+628>>2]|0,r=Bc(n)|0,a[m>>2]=136922,Y(t,r,154321,m),u=f,0;$c(q,0,Og(n)|0);a[h>>2]=k;Pd(n,322,h)|0;a[g>>2]=l;Pd(n,323,g)|0;a:do switch(N[b+28>>1]|0){case 5:case 1:switch(w[b+30>>1]|0){case 6:case 2:H=
2;x=17;break a;case 7:case 3:z=3;x=16;break a;case 8:case 4:z=1;x=16;break a;default:H=0;x=17;break a}case 6:case 2:switch(w[b+30>>1]|0){case 5:case 1:H=2;x=17;break a;case 7:case 3:z=1;x=16;break a;case 8:case 4:z=3;x=16;break a;default:H=0;x=17;break a}case 7:case 3:switch(w[b+30>>1]|0){case 5:case 1:z=3;x=16;break a;case 8:case 4:H=2;x=17;break a;case 6:case 2:z=1;x=16;break a;default:H=0;x=17;break a}case 8:case 4:switch(w[b+30>>1]|0){case 5:case 1:z=1;x=16;break a;case 7:case 3:H=2;x=17;break a;
case 6:case 2:z=3;x=16;break a;default:H=0;x=17;break a}default:H=0,x=17}while(0);16==(x|0)?(g=a[k>>2]|0,v=z,C=g,A=1,V=0-(g+c)|0,D=e+-1|0):17==(x|0)&&(x=a[k>>2]|0,v=H,C=x,A=0,V=c-x|0,D=0);x=b+88|0;H=((a[x>>2]|0)>>>0)%(C>>>0)|0;g=C-H|0;C=H+V|0;if(z=0==(e|0))b=1;else for(h=b+84|0,m=b+4|0,r=0==(c|0),t=b+26|0,J=1,I=0,G=D;;){D=a[l>>2]|0;L=a[h>>2]|0;K=D-(((L+I|0)>>>0)%(D>>>0)|0)|0;D=(K+I|0)>>>0>e>>>0?e-I|0:K;a:do if(r)K=J;else for(K=E(G,c)|0,F=L,L=a[x>>2]|0,S=H,O=C,M=g,T=0;;){if(-1==(sd(n,q,L,F+I|0,0,0)|
0)&&0!=(a[m>>2]|0)){K=0;break a}X=(((a[h>>2]|0)+I|0)>>>0)%((a[l>>2]|0)>>>0)|0;F=E(tg(n)|0,X)|0;X=(E(N[t>>1]|0,S)|0)+F|0;(T+M|0)>>>0>c>>>0&&(F=c-T|0,S=M=(a[k>>2]|0)-F|0,O=M+V|0,M=F);Ii[p&31](b,d+(T+K<<2)|0,T,G,M,D,S,O,q+X|0);X=M+T|0;if(X>>>0>=c>>>0){K=J;break a}F=a[h>>2]|0;L=M+L|0;S=0;O=V;M=a[k>>2]|0;T=X}while(0);I=D+I|0;if(I>>>0>=e>>>0){b=K;break}else J=K,G=(A?0-D|0:D)+G|0}ja(q);if(0==(v&2|0)|z)return u=f,b|0;z=c+-1|0;v=0;do{q=E(v,c)|0;G=z+q|0;if((q|0)<(G|0)){A=d+(q<<2)|0;q=d+(G<<2)|0;do G=a[A>>2]|
0,a[A>>2]=a[q>>2],a[q>>2]=G,A=A+4|0,q=q+-4|0;while(A>>>0<q>>>0)}v=v+1|0}while((v|0)!=(e|0));u=f;return b|0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,t=0,r=0,H=0,x=0,z=0,v=0,C,A,V,D,J,I,G,L;f=u;u=u+48|0;g=f+24|0;h=f;m=f+28|0;k=f+32|0;l=a[b>>2]|0;n=a[b+52>>2]|0;p=a[b+16>>2]|0;a[h>>2]=f+34;a[h+4>>2]=k;ne(l,530,h)|0;if(!(w[k>>1]|0))return h=a[l+628>>2]|0,Y(h,Bc(l)|0,137155,f+8|0),u=f,0;h=eb(se(l)|0)|0;if(!h)return q=a[l+628>>2]|0,Y(q,Bc(l)|0,137190,f+16|0),u=f,0;$c(h,0,se(l)|0);a:do switch(N[b+
28>>1]|0){case 5:case 1:switch(w[b+30>>1]|0){case 6:case 2:t=2;x=H=r=0;break a;case 7:case 3:z=3;v=18;break a;case 8:case 4:z=1;v=18;break a;default:x=H=r=t=0;break a}case 6:case 2:switch(w[b+30>>1]|0){case 5:case 1:t=2;x=H=r=0;break a;case 7:case 3:z=1;v=18;break a;case 8:case 4:z=3;v=18;break a;default:x=H=r=t=0;break a}case 7:case 3:switch(w[b+30>>1]|0){case 5:case 1:z=3;v=18;break a;case 8:case 4:t=2;x=H=r=0;break a;case 6:case 2:z=1;v=18;break a;default:x=H=r=t=0;break a}case 8:case 4:switch(w[b+
30>>1]|0){case 5:case 1:z=1;v=18;break a;case 7:case 3:t=2;x=H=r=0;break a;case 6:case 2:z=3;v=18;break a;default:x=H=r=t=0;break a}default:x=H=r=t=0}while(0);18==(v|0)&&(t=z,r=1,H=0-(c<<1)|0,x=e+-1|0);a[g>>2]=m;ne(l,278,g)|0;g=Pe(l)|0;z=p>>>0>c>>>0?p-c|0:0;p=b+4|0;v=0==(e|0);a:do if(v)q=1;else if(q=b+84|0,C=b+88|0,A=b+26|0,r)for(V=0,D=x;;){J=a[m>>2]|0;I=(a[q>>2]|0)+V|0;G=J-((I>>>0)%(J>>>0)|0)|0;J=(G+V|0)>>>0>e>>>0?e-V|0:G;G=N[k>>1]|0;L=(J>>>0)%(G>>>0)|0;I=Pc(l,I,0)|0;if(-1==(Vc(l,I,h,E(J+(0==(L|
0)?0:G-L|0)+((((a[q>>2]|0)+V|0)>>>0)%((a[m>>2]|0)>>>0)|0)|0,g)|0)|0)&&0!=(a[p>>2]|0)){q=0;break a}L=E((((a[q>>2]|0)+V|0)>>>0)%((a[m>>2]|0)>>>0)|0,g)|0;G=d+((E(D,c)|0)<<2)|0;I=h+((E(N[A>>1]|0,a[C>>2]|0)|0)+L)|0;Ii[n&31](b,G,0,D,c,J,z,H,I);V=J+V|0;if(V>>>0>=e>>>0){q=1;break}else D=D-J|0}else for(D=0,V=x;;){J=a[m>>2]|0;I=(a[q>>2]|0)+D|0;G=J-((I>>>0)%(J>>>0)|0)|0;J=(G+D|0)>>>0>e>>>0?e-D|0:G;G=N[k>>1]|0;L=(J>>>0)%(G>>>0)|0;I=Pc(l,I,0)|0;if(-1==(Vc(l,I,h,E(J+(0==(L|0)?0:G-L|0)+((((a[q>>2]|0)+D|0)>>>0)%
((a[m>>2]|0)>>>0)|0)|0,g)|0)|0)&&0!=(a[p>>2]|0)){q=0;break a}L=E((((a[q>>2]|0)+D|0)>>>0)%((a[m>>2]|0)>>>0)|0,g)|0;G=d+((E(V,c)|0)<<2)|0;I=h+((E(N[A>>1]|0,a[C>>2]|0)|0)+L)|0;Ii[n&31](b,G,0,V,c,J,z,H,I);D=J+D|0;if(D>>>0>=e>>>0){q=1;break}else V=J+V|0}while(0);if(!(0==(t&2|0)|v)){v=c+-1|0;t=0;do{H=E(t,c)|0;z=v+H|0;if((H|0)<(z|0)){b=d+(H<<2)|0;H=d+(z<<2)|0;do z=a[b>>2]|0,a[b>>2]=a[H>>2],a[H>>2]=z,b=b+4|0,H=H+-4|0;while(b>>>0<H>>>0)}t=t+1|0}while((t|0)!=(e|0))}ja(h);u=f;return q|0},function(b,d,c,e){b|=
0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,t,r=0,H,x,z,v=0,C,A=0,V=0,D=0,J=0,I=0,G=0,L,K,F,S,O,M,T,X,P,R,W,U,ba,Z;f=u;u=u+48|0;g=f+24|0;h=f+16|0;m=f+8|0;k=f+32|0;l=f+28|0;n=a[b>>2]|0;p=a[b+52>>2]|0;q=a[b+12>>2]|0;t=Og(n)|0;if(0!=(t|0)&&(r=0!=(q|0),q=E(r?4:3,t)|0,0!=(q|0))){H=eb(q)|0;if(!H)return x=a[n+628>>2]|0,z=Bc(n)|0,a[m>>2]=136922,Y(x,z,154321,m),u=f,0;$c(H,0,q);q=H+t|0;m=H+(t<<1)|0;z=r?H+(3*t|0)|0:0;a[h>>2]=k;Pd(n,322,h)|0;a[g>>2]=l;Pd(n,323,g)|0;a:do switch(N[b+28>>1]|0){case 5:case 1:switch(w[b+
30>>1]|0){case 6:case 2:v=2;C=20;break a;case 7:case 3:A=3;C=19;break a;case 8:case 4:A=1;C=19;break a;default:v=0;C=20;break a}case 6:case 2:switch(w[b+30>>1]|0){case 5:case 1:v=2;C=20;break a;case 7:case 3:A=1;C=19;break a;case 8:case 4:A=3;C=19;break a;default:v=0;C=20;break a}case 7:case 3:switch(w[b+30>>1]|0){case 5:case 1:A=3;C=19;break a;case 8:case 4:v=2;C=20;break a;case 6:case 2:A=1;C=19;break a;default:v=0;C=20;break a}case 8:case 4:switch(w[b+30>>1]|0){case 5:case 1:A=1;C=19;break a;case 7:case 3:v=
2;C=20;break a;case 6:case 2:A=3;C=19;break a;default:v=0;C=20;break a}default:v=0,C=20}while(0);19==(C|0)?(g=a[k>>2]|0,V=A,D=1,J=g,I=0-(g+c)|0,G=e+-1|0):20==(C|0)&&(C=a[k>>2]|0,V=v,D=0,J=C,I=c-C|0,G=0);switch(N[b+32>>1]|0){case 3:case 1:case 0:L=1;F=K=H;break;default:L=3,K=q,F=m}m=b+88|0;q=((a[m>>2]|0)>>>0)%(J>>>0)|0;C=J-q|0;J=q+I|0;if(v=0==(e|0))b=1;else for(g=b+84|0,A=b+4|0,h=0==(c|0),t=1==(L|0),x=L&65535,L=b+26|0,S=1,O=0,M=G;;){G=a[l>>2]|0;T=a[g>>2]|0;X=G-(((T+O|0)>>>0)%(G>>>0)|0)|0;G=(X+O|0)>>>
0>e>>>0?e-O|0:X;a:do if(h)X=S;else for(X=E(M,c)|0,P=T,T=a[m>>2]|0,R=q,W=J,U=C,ba=0;;){if(-1==(sd(n,H,T,P+O|0,0,0)|0)&&0!=(a[A>>2]|0)){X=0;break a}if(!t){if(-1==(sd(n,K,T,(a[g>>2]|0)+O|0,0,1)|0)&&0!=(a[A>>2]|0)){X=0;break a}if(-1==(sd(n,F,T,(a[g>>2]|0)+O|0,0,2)|0)&&0!=(a[A>>2]|0)){X=0;break a}}if(r&&-1==(sd(n,z,T,(a[g>>2]|0)+O|0,0,x)|0)&&0!=(a[A>>2]|0)){X=0;break a}Z=(((a[g>>2]|0)+O|0)>>>0)%((a[l>>2]|0)>>>0)|0;P=E(tg(n)|0,Z)|0;Z=(E(N[L>>1]|0,R)|0)+P|0;(ba+U|0)>>>0>c>>>0&&(P=c-ba|0,R=U=(a[k>>2]|0)-
P|0,W=U+I|0,U=P);Gk[p&15](b,d+(ba+X<<2)|0,ba,M,U,G,R,W,H+Z|0,K+Z|0,F+Z|0,r?z+Z|0:0);Z=U+ba|0;if(Z>>>0>=c>>>0){X=S;break a}P=a[g>>2]|0;T=U+T|0;R=0;W=I;U=a[k>>2]|0;ba=Z}while(0);O=G+O|0;if(O>>>0>=e>>>0){b=X;break}else S=X,M=(D?0-G|0:G)+M|0}if(!(0==(V&2|0)|v)){v=c+-1|0;V=0;do{M=E(V,c)|0;D=v+M|0;if((M|0)<(D|0)){X=d+(M<<2)|0;M=d+(D<<2)|0;do D=a[X>>2]|0,a[X>>2]=a[M>>2],a[M>>2]=D,X=X+4|0,M=M+-4|0;while(X>>>0<M>>>0)}V=V+1|0}while((V|0)!=(e|0))}ja(H);u=f;return b|0}b=a[n+628>>2]|0;H=Bc(n)|0;a[f>>2]=136947;
Y(b,H,139955,f);u=f;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,t=0,r,H,x=0,z=0,v=0,C=0,A=0,V=0,D,J,I,G,L,K,F,S,O,M;f=u;u=u+32|0;g=f+16|0;h=f+8|0;m=f+20|0;k=a[b>>2]|0;l=a[b+52>>2]|0;n=a[b+16>>2]|0;p=a[b+12>>2]|0;q=se(k)|0;if(0!=(q|0)&&(t=0!=(p|0),p=E(t?4:3,q)|0,0!=(p|0))){r=eb(p)|0;if(!r)return H=a[k+628>>2]|0,Y(H,Bc(k)|0,136922,h),u=f,0;$c(r,0,p);p=r+q|0;h=r+(q<<1)|0;H=t?r+(3*q|0)|0:0;a:do switch(N[b+28>>1]|0){case 5:case 1:switch(w[b+30>>1]|0){case 6:case 2:x=2;C=v=z=0;
break a;case 7:case 3:A=3;V=19;break a;case 8:case 4:A=1;V=19;break a;default:C=v=z=x=0;break a}case 6:case 2:switch(w[b+30>>1]|0){case 5:case 1:x=2;C=v=z=0;break a;case 7:case 3:A=1;V=19;break a;case 8:case 4:A=3;V=19;break a;default:C=v=z=x=0;break a}case 7:case 3:switch(w[b+30>>1]|0){case 5:case 1:A=3;V=19;break a;case 8:case 4:x=2;C=v=z=0;break a;case 6:case 2:A=1;V=19;break a;default:C=v=z=x=0;break a}case 8:case 4:switch(w[b+30>>1]|0){case 5:case 1:A=1;V=19;break a;case 7:case 3:x=2;C=v=z=0;
break a;case 6:case 2:A=3;V=19;break a;default:C=v=z=x=0;break a}default:C=v=z=x=0}while(0);19==(V|0)&&(x=A,z=1,v=0-(c<<1)|0,C=e+-1|0);switch(N[b+32>>1]|0){case 3:case 1:case 0:D=1;I=J=r;break;default:D=3,J=p,I=h}a[g>>2]=m;ne(k,278,g)|0;g=Pe(k)|0;h=n>>>0>c>>>0?n-c|0:0;n=b+4|0;p=0==(e|0);a:do if(p)q=1;else for(A=b+84|0,V=1==(D|0),q=D&65535,G=b+88|0,L=b+26|0,K=0,F=C;;){S=a[m>>2]|0;O=(a[A>>2]|0)+K|0;M=S-((O>>>0)%(S>>>0)|0)|0;S=(M+K|0)>>>0>e>>>0?e-K|0:M;M=Pc(k,O,0)|0;if(-1==(Vc(k,M,r,E(((((a[A>>2]|0)+
K|0)>>>0)%((a[m>>2]|0)>>>0)|0)+S|0,g)|0)|0)&&0!=(a[n>>2]|0)){q=0;break a}if(!V){M=Pc(k,O,1)|0;if(-1==(Vc(k,M,J,E(((((a[A>>2]|0)+K|0)>>>0)%((a[m>>2]|0)>>>0)|0)+S|0,g)|0)|0)&&0!=(a[n>>2]|0)){q=0;break a}M=Pc(k,O,2)|0;if(-1==(Vc(k,M,I,E(((((a[A>>2]|0)+K|0)>>>0)%((a[m>>2]|0)>>>0)|0)+S|0,g)|0)|0)&&0!=(a[n>>2]|0)){q=0;break a}}if(t&&(M=Pc(k,O,q)|0,-1==(Vc(k,M,H,E(((((a[A>>2]|0)+K|0)>>>0)%((a[m>>2]|0)>>>0)|0)+S|0,g)|0)|0))&&0!=(a[n>>2]|0)){q=0;break a}M=E((((a[A>>2]|0)+K|0)>>>0)%((a[m>>2]|0)>>>0)|0,g)|0;
O=(E(N[L>>1]|0,a[G>>2]|0)|0)+M|0;M=d+((E(F,c)|0)<<2)|0;Gk[l&15](b,M,0,F,c,S,h,v,r+O|0,J+O|0,I+O|0,t?H+O|0:0);K=S+K|0;if(K>>>0>=e>>>0){q=1;break}else F=(z?0-S|0:S)+F|0}while(0);if(!(0==(x&2|0)|p)){p=c+-1|0;x=0;do{z=E(x,c)|0;H=p+z|0;if((z|0)<(H|0)){t=d+(z<<2)|0;z=d+(H<<2)|0;do H=a[t>>2]|0,a[t>>2]=a[z>>2],a[z>>2]=H,t=t+4|0,z=z+-4|0;while(t>>>0<z>>>0)}x=x+1|0}while((x|0)!=(e|0))}ja(r);u=f;return q|0}q=a[k+628>>2]|0;r=Bc(k)|0;a[f>>2]=136906;Y(q,r,139955,f);u=f;return 0},function(b,d,c,e){b|=0;d|=0;e|=
0;if((d|0)==(d|0)&((0>(d|0))<<31>>31|0)==(c|0)){var f;c=u;u=u+32|0;f=c+20|0;a[c>>2]=b|0;a[c+4>>2]=0;a[c+8>>2]=d|0;a[c+12>>2]=f;a[c+16>>2]=e|0;b=0!=(le(ql(140,c|0)|0)|0);u=c;c=(b?-1:a[f>>2]|0)|0;U=(0>(c|0))<<31>>31;return c|0}c=md()|0;a[c>>2]=22;return U=-1},function(b,d,c,e){b|=0;var f,g,h,m,k,l=0,n=0,p=0,q=0,t=0;e=u;u=u+16|0;c=e+8|0;d=e;f=w[b+88>>1]|0;g=a[1940]|0;a:do if(g){for(h=g;;){m=a[h+4>>2]|0;if((w[m+4>>1]|0)==f<<16>>16){k=m;break}h=a[h>>2]|0;if(!h){h=3;break a}}h=a[b+628>>2]|0;m=a[b>>2]|0;
k?(p=k,q=h,t=m,h=10):(l=h,n=m,h=11)}else h=3;while(0);a:do if(3==(h|0)){b:do if(a[1941]|0){for(k=7764;;){if((w[k+4>>1]|0)==f<<16>>16){g=k;break}k=k+12|0;if(!(a[k>>2]|0))break b}p=g;q=a[b+628>>2]|0;t=a[b>>2]|0;h=10;break a}while(0);l=a[b+628>>2]|0;n=a[b>>2]|0;h=11}while(0);return 10==(h|0)?(a[d>>2]=a[p>>2],a[d+4>>2]=140114,Y(q,t,140176,d),u=e,-1):11==(h|0)?(a[c>>2]=f&65535,a[c+4>>2]=140114,Y(l,n,140210,c),u=e,-1):0},function(b,d,c,e){b|=0;var f,g,h,m,k,l=0,n=0,p=0,q=0,t=0;e=u;u=u+16|0;c=e+8|0;d=e;
f=w[b+88>>1]|0;g=a[1940]|0;a:do if(g){for(h=g;;){m=a[h+4>>2]|0;if((w[m+4>>1]|0)==f<<16>>16){k=m;break}h=a[h>>2]|0;if(!h){h=3;break a}}h=a[b+628>>2]|0;m=a[b>>2]|0;k?(p=k,q=h,t=m,h=10):(l=h,n=m,h=11)}else h=3;while(0);a:do if(3==(h|0)){b:do if(a[1941]|0){for(k=7764;;){if((w[k+4>>1]|0)==f<<16>>16){g=k;break}k=k+12|0;if(!(a[k>>2]|0))break b}p=g;q=a[b+628>>2]|0;t=a[b>>2]|0;h=10;break a}while(0);l=a[b+628>>2]|0;n=a[b>>2]|0;h=11}while(0);return 10==(h|0)?(a[d>>2]=a[p>>2],a[d+4>>2]=143001,Y(q,t,140176,d),
u=e,-1):11==(h|0)?(a[c>>2]=f&65535,a[c+4>>2]=143001,Y(l,n,140210,c),u=e,-1):0},function(b,d,c,e){b|=0;var f,g,h,m,k,l=0,n=0,p=0,q=0,t=0;e=u;u=u+16|0;c=e+8|0;d=e;f=w[b+88>>1]|0;g=a[1940]|0;a:do if(g){for(h=g;;){m=a[h+4>>2]|0;if((w[m+4>>1]|0)==f<<16>>16){k=m;break}h=a[h>>2]|0;if(!h){h=3;break a}}h=a[b+628>>2]|0;m=a[b>>2]|0;k?(p=k,q=h,t=m,h=10):(l=h,n=m,h=11)}else h=3;while(0);a:do if(3==(h|0)){b:do if(a[1941]|0){for(k=7764;;){if((w[k+4>>1]|0)==f<<16>>16){g=k;break}k=k+12|0;if(!(a[k>>2]|0))break b}p=
g;q=a[b+628>>2]|0;t=a[b>>2]|0;h=10;break a}while(0);l=a[b+628>>2]|0;n=a[b>>2]|0;h=11}while(0);return 10==(h|0)?(a[d>>2]=a[p>>2],a[d+4>>2]=142996,Y(q,t,140176,d),u=e,-1):11==(h|0)?(a[c>>2]=f&65535,a[c+4>>2]=142996,Y(l,n,140210,c),u=e,-1):0},function(b,d,c,e){b|=0;var f,g,h,m,k,l=0,n=0,p=0,q=0,t=0;e=u;u=u+16|0;c=e+8|0;d=e;f=w[b+88>>1]|0;g=a[1940]|0;a:do if(g){for(h=g;;){m=a[h+4>>2]|0;if((w[m+4>>1]|0)==f<<16>>16){k=m;break}h=a[h>>2]|0;if(!h){h=3;break a}}h=a[b+628>>2]|0;m=a[b>>2]|0;k?(p=k,q=h,t=m,h=
10):(l=h,n=m,h=11)}else h=3;while(0);a:do if(3==(h|0)){b:do if(a[1941]|0){for(k=7764;;){if((w[k+4>>1]|0)==f<<16>>16){g=k;break}k=k+12|0;if(!(a[k>>2]|0))break b}p=g;q=a[b+628>>2]|0;t=a[b>>2]|0;h=10;break a}while(0);l=a[b+628>>2]|0;n=a[b>>2]|0;h=11}while(0);return 10==(h|0)?(a[d>>2]=a[p>>2],a[d+4>>2]=140114,Y(q,t,140080,d),u=e,-1):11==(h|0)?(a[c>>2]=f&65535,a[c+4>>2]=140114,Y(l,n,140123,c),u=e,-1):0},function(b,d,c,e){b|=0;var f,g,h,m,k,l=0,n=0,p=0,q=0,t=0;e=u;u=u+16|0;c=e+8|0;d=e;f=w[b+88>>1]|0;g=
a[1940]|0;a:do if(g){for(h=g;;){m=a[h+4>>2]|0;if((w[m+4>>1]|0)==f<<16>>16){k=m;break}h=a[h>>2]|0;if(!h){h=3;break a}}h=a[b+628>>2]|0;m=a[b>>2]|0;k?(p=k,q=h,t=m,h=10):(l=h,n=m,h=11)}else h=3;while(0);a:do if(3==(h|0)){b:do if(a[1941]|0){for(k=7764;;){if((w[k+4>>1]|0)==f<<16>>16){g=k;break}k=k+12|0;if(!(a[k>>2]|0))break b}p=g;q=a[b+628>>2]|0;t=a[b>>2]|0;h=10;break a}while(0);l=a[b+628>>2]|0;n=a[b>>2]|0;h=11}while(0);return 10==(h|0)?(a[d>>2]=a[p>>2],a[d+4>>2]=143001,Y(q,t,140080,d),u=e,-1):11==(h|0)?
(a[c>>2]=f&65535,a[c+4>>2]=143001,Y(l,n,140123,c),u=e,-1):0},function(b,d,c,e){b|=0;var f,g,h,m,k,l=0,n=0,p=0,q=0,t=0;e=u;u=u+16|0;c=e+8|0;d=e;f=w[b+88>>1]|0;g=a[1940]|0;a:do if(g){for(h=g;;){m=a[h+4>>2]|0;if((w[m+4>>1]|0)==f<<16>>16){k=m;break}h=a[h>>2]|0;if(!h){h=3;break a}}h=a[b+628>>2]|0;m=a[b>>2]|0;k?(p=k,q=h,t=m,h=10):(l=h,n=m,h=11)}else h=3;while(0);a:do if(3==(h|0)){b:do if(a[1941]|0){for(k=7764;;){if((w[k+4>>1]|0)==f<<16>>16){g=k;break}k=k+12|0;if(!(a[k>>2]|0))break b}p=g;q=a[b+628>>2]|0;
t=a[b>>2]|0;h=10;break a}while(0);l=a[b+628>>2]|0;n=a[b>>2]|0;h=11}while(0);return 10==(h|0)?(a[d>>2]=a[p>>2],a[d+4>>2]=142996,Y(q,t,140080,d),u=e,-1):11==(h|0)?(a[c>>2]=f&65535,a[c+4>>2]=142996,Y(l,n,140123,c),u=e,-1):0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h;e=u;u=u+32|0;f=e;g=b+608|0;h=a[g>>2]|0;if((h|0)<(c|0))return g=a[b+628>>2]|0,a[f>>2]=a[b+444>>2],b=f+8|0,a[b>>2]=h,a[b+4>>2]=(0>(h|0))<<31>>31,b=f+16|0,a[b>>2]=c,a[b+4>>2]=(0>(c|0))<<31>>31,Y(g,142682,142697,f),u=e,0;f=b+604|0;b=a[f>>2]|
0;(b|0)==(d|0)?b=d:(Ab(d,b,c),b=a[f>>2]|0,h=a[g>>2]|0);a[f>>2]=b+c;a[g>>2]=h-c;u=e;return 1},function(b,d,c,e){b|=0;c|=0;var f=0,g,h,m,k,l,n;if(0>=(c|0))return 1;e=b+608|0;g=b+592|0;h=b+604|0;m=c;for(c=d|0;;){d=a[e>>2]|0;k=a[g>>2]|0;l=(d+m|0)>(k|0)?k-d|0:m;if(0>=(l|0)){b=4;break}n=a[h>>2]|0;(n|0)==(c|0)?n=c:(Ab(n,c,l),n=a[h>>2]|0,d=a[e>>2]|0,k=a[g>>2]|0);a[h>>2]=n+l;n=d+l|0;a[e>>2]=n;c=c+l|0;m=m-l|0;if((n|0)>=(k|0)&&0==(Lc(b)|0)){f=-1;b=10;break}if(0>=(m|0)){f=1;b=10;break}}if(4==(b|0))Z(142646,142652,
55,142667);else if(10==(b|0))return f|0;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,t=0,r=0,w=0,v=0,z=0,Q=0,C=0,A=0,V=0,E=0,J=0,I=0,G=0,D=0,K=0,F=0,N=0,O=0,M=0,T=0,X=0,P=0,S=0,R=0,W=0,ba=0,U=0,Z=0,da=0,ga=0,aa=0,ma=0,ca=0,ha=0,fa=0,ja=0,pa=0,ya=0,ra=0,Aa=0,oa=0,sa=0,Ka=0,ua=0,Ia=0,Da=0,na=0,Na=0,Qa=0,Ca=0,Ga=0,Ea=0,La=0,Wa=0,Va=0,eb=0,fb=0,xb=0,Zb=0,db=0,jb=0,mc=0,pb=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,
va=0,za=0,ta=0,nb=0,ub=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,lb=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,ab=0,Ua=0,rb=0,Jb=0,Ab=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,Hb=0,Lb=0,Gb=0,Kb=0,wb=0,Sb=0,Pb=0,zb=0,Ob=0,Tb=0,Qb=0,ac=0,Vb=0,Yb=0,ec=0,fc=0,$b=0,lc=0,jc=0,kc=0,nc=0,hc=0,yc=0,xc=0,vc=0,Bc=0,Cc=0,Ec=0,zc=0,Gc=0,oc=0,Hc=0,Jc=0,Lc=0,ic=0,Fc=0,Ic=0,bd=0,Oc=0,Rc=0,Uc=0,Wc=0,Pc=0,ad=0,Qc=0,Vc=0,$c=0,hd=0,Xc=0,cd=0,Rb=0,od=0,tc=0,Xb=0,rc=0,ed=0,gd=0,dd=0,ld=0,md=0,sd=0,td=0,Yc=0,wc=0,id=0,dc=0,Ac=
0,Sc=0,Tc=0,qd=0,rd=0,jd=0,vd=0,wd=0,pd=0,zd=0,Cd=0,Dd=0,Kd=0,Nd=0,Id=0,Xd=0,ce=0,oe=0,Pd=0,Vd=0,Df=0,Md=0,ne=0,qe=0,Ld=0,he=0,te=0,de=0,He=0,ue=0,Od=0,Sd=0,ae=0,De=0,be=0,Fd=0,Rd=0,Gd=0,$d=0,ge=0,ud=0,xd=0,ie=0,je=0,xe=0,Of=0,Dc=0,yd=0,Ad=0,Td=0,se=0,le=0,Ye=0,Yd=0,ve=0,Je=0,ze=0,Qe=0,we=0,Ze=0,re=0,Ae=0,kf=0,ee=0,df=0,ye=0,ef=0,Ue=0,Ke=0,Ne=0,$e=0,me=0,Oe=0,Pe=0,Me=0;e=u;u=u+176|0;f=e+144|0;g=e+120|0;h=e+104|0;m=e+88|0;k=e+72|0;l=e+56|0;n=e+40|0;p=e+24|0;q=e+8|0;t=a[b+576>>2]|0;r=a[t+12>>2]|0;w=
a[t+44>>2]|0;v=t+8|0;if((c|0)%(a[v>>2]|0)|0)return Y(a[b+628>>2]|0,143789,153793,e),z=-1,u=e,z|0;Q=t+48|0;C=a[Q>>2]|0;A=t+52|0;V=a[A>>2]|0;E=t+56|0;J=a[E>>2]|0;I=b+604|0;G=a[I>>2]|0;D=b+608|0;K=a[D>>2]|0;F=G+K|0;do if(0<(c|0)){N=t+72|0;O=t+68|0;M=0<(r|0);T=t+92|0;X=b+628|0;P=b+12|0;S=b+492|0;R=b+452|0;W=t+60|0;ba=d;U=c;Z=a[O>>2]|0;da=a[N>>2]|0;ga=C;aa=V;ma=J;ca=G;a:for(;;){b:do if(M){ha=da;fa=ga;ja=aa;ya=pa=0;ra=a[Z>>2]|0;Aa=ca;oa=da;sa=Z+4|0;c:for(;;){Ka=(oa|0)==(da|0);d:do if(Ka)for(ua=fa,Ia=ja,
Da=0,na=pa,Na=ya,Qa=ra,Ca=Aa,Ga=sa;;){do if(7>(Ia|0))if(Ca>>>0>=F>>>0)if(Ia)mc=ua,pb=7,Ta=Ca;else{Ea=ba;La=da;Wa=ua;Va=0;eb=ma;fb=Da;xb=Na;Zb=Ca;db=da;jb=88;break a}else mc=(x[w+(x[Ca>>0]|0)>>0]|0)<<Ia|ua,pb=Ia+8|0,Ta=Ca+1|0;else mc=ua,pb=Ia,Ta=Ca;while(0);Ya=mc&127;Sa=x[(Ya<<3)+8281>>0]|0;mb=pb-Sa|0;Db=mc>>>Sa;switch(x[8280+(Ya<<3)>>0]|0){case 6:cc=mb;Za=Db;ia=Da;qa=Na;Ja=Ta;ea=da;jb=77;break c;case 12:wa=Sa;Ma=mb;xa=Db;$a=pb;la=Da;Ba=Na;va=Ta;za=da;jb=78;break c;case 2:ta=mb;nb=Db;ub=Da;gb=Na;hb=
Qa;ob=Ta;Bb=Ga;jb=22;break d;case 3:qb=mb;kb=Db;ib=Da;Cb=Na;lb=na;sb=Qa;Xa=Ta;Fa=Ga;jb=62;break d;case 4:Pa=Ya;Eb=mb;vb=Db;tb=Da;bb=Na;Ib=na;Mb=Qa;ab=Ta;Ua=Ga;jb=66;break d;case 5:rb=Ya;Jb=mb;Ab=Db;yb=Da;cb=Na;gc=Qa;Ub=Ta;Fb=Ga;jb=70;break d;case 1:break;default:Hb=Db;Lb=mb;Gb=Da;Kb=Na;wb=Ta;Sb=da;jb=85;break c}Ya=(a[Ga>>2]|0)+Qa|0;Sa=na+Da+Ya|0;if((r|0)>(Ya|0))ua=Db,Ia=mb,Da=Sa,na=0-Ya|0,Na=Ya,Qa=Ya+(a[Ga+4>>2]|0)|0,Ca=Ta,Ga=Ga+8|0;else{Pb=Db;zb=mb;Ob=Sa;Tb=Ya;Qb=Ta;ac=da;jb=99;break c}}else for(Ga=
fa,Ca=ja,Qa=0,Na=pa,na=ya,Da=ra,Ia=Aa,ua=sa;;){do if(7>(Ca|0))if(Ia>>>0>=F>>>0)if(Ca)Vb=Ga,Yb=7,ec=Ia;else{Ea=ba;La=da;Wa=Ga;Va=0;eb=ma;fb=Qa;xb=na;Zb=Ia;db=oa;jb=88;break a}else Vb=(x[w+(x[Ia>>0]|0)>>0]|0)<<Ca|Ga,Yb=Ca+8|0,ec=Ia+1|0;else Vb=Ga,Yb=Ca,ec=Ia;while(0);Ya=Vb&127;Sa=x[(Ya<<3)+8281>>0]|0;mb=Yb-Sa|0;Db=Vb>>>Sa;switch(x[8280+(Ya<<3)>>0]|0){case 6:cc=mb;Za=Db;ia=Qa;qa=na;Ja=ec;ea=oa;jb=77;break c;case 12:wa=Sa;Ma=mb;xa=Db;$a=Yb;la=Qa;Ba=na;va=ec;za=oa;jb=78;break c;case 2:ta=mb;nb=Db;ub=Qa;
gb=na;hb=Da;ob=ec;Bb=ua;jb=22;break d;case 3:qb=mb;kb=Db;ib=Qa;Cb=na;lb=Na;sb=Da;Xa=ec;Fa=ua;jb=62;break d;case 4:Pa=Ya;Eb=mb;vb=Db;tb=Qa;bb=na;Ib=Na;Mb=Da;ab=ec;Ua=ua;jb=66;break d;case 5:rb=Ya;Jb=mb;Ab=Db;yb=Qa;cb=na;gc=Da;Ub=ec;Fb=ua;jb=70;break d;case 1:break;default:Hb=Db;Lb=mb;Gb=Qa;Kb=na;wb=ec;Sb=oa;jb=85;break c}if((Da|0)<=(na|0)&(Da|0)<(r|0))for(Ya=Da,Sa=ua;;)if(fc=(a[Sa>>2]|0)+Ya+(a[Sa+4>>2]|0)|0,$b=Sa+8|0,(fc|0)<=(na|0)&(fc|0)<(r|0))Ya=fc,Sa=$b;else{lc=fc;jc=$b;break}else lc=Da,jc=ua;Sa=
(a[jc>>2]|0)+lc|0;Ya=Na+Qa+Sa|0;if((r|0)>(Sa|0))Ga=Db,Ca=mb,Qa=Ya,Na=0-Sa|0,na=Sa,Da=Sa+(a[jc+4>>2]|0)|0,Ia=ec,ua=jc+8|0;else{Pb=Db;zb=mb;Ob=Ya;Tb=Sa;Qb=ec;ac=oa;jb=99;break c}}while(0);if(22==(jb|0)){jb=0;if(oa-ha&4){Na=nb;Ga=ta;ua=ub;Ia=gb;Da=ob;d:for(;;){do if(13>(Ga|0)){if(Da>>>0>=F>>>0)if(Ga){Xb=Na;rc=13;ed=Da;break}else{Ea=ba;La=da;Wa=Na;Va=0;eb=ma;fb=ua;xb=Ia;Zb=Da;db=oa;jb=88;break a}Qa=Da+1|0;Sa=(x[w+(x[Da>>0]|0)>>0]|0)<<Ga|Na;Ya=Ga+8|0;13>(Ya|0)?Qa>>>0<F>>>0?(Xb=(x[w+(x[Qa>>0]|0)>>0]|0)<<
Ya|Sa,rc=Ga+16|0,ed=Da+2|0):(Xb=Sa,rc=13,ed=Qa):(Xb=Sa,rc=Ya,ed=Qa)}else Xb=Na,rc=Ga,ed=Da;while(0);Qa=Xb&8191;Ya=x[(Qa<<3)+42073>>0]|0;Sa=rc-Ya|0;Ca=Xb>>>Ya;switch(x[42072+(Qa<<3)>>0]|0){case 8:gd=Qa;dd=Sa;ld=Ca;md=ua;sd=Ia;td=ed;break d;case 11:case 10:break;default:ad=Ca;Qc=Sa;Vc=ua;$c=Ia;hd=ed;Xc=oa;jb=86;break c}Ya=a[(Qa<<3)+42076>>2]|0;Na=Ca;Ga=Sa;ua=Ya+ua|0;Ia=Ya+Ia|0;Da=ed}Da=a[(gd<<3)+42076>>2]|0;Ia=oa+4|0;a[oa>>2]=Da+md;ua=ld;Ga=dd;Na=0;na=Da+sd|0;Da=td;d:for(;;){do if(12>(Ga|0)){if(Da>>>
0>=F>>>0)if(Ga){Yc=ua;wc=12;id=Da;break}else{Ea=ba;La=da;Wa=ua;Va=0;eb=ma;fb=Na;xb=na;Zb=Da;db=Ia;jb=88;break a}Ya=Da+1|0;Sa=(x[w+(x[Da>>0]|0)>>0]|0)<<Ga|ua;Ca=Ga+8|0;12>(Ca|0)?Ya>>>0<F>>>0?(Yc=(x[w+(x[Ya>>0]|0)>>0]|0)<<Ca|Sa,wc=Ga+16|0,id=Da+2|0):(Yc=Sa,wc=12,id=Ya):(Yc=Sa,wc=Ca,id=Ya)}else Yc=ua,wc=Ga,id=Da;while(0);Ya=Yc&4095;Ca=x[(Ya<<3)+9305>>0]|0;Sa=wc-Ca|0;Qa=Yc>>>Ca;switch(x[9304+(Ya<<3)>>0]|0){case 7:dc=Ya;Ac=Sa;Sc=Qa;Tc=Na;qd=na;rd=id;break d;case 11:case 9:break;default:zc=Qa;Gc=Sa;oc=
Na;Hc=na;Jc=id;Lc=Ia;jb=87;break c}Ca=a[(Ya<<3)+9308>>2]|0;ua=Qa;Ga=Sa;Na=Ca+Na|0;na=Ca+na|0;Da=id}Da=a[(dc<<3)+9308>>2]|0;a[Ia>>2]=Da+Tc;cd=Sc;Rb=Ac;od=Da+qd|0;tc=rd}else{ua=nb;Ia=ta;Da=ub;na=gb;Na=ob;d:for(;;){do if(12>(Ia|0)){if(Na>>>0>=F>>>0)if(Ia){kc=ua;nc=12;hc=Na;break}else{Ea=ba;La=da;Wa=ua;Va=0;eb=ma;fb=Da;xb=na;Zb=Na;db=oa;jb=88;break a}Qa=Na+1|0;Ca=(x[w+(x[Na>>0]|0)>>0]|0)<<Ia|ua;Ga=Ia+8|0;12>(Ga|0)?Qa>>>0<F>>>0?(kc=(x[w+(x[Qa>>0]|0)>>0]|0)<<Ga|Ca,nc=Ia+16|0,hc=Na+2|0):(kc=Ca,nc=12,hc=
Qa):(kc=Ca,nc=Ga,hc=Qa)}else kc=ua,nc=Ia,hc=Na;while(0);Qa=kc&4095;Ga=x[(Qa<<3)+9305>>0]|0;Ca=nc-Ga|0;Sa=kc>>>Ga;switch(x[9304+(Qa<<3)>>0]|0){case 7:yc=Qa;xc=Ca;vc=Sa;Bc=Da;Cc=na;Ec=hc;break d;case 11:case 9:break;default:zc=Sa;Gc=Ca;oc=Da;Hc=na;Jc=hc;Lc=oa;jb=87;break c}Ga=a[(Qa<<3)+9308>>2]|0;ua=Sa;Ia=Ca;Da=Ga+Da|0;na=Ga+na|0;Na=hc}Na=a[(yc<<3)+9308>>2]|0;na=oa+4|0;a[oa>>2]=Na+Bc;Da=vc;Ia=xc;ua=0;Ga=Na+Cc|0;Na=Ec;d:for(;;){do if(13>(Ia|0)){if(Na>>>0>=F>>>0)if(Ia){ic=Da;Fc=13;Ic=Na;break}else{Ea=
ba;La=da;Wa=Da;Va=0;eb=ma;fb=ua;xb=Ga;Zb=Na;db=na;jb=88;break a}Ca=Na+1|0;Sa=(x[w+(x[Na>>0]|0)>>0]|0)<<Ia|Da;Qa=Ia+8|0;13>(Qa|0)?Ca>>>0<F>>>0?(ic=(x[w+(x[Ca>>0]|0)>>0]|0)<<Qa|Sa,Fc=Ia+16|0,Ic=Na+2|0):(ic=Sa,Fc=13,Ic=Ca):(ic=Sa,Fc=Qa,Ic=Ca)}else ic=Da,Fc=Ia,Ic=Na;while(0);Ca=ic&8191;Qa=x[(Ca<<3)+42073>>0]|0;Sa=Fc-Qa|0;Ya=ic>>>Qa;switch(x[42072+(Ca<<3)>>0]|0){case 8:bd=Ca;Oc=Sa;Rc=Ya;Uc=ua;Wc=Ga;Pc=Ic;break d;case 11:case 10:break;default:ad=Ya;Qc=Sa;Vc=ua;$c=Ga;hd=Ic;Xc=na;jb=86;break c}Qa=a[(Ca<<
3)+42076>>2]|0;Da=Ya;Ia=Sa;ua=Qa+ua|0;Ga=Qa+Ga|0;Na=Ic}Na=a[(bd<<3)+42076>>2]|0;a[na>>2]=Na+Uc;cd=Rc;Rb=Oc;od=Na+Wc|0;tc=Pc}Da=oa+8|0;if((Da|0)!=(da|0))if((hb|0)<=(od|0)&(hb|0)<(r|0))for(na=hb,Na=Bb;;)if(Ga=(a[Na>>2]|0)+na+(a[Na+4>>2]|0)|0,ua=Na+8|0,(Ga|0)<=(od|0)&(Ga|0)<(r|0))na=Ga,Na=ua;else{jd=cd;vd=Rb;wd=od;pd=Ga;zd=tc;Cd=Da;Dd=ua;break}else jd=cd,vd=Rb,wd=od,pd=hb,zd=tc,Cd=Da,Dd=Bb;else jd=cd,vd=Rb,wd=od,pd=hb,zd=tc,Cd=da,Dd=Bb}else if(62==(jb|0)){jb=0;if(Ka?0:(sb|0)<=(Cb|0)&(sb|0)<(r|0))for(Na=
sb,na=Fa;;)if(Ia=(a[na>>2]|0)+Na+(a[na+4>>2]|0)|0,ua=na+8|0,(Ia|0)<=(Cb|0)&(Ia|0)<(r|0))Na=Ia,na=ua;else{Kd=Ia;Nd=ua;break}else Kd=sb,Nd=Fa;a[oa>>2]=lb+ib+Kd;jd=kb;vd=qb;wd=Kd;pd=(a[Nd>>2]|0)+Kd|0;zd=Xa;Cd=oa+4|0;Dd=Nd+4|0}else if(66==(jb|0)){jb=0;if(Ka?0:(Mb|0)<=(bb|0)&(Mb|0)<(r|0))for(na=Mb,Na=Ua;;)if(Da=(a[Na>>2]|0)+na+(a[Na+4>>2]|0)|0,ua=Na+8|0,(Da|0)<=(bb|0)&(Da|0)<(r|0))na=Da,Na=ua;else{Id=Da;Xd=ua;break}else Id=Mb,Xd=Ua;Na=a[(Pa<<3)+8284>>2]|0;a[oa>>2]=Ib+tb+Id+Na;jd=vb;vd=Eb;wd=Na+Id|0;pd=
(a[Xd>>2]|0)+Id|0;zd=ab;Cd=oa+4|0;Dd=Xd+4|0}else if(70==(jb|0)){jb=0;if((Na=(oa|0)!=(da|0))&&(gc|0)<=(cb|0)&(gc|0)<(r|0))for(na=gc,Ka=Fb;;)if(ua=(a[Ka>>2]|0)+na+(a[Ka+4>>2]|0)|0,Da=Ka+8|0,(ua|0)<=(cb|0)&(ua|0)<(r|0))na=ua,Ka=Da;else{ce=ua;oe=Da;break}else ce=gc,oe=Fb;Ka=a[(rb<<3)+8284>>2]|0;na=Ka+cb|0;if((ce|0)<=(na|0)&(Na|(ce|0)<(na|0))){Pd=Jb;Vd=Ab;Df=yb;Md=cb;ne=Ub;qe=oa;jb=74;break}a[oa>>2]=ce-cb+yb-Ka;na=oe+-4|0;jd=Ab;vd=Jb;wd=ce-Ka|0;pd=ce-(a[na>>2]|0)|0;zd=Ub;Cd=oa+4|0;Dd=na}if((r|0)>(wd|0))fa=
jd,ja=vd,pa=0-wd|0,ya=wd,ra=pd,Aa=zd,oa=Cd,sa=Dd;else{Ld=jd;he=vd;te=ma;de=wd;He=zd;ue=Cd;break b}}do if(74==(jb|0))jb=0,sa=a[X>>2]|0,oa=0!=(a[P>>2]&1024|0),Aa=a[(oa?S:R)>>2]|0,a[q>>2]=a[T>>2],a[q+4>>2]=oa?142996:143001,a[q+8>>2]=Aa,a[q+12>>2]=Md,Y(sa,143789,143007,q),Od=Vd,Sd=Pd,ae=ma,De=Df,be=Md,Fd=ne,Rd=qe;else if(77==(jb|0))jb=0,a[ea>>2]=r-qa,sa=a[X>>2]|0,Aa=0!=(a[P>>2]&1024|0),oa=a[(Aa?S:R)>>2]|0,a[p>>2]=a[T>>2],a[p+4>>2]=Aa?142996:143001,a[p+8>>2]=oa,a[p+12>>2]=qa,Y(sa,143789,143800,p),Od=Za,
Sd=cc,ae=ma,De=ia,be=qa,Fd=Ja,Rd=ea+4|0;else if(78==(jb|0)){jb=0;sa=za+4|0;a[za>>2]=r-Ba;do if(4>(Ma|0))if(va>>>0>=F>>>0)if(($a|0)==(wa|0)){Ea=ba;La=da;Wa=xa;Va=Ma;eb=ma;fb=la;xb=Ba;Zb=va;db=sa;jb=88;break a}else Gd=xa,$d=4,ge=va;else Gd=(x[w+(x[va>>0]|0)>>0]|0)<<Ma|xa,$d=Ma+8|0,ge=va+1|0;else Gd=xa,$d=Ma,ge=va;while(0);Gd&15&&(Na=a[X>>2]|0,oa=0!=(a[P>>2]&1024|0),Aa=a[(oa?S:R)>>2]|0,a[n>>2]=a[T>>2],a[n+4>>2]=oa?142996:143001,a[n+8>>2]=Aa,a[n+12>>2]=Ba,Y(Na,143789,143007,n));Od=Gd>>>4;Sd=$d+-4|0;ae=
1;De=la;be=Ba;Fd=ge;Rd=sa}else if(86==(jb|0))jb=0,Na=a[X>>2]|0,Aa=0!=(a[P>>2]&1024|0),oa=a[(Aa?S:R)>>2]|0,a[k>>2]=a[T>>2],a[k+4>>2]=Aa?142996:143001,a[k+8>>2]=oa,a[k+12>>2]=$c,Y(Na,143789,143007,k),Od=ad,Sd=Qc,ae=ma,De=Vc,be=$c,Fd=hd,Rd=Xc;else if(87==(jb|0))jb=0,Na=a[X>>2]|0,oa=0!=(a[P>>2]&1024|0),Aa=a[(oa?S:R)>>2]|0,a[m>>2]=a[T>>2],a[m+4>>2]=oa?142996:143001,a[m+8>>2]=Aa,a[m+12>>2]=Hc,Y(Na,143789,143007,m),Od=zc,Sd=Gc,ae=ma,De=oc,be=Hc,Fd=Jc,Rd=Lc;else if(99==(jb|0)){jb=0;if(!Ob){Ld=Pb;he=zb;te=
ma;de=Tb;He=Qb;ue=ac;break b}if((Tb+Ob|0)<(r|0)){do if(1>(zb|0))if(Qb>>>0>=F>>>0)if(zb)ud=Pb,xd=1,ie=Qb;else{Ea=ba;La=da;Wa=Pb;Va=0;eb=ma;fb=Ob;xb=Tb;Zb=Qb;db=ac;jb=88;break a}else ud=(x[w+(x[Qb>>0]|0)>>0]|0)<<zb|Pb,xd=zb+8|0,ie=Qb+1|0;else ud=Pb,xd=zb,ie=Qb;while(0);if(!(ud&1)){Hb=ud;Lb=xd;Gb=Ob;Kb=Tb;wb=ie;Sb=ac;jb=85;break}je=ud>>>1;xe=xd+-1|0;Of=ie}else je=Pb,xe=zb,Of=Qb;a[ac>>2]=Ob;Ld=je;he=xe;te=ma;de=Tb;He=Of;ue=ac+4|0;break b}while(0);85==(jb|0)&&(jb=0,sa=a[X>>2]|0,Na=0!=(a[P>>2]&1024|0),
Aa=a[(Na?S:R)>>2]|0,a[l>>2]=a[T>>2],a[l+4>>2]=Na?142996:143001,a[l+8>>2]=Aa,a[l+12>>2]=Kb,Y(sa,143789,143007,l),Od=Hb,Sd=Lb,ae=ma,De=Gb,be=Kb,Fd=wb,Rd=Sb);De?(a[Rd>>2]=De,Ld=Od,he=Sd,te=ae,de=be,He=Fd,ue=Rd+4|0):(Ld=Od,he=Sd,te=ae,de=be,He=Fd,ue=Rd)}else Ld=ga,he=aa,te=ma,de=0,He=ca,ue=da;while(0);do if((de|0)==(r|0))Dc=ue;else{sa=a[T>>2]|0;Aa=a[X>>2]|0;Na=0!=(a[P>>2]&1024|0);oa=a[(Na?S:R)>>2]|0;a[f>>2]=de>>>0<r>>>0?143089:143103;a[f+4>>2]=sa;a[f+8>>2]=Na?142996:143001;a[f+12>>2]=oa;a[f+16>>2]=de;
a[f+20>>2]=r;Wb(Aa,143789,143124,f);Aa=(de|0)>(r|0);if(Aa&ue>>>0>da>>>0)for(oa=de,Na=ue;;)if(sa=Na+-4|0,ra=oa-(a[sa>>2]|0)|0,ya=(ra|0)>(r|0),ya&sa>>>0>da>>>0)oa=ra,Na=sa;else{yd=ya;Ad=ra;Td=sa;break}else yd=Aa,Ad=de,Td=ue;(Ad|0)>=(r|0)?yd?(a[Td>>2]=r,a[Td+4>>2]=0,Dc=Td+8|0):Dc=Td:(Td-da&4?(a[Td>>2]=0,se=Td+4|0):se=Td,a[se>>2]=r-(0>(Ad|0)?0:Ad),Dc=se+4|0)}while(0);if(te){le=ba;Ye=da;Yd=Ld;ve=he;Je=te;ze=He;Qe=Dc;break}Ud[a[W>>2]&31](ba,da,Dc,r);a[Dc>>2]=0;Z=a[N>>2]|0;da=a[O>>2]|0;a[N>>2]=da;a[O>>2]=
Z;Na=a[v>>2]|0;U=U-Na|0;a[T>>2]=(a[T>>2]|0)+1;if(0>=(U|0)){we=Ld;Ze=he;re=He;jb=128;break}else ba=ba+Na|0,ga=Ld,aa=he,ma=0,ca=He}if(128==(jb|0))Ae=a[I>>2]|0,kf=a[D>>2]|0,ee=we,df=Ze,ye=0,ef=re;else{do if(88==(jb|0))if(ca=a[X>>2]|0,ma=0!=(a[P>>2]&1024|0),aa=a[(ma?S:R)>>2]|0,a[h>>2]=a[T>>2],a[h+4>>2]=ma?142996:143001,a[h+8>>2]=aa,a[h+12>>2]=xb,Wb(ca,143789,143048,h),fb?(a[db>>2]=fb,Ue=db+4|0):Ue=db,(xb|0)==(r|0))le=Ea,Ye=La,Yd=Wa,ve=Va,Je=eb,ze=Zb,Qe=Ue;else{ca=a[T>>2]|0;aa=a[X>>2]|0;ma=0!=(a[P>>2]&
1024|0);ga=a[(ma?S:R)>>2]|0;a[g>>2]=xb>>>0<r>>>0?143089:143103;a[g+4>>2]=ca;a[g+8>>2]=ma?142996:143001;a[g+12>>2]=ga;a[g+16>>2]=xb;a[g+20>>2]=r;Wb(aa,143789,143124,g);aa=(xb|0)>(r|0);if(aa&Ue>>>0>La>>>0)for(ga=xb,ma=Ue;;)if(ca=ma+-4|0,ba=ga-(a[ca>>2]|0)|0,U=(ba|0)>(r|0),U&ca>>>0>La>>>0)ga=ba,ma=ca;else{Ke=U;Ne=ba;$e=ca;break}else Ke=aa,Ne=xb,$e=Ue;(Ne|0)>=(r|0)?Ke?(a[$e>>2]=r,a[$e+4>>2]=0,le=Ea,Ye=La,Yd=Wa,ve=Va,Je=eb,ze=Zb,Qe=$e+8|0):(le=Ea,Ye=La,Yd=Wa,ve=Va,Je=eb,ze=Zb,Qe=$e):($e-La&4?(a[$e>>2]=
0,me=$e+4|0):me=$e,a[me>>2]=r-(0>(Ne|0)?0:Ne),le=Ea,Ye=La,Yd=Wa,ve=Va,Je=eb,ze=Zb,Qe=me+4|0)}while(0);13>(ve|0)?ze>>>0>=F>>>0?(Oe=Yd,Pe=0==(ve|0)?0:13,Me=ze):(R=ze+1|0,S=(x[w+(x[ze>>0]|0)>>0]|0)<<ve|Yd,P=ve+8|0,13>(P|0)?R>>>0<F>>>0?(Oe=(x[w+(x[R>>0]|0)>>0]|0)<<P|S,Pe=ve+16|0,Me=ze+2|0):(Oe=S,Pe=13,Me=R):(Oe=S,Pe=P,Me=R)):(Oe=Yd,Pe=ve,Me=ze);Ud[a[W>>2]&31](le,Ye,Qe,r);a[A>>2]=Pe+-13;a[Q>>2]=Oe>>>13;a[E>>2]=Je;a[D>>2]=(a[I>>2]|0)-Me+(a[D>>2]|0);a[I>>2]=Me;z=0!=(a[T>>2]|0)?1:-1;u=e;return z|0}}else Ae=
G,kf=K,ee=C,df=V,ye=J,ef=G;while(0);a[A>>2]=df;a[Q>>2]=ee;a[E>>2]=ye;a[D>>2]=Ae-ef+kf;a[I>>2]=ef;z=1;u=e;return z|0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m;e=u;u=u+16|0;f=a[b+576>>2]|0;g=f+8|0;if((c|0)%(a[g>>2]|0)|0)return Y(a[b+628>>2]|0,143192,143203,e),u=e,0;if(0>=(c|0))return u=e,1;h=f+80|0;m=f+12|0;f=d;for(d=c;!(bl(b,f,a[h>>2]|0,a[m>>2]|0),Ab(a[h>>2]|0,f,a[g>>2]|0),c=a[g>>2]|0,d=d-c|0,0>=(d|0));)f=f+c|0;u=e;return 1},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f=0,g=0,h=0,m=0,k=0,l=0,n=0,
p=0,q=0,t=0,r=0,w=0,v=0,z=0,Q=0,C=0,A=0,V=0,E=0,J=0,I=0,G=0,D=0,K=0,F=0,N=0,O=0,M=0,T=0,X=0,P=0,S=0,R=0,W=0,ba=0,U=0,Z=0,da=0,ga=0,aa=0,ma=0,ca=0,ha=0,fa=0,ja=0,pa=0,ya=0,ra=0,Aa=0,oa=0,sa=0,Qa=0,ua=0,Ia=0,Da=0,na=0,Na=0,Ka=0,Ca=0,Ga=0,Ea=0,La=0,Wa=0,Va=0,eb=0,db=0,xb=0,Zb=0,fb=0,jb=0,pb=0,ub=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,lb=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,ab=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,
rb=0,Ua=0,Ab=0,Jb=0,Hb=0,yb=0,cb=0,gc=0,Ub=0,Fb=0,Lb=0,Gb=0,Kb=0,Qb=0,wb=0,Pb=0,Sb=0,zb=0,Ob=0;e=u;u=u+112|0;f=e+80|0;g=e+56|0;h=e+40|0;m=e+24|0;k=e+8|0;l=a[b+576>>2]|0;n=a[l+12>>2]|0;p=a[l+44>>2]|0;q=a[l+4>>2]|0;t=l+8|0;if((c|0)%(a[t>>2]|0)|0)return Y(a[b+628>>2]|0,142982,153793,e),r=-1,u=e,r|0;w=l+48|0;v=a[w>>2]|0;z=l+52|0;Q=a[z>>2]|0;C=l+56|0;A=a[C>>2]|0;V=b+604|0;E=a[V>>2]|0;J=b+608|0;I=a[J>>2]|0;G=E+I|0;D=a[l+72>>2]|0;do if(0<(c|0)){K=l+92|0;F=b+628|0;N=b+12|0;O=b+492|0;M=b+452|0;T=l+60|0;X=
0==(q&4|0);P=0==(q&8|0);S=D;R=d;W=c;ba=v;U=Q;Z=A;da=E;a:for(;;){ga=ba;aa=U;ma=0;ca=da;ha=D;b:for(;;){fa=ga;ja=aa;pa=0;ya=ma;ra=ca;c:for(;;){do if(12>(ja|0)){if(ra>>>0>=G>>>0)if(ja){na=fa;Na=12;Ka=ra;break}else{Aa=R;oa=fa;sa=Z;Qa=pa;ua=ya;Ia=ra;Da=ha;break a}Ca=ra+1|0;Ga=(x[p+(x[ra>>0]|0)>>0]|0)<<ja|fa;Ea=ja+8|0;12>(Ea|0)?Ca>>>0<G>>>0?(na=(x[p+(x[Ca>>0]|0)>>0]|0)<<Ea|Ga,Na=ja+16|0,Ka=ra+2|0):(na=Ga,Na=12,Ka=Ca):(na=Ga,Na=Ea,Ka=Ca)}else na=fa,Na=ja,Ka=ra;while(0);Ca=na&4095;Ea=x[(Ca<<3)+9305>>0]|0;
Ga=Na-Ea|0;La=na>>>Ea;switch(x[9304+(Ca<<3)>>0]|0){case 12:Wa=La;Va=Ga;eb=1;db=pa;xb=ya;Zb=Ka;fb=ha;jb=39;break b;case 7:pb=Ca;ub=Ga;Ta=La;Ya=pa;Sa=ya;mb=Ka;break c;case 11:case 9:break;default:Db=Ga;cc=La;Za=pa;ia=ya;qa=Ka;Ja=ha;jb=16;break b}Ea=a[(Ca<<3)+9308>>2]|0;fa=La;ja=Ga;pa=Ea+pa|0;ya=Ea+ya|0;ra=Ka}ra=a[(pb<<3)+9308>>2]|0;ya=ra+Ya|0;pa=ha+4|0;a[ha>>2]=ya;ja=ra+Sa|0;if((ja|0)<(n|0))ea=Ta,wa=ub,Ma=0,xa=ja,$a=mb;else{la=Ta;Ba=ub;va=Z;za=ja;ta=mb;nb=pa;break}c:for(;;){do if(13>(wa|0)){if($a>>>
0>=G>>>0)if(wa){lb=ea;gb=13;hb=$a;break}else{Aa=R;oa=ea;sa=Z;Qa=Ma;ua=xa;Ia=$a;Da=pa;break a}ja=$a+1|0;ra=(x[p+(x[$a>>0]|0)>>0]|0)<<wa|ea;fa=wa+8|0;13>(fa|0)?ja>>>0<G>>>0?(lb=(x[p+(x[ja>>0]|0)>>0]|0)<<fa|ra,gb=wa+16|0,hb=$a+2|0):(lb=ra,gb=13,hb=ja):(lb=ra,gb=fa,hb=ja)}else lb=ea,gb=wa,hb=$a;while(0);ja=lb&8191;fa=x[(ja<<3)+42073>>0]|0;ra=gb-fa|0;Ea=lb>>>fa;switch(x[42072+(ja<<3)>>0]|0){case 12:Wa=Ea;Va=ra;eb=1;db=Ma;xb=xa;Zb=hb;fb=pa;jb=39;break b;case 8:ob=ja;Bb=ra;qb=Ea;kb=Ma;ib=xa;Cb=hb;break c;
case 11:case 10:break;default:ab=ra;sb=Ea;Xa=pa;Fa=Ma;Pa=xa;Eb=hb;jb=26;break b}fa=a[(ja<<3)+42076>>2]|0;ea=Ea;wa=ra;Ma=fa+Ma|0;xa=fa+xa|0;$a=hb}fa=a[(ob<<3)+42076>>2]|0;ra=fa+kb|0;Ea=ha+8|0;a[pa>>2]=ra;ja=fa+ib|0;if((ja|0)>=(n|0)){la=qb;Ba=Bb;va=Z;za=ja;ta=Cb;nb=Ea;break}ga=qb;aa=Bb;ma=ja;ca=Cb;ha=0==(ra|ya|0)?ha:Ea}16==(jb|0)?(jb=0,ha=a[F>>2]|0,ca=0!=(a[N>>2]&1024|0),ma=a[(ca?O:M)>>2]|0,a[k>>2]=a[K>>2],a[k+4>>2]=ca?142996:143001,a[k+8>>2]=ma,a[k+12>>2]=ia,Y(ha,142982,143007,k),Wa=cc,Va=Db,eb=Z,
db=Za,xb=ia,Zb=qa,fb=Ja,jb=39):26==(jb|0)&&(jb=0,ha=a[F>>2]|0,ma=0!=(a[N>>2]&1024|0),ca=a[(ma?O:M)>>2]|0,a[m>>2]=a[K>>2],a[m+4>>2]=ma?142996:143001,a[m+8>>2]=ca,a[m+12>>2]=Pa,Y(ha,142982,143007,m),Wa=sb,Va=ab,eb=Z,db=Fa,xb=Pa,Zb=Eb,fb=Xa,jb=39);39==(jb|0)&&(jb=0,db?(a[fb>>2]=db,la=Wa,Ba=Va,va=eb,za=xb,ta=Zb,nb=fb+4|0):(la=Wa,Ba=Va,va=eb,za=xb,ta=Zb,nb=fb));do if((za|0)==(n|0))vb=nb;else{ha=a[K>>2]|0;ca=a[F>>2]|0;ma=0!=(a[N>>2]&1024|0);aa=a[(ma?O:M)>>2]|0;a[f>>2]=za>>>0<n>>>0?143089:143103;a[f+4>>
2]=ha;a[f+8>>2]=ma?142996:143001;a[f+12>>2]=aa;a[f+16>>2]=za;a[f+20>>2]=n;Wb(ca,142982,143124,f);ca=(za|0)>(n|0);if(nb>>>0>D>>>0&ca)for(aa=za,ma=nb;;)if(ha=ma+-4|0,ga=aa-(a[ha>>2]|0)|0,Ea=(ga|0)>(n|0),ha>>>0>D>>>0&Ea)aa=ga,ma=ha;else{tb=Ea;bb=ga;Ib=ha;break}else tb=ca,bb=za,Ib=nb;(bb|0)>=(n|0)?tb?(a[Ib>>2]=n,a[Ib+4>>2]=0,vb=Ib+8|0):vb=Ib:(Ib-S&4?(a[Ib>>2]=0,Mb=Ib+4|0):Mb=Ib,a[Mb>>2]=n-(0>(bb|0)?0:bb),vb=Mb+4|0)}while(0);Ud[a[T>>2]&31](R,D,vb,n);X?P?(rb=la,Ua=Ba,Ab=ta):(ma=Ba&-16,aa=la>>>(Ba-ma|0),
ma?(rb=aa,Ua=ma,Ab=ta):(rb=aa,Ua=0,Ab=0==(ta&1|0)?ta:ta+1|0)):(ma=Ba&-8,rb=la>>>(Ba-ma|0),Ua=ma,Ab=ta);ma=a[t>>2]|0;W=W-ma|0;a[K>>2]=(a[K>>2]|0)+1;if(0>=(W|0)){Jb=rb;Hb=Ua;yb=va;cb=Ab;jb=57;break}else R=R+ma|0,ba=rb,U=Ua,Z=va,da=Ab}if(57==(jb|0))gc=a[V>>2]|0,Ub=a[J>>2]|0,Fb=Jb,Lb=Hb,Gb=yb,Kb=cb;else{da=a[F>>2]|0;Z=0!=(a[N>>2]&1024|0);U=a[(Z?O:M)>>2]|0;a[h>>2]=a[K>>2];a[h+4>>2]=Z?142996:143001;a[h+8>>2]=U;a[h+12>>2]=ua;Wb(da,142982,143048,h);Qa?(a[Da>>2]=Qa,Qb=Da+4|0):Qb=Da;do if((ua|0)==(n|0))wb=
Qb;else{da=a[K>>2]|0;U=a[F>>2]|0;Z=0!=(a[N>>2]&1024|0);ba=a[(Z?O:M)>>2]|0;a[g>>2]=ua>>>0<n>>>0?143089:143103;a[g+4>>2]=da;a[g+8>>2]=Z?142996:143001;a[g+12>>2]=ba;a[g+16>>2]=ua;a[g+20>>2]=n;Wb(U,142982,143124,g);U=(ua|0)>(n|0);if(Qb>>>0>D>>>0&U)for(ba=ua,Z=Qb;;)if(da=Z+-4|0,R=ba-(a[da>>2]|0)|0,W=(R|0)>(n|0),da>>>0>D>>>0&W)ba=R,Z=da;else{Pb=W;Sb=R;zb=da;break}else Pb=U,Sb=ua,zb=Qb;(Sb|0)>=(n|0)?Pb?(a[zb>>2]=n,a[zb+4>>2]=0,wb=zb+8|0):wb=zb:(zb-S&4?(a[zb>>2]=0,Ob=zb+4|0):Ob=zb,a[Ob>>2]=n-(0>(Sb|0)?0:
Sb),wb=Ob+4|0)}while(0);Ud[a[T>>2]&31](Aa,D,wb,n);a[z>>2]=0;a[w>>2]=oa;a[C>>2]=sa;a[J>>2]=(a[V>>2]|0)-Ia+(a[J>>2]|0);a[V>>2]=Ia;r=-1;u=e;return r|0}}else gc=E,Ub=I,Fb=v,Lb=Q,Gb=A,Kb=E;while(0);a[z>>2]=Lb;a[w>>2]=Fb;a[C>>2]=Gb;a[J>>2]=gc-Kb+Ub;a[V>>2]=Kb;r=1;u=e;return r|0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,t=0,r=0,w=0,v=0,z=0,Q=0,C=0,A=0,V=0,E=0,J=0,I=0,G=0,D=0,K=0,F=0,N=0,O=0,M=0,T=0,X=0,P=0,S=0,R=0,W=0,ba=0,U=0,Z=0,da=0,ga=0,aa=0,ma=0,ca=0,ha=0,fa=0,ja=
0,pa=0,ya=0,ra=0,Aa=0,oa=0,sa=0,Ka=0,ua=0,Ia=0,Da=0,na=0,Na=0,Qa=0,Ca=0,Ga=0,Ea=0,La=0,Wa=0,Va=0,eb=0,fb=0,xb=0,db=0,lb=0,jb=0,pb=0,ub=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,cc=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,rb=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,ab=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Ab=0,Ua=0,Hb=0,Jb=0,Lb=0,yb=0,cb=0,Gb=0,Ub=0,Fb=0,Kb=0,Qb=0,Pb=0,Sb=0,wb=0,ac=0,ec=0,zb=0,Ob=0,Tb=0,Vb=0,Yb=0,fc=0,kc=0,jc=0,$b=0,lc=0,nc=0,yc=0,xc=0,vc=0,hc=0,
Bc=0;e=u;u=u+128|0;f=e+104|0;g=e+80|0;h=e+56|0;m=e+40|0;k=e+24|0;l=e+8|0;n=a[b+576>>2]|0;p=a[n+12>>2]|0;q=a[n+44>>2]|0;t=n+8|0;if((c|0)%(a[t>>2]|0)|0)return Y(a[b+628>>2]|0,144038,153793,e),r=-1,u=e,r|0;w=n+48|0;v=a[w>>2]|0;z=n+52|0;Q=a[z>>2]|0;C=n+56|0;A=a[C>>2]|0;V=b+604|0;E=a[V>>2]|0;J=b+608|0;I=a[J>>2]|0;G=E+I|0;D=a[n+72>>2]|0;a:do{if(0<(c|0)){K=n+92|0;F=b+628|0;N=b+12|0;O=b+492|0;M=b+452|0;T=n+60|0;X=D;P=d;S=c;R=v;W=Q;ba=A;U=E;b:for(;;){c:do if(ba)sa=R,Ka=W,ua=U;else for(Z=R,da=W,ga=U;;){do if(11>
(da|0)){if(ga>>>0>=G>>>0)if(da){ja=Z;pa=11;ya=ga;break}else{aa=P;ma=Z;ca=0;ha=ga;fa=67;break b}ra=ga+1|0;Aa=(x[q+(x[ga>>0]|0)>>0]|0)<<da|Z;oa=da+8|0;11>(oa|0)?ra>>>0<G>>>0?(ja=(x[q+(x[ra>>0]|0)>>0]|0)<<oa|Aa,pa=da+16|0,ya=ga+2|0):(ja=Aa,pa=11,ya=ra):(ja=Aa,pa=oa,ya=ra)}else ja=Z,pa=da,ya=ga;while(0);if(!(ja&2047)){sa=ja;Ka=pa;ua=ya;break c}Z=ja>>>1;da=pa+-1|0;ga=ya}while(0);for(;;){do if(8>(Ka|0))if(ua>>>0>=G>>>0)if(Ka)Ia=sa,Da=8,na=ua;else{aa=P;ma=sa;ca=ba;ha=ua;fa=67;break b}else Ia=(x[q+(x[ua>>
0]|0)>>0]|0)<<Ka|sa,Da=Ka+8|0,na=ua+1|0;else Ia=sa,Da=Ka,na=ua;while(0);if(Ia&255){Na=Ia;Qa=Da;Ca=na;break}sa=Ia>>>8;Ka=Da+-8|0;ua=na}ga=Na;for(da=Qa;;)if(Z=da+-1|0,ra=ga>>>1,ga&1){Ga=ra;Ea=Z;La=0;Wa=Ca;Va=D;break}else ga=ra,da=Z;c:for(;;){da=Ga;ga=Ea;Z=0;ra=La;oa=Wa;d:for(;;){do if(12>(ga|0)){if(oa>>>0>=G>>>0)if(ga){pb=da;ub=12;Ta=oa;break}else{eb=P;fb=da;xb=Z;db=ra;lb=oa;jb=Va;fa=44;break b}Aa=oa+1|0;Ya=(x[q+(x[oa>>0]|0)>>0]|0)<<ga|da;Sa=ga+8|0;12>(Sa|0)?Aa>>>0<G>>>0?(pb=(x[q+(x[Aa>>0]|0)>>0]|0)<<
Sa|Ya,ub=ga+16|0,Ta=oa+2|0):(pb=Ya,ub=12,Ta=Aa):(pb=Ya,ub=Sa,Ta=Aa)}else pb=da,ub=ga,Ta=oa;while(0);Aa=pb&4095;Sa=x[(Aa<<3)+9305>>0]|0;Ya=ub-Sa|0;mb=pb>>>Sa;switch(x[9304+(Aa<<3)>>0]|0){case 12:Db=mb;cc=Ya;Za=1;ia=Z;qa=ra;Ja=Ta;ea=Va;fa=55;break c;case 7:wa=Aa;Ma=Ya;xa=mb;$a=Z;la=ra;Ba=Ta;break d;case 11:case 9:break;default:va=Ya;za=mb;ta=Z;nb=ra;rb=Ta;gb=Va;fa=32;break c}Sa=a[(Aa<<3)+9308>>2]|0;da=mb;ga=Ya;Z=Sa+Z|0;ra=Sa+ra|0;oa=Ta}oa=a[(wa<<3)+9308>>2]|0;ra=oa+$a|0;Z=Va+4|0;a[Va>>2]=ra;ga=oa+la|
0;if((ga|0)<(p|0))hb=xa,ob=Ma,Bb=0,qb=ga,kb=Ba;else{ib=xa;Cb=Ma;ab=0;sb=ga;Xa=Ba;Fa=Z;break}d:for(;;){do if(13>(ob|0)){if(kb>>>0>=G>>>0)if(ob){Pa=hb;Eb=13;vb=kb;break}else{eb=P;fb=hb;xb=Bb;db=qb;lb=kb;jb=Z;fa=44;break b}ga=kb+1|0;oa=(x[q+(x[kb>>0]|0)>>0]|0)<<ob|hb;da=ob+8|0;13>(da|0)?ga>>>0<G>>>0?(Pa=(x[q+(x[ga>>0]|0)>>0]|0)<<da|oa,Eb=ob+16|0,vb=kb+2|0):(Pa=oa,Eb=13,vb=ga):(Pa=oa,Eb=da,vb=ga)}else Pa=hb,Eb=ob,vb=kb;while(0);ga=Pa&8191;da=x[(ga<<3)+42073>>0]|0;oa=Eb-da|0;Sa=Pa>>>da;switch(x[42072+
(ga<<3)>>0]|0){case 12:Db=Sa;cc=oa;Za=1;ia=Bb;qa=qb;Ja=vb;ea=Z;fa=55;break c;case 8:tb=ga;bb=oa;Ib=Sa;Mb=Bb;Ab=qb;Ua=vb;break d;case 11:case 10:break;default:Hb=oa;Jb=Sa;Lb=Z;yb=Bb;cb=qb;Gb=vb;fa=42;break c}da=a[(ga<<3)+42076>>2]|0;hb=Sa;ob=oa;Bb=da+Bb|0;qb=da+qb|0;kb=vb}da=a[(tb<<3)+42076>>2]|0;oa=da+Mb|0;Sa=Va+8|0;a[Z>>2]=oa;ga=da+Ab|0;if((ga|0)>=(p|0)){ib=Ib;Cb=bb;ab=0;sb=ga;Xa=Ua;Fa=Sa;break}Ga=Ib;Ea=bb;La=ga;Wa=Ua;Va=0==(oa|ra|0)?Va:Sa}32==(fa|0)?(fa=0,Sa=a[F>>2]|0,oa=0!=(a[N>>2]&1024|0),ga=
a[(oa?O:M)>>2]|0,a[l>>2]=a[K>>2],a[l+4>>2]=oa?142996:143001,a[l+8>>2]=ga,a[l+12>>2]=nb,Y(Sa,144038,143007,l),Db=za,cc=va,Za=0,ia=ta,qa=nb,Ja=rb,ea=gb,fa=55):42==(fa|0)&&(fa=0,Sa=a[F>>2]|0,ga=0!=(a[N>>2]&1024|0),oa=a[(ga?O:M)>>2]|0,a[k>>2]=a[K>>2],a[k+4>>2]=ga?142996:143001,a[k+8>>2]=oa,a[k+12>>2]=cb,Y(Sa,144038,143007,k),Db=Jb,cc=Hb,Za=0,ia=yb,qa=cb,Ja=Gb,ea=Lb,fa=55);55==(fa|0)&&(fa=0,ia?(a[ea>>2]=ia,ib=Db,Cb=cc,ab=Za,sb=qa,Xa=Ja,Fa=ea+4|0):(ib=Db,Cb=cc,ab=Za,sb=qa,Xa=Ja,Fa=ea));do if((sb|0)==(p|
0))Ub=Fa;else{Sa=a[K>>2]|0;oa=a[F>>2]|0;ga=0!=(a[N>>2]&1024|0);da=a[(ga?O:M)>>2]|0;a[g>>2]=sb>>>0<p>>>0?143089:143103;a[g+4>>2]=Sa;a[g+8>>2]=ga?142996:143001;a[g+12>>2]=da;a[g+16>>2]=sb;a[g+20>>2]=p;Wb(oa,144038,143124,g);oa=(sb|0)>(p|0);if(oa&Fa>>>0>D>>>0)for(da=sb,ga=Fa;;)if(Sa=ga+-4|0,Ya=da-(a[Sa>>2]|0)|0,mb=(Ya|0)>(p|0),mb&Sa>>>0>D>>>0)da=Ya,ga=Sa;else{Fb=mb;Kb=Ya;Qb=Sa;break}else Fb=oa,Kb=sb,Qb=Fa;(Kb|0)>=(p|0)?Fb?(a[Qb>>2]=p,a[Qb+4>>2]=0,Ub=Qb+8|0):Ub=Qb:(Qb-X&4?(a[Qb>>2]=0,Pb=Qb+4|0):Pb=Qb,
a[Pb>>2]=p-(0>(Kb|0)?0:Kb),Ub=Pb+4|0)}while(0);Ud[a[T>>2]&31](P,D,Ub,p);ga=a[t>>2]|0;S=S-ga|0;a[K>>2]=(a[K>>2]|0)+1;if(0>=(S|0)){Sb=ib;wb=Cb;ac=ab;ec=Xa;fa=71;break}else P=P+ga|0,R=ib,W=Cb,ba=ab,U=Xa}do if(44==(fa|0))if(U=a[F>>2]|0,ba=0!=(a[N>>2]&1024|0),W=a[(ba?O:M)>>2]|0,a[m>>2]=a[K>>2],a[m+4>>2]=ba?142996:143001,a[m+8>>2]=W,a[m+12>>2]=db,Wb(U,144038,143048,m),xb?(a[jb>>2]=xb,zb=jb+4|0):zb=jb,(db|0)==(p|0))Ob=eb,Tb=fb,Vb=0,Yb=lb,fc=zb;else{U=a[K>>2]|0;W=a[F>>2]|0;ba=0!=(a[N>>2]&1024|0);R=a[(ba?
O:M)>>2]|0;a[h>>2]=db>>>0<p>>>0?143089:143103;a[h+4>>2]=U;a[h+8>>2]=ba?142996:143001;a[h+12>>2]=R;a[h+16>>2]=db;a[h+20>>2]=p;Wb(W,144038,143124,h);W=(db|0)>(p|0);if(W&zb>>>0>D>>>0)for(R=db,ba=zb;;)if(U=ba+-4|0,P=R-(a[U>>2]|0)|0,S=(P|0)>(p|0),S&U>>>0>D>>>0)R=P,ba=U;else{kc=S;jc=P;$b=U;break}else kc=W,jc=db,$b=zb;(jc|0)>=(p|0)?kc?(a[$b>>2]=p,a[$b+4>>2]=0,Ob=eb,Tb=fb,Vb=0,Yb=lb,fc=$b+8|0):(Ob=eb,Tb=fb,Vb=0,Yb=lb,fc=$b):($b-X&4?(a[$b>>2]=0,lc=$b+4|0):lc=$b,a[lc>>2]=p-(0>(jc|0)?0:jc),Ob=eb,Tb=fb,Vb=0,
Yb=lb,fc=lc+4|0)}else if(67==(fa|0))p?(ba=a[K>>2]|0,R=a[F>>2]|0,U=0!=(a[N>>2]&1024|0),P=a[(U?O:M)>>2]|0,a[f>>2]=143089,a[f+4>>2]=ba,a[f+8>>2]=U?142996:143001,a[f+12>>2]=P,a[f+16>>2]=0,a[f+20>>2]=p,Wb(R,144038,143124,f),R=D+4|0,a[D>>2]=p,0<(p|0)?(Ob=aa,Tb=ma,Vb=ca,Yb=ha,fc=R):(a[R>>2]=0,Ob=aa,Tb=ma,Vb=ca,Yb=ha,fc=D+8|0)):(Ob=aa,Tb=ma,Vb=ca,Yb=ha,fc=D);else if(71==(fa|0)){nc=a[V>>2]|0;yc=a[J>>2]|0;xc=Sb;vc=wb;hc=ac;Bc=ec;break a}while(0);Ud[a[T>>2]&31](Ob,D,fc,p);a[z>>2]=0;a[w>>2]=Tb;a[C>>2]=Vb;a[J>>
2]=(a[V>>2]|0)-Yb+(a[J>>2]|0);a[V>>2]=Yb;r=-1;u=e;return r|0}nc=E;yc=I;xc=v;vc=Q;hc=A;Bc=E}while(0);a[z>>2]=vc;a[w>>2]=xc;a[C>>2]=hc;a[J>>2]=nc-Bc+yc;a[V>>2]=Bc;r=1;u=e;return r|0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m=0,k,l,n,p,q,r,B,w,x,z,v,C,A,V,E,J,I,G,D;e=u;u=u+16|0;f=b+576|0;g=a[f>>2]|0;h=g+8|0;if((c|0)%(a[h>>2]|0)|0)return Y(a[b+628>>2]|0,143992,143203,e),u=e,0;if(0>=(c|0))return u=e,1;k=g+4|0;l=b+608|0;n=b+592|0;p=b+604|0;q=g+28|0;r=g+12|0;B=g+76|0;w=g+84|0;x=g+88|0;z=g+80|0;g=d;d=
c;a:for(;;){if(!(a[k>>2]&2)){c=a[f>>2]|0;v=c+52|0;C=a[v>>2]|0;A=c+48|0;V=a[A>>2]|0;E=c+28|0;do if(4==(C|0)|0==(a[E>>2]&4|0))I=C,G=V;else if(J=4>(C|0)?4:-4,I=J+C|0,C>>>0>=I>>>0){if(9<=I>>>0){b=14;break a}I=0-J|0;G=V}else{J=a[l>>2]|0;D=C;for(G=V&255;;)if(I=I-D|0,(J|0)>=(a[n>>2]|0)&&Lc(b)|0,J=a[p>>2]|0,a[p>>2]=J+1,t[J>>0]=G,J=(a[l>>2]|0)+1|0,a[l>>2]=J,8<I>>>0)D=8,G=0;else{G=I;break}I=8-G|0;8==(G|0)&&((J|0)>=(a[n>>2]|0)&&Lc(b)|0,G=a[p>>2]|0,a[p>>2]=G+1,t[G>>0]=0,a[l>>2]=(a[l>>2]|0)+1,I=8);G=0}while(0);
a[E>>2]&1?(c=0==(a[c+76>>2]|0)|2,E=13):(c=1,E=12);if(E>>>0<=I>>>0){b=26;break}V=a[l>>2]|0;C=I;I=G;for(G=E;;)if(D=G-C|0,(V|0)>=(a[n>>2]|0)&&Lc(b)|0,J=a[p>>2]|0,a[p>>2]=J+1,t[J>>0]=c>>>D|I,J=(a[l>>2]|0)+1|0,a[l>>2]=J,8<D>>>0)V=J,C=8,I=0,G=D;else{C=D;V=J;break}G=8-C|0;I=(a[8064+(C<<2)>>2]&c)<<G;8==(C|0)?((V|0)>=(a[n>>2]|0)&&Lc(b)|0,C=a[p>>2]|0,a[p>>2]=C+1,t[C>>0]=I,a[l>>2]=(a[l>>2]|0)+1,C=8,V=0):(C=G,V=I);a[A>>2]=V;a[v>>2]=C}a[q>>2]&1?(a[B>>2]|0?(bl(b,g,a[z>>2]|0,a[r>>2]|0),I=(a[w>>2]|0)+-1|0,v=a[w>>
2]=I):(cl(b,g,a[r>>2]|0),a[B>>2]=1,v=a[w>>2]|0),v?Ab(a[z>>2]|0,g,a[h>>2]|0):(a[B>>2]=0,a[w>>2]=(a[x>>2]|0)+-1)):cl(b,g,a[r>>2]|0);v=a[h>>2]|0;d=d-v|0;if(0>=(d|0)){m=1;b=41;break}else g=g+v|0}if(14==(b|0))Z(144003,142823,702,144013);else if(26==(b|0))Z(143169,142823,708,144013);else if(41==(b|0))return u=e,m|0;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,t=0,r=0,w=0,v=0,z=0,Q=0,C=0,A=0,V=0,E=0,J=0,I=0,G=0,D=0,K=0,F=0,N=0,O=0,M=0,T=0,X=0,P=0,S=0,R=0,W=0,ba=
0,U=0,Z=0,da=0,ga=0,aa=0,ma=0,ca=0,ha=0,fa=0,ja=0,pa=0,ra=0,ya=0,Aa=0,oa=0,sa=0,Ka=0,ua=0,Ia=0,Da=0,na=0,Na=0,Qa=0,Ca=0,Ga=0,Ea=0,La=0,Wa=0,Va=0,eb=0,db=0,xb=0,fb=0,pb=0,jb=0,lb=0,ub=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,ab=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,rb=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,Ab=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Hb=0,Ua=0,Kb=0,Jb=0,Lb=0,yb=0,cb=0,Gb=0,Qb=0,Fb=0,Pb=0,Sb=0,Yb=0,Vb=0,wb=0,ac=0,ec=0,zb=0,Ob=0,Tb=0,fc=0,$b=0,jc=
0,kc=0,lc=0,nc=0,yc=0,xc=0,vc=0,Bc=0,Cc=0,hc=0,Ec=0,Gc=0,Hc=0,Ic=0,Jc=0,Fc=0,zc=0,Lc=0,oc=0,Oc=0,Uc=0,Wc=0,ic=0,$c=0,ad=0,bd=0,Qc=0,Rc=0,Vc=0,Pc=0,Xc=0,cd=0,jd=0,dd=0,ld=0,hd=0,pd=0,md=0,Rb=0,od=0,tc=0,Xb=0,rc=0,ed=0,gd=0,sd=0,td=0,qd=0,rd=0,zd=0,Yc=0,wc=0,id=0,dc=0,Ac=0,Sc=0,Tc=0,Cd=0,Dd=0,Kd=0,vd=0,wd=0,Id=0,Ld=0,Nd=0,Od=0,Td=0,Xd=0,Sd=0,Yd=0,ce=0,oe=0,Pd=0,Vd=0,Md=0,le=0,ne=0,qe=0,se=0,he=0,te=0,de=0,He=0,ue=0,xe=0,Ae=0,ae=0,De=0,be=0,Fd=0,Rd=0,Gd=0,$d=0,ge=0,ud=0,xd=0,ie=0,je=0,we=0,re=0,Dc=0,
yd=0,Ad=0,Me=0,Ne=0,Oe=0,Ye=0,Pe=0,ve=0,Je=0,ze=0,Qe=0,ee=0,Ze=0,me=0,ye=0,kf=0,Ve=0,df=0,We=0,ef=0,Ue=0,Ke=0,sf=0,$e=0,gf=0,nf=0,of=0,Kf=0,Lf=0,Nc=0,Mc=0,qc=0,Re=0,pe=0,uc=0,Uf=0,Wf=0,Se=0,Mf=0,Pf=0,Xe=0,Xf=0,Sf=0,Yf=0,rf=0,Hf=0,mf=0,uf=0,qh=0,vf=0,yf=0,zf=0,Af=0,Bf=0,Cf=0,pf=0,jg=0,bg=0,dg=0,mg=0,ng=0,eg=0,og=0,pg=0,qg=0,fg=0,tg=0,Dg=0,Tf=0,qf=0,Gf=0,If=0,eh=0,mh=0,nh=0,tf=0,fh=0,wf=0,xf=0,Jf=0,Vf=0,gg=0,Ig=0,rg=0,sg=0,Ng=0,Og=0,Gg=0,Vg=0,ah=0,bh=0,ch=0,Kg=0,oh=0,Pg=0,rh=0,vg=0,Eg=0,ih=0,jh=0,kh=
0,lh=0,cg=0,wg=0,xg=0,yg=0,zg=0,Zf=0,ag=0,Ag=0,Tg=0,kg=0,hg=0,Fg=0,sh=0,Ug=0,lg=0,gh=0,Hg=0,Wg=0,Xg=0,Yg=0,Zg=0,$g=0,Jg=0;e=u;u=u+288|0;f=e+264|0;g=e+240|0;h=e+216|0;m=e+200|0;k=e+184|0;l=e+168|0;n=e+152|0;p=e+136|0;q=e+120|0;t=e+104|0;r=e+80|0;w=e+56|0;v=e+40|0;z=e+24|0;Q=e+8|0;C=a[b+576>>2]|0;A=a[C+12>>2]|0;V=a[C+44>>2]|0;E=C+8|0;if((c|0)%(a[E>>2]|0)|0)return Y(a[b+628>>2]|0,144240,153793,e),J=-1,u=e,J|0;I=C+48|0;G=a[I>>2]|0;D=C+52|0;K=a[D>>2]|0;F=C+56|0;N=a[F>>2]|0;O=b+604|0;M=a[O>>2]|0;T=b+608|
0;X=a[T>>2]|0;P=M+X|0;a:do{if(0<(c|0)){S=C+72|0;R=C+68|0;W=0<(A|0);ba=C+92|0;U=b+628|0;Z=b+12|0;da=b+492|0;ga=b+452|0;aa=C+60|0;ma=d;ca=c;ha=a[S>>2]|0;fa=G;ja=K;pa=N;ra=M;b:for(;;){c:do if(pa)Wa=fa,Va=ja,eb=ra;else for(ya=fa,Aa=ja,oa=ra;;){do if(11>(Aa|0)){if(oa>>>0>=P>>>0)if(Aa){Na=ya;Qa=11;Ca=oa;break}else{sa=ma;Ka=ha;ua=ya;Ia=0;Da=oa;na=186;break b}Ga=oa+1|0;Ea=(x[V+(x[oa>>0]|0)>>0]|0)<<Aa|ya;La=Aa+8|0;11>(La|0)?Ga>>>0<P>>>0?(Na=(x[V+(x[Ga>>0]|0)>>0]|0)<<La|Ea,Qa=Aa+16|0,Ca=oa+2|0):(Na=Ea,Qa=11,
Ca=Ga):(Na=Ea,Qa=La,Ca=Ga)}else Na=ya,Qa=Aa,Ca=oa;while(0);if(!(Na&2047)){Wa=Na;Va=Qa;eb=Ca;break c}ya=Na>>>1;Aa=Qa+-1|0;oa=Ca}while(0);for(;;){do if(8>(Va|0))if(eb>>>0>=P>>>0)if(Va)db=Wa,xb=8,fb=eb;else{sa=ma;Ka=ha;ua=Wa;Ia=pa;Da=eb;na=186;break b}else db=(x[V+(x[eb>>0]|0)>>0]|0)<<Va|Wa,xb=Va+8|0,fb=eb+1|0;else db=Wa,xb=Va,fb=eb;while(0);if(db&255){pb=db;jb=xb;lb=fb;break}Wa=db>>>8;Va=xb+-8|0;eb=fb}oa=pb;for(Aa=jb;;)if(ya=Aa+-1|0,Ga=oa>>>1,oa&1){ub=ya;Ta=Ga;Ya=Aa;break}else oa=Ga,Aa=ya;do if(2>(Ya|
0))if(lb>>>0>=P>>>0)if(ub)Sa=Ta,mb=1,Db=lb;else{sa=ma;Ka=ha;ua=Ta;Ia=0;Da=lb;na=186;break b}else Sa=(x[V+(x[lb>>0]|0)>>0]|0)<<ub|Ta,mb=Ya+7|0,Db=lb+1|0;else Sa=Ta,mb=ub,Db=lb;while(0);Aa=mb+-1|0;oa=Sa>>>1;Ga=a[R>>2]|0;ya=Ga+4|0;La=a[Ga>>2]|0;do if(Sa&1){va=oa;ea=Aa;wa=0;qa=Db;ia=ha;c:for(;;){Za=va;ab=ea;Ea=0;Ga=wa;Ba=qa;d:for(;;){do if(12>(ab|0)){if(Ba>>>0>=P>>>0)if(ab){mf=Za;uf=12;qh=Ba;break}else{Pf=ma;Xe=ha;Xf=Za;Sf=Ea;Yf=Ga;rf=Ba;Hf=ia;na=51;break b}Ma=Ba+1|0;la=(x[V+(x[Ba>>0]|0)>>0]|0)<<ab|Za;
xa=ab+8|0;12>(xa|0)?Ma>>>0<P>>>0?(mf=(x[V+(x[Ma>>0]|0)>>0]|0)<<xa|la,uf=ab+16|0,qh=Ba+2|0):(mf=la,uf=12,qh=Ma):(mf=la,uf=xa,qh=Ma)}else mf=Za,uf=ab,qh=Ba;while(0);Ma=mf&4095;xa=x[(Ma<<3)+9305>>0]|0;la=uf-xa|0;$a=mf>>>xa;switch(x[9304+(Ma<<3)>>0]|0){case 12:vf=$a;yf=la;zf=1;Af=Ea;Bf=Ga;Cf=qh;pf=ia;na=62;break c;case 7:jg=Ma;bg=la;dg=$a;mg=Ea;ng=Ga;eg=qh;break d;case 11:case 9:break;default:og=la;pg=$a;qg=Ea;fg=Ga;tg=qh;Dg=ia;na=38;break c}xa=a[(Ma<<3)+9308>>2]|0;Za=$a;ab=la;Ea=xa+Ea|0;Ga=xa+Ga|0;Ba=
qh}Ba=a[(jg<<3)+9308>>2]|0;Ga=Ba+mg|0;Ea=ia+4|0;a[ia>>2]=Ga;ab=Ba+ng|0;if((ab|0)<(A|0))Tf=dg,qf=bg,Gf=0,If=ab,eh=eg;else{mh=dg;nh=bg;tf=0;fh=ab;wf=eg;xf=Ea;break}d:for(;;){do if(13>(qf|0)){if(eh>>>0>=P>>>0)if(qf){Jf=Tf;Vf=13;gg=eh;break}else{Pf=ma;Xe=ha;Xf=Tf;Sf=Gf;Yf=If;rf=eh;Hf=Ea;na=51;break b}ab=eh+1|0;Ba=(x[V+(x[eh>>0]|0)>>0]|0)<<qf|Tf;Za=qf+8|0;13>(Za|0)?ab>>>0<P>>>0?(Jf=(x[V+(x[ab>>0]|0)>>0]|0)<<Za|Ba,Vf=qf+16|0,gg=eh+2|0):(Jf=Ba,Vf=13,gg=ab):(Jf=Ba,Vf=Za,gg=ab)}else Jf=Tf,Vf=qf,gg=eh;while(0);
ab=Jf&8191;Za=x[(ab<<3)+42073>>0]|0;Ba=Vf-Za|0;xa=Jf>>>Za;switch(x[42072+(ab<<3)>>0]|0){case 12:vf=xa;yf=Ba;zf=1;Af=Gf;Bf=If;Cf=gg;pf=Ea;na=62;break c;case 8:Ig=ab;rg=Ba;sg=xa;Ng=Gf;Og=If;Gg=gg;break d;case 11:case 10:break;default:Vg=Ba;ah=xa;bh=Ea;ch=Gf;Kg=If;oh=gg;na=48;break c}Za=a[(ab<<3)+42076>>2]|0;Tf=xa;qf=Ba;Gf=Za+Gf|0;If=Za+If|0;eh=gg}Za=a[(Ig<<3)+42076>>2]|0;Ba=Za+Ng|0;xa=ia+8|0;a[Ea>>2]=Ba;ab=Za+Og|0;if((ab|0)>=(A|0)){mh=sg;nh=rg;tf=0;fh=ab;wf=Gg;xf=xa;break}va=sg;ea=rg;wa=ab;qa=Gg;ia=
0==(Ba|Ga|0)?ia:xa}38==(na|0)?(na=0,ia=a[U>>2]|0,qa=0!=(a[Z>>2]&1024|0),wa=a[(qa?da:ga)>>2]|0,a[Q>>2]=a[ba>>2],a[Q+4>>2]=qa?142996:143001,a[Q+8>>2]=wa,a[Q+12>>2]=fg,Y(ia,144240,143007,Q),vf=pg,yf=og,zf=0,Af=qg,Bf=fg,Cf=tg,pf=Dg,na=62):48==(na|0)&&(na=0,ia=a[U>>2]|0,wa=0!=(a[Z>>2]&1024|0),qa=a[(wa?da:ga)>>2]|0,a[z>>2]=a[ba>>2],a[z+4>>2]=wa?142996:143001,a[z+8>>2]=qa,a[z+12>>2]=Kg,Y(ia,144240,143007,z),vf=ah,yf=Vg,zf=0,Af=ch,Bf=Kg,Cf=oh,pf=bh,na=62);62==(na|0)&&(na=0,Af?(a[pf>>2]=Af,mh=vf,nh=yf,tf=
zf,fh=Bf,wf=Cf,xf=pf+4|0):(mh=vf,nh=yf,tf=zf,fh=Bf,wf=Cf,xf=pf));if((fh|0)==(A|0))Mc=mh,qc=nh,Re=tf,pe=wf,uc=xf;else{ia=a[ba>>2]|0;qa=a[U>>2]|0;wa=0!=(a[Z>>2]&1024|0);ea=a[(wa?da:ga)>>2]|0;a[r>>2]=fh>>>0<A>>>0?143089:143103;a[r+4>>2]=ia;a[r+8>>2]=wa?142996:143001;a[r+12>>2]=ea;a[r+16>>2]=fh;a[r+20>>2]=A;Wb(qa,144240,143124,r);qa=(fh|0)>(A|0);if(xf>>>0>ha>>>0&qa)for(ea=fh,wa=xf;;)if(ia=wa+-4|0,va=ea-(a[ia>>2]|0)|0,Ja=(va|0)>(A|0),ia>>>0>ha>>>0&Ja)ea=va,wa=ia;else{Pg=Ja;rh=va;vg=ia;break}else Pg=qa,
rh=fh,vg=xf;(rh|0)>=(A|0)?Pg?(a[vg>>2]=A,a[vg+4>>2]=0,Mc=mh,qc=nh,Re=tf,pe=wf,uc=vg+8|0):(Mc=mh,qc=nh,Re=tf,pe=wf,uc=vg):(vg-ha&4?(a[vg>>2]=0,Eg=vg+4|0):Eg=vg,a[Eg>>2]=A-(0>(rh|0)?0:rh),Mc=mh,qc=nh,Re=tf,pe=wf,uc=Eg+4|0)}}else{c:do if(W){Ga=ha;Ea=oa;ab=Aa;ia=Za=0;qa=La;Ja=Db;ea=ha;wa=ya;d:for(;;){Ma=(ea|0)==(ha|0);e:do if(Ma)for(xa=Ea,$a=ab,la=0,Ba=Za,va=ia,za=qa,ta=Ja,nb=wa;;){do if(7>($a|0))if(ta>>>0>=P>>>0)if($a)Cb=xa,Ab=7,sb=ta;else{rb=ma;gb=ha;hb=xa;ob=0;Bb=la;qb=va;kb=ta;ib=ha;na=154;break b}else Cb=
(x[V+(x[ta>>0]|0)>>0]|0)<<$a|xa,Ab=$a+8|0,sb=ta+1|0;else Cb=xa,Ab=$a,sb=ta;while(0);Xa=Cb&127;Fa=x[(Xa<<3)+8281>>0]|0;Pa=Ab-Fa|0;Eb=Cb>>>Fa;switch(x[8280+(Xa<<3)>>0]|0){case 6:vb=Pa;tb=Eb;bb=la;Ib=va;Mb=sb;Hb=ha;na=143;break d;case 12:Ua=Fa;Kb=Pa;Jb=Eb;Lb=Ab;yb=la;cb=va;Gb=sb;Qb=ha;na=144;break d;case 2:Fb=Pa;Pb=Eb;Sb=la;Yb=va;Vb=za;wb=sb;ac=nb;na=88;break e;case 3:ec=Pa;zb=Eb;Ob=la;Tb=va;fc=Ba;$b=za;jc=sb;kc=nb;na=128;break e;case 4:lc=Xa;nc=Pa;yc=Eb;xc=la;vc=va;Bc=Ba;Cc=za;hc=sb;Ec=nb;na=132;break e;
case 5:Gc=Xa;Hc=Pa;Ic=Eb;Jc=la;Fc=va;zc=za;Lc=sb;oc=nb;na=136;break e;case 1:break;default:Oc=Eb;Uc=Pa;Wc=la;ic=va;$c=sb;ad=ha;na=151;break d}Xa=(a[nb>>2]|0)+za|0;Fa=Ba+la+Xa|0;if((A|0)>(Xa|0))xa=Eb,$a=Pa,la=Fa,Ba=0-Xa|0,va=Xa,za=Xa+(a[nb+4>>2]|0)|0,ta=sb,nb=nb+8|0;else{bd=Eb;Qc=Pa;Rc=Fa;Vc=Xa;Pc=sb;Xc=ha;na=165;break d}}else for(nb=Ea,ta=ab,za=0,va=Za,Ba=ia,la=qa,$a=Ja,xa=wa;;){do if(7>(ta|0))if($a>>>0>=P>>>0)if(ta)cd=nb,jd=7,dd=$a;else{rb=ma;gb=ha;hb=nb;ob=0;Bb=za;qb=Ba;kb=$a;ib=ea;na=154;break b}else cd=
(x[V+(x[$a>>0]|0)>>0]|0)<<ta|nb,jd=ta+8|0,dd=$a+1|0;else cd=nb,jd=ta,dd=$a;while(0);Xa=cd&127;Fa=x[(Xa<<3)+8281>>0]|0;Pa=jd-Fa|0;Eb=cd>>>Fa;switch(x[8280+(Xa<<3)>>0]|0){case 6:vb=Pa;tb=Eb;bb=za;Ib=Ba;Mb=dd;Hb=ea;na=143;break d;case 12:Ua=Fa;Kb=Pa;Jb=Eb;Lb=jd;yb=za;cb=Ba;Gb=dd;Qb=ea;na=144;break d;case 2:Fb=Pa;Pb=Eb;Sb=za;Yb=Ba;Vb=la;wb=dd;ac=xa;na=88;break e;case 3:ec=Pa;zb=Eb;Ob=za;Tb=Ba;fc=va;$b=la;jc=dd;kc=xa;na=128;break e;case 4:lc=Xa;nc=Pa;yc=Eb;xc=za;vc=Ba;Bc=va;Cc=la;hc=dd;Ec=xa;na=132;break e;
case 5:Gc=Xa;Hc=Pa;Ic=Eb;Jc=za;Fc=Ba;zc=la;Lc=dd;oc=xa;na=136;break e;case 1:break;default:Oc=Eb;Uc=Pa;Wc=za;ic=Ba;$c=dd;ad=ea;na=151;break d}if((la|0)<=(Ba|0)&(la|0)<(A|0))for(Xa=la,Fa=xa;;)if(ld=(a[Fa>>2]|0)+Xa+(a[Fa+4>>2]|0)|0,hd=Fa+8|0,(ld|0)<=(Ba|0)&(ld|0)<(A|0))Xa=ld,Fa=hd;else{pd=ld;md=hd;break}else pd=la,md=xa;Fa=(a[md>>2]|0)+pd|0;Xa=va+za+Fa|0;if((A|0)>(Fa|0))nb=Eb,ta=Pa,za=Xa,va=0-Fa|0,Ba=Fa,la=Fa+(a[md+4>>2]|0)|0,$a=dd,xa=md+8|0;else{bd=Eb;Qc=Pa;Rc=Xa;Vc=Fa;Pc=dd;Xc=ea;na=165;break d}}while(0);
if(88==(na|0)){na=0;if(ea-Ga&4){va=Pb;nb=Fb;xa=Sb;$a=Yb;la=wb;e:for(;;){do if(13>(nb|0)){if(la>>>0>=P>>>0)if(nb){Pd=va;Vd=13;Md=la;break}else{rb=ma;gb=ha;hb=va;ob=0;Bb=xa;qb=$a;kb=la;ib=ea;na=154;break b}za=la+1|0;Fa=(x[V+(x[la>>0]|0)>>0]|0)<<nb|va;Xa=nb+8|0;13>(Xa|0)?za>>>0>=P>>>0?(Pd=Fa,Vd=13,Md=za):(Pd=(x[V+(x[za>>0]|0)>>0]|0)<<Xa|Fa,Vd=nb+16|0,Md=la+2|0):(Pd=Fa,Vd=Xa,Md=za)}else Pd=va,Vd=nb,Md=la;while(0);za=Pd&8191;Xa=x[(za<<3)+42073>>0]|0;Fa=Vd-Xa|0;ta=Pd>>>Xa;switch(x[42072+(za<<3)>>0]|0){case 8:le=
za;ne=Fa;qe=ta;se=xa;he=$a;te=Md;break e;case 11:case 10:break;default:Id=ta;Ld=Fa;Nd=xa;Od=$a;Td=Md;Xd=ea;na=152;break d}Xa=a[(za<<3)+42076>>2]|0;va=ta;nb=Fa;xa=Xa+xa|0;$a=Xa+$a|0;la=Md}la=a[(le<<3)+42076>>2]|0;$a=ea+4|0;a[ea>>2]=la+se;xa=qe;nb=ne;va=0;Ba=la+he|0;la=te;e:for(;;){do if(12>(nb|0)){if(la>>>0>=P>>>0)if(nb){de=xa;He=12;ue=la;break}else{rb=ma;gb=ha;hb=xa;ob=0;Bb=va;qb=Ba;kb=la;ib=$a;na=154;break b}Xa=la+1|0;Fa=(x[V+(x[la>>0]|0)>>0]|0)<<nb|xa;ta=nb+8|0;12>(ta|0)?Xa>>>0>=P>>>0?(de=Fa,He=
12,ue=Xa):(de=(x[V+(x[Xa>>0]|0)>>0]|0)<<ta|Fa,He=nb+16|0,ue=la+2|0):(de=Fa,He=ta,ue=Xa)}else de=xa,He=nb,ue=la;while(0);Xa=de&4095;ta=x[(Xa<<3)+9305>>0]|0;Fa=He-ta|0;za=de>>>ta;switch(x[9304+(Xa<<3)>>0]|0){case 7:xe=Xa;Ae=Fa;ae=za;De=va;be=Ba;Fd=ue;break e;case 11:case 9:break;default:qd=za;rd=Fa;zd=va;Yc=Ba;wc=ue;id=$a;na=153;break d}ta=a[(Xa<<3)+9308>>2]|0;xa=za;nb=Fa;va=ta+va|0;Ba=ta+Ba|0;la=ue}la=a[(xe<<3)+9308>>2]|0;a[$a>>2]=la+De;Sd=ae;Yd=Ae;ce=la+be|0;oe=Fd}else{xa=Pb;$a=Fb;la=Sb;Ba=Yb;va=
wb;e:for(;;){do if(12>($a|0)){if(va>>>0>=P>>>0)if($a){Rb=xa;od=12;tc=va;break}else{rb=ma;gb=ha;hb=xa;ob=0;Bb=la;qb=Ba;kb=va;ib=ea;na=154;break b}za=va+1|0;ta=(x[V+(x[va>>0]|0)>>0]|0)<<$a|xa;nb=$a+8|0;12>(nb|0)?za>>>0>=P>>>0?(Rb=ta,od=12,tc=za):(Rb=(x[V+(x[za>>0]|0)>>0]|0)<<nb|ta,od=$a+16|0,tc=va+2|0):(Rb=ta,od=nb,tc=za)}else Rb=xa,od=$a,tc=va;while(0);za=Rb&4095;nb=x[(za<<3)+9305>>0]|0;ta=od-nb|0;Fa=Rb>>>nb;switch(x[9304+(za<<3)>>0]|0){case 7:Xb=za;rc=ta;ed=Fa;gd=la;sd=Ba;td=tc;break e;case 11:case 9:break;
default:qd=Fa;rd=ta;zd=la;Yc=Ba;wc=tc;id=ea;na=153;break d}nb=a[(za<<3)+9308>>2]|0;xa=Fa;$a=ta;la=nb+la|0;Ba=nb+Ba|0;va=tc}va=a[(Xb<<3)+9308>>2]|0;Ba=ea+4|0;a[ea>>2]=va+gd;la=ed;$a=rc;xa=0;nb=va+sd|0;va=td;e:for(;;){do if(13>($a|0)){if(va>>>0>=P>>>0)if($a){dc=la;Ac=13;Sc=va;break}else{rb=ma;gb=ha;hb=la;ob=0;Bb=xa;qb=nb;kb=va;ib=Ba;na=154;break b}ta=va+1|0;Fa=(x[V+(x[va>>0]|0)>>0]|0)<<$a|la;za=$a+8|0;13>(za|0)?ta>>>0>=P>>>0?(dc=Fa,Ac=13,Sc=ta):(dc=(x[V+(x[ta>>0]|0)>>0]|0)<<za|Fa,Ac=$a+16|0,Sc=va+2|
0):(dc=Fa,Ac=za,Sc=ta)}else dc=la,Ac=$a,Sc=va;while(0);ta=dc&8191;za=x[(ta<<3)+42073>>0]|0;Fa=Ac-za|0;Xa=dc>>>za;switch(x[42072+(ta<<3)>>0]|0){case 8:Tc=ta;Cd=Fa;Dd=Xa;Kd=xa;vd=nb;wd=Sc;break e;case 11:case 10:break;default:Id=Xa;Ld=Fa;Nd=xa;Od=nb;Td=Sc;Xd=Ba;na=152;break d}za=a[(ta<<3)+42076>>2]|0;la=Xa;$a=Fa;xa=za+xa|0;nb=za+nb|0;va=Sc}va=a[(Tc<<3)+42076>>2]|0;a[Ba>>2]=va+Kd;Sd=Dd;Yd=Cd;ce=va+vd|0;oe=wd}la=ea+8|0;if((la|0)!=(ha|0))if((Vb|0)<=(ce|0)&(Vb|0)<(A|0))for(Ba=Vb,va=ac;;)if(nb=(a[va>>2]|
0)+Ba+(a[va+4>>2]|0)|0,xa=va+8|0,(nb|0)<=(ce|0)&(nb|0)<(A|0))Ba=nb,va=xa;else{Rd=Sd;Gd=Yd;$d=ce;ge=nb;ud=oe;xd=la;ie=xa;break}else Rd=Sd,Gd=Yd,$d=ce,ge=Vb,ud=oe,xd=la,ie=ac;else Rd=Sd,Gd=Yd,$d=ce,ge=Vb,ud=oe,xd=ha,ie=ac}else if(128==(na|0)){na=0;if(Ma?0:($b|0)<=(Tb|0)&($b|0)<(A|0))for(va=$b,Ba=kc;;)if($a=(a[Ba>>2]|0)+va+(a[Ba+4>>2]|0)|0,xa=Ba+8|0,($a|0)<=(Tb|0)&($a|0)<(A|0))va=$a,Ba=xa;else{je=$a;we=xa;break}else je=$b,we=kc;a[ea>>2]=fc+Ob+je;Rd=zb;Gd=ec;$d=je;ge=(a[we>>2]|0)+je|0;ud=jc;xd=ea+4|0;
ie=we+4|0}else if(132==(na|0)){na=0;if(Ma?0:(Cc|0)<=(vc|0)&(Cc|0)<(A|0))for(Ba=Cc,va=Ec;;)if(la=(a[va>>2]|0)+Ba+(a[va+4>>2]|0)|0,xa=va+8|0,(la|0)<=(vc|0)&(la|0)<(A|0))Ba=la,va=xa;else{re=la;Dc=xa;break}else re=Cc,Dc=Ec;va=a[(lc<<3)+8284>>2]|0;a[ea>>2]=Bc+xc+re+va;Rd=yc;Gd=nc;$d=va+re|0;ge=(a[Dc>>2]|0)+re|0;ud=hc;xd=ea+4|0;ie=Dc+4|0}else if(136==(na|0)){na=0;if((va=(ea|0)!=(ha|0))&&(zc|0)<=(Fc|0)&(zc|0)<(A|0))for(Ba=zc,Ma=oc;;)if(xa=(a[Ma>>2]|0)+Ba+(a[Ma+4>>2]|0)|0,la=Ma+8|0,(xa|0)<=(Fc|0)&(xa|0)<
(A|0))Ba=xa,Ma=la;else{yd=xa;Ad=la;break}else yd=zc,Ad=oc;Ma=a[(Gc<<3)+8284>>2]|0;Ba=Ma+Fc|0;if((yd|0)<=(Ba|0)&(va|(yd|0)<(Ba|0))){Me=Hc;Ne=Ic;Oe=Jc;Ye=Fc;Pe=Lc;ve=ea;na=140;break}a[ea>>2]=yd-Fc+Jc-Ma;Ba=Ad+-4|0;Rd=Ic;Gd=Hc;$d=yd-Ma|0;ge=yd-(a[Ba>>2]|0)|0;ud=Lc;xd=ea+4|0;ie=Ba}if((A|0)>($d|0))Ea=Rd,ab=Gd,Za=0-$d|0,ia=$d,qa=ge,Ja=ud,ea=xd,wa=ie;else{Je=Rd;ze=Gd;Qe=0;ee=$d;Ze=ud;me=xd;break c}}do if(140==(na|0))na=0,wa=a[U>>2]|0,ea=0!=(a[Z>>2]&1024|0),Ja=a[(ea?da:ga)>>2]|0,a[t>>2]=a[ba>>2],a[t+4>>2]=
ea?142996:143001,a[t+8>>2]=Ja,a[t+12>>2]=Ye,Y(wa,144240,143007,t),ye=Ne,kf=Me,Ve=0,df=Oe,We=Ye,ef=Pe,Ue=ve;else if(143==(na|0))na=0,a[Hb>>2]=A-Ib,wa=a[U>>2]|0,Ja=0!=(a[Z>>2]&1024|0),ea=a[(Ja?da:ga)>>2]|0,a[q>>2]=a[ba>>2],a[q+4>>2]=Ja?142996:143001,a[q+8>>2]=ea,a[q+12>>2]=Ib,Y(wa,144240,143800,q),ye=tb,kf=vb,Ve=0,df=bb,We=Ib,ef=Mb,Ue=Hb+4|0;else if(144==(na|0)){na=0;wa=Qb+4|0;a[Qb>>2]=A-cb;do if(4>(Kb|0))if(Gb>>>0>=P>>>0)if((Lb|0)==(Ua|0)){rb=ma;gb=ha;hb=Jb;ob=Kb;Bb=yb;qb=cb;kb=Gb;ib=wa;na=154;break b}else Ke=
Jb,sf=4,$e=Gb;else Ke=(x[V+(x[Gb>>0]|0)>>0]|0)<<Kb|Jb,sf=Kb+8|0,$e=Gb+1|0;else Ke=Jb,sf=Kb,$e=Gb;while(0);Ke&15&&(va=a[U>>2]|0,ea=0!=(a[Z>>2]&1024|0),Ja=a[(ea?da:ga)>>2]|0,a[p>>2]=a[ba>>2],a[p+4>>2]=ea?142996:143001,a[p+8>>2]=Ja,a[p+12>>2]=cb,Y(va,144240,143007,p));ye=Ke>>>4;kf=sf+-4|0;Ve=1;df=yb;We=cb;ef=$e;Ue=wa}else if(152==(na|0))na=0,va=a[U>>2]|0,Ja=0!=(a[Z>>2]&1024|0),ea=a[(Ja?da:ga)>>2]|0,a[l>>2]=a[ba>>2],a[l+4>>2]=Ja?142996:143001,a[l+8>>2]=ea,a[l+12>>2]=Od,Y(va,144240,143007,l),ye=Id,kf=
Ld,Ve=0,df=Nd,We=Od,ef=Td,Ue=Xd;else if(153==(na|0))na=0,va=a[U>>2]|0,ea=0!=(a[Z>>2]&1024|0),Ja=a[(ea?da:ga)>>2]|0,a[k>>2]=a[ba>>2],a[k+4>>2]=ea?142996:143001,a[k+8>>2]=Ja,a[k+12>>2]=Yc,Y(va,144240,143007,k),ye=qd,kf=rd,Ve=0,df=zd,We=Yc,ef=wc,Ue=id;else if(165==(na|0)){na=0;if(!Rc){Je=bd;ze=Qc;Qe=0;ee=Vc;Ze=Pc;me=Xc;break c}if((Vc+Rc|0)<(A|0)){do if(1>(Qc|0))if(Pc>>>0>=P>>>0)if(Qc)gf=bd,nf=1,of=Pc;else{rb=ma;gb=ha;hb=bd;ob=0;Bb=Rc;qb=Vc;kb=Pc;ib=Xc;na=154;break b}else gf=(x[V+(x[Pc>>0]|0)>>0]|0)<<
Qc|bd,nf=Qc+8|0,of=Pc+1|0;else gf=bd,nf=Qc,of=Pc;while(0);if(!(gf&1)){Oc=gf;Uc=nf;Wc=Rc;ic=Vc;$c=of;ad=Xc;na=151;break}Kf=gf>>>1;Lf=nf+-1|0;Nc=of}else Kf=bd,Lf=Qc,Nc=Pc;a[Xc>>2]=Rc;Je=Kf;ze=Lf;Qe=0;ee=Vc;Ze=Nc;me=Xc+4|0;break c}while(0);151==(na|0)&&(na=0,wa=a[U>>2]|0,va=0!=(a[Z>>2]&1024|0),Ja=a[(va?da:ga)>>2]|0,a[n>>2]=a[ba>>2],a[n+4>>2]=va?142996:143001,a[n+8>>2]=Ja,a[n+12>>2]=ic,Y(wa,144240,143007,n),ye=Oc,kf=Uc,Ve=0,df=Wc,We=ic,ef=$c,Ue=ad);df?(a[Ue>>2]=df,Je=ye,ze=kf,Qe=Ve,ee=We,Ze=ef,me=Ue+
4|0):(Je=ye,ze=kf,Qe=Ve,ee=We,Ze=ef,me=Ue)}else Je=oa,ze=Aa,ee=Qe=0,Ze=Db,me=ha;while(0);if((ee|0)==(A|0))Mc=Je,qc=ze,Re=Qe,pe=Ze,uc=me;else{wa=a[ba>>2]|0;Ja=a[U>>2]|0;va=0!=(a[Z>>2]&1024|0);ea=a[(va?da:ga)>>2]|0;a[g>>2]=ee>>>0<A>>>0?143089:143103;a[g+4>>2]=wa;a[g+8>>2]=va?142996:143001;a[g+12>>2]=ea;a[g+16>>2]=ee;a[g+20>>2]=A;Wb(Ja,144240,143124,g);Ja=(ee|0)>(A|0);if(me>>>0>ha>>>0&Ja)for(ea=ee,va=me;;)if(wa=va+-4|0,qa=ea-(a[wa>>2]|0)|0,ia=(qa|0)>(A|0),wa>>>0>ha>>>0&ia)ea=qa,va=wa;else{Uf=ia;Wf=qa;
Se=wa;break}else Uf=Ja,Wf=ee,Se=me;(Wf|0)>=(A|0)?Uf?(a[Se>>2]=A,a[Se+4>>2]=0,Mc=Je,qc=ze,Re=Qe,pe=Ze,uc=Se+8|0):(Mc=Je,qc=ze,Re=Qe,pe=Ze,uc=Se):(Se-ha&4?(a[Se>>2]=0,Mf=Se+4|0):Mf=Se,a[Mf>>2]=A-(0>(Wf|0)?0:Wf),Mc=Je,qc=ze,Re=Qe,pe=Ze,uc=Mf+4|0)}}while(0);Ud[a[aa>>2]&31](ma,ha,uc,A);a[uc>>2]=0;Aa=a[S>>2]|0;ha=a[R>>2]|0;a[S>>2]=ha;a[R>>2]=Aa;Aa=a[E>>2]|0;ca=ca-Aa|0;a[ba>>2]=(a[ba>>2]|0)+1;if(0>=(ca|0)){ih=Mc;jh=qc;kh=Re;lh=pe;na=190;break}else ma=ma+Aa|0,fa=Mc,ja=qc,pa=Re,ra=pe}do if(51==(na|0))if(ra=
a[U>>2]|0,pa=0!=(a[Z>>2]&1024|0),ja=a[(pa?da:ga)>>2]|0,a[v>>2]=a[ba>>2],a[v+4>>2]=pa?142996:143001,a[v+8>>2]=ja,a[v+12>>2]=Yf,Wb(ra,144240,143048,v),Sf?(a[Hf>>2]=Sf,cg=Hf+4|0):cg=Hf,(Yf|0)==(A|0))wg=Pf,xg=Xe,yg=Xf,Zf=zg=0,ag=rf,Ag=cg;else{ra=a[ba>>2]|0;ja=a[U>>2]|0;pa=0!=(a[Z>>2]&1024|0);fa=a[(pa?da:ga)>>2]|0;a[w>>2]=Yf>>>0<A>>>0?143089:143103;a[w+4>>2]=ra;a[w+8>>2]=pa?142996:143001;a[w+12>>2]=fa;a[w+16>>2]=Yf;a[w+20>>2]=A;Wb(ja,144240,143124,w);ja=(Yf|0)>(A|0);if(cg>>>0>Xe>>>0&ja)for(fa=Yf,pa=cg;;)if(ra=
pa+-4|0,ma=fa-(a[ra>>2]|0)|0,ca=(ma|0)>(A|0),ra>>>0>Xe>>>0&ca)fa=ma,pa=ra;else{Tg=ca;kg=ma;hg=ra;break}else Tg=ja,kg=Yf,hg=cg;(kg|0)>=(A|0)?Tg?(a[hg>>2]=A,a[hg+4>>2]=0,wg=Pf,xg=Xe,yg=Xf,Zf=zg=0,ag=rf,Ag=hg+8|0):(wg=Pf,xg=Xe,yg=Xf,Zf=zg=0,ag=rf,Ag=hg):(hg-Xe&4?(a[hg>>2]=0,Fg=hg+4|0):Fg=hg,a[Fg>>2]=A-(0>(kg|0)?0:kg),wg=Pf,xg=Xe,yg=Xf,Zf=zg=0,ag=rf,Ag=Fg+4|0)}else if(154==(na|0))if(pa=a[U>>2]|0,fa=0!=(a[Z>>2]&1024|0),ra=a[(fa?da:ga)>>2]|0,a[m>>2]=a[ba>>2],a[m+4>>2]=fa?142996:143001,a[m+8>>2]=ra,a[m+
12>>2]=qb,Wb(pa,144240,143048,m),Bb?(a[ib>>2]=Bb,sh=ib+4|0):sh=ib,(qb|0)==(A|0))wg=rb,xg=gb,yg=hb,zg=ob,Zf=0,ag=kb,Ag=sh;else{pa=a[ba>>2]|0;ra=a[U>>2]|0;fa=0!=(a[Z>>2]&1024|0);ma=a[(fa?da:ga)>>2]|0;a[h>>2]=qb>>>0<A>>>0?143089:143103;a[h+4>>2]=pa;a[h+8>>2]=fa?142996:143001;a[h+12>>2]=ma;a[h+16>>2]=qb;a[h+20>>2]=A;Wb(ra,144240,143124,h);ra=(qb|0)>(A|0);if(sh>>>0>gb>>>0&ra)for(ma=qb,fa=sh;;)if(pa=fa+-4|0,ca=ma-(a[pa>>2]|0)|0,R=(ca|0)>(A|0),pa>>>0>gb>>>0&R)ma=ca,fa=pa;else{Ug=R;lg=ca;gh=pa;break}else Ug=
ra,lg=qb,gh=sh;(lg|0)>=(A|0)?Ug?(a[gh>>2]=A,a[gh+4>>2]=0,wg=rb,xg=gb,yg=hb,zg=ob,Zf=0,ag=kb,Ag=gh+8|0):(wg=rb,xg=gb,yg=hb,zg=ob,Zf=0,ag=kb,Ag=gh):(gh-gb&4?(a[gh>>2]=0,Hg=gh+4|0):Hg=gh,a[Hg>>2]=A-(0>(lg|0)?0:lg),wg=rb,xg=gb,yg=hb,zg=ob,Zf=0,ag=kb,Ag=Hg+4|0)}else if(186==(na|0))A?(fa=a[ba>>2]|0,ma=a[U>>2]|0,ja=0!=(a[Z>>2]&1024|0),pa=a[(ja?da:ga)>>2]|0,a[f>>2]=143089,a[f+4>>2]=fa,a[f+8>>2]=ja?142996:143001,a[f+12>>2]=pa,a[f+16>>2]=0,a[f+20>>2]=A,Wb(ma,144240,143124,f),ma=Ka+4|0,a[Ka>>2]=A,W?(wg=sa,xg=
Ka,yg=ua,zg=0,Zf=Ia,ag=Da,Ag=ma):(a[ma>>2]=0,wg=sa,xg=Ka,yg=ua,zg=0,Zf=Ia,ag=Da,Ag=Ka+8|0)):(wg=sa,xg=Ka,yg=ua,zg=0,Zf=Ia,ag=Da,Ag=Ka);else if(190==(na|0)){Wg=a[O>>2]|0;Xg=a[T>>2]|0;Yg=ih;Zg=jh;$g=kh;Jg=lh;break a}while(0);Ud[a[aa>>2]&31](wg,xg,Ag,A);a[D>>2]=zg;a[I>>2]=yg;a[F>>2]=Zf;a[T>>2]=(a[O>>2]|0)-ag+(a[T>>2]|0);a[O>>2]=ag;J=-1;u=e;return J|0}Wg=M;Xg=X;Yg=G;Zg=K;$g=N;Jg=M}while(0);a[D>>2]=Zg;a[I>>2]=Yg;a[F>>2]=$g;a[T>>2]=Wg-Jg+Xg;a[O>>2]=Jg;J=1;u=e;return J|0},function(b,d,c,e){b|=0;d|=0;c|=
0;var f,g,h,m,k,l,n,p,q;e=u;u=u+16|0;f=e+4|0;g=a[b+576>>2]|0;h=b+604|0;m=g+800|0;a[m>>2]=a[h>>2];k=b+608|0;l=g+804|0;a[l>>2]=a[k>>2];n=g+840|0;p=a[n>>2]|0;if(!p)return u=e,0;q=(c|0)/(p|0)|0;(c|0)%(p|0)|0&&Wb(a[b+628>>2]|0,a[b>>2]|0,145243,e);p=a[g+32>>2]|0;c=(q|0)>(p|0)?p:q;a:do if(c){q=b+444|0;p=d;for(b=c;;){a[f>>2]=p;d=g;c=f;d|=0;c|=0;var t,r,w,x,z=0,v=0,C=0;t=4;r=Hc(40)|0;a[r>>2]=0;r=Xc(d+624|0,1,r|0,t|0)|0;t=U;Wa=w=Wa=0;0!=(w|0)&0!=(pa|0)?((x=db(a[w>>2]|0,r|0,t|0)|0)||Vb(w|0,pa|0),U=pa):x=-1;
for(x=1==(x|0)?U:0;;){if(x){z=-1;v=6;break}Wa=0;C=Pg(17,d|0,c|0,1)|0;x=Wa;Wa=0;0!=(x|0)&0!=(pa|0)?((w=db(a[x>>2]|0,r|0,t|0)|0)||Vb(x|0,pa|0),U=pa):w=-1;if(1==(w|0))x=U;else break}6!=(v|0)&&(z=C);Gc(r|0);d=z|0;if(1!=(d|0)){f=0;break}a[q>>2]=(a[q>>2]|0)+1;if(1<(b|0))p=p+(a[n>>2]|0)|0,b=b+-1|0;else break a}u=e;return f|0}while(0);a[h>>2]=a[m>>2];a[k>>2]=a[l>>2];f=(a[g+140>>2]|0)>>>0<(a[g+116>>2]|0)>>>0?1:0!=(qg(g)|0);u=e;return f&1|0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q=0,r=0,B=0,
w=0,v=0,z=p=0,Q=0,C=0,A=0,V=0;e=u;u=u+16|0;f=e+8|0;g=e+12|0;(h=a[b+576>>2]|0)||Z(154187,144647,1883,144795);m=h+840|0;k=a[m>>2]|0;l=(c|0)/(k|0)|0;(c|0)%(k|0)|0&&Wb(a[b+628>>2]|0,a[b>>2]|0,144806,e);a[b+12>>2]&1024?n=l:(k=a[b+444>>2]|0,c=a[b+60>>2]|0,n=(k+l|0)>>>0>c>>>0?c-k|0:l);l=h+72|0;k=a[l>>2]|0;if(12==(k|0))if(c=(a[m>>2]<<1|0)/3|0,p=eb(c<<1)|0)r=d,B=p,w=c,v=n,p=10;else return Y(a[b+628>>2]|0,144795,144836,f),u=e,0;else z=d,Q=k,A=C=0,V=n;for(;;){10==(p|0)&&(p=0,z=r,Q=a[l>>2]|0,C=B,A=w,V=v);n=V+
-1|0;f=12==(Q|0);if(0>=(V|0))break;if(f){if(k=(A|0)/2|0,a[g>>2]=C,1<(A|0)){d=0;do c=3*d|0,p=C+(d<<1<<1)|0,t[p>>0]=(x[z+(c+1)>>0]|0)>>>4|(x[z+c>>0]|0)<<4,t[p+1>>0]=t[z+(c+2)>>0]|0,d=d+1|0;while((d|0)<(k|0))}}else a[g>>2]=z;c=g;d=h;d|=0;c|=0;var E,w=B=p=0;k=4;r=Hc(40)|0;a[r>>2]=0;r=Xc(d+624|0,1,r|0,k|0)|0;k=U;Wa=E=Wa=0;0!=(E|0)&0!=(pa|0)?((v=db(a[E>>2]|0,r|0,k|0)|0)||Vb(E|0,pa|0),U=pa):v=-1;for(v=1==(v|0)?U:0;;){if(v){p=-1;B=6;break}Wa=0;w=Pg(15,d|0,c|0,1)|0;v=Wa;Wa=0;0!=(v|0)&0!=(pa|0)?((E=db(a[v>>
2]|0,r|0,k|0)|0)||Vb(v|0,pa|0),U=pa):E=-1;if(1==(E|0))v=U;else break}6!=(B|0)&&(p=w);Gc(r|0);d=p|0;if(1!=(d|0)){q=0;p=23;break}1<(V|0)&&(k=b+444|0,a[k>>2]=(a[k>>2]|0)+1);r=z+(a[m>>2]|0)|0;B=C;w=A;v=n;p=10}if(23==(p|0))return u=e,q|0;if(!f)return u=e,1;ja(C);u=e;return 1},function(b,d,c,e){e=u;u=u+16|0;Y(a[(b|0)+628>>2]|0,145746,145763,e);u=e;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q,r,B,w,x,z,v,C,A,V,D,J,I,G,L=0,K,F,S,O,M,T,X,P,R,W,Z,ba,da;e=u;u=u+16|0;f=e+8|0;g=e;h=a[b+576>>
2]|0;m=a[h+32>>2]|0;a:do if(m){k=h+216|0;l=a[(a[k>>2]|0)+132>>2]|0;n=a[h+888>>2]|0;p=h+840|0;q=h+884|0;r=h+320|0;B=h+844|0;w=h+36|0;x=h+836|0;z=b+444|0;v=l+-1|0;C=E(n,v)|0;A=0==(l|0);V=d;D=c;J=a[p>>2]|0;I=m;b:for(;;){if((D|0)<(J|0)){k=4;break}G=a[q>>2]|0;if(7<(G|0)){J=a[r>>2]<<3;G=h;K=B;F=J;G|=0;K|=0;F|=0;X=T=M=0;S=4;O=Hc(40)|0;a[O>>2]=0;O=Xc(G+624|0,1,O|0,S|0)|0;S=U;Wa=R=Wa=0;0!=(R|0)&0!=(pa|0)?((P=db(a[R>>2]|0,O|0,S|0)|0)||Vb(R|0,pa|0),U=pa):P=-1;for(P=1==(P|0)?U:0;;){if(P){M=-1;T=6;break}Wa=0;
X=Pg(18,G|0,K|0,F|0)|0;P=Wa;Wa=0;0!=(P|0)&0!=(pa|0)?((R=db(a[P>>2]|0,O|0,S|0)|0)||Vb(P|0,pa|0),U=pa):R=-1;if(1==(R|0))P=U;else break}6!=(T|0)&&(M=X);Gc(O|0);G=M|0;if((G|0)!=(J|0)){L=0;k=32;break}J=a[q>>2]=0}else J=G;if(0<(a[w>>2]|0)){J=G=0;for(K=a[k>>2]|0;;){F=a[K+8>>2]|0;S=a[K+12>>2]|0;c:do if(0<(S|0)){O=h+844+(G<<2)|0;M=F+C|0;if(1==(F|0))for(T=J,X=0;;){if((D|0)<(M+T|0)){k=19;break b}if(!A)for(P=(a[O>>2]|0)+((E(a[q>>2]|0,S)|0)+X<<2)|0,R=a[P>>2]|0,P=l,W=V+T|0;;)if(P=P+-1|0,t[W>>0]=t[R>>0]|0,P)R=R+
1|0,W=W+n|0;else break;W=T+1|0;X=X+1|0;if((X|0)>=(S|0)){O=W;break c}else T=W}T=A|1>(F|0);X=J;for(W=0;;){if((D|0)<(M+X|0)){k=19;break b}if(!T)for(R=(a[O>>2]|0)+((E(a[q>>2]|0,S)|0)+W<<2)|0,P=v,Z=a[R>>2]|0,R=V+X|0;;){ba=Z;for(da=0;t[R+da>>0]=t[ba>>0]|0,da=da+1|0,(da|0)!=(F|0);)ba=ba+1|0;if(P)P=P+-1|0,Z=Z+F|0,R=R+n|0;else break}R=X+F|0;W=W+1|0;if((W|0)>=(S|0)){O=R;break}else X=R}}else O=J;while(0);G=G+1|0;if((G|0)>=(a[w>>2]|0))break;else J=O,K=K+88|0}J=a[q>>2]|0}a[q>>2]=J+1;K=N[x>>1]|0;a[z>>2]=(a[z>>
2]|0)+K;J=a[p>>2]|0;I=I-K|0;if(0>=(I|0))break a;else V=V+J|0,D=D-J|0}if(4==(k|0))return Y(a[b+628>>2]|0,145605,145619,g),L=0,u=e,L|0;if(19==(k|0))return Y(a[b+628>>2]|0,145605,145669,f),L=0,u=e,L|0;if(32==(k|0))return u=e,L|0}while(0);b=(a[h+140>>2]|0)>>>0<(a[h+116>>2]|0)>>>0?1:0!=(qg(h)|0);u=e;return b&1|0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q,r,B,w,x,z,v,C,A,V,D,J,I,G,L,K,F,R,O,M,T;e=u;u=u+16|0;f=a[b+576>>2]|0;g=a[f+888>>2]|0;f||Z(154187,144647,1965,144938);h=N[f+834>>1]|0;m=f+
836|0;k=N[m>>1]|0;l=(E(k,h)|0)+2|0;n=((E(E(a[f+72>>2]|0,(((a[f+28>>2]|0)+-1+h|0)>>>0)/(h>>>0)|0)|0,l)|0)+7|0)>>>3;l=E((c|0)/(n|0)|0,k)|0;(c|0)%(n|0)|0&&Wb(a[b+628>>2]|0,a[b>>2]|0,144806,e);c=f+84|0;k=a[(a[c>>2]|0)+132>>2]|0;h=f+276|0;if(0>=(l|0))return u=e,1;p=f+76|0;q=f+884|0;r=f+844|0;B=b+444|0;b=0==(k|0);w=d;for(d=l;;){l=a[p>>2]|0;if(0<(l|0))for(x=l,z=l=0,v=a[c>>2]|0;;){C=a[v+8>>2]|0;A=a[v+12>>2]|0;V=a[v+28>>2]|0;D=E(C,k)|0;if(0<(A|0)){x=f+844+(l<<2)|0;J=1==(C|0);I=0<((V<<3)-D|0);G=(V<<3)-D|0;
D=E(C,A)|0;V=b|1>(C|0);L=z;for(K=0;;){F=w+L|0;R=(E(a[q>>2]|0,A)|0)+K|0;O=a[(a[x>>2]|0)+(R<<2)>>2]|0;if(J)if(b)R=O;else{R=F;F=k;for(M=O;;)if(F=F+-1|0,t[M>>0]=t[R>>0]|0,F)R=R+g|0,M=M+1|0;else break;R=O+k|0}else if(V)R=O;else for(M=k,R=F,F=O;;){M=M+-1|0;O=F;for(T=0;t[O>>0]=t[R+T>>0]|0,T=T+1|0,(T|0)!=(C|0);)O=O+1|0;O=F+C|0;if(M)R=R+g|0,F=O;else{R=O;break}}if(I)for(F=R,R=0;t[F>>0]=t[F+-1>>0]|0,R=R+1|0,(R|0)!=(G|0);)F=F+1|0;K=K+1|0;if((K|0)==(A|0))break;else L=L+C|0}C=a[p>>2]|0;z=z+D|0}else C=x;l=l+1|0;
if((l|0)>=(C|0))break;else x=C,v=v+88|0}v=a[q>>2]|0;a[q>>2]=v+1;if(6<(v|0)){v=a[h>>2]<<3;if((Re(f,r,v)|0)!=(v|0)){b=0;d=28;break}a[q>>2]=0}v=N[m>>1]|0;a[B>>2]=(a[B>>2]|0)+v;d=d-v|0;if(0>=(d|0)){b=1;d=28;break}else w=w+n|0}return 28==(d|0)?(u=e,b|0):0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g;f=Pe(b)|0;if(!f)return 0;(c|0)%(f|0)|0&&Z(146868,146646,385,147503);g=b+532|0;if(!c)return 1;for(;;){if(!(rb[a[g>>2]&63](b,d,f,e)|0)){b=0;e=7;break}if((c|0)==(f|0)){b=1;e=7;break}else d=d+f|0,c=c-f|0}return 7==
(e|0)?b|0:0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g;f=tg(b)|0;if(!f)return 0;(c|0)%(f|0)|0&&Z(146868,146646,404,147486);g=b+532|0;if(!c)return 1;for(;;){if(!(rb[a[g>>2]&63](b,d,f,e)|0)){b=0;e=7;break}if((c|0)==(f|0)){b=1;e=7;break}else d=d+f|0,c=c-f|0}return 7==(e|0)?b|0:0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g;f=Pe(b)|0;if(!f)return 0;(c|0)%(f|0)|0&&Z(146868,146646,656,146900);g=b+536|0;if(!c)return 1;for(;;){if(1!=(rb[a[g>>2]&63](b,d,f,e)|0)){b=0;e=7;break}if((c|0)==(f|0)){b=1;e=
7;break}else d=d+f|0,c=c-f|0}return 7==(e|0)?b|0:0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g;f=tg(b)|0;if(!f)return 0;(c|0)%(f|0)|0&&Z(146868,146646,674,146883);g=b+536|0;if(!c)return 1;for(;;){if(1!=(rb[a[g>>2]&63](b,d,f,e)|0)){b=0;e=7;break}if((c|0)==(f|0)){b=1;e=7;break}else d=d+f|0,c=c-f|0}return 7==(e|0)?b|0:0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h=0,m,k,l,n,p,q,t,r;f=u;u=u+16|0;g=a[b+576>>2]|0;(e|0)<<16>>16&&Z(147105,146646,263,147614);g||Z(154187,146646,264,147614);e=(c|0)/(a[g+8>>
2]|0)|0;2!=(a[g>>2]|0)?(a[g+16>>2]|0)<(e|0)?Z(147125,146646,271,147614):h=a[g+12>>2]|0:h=d;c=b+604|0;m=a[c>>2]|0;k=b+608|0;l=a[k>>2]|0;if(0<(l|0)&0<(e|0)){n=((l+(3>(l|0)?~l:-4)+3|0)>>>0)/3|0;p=e+-1|0;q=n>>>0>p>>>0?p:n;n=~q;p=q+1|0;q=3*n|0;t=E(n,-3)|0;n=m;for(r=0;a[h+(r<<2)>>2]=(x[n+1>>0]|0)<<8|(x[n>>0]|0)<<16|x[n+2>>0]|0,r=r+1|0,(r|0)!=(p|0);)n=n+3|0;h=m+t|0;l=l+q|0}else h=m,p=0;a[c>>2]=h;a[k>>2]=l;if((e|0)==(p|0))return td[a[g+20>>2]&127](g,d,e),u=f,1;d=a[b+628>>2]|0;g=e-p|0;a[f>>2]=a[b+444>>2];
b=f+8|0;a[b>>2]=g;a[b+4>>2]=(0>(g|0))<<31>>31;Y(d,147614,147552,f);u=f;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h=0,m,k,l,n,p,q,r=0,B=0,w,v,z,Q,C,A,V,E,J,I,G,D,K=0,F=0,N=0;f=u;u=u+16|0;(e|0)<<16>>16&&Z(147105,146646,319,147599);(e=a[b+576>>2]|0)||Z(154187,146646,321,147599);g=(c|0)/(a[e+8>>2]|0)|0;2!=(a[e>>2]|0)?(a[e+16>>2]|0)<(g|0)?Z(147125,146646,328,147599):h=a[e+12>>2]|0:h=d;$c(h,0,g<<2);c=b+604|0;m=a[c>>2]|0;k=b+608|0;l=a[k>>2]|0;a:do if(0<(g|0))for(n=m,p=l,q=32;;){q=q+-8|0;if(-1>=
(q|0)){r=n;B=p;n=26;break a}b:do if(0<(p|0))for(w=n,v=p,z=0;;){Q=t[w>>0]|0;C=Q&255;A=w+1|0;c:do if(0>Q<<24>>24)if(V=w+2|0,E=(x[A>>0]|0)<<q,J=v+-2|0,(z|0)<(g|0)){I=z-g|0;G=126-C|0;D=z-(I>>>0>G>>>0?I:G)|0;G=z;do I=h+(G<<2)|0,G=G+1|0,a[I>>2]|=E;while((G|0)!=(D|0));G=V;E=J}else G=V,E=J,D=z;else{if(D=v+-1|0)w=D;else{C=A;A=0;break b}for(;;){if(!((z|0)<(g|0)&0!=(C|0))){G=A;E=w;D=z;break c}D=A+1|0;G=z+1|0;E=h+(z<<2)|0;a[E>>2]|=(x[A>>0]|0)<<q;if(w=w+-1|0)A=D,z=G,C=C+-1|0;else{C=D;A=0;z=G;break b}}}while(0);
if((g|0)>(D|0)&0<(E|0))w=G,v=E,z=D;else{C=G;A=E;z=D;break}}else C=n,A=p,z=0;while(0);if((g|0)!=(z|0)){K=C;F=A;N=z;n=25;break}else n=C,p=A}else for(p=0==(g|0),n=32;;){n=n+-8|0;if(-1>=(n|0)){r=m;B=l;n=26;break a}if(!p){K=m;F=l;N=0;n=25;break}}while(0);if(25==(n|0))l=a[b+628>>2]|0,m=g-N|0,a[f>>2]=a[b+444>>2],b=f+8|0,a[b>>2]=m,a[b+4>>2]=(0>(m|0))<<31>>31,Y(l,147599,147552,f),a[c>>2]=K,a[k>>2]=F,u=f;else if(26==(n|0))return td[a[e+20>>2]&127](e,d,g),a[c>>2]=r,a[k>>2]=B,u=f,1;return 0},function(b,d,c,e){b|=
0;d|=0;c|=0;var f,g,h=0,m,k,l,n,p,q=0,r=0,B,H,v,z,A,C,E,V,D,J,I,G,L=0,K=0,F=0;f=u;u=u+16|0;g=a[b+576>>2]|0;(e|0)<<16>>16&&Z(147105,146646,197,147539);g||Z(154187,146646,198,147539);e=(c|0)/(a[g+8>>2]|0)|0;1!=(a[g>>2]|0)?(a[g+16>>2]|0)<(e|0)?Z(147125,146646,205,147539):h=a[g+12>>2]|0:h=d;$c(h,0,e<<1);c=b+604|0;m=b+608|0;k=0<(e|0);l=a[c>>2]|0;n=a[m>>2]|0;for(p=16;;){p=p+-8|0;if(-1>=(p|0)){q=l;r=n;h=23;break}a:do if(k&0<(n|0))for(B=l,H=n,v=0;;){z=t[B>>0]|0;A=z&255;C=B+1|0;b:do if(0>z<<24>>24)if(E=B+
2|0,V=(x[C>>0]|0)<<p,D=H+-2|0,(v|0)<(e|0)){J=v-e|0;I=126-A|0;G=v-(J>>>0>I>>>0?J:I)|0;I=v;do J=h+(I<<1)|0,I=I+1|0,w[J>>1]=N[J>>1]|0|V;while((I|0)!=(G|0));I=E;V=D}else I=E,V=D,G=v;else{if(G=H+-1|0)B=G;else{A=C;C=0;break a}for(;;){if(!((v|0)<(e|0)&0!=(A|0))){I=C;V=B;G=v;break b}G=C+1|0;I=v+1|0;V=h+(v<<1)|0;w[V>>1]=N[V>>1]|0|(x[C>>0]|0)<<p;if(B=B+-1|0)C=G,v=I,A=A+-1|0;else{A=G;C=0;v=I;break a}}}while(0);if((e|0)>(G|0)&0<(V|0))B=I,H=V,v=G;else{A=I;C=V;v=G;break}}else A=l,C=n,v=0;while(0);if((e|0)!=(v|
0)){L=A;K=C;F=v;h=22;break}else l=A,n=C}if(22==(h|0))C=a[b+628>>2]|0,n=e-F|0,a[f>>2]=a[b+444>>2],b=f+8|0,a[b>>2]=n,a[b+4>>2]=(0>(n|0))<<31>>31,Y(C,147539,147552,f),a[c>>2]=L,a[m>>2]=K,u=f;else if(23==(h|0))return td[a[g+20>>2]&127](g,d,e),a[c>>2]=q,a[m>>2]=r,u=f,1;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g=0,h,m,k,l,n,p,q,r=0,B,u=0,w=0,z=0,v=0,x=0;f=a[b+576>>2]|0;(e|0)<<16>>16&&Z(147105,146646,516,147308);f||Z(154187,146646,517,147308);e=(c|0)/(a[f+8>>2]|0)|0;2!=(a[f>>2]|0)?(a[f+16>>2]|0)<
(e|0)?Z(147125,146646,524,147308):(c=a[f+12>>2]|0,td[a[f+20>>2]&127](f,d,e),g=c):g=d;d=b+604|0;f=a[d>>2]|0;c=b+592|0;h=a[c>>2]|0;m=b+608|0;k=h-(a[m>>2]|0)|0;do if(e){l=e;n=k;p=f;for(q=g;;){l=l+-1|0;if(3>(n|0)){a[d>>2]=p;a[m>>2]=(a[c>>2]|0)-n;if(!(Lc(b)|0)){r=-1;l=17;break}n=(a[c>>2]|0)-(a[m>>2]|0)|0;B=a[d>>2]|0}else B=p;t[B>>0]=(a[q>>2]|0)>>>16;t[B+1>>0]=(a[q>>2]|0)>>>8;p=B+3|0;t[B+2>>0]=a[q>>2];n=n+-3|0;if(l)q=q+4|0;else{u=p;w=n;l=15;break}}if(15==(l|0))z=a[c>>2]|0,v=w,x=u;else if(17==(l|0))return r|
0}else z=h,v=k,x=f;while(0);a[d>>2]=x;a[m>>2]=z-v;return 1},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g=0,h,m,k,l,n,p,q,r,B=0,u,w,z,v,x,A,V=0,E=0;f=a[b+576>>2]|0;(e|0)<<16>>16&&Z(147105,146646,568,147293);f||Z(154187,146646,569,147293);e=(c|0)/(a[f+8>>2]|0)|0;2!=(a[f>>2]|0)?(a[f+16>>2]|0)<(e|0)?Z(147125,146646,577,147293):(c=a[f+12>>2]|0,td[a[f+20>>2]&127](f,d,e),g=c):g=d;d=b+604|0;f=b+592|0;c=b+608|0;h=0<(e|0);m=24;k=(a[f>>2]|0)-(a[c>>2]|0)|0;l=a[d>>2]|0;n=0;a:for(;;){if(h)for(p=255<<m,q=0,r=n;;){if(4>
(k|0)){a[d>>2]=l;a[c>>2]=(a[f>>2]|0)-k;if(!(Lc(b)|0)){B=-1;b=43;break a}u=(a[f>>2]|0)-(a[c>>2]|0)|0;w=a[d>>2]|0}else u=k,w=l;b:do if((q|0)<(e|0)){for(z=q;;){v=a[g+(z<<2)>>2]|0;for(l=1;;){x=l+z|0;A=(x|0)<(e|0);if(!A){k=x;v=A;n=l;break}if((a[g+(x<<2)>>2]^v)&p){k=x;v=A;n=l;break}A=l+1|0;if(129>(A|0))l=A;else{k=z;n=A;break b}}l=3<(n|0);if(l|v^1){v=z;break}else z=k}k=l?v:k}else k=q,n=r;while(0);b:do if(2==(k-q&-2|0)){z=a[g+(q<<2)>>2]&p;for(l=q+1|0;;){v=l+1|0;if((a[g+(l<<2)>>2]&p|0)!=(z|0)){v=q;z=u;r=w;
break b}if((v|0)==(k|0))break;else l=v}t[w>>0]=127-q+l;t[w+1>>0]=z>>>m;v=k;z=u+-2|0;r=w+2|0}else v=q,z=u,r=w;while(0);if((k|0)>(v|0))for(l=~k,A=z,x=r;;){w=k-v|0;q=127<(w|0)?127:w;if((A|0)<(q+3|0)){a[d>>2]=x;a[c>>2]=(a[f>>2]|0)-A;if(!(Lc(b)|0)){B=-1;b=43;break a}u=(a[f>>2]|0)-(a[c>>2]|0)|0;A=a[d>>2]|0}else u=A,A=x;t[A>>0]=q;w=A+1|0;if(q){z=v+l|0;r=-128<(z|0)?z:-128;z=A+(0-r)|0;A=v+-1|0;x=q;for(q=w;;)if(x=x+-1|0,t[q>>0]=(a[g+(v<<2)>>2]|0)>>>m,x)v=v+1|0,q=q+1|0;else break;v=A-r|0;w=z;q=r}else q=-1;q=
u+q|0;if((k|0)>(v|0))A=q,x=w;else{l=v;u=w;break}}else l=v,q=z,u=r;3<(n|0)?(t[u>>0]=n+126,t[u+1>>0]=(a[g+(k<<2)>>2]|0)>>>m,k=q+-2|0,u=u+2|0):(k=q,n=0);q=n+l|0;if((q|0)>=(e|0)){p=k;q=u;break}else l=u,r=n}else p=k,q=l;m=m+-8|0;if(-1>=(m|0)){V=p;E=q;b=42;break}else k=p,l=q}return 42==(b|0)?(a[d>>2]=E,a[c>>2]=(a[f>>2]|0)-V,1):43==(b|0)?B|0:0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g=0,h,m,k,l,n,p,q,r,B=0,u,v,z,x,C,A,V=0,E=0;f=a[b+576>>2]|0;(e|0)<<16>>16&&Z(147105,146646,428,147112);f||Z(154187,146646,
429,147112);e=(c|0)/(a[f+8>>2]|0)|0;1!=(a[f>>2]|0)?(a[f+16>>2]|0)<(e|0)?Z(147125,146646,436,147112):(c=a[f+12>>2]|0,td[a[f+20>>2]&127](f,d,e),g=c):g=d;d=b+604|0;f=b+592|0;c=b+608|0;h=0<(e|0);m=8;k=(a[f>>2]|0)-(a[c>>2]|0)|0;l=a[d>>2]|0;n=0;a:for(;;){if(h)for(p=255<<m,q=0,r=n;;){if(4>(k|0)){a[d>>2]=l;a[c>>2]=(a[f>>2]|0)-k;if(!(Lc(b)|0)){B=-1;b=43;break a}u=(a[f>>2]|0)-(a[c>>2]|0)|0;v=a[d>>2]|0}else u=k,v=l;b:do if((q|0)<(e|0)){for(z=q;;){x=(N[g+(z<<1)>>1]&p)<<16>>16;for(l=1;;){C=l+z|0;A=(C|0)<(e|0);
if(!A){k=C;x=A;n=l;break}if((w[g+(C<<1)>>1]&p|0)!=(x|0)){k=C;x=A;n=l;break}A=l+1|0;if(129>(A|0))l=A;else{k=z;n=A;break b}}l=3<(n|0);if(l|x^1){x=z;break}else z=k}k=l?x:k}else k=q,n=r;while(0);b:do if(2==(k-q&-2|0)){z=(N[g+(q<<1)>>1]&p)<<16>>16;for(l=q+1|0;;){x=l+1|0;if((w[g+(l<<1)>>1]&p|0)!=(z|0)){x=q;z=u;r=v;break b}if((x|0)==(k|0))break;else l=x}t[v>>0]=127-q+l;t[v+1>>0]=z>>m;x=k;z=u+-2|0;r=v+2|0}else x=q,z=u,r=v;while(0);if((k|0)>(x|0))for(l=~k,A=z,C=r;;){v=k-x|0;q=127<(v|0)?127:v;if((A|0)<(q+3|
0)){a[d>>2]=C;a[c>>2]=(a[f>>2]|0)-A;if(!(Lc(b)|0)){B=-1;b=43;break a}u=(a[f>>2]|0)-(a[c>>2]|0)|0;A=a[d>>2]|0}else u=A,A=C;t[A>>0]=q;v=A+1|0;if(q){z=x+l|0;r=-128<(z|0)?z:-128;z=A+(0-r)|0;A=x+-1|0;C=q;for(q=v;;)if(C=C+-1|0,t[q>>0]=w[g+(x<<1)>>1]>>m,C)x=x+1|0,q=q+1|0;else break;x=A-r|0;v=z;q=r}else q=-1;q=u+q|0;if((k|0)>(x|0))A=q,C=v;else{l=x;u=v;break}}else l=x,q=z,u=r;3<(n|0)?(t[u>>0]=n+126,t[u+1>>0]=w[g+(k<<1)>>1]>>m,k=q+-2|0,u=u+2|0):(k=q,n=0);q=n+l|0;if((q|0)>=(e|0)){p=k;q=u;break}else l=u,r=n}else p=
k,q=l;m=m+-8|0;if(-1>=(m|0)){V=p;E=q;b=42;break}else k=p,l=q}return 42==(b|0)?(a[d>>2]=E,a[c>>2]=(a[f>>2]|0)-V,1):43==(b|0)?B|0:0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,r=0,B=0,v=0,A=0,z=0,Q=0,C=0,E=0,V=0,D=0,J=0,I=0,G=0,L=0,K=0,F=0,R=0,O=0,M=0,T=0,X=0,P=0,S=0,W=0,da=0,ba=0,aa=0,ca=0,fa=0,ga=0,ja=0,ma=0,pa=0,ha=0,ra=0,ya=0,Aa=0,Ka=0,Qa=0,Va=0,oa=0,sa=0,Wa=0,ua=0,Ia=0,Da=0,na=0,Na=0,eb=0,Ca=0,Ga=0,Ea=0,La=0,ab=0,db=0,fb=0,lb=0,xb=0,rb=0,ub=0,jb=0,pb=0,Ab=0,Ta=
0,Ya=0,Sa=0,mb=0,Db=0,Hb=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,Kb=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,Gb=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Lb=0,Ua=0,Pb=0,Jb=0,Sb=0,yb=0,cb=0,Vb=0,Ub=0,Fb=0,Yb=0,ac=0,$b=0,ec=0,wb=0,fc=0,jc=0,zb=0,Ob=0,Tb=0,kc=0,lc=0,nc=0,yc=0,xc=0,vc=0;e=u;u=u+80|0;f=e+64|0;g=e+56|0;h=e+48|0;m=e+40|0;k=e+32|0;l=e+24|0;n=e+16|0;p=e+8|0;q=e;(r=a[b+576>>2]|0)||Z(154187,147682,375,147871);B=r+124|0;a[B>>2]|0||Z(147881,147682,
376,147871);v=r+88|0;if(A=a[v>>2]|0)if(C=a[r+108>>2]|0,E=(N[C+4>>1]|0)-A|0,(E|0)<=(c|0)){V=d+E|0;D=C;J=E;I=V;do I=I+-1|0,G=D,D=a[D>>2]|0,t[I>>0]=t[G+6>>0]|0,J=J+-1|0;while(0!=(J|0)&0!=(D|0));a[v>>2]=0;z=c-E|0;Q=V}else{a[v>>2]=A+c;D=C;J=E;do D=a[D>>2]|0,J=J+-1|0,L=0!=(D|0);while((J|0)>(c|0)&L);if(!L)return K=1,u=e,K|0;J=D;E=c;C=d+c|0;do C=C+-1|0,t[C>>0]=t[J+6>>0]|0,J=a[J>>2]|0,E=E+-1|0;while(0!=(E|0)&0!=(J|0));K=1;u=e;return K|0}else z=c,Q=d;c=b+604|0;d=a[c>>2]|0;L=r+64|0;A=N[L>>1]|0;J=r+72|0;E=a[J>>
2]|0;C=r+76|0;D=a[C>>2]|0;V=r+84|0;I=a[V>>2]|0;G=r+112|0;F=a[G>>2]|0;R=r+116|0;O=a[R>>2]|0;M=r+120|0;T=a[M>>2]|0;a:do if(0<(z|0)){X=r+96|0;P=F;S=d;W=O;da=T;ba=A;aa=I;ca=D;fa=E;ga=z;ja=Q;b:for(;;){ma=X;pa=a[ma>>2]|0;ha=a[ma+4>>2]|0;ma=(0>(ba|0))<<31>>31;if(ha>>>0<ma>>>0|(ha|0)==(ma|0)&pa>>>0<ba>>>0){ra=P;ya=S;Aa=W;Ka=da;Qa=ba;Va=aa;oa=ca;sa=fa;Wa=ga;ua=18;break}Ia=S+1|0;Da=x[S>>0]|0|fa<<8;na=ca+8|0;(na|0)<(ba|0)?(Na=S+2|0,eb=ca+16|0,Ca=x[Ia>>0]|0|Da<<8):(Na=Ia,eb=na,Ca=Da);Da=eb-ba|0;na=Ca>>>Da&aa;
Ia=na&65535;Ga=Ic(pa|0,ha|0,ba|0,ma|0)|0;ma=X;a[ma>>2]=Ga;a[ma+4>>2]=U;ma=na&65535;c:do switch(Ia<<16>>16){case 257:Ea=Na;La=W;ab=da;db=ba;fb=aa;lb=Da;xb=Ca;rb=ga;ub=P;break a;case 256:Ga=a[B>>2]|0;ha=Na;pa=Da;jb=Ca;d:for(;;){pb=Ga+2064|0;$c(pb,0,38888);Ab=a[B>>2]|0;Ta=X;Ya=a[Ta>>2]|0;Sa=a[Ta+4>>2]|0;if(0>Sa>>>0|0==(Sa|0)&9>Ya>>>0){mb=pb;Db=Ab;Hb=P;Za=ha;ia=pa;qa=jb;Ja=ga;ua=24;break b}Ta=ha+1|0;ea=x[ha>>0]|0|jb<<8;wa=pa+8|0;9>(wa|0)?(Ma=ha+2|0,xa=pa+16|0,$a=x[Ta>>0]|0|ea<<8):(Ma=Ta,xa=wa,$a=ea);
ea=xa+-9|0;wa=$a>>>ea;Ta=wa&511;la=Ta&65535;Ba=Qb(Ya|0,Sa|0,-9,-1)|0;Sa=X;a[Sa>>2]=Ba;a[Sa+4>>2]=U;switch(la<<16>>16){case 257:va=pb;za=Ab;ta=ea;nb=P;Kb=Ma;gb=$a;hb=ga;ua=55;break b;case 256:Ga=Ab;ha=Ma;pa=ea;jb=$a;break;default:ob=pb;Bb=Ab;qb=ea;kb=wa;ib=Ta;Cb=la;Gb=Ma;sb=$a;break d}}if(256<(Cb&65535)){ua=29;break b}t[ja>>0]=kb;Xa=Gb;Fa=ob;Pa=Bb+4080|0;Eb=9;vb=511;tb=qb;bb=sb;Ib=ga+-1|0;Mb=(a[B>>2]|0)+(ib<<3)|0;Lb=ja+1|0;break;default:jb=a[B>>2]|0;pa=jb+(ma<<3)|0;ha=jb+40952|0;if(!(W>>>0>=jb>>>0&
W>>>0<ha>>>0)){ua=33;break b}a[W>>2]=P;if(!(P>>>0>=jb>>>0&P>>>0<ha>>>0)){ua=35;break b}ha=W+7|0;t[ha>>0]=t[P+7>>0]|0;w[W+4>>1]=(N[P+4>>1]|0)+1;t[W+6>>0]=t[(pa>>>0<W>>>0?jb+(ma<<3)+7|0:ha)>>0]|0;ha=W+8|0;ha>>>0>da>>>0?(Ga=ba+1|0,la=12<(Ga|0)?12:Ga,Ga=1<<la,Ua=jb+(Ga+-2<<3)|0,Pb=la,Jb=Ga+-1|0):(Ua=da,Pb=ba,Jb=aa);if(255>=(Ia&65535)){t[ja>>0]=na;Xa=Na;Fa=ha;Pa=Ua;Eb=Pb;vb=Jb;tb=Da;bb=Ca;Ib=ga+-1|0;Mb=pa;Lb=ja+1|0;break c}Ga=w[jb+(ma<<3)+4>>1]|0;jb=Ga&65535;if(!(Ga<<16>>16)){ua=40;break b}if((ga|0)<(jb|
0)){Sb=Da;yb=pa;cb=ha;Vb=Na;Ub=Ua;Fb=Pb;Yb=Jb;ac=Ca;$b=ga;ec=ja;ua=42;break b}Ga=ja+jb|0;la=pa;Ta=Ga;do Ta=Ta+-1|0,wa=la,la=a[la>>2]|0,t[Ta>>0]=t[wa+6>>0]|0,wb=0!=(la|0);while(Ta>>>0>ja>>>0&wb);if(wb){fc=Da;jc=pa;zb=ha;Ob=Na;Tb=Ua;kc=Pb;lc=Jb;nc=Ca;yc=ga;ua=52;break b}Xa=Na;Fa=ha;Pa=Ua;Eb=Pb;vb=Jb;tb=Da;bb=Ca;Ib=ga-jb|0;Mb=pa;Lb=Ga}while(0);if(0<(Ib|0))P=Mb,S=Xa,W=Fa,da=Pa,ba=Eb,aa=vb,ca=tb,fa=bb,ga=Ib,ja=Lb;else{Ea=Xa;La=Fa;ab=Pa;db=Eb;fb=vb;lb=tb;xb=bb;rb=Ib;ub=Mb;break a}}if(18==(ua|0))ja=a[b+
628>>2]|0,a[q>>2]=a[b+452>>2],Wb(ja,147871,147905,q),Ea=ya,La=Aa,ab=Ka,db=Qa,fb=Va,lb=oa,xb=sa,rb=Wa,ub=ra;else if(24==(ua|0))ja=a[b+628>>2]|0,a[p>>2]=a[b+452>>2],Wb(ja,147871,147905,p),Ea=Za,La=mb,ab=Db+4080|0,db=9,fb=511,lb=ia,xb=qa,rb=Ja,ub=Hb;else{if(29==(ua|0))return ja=a[b+628>>2]|0,ga=a[b>>2]|0,a[n>>2]=a[b+444>>2],Y(ja,ga,147954,n),K=0,u=e,K|0;if(33==(ua|0))return ga=a[b+628>>2]|0,a[l>>2]=a[b+444>>2],Y(ga,147871,148E3,l),K=0,u=e,K|0;if(35==(ua|0))return ga=a[b+628>>2]|0,a[k>>2]=a[b+444>>2],
Y(ga,147871,148E3,k),K=0,u=e,K|0;if(40==(ua|0))return ga=a[b+628>>2]|0,a[m>>2]=a[b+444>>2],Y(ga,147871,148035,m),K=0,u=e,K|0;if(42==(ua|0)){for(ga=a[r+108>>2]=yb;;){ja=a[ga>>2]|0;if(!ja){Ea=Vb;La=cb;ab=Ub;db=Fb;fb=Yb;lb=Sb;xb=ac;rb=$b;ub=yb;break a}if((N[ja+4>>1]|0)>($b|0))ga=ja;else{xc=ja;break}}a[v>>2]=$b;ga=xc;ja=$b;fa=ec+$b|0;do fa=fa+-1|0,t[fa>>0]=t[ga+6>>0]|0,ga=a[ga>>2]|0,ja=ja+-1|0,vc=0!=(ga|0);while(0!=(ja|0)&vc);vc&&(ga=a[b+628>>2]|0,a[h>>2]=a[b+444>>2],Y(ga,147871,148106,h));Ea=Vb;La=cb;
ab=Ub;db=Fb;fb=Yb;lb=Sb;xb=ac;rb=ja;ub=yb}else 52==(ua|0)?(ga=a[b+628>>2]|0,a[g>>2]=a[b+444>>2],Y(ga,147871,148106,g),Ea=Ob,La=zb,ab=Tb,db=kc,fb=lc,lb=fc,xb=nc,rb=yc,ub=jc):55==(ua|0)&&(Ea=Kb,La=va,ab=za+4080|0,db=9,fb=511,lb=ta,xb=gb,rb=hb,ub=nb)}}else Ea=d,La=O,ab=T,db=A,fb=I,lb=D,xb=E,rb=z,ub=F;while(0);a[c>>2]=Ea;w[L>>1]=db;a[J>>2]=xb;a[C>>2]=lb;a[V>>2]=fb;a[G>>2]=ub;a[R>>2]=La;a[M>>2]=ab;if(0>=(rb|0))return K=1,u=e,K|0;ab=a[b+628>>2]|0;a[f>>2]=a[b+444>>2];b=f+8|0;a[b>>2]=rb;a[b+4>>2]=(0>(rb|
0))<<31>>31;Y(ab,147871,148158,f);K=0;u=e;return K|0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q,r,B,u,v,z,A,C,E,V,D,J,I,G,L,K,F,R,O,M,T,X,P,S,W,Y,ba,U,da,aa,ga,ca,ma,fa,ha,ja,pa,ra,ya,Aa,Ka,oa,sa,Qa,ua,Ia,Da,na,Na,Va,Ca=0,Ga=0,Ea=0,La=0,Wa=0,ab=0,db=0,eb=0,fb=0,lb=0;e=a[b+576>>2]|0;if(!e)return 0;f=e+152|0;a[f>>2]|0||Z(147763,147682,888,147787);g=e+140|0;h=a[g>>2]|0;m=e+144|0;k=a[m>>2]|0;l=e+132|0;n=a[l>>2]|0;p=e+72|0;q=a[p>>2]|0;r=e+76|0;B=a[r>>2]|0;u=e+68|0;v=N[u>>1]|0;z=e+66|0;A=N[z>>
1]|0;C=e+64|0;E=N[C>>1]|0;V=b+604|0;D=a[V>>2]|0;J=a[e+148>>2]|0;I=e+128|0;G=a[I>>2]|0;L=G&65535;0<(c|0)&65535==(G&65535|0)?(G=q<<E|256,K=E+B|0,F=K+-8|0,R=D+1|0,t[D>>0]=G>>>F,7<(F|0)?(O=K+-16|0,t[R>>0]=G>>>O,M=O,T=D+2|0):(M=F,T=R),X=d+1|0,P=c+-1|0,S=x[d>>0]|0,W=h+1|0,Y=M,ba=G,U=T,da=E+k|0):(X=d,P=c,S=L,W=h,Y=B,ba=q,U=D,da=k);a:do if(0<(P|0)){k=b+588|0;D=b+608|0;q=e+136|0;B=X;h=P;L=n;c=S;d=v;T=W;G=A;M=E;R=Y;F=ba;O=U;K=da;b:for(;;){aa=t[B>>0]|0;B=B+1|0;ga=aa&255;ca=h;h=h+-1|0;ma=T+1|0;fa=c&65535;ha=
(ga<<12)+fa|0;ja=ga<<5;ga=ja^fa;c=a[f>>2]|0;pa=a[c+(ga<<3)>>2]|0;c:do if((pa|0)!=(ha|0)){d:do if(-1<(pa|0)){ra=(ja|0)==(fa|0)?1:9001-ga|0;for(ya=ga;;){Aa=ya-ra|0;Ka=0>(Aa|0)?Aa+9001|0:Aa;Aa=a[c+(Ka<<3)>>2]|0;if((Aa|0)==(ha|0)){T=Ka;break}if(-1<(Aa|0))ya=Ka;else{oa=Ka;break d}}oa=L;Ka=w[c+(T<<3)+4>>1]|0;sa=d;Qa=ma;ua=G;Ia=M;Da=R;na=F;Na=O;Va=K;break c}else oa=ga;while(0);O>>>0>J>>>0?(a[D>>2]=O-(a[k>>2]|0),Lc(b)|0,Va=a[k>>2]|0):Va=O;ya=F<<M|fa;ra=M+R|0;Ka=ra+-8|0;Aa=Va+1|0;t[Va>>0]=ya>>>Ka;7<(Ka|0)?
(sa=ra+-16|0,t[Aa>>0]=ya>>>sa,Na=Aa,Da=sa,Va=Va+2|0):(Na=Va,Da=Ka,Va=Aa);Aa=M+K|0;Ka=aa&255;sa=d+1|0;w[c+(oa<<3)+4>>1]=d;a[c+(oa<<3)>>2]=ha;if(4094==(sa|0)){ra=a[f>>2]|0;na=ra+72E3|0;for(oa=8993;!(oa=oa+-8|0,a[na+-56>>2]=-1,a[na+-48>>2]=-1,a[na+-40>>2]=-1,a[na+-32>>2]=-1,a[na+-24>>2]=-1,a[na+-16>>2]=-1,a[na+-8>>2]=-1,a[na>>2]=-1,-1>=(oa|0));)na=na+-64|0;a[ra>>2]=-1;a[q>>2]=0;na=ya<<M|256;oa=Da+M|0;ra=oa+-8|0;Aa=Na+2|0;t[Va>>0]=na>>>ra;7>=(ra|0)?(oa=L,sa=258,Qa=0,ua=511,Ia=9,Da=ra,Na=Aa):(ra=oa+-16|
0,t[Aa>>0]=na>>>ra,oa=L,sa=258,Qa=0,ua=511,Ia=9,Da=ra,Na=Na+3|0);Va=M}else if((d|0)>=(G|0)){na=M+1|0;if(13<=(na|0))break b;oa=L;Qa=ma;ua=(1<<na)+-1|0;Ia=na;na=ya;Na=Va;Va=Aa}else if((ma|0)>=(L|0))if(na=T+10001|0,oa=8388606<(T|0)?(ra=Aa>>8)?(ma|0)/(ra|0)|0:2147483647:(ma<<8|0)/(Aa|0)|0,(oa|0)>(a[q>>2]|0))a[q>>2]=oa,oa=na,Qa=ma,ua=G,Ia=M,na=ya,Na=Va,Va=Aa;else{ra=a[f>>2]|0;Aa=ra+72E3|0;for(oa=8993;!(oa=oa+-8|0,a[Aa+-56>>2]=-1,a[Aa+-48>>2]=-1,a[Aa+-40>>2]=-1,a[Aa+-32>>2]=-1,a[Aa+-24>>2]=-1,a[Aa+-16>>
2]=-1,a[Aa+-8>>2]=-1,a[Aa>>2]=-1,-1>=(oa|0));)Aa=Aa+-64|0;a[ra>>2]=-1;a[q>>2]=0;Aa=ya<<M|256;oa=Da+M|0;ra=oa+-8|0;ya=Na+2|0;t[Va>>0]=Aa>>>ra;7<(ra|0)?(Va=oa+-16|0,t[ya>>0]=Aa>>>Va,oa=na,sa=258,Qa=0,ua=511,Ia=9,Da=Va,na=Aa,Na=Na+3|0):(oa=na,sa=258,Qa=0,ua=511,Ia=9,Da=ra,na=Aa,Na=ya);Va=M}else oa=L,Qa=ma,ua=G,Ia=M,na=ya,Na=Va,Va=Aa}else oa=L,Ka=w[c+(ga<<3)+4>>1]|0,sa=d,Qa=ma,ua=G,Ia=M,Da=R,na=F,Na=O,Va=K;while(0);if(1>=(ca|0)){Ca=oa;Ga=Ka;Ea=sa;La=Qa;Wa=ua;ab=Ia;db=Da;eb=na;fb=Na;lb=Va;break a}else L=
oa,c=Ka,d=sa,T=Qa,G=ua,M=Ia,R=Da,F=na,O=Na,K=Va}Z(147797,147682,986,147787)}else Ca=n,Ga=S,Ea=v,La=W,Wa=A,ab=E,db=Y,eb=ba,fb=U,lb=da;while(0);a[g>>2]=La;a[m>>2]=lb;a[l>>2]=Ca;a[I>>2]=Ga&65535;a[p>>2]=eb;a[r>>2]=db;w[u>>1]=Ea;w[z>>1]=Wa;w[C>>1]=ab;a[V>>2]=fb;return 1},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,r=0,B=0,v=0,A=0,z=0,Q=0,C=0,E=0,V=0,D=0,J=0,I=0,G=0,L=0,K=0,F=0,R=0,O=0,M=0,T=0,X=0,P=0,S=0,W=0,da=0,ba=0,aa=0,ca=0,fa=0,ga=0,ja=0,ma=0,pa=0,ha=0,ra=0,ya=0,
Aa=0,Ka=0,Qa=0,Va=0,oa=0,sa=0,Wa=0,ua=0,Ia=0,Da=0,na=0,Na=0,ab=0,Ca=0,Ga=0,Ea=0,La=0,db=0,eb=0,fb=0,lb=0,xb=0,rb=0,ub=0,jb=0,pb=0,Ab=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,Hb=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,Kb=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,Gb=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Lb=0,Ua=0,Pb=0,Jb=0,Sb=0,yb=0,cb=0,Vb=0,Ub=0,Fb=0,Yb=0;e=u;u=u+64|0;f=e+48|0;g=e+40|0;h=e+32|0;m=e+24|0;k=e+16|0;l=e+8|0;n=e;(p=a[b+576>>2]|0)||Z(154187,147682,601,
148255);q=p+88|0;r=a[q>>2]|0;do if(r)if(A=a[p+108>>2]|0,z=(N[A+4>>1]|0)-r|0,(z|0)<=(c|0)){Q=d+z|0;C=A;E=z;for(V=Q;;)if(V=V+-1|0,t[V>>0]=t[C+6>>0]|0,E=E+-1|0)C=a[C>>2]|0;else break;a[q>>2]=0;B=c-z|0;v=Q}else{a[q>>2]=r+c;C=A;for(E=z;;)if(V=a[C>>2]|0,E=E+-1|0,(E|0)<=(c|0)){D=V;break}else C=V;C=D;E=c;for(z=d+c|0;;)if(z=z+-1|0,t[z>>0]=t[C+6>>0]|0,E=E+-1|0)C=a[C>>2]|0;else{J=1;break}u=e;return J|0}else B=c,v=d;while(0);c=b+604|0;d=a[c>>2]|0;D=p+64|0;r=N[D>>1]|0;C=p+72|0;E=a[C>>2]|0;z=p+76|0;A=a[z>>2]|0;
Q=p+84|0;V=a[Q>>2]|0;I=p+112|0;G=a[I>>2]|0;L=p+116|0;K=a[L>>2]|0;F=p+120|0;R=a[F>>2]|0;a:do if(0<(B|0)){O=p+96|0;M=p+124|0;T=G;X=d;P=K;S=R;W=r;da=V;ba=A;aa=E;ca=B;fa=v;b:for(;;){ga=O;ja=a[ga>>2]|0;ma=a[ga+4>>2]|0;ga=(0>(W|0))<<31>>31;if(ma>>>0<ga>>>0|(ma|0)==(ga|0)&ja>>>0<W>>>0){pa=T;ha=X;ra=P;ya=S;Aa=W;Ka=da;Qa=ba;Va=aa;oa=ca;sa=16;break}Wa=X+1|0;ua=(x[X>>0]|0)<<ba|aa;Ia=ba+8|0;(Ia|0)<(W|0)?(Da=X+2|0,na=ba+16|0,Na=(x[Wa>>0]|0)<<Ia|ua):(Da=Wa,na=Ia,Na=ua);ua=Na&da;Ia=ua&65535;Wa=Na>>W;ab=na-W|0;Ca=
Ic(ja|0,ma|0,W|0,ga|0)|0;ga=O;a[ga>>2]=Ca;a[ga+4>>2]=U;c:do switch(Ia|0){case 257:Ga=Da;Ea=P;La=S;db=W;eb=da;fb=ab;lb=Wa;xb=ca;rb=T;break a;case 256:ga=a[M>>2]|0;Ca=Da;ma=ab;ja=Wa;d:for(;;){ub=ga+2064|0;$c(ub,0,38888);jb=a[M>>2]|0;pb=O;Ab=a[pb>>2]|0;Ta=a[pb+4>>2]|0;if(0>Ta>>>0|0==(Ta|0)&9>Ab>>>0){Ya=ub;Sa=jb;mb=T;Db=Ca;Hb=ma;Za=ja;ia=ca;sa=22;break b}pb=Ca+1|0;qa=(x[Ca>>0]|0)<<ma|ja;Ja=ma+8|0;9>(Ja|0)?(ea=Ca+2|0,wa=ma+16|0,Ma=(x[pb>>0]|0)<<Ja|qa):(ea=pb,wa=Ja,Ma=qa);qa=Ma&511;Ja=Ma>>9;pb=wa+-9|0;
xa=Qb(Ab|0,Ta|0,-9,-1)|0;Ta=O;a[Ta>>2]=xa;a[Ta+4>>2]=U;switch(qa|0){case 257:$a=ub;la=jb;Ba=Ja;va=pb;za=T;ta=ea;nb=ca;sa=47;break b;case 256:ga=jb;Ca=ea;ma=pb;ja=Ja;break;default:Kb=ub;gb=jb;hb=qa;ob=Ja;Bb=pb;qb=ea;kb=Ma;break d}}if(256<hb>>>0){sa=27;break b}t[fa>>0]=kb;ib=qb;Cb=Kb;Gb=gb+4088|0;sb=9;Xa=511;Fa=Bb;Pa=ob;Eb=ca+-1|0;vb=(a[M>>2]|0)+(hb<<3)|0;tb=fa+1|0;break;default:ja=a[M>>2]|0;ma=ja+(Ia<<3)|0;Ca=ja+40952|0;if(!(P>>>0>=ja>>>0&P>>>0<Ca>>>0)){sa=31;break b}a[P>>2]=T;if(!(T>>>0>=ja>>>0&T>>>
0<Ca>>>0)){sa=33;break b}Ca=P+7|0;t[Ca>>0]=t[T+7>>0]|0;w[P+4>>1]=(N[T+4>>1]|0)+1;t[P+6>>0]=t[(ma>>>0<P>>>0?ja+(Ia<<3)+7|0:Ca)>>0]|0;Ca=P+8|0;Ca>>>0>S>>>0?(ga=W+1|0,pb=12<(ga|0)?12:ga,ga=(1<<pb)+-1|0,bb=ja+(ga<<3)|0,Ib=pb,Mb=ga):(bb=S,Ib=W,Mb=da);if(255>=Ia>>>0){t[fa>>0]=ua;ib=Da;Cb=Ca;Gb=bb;sb=Ib;Xa=Mb;Fa=ab;Pa=Wa;Eb=ca+-1|0;vb=ma;tb=fa+1|0;break c}ga=w[ja+(Ia<<3)+4>>1]|0;ja=ga&65535;if(!(ga<<16>>16)){sa=38;break b}if((ca|0)<(ja|0)){Lb=Wa;Ua=ab;Pb=ma;Jb=Ca;Sb=Da;yb=bb;cb=Ib;Vb=Mb;Ub=ca;Fb=fa;sa=40;
break b}ga=fa+ja|0;pb=ma;Ja=ga;do Ja=Ja+-1|0,t[Ja>>0]=t[pb+6>>0]|0,pb=a[pb>>2]|0;while(0!=(pb|0));ib=Da;Cb=Ca;Gb=bb;sb=Ib;Xa=Mb;Fa=ab;Pa=Wa;Eb=ca-ja|0;vb=ma;tb=ga}while(0);if(0<(Eb|0))T=vb,X=ib,P=Cb,S=Gb,W=sb,da=Xa,ba=Fa,aa=Pa,ca=Eb,fa=tb;else{Ga=ib;Ea=Cb;La=Gb;db=sb;eb=Xa;fb=Fa;lb=Pa;xb=Eb;rb=vb;break a}}if(16==(sa|0))fa=a[b+628>>2]|0,a[n>>2]=a[b+452>>2],Wb(fa,148255,147905,n),Ga=ha,Ea=ra,La=ya,db=Aa,eb=Ka,fb=Qa,lb=Va,xb=oa,rb=pa;else if(22==(sa|0))fa=a[b+628>>2]|0,a[l>>2]=a[b+452>>2],Wb(fa,148255,
147905,l),Ga=Db,Ea=Ya,La=Sa+4088|0,db=9,eb=511,fb=Hb,lb=Za,xb=ia,rb=mb;else{if(27==(sa|0))return fa=a[b+628>>2]|0,ca=a[b>>2]|0,a[k>>2]=a[b+444>>2],Y(fa,ca,147954,k),J=0,u=e,J|0;if(31==(sa|0))return ca=a[b+628>>2]|0,a[m>>2]=a[b+444>>2],Y(ca,148255,148E3,m),J=0,u=e,J|0;if(33==(sa|0))return ca=a[b+628>>2]|0,a[h>>2]=a[b+444>>2],Y(ca,148255,148E3,h),J=0,u=e,J|0;if(38==(sa|0))return ca=a[b+628>>2]|0,a[g>>2]=a[b+444>>2],Y(ca,148255,148035,g),J=0,u=e,J|0;if(40==(sa|0)){for(ca=a[p+108>>2]=Pb;;)if(fa=a[ca>>
2]|0,(N[fa+4>>1]|0)>(Ub|0))ca=fa;else{Yb=fa;break}a[q>>2]=Ub;ca=Yb;fa=Ub;for(aa=Fb+Ub|0;;)if(aa=aa+-1|0,t[aa>>0]=t[ca+6>>0]|0,fa=fa+-1|0)ca=a[ca>>2]|0;else{Ga=Sb;Ea=Jb;La=yb;db=cb;eb=Vb;fb=Ua;lb=Lb;xb=0;rb=Pb;break}}else 47==(sa|0)&&(Ga=ta,Ea=$a,La=la+4088|0,db=9,eb=511,fb=va,lb=Ba,xb=nb,rb=za)}}else Ga=d,Ea=K,La=R,db=r,eb=V,fb=A,lb=E,xb=B,rb=G;while(0);a[c>>2]=Ga;w[D>>1]=db;a[C>>2]=lb;a[z>>2]=fb;a[Q>>2]=eb;a[I>>2]=rb;a[L>>2]=Ea;a[F>>2]=La;if(0>=(xb|0))return J=1,u=e,J|0;La=a[b+628>>2]|0;a[f>>2]=
a[b+444>>2];b=f+8|0;a[b>>2]=xb;a[b+4>>2]=(0>(xb|0))<<31>>31;Y(La,148255,148158,f);J=0;u=e;return J|0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q,r,B,w,v,z,A,C,E,V,D,J,I,G,L,K,F;e=u;u=u+16|0;f=e+8|0;(g=0<(c|0))&&Va(d|0,-1,c|0)|0;h=b+604|0;m=b+608|0;k=a[b+580>>2]|0;if((c|0)%(k|0)|0)return Y(a[b+628>>2]|0,148314,153793,e),u=e,0;l=a[m>>2]|0;n=a[h>>2]|0;a:do{if(0<(l|0)&g){p=b+56|0;g=b+12|0;q=b+68|0;r=k+1|0;B=n;w=l;b:for(;;){v=B+1|0;z=x[B>>0]|0;A=w+-1|0;c:do switch(z|0){case 0:if((w|0)<=(k|
0))break b;Ab(d,v,k);C=B+r|0;l=A-k|0;break;case 64:if(5>(w|0))break b;l=(x[v>>0]|0)<<8|x[B+2>>0]|0;C=(x[B+3>>0]|0)<<8|x[B+4>>0]|0;n=C+4|0;if((w|0)<=(n|0)|(C+l|0)>(k|0))break b;Ab(d+l|0,B+5|0,C);C=B+(C+5)|0;l=A-n|0;break;default:for(n=a[(0==(a[g>>2]&1024|0)?p:q)>>2]|0,C=v,l=A,B=0,w=d;;){v=z>>>6;z&=63;A=B>>>0<n>>>0;d:do if(0!=(z|0)&A)for(E=v<<6&255,V=v<<4,D=v<<2,J=z,I=B,G=w;;){L=I;e:for(;;){K=J;J=J+-1|0;I=L+1|0;switch(L&3|0){case 3:F=J;break e;case 0:t[G>>0]=E;break;case 1:t[G>>0]=x[G>>0]|0|V;break;
case 2:t[G>>0]=x[G>>0]|0|D}L=I>>>0<n>>>0;if(1<(K|0)&L)L=I;else{E=L;V=I;break d}}L=G+1|0;t[G>>0]=x[G>>0]|0|v;J=I>>>0<n>>>0;if(1<(K|0)&J)J=F,G=L;else{E=J;V=I;G=L;break}}else E=A,V=B,G=w;while(0);if(!E)break c;if(!l)break b;A=x[C>>0]|0;C=C+1|0;l=l+-1|0;z=A;B=V;w=G}}while(0);c=c-k|0;if(0<(l|0)&0<(c|0))B=C,w=l,d=d+k|0;else{p=C;q=l;break a}}d=a[b+628>>2]|0;a[f>>2]=a[b+444>>2];Y(d,148314,148325,f);u=e;return 0}p=n;q=l}while(0);a[h>>2]=p;a[m>>2]=q;u=e;return 1},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,
m,k,l,n,p,q,r,B,w,v,z,A,C,D,V,F,J,I,G,L,K;e=u;u=u+16|0;f=e+8|0;g=e;h=e+12|0;m=a[b+576>>2]|0;if(t[m+497>>0]|0){k=m+1212|0;a:do if((c>>>0)%((a[k>>2]|0)>>>0)|0)Y(a[b+628>>2]|0,151196,151162,f);else{0>=(c|0)&&Z(151191,148429,869,151196);a[h>>2]=d;l=m+632|0;n=c;do{if(!(Ph(m,l,h)|0))break a;p=a[k>>2]|0;a[h>>2]=(a[h>>2]|0)+p;n=n-p|0}while(0<(n|0));b=1;u=e;return b|0}while(0);u=e;return 0}f=m+1212|0;if((c>>>0)%((a[f>>2]|0)>>>0)|0)return Y(a[b+628>>2]|0,151147,151162,g),u=e,0;0>=(c|0)&&Z(151191,148429,821,
151147);g=m+632|0;b=m+1200|0;h=m+1208|0;k=m+229|0;n=m+1184|0;l=m+1152|0;p=m+1188|0;q=m+1160|0;r=m+1192|0;B=m+1204|0;w=m+1164|0;v=m+228|0;z=a[h>>2]|0;A=d;for(d=c;;){if(z)C=z;else{if(!(ok(m,g,a[b>>2]|0,x[k>>0]<<3)|0)){b=0;d=30;break}C=a[h>>2]|0}c=E(a[q>>2]|0,C)|0;if(a[B>>2]|0){z=t[k>>0]|0;D=E(z&255,C)|0;V=z;z=(a[p>>2]|0)+c|0;F=(a[r>>2]|0)+c|0;c=(a[n>>2]|0)+(E(D,a[l>>2]|0)|0)|0;D=A;for(C=0;;){J=t[v>>0]|0;if(V<<24>>24)for(I=J,G=V,L=J,J=D,K=c,D=0;;){if(L<<24>>24){G=K;for(K=0;;)if(I=G+1|0,V=J+1|0,t[J>>
0]=t[G>>0]|0,K=K+1<<24>>24,G=t[v>>0]|0,(K&255)>=(G&255)){K=I;J=V;V=G;break}else J=V,G=I;I=V;G=t[k>>0]|0}else V=0;D=D+1<<24>>24;if((D&255)>=(G&255)){D=J;break}else L=V,K=K+((a[l>>2]|0)-(V&255))|0}else I=J;t[D>>0]=t[z>>0]|0;t[D+1>>0]=t[F>>0]|0;K=C+1|0;if(K>>>0>=(a[B>>2]|0)>>>0)break;V=t[k>>0]|0;z=z+1|0;F=F+1|0;c=c+(I&255)|0;D=D+2|0;C=K}c=a[h>>2]|0}else c=C;C=c+1|0;z=(C|0)==(a[w>>2]|0)?0:C;a[h>>2]=z;C=a[f>>2]|0;d=d-C|0;if(0>=(d|0)){b=1;d=30;break}else A=A+C|0}return 30==(d|0)?(u=e,b|0):0},function(b,
d,c,e){e=u;u=u+16|0;Y(a[(b|0)+628>>2]|0,151018,151030,e);u=e;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q,r,B,w=0,v=0,z,x,C=0,A=0,E=0,D=0,J=0,I=0,G=0,L=0,K=0,F,N=0,O=0,M=0;F=0;e=u;u=u+32|0;f=e+24|0;g=e+16|0;h=e+8|0;m=e;k=b+604|0;l=a[k>>2]|0;n=b+608|0;p=a[n>>2]|0;q=b+628|0;r=0<(c|0);a:do{if(r){B=p;b:for(;;){p=l;for(l=B;;){if(0>=(l|0)){w=p;v=l;p=5;break b}B=p+1|0;z=t[p>>0]|0;x=l+-1|0;if(0<=z<<24>>24){C=B;A=z;E=x;D=p;J=l;p=12;break}if(-128==z<<24>>24)p=B,l=x;else{I=B;G=z;L=p;K=l;
p=8;break}}if(8==(p|0))l=1-(G<<24>>24)|0,(l|0)>(c|0)?(p=a[q>>2]|0,a[m>>2]=l-c,Wb(p,152115,152130,m),F=c):F=l,l=L+2|0,p=K+-2|0,0<(F|0)?(Va(d|0,t[I>>0]|0,F|0)|0,N=d+F|0):N=d,O=l,M=p;else if(12==(p|0)){p=A<<24>>24;(c|0)<(p+1|0)?(l=a[q>>2]|0,a[h>>2]=1-c+p,Wb(l,152115,152130,h),O=c+-1|0):O=p;p=O+1|0;if((J|0)<=(p|0)){p=17;break}Ab(d,C,p);N=d+p|0;O=D+(O+2)|0;M=E-p|0;F=p}c=c-F|0;if(p=0<(c|0))d=N,r=p,l=O,B=M;else{B=O;z=M;break a}}if(5==(p|0))a[k>>2]=w,a[n>>2]=v;else if(17==(p|0)&&(Wb(a[q>>2]|0,152115,152175,
g),a[k>>2]=C,a[n>>2]=E,!r))return b=1,u=e,b|0;B=a[q>>2]|0;a[f>>2]=a[b+444>>2];Y(B,152115,152223,f);b=0;u=e;return b|0}B=l;z=p}while(0);a[k>>2]=B;a[n>>2]=z;u=e;return 1},Qh,function(b,d,c,e){b|=0;c|=0;e|=0;var f,g;f=a[a[b+576>>2]>>2]|0;if(0<(c|0))d|=0,g=c;else return 1;for(;;){c=(g|0)<(f|0)?g:f;if(0>(Qh(b,d,c,e)|0)){b=-1;c=4;break}g=g-c|0;if(0>=(g|0)){b=1;c=4;break}else d=d+c|0}return 4==(c|0)?b|0:0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f=0,g=0,h=0,m=0,k=0,l=0,n=0,p=0,q=0,r=0,B=0,v=0,x=0,z=0,
A=0,C=0,D=0,V=0,F=0,J=0,I=0,G=0,L=0,K=0,R=0,S=0,O=0,M=0,T=0,X=0,P=0,U=0,da=0,aa=0,ba=0,ca=0,fa=0,ja=0,ga=0,pa=0,ma=0,ra=0,ha=0,ya=0,Aa=0,Ka=0,Qa=0,Va=0,Wa=0,oa=0,sa=0,ab=0,ua=0,Ia=0,Da=0,na=0,Na=0,db=0,Ca=0,Ga=0,Ea=0,La=0,eb=0,fb=0,lb=0,pb=0,rb=0,ub=0,Ab=0,jb=0,Gb=0,Hb=0,Ta=0,Ya=0,Sa=0,mb=0,Db=0,Kb=0,Za=0,ia=0,qa=0,Ja=0,ea=0,wa=0,Ma=0,xa=0,$a=0,la=0,Ba=0,va=0,za=0,ta=0,nb=0,Lb=0,gb=0,hb=0,ob=0,Bb=0,qb=0,kb=0,ib=0,Cb=0,Pb=0,sb=0,Xa=0,Fa=0,Pa=0,Eb=0,vb=0,tb=0,bb=0,Ib=0,Mb=0,Qb=0,Ua=0;e=u;u=u+48|0;f=
e+40|0;g=e+32|0;h=e+24|0;m=e+16|0;k=e+8|0;l=e;n=a[b+576>>2]|0;p=n+132|0;switch(a[p>>2]|0){case 5:q=c>>>2;break;case 2:case 3:case 4:q=c>>>1;break;case 1:case 0:q=c;break;default:return c=a[b+628>>2]|0,a[l>>2]=N[b+84>>1],Y(c,152640,152446,l),r=0,u=e,r|0}l=n+124|0;c=E(N[l>>1]|0,a[b+56>>2]|0)|0;n||Z(154187,152287,772,152640);B=n+120|0;v=n+64|0;a[n+76>>2]=a[B>>2];x=n+80|0;a[x>>2]=q<<1;z=b+628|0;A=b+444|0;C=n+88|0;a:do switch(Ji(v,1)|0){case 1:D=12;break a;case -3:V=a[z>>2]|0;F=a[C>>2]|0;a[k>>2]=a[A>>
2];a[k+4>>2]=F;Y(V,152640,154366,k);if(ng(v)|0){r=0;D=103;break a}break;case 0:break;default:D=10;break a}while(0!=(a[x>>2]|0));if(10==(D|0))return v=a[z>>2]|0,a[m>>2]=a[C>>2],Y(v,152640,154272,m),r=0,u=e,r|0;if(12==(D|0)){if(m=a[x>>2]|0)return x=a[z>>2]|0,a[h>>2]=a[A>>2],a[h+4>>2]=m,Y(x,152640,154401,h),r=0,u=e,r|0}else if(103==(D|0))return u=e,r|0;h=a[B>>2]|0;a[b+12>>2]&128&&Vd(h,q);(B=(q|0)%(c|0)|0)?(x=a[z>>2]|0,a[g>>2]=c,a[g+4>>2]=q,Wb(x,152640,152655,g),J=q-B|0):J=q;if(0>=(J|0))return r=1,u=
e,r|0;B=n+148|0;q=c<<2;g=3<(c|0);x=4<(c|0);m=n+152|0;A=c<<1;v=n+156|0;n=d;d=0;C=h;a:for(;;){switch(a[p>>2]|0){case 5:h=w[l>>1]|0;k=h&65535;V=a[B>>2]|0;b:do if((c|0)>=(k|0))switch(k|0){case 3:F=(N[C>>1]|0)&2047;I=(N[C+2>>1]|0)&2047;G=a[V+(I<<2)>>2]|0;L=(N[C+4>>1]|0)&2047;K=a[V+(L<<2)>>2]|0;a[n>>2]=a[V+(F<<2)>>2];a[n+4>>2]=G;a[n+8>>2]=K;if(g)R=c,S=C,O=n,M=L,T=I,X=F;else break b;do R=R+-3|0,F=S,S=S+6|0,I=O,O=O+12|0,X=(N[S>>1]|0)+X|0,T=(N[F+8>>1]|0)+T|0,L=a[V+((T&2047)<<2)>>2]|0,M=(N[F+10>>1]|0)+M|0,
F=a[V+((M&2047)<<2)>>2]|0,a[O>>2]=a[V+((X&2047)<<2)>>2],a[I+16>>2]=L,a[I+20>>2]=F;while(3<(R|0));break;case 4:F=(N[C>>1]|0)&2047;I=(N[C+2>>1]|0)&2047;L=a[V+(I<<2)>>2]|0;K=(N[C+4>>1]|0)&2047;G=a[V+(K<<2)>>2]|0;P=(N[C+6>>1]|0)&2047;U=a[V+(P<<2)>>2]|0;a[n>>2]=a[V+(F<<2)>>2];a[n+4>>2]=L;a[n+8>>2]=G;a[n+12>>2]=U;if(x)da=c,aa=C,ba=n,ca=P,fa=K,ja=I,ga=F;else break b;do da=da+-4|0,F=aa,aa=aa+8|0,I=ba,ba=ba+16|0,ga=(N[aa>>1]|0)+ga|0,ja=(N[F+10>>1]|0)+ja|0,K=a[V+((ja&2047)<<2)>>2]|0,fa=(N[F+12>>1]|0)+fa|0,
P=a[V+((fa&2047)<<2)>>2]|0,ca=(N[F+14>>1]|0)+ca|0,F=a[V+((ca&2047)<<2)>>2]|0,a[ba>>2]=a[V+((ga&2047)<<2)>>2],a[I+20>>2]=K,a[I+24>>2]=P,a[I+28>>2]=F;while(4<(da|0));break;default:F=~k;I=k+2|0;P=C;K=n;for(U=k;;)if(a[K>>2]=a[V+(((N[P>>1]|0)&2047)<<2)>>2],1<(U|0))P=P+2|0,K=K+4|0,U=U+-1|0;else break;U=I+(0==h<<16>>16?F:-2)|0;K=c-k|0;if(0<(K|0))pa=K,ma=n,ra=C;else break b;do{ma=ma+(U<<2)|0;K=ra=ra+(U<<1)|0;P=ma;for(G=k;;)if(L=K+(k<<1)|0,w[L>>1]=(N[L>>1]|0)+(N[K>>1]|0),a[P>>2]=a[V+(((N[K>>1]|0)&2047)<<2)>>
2],1<(G|0))K=K+2|0,P=P+4|0,G=G+-1|0;else break;pa=pa-k|0}while(0<(pa|0))}while(0);ha=n+q|0;break;case 4:k=w[l>>1]|0;V=k&65535;h=a[m>>2]|0;b:do if((c|0)>=(V|0))switch(V|0){case 3:U=(N[C>>1]|0)&2047;w[n>>1]=w[h+(U<<1)>>1]|0;F=(N[C+2>>1]|0)&2047;w[n+2>>1]=w[h+(F<<1)>>1]|0;I=(N[C+4>>1]|0)&2047;w[n+4>>1]=w[h+(I<<1)>>1]|0;if(g)ya=c,Aa=C,Ka=n,Qa=I,Va=F,Wa=U;else break b;do ya=ya+-3|0,U=Aa,Aa=Aa+6|0,F=Ka,Ka=Ka+6|0,Wa=(N[Aa>>1]|0)+Wa|0,w[Ka>>1]=w[h+((Wa&2047)<<1)>>1]|0,Va=(N[U+8>>1]|0)+Va|0,w[F+8>>1]=w[h+
((Va&2047)<<1)>>1]|0,Qa=(N[U+10>>1]|0)+Qa|0,w[F+10>>1]=w[h+((Qa&2047)<<1)>>1]|0;while(3<(ya|0));break;case 4:F=(N[C>>1]|0)&2047;w[n>>1]=w[h+(F<<1)>>1]|0;U=(N[C+2>>1]|0)&2047;w[n+2>>1]=w[h+(U<<1)>>1]|0;I=(N[C+4>>1]|0)&2047;w[n+4>>1]=w[h+(I<<1)>>1]|0;G=(N[C+6>>1]|0)&2047;w[n+6>>1]=w[h+(G<<1)>>1]|0;if(x)oa=c,sa=C,ab=n,ua=G,Ia=I,Da=U,na=F;else break b;do oa=oa+-4|0,F=sa,sa=sa+8|0,U=ab,ab=ab+8|0,na=(N[sa>>1]|0)+na|0,w[ab>>1]=w[h+((na&2047)<<1)>>1]|0,Da=(N[F+10>>1]|0)+Da|0,w[U+10>>1]=w[h+((Da&2047)<<1)>>
1]|0,Ia=(N[F+12>>1]|0)+Ia|0,w[U+12>>1]=w[h+((Ia&2047)<<1)>>1]|0,ua=(N[F+14>>1]|0)+ua|0,w[U+14>>1]=w[h+((ua&2047)<<1)>>1]|0;while(4<(oa|0));break;default:U=~V;F=V+2|0;I=C;G=n;for(P=V;;)if(w[G>>1]=w[h+(((N[I>>1]|0)&2047)<<1)>>1]|0,1<(P|0))I=I+2|0,G=G+2|0,P=P+-1|0;else break;P=F+(0==k<<16>>16?U:-2)|0;G=c-V|0;if(0<(G|0))Na=G,db=n,Ca=C;else break b;do{db=db+(P<<1)|0;G=Ca=Ca+(P<<1)|0;I=db;for(K=V;;)if(L=G+(V<<1)|0,w[L>>1]=(N[L>>1]|0)+(N[G>>1]|0),w[I>>1]=w[h+(((N[G>>1]|0)&2047)<<1)>>1]|0,1<(K|0))G=G+2|0,
I=I+2|0,K=K+-1|0;else break;Na=Na-V|0}while(0<(Na|0))}while(0);ha=n+A|0;break;case 3:V=w[l>>1]|0;h=V&65535;k=a[B>>2]|0;b:do if((c|0)>=(h|0))switch(h|0){case 3:P=(N[C>>1]|0)&2047;Ga=2048*+W[k+(P<<2)>>2];U=(N[C+2>>1]|0)&2047;Ea=2048*+W[k+(U<<2)>>2];F=(N[C+4>>1]|0)&2047;La=2048*+W[k+(F<<2)>>2];w[n>>1]=3071>Ga?~~Ga&65535:3071;w[n+2>>1]=3071>Ea?~~Ea&65535:3071;w[n+4>>1]=3071>La?~~La&65535:3071;if(g)eb=c,fb=C,lb=n,pb=F,rb=U,ub=P;else break b;do eb=eb+-3|0,P=fb,fb=fb+6|0,U=lb,lb=lb+6|0,ub=(N[fb>>1]|0)+ub|
0,La=2048*+W[k+((ub&2047)<<2)>>2],rb=(N[P+8>>1]|0)+rb|0,Ea=2048*+W[k+((rb&2047)<<2)>>2],pb=(N[P+10>>1]|0)+pb|0,Ga=2048*+W[k+((pb&2047)<<2)>>2],w[lb>>1]=3071>La?~~La&65535:3071,w[U+8>>1]=3071>Ea?~~Ea&65535:3071,w[U+10>>1]=3071>Ga?~~Ga&65535:3071;while(3<(eb|0));break;case 4:U=(N[C>>1]|0)&2047;Ga=2048*+W[k+(U<<2)>>2];P=(N[C+2>>1]|0)&2047;Ea=2048*+W[k+(P<<2)>>2];F=(N[C+4>>1]|0)&2047;La=2048*+W[k+(F<<2)>>2];K=(N[C+6>>1]|0)&2047;Ab=2048*+W[k+(K<<2)>>2];w[n>>1]=3071>Ga?~~Ga&65535:3071;w[n+2>>1]=3071>Ea?
~~Ea&65535:3071;w[n+4>>1]=3071>La?~~La&65535:3071;w[n+6>>1]=3071>Ab?~~Ab&65535:3071;if(x)jb=c,Gb=C,Hb=n,Ta=K,Ya=F,Sa=P,mb=U;else break b;do jb=jb+-4|0,U=Gb,Gb=Gb+8|0,P=Hb,Hb=Hb+8|0,mb=(N[Gb>>1]|0)+mb|0,Ab=2048*+W[k+((mb&2047)<<2)>>2],Sa=(N[U+10>>1]|0)+Sa|0,La=2048*+W[k+((Sa&2047)<<2)>>2],Ya=(N[U+12>>1]|0)+Ya|0,Ea=2048*+W[k+((Ya&2047)<<2)>>2],Ta=(N[U+14>>1]|0)+Ta|0,Ga=2048*+W[k+((Ta&2047)<<2)>>2],w[Hb>>1]=3071>Ab?~~Ab&65535:3071,w[P+10>>1]=3071>La?~~La&65535:3071,w[P+12>>1]=3071>Ea?~~Ea&65535:3071,
w[P+14>>1]=3071>Ga?~~Ga&65535:3071;while(4<(jb|0));break;default:P=~h;U=h+2|0;F=C;K=n;for(I=h;;)if(Ga=2048*+W[k+(((N[F>>1]|0)&2047)<<2)>>2],w[K>>1]=3071>Ga?~~Ga&65535:3071,1<(I|0))F=F+2|0,K=K+2|0,I=I+-1|0;else break;I=U+(0==V<<16>>16?P:-2)|0;K=c-h|0;if(0<(K|0))Db=K,Kb=n,Za=C;else break b;do{Kb=Kb+(I<<1)|0;K=Za=Za+(I<<1)|0;F=Kb;for(G=h;;)if(L=K+(h<<1)|0,ia=(N[L>>1]|0)+(N[K>>1]|0)|0,w[L>>1]=ia,Ga=2048*+W[k+((ia&2047)<<2)>>2],w[F>>1]=3071>Ga?~~Ga&65535:3071,1<(G|0))K=K+2|0,F=F+2|0,G=G+-1|0;else break;
Db=Db-h|0}while(0<(Db|0))}while(0);ha=n+A|0;break;case 2:h=w[l>>1]|0;k=h&65535;b:do if((c|0)>=(k|0))switch(k|0){case 3:V=w[C>>1]|0;w[n>>1]=V;I=w[C+2>>1]|0;w[n+2>>1]=I;P=w[C+4>>1]|0;w[n+4>>1]=P;if(!g)break b;U=n;G=C;F=c;K=P&65535;P=I&65535;I=V&65535;do F=F+-3|0,V=G,G=G+6|0,ia=U,U=U+6|0,I=(N[G>>1]|0)+I|0,w[U>>1]=I&2047,P=(N[V+8>>1]|0)+P|0,w[ia+8>>1]=P&2047,K=(N[V+10>>1]|0)+K|0,w[ia+10>>1]=K&2047;while(3<(F|0));break;case 4:F=w[C>>1]|0;w[n>>1]=F;K=w[C+2>>1]|0;w[n+2>>1]=K;P=w[C+4>>1]|0;w[n+4>>1]=P;I=
w[C+6>>1]|0;w[n+6>>1]=I;if(!x)break b;U=n;G=C;ia=c;V=I&65535;I=P&65535;P=K&65535;K=F&65535;do ia=ia+-4|0,F=G,G=G+8|0,L=U,U=U+8|0,K=(N[G>>1]|0)+K|0,w[U>>1]=K&2047,P=(N[F+10>>1]|0)+P|0,w[L+10>>1]=P&2047,I=(N[F+12>>1]|0)+I|0,w[L+12>>1]=I&2047,V=(N[F+14>>1]|0)+V|0,w[L+14>>1]=V&2047;while(4<(ia|0));break;default:ia=~k;V=k+2|0;I=C;P=n;for(K=k;;)if(w[P>>1]=(N[I>>1]|0)&2047,1<(K|0))I=I+2|0,P=P+2|0,K=K+-1|0;else break;K=V+(0==h<<16>>16?ia:-2)|0;P=c-k|0;if(0<(P|0))qa=P,Ja=n,ea=C;else break b;do{Ja=Ja+(K<<1)|
0;P=ea=ea+(K<<1)|0;I=Ja;for(U=k;;)if(G=P+(k<<1)|0,w[G>>1]=(N[G>>1]|0)+(N[P>>1]|0),w[I>>1]=(N[P>>1]|0)&2047,1<(U|0))P=P+2|0,I=I+2|0,U=U+-1|0;else break;qa=qa-k|0}while(0<(qa|0))}while(0);ha=n+A|0;break;case 0:k=w[l>>1]|0;h=k&65535;K=a[v>>2]|0;b:do if((c|0)>=(h|0))switch(h|0){case 3:ia=(N[C>>1]|0)&2047;t[n>>0]=t[K+ia>>0]|0;V=(N[C+2>>1]|0)&2047;t[n+1>>0]=t[K+V>>0]|0;U=(N[C+4>>1]|0)&2047;t[n+2>>0]=t[K+U>>0]|0;if(g)wa=c,Ma=C,xa=n,$a=U,la=V,Ba=ia;else break b;do wa=wa+-3|0,ia=Ma,Ma=Ma+6|0,V=xa,xa=xa+3|
0,Ba=(N[Ma>>1]|0)+Ba|0,t[xa>>0]=t[K+(Ba&2047)>>0]|0,la=(N[ia+8>>1]|0)+la|0,t[V+4>>0]=t[K+(la&2047)>>0]|0,$a=(N[ia+10>>1]|0)+$a|0,t[V+5>>0]=t[K+($a&2047)>>0]|0;while(3<(wa|0));break;case 4:V=(N[C>>1]|0)&2047;t[n>>0]=t[K+V>>0]|0;ia=(N[C+2>>1]|0)&2047;t[n+1>>0]=t[K+ia>>0]|0;U=(N[C+4>>1]|0)&2047;t[n+2>>0]=t[K+U>>0]|0;I=(N[C+6>>1]|0)&2047;t[n+3>>0]=t[K+I>>0]|0;if(x)va=c,za=C,ta=n,nb=I,Lb=U,gb=ia,hb=V;else break b;do va=va+-4|0,V=za,za=za+8|0,ia=ta,ta=ta+4|0,hb=(N[za>>1]|0)+hb|0,t[ta>>0]=t[K+(hb&2047)>>
0]|0,gb=(N[V+10>>1]|0)+gb|0,t[ia+5>>0]=t[K+(gb&2047)>>0]|0,Lb=(N[V+12>>1]|0)+Lb|0,t[ia+6>>0]=t[K+(Lb&2047)>>0]|0,nb=(N[V+14>>1]|0)+nb|0,t[ia+7>>0]=t[K+(nb&2047)>>0]|0;while(4<(va|0));break;default:ia=~h;V=h+2|0;U=C;I=n;for(P=h;;)if(t[I>>0]=t[K+((N[U>>1]|0)&2047)>>0]|0,1<(P|0))U=U+2|0,I=I+1|0,P=P+-1|0;else break;P=V+(0==k<<16>>16?ia:-2)|0;I=c-h|0;if(0<(I|0))ob=I,Bb=n,qb=C;else break b;do{Bb=Bb+P|0;I=qb=qb+(P<<1)|0;U=Bb;for(G=h;;)if(L=I+(h<<1)|0,w[L>>1]=(N[L>>1]|0)+(N[I>>1]|0),t[U>>0]=t[K+((N[I>>1]|
0)&2047)>>0]|0,1<(G|0))I=I+2|0,U=U+1|0,G=G+-1|0;else break;ob=ob-h|0}while(0<(ob|0))}while(0);ha=n+c|0;break;case 1:h=w[l>>1]|0;K=h&65535;k=a[v>>2]|0;b:do if((c|0)>=(K|0))switch(K|0){case 3:t[n>>0]=0;P=(N[C+4>>1]|0)&2047;ia=(N[C+2>>1]|0)&2047;V=t[k+ia>>0]|0;G=(N[C>>1]|0)&2047;U=t[k+G>>0]|0;t[n+1>>0]=t[k+P>>0]|0;t[n+2>>0]=V;t[n+3>>0]=U;if(g)kb=c,ib=C,Cb=n,Pb=P,sb=ia,Xa=G;else break b;do kb=kb+-3|0,G=ib,ib=ib+6|0,ia=Cb,Cb=Cb+4|0,t[Cb>>0]=0,Pb=(N[G+10>>1]|0)+Pb|0,sb=(N[G+8>>1]|0)+sb|0,G=t[k+(sb&2047)>>
0]|0,Xa=(N[ib>>1]|0)+Xa|0,P=t[k+(Xa&2047)>>0]|0,t[ia+5>>0]=t[k+(Pb&2047)>>0]|0,t[ia+6>>0]=G,t[ia+7>>0]=P;while(3<(kb|0));break;case 4:P=(N[C+6>>1]|0)&2047;ia=(N[C+4>>1]|0)&2047;G=t[k+ia>>0]|0;U=(N[C+2>>1]|0)&2047;V=t[k+U>>0]|0;I=(N[C>>1]|0)&2047;L=t[k+I>>0]|0;t[n>>0]=t[k+P>>0]|0;t[n+1>>0]=G;t[n+2>>0]=V;t[n+3>>0]=L;if(x)Fa=c,Pa=C,Eb=n,vb=P,tb=ia,bb=U,Ib=I;else break b;do Fa=Fa+-4|0,I=Pa,Pa=Pa+8|0,U=Eb,Eb=Eb+4|0,vb=(N[I+14>>1]|0)+vb|0,tb=(N[I+12>>1]|0)+tb|0,ia=t[k+(tb&2047)>>0]|0,bb=(N[I+10>>1]|0)+
bb|0,I=t[k+(bb&2047)>>0]|0,Ib=(N[Pa>>1]|0)+Ib|0,P=t[k+(Ib&2047)>>0]|0,t[Eb>>0]=t[k+(vb&2047)>>0]|0,t[U+5>>0]=ia,t[U+6>>0]=I,t[U+7>>0]=P;while(4<(Fa|0));break;default:P=~K;U=K+2|0;I=C;ia=n;for(L=K;;)if(t[ia>>0]=t[k+((N[I>>1]|0)&2047)>>0]|0,1<(L|0))I=I+2|0,ia=ia+1|0,L=L+-1|0;else break;L=U+(0==h<<16>>16?P:-2)|0;ia=c-K|0;if(0<(ia|0))Mb=ia,Qb=n,Ua=C;else break b;do{Qb=Qb+L|0;ia=Ua=Ua+(L<<1)|0;I=Qb;for(V=K;;)if(G=ia+(K<<1)|0,w[G>>1]=(N[G>>1]|0)+(N[ia>>1]|0),t[I>>0]=t[k+((N[ia>>1]|0)&2047)>>0]|0,1<(V|0))ia=
ia+2|0,I=I+1|0,V=V+-1|0;else break;Mb=Mb-K|0}while(0<(Mb|0))}while(0);ha=n+c|0;break;default:break a}d=d+c|0;if((d|0)>=(J|0)){r=1;D=103;break}else n=ha,C=C+(c<<1)|0}if(103==(D|0))return u=e,r|0;D=a[z>>2]|0;a[f>>2]=N[b+84>>1];Y(D,152640,152722,f);r=0;u=e;return r|0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p=0,q,t,r,v,A,z,Q,C,D,V,F,J,I,G,L,K,R,S,O,M,T,X,P,U,da,Z,ba,aa,ca,fa,ga=0;e=u;u=u+32|0;f=e+24|0;g=e+16|0;h=e+8|0;m=e;k=a[b+576>>2]|0;l=a[k+132>>2]|0;switch(l|0){case 5:n=c>>>2;break;case 2:case 3:case 4:n=
c>>>1;break;case 1:case 0:n=c;break;default:return c=a[b+628>>2]|0,a[m>>2]=N[b+84>>1],Y(c,152431,152446,m),u=e,0}m=k+124|0;c=E(N[m>>1]|0,a[b+56>>2]|0)|0;q=k+120|0;a:do{if(0<(n|0)){t=a[q>>2]|0;q=k+160|0;r=c<<2;v=c+-1|0;A=3<(c|0);z=4<(c|0);Q=k+164|0;C=c<<1;D=k+168|0;V=t;F=d;d=0;J=t;b:for(;;){switch(l|0){case 5:t=w[m>>1]|0;I=t&65535;G=a[q>>2]|0;L=+W[27466];c:do if((c|0)>=(I|0))switch(I|0){case 3:K=+W[F>>2];R=0>K?0:2>K?+(N[G+(~~(L*K)<<1)>>1]|0):24.200000762939453<K?2047:+W[27464]*+Nd(+(K*+W[27465]))+
.5;S=~~R&65535;w[J>>1]=S;O=S&65535;K=+W[F+4>>2];R=0>K?0:2>K?+(N[G+(~~(L*K)<<1)>>1]|0):24.200000762939453<K?2047:+W[27464]*+Nd(+(K*+W[27465]))+.5;S=~~R&65535;w[J+2>>1]=S;M=S&65535;K=+W[F+8>>2];R=0>K?0:2>K?+(N[G+(~~(L*K)<<1)>>1]|0):24.200000762939453<K?2047:+W[27464]*+Nd(+(K*+W[27465]))+.5;S=~~R&65535;w[J+4>>1]=S;if(!A)break c;K=+W[27464];T=+W[27465];R=c;X=F;P=J;U=S&65535;S=M;da=O;do R=R+-3|0,Z=P,P=P+6|0,ba=X,X=X+12|0,aa=+W[X>>2],O=0>aa?0:2>aa?+(N[G+(~~(L*aa)<<1)>>1]|0):24.200000762939453<aa?2047:K*
+Nd(+(T*aa))+.5,ca=da,da=~~O,w[P>>1]=da-ca&2047,aa=+W[ba+16>>2],O=0>aa?0:2>aa?+(N[G+(~~(L*aa)<<1)>>1]|0):24.200000762939453<aa?2047:K*+Nd(+(T*aa))+.5,ca=S,S=~~O,w[Z+8>>1]=S-ca&2047,aa=+W[ba+20>>2],ca=0>aa?0:2>aa?+(N[G+(~~(L*aa)<<1)>>1]|0):24.200000762939453<aa?2047:K*+Nd(+(T*aa))+.5,ba=U,U=~~ca,w[Z+10>>1]=U-ba&2047;while(3<(R|0));break;case 4:T=+W[F>>2];R=0>T?0:2>T?+(N[G+(~~(L*T)<<1)>>1]|0):24.200000762939453<T?2047:+W[27464]*+Nd(+(T*+W[27465]))+.5;R=~~R&65535;w[J>>1]=R;U=R&65535;T=+W[F+4>>2];R=0>
T?0:2>T?+(N[G+(~~(L*T)<<1)>>1]|0):24.200000762939453<T?2047:+W[27464]*+Nd(+(T*+W[27465]))+.5;R=~~R&65535;w[J+2>>1]=R;S=R&65535;T=+W[F+8>>2];R=0>T?0:2>T?+(N[G+(~~(L*T)<<1)>>1]|0):24.200000762939453<T?2047:+W[27464]*+Nd(+(T*+W[27465]))+.5;R=~~R&65535;w[J+4>>1]=R;da=R&65535;T=+W[F+12>>2];R=0>T?0:2>T?+(N[G+(~~(L*T)<<1)>>1]|0):24.200000762939453<T?2047:+W[27464]*+Nd(+(T*+W[27465]))+.5;R=~~R&65535;w[J+6>>1]=R;if(!z)break c;T=+W[27464];K=+W[27465];P=c;X=F;O=J;M=R&65535;R=da;ba=S;ca=U;do P=P+-4|0,da=O,O=
O+8|0,fa=X,X=X+16|0,aa=+W[X>>2],U=0>aa?0:2>aa?+(N[G+(~~(L*aa)<<1)>>1]|0):24.200000762939453<aa?2047:T*+Nd(+(K*aa))+.5,Z=ca,ca=~~U,w[O>>1]=ca-Z&2047,aa=+W[fa+20>>2],U=0>aa?0:2>aa?+(N[G+(~~(L*aa)<<1)>>1]|0):24.200000762939453<aa?2047:T*+Nd(+(K*aa))+.5,Z=ba,ba=~~U,w[da+10>>1]=ba-Z&2047,aa=+W[fa+24>>2],U=0>aa?0:2>aa?+(N[G+(~~(L*aa)<<1)>>1]|0):24.200000762939453<aa?2047:T*+Nd(+(K*aa))+.5,Z=R,R=~~U,w[da+12>>1]=R-Z&2047,aa=+W[fa+28>>2],U=0>aa?0:2>aa?+(N[G+(~~(L*aa)<<1)>>1]|0):24.200000762939453<aa?2047:
T*+Nd(+(K*aa))+.5,fa=M,M=~~U,w[da+14>>1]=M-fa&2047;while(4<(P|0));break;default:P=F+(v<<2)|0;M=J+(v<<1)|0;R=c-I|0;K=+W[27464];if(0<(R|0))for(T=K,aa=+W[27465],ba=-2-I+(0==t<<16>>16?I+1|0:2)|0,ca=P,O=R,R=M;;){X=ca;U=R;for(S=I;!(da=S,S=S+-1|0,K=+W[X>>2],K=0>K?0:2>K?+(N[G+(~~(L*K)<<1)>>1]|0):24.200000762939453<K?2047:T*+Nd(+(aa*K))+.5,fa=~~K&65535,w[U>>1]=fa,Z=U+(I<<1)|0,w[Z>>1]=(N[Z>>1]|0)-(fa&65535)&2047,1>=(da|0));)X=X+-4|0,U=U+-2|0;U=ca+(ba<<2)|0;X=R+(ba<<1)|0;O=O-I|0;if(0>=(O|0)){R=U;ca=X;X=aa;break}else ca=
U,R=X}else R=P,ca=M,T=K,X=+W[27465];for(O=I;!(ba=O,O=O+-1|0,aa=+W[R>>2],K=0>aa?0:2>aa?+(N[G+(~~(L*aa)<<1)>>1]|0):24.200000762939453<aa?2047:T*+Nd(+(X*aa))+.5,w[ca>>1]=~~K,1>=(ba|0));)R=R+-4|0,ca=ca+-2|0}while(0);t=F+r|0;break;case 4:G=w[m>>1]|0;I=G&65535;t=a[Q>>2]|0;c:do if((c|0)>=(I|0))switch(I|0){case 3:ca=w[t+((N[F>>1]|0)>>>2<<1)>>1]|0;w[J>>1]=ca;R=w[t+((N[F+2>>1]|0)>>>2<<1)>>1]|0;w[J+2>>1]=R;O=w[t+((N[F+4>>1]|0)>>>2<<1)>>1]|0;w[J+4>>1]=O;if(!A)break c;M=c;P=F;X=J;U=O&65535;O=R&65535;R=ca&65535;
do M=M+-3|0,ca=X,X=X+6|0,S=P,P=P+6|0,da=R,R=N[t+((N[P>>1]|0)>>>2<<1)>>1]|0,w[X>>1]=R-da&2047,da=O,O=N[t+((N[S+8>>1]|0)>>>2<<1)>>1]|0,w[ca+8>>1]=O-da&2047,da=U,U=N[t+((N[S+10>>1]|0)>>>2<<1)>>1]|0,w[ca+10>>1]=U-da&2047;while(3<(M|0));break;case 4:M=w[t+((N[F>>1]|0)>>>2<<1)>>1]|0;w[J>>1]=M;U=w[t+((N[F+2>>1]|0)>>>2<<1)>>1]|0;w[J+2>>1]=U;O=w[t+((N[F+4>>1]|0)>>>2<<1)>>1]|0;w[J+4>>1]=O;R=w[t+((N[F+6>>1]|0)>>>2<<1)>>1]|0;w[J+6>>1]=R;if(!z)break c;X=c;P=F;da=J;ca=R&65535;R=O&65535;O=U&65535;U=M&65535;do X=
X+-4|0,M=da,da=da+8|0,S=P,P=P+8|0,fa=U,U=N[t+((N[P>>1]|0)>>>2<<1)>>1]|0,w[da>>1]=U-fa&2047,fa=O,O=N[t+((N[S+10>>1]|0)>>>2<<1)>>1]|0,w[M+10>>1]=O-fa&2047,fa=R,R=N[t+((N[S+12>>1]|0)>>>2<<1)>>1]|0,w[M+12>>1]=R-fa&2047,fa=ca,ca=N[t+((N[S+14>>1]|0)>>>2<<1)>>1]|0,w[M+14>>1]=ca-fa&2047;while(4<(X|0));break;default:X=F+(v<<1)|0;ca=J+(v<<1)|0;R=c-I|0;if(0<(R|0))for(O=-2-I+(0==G<<16>>16?I+1|0:2)|0,U=X,da=R,R=ca;;){P=U;fa=R;for(M=I;;)if(S=w[t+((N[P>>1]|0)>>>2<<1)>>1]|0,w[fa>>1]=S,Z=fa+(I<<1)|0,w[Z>>1]=(N[Z>>
1]|0)-(S&65535)&2047,1<(M|0))P=P+-2|0,fa=fa+-2|0,M=M+-1|0;else break;M=U+(O<<1)|0;fa=R+(O<<1)|0;da=da-I|0;if(0>=(da|0)){L=M;R=fa;ca=I;break}else U=M,R=fa}else L=X,R=ca,ca=I;for(;;)if(w[R>>1]=w[t+((N[L>>1]|0)>>>2<<1)>>1]|0,1<(ca|0))L=L+-2|0,R=R+-2|0,ca=ca+-1|0;else break}while(0);t=F+C|0;break;case 0:t=w[m>>1]|0;I=t&65535;G=a[D>>2]|0;c:do if((c|0)>=(I|0))switch(I|0){case 3:ca=w[G+((x[F>>0]|0)<<1)>>1]|0;w[J>>1]=ca;X=w[G+((x[F+1>>0]|0)<<1)>>1]|0;w[J+2>>1]=X;R=w[G+((x[F+2>>0]|0)<<1)>>1]|0;w[J+4>>1]=R;
if(!A)break c;U=c;da=F;O=J;fa=R&65535;R=X&65535;X=ca&65535;do U=U+-3|0,ca=da,da=da+3|0,M=X,X=N[G+((x[da>>0]|0)<<1)>>1]|0,P=O,O=O+6|0,w[O>>1]=X-M&2047,M=R,R=N[G+((x[ca+4>>0]|0)<<1)>>1]|0,w[P+8>>1]=R-M&2047,M=fa,fa=N[G+((x[ca+5>>0]|0)<<1)>>1]|0,w[P+10>>1]=fa-M&2047;while(3<(U|0));break;case 4:U=w[G+((x[F>>0]|0)<<1)>>1]|0;w[J>>1]=U;fa=w[G+((x[F+1>>0]|0)<<1)>>1]|0;w[J+2>>1]=fa;R=w[G+((x[F+2>>0]|0)<<1)>>1]|0;w[J+4>>1]=R;X=w[G+((x[F+3>>0]|0)<<1)>>1]|0;w[J+6>>1]=X;if(!z)break c;O=c;da=F;M=J;P=X&65535;X=
R&65535;R=fa&65535;fa=U&65535;do O=O+-4|0,U=da,da=da+4|0,ca=fa,fa=N[G+((x[da>>0]|0)<<1)>>1]|0,ba=M,M=M+8|0,w[M>>1]=fa-ca&2047,ca=R,R=N[G+((x[U+5>>0]|0)<<1)>>1]|0,w[ba+10>>1]=R-ca&2047,ca=X,X=N[G+((x[U+6>>0]|0)<<1)>>1]|0,w[ba+12>>1]=X-ca&2047,ca=P,P=N[G+((x[U+7>>0]|0)<<1)>>1]|0,w[ba+14>>1]=P-ca&2047;while(4<(O|0));break;default:O=v+I|0;P=J+(O<<1)|0;X=F+O|0;O=c-I|0;if(0<(O|0))for(R=-2-I+(0==t<<16>>16?I+1|0:2)|0,fa=X,M=O,O=P;;){da=fa;ca=O;for(ba=I;;)if(U=w[G+((x[da>>0]|0)<<1)>>1]|0,w[ca>>1]=U,S=ca+(I<<
1)|0,w[S>>1]=(N[S>>1]|0)-(U&65535)&2047,1<(ba|0))da=da+-1|0,ca=ca+-2|0,ba=ba+-1|0;else break;ba=fa+R|0;ca=O+(R<<1)|0;M=M-I|0;if(0>=(M|0)){L=ba;R=ca;ca=I;break}else fa=ba,O=ca}else L=X,R=P,ca=I;for(;;)if(w[R>>1]=w[G+((x[L>>0]|0)<<1)>>1]|0,1<(ca|0))L=L+-1|0,R=R+-2|0,ca=ca+-1|0;else break}while(0);t=F+c|0;break;default:break b}d=d+c|0;if((d|0)>=(n|0)){r=V;break a}else F=t,J=J+(c<<1)|0}J=a[b+628>>2]|0;a[h>>2]=N[b+84>>1];Y(J,152431,152446,h);p=0;u=e;return p|0}r=a[q>>2]|0}while(0);q=k+64|0;a[q>>2]=r;r=
k+68|0;a[r>>2]=n<<1;if((n&2147483647|0)!=(n|0))return Y(a[b+628>>2]|0,152431,152485,g),u=e,0;g=k+80|0;n=b+592|0;h=b+608|0;c=b+588|0;for(t=k+76|0;!(Di(q,0)|0);)if(a[g>>2]|0||(a[h>>2]=a[n>>2],Lc(b)|0,a[t>>2]=a[c>>2],a[g>>2]=a[n>>2]),!(a[r>>2]|0)){p=1;ga=146;break}if(146==(ga|0))return u=e,p|0;ga=a[b+628>>2]|0;a[f>>2]=a[k+88>>2];Y(ga,152431,154240,f);u=e;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g;(f=a[b+576>>2]|0)||Z(154187,152869,421,153533);(g=a[f+28>>2]|0)||Z(153552,152869,422,153533);
f=f+40|0;a[f>>2]|0||Z(153509,152869,423,153533);if(!(rb[g&63](b,d,c,e)|0))return 0;td[a[f>>2]&127](b,d,c);return 1},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g;(f=a[b+576>>2]|0)||Z(154187,152869,444,153448);(g=a[f+36>>2]|0)||Z(153468,152869,445,153448);if(!(rb[g&63](b,d,c,e)|0))return 0;e=a[f+8>>2]|0;0>=(e|0)&&Z(153109,152869,449,153448);(c|0)%(e|0)|0&&Z(153491,152869,450,153448);g=f+40|0;(f=a[g>>2]|0)||Z(153509,152869,451,153448);if(0>=(c|0))return 1;td[f&127](b,d,e);f=c-e|0;if(!(0<(f|0)))return 1;
do d=d+e|0,td[a[g>>2]&127](b,d,e),f=f-e|0;while(0<(f|0));return 1},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g;(f=a[b+576>>2]|0)||Z(154187,152869,614,153138);(g=a[f+24>>2]|0)||Z(153015,152869,615,153138);f=f+12|0;if(a[f>>2]|0)return td[g&127](b,d,c),rb[a[f>>2]&63](b,d,c,e)|0;Z(153157,152869,616,153138);return 0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l;f=u;u=u+16|0;g=f;(h=a[b+576>>2]|0)||Z(154187,152869,633,152995);m=h+24|0;a[m>>2]|0||Z(153015,152869,634,152995);k=h+20|0;a[k>>2]|0||
Z(153039,152869,635,152995);l=eb(c)|0;if(!l)return b=a[b+628>>2]|0,a[g>>2]=c,Y(b,152995,153062,g),u=f,0;Ec(l|0,d|0,c|0)|0;d=a[h+8>>2]|0;0>=(d|0)&&Z(153109,152869,653,152995);(c|0)%(d|0)|0&&Z(153121,152869,654,152995);if(0<(c|0))for(h=l,g=c;!(td[a[m>>2]&127](b,h,d),g=g-d|0,0>=(g|0));)h=h+d|0;d=rb[a[k>>2]&63](b,l,c,e)|0;ja(l);u=f;return d|0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h=0,m,k,l,n,p,q,r,B,w,v,z,A,C,E,D,F,J,I=0,G=0,L=0,K=0;e=u;u=u+32|0;f=e+8|0;g=b+580|0;if((c|0)%(a[g>>2]|0)|0)return Y(a[b+
628>>2]|0,153776,153793,e),u=e,0;if(0>=(c|0))return u=e,1;m=b+56|0;k=b+604|0;l=b+608|0;n=c;c=a[l>>2]|0;p=a[k>>2]|0;for(q=d;;){d=a[m>>2]|0;r=0<(d|0);a:do if(r&0<(c|0))for(B=q,w=p,p=c,r=v=0;;){z=w+1|0;w=x[w>>0]|0;c=p+-1|0;b:do switch(w&192|0){case 0:r&1?(D=x[B>>0]|0|v,t[B>>0]=D,A=B+1|0,C=D&255,E=w+-1|0,D=r+1|0):(A=B,C=v<<4|v,E=w,D=r);D=E+D|0;0<(E|0)&(D|0)<(d|0)?(F=(E+2+(2>(E|0)?~E:-3)|0)>>>1,J=F+1|0,Va(A|0,C&255|0,J|0)|0,J=A+J|0,F=E+-2-(F<<1)|0):(J=A,F=E);-1==(F|0)&&(F=J+-1|0,t[F>>0]=(x[F>>0]|0)&240,
J=F);E=J;F=C&15;break;case 64:D=w>>>4&3;2!=(D|0)?(F=(a[109904+(D<<2)>>2]|0)+v&15,J=r+1|0,r&1?(t[B>>0]=x[B>>0]|0|F,E=B+1|0):(t[B>>0]=F<<4,E=B),C=J):(E=B,F=v,C=r);D=w>>>2&3;2!=(D|0)?(J=(a[109904+(D<<2)>>2]|0)+F&15,(C|0)<(d|0)&&(F=C+1|0,C&1?(t[E>>0]=x[E>>0]|0|J,E=E+1|0):t[E>>0]=J<<4,C=F)):J=F;D=w&3;if(2!=(D|0))if(J=(a[109904+(D<<2)>>2]|0)+J&15,(C|0)<(d|0)){D=C+1|0;C&1?(t[E>>0]=x[E>>0]|0|J,E=E+1|0):t[E>>0]=J<<4;F=J;break b}else F=J,D=C;else F=J,D=C;break;case 128:J=w>>>3&7;4!=(J|0)?(D=(a[109920+(J<<2)>>
2]|0)+v&15,F=r+1|0,r&1?(t[B>>0]=x[B>>0]|0|D,C=B+1|0):(t[B>>0]=D<<4,C=B),A=D,D=F):(C=B,A=v,D=r);J=w&7;if(4!=(J|0))if(F=(a[109920+(J<<2)>>2]|0)+A&15,(D|0)<(d|0)){J=D+1|0;D&1?(t[C>>0]=x[C>>0]|0|F,E=C+1|0):(t[C>>0]=F<<4,E=C);D=J;break b}else E=C;else E=C,F=A;break;case 192:F=w&15;J=r+1|0;r&1?(t[B>>0]=x[B>>0]|0|F,E=B+1|0):(t[B>>0]=w<<4,E=B);D=J;break b;default:E=B,F=v,D=r}while(0);w=(D|0)<(d|0);if(1<(p|0)&w)B=E,w=z,p=c,v=F,r=D;else{B=w;v=c;w=D;break a}}else B=r,z=p,v=c,w=0;while(0);a[k>>2]=z;a[l>>2]=v;
if((w|0)!=(d|0)){I=d;G=B;L=w;break}r=a[g>>2]|0;n=n-r|0;if(0>=(n|0)){h=1;K=45;break}else c=v,p=z,q=q+r|0}if(45==(K|0))return u=e,h|0;K=a[b+628>>2]|0;q=a[b+444>>2]|0;a[f>>2]=G?153829:153840;a[f+4>>2]=q;q=f+8|0;a[q>>2]=L;a[q+4>>2]=(0>(L|0))<<31>>31;L=f+16|0;a[L>>2]=I;a[L+4>>2]=(0>(I|0))<<31>>31;Y(K,153849,153863,f);u=e;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q,t=0,r,w=0;e=u;u=u+32|0;f=e+16|0;g=e+8|0;h=e;(m=a[b+576>>2]|0)||Z(154187,154074,155,154324);1!=(a[m+124>>2]|0)&&Z(154334,
154074,156,154324);k=b+604|0;l=m+64|0;a[l>>2]=a[k>>2];n=b+608|0;p=m+68|0;a[p>>2]=a[n>>2];a[m+76>>2]=d;d=m+80|0;a[d>>2]=c;c=b+628|0;q=b+444|0;b=m+88|0;a:do switch(Ji(l,1)|0){case 1:t=10;break a;case -3:m=a[c>>2]|0;r=a[b>>2]|0;a[h>>2]=a[q>>2];a[h+4>>2]=0==(r|0)?155687:r;Y(m,154324,154366,h);if(ng(l)|0){w=0;t=13;break a}break;case 0:break;default:t=8;break a}while(0!=(a[d>>2]|0));if(8==(t|0))return h=a[c>>2]|0,m=a[b>>2]|0,a[g>>2]=0==(m|0)?155687:m,Y(h,154324,154272,g),u=e,0;if(10==(t|0)){if(g=a[d>>2]|
0)return d=a[c>>2]|0,a[f>>2]=a[q>>2],a[f+4>>2]=g,Y(d,154324,154401,f),u=e,0}else if(13==(t|0))return u=e,w|0;a[k>>2]=a[l>>2];a[n>>2]=a[p>>2];u=e;return 1},function(b,d,c,e){b|=0;d|=0;c|=0;var f,g,h,m,k,l,n,p=0,q=0;e=u;u=u+16|0;f=e;(g=a[b+576>>2]|0)||Z(154187,154074,261,154198);2!=(a[g+124>>2]|0)&&Z(154208,154074,262,154198);h=g+64|0;a[h>>2]=d;d=g+68|0;a[d>>2]=c;c=g+80|0;m=b+592|0;k=b+608|0;l=b+588|0;for(n=g+76|0;!(Di(h,0)|0);)if(a[c>>2]|0||(a[k>>2]=a[m>>2],Lc(b)|0,a[n>>2]=a[l>>2],a[c>>2]=a[m>>2]),
!(a[d>>2]|0)){p=1;q=11;break}if(11==(q|0))return u=e,p|0;q=a[b+628>>2]|0;b=a[g+88>>2]|0;a[f>>2]=0==(b|0)?155687:b;Y(q,154198,154240,f);u=e;return 0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p;f=a[b+4>>2]|0;g=999999984/(c>>>0)|0;g||(h=a[b>>2]|0,a[h+20>>2]=72,R[a[h>>2]&127](b));h=(g|0)<(e|0)?g:e;a[f+80>>2]=h;f=ih(b,d,e<<2)|0;if(!e)return f|0;g=~e;m=0;for(k=h;;){h=e-m|0;l=k;k=k>>>0<h>>>0?k:h;h=nk(b,d,E(k,c)|0)|0;if(k){n=m+g|0;p=~l;l=n>>>0>p>>>0?n:p;p=m;for(n=k;;)if(a[f+(p<<2)>>2]=h,n=
n+-1|0)p=p+1|0,h=h+c|0;else break;m=m+-1-l|0}if(m>>>0>=e>>>0)break}return f|0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q;f=a[b+4>>2]|0;g=c<<7;h=999999984/(g>>>0)|0;h||(m=a[b>>2]|0,a[m+20>>2]=72,R[a[m>>2]&127](b));m=(h|0)<(e|0)?h:e;a[f+80>>2]=m;f=ih(b,d,e<<2)|0;if(!e)return f|0;h=~e;k=0;for(l=m;;){m=e-k|0;n=l;l=l>>>0<m>>>0?l:m;m=nk(b,d,E(g,l)|0)|0;if(l){p=k+h|0;q=~n;n=p>>>0>q>>>0?p:q;q=k;for(p=l;;)if(a[f+(q<<2)>>2]=m,p=p+-1|0)q=q+1|0,m=m+(c<<7)|0;else break;k=k+-1-n|0}if(k>>>0>=e>>>
0)break}return f|0},Hf,Hf,Hf,Hf,Hf,Hf,Hf,Hf,Hf],dd=[Pb,function(b,d){b|=0;a[b+504>>2]=7;a[b+532>>2]=12;a[b+540>>2]=12;a[b+548>>2]=12;a[b+536>>2]=13;a[b+544>>2]=13;a[b+552>>2]=13;a[b+560>>2]=23;return 1},function(b,d){b|=0;var c;c=u;u=u+16|0;5!=(d|0)&&Z(147656,147682,1110,147692);d=eb(160)|0;if(a[b+576>>2]=d)return a[d+124>>2]=0,a[d+104>>2]=0,a[d+152>>2]=0,a[d+80>>2]=a[b+8>>2],a[b+504>>2]=25,a[b+508>>2]=26,a[b+512>>2]=31,a[b+532>>2]=35,a[b+540>>2]=35,a[b+548>>2]=35,a[b+516>>2]=27,a[b+524>>2]=32,a[b+
528>>2]=28,a[b+536>>2]=36,a[b+544>>2]=36,a[b+552>>2]=36,a[b+564>>2]=21,Ci(b)|0,u=c,1;Y(a[b+628>>2]|0,147692,147704,c);u=c;return 0},function(b,d){b|=0;a[b+532>>2]=41;a[b+540>>2]=41;a[b+548>>2]=41;a[b+524>>2]=37;a[b+528>>2]=34;a[b+536>>2]=42;a[b+544>>2]=43;a[b+552>>2]=43;return 1},function(b,d){b|=0;a[b+508>>2]=41;a[b+532>>2]=50;a[b+540>>2]=50;return 1},function(b,d){b|=0;a[b+512>>2]=33;a[b+532>>2]=38;a[b+540>>2]=38;a[b+548>>2]=38;return 1},function(b,d){b|=0;var c,e,f,g;c=u;u=u+32|0;7!=(d|0)&&Z(144620,
144647,2307,144658);if(!(qe(b,107608,4)|0))return Y(a[b+628>>2]|0,144658,144671,c),u=c,0;d=eb(936)|0;e=b+576|0;a[e>>2]=d;if(!d)return Y(a[b+628>>2]|0,144658,144711,c+8|0),u=c,0;$c(d,0,936);d=a[e>>2]|0;a[d+828>>2]=b;e=b+668|0;f=b+672|0;a[d+892>>2]=a[f>>2];a[f>>2]=13;a[d+896>>2]=a[e>>2];a[e>>2]=14;e=b+676|0;a[d+900>>2]=a[e>>2];a[e>>2]=10;e=d+912|0;a[e>>2]=0;f=d+916|0;a[f>>2]=0;a[d+920>>2]=75;a[d+924>>2]=0;a[d+928>>2]=3;a[d+932>>2]=0;a[b+504>>2]=12;a[b+508>>2]=13;a[b+512>>2]=26;a[b+532>>2]=20;a[b+540>>
2]=20;a[b+548>>2]=20;a[b+516>>2]=14;a[b+524>>2]=27;a[b+528>>2]=15;a[b+536>>2]=21;a[b+544>>2]=21;a[b+552>>2]=21;a[b+564>>2]=4;g=b+568|0;a[d+904>>2]=a[g>>2];a[g>>2]=28;g=b+572|0;a[d+908>>2]=a[g>>2];a[g>>2]=11;g=b+12|0;a[g>>2]|=256;a[d+488>>2]=0;d=b+16|0;if(!(0==(a[d>>2]|0)&0==(a[d+4>>2]|0)))return u=c,1;a[f>>2]=2E3;f=eb(2E3)|0;if(a[e>>2]=f)return $c(f,0,2E3),u=c,1;Y(a[b+628>>2]|0,144658,144741,c+16|0);u=c;return 0},function(b,d){b|=0;var c,e,f;c=u;u=u+32|0;e=c+16|0;6!=(d|0)&&Z(148403,148429,424,148441);
if(!(qe(b,109532,7)|0))return Y(a[b+628>>2]|0,148441,148455,c),u=c,0;if(d=eb(5368)|0)return $c(d,0,5368),a[d>>2]=b,t[d+224>>0]=1,t[d+228>>0]=2,t[d+229>>0]=2,a[e>>2]=2,a[e+4>>2]=2,lb(b,530,e)|0,a[b+504>>2]=29,a[b+508>>2]=30,a[b+512>>2]=34,a[b+652>>2]=29,a[b+532>>2]=39,a[b+540>>2]=39,a[b+548>>2]=39,a[b+516>>2]=31,a[b+524>>2]=35,a[b+528>>2]=32,a[b+536>>2]=40,a[b+544>>2]=40,a[b+552>>2]=40,a[b+564>>2]=22,a[b+576>>2]=d,e=b+668|0,f=b+672|0,a[d+160>>2]=a[f>>2],a[f>>2]=21,a[d+164>>2]=a[e>>2],a[e>>2]=22,e=
b+676|0,a[d+168>>2]=a[e>>2],a[e>>2]=30,e=b+12|0,a[e>>2]|=131072,u=c,1;Y(a[b+628>>2]|0,148441,148499,c+8|0);u=c;return 0},function(b,d){b|=0;var c;d=u;u=u+16|0;c=d;if(!($i(b)|0))return u=d,0;a[b+532>>2]=16;a[b+540>>2]=16;a[b+548>>2]=16;a[c>>2]=7;c=lb(b,65536,c)|0;u=d;return c|0},function(b,d){b|=0;var c;d=u;u=u+16|0;c=d;if(!($i(b)|0))return u=d,0;a[b+532>>2]=16;a[b+540>>2]=16;a[b+548>>2]=16;a[c>>2]=11;c=lb(b,65536,c)|0;u=d;return c|0},function(b,d){b|=0;var c;d=u;u=u+16|0;c=d+8|0;if(!($i(b)|0))return u=
d,1;if(qe(b,7992,1)|0)return a[c>>2]=1,c=lb(b,65536,c)|0,u=d,c|0;Y(a[b+628>>2]|0,142852,142870,d);u=d;return 0},function(b,d){b|=0;var c;d=u;u=u+16|0;c=d+8|0;if(!($i(b)|0))return u=d,0;if(qe(b,8028,1)|0)return a[b+532>>2]=14,a[b+540>>2]=14,a[b+548>>2]=14,a[b+536>>2]=15,a[b+544>>2]=15,a[b+552>>2]=15,a[b+528>>2]=8,a[c>>2]=1,c=lb(b,65536,c)|0,u=d,c|0;Y(a[b+628>>2]|0,142917,142935,d);u=d;return 0},function(b,d){b|=0;a[b+504>>2]=6;a[b+500>>2]=0;a[b+508>>2]=6;a[b+520>>2]=0;a[b+516>>2]=6;return 1},function(b,
d){b|=0;d|=0;var c,e,f;c=u;u=u+16|0;e=c+8|0;f=c;a:do{if(32946>(d|0))switch(d|0){case 8:break a}else switch(d|0){case 32946:break a}Z(154001,154074,402,154084)}while(0);if(!(qe(b,109952,1)|0))return Y(a[b+628>>2]|0,154084,154096,f),u=c,0;f=eb(136)|0;if(a[b+576>>2]=f)return e=f+96|0,d=b+672|0,a[e>>2]=0,a[e+4>>2]=0,a[e+8>>2]=0,a[e+12>>2]=0,a[f+128>>2]=a[d>>2],a[d>>2]=27,d=b+668|0,a[f+132>>2]=a[d>>2],a[d>>2]=28,a[f+120>>2]=-1,a[f+124>>2]=0,a[b+504>>2]=42,a[b+508>>2]=43,a[b+512>>2]=40,a[b+532>>2]=51,a[b+
540>>2]=51,a[b+548>>2]=51,a[b+516>>2]=44,a[b+524>>2]=41,a[b+528>>2]=45,a[b+536>>2]=52,a[b+544>>2]=52,a[b+552>>2]=52,a[b+564>>2]=29,Ci(b)|0,u=c,1;Y(a[b+628>>2]|0,154084,154139,e);u=c;return 0},function(b,d){b|=0;var c,e,f,g,h,m,k,l,n,p,q,r,B;c=u;u=u+16|0;32909!=(d|0)&&Z(152256,152287,1366,152302);if(!(qe(b,109784,2)|0))return Y(a[b+628>>2]|0,152302,152319,c),u=c,0;d=eb(172)|0;a[b+576>>2]=d;if(!d)return Y(a[b+628>>2]|0,152302,152363,c+8|0),u=c,0;$c(d,0,172);a[d+108>>2]=0;a[d+132>>2]=-1;a[b+504>>2]=
35;a[b+508>>2]=36;a[b+512>>2]=38;a[b+532>>2]=44;a[b+540>>2]=44;a[b+548>>2]=44;a[b+516>>2]=37;a[b+524>>2]=39;a[b+528>>2]=38;a[b+536>>2]=45;a[b+544>>2]=45;a[b+552>>2]=45;a[b+556>>2]=27;a[b+564>>2]=28;e=b+672|0;a[d+140>>2]=a[e>>2];a[e>>2]=23;e=b+668|0;a[d+144>>2]=a[e>>2];a[e>>2]=24;a[d+136>>2]=-1;a[d+128>>2]=0;Ci(b)|0;W[27464]=250;W[27465]=148.4131622314453;b=eb(54600)|0;e=eb(32768)|0;f=eb(512)|0;g=eb(8196)|0;h=eb(4098)|0;m=eb(2049)|0;k=0==(b|0);l=0==(e|0);n=0==(f|0);p=0==(g|0);q=0==(h|0);r=0==(m|0);
if(!(k|l|n|p|q|r)){k=0;do W[g+(k<<2)>>2]=7.326255555493672E-5*+(k|0),k=k+1|0;while(250!=(k|0));n=250;do k=.006737946999085467*+xh(+(.004*+(n|0))),W[g+(n<<2)>>2]=k,n=n+1|0;while(2048!=(n|0));a[g+8192>>2]=a[g+8188>>2];n=0;do k=+W[g+(n<<2)>>2],l=65535*k+.5,w[h+(n<<1)>>1]=65535<l?-1:~~l&65535,l=255*k+.5,t[m+n>>0]=255<l?-1:~~l&255,n=n+1|0;while(2049!=(n|0));p=q=0;do l=7.326255555493672E-5*+(q|0),n=p+1|0,p=l*l>+W[g+(p<<2)>>2]*+W[g+(n<<2)>>2]?n:p,w[b+(q<<1)>>1]=p,q=q+1|0;while(27300!=(q|0));for(B=r=0;;){l=
+(r|0)/16383;k=l*l;l=+W[g+(B<<2)>>2];for(q=B;;)if(p=q+1|0,n=l,l=+W[g+(p<<2)>>2],k>n*l)q=p;else{p=q;break}w[e+(r<<1)>>1]=p;q=r+1|0;if(16384==(q|0)){n=q=0;break}else r=q,B=p}for(;;){l=+(q|0)/255;k=l*l;l=+W[g+(n<<2)>>2];for(p=n;;)if(B=p+1|0,n=l,l=+W[g+(B<<2)>>2],k>n*l)p=B;else{k=p;break}w[f+(q<<1)>>1]=k;p=q+1|0;if(256==(p|0))break;else q=p,n=k}W[27466]=13650;a[d+148>>2]=g;a[d+152>>2]=h;a[d+156>>2]=m;a[d+160>>2]=b;a[d+164>>2]=e;a[d+168>>2]=f;u=c;return 1}k||ja(b);l||ja(e);n||ja(f);p||ja(g);q||ja(h);r||
ja(m);m=d+148|0;a[m>>2]=0;a[m+4>>2]=0;a[m+8>>2]=0;a[m+12>>2]=0;a[m+16>>2]=0;a[m+20>>2]=0;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f;c=u;u=u+16|0;e=c+8|0;34676!=(d&-2|0)&&Z(146583,146646,1634,146656);if(!(qe(b,109056,2)|0))return Y(a[b+628>>2]|0,146656,146671,c),u=c,0;f=eb(32)|0;if(a[b+576>>2]=f)return $c(f,0,32),a[f>>2]=-1,a[f+4>>2]=34677==(d|0)&1,a[f+20>>2]=15,a[b+504>>2]=22,a[b+508>>2]=23,a[b+540>>2]=25,a[b+548>>2]=26,a[b+516>>2]=24,a[b+544>>2]=27,a[b+552>>2]=28,a[b+556>>2]=19,a[b+564>>2]=
20,d=b+672|0,a[f+24>>2]=a[d>>2],a[d>>2]=19,d=b+668|0,a[f+28>>2]=a[d>>2],a[d>>2]=20,u=c,1;f=a[b+628>>2]|0;a[e>>2]=a[b>>2];Y(f,146656,146713,e);u=c;return 0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n=0,p,q,t,r,u;c=(a[b+12>>2]|0)+-5|0;e=65535>c>>>0?c:65535;c=b+116|0;f=b+108|0;g=b+92|0;h=b+44|0;for(m=b+56|0;;){k=a[c>>2]|0;if(2>k>>>0){Dh(b);l=a[c>>2]|0;if(!(l|d)){n=0;e=35;break}if(l)p=l;else{e=20;break}}else p=k;k=(a[f>>2]|0)+p|0;a[f>>2]=k;a[c>>2]=0;l=a[g>>2]|0;p=l+e|0;if(0!=(k|0)&k>>>0<p>>>0)p=k;
else{a[c>>2]=k-p;a[f>>2]=p;p=-1<(l|0)?(a[m>>2]|0)+l|0:0;zd(b,p,e,0);a[g>>2]=a[f>>2];l=a[b>>2]|0;p=a[l+28>>2]|0;jd(p);k=p+20|0;q=a[k>>2]|0;t=l+16|0;r=a[t>>2]|0;u=q>>>0>r>>>0?r:q;0!=(u|0)&&(q=l+12|0,r=p+16|0,Ec(a[q>>2]|0,a[r>>2]|0,u|0)|0,a[q>>2]=(a[q>>2]|0)+u,a[r>>2]=(a[r>>2]|0)+u,q=l+20|0,a[q>>2]=(a[q>>2]|0)+u,a[t>>2]=(a[t>>2]|0)-u,t=a[k>>2]|0,a[k>>2]=t-u,(t|0)==(u|0))&&(a[r>>2]=a[p+8>>2]);if(!(a[(a[b>>2]|0)+16>>2]|0)){n=0;e=35;break}p=a[f>>2]|0;l=a[g>>2]|0}p=p-l|0;if(!(p>>>0<((a[h>>2]|0)+-262|0)>>>
0||(k=-1<(l|0)?(a[m>>2]|0)+l|0:0,zd(b,k,p,0),a[g>>2]=a[f>>2],p=a[b>>2]|0,r=a[p+28>>2]|0,jd(r),u=r+20|0,t=a[u>>2]|0,k=p+16|0,q=a[k>>2]|0,l=t>>>0>q>>>0?q:t,0!=(l|0)&&(t=p+12|0,q=r+16|0,Ec(a[t>>2]|0,a[q>>2]|0,l|0)|0,a[t>>2]=(a[t>>2]|0)+l,a[q>>2]=(a[q>>2]|0)+l,t=p+20|0,a[t>>2]=(a[t>>2]|0)+l,a[k>>2]=(a[k>>2]|0)-l,k=a[u>>2]|0,a[u>>2]=k-l,(k|0)==(l|0))&&(a[q>>2]=a[r+8>>2]),a[(a[b>>2]|0)+16>>2]|0))){n=0;e=35;break}}if(20==(e|0)){a[b+5812>>2]=0;if(4==(d|0))return d=a[g>>2]|0,n=-1<(d|0)?(a[m>>2]|0)+d|0:0,zd(b,
n,(a[f>>2]|0)-d|0,1),a[g>>2]=a[f>>2],d=a[b>>2]|0,n=a[d+28>>2]|0,jd(n),k=n+20|0,l=a[k>>2]|0,h=d+16|0,p=a[h>>2]|0,e=l>>>0>p>>>0?p:l,0!=(e|0)&&(l=d+12|0,p=n+16|0,Ec(a[l>>2]|0,a[p>>2]|0,e|0)|0,a[l>>2]=(a[l>>2]|0)+e,a[p>>2]=(a[p>>2]|0)+e,l=d+20|0,a[l>>2]=(a[l>>2]|0)+e,a[h>>2]=(a[h>>2]|0)-e,h=a[k>>2]|0,a[k>>2]=h-e,(h|0)==(e|0))&&(a[p>>2]=a[n+8>>2]),n=0==(a[(a[b>>2]|0)+16>>2]|0)?2:3,n|0;n=a[f>>2]|0;p=a[g>>2]|0;return(n|0)>(p|0)&&(h=-1<(p|0)?(a[m>>2]|0)+p|0:0,zd(b,h,n-p|0,0),a[g>>2]=a[f>>2],f=a[b>>2]|0,g=
a[f+28>>2]|0,jd(g),p=g+20|0,n=a[p>>2]|0,h=f+16|0,m=a[h>>2]|0,e=n>>>0>m>>>0?m:n,0!=(e|0)&&(n=f+12|0,m=g+16|0,Ec(a[n>>2]|0,a[m>>2]|0,e|0)|0,a[n>>2]=(a[n>>2]|0)+e,a[m>>2]=(a[m>>2]|0)+e,n=f+20|0,a[n>>2]=(a[n>>2]|0)+e,a[h>>2]=(a[h>>2]|0)-e,h=a[p>>2]|0,a[p>>2]=h-e,(h|0)==(e|0))&&(a[m>>2]=a[g+8>>2]),!(a[(a[b>>2]|0)+16>>2]|0))?0:1}return 35==(e|0)?n|0:0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,B,u,v,z,A,C,E,D,F=0,J,I,G,L,K=0,N,R,O,M,T,X,P;c=b+116|0;e=0==(d|0);f=b+72|0;g=b+88|0;h=b+108|0;m=b+56|
0;k=b+84|0;l=b+68|0;n=b+52|0;p=b+64|0;q=b+44|0;r=b+96|0;B=b+112|0;u=b+5792|0;v=b+5796|0;z=b+5784|0;A=b+5788|0;C=b+128|0;for(E=b+92|0;;){if(262>(a[c>>2]|0)>>>0){Dh(b);D=a[c>>2]|0;if(e&262>D>>>0){F=0;J=39;break}if(!D){J=24;break}J=2>=D>>>0?9:6}else J=6;6==(J|0)&&(J=0,D=a[h>>2]|0,I=((x[(a[m>>2]|0)+(D+2)>>0]|0)^a[f>>2]<<a[g>>2])&a[k>>2],a[f>>2]=I,G=(a[l>>2]|0)+(I<<1)|0,I=w[G>>1]|0,w[(a[p>>2]|0)+((a[n>>2]&D)<<1)>>1]=I,L=I&65535,w[G>>1]=D,0!=I<<16>>16&&(D-L|0)>>>0<=((a[q>>2]|0)+-262|0)>>>0?(D=pg(b,L)|0,
K=a[r>>2]=D):J=9);9==(J|0)&&(K=a[r>>2]|0);do if(2<K>>>0){D=K+253|0;L=(a[h>>2]|0)-(a[B>>2]|0)|0;I=a[u>>2]|0;w[(a[v>>2]|0)+(I<<1)>>1]=L;a[u>>2]=I+1;t[(a[z>>2]|0)+I>>0]=D;I=b+148+((x[155385+(D&255)>>0]|256)+1<<2)|0;w[I>>1]=(w[I>>1]|0)+1<<16>>16;I=L+65535&65535;L=b+2440+((x[154873+(256>I>>>0?I:(I>>>7)+256|0)>>0]|0)<<2)|0;w[L>>1]=(w[L>>1]|0)+1<<16>>16;L=(a[u>>2]|0)==((a[A>>2]|0)+-1|0)&1;I=a[r>>2]|0;D=(a[c>>2]|0)-I|0;a[c>>2]=D;if(2<D>>>0&&I>>>0<=(a[C>>2]|0)>>>0){D=I+-1|0;a[r>>2]=D;I=a[g>>2]|0;N=a[m>>2]|
0;G=a[k>>2]|0;R=a[l>>2]|0;O=a[n>>2]|0;M=a[p>>2]|0;J=D;D=a[h>>2]|0;for(T=a[f>>2]|0;;)if(X=D+1|0,a[h>>2]=X,T=((x[N+(D+3)>>0]|0)^T<<I)&G,a[f>>2]=T,P=R+(T<<1)|0,w[M+((O&X)<<1)>>1]=w[P>>1]|0,w[P>>1]=X,J=J+-1|0,a[r>>2]=J)D=X;else{J=D;break}D=J+2|0;a[h>>2]=D}else D=(a[h>>2]|0)+I|0,a[h>>2]=D,a[r>>2]=0,G=a[m>>2]|0,N=x[G+D>>0]|0,a[f>>2]=N,a[f>>2]=((x[G+(D+1)>>0]|0)^N<<a[g>>2])&a[k>>2];J=L}else D=t[(a[m>>2]|0)+(a[h>>2]|0)>>0]|0,J=a[u>>2]|0,w[(a[v>>2]|0)+(J<<1)>>1]=0,a[u>>2]=J+1,t[(a[z>>2]|0)+J>>0]=D,J=b+148+
((D&255)<<2)|0,w[J>>1]=(w[J>>1]|0)+1<<16>>16,J=(a[u>>2]|0)==((a[A>>2]|0)+-1|0)&1,a[c>>2]=(a[c>>2]|0)+-1,D=(a[h>>2]|0)+1|0,a[h>>2]=D;while(0);if(J&&(J=a[E>>2]|0,L=-1<(J|0)?(a[m>>2]|0)+J|0:0,zd(b,L,D-J|0,0),a[E>>2]=a[h>>2],J=a[b>>2]|0,D=a[J+28>>2]|0,jd(D),O=D+20|0,M=a[O>>2]|0,T=J+16|0,R=a[T>>2]|0,G=M>>>0>R>>>0?R:M,0!=(G|0)&&(M=J+12|0,R=D+16|0,Ec(a[M>>2]|0,a[R>>2]|0,G|0)|0,a[M>>2]=(a[M>>2]|0)+G,a[R>>2]=(a[R>>2]|0)+G,M=J+20|0,a[M>>2]=(a[M>>2]|0)+G,a[T>>2]=(a[T>>2]|0)-G,T=a[O>>2]|0,a[O>>2]=T-G,(T|0)==
(G|0))&&(a[R>>2]=a[D+8>>2]),!(a[(a[b>>2]|0)+16>>2]|0))){F=0;J=39;break}}return 24==(J|0)?(D=a[h>>2]|0,a[b+5812>>2]=2>D>>>0?D:2,4==(d|0)?(d=a[E>>2]|0,e=-1<(d|0)?(a[m>>2]|0)+d|0:0,zd(b,e,D-d|0,1),a[E>>2]=a[h>>2],d=a[b>>2]|0,e=a[d+28>>2]|0,jd(e),L=e+20|0,J=a[L>>2]|0,c=d+16|0,A=a[c>>2]|0,z=J>>>0>A>>>0?A:J,0!=(z|0)&&(J=d+12|0,A=e+16|0,Ec(a[J>>2]|0,a[A>>2]|0,z|0)|0,a[J>>2]=(a[J>>2]|0)+z,a[A>>2]=(a[A>>2]|0)+z,J=d+20|0,a[J>>2]=(a[J>>2]|0)+z,a[c>>2]=(a[c>>2]|0)-z,c=a[L>>2]|0,a[L>>2]=c-z,(c|0)==(z|0))&&(a[A>>
2]=a[e+8>>2]),F=0==(a[(a[b>>2]|0)+16>>2]|0)?2:3,F|0):a[u>>2]|0&&(u=a[E>>2]|0,c=-1<(u|0)?(a[m>>2]|0)+u|0:0,zd(b,c,D-u|0,0),a[E>>2]=a[h>>2],h=a[b>>2]|0,E=a[h+28>>2]|0,jd(E),u=E+20|0,D=a[u>>2]|0,c=h+16|0,m=a[c>>2]|0,e=D>>>0>m>>>0?m:D,0!=(e|0)&&(D=h+12|0,m=E+16|0,Ec(a[D>>2]|0,a[m>>2]|0,e|0)|0,a[D>>2]=(a[D>>2]|0)+e,a[m>>2]=(a[m>>2]|0)+e,D=h+20|0,a[D>>2]=(a[D>>2]|0)+e,a[c>>2]=(a[c>>2]|0)-e,c=a[u>>2]|0,a[u>>2]=c-e,(c|0)==(e|0))&&(a[m>>2]=a[E+8>>2]),!(a[(a[b>>2]|0)+16>>2]|0))?0:1):39==(J|0)?F|0:0},function(b,
d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,B,u,v,z,A,C,D,E,F,J,I,G,L,K=0,N=0,R,O,M,T=0,X=0,P,S,U;c=b+116|0;e=0==(d|0);f=b+72|0;g=b+88|0;h=b+108|0;m=b+56|0;k=b+84|0;l=b+68|0;n=b+52|0;p=b+64|0;q=b+96|0;r=b+120|0;B=b+112|0;u=b+100|0;v=b+5792|0;z=b+5796|0;A=b+5784|0;C=b+5788|0;D=b+104|0;E=b+92|0;F=b+128|0;J=b+44|0;I=b+136|0;a:for(;;){for(G=a[c>>2]|0;;){if(262>G>>>0){Dh(b);L=a[c>>2]|0;if(e&262>L>>>0){K=0;G=55;break a}if(!L){G=38;break a}2>=L>>>0?(a[r>>2]=a[q>>2],a[u>>2]=a[B>>2],N=a[q>>2]=2,G=16):G=8}else G=
8;do if(8==(G|0))if(G=0,L=a[h>>2]|0,R=((x[(a[m>>2]|0)+(L+2)>>0]|0)^a[f>>2]<<a[g>>2])&a[k>>2],a[f>>2]=R,O=(a[l>>2]|0)+(R<<1)|0,R=w[O>>1]|0,w[(a[p>>2]|0)+((a[n>>2]&L)<<1)>>1]=R,M=R&65535,w[O>>1]=L,L=a[q>>2]|0,a[r>>2]=L,a[u>>2]=a[B>>2],a[q>>2]=2,R<<16>>16)if(L>>>0<(a[F>>2]|0)>>>0){if(((a[h>>2]|0)-M|0)>>>0<=((a[J>>2]|0)+-262|0)>>>0)if(R=pg(b,M)|0,a[q>>2]=R,6>R>>>0){if(1!=(a[I>>2]|0)){if(3!=(R|0)){N=R;G=16;break}if(4096>=((a[h>>2]|0)-(a[B>>2]|0)|0)>>>0){N=3;G=16;break}}N=a[q>>2]=2}else N=R;else N=2;G=
16}else T=L,X=2;else N=2,G=16;while(0);16==(G|0)&&(T=a[r>>2]|0,X=N);if(!(3>T>>>0|X>>>0>T>>>0)){R=T;break}if(a[D>>2]|0){if(L=t[(a[m>>2]|0)+((a[h>>2]|0)+-1)>>0]|0,R=a[v>>2]|0,w[(a[z>>2]|0)+(R<<1)>>1]=0,a[v>>2]=R+1,t[(a[A>>2]|0)+R>>0]=L,R=b+148+((L&255)<<2)|0,w[R>>1]=(w[R>>1]|0)+1<<16>>16,(a[v>>2]|0)==((a[C>>2]|0)+-1|0)&&(R=a[E>>2]|0,L=-1<(R|0)?(a[m>>2]|0)+R|0:0,zd(b,L,(a[h>>2]|0)-R|0,0),a[E>>2]=a[h>>2],R=a[b>>2]|0,L=a[R+28>>2]|0,jd(L),M=L+20|0,O=a[M>>2]|0,P=R+16|0,S=a[P>>2]|0,U=O>>>0>S>>>0?S:O,0!=(U|
0)&&(O=R+12|0,S=L+16|0,Ec(a[O>>2]|0,a[S>>2]|0,U|0)|0,a[O>>2]=(a[O>>2]|0)+U,a[S>>2]=(a[S>>2]|0)+U,O=R+20|0,a[O>>2]=(a[O>>2]|0)+U,a[P>>2]=(a[P>>2]|0)-U,P=a[M>>2]|0,a[M>>2]=P-U,(P|0)==(U|0))&&(a[S>>2]=a[L+8>>2])),a[h>>2]=(a[h>>2]|0)+1,G=(a[c>>2]|0)+-1|0,a[c>>2]=G,!(a[(a[b>>2]|0)+16>>2]|0)){K=0;G=55;break a}}else a[D>>2]=1,a[h>>2]=(a[h>>2]|0)+1,L=(a[c>>2]|0)+-1|0,G=a[c>>2]=L}G=a[h>>2]|0;L=G+-3+(a[c>>2]|0)|0;S=R+253|0;U=G+65535-(a[u>>2]|0)|0;G=a[v>>2]|0;w[(a[z>>2]|0)+(G<<1)>>1]=U;a[v>>2]=G+1;t[(a[A>>2]|
0)+G>>0]=S;G=b+148+((x[155385+(S&255)>>0]|256)+1<<2)|0;w[G>>1]=(w[G>>1]|0)+1<<16>>16;G=U+65535&65535;U=b+2440+((x[154873+(256>G>>>0?G:(G>>>7)+256|0)>>0]|0)<<2)|0;w[U>>1]=(w[U>>1]|0)+1<<16>>16;U=a[v>>2]|0;G=(a[C>>2]|0)+-1|0;S=a[r>>2]|0;a[c>>2]=1-S+(a[c>>2]|0);P=S+-2|0;a[r>>2]=P;S=a[h>>2]|0;for(M=P;;)if(P=S+1|0,a[h>>2]=P,P>>>0<=L>>>0&&(O=((x[(a[m>>2]|0)+(S+3)>>0]|0)^a[f>>2]<<a[g>>2])&a[k>>2],a[f>>2]=O,R=(a[l>>2]|0)+(O<<1)|0,w[(a[p>>2]|0)+((a[n>>2]&P)<<1)>>1]=w[R>>1]|0,w[R>>1]=P),M=M+-1|0,a[r>>2]=M)S=
P;else{L=S;break}a[D>>2]=0;a[q>>2]=2;S=L+2|0;a[h>>2]=S;if((U|0)==(G|0)&&(M=a[E>>2]|0,R=-1<(M|0)?(a[m>>2]|0)+M|0:0,zd(b,R,S-M|0,0),a[E>>2]=a[h>>2],M=a[b>>2]|0,S=a[M+28>>2]|0,jd(S),L=S+20|0,P=a[L>>2]|0,R=M+16|0,O=a[R>>2]|0,G=P>>>0>O>>>0?O:P,0!=(G|0)&&(P=M+12|0,O=S+16|0,Ec(a[P>>2]|0,a[O>>2]|0,G|0)|0,a[P>>2]=(a[P>>2]|0)+G,a[O>>2]=(a[O>>2]|0)+G,P=M+20|0,a[P>>2]=(a[P>>2]|0)+G,a[R>>2]=(a[R>>2]|0)-G,R=a[L>>2]|0,a[L>>2]=R-G,(R|0)==(G|0))&&(a[O>>2]=a[S+8>>2]),!(a[(a[b>>2]|0)+16>>2]|0))){K=0;G=55;break}}return 38==
(G|0)?(a[D>>2]|0&&(R=t[(a[m>>2]|0)+((a[h>>2]|0)+-1)>>0]|0,L=a[v>>2]|0,w[(a[z>>2]|0)+(L<<1)>>1]=0,a[v>>2]=L+1,t[(a[A>>2]|0)+L>>0]=R,L=b+148+((R&255)<<2)|0,w[L>>1]=(w[L>>1]|0)+1<<16>>16,a[D>>2]=0),D=a[h>>2]|0,a[b+5812>>2]=2>D>>>0?D:2,4==(d|0)?(d=a[E>>2]|0,c=-1<(d|0)?(a[m>>2]|0)+d|0:0,zd(b,c,D-d|0,1),a[E>>2]=a[h>>2],d=a[b>>2]|0,c=a[d+28>>2]|0,jd(c),L=c+20|0,R=a[L>>2]|0,A=d+16|0,z=a[A>>2]|0,q=R>>>0>z>>>0?z:R,0!=(q|0)&&(R=d+12|0,z=c+16|0,Ec(a[R>>2]|0,a[z>>2]|0,q|0)|0,a[R>>2]=(a[R>>2]|0)+q,a[z>>2]=(a[z>>
2]|0)+q,R=d+20|0,a[R>>2]=(a[R>>2]|0)+q,a[A>>2]=(a[A>>2]|0)-q,A=a[L>>2]|0,a[L>>2]=A-q,(A|0)==(q|0))&&(a[z>>2]=a[c+8>>2]),K=0==(a[(a[b>>2]|0)+16>>2]|0)?2:3,K|0):a[v>>2]|0&&(v=a[E>>2]|0,q=-1<(v|0)?(a[m>>2]|0)+v|0:0,zd(b,q,D-v|0,0),a[E>>2]=a[h>>2],h=a[b>>2]|0,E=a[h+28>>2]|0,jd(E),v=E+20|0,D=a[v>>2]|0,q=h+16|0,m=a[q>>2]|0,c=D>>>0>m>>>0?m:D,0!=(c|0)&&(D=h+12|0,m=E+16|0,Ec(a[D>>2]|0,a[m>>2]|0,c|0)|0,a[D>>2]=(a[D>>2]|0)+c,a[m>>2]=(a[m>>2]|0)+c,D=h+20|0,a[D>>2]=(a[D>>2]|0)+c,a[q>>2]=(a[q>>2]|0)-c,q=a[v>>2]|
0,a[v>>2]=q-c,(q|0)==(c|0))&&(a[m>>2]=a[E+8>>2]),!(a[(a[b>>2]|0)+16>>2]|0))?0:1):55==(G|0)?K|0:0},function(b,d){var c,e;c=a[(b|0)>>2]|0;b=a[(d|0)>>2]|0;d=a[c>>2]|0;e=a[b>>2]|0;return(d|0)!=(e|0)?d-e|0:(e=a[c+8>>2]|0)?(a[b+8>>2]|0)-e|0:0},function(a,d){return 1},function(b,d){b|=0;d=u;u=u+16|0;Y(a[b+628>>2]|0,a[b>>2]|0,140263,d);u=d;return 0},function(a,d){d|=0;var c;if(1<=(d|0))return d|0;d=Td(a|0)|0;a=U;c=0==(d|0)&0==(a|0);c=pf(8192,0,(c?1:d)|0,(c?0:a)|0)|0;return(0==(c|0)&0==(U|0)?1:c)|0},function(b,
d){b|=0;var c;c=E(a[b+580>>2]|0,d|0)|0;d=b+604|0;a[d>>2]=(a[d>>2]|0)+c;d=b+608|0;a[d>>2]=(a[d>>2]|0)-c;return 1},function(b,d){b|=0;var c;(d=a[b+576>>2]|0)||Z(154187,142823,152,144051);a[d+52>>2]=0;a[d+48>>2]=0;a[d+56>>2]=0;c=(0!=(2!=(w[b+94>>1]|0)&1|0)?138932:139188)|0;a[d+44>>2]=c;c=a[d+68>>2]|0;if(!c)return a[(d+92|0)>>2]=0,1;a[c>>2]=a[d+12>>2];a[c+4>>2]=0;a[(d+92|0)>>2]=0;return 1},function(b,d){b|=0;var c;(d=a[b+576>>2]|0)||Z(154187,142823,723,144024);a[d+52>>2]=8;a[d+48>>2]=0;a[d+76>>2]=0;(c=
a[d+80>>2]|0)&&$c(c,0,a[d+8>>2]|0);if(!(a[d+28>>2]&1))return a[(d+88|0)>>2]=0,a[(d+84|0)>>2]=0,a[(d+92|0)>>2]=0,1;c=+W[b+120>>2];c=150<(3==(w[b+124>>1]|0)?2.5399999618530273*c:c)?4:2;a[(d+88|0)>>2]=c;a[(d+84|0)>>2]=c+-1|0;a[(d+92|0)>>2]=0;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,t,r,v,x,z,A=0,C=0;c=u;u=u+80|0;e=c+72|0;f=c+64|0;g=c+48|0;h=c+40|0;m=c+32|0;k=c+16|0;l=b+576|0;(n=a[l>>2]|0)||Z(154187,144647,1017,145272);p=n+16|0;0==(a[p>>2]|0)&&(da[a[b+508>>2]&63](b)|0,0==(a[p>>2]|0))&&
Z(145286,144647,1024,145272);r=n|0;x=t=0;p=4;q=Hc(40)|0;a[q>>2]=0;q=Xc(r+624|0,1,q|0,p|0)|0;p=U;Wa=z=Wa=0;0!=(z|0)&0!=(pa|0)?((v=db(a[z>>2]|0,q|0,p|0)|0)||Vb(z|0,pa|0),U=pa):v=-1;for(v=1==(v|0)?U:0;;){if(v){t=0;x=6;break}Wa=0;ri(18,r|0);v=Wa;Wa=0;0!=(v|0)&0!=(pa|0)?((z=db(a[v>>2]|0,q|0,p|0)|0)||Vb(v|0,pa|0),U=pa):z=-1;if(1==(z|0))v=U;else break}6!=(x|0)&&(t=1);Gc(q|0);if(!(t|0)||1!=(fg(n,1)|0))return u=c,0;a[b+604>>2]=a[n+800>>2];a[b+608>>2]=a[n+804>>2];p=(a[b+60>>2]|0)-(a[b+444>>2]|0)|0;a[b+12>>
2]&1024?(q=a[b+68>>2]|0,p=a[b+72>>2]|0,r=tg(b)|0):(q=a[b+56>>2]|0,t=a[b+100>>2]|0,r=Pe(b)|0,p=p>>>0>t>>>0?t:p);a[n+840>>2]=r;r=b+126|0;0==d<<16>>16|2!=(w[r>>1]|0)?(t=p,x=q):(d=N[n+834>>1]|0,v=q>>>0<(0-d|0)>>>0?((q+-1+d|0)>>>0)/(d>>>0)|0:0,d=N[n+836>>1]|0,t=p>>>0<(0-d|0)>>>0?((p+-1+d|0)>>>0)/(d>>>0)|0:0,x=v);q=n+28|0;p=a[q>>2]|0;v=a[n+32>>2]|0;p>>>0<x>>>0|v>>>0<t>>>0?(d=a[b+628>>2]|0,a[c>>2]=x,a[c+4>>2]=t,a[c+8>>2]=p,a[c+12>>2]=v,Wb(d,145272,145317,c),v=a[q>>2]|0):v=p;p=a[n+32>>2]|0;if(v>>>0>x>>>0|
p>>>0>t>>>0)return q=a[b+628>>2]|0,a[k>>2]=x,a[k+4>>2]=t,a[k+8>>2]=v,a[k+12>>2]=p,Y(q,145272,145374,k),u=c,0;k=n+36|0;q=a[k>>2]|0;z=(p=1==(w[r>>1]|0))?N[b+98>>1]|0:1;if((q|0)!=(z|0))return Y(a[b+628>>2]|0,145272,145450,m),u=c,0;if((a[n+212>>2]|0)!=(N[b+84>>1]|0))return Y(a[b+628>>2]|0,145272,145480,h),u=c,0;h=n+216|0;m=a[h>>2]|0;z=a[m+8>>2]|0;a:do if(p){r=N[n+834>>1]|0;v=a[m+12>>2]|0;t=w[n+836>>1]|0;if(!((z|0)==(r|0)&(v|0)==(t&65535|0)))return x=a[b+628>>2]|0,a[g>>2]=z,a[g+4>>2]=v,a[g+8>>2]=r,a[g+
12>>2]=t&65535,Y(x,145272,145509,g),h=0,u=c,h|0;do if(1<(q|0)){for(x=1;1==(a[m+(88*x|0)+8>>2]|0)&&1==(a[m+(88*x|0)+12>>2]|0);)if(x=x+1|0,(x|0)>=(q|0)){A=37;break}if(37==(A|0))if(p)break;else{A=41;break a}Y(a[b+628>>2]|0,145272,145574,f);h=0;u=c;return h|0}while(0);6==(w[n+832>>1]|0)&&1==(a[n+924>>2]|0)?(a[n+40>>2]=3,a[n+44>>2]=2,A=45):(a[n+40>>2]=0,a[n+44>>2]=0,1==(w[n+834>>1]|0)&&1==(w[n+836>>1]|0)?A=45:(a[n+68>>2]=1,a[n+76>>2]=0,a[b+532>>2]=22,a[b+540>>2]=23,a[b+548>>2]=23,C=0))}else if(1==(z|0)&&
1==(a[m+12>>2]|0))A=41;else return Y(a[b+628>>2]|0,145272,145574,e),h=0,u=c,h|0;while(0);41==(A|0)&&(a[n+40>>2]=0,a[n+44>>2]=0,A=45);45==(A|0)&&(a[n+68>>2]=0,a[b+532>>2]=20,a[b+540>>2]=20,a[b+548>>2]=20,C=1);e=n|0;A=m=0;f=4;g=Hc(40)|0;a[g>>2]=0;g=Xc(e+624|0,1,g|0,f|0)|0;f=U;Wa=p=Wa=0;0!=(p|0)&0!=(pa|0)?((r=db(a[p>>2]|0,g|0,f|0)|0)||Vb(p|0,pa|0),U=pa):r=-1;for(r=1==(r|0)?U:0;;){if(r){m=0;A=6;break}Wa=0;si(21,e|0)|0;r=Wa;Wa=0;0!=(r|0)&0!=(pa|0)?((p=db(a[r>>2]|0,g|0,f|0)|0)||Vb(r|0,pa|0),U=pa):p=-1;
if(1==(p|0))r=U;else break}6!=(A|0)&&(m=1);Gc(g|0);b=0==(m|0);if(C|b)return u=c,b&1^1|0;b=a[k>>2]|0;k=a[l>>2]|0;a:do{if(0<(b|0)){l=0;C=a[h>>2]|0;for(A=0;;){e=a[C+8>>2]|0;m=a[C+12>>2]|0;z=eg(k,a[C+28>>2]<<3,m<<3)|0;if(!z){h=0;break}f=(E(m,e)|0)+A|0;a[k+844+(l<<2)>>2]=z;l=l+1|0;if((l|0)>=(b|0)){l=f;break a}else C=C+88|0,A=f}u=c;return h|0}l=0}while(0);a[k+888>>2]=l;a[n+884>>2]=8;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l;c=u;u=u+16|0;e=b+576|0;(f=a[e>>2]|0)||Z(154187,144647,1745,144862);
g=f+16|0;h=a[g>>2]|0;1==(h|0)?(da[a[b+516>>2]&63](b)|0,m=a[g>>2]|0):m=h;m&&Z(144876,144647,1752,144862);a[b+12>>2]&1024?(m=a[b+68>>2]|0,h=a[b+72>>2]|0,k=tg(b)|0,g=h):(m=a[b+56>>2]|0,h=(a[b+60>>2]|0)-(a[b+444>>2]|0)|0,g=a[b+100>>2]|0,k=Pe(b)|0,g=h>>>0>g>>>0?g:h);l=m;a[f+840>>2]=k;k=w[b+126>>1]|0;m=0==d<<16>>16;m|2!=k<<16>>16?h=g:(h=N[f+834>>1]|0,l=l>>>0<(0-h|0)>>>0?((l+-1+h|0)>>>0)/(h>>>0)|0:0,h=N[f+836>>1]|0,h=g>>>0<(0-h|0)>>>0?((g+-1+h|0)>>>0)/(h>>>0)|0:0);if(65535<(h|l)>>>0)return Y(a[b+628>>2]|
0,144862,144908,c),u=c,0;a[f+28>>2]=l;a[f+32>>2]=h;do if(1==k<<16>>16){a[f+36>>2]=N[b+98>>1];if(6!=(w[f+832>>1]|0)){if(uf(f,a[f+40>>2]|0)|0){g=0;break}else f=0;u=c;return f|0}l=1==(a[f+924>>2]|0)?0:1==(w[f+834>>1]|0)&&1==(w[f+836>>1]|0)?0:1;if(uf(f,3)|0)h=a[f+84>>2]|0,a[h+8>>2]=N[f+834>>1],a[h+12>>2]=N[f+836>>1],g=l;else return f=0,u=c,f|0}else{if(!(uf(f,0)|0))return f=0,u=c,f|0;h=a[f+84>>2]|0;a[h>>2]=d&65535;m|6!=(w[f+832>>1]|0)||(a[h+16>>2]=1,a[h+20>>2]=1,a[h+24>>2]=1);g=0}while(0);a[f+244>>2]=
0;a[f+256>>2]=0;if(!(mg(f,a[f+920>>2]|0)|0))return u=c,0;m=a[f+928>>2]|0;d=f+88|0;l=a[d>>2]|0;k=0==(l|0);m&1?(k||(a[l+128>>2]=1),(l=a[d+4>>2]|0)&&(a[l+128>>2]=1)):(k||(a[l+128>>2]=0),(h=a[d+4>>2]|0)&&(a[h+128>>2]=0));m&2?(m=f+120|0,(l=a[m>>2]|0)&&(a[l+276>>2]=1),l=f+136|0,(d=a[l>>2]|0)&&(a[d+276>>2]=1),(d=a[m+4>>2]|0)&&(a[d+276>>2]=1),(d=a[l+4>>2]|0)&&(a[d+276>>2]=1),a[f+216>>2]=0):a[f+216>>2]=1;d=0!=(g|0);a[f+208>>2]=d&1;a[b+536>>2]=d?24:21;a[b+544>>2]=d?24:21;a[b+552>>2]=d?24:21;m=f|0;var n,p;l=
g=0;k=4;h=Hc(40)|0;a[h>>2]=0;h=Xc(m+624|0,1,h|0,k|0)|0;k=U;Wa=n=Wa=0;0!=(n|0)&0!=(pa|0)?((p=db(a[n>>2]|0,h|0,k|0)|0)||Vb(n|0,pa|0),U=pa):p=-1;for(p=1==(p|0)?U:0;;){if(p){g=0;l=6;break}Wa=0;dk(3,m|0,0);p=Wa;Wa=0;0!=(p|0)&0!=(pa|0)?((n=db(a[p>>2]|0,h|0,k|0)|0)||Vb(p|0,pa|0),U=pa):n=-1;if(1==(n|0))p=U;else break}6!=(l|0)&&(g=1);Gc(h|0);if(!(g|0))return u=c,0;if(d){d=a[f+76>>2]|0;b=a[e>>2]|0;a:do{if(0<(d|0)){e=0;g=a[f+84>>2]|0;for(l=0;;){m=a[g+8>>2]|0;k=a[g+12>>2]|0;h=eg(b,a[g+28>>2]<<3,k<<3)|0;if(!h){f=
0;break}l=(E(k,m)|0)+l|0;a[b+844+(e<<2)>>2]=h;e=e+1|0;if((e|0)>=(d|0)){e=l;break a}else g=g+88|0}u=c;return f|0}e=0}while(0);a[b+888>>2]=e}a[f+884>>2]=0;u=c;return 1},function(b,d){b|=0;var c;c=dd[a[(a[b+576>>2]|0)+904>>2]&127](b,d|0)|0;if(c>>>0>=(a[b+60>>2]|0)>>>0)return c|0;d=N[b+194>>1]|0;b=d<<3;return E(c>>>0<(0-b|0)>>>0?(((c+-1+b|0)>>>0)/(b>>>0)|0)<<3:0,d)|0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,t,r=0;c=b+440|0;e=a[c>>2]|0;f=a[b>>2]|0;a[f+20>>2]=124;a[f+24>>2]=e;a[f+28>>2]=d;ub[a[f+
4>>2]&31](b,-1);f=d+1&7|208;g=d+2&7|208;h=d+7&7|208;m=d+6&7|208;d=e;a:for(;;){e=208==(d&-8|0);k=(d|0)==(f|0);l=(d|0)==(g|0);n=(d|0)==(h|0);p=(d|0)==(m|0);b:do if(192>(d|0))q=a[b>>2]|0,a[q+20>>2]=99,t=q+24|0,a[t>>2]=e?d:k?f:d,a[q+28>>2]=2,ub[a[q+4>>2]&31](b,4);else{if(!e){e=10;break a}for(q=k|l?3:n|p?2:1;;)switch(t=a[b>>2]|0,a[t+20>>2]=99,a[t+24>>2]=d,a[t+28>>2]=q,ub[a[t+4>>2]&31](b,4),q|0){case 1:e=13;break a;case 3:r=1;e=17;break a;case 2:break b}}while(0);if(!(rg(b)|0)){r=0;e=17;break}d=a[c>>2]|
0}return 10==(e|0)?(m=a[b>>2]|0,a[m+20>>2]=99,a[(m+24|0)>>2]=k?f:d,a[m+28>>2]=3,ub[a[m+4>>2]&31](b,4),1):13==(e|0)?(a[c>>2]=0,1):17==(e|0)?r|0:0},function(b,d){b|=0;d|=0;var c,e;c=a[b+20>>2]|0;200!=(c&-2|0)&&(e=a[b>>2]|0,a[e+20>>2]=21,a[e+24>>2]=c,R[a[e>>2]&127](b));e=Nh(b)|0;switch(e|0){case 1:return 1;case 2:return d&&(d=a[b>>2]|0,a[d+20>>2]=53,R[a[d>>2]&127](b)),yi(b),2;default:return e|0}},function(b,d){b|=0;var c,e,f,g,h;d=u;u=u+16|0;c=d;(e=a[b+576>>2]|0)||Z(154187,147682,267,148208);f=e+124|
0;if(g=a[f>>2]|0)h=g;else if(da[a[b+508>>2]&63](b)|0,h=a[f>>2]|0,!h)return u=d,0;g=a[b+588>>2]|0;0==(t[g>>0]|0)&&0!=(t[g+1>>0]&1)?(g=e+104|0,a[g>>2]|0?c=h:(Wb(a[b+628>>2]|0,148208,148221,c),a[b+532>>2]=37,a[b+540>>2]=37,a[b+548>>2]=37,da[a[b+508>>2]&63](b)|0,a[g>>2]=37,c=a[f>>2]|0),w[e+66>>1]=511,g=c):(w[e+66>>1]=510,a[e+104>>2]=35,g=h);w[e+64>>1]=9;a[e+76>>2]=0;a[e+72>>2]=0;a[e+88>>2]=0;h=e+84|0;a[h>>2]=511;c=a[b+608>>2]|0;b=Oc(c|0,(0>(c|0))<<31>>31|0,3)|0;c=e+96|0;a[c>>2]=b;a[c+4>>2]=U;c=g+2064|
0;a[e+116>>2]=c;$c(c,0,38888);c=a[f>>2]|0;a[e+112>>2]=c+-8;a[e+120>>2]=c+((a[h>>2]|0)+-1<<3);u=d;return 1},function(b,d){b|=0;var c,e;(d=a[b+576>>2]|0)||Z(154187,147682,807,147815);c=d+152|0;(e=a[c>>2]|0)?c=e:(da[a[b+516>>2]&63](b)|0,c=a[c>>2]|0);w[d+64>>1]=9;w[d+66>>1]=511;w[d+68>>1]=258;a[d+76>>2]=0;a[d+72>>2]=0;a[d+132>>2]=1E4;a[d+136>>2]=0;a[d+140>>2]=0;a[d+144>>2]=0;a[d+148>>2]=(a[b+588>>2]|0)+((a[b+592>>2]|0)+-5);b=c+72E3|0;for(e=8993;!(e=e+-8|0,a[b+-56>>2]=-1,a[b+-48>>2]=-1,a[b+-40>>2]=-1,
a[b+-32>>2]=-1,a[b+-24>>2]=-1,a[b+-16>>2]=-1,a[b+-8>>2]=-1,a[b>>2]=-1,-1>=(e|0));)b=b+-64|0;a[c>>2]=-1;a[d+128>>2]=65535;return 1},function(b,d){b|=0;var c,e,f;d=u;u=u+16|0;c=d;e=w[b+84>>1]|0;if(2==e<<16>>16)return u=d,1;f=a[b+628>>2]|0;a[c>>2]=e&65535;Y(f,148358,148372,c);u=d;return 0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,B,v,A,z,Q=0,C,D,F,R=0,J=0,I,G,L,K,S=0,W,O,M=0,T=0,X=0,P=0,da=0,aa=0;c=u;u=u+48|0;e=c+32|0;f=c+24|0;g=c+16|0;h=c+8|0;m=c;k=b+576|0;l=a[k>>2]|0;t[l+226>>0]|0||Ig(b);
do if(!(t[l+488>>0]|0)){n=a[k>>2]|0;p=n+488|0;t[p>>0]|0&&Z(151233,148429,1040,151256);q=a[b+56>>2]|0;a[n+184>>2]=q;r=a[b+60>>2]|0;a[n+188>>2]=r;a[b+12>>2]&1024?(q=a[b+72>>2]|0,z=r+-1+q|0,B=z-((z>>>0)%(q>>>0)|0)|0,v=a[b+68>>2]|0,A=q):(B=r,v=q,A=a[b+100>>2]|0);a[n+192>>2]=v;a[n+196>>2]=A;a[n+200>>2]=B;a:do switch(w[b+98>>1]|0){case 1:t[n+204>>0]=1;t[n+205>>0]=0;t[n+206>>0]=1;t[n+228>>0]=1;t[n+229>>0]=1;break;case 3:t[n+204>>0]=3;t[n+205>>0]=0;q=n+206|0;t[q>>0]=1==(w[b+126>>1]|0)?3:1;break a;default:return q=
a[b+628>>2]|0,a[m>>2]=x[n+204>>0],Y(q,151256,151276,m),Q=0,u=c,Q|0}while(0);if(A>>>0<r>>>0){q=x[n+229>>0]<<3;if((A>>>0)%(q>>>0)|0)return Y(a[b+628>>2]|0,151256,151337,h),Q=0,u=c,Q|0;z=x[n+228>>0]<<3;C=(E((A>>>0)/(q>>>0)|0,((v+-1+z|0)>>>0)/(z>>>0)|0)|0)&65535;w[n+360>>1]=C}if(Xg(b)|0)t[n+392>>0]=1,a[n+396>>2]=a[n+1220>>2],a[n+400>>2]=a[n+1224>>2],r=n+1232|0,C=N[n+1256>>1]|0,z=Ic(a[r>>2]|0,a[r+4>>2]|0,C|0,0)|0,r=n+408|0,a[r>>2]=z,a[r+4>>2]=U,r=n+1248|0,z=Qb(C|0,0,a[r>>2]|0,a[r+4>>2]|0)|0,r=n+416|0,
a[r>>2]=z,a[r+4>>2]=U,t[p>>0]=1;else return Q=0,u=c,Q|0}while(0);h=d&65535;a:do if(!(t[l+392+(h<<5)>>0]|0)){v=a[k>>2]|0;d<<16>>16||Z(151399,148429,1102,151403);3<=(d&65535)&&Z(151425,148429,1103,151403);t[v+392>>0]|0||Z(151429,148429,1104,151403);t[v+392+(h<<5)>>0]|0&&Z(151451,148429,1105,151403);for(A=h+255&255;;)if(m=A&255,t[v+392+(m<<5)>>0]|0){D=m;F=A;break}else A=A+-1<<24>>24;A=v+205|0;t[A>>0]=F;p=v+1220|0;a[p>>2]=a[v+392+(D<<5)+4>>2];n=v+1224|0;a[n>>2]=a[v+392+(D<<5)+8>>2];m=v+392+(D<<5)+16|
0;B=a[m+4>>2]|0;z=r=v+1232|0;a[z>>2]=a[m>>2];a[z+4>>2]=B;t[v+1240>>0]=0;B=v+392+(D<<5)+24|0;z=a[B+4>>2]|0;C=m=v+1248|0;a[C>>2]=a[B>>2];a[C+4>>2]=z;z=v+1256|0;w[z>>1]=0;C=v+1260|0;a[C>>2]=0;if(D>>>0<h>>>0){B=0;b:for(;;){if(B<<16>>16)J=B;else{if(!(Fc(v)|0)){Q=0;R=105;break}q=w[z>>1]|0;if(q<<16>>16)J=q;else{R=36;break}}q=a[C>>2]|0;I=t[q>>0]|0;G=q+1|0;a[C>>2]=G;q=J+-1<<16>>16;w[z>>1]=q;if(-1==I<<24>>24){L=q;K=G;c:for(;;){if(L<<16>>16)S=K,W=L;else{if(!(Fc(v)|0)){Q=0;R=105;break b}q=w[z>>1]|0;if(!(q<<16>>
16)){R=42;break b}S=a[C>>2]|0;W=q}q=t[S>>0]|0;G=S+1|0;a[C>>2]=G;I=W+-1<<16>>16;w[z>>1]=I;switch(q<<24>>24){case -1:L=I;K=G;break;case -38:break c;default:B=I;continue b}}t[A>>0]=(t[A>>0]|0)+1<<24>>24;if(!(Oh(b)|0)){Q=0;R=105;break}I=x[A>>0]|0;t[v+392+(I<<5)>>0]=1;a[v+392+(I<<5)+4>>2]=a[p>>2];a[v+392+(I<<5)+8>>2]=a[n>>2];G=r;B=w[z>>1]|0;q=B&65535;O=Ic(a[G>>2]|0,a[G+4>>2]|0,q|0,0)|0;G=v+392+(I<<5)+16|0;a[G>>2]=O;a[G+4>>2]=U;G=m;O=Qb(q|0,0,a[G>>2]|0,a[G+4>>2]|0)|0;G=v+392+(I<<5)+24|0;a[G>>2]=O;a[G+4>>
2]=U;if(I>>>0>=h>>>0)break a}else B=q}if(36==(R|0))Z(149747,148429,2016,149786);else if(42==(R|0))Z(149747,148429,2016,149786);else if(105==(R|0))return u=c,Q|0}}while(0);K=a[(0==(a[b+12>>2]&1024|0)?b+452|0:b+492|0)>>2]|0;L=l+489|0;W=l+490|0;t[L>>0]|0?(w[W>>1]|0)==d<<16>>16&&(S=l+492|0,J=a[S>>2]|0,J>>>0<=K>>>0)?(M=S,T=J):(t[l+496>>0]|0&&(J=a[k>>2]|0,S=J+496|0,t[S>>0]|0?(fi(J+632|0),t[S>>0]=0):Z(150963,148429,1245,150993)),t[L>>0]=0,R=54):R=54;do if(54==(R|0)){t[l+205>>0]=d;w[W>>1]=d;L=E(a[b+164>>
2]|0,h)|0;S=l+492|0;a[S>>2]=L;L=l+1240|0;t[L>>0]|0?(D=J=l+1232|0,F=l+1256|0,v=Ic(a[D>>2]|0,a[D+4>>2]|0,N[F>>1]|0,0)|0,D=l+392+(h<<5)+16|0,m=a[D>>2]|0,B=a[D+4>>2]|0,(v|0)==(m|0)&(U|0)==(B|0)||(X=J,P=F,da=m,aa=B,R=57)):(B=l+392+(h<<5)+16|0,X=l+1232|0,P=l+1256|0,da=a[B>>2]|0,aa=a[B+4>>2]|0,R=57);57==(R|0)&&(a[l+1220>>2]=a[l+392+(h<<5)+4>>2],a[l+1224>>2]=a[l+392+(h<<5)+8>>2],B=X,a[B>>2]=da,a[B+4>>2]=aa,t[L>>0]=0,L=l+392+(h<<5)+24|0,B=a[L+4>>2]|0,m=l+1248|0,a[m>>2]=a[L>>2],a[m+4>>2]=B,w[P>>1]=0,a[l+1260>>
2]=0);B=a[k>>2]|0;m=B+496|0;if(t[m>>0]|0)return Q=0,u=c,Q|0;a[B+3312>>2]=0;t[B+362>>0]=0;L=B+500|0;Fg(L)|0;a[B+508>>2]=23;a[L>>2]=24;F=B+632|0;a[F>>2]=L;a[B+644>>2]=b;D=B;p=F;D|=0;p|=0;A=v=0;q=4;r=Hc(40)|0;a[r>>2]=0;r=Xc(D+4|0,1,r|0,q|0)|0;q=U;Wa=D=Wa=0;0!=(D|0)&0!=(pa|0)?((z=db(a[D>>2]|0,r|0,q|0)|0)||Vb(D|0,pa|0),U=pa):z=-1;for(z=1==(z|0)?U:0;;){if(z){v=0;A=6;break}Wa=0;Qi(14,p|0,90,488);z=Wa;Wa=0;0!=(z|0)&0!=(pa|0)?((D=db(a[z>>2]|0,r|0,q|0)|0)||Vb(z|0,pa|0),U=pa):D=-1;if(1==(D|0))z=U;else break}6!=
(A|0)&&(v=1);Gc(r|0);p=v|0;if(!(p|0))return Q=0,u=c,Q|0;t[m>>0]=1;a[B+1124>>2]=0;a[B+1128>>2]=25;a[B+1132>>2]=33;a[B+1136>>2]=5;a[B+1140>>2]=36;a[B+1144>>2]=26;a[B+656>>2]=B+1120;z=B;m=F;z|=0;m|=0;v=r=0;p=4;q=Hc(40)|0;a[q>>2]=0;q=Xc(z+4|0,1,q|0,p|0)|0;p=U;Wa=z=Wa=0;0!=(z|0)&0!=(pa|0)?((A=db(a[z>>2]|0,q|0,p|0)|0)||Vb(z|0,pa|0),U=pa):A=-1;for(A=1==(A|0)?U:0;;){if(A){r=0;v=6;break}Wa=0;Jk(30,m|0,1)|0;A=Wa;Wa=0;0!=(A|0)&0!=(pa|0)?((z=db(a[A>>2]|0,q|0,p|0)|0)||Vb(A|0,pa|0),U=pa):z=-1;if(1==(z|0))A=U;else break}6!=
(v|0)&&(r=1);Gc(q|0);m=r|0;if(!(m|0))return Q=0,u=c,Q|0;m=t[B+206>>0]|0;if(0==(t[B+230>>0]|0)&1<(m&255)){if(a[B+700>>2]=1,a[B+708>>2]=0,t[B+497>>0]=0,L=B+1148|0,!(t[L>>0]|0)){J=B+1180|0;a[J>>2]|0&&Z(151473,148429,1185,151509);v=B+1200|0;a[v>>2]|0&&Z(151530,148429,1186,151509);D=B+192|0;z=B+228|0;r=x[z>>0]|0;n=r<<3;p=(a[D>>2]|0)+-1+n|0;A=p-((p>>>0)%(n>>>0)|0)|0;n=B+1152|0;a[n>>2]=A;p=B+229|0;C=x[p>>0]<<3;I=B+1156|0;a[I>>2]=C;G=(A>>>0)/(r>>>0)|0;r=B+1160|0;a[r>>2]=G;O=B+1164|0;a[O>>2]=8;q=E(C,A)|0;
A=B+1168|0;a[A>>2]=q;C=B+1172|0;a[C>>2]=G<<3;m=q+(G<<4)|0;a[B+1176>>2]=m;G=eb(m)|0;a[J>>2]=G;if(!G)return Y(a[b+628>>2]|0,151509,150005,g),Q=0,u=c,Q|0;J=B+1184|0;a[J>>2]=G;m=a[A>>2]|0;A=B+1188|0;a[A>>2]=G+m;q=B+1192|0;a[q>>2]=G+((a[C>>2]|0)+m);m=(a[I>>2]|0)+3+(a[O>>2]<<1)|0;a[B+1196>>2]=m;C=eb(m<<2)|0;a[v>>2]=C;if(!C)return Y(a[b+628>>2]|0,151509,150005,f),Q=0,u=c,Q|0;m=C+12|0;a[C>>2]=m;G=a[I>>2]|0;I=G+3|0;a[C+4>>2]=(a[v>>2]|0)+(I<<2);M=a[O>>2]|0;a[C+8>>2]=(a[v>>2]|0)+(M+I<<2);if(G){I=a[n>>2]|0;n=
1<G>>>0?(G<<2)+12|0:16;v=m;for(m=0;O=(a[J>>2]|0)+(E(m,I)|0)|0,a[v>>2]=O,m=m+1|0,(m|0)!=(G|0);)v=v+4|0;n=C+n|0}else n=m;if(M){v=a[r>>2]|0;G=1<M>>>0;m=n;for(I=0;J=(a[A>>2]|0)+(E(I,v)|0)|0,a[m>>2]=J,I=I+1|0,(I|0)!=(M|0);)m=m+4|0;m=n+((G?M:1)<<2)|0;for(I=0;A=(a[q>>2]|0)+(E(I,v)|0)|0,a[m>>2]=A,I=I+1|0,(I|0)!=(M|0);)m=m+4|0}m=x[z>>0]|0;M=(((a[D>>2]|0)+-1+m|0)>>>0)/(m>>>0)|0;a[B+1204>>2]=M;a[B+1208>>2]=0;I=x[p>>0]|0;v=E((E(I,m)|0)+2|0,M)|0;a[B+1212>>2]=v;a[B+1216>>2]=(((a[B+196>>2]|0)+-1+I|0)>>>0)/(I>>>
0)|0;t[L>>0]=1}}else a[B+672>>2]=0,a[B+676>>2]=0,t[B+497>>0]=1,I=E(a[B+192>>2]|0,m&255)|0,a[B+1212>>2]=I,a[B+1216>>2]=a[B+196>>2];v=B;v|=0;F|=0;r=q=0;m=4;p=Hc(40)|0;a[p>>2]=0;p=Xc(v+4|0,1,p|0,m|0)|0;m=U;Wa=v=Wa=0;0!=(v|0)&0!=(pa|0)?((A=db(a[v>>2]|0,p|0,m|0)|0)||Vb(v|0,pa|0),U=pa):A=-1;for(v=1==(A|0)?U:0;;){if(v){q=0;r=6;break}Wa=0;si(21,F|0)|0;A=Wa;Wa=0;0!=(A|0)&0!=(pa|0)?((v=db(a[A>>2]|0,p|0,m|0)|0)||Vb(A|0,pa|0),U=pa):v=-1;if(1==(v|0))v=U;else break}6!=(r|0)&&(q=1);Gc(p|0);F=q|0;if(F|0)t[B+489>>
0]=1,M=S,T=a[S>>2]|0;else return Q=0,u=c,Q|0}while(0);if(T>>>0>=K>>>0)return u=c,1;T=l+497|0;a:for(;;){l=a[k>>2]|0;b:do if(t[T>>0]|0){da=l+5364|0;if(0==(a[da>>2]|0)&&(P=eb(a[l+1212>>2]|0)|0,a[da>>2]=P,0==(P|0))){R=101;break a}P=l+632|0;aa=l+1216|0;if(a[aa>>2]|0){g=0;do if(g=g+1|0,!(Ph(l,P,da)|0)){Q=0;R=105;break a}while(g>>>0<(a[aa>>2]|0)>>>0)}}else{n=a[l+1216>>2]|0;f=l+1208|0;g=a[f>>2]|0;P=l+1164|0;h=a[P>>2]|0;do if(g)if(aa=h-g|0,n>>>0>aa>>>0)a[f>>2]=0,B=n-aa|0;else{aa=g+n|0;a[f>>2]=(aa|0)==(h|0)?
0:aa;break b}else B=n;while(0);if(B>>>0<h>>>0)g=B;else for(n=l+632|0,g=l+1200|0,aa=l+229|0,da=B;;){if(!(ok(l,n,a[g>>2]|0,x[aa>>0]<<3)|0)){Q=0;R=105;break a}X=a[P>>2]|0;d=da-X|0;if(d>>>0<X>>>0){g=d;break}else da=d}if(g){if(!(ok(l,l+632|0,a[l+1200>>2]|0,x[l+229>>0]<<3)|0)){Q=0;R=105;break a}a[f>>2]=g}}while(0);l=(a[M>>2]|0)+1|0;a[M>>2]=l;if(l>>>0>=K>>>0){Q=1;R=105;break}}if(101==(R|0))Y(a[b+628>>2]|0,151568,150005,e),u=c;else if(105==(R|0))return u=c,Q|0;return 0},function(b,d){d=u;u=u+16|0;Y(a[(b|
0)+628>>2]|0,151115,151030,d);u=d;return 0},function(b,d){var c;d=u;u=u+16|0;c=a[(b|0)+12>>2]|0;Y(a[c+628>>2]|0,151596,151604,d);Bi(c);return 0},function(b,d){b|=0;var c;d=eb(4)|0;c=b+576|0;a[c>>2]=d;if(!d)return 0;d=a[b+12>>2]&1024?tg(b)|0:Pe(b)|0;a[a[c>>2]>>2]=d;return 1},function(b,d){b|=0;var c;if(d=a[b+576>>2]|0)return c=d+64|0,a[c>>2]=a[b+588>>2],a[d+68>>2]=a[b+608>>2],0==(If(c)|0)|0;Z(154187,152287,723,152750);return 0},function(b,d){b|=0;if(d=a[b+576>>2]|0)return a[d+76>>2]=a[b+588>>2],a[d+
80>>2]=a[b+592>>2],0==(qk(d+64|0)|0)|0;Z(154187,152287,919,152544);return 0},function(b,d){b|=0;var c;(d=a[b+576>>2]|0)||Z(154187,154074,129,154451);a[d+124>>2]&1||da[a[b+508>>2]&63](b)|0;c=d+64|0;a[c>>2]=a[b+588>>2];a[d+68>>2]=a[b+608>>2];return 0==(If(c)|0)|0},function(b,d){b|=0;(d=a[b+576>>2]|0)||Z(154187,154074,234,154287);2!=(a[d+124>>2]|0)&&da[a[b+516>>2]&63](b)|0;a[d+76>>2]=a[b+588>>2];a[d+80>>2]=a[b+592>>2];return 0==(qk(d+64|0)|0)|0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,t,r,
u;c=a[b+424>>2]|0;e=b+236|0;a[e>>2]|0&&(f=c+68|0,(g=a[f>>2]|0)?k=g:(h=c+72|0,jh(b,a[h>>2]|0),m=a[e>>2]|0,a[f>>2]=m,a[h>>2]=(a[h>>2]|0)+1&7,k=m),a[f>>2]=k+-1);k=b+320|0;if(0>=(a[k>>2]|0))return 1;f=b+376|0;g=0;do{m=a[b+324+(g<<2)>>2]|0;h=a[(a[b+296+(m<<2)>>2]|0)+20>>2]|0;e=w[a[d+(g<<2)>>2]>>1]>>a[f>>2];l=c+76+(h<<2)|0;n=a[l>>2]|0;p=c+52+(m<<2)|0;q=a[p>>2]|0;t=n+q|0;r=c+36+(m<<2)|0;m=a[r>>2]|0;u=e-m|0;if((e|0)!=(m|0)){a[r>>2]=e;ec(b,t,1);0<(u|0)?(ec(b,n+(q+1)|0,0),m=q+2|0,q=4,r=u):(ec(b,n+(q+1)|0,1),
m=q+3|0,q=8,r=0-u|0);u=n+m|0;a[p>>2]=q;if(n=r+-1|0)if(ec(b,u,1),q=(a[l>>2]|0)+20|0,l=n>>1)for(e=l,l=1,r=q;;)if(ec(b,r,1),q=l<<1,m=r+1|0,e>>=1)l=q,r=m;else{l=q;u=m;break}else l=1,u=q;else l=0;ec(b,u,0);(l|0)>=(1<<x[b+152+h>>0]>>1|0)?(l|0)>(1<<x[b+168+h>>0]>>1|0)&&(a[p>>2]=(a[p>>2]|0)+8):a[p>>2]=0;r=u+14|0;if(l>>=1){e=l;do ec(b,r,0!=(e&n|0)&1),e>>=1;while(0!=(e|0))}}else ec(b,t,0),a[p>>2]=0;g=g+1|0}while((g|0)<(a[k>>2]|0));return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,t,r,u,v,z=0,A=0,
C=0,D=0,E=0,F=0,J=0,I=0,G=q=0,L=0,K=0;c=a[b+424>>2]|0;e=b+236|0;a[e>>2]|0&&(f=c+68|0,(g=a[f>>2]|0)?k=g:(h=c+72|0,jh(b,a[h>>2]|0),m=a[e>>2]|0,a[f>>2]=m,a[h>>2]=(a[h>>2]|0)+1&7,k=m),a[f>>2]=k+-1);k=a[b+384>>2]|0;f=a[d>>2]|0;d=a[(a[b+296>>2]|0)+24>>2]|0;g=b+368|0;m=a[g>>2]|0;h=b+376|0;for(e=m;;){l=w[f+(a[k+(e<<2)>>2]<<1)>>1]|0;n=l<<16>>16;if(-1<l<<16>>16){if(n>>a[h>>2]){p=e;break}}else if(0-n>>a[h>>2]){p=e;break}e=e+-1|0;if(!e){p=0;break}}e=a[b+364>>2]|0;n=e+-1|0;if((e|0)>(p|0))e=m,q=n;else{m=c+140+
(d<<2)|0;e=c+204|0;l=b+184+d|0;for(t=n;;){n=(a[m>>2]|0)+(3*t|0)|0;ec(b,n,0);for(r=n;;){n=t+1|0;u=w[f+(a[k+(n<<2)>>2]<<1)>>1]|0;v=u<<16>>16;if(-1<u<<16>>16){if(u=v>>a[h>>2]){z=n;A=u;C=t;D=r;n=16;break}}else if(u=0-v>>a[h>>2]){E=n;F=u;J=t;I=r;n=18;break}ec(b,r+1|0,0);t=n;r=r+3|0}16==(n|0)?(ec(b,D+1|0,1),ec(b,e,0),q=z,G=C,L=D,K=A):18==(n|0)&&(ec(b,I+1|0,1),ec(b,e,1),q=E,G=J,L=I,K=F);r=L+2|0;if(t=K+-1|0)if(ec(b,r,1),2<=t>>>0)if(ec(b,r,1),n=(a[m>>2]|0)+((G|0)<(x[l>>0]|0)?189:217)|0,u=t>>2)for(v=u,u=2,
r=n;;)if(ec(b,r,1),n=u<<1,r=r+1|0,v>>=1)u=n;else{u=n;n=r;break}else u=2;else u=1,n=r;else u=0,n=r;ec(b,n,0);r=n+14|0;if(u>>=1){v=u;do ec(b,r,0!=(v&t|0)&1),v>>=1;while(0!=(v|0))}if((q|0)<(p|0))t=q;else break}e=a[g>>2]|0}if((q|0)>=(e|0))return 1;ec(b,(a[c+140+(d<<2)>>2]|0)+(3*q|0)|0,1);return 1},function(b,d){b|=0;d|=0;var c,e,f,g;c=a[b+424>>2]|0;e=b+236|0;a[e>>2]|0&&(f=c+68|0,(g=a[f>>2]|0)?e=g:(g=c+72|0,jh(b,a[g>>2]|0),e=a[e>>2]|0,a[f>>2]=e,a[g>>2]=(a[g>>2]|0)+1&7),a[f>>2]=e+-1);e=c+204|0;c=a[b+376>>
2]|0;f=b+320|0;if(0<(a[f>>2]|0))g=0;else return 1;do ec(b,e,(w[a[d+(g<<2)>>2]>>1]|0)>>>c&1),g=g+1|0;while((g|0)<(a[f>>2]|0));return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p=0,q=0,t=0,r=0,u,v=0,z=0,x=0,C=0,A=0,D=0,E=0;c=a[b+424>>2]|0;e=b+236|0;a[e>>2]|0&&(f=c+68|0,(g=a[f>>2]|0)?k=g:(h=c+72|0,jh(b,a[h>>2]|0),m=a[e>>2]|0,a[f>>2]=m,a[h>>2]=(a[h>>2]|0)+1&7,k=m),a[f>>2]=k+-1);k=a[b+384>>2]|0;f=a[d>>2]|0;d=a[(a[b+296>>2]|0)+24>>2]|0;g=b+368|0;m=a[g>>2]|0;h=b+376|0;for(e=m;;){l=w[f+(a[k+(e<<2)>>
2]<<1)>>1]|0;n=l<<16>>16;if(-1<l<<16>>16){if(n>>a[h>>2]){p=e;q=10;break}}else if(0-n>>a[h>>2]){p=e;q=10;break}e=e+-1|0;if(!e){r=t=0;break}}a:do if(10==(q|0))if(e=b+372|0,0<(p|0))for(n=p;;){l=w[f+(a[k+(n<<2)>>2]<<1)>>1]|0;u=l<<16>>16;if(-1<l<<16>>16){if(u>>a[e>>2]){t=p;r=n;break a}}else if(0-u>>a[e>>2]){t=p;r=n;break a}u=n+-1|0;if(1<(n|0))n=u;else{t=p;r=u;break}}else r=t=p;while(0);p=a[b+364>>2]|0;n=p+-1|0;if((p|0)>(t|0))f=m;else{m=c+140+(d<<2)|0;p=c+204|0;for(e=n;;){n=(a[m>>2]|0)+(3*e|0)|0;(e|0)<
(r|0)||ec(b,n,0);l=e;for(e=n;;){n=l+1|0;u=w[f+(a[k+(n<<2)>>2]<<1)>>1]|0;l=u<<16>>16;if(-1<u<<16>>16){if(u=l>>a[h>>2]){v=n;z=u;x=e;q=21;break}}else if(u=0-l>>a[h>>2]){C=n;A=u;D=e;q=25;break}ec(b,e+1|0,0);l=n;e=e+3|0}21==(q|0)?(1<z>>>0?ec(b,x+2|0,z&1):(ec(b,x+1|0,1),ec(b,p,0)),E=v):25==(q|0)&&(1<A>>>0?ec(b,D+2|0,A&1):(ec(b,D+1|0,1),ec(b,p,1)),E=C);if((E|0)<(t|0))e=E;else break}f=a[g>>2]|0;n=E}if((n|0)>=(f|0))return 1;ec(b,(a[c+140+(d<<2)>>2]|0)+(3*n|0)|0,1);return 1},function(b,d){b|=0;d|=0;var c,e,
f,g,h,m,k,l,n,p,q,t,r,u,v,z,A,C,D=0,E=0,F=0,J=0;c=a[b+424>>2]|0;e=b+236|0;a[e>>2]|0&&(f=c+68|0,(g=a[f>>2]|0)?k=g:(h=c+72|0,jh(b,a[h>>2]|0),m=a[e>>2]|0,a[f>>2]=m,a[h>>2]=(a[h>>2]|0)+1&7,k=m),a[f>>2]=k+-1);k=a[b+384>>2]|0;f=b+320|0;if(0>=(a[f>>2]|0))return 1;g=b+388|0;m=c+204|0;h=0;do{e=a[d+(h<<2)>>2]|0;l=a[b+324+(h<<2)>>2]|0;n=a[b+296+(l<<2)>>2]|0;p=a[n+20>>2]|0;q=c+76+(p<<2)|0;t=a[q>>2]|0;r=c+52+(l<<2)|0;u=a[r>>2]|0;v=t+u|0;z=w[e>>1]|0;A=c+36+(l<<2)|0;l=a[A>>2]|0;C=z-l|0;if((z|0)!=(l|0)){a[A>>2]=
z;ec(b,v,1);0<(C|0)?(ec(b,t+(u+1)|0,0),A=u+2|0,v=4,u=C):(ec(b,t+(u+1)|0,1),A=u+3|0,v=8,u=0-C|0);C=t+A|0;a[r>>2]=v;if(t=u+-1|0)if(ec(b,C,1),u=(a[q>>2]|0)+20|0,q=t>>1)for(z=q,q=1,A=u;;)if(ec(b,A,1),u=q<<1,l=A+1|0,z>>=1)q=u,A=l;else{v=u;A=l;break}else v=1,A=u;else v=0,A=C;ec(b,A,0);(v|0)>=(1<<x[b+152+p>>0]>>1|0)?(v|0)>(1<<x[b+168+p>>0]>>1|0)&&(a[r>>2]=(a[r>>2]|0)+8):a[r>>2]=0;A=A+14|0;if(q=v>>1){z=q;do ec(b,A,0!=(z&t|0)&1),z>>=1;while(0!=(z|0))}}else ec(b,v,0),a[r>>2]=0;if(z=a[g>>2]|0){t=a[n+24>>2]|
0;for(A=z;;){if(w[e+(a[k+(A<<2)>>2]<<1)>>1]|0){D=A;E=25;break}A=A+-1|0;if(!A){F=z;J=0;break}}if(25==(E|0))if(E=0,0<(D|0)){A=c+140+(t<<2)|0;n=b+184+t|0;for(r=0;;){v=a[A>>2]|0;p=3*r|0;C=v+p|0;ec(b,C,0);q=r+1|0;l=w[e+(a[k+(q<<2)>>2]<<1)>>1]|0;u=l<<16>>16;J=v+(p+1)|0;if(l<<16>>16)F=q,p=l,v=u;else{p=J;v=q;for(r=C;;)if(ec(b,p,0),C=r+3|0,q=v+1|0,u=w[e+(a[k+(q<<2)>>2]<<1)>>1]|0,J=r+4|0,u<<16>>16){r=v;F=q;v=u;break}else p=J,v=q,r=C;p=v;v=v<<16>>16}q=J;J=r;r=C;ec(b,q,1);0<p<<16>>16?(ec(b,m,0),p=v):(ec(b,m,
1),p=0-v|0);v=r+2|0;if(r=p+-1|0)if(ec(b,v,1),2<=r>>>0)if(ec(b,v,1),p=(a[A>>2]|0)+((J|0)<(x[n>>0]|0)?189:217)|0,J=r>>2)for(u=J,J=2,q=p;;)if(ec(b,q,1),p=J<<1,C=q+1|0,u>>=1)J=p,q=C;else{J=p;p=C;break}else J=2;else J=1,p=v;else J=0,p=v;ec(b,p,0);q=p+14|0;if(J>>=1){u=J;do ec(b,q,0!=(u&r|0)&1),u>>=1;while(0!=(u|0))}if((F|0)<(D|0))r=F;else{e=F;break}}F=a[g>>2]|0;J=e}else F=z,J=0;(J|0)<(F|0)&&ec(b,(a[c+140+(t<<2)>>2]|0)+(3*J|0)|0,1)}h=h+1|0}while((h|0)<(a[f>>2]|0));return 1},function(b,d){b|=0;d|=0;var c,
e,f,g,h,m,k,l,n,p,q,t,r,u,v,z,x,C,A,D,F,J,I,G,L,K,R,N,O,M,T,S,P=0,U,W=0,da=0,ba=0;c=b+404|0;e=a[c>>2]|0;f=(a[b+312>>2]|0)+-1|0;g=b+288|0;h=(a[g>>2]|0)+-1|0;m=e+16|0;k=a[m>>2]|0;l=e+20|0;n=a[l>>2]|0;do if((k|0)<(n|0)){p=e+12|0;q=b+292|0;t=b+420|0;r=e+8|0;u=b+424|0;v=e+24|0;z=a[p>>2]|0;x=n;C=k;a:for(;;){if(!(z>>>0>f>>>0)){do{x=a[q>>2]|0;if(0<(x|0))if(z>>>0<f>>>0)for(A=x,x=D=0;;){F=a[b+296+(x<<2)>>2]|0;J=F+4|0;I=a[(a[t>>2]|0)+4+(a[J>>2]<<2)>>2]|0;G=F+56|0;L=a[G>>2]|0;K=E(a[F+68>>2]|0,z)|0;R=F+40|0;N=
F+60|0;if(0<(a[N>>2]|0)){A=F+76|0;O=L;M=D;T=0;for(S=E(a[R>>2]|0,C)|0;;){if((a[r>>2]|0)>>>0>=h>>>0&&(T+C|0)>=(a[A>>2]|0)){if(Va(a[e+24+(M<<2)>>2]|0,0,O<<7|0)|0,P=a[G>>2]|0,0<(P|0)){D=a[e+24+(M+-1<<2)>>2]|0;U=0;do w[a[e+24+(U+M<<2)>>2]>>1]=w[D>>1]|0,U=U+1|0;while((U|0)<(P|0))}}else W=13;if(13==(W|0)&&(W=0,ee[I&15](b,F,a[d+(a[J>>2]<<2)>>2]|0,a[e+24+(M<<2)>>2]|0,S,K,L),P=a[G>>2]|0,(P|0)>(L|0))&&(Va(a[e+24+(M+L<<2)>>2]|0,0,P-L<<7|0)|0,P=a[G>>2]|0,(L|0)<(P|0))){U=L;do D=U+M|0,w[a[e+24+(D<<2)>>2]>>1]=w[a[e+
24+(D+-1<<2)>>2]>>1]|0,U=U+1|0;while((U|0)<(P|0))}O=a[G>>2]|0;P=O+M|0;T=T+1|0;if((T|0)>=(a[N>>2]|0)){J=P;break}else M=P,S=(a[R>>2]|0)+S|0}F=a[q>>2]|0}else F=A,J=D;x=x+1|0;if((x|0)>=(F|0))break;else A=F,D=J}else for(D=x,x=A=0;;){S=a[b+296+(x<<2)>>2]|0;R=S+4|0;M=a[(a[t>>2]|0)+4+(a[R>>2]<<2)>>2]|0;N=S+56|0;T=a[S+72>>2]|0;O=E(a[S+68>>2]|0,z)|0;G=S+40|0;L=S+60|0;if(0<(a[L>>2]|0)){K=S+76|0;J=A;F=0;for(I=E(a[G>>2]|0,C)|0;;){if((a[r>>2]|0)>>>0>=h>>>0&&(F+C|0)>=(a[K>>2]|0)){Va(a[e+24+(J<<2)>>2]|0,0,a[N>>2]<<
7|0)|0;A=a[N>>2]|0;if(0<(A|0)){P=a[e+24+(J+-1<<2)>>2]|0;U=0;do w[a[e+24+(U+J<<2)>>2]>>1]=w[P>>1]|0,U=U+1|0;while((U|0)<(A|0))}D=A}else if(ee[M&15](b,S,a[d+(a[R>>2]<<2)>>2]|0,a[e+24+(J<<2)>>2]|0,I,O,T),U=a[N>>2]|0,(U|0)>(T|0)){Va(a[e+24+(J+T<<2)>>2]|0,0,U-T<<7|0)|0;P=a[N>>2]|0;if((T|0)<(P|0)){D=T;do A=D+J|0,w[a[e+24+(A<<2)>>2]>>1]=w[a[e+24+(A+-1<<2)>>2]>>1]|0,D=D+1|0;while((D|0)<(P|0))}D=P}else D=U;D=D+J|0;F=F+1|0;if((F|0)>=(a[L>>2]|0)){J=D;break}else J=D,I=(a[G>>2]|0)+I|0}F=a[q>>2]|0}else F=D,J=A;
x=x+1|0;if((x|0)>=(F|0))break;else D=F,A=J}if(!(dd[a[(a[u>>2]|0)+4>>2]&127](b,v)|0)){da=z;ba=C;break a}z=z+1|0}while(z>>>0<=f>>>0);x=a[l>>2]|0}a[p>>2]=0;C=C+1|0;if((C|0)>=(x|0)){W=38;break}else z=0}if(38==(W|0))p=q,q=a[c>>2]|0;else return a[m>>2]=ba,a[p>>2]=da,0}else p=b+292|0,r=e+8|0,q=e;while(0);a[r>>2]=(a[r>>2]|0)+1;1>=(a[p>>2]|0)?(r=a[b+296>>2]|0,a[q+20>>2]=(a[q+8>>2]|0)>>>0<((a[g>>2]|0)+-1|0)>>>0?a[r+12>>2]:a[r+76>>2]):a[q+20>>2]=1;a[q+12>>2]=0;a[q+16>>2]=0;return 1},function(b,d){b|=0;d|=0;
var c,e,f,g,h,m,k,l,n,p,q,t,r,u,v,z,x,C,A,D=0,F=0,J,I,G;c=a[b+404>>2]|0;e=(a[b+288>>2]|0)+-1|0;f=b+76|0;if(0>=(a[f>>2]|0))return c=tk(b,d)|0,c|0;g=b+4|0;h=c+8|0;m=b+420|0;k=0;for(l=a[b+84>>2]|0;;){n=l+12|0;p=a[n>>2]|0;q=E(p,a[h>>2]|0)|0;t=jg[a[(a[g>>2]|0)+32>>2]&3](b,a[c+64+(k<<2)>>2]|0,q,p,1)|0;p=a[h>>2]|0;p>>>0<e>>>0?r=a[n>>2]|0:(q=a[n>>2]|0,u=((a[l+32>>2]|0)>>>0)%(q>>>0)|0,r=0==(u|0)?q:u);u=a[l+28>>2]|0;q=a[l+8>>2]|0;v=(u>>>0)%(q>>>0)|0;z=0<(v|0)?q-v|0:v;v=a[(a[m>>2]|0)+4+(k<<2)>>2]|0;if(0<(r|
0)){p=d+(k<<2)|0;x=l+40|0;C=0<(z|0);A=z<<7;D=u+-1|0;F=0;do{J=a[t+(F<<2)>>2]|0;I=E(a[x>>2]|0,F)|0;ee[v&15](b,l,a[p>>2]|0,J,I,0,u);if(C){Va(J+(u<<7)|0,0,A|0)|0;I=w[J+(D<<7)>>1]|0;G=0;do w[J+(G+u<<7)>>1]=I,G=G+1|0;while((G|0)!=(z|0))}F=F+1|0}while((F|0)!=(r|0));v=a[h>>2]|0}else v=p;if((v|0)==(e|0)&&(F=z+u|0,D=(F>>>0)/(q>>>0)|0,(r|0)<(a[n>>2]|0))){A=F<<7;F=0==(D|0);C=q+-1|0;p=0<(q|0);v=r;do{x=a[t+(v<<2)>>2]|0;G=a[t+(v+-1<<2)>>2]|0;Va(x|0,0,A|0)|0;if(!F)for(I=0,J=G,G=x;;){x=w[J+(C<<7)>>1]|0;if(p){r=0;
do w[G+(r<<7)>>1]=x,r=r+1|0;while((r|0)!=(q|0))}I=I+1|0;if(I>>>0>=D>>>0)break;else J=J+(q<<7)|0,G=G+(q<<7)|0}v=v+1|0}while((v|0)<(a[n>>2]|0))}k=k+1|0;if((k|0)>=(a[f>>2]|0))break;else l=l+88|0}c=tk(b,d)|0;return c|0},tk,function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,u,v,x,z,A,C,D=0,E,F,J,I;c=a[b+424>>2]|0;e=b+24|0;f=a[e>>2]|0;g=c+112|0;a[g>>2]=a[f>>2];h=c+116|0;a[h>>2]=a[f+4>>2];f=b+236|0;0!=(a[f>>2]|0)&&0==(a[c+36>>2]|0)&&gi(c,a[c+40>>2]|0);m=b+320|0;if(0<(a[m>>2]|0)){k=b+376|0;l=c+108|0;n=c+
120|0;p=c+16|0;q=c+12|0;r=0;do{u=a[b+324+(r<<2)>>2]|0;v=a[(a[b+296+(u<<2)>>2]|0)+20>>2]|0;x=w[a[d+(r<<2)>>2]>>1]>>a[k>>2];z=c+20+(u<<2)|0;u=x-(a[z>>2]|0)|0;a[z>>2]=x;x=(u>>31)+u|0;if(z=0>(u|0)?0-u|0:u){u=0;for(A=z;;)if(z=u+1|0,A>>=1)u=z;else{C=z;break}10<(u|0)&&(u=a[b>>2]|0,a[u+20>>2]=6,R[a[u>>2]&127](b))}else C=0;do if(a[l>>2]|0)u=(a[c+76+(v<<2)>>2]|0)+(C<<2)|0,a[u>>2]=(a[u>>2]|0)+1;else if(u=a[c+44+(v<<2)>>2]|0,A=a[u+(C<<2)>>2]|0,z=t[u+1024+C>>0]|0,u=z<<24>>24,0!=z<<24>>24||(z=a[n>>2]|0,D=a[z>>
2]|0,a[D+20>>2]=41,R[a[D>>2]&127](z),0==(a[l>>2]|0))){z=(a[p>>2]|0)+u|0;D=((1<<u)+-1&A)<<24-z|a[q>>2];if(7<(z|0)){A=z;for(u=D;;)if(E=u>>>16,F=E&255,J=a[g>>2]|0,a[g>>2]=J+1,t[J>>0]=E,E=(a[h>>2]|0)+-1|0,a[h>>2]=E,E||(E=a[n>>2]|0,J=a[E+24>>2]|0,da[a[J+12>>2]&63](E)|0||(E=a[n>>2]|0,I=a[E>>2]|0,a[I+20>>2]=25,R[a[I>>2]&127](E)),a[g>>2]=a[J>>2],a[h>>2]=a[J+4>>2]),255==(F|0)&&(F=a[g>>2]|0,a[g>>2]=F+1,t[F>>0]=0,F=(a[h>>2]|0)+-1|0,a[h>>2]=F,0==(F|0))&&(F=a[n>>2]|0,J=a[F+24>>2]|0,da[a[J+12>>2]&63](F)|0||(F=
a[n>>2]|0,E=a[F>>2]|0,a[E+20>>2]=25,R[a[E>>2]&127](F)),a[g>>2]=a[J>>2],a[h>>2]=a[J+4>>2]),J=u<<8,A=A+-8|0,7>=(A|0)){u=J;break}else u=J;z&=7}else u=D;a[q>>2]=u;a[p>>2]=z}while(0);if(0!=(C|0)&&0==(a[l>>2]|0)){v=(a[p>>2]|0)+C|0;u=((1<<C)+-1&x)<<24-v|a[q>>2];if(7<(v|0)){A=v;for(J=u;;)if(F=J>>>16,E=F&255,I=a[g>>2]|0,a[g>>2]=I+1,t[I>>0]=F,F=(a[h>>2]|0)+-1|0,a[h>>2]=F,F||(F=a[n>>2]|0,I=a[F+24>>2]|0,da[a[I+12>>2]&63](F)|0||(F=a[n>>2]|0,x=a[F>>2]|0,a[x+20>>2]=25,R[a[x>>2]&127](F)),a[g>>2]=a[I>>2],a[h>>2]=
a[I+4>>2]),255==(E|0)&&(E=a[g>>2]|0,a[g>>2]=E+1,t[E>>0]=0,E=(a[h>>2]|0)+-1|0,a[h>>2]=E,0==(E|0))&&(E=a[n>>2]|0,I=a[E+24>>2]|0,da[a[I+12>>2]&63](E)|0||(E=a[n>>2]|0,F=a[E>>2]|0,a[F+20>>2]=25,R[a[F>>2]&127](E)),a[g>>2]=a[I>>2],a[h>>2]=a[I+4>>2]),I=J<<8,A=A+-8|0,7>=(A|0)){x=I;break}else J=I;v&=7}else x=u;a[q>>2]=x;a[p>>2]=v}r=r+1|0}while((r|0)<(a[m>>2]|0))}m=a[e>>2]|0;a[m>>2]=a[g>>2];a[m+4>>2]=a[h>>2];h=a[f>>2]|0;if(!h)return 1;f=c+36|0;(m=a[f>>2]|0)?c=m:(a[f>>2]=h,g=c+40|0,a[g>>2]=(a[g>>2]|0)+1&7,c=
h);a[f>>2]=c+-1;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,u,v,A,z,D,C,E,F,N,J,I,G,L,K,S,U,O=0,M,T=0,X,P,W,Y=0;c=a[b+424>>2]|0;e=b+24|0;f=a[e>>2]|0;g=c+112|0;a[g>>2]=a[f>>2];h=c+116|0;a[h>>2]=a[f+4>>2];f=b+236|0;0!=(a[f>>2]|0)&&0==(a[c+36>>2]|0)&&gi(c,a[c+40>>2]|0);m=a[b+368>>2]|0;k=a[b+376>>2]|0;l=a[b+384>>2]|0;n=a[d>>2]|0;d=a[b+364>>2]|0;if((d|0)<=(m|0)){p=c+128|0;q=c+124|0;r=c+108|0;u=c+120|0;v=c+16|0;A=c+12|0;z=c+136|0;D=c+132|0;C=d;for(d=0;;){E=w[n+(a[l+(C<<2)>>2]<<1)>>1]|
0;F=E<<16>>16;do if(E<<16>>16)if(0>E<<16>>16?(J=N=0-F>>k,I=~N):I=J=N=F>>k,J){if(N=a[p>>2]|0){G=0;for(L=N;;)if(L>>=1)G=G+1|0;else{K=G;break}14<(K|0)&&(G=a[u>>2]|0,L=a[G>>2]|0,a[L+20>>2]=41,R[a[L>>2]&127](G));G=a[q>>2]|0;L=K<<4;do if(a[r>>2]|0)N=(a[c+92+(G<<2)>>2]|0)+(L<<2)|0,a[N>>2]=(a[N>>2]|0)+1;else if(N=a[c+60+(G<<2)>>2]|0,S=a[N+(L<<2)>>2]|0,U=t[N+1024+L>>0]|0,N=U<<24>>24,0!=U<<24>>24||(U=a[u>>2]|0,O=a[U>>2]|0,a[O+20>>2]=41,R[a[O>>2]&127](U),0==(a[r>>2]|0))){U=(a[v>>2]|0)+N|0;O=((1<<N)+-1&S)<<24-
U|a[A>>2];if(7<(U|0)){S=U;for(N=O;;)if(M=N>>>16,T=M&255,X=a[g>>2]|0,a[g>>2]=X+1,t[X>>0]=M,M=(a[h>>2]|0)+-1|0,a[h>>2]=M,M||(M=a[u>>2]|0,X=a[M+24>>2]|0,da[a[X+12>>2]&63](M)|0||(M=a[u>>2]|0,P=a[M>>2]|0,a[P+20>>2]=25,R[a[P>>2]&127](M)),a[g>>2]=a[X>>2],a[h>>2]=a[X+4>>2]),255==(T|0)&&(X=a[g>>2]|0,a[g>>2]=X+1,t[X>>0]=0,X=(a[h>>2]|0)+-1|0,a[h>>2]=X,X||(X=a[u>>2]|0,M=a[X+24>>2]|0,da[a[M+12>>2]&63](X)|0||(X=a[u>>2]|0,P=a[X>>2]|0,a[P+20>>2]=25,R[a[P>>2]&127](X)),a[g>>2]=a[M>>2],a[h>>2]=a[M+4>>2])),T=N<<8,S=
S+-8|0,7>=(S|0)){S=T;break}else N=T;M=U&7}else M=U,S=O;a[A>>2]=S;a[v>>2]=M}while(0);if(0!=(K|0)&&0==(a[r>>2]|0)){L=(a[v>>2]|0)+K|0;G=(a[p>>2]&(1<<K)+-1)<<24-L|a[A>>2];if(7<(L|0)){N=L;for(S=G;;)if(T=S>>>16,M=T&255,X=a[g>>2]|0,a[g>>2]=X+1,t[X>>0]=T,T=(a[h>>2]|0)+-1|0,a[h>>2]=T,T||(T=a[u>>2]|0,X=a[T+24>>2]|0,da[a[X+12>>2]&63](T)|0||(T=a[u>>2]|0,P=a[T>>2]|0,a[P+20>>2]=25,R[a[P>>2]&127](T)),a[g>>2]=a[X>>2],a[h>>2]=a[X+4>>2]),255==(M|0)&&(X=a[g>>2]|0,a[g>>2]=X+1,t[X>>0]=0,X=(a[h>>2]|0)+-1|0,a[h>>2]=X,X||
(X=a[u>>2]|0,T=a[X+24>>2]|0,da[a[T+12>>2]&63](X)|0||(X=a[u>>2]|0,P=a[X>>2]|0,a[P+20>>2]=25,R[a[P>>2]&127](X)),a[g>>2]=a[T>>2],a[h>>2]=a[T+4>>2])),M=S<<8,N=N+-8|0,7>=(N|0)){G=M;break}else S=M;S=L&7}else S=L;a[A>>2]=G;a[v>>2]=S}a[p>>2]=0;S=a[D>>2]|0;a:do if(0!=(S|0)&0==(a[r>>2]|0))for(N=S,M=a[z>>2]|0,O=0;;){if(!O){U=a[v>>2]|0;T=U+1|0;X=((x[M>>0]|0)&1)<<23-U|a[A>>2];if(7<(T|0)){U=T;for(P=X;;)if(K=P>>>16,W=K&255,G=a[g>>2]|0,a[g>>2]=G+1,t[G>>0]=K,K=(a[h>>2]|0)+-1|0,a[h>>2]=K,K||(K=a[u>>2]|0,G=a[K+24>>
2]|0,da[a[G+12>>2]&63](K)|0||(K=a[u>>2]|0,S=a[K>>2]|0,a[S+20>>2]=25,R[a[S>>2]&127](K)),a[g>>2]=a[G>>2],a[h>>2]=a[G+4>>2]),255==(W|0)&&(G=a[g>>2]|0,a[g>>2]=G+1,t[G>>0]=0,G=(a[h>>2]|0)+-1|0,a[h>>2]=G,G||(G=a[u>>2]|0,K=a[G+24>>2]|0,da[a[K+12>>2]&63](G)|0||(G=a[u>>2]|0,S=a[G>>2]|0,a[S+20>>2]=25,R[a[S>>2]&127](G)),a[g>>2]=a[K>>2],a[h>>2]=a[K+4>>2])),W=P<<8,U=U+-8|0,7>=(U|0)){S=W;break}else P=W;G=T&7}else G=T,S=X;a[A>>2]=S;a[v>>2]=G}P=N+-1|0;if(!P)break a;N=P;M=M+1|0;O=a[r>>2]|0}while(0);a[D>>2]=0}if(15<
(d|0)){S=d;do{G=a[q>>2]|0;do if(a[r>>2]|0)L=(a[c+92+(G<<2)>>2]|0)+960|0,a[L>>2]=(a[L>>2]|0)+1;else if(L=a[c+60+(G<<2)>>2]|0,O=a[L+960>>2]|0,M=t[L+1264>>0]|0,L=M<<24>>24,0!=M<<24>>24||(M=a[u>>2]|0,N=a[M>>2]|0,a[N+20>>2]=41,R[a[N>>2]&127](M),0==(a[r>>2]|0))){M=(a[v>>2]|0)+L|0;N=((1<<L)+-1&O)<<24-M|a[A>>2];if(7<(M|0)){O=M;for(L=N;;)if(P=L>>>16,U=P&255,W=a[g>>2]|0,a[g>>2]=W+1,t[W>>0]=P,P=(a[h>>2]|0)+-1|0,a[h>>2]=P,P||(P=a[u>>2]|0,W=a[P+24>>2]|0,da[a[W+12>>2]&63](P)|0||(P=a[u>>2]|0,K=a[P>>2]|0,a[K+20>>
2]=25,R[a[K>>2]&127](P)),a[g>>2]=a[W>>2],a[h>>2]=a[W+4>>2]),255==(U|0)&&(W=a[g>>2]|0,a[g>>2]=W+1,t[W>>0]=0,W=(a[h>>2]|0)+-1|0,a[h>>2]=W,W||(W=a[u>>2]|0,P=a[W+24>>2]|0,da[a[P+12>>2]&63](W)|0||(W=a[u>>2]|0,K=a[W>>2]|0,a[K+20>>2]=25,R[a[K>>2]&127](W)),a[g>>2]=a[P>>2],a[h>>2]=a[P+4>>2])),U=L<<8,O=O+-8|0,7>=(O|0)){L=U;break}else L=U;M&=7}else L=N;a[A>>2]=L;a[v>>2]=M}while(0);S=S+-16|0}while(15<(S|0));N=d&15}else N=d;S=1;for(G=J;;)if(G>>=1)S=S+1|0;else{J=S;break}10<(J|0)&&(S=a[b>>2]|0,a[S+20>>2]=6,R[a[S>>
2]&127](b));S=a[q>>2]|0;G=J+(N<<4)|0;do if(a[r>>2]|0)L=(a[c+92+(S<<2)>>2]|0)+(G<<2)|0,a[L>>2]=(a[L>>2]|0)+1;else if(L=a[c+60+(S<<2)>>2]|0,O=a[L+(G<<2)>>2]|0,X=t[L+1024+G>>0]|0,L=X<<24>>24,0!=X<<24>>24||(X=a[u>>2]|0,T=a[X>>2]|0,a[T+20>>2]=41,R[a[T>>2]&127](X),0==(a[r>>2]|0))){X=(a[v>>2]|0)+L|0;T=((1<<L)+-1&O)<<24-X|a[A>>2];if(7<(X|0)){O=X;for(L=T;;)if(U=L>>>16,P=U&255,W=a[g>>2]|0,a[g>>2]=W+1,t[W>>0]=U,U=(a[h>>2]|0)+-1|0,a[h>>2]=U,U||(U=a[u>>2]|0,W=a[U+24>>2]|0,da[a[W+12>>2]&63](U)|0||(U=a[u>>2]|0,
K=a[U>>2]|0,a[K+20>>2]=25,R[a[K>>2]&127](U)),a[g>>2]=a[W>>2],a[h>>2]=a[W+4>>2]),255==(P|0)&&(W=a[g>>2]|0,a[g>>2]=W+1,t[W>>0]=0,W=(a[h>>2]|0)+-1|0,a[h>>2]=W,W||(W=a[u>>2]|0,U=a[W+24>>2]|0,da[a[U+12>>2]&63](W)|0||(W=a[u>>2]|0,K=a[W>>2]|0,a[K+20>>2]=25,R[a[K>>2]&127](W)),a[g>>2]=a[U>>2],a[h>>2]=a[U+4>>2])),P=L<<8,O=O+-8|0,7>=(O|0)){N=P;break}else L=P;M=X&7}else M=X,N=T;a[A>>2]=N;a[v>>2]=M}while(0);J||(G=a[u>>2]|0,S=a[G>>2]|0,a[S+20>>2]=41,R[a[S>>2]&127](G));if(!(a[r>>2]|0)){G=(a[v>>2]|0)+J|0;S=((1<<
J)+-1&I)<<24-G|a[A>>2];if(7<(G|0)){L=G;for(O=S;;)if(P=O>>>16,N=P&255,M=a[g>>2]|0,a[g>>2]=M+1,t[M>>0]=P,P=(a[h>>2]|0)+-1|0,a[h>>2]=P,P||(P=a[u>>2]|0,M=a[P+24>>2]|0,da[a[M+12>>2]&63](P)|0||(P=a[u>>2]|0,U=a[P>>2]|0,a[U+20>>2]=25,R[a[U>>2]&127](P)),a[g>>2]=a[M>>2],a[h>>2]=a[M+4>>2]),255==(N|0)&&(M=a[g>>2]|0,a[g>>2]=M+1,t[M>>0]=0,M=(a[h>>2]|0)+-1|0,a[h>>2]=M,M||(M=a[u>>2]|0,P=a[M+24>>2]|0,da[a[P+12>>2]&63](M)|0||(M=a[u>>2]|0,U=a[M>>2]|0,a[U+20>>2]=25,R[a[U>>2]&127](M)),a[g>>2]=a[P>>2],a[h>>2]=a[P+4>>2])),
N=O<<8,L=L+-8|0,7>=(L|0)){S=N;break}else O=N;N=G&7}else N=G;G=S;a[A>>2]=G;a[v>>2]=N}I=0}else I=d+1|0;else I=d+1|0;while(0);if((C|0)<(m|0))C=C+1|0,d=I;else{k=I;break}}if(0<(k|0)&&(k=c+128|0,I=(a[k>>2]|0)+1|0,a[k>>2]=I,32767==(I|0))){I=a[c+124>>2]|0;d=c+108|0;if(a[d>>2]|0)m=(a[c+92+(I<<2)>>2]|0)+896|0,a[m>>2]=(a[m>>2]|0)+1,Y=147;else if(C=a[c+60+(I<<2)>>2]|0,m=a[C+896>>2]|0,N=t[C+1248>>0]|0,C=N<<24>>24,N<<24>>24||(N=a[c+120>>2]|0,v=a[N>>2]|0,a[v+20>>2]=41,R[a[v>>2]&127](N)),!(a[d>>2]|0)){N=c+16|0;v=
(a[N>>2]|0)+C|0;G=c+12|0;A=((1<<C)+-1&m)<<24-v|a[G>>2];if(7<(v|0)){m=c+120|0;C=v;for(S=A;!(u=S>>>16,I=u&255,J=a[g>>2]|0,a[g>>2]=J+1,t[J>>0]=u,u=(a[h>>2]|0)+-1|0,a[h>>2]=u,u||(u=a[m>>2]|0,J=a[u+24>>2]|0,da[a[J+12>>2]&63](u)|0||(u=a[m>>2]|0,r=a[u>>2]|0,a[r+20>>2]=25,R[a[r>>2]&127](u)),a[g>>2]=a[J>>2],a[h>>2]=a[J+4>>2]),255==(I|0)&&(I=a[g>>2]|0,a[g>>2]=I+1,t[I>>0]=0,I=(a[h>>2]|0)+-1|0,a[h>>2]=I,0==(I|0))&&(I=a[m>>2]|0,J=a[I+24>>2]|0,da[a[J+12>>2]&63](I)|0||(I=a[m>>2]|0,u=a[I>>2]|0,a[u+20>>2]=25,R[a[u>>
2]&127](I)),a[g>>2]=a[J>>2],a[h>>2]=a[J+4>>2]),J=S<<8,C=C+-8|0,7>=(C|0));)S=J;m=v&7;r=J}else m=v,r=A;a[G>>2]=r;a[N>>2]=m;Y=147}if(147==(Y|0)&&0==(a[d>>2]|0)){Y=c+16|0;m=a[Y>>2]|0;I=m+14|0;N=c+12|0;r=(a[k>>2]&16383)<<10-m|a[N>>2];if(7<(I|0)){m=c+120|0;G=I;for(A=r;!(v=A>>>16,l=v&255,S=a[g>>2]|0,a[g>>2]=S+1,t[S>>0]=v,v=(a[h>>2]|0)+-1|0,a[h>>2]=v,v||(v=a[m>>2]|0,S=a[v+24>>2]|0,da[a[S+12>>2]&63](v)|0||(v=a[m>>2]|0,C=a[v>>2]|0,a[C+20>>2]=25,R[a[C>>2]&127](v)),a[g>>2]=a[S>>2],a[h>>2]=a[S+4>>2]),255==(l|
0)&&(l=a[g>>2]|0,a[g>>2]=l+1,t[l>>0]=0,l=(a[h>>2]|0)+-1|0,a[h>>2]=l,0==(l|0))&&(l=a[m>>2]|0,S=a[l+24>>2]|0,da[a[S+12>>2]&63](l)|0||(l=a[m>>2]|0,v=a[l>>2]|0,a[v+20>>2]=25,R[a[v>>2]&127](l)),a[g>>2]=a[S>>2],a[h>>2]=a[S+4>>2]),S=A<<8,G=G+-8|0,7>=(G|0));)A=S;v=I&7;u=S}else v=I,u=r;a[N>>2]=u;a[Y>>2]=v}a[k>>2]=0;k=c+132|0;v=a[k>>2]|0;a:do if(0!=(v|0)&0==(a[d>>2]|0))for(Y=c+16|0,u=c+12|0,N=c+120|0,r=v,I=a[c+136>>2]|0,v=0;;){if(!v){A=a[Y>>2]|0;G=A+1|0;m=((x[I>>0]|0)&1)<<23-A|a[u>>2];if(7<(G|0)){A=G;for(S=
m;;)if(l=S>>>16,v=l&255,C=a[g>>2]|0,a[g>>2]=C+1,t[C>>0]=l,l=(a[h>>2]|0)+-1|0,a[h>>2]=l,l||(l=a[N>>2]|0,C=a[l+24>>2]|0,da[a[C+12>>2]&63](l)|0||(l=a[N>>2]|0,m=a[l>>2]|0,a[m+20>>2]=25,R[a[m>>2]&127](l)),a[g>>2]=a[C>>2],a[h>>2]=a[C+4>>2]),255==(v|0)&&(v=a[g>>2]|0,a[g>>2]=v+1,t[v>>0]=0,v=(a[h>>2]|0)+-1|0,a[h>>2]=v,0==(v|0))&&(v=a[N>>2]|0,C=a[v+24>>2]|0,da[a[C+12>>2]&63](v)|0||(v=a[N>>2]|0,l=a[v>>2]|0,a[l+20>>2]=25,R[a[l>>2]&127](v)),a[g>>2]=a[C>>2],a[h>>2]=a[C+4>>2]),C=S<<8,A=A+-8|0,7>=(A|0)){A=C;break}else S=
C;v=G&7}else v=G,A=m;a[u>>2]=A;a[Y>>2]=v}S=r+-1|0;if(!S)break a;r=S;I=I+1|0;v=a[d>>2]|0}while(0);a[k>>2]=0}}k=a[e>>2]|0;a[k>>2]=a[g>>2];a[k+4>>2]=a[h>>2];h=a[f>>2]|0;if(!h)return 1;f=c+36|0;(k=a[f>>2]|0)?c=k:(a[f>>2]=h,g=c+40|0,a[g>>2]=(a[g>>2]|0)+1&7,c=h);a[f>>2]=c+-1;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,u,v,x,z,A,C;c=a[b+424>>2]|0;e=b+24|0;f=a[e>>2]|0;g=c+112|0;a[g>>2]=a[f>>2];h=c+116|0;a[h>>2]=a[f+4>>2];f=b+236|0;0!=(a[f>>2]|0)&&0==(a[c+36>>2]|0)&&gi(c,a[c+40>>2]|0);m=
a[b+376>>2]|0;k=b+320|0;b=a[k>>2]|0;if(0<(b|0))for(l=c+108|0,n=c+16|0,p=c+12|0,q=c+120|0,r=b,b=0;;){if(a[l>>2]|0)v=r;else{u=a[n>>2]|0;v=u+1|0;x=((w[a[d+(b<<2)>>2]>>1]|0)>>>m&1)<<23-u|a[p>>2];if(7<(v|0)){for(u=v;;)if(r=x>>>16,z=r&255,A=a[g>>2]|0,a[g>>2]=A+1,t[A>>0]=r,r=(a[h>>2]|0)+-1|0,a[h>>2]=r,r||(r=a[q>>2]|0,A=a[r+24>>2]|0,da[a[A+12>>2]&63](r)|0||(r=a[q>>2]|0,C=a[r>>2]|0,a[C+20>>2]=25,R[a[C>>2]&127](r)),a[g>>2]=a[A>>2],a[h>>2]=a[A+4>>2]),255==(z|0)&&(z=a[g>>2]|0,a[g>>2]=z+1,t[z>>0]=0,z=(a[h>>2]|
0)+-1|0,a[h>>2]=z,0==(z|0))&&(z=a[q>>2]|0,A=a[z+24>>2]|0,da[a[A+12>>2]&63](z)|0||(z=a[q>>2]|0,r=a[z>>2]|0,a[r+20>>2]=25,R[a[r>>2]&127](z)),a[g>>2]=a[A>>2],a[h>>2]=a[A+4>>2]),A=x<<8,u=u+-8|0,7>=(u|0)){x=A;break}else x=A;u=a[k>>2]|0;v&=7}else u=r;a[p>>2]=x;a[n>>2]=v;v=u}b=b+1|0;if((b|0)>=(v|0))break;else r=v}v=a[e>>2]|0;a[v>>2]=a[g>>2];a[v+4>>2]=a[h>>2];h=a[f>>2]|0;if(!h)return 1;f=c+36|0;(v=a[f>>2]|0)?c=v:(a[f>>2]=h,g=c+40|0,a[g>>2]=(a[g>>2]|0)+1&7,c=h);a[f>>2]=c+-1;return 1},function(b,d){b|=0;d|=
0;var c,e,f,g,h,m,k,l,n,p,q,r,v,A,D,z,E,C,F,V=0,S,J=0,I,G=0,L,K,U,W,O,M,T,X=0,P=0,Y,Z,aa=0,ba,ca,fa=0,ja;ja=0;c=u;u=u+256|0;e=a[b+424>>2]|0;f=b+24|0;g=a[f>>2]|0;h=e+112|0;a[h>>2]=a[g>>2];m=e+116|0;a[m>>2]=a[g+4>>2];g=b+236|0;0!=(a[g>>2]|0)&&0==(a[e+36>>2]|0)&&gi(e,a[e+40>>2]|0);k=a[b+368>>2]|0;l=a[b+376>>2]|0;n=a[b+384>>2]|0;p=a[d>>2]|0;d=a[b+364>>2]|0;if(b=(d|0)>(k|0))D=e+136|0,l=e+132|0,z=n=0;else{q=0;for(r=d;;)if(v=w[p+(a[n+(r<<2)>>2]<<1)>>1]|0,A=v<<16>>16,D=(0>v<<16>>16?0-A|0:A)>>l,a[c+(r<<2)>>
2]=D,A=1==(D|0)?r:q,(r|0)<(k|0))q=A,r=r+1|0;else{z=A;break}r=e+136|0;q=e+132|0;if(b)D=r,l=q,z=n=0;else for(b=e+128|0,l=e+124|0,A=e+108|0,D=e+120|0,v=e+16|0,E=e+12|0,C=0,F=(a[r>>2]|0)+(a[q>>2]|0)|0,V=d,d=0;;){S=a[c+(V<<2)>>2]|0;do if(S){if((V|0)>(z|0)|16>(d|0))L=C,K=F,U=d;else for(I=C,J=F,G=d;;){if(U=a[b>>2]|0){W=0;for(O=U;;)if(O>>=1)W=W+1|0;else{K=W;break}14<(K|0)&&(W=a[D>>2]|0,O=a[W>>2]|0,a[O+20>>2]=41,R[a[O>>2]&127](W));W=a[l>>2]|0;O=K<<4;do if(a[A>>2]|0)U=(a[e+92+(W<<2)>>2]|0)+(O<<2)|0,a[U>>2]=
(a[U>>2]|0)+1;else if(U=a[e+60+(W<<2)>>2]|0,M=a[U+(O<<2)>>2]|0,T=t[U+1024+O>>0]|0,U=T<<24>>24,0!=T<<24>>24||(T=a[D>>2]|0,X=a[T>>2]|0,a[X+20>>2]=41,R[a[X>>2]&127](T),0==(a[A>>2]|0))){T=(a[v>>2]|0)+U|0;X=((1<<U)+-1&M)<<24-T|a[E>>2];if(7<(T|0)){M=T;for(U=X;;)if(P=U>>>16,Y=P&255,Z=a[h>>2]|0,a[h>>2]=Z+1,t[Z>>0]=P,P=(a[m>>2]|0)+-1|0,a[m>>2]=P,P||(P=a[D>>2]|0,Z=a[P+24>>2]|0,da[a[Z+12>>2]&63](P)|0||(P=a[D>>2]|0,aa=a[P>>2]|0,a[aa+20>>2]=25,R[a[aa>>2]&127](P)),a[h>>2]=a[Z>>2],a[m>>2]=a[Z+4>>2]),255==(Y|0)&&
(Z=a[h>>2]|0,a[h>>2]=Z+1,t[Z>>0]=0,Z=(a[m>>2]|0)+-1|0,a[m>>2]=Z,Z||(Z=a[D>>2]|0,P=a[Z+24>>2]|0,da[a[P+12>>2]&63](Z)|0||(Z=a[D>>2]|0,aa=a[Z>>2]|0,a[aa+20>>2]=25,R[a[aa>>2]&127](Z)),a[h>>2]=a[P>>2],a[m>>2]=a[P+4>>2])),Y=U<<8,M=M+-8|0,7>=(M|0)){L=Y;break}else U=Y;U=T&7}else U=T,L=X;a[E>>2]=L;a[v>>2]=U}while(0);if(0!=(K|0)&&0==(a[A>>2]|0)){O=(a[v>>2]|0)+K|0;W=(a[b>>2]&(1<<K)+-1)<<24-O|a[E>>2];if(7<(O|0)){U=O;for(M=W;;)if(Y=M>>>16,P=Y&255,Z=a[h>>2]|0,a[h>>2]=Z+1,t[Z>>0]=Y,Y=(a[m>>2]|0)+-1|0,a[m>>2]=Y,
Y||(Y=a[D>>2]|0,Z=a[Y+24>>2]|0,da[a[Z+12>>2]&63](Y)|0||(Y=a[D>>2]|0,aa=a[Y>>2]|0,a[aa+20>>2]=25,R[a[aa>>2]&127](Y)),a[h>>2]=a[Z>>2],a[m>>2]=a[Z+4>>2]),255==(P|0)&&(Z=a[h>>2]|0,a[h>>2]=Z+1,t[Z>>0]=0,Z=(a[m>>2]|0)+-1|0,a[m>>2]=Z,Z||(Z=a[D>>2]|0,Y=a[Z+24>>2]|0,da[a[Y+12>>2]&63](Z)|0||(Z=a[D>>2]|0,aa=a[Z>>2]|0,a[aa+20>>2]=25,R[a[aa>>2]&127](Z)),a[h>>2]=a[Y>>2],a[m>>2]=a[Y+4>>2])),P=M<<8,U=U+-8|0,7>=(U|0)){L=P;break}else M=P;K=O&7}else K=O,L=W;a[E>>2]=L;a[v>>2]=K}a[b>>2]=0;M=a[q>>2]|0;a:do if(0!=(M|0)&
0==(a[A>>2]|0))for(U=M,P=a[r>>2]|0,X=0;;){if(!X){T=a[v>>2]|0;Y=T+1|0;Z=((x[P>>0]|0)&1)<<23-T|a[E>>2];if(7<(Y|0)){T=Y;for(aa=Z;;)if(M=aa>>>16,ba=M&255,ca=a[h>>2]|0,a[h>>2]=ca+1,t[ca>>0]=M,M=(a[m>>2]|0)+-1|0,a[m>>2]=M,M||(M=a[D>>2]|0,ca=a[M+24>>2]|0,da[a[ca+12>>2]&63](M)|0||(M=a[D>>2]|0,K=a[M>>2]|0,a[K+20>>2]=25,R[a[K>>2]&127](M)),a[h>>2]=a[ca>>2],a[m>>2]=a[ca+4>>2]),255==(ba|0)&&(ca=a[h>>2]|0,a[h>>2]=ca+1,t[ca>>0]=0,ca=(a[m>>2]|0)+-1|0,a[m>>2]=ca,ca||(ca=a[D>>2]|0,M=a[ca+24>>2]|0,da[a[M+12>>2]&63](ca)|
0||(ca=a[D>>2]|0,K=a[ca>>2]|0,a[K+20>>2]=25,R[a[K>>2]&127](ca)),a[h>>2]=a[M>>2],a[m>>2]=a[M+4>>2])),ba=aa<<8,T=T+-8|0,7>=(T|0)){K=ba;break}else aa=ba;aa=Y&7}else aa=Y,K=Z;a[E>>2]=K;a[v>>2]=aa}aa=U+-1|0;if(!aa)break a;U=aa;P=P+1|0;X=a[A>>2]|0}while(0);a[q>>2]=0}M=a[l>>2]|0;a:do if(a[A>>2]|0)Z=(a[e+92+(M<<2)>>2]|0)+960|0,a[Z>>2]=(a[Z>>2]|0)+1,fa=83;else if(W=a[e+60+(M<<2)>>2]|0,O=a[W+960>>2]|0,X=t[W+1264>>0]|0,W=X<<24>>24,0==X<<24>>24&&(X=a[D>>2]|0,P=a[X>>2]|0,a[P+20>>2]=41,R[a[P>>2]&127](X),0!=(a[A>>
2]|0)))fa=83;else{X=(a[v>>2]|0)+W|0;P=((1<<W)+-1&O)<<24-X|a[E>>2];if(7<(X|0)){O=X;for(W=P;;)if(U=W>>>16,aa=U&255,T=a[h>>2]|0,a[h>>2]=T+1,t[T>>0]=U,U=(a[m>>2]|0)+-1|0,a[m>>2]=U,U||(U=a[D>>2]|0,T=a[U+24>>2]|0,da[a[T+12>>2]&63](U)|0||(U=a[D>>2]|0,ba=a[U>>2]|0,a[ba+20>>2]=25,R[a[ba>>2]&127](U)),a[h>>2]=a[T>>2],a[m>>2]=a[T+4>>2]),255==(aa|0)&&(T=a[h>>2]|0,a[h>>2]=T+1,t[T>>0]=0,T=(a[m>>2]|0)+-1|0,a[m>>2]=T,T||(T=a[D>>2]|0,U=a[T+24>>2]|0,da[a[U+12>>2]&63](T)|0||(T=a[D>>2]|0,ba=a[T>>2]|0,a[ba+20>>2]=25,R[a[ba>>
2]&127](T)),a[h>>2]=a[U>>2],a[m>>2]=a[U+4>>2])),aa=W<<8,O=O+-8|0,7>=(O|0)){L=aa;break}else W=aa;ja=a[A>>2]|0;K=X&7}else ja=0,K=X,L=P;a[E>>2]=L;a[v>>2]=K;W=G+-16|0;if(0!=(I|0)&0==(ja|0))for(O=I,aa=J,Z=0;;){if(!Z){Y=a[v>>2]|0;U=Y+1|0;T=((x[aa>>0]|0)&1)<<23-Y|a[E>>2];if(7<(U|0)){Y=U;for(ba=T;;)if(M=ba>>>16,ca=M&255,K=a[h>>2]|0,a[h>>2]=K+1,t[K>>0]=M,M=(a[m>>2]|0)+-1|0,a[m>>2]=M,M||(M=a[D>>2]|0,K=a[M+24>>2]|0,da[a[K+12>>2]&63](M)|0||(M=a[D>>2]|0,ja=a[M>>2]|0,a[ja+20>>2]=25,R[a[ja>>2]&127](M)),a[h>>2]=
a[K>>2],a[m>>2]=a[K+4>>2]),255==(ca|0)&&(K=a[h>>2]|0,a[h>>2]=K+1,t[K>>0]=0,K=(a[m>>2]|0)+-1|0,a[m>>2]=K,K||(K=a[D>>2]|0,M=a[K+24>>2]|0,da[a[M+12>>2]&63](K)|0||(K=a[D>>2]|0,ja=a[K>>2]|0,a[ja+20>>2]=25,R[a[ja>>2]&127](K)),a[h>>2]=a[M>>2],a[m>>2]=a[M+4>>2])),ca=ba<<8,Y=Y+-8|0,7>=(Y|0)){J=ca;break}else ba=ca;ja=U&7}else ja=U,J=T;a[E>>2]=J;a[v>>2]=ja}ba=O+-1|0;if(!ba){ja=W;break a}O=ba;aa=aa+1|0;Z=a[A>>2]|0}else ja=W}while(0);83==(fa|0)&&(fa=0,ja=G+-16|0);M=a[r>>2]|0;if(16>(ja|0)){L=0;K=M;U=ja;break}else I=
0,J=M,G=ja}if(1<(S|0))t[K+L>>0]=S&1,J=L+1|0,I=K,G=U;else{if(G=a[b>>2]|0){J=0;for(I=G;;)if(I>>=1)J=J+1|0;else{W=J;break}14<(W|0)&&(J=a[D>>2]|0,I=a[J>>2]|0,a[I+20>>2]=41,R[a[I>>2]&127](J));J=a[l>>2]|0;I=W<<4;do if(a[A>>2]|0)G=(a[e+92+(J<<2)>>2]|0)+(I<<2)|0,a[G>>2]=(a[G>>2]|0)+1;else if(G=a[e+60+(J<<2)>>2]|0,M=a[G+(I<<2)>>2]|0,Z=t[G+1024+I>>0]|0,G=Z<<24>>24,0!=Z<<24>>24||(Z=a[D>>2]|0,aa=a[Z>>2]|0,a[aa+20>>2]=41,R[a[aa>>2]&127](Z),0==(a[A>>2]|0))){Z=(a[v>>2]|0)+G|0;aa=((1<<G)+-1&M)<<24-Z|a[E>>2];if(7<
(Z|0)){M=Z;for(G=aa;;)if(O=G>>>16,P=O&255,X=a[h>>2]|0,a[h>>2]=X+1,t[X>>0]=O,O=(a[m>>2]|0)+-1|0,a[m>>2]=O,O||(O=a[D>>2]|0,X=a[O+24>>2]|0,da[a[X+12>>2]&63](O)|0||(O=a[D>>2]|0,ba=a[O>>2]|0,a[ba+20>>2]=25,R[a[ba>>2]&127](O)),a[h>>2]=a[X>>2],a[m>>2]=a[X+4>>2]),255==(P|0)&&(X=a[h>>2]|0,a[h>>2]=X+1,t[X>>0]=0,X=(a[m>>2]|0)+-1|0,a[m>>2]=X,X||(X=a[D>>2]|0,O=a[X+24>>2]|0,da[a[O+12>>2]&63](X)|0||(X=a[D>>2]|0,ba=a[X>>2]|0,a[ba+20>>2]=25,R[a[ba>>2]&127](X)),a[h>>2]=a[O>>2],a[m>>2]=a[O+4>>2])),P=G<<8,M=M+-8|0,7>=
(M|0)){O=P;break}else G=P;M=Z&7}else M=Z,O=aa;a[E>>2]=O;a[v>>2]=M}while(0);if(0!=(W|0)&&0==(a[A>>2]|0)){I=(a[v>>2]|0)+W|0;J=(a[b>>2]&(1<<W)+-1)<<24-I|a[E>>2];if(7<(I|0)){G=I;for(M=J;;)if(P=M>>>16,W=P&255,O=a[h>>2]|0,a[h>>2]=O+1,t[O>>0]=P,P=(a[m>>2]|0)+-1|0,a[m>>2]=P,P||(P=a[D>>2]|0,O=a[P+24>>2]|0,da[a[O+12>>2]&63](P)|0||(P=a[D>>2]|0,X=a[P>>2]|0,a[X+20>>2]=25,R[a[X>>2]&127](P)),a[h>>2]=a[O>>2],a[m>>2]=a[O+4>>2]),255==(W|0)&&(O=a[h>>2]|0,a[h>>2]=O+1,t[O>>0]=0,O=(a[m>>2]|0)+-1|0,a[m>>2]=O,O||(O=a[D>>
2]|0,P=a[O+24>>2]|0,da[a[P+12>>2]&63](O)|0||(O=a[D>>2]|0,X=a[O>>2]|0,a[X+20>>2]=25,R[a[X>>2]&127](O)),a[h>>2]=a[P>>2],a[m>>2]=a[P+4>>2])),W=M<<8,G=G+-8|0,7>=(G|0)){J=W;break}else M=W;I&=7}a[E>>2]=J;a[v>>2]=I}a[b>>2]=0;M=a[q>>2]|0;a:do if(0!=(M|0)&0==(a[A>>2]|0))for(G=M,W=a[r>>2]|0,aa=0;;){if(!aa){Z=a[v>>2]|0;P=Z+1|0;O=((x[W>>0]|0)&1)<<23-Z|a[E>>2];if(7<(P|0)){Z=P;for(X=O;;)if(ba=X>>>16,Y=ba&255,ca=a[h>>2]|0,a[h>>2]=ca+1,t[ca>>0]=ba,ba=(a[m>>2]|0)+-1|0,a[m>>2]=ba,ba||(ba=a[D>>2]|0,ca=a[ba+24>>2]|0,
da[a[ca+12>>2]&63](ba)|0||(ba=a[D>>2]|0,M=a[ba>>2]|0,a[M+20>>2]=25,R[a[M>>2]&127](ba)),a[h>>2]=a[ca>>2],a[m>>2]=a[ca+4>>2]),255==(Y|0)&&(ca=a[h>>2]|0,a[h>>2]=ca+1,t[ca>>0]=0,ca=(a[m>>2]|0)+-1|0,a[m>>2]=ca,ca||(ca=a[D>>2]|0,ba=a[ca+24>>2]|0,da[a[ba+12>>2]&63](ca)|0||(ca=a[D>>2]|0,M=a[ca>>2]|0,a[M+20>>2]=25,R[a[M>>2]&127](ca)),a[h>>2]=a[ba>>2],a[m>>2]=a[ba+4>>2])),Y=X<<8,Z=Z+-8|0,7>=(Z|0)){J=Y;break}else X=Y;X=P&7}else X=P,J=O;a[E>>2]=J;a[v>>2]=X}X=G+-1|0;if(!X)break a;G=X;W=W+1|0;aa=a[A>>2]|0}while(0);
a[q>>2]=0}M=a[l>>2]|0;J=U<<4|1;a:do if(a[A>>2]|0)W=(a[e+92+(M<<2)>>2]|0)+(J<<2)|0,a[W>>2]=(a[W>>2]|0)+1;else if(I=a[e+60+(M<<2)>>2]|0,aa=a[I+(J<<2)>>2]|0,W=t[I+1024+J>>0]|0,I=W<<24>>24,0!=W<<24>>24||(W=a[D>>2]|0,G=a[W>>2]|0,a[G+20>>2]=41,R[a[G>>2]&127](W),0==(a[A>>2]|0))){W=(a[v>>2]|0)+I|0;G=((1<<I)+-1&aa)<<24-W|a[E>>2];if(7<(W|0)){aa=W;for(I=G;;)if(X=I>>>16,Z=X&255,Y=a[h>>2]|0,a[h>>2]=Y+1,t[Y>>0]=X,X=(a[m>>2]|0)+-1|0,a[m>>2]=X,X||(X=a[D>>2]|0,Y=a[X+24>>2]|0,da[a[Y+12>>2]&63](X)|0||(X=a[D>>2]|0,T=
a[X>>2]|0,a[T+20>>2]=25,R[a[T>>2]&127](X)),a[h>>2]=a[Y>>2],a[m>>2]=a[Y+4>>2]),255==(Z|0)&&(Z=a[h>>2]|0,a[h>>2]=Z+1,t[Z>>0]=0,Z=(a[m>>2]|0)+-1|0,a[m>>2]=Z,0==(Z|0))&&(Z=a[D>>2]|0,Y=a[Z+24>>2]|0,da[a[Y+12>>2]&63](Z)|0||(Z=a[D>>2]|0,X=a[Z>>2]|0,a[X+20>>2]=25,R[a[X>>2]&127](Z)),a[h>>2]=a[Y>>2],a[m>>2]=a[Y+4>>2]),Y=I<<8,aa=aa+-8|0,7>=(aa|0)){O=Y;break}else I=Y;I=a[A>>2]|0;a[E>>2]=O;a[v>>2]=W&7;if(I)break}else a[E>>2]=G,a[v>>2]=W;I=a[v>>2]|0;aa=I+1|0;Y=((N[p+(a[n+(V<<2)>>2]<<1)>>1]|0)>>>15&65535^1)<<23-
I|a[E>>2];if(7<(aa|0)){I=aa;for(Z=Y;;)if(X=Z>>>16,T=X&255,U=a[h>>2]|0,a[h>>2]=U+1,t[U>>0]=X,X=(a[m>>2]|0)+-1|0,a[m>>2]=X,X||(X=a[D>>2]|0,U=a[X+24>>2]|0,da[a[U+12>>2]&63](X)|0||(X=a[D>>2]|0,ba=a[X>>2]|0,a[ba+20>>2]=25,R[a[ba>>2]&127](X)),a[h>>2]=a[U>>2],a[m>>2]=a[U+4>>2]),255==(T|0)&&(U=a[h>>2]|0,a[h>>2]=U+1,t[U>>0]=0,U=(a[m>>2]|0)+-1|0,a[m>>2]=U,U||(U=a[D>>2]|0,X=a[U+24>>2]|0,da[a[X+12>>2]&63](U)|0||(U=a[D>>2]|0,ba=a[U>>2]|0,a[ba+20>>2]=25,R[a[ba>>2]&127](U)),a[h>>2]=a[X>>2],a[m>>2]=a[X+4>>2])),T=
Z<<8,I=I+-8|0,7>=(I|0)){O=T;break}else Z=T;I=a[A>>2]|0;W=aa&7}else I=0,W=aa,O=Y;a[E>>2]=O;a[v>>2]=W;if(0!=(L|0)&0==(I|0))for(Z=L,I=K,W=0;;){if(!W){G=a[v>>2]|0;T=G+1|0;O=((x[I>>0]|0)&1)<<23-G|a[E>>2];if(7<(T|0)){G=T;for(P=O;;)if(X=P>>>16,U=X&255,ba=a[h>>2]|0,a[h>>2]=ba+1,t[ba>>0]=X,X=(a[m>>2]|0)+-1|0,a[m>>2]=X,X||(X=a[D>>2]|0,ba=a[X+24>>2]|0,da[a[ba+12>>2]&63](X)|0||(X=a[D>>2]|0,ca=a[X>>2]|0,a[ca+20>>2]=25,R[a[ca>>2]&127](X)),a[h>>2]=a[ba>>2],a[m>>2]=a[ba+4>>2]),255==(U|0)&&(ba=a[h>>2]|0,a[h>>2]=ba+
1,t[ba>>0]=0,ba=(a[m>>2]|0)+-1|0,a[m>>2]=ba,ba||(ba=a[D>>2]|0,X=a[ba+24>>2]|0,da[a[X+12>>2]&63](ba)|0||(ba=a[D>>2]|0,ca=a[ba>>2]|0,a[ca+20>>2]=25,R[a[ca>>2]&127](ba)),a[h>>2]=a[X>>2],a[m>>2]=a[X+4>>2])),U=P<<8,G=G+-8|0,7>=(G|0)){G=U;break}else P=U;P=T&7}else P=T,G=O;a[E>>2]=G;a[v>>2]=P}P=Z+-1|0;if(!P)break a;Z=P;I=I+1|0;W=a[A>>2]|0}}while(0);J=0;I=a[r>>2]|0;G=0}}else J=C,I=F,G=d+1|0;while(0);if((V|0)<(k|0))C=J,F=I,V=V+1|0,d=G;else{D=r;l=q;n=J;z=G;break}}}if(0<(z|0)|0!=(n|0)&&(z=e+128|0,G=(a[z>>2]|
0)+1|0,a[z>>2]=G,J=(a[l>>2]|0)+n|0,a[l>>2]=J,!(0==(G|0)|938>J>>>0&32767!=(G|0)))){J=0;for(n=G;;)if(n>>=1)J=J+1|0;else{p=J;break}14<(p|0)&&(J=a[e+120>>2]|0,n=a[J>>2]|0,a[n+20>>2]=41,R[a[n>>2]&127](J));J=a[e+124>>2]|0;n=p<<4;G=e+108|0;do if(a[G>>2]|0)C=(a[e+92+(J<<2)>>2]|0)+(n<<2)|0,a[C>>2]=(a[C>>2]|0)+1;else if(q=a[e+60+(J<<2)>>2]|0,r=a[q+(n<<2)>>2]|0,d=t[q+1024+n>>0]|0,q=d<<24>>24,0!=d<<24>>24||(d=a[e+120>>2]|0,V=a[d>>2]|0,a[V+20>>2]=41,R[a[V>>2]&127](d),0==(a[G>>2]|0))){d=e+16|0;V=(a[d>>2]|0)+q|
0;I=e+12|0;F=((1<<q)+-1&r)<<24-V|a[I>>2];if(7<(V|0)){r=e+120|0;q=V;for(C=F;;)if(k=C>>>16,A=k&255,P=a[h>>2]|0,a[h>>2]=P+1,t[P>>0]=k,k=(a[m>>2]|0)+-1|0,a[m>>2]=k,k||(k=a[r>>2]|0,P=a[k+24>>2]|0,da[a[P+12>>2]&63](k)|0||(k=a[r>>2]|0,v=a[k>>2]|0,a[v+20>>2]=25,R[a[v>>2]&127](k)),a[h>>2]=a[P>>2],a[m>>2]=a[P+4>>2]),255==(A|0)&&(A=a[h>>2]|0,a[h>>2]=A+1,t[A>>0]=0,A=(a[m>>2]|0)+-1|0,a[m>>2]=A,0==(A|0))&&(A=a[r>>2]|0,P=a[A+24>>2]|0,da[a[P+12>>2]&63](A)|0||(A=a[r>>2]|0,k=a[A>>2]|0,a[k+20>>2]=25,R[a[k>>2]&127](A)),
a[h>>2]=a[P>>2],a[m>>2]=a[P+4>>2]),P=C<<8,q=q+-8|0,7>=(q|0)){v=P;break}else C=P;k=V&7;F=v}else k=V;a[I>>2]=F;a[d>>2]=k}while(0);if(0!=(p|0)&&0==(a[G>>2]|0)){n=e+16|0;J=(a[n>>2]|0)+p|0;k=e+12|0;F=(a[z>>2]&(1<<p)+-1)<<24-J|a[k>>2];if(7<(J|0)){p=e+120|0;v=J;for(C=F;!(q=C>>>16,r=q&255,P=a[h>>2]|0,a[h>>2]=P+1,t[P>>0]=q,q=(a[m>>2]|0)+-1|0,a[m>>2]=q,q||(q=a[p>>2]|0,P=a[q+24>>2]|0,da[a[P+12>>2]&63](q)|0||(q=a[p>>2]|0,A=a[q>>2]|0,a[A+20>>2]=25,R[a[A>>2]&127](q)),a[h>>2]=a[P>>2],a[m>>2]=a[P+4>>2]),255==(r|
0)&&(r=a[h>>2]|0,a[h>>2]=r+1,t[r>>0]=0,r=(a[m>>2]|0)+-1|0,a[m>>2]=r,0==(r|0))&&(r=a[p>>2]|0,P=a[r+24>>2]|0,da[a[P+12>>2]&63](r)|0||(r=a[p>>2]|0,q=a[r>>2]|0,a[q+20>>2]=25,R[a[q>>2]&127](r)),a[h>>2]=a[P>>2],a[m>>2]=a[P+4>>2]),P=C<<8,v=v+-8|0,7>=(v|0));)C=P;V=J&7;E=P}else V=J,E=F;a[k>>2]=E;a[n>>2]=V}a[z>>2]=0;z=a[l>>2]|0;a:do if(0!=(z|0)&0==(a[G>>2]|0))for(V=e+16|0,n=e+12|0,E=e+120|0,k=z,F=a[D>>2]|0,J=0;;){if(!J){D=a[V>>2]|0;C=D+1|0;v=((x[F>>0]|0)&1)<<23-D|a[n>>2];if(7<(C|0)){D=C;for(p=v;!(P=p>>>16,
r=P&255,q=a[h>>2]|0,a[h>>2]=q+1,t[q>>0]=P,P=(a[m>>2]|0)+-1|0,a[m>>2]=P,P||(P=a[E>>2]|0,q=a[P+24>>2]|0,da[a[q+12>>2]&63](P)|0||(P=a[E>>2]|0,A=a[P>>2]|0,a[A+20>>2]=25,R[a[A>>2]&127](P)),a[h>>2]=a[q>>2],a[m>>2]=a[q+4>>2]),255==(r|0)&&(r=a[h>>2]|0,a[h>>2]=r+1,t[r>>0]=0,r=(a[m>>2]|0)+-1|0,a[m>>2]=r,0==(r|0))&&(r=a[E>>2]|0,q=a[r+24>>2]|0,da[a[q+12>>2]&63](r)|0||(r=a[E>>2]|0,P=a[r>>2]|0,a[P+20>>2]=25,R[a[P>>2]&127](r)),a[h>>2]=a[q>>2],a[m>>2]=a[q+4>>2]),q=p<<8,D=D+-8|0,7>=(D|0));)p=q;C&=7}else q=v;a[n>>
2]=q;a[V>>2]=C}p=k+-1|0;if(!p)break a;k=p;F=F+1|0;J=a[G>>2]|0}while(0);a[l>>2]=0}l=a[f>>2]|0;a[l>>2]=a[h>>2];a[l+4>>2]=a[m>>2];m=a[g>>2]|0;if(!m)return u=c,1;g=e+36|0;(l=a[g>>2]|0)?e=l:(a[g>>2]=m,h=e+40|0,a[h>>2]=(a[h>>2]|0)+1&7,e=m);a[g>>2]=e+-1;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,t,u,v,z,x,A;c=a[b+424>>2]|0;e=b+236|0;if(f=a[e>>2]|0){g=c+36|0;if(h=a[g>>2]|0)n=h;else{m=b+292|0;if(0<(a[m>>2]|0)){k=0;do a[c+20+(k<<2)>>2]=0,k=k+1|0;while((k|0)<(a[m>>2]|0));l=a[e>>2]|0}else l=
f;n=a[g>>2]=l}a[g>>2]=n+-1}n=b+320|0;if(0>=(a[n>>2]|0))return 1;g=b+388|0;h=b+384|0;l=0;do{f=a[b+324+(l<<2)>>2]|0;e=a[b+296+(f<<2)>>2]|0;m=d+(l<<2)|0;k=a[m>>2]|0;p=c+20+(f<<2)|0;f=a[c+76+(a[e+20>>2]<<2)>>2]|0;q=a[c+92+(a[e+24>>2]<<2)>>2]|0;e=a[g>>2]|0;r=a[h>>2]|0;t=(w[k>>1]|0)-(a[p>>2]|0)|0;if(u=0>(t|0)?0-t|0:t){t=0;for(v=u;;)if(u=t+1|0,v>>=1)t=u;else{v=u;break}10<(t|0)&&(t=a[b>>2]|0,a[t+20>>2]=6,R[a[t>>2]&127](b));t=v}else t=0;t=f+(t<<2)|0;a[t>>2]=(a[t>>2]|0)+1;if(1<=(e|0)){t=q+960|0;v=1;for(u=0;;){f=
w[k+(a[r+(v<<2)>>2]<<1)>>1]|0;z=f<<16>>16;if(f<<16>>16){15<(u|0)?(x=u+-16|0,u=x>>>4,a[t>>2]=u+1+(a[t>>2]|0),A=x-(u<<4)|0):A=u;u=1;for(x=0>f<<16>>16?0-z|0:z;;)if(x>>=1)u=u+1|0;else{f=u;break}10<(f|0)&&(u=a[b>>2]|0,a[u+20>>2]=6,R[a[u>>2]&127](b));u=q+(f+(A<<4)<<2)|0;a[u>>2]=(a[u>>2]|0)+1;f=0}else f=u+1|0;if((v|0)==(e|0)){e=f;break}else v=v+1|0,u=f}0<(e|0)&&(a[q>>2]=(a[q>>2]|0)+1)}a[p>>2]=w[a[m>>2]>>1];l=l+1|0}while((l|0)<(a[n>>2]|0));return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,v,x,
A,z,D,C,E,F=0,N=0,J,I,G,L,K,S,U,O,M,T,X,P;c=u;u=u+48|0;e=a[b+424>>2]|0;f=b+24|0;g=a[f>>2]|0;h=a[g>>2]|0;a[c>>2]=h;m=c+4|0;a[m>>2]=a[g+4>>2];g=c+8|0;k=e+12|0;a[g>>2]=a[k>>2];a[g+4>>2]=a[k+4>>2];a[g+8>>2]=a[k+8>>2];a[g+12>>2]=a[k+12>>2];a[g+16>>2]=a[k+16>>2];a[g+20>>2]=a[k+20>>2];l=c+32|0;a[l>>2]=b;n=b+236|0;p=h;if(0!=(a[n>>2]|0)&&0==(a[e+36>>2]|0)){h=a[e+40>>2]|0;q=c+12|0;r=a[q>>2]|0;v=c+8|0;do if(0<(r|0)){x=p;A=r+7|0;for(z=a[v>>2]|127<<17-r;;){D=z>>>16;C=D&255;a[c>>2]=x+1;t[x>>0]=D;D=(a[m>>2]|0)+
-1|0;a[m>>2]=D;if(!D){D=a[l>>2]|0;E=a[D+24>>2]|0;if(!(da[a[E+12>>2]&63](D)|0)){F=0;x=116;break}a[c>>2]=a[E>>2];a[m>>2]=a[E+4>>2]}if(255==(C|0)&&(C=a[c>>2]|0,a[c>>2]=C+1,t[C>>0]=0,C=(a[m>>2]|0)+-1|0,a[m>>2]=C,0==(C|0))){C=a[l>>2]|0;E=a[C+24>>2]|0;if(!(da[a[E+12>>2]&63](C)|0)){F=0;x=116;break}a[c>>2]=a[E>>2];a[m>>2]=a[E+4>>2]}E=A+-8|0;if(7>=(E|0)){x=14;break}x=a[c>>2]|0;A=E;z<<=8}if(14==(x|0))N=a[c>>2]|0;else if(116==(x|0))return u=c,F|0}else N=p;while(0);a[v>>2]=0;a[q>>2]=0;a[c>>2]=N+1;t[N>>0]=-1;
N=(a[m>>2]|0)+-1|0;if(a[m>>2]=N)J=a[c>>2]|0;else if(q=a[l>>2]|0,v=a[q+24>>2]|0,da[a[v+12>>2]&63](q)|0)q=a[v>>2]|0,a[c>>2]=q,a[m>>2]=a[v+4>>2],J=q;else return u=c,0;a[c>>2]=J+1;t[J>>0]=h+208;h=(a[m>>2]|0)+-1|0;a[m>>2]=h;J=a[l>>2]|0;if(!h)if(N=a[J+24>>2]|0,da[a[N+12>>2]&63](J)|0)a[c>>2]=a[N>>2],a[m>>2]=a[N+4>>2];else return u=c,0;if(0<(a[J+292>>2]|0)){h=0;do a[c+16+(h<<2)>>2]=0,h=h+1|0,N=a[l>>2]|0;while((h|0)<(a[N+292>>2]|0));I=N}else I=J}else I=b;J=b+320|0;a:do if(0<(a[J>>2]|0)){h=c+12|0;N=c+8|0;q=
I;v=0;b:for(;;){p=a[b+324+(v<<2)>>2]|0;r=a[b+296+(p<<2)>>2]|0;z=d+(v<<2)|0;A=a[z>>2]|0;x=c+16+(p<<2)|0;p=a[e+44+(a[r+20>>2]<<2)>>2]|0;E=a[e+60+(a[r+24>>2]<<2)>>2]|0;r=a[q+388>>2]|0;C=a[q+384>>2]|0;D=(w[A>>1]|0)-(a[x>>2]|0)|0;G=(D>>31)+D|0;if(F=0>(D|0)?0-D|0:D){D=0;for(L=F;;)if(F=D+1|0,L>>=1)D=F;else{K=D;break}10<(K|0)&&(D=a[q>>2]|0,a[D+20>>2]=6,R[a[D>>2]&127](q));S=F}else S=0;D=a[p+(S<<2)>>2]|0;L=t[p+1024+S>>0]|0;F=L<<24>>24;L<<24>>24||(L=a[q>>2]|0,a[L+20>>2]=41,R[a[L>>2]&127](q));L=(a[h>>2]|0)+F|
0;F=((1<<F)+-1&D)<<24-L|a[N>>2];if(7<(L|0))for(D=L;;){K=F>>>16;q=K&255;U=a[c>>2]|0;a[c>>2]=U+1;t[U>>0]=K;K=(a[m>>2]|0)+-1|0;a[m>>2]=K;if(!K){K=a[l>>2]|0;U=a[K+24>>2]|0;if(!(da[a[U+12>>2]&63](K)|0)){F=0;x=116;break b}a[c>>2]=a[U>>2];a[m>>2]=a[U+4>>2]}if(255==(q|0)&&(q=a[c>>2]|0,a[c>>2]=q+1,t[q>>0]=0,q=(a[m>>2]|0)+-1|0,a[m>>2]=q,0==(q|0))){q=a[l>>2]|0;U=a[q+24>>2]|0;if(!(da[a[U+12>>2]&63](q)|0)){F=0;x=116;break b}a[c>>2]=a[U>>2];a[m>>2]=a[U+4>>2]}U=F<<8;q=D+-8|0;if(7<(q|0))D=q,F=U;else{p=U;break}}else p=
F,q=L;a[N>>2]=p;a[h>>2]=q;if(S){F=q+S|0;D=((1<<S)+-1&G)<<24-F|p;if(7<(F|0))for(p=F,q=D;;){U=q>>>16;K=U&255;D=a[c>>2]|0;a[c>>2]=D+1;t[D>>0]=U;U=(a[m>>2]|0)+-1|0;a[m>>2]=U;if(!U){U=a[l>>2]|0;D=a[U+24>>2]|0;if(!(da[a[D+12>>2]&63](U)|0)){F=0;x=116;break b}a[c>>2]=a[D>>2];a[m>>2]=a[D+4>>2]}if(255==(K|0)&&(K=a[c>>2]|0,a[c>>2]=K+1,t[K>>0]=0,K=(a[m>>2]|0)+-1|0,a[m>>2]=K,0==(K|0))){K=a[l>>2]|0;D=a[K+24>>2]|0;if(!(da[a[D+12>>2]&63](K)|0)){F=0;x=116;break b}a[c>>2]=a[D>>2];a[m>>2]=a[D+4>>2]}D=q<<8;K=p+-8|0;
if(7<(K|0))p=K,q=D;else{p=K;q=D;break}}else p=F,q=D;a[N>>2]=q;a[h>>2]=p;F=q;K=p}else F=p,K=q;if(1<=(r|0)){q=E+960|0;p=E+1264|0;G=F;L=K;F=1;for(D=0;;){K=w[A+(a[C+(F<<2)>>2]<<1)>>1]|0;U=K<<16>>16;if(K<<16>>16){if(15<(D|0))for(;;){O=a[q>>2]|0;M=t[p>>0]|0;S=M<<24>>24;M<<24>>24||(M=a[l>>2]|0,T=a[M>>2]|0,a[T+20>>2]=41,R[a[T>>2]&127](M));M=L+S|0;T=((1<<S)+-1&O)<<24-M|G;if(7<(M|0))for(O=M,S=T;;){X=S>>>16;T=X&255;P=a[c>>2]|0;a[c>>2]=P+1;t[P>>0]=X;X=(a[m>>2]|0)+-1|0;a[m>>2]=X;if(!X){X=a[l>>2]|0;P=a[X+24>>2]|
0;if(!(da[a[P+12>>2]&63](X)|0)){F=0;x=116;break b}a[c>>2]=a[P>>2];a[m>>2]=a[P+4>>2]}do if(255==(T|0)&&(P=a[c>>2]|0,a[c>>2]=P+1,t[P>>0]=0,P=(a[m>>2]|0)+-1|0,a[m>>2]=P,!P)){P=a[l>>2]|0;X=a[P+24>>2]|0;if(!(da[a[X+12>>2]&63](P)|0)){F=0;x=116;break b}a[c>>2]=a[X>>2];a[m>>2]=a[X+4>>2]}while(0);T=S<<8;X=O+-8|0;if(7<(X|0))O=X,S=T;else{G=X;M=T;break}}else G=M,M=T;a[N>>2]=M;a[h>>2]=G;S=D+-16|0;if(15<(S|0))L=G,G=M,D=S;else{X=G;T=M;break}}else X=L,T=G,S=D;D=K<<16>>16>>15;G=1;for(L=0>K<<16>>16?0-U|0:U;;)if(L>>=
1)G=G+1|0;else{M=G;break}G=(D<<16>>16)+U|0;10<(M|0)&&(L=a[l>>2]|0,K=a[L>>2]|0,a[K+20>>2]=6,R[a[K>>2]&127](L));L=M+(S<<4)|0;K=a[E+(L<<2)>>2]|0;S=t[E+1024+L>>0]|0;L=S<<24>>24;S<<24>>24||(S=a[l>>2]|0,O=a[S>>2]|0,a[O+20>>2]=41,R[a[O>>2]&127](S));S=X+L|0;O=((1<<L)+-1&K)<<24-S|T;if(7<(S|0))for(K=S,L=O;;){T=L>>>16;X=T&255;P=a[c>>2]|0;a[c>>2]=P+1;t[P>>0]=T;T=(a[m>>2]|0)+-1|0;a[m>>2]=T;if(!T){T=a[l>>2]|0;P=a[T+24>>2]|0;if(!(da[a[P+12>>2]&63](T)|0)){F=0;x=116;break b}a[c>>2]=a[P>>2];a[m>>2]=a[P+4>>2]}do if(255==
(X|0)&&(P=a[c>>2]|0,a[c>>2]=P+1,t[P>>0]=0,P=(a[m>>2]|0)+-1|0,a[m>>2]=P,!P)){P=a[l>>2]|0;T=a[P+24>>2]|0;if(!(da[a[T+12>>2]&63](P)|0)){F=0;x=116;break b}a[c>>2]=a[T>>2];a[m>>2]=a[T+4>>2]}while(0);X=L<<8;T=K+-8|0;if(7<(T|0))K=T,L=X;else{U=T;D=X;break}}else U=S,D=O;a[N>>2]=D;a[h>>2]=U;M||(L=a[l>>2]|0,K=a[L>>2]|0,a[K+20>>2]=41,R[a[K>>2]&127](L));L=U+M|0;K=((1<<M)+-1&G)<<24-L|D;if(7<(L|0))for(U=L,D=K;;){X=D>>>16;T=X&255;M=a[c>>2]|0;a[c>>2]=M+1;t[M>>0]=X;X=(a[m>>2]|0)+-1|0;a[m>>2]=X;if(!X){X=a[l>>2]|0;M=
a[X+24>>2]|0;if(!(da[a[M+12>>2]&63](X)|0)){F=0;x=116;break b}a[c>>2]=a[M>>2];a[m>>2]=a[M+4>>2]}do if(255==(T|0)&&(M=a[c>>2]|0,a[c>>2]=M+1,t[M>>0]=0,M=(a[m>>2]|0)+-1|0,a[m>>2]=M,!M)){M=a[l>>2]|0;X=a[M+24>>2]|0;if(!(da[a[X+12>>2]&63](M)|0)){F=0;x=116;break b}a[c>>2]=a[X>>2];a[m>>2]=a[X+4>>2]}while(0);T=D<<8;X=U+-8|0;if(7<(X|0))U=X,D=T;else{U=X;K=T;break}}else U=L;a[N>>2]=K;a[h>>2]=U;G=K;K=0}else U=L,K=D+1|0;if((F|0)<(r|0))L=U,F=F+1|0,D=K;else{r=U;A=G;C=K;break}}if(0<(C|0)){D=a[E>>2]|0;F=t[E+1024>>0]|
0;L=F<<24>>24;F<<24>>24||(F=a[l>>2]|0,G=a[F>>2]|0,a[G+20>>2]=41,R[a[G>>2]&127](F));F=r+L|0;G=((1<<L)+-1&D)<<24-F|A;if(7<(F|0))for(D=F,L=G;;){r=L>>>16;p=r&255;q=a[c>>2]|0;a[c>>2]=q+1;t[q>>0]=r;r=(a[m>>2]|0)+-1|0;a[m>>2]=r;if(!r){r=a[l>>2]|0;q=a[r+24>>2]|0;if(!(da[a[q+12>>2]&63](r)|0)){F=0;x=116;break b}a[c>>2]=a[q>>2];a[m>>2]=a[q+4>>2]}if(255==(p|0)&&(p=a[c>>2]|0,a[c>>2]=p+1,t[p>>0]=0,p=(a[m>>2]|0)+-1|0,a[m>>2]=p,0==(p|0))){p=a[l>>2]|0;q=a[p+24>>2]|0;if(!(da[a[q+12>>2]&63](p)|0)){F=0;x=116;break b}a[c>>
2]=a[q>>2];a[m>>2]=a[q+4>>2]}q=L<<8;p=D+-8|0;if(7<(p|0))D=p,L=q;else{E=p;r=q;break}}else E=F,r=G;a[N>>2]=r;a[h>>2]=E}}a[x>>2]=w[a[z>>2]>>1];L=v+1|0;if((L|0)>=(a[J>>2]|0))break a;q=a[l>>2]|0;v=L}if(116==(x|0))return u=c,F|0}while(0);x=a[f>>2]|0;a[x>>2]=a[c>>2];a[x+4>>2]=a[m>>2];a[k>>2]=a[g>>2];a[k+4>>2]=a[g+4>>2];a[k+8>>2]=a[g+8>>2];a[k+12>>2]=a[g+12>>2];a[k+16>>2]=a[g+16>>2];a[k+20>>2]=a[g+20>>2];g=a[n>>2]|0;if(!g)return u=c,1;n=e+36|0;(k=a[n>>2]|0)?e=k:(a[n>>2]=g,m=e+40|0,a[m>>2]=(a[m>>2]|0)+1&7,
e=g);a[n>>2]=e+-1;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,t,u=0;c=a[b+468>>2]|0;a[b+280>>2]|0&&(e=c+56|0,(f=a[e>>2]|0)?g=f:(hi(b),g=a[e>>2]|0),a[e>>2]=g+-1);g=c+20|0;if(-1==(a[g>>2]|0))return 1;e=b+368|0;if(0>=(a[e>>2]|0))return 1;f=b+424|0;h=0;a:for(;;){m=a[d+(h<<2)>>2]|0;k=a[b+372+(h<<2)>>2]|0;l=a[(a[b+344+(k<<2)>>2]|0)+20>>2]|0;n=c+60+(l<<2)|0;p=a[n>>2]|0;q=c+40+(k<<2)|0;r=a[q>>2]|0;if(Cc(b,p+r|0)|0){t=Cc(b,p+(r+1)|0)|0;p=p+(r+2+t)|0;if(r=Cc(b,p)|0)if(p=(a[n>>2]|0)+20|
0,Cc(b,p)|0)for(n=r,r=p;;){p=n<<1;if(32768==(p|0))break a;r=r+1|0;if(Cc(b,r)|0)n=p;else{n=p;p=r;break}}else n=r;else n=0;(n|0)>=(1<<(x[b+232+l>>0]|0)>>1|0)?(r=t<<2,a[q>>2]=(n|0)>(1<<(x[b+248+l>>0]|0)>>1|0)?r+12:r+4):a[q>>2]=0;q=p+14|0;if(l=n>>1)for(p=l,l=n;;)if(r=0==(Cc(b,q)|0),n=(r?0:p)|l,p>>=1)l=n;else{q=n;break}else q=n;l=c+24+(k<<2)|0;p=(a[l>>2]|0)+(0==(t|0)?q+1|0:~q)|0;k=a[l>>2]=p}else a[q>>2]=0,k=a[c+24+(k<<2)>>2]|0;w[m>>1]=k<<a[f>>2];h=h+1|0;if((h|0)>=(a[e>>2]|0)){u=24;break}}if(24==(u|0))return 1;
u=a[b>>2]|0;a[u+20>>2]=117;ub[a[u+4>>2]&31](b,-1);a[g>>2]=-1;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,t,u,v;c=a[b+468>>2]|0;a[b+280>>2]|0&&(e=c+56|0,(f=a[e>>2]|0)?g=f:(hi(b),g=a[e>>2]|0),a[e>>2]=g+-1);g=c+20|0;if(-1==(a[g>>2]|0))return 1;e=a[b+432>>2]|0;f=a[d>>2]|0;d=a[(a[b+344>>2]|0)+24>>2]|0;h=c+124+(d<<2)|0;m=b+416|0;k=c+188|0;c=b+424|0;l=b+264+d|0;d=(a[b+412>>2]|0)+-1|0;a:for(;;){n=(a[h>>2]|0)+(3*d|0)|0;if(Cc(b,n)|0){c=20;break}else p=d,q=n;for(;;){n=p;p=p+1|0;if(Cc(b,q+1|
0)|0){r=n;break}if((p|0)>=(a[m>>2]|0)){c=10;break a}else q=q+3|0}n=Cc(b,k)|0;q=q+2|0;if(t=Cc(b,q)|0){if(Cc(b,q)|0)if(q=t<<1,u=(a[h>>2]|0)+((r|0)<(x[l>>0]|0)?189:217)|0,Cc(b,u)|0)for(v=q,q=u;;){u=v<<1;if(32768==(u|0)){c=15;break a}t=q+1|0;if(Cc(b,t)|0)v=u,q=t;else{r=u;q=t;break}}else r=q,q=u;else r=t;q=q+14|0;if(v=r>>1)for(t=v,v=r;;)if(u=0==(Cc(b,q)|0),r=(u?0:t)|v,t>>=1)v=r;else{q=r;break}else q=r}else q=0;w[f+(a[e+(p<<2)>>2]<<1)>>1]=(0==(n|0)?q+1|0:~q)<<a[c>>2];if((p|0)<(a[m>>2]|0))d=p;else{c=20;
break}}return 10==(c|0)||15==(c|0)?(p=a[b>>2]|0,a[p+20>>2]=117,ub[a[p+4>>2]&31](b,-1),a[g>>2]=-1,1):20==(c|0)?1:0},function(b,d){b|=0;d|=0;var c,e,f,g,h;c=a[b+468>>2]|0;a[b+280>>2]|0&&(e=c+56|0,(f=a[e>>2]|0)?g=f:(hi(b),g=a[e>>2]|0),a[e>>2]=g+-1);g=c+188|0;c=1<<a[b+424>>2];e=b+368|0;if(0<(a[e>>2]|0))h=0;else return 1;do Cc(b,g)|0&&(f=a[d+(h<<2)>>2]|0,w[f>>1]=N[f>>1]|0|c),h=h+1|0;while((h|0)<(a[e>>2]|0));return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,t,u=0,v=0,z=0,x=0,A=0,D;D=0;c=a[b+
468>>2]|0;a[b+280>>2]|0&&(e=c+56|0,(f=a[e>>2]|0)?g=f:(hi(b),g=a[e>>2]|0),a[e>>2]=g+-1);g=c+20|0;if(-1==(a[g>>2]|0))return 1;e=a[b+432>>2]|0;f=a[d>>2]|0;d=a[(a[b+344>>2]|0)+24>>2]|0;h=a[b+424>>2]|0;m=1<<h;k=-1<<h;h=b+416|0;for(l=a[h>>2]|0;;){if(w[f+(a[e+(l<<2)>>2]<<1)>>1]|0){n=l;break}l=l+-1|0;if(!l){n=0;break}}l=c+124+(d<<2)|0;d=c+188|0;c=m&65535;p=k&65535;q=(a[b+412>>2]|0)+-1|0;a:for(;;){r=(a[l>>2]|0)+(3*q|0)|0;if((q|0)>=(n|0)&&0!=(Cc(b,r)|0)){r=24;break}else t=r;for(;;){q=q+1|0;r=f+(a[e+(q<<2)>>
2]<<1)|0;if(w[r>>1]|0){u=q;v=r;z=t;r=13;break}if(Cc(b,t+1|0)|0){x=q;A=r;r=18;break}if((q|0)>=(a[h>>2]|0)){r=22;break a}else t=t+3|0}13==(r|0)?(Cc(b,z+2|0)|0&&(r=w[v>>1]|0,D=r<<16>>16,w[v>>1]=0>r<<16>>16?D+k:D+m),D=u):18==(r|0)&&(Cc(b,d)|0?w[A>>1]=p:w[A>>1]=c,D=x);if((D|0)<(a[h>>2]|0))q=D;else{r=24;break}}return 22==(r|0)?(D=a[b>>2]|0,a[D+20>>2]=117,ub[a[D+4>>2]&31](b,-1),a[g>>2]=-1,1):24==(r|0)?1:0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,t,u,v,z,A,C;c=a[b+468>>2]|0;a[b+280>>2]|0&&(e=
c+56|0,(f=a[e>>2]|0)?g=f:(hi(b),g=a[e>>2]|0),a[e>>2]=g+-1);g=c+20|0;if(-1==(a[g>>2]|0))return 1;e=a[b+432>>2]|0;f=b+368|0;if(0>=(a[f>>2]|0))return 1;h=b+436|0;m=c+188|0;k=0;a:for(;;){l=a[d+(k<<2)>>2]|0;n=a[b+372+(k<<2)>>2]|0;p=a[b+344+(n<<2)>>2]|0;q=a[p+20>>2]|0;r=c+60+(q<<2)|0;t=a[r>>2]|0;u=c+40+(n<<2)|0;v=a[u>>2]|0;if(Cc(b,t+v|0)|0){z=Cc(b,t+(v+1)|0)|0;t=t+(v+2+z)|0;if(v=Cc(b,t)|0)if(t=(a[r>>2]|0)+20|0,Cc(b,t)|0)for(r=v,v=t;;){t=r<<1;if(32768==(t|0)){c=13;break a}A=v+1|0;if(Cc(b,A)|0)r=t,v=A;else{r=
t;t=A;break}}else r=v;else r=0;(r|0)>=(1<<(x[b+232+q>>0]|0)>>1|0)?(v=z<<2,a[u>>2]=(r|0)>(1<<(x[b+248+q>>0]|0)>>1|0)?v+12:v+4):a[u>>2]=0;u=t+14|0;if(q=r>>1)for(t=q,q=r;;)if(v=0==(Cc(b,u)|0),r=(v?0:t)|q,t>>=1)q=r;else{u=r;break}else u=r;q=c+24+(n<<2)|0;t=(a[q>>2]|0)+(0==(z|0)?u+1|0:~u)|0;q=a[q>>2]=t}else a[u>>2]=0,q=a[c+24+(n<<2)>>2]|0;w[l>>1]=q;b:do if(a[h>>2]|0)for(t=a[p+24>>2]|0,q=c+124+(t<<2)|0,u=b+264+t|0,t=0;;){r=(a[q>>2]|0)+(3*t|0)|0;if(Cc(b,r)|0)break b;else n=t,t=r;for(;;){r=n;n=n+1|0;if(Cc(b,
t+1|0)|0){z=r;break}if((n|0)>=(a[h>>2]|0)){c=28;break a}else t=t+3|0}r=Cc(b,m)|0;v=t+2|0;if(A=Cc(b,v)|0){if(Cc(b,v)|0)if(t=A<<1,A=(a[q>>2]|0)+((z|0)<(x[u>>0]|0)?189:217)|0,Cc(b,A)|0)for(C=t,t=A;;){A=C<<1;if(32768==(A|0)){c=33;break a}v=t+1|0;if(Cc(b,v)|0)C=A,t=v;else{z=A;t=v;break}}else z=t,t=A;else z=A,t=v;t=t+14|0;if(C=z>>1)for(v=C,C=z;;)if(A=0==(Cc(b,t)|0),z=(A?0:v)|C,v>>=1)C=z;else{t=z;break}else t=z}else t=0;w[l+(a[e+(n<<2)>>2]<<1)>>1]=0==(r|0)?t+1|0:t^65535;if((n|0)<(a[h>>2]|0))t=n;else break}while(0);
k=k+1|0;if((k|0)>=(a[f>>2]|0)){c=39;break}}return 13==(c|0)||28==(c|0)||33==(c|0)?(f=a[b>>2]|0,a[f+20>>2]=117,ub[a[f+4>>2]&31](b,-1),a[g>>2]=-1,1):39==(c|0)?1:0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q=0,r=0,t,u,v,w,x,A,D,F,N;c=a[b+452>>2]|0;e=b+332|0;f=(a[e>>2]|0)+-1|0;g=b+144|0;h=b+152|0;m=b+460|0;k=b+148|0;for(l=b+156|0;;){n=a[g>>2]|0;p=a[h>>2]|0;if((n|0)>=(p|0)){if((n|0)!=(p|0))break;if((a[k>>2]|0)>>>0>(a[l>>2]|0)>>>0)break}if(!(da[a[a[m>>2]>>2]&63](b)|0)){q=0;r=21;break}}if(21==(r|
0))return q|0;r=b+36|0;m=a[r>>2]|0;if(0<(m|0))for(k=b+4|0,h=b+472|0,g=m,m=0,p=a[b+216>>2]|0;;){if(a[p+52>>2]|0){n=p+12|0;g=a[n>>2]|0;q=E(g,a[l>>2]|0)|0;t=jg[a[(a[k>>2]|0)+32>>2]&3](b,a[c+72+(m<<2)>>2]|0,q,g,0)|0;(a[l>>2]|0)>>>0<f>>>0?u=a[n>>2]|0:(g=a[n>>2]|0,n=((a[p+32>>2]|0)>>>0)%(g>>>0)|0,u=0==(n|0)?g:n);n=a[(a[h>>2]|0)+4+(m<<2)>>2]|0;if(0<(u|0))for(g=p+28|0,q=p+40|0,v=p+36|0,w=a[g>>2]|0,x=0,A=a[d+(m<<2)>>2]|0;;){if(w)for(w=0,D=a[t+(x<<2)>>2]|0,F=0;;)if(sf[n&63](b,p,D,A,F),w=w+1|0,N=a[g>>2]|0,w>>>
0>=N>>>0){w=N;break}else D=D+128|0,F=(a[v>>2]|0)+F|0;else w=0;x=x+1|0;if((x|0)==(u|0))break;else A=A+(a[q>>2]<<2)|0}n=a[r>>2]|0}else n=g;m=m+1|0;if((m|0)>=(n|0))break;else g=n,p=p+88|0}p=(a[l>>2]|0)+1|0;a[l>>2]=p;q=p>>>0<(a[e>>2]|0)>>>0?3:4;return q|0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,t,u,v,w,x,A,D,F=0,N=0,J,I,G,L,K,S,U,O,M,T,X,P,W,Y,Z,ba,da,aa,ca=0,ga=0,fa=0,ma=0,ja=0;c=b+452|0;e=a[c>>2]|0;f=(a[b+360>>2]|0)+-1|0;g=b+332|0;h=a[g>>2]|0;m=h+-1|0;k=e+24|0;l=a[k>>2]|0;n=e+28|0;do if((l|
0)<(a[n>>2]|0)){p=e+20|0;q=b+436|0;r=b+468|0;t=e+32|0;u=b+340|0;v=b+472|0;w=b+148|0;x=b+368|0;A=a[p>>2]|0;D=l;a:for(;;){if(A>>>0<=f>>>0){do{a[q>>2]|0&&Va(a[t>>2]|0,0,a[x>>2]<<7|0)|0;if(!(dd[a[(a[r>>2]|0)+4>>2]&127](b,t)|0)){F=A;N=D;break a}if(0<(a[u>>2]|0))for(J=A>>>0<f>>>0,G=I=0;;){L=a[b+344+(G<<2)>>2]|0;b:do if(a[L+52>>2]|0)if(K=a[L+4>>2]|0,S=a[(a[v>>2]|0)+4+(K<<2)>>2]|0,U=L+56|0,O=a[(J?U:L+72|0)>>2]|0,M=L+40|0,T=a[M>>2]|0,X=E(a[L+68>>2]|0,A)|0,P=L+60|0,W=a[P>>2]|0,0<(W|0)){Y=L+76|0;Z=L+36|0;if(0>=
(O|0))for(ba=a[U>>2]|0,da=I,aa=0;;)if(K=ba+da|0,aa=aa+1|0,(aa|0)>=(W|0)){S=K;break b}else da=K;da=W;aa=T;ba=I;K=(a[d+(K<<2)>>2]|0)+((E(T,D)|0)<<2)|0;for(W=0;;){(a[w>>2]|0)>>>0>=m>>>0&&(W+D|0)>=(a[Y>>2]|0)?(ca=aa,ga=da):(fa=X,ma=0,ja=20);if(20==(ja|0)){for(;ja=0,sf[S&63](b,L,a[e+32+(ma+ba<<2)>>2]|0,K,fa),ma=ma+1|0,(ma|0)!=(O|0);)fa=(a[Z>>2]|0)+fa|0;ca=a[M>>2]|0;ga=a[P>>2]|0}ba=(a[U>>2]|0)+ba|0;W=W+1|0;if((W|0)>=(ga|0)){S=ba;break}else da=ga,aa=ca,K=K+(ca<<2)|0}}else S=I;else S=(a[L+64>>2]|0)+I|0;while(0);
G=G+1|0;if((G|0)>=(a[u>>2]|0))break;else I=S}A=A+1|0}while(A>>>0<=f>>>0)}a[p>>2]=0;D=D+1|0;if((D|0)>=(a[n>>2]|0)){ja=26;break}else A=0}if(26==(ja|0))p=w,q=a[g>>2]|0;else return a[k>>2]=N,a[p>>2]=F,0}else p=b+148|0,q=h;while(0);h=b+156|0;a[h>>2]=(a[h>>2]|0)+1;h=(a[p>>2]|0)+1|0;a[p>>2]=h;if(h>>>0>=q>>>0)return R[a[(a[b+460>>2]|0)+12>>2]&127](b),4;p=a[c>>2]|0;1>=(a[b+340>>2]|0)?(c=a[b+344>>2]|0,a[p+28>>2]=h>>>0<(q+-1|0)>>>0?a[c+12>>2]:a[c+76>>2]):a[p+28>>2]=1;a[p+20>>2]=0;a[p+24>>2]=0;return 3},function(b,
d){b|=0;d|=0;var c,e,f,g,h,m,k,l,n,p,q,r,t,v=0,x=0,z,A,C,D,F,R,J,I,G,L,K,S,U,O,M,T,X,P,W,Y,Z,ba,aa,ca,fa,ga,ja,ma,pa,ha,ra,ya,Aa,Ka,Qa,Va,oa,sa,Wa,ua,Ia,Da,na,Na,ab,Ca,Ga,Ea,La;c=u;u=u+128|0;e=a[b+452>>2]|0;f=b+332|0;g=(a[f>>2]|0)+-1|0;h=b+144|0;m=b+152|0;k=b+460|0;l=b+412|0;n=b+148|0;for(p=b+156|0;;){q=a[h>>2]|0;r=a[m>>2]|0;if((q|0)>(r|0))break;t=a[k>>2]|0;if(a[t+20>>2]|0)break;if((q|0)==(r|0)&&(a[n>>2]|0)>>>0>((a[p>>2]|0)+(0==(a[l>>2]|0)&1)|0)>>>0)break;if(!(da[a[t>>2]&63](b)|0)){v=0;x=70;break}}if(70==
(x|0))return u=c,v|0;x=b+36|0;l=a[x>>2]|0;if(0<(l|0))for(n=b+4|0,k=e+112|0,m=b+472|0,h=c+4|0,t=c+18|0,r=c+32|0,q=c+16|0,v=c+2|0,z=l,l=0,A=a[b+216>>2]|0;;){if(a[A+52>>2]|0){z=a[p>>2]|0;C=A+12|0;D=a[C>>2]|0;z>>>0<g>>>0?(F=D<<1,R=D,J=0):(F=((a[A+32>>2]|0)>>>0)%(D>>>0)|0,R=F=I=0==(F|0)?D:F,J=1);z?(I=E(D,z+-1|0)|0,z=jg[a[(a[n>>2]|0)+32>>2]&3](b,a[e+72+(l<<2)>>2]|0,I,D+F|0,0)|0,G=z+(a[C>>2]<<2)|0,L=0):(G=jg[a[(a[n>>2]|0)+32>>2]&3](b,a[e+72+(l<<2)>>2]|0,0,F,0)|0,L=1);C=a[k>>2]|0;z=6*l|0;D=a[A+80>>2]|0;I=
N[D>>1]|0;F=N[D+2>>1]|0;K=N[D+16>>1]|0;S=N[D+32>>1]|0;U=N[D+18>>1]|0;O=N[D+4>>1]|0;D=a[(a[m>>2]|0)+4+(l<<2)>>2]|0;if(0<(R|0))for(L=0!=(L|0),J=0!=(J|0),M=R+-1|0,T=A+28|0,X=C+((z|1)<<2)|0,P=C+(z+2<<2)|0,W=C+(z+3<<2)|0,Y=C+(z+4<<2)|0,Z=C+(z+5<<2)|0,z=A+36|0,C=9*I|0,ba=O<<7,aa=O<<8,O=5*I|0,ca=U<<7,fa=U<<8,U=S<<7,ga=S<<8,S=36*I|0,I=K<<7,ja=K<<8,K=F<<7,ma=F<<8,F=A+40|0,pa=0,ha=a[d+(l<<2)>>2]|0;;){ra=a[G+(pa<<2)>>2]|0;ya=L&0==(pa|0)?ra:a[G+(pa+-1<<2)>>2]|0;Aa=J&(pa|0)==(M|0)?ra:a[G+(pa+1<<2)>>2]|0;Ka=w[ya>>
1]|0;Qa=w[ra>>1]|0;Va=w[Aa>>1]|0;oa=(a[T>>2]|0)+-1|0;Wa=sa=Ka;ua=Ka=Qa;Ia=Qa=Va;Va=0;Da=ra;ra=Aa;for(Aa=0;!(Ec(c|0,Da|0,128)|0,Va>>>0<oa>>>0?(na=w[ya+128>>1]|0,Na=w[Da+128>>1]|0,ab=w[ra+128>>1]|0):(na=Wa,Na=ua,ab=Ia),Ca=a[X>>2]|0,0!=(Ca|0)&0==(w[v>>1]|0)&&(Ga=E(S,Ka-Na|0)|0,-1<(Ga|0)?(Ea=(Ga+K|0)/(ma|0)|0,0<(Ca|0)?(La=1<<Ca,Ca=(Ea|0)<(La|0)?Ea:La+-1|0):Ca=Ea):(Ea=(K-Ga|0)/(ma|0)|0,0<(Ca|0)?(Ga=1<<Ca,Ca=(Ea|0)<(Ga|0)?Ea:Ga+-1|0):Ca=Ea,Ca=0-Ca|0),w[v>>1]=Ca),Ea=a[P>>2]|0,0!=(Ea|0)&0==(w[q>>1]|0)&&(Ga=
E(S,Wa-Ia|0)|0,-1<(Ga|0)?(Ca=(Ga+I|0)/(ja|0)|0,0<(Ea|0)&&(La=1<<Ea,Ca=(Ca|0)<(La|0)?Ca:La+-1|0)):(Ca=(I-Ga|0)/(ja|0)|0,0<(Ea|0)&&(Ga=1<<Ea,Ca=(Ca|0)<(Ga|0)?Ca:Ga+-1|0),Ca=0-Ca|0),w[q>>1]=Ca),Ca=a[W>>2]|0,0!=(Ca|0)&0==(w[r>>1]|0)&&(Ga=E(C,Wa-(ua<<1)+Ia|0)|0,-1<(Ga|0)?(Ea=(Ga+U|0)/(ga|0)|0,0>=(Ca|0)?Ca=Ea:(La=1<<Ca,Ca=(Ea|0)<(La|0)?Ea:La+-1|0)):(La=(U-Ga|0)/(ga|0)|0,0<(Ca|0)?(Ea=1<<Ca,Ca=(La|0)<(Ea|0)?La:Ea+-1|0):Ca=La,Ca=0-Ca|0),w[r>>1]=Ca),Ca=a[Y>>2]|0,0!=(Ca|0)&0==(w[t>>1]|0)&&(Ga=E(O,sa-Qa-na+ab|
0)|0,-1<(Ga|0)?(La=(Ga+ca|0)/(fa|0)|0,0>=(Ca|0)?Qa=La:(Ea=1<<Ca,Qa=(La|0)<(Ea|0)?La:Ea+-1|0)):(Ea=(ca-Ga|0)/(fa|0)|0,0<(Ca|0)?(La=1<<Ca,Qa=(Ea|0)<(La|0)?Ea:La+-1|0):Qa=Ea,Qa=0-Qa|0),w[t>>1]=Qa),Ca=a[Z>>2]|0,0!=(Ca|0)&0==(w[h>>1]|0)&&(Ga=E(C,Ka-(ua<<1)+Na|0)|0,-1<(Ga|0)?(Ea=(Ga+ba|0)/(aa|0)|0,0>=(Ca|0)?Ka=Ea:(La=1<<Ca,Ka=(Ea|0)<(La|0)?Ea:La+-1|0)):(La=(ba-Ga|0)/(aa|0)|0,0<(Ca|0)?(Ea=1<<Ca,Ka=(La|0)<(Ea|0)?La:Ea+-1|0):Ka=La,Ka=0-Ka|0),w[h>>1]=Ka),sf[D&63](b,A,c,ha,Aa),Va=Va+1|0,Va>>>0>oa>>>0);)Ca=Ia,
Ga=ua,La=Wa,Wa=na,ua=Na,Ia=ab,Da=Da+128|0,ra=ra+128|0,Aa=(a[z>>2]|0)+Aa|0,ya=ya+128|0,Qa=Ca,Ka=Ga,sa=La;pa=pa+1|0;if((pa|0)==(R|0))break;else ha=ha+(a[F>>2]<<2)|0}z=a[x>>2]|0}l=l+1|0;if((l|0)>=(z|0))break;else A=A+88|0}A=(a[p>>2]|0)+1|0;a[p>>2]=A;v=A>>>0<(a[f>>2]|0)>>>0?3:4;u=c;return v|0},function(b,d){b|=0;d|=0;var c,e,f,g,h,m,k=0,l,n,p,q=0,r,t,v,A,z,D,C,E,F,N,J,I,G,L,K,R=0,S=0,O=0,M=0,T=0,U=0,P=0,W=0,Y=0,Z=0,ba=0,aa=0,ca=0,fa=0,ga=0;c=u;u=u+48|0;e=c+20|0;f=c;g=a[b+468>>2]|0;h=a[b+424>>2]|0;m=b+
280|0;if(0!=(a[m>>2]|0)&&(k=g+44|0,0==(a[k>>2]|0))){l=g+16|0;n=a[b+464>>2]|0;p=n+24|0;a[p>>2]=(a[p>>2]|0)+((a[l>>2]|0)/8|0);a[l>>2]=0;if(!(da[a[n+8>>2]&63](b)|0))return u=c,0;n=b+340|0;if(0<(a[n>>2]|0)){l=0;do a[g+24+(l<<2)>>2]=0,l=l+1|0;while((l|0)<(a[n>>2]|0))}a[g+20>>2]=0;a[k>>2]=a[m>>2];a[b+440>>2]|0||(a[g+40>>2]=0)}if(!(a[g+40>>2]|0)){a[e+16>>2]=b;m=b+24|0;k=a[m>>2]|0;n=a[k>>2]|0;a[e>>2]=n;l=a[k+4>>2]|0;p=e+4|0;a[p>>2]=l;r=g+12|0;t=a[r>>2]|0;v=g+16|0;A=a[v>>2]|0;z=g+20|0;a[f>>2]=a[z>>2];a[f+
4>>2]=a[z+4>>2];a[f+8>>2]=a[z+8>>2];a[f+12>>2]=a[z+12>>2];a[f+16>>2]=a[z+16>>2];D=b+368|0;do if(0<(a[D>>2]|0)){C=e+8|0;E=e+12|0;F=A;N=0;for(J=t;;){I=a[d+(N<<2)>>2]|0;G=a[b+372+(N<<2)>>2]|0;L=a[g+48+(a[(a[b+344+(G<<2)>>2]|0)+20>>2]<<2)>>2]|0;if(8>(F|0)){if(!(Uc(e,J,F,0)|0)){q=0;K=27;break}J=a[C>>2]|0;F=a[E>>2]|0;8>(F|0)?(R=F,S=J,O=1,K=16):(M=F,T=J,K=14)}else M=F,T=J,K=14;14==(K|0)&&(K=0,J=T>>M+-8&255,(F=a[L+144+(J<<2)>>2]|0)?(U=M-F|0,P=T,W=x[L+1168+J>>0]|0):(R=M,S=T,O=9,K=16));if(16==(K|0)){J=Tf(e,
S,R,L,O)|0;if(0>(J|0)){q=0;K=27;break}U=a[E>>2]|0;P=a[C>>2]|0;W=J}if(W){if((U|0)<(W|0)){if(!(Uc(e,P,U,W)|0)){q=0;K=27;break}L=a[E>>2]|0;K=a[C>>2]|0}else L=U,K=P;J=L-W|0;L=a[122072+(W<<2)>>2]|0;F=K>>J&L;F=F-((F|0)>(a[122072+(W+-1<<2)>>2]|0)?0:L)|0}else J=U,K=P,F=0;L=f+4+(G<<2)|0;G=(a[L>>2]|0)+F|0;a[L>>2]=G;w[I>>1]=G<<h;N=N+1|0;if((N|0)>=(a[D>>2]|0)){Y=J;Z=K;K=24;break}else F=J,J=K}if(24==(K|0))ba=a[m>>2]|0,aa=a[e>>2]|0,ca=a[p>>2]|0,fa=Y,ga=Z;else if(27==(K|0))return u=c,q|0}else ba=k,aa=n,ca=l,fa=
A,ga=t;while(0);a[ba>>2]=aa;a[ba+4>>2]=ca;a[r>>2]=ga;a[v>>2]=fa;a[z>>2]=a[f>>2];a[z+4>>2]=a[f+4>>2];a[z+8>>2]=a[f+8>>2];a[z+12>>2]=a[f+12>>2];a[z+16>>2]=a[f+16>>2]}f=g+44|0;a[f>>2]=(a[f>>2]|0)+-1;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f,g=0,h,m,k,l=0,n,p,q,r,t,v,A,z,D,C,E,F,N=0,J=0,I=0,G=0,L=0,K=0,R=0,S=0,O=0,M=0,T=0,U=0,P=0,W=0,Y,Z;c=u;u=u+32|0;e=a[b+468>>2]|0;f=b+280|0;if(0!=(a[f>>2]|0)&&(g=e+44|0,0==(a[g>>2]|0))){h=e+16|0;m=a[b+464>>2]|0;k=m+24|0;a[k>>2]=(a[k>>2]|0)+((a[h>>2]|0)/8|0);a[h>>
2]=0;if(!(da[a[m+8>>2]&63](b)|0))return u=c,0;m=b+340|0;if(0<(a[m>>2]|0)){h=0;do a[e+24+(h<<2)>>2]=0,h=h+1|0;while((h|0)<(a[m>>2]|0))}a[e+20>>2]=0;a[g>>2]=a[f>>2];a[b+440>>2]|0||(a[e+40>>2]=0)}if(!(a[e+40>>2]|0)){f=a[b+416>>2]|0;g=a[b+424>>2]|0;m=a[b+432>>2]|0;h=e+20|0;if(k=a[h>>2]|0)f=k+-1|0;else{a[c+16>>2]=b;k=b+24|0;n=a[k>>2]|0;a[c>>2]=a[n>>2];p=c+4|0;a[p>>2]=a[n+4>>2];n=e+12|0;q=a[n>>2]|0;r=e+16|0;t=a[r>>2]|0;v=a[d>>2]|0;d=a[e+64>>2]|0;A=a[b+412>>2]|0;a:do if((A|0)<=(f|0)){b=c+8|0;z=c+12|0;D=
t;C=q;E=A;b:for(;;){if(8>(D|0)){if(!(Uc(c,C,D,0)|0)){l=0;F=35;break}C=a[b>>2]|0;D=a[z>>2]|0;8>(D|0)?(N=D,J=C,I=1,F=18):(G=D,L=C,F=16)}else G=D,L=C,F=16;16==(F|0)&&(F=0,C=L>>G+-8&255,(D=a[d+144+(C<<2)>>2]|0)?(K=G-D|0,R=L,S=x[d+1168+C>>0]|0):(N=G,J=L,I=9,F=18));if(18==(F|0)){C=Tf(c,J,N,d,I)|0;if(0>(C|0)){l=0;F=35;break}K=a[z>>2]|0;R=a[b>>2]|0;S=C}C=S>>4;if(D=S&15){E=C+E|0;if((K|0)<(D|0)){if(!(Uc(c,R,K,D)|0)){l=0;F=35;break}C=a[z>>2]|0;F=a[b>>2]|0}else C=K,F=R;C=C-D|0;Y=a[122072+(D<<2)>>2]|0;Z=F>>C&
Y;w[v+(a[m+(E<<2)>>2]<<1)>>1]=Z-((Z|0)>(a[122072+(D+-1<<2)>>2]|0)?0:Y)<<g;D=C;C=F}else{switch(C|0){case 0:O=0;M=K;T=R;break a;case 15:break;default:U=C;P=K;W=R;F=26;break b}D=K;C=R;E=E+15|0}if((E|0)<(f|0))E=E+1|0;else{O=0;M=D;T=C;break a}}if(26==(F|0)){E=1<<U;if((P|0)<(U|0))if(Uc(c,W,P,U)|0)O=a[z>>2]|0,T=a[b>>2]|0;else return l=0,u=c,l|0;else O=P,T=W;b=O-U|0;O=E+-1+(T>>b&a[122072+(U<<2)>>2])|0;M=b}else if(35==(F|0))return u=c,l|0}else O=0,M=t,T=q;while(0);q=a[k>>2]|0;a[q>>2]=a[c>>2];a[q+4>>2]=a[p>>
2];a[n>>2]=T;a[r>>2]=M;f=O}a[h>>2]=f}f=e+44|0;a[f>>2]=(a[f>>2]|0)+-1;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f,g=0,h,m,k,l=0,n,p,q,r,t,v,x,z,A,C,D,E=0,F=0,J=0,I=0,G=0,L=0,K=0;c=u;u=u+32|0;e=a[b+468>>2]|0;f=b+280|0;if(0!=(a[f>>2]|0)&&(g=e+44|0,0==(a[g>>2]|0))){h=e+16|0;m=a[b+464>>2]|0;k=m+24|0;a[k>>2]=(a[k>>2]|0)+((a[h>>2]|0)/8|0);a[h>>2]=0;if(!(da[a[m+8>>2]&63](b)|0))return u=c,0;m=b+340|0;if(0<(a[m>>2]|0)){h=0;do a[e+24+(h<<2)>>2]=0,h=h+1|0;while((h|0)<(a[m>>2]|0))}a[e+20>>2]=0;a[g>>2]=a[f>>
2];a[b+440>>2]|0||(a[e+40>>2]=0)}a[c+16>>2]=b;f=b+24|0;g=a[f>>2]|0;m=a[g>>2]|0;a[c>>2]=m;h=a[g+4>>2]|0;k=c+4|0;a[k>>2]=h;n=e+12|0;p=a[n>>2]|0;q=e+16|0;r=a[q>>2]|0;t=1<<a[b+424>>2];v=b+368|0;do if(0<(a[v>>2]|0)){b=c+8|0;x=c+12|0;z=r;A=0;for(C=p;;){if(1>(z|0)){if(!(Uc(c,C,z,1)|0)){l=0;x=18;break}z=a[x>>2]|0;C=a[b>>2]|0}z=z+-1|0;1<<z&C&&(D=a[d+(A<<2)>>2]|0,w[D>>1]=N[D>>1]|0|t);A=A+1|0;if((A|0)>=(a[v>>2]|0)){E=z;F=C;x=16;break}}if(16==(x|0))J=a[f>>2]|0,I=a[c>>2]|0,G=a[k>>2]|0,L=E,K=F;else if(18==(x|0))return u=
c,l|0}else J=g,I=m,G=h,L=r,K=p;while(0);a[J>>2]=I;a[J+4>>2]=G;a[n>>2]=K;a[q>>2]=L;L=e+44|0;a[L>>2]=(a[L>>2]|0)+-1;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h=0,m,k,l,n,p,q,r,t,v,A,z,D,C,E,F,N,J,I=0,G=0,L=0,K,R=0,S=0,O=0,M=0,T=0,U=0,P=0,W=0,Y=0,Z=0,ba=0,aa=0,ca=0,fa,ga,ja,ma,pa,ha=0,ra=0,ya=0,Aa=0,Ka=0,Qa=0,Va=0,oa=0,sa=0,Wa=0;c=u;u=u+288|0;e=c+24|0;f=a[b+468>>2]|0;g=b+280|0;if(0!=(a[g>>2]|0)&&(h=f+44|0,0==(a[h>>2]|0))){m=f+16|0;k=a[b+464>>2]|0;l=k+24|0;a[l>>2]=(a[l>>2]|0)+((a[m>>2]|0)/8|0);
a[m>>2]=0;if(!(da[a[k+8>>2]&63](b)|0))return u=c,0;k=b+340|0;if(0<(a[k>>2]|0)){m=0;do a[f+24+(m<<2)>>2]=0,m=m+1|0;while((m|0)<(a[k>>2]|0))}a[f+20>>2]=0;a[h>>2]=a[g>>2];a[b+440>>2]|0||(a[f+40>>2]=0)}do if(!(a[f+40>>2]|0)){g=a[b+416>>2]|0;h=a[b+424>>2]|0;k=1<<h;m=-1<<h;h=a[b+432>>2]|0;a[c+16>>2]=b;l=b+24|0;n=a[l>>2]|0;a[c>>2]=a[n>>2];p=c+4|0;a[p>>2]=a[n+4>>2];n=f+12|0;q=a[n>>2]|0;r=f+16|0;t=a[r>>2]|0;v=f+20|0;A=a[v>>2]|0;z=a[d>>2]|0;D=a[f+64>>2]|0;C=a[b+412>>2]|0;E=c+8|0;F=c+12|0;a:do if(A)Qa=A,Va=
t,oa=q,sa=C,Wa=0,M=46;else{N=t;J=q;I=C;G=0;b:for(;;){if(8>(N|0)){if(!(Uc(c,J,N,0)|0)){L=G;break a}K=a[E>>2]|0;N=a[F>>2]|0;8>(N|0)?(R=N,S=K,O=1,M=17):(T=N,U=K,M=15)}else T=N,U=J,M=15;15==(M|0)&&(M=0,K=U>>T+-8&255,(N=a[D+144+(K<<2)>>2]|0)?(P=T-N|0,W=U,Y=x[D+1168+K>>0]|0):(R=T,S=U,O=9,M=17));if(17==(M|0)){M=0;K=Tf(c,S,R,D,O)|0;if(0>(K|0)){L=G;break a}P=a[F>>2]|0;W=a[E>>2]|0;Y=K}K=Y>>4;switch(Y&15|0){case 0:if(15==(K|0))Z=P,ba=W,aa=15,ca=0;else{J=K;N=P;fa=W;K=I;ga=G;break b}break;case 1:M=21;break;default:N=
a[b>>2]|0,a[N+20>>2]=121,ub[a[N+4>>2]&31](b,-1),M=21}if(21==(M|0)){M=0;if(1>(P|0)){if(!(Uc(c,W,P,1)|0)){L=G;break a}Z=a[F>>2]|0;ca=a[E>>2]|0}else Z=P,ca=W;Z=N=Z+-1|0;ba=ca;aa=K;ca=0==(1<<N&ca|0)?m:k}N=Z;K=ba;J=I;ga=aa;c:for(;;){fa=z+(a[h+(J<<2)>>2]<<1)|0;do if(w[fa>>1]|0){if(1>(N|0)){if(!(Uc(c,K,N,1)|0)){L=G;break a}ja=a[F>>2]|0;ma=a[E>>2]|0}else ja=N,ma=K;ja=ja+-1|0;0!=(1<<ja&ma|0)&&(ha=w[fa>>1]|0,ra=ha<<16>>16,0==(ra&k|0))&&(w[fa>>1]=-1<ha<<16>>16?ra+k:ra+m);pa=ga}else if(1>(ga|0)){fa=J;break c}else ja=
N,ma=K,pa=ga+-1|0;while(0);fa=J+1|0;if((J|0)<(g|0))N=ja,K=ma,J=fa,ga=pa;else{N=ja;K=ma;break}}ca?(ga=a[h+(fa<<2)>>2]|0,w[z+(ga<<1)>>1]=ca,a[e+(G<<2)>>2]=ga,ga=G+1|0):ga=G;if((fa|0)<(g|0))J=K,I=fa+1|0,G=ga;else{ya=0;Aa=N;Ka=K;M=58;break a}}G=1<<J;if(J){if((N|0)<(J|0)){if(!(Uc(c,fa,N,J)|0)){L=ga;break}I=a[F>>2]|0;M=a[E>>2]|0}else I=N,M=fa;I=I-J|0;(J=(M>>I&a[122072+(J<<2)>>2])+G|0)?(Qa=J,Va=I,oa=M,sa=K,Wa=ga,M=46):(ya=0,Aa=I,Ka=M,M=58)}else Qa=G,Va=N,oa=fa,sa=K,Wa=ga,M=46}while(0);a:do if(46==(M|0)){C=
Va;q=oa;for(t=sa;;){A=z+(a[h+(t<<2)>>2]<<1)|0;do if(w[A>>1]|0){if(1>(C|0)){if(!(Uc(c,q,C,1)|0)){L=Wa;break a}D=a[F>>2]|0;K=a[E>>2]|0}else D=C,K=q;D=D+-1|0;0!=(1<<D&K|0)&&(G=w[A>>1]|0,I=G<<16>>16,0==(I&k|0))&&(w[A>>1]=-1<G<<16>>16?I+k:I+m)}else D=C,K=q;while(0);if((t|0)<(g|0))C=D,q=K,t=t+1|0;else{Aa=D;q=K;break}}ya=Qa+-1|0;Ka=q;M=58}while(0);if(58==(M|0))g=a[l>>2]|0,a[g>>2]=a[c>>2],a[g+4>>2]=a[p>>2],a[n>>2]=Ka,a[r>>2]=Aa,a[v>>2]=ya;else{if(L)f=L;else return e=0,u=c,e|0;do f=f+-1|0,w[z+(a[e+(f<<2)>>
2]<<1)>>1]=0;while(0!=(f|0));e=0;u=c;return e|0}}while(0);f=f+44|0;a[f>>2]=(a[f>>2]|0)+-1;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m=0,k,l,n,p=0,q,r,t,v,A,z,D,C,E,F,N,J,I,G,L=0,K=0,R=0,S=0,O=0,M=0,T=0,U=0,P,W,Y=W=P=0,Z,ba,aa,ca,fa=0,ga=0,ja=0,ma=0,pa=0,ha=0,ra=0,ya=0,Aa=0,Ka=0,Qa,Va,oa=0,sa=0,Wa=0,ua=0,Ia=0,Da=0,na=0,Na=0,ab=0,Ca=0,Ga=0,Ea=0,La=0,db=0,eb=0;c=u;u=u+48|0;e=c+20|0;f=c;g=a[b+468>>2]|0;h=b+280|0;if(0!=(a[h>>2]|0)&&(m=g+44|0,0==(a[m>>2]|0))){k=g+16|0;l=a[b+464>>2]|0;n=l+24|0;
a[n>>2]=(a[n>>2]|0)+((a[k>>2]|0)/8|0);a[k>>2]=0;if(!(da[a[l+8>>2]&63](b)|0))return u=c,0;l=b+340|0;if(0<(a[l>>2]|0)){k=0;do a[g+24+(k<<2)>>2]=0,k=k+1|0;while((k|0)<(a[l>>2]|0))}a[g+20>>2]=0;a[m>>2]=a[h>>2];a[b+440>>2]|0||(a[g+40>>2]=0)}if(!(a[g+40>>2]|0)){a[e+16>>2]=b;h=b+24|0;m=a[h>>2]|0;l=a[m>>2]|0;a[e>>2]=l;k=a[m+4>>2]|0;n=e+4|0;a[n>>2]=k;q=g+12|0;r=a[q>>2]|0;t=g+16|0;v=a[t>>2]|0;A=g+20|0;a[f>>2]=a[A>>2];a[f+4>>2]=a[A+4>>2];a[f+8>>2]=a[A+8>>2];a[f+12>>2]=a[A+12>>2];a[f+16>>2]=a[A+16>>2];z=b+368|
0;do if(0<(a[z>>2]|0)){D=e+8|0;C=e+12|0;E=v;F=0;N=r;a:for(;;){J=a[d+(F<<2)>>2]|0;I=a[g+100+(F<<2)>>2]|0;if(8>(E|0)){if(!(Uc(e,N,E,0)|0)){p=0;G=64;break}E=a[D>>2]|0;N=a[C>>2]|0;8>(N|0)?(L=N,K=E,R=1,G=16):(S=N,O=E,G=14)}else S=E,O=N,G=14;14==(G|0)&&(G=0,E=O>>S+-8&255,(N=a[I+144+(E<<2)>>2]|0)?(M=S-N|0,T=O,U=x[I+1168+E>>0]|0):(L=S,K=O,R=9,G=16));if(16==(G|0)){E=Tf(e,K,L,I,R)|0;if(0>(E|0)){p=0;G=64;break}M=a[C>>2]|0;T=a[D>>2]|0;U=E}E=a[g+140+(F<<2)>>2]|0;I=a[g+180+(F<<2)>>2]|0;N=0!=(U|0);b:do if(I){if(N){if((M|
0)<(U|0)){if(!(Uc(e,T,M,U)|0)){p=0;G=64;break a}G=a[C>>2]|0;Z=a[D>>2]|0}else G=M,Z=T;ba=G-U|0;G=a[122072+(U<<2)>>2]|0;aa=Z>>ba&G;aa=aa-((aa|0)>(a[122072+(U+-1<<2)>>2]|0)?0:G)|0}else ba=M,Z=T,aa=0;G=f+4+(a[b+372+(F<<2)>>2]<<2)|0;aa=(a[G>>2]|0)+aa|0;a[G>>2]=aa;w[J>>1]=aa;if(1<(I|0)){aa=ba;G=Z;for(ba=1;;){if(8>(aa|0)){if(!(Uc(e,G,aa,0)|0)){p=0;G=64;break a}ca=a[D>>2]|0;Z=a[C>>2]|0;8>(Z|0)?(fa=Z,ga=ca,ja=1,G=30):(ma=Z,pa=ca,G=28)}else ma=aa,pa=G,G=28;28==(G|0)&&(G=0,ca=pa>>ma+-8&255,(Z=a[E+144+(ca<<2)>>
2]|0)?(ha=ma-Z|0,ra=pa,ya=x[E+1168+ca>>0]|0):(fa=ma,ga=pa,ja=9,G=30));if(30==(G|0)){G=0;ca=Tf(e,ga,fa,E,ja)|0;if(0>(ca|0)){p=0;G=64;break a}ha=a[C>>2]|0;ra=a[D>>2]|0;ya=ca}ca=ya>>4;if(Z=ya&15){ba=ca+ba|0;if((ha|0)<(Z|0)){if(!(Uc(e,ra,ha,Z)|0)){p=0;G=64;break a}ca=a[C>>2]|0;aa=a[D>>2]|0}else ca=ha,aa=ra;ca=ca-Z|0;Qa=a[122072+(Z<<2)>>2]|0;Va=aa>>ca&Qa;w[J+(a[119984+(ba<<2)>>2]<<1)>>1]=Va-((Va|0)>(a[122072+(Z+-1<<2)>>2]|0)?0:Qa);Z=aa}else{if(15!=(ca|0)){Aa=ha;Ka=ra;break b}ca=ha;Z=ra;ba=ba+15|0}ba=ba+
1|0;if((ba|0)<(I|0))aa=ca,G=Z;else{aa=ca;break}}64>(ba|0)?(P=aa,W=Z,Y=ba,G=46):(Aa=aa,Ka=Z)}else P=ba,W=Z,Y=1,G=46}else{if(N){if((M|0)<(U|0)){if(!(Uc(e,T,M,U)|0)){p=0;G=64;break a}P=a[C>>2]|0;W=a[D>>2]|0}else P=M,W=T;P=P-U|0}else P=M,W=T;Y=1;G=46}while(0);b:do if(46==(G|0))for(;;){if(8>(P|0)){if(!(Uc(e,W,P,0)|0)){p=0;G=64;break a}I=a[D>>2]|0;J=a[C>>2]|0;8>(J|0)?(oa=J,sa=I,Wa=1,G=51):(ua=J,Ia=I,G=49)}else ua=P,Ia=W,G=49;49==(G|0)&&(G=0,I=Ia>>ua+-8&255,(J=a[E+144+(I<<2)>>2]|0)?(Da=ua-J|0,na=Ia,Na=x[E+
1168+I>>0]|0):(oa=ua,sa=Ia,Wa=9,G=51));if(51==(G|0)){G=0;I=Tf(e,sa,oa,E,Wa)|0;if(0>(I|0)){p=0;G=64;break a}Da=a[C>>2]|0;na=a[D>>2]|0;Na=I}I=Na>>4;if(J=Na&15){if((Da|0)<(J|0)){if(!(Uc(e,na,Da,J)|0)){p=0;G=64;break a}ba=a[C>>2]|0;N=a[D>>2]|0}else ba=Da,N=na;J=ba-J|0}else if(15==(I|0))I=15,J=Da,N=na;else{Aa=Da;Ka=na;break b}Y=Y+1+I|0;if(64<=(Y|0)){Aa=J;Ka=N;break}else P=J,W=N}while(0);F=F+1|0;if((F|0)>=(a[z>>2]|0)){ab=Aa;Ca=Ka;G=61;break}else E=Aa,N=Ka}if(61==(G|0))Ga=a[h>>2]|0,Ea=a[e>>2]|0,La=a[n>>
2]|0,db=ab,eb=Ca;else if(64==(G|0))return u=c,p|0}else Ga=m,Ea=l,La=k,db=v,eb=r;while(0);a[Ga>>2]=Ea;a[Ga+4>>2]=La;a[q>>2]=eb;a[t>>2]=db;a[A>>2]=a[f>>2];a[A+4>>2]=a[f+4>>2];a[A+8>>2]=a[f+8>>2];a[A+12>>2]=a[f+12>>2];a[A+16>>2]=a[f+16>>2]}f=g+44|0;a[f>>2]=(a[f>>2]|0)+-1;u=c;return 1},function(b,d){b|=0;d|=0;var c,e,f,g,h,m=0,k,l,n,p=0,q,r,t,v,A,z,D,C,E,F,N,J,I,G,L,K,R=0,S=0,O=0,M=0,T=0,U=0,P=0,W=0,Y,Z,ba=Z=Y=0,aa,ca,fa,ga=0,ja=0,ma=0,pa=0,ha=0,ra=0,ya=0,Aa=0,Ka=0,Qa=0,Va,oa,sa=0,Wa=0,ua=0,Ia=0,Da=0,
na=0,Na=0,ab=0,Ca=0,Ga=0,Ea=0,La=0,db=0,eb=0,fb=0;c=u;u=u+48|0;e=c+20|0;f=c;g=a[b+468>>2]|0;h=b+280|0;if(0!=(a[h>>2]|0)&&(m=g+44|0,0==(a[m>>2]|0))){k=g+16|0;l=a[b+464>>2]|0;n=l+24|0;a[n>>2]=(a[n>>2]|0)+((a[k>>2]|0)/8|0);a[k>>2]=0;if(!(da[a[l+8>>2]&63](b)|0))return u=c,0;l=b+340|0;if(0<(a[l>>2]|0)){k=0;do a[g+24+(k<<2)>>2]=0,k=k+1|0;while((k|0)<(a[l>>2]|0))}a[g+20>>2]=0;a[m>>2]=a[h>>2];a[b+440>>2]|0||(a[g+40>>2]=0)}if(!(a[g+40>>2]|0)){h=a[b+432>>2]|0;m=a[b+436>>2]|0;a[e+16>>2]=b;l=b+24|0;k=a[l>>2]|
0;n=a[k>>2]|0;a[e>>2]=n;q=a[k+4>>2]|0;r=e+4|0;a[r>>2]=q;t=g+12|0;v=a[t>>2]|0;A=g+16|0;z=a[A>>2]|0;D=g+20|0;a[f>>2]=a[D>>2];a[f+4>>2]=a[D+4>>2];a[f+8>>2]=a[D+8>>2];a[f+12>>2]=a[D+12>>2];a[f+16>>2]=a[D+16>>2];C=b+368|0;do if(0<(a[C>>2]|0)){E=e+8|0;F=e+12|0;N=z;J=0;I=v;a:for(;;){G=a[d+(J<<2)>>2]|0;L=a[g+100+(J<<2)>>2]|0;if(8>(N|0)){if(!(Uc(e,I,N,0)|0)){p=0;K=64;break}N=a[E>>2]|0;I=a[F>>2]|0;8>(I|0)?(R=I,S=N,O=1,K=16):(M=I,T=N,K=14)}else M=N,T=I,K=14;14==(K|0)&&(K=0,N=T>>M+-8&255,(I=a[L+144+(N<<2)>>2]|
0)?(U=M-I|0,P=T,W=x[L+1168+N>>0]|0):(R=M,S=T,O=9,K=16));if(16==(K|0)){N=Tf(e,S,R,L,O)|0;if(0>(N|0)){p=0;K=64;break}U=a[F>>2]|0;P=a[E>>2]|0;W=N}N=a[g+140+(J<<2)>>2]|0;L=a[g+180+(J<<2)>>2]|0;I=0!=(W|0);b:do if(L){if(I){if((U|0)<(W|0)){if(!(Uc(e,P,U,W)|0)){p=0;K=64;break a}aa=a[F>>2]|0;ca=a[E>>2]|0}else aa=U,ca=P;fa=aa-W|0;aa=a[122072+(W<<2)>>2]|0;K=ca>>fa&aa;K=K-((K|0)>(a[122072+(W+-1<<2)>>2]|0)?0:aa)|0}else fa=U,ca=P,K=0;aa=f+4+(a[b+372+(J<<2)>>2]<<2)|0;K=(a[aa>>2]|0)+K|0;a[aa>>2]=K;w[G>>1]=K;if(1<
(L|0))for(K=fa,aa=ca,fa=1;;){if(8>(K|0)){if(!(Uc(e,aa,K,0)|0)){p=0;K=64;break a}ca=a[E>>2]|0;aa=a[F>>2]|0;8>(aa|0)?(ga=aa,ja=ca,ma=1,K=30):(pa=aa,ha=ca,K=28)}else pa=K,ha=aa,K=28;28==(K|0)&&(K=0,ca=ha>>pa+-8&255,(aa=a[N+144+(ca<<2)>>2]|0)?(ra=pa-aa|0,ya=ha,Aa=x[N+1168+ca>>0]|0):(ga=pa,ja=ha,ma=9,K=30));if(30==(K|0)){K=0;ca=Tf(e,ja,ga,N,ma)|0;if(0>(ca|0)){p=0;K=64;break a}ra=a[F>>2]|0;ya=a[E>>2]|0;Aa=ca}ca=Aa>>4;if(aa=Aa&15){fa=ca+fa|0;if((ra|0)<(aa|0)){if(!(Uc(e,ya,ra,aa)|0)){p=0;K=64;break a}ca=
a[F>>2]|0;K=a[E>>2]|0}else ca=ra,K=ya;ca=ca-aa|0;Va=a[122072+(aa<<2)>>2]|0;oa=K>>ca&Va;w[G+(a[h+(fa<<2)>>2]<<1)>>1]=oa-((oa|0)>(a[122072+(aa+-1<<2)>>2]|0)?0:Va);aa=ca;ca=K}else{if(15!=(ca|0)){Ka=ra;Qa=ya;break b}aa=ra;ca=ya;fa=fa+15|0}fa=fa+1|0;if((fa|0)<(L|0))K=aa,aa=ca;else{Y=aa;Z=ca;ba=fa;K=45;break}}else Y=fa,Z=ca,ba=1,K=45}else{if(I){if((U|0)<(W|0)){if(!(Uc(e,P,U,W)|0)){p=0;K=64;break a}Y=a[F>>2]|0;Z=a[E>>2]|0}else Y=U,Z=P;Y=Y-W|0}else Y=U,Z=P;ba=1;K=45}while(0);b:do if(45==(K|0))if(K=0,(ba|
0)>(m|0))Ka=Y,Qa=Z;else for(L=Y,G=Z,I=ba;;){if(8>(L|0)){if(!(Uc(e,G,L,0)|0)){p=0;K=64;break a}fa=a[E>>2]|0;aa=a[F>>2]|0;8>(aa|0)?(sa=aa,Wa=fa,ua=1,K=51):(Ia=aa,Da=fa,K=49)}else Ia=L,Da=G,K=49;49==(K|0)&&(K=0,fa=Da>>Ia+-8&255,(aa=a[N+144+(fa<<2)>>2]|0)?(na=Ia-aa|0,Na=Da,ab=x[N+1168+fa>>0]|0):(sa=Ia,Wa=Da,ua=9,K=51));if(51==(K|0)){K=0;fa=Tf(e,Wa,sa,N,ua)|0;if(0>(fa|0)){p=0;K=64;break a}na=a[F>>2]|0;Na=a[E>>2]|0;ab=fa}fa=ab>>4;if(aa=ab&15){if((na|0)<(aa|0)){if(!(Uc(e,Na,na,aa)|0)){p=0;K=64;break a}ca=
a[F>>2]|0;G=a[E>>2]|0}else ca=na,G=Na;L=fa;aa=ca-aa|0}else if(15==(fa|0))L=15,aa=na,G=Na;else{Ka=na;Qa=Na;break b}I=I+1+L|0;if((I|0)>(m|0)){Ka=aa;Qa=G;break}else L=aa}while(0);J=J+1|0;if((J|0)>=(a[C>>2]|0)){Ca=Ka;Ga=Qa;K=61;break}else N=Ka,I=Qa}if(61==(K|0))Ea=a[l>>2]|0,La=a[e>>2]|0,db=a[r>>2]|0,eb=Ca,fb=Ga;else if(64==(K|0))return u=c,p|0}else Ea=k,La=n,db=q,eb=z,fb=v;while(0);a[Ea>>2]=La;a[Ea+4>>2]=db;a[t>>2]=fb;a[A>>2]=eb;a[D>>2]=a[f>>2];a[D+4>>2]=a[f+4>>2];a[D+8>>2]=a[f+8>>2];a[D+12>>2]=a[f+12>>
2];a[D+16>>2]=a[f+16>>2]}f=g+44|0;a[f>>2]=(a[f>>2]|0)+-1;u=c;return 1},Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb,Pb],jg=[hl,function(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k=0,l,n,p,q,r=0,t=0,u=0,v=0,w=0,x=0,A=0,D,F,N,J=0,I=0,G=0;g=e+c|0;h=d+4|0;g>>>0<=(a[h>>2]|0)>>>0&&(a[d+12>>2]|0)>>>0>=e>>>0&&0!=(a[d>>2]|0)||(e=a[b>>2]|0,a[e+20>>2]=23,R[a[e>>2]&127](b));e=d+24|
0;m=a[e>>2]|0;m>>>0<=c>>>0&&g>>>0<=((a[d+16>>2]|0)+m|0)>>>0||(k=7);a:do if(7==(k|0)){a[d+40>>2]|0||(m=a[b>>2]|0,a[m+20>>2]=71,R[a[m>>2]&127](b));m=d+36|0;if(a[m>>2]|0){l=a[d+8>>2]|0;n=a[e>>2]|0;p=d+20|0;q=d+16|0;r=a[q>>2]|0;b:do if(0<(r|0)&&(t=d+28|0,u=d+48|0,v=d+52|0,w=a[p>>2]|0,x=(w|0)<(r|0)?w:r,w=(a[t>>2]|0)-n|0,A=(x|0)<(w|0)?x:w,w=(a[h>>2]|0)-n|0,x=(A|0)<(w|0)?A:w,1<=(x|0)))for(w=x,x=E(n,l)|0,A=0;;){D=E(w,l)|0;sf[a[v>>2]&63](b,u,a[(a[d>>2]|0)+(A<<2)>>2]|0,x,D);F=a[p>>2]|0;N=a[q>>2]|0;A=F+A|0;
if((N|0)<=(A|0))break b;w=N-A|0;N=(F|0)<(w|0)?F:w;w=A+(a[e>>2]|0)|0;F=(a[t>>2]|0)-w|0;N=(N|0)<(F|0)?N:F;F=(a[h>>2]|0)-w|0;w=(N|0)<(F|0)?N:F;if(1>(w|0))break;else x=D+x|0}while(0);a[m>>2]=0}q=d+16|0;p=a[q>>2]|0;(a[e>>2]|0)>>>0<c>>>0?m=c:(l=g-p|0,m=0>(l|0)?0:l);a[e>>2]=m;l=a[d+8>>2]|0;n=d+20|0;if(0<(p|0)&&(r=d+28|0,x=d+48|0,w=a[n>>2]|0,t=(w|0)<(p|0)?w:p,p=(a[r>>2]|0)-m|0,w=(t|0)<(p|0)?t:p,p=(a[h>>2]|0)-m|0,t=(w|0)<(p|0)?w:p,1<=(t|0)))for(p=t,t=E(l,m)|0,w=0;;){A=E(p,l)|0;sf[a[x>>2]&63](b,x,a[(a[d>>2]|
0)+(w<<2)>>2]|0,t,A);u=a[n>>2]|0;v=a[q>>2]|0;w=u+w|0;if((v|0)<=(w|0))break a;D=v-w|0;v=(u|0)<(D|0)?u:D;D=w+(a[e>>2]|0)|0;u=(a[r>>2]|0)-D|0;F=(v|0)<(u|0)?v:u;u=(a[h>>2]|0)-D|0;p=(F|0)<(u|0)?F:u;if(1>(p|0))break;else t=A+t|0}}while(0);h=d+28|0;m=a[h>>2]|0;if(m>>>0<g>>>0)if(t=0==(f|0),m>>>0<c>>>0?t?(J=0,I=c):(p=a[b>>2]|0,a[p+20>>2]=23,R[a[p>>2]&127](b),G=c,k=28):t?(J=0,I=m):(G=m,k=28),28==(k|0)&&(a[h>>2]=g,J=1,I=G),a[d+32>>2]|0){if(t=a[d+8>>2]|0,p=a[e>>2]|0,r=I-p|0,w=g-p|0,r>>>0<w>>>0){p=r;do Va(a[(a[d>>
2]|0)+(p<<2)>>2]|0,0,t|0)|0,p=p+1|0;while((p|0)!=(w|0))}}else J||(t=a[b>>2]|0,a[t+20>>2]=23,R[a[t>>2]&127](b));if(!f)return b=a[d>>2]|0,e=a[e>>2]|0,b+((c-e|0)<<2)|0;a[d+36>>2]=1;b=a[d>>2]|0;e=a[e>>2]|0;return b+((c-e|0)<<2)|0},function(b,d,c,e,f){b|=0;d|=0;c|=0;e|=0;f|=0;var g,h,m,k=0,l,n,p,q,r=0,t=0,u=0,v=0,w=0,x=0,A=0,D,F,N,J=0,I=0,G=0;g=e+c|0;h=d+4|0;g>>>0<=(a[h>>2]|0)>>>0&&(a[d+12>>2]|0)>>>0>=e>>>0&&0!=(a[d>>2]|0)||(e=a[b>>2]|0,a[e+20>>2]=23,R[a[e>>2]&127](b));e=d+24|0;m=a[e>>2]|0;m>>>0<=c>>>
0&&g>>>0<=((a[d+16>>2]|0)+m|0)>>>0||(k=7);a:do if(7==(k|0)){a[d+40>>2]|0||(m=a[b>>2]|0,a[m+20>>2]=71,R[a[m>>2]&127](b));m=d+36|0;if(a[m>>2]|0){l=a[d+8>>2]<<7;n=a[e>>2]|0;p=d+20|0;q=d+16|0;r=a[q>>2]|0;b:do if(0<(r|0)&&(t=d+28|0,u=d+48|0,v=d+52|0,w=a[p>>2]|0,x=(w|0)<(r|0)?w:r,w=(a[t>>2]|0)-n|0,A=(x|0)<(w|0)?x:w,w=(a[h>>2]|0)-n|0,x=(A|0)<(w|0)?A:w,1<=(x|0)))for(w=x,x=E(n,l)|0,A=0;;){D=E(w,l)|0;sf[a[v>>2]&63](b,u,a[(a[d>>2]|0)+(A<<2)>>2]|0,x,D);F=a[p>>2]|0;N=a[q>>2]|0;A=F+A|0;if((N|0)<=(A|0))break b;
w=N-A|0;N=(F|0)<(w|0)?F:w;w=A+(a[e>>2]|0)|0;F=(a[t>>2]|0)-w|0;N=(N|0)<(F|0)?N:F;F=(a[h>>2]|0)-w|0;w=(N|0)<(F|0)?N:F;if(1>(w|0))break;else x=D+x|0}while(0);a[m>>2]=0}q=d+16|0;p=a[q>>2]|0;(a[e>>2]|0)>>>0<c>>>0?m=c:(l=g-p|0,m=0>(l|0)?0:l);a[e>>2]=m;l=a[d+8>>2]<<7;n=d+20|0;if(0<(p|0)&&(r=d+28|0,x=d+48|0,w=a[n>>2]|0,t=(w|0)<(p|0)?w:p,p=(a[r>>2]|0)-m|0,w=(t|0)<(p|0)?t:p,p=(a[h>>2]|0)-m|0,t=(w|0)<(p|0)?w:p,1<=(t|0)))for(p=t,t=E(l,m)|0,w=0;;){A=E(p,l)|0;sf[a[x>>2]&63](b,x,a[(a[d>>2]|0)+(w<<2)>>2]|0,t,A);
u=a[n>>2]|0;v=a[q>>2]|0;w=u+w|0;if((v|0)<=(w|0))break a;D=v-w|0;v=(u|0)<(D|0)?u:D;D=w+(a[e>>2]|0)|0;u=(a[r>>2]|0)-D|0;F=(v|0)<(u|0)?v:u;u=(a[h>>2]|0)-D|0;p=(F|0)<(u|0)?F:u;if(1>(p|0))break;else t=A+t|0}}while(0);h=d+28|0;m=a[h>>2]|0;if(m>>>0<g>>>0)if(t=0==(f|0),m>>>0<c>>>0?t?(J=0,I=c):(p=a[b>>2]|0,a[p+20>>2]=23,R[a[p>>2]&127](b),G=c,k=28):t?(J=0,I=m):(G=m,k=28),28==(k|0)&&(a[h>>2]=g,J=1,I=G),a[d+32>>2]|0){if(t=a[d+8>>2]<<7,p=a[e>>2]|0,r=I-p|0,w=g-p|0,r>>>0<w>>>0){p=r;do Va(a[(a[d>>2]|0)+(p<<2)>>2]|
0,0,t|0)|0,p=p+1|0;while((p|0)!=(w|0))}}else J||(t=a[b>>2]|0,a[t+20>>2]=23,R[a[t>>2]&127](b));if(!f)return b=a[d>>2]|0,e=a[e>>2]|0,b+((c-e|0)<<2)|0;a[d+36>>2]=1;b=a[d>>2]|0;e=a[e>>2]|0;return b+((c-e|0)<<2)|0},hl],Ud=[mi,function(a,d,c,e){},function(b,d,c,e){b=d|0;c|=0;d=u;u=u+16|0;a[d>>2]=b;a[d+4>>2]=c;c=le(Qj(91,d|0)|0)|0;u=d;c|0},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p=0,q=0,r=0;c-d&4?(a[c>>2]=0,f=c+4|0):f=c;if(f>>>0>d>>>0)for(c=d,d=0;;){g=a[c>>2]|0;g>>>0>e>>>0|(g+d|0)>>>0>e>>>
0?(h=e-d|0,m=a[c>>2]=h):m=g;if(m){g=d>>>3;h=b+g|0;k=d&7;l=8-k|0;if(m>>>0>l>>>0){k?(t[h>>0]=(x[h>>0]|0)&255<<l,g=b+(g+1)|0,m=m-l|0):g=h;if(l=m>>>3){if(63<m>>>0){if(g&3)for(;;)if(n=g+1|0,t[g>>0]=0,k=l+-1|0,0!=(k|0)&0!=(n&3|0))g=n,l=k;else{h=n;break}else h=g,k=l;l=k>>>2;g=l<<2;Va(h|0,0,g|0)|0;g=h+g|0;l=k-(l<<2)|0}switch(l|0){case 15:t[g+14>>0]=0;p=17;break;case 14:p=17;break;case 13:p=18;break;case 12:p=19;break;case 11:p=20;break;case 10:p=21;break;case 9:p=22;break;case 8:p=23;break;case 7:p=24;break;
case 6:p=25;break;case 5:p=26;break;case 4:p=27;break;case 3:p=28;break;case 2:p=29;break;case 1:p=30;break;default:q=g}17==(p|0)&&(t[g+13>>0]=0,p=18);18==(p|0)&&(t[g+12>>0]=0,p=19);19==(p|0)&&(t[g+11>>0]=0,p=20);20==(p|0)&&(t[g+10>>0]=0,p=21);21==(p|0)&&(t[g+9>>0]=0,p=22);22==(p|0)&&(t[g+8>>0]=0,p=23);23==(p|0)&&(t[g+7>>0]=0,p=24);24==(p|0)&&(t[g+6>>0]=0,p=25);25==(p|0)&&(t[g+5>>0]=0,p=26);26==(p|0)&&(t[g+4>>0]=0,p=27);27==(p|0)&&(t[g+3>>0]=0,p=28);28==(p|0)&&(t[g+2>>0]=0,p=29);29==(p|0)&&(t[g+1>>
0]=0,p=30);30==(p|0)&&(p=0,t[g>>0]=0,q=g+l|0);l=q;g=m&7}else l=g,g=m;g&&(t[l>>0]=(x[l>>0]|0)&255>>>g)}else t[h>>0]=((x[142803+m>>0]|0)>>>k^255)&(x[h>>0]|0);d=(a[c>>2]|0)+d|0}l=c+4|0;g=a[l>>2]|0;g>>>0>e>>>0|(g+d|0)>>>0>e>>>0?(k=e-d|0,m=a[l>>2]=k):m=g;if(m){g=d>>>3;k=b+g|0;n=d&7;h=8-n|0;if(m>>>0>h>>>0){n?(t[k>>0]=x[k>>0]|0|255>>>n,g=b+(g+1)|0,m=m-h|0):g=k;if(h=m>>>3){if(63<m>>>0){if(g&3)for(;;)if(k=g+1|0,t[g>>0]=-1,h=h+-1|0,0!=(h|0)&0!=(k&3|0))g=k;else{n=h;break}else k=g,n=h;h=n>>>2;g=h<<2;Va(k|0,-1,
g|0)|0;g=k+g|0;h=n-(h<<2)|0}switch(h|0){case 15:t[g+14>>0]=-1;p=49;break;case 14:p=49;break;case 13:p=50;break;case 12:p=51;break;case 11:p=52;break;case 10:p=53;break;case 9:p=54;break;case 8:p=55;break;case 7:p=56;break;case 6:p=57;break;case 5:p=58;break;case 4:p=59;break;case 3:p=60;break;case 2:p=61;break;case 1:p=62;break;default:r=g}49==(p|0)&&(t[g+13>>0]=-1,p=50);50==(p|0)&&(t[g+12>>0]=-1,p=51);51==(p|0)&&(t[g+11>>0]=-1,p=52);52==(p|0)&&(t[g+10>>0]=-1,p=53);53==(p|0)&&(t[g+9>>0]=-1,p=54);
54==(p|0)&&(t[g+8>>0]=-1,p=55);55==(p|0)&&(t[g+7>>0]=-1,p=56);56==(p|0)&&(t[g+6>>0]=-1,p=57);57==(p|0)&&(t[g+5>>0]=-1,p=58);58==(p|0)&&(t[g+4>>0]=-1,p=59);59==(p|0)&&(t[g+3>>0]=-1,p=60);60==(p|0)&&(t[g+2>>0]=-1,p=61);61==(p|0)&&(t[g+1>>0]=-1,p=62);62==(p|0)&&(p=0,t[g>>0]=-1,r=g+h|0);g=r;m&=7}m&&(t[g>>0]=x[g>>0]|0|65280>>>m)}else t[k>>0]=x[k>>0]|0|(x[142803+m>>0]|0)>>>n;l=(a[l>>2]|0)+d|0}else l=d;c=c+8|0;if(c>>>0>=f>>>0){b=l;break}else d=l}else b=0;(b|0)!=(e|0)&&Z(142812,142823,453,142834)},function(b,
d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,t=0;f=a[b+396>>2]|0;g=f+8|0;h=b+288|0;if(!((a[g>>2]|0)>>>0>=(a[h>>2]|0)>>>0)){m=f+12|0;k=b+284|0;l=b+400|0;n=f+24|0;p=b+404|0;q=f+16|0;for(f=a[m>>2]|0;;){r=a[k>>2]|0;f>>>0<r>>>0&&(ee[a[(a[l>>2]|0)+4>>2]&15](b,d,c,e,n,m,r),f=a[m>>2]|0,r=a[k>>2]|0);if((f|0)!=(r|0)){b=12;break}r=0==(dd[a[(a[p>>2]|0)+4>>2]&127](b,n)|0);t=0!=(a[q>>2]|0);if(r){b=7;break}t&&(a[c>>2]=(a[c>>2]|0)+1,a[q>>2]=0);a[m>>2]=0;r=(a[g>>2]|0)+1|0;a[g>>2]=r;if(r>>>0<(a[h>>2]|0)>>>0)f=
0;else{b=12;break}}7!=(b|0)||t||(a[c>>2]=(a[c>>2]|0)+-1,a[q>>2]=1)}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v,w,z,A;f=E(a[d+36>>2]|0,a[d+28>>2]|0)|0;d=b+276|0;g=a[d>>2]|0;h=a[b+28>>2]|0;if(-2<(g|0)&0<(f-h|0)){m=h+-1|0;k=m-f|0;l=f+2-h+(-2<(k|0)?k:-2)|0;k=g+1|0;for(n=0;p=a[c+(n+-1<<2)>>2]|0,Va(p+h|0,t[p+m>>0]|0,l|0)|0,(n|0)!=(k|0);)n=n+1|0;q=a[d>>2]|0}else q=g;g=a[b+228>>2]|0;b=65536-(g<<9)|0;n=g<<6;if(!(0>=(q|0)))if(q=f+-2|0){g=f+-1|0;f=0;do{v=a[e+(f<<2)>>2]|0;k=a[c+(f<<2)>>
2]|0;l=a[c+(f+-1<<2)>>2]|0;f=f+1|0;m=a[c+(f<<2)>>2]|0;u=l+1|0;p=m+1|0;r=(x[m>>0]|0)+(x[l>>0]|0)|0;l=x[k>>0]|0;m=r+l|0;h=k+1|0;w=(x[p>>0]|0)+(x[u>>0]|0)+(x[h>>0]|0)|0;z=((E(l,b)|0)+32768+(E(m+r+w|0,n)|0)|0)>>>16&255;t[v>>0]=z;z=v+g|0;r=v;v=u;u=p;p=q;l=w;w=h;for(h=m;;)if(r=r+1|0,m=x[w>>0]|0,w=w+1|0,v=v+1|0,u=u+1|0,A=(x[u>>0]|0)+(x[v>>0]|0)+(x[w>>0]|0)|0,h=((E(m,b)|0)+32768+(E(h+l-m+A|0,n)|0)|0)>>>16&255,t[r>>0]=h,p=p+-1|0)h=l,l=A;else{p=A;break}h=x[k+g>>0]|0;l=((E(h,b)|0)+32768+(E(l-h+(p<<1)|0,n)|0)|
0)>>>16&255;t[z>>0]=l}while((f|0)<(a[d>>2]|0))}else{g=0;do k=a[e+(g<<2)>>2]|0,l=a[c+(g<<2)>>2]|0,m=a[c+(g+-1<<2)>>2]|0,g=g+1|0,h=a[c+(g<<2)>>2]|0,p=(x[h>>0]|0)+(x[m>>0]|0)|0,r=x[l>>0]|0,u=p+r|0,v=l+1|0,l=(x[h+1>>0]|0)+(x[m+1>>0]|0)+(x[v>>0]|0)|0,m=((E(r,b)|0)+32768+(E(u+p+l|0,n)|0)|0)>>>16&255,t[k>>0]=m,m=x[v>>0]|0,v=((E(m,b)|0)+32768+(E(u-m+(l<<1)|0,n)|0)|0)>>>16&255,t[k+1>>0]=v;while((g|0)<(a[d>>2]|0))}},function(b,d,c,e){b|=0;d|=0;e|=0;var f,g,h;f=b+276|0;g=b+28|0;Dg(c|0,0,e,0,a[f>>2]|0,a[g>>2]|
0);c=a[f>>2]|0;f=a[g>>2]|0;g=E(a[d+36>>2]|0,a[d+28>>2]|0)|0;if(0<(c|0)&0<(g-f|0)){d=f+-1|0;b=d-g|0;h=2-f+g+(-2<(b|0)?b:-2)|0;b=0;do g=a[e+(b<<2)>>2]|0,Va(g+f|0,t[g+d>>0]|0,h|0)|0,b=b+1|0;while((b|0)!=(c|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l;f=E(a[d+36>>2]|0,a[d+28>>2]|0)|0;d=b+276|0;g=a[d>>2]|0;h=a[b+28>>2]|0;b=f<<1;if(0<(g|0)&0<(b-h|0)){m=h+-1|0;k=m-b|0;l=b+2-h+(-2<(k|0)?k:-2)|0;k=0;do b=a[c+(k<<2)>>2]|0,Va(b+h|0,t[b+m>>0]|0,l|0)|0,k=k+1|0;while((k|0)!=(g|0));b=a[d>>2]|0}else b=
g;if(!(0>=(b|0)))if(f){h=0;do{b=0;g=a[c+(h<<2)>>2]|0;k=0;for(l=a[e+(h<<2)>>2]|0;t[l>>0]=((x[g>>0]|0)+b+(x[g+1>>0]|0)|0)>>>1,k=k+1|0,(k|0)!=(f|0);)b^=1,g=g+2|0,l=l+1|0;h=h+1|0}while((h|0)<(a[d>>2]|0))}else{g=0;do g=g+1|0;while((g|0)<(b|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v,w,z,A,C,D,F,N,J,I,G,L,K,R,S,O,M,T;f=E(a[d+36>>2]|0,a[d+28>>2]|0)|0;d=b+276|0;g=a[d>>2]|0;h=a[b+28>>2]|0;m=f<<1;if(-2<(g|0)&0<(m-h|0)){k=h+-1|0;l=k-m|0;n=m+2-h+(-2<(l|0)?l:-2)|0;l=g+1|0;for(m=0;p=
a[c+(m+-1<<2)>>2]|0,Va(p+h|0,t[p+k>>0]|0,n|0)|0,(m|0)!=(l|0);)m=m+1|0;q=a[d>>2]|0}else q=g;g=a[b+228>>2]|0;b=(E(g,-80)|0)+16384|0;m=g<<4;if(!(0>=(q|0)))for(q=f+-2|0,g=f+-1|0,l=f<<1,f=l+-3|0,n=l+-3|0,k=l+-3|0,h=l=0;;){p=a[e+(h<<2)>>2]|0;r=a[c+(l<<2)>>2]|0;u=a[c+((l|1)<<2)>>2]|0;v=a[c+(l+-1<<2)>>2]|0;l=l+2|0;w=a[c+(l<<2)>>2]|0;z=x[r>>0]|0;A=x[u>>0]|0;C=x[v>>0]|0;D=x[w>>0]|0;F=r+2|0;N=u+2|0;J=v+2|0;I=w+2|0;G=((E((x[r+1>>0]|0)+z+A+(x[u+1>>0]|0)|0,b)|0)+32768+(E(D+C+(x[J>>0]|0)+(x[I>>0]|0)+(A+z+C+(x[v+
1>>0]|0)+D+(x[w+1>>0]|0)+(x[F>>0]|0)+(x[N>>0]|0)<<1)|0,m)|0)|0)>>>16&255;t[p>>0]=G;G=p+g|0;D=p;p=r;r=u;C=v;z=w;A=J;J=I;I=q;L=F;for(F=N;;){N=D+1|0;K=x[p+3>>0]|0;R=x[r+3>>0]|0;S=K+(x[L>>0]|0)+(x[F>>0]|0)+R|0;O=x[C+3>>0]|0;M=x[z+3>>0]|0;p=O+(x[A>>0]|0)+(x[J>>0]|0)+M+(x[p+1>>0]|0)|0;if(!I){A=K;break}M=L+2|0;O=F+2|0;R=A+2|0;K=J+2|0;r=((E(S,b)|0)+32768+(E((x[R>>0]|0)+(x[C+1>>0]|0)+((x[M>>0]|0)+p+(x[r+1>>0]|0)+(x[O>>0]|0)<<1)+(x[z+1>>0]|0)+(x[K>>0]|0)|0,m)|0)|0)>>>16&255;t[N>>0]=r;r=J;p=A;S=F;T=L;D=N;A=
R;J=K;I=I+-1|0;L=M;F=O;z=r;C=p;r=S;p=T}p=((E(S,b)|0)+32768+(E(M+O+(x[v+n>>0]|0)+(x[w+k>>0]|0)+(R+A+p+(x[u+f>>0]|0)<<1)|0,m)|0)|0)>>>16&255;t[G>>0]=p;if((l|0)>=(a[d>>2]|0))break;else h=h+1|0}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n;f=E(a[d+36>>2]|0,a[d+28>>2]|0)|0;d=b+276|0;g=a[d>>2]|0;h=a[b+28>>2]|0;b=f<<1;if(0<(g|0)&0<(b-h|0)){m=h+-1|0;k=m-b|0;l=b+2-h+(-2<(k|0)?k:-2)|0;k=0;do b=a[c+(k<<2)>>2]|0,Va(b+h|0,t[b+m>>0]|0,l|0)|0,k=k+1|0;while((k|0)!=(g|0));b=a[d>>2]|0}else b=g;if(!(0>=
(b|0)))if(f)for(n=h=0;;){b=1;g=a[c+(h<<2)>>2]|0;k=a[c+((h|1)<<2)>>2]|0;l=0;for(m=a[e+(n<<2)>>2]|0;t[m>>0]=((x[g>>0]|0)+b+(x[g+1>>0]|0)+(x[k>>0]|0)+(x[k+1>>0]|0)|0)>>>2,l=l+1|0,(l|0)!=(f|0);)b^=3,g=g+2|0,k=k+2|0,m=m+1|0;h=h+2|0;if((h|0)>=(a[d>>2]|0))break;else n=n+1|0}else{g=0;do g=g+2|0;while((g|0)<(b|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v,w,z,A,C;f=a[b+416>>2]|0;g=E(a[d+36>>2]|0,a[d+28>>2]|0)|0;h=a[d+4>>2]|0;d=t[f+92+h>>0]|0;m=d&255;k=t[f+102+h>>0]|0;h=k&255;f=E(h,
m)|0;l=f>>>1;n=b+276|0;p=a[n>>2]|0;q=a[b+28>>2]|0;b=E(m,g)|0;if(0<(p|0)&0<(b-q|0)){r=q+-1|0;u=r-b|0;v=b+2-q+(-2<(u|0)?u:-2)|0;u=0;do b=a[c+(u<<2)>>2]|0,Va(b+q|0,t[b+r>>0]|0,v|0)|0,u=u+1|0;while((u|0)!=(p|0));w=a[n>>2]|0}else w=p;if(!(0>=(w|0)))for(p=0==(g|0),u=0==k<<24>>24,k=0==d<<24>>24,d=w,v=w=0;;){if(p)b=d;else{q=r=0;for(b=a[e+(v<<2)>>2]|0;;){if(u)d=0;else for(d=z=0;;){if(k)A=z;else for(A=0,C=(a[c+(d+w<<2)>>2]|0)+q|0;;)if(z=(x[C>>0]|0)+z|0,A=A+1|0,(A|0)==(m|0)){A=z;break}else C=C+1|0;d=d+1|0;if((d|
0)==(h|0)){d=A;break}else z=A}t[b>>0]=(d+l|0)/(f|0)|0;r=r+1|0;if((r|0)==(g|0))break;else q=q+m|0,b=b+1|0}b=a[n>>2]|0}w=w+h|0;if((w|0)>=(b|0))break;else d=b,v=v+1|0}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v,w,z,A,C,D,E,F,J,I,G;f=a[b+476>>2]|0;g=a[b+336>>2]|0;h=a[f+16>>2]|0;m=a[f+20>>2]|0;k=a[f+24>>2]|0;l=a[f+28>>2]|0;f=c<<1;n=a[d>>2]|0;p=a[n+(f<<2)>>2]|0;q=a[n+((f|1)<<2)>>2]|0;f=a[(a[d+4>>2]|0)+(c<<2)>>2]|0;n=a[(a[d+8>>2]|0)+(c<<2)>>2]|0;c=a[e>>2]|0;d=a[e+4>>2]|0;e=b+112|
0;b=a[e>>2]|0;if(r=b>>>1){b=6*r|0;u=r<<1;v=c+b|0;w=n+r|0;z=r;A=p;C=q;D=f;E=n;n=c;for(c=d;;)if(F=x[D>>0]|0,J=x[E>>0]|0,I=a[h+(J<<2)>>2]|0,G=(a[k+(J<<2)>>2]|0)+(a[l+(F<<2)>>2]|0)>>16,J=a[m+(F<<2)>>2]|0,F=x[A>>0]|0,t[n>>0]=t[g+(F+I)>>0]|0,t[n+1>>0]=t[g+(F+G)>>0]|0,t[n+2>>0]=t[g+(F+J)>>0]|0,F=x[A+1>>0]|0,t[n+3>>0]=t[g+(F+I)>>0]|0,t[n+4>>0]=t[g+(F+G)>>0]|0,t[n+5>>0]=t[g+(F+J)>>0]|0,F=x[C>>0]|0,t[c>>0]=t[g+(F+I)>>0]|0,t[c+1>>0]=t[g+(F+G)>>0]|0,t[c+2>>0]=t[g+(F+J)>>0]|0,F=x[C+1>>0]|0,t[c+3>>0]=t[g+(F+I)>>
0]|0,t[c+4>>0]=t[g+(F+G)>>0]|0,t[c+5>>0]=t[g+(F+J)>>0]|0,z=z+-1|0)A=A+2|0,C=C+2|0,D=D+1|0,E=E+1|0,n=n+6|0,c=c+6|0;else break;e=a[e>>2]|0;p=p+u|0;q=q+u|0;f=f+r|0;n=w;c=v;b=d+b|0}else e=b,b=d;e&1&&(e=x[f>>0]|0,f=x[n>>0]|0,n=a[h+(f<<2)>>2]|0,h=(a[k+(f<<2)>>2]|0)+(a[l+(e<<2)>>2]|0)>>16,l=a[m+(e<<2)>>2]|0,e=x[p>>0]|0,t[c>>0]=t[g+(e+n)>>0]|0,t[c+1>>0]=t[g+(e+h)>>0]|0,t[c+2>>0]=t[g+(e+l)>>0]|0,e=x[q>>0]|0,t[b>>0]=t[g+(e+n)>>0]|0,t[b+1>>0]=t[g+(e+h)>>0]|0,t[b+2>>0]=t[g+(e+l)>>0]|0)},function(b,d,c,e){b|=
0;d|=0;c|=0;var f,g,h,m,k,l,n,p,q,r,u,v,w,z,A,C;f=a[b+476>>2]|0;g=a[b+336>>2]|0;h=a[f+16>>2]|0;m=a[f+20>>2]|0;k=a[f+24>>2]|0;l=a[f+28>>2]|0;f=a[(a[d>>2]|0)+(c<<2)>>2]|0;n=a[(a[d+4>>2]|0)+(c<<2)>>2]|0;p=a[(a[d+8>>2]|0)+(c<<2)>>2]|0;c=a[(e|0)>>2]|0;e=b+112|0;b=a[e>>2]|0;if(d=b>>>1){b=p+d|0;q=d;r=f;u=n;v=p;for(p=c;;)if(w=x[u>>0]|0,z=x[v>>0]|0,A=a[h+(z<<2)>>2]|0,C=(a[k+(z<<2)>>2]|0)+(a[l+(w<<2)>>2]|0)>>16,z=a[m+(w<<2)>>2]|0,w=x[r>>0]|0,t[p>>0]=t[g+(w+A)>>0]|0,t[p+1>>0]=t[g+(w+C)>>0]|0,t[p+2>>0]=t[g+(w+
z)>>0]|0,w=x[r+1>>0]|0,t[p+3>>0]=t[g+(w+A)>>0]|0,t[p+4>>0]=t[g+(w+C)>>0]|0,t[p+5>>0]=t[g+(w+z)>>0]|0,q=q+-1|0)r=r+2|0,u=u+1|0,v=v+1|0,p=p+6|0;else break;e=a[e>>2]|0;f=f+(d<<1)|0;n=n+d|0;p=b;d=c+(6*d|0)|0}else e=b,d=c;e&1&&(e=x[n>>0]|0,n=x[p>>0]|0,p=(a[k+(n<<2)>>2]|0)+(a[l+(e<<2)>>2]|0)>>16,l=a[m+(e<<2)>>2]|0,e=x[f>>0]|0,t[d>>0]=t[g+(e+(a[h+(n<<2)>>2]|0))>>0]|0,t[d+1>>0]=t[g+(e+p)>>0]|0,t[d+2>>0]=t[g+(e+l)>>0]|0)},function(b,d,c,e){a[(e|0)>>2]=0},function(b,d,c,e){a[(e|0)>>2]=c|0},function(b,d,c,e){b|=
0;c|=0;var f,g,h,m,k;d=a[(e|0)>>2]|0;e=b+320|0;f=a[e>>2]|0;if(!(0>=(f|0)))for(g=b+112|0,b=f,f=0;;){h=a[d+(f<<2)>>2]|0;m=a[g>>2]|0;k=h+m|0;if(0<(m|0)){m=a[c+(f<<2)>>2]|0;for(b=h;!(h=t[m>>0]|0,t[b>>0]=h,t[b+1>>0]=h,b=b+2|0,b>>>0>=k>>>0);)m=m+1|0;h=a[e>>2]|0}else h=b;f=f+1|0;if((f|0)>=(h|0))break;else b=h}},function(b,d,c,e){b|=0;c|=0;var f,g,h,m,k,l;d=a[(e|0)>>2]|0;e=b+320|0;if(!(0>=(a[e>>2]|0)))for(f=b+112|0,g=b=0;;){h=a[d+(g<<2)>>2]|0;m=a[f>>2]|0;k=h+m|0;if(0<(m|0)){m=a[c+(b<<2)>>2]|0;for(l=h;!(h=
t[m>>0]|0,t[l>>0]=h,t[l+1>>0]=h,l=l+2|0,l>>>0>=k>>>0);)m=m+1|0;h=a[f>>2]|0}else h=m;Dg(d,g,d,g|1,1,h);g=g+2|0;if((g|0)>=(a[e>>2]|0))break;else b=b+1|0}},function(b,d,c,e){b|=0;c|=0;var f,g,h,m,k,l,n,p,q;f=a[b+476>>2]|0;g=a[(e|0)>>2]|0;e=a[(d|0)+4>>2]|0;d=t[f+140+e>>0]|0;h=d&255;m=t[f+150+e>>0]|0;e=m&255;f=b+320|0;if(!(0>=(a[f>>2]|0)))if(k=b+112|0,b=0!=d<<24>>24,l=e+-1|0,n=(0==d<<24>>24?~h:-2)+h+2|0,1<(m&255)){for(h=m=0;;){d=a[g+(h<<2)>>2]|0;p=a[k>>2]|0;q=d+p|0;if(0<(p|0)){if(!b){b=5;break}for(p=a[c+
(m<<2)>>2]|0;!(Va(d|0,t[p>>0]|0,n|0)|0,d=d+n|0,d>>>0>=q>>>0);)p=p+1|0}Dg(g,h,g,h+1|0,l,a[k>>2]|0);h=h+e|0;if((h|0)>=(a[f>>2]|0)){b=15;break}else m=m+1|0}if(5==(b|0))for(;;);}else{for(h=m=0;;){l=a[g+(h<<2)>>2]|0;p=a[k>>2]|0;q=l+p|0;if(0<(p|0)){if(!b){b=13;break}p=a[c+(m<<2)>>2]|0;for(d=l;!(Va(d|0,t[p>>0]|0,n|0)|0,d=d+n|0,d>>>0>=q>>>0);)p=p+1|0}h=h+e|0;if((h|0)>=(a[f>>2]|0)){b=15;break}else m=m+1|0}if(13==(b|0))for(;;);}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n;f=a[(a[b+484>>2]|0)+24>>
2]|0;g=a[f>>2]|0;h=a[f+4>>2]|0;m=a[f+8>>2]|0;f=a[b+112>>2]|0;if(!(1>(e|0)|0==(f|0))){k=0;do{b=f;l=a[d+(k<<2)>>2]|0;for(n=a[c+(k<<2)>>2]|0;;)if(t[n>>0]=(x[h+(x[l+1>>0]|0)>>0]|0)+(x[g+(x[l>>0]|0)>>0]|0)+(x[m+(x[l+2>>0]|0)>>0]|0),b=b+-1|0)l=l+3|0,n=n+1|0;else break;k=k+1|0}while((k|0)!=(e|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u;f=a[(a[b+484>>2]|0)+24>>2]|0;g=a[b+112>>2]|0;h=a[b+120>>2]|0;if(!(0>=(e|0))){b=0==(g|0);m=0<(h|0);k=0;do{if(!b)for(l=g,n=a[d+(k<<2)>>2]|0,p=a[c+
(k<<2)>>2]|0;;){if(m){r=q=0;for(u=n;;)if(r=(x[(a[f+(q<<2)>>2]|0)+(x[u>>0]|0)>>0]|0)+r|0,q=q+1|0,(q|0)==(h|0)){q=r;break}else u=u+1|0;n=n+h|0}else q=0;t[p>>0]=q;if(l=l+-1|0)p=p+1|0;else break}k=k+1|0}while((k|0)!=(e|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v,w,z,A,C,D;f=a[b+484>>2]|0;g=a[f+24>>2]|0;h=a[g>>2]|0;m=a[g+4>>2]|0;k=a[g+8>>2]|0;g=a[b+112>>2]|0;if(!(0>=(e|0))){b=f+48|0;l=f+52|0;n=f+56|0;p=f+60|0;f=0==(g|0);q=a[b>>2]|0;r=0;do{u=a[l>>2]|0;v=a[n>>2]|0;w=a[p>>2]|0;
if(!f)for(z=g,A=0,C=a[d+(r<<2)>>2]|0,D=a[c+(r<<2)>>2]|0;;)if(t[D>>0]=(x[m+((x[C+1>>0]|0)+(a[v+(q<<6)+(A<<2)>>2]|0))>>0]|0)+(x[h+((x[C>>0]|0)+(a[u+(q<<6)+(A<<2)>>2]|0))>>0]|0)+(x[k+((x[C+2>>0]|0)+(a[w+(q<<6)+(A<<2)>>2]|0))>>0]|0),z=z+-1|0)A=A+1&15,C=C+3|0,D=D+1|0;else break;q=q+1&15;a[b>>2]=q;r=r+1|0}while((r|0)!=(e|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v,w,z,A,C,D;f=a[b+484>>2]|0;g=a[b+120>>2]|0;h=a[b+112>>2]|0;if(!(0>=(e|0))){b=f+48|0;m=0<(g|0);k=f+24|0;l=0==(h|0);
n=0;do{p=c+(n<<2)|0;Va(a[p>>2]|0,0,h|0)|0;q=a[b>>2]|0;if(m){r=d+(n<<2)|0;u=0;do{v=a[(a[k>>2]|0)+(u<<2)>>2]|0;w=a[f+52+(u<<2)>>2]|0;if(!l)for(z=h,A=0,C=(a[r>>2]|0)+u|0,D=a[p>>2]|0;;)if(t[D>>0]=(x[D>>0]|0)+(x[v+((x[C>>0]|0)+(a[w+(q<<6)+(A<<2)>>2]|0))>>0]|0),z=z+-1|0)A=A+1&15,C=C+g|0,D=D+1|0;else break;u=u+1|0}while((u|0)!=(g|0))}a[b>>2]=q+1&15;n=n+1|0}while((n|0)!=(e|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v,A,z,D,C,F,N,R,J,I,G,L,K,S,U,O,M,T,W,P;f=a[b+484>>2]|0;g=a[b+120>>
2]|0;h=a[b+112>>2]|0;m=a[b+336>>2]|0;if(!(0>=(e|0))){b=0<(g|0);k=f+84|0;l=f+24|0;n=f+16|0;p=0==(h|0);q=h+-1|0;r=E(q,g)|0;u=0-g|0;v=h+1|0;A=0;do{z=c+(A<<2)|0;Va(a[z>>2]|0,0,h|0)|0;if(b){D=d+(A<<2)|0;C=0;do{F=a[z>>2]|0;N=a[f+68+(C<<2)>>2]|0;a[k>>2]|0?(R=C+r|0,J=-1,I=u,G=N+(v<<1)|0,L=F+q|0):(R=C,J=1,I=g,G=N,L=F);F=a[(a[l>>2]|0)+(C<<2)>>2]|0;N=a[(a[n>>2]|0)+(C<<2)>>2]|0;if(p)F=0;else{K=E(h,J)|0;U=S=0;O=h;M=0;T=G;for(R=(a[D>>2]|0)+R|0;;)if(W=T,T=T+(J<<1)|0,M=x[m+((M+8+(w[T>>1]|0)>>4)+(x[R>>0]|0))>>0]|
0,P=x[F+M>>0]|0,t[L>>0]=(x[L>>0]|0)+P,M=M-(x[N+P>>0]|0)|0,w[W>>1]=(3*M|0)+U,W=(5*M|0)+S|0,O=O+-1|0)S=M,U=W,M=7*M|0,R=R+I|0,L=L+J|0;else{F=W;break}G=G+(K<<1)|0}w[G>>1]=F;C=C+1|0}while((C|0)!=(g|0))}a[k>>2]=0==(a[k>>2]|0)&1;A=A+1|0}while((A|0)!=(e|0))}},function(b,d,c,e){b|=0;d|=0;e|=0;var f,g,h,m,k,l;c=a[(a[b+484>>2]|0)+24>>2]|0;f=a[b+112>>2]|0;if(!(1>(e|0)|0==(f|0))){g=0;do{b=f;for(h=a[d+(g<<2)>>2]|0;;)if(m=(a[c+((x[h>>0]|0)>>>3<<2)>>2]|0)+((x[h+1>>0]|0)>>>2<<6)+((x[h+2>>0]|0)>>>3<<1)|0,k=w[m>>1]|
0,l=k+1<<16>>16,w[m>>1]=0==l<<16>>16?k:l,b=b+-1|0)h=h+3|0;else break;g=g+1|0}while((g|0)!=(e|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v,A,z,D,C,F,N,R,J,I,G,L,K,S,U,O,M,T,W,P,Y,Z,aa,ba,ca,da,fa,ga;f=a[b+484>>2]|0;g=a[f+24>>2]|0;h=a[b+112>>2]|0;m=a[b+336>>2]|0;k=a[f+40>>2]|0;l=a[b+136>>2]|0;n=a[l>>2]|0;p=a[l+4>>2]|0;q=a[l+8>>2]|0;if(!(0>=(e|0))){l=f+36|0;r=f+32|0;f=0==(h|0);u=h+-1|0;v=3*u|0;A=(3*h|0)+3|0;z=0;do{D=a[d+(z<<2)>>2]|0;C=a[c+(z<<2)>>2]|0;a[l>>2]|0?(F=-1,N=-3,
R=(a[r>>2]|0)+(A<<1)|0,J=D+v|0,I=C+u|0,G=0):(F=1,N=3,R=a[r>>2]|0,J=D,I=C,G=1);a[l>>2]=G;if(f)D=N=F=0;else{C=N+1|0;D=N+2|0;G=E(h,N)|0;M=O=U=S=K=L=0;T=h;Y=P=W=0;Z=R;for(aa=I;;)if(I=Z,Z=Z+(N<<1)|0,ba=x[m+((x[J>>0]|0)+(a[k+(W+8+(w[Z>>1]|0)>>4<<2)>>2]|0))>>0]|0,ca=x[m+((x[J+1>>0]|0)+(a[k+(P+8+(w[I+(C<<1)>>1]|0)>>4<<2)>>2]|0))>>0]|0,W=x[m+((x[J+2>>0]|0)+(a[k+(Y+8+(w[I+(D<<1)>>1]|0)>>4<<2)>>2]|0))>>0]|0,P=W>>>3,Y=ca>>>2,da=ba>>>3,fa=(a[g+(da<<2)>>2]|0)+(Y<<6)+(P<<1)|0,ga=w[fa>>1]|0,ga<<16>>16?P=ga:(Hg(b,
da,Y,P),P=w[fa>>1]|0),ga=(P&65535)+-1|0,t[aa>>0]=ga,fa=ba-(x[n+ga>>0]|0)|0,ba=ca-(x[p+ga>>0]|0)|0,ca=W-(x[q+ga>>0]|0)|0,w[I>>1]=(3*fa|0)+U,ga=(5*fa|0)+L|0,w[I+2>>1]=(3*ba|0)+O,W=(5*ba|0)+K|0,w[I+4>>1]=(3*ca|0)+M,I=(5*ca|0)+S|0,T=T+-1|0)L=fa,K=ba,S=ca,U=ga,O=W,M=I,W=7*fa|0,P=7*ba|0,Y=7*ca|0,J=J+N|0,aa=aa+F|0;else{F=ga;N=W;D=I;break}R=R+(G<<1)|0}w[R>>1]=F;w[R+2>>1]=N;w[R+4>>1]=D;z=z+1|0}while((z|0)!=(e|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k,l,n,p,q,r,u,v;f=a[(a[b+484>>2]|0)+24>>2]|
0;g=a[b+112>>2]|0;if(!(0>=(e|0))){h=0==(g|0);m=0;do{if(!h)for(k=g,l=a[d+(m<<2)>>2]|0,n=a[c+(m<<2)>>2]|0;;)if(p=(x[l>>0]|0)>>>3,q=(x[l+1>>0]|0)>>>2,r=(x[l+2>>0]|0)>>>3,u=(a[f+(p<<2)>>2]|0)+(q<<6)+(r<<1)|0,v=w[u>>1]|0,v<<16>>16?p=v:(Hg(b,p,q,r),p=w[u>>1]|0),t[n>>0]=(p&65535)+255,k=k+-1|0)l=l+3|0,n=n+1|0;else break;m=m+1|0}while((m|0)!=(e|0))}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m,k=0,l=0,n=0,p=0,q=0,r=0,t=0,u,v,w,x,A,D,F;f=b+448|0;g=a[f>>2]|0;h=g+48|0;if(!(a[h>>2]|0))if(dd[a[(a[b+452>>
2]|0)+12>>2]&127](b,a[g+56+(a[g+64>>2]<<2)>>2]|0)|0)a[h>>2]=1,m=g+76|0,a[m>>2]=(a[m>>2]|0)+1;else return;m=g+68|0;switch(a[m>>2]|0){case 2:k=g+52|0;l=g+72|0;ee[a[(a[b+456>>2]|0)+4>>2]&15](b,a[g+56+(a[g+64>>2]<<2)>>2]|0,k,a[l>>2]|0,d,c,e);if((a[k>>2]|0)>>>0<(a[l>>2]|0)>>>0)return;a[m>>2]=0;if((a[c>>2]|0)>>>0<e>>>0)n=k,p=l,q=9;else return;break;case 0:n=g+52|0;p=g+72|0;q=9;break;case 1:r=g+52|0;t=g+72|0;break;default:return}if(9==(q|0)){a[n>>2]=0;q=a[b+328>>2]|0;a[p>>2]=q+-1;if((a[g+76>>2]|0)==(a[b+
332>>2]|0)&&(l=a[f>>2]|0,k=a[b+36>>2]|0,0<(k|0)))for(u=l+72|0,v=l+64|0,w=0,x=a[b+216>>2]|0;;){A=E(a[x+40>>2]|0,a[x+12>>2]|0)|0;D=(A|0)/(q|0)|0;r=((a[x+48>>2]|0)>>>0)%(A>>>0)|0;t=0==(r|0)?A:r;w||(a[u>>2]=((t+-1|0)/(D|0)|0)+1);r=a[(a[l+56+(a[v>>2]<<2)>>2]|0)+(w<<2)>>2]|0;A=D<<1;if(0<(D|0)){D=r+(t+-1<<2)|0;F=0;do a[r+(F+t<<2)>>2]=a[D>>2],F=F+1|0;while((F|0)<(A|0))}w=w+1|0;if((w|0)==(k|0))break;else x=x+88|0}a[m>>2]=1;r=n;t=p}p=g+64|0;ee[a[(a[b+456>>2]|0)+4>>2]&15](b,a[g+56+(a[p>>2]<<2)>>2]|0,r,a[t>>
2]|0,d,c,e);if(!((a[r>>2]|0)>>>0<(a[t>>2]|0)>>>0)){if(1==(a[g+76>>2]|0))if(g=a[f>>2]|0,f=a[b+328>>2]|0,e=a[b+36>>2]|0,0<(e|0))for(c=g+56|0,d=g+60|0,g=f+1|0,n=f+2|0,x=0,k=a[b+216>>2]|0;;){w=(E(a[k+40>>2]|0,a[k+12>>2]|0)|0)/(f|0)|0;v=a[(a[c>>2]|0)+(x<<2)>>2]|0;l=a[(a[d>>2]|0)+(x<<2)>>2]|0;if(0<(w|0)){u=E(w,g)|0;q=E(w,n)|0;A=0;do F=A+u|0,D=A-w|0,a[v+(D<<2)>>2]=a[v+(F<<2)>>2],a[l+(D<<2)>>2]=a[l+(F<<2)>>2],F=A+q|0,a[v+(F<<2)>>2]=a[v+(A<<2)>>2],a[l+(F<<2)>>2]=a[l+(A<<2)>>2],A=A+1|0;while((A|0)!=(w|0))}x=
x+1|0;if((x|0)==(e|0)){b=f;break}else k=k+88|0}else b=f;else b=a[b+328>>2]|0;a[p>>2]^=1;a[h>>2]=0;a[r>>2]=b+1;a[t>>2]=b+2;a[m>>2]=2}},function(b,d,c,e){b|=0;d|=0;c|=0;e|=0;var f,g,h,m;f=a[b+448>>2]|0;g=f+48|0;if(a[g>>2]|0)m=f+8|0;else if(h=f+8|0,dd[a[(a[b+452>>2]|0)+12>>2]&127](b,h)|0)a[g>>2]=1,m=h;else return;h=a[b+328>>2]|0;f=f+52|0;ee[a[(a[b+456>>2]|0)+4>>2]&15](b,m,f,h,d,c,e);(a[f>>2]|0)>>>0<h>>>0||(a[g>>2]=0,a[f>>2]=0)},function(b,d,c,e){b|=0;ee[a[(a[b+456>>2]|0)+4>>2]&15](b,0,0,0,d|0,c|0,e|
0)},mi,mi,mi];return{_GetField:function(b,d){var c,e;c=u;u=u+16|0;e=c+4|0;a[e>>2]=0;a[c>>2]=e;Pd(b|0,d|0,c)|0;u=c;return a[e>>2]|0},_TIFFClose:function(b){b|=0;var d,c;d=a[b+644>>2]|0;c=a[b+628>>2]|0;Ik(b);da[d&63](c)|0},_TIFFReadDirectory:ck,_TIFFGetField:Pd,_bitshift64Lshr:Oe,_bitshift64Shl:Oc,_TIFFReadRGBAImageOriented:vc,_TIFFCurrentDirectory:function(a){return w[(a|0)+448>>1]|0},_fflush:Rk,_TIFFSetDirectory:function(b,d){b|=0;d|=0;var c,e,f,g,h,m;c=u;u=u+16|0;a[b+12>>2]&524288?(g=b+432|0,e=a[g>>
2]|0,f=a[g+4>>2]|0):(e=a[b+428>>2]|0,f=0);g=c;a[g>>2]=e;a[g+4>>2]=f;a:do{if(0!=d<<16>>16&(0!=(e|0)|0!=(f|0))){for(g=d;;){if(!(Gj(b,c,0)|0)){g=0;break}e=g+-1<<16>>16;f=c;g=a[f>>2]|0;f=a[f+4>>2]|0;if(0!=e<<16>>16&(0!=(g|0)|0!=(f|0)))g=e;else{h=f;m=e;break a}}u=c;return g|0}g=e;h=f;m=d}while(0);f=b+24|0;a[f>>2]=g;a[f+4>>2]=h;w[b+448>>1]=(d&65535)+65535-(m&65535);w[b+38>>1]=0;g=ck(b)|0;u=c;return g|0},_realloc:qi,_memset:Va,_memcpy:Ec,_llvm_bswap_i32:lk,_i64Subtract:Ic,_TIFFOpen:function(b,d){b|=0;d|=
0;var c,e,f,g,h;c=u;u=u+32|0;e=c+16|0;f=c+8|0;g=c;a:{var m;m=d|0;var k;h=u;u=u+16|0;k=t[m>>0]|0;switch(k<<24>>24|0){case 114:m=43==(t[m+1>>0]|0)?2:0;u=h;h=m|0;break a;case 97:case 119:u=h;h=(119==k<<24>>24?578:66)|0;break a;default:a[h>>2]=m,Y(0,139905,137216,h),u=h,h=-1}}h|=0;if(-1==(h|0))return u=c,0;a[g>>2]=438;var l;m=u;u=u+32|0;k=m+16|0;a[k>>2]=g|0;g=(a[k>>2]|0)+3&-4;l=a[g>>2]|0;a[k>>2]=g+4;a[m>>2]=b|0;a[m+4>>2]=h|32768;a[m+8>>2]=l;l=le(tl(5,m|0)|0)|0;u=m;h=l|0;if(0<=(h|0)){if(g=rd(b,d,h,8,9,
5,2,3,10,2)|0)return a[g+4>>2]=h,u=c,g|0;Xk(h)|0;u=c;return 0}g=md()|0;h=a[g>>2]|0;if(0<(h|0)&&0!=(uk(h)|0))return h=uk(a[g>>2]|0)|0,a[f>>2]=b,a[f+4>>2]=h,Y(0,139905,139914,f),u=c,0;a[e>>2]=b;Y(0,139905,139921,e);u=c;return 0},_i64Add:Qb,_TIFFReadRGBAImage:function(a,d,c,e,f){return vc(a|0,d|0,c|0,e|0,4,f|0)|0},__TIFFmalloc:eb,___errno_location:md,_testSetjmp:db,_saveSetjmp:Xc,_free:Gc,_malloc:Hc,__TIFFfree:ja,runPostSets:function(){},_emscripten_replace_memory:function(b){if(Fk(b)&16777215||16777215>=
Fk(b)||2147483648<Fk(b))return!1;t=new il(b);w=new jl(b);a=new kl(b);x=new ll(b);N=new ml(b);new nl(b);W=new ol(b);Hb=new pl(b);A=b;return!0},stackAlloc:function(a){var d;d=u;u=u+(a|0)|0;u=u+15&-16;return d|0},stackSave:function(){return u|0},stackRestore:function(a){u=a|0},establishStackSpace:function(a,d){u=a|0},setThrew:function(a,d){Wa||(Wa=a|0,pa=d|0)},setTempRet0:function(a){U=a|0},getTempRet0:function(){return U|0},dynCall_iiii:function(a,d,c,e){return Aa[(a|0)&63](d|0,c|0,e|0)|0},dynCall_viiiiiii:function(a,
d,c,e,f,g,h,m){ee[(a|0)&15](d|0,c|0,e|0,f|0,g|0,h|0,m|0)},dynCall_viiiii:function(a,d,c,e,f,g){sf[(a|0)&63](d|0,c|0,e|0,f|0,g|0)},dynCall_vi:function(a,d){R[(a|0)&127](d|0)},dynCall_vii:function(a,d,c){ub[(a|0)&31](d|0,c|0)},dynCall_iiiiiii:function(a,d,c,e,f,g,h){return Hi[(a|0)&3](d|0,c|0,e|0,f|0,g|0,h|0)|0},dynCall_viiiiiiiiiiii:function(a,d,c,e,f,g,h,m,k,l,n,p,q){Gk[(a|0)&15](d|0,c|0,e|0,f|0,g|0,h|0,m|0,k|0,l|0,n|0,p|0,q|0)},dynCall_ii:function(a,d){return da[(a|0)&63](d|0)|0},dynCall_viii:function(a,
d,c,e){td[(a|0)&127](d|0,c|0,e|0)},dynCall_viiiiiiiii:function(a,d,c,e,f,g,h,m,k,l){Ii[(a|0)&31](d|0,c|0,e|0,f|0,g|0,h|0,m|0,k|0,l|0)},dynCall_iiiii:function(a,d,c,e,f){return rb[(a|0)&63](d|0,c|0,e|0,f|0)|0},dynCall_iii:function(a,d,c){return dd[(a|0)&127](d|0,c|0)|0},dynCall_iiiiii:function(a,d,c,e,f,g){return jg[(a|0)&3](d|0,c|0,e|0,f|0,g|0)|0},dynCall_viiii:function(a,d,c,e,f){Ud[(a|0)&31](d|0,c|0,e|0,f|0)}}}(F.asmGlobalArg,F.asmLibraryArg,rd);F._GetField=ab._GetField;F._TIFFClose=ab._TIFFClose;
F._TIFFReadDirectory=ab._TIFFReadDirectory;F._TIFFGetField=ab._TIFFGetField;var Rj=F._bitshift64Lshr=ab._bitshift64Lshr,Mj=F._bitshift64Shl=ab._bitshift64Shl;F._TIFFReadRGBAImageOriented=ab._TIFFReadRGBAImageOriented;F._TIFFCurrentDirectory=ab._TIFFCurrentDirectory;F._fflush=ab._fflush;F._TIFFSetDirectory=ab._TIFFSetDirectory;F._TIFFOpen=ab._TIFFOpen;var Mi=F._memset=ab._memset,Vj=F._memcpy=ab._memcpy,Xj=F._llvm_bswap_i32=ab._llvm_bswap_i32,Lj=F._i64Subtract=ab._i64Subtract,Ph=F._realloc=ab._realloc,
Nj=F._i64Add=ab._i64Add;F._TIFFReadRGBAImage=ab._TIFFReadRGBAImage;F.__TIFFmalloc=ab.__TIFFmalloc;F.___errno_location=ab.___errno_location;var Sj=F._testSetjmp=ab._testSetjmp,Qj=F._saveSetjmp=ab._saveSetjmp,vf=F._free=ab._free;F.runPostSets=ab.runPostSets;var uf=F._malloc=ab._malloc;F.__TIFFfree=ab.__TIFFfree;var Dj=F._emscripten_replace_memory=ab._emscripten_replace_memory;F.dynCall_iiii=ab.dynCall_iiii;F.dynCall_viiiiiii=ab.dynCall_viiiiiii;F.dynCall_viiiii=ab.dynCall_viiiii;F.dynCall_vi=ab.dynCall_vi;
F.dynCall_vii=ab.dynCall_vii;F.dynCall_iiiiiii=ab.dynCall_iiiiiii;F.dynCall_viiiiiiiiiiii=ab.dynCall_viiiiiiiiiiii;F.dynCall_ii=ab.dynCall_ii;F.dynCall_viii=ab.dynCall_viii;F.dynCall_viiiiiiiii=ab.dynCall_viiiiiiiii;F.dynCall_iiiii=ab.dynCall_iiiii;F.dynCall_iii=ab.dynCall_iii;F.dynCall_iiiiii=ab.dynCall_iiiiii;F.dynCall_viiii=ab.dynCall_viiii;ra.stackAlloc=ab.stackAlloc;ra.stackSave=ab.stackSave;ra.stackRestore=ab.stackRestore;ra.establishStackSpace=ab.establishStackSpace;ra.setTempRet0=ab.setTempRet0;
ra.getTempRet0=ab.getTempRet0;of.prototype=Error();of.prototype.constructor=of;var Ej,Th=null,Vf=function v(){F.calledRun||$g();F.calledRun||(Vf=v)};F.callMain=F.callMain=function(r){function A(){for(var r=0;3>r;r++)S.push(0)}fb(0==Uf,"cannot call main when async dependencies remain! (listen on __ATMAIN__)");fb(0==Jf.length,"cannot call main when preRun functions remain to be called");r=r||[];pg||(pg=!0,mg(qg));var D=r.length+1,S=[vc(yf(F.thisProgram),"i8",0)];A();for(var aa=0;aa<D-1;aa+=1)S.push(vc(yf(r[aa]),
"i8",0)),A();S.push(0);S=vc(S,"i32",0);try{var ca=F._main(D,S,0);Jg(ca,!0)}catch(ra){if(!(ra instanceof of))if("SimulateInfiniteLoop"==ra)F.noExitRuntime=!0;else throw ra&&"object"===typeof ra&&ra.stack&&F.printErr("exception thrown: "+[ra,ra.stack]),ra;}finally{}};F.run=F.run=$g;F.exit=F.exit=Jg;var bh=[];F.abort=F.abort=Vc;if(F.preInit)for("function"==typeof F.preInit&&(F.preInit=[F.preInit]);0<F.preInit.length;)F.preInit.pop()();var Sh=!0;F.noInitialRun&&(Sh=!1);$g();return F},TiffTag={SUBFILETYPE:254,
OSUBFILETYPE:255,IMAGEWIDTH:256,IMAGELENGTH:257,BITSPERSAMPLE:258,COMPRESSION:259,PHOTOMETRIC:262,THRESHHOLDING:263,CELLWIDTH:264,CELLLENGTH:265,FILLORDER:266,DOCUMENTNAME:269,IMAGEDESCRIPTION:270,MAKE:271,MODEL:272,STRIPOFFSETS:273,ORIENTATION:274,SAMPLESPERPIXEL:277,ROWSPERSTRIP:278,STRIPBYTECOUNTS:279,MINSAMPLEVALUE:280,MAXSAMPLEVALUE:281,XRESOLUTION:282,YRESOLUTION:283,PLANARCONFIG:284,PAGENAME:285,XPOSITION:286,YPOSITION:287,FREEOFFSETS:288,FREEBYTECOUNTS:289,GRAYRESPONSEUNIT:290,GRAYRESPONSECURVE:291,
RESOLUTIONUNIT:296,PAGENUMBER:297,COLORRESPONSEUNIT:300,TRANSFERFUNCTION:301,SOFTWARE:305,DATETIME:306,ARTIST:315,HOSTCOMPUTER:316,PREDICTOR:317,WHITEPOINT:318,PRIMARYCHROMATICITIES:319,COLORMAP:320,HALFTONEHINTS:321,TILEWIDTH:322,TILELENGTH:323,TILEOFFSETS:324,TILEBYTECOUNTS:325,BADFAXLINES:326,CLEANFAXDATA:327,CONSECUTIVEBADFAXLINES:328,SUBIFD:330,INKSET:332,INKNAMES:333,NUMBEROFINKS:334,DOTRANGE:336,TARGETPRINTER:337,EXTRASAMPLES:338,SAMPLEFORMAT:339,SMINSAMPLEVALUE:340,SMAXSAMPLEVALUE:341,CLIPPATH:343,
XCLIPPATHUNITS:344,YCLIPPATHUNITS:345,INDEXED:346,JPEGTABLES:347,OPIPROXY:351,GLOBALPARAMETERSIFD:400,PROFILETYPE:401,FAXPROFILE:402,CODINGMETHODS:403,VERSIONYEAR:404,MODENUMBER:405,DECODE:433,IMAGEBASECOLOR:434,JPEGPROC:512,JPEGIFOFFSET:513,JPEGIFBYTECOUNT:514,JPEGRESTARTINTERVAL:515,JPEGLOSSLESSPREDICTORS:517,JPEGPOINTTRANSFORM:518,JPEGQTABLES:519,JPEGDCTABLES:520,JPEGACTABLES:521,YCBCRCOEFFICIENTS:529,YCBCRSUBSAMPLING:530,YCBCRPOSITIONING:531,REFERENCEBLACKWHITE:532,STRIPROWCOUNTS:559,XMLPACKET:700,
OPIIMAGEID:32781,REFPTS:32953,REGIONTACKPOINT:32954,REGIONWARPCORNERS:32955,REGIONAFFINE:32956,MATTEING:32995,DATATYPE:32996,IMAGEDEPTH:32997,TILEDEPTH:32998,PIXAR_IMAGEFULLWIDTH:33300,PIXAR_IMAGEFULLLENGTH:33301,PIXAR_TEXTUREFORMAT:33302,PIXAR_WRAPMODES:33303,PIXAR_FOVCOT:33304,PIXAR_MATRIX_WORLDTOSCREEN:33305,PIXAR_MATRIX_WORLDTOCAMERA:33306,WRITERSERIALNUMBER:33405,CFAREPEATPATTERNDIM:33421,CFAPATTERN:33422,COPYRIGHT:33432,RICHTIFFIPTC:33723,FRAMECOUNT:34232,PHOTOSHOP:34377,EXIFIFD:34665,ICCPROFILE:34675,
IMAGELAYER:34732,JBIGOPTIONS:34750,GPSIFD:34853,FAXRECVPARAMS:34908,FAXSUBADDRESS:34909,FAXRECVTIME:34910,FAXDCS:34911,STONITS:37439,FEDEX_EDR:34929,INTEROPERABILITYIFD:40965,DNGVERSION:50706,DNGBACKWARDVERSION:50707,UNIQUECAMERAMODEL:50708,LOCALIZEDCAMERAMODEL:50709,CFAPLANECOLOR:50710,CFALAYOUT:50711,LINEARIZATIONTABLE:50712,BLACKLEVELREPEATDIM:50713,BLACKLEVEL:50714,BLACKLEVELDELTAH:50715,BLACKLEVELDELTAV:50716,WHITELEVEL:50717,DEFAULTSCALE:50718,DEFAULTCROPORIGIN:50719,DEFAULTCROPSIZE:50720,ANALOGBALANCE:50727,
ASSHOTNEUTRAL:50728,ASSHOTWHITEXY:50729,BASELINEEXPOSURE:50730,BASELINENOISE:50731,BASELINESHARPNESS:50732,BAYERGREENSPLIT:50733,LINEARRESPONSELIMIT:50734,CAMERASERIALNUMBER:50735,LENSINFO:50736,CHROMABLURRADIUS:50737,ANTIALIASSTRENGTH:50738,SHADOWSCALE:50739,DNGPRIVATEDATA:50740,MAKERNOTESAFETY:50741,BESTQUALITYSCALE:50780,RAWDATAUNIQUEID:50781,ORIGINALRAWFILENAME:50827,ORIGINALRAWFILEDATA:50828,ACTIVEAREA:50829,MASKEDAREAS:50830,ASSHOTICCPROFILE:50831,ASSHOTPREPROFILEMATRIX:50832,CURRENTICCPROFILE:50833,
CURRENTPREPROFILEMATRIX:50834,DCSHUESHIFTVALUES:65535,FAXMODE:65536,JPEGQUALITY:65537,JPEGCOLORMODE:65538,JPEGTABLESMODE:65539,FAXFILLFUNC:65540,PIXARLOGDATAFMT:65549,DCSIMAGERTYPE:65550,DCSINTERPMODE:65551,DCSBALANCEARRAY:65552,DCSCORRECTMATRIX:65553,DCSGAMMA:65554,DCSTOESHOULDERPTS:65555,DCSCALIBRATIONFD:65556,ZIPQUALITY:65557,PIXARLOGQUALITY:65558,DCSCLIPRECTANGLE:65559,SGILOGDATAFMT:65560,SGILOGENCODE:65561,LZMAPRESET:65562,PERSAMPLE:65563},Tiff=function(){function Lb(nc){null===Lb.Module&&Lb.initialize({});
this._filename=Lb.createFileSystemObjectFromBuffer(nc.buffer);this._tiffPtr=Lb.Module.ccall("TIFFOpen","number",["string","string"],[this._filename,"r"]);if(0===this._tiffPtr)throw new Lb.Exception("The function TIFFOpen returns NULL");}Lb.initialize=function(nc){null===Lb.Module&&(Lb.Module=loadModule(nc))};Lb.prototype.width=function(){return this.getField(Lb.Tag.IMAGEWIDTH)};Lb.prototype.height=function(){return this.getField(Lb.Tag.IMAGELENGTH)};Lb.prototype.currentDirectory=function(){return Lb.Module.ccall("TIFFCurrentDirectory",
"number",["number"],[this._tiffPtr])};Lb.prototype.countDirectory=function(){for(var nc=0,fb=this.currentDirectory();nc+=1,0!==Lb.Module.ccall("TIFFReadDirectory","number",["number"],[this._tiffPtr]););this.setDirectory(fb);return nc};Lb.prototype.setDirectory=function(nc){return Lb.Module.ccall("TIFFSetDirectory","number",["number","number"],[this._tiffPtr,nc])};Lb.prototype.getField=function(nc){return Lb.Module.ccall("GetField","number",["number","number"],[this._tiffPtr,nc])};Lb.prototype.readRGBAImage=
function(){var nc=this.width(),fb=this.height(),me=Lb.Module.ccall("_TIFFmalloc","number",["number"],[nc*fb*4]);if(0===Lb.Module.ccall("TIFFReadRGBAImageOriented","number","number number number number number number".split(" "),[this._tiffPtr,nc,fb,me,1,0]))throw new Lb.Exception("The function TIFFReadRGBAImageOriented returns NULL");nc=Lb.Module.HEAPU8.buffer.slice(me,me+nc*fb*4);Lb.Module.ccall("free","number",["number"],[me]);return nc};Lb.prototype.toCanvas=function(){var nc=this.width(),fb=this.height(),
me=Lb.Module.ccall("_TIFFmalloc","number",["number"],[nc*fb*4]);if(0===Lb.Module.ccall("TIFFReadRGBAImageOriented","number","number number number number number number".split(" "),[this._tiffPtr,nc,fb,me,1,0]))throw new Lb.Exception("The function TIFFReadRGBAImageOriented returns NULL");var If=Lb.Module.HEAPU8.subarray(me,me+nc*fb*4),dg=document.createElement("canvas"),vc=dg.getContext("2d");dg.width=nc;dg.height=fb;nc=vc.createImageData(nc,fb);nc.data.set(If);vc.putImageData(nc,0,0);Lb.Module.ccall("free",
"number",["number"],[me]);return dg};Lb.prototype.toDataURL=function(){return this.toCanvas().toDataURL()};Lb.prototype.close=function(){Lb.Module.ccall("TIFFClose","number",["number"],[this._tiffPtr])};Lb.createUniqueFileName=function(){Lb.uniqueIdForFileName+=1;return String(Lb.uniqueIdForFileName)+".tiff"};Lb.createFileSystemObjectFromBuffer=function(nc){var fb=Lb.createUniqueFileName();Lb.Module.FS.createDataFile("/",fb,new Uint8Array(nc),!0,!1);return fb};Lb.uniqueIdForFileName=0;Lb.Module=null;
return Lb}();(function(Lb){var nc=function(){return function(fb){this.message=fb;this.name="Tiff.Exception"}}();Lb.Exception=nc;Lb.Tag=TiffTag})(Tiff||(Tiff={}));Tiff.prototype.width=Tiff.prototype.width;Tiff.prototype.height=Tiff.prototype.height;Tiff.prototype.currentDirectory=Tiff.prototype.currentDirectory;Tiff.prototype.countDirectory=Tiff.prototype.countDirectory;Tiff.prototype.setDirectory=Tiff.prototype.setDirectory;Tiff.prototype.getField=Tiff.prototype.getField;
Tiff.prototype.readRGBAImage=Tiff.prototype.readRGBAImage;Tiff.prototype.close=Tiff.prototype.close;Tiff.Exception=Tiff.Exception;Tiff.initialize=Tiff.initialize;"object"===typeof process&&"function"==="function"?module.exports=Tiff: true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return Tiff}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof window?window.Tiff=Tiff:"function"===typeof importScripts&&(self.Tiff=Tiff);})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), "/", __webpack_require__(14).Buffer))

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 256 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(54)
exports.createHash = exports.Hash = __webpack_require__(62)
exports.createHmac = exports.Hmac = __webpack_require__(150)

var algos = __webpack_require__(272)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(153)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(274)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(291)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(296)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(334)

var publicEncrypt = __webpack_require__(335)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(338)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 258 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(2).Buffer;
var util = __webpack_require__(260);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(147);

/*<replacement>*/
var util = __webpack_require__(63);
util.inherits = __webpack_require__(1);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(99);


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44);


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(98).Transform


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(98).PassThrough


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(1)
var Hash = __webpack_require__(55)
var Buffer = __webpack_require__(2).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(1)
var Hash = __webpack_require__(55)
var Buffer = __webpack_require__(2).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(1)
var Sha256 = __webpack_require__(148)
var Hash = __webpack_require__(55)
var Buffer = __webpack_require__(2).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1)
var SHA512 = __webpack_require__(149)
var Hash = __webpack_require__(55)
var Buffer = __webpack_require__(2).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(1)
var Buffer = __webpack_require__(2).Buffer

var Base = __webpack_require__(40)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(152)


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(154)
var defaultEncoding = __webpack_require__(155)
var sync = __webpack_require__(156)
var Buffer = __webpack_require__(2).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(28)))

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(275)
var aes = __webpack_require__(104)
var aesModes = __webpack_require__(105)
var desModes = __webpack_require__(290)
var ebtk = __webpack_require__(75)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(40)
var des = __webpack_require__(103)
var inherits = __webpack_require__(1)
var Buffer = __webpack_require__(2).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(23);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(23);
var inherits = __webpack_require__(1);

var des = __webpack_require__(103);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(23);
var inherits = __webpack_require__(1);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(23);
var inherits = __webpack_require__(1);

var des = __webpack_require__(103);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(105)
var AuthCipher = __webpack_require__(160)
var Buffer = __webpack_require__(2).Buffer
var StreamCipher = __webpack_require__(161)
var Transform = __webpack_require__(40)
var aes = __webpack_require__(74)
var ebtk = __webpack_require__(75)
var inherits = __webpack_require__(1)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 282 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(64)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2).Buffer
var xor = __webpack_require__(64)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(64)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(160)
var Buffer = __webpack_require__(2).Buffer
var MODES = __webpack_require__(105)
var StreamCipher = __webpack_require__(161)
var Transform = __webpack_require__(40)
var aes = __webpack_require__(74)
var ebtk = __webpack_require__(75)
var inherits = __webpack_require__(1)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 290 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(162)
var primes = __webpack_require__(294)

var DH = __webpack_require__(295)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 292 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 293 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(11);
var MillerRabin = __webpack_require__(164);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(162);
var randomBytes = __webpack_require__(54);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(62)
var stream = __webpack_require__(96)
var inherits = __webpack_require__(1)
var sign = __webpack_require__(297)
var verify = __webpack_require__(333)

var algorithms = __webpack_require__(152)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(150)
var crt = __webpack_require__(106)
var EC = __webpack_require__(18).ec
var BN = __webpack_require__(11)
var parseKeys = __webpack_require__(77)
var curves = __webpack_require__(174)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.1","/Users/geroduppel/PhpstormProjects/plexipeople-shopware/custom/plugins/NetiPlexipeopleLeonardo/build"]],"_development":true,"_from":"elliptic@6.4.1","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.1","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.1","saveSpec":null,"fetchSpec":"6.4.1"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_spec":"6.4.1","_where":"/Users/geroduppel/PhpstormProjects/plexipeople-shopware/custom/plugins/NetiPlexipeopleLeonardo/build","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(11);
var minAssert = __webpack_require__(23);
var minUtils = __webpack_require__(166);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(11);
var elliptic = __webpack_require__(18);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(76);
var elliptic = __webpack_require__(18);
var BN = __webpack_require__(11);
var inherits = __webpack_require__(1);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(76);
var BN = __webpack_require__(11);
var inherits = __webpack_require__(1);
var Base = curve.base;

var elliptic = __webpack_require__(18);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(76);
var elliptic = __webpack_require__(18);
var BN = __webpack_require__(11);
var inherits = __webpack_require__(1);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(107);
var elliptic = __webpack_require__(18);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(311);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(306);
exports.sha224 = __webpack_require__(307);
exports.sha256 = __webpack_require__(168);
exports.sha384 = __webpack_require__(308);
exports.sha512 = __webpack_require__(169);


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var common = __webpack_require__(65);
var shaCommon = __webpack_require__(167);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var SHA256 = __webpack_require__(168);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

var SHA512 = __webpack_require__(169);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var common = __webpack_require__(65);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var assert = __webpack_require__(23);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(11);
var HmacDRBG = __webpack_require__(313);
var elliptic = __webpack_require__(18);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(314);
var Signature = __webpack_require__(315);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(107);
var utils = __webpack_require__(166);
var assert = __webpack_require__(23);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(11);
var elliptic = __webpack_require__(18);
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(11);

var elliptic = __webpack_require__(18);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(107);
var elliptic = __webpack_require__(18);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(317);
var Signature = __webpack_require__(318);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(18);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(11);
var elliptic = __webpack_require__(18);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(66)

exports.certificate = __webpack_require__(330)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(66);
var inherits = __webpack_require__(1);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(321).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(322);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 322 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(67).Reporter;
var EncoderBuffer = __webpack_require__(67).EncoderBuffer;
var DecoderBuffer = __webpack_require__(67).DecoderBuffer;
var assert = __webpack_require__(23);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(171);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(172);
decoders.pem = __webpack_require__(327);


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);
var Buffer = __webpack_require__(14).Buffer;

var DERDecoder = __webpack_require__(172);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(173);
encoders.pem = __webpack_require__(329);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(1);

var DEREncoder = __webpack_require__(173);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(66)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(75)
var ciphers = __webpack_require__(104)
var Buffer = __webpack_require__(2).Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(11)
var EC = __webpack_require__(18).ec
var parseKeys = __webpack_require__(77)
var curves = __webpack_require__(174)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(18)
var BN = __webpack_require__(11)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14).Buffer))

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(336)
exports.privateDecrypt = __webpack_require__(337)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(77)
var randomBytes = __webpack_require__(54)
var createHash = __webpack_require__(62)
var mgf = __webpack_require__(175)
var xor = __webpack_require__(176)
var BN = __webpack_require__(11)
var withPublic = __webpack_require__(177)
var crt = __webpack_require__(106)
var Buffer = __webpack_require__(2).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(77)
var mgf = __webpack_require__(175)
var xor = __webpack_require__(176)
var BN = __webpack_require__(11)
var crt = __webpack_require__(106)
var createHash = __webpack_require__(62)
var withPublic = __webpack_require__(177)
var Buffer = __webpack_require__(2).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(2)
var randombytes = __webpack_require__(54)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(28)))

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {

    var debug = false;

    var root = this;

    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };

    if (true) {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = EXIF;
        }
        exports.EXIF = EXIF;
    } else {
        root.EXIF = EXIF;
    }

    var ExifTags = EXIF.Tags = {

        // version tags
        0x9000 : "ExifVersion",             // EXIF version
        0xA000 : "FlashpixVersion",         // Flashpix format version

        // colorspace tags
        0xA001 : "ColorSpace",              // Color space information tag

        // image configuration
        0xA002 : "PixelXDimension",         // Valid width of meaningful image
        0xA003 : "PixelYDimension",         // Valid height of meaningful image
        0x9101 : "ComponentsConfiguration", // Information about channels
        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel

        // user information
        0x927C : "MakerNote",               // Any desired information written by the manufacturer
        0x9286 : "UserComment",             // Comments by user

        // related file
        0xA004 : "RelatedSoundFile",        // Name of related sound file

        // date and time
        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

        // picture-taking conditions
        0x829A : "ExposureTime",            // Exposure time (in seconds)
        0x829D : "FNumber",                 // F number
        0x8822 : "ExposureProgram",         // Exposure program
        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
        0x8827 : "ISOSpeedRatings",         // ISO speed rating
        0x8828 : "OECF",                    // Optoelectric conversion factor
        0x9201 : "ShutterSpeedValue",       // Shutter speed
        0x9202 : "ApertureValue",           // Lens aperture
        0x9203 : "BrightnessValue",         // Value of brightness
        0x9204 : "ExposureBias",            // Exposure bias
        0x9205 : "MaxApertureValue",        // Smallest F number of lens
        0x9206 : "SubjectDistance",         // Distance to subject in meters
        0x9207 : "MeteringMode",            // Metering mode
        0x9208 : "LightSource",             // Kind of light source
        0x9209 : "Flash",                   // Flash status
        0x9214 : "SubjectArea",             // Location and area of main subject
        0x920A : "FocalLength",             // Focal length of the lens in mm
        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
        0xA20C : "SpatialFrequencyResponse",    //
        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214 : "SubjectLocation",         // Location of subject in image
        0xA215 : "ExposureIndex",           // Exposure index selected on camera
        0xA217 : "SensingMethod",           // Image sensor type
        0xA300 : "FileSource",              // Image source (3 == DSC)
        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
        0xA302 : "CFAPattern",              // Color filter array geometric pattern
        0xA401 : "CustomRendered",          // Special processing
        0xA402 : "ExposureMode",            // Exposure mode
        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406 : "SceneCaptureType",        // Type of scene
        0xA407 : "GainControl",             // Degree of overall image gain adjustment
        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
        0xA40B : "DeviceSettingDescription",    //
        0xA40C : "SubjectDistanceRange",    // Distance to subject

        // other tags
        0xA005 : "InteroperabilityIFDPointer",
        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
    };

    var TiffTags = EXIF.TiffTags = {
        0x0100 : "ImageWidth",
        0x0101 : "ImageHeight",
        0x8769 : "ExifIFDPointer",
        0x8825 : "GPSInfoIFDPointer",
        0xA005 : "InteroperabilityIFDPointer",
        0x0102 : "BitsPerSample",
        0x0103 : "Compression",
        0x0106 : "PhotometricInterpretation",
        0x0112 : "Orientation",
        0x0115 : "SamplesPerPixel",
        0x011C : "PlanarConfiguration",
        0x0212 : "YCbCrSubSampling",
        0x0213 : "YCbCrPositioning",
        0x011A : "XResolution",
        0x011B : "YResolution",
        0x0128 : "ResolutionUnit",
        0x0111 : "StripOffsets",
        0x0116 : "RowsPerStrip",
        0x0117 : "StripByteCounts",
        0x0201 : "JPEGInterchangeFormat",
        0x0202 : "JPEGInterchangeFormatLength",
        0x012D : "TransferFunction",
        0x013E : "WhitePoint",
        0x013F : "PrimaryChromaticities",
        0x0211 : "YCbCrCoefficients",
        0x0214 : "ReferenceBlackWhite",
        0x0132 : "DateTime",
        0x010E : "ImageDescription",
        0x010F : "Make",
        0x0110 : "Model",
        0x0131 : "Software",
        0x013B : "Artist",
        0x8298 : "Copyright"
    };

    var GPSTags = EXIF.GPSTags = {
        0x0000 : "GPSVersionID",
        0x0001 : "GPSLatitudeRef",
        0x0002 : "GPSLatitude",
        0x0003 : "GPSLongitudeRef",
        0x0004 : "GPSLongitude",
        0x0005 : "GPSAltitudeRef",
        0x0006 : "GPSAltitude",
        0x0007 : "GPSTimeStamp",
        0x0008 : "GPSSatellites",
        0x0009 : "GPSStatus",
        0x000A : "GPSMeasureMode",
        0x000B : "GPSDOP",
        0x000C : "GPSSpeedRef",
        0x000D : "GPSSpeed",
        0x000E : "GPSTrackRef",
        0x000F : "GPSTrack",
        0x0010 : "GPSImgDirectionRef",
        0x0011 : "GPSImgDirection",
        0x0012 : "GPSMapDatum",
        0x0013 : "GPSDestLatitudeRef",
        0x0014 : "GPSDestLatitude",
        0x0015 : "GPSDestLongitudeRef",
        0x0016 : "GPSDestLongitude",
        0x0017 : "GPSDestBearingRef",
        0x0018 : "GPSDestBearing",
        0x0019 : "GPSDestDistanceRef",
        0x001A : "GPSDestDistance",
        0x001B : "GPSProcessingMethod",
        0x001C : "GPSAreaInformation",
        0x001D : "GPSDateStamp",
        0x001E : "GPSDifferential"
    };

     // EXIF 2.3 Spec
    var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset",    // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
    };

    var StringValues = EXIF.StringValues = {
        ExposureProgram : {
            0 : "Not defined",
            1 : "Manual",
            2 : "Normal program",
            3 : "Aperture priority",
            4 : "Shutter priority",
            5 : "Creative program",
            6 : "Action program",
            7 : "Portrait mode",
            8 : "Landscape mode"
        },
        MeteringMode : {
            0 : "Unknown",
            1 : "Average",
            2 : "CenterWeightedAverage",
            3 : "Spot",
            4 : "MultiSpot",
            5 : "Pattern",
            6 : "Partial",
            255 : "Other"
        },
        LightSource : {
            0 : "Unknown",
            1 : "Daylight",
            2 : "Fluorescent",
            3 : "Tungsten (incandescent light)",
            4 : "Flash",
            9 : "Fine weather",
            10 : "Cloudy weather",
            11 : "Shade",
            12 : "Daylight fluorescent (D 5700 - 7100K)",
            13 : "Day white fluorescent (N 4600 - 5400K)",
            14 : "Cool white fluorescent (W 3900 - 4500K)",
            15 : "White fluorescent (WW 3200 - 3700K)",
            17 : "Standard light A",
            18 : "Standard light B",
            19 : "Standard light C",
            20 : "D55",
            21 : "D65",
            22 : "D75",
            23 : "D50",
            24 : "ISO studio tungsten",
            255 : "Other"
        },
        Flash : {
            0x0000 : "Flash did not fire",
            0x0001 : "Flash fired",
            0x0005 : "Strobe return light not detected",
            0x0007 : "Strobe return light detected",
            0x0009 : "Flash fired, compulsory flash mode",
            0x000D : "Flash fired, compulsory flash mode, return light not detected",
            0x000F : "Flash fired, compulsory flash mode, return light detected",
            0x0010 : "Flash did not fire, compulsory flash mode",
            0x0018 : "Flash did not fire, auto mode",
            0x0019 : "Flash fired, auto mode",
            0x001D : "Flash fired, auto mode, return light not detected",
            0x001F : "Flash fired, auto mode, return light detected",
            0x0020 : "No flash function",
            0x0041 : "Flash fired, red-eye reduction mode",
            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod : {
            1 : "Not defined",
            2 : "One-chip color area sensor",
            3 : "Two-chip color area sensor",
            4 : "Three-chip color area sensor",
            5 : "Color sequential area sensor",
            7 : "Trilinear sensor",
            8 : "Color sequential linear sensor"
        },
        SceneCaptureType : {
            0 : "Standard",
            1 : "Landscape",
            2 : "Portrait",
            3 : "Night scene"
        },
        SceneType : {
            1 : "Directly photographed"
        },
        CustomRendered : {
            0 : "Normal process",
            1 : "Custom process"
        },
        WhiteBalance : {
            0 : "Auto white balance",
            1 : "Manual white balance"
        },
        GainControl : {
            0 : "None",
            1 : "Low gain up",
            2 : "High gain up",
            3 : "Low gain down",
            4 : "High gain down"
        },
        Contrast : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        Saturation : {
            0 : "Normal",
            1 : "Low saturation",
            2 : "High saturation"
        },
        Sharpness : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        SubjectDistanceRange : {
            0 : "Unknown",
            1 : "Macro",
            2 : "Close view",
            3 : "Distant view"
        },
        FileSource : {
            3 : "DSC"
        },

        Components : {
            0 : "",
            1 : "Y",
            2 : "Cb",
            3 : "Cr",
            4 : "R",
            5 : "G",
            6 : "B"
        }
    };

    function addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + event, handler);
        }
    }

    function imageHasData(img) {
        return !!(img.exifdata);
    }


    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }

    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }

    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (EXIF.isXmpEnabled) {
               var xmpdata= findXMPinJPEG(binFile);
               img.xmpdata = xmpdata || {};               
            }
            if (callback) {
                callback.call(img);
            }
        }

        if (img.src) {
            if (/^data\:/i.test(img.src)) { // Data URI
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);

            } else if (/^blob\:/i.test(img.src)) { // Object URL
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function (blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw "Could not load image";
                    }
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };

            fileReader.readAsArrayBuffer(img);
        }
    }

    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }

            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);

            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data

            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");

                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                // offset += 2 + file.getShortAt(offset+2, true);

            } else {
                offset += 2 + dataView.getUint16(offset+2);
            }

        }

    }

    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;


        var isFieldSegmentStart = function(dataView, offset){
            return (
                dataView.getUint8(offset) === 0x38 &&
                dataView.getUint8(offset+1) === 0x42 &&
                dataView.getUint8(offset+2) === 0x49 &&
                dataView.getUint8(offset+3) === 0x4D &&
                dataView.getUint8(offset+4) === 0x04 &&
                dataView.getUint8(offset+5) === 0x04
            );
        };

        while (offset < length) {

            if ( isFieldSegmentStart(dataView, offset )){

                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset+7);
                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if(nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }

                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                return readIPTCData(file, startOffset, sectionLength);

                break;

            }


            // Not the marker, continue searching
            offset++;

        }

    }
    var IptcFieldMap = {
        0x78 : 'caption',
        0x6E : 'credit',
        0x19 : 'keywords',
        0x37 : 'dateCreated',
        0x50 : 'byline',
        0x55 : 'bylineTitle',
        0x7A : 'captionWriter',
        0x69 : 'headline',
        0x74 : 'copyright',
        0x0F : 'category'
    };
    function readIPTCData(file, startOffset, sectionLength){
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset+sectionLength) {
            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
                segmentType = dataView.getUint8(segmentStartPos+2);
                if(segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos+3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
                    // Check if we already stored a value with this name
                    if(data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if(data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }

            }
            segmentStartPos++;
        }
        return data;
    }



    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset, tag,
            i;

        for (i=0;i<entries;i++) {
            entryOffset = dirStart + i*12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }


    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset+2, !bigEnd),
            numValues = file.getUint32(entryOffset+4, !bigEnd),
            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
            offset,
            vals, val, n,
            numerator, denominator;

        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues == 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }

            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return getStringFromDB(file, offset, numValues-1);

            case 3: // short, 16 bit int
                if (numValues == 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
                    }
                    return vals;
                }

            case 4: // long, 32 bit int
                if (numValues == 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 5:    // rational = two long values, first is numerator, second is denominator
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset+4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }

            case 9: // slong, 32 bit signed int
                if (numValues == 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues == 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
                    }
                    return vals;
                }
        }
    }

    /**
    * Given an IFD (Image File Directory) start offset
    * returns an offset to next IFD or 0 if it's the last IFD.
    */
    function getNextIFDOffset(dataView, dirStart, bigEnd){
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);

        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.

        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }

    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd){
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart+firstIFDOffset, bigEnd);

        if (!IFD1OffsetPointer) {
            // console.log('******** IFD1Offset is empty, image thumb not found ********');
            return {};
        }
        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
            return {};
        }
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);

        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd)

        // EXIF 2.3 specification for JPEG format thumbnail

        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.

        if (thumbTags['Compression']) {
            // console.log('Thumbnail image found!');

            switch (thumbTags['Compression']) {
                case 6:
                    // console.log('Thumbnail image format is JPEG');
                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                    // extract the thumbnail
                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
                        var tLength = thumbTags.JpegIFByteCount;
                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
                            type: 'image/jpeg'
                        });
                    }
                break;

            case 1:
                console.log("Thumbnail image format is TIFF, which is not implemented.");
                break;
            default:
                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
            }
        }
        else if (thumbTags['PhotometricInterpretation'] == 2) {
            console.log("Thumbnail image format is RGB, which is not implemented.");
        }
        return thumbTags;
    }

    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for (n = start; n < start+length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }

    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }

        var bigEnd,
            tags, tag,
            exifData, gpsData,
            tiffOffset = start + 6;

        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) {
            bigEnd = false;
        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
            bigEnd = true;
        } else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }

        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
            return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case "LightSource" :
                    case "Flash" :
                    case "MeteringMode" :
                    case "ExposureProgram" :
                    case "SensingMethod" :
                    case "SceneCaptureType" :
                    case "SceneType" :
                    case "CustomRendered" :
                    case "WhiteBalance" :
                    case "GainControl" :
                    case "Contrast" :
                    case "Saturation" :
                    case "Sharpness" :
                    case "SubjectDistanceRange" :
                    case "FileSource" :
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;

                    case "ExifVersion" :
                    case "FlashpixVersion" :
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;

                    case "ComponentsConfiguration" :
                        exifData[tag] =
                            StringValues.Components[exifData[tag][0]] +
                            StringValues.Components[exifData[tag][1]] +
                            StringValues.Components[exifData[tag][2]] +
                            StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }

        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case "GPSVersionID" :
                        gpsData[tag] = gpsData[tag][0] +
                            "." + gpsData[tag][1] +
                            "." + gpsData[tag][2] +
                            "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }

        // extract thumbnail
        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);

        return tags;
    }

   function findXMPinJPEG(file) {

        if (!('DOMParser' in self)) {
            // console.warn('XML parsing not supported without DOMParser');
            return;
        }
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
           if (debug) console.log("Not a valid JPEG");
           return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            dom = new DOMParser();

        while (offset < (length-4)) {
            if (getStringFromDB(dataView, offset, 4) == "http") {
                var startOffset = offset - 1;
                var sectionLength = dataView.getUint16(offset - 2) - 1;
                var xmpString = getStringFromDB(dataView, startOffset, sectionLength)
                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
                xmpString = xmpString.substring( xmpString.indexOf( '<x:xmpmeta' ), xmpEndIndex );

                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10
                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
                //Without these namespaces, XML is thought to be invalid by parsers
                xmpString = xmpString.slice(0, indexOfXmp)
                            + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
                            + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
                            + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
                            + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
                            + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
                            + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
                            + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
                            + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
                            + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
                            + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
                            + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
                            + xmpString.slice(indexOfXmp)

                var domDocument = dom.parseFromString( xmpString, 'text/xml' );
                return xml2Object(domDocument);
            } else{
             offset++;
            }
        }
    }

    function xml2json(xml) {
        var json = {};
      
        if (xml.nodeType == 1) { // element node
          if (xml.attributes.length > 0) {
            json['@attributes'] = {};
            for (var j = 0; j < xml.attributes.length; j++) {
              var attribute = xml.attributes.item(j);
              json['@attributes'][attribute.nodeName] = attribute.nodeValue;
            }
          }
        } else if (xml.nodeType == 3) { // text node
          return xml.nodeValue;
        }
      
        // deal with children
        if (xml.hasChildNodes()) {
          for(var i = 0; i < xml.childNodes.length; i++) {
            var child = xml.childNodes.item(i);
            var nodeName = child.nodeName;
            if (json[nodeName] == null) {
              json[nodeName] = xml2json(child);
            } else {
              if (json[nodeName].push == null) {
                var old = json[nodeName];
                json[nodeName] = [];
                json[nodeName].push(old);
              }
              json[nodeName].push(xml2json(child));
            }
          }
        }
        
        return json;
    }

    function xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) {
              for (var i = 0; i < xml.children.length; i++) {
                var item = xml.children.item(i);
                var attributes = item.attributes;
                for(var idx in attributes) {
                    var itemAtt = attributes[idx];
                    var dataKey = itemAtt.nodeName;
                    var dataValue = itemAtt.nodeValue;

                    if(dataKey !== undefined) {
                        obj[dataKey] = dataValue;
                    }
                }
                var nodeName = item.nodeName;

                if (typeof (obj[nodeName]) == "undefined") {
                  obj[nodeName] = xml2json(item);
                } else {
                  if (typeof (obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];

                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                  }
                  obj[nodeName].push(xml2json(item));
                }
              }
            } else {
              obj = xml.textContent;
            }
            return obj;
          } catch (e) {
              console.log(e.message);
          }
    }

    EXIF.enableXmp = function() {
        EXIF.isXmpEnabled = true;
    }

    EXIF.disableXmp = function() {
        EXIF.isXmpEnabled = false;
    }

    EXIF.getData = function(img, callback) {
        if (((self.Image && img instanceof self.Image)
            || (self.HTMLImageElement && img instanceof self.HTMLImageElement))
            && !img.complete)
            return false;

        if (!imageHasData(img)) {
            getImageData(img, callback);
        } else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    }

    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    }
    
    EXIF.getIptcTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
    }

    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.exifdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }
    
    EXIF.getAllIptcTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.iptcdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }

    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a,
            data = img.exifdata,
            strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] == "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    } else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                } else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    }

    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    }

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            return EXIF;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}.call(this));



/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

/* global module, require */

module.exports = __webpack_require__(34)

__webpack_require__(178)
__webpack_require__(78)
__webpack_require__(341)
__webpack_require__(179)
__webpack_require__(342)
__webpack_require__(180)
__webpack_require__(343)
__webpack_require__(344)


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Fetch
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2017, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, Promise */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var global = loadImage.global

  if (
    global.fetch &&
    global.Request &&
    global.Response &&
    global.Response.prototype.blob
  ) {
    loadImage.fetchBlob = function (url, callback, options) {
      /**
       * Fetch response handler.
       *
       * @param {Response} response Fetch response
       * @returns {Blob} Fetched Blob.
       */
      function responseHandler(response) {
        return response.blob()
      }
      if (global.Promise && typeof callback !== 'function') {
        return fetch(new Request(url, callback)).then(responseHandler)
      }
      fetch(new Request(url, options))
        .then(responseHandler)
        .then(callback)
        [
          // Avoid parsing error in IE<9, where catch is a reserved word.
          // eslint-disable-next-line dot-notation
          'catch'
        ](function (err) {
          callback(null, err)
        })
    }
  } else if (
    global.XMLHttpRequest &&
    // https://xhr.spec.whatwg.org/#the-responsetype-attribute
    new XMLHttpRequest().responseType === ''
  ) {
    loadImage.fetchBlob = function (url, callback, options) {
      /**
       * Promise executor
       *
       * @param {Function} resolve Resolution function
       * @param {Function} reject Rejection function
       */
      function executor(resolve, reject) {
        options = options || {} // eslint-disable-line no-param-reassign
        var req = new XMLHttpRequest()
        req.open(options.method || 'GET', url)
        if (options.headers) {
          Object.keys(options.headers).forEach(function (key) {
            req.setRequestHeader(key, options.headers[key])
          })
        }
        req.withCredentials = options.credentials === 'include'
        req.responseType = 'blob'
        req.onload = function () {
          resolve(req.response)
        }
        req.onerror = req.onabort = req.ontimeout = function (err) {
          if (resolve === reject) {
            // Not using Promises
            reject(null, err)
          } else {
            reject(err)
          }
        }
        req.send(options.body)
      }
      if (global.Promise && typeof callback !== 'function') {
        options = callback // eslint-disable-line no-param-reassign
        return new Promise(executor)
      }
      return executor(callback, callback)
    }
  }
})


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Exif tags mapping based on
 * https://github.com/jseidelin/exif-js
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34), __webpack_require__(179)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-exif'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var ExifMapProto = loadImage.ExifMap.prototype

  ExifMapProto.tags = {
    // =================
    // TIFF tags (IFD0):
    // =================
    0x0100: 'ImageWidth',
    0x0101: 'ImageHeight',
    0x0102: 'BitsPerSample',
    0x0103: 'Compression',
    0x0106: 'PhotometricInterpretation',
    0x0112: 'Orientation',
    0x0115: 'SamplesPerPixel',
    0x011c: 'PlanarConfiguration',
    0x0212: 'YCbCrSubSampling',
    0x0213: 'YCbCrPositioning',
    0x011a: 'XResolution',
    0x011b: 'YResolution',
    0x0128: 'ResolutionUnit',
    0x0111: 'StripOffsets',
    0x0116: 'RowsPerStrip',
    0x0117: 'StripByteCounts',
    0x0201: 'JPEGInterchangeFormat',
    0x0202: 'JPEGInterchangeFormatLength',
    0x012d: 'TransferFunction',
    0x013e: 'WhitePoint',
    0x013f: 'PrimaryChromaticities',
    0x0211: 'YCbCrCoefficients',
    0x0214: 'ReferenceBlackWhite',
    0x0132: 'DateTime',
    0x010e: 'ImageDescription',
    0x010f: 'Make',
    0x0110: 'Model',
    0x0131: 'Software',
    0x013b: 'Artist',
    0x8298: 'Copyright',
    0x8769: {
      // ExifIFDPointer
      0x9000: 'ExifVersion', // EXIF version
      0xa000: 'FlashpixVersion', // Flashpix format version
      0xa001: 'ColorSpace', // Color space information tag
      0xa002: 'PixelXDimension', // Valid width of meaningful image
      0xa003: 'PixelYDimension', // Valid height of meaningful image
      0xa500: 'Gamma',
      0x9101: 'ComponentsConfiguration', // Information about channels
      0x9102: 'CompressedBitsPerPixel', // Compressed bits per pixel
      0x927c: 'MakerNote', // Any desired information written by the manufacturer
      0x9286: 'UserComment', // Comments by user
      0xa004: 'RelatedSoundFile', // Name of related sound file
      0x9003: 'DateTimeOriginal', // Date and time when the original image was generated
      0x9004: 'DateTimeDigitized', // Date and time when the image was stored digitally
      0x9010: 'OffsetTime', // Time zone when the image file was last changed
      0x9011: 'OffsetTimeOriginal', // Time zone when the image was stored digitally
      0x9012: 'OffsetTimeDigitized', // Time zone when the image was stored digitally
      0x9290: 'SubSecTime', // Fractions of seconds for DateTime
      0x9291: 'SubSecTimeOriginal', // Fractions of seconds for DateTimeOriginal
      0x9292: 'SubSecTimeDigitized', // Fractions of seconds for DateTimeDigitized
      0x829a: 'ExposureTime', // Exposure time (in seconds)
      0x829d: 'FNumber',
      0x8822: 'ExposureProgram', // Exposure program
      0x8824: 'SpectralSensitivity', // Spectral sensitivity
      0x8827: 'PhotographicSensitivity', // EXIF 2.3, ISOSpeedRatings in EXIF 2.2
      0x8828: 'OECF', // Optoelectric conversion factor
      0x8830: 'SensitivityType',
      0x8831: 'StandardOutputSensitivity',
      0x8832: 'RecommendedExposureIndex',
      0x8833: 'ISOSpeed',
      0x8834: 'ISOSpeedLatitudeyyy',
      0x8835: 'ISOSpeedLatitudezzz',
      0x9201: 'ShutterSpeedValue', // Shutter speed
      0x9202: 'ApertureValue', // Lens aperture
      0x9203: 'BrightnessValue', // Value of brightness
      0x9204: 'ExposureBias', // Exposure bias
      0x9205: 'MaxApertureValue', // Smallest F number of lens
      0x9206: 'SubjectDistance', // Distance to subject in meters
      0x9207: 'MeteringMode', // Metering mode
      0x9208: 'LightSource', // Kind of light source
      0x9209: 'Flash', // Flash status
      0x9214: 'SubjectArea', // Location and area of main subject
      0x920a: 'FocalLength', // Focal length of the lens in mm
      0xa20b: 'FlashEnergy', // Strobe energy in BCPS
      0xa20c: 'SpatialFrequencyResponse',
      0xa20e: 'FocalPlaneXResolution', // Number of pixels in width direction per FPRUnit
      0xa20f: 'FocalPlaneYResolution', // Number of pixels in height direction per FPRUnit
      0xa210: 'FocalPlaneResolutionUnit', // Unit for measuring the focal plane resolution
      0xa214: 'SubjectLocation', // Location of subject in image
      0xa215: 'ExposureIndex', // Exposure index selected on camera
      0xa217: 'SensingMethod', // Image sensor type
      0xa300: 'FileSource', // Image source (3 == DSC)
      0xa301: 'SceneType', // Scene type (1 == directly photographed)
      0xa302: 'CFAPattern', // Color filter array geometric pattern
      0xa401: 'CustomRendered', // Special processing
      0xa402: 'ExposureMode', // Exposure mode
      0xa403: 'WhiteBalance', // 1 = auto white balance, 2 = manual
      0xa404: 'DigitalZoomRatio', // Digital zoom ratio
      0xa405: 'FocalLengthIn35mmFilm',
      0xa406: 'SceneCaptureType', // Type of scene
      0xa407: 'GainControl', // Degree of overall image gain adjustment
      0xa408: 'Contrast', // Direction of contrast processing applied by camera
      0xa409: 'Saturation', // Direction of saturation processing applied by camera
      0xa40a: 'Sharpness', // Direction of sharpness processing applied by camera
      0xa40b: 'DeviceSettingDescription',
      0xa40c: 'SubjectDistanceRange', // Distance to subject
      0xa420: 'ImageUniqueID', // Identifier assigned uniquely to each image
      0xa430: 'CameraOwnerName',
      0xa431: 'BodySerialNumber',
      0xa432: 'LensSpecification',
      0xa433: 'LensMake',
      0xa434: 'LensModel',
      0xa435: 'LensSerialNumber'
    },
    0x8825: {
      // GPSInfoIFDPointer
      0x0000: 'GPSVersionID',
      0x0001: 'GPSLatitudeRef',
      0x0002: 'GPSLatitude',
      0x0003: 'GPSLongitudeRef',
      0x0004: 'GPSLongitude',
      0x0005: 'GPSAltitudeRef',
      0x0006: 'GPSAltitude',
      0x0007: 'GPSTimeStamp',
      0x0008: 'GPSSatellites',
      0x0009: 'GPSStatus',
      0x000a: 'GPSMeasureMode',
      0x000b: 'GPSDOP',
      0x000c: 'GPSSpeedRef',
      0x000d: 'GPSSpeed',
      0x000e: 'GPSTrackRef',
      0x000f: 'GPSTrack',
      0x0010: 'GPSImgDirectionRef',
      0x0011: 'GPSImgDirection',
      0x0012: 'GPSMapDatum',
      0x0013: 'GPSDestLatitudeRef',
      0x0014: 'GPSDestLatitude',
      0x0015: 'GPSDestLongitudeRef',
      0x0016: 'GPSDestLongitude',
      0x0017: 'GPSDestBearingRef',
      0x0018: 'GPSDestBearing',
      0x0019: 'GPSDestDistanceRef',
      0x001a: 'GPSDestDistance',
      0x001b: 'GPSProcessingMethod',
      0x001c: 'GPSAreaInformation',
      0x001d: 'GPSDateStamp',
      0x001e: 'GPSDifferential',
      0x001f: 'GPSHPositioningError'
    },
    0xa005: {
      // InteroperabilityIFDPointer
      0x0001: 'InteroperabilityIndex'
    }
  }

  // IFD1 directory can contain any IFD0 tags:
  ExifMapProto.tags.ifd1 = ExifMapProto.tags

  ExifMapProto.stringValues = {
    ExposureProgram: {
      0: 'Undefined',
      1: 'Manual',
      2: 'Normal program',
      3: 'Aperture priority',
      4: 'Shutter priority',
      5: 'Creative program',
      6: 'Action program',
      7: 'Portrait mode',
      8: 'Landscape mode'
    },
    MeteringMode: {
      0: 'Unknown',
      1: 'Average',
      2: 'CenterWeightedAverage',
      3: 'Spot',
      4: 'MultiSpot',
      5: 'Pattern',
      6: 'Partial',
      255: 'Other'
    },
    LightSource: {
      0: 'Unknown',
      1: 'Daylight',
      2: 'Fluorescent',
      3: 'Tungsten (incandescent light)',
      4: 'Flash',
      9: 'Fine weather',
      10: 'Cloudy weather',
      11: 'Shade',
      12: 'Daylight fluorescent (D 5700 - 7100K)',
      13: 'Day white fluorescent (N 4600 - 5400K)',
      14: 'Cool white fluorescent (W 3900 - 4500K)',
      15: 'White fluorescent (WW 3200 - 3700K)',
      17: 'Standard light A',
      18: 'Standard light B',
      19: 'Standard light C',
      20: 'D55',
      21: 'D65',
      22: 'D75',
      23: 'D50',
      24: 'ISO studio tungsten',
      255: 'Other'
    },
    Flash: {
      0x0000: 'Flash did not fire',
      0x0001: 'Flash fired',
      0x0005: 'Strobe return light not detected',
      0x0007: 'Strobe return light detected',
      0x0009: 'Flash fired, compulsory flash mode',
      0x000d: 'Flash fired, compulsory flash mode, return light not detected',
      0x000f: 'Flash fired, compulsory flash mode, return light detected',
      0x0010: 'Flash did not fire, compulsory flash mode',
      0x0018: 'Flash did not fire, auto mode',
      0x0019: 'Flash fired, auto mode',
      0x001d: 'Flash fired, auto mode, return light not detected',
      0x001f: 'Flash fired, auto mode, return light detected',
      0x0020: 'No flash function',
      0x0041: 'Flash fired, red-eye reduction mode',
      0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
      0x0047: 'Flash fired, red-eye reduction mode, return light detected',
      0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
      0x004d: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
      0x004f: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
      0x0059: 'Flash fired, auto mode, red-eye reduction mode',
      0x005d: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
      0x005f: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
    },
    SensingMethod: {
      1: 'Undefined',
      2: 'One-chip color area sensor',
      3: 'Two-chip color area sensor',
      4: 'Three-chip color area sensor',
      5: 'Color sequential area sensor',
      7: 'Trilinear sensor',
      8: 'Color sequential linear sensor'
    },
    SceneCaptureType: {
      0: 'Standard',
      1: 'Landscape',
      2: 'Portrait',
      3: 'Night scene'
    },
    SceneType: {
      1: 'Directly photographed'
    },
    CustomRendered: {
      0: 'Normal process',
      1: 'Custom process'
    },
    WhiteBalance: {
      0: 'Auto white balance',
      1: 'Manual white balance'
    },
    GainControl: {
      0: 'None',
      1: 'Low gain up',
      2: 'High gain up',
      3: 'Low gain down',
      4: 'High gain down'
    },
    Contrast: {
      0: 'Normal',
      1: 'Soft',
      2: 'Hard'
    },
    Saturation: {
      0: 'Normal',
      1: 'Low saturation',
      2: 'High saturation'
    },
    Sharpness: {
      0: 'Normal',
      1: 'Soft',
      2: 'Hard'
    },
    SubjectDistanceRange: {
      0: 'Unknown',
      1: 'Macro',
      2: 'Close view',
      3: 'Distant view'
    },
    FileSource: {
      3: 'DSC'
    },
    ComponentsConfiguration: {
      0: '',
      1: 'Y',
      2: 'Cb',
      3: 'Cr',
      4: 'R',
      5: 'G',
      6: 'B'
    },
    Orientation: {
      1: 'Original',
      2: 'Horizontal flip',
      3: 'Rotate 180° CCW',
      4: 'Vertical flip',
      5: 'Vertical flip + Rotate 90° CW',
      6: 'Rotate 90° CW',
      7: 'Horizontal flip + Rotate 90° CW',
      8: 'Rotate 90° CCW'
    }
  }

  ExifMapProto.getText = function (name) {
    var value = this.get(name)
    switch (name) {
      case 'LightSource':
      case 'Flash':
      case 'MeteringMode':
      case 'ExposureProgram':
      case 'SensingMethod':
      case 'SceneCaptureType':
      case 'SceneType':
      case 'CustomRendered':
      case 'WhiteBalance':
      case 'GainControl':
      case 'Contrast':
      case 'Saturation':
      case 'Sharpness':
      case 'SubjectDistanceRange':
      case 'FileSource':
      case 'Orientation':
        return this.stringValues[name][value]
      case 'ExifVersion':
      case 'FlashpixVersion':
        if (!value) return
        return String.fromCharCode(value[0], value[1], value[2], value[3])
      case 'ComponentsConfiguration':
        if (!value) return
        return (
          this.stringValues[name][value[0]] +
          this.stringValues[name][value[1]] +
          this.stringValues[name][value[2]] +
          this.stringValues[name][value[3]]
        )
      case 'GPSVersionID':
        if (!value) return
        return value[0] + '.' + value[1] + '.' + value[2] + '.' + value[3]
    }
    return String(value)
  }

  ExifMapProto.getAll = function () {
    var map = {}
    var prop
    var obj
    var name
    for (prop in this) {
      if (Object.prototype.hasOwnProperty.call(this, prop)) {
        obj = this[prop]
        if (obj && obj.getAll) {
          map[this.ifds[prop].name] = obj.getAll()
        } else {
          name = this.tags[prop]
          if (name) map[name] = this.getText(name)
        }
      }
    }
    return map
  }

  ExifMapProto.getName = function (tagCode) {
    var name = this.tags[tagCode]
    if (typeof name === 'object') return this.ifds[tagCode].name
    return name
  }

  // Extend the map of tag names to tag codes:
  ;(function () {
    var tags = ExifMapProto.tags
    var prop
    var ifd
    var subTags
    // Map the tag names to tags:
    for (prop in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, prop)) {
        ifd = ExifMapProto.ifds[prop]
        if (ifd) {
          subTags = tags[prop]
          for (prop in subTags) {
            if (Object.prototype.hasOwnProperty.call(subTags, prop)) {
              ifd.map[subTags[prop]] = Number(prop)
            }
          }
        } else {
          ExifMapProto.map[tags[prop]] = Number(prop)
        }
      }
    }
  })()
})


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image IPTC Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 *
 * IPTC tags mapping based on
 * https://iptc.org/standards/photo-metadata
 * https://exiftool.org/TagNames/IPTC.html
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34), __webpack_require__(180)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-iptc'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var IptcMapProto = loadImage.IptcMap.prototype

  IptcMapProto.tags = {
    0: 'ApplicationRecordVersion',
    3: 'ObjectTypeReference',
    4: 'ObjectAttributeReference',
    5: 'ObjectName',
    7: 'EditStatus',
    8: 'EditorialUpdate',
    10: 'Urgency',
    12: 'SubjectReference',
    15: 'Category',
    20: 'SupplementalCategories',
    22: 'FixtureIdentifier',
    25: 'Keywords',
    26: 'ContentLocationCode',
    27: 'ContentLocationName',
    30: 'ReleaseDate',
    35: 'ReleaseTime',
    37: 'ExpirationDate',
    38: 'ExpirationTime',
    40: 'SpecialInstructions',
    42: 'ActionAdvised',
    45: 'ReferenceService',
    47: 'ReferenceDate',
    50: 'ReferenceNumber',
    55: 'DateCreated',
    60: 'TimeCreated',
    62: 'DigitalCreationDate',
    63: 'DigitalCreationTime',
    65: 'OriginatingProgram',
    70: 'ProgramVersion',
    75: 'ObjectCycle',
    80: 'Byline',
    85: 'BylineTitle',
    90: 'City',
    92: 'Sublocation',
    95: 'State',
    100: 'CountryCode',
    101: 'Country',
    103: 'OriginalTransmissionReference',
    105: 'Headline',
    110: 'Credit',
    115: 'Source',
    116: 'CopyrightNotice',
    118: 'Contact',
    120: 'Caption',
    121: 'LocalCaption',
    122: 'Writer',
    125: 'RasterizedCaption',
    130: 'ImageType',
    131: 'ImageOrientation',
    135: 'LanguageIdentifier',
    150: 'AudioType',
    151: 'AudioSamplingRate',
    152: 'AudioSamplingResolution',
    153: 'AudioDuration',
    154: 'AudioOutcue',
    184: 'JobID',
    185: 'MasterDocumentID',
    186: 'ShortDocumentID',
    187: 'UniqueDocumentID',
    188: 'OwnerID',
    200: 'ObjectPreviewFileFormat',
    201: 'ObjectPreviewFileVersion',
    202: 'ObjectPreviewData',
    221: 'Prefs',
    225: 'ClassifyState',
    228: 'SimilarityIndex',
    230: 'DocumentNotes',
    231: 'DocumentHistory',
    232: 'ExifCameraInfo',
    255: 'CatalogSets'
  }

  IptcMapProto.stringValues = {
    10: {
      0: '0 (reserved)',
      1: '1 (most urgent)',
      2: '2',
      3: '3',
      4: '4',
      5: '5 (normal urgency)',
      6: '6',
      7: '7',
      8: '8 (least urgent)',
      9: '9 (user-defined priority)'
    },
    75: {
      a: 'Morning',
      b: 'Both Morning and Evening',
      p: 'Evening'
    },
    131: {
      L: 'Landscape',
      P: 'Portrait',
      S: 'Square'
    }
  }

  IptcMapProto.getText = function (id) {
    var value = this.get(id)
    var tagCode = this.map[id]
    var stringValue = this.stringValues[tagCode]
    if (stringValue) return stringValue[value]
    return String(value)
  }

  IptcMapProto.getAll = function () {
    var map = {}
    var prop
    var name
    for (prop in this) {
      if (Object.prototype.hasOwnProperty.call(this, prop)) {
        name = this.tags[prop]
        if (name) map[name] = this.getText(name)
      }
    }
    return map
  }

  IptcMapProto.getName = function (tagCode) {
    return this.tags[tagCode]
  }

  // Extend the map of tag names to tag codes:
  ;(function () {
    var tags = IptcMapProto.tags
    var map = IptcMapProto.map || {}
    var prop
    // Map the tag names to tags:
    for (prop in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, prop)) {
        map[tags[prop]] = Number(prop)
      }
    }
  })()
})


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Orientation
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/*
Exif orientation values to correctly display the letter F:

    1             2
  ██████        ██████
  ██                ██
  ████            ████
  ██                ██
  ██                ██

    3             4
      ██        ██
      ██        ██
    ████        ████
      ██        ██
  ██████        ██████

    5             6
██████████    ██
██  ██        ██  ██
██            ██████████

    7             8
        ██    ██████████
    ██  ██        ██  ██
██████████            ██

*/

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34), __webpack_require__(178), __webpack_require__(78)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(
      require('./load-image'),
      require('./load-image-scale'),
      require('./load-image-meta')
    )
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var originalTransform = loadImage.transform
  var originalRequiresCanvas = loadImage.requiresCanvas
  var originalRequiresMetaData = loadImage.requiresMetaData
  var originalTransformCoordinates = loadImage.transformCoordinates
  var originalGetTransformedOptions = loadImage.getTransformedOptions

  ;(function ($) {
    // Guard for non-browser environments (e.g. server-side rendering):
    if (!$.global.document) return
    // black+white 3x2 JPEG, with the following meta information set:
    // - EXIF Orientation: 6 (Rotated 90° CCW)
    // Image data layout (B=black, F=white):
    // BFF
    // BBB
    var testImageURL =
      'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' +
      'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' +
      'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' +
      'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/x' +
      'ABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAA' +
      'AAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQ' +
      'voP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXw' +
      'H/9k='
    var img = document.createElement('img')
    img.onload = function () {
      // Check if the browser supports automatic image orientation:
      $.orientation = img.width === 2 && img.height === 3
      if ($.orientation) {
        var canvas = $.createCanvas(1, 1, true)
        var ctx = canvas.getContext('2d')
        ctx.drawImage(img, 1, 1, 1, 1, 0, 0, 1, 1)
        // Check if the source image coordinates (sX, sY, sWidth, sHeight) are
        // correctly applied to the auto-orientated image, which should result
        // in a white opaque pixel (e.g. in Safari).
        // Browsers that show a transparent pixel (e.g. Chromium) fail to crop
        // auto-oriented images correctly and require a workaround, e.g.
        // drawing the complete source image to an intermediate canvas first.
        // See https://bugs.chromium.org/p/chromium/issues/detail?id=1074354
        $.orientationCropBug =
          ctx.getImageData(0, 0, 1, 1).data.toString() !== '255,255,255,255'
      }
    }
    img.src = testImageURL
  })(loadImage)

  /**
   * Determines if the orientation requires a canvas element.
   *
   * @param {object} [options] Options object
   * @param {boolean} [withMetaData] Is metadata required for orientation
   * @returns {boolean} Returns true if orientation requires canvas/meta
   */
  function requiresCanvasOrientation(options, withMetaData) {
    var orientation = options && options.orientation
    return (
      // Exif orientation for browsers without automatic image orientation:
      (orientation === true && !loadImage.orientation) ||
      // Orientation reset for browsers with automatic image orientation:
      (orientation === 1 && loadImage.orientation) ||
      // Orientation to defined value, requires meta for orientation reset only:
      ((!withMetaData || loadImage.orientation) &&
        orientation > 1 &&
        orientation < 9)
    )
  }

  /**
   * Determines if the image requires an orientation change.
   *
   * @param {number} [orientation] Defined orientation value
   * @param {number} [autoOrientation] Auto-orientation based on Exif data
   * @returns {boolean} Returns true if an orientation change is required
   */
  function requiresOrientationChange(orientation, autoOrientation) {
    return (
      orientation !== autoOrientation &&
      ((orientation === 1 && autoOrientation > 1 && autoOrientation < 9) ||
        (orientation > 1 && orientation < 9))
    )
  }

  /**
   * Determines orientation combinations that require a rotation by 180°.
   *
   * The following is a list of combinations that return true:
   *
   * 2 (flip) => 5 (rot90,flip), 7 (rot90,flip), 6 (rot90), 8 (rot90)
   * 4 (flip) => 5 (rot90,flip), 7 (rot90,flip), 6 (rot90), 8 (rot90)
   *
   * 5 (rot90,flip) => 2 (flip), 4 (flip), 6 (rot90), 8 (rot90)
   * 7 (rot90,flip) => 2 (flip), 4 (flip), 6 (rot90), 8 (rot90)
   *
   * 6 (rot90) => 2 (flip), 4 (flip), 5 (rot90,flip), 7 (rot90,flip)
   * 8 (rot90) => 2 (flip), 4 (flip), 5 (rot90,flip), 7 (rot90,flip)
   *
   * @param {number} [orientation] Defined orientation value
   * @param {number} [autoOrientation] Auto-orientation based on Exif data
   * @returns {boolean} Returns true if rotation by 180° is required
   */
  function requiresRot180(orientation, autoOrientation) {
    if (autoOrientation > 1 && autoOrientation < 9) {
      switch (orientation) {
        case 2:
        case 4:
          return autoOrientation > 4
        case 5:
        case 7:
          return autoOrientation % 2 === 0
        case 6:
        case 8:
          return (
            autoOrientation === 2 ||
            autoOrientation === 4 ||
            autoOrientation === 5 ||
            autoOrientation === 7
          )
      }
    }
    return false
  }

  // Determines if the target image should be a canvas element:
  loadImage.requiresCanvas = function (options) {
    return (
      requiresCanvasOrientation(options) ||
      originalRequiresCanvas.call(loadImage, options)
    )
  }

  // Determines if metadata should be loaded automatically:
  loadImage.requiresMetaData = function (options) {
    return (
      requiresCanvasOrientation(options, true) ||
      originalRequiresMetaData.call(loadImage, options)
    )
  }

  loadImage.transform = function (img, options, callback, file, data) {
    originalTransform.call(
      loadImage,
      img,
      options,
      function (img, data) {
        if (data) {
          var autoOrientation =
            loadImage.orientation && data.exif && data.exif.get('Orientation')
          if (autoOrientation > 4 && autoOrientation < 9) {
            // Automatic image orientation switched image dimensions
            var originalWidth = data.originalWidth
            var originalHeight = data.originalHeight
            data.originalWidth = originalHeight
            data.originalHeight = originalWidth
          }
        }
        callback(img, data)
      },
      file,
      data
    )
  }

  // Transforms coordinate and dimension options
  // based on the given orientation option:
  loadImage.getTransformedOptions = function (img, opts, data) {
    var options = originalGetTransformedOptions.call(loadImage, img, opts)
    var exifOrientation = data.exif && data.exif.get('Orientation')
    var orientation = options.orientation
    var autoOrientation = loadImage.orientation && exifOrientation
    if (orientation === true) orientation = exifOrientation
    if (!requiresOrientationChange(orientation, autoOrientation)) {
      return options
    }
    var top = options.top
    var right = options.right
    var bottom = options.bottom
    var left = options.left
    var newOptions = {}
    for (var i in options) {
      if (Object.prototype.hasOwnProperty.call(options, i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.orientation = orientation
    if (
      (orientation > 4 && !(autoOrientation > 4)) ||
      (orientation < 5 && autoOrientation > 4)
    ) {
      // Image dimensions and target dimensions are switched
      newOptions.maxWidth = options.maxHeight
      newOptions.maxHeight = options.maxWidth
      newOptions.minWidth = options.minHeight
      newOptions.minHeight = options.minWidth
      newOptions.sourceWidth = options.sourceHeight
      newOptions.sourceHeight = options.sourceWidth
    }
    if (autoOrientation > 1) {
      // Browsers which correctly apply source image coordinates to
      // auto-oriented images
      switch (autoOrientation) {
        case 2:
          // Horizontal flip
          right = options.left
          left = options.right
          break
        case 3:
          // 180° Rotate CCW
          top = options.bottom
          right = options.left
          bottom = options.top
          left = options.right
          break
        case 4:
          // Vertical flip
          top = options.bottom
          bottom = options.top
          break
        case 5:
          // Horizontal flip + 90° Rotate CCW
          top = options.left
          right = options.bottom
          bottom = options.right
          left = options.top
          break
        case 6:
          // 90° Rotate CCW
          top = options.left
          right = options.top
          bottom = options.right
          left = options.bottom
          break
        case 7:
          // Vertical flip + 90° Rotate CCW
          top = options.right
          right = options.top
          bottom = options.left
          left = options.bottom
          break
        case 8:
          // 90° Rotate CW
          top = options.right
          right = options.bottom
          bottom = options.left
          left = options.top
          break
      }
      // Some orientation combinations require additional rotation by 180°:
      if (requiresRot180(orientation, autoOrientation)) {
        var tmpTop = top
        var tmpRight = right
        top = bottom
        right = left
        bottom = tmpTop
        left = tmpRight
      }
    }
    newOptions.top = top
    newOptions.right = right
    newOptions.bottom = bottom
    newOptions.left = left
    // Account for defined browser orientation:
    switch (orientation) {
      case 2:
        // Horizontal flip
        newOptions.right = left
        newOptions.left = right
        break
      case 3:
        // 180° Rotate CCW
        newOptions.top = bottom
        newOptions.right = left
        newOptions.bottom = top
        newOptions.left = right
        break
      case 4:
        // Vertical flip
        newOptions.top = bottom
        newOptions.bottom = top
        break
      case 5:
        // Vertical flip + 90° Rotate CW
        newOptions.top = left
        newOptions.right = bottom
        newOptions.bottom = right
        newOptions.left = top
        break
      case 6:
        // 90° Rotate CW
        newOptions.top = right
        newOptions.right = bottom
        newOptions.bottom = left
        newOptions.left = top
        break
      case 7:
        // Horizontal flip + 90° Rotate CW
        newOptions.top = right
        newOptions.right = top
        newOptions.bottom = left
        newOptions.left = bottom
        break
      case 8:
        // 90° Rotate CCW
        newOptions.top = left
        newOptions.right = top
        newOptions.bottom = right
        newOptions.left = bottom
        break
    }
    return newOptions
  }

  // Transform image orientation based on the given EXIF orientation option:
  loadImage.transformCoordinates = function (canvas, options, data) {
    originalTransformCoordinates.call(loadImage, canvas, options, data)
    var orientation = options.orientation
    var autoOrientation =
      loadImage.orientation && data.exif && data.exif.get('Orientation')
    if (!requiresOrientationChange(orientation, autoOrientation)) {
      return
    }
    var ctx = canvas.getContext('2d')
    var width = canvas.width
    var height = canvas.height
    var sourceWidth = width
    var sourceHeight = height
    if (
      (orientation > 4 && !(autoOrientation > 4)) ||
      (orientation < 5 && autoOrientation > 4)
    ) {
      // Image dimensions and target dimensions are switched
      canvas.width = height
      canvas.height = width
    }
    if (orientation > 4) {
      // Destination and source dimensions are switched
      sourceWidth = height
      sourceHeight = width
    }
    // Reset automatic browser orientation:
    switch (autoOrientation) {
      case 2:
        // Horizontal flip
        ctx.translate(sourceWidth, 0)
        ctx.scale(-1, 1)
        break
      case 3:
        // 180° Rotate CCW
        ctx.translate(sourceWidth, sourceHeight)
        ctx.rotate(Math.PI)
        break
      case 4:
        // Vertical flip
        ctx.translate(0, sourceHeight)
        ctx.scale(1, -1)
        break
      case 5:
        // Horizontal flip + 90° Rotate CCW
        ctx.rotate(-0.5 * Math.PI)
        ctx.scale(-1, 1)
        break
      case 6:
        // 90° Rotate CCW
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-sourceWidth, 0)
        break
      case 7:
        // Vertical flip + 90° Rotate CCW
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-sourceWidth, sourceHeight)
        ctx.scale(1, -1)
        break
      case 8:
        // 90° Rotate CW
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(0, -sourceHeight)
        break
    }
    // Some orientation combinations require additional rotation by 180°:
    if (requiresRot180(orientation, autoOrientation)) {
      ctx.translate(sourceWidth, sourceHeight)
      ctx.rotate(Math.PI)
    }
    switch (orientation) {
      case 2:
        // Horizontal flip
        ctx.translate(width, 0)
        ctx.scale(-1, 1)
        break
      case 3:
        // 180° Rotate CCW
        ctx.translate(width, height)
        ctx.rotate(Math.PI)
        break
      case 4:
        // Vertical flip
        ctx.translate(0, height)
        ctx.scale(1, -1)
        break
      case 5:
        // Vertical flip + 90° Rotate CW
        ctx.rotate(0.5 * Math.PI)
        ctx.scale(1, -1)
        break
      case 6:
        // 90° Rotate CW
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(0, -height)
        break
      case 7:
        // Horizontal flip + 90° Rotate CW
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(width, -height)
        ctx.scale(-1, 1)
        break
      case 8:
        // 90° Rotate CCW
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-width, 0)
        break
    }
  }
})


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.styles)},[_vm._t("upload-button",[_vm._m(0)])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn--plain is--primary-icon is--center is--large"},[_c('i',{staticClass:"icon-upload2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Guide_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0375f2a3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guide_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0375f2a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Guide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0375f2a3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(348);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0c1cbcef", content, true, {});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".btn--plain[data-v-0375f2a3]{background:none;border:none;border-radius:0;font-size:20px}.btn--plain[data-v-0375f2a3]:focus{outline:none}.btn.is--third[data-v-0375f2a3]{padding:2px 12px;line-height:34px}.btn.is--third.is--small[data-v-0375f2a3]{line-height:30px}.btn.is--third.is--large[data-v-0375f2a3]{line-height:38px}.btn--plain.has--extra-space[data-v-0375f2a3],.btn.has--extra-space[data-v-0375f2a3]{width:40px;height:40px}.btn--plain.has--extra-space-left[data-v-0375f2a3],.btn.has--extra-space-left[data-v-0375f2a3]{text-align:left}.btn--plain.has--extra-space-right[data-v-0375f2a3],.btn.has--extra-space-right[data-v-0375f2a3]{text-align:right}.btn--plain.is--primary-icon[data-v-0375f2a3],.btn--plain i.icon--trash[data-v-0375f2a3],.btn.is--primary-icon[data-v-0375f2a3],.btn i.icon--trash[data-v-0375f2a3]{color:#009fe3}.btn--plain.button-guide i[data-v-0375f2a3],.btn.button-guide i[data-v-0375f2a3]{color:#009600}.guide-container[data-v-0375f2a3]{background-color:#fff;width:100%;height:100%;margin:0;overflow:hidden;display:flex;flex-direction:column}@media screen and (min-width:48em){.guide-container[data-v-0375f2a3]{width:80%;min-width:600px;max-width:1260px;height:85%;margin:5rem auto}}.guide-container .header[data-v-0375f2a3]{width:100%;position:relative}.guide-container .header h2[data-v-0375f2a3]{margin:0;font-size:1rem;line-height:normal;padding:15px 60px 10px 10px;font-weight:400;color:#009fe3}@media screen and (min-width:48em){.guide-container .header h2[data-v-0375f2a3]{font-size:1.25rem;padding:15px 60px 10px 30px}}.guide-container .header .is--modal-close[data-v-0375f2a3]{position:absolute;right:10px;top:0}@media screen and (min-width:48em){.guide-container .header .is--modal-close[data-v-0375f2a3]{right:0}}.guide-container .header .is--modal-close .modal--close[data-v-0375f2a3]{padding:0;cursor:pointer;position:absolute;right:10px;top:10px;width:30px;height:30px;line-height:30px;font-size:10px}.guide-container .body[data-v-0375f2a3]{overflow-y:auto}.guide-container .body .guide-content[data-v-0375f2a3]{width:100%;padding:0 10px}@media screen and (min-width:48em){.guide-container .body .guide-content[data-v-0375f2a3]{display:flex;flex-wrap:wrap;justify-content:space-between;padding:0 30px}}.guide-container .body .guide-content .ngrid[data-v-0375f2a3]{width:100%}.guide-container .block[data-v-0375f2a3]{clear:both}.guide-container .item[data-v-0375f2a3]{margin:20px 0}.guide-container .item-text[data-v-0375f2a3]{width:100%}@media screen and (min-width:48em){.guide-container .item-text[data-v-0375f2a3]{width:40%}}.guide-container .item-text p[data-v-0375f2a3]{padding-left:0}.guide-container .item-text img[data-v-0375f2a3]{width:18px;display:inline-block;vertical-align:sub;padding-bottom:2px}.guide-container .item-text .has--underline[data-v-0375f2a3]{border-bottom:1px solid #444041}.guide-container .item-image[data-v-0375f2a3]{width:100%}@media screen and (min-width:48em){.guide-container .item-image[data-v-0375f2a3]{width:60%}}.guide-container .item-image img[data-v-0375f2a3]{margin:auto}@media screen and (min-width:48em){.guide-container .item-image img[data-v-0375f2a3]{padding:0 30px}}", ""]);

// exports


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-container"},[_c('section',{staticClass:"header"},[(1 === _vm.menuitem)?_c('h2',[_vm._v("\n            Wie verwende ich die Galerie?\n        ")]):_vm._e(),_vm._v(" "),(2 === _vm.menuitem)?_c('h2',[_vm._v("\n            Wie bestimme ich den Auschnitt für mein Plexipeople?\n        ")]):_vm._e(),_vm._v(" "),(3 === _vm.menuitem)?_c('h2',[_vm._v("\n            Wie benutze ich den Konfigurator?\n        ")]):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('section',{staticClass:"body"},[(1 === _vm.menuitem)?_c('div',{staticClass:"block-group guide-content"},[_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(2 === _vm.menuitem)?_c('div',{staticClass:"block-group guide-content"},[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(3 === _vm.menuitem)?_c('div',{staticClass:"block-group guide-content"},[_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is--modal-close"},[_c('div',{staticClass:"btn icon--cross is--small is--center btn--grey modal--close"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-image item-first"},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/gallery/Galeriebeschreibung.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-text"},[_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-01.svg","alt":"1"}}),_vm._v(" Hier siehst Du Deine Bildausschnitte. Wähle durch\n                    Anklicken so viele Ausschnitte aus, wie Du auf einem\n                    Holzfuß platzieren möchtest.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Für ein mehrteiliges Plexipeople musst Du mehrere Fotos\n                    auswählen. Diese können vom selben Ursprungsfoto oder\n                    aus mehreren hochgeladenen Bildern gestaltet werden.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-02.svg","alt":"2"}}),_vm._v(" Kontrolliere mit der Lupe Deine Bildausschnitte, achte\n                    darauf, dass keine Körperteile abgeschnitten sind.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-03.svg","alt":"3"}}),_vm._v(" Mit dem Ausschnitt-Symbol kannst Du Deinen\n                    Bildausschnitt noch einmal bearbeiten.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-04.svg","alt":"4"}}),_vm._v(" Du kannst Deinen Ausschnitt durch die Doppelpfeile in\n                    den Konfigurator laden oder Du klickst auf den Button\n                    \"Weiter zum Konfigurator\".\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-05.svg","alt":"5"}}),_vm._v(" Klicke auf den Papierkorb um die Fotos oder\n                    Ausschnitte zu löschen.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-06.svg","alt":"6"}}),_vm._v(" Unter Originale befinden sich Deine hochgeladenen\n                    Originalbilder. Diese kannst Du mit Hilfe "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-07.svg","alt":"7"}}),_vm._v("\n                    der Pfeile gegen\n                    oder mit dem Uhrzeigersinn drehen, mit "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-08.svg","alt":"8"}}),_vm._v("\n                    der Lupe\n                    vergrößert anschauen oder mit dem "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-09.svg","alt":"9"}}),_vm._v("\n                    Ausschnitt-Symbol\n                    einen weiteren Ausschnitt wählen. Du kannst von einem Foto\n                    so viele Ausschnitte bestimmen wie Du möchtest.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-10.svg","alt":"10"}}),_vm._v(" Durch den Upload-Button kannst Du weitere Fotos\n                    hochladen.\n                ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Bitte beachte: Wenn Du den Browser schließt sind alle Deine\n                    Fotos, sowie auch Deine Ausschnitte verschwunden.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-image item-first"},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/extractor/Editor-oben.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-text"},[_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-01.svg","alt":"1"}}),_vm._v(" Klicke mit der Maus oder Deinem Finger auf\n                    die blauen Punkten und ziehe diese um Deine\n                    Auswahl grob herum.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Achte darauf, dass die blauen Punkte den\n                    gewünschten Bereich nicht beschneiden.\n                    Hast Du Deinen Ausschnitt gewählt, kannst Du\n                    unter "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-02.svg","alt":"2"}}),_vm._v(" "),_c('strong',{staticClass:"has--underline"},[_vm._v("Ausschnitt übernehmen")]),_vm._v(" die Größe\n                    anpassen und den Holzfuß wählen.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Alternativ kannst Du den Ausschnitt unter "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-03.svg","alt":"3"}}),_vm._v(" "),_c('strong',{staticClass:"has--underline"},[_vm._v("Ausschnitt zur Galerie")]),_vm._v(" hinzufügen und dort\n                    ein weiteres Foto hochladen.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-04.svg","alt":"4"}}),_vm._v(" Hier kannst Du Deine Auswahl\n                    zurückzusetzen, um eine neue Auswahl zu\n                    treffen.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-05.svg","alt":"5"}}),_vm._v(" Möchtest Du ein anderes Motiv hochladen,\n                    klicke auf den Papierkorb.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-image"},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/extractor/Editor-unten.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-text"},[_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-06.svg","alt":"6"}}),_vm._v(" Bei mehreren Motiven auf einem Foto\n                    markierst Du zuerst den einen Ausschnitt, fügst\n                    "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-07.svg","alt":"7"}}),_vm._v(" "),_c('strong',{staticClass:"has--underline"},[_vm._v("Ausschnitt zur Galerie")]),_vm._v(" hinzu und\n                    diesen unter\n                    "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-08.svg","alt":"8"}}),_vm._v(" wählst dann den zweiten Ausschnitt aus.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Dies kannst Du nach Belieben wiederholen, bis Du\n                    alle gewünschten Motive ausgewählt und Deiner\n                    Galerie hinzugefügt hast.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    In "),_c('strong',{staticClass:"has--underline"},[_vm._v("Deine Galerie")]),_vm._v(" kannst Du sie Dir dann alle\n                    ansehen.\n                ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Bitte beachte: Wenn Du den Browser schließt\n                        sind alle Deine Fotos, sowie auch Deine\n                        Ausschnitte verschwunden.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-image item-first"},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/editor/Konfi-Beschreibung-Bild-oben-01.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-text"},[_c('p',[_vm._v("\n                    Bestimme die Größe Deiner Plexipeople, mit\n                    einem "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-01.svg","alt":"1"}}),_vm._v("\n                    Klick auf die Größenanzeige S, M oder L\n                    oder ziehe die beiden Pfeile auf Deine\n                    gewünschte Größe.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-02.svg","alt":"2"}}),_vm._v(" Wähle den passenden Holzfuß. Klicke dafür\n                    auf eine der fünf Holzfußbreiten unter Deinem\n                    Ausschnitt oder im Menü rechts mit ein oder zwei\n                    Nuten.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-03.svg","alt":"3"}}),_vm._v(" Der Preis wird anhand unserer drei\n                    Preiskategorien S, M, L und der Holzfußgröße\n                    automatisch berechnet.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-04.svg","alt":"4"}}),_vm._v(" Über das Ausschnitt-Symbol kannst Du\n                    Deinen Bildausschnitt korrigieren und ersetzen.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-05.svg","alt":"5"}}),_vm._v(" Entferne Deinen Bildausschnitt mit dem\n                    Papierkorb.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-image"},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/editor/Konfi-Beschreibung-Bild-mitte-01.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-text"},[_c('p',[_vm._v("\n                    Bei einem mehrteiligen Plexipeople platzierst Du aus der Galerie mehrere Figuren auf einem Holzfuß, diese kannst Du dann nacheinander in der "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-06.svg","alt":"6"}}),_vm._v(" Größe aufeinander abstimmen und verteilen.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Es gibt zwei Möglichkeiten ein mehrteiliges Plexipeople zu gestalten.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Du kannst den Holzfuß mit "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-07.svg","alt":"7"}}),_vm._v(" "),_c('strong',[_vm._v("EINER")]),_vm._v(" Nut wählen\n                    und platzierst Deine Plexipeople nebeneinander.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-image"},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/editor/Konfi-Beschreibung-Bild-unten-01.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item block item-text"},[_c('p',[_vm._v("\n                    Alternativ wählst Du einen Holzfuß mit "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-08.svg","alt":"8"}}),_vm._v(" "),_c('strong',[_vm._v("ZWEI")]),_vm._v(" Nuten für mehr Platz und verschiebst\n                    Deine Plexipeople auch hintereinander.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-09.svg","alt":"9"}}),_vm._v(" Mit den Pfeilen oben links wechselst Du von der\n                    vorderen Nut in die Hintere oder umgekehrt.\n                    "),_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-10.svg","alt":"10"}}),_vm._v(" Unter „Dein Plexipeople“ kannst Du erkennen\n                    welches Element sich in welcher Nut befindet.\n                ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/guide/Zahlen-11.svg","alt":"11"}}),_vm._v(" Die Transparenz zeigt Dir wie viel von Deinem\n                    hinteren Plexipeople verdeckt wird.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    Durch den Upload-Button oben rechts in der\n                    Menüleiste kannst Du ein weiteres Motiv hochladen\n                    und landest dann wieder in der Galerie. Dort findest\n                    Du alle Deine Bildausschnitt und kannst diese an- und abwählen.\n                ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Bitte beachte: Wenn Du den Browser schließt sind\n                    alle Deine Fotos, sowie auch Deine Ausschnitte verschwunden.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"action-navi"},[_c('ul',{staticClass:"list--unstyled is--actionNavList"},[(_vm.enableButtons)?_c('li',{staticClass:"is--listItem is--delete"},[_c('button',{ref:"intro-delete",staticClass:"btn--plain is--icon-left",on:{"click":_vm.removeClicked}},[_c('i',{staticClass:"icon-close"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("navigation.delete")))])])]):_vm._e(),_vm._v(" "),(_vm.enableButtons)?_c('li',{staticClass:"is--listItem is--back"},[_c('button',{ref:"intro-clipping",staticClass:"btn--plain is--icon-left",on:{"click":_vm.editClicked}},[_c('i',{staticClass:"icon-edit"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("navigation.edit")))])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.enableButtons)?_c('li',{staticClass:"is--listItem is--manual"},[_c('button',{staticClass:"btn--plain is--icon-left",on:{"click":_vm.infoClicked}},[_c('i',{staticClass:"icon-info-mark"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("navigation.manual")))])])]):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.enableButtons),expression:"enableButtons"}],staticClass:"is--listItem is--upload is--last"},[_c('app-uploader',{staticClass:"panel-uploader",staticStyle:{"position":"relative"},attrs:{"event-prefix":'navigation'},on:{"added":_vm.addImage,"filesAdded":function($event){return _vm.$emit('openExtractor', '_uploaded')},"completed":_vm.completeImage}},[_c('button',{ref:"intro-upload",staticClass:"btn--plain is--icon-left",staticStyle:{"position":"relative","z-index":"1"},attrs:{"slot":"upload-button"},slot:"upload-button"},[_c('i',{staticClass:"icon-plus"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("navigation.upload")))])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"is--listItem is--brand"},[_c('a',{staticClass:"is--brandLogo",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleTheme/Resources/Themes/Frontend/Plexipeople/frontend/_public/src/img/logos/logo.svg","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClipPath_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661125d1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClipPath_vue__ = __webpack_require__(373);
function injectStyle (ssrContext) {
  __webpack_require__(352)
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-661125d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClipPath_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661125d1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClipPath_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(353);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("df587a22", content, true, {});

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".handle,.point,.shapes li{color:#009fe3}main{display:flex;flex-direction:column}@media (min-width:800px){main{position:fixed;top:0;left:0;height:100%;right:23.625rem;padding:.25rem .25rem .25rem .75rem;touch-action:none}main .panel.dark{display:none}}.v--modal-overlay{background:rgba(0,0,0,.8)}.v--modal-top-right{z-index:9999}", ""]);

// exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(355);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("01cb478f", content, true, {});

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".btn--plain[data-v-661125d1]{background:none;border:none;border-radius:0;font-size:20px}.btn--plain[data-v-661125d1]:focus{outline:none}.btn.is--third[data-v-661125d1]{padding:2px 12px;line-height:34px}.btn.is--third.is--small[data-v-661125d1]{line-height:30px}.btn.is--third.is--large[data-v-661125d1]{line-height:38px}.btn--plain.has--extra-space[data-v-661125d1],.btn.has--extra-space[data-v-661125d1]{width:40px;height:40px}.btn--plain.has--extra-space-left[data-v-661125d1],.btn.has--extra-space-left[data-v-661125d1]{text-align:left}.btn--plain.has--extra-space-right[data-v-661125d1],.btn.has--extra-space-right[data-v-661125d1]{text-align:right}.btn--plain.is--primary-icon[data-v-661125d1],.btn--plain i.icon--trash[data-v-661125d1],.btn.is--primary-icon[data-v-661125d1],.btn i.icon--trash[data-v-661125d1]{color:#009fe3}.btn--plain.button-guide i[data-v-661125d1],.btn.button-guide i[data-v-661125d1]{color:#009600}.is--extractor[data-v-661125d1]{width:100%;height:100%;background:#fff}.is--extractor button.is--loading[data-v-661125d1]:before{content:\"\";position:absolute;margin-left:-50px;background-image:url(/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg);height:36px;width:36px;background-size:contain;background-repeat:no-repeat}.ct-top-right[data-v-661125d1]{cursor:pointer;padding-top:20px;padding-right:30px;font-weight:600;color:#fff}.scale-enter-active[data-v-661125d1],.scale-leave-active[data-v-661125d1]{transition:all .5s}.scale-enter[data-v-661125d1],.scale-leave-active[data-v-661125d1]{opacity:0;transform:scale(.3) translateY(24px)}", ""]);

// exports


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Playground_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b507364_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Playground_vue__ = __webpack_require__(368);
function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Playground_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b507364_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Playground_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("563cc615", content, true, {});

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".is--playground-image,.playground-container{width:100%;height:100%}.playground-container{position:relative;user-select:none;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;display:flex;flex-direction:column;justify-content:center;align-content:center;align-items:center}@media (min-width:800px){.playground-container{border-radius:0 0 2px 2px}}.playground-container .playground{position:relative;user-select:none}.playground-container .playground .sandbox{position:relative;border:1px solid #009fe3;touch-action:none;user-select:none}.playground-container .playground .sandbox .handles,.playground-container .playground .sandbox .handles .handle.draggable,.playground-container .playground .sandbox .handles .handle.draggable:after{user-select:none}.playground-container .playground .sandbox .clipboard,.playground-container .playground .sandbox .shadowboard{position:absolute;top:10px;left:10px;right:10px;bottom:10px;background:transparent 50%;background-size:cover}.playground-container .playground .sandbox .shadowboard{pointer-events:none;opacity:0;transition:opacity .375s}.playground-container .playground .sandbox .shadowboard.on{opacity:.25}.playground-container .has--playground-actions{padding-top:1rem}", ""]);

// exports


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Handles_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2d2e2f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Handles_vue__ = __webpack_require__(367);
function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Handles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2d2e2f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Handles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(361);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("3df28c33", content, true, {});

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".handles{position:absolute;top:0;left:0;right:0;bottom:0}.handles .delete-point,.handles .handle{position:absolute;width:20px;height:20px}.handles .handle{border-radius:50%;box-shadow:inset 0 0 0 10px;opacity:.8;transition:opacity .25s}.handles .handle.is-dragging,.handles .handle.is-pointer-down{z-index:100;box-shadow:inset 0 0 0 3px;cursor:none;transition:box-shadow 0s}.handles .handle.draggable{cursor:grab}.handles .handle.show-delete .delete-point{transform:scale3d(.9,.9,.9);transition:transform .25s cubic-bezier(.15,1,.3,1.1),opacity .25s;opacity:1}.handles .handle:after{display:block;content:\"\";position:absolute;top:-8px;left:-8px;right:-8px;bottom:-8px}.handles .handle .delete-point{position:absolute;left:22px;top:0;width:25px;padding-left:5px;border-radius:3px;background:#d3d0c9;transform:scale3d(0,0,0);transform-origin:left center;cursor:pointer;opacity:.75;clip-path:polygon(25% 0,100% 1%,100% 100%,25% 100%,0 50%);transition:transform .25s,opacity .25s}.handles .handle .delete-point:after{display:block;content:\"\";position:absolute;top:4px;left:9px;right:4px;bottom:4px;background:#100a09;clip-path:polygon(20% 10%,10% 20%,40% 50%,10% 80%,20% 90%,50% 60%,80% 90%,90% 80%,60% 50%,90% 20%,80% 10%,50% 40%)}.playground:hover .handle{opacity:1}", ""]);

// exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Draggabilly v2.2.0
 * Make that shiz draggable
 * https://draggabilly.desandro.com
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(363),
        __webpack_require__(364)
      ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( getSize, Unidragger ) {
        return factory( window, getSize, Unidragger );
      }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('get-size'),
      require('unidragger')
    );
  } else {
    // browser global
    window.Draggabilly = factory(
      window,
      window.getSize,
      window.Unidragger
    );
  }

}( window, function factory( window, getSize, Unidragger ) {

'use strict';

// -------------------------- helpers & variables -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

function noop() {}

var jQuery = window.jQuery;

// --------------------------  -------------------------- //

function Draggabilly( element, options ) {
  // querySelector if string
  this.element = typeof element == 'string' ?
    document.querySelector( element ) : element;

  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = extend( {}, this.constructor.defaults );
  this.option( options );

  this._create();
}

// inherit Unidragger methods
var proto = Draggabilly.prototype = Object.create( Unidragger.prototype );

Draggabilly.defaults = {
};

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  extend( this.options, opts );
};

// css position values that don't need to be set
var positionValues = {
  relative: true,
  absolute: true,
  fixed: true
};

proto._create = function() {
  // properties
  this.position = {};
  this._getPosition();

  this.startPoint = { x: 0, y: 0 };
  this.dragPoint = { x: 0, y: 0 };

  this.startPosition = extend( {}, this.position );

  // set relative positioning
  var style = getComputedStyle( this.element );
  if ( !positionValues[ style.position ] ) {
    this.element.style.position = 'relative';
  }

  // events, bridge jQuery events from vanilla
  this.on( 'pointerDown', this.onPointerDown );
  this.on( 'pointerMove', this.onPointerMove );
  this.on( 'pointerUp', this.onPointerUp );

  this.enable();
  this.setHandles();
};

/**
 * set this.handles and bind start events to 'em
 */
proto.setHandles = function() {
  this.handles = this.options.handle ?
    this.element.querySelectorAll( this.options.handle ) : [ this.element ];

  this.bindHandles();
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = [ event ].concat( args );
  this.emitEvent( type, emitArgs );
  this.dispatchJQueryEvent( type, event, args );
};

proto.dispatchJQueryEvent = function( type, event, args ) {
  var jQuery = window.jQuery;
  // trigger jQuery event
  if ( !jQuery || !this.$element ) {
    return;
  }
  // create jQuery event
  var $event = jQuery.Event( event );
  $event.type = type;
  this.$element.trigger( $event, args );
};

// -------------------------- position -------------------------- //

// get x/y position from style
proto._getPosition = function() {
  var style = getComputedStyle( this.element );
  var x = this._getPositionCoord( style.left, 'width' );
  var y = this._getPositionCoord( style.top, 'height' );
  // clean up 'auto' or other non-integer values
  this.position.x = isNaN( x ) ? 0 : x;
  this.position.y = isNaN( y ) ? 0 : y;

  this._addTransformPosition( style );
};

proto._getPositionCoord = function( styleSide, measure ) {
  if ( styleSide.indexOf('%') != -1 ) {
    // convert percent into pixel for Safari, #75
    var parentSize = getSize( this.element.parentNode );
    // prevent not-in-DOM element throwing bug, #131
    return !parentSize ? 0 :
      ( parseFloat( styleSide ) / 100 ) * parentSize[ measure ];
  }
  return parseInt( styleSide, 10 );
};

// add transform: translate( x, y ) to position
proto._addTransformPosition = function( style ) {
  var transform = style.transform;
  // bail out if value is 'none'
  if ( transform.indexOf('matrix') !== 0 ) {
    return;
  }
  // split matrix(1, 0, 0, 1, x, y)
  var matrixValues = transform.split(',');
  // translate X value is in 12th or 4th position
  var xIndex = transform.indexOf('matrix3d') === 0 ? 12 : 4;
  var translateX = parseInt( matrixValues[ xIndex ], 10 );
  // translate Y value is in 13th or 5th position
  var translateY = parseInt( matrixValues[ xIndex + 1 ], 10 );
  this.position.x += translateX;
  this.position.y += translateY;
};

// -------------------------- events -------------------------- //

proto.onPointerDown = function( event, pointer ) {
  this.element.classList.add('is-pointer-down');
  this.dispatchJQueryEvent( 'pointerDown', event, [ pointer ] );
};

/**
 * drag start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.dragStart = function( event, pointer ) {
  if ( !this.isEnabled ) {
    return;
  }
  this._getPosition();
  this.measureContainment();
  // position _when_ drag began
  this.startPosition.x = this.position.x;
  this.startPosition.y = this.position.y;
  // reset left/top style
  this.setLeftTop();

  this.dragPoint.x = 0;
  this.dragPoint.y = 0;

  this.element.classList.add('is-dragging');
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
  // start animation
  this.animate();
};

proto.measureContainment = function() {
  var container = this.getContainer();
  if ( !container ) {
    return;
  }

  var elemSize = getSize( this.element );
  var containerSize = getSize( container );
  var elemRect = this.element.getBoundingClientRect();
  var containerRect = container.getBoundingClientRect();

  var borderSizeX = containerSize.borderLeftWidth + containerSize.borderRightWidth;
  var borderSizeY = containerSize.borderTopWidth + containerSize.borderBottomWidth;

  var position = this.relativeStartPosition = {
    x: elemRect.left - ( containerRect.left + containerSize.borderLeftWidth ),
    y: elemRect.top - ( containerRect.top + containerSize.borderTopWidth )
  };

  this.containSize = {
    width: ( containerSize.width - borderSizeX ) - position.x - elemSize.width,
    height: ( containerSize.height - borderSizeY ) - position.y - elemSize.height
  };
};

proto.getContainer = function() {
  var containment = this.options.containment;
  if ( !containment ) {
    return;
  }
  var isElement = containment instanceof HTMLElement;
  // use as element
  if ( isElement ) {
    return containment;
  }
  // querySelector if string
  if ( typeof containment == 'string' ) {
    return document.querySelector( containment );
  }
  // fallback to parent element
  return this.element.parentNode;
};

// ----- move event ----- //

proto.onPointerMove = function( event, pointer, moveVector ) {
  this.dispatchJQueryEvent( 'pointerMove', event, [ pointer, moveVector ] );
};

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.dragMove = function( event, pointer, moveVector ) {
  if ( !this.isEnabled ) {
    return;
  }
  var dragX = moveVector.x;
  var dragY = moveVector.y;

  var grid = this.options.grid;
  var gridX = grid && grid[0];
  var gridY = grid && grid[1];

  dragX = applyGrid( dragX, gridX );
  dragY = applyGrid( dragY, gridY );

  dragX = this.containDrag( 'x', dragX, gridX );
  dragY = this.containDrag( 'y', dragY, gridY );

  // constrain to axis
  dragX = this.options.axis == 'y' ? 0 : dragX;
  dragY = this.options.axis == 'x' ? 0 : dragY;

  this.position.x = this.startPosition.x + dragX;
  this.position.y = this.startPosition.y + dragY;
  // set dragPoint properties
  this.dragPoint.x = dragX;
  this.dragPoint.y = dragY;

  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

function applyGrid( value, grid, method ) {
  method = method || 'round';
  return grid ? Math[ method ]( value / grid ) * grid : value;
}

proto.containDrag = function( axis, drag, grid ) {
  if ( !this.options.containment ) {
    return drag;
  }
  var measure = axis == 'x' ? 'width' : 'height';

  var rel = this.relativeStartPosition[ axis ];
  var min = applyGrid( -rel, grid, 'ceil' );
  var max = this.containSize[ measure ];
  max = applyGrid( max, grid, 'floor' );
  return  Math.max( min, Math.min( max, drag ) );
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.onPointerUp = function( event, pointer ) {
  this.element.classList.remove('is-pointer-down');
  this.dispatchJQueryEvent( 'pointerUp', event, [ pointer ] );
};

/**
 * drag end
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.dragEnd = function( event, pointer ) {
  if ( !this.isEnabled ) {
    return;
  }
  // use top left position when complete
  this.element.style.transform = '';
  this.setLeftTop();
  this.element.classList.remove('is-dragging');
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

// -------------------------- animation -------------------------- //

proto.animate = function() {
  // only render and animate if dragging
  if ( !this.isDragging ) {
    return;
  }

  this.positionDrag();

  var _this = this;
  requestAnimationFrame( function animateFrame() {
    _this.animate();
  });

};

// left/top positioning
proto.setLeftTop = function() {
  this.element.style.left = this.position.x + 'px';
  this.element.style.top  = this.position.y + 'px';
};

proto.positionDrag = function() {
  this.element.style.transform = 'translate3d( ' + this.dragPoint.x +
    'px, ' + this.dragPoint.y + 'px, 0)';
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  this.dispatchEvent( 'staticClick', event, [ pointer ] );
};

// ----- methods ----- //

/**
 * @param {Number} x
 * @param {Number} y
 */
proto.setPosition = function( x, y ) {
  this.position.x = x;
  this.position.y = y;
  this.setLeftTop();
};

proto.enable = function() {
  this.isEnabled = true;
};

proto.disable = function() {
  this.isEnabled = false;
  if ( this.isDragging ) {
    this.dragEnd();
  }
};

proto.destroy = function() {
  this.disable();
  // reset styles
  this.element.style.transform = '';
  this.element.style.left = '';
  this.element.style.top = '';
  this.element.style.position = '';
  // unbind handles
  this.unbindHandles();
  // remove jQuery data
  if ( this.$element ) {
    this.$element.removeData('draggabilly');
  }
};

// ----- jQuery bridget ----- //

// required for jQuery bridget
proto._init = noop;

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'draggabilly', Draggabilly );
}

// -----  ----- //

return Draggabilly;

}));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unidragger v2.3.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(365)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Unipointer ) {
      return factory( window, Unipointer );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd
 */
proto._bindHandles = function( isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  // bind each handle
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
  var touchAction = isAdd ? this._touchActionValue : '';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isAdd );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
    if ( window.PointerEvent ) {
      handle.style.touchAction = touchAction;
    }
  }
};

// prototype so it can be overwriteable by Flickity
proto._touchActionValue = 'none';

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }
  // track start event position
  this.pointerDownPointer = pointer;

  event.preventDefault();
  this.pointerDownBlur();
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  SELECT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

// dismiss inputs with text fields. flickity#403, flickity#404
proto.okayPointerDown = function( event ) {
  var isCursorNode = cursorNodes[ event.target.nodeName ];
  var isClickType = clickTypes[ event.target.type ];
  var isOkay = !isCursorNode || isClickType;
  if ( !isOkay ) {
    this._pointerReset();
  }
  return isOkay;
};

// kludge to blur previously focused input
proto.pointerDownBlur = function() {
  var focused = document.activeElement;
  // do not blur body for IE10, metafizzy/flickity#117
  var canBlur = focused && focused.blur && focused != document.body;
  if ( canBlur ) {
    focused.blur();
  }
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var moveVector = {
    x: pointer.pageX - this.pointerDownPointer.pageX,
    y: pointer.pageY - this.pointerDownPointer.pageY
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  // prevent clicks
  this.isPreventingClicks = true;
  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(366)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
      return factory( window, EvEmitter );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {

'use strict';

function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */
proto._bindStartEvent = function( elem, isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

  // default to mouse events
  var startEvent = 'mousedown';
  if ( window.PointerEvent ) {
    // Pointer Events
    startEvent = 'pointerdown';
  } else if ( 'ontouchstart' in window ) {
    // Touch Events. iOS Safari
    startEvent = 'touchstart';
  }
  elem[ bindMethod ]( startEvent, this );
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss right click and other pointers
  // button = 0 is okay, 1-4 not
  if ( event.button || this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  this._pointerReset();
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto._pointerReset = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handles"},_vm._l((_vm.coords),function(coord,i){return _c('div',{staticClass:"handle",attrs:{"data-handle":i}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playground-container",attrs:{"id":"playground_container"}},[_c('section',{staticClass:"playground"},[_c('div',{staticClass:"sandbox",style:({ width: _vm.options.width + 20 + 'px', height: _vm.options.height + 20 + 'px' })},[_c('div',{staticClass:"shadowboard",class:{'on': _vm.options.shadowBoard},style:(_vm.background)}),_vm._v(" "),_c('svg',{staticClass:"clipboard",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","overflow":"visible","xml:space":"preserve","width":_vm.options.width,"height":_vm.options.height,"viewBox":'0 0 ' + _vm.options.width + ' ' + _vm.options.height,"enable-background":'new 0 0 ' + _vm.options.width + ' ' + _vm.options.height}},[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('polygon',{attrs:{"id":"polygon","points":_vm.clipPoints}})]),_vm._v(" "),_c('g',{attrs:{"clip-path":"url(#clip-path)"}},[_c('image',{attrs:{"width":_vm.options.width,"height":_vm.options.height,"xlink:href":_vm.images[_vm.selectedImage].source}})])]),_vm._v(" "),_c('handles',{attrs:{"shape":_vm.shape,"coords":_vm.coords,"options":_vm.options},on:{"updateHandle":_vm.updateHandle}})],1)]),_vm._v(" "),_vm._t("bottom")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offcanvas_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063c7ccf_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offcanvas_vue__ = __webpack_require__(372);
function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-063c7ccf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offcanvas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063c7ccf_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offcanvas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(371);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("877d7c2e", content, true, {});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".btn--plain[data-v-063c7ccf]{background:none;border:none;border-radius:0;font-size:20px}.btn--plain[data-v-063c7ccf]:focus{outline:none}.btn.is--third[data-v-063c7ccf]{padding:2px 12px;line-height:34px}.btn.is--third.is--small[data-v-063c7ccf]{line-height:30px}.btn.is--third.is--large[data-v-063c7ccf]{line-height:38px}.btn--plain.has--extra-space[data-v-063c7ccf],.btn.has--extra-space[data-v-063c7ccf]{width:40px;height:40px}.btn--plain.has--extra-space-left[data-v-063c7ccf],.btn.has--extra-space-left[data-v-063c7ccf]{text-align:left}.btn--plain.has--extra-space-right[data-v-063c7ccf],.btn.has--extra-space-right[data-v-063c7ccf]{text-align:right}.btn--plain.is--primary-icon[data-v-063c7ccf],.btn--plain i.icon--trash[data-v-063c7ccf],.btn.is--primary-icon[data-v-063c7ccf],.btn i.icon--trash[data-v-063c7ccf]{color:#009fe3}.btn--plain.button-guide i[data-v-063c7ccf],.btn.button-guide i[data-v-063c7ccf]{color:#009600}.offcanvas-container .buttons--off-canvas[data-v-063c7ccf]{display:block;position:fixed;top:200px;z-index:200;-webkit-transition:all .45s cubic-bezier(.3,0,.15,1);transition:all .45s cubic-bezier(.3,0,.15,1)}.offcanvas-container .buttons--off-canvas.is--open-btn[data-v-063c7ccf]{right:17.4rem}.offcanvas-container .buttons--off-canvas.is--collapsed-btn[data-v-063c7ccf]{right:-3px}.offcanvas-container .container--ajax-cart[data-v-063c7ccf]{-webkit-box-shadow:-1px 0 1px 1px rgba(0,0,0,.1);-moz-box-shadow:-1px 0 1px 1px rgba(0,0,0,.1);box-shadow:-1px 0 1px 1px rgba(0,0,0,.1)}.offcanvas-container ul li[data-v-063c7ccf]{margin:10px 20px 20px;width:auto;text-align:center;border-bottom:1px solid #dadae5;padding-bottom:10px}.offcanvas-container ul li a[data-v-063c7ccf]{display:flex;width:100%;justify-content:center;margin-bottom:10px}.offcanvas-container ul li.title--off-canvas[data-v-063c7ccf]{border:none;margin:0;padding:2px 10px 0;line-height:38px;display:block;background:#3e3e3e;color:#fff;font-weight:600;text-align:left}.offcanvas-container ul li.title--off-canvas a[data-v-063c7ccf]{display:inline-block;text-align:left}", ""]);

// exports


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offcanvas-container"},[_c('div',{staticClass:"buttons--off-canvas",class:{ 'is--open-btn': _vm.open, 'is--collapsed-btn': ! _vm.open }},[(_vm.open)?_c('a',{staticClass:"btn is--center is--small close--off-canvas",attrs:{"href":"#close-extraxtor-menu"},on:{"click":function($event){$event.preventDefault();return _vm.closeOffcanvasMenu($event)}}},[_c('i',{staticClass:"icon--arrow-left"})]):_c('a',{staticClass:"btn is--center is--small open--off-canvas",attrs:{"href":"#open-extraxtor-menu"},on:{"click":_vm.openOffcanvasMenu}},[_c('i',{staticClass:"icon--arrow-right"})])]),_vm._v(" "),_c('div',{staticClass:"container--ajax-cart off-canvas is--right is--active",class:{ 'is--open': _vm.open, 'is--collapsed': ! _vm.open }},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel is--extractor",style:({ overflow: _vm.overflow })},[_c('div',{ref:"wrapping-container",staticClass:"is--playground-image"},[(_vm.showPlayground)?_c('playground',{attrs:{"viewport":_vm.viewport,"coords":_vm.config.coords,"options":_vm.options,"shape":_vm.shapes[_vm.selectedIndex],"images":_vm.config.images,"selectedImage":_vm.selectedImage},on:{"updateHandle":_vm.updateHandle}},[_c('template',{slot:"bottom"},[_c('div',{staticClass:"has--playground-actions"},[(_vm.config.editInPlace)?_c('button',{class:[ { 'is--loading': _vm.isLoadingActive }, 'btn', 'is--primary', 'is--center' ],attrs:{"disabled":_vm.isLoadingActive},on:{"click":_vm.addExtractionAndClose}},[(0 === this.config.images[this.selectedImage].completeTimestamp)?[_vm._v(_vm._s(_vm.$t('extractor.fileInProgress')))]:[_vm._v(_vm._s(_vm.$t('extractor.modifyExtraction')))]],2):_vm._e(),_vm._v(" "),(! _vm.config.editInPlace)?[((_vm.selectedImage + 1) < _vm.config.images.length)?_c('button',{class:[ { 'is--loading': _vm.isLoadingActive }, 'btn', 'is--third', 'is--center', 'is--small' ],attrs:{"disabled":_vm.isLoadingActive},on:{"click":_vm.addExtractionAndNext}},[(0 === this.config.images[this.selectedImage].completeTimestamp)?[_vm._v(_vm._s(_vm.$t('extractor.fileInProgress')))]:[_vm._v(_vm._s(_vm.$t('extractor.addExtractionAndNext')))]],2):_vm._e(),_vm._v(" "),((_vm.selectedImage + 1) === _vm.config.images.length)?_c('button',{class:[ { 'is--loading': _vm.isLoadingActive }, 'btn', 'is--primary', 'is--center' ],attrs:{"disabled":_vm.isLoadingActive},on:{"click":_vm.addExtractionAndClose}},[(0 === this.config.images[this.selectedImage].completeTimestamp)?[_vm._v(_vm._s(_vm.$t('extractor.fileInProgress')))]:[_vm._v(_vm._s(_vm.$t('extractor.addExtractionAndClose')))]],2):_vm._e()]:_vm._e()],2)])],2):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d1f0872_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d1f0872"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d1f0872_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(376);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("6657eeab", content, true, {});

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".btn--plain[data-v-7d1f0872]{background:none;border:none;border-radius:0;font-size:20px}.btn--plain[data-v-7d1f0872]:focus{outline:none}.btn.is--third[data-v-7d1f0872]{padding:2px 12px;line-height:34px}.btn.is--third.is--small[data-v-7d1f0872]{line-height:30px}.btn.is--third.is--large[data-v-7d1f0872]{line-height:38px}.btn--plain.has--extra-space[data-v-7d1f0872],.btn.has--extra-space[data-v-7d1f0872]{width:40px;height:40px}.btn--plain.has--extra-space-left[data-v-7d1f0872],.btn.has--extra-space-left[data-v-7d1f0872]{text-align:left}.btn--plain.has--extra-space-right[data-v-7d1f0872],.btn.has--extra-space-right[data-v-7d1f0872]{text-align:right}.btn--plain.is--primary-icon[data-v-7d1f0872],.btn--plain i.icon--trash[data-v-7d1f0872],.btn.is--primary-icon[data-v-7d1f0872],.btn i.icon--trash[data-v-7d1f0872]{color:#009fe3}.btn--plain.button-guide i[data-v-7d1f0872],.btn.button-guide i[data-v-7d1f0872]{color:#009600}.is--editor button.is--uploader[data-v-7d1f0872]{position:absolute;bottom:20px;left:0;right:0;margin:auto;width:100px;padding:0;border:0;background:none;color:#009fe3;display:flex;flex-direction:column;align-items:center}.is--editor button.is--uploader i[data-v-7d1f0872]{font-size:80px;margin-bottom:10px}.is--editor button.is--uploader span[data-v-7d1f0872]{font-size:16px;font-weight:700}@media screen and (min-width:48em){.is--editor button.is--uploader[data-v-7d1f0872]{bottom:50px}}.has--guide-info[data-v-7d1f0872]{font-size:1.3rem;text-align:center;margin-bottom:50px}.actions[data-v-7d1f0872],.info[data-v-7d1f0872]{display:none;color:#009fe3}.active .actions[data-v-7d1f0872],.active .info[data-v-7d1f0872]{display:block}.actions.left[data-v-7d1f0872]{left:-26px}.actions.right[data-v-7d1f0872]{right:0}.actions.right button[data-v-7d1f0872]{margin-left:5px}.h-rule[data-v-7d1f0872]{position:absolute;width:100%;height:1px;bottom:0;left:0;right:0;border:1px dashed #96e0ff;border-bottom:none;margin:auto}.h-rule span.label[data-v-7d1f0872]{position:absolute;top:-20px;right:-12px;background-color:#fff;color:#009fe3;padding:0 6px}.is--groove-btn[data-v-7d1f0872]{position:relative}.is--groove-btn span[data-v-7d1f0872]{position:absolute;top:-7px;right:-10px;width:20px;height:20px;display:inline-block;text-align:center;font-size:12px;line-height:18px;border:1px solid #009fe3;border-radius:10px;padding:0 6px;color:#009fe3;background:#fff}.is--upload[data-v-7d1f0872]{background:none;border:none;border-radius:0;font-size:20px;font-size:26px;color:#d3d0c9;margin:0 0 30px}.is--upload[data-v-7d1f0872]:focus{background:none;border:none}.footer[data-v-7d1f0872]{position:relative;height:62px;margin:auto}.footer.is--none[data-v-7d1f0872]{background:none;display:none}.footer.is--nut-tree[data-v-7d1f0872]{background:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot.png\") no-repeat 50%;width:100%;background-size:100% 62px}.footer.is--white[data-v-7d1f0872]{width:100%;background-repeat:no-repeat;background-size:contain}.footer.is--white.size-100[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/white/foot-front/100.png\");background-size:200px 40px}.footer.is--white.size-150[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/white/foot-front/150.png\");background-size:300px 40px}.footer.is--white.size-200[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/white/foot-front/200.png\");background-size:400px 40px}.footer.is--white.size-250[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/white/foot-front/250.png\");background-size:500px 40px}.footer.is--white.size-300[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/white/foot-front/300.png\");background-size:600px 40px}.footer .sockel--wrapper[data-v-7d1f0872]{position:absolute;bottom:-2px}@media screen and (min-width:48em){.footer .sockel--wrapper[data-v-7d1f0872]{bottom:-5px}}.footer .sockel[data-v-7d1f0872]{position:relative;margin:0 auto;background-size:contain}.footer .sockel.is--nut-tree.nut-1[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/nut-tree/grooves-1_middle.png\")}.footer .sockel.is--nut-tree.nut-2[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/nut-tree/grooves-2_middle.png\")}.footer .sockel.is--white.nut-1[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/white/grooves-1_middle.png\")}.footer .sockel.is--white.nut-2[data-v-7d1f0872]{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/white/grooves-2_middle.png\")}.footer .imgHolder[data-v-7d1f0872]{position:absolute;top:0;bottom:0;width:100%}.footer .imgHolder img[data-v-7d1f0872]{width:auto;height:100%;display:inline-block}.footer .imgHolder.cornerLeft[data-v-7d1f0872]{left:0}.footer .imgHolder.cornerRight[data-v-7d1f0872]{right:0;text-align:right}.base--footer[data-v-7d1f0872]{position:absolute;bottom:0;opacity:.2;left:0;right:0;background-size:100% 62px;margin:auto;z-index:1;border:1px solid #000;border-left:none;border-right:none}.base--footer.is--none[data-v-7d1f0872]{position:relative}.preloading-images-indicator[data-v-7d1f0872]{display:flex;justify-content:center;align-items:center;position:absolute;left:0;right:0;bottom:0;top:0}.preloading-images-indicator img[data-v-7d1f0872]{width:120px;height:120px}.base--footer .is--width-indicator[data-v-7d1f0872]{position:absolute;height:100%;left:0;right:0;margin:0 auto;border-left:1px dashed #000;border-right:1px dashed #000}.base--footer .is--width-indicator .is--label[data-v-7d1f0872]{position:absolute;bottom:5px;right:5px;font-size:smaller;font-weight:600}.footer .is--label[data-v-7d1f0872]{position:absolute;bottom:5px;right:8px;font-size:smaller;font-weight:600;color:#fff}.footer.is--white .is--label[data-v-7d1f0872]{color:#6b6b6b}", ""]);

// exports


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraggableResizeable_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6aaf5776"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraggableResizeable_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(379);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("a8736146", content, true, {});

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".vdr[data-v-6aaf5776]{position:absolute;box-sizing:border-box;background-size:cover;opacity:.2}.vdr.active[data-v-6aaf5776]{opacity:1;border:1px solid #009fe3}.vdr.active .actions[data-v-6aaf5776]{position:absolute;top:-26px}.vdr.active .info[data-v-6aaf5776]{text-transform:uppercase;font-weight:700;color:#fff;font-size:18px;display:inline-block}.vdr.active .info li[data-v-6aaf5776]{background-color:#009fe3;text-align:center;margin-bottom:1px;padding:0 3px 3px 2px}.vdr.draggable[data-v-6aaf5776]{cursor:-webkit-grab}.vdr .is--indicator[data-v-6aaf5776]{width:20px;height:20px;border-radius:10px;font-size:12px;line-height:18px;font-weight:700;border:1px solid #fff;display:inline-block}.handle[data-v-6aaf5776]{box-sizing:border-box;display:none;position:absolute;width:10px;height:10px;font-size:1px;background:#eee;border:1px solid #333}.handle-tm[data-v-6aaf5776]{top:-42px;right:0;left:0;margin:auto;cursor:n-resize;width:60px;height:60px;text-align:center;background:none;border:none}.handle-tm[data-v-6aaf5776]:after{content:\"\\E90F\";font-family:Plexipeople;display:inline-block;width:40px;height:40px;font-size:35px;color:#009fe3;text-align:center}@media only screen and (max-width:768px){[class*=handle-][data-v-6aaf5776]:before{content:\"\";left:-10px;right:-10px;bottom:-10px;top:-10px;position:absolute}}", ""]);

// exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueDraggableResizable=e():t.VueDraggableResizable=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=40)}([function(t,e,n){var r=n(35)("wks"),i=n(22),o=n(1).Symbol,s="function"==typeof o;(t.exports=function(t){return r[t]||(r[t]=s&&o[t]||(s?o:i)("Symbol."+t))}).store=r},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){t.exports=!n(12)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(5),i=n(33);t.exports=n(2)?function(t,e,n){return r.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var r=n(6),i=n(55),o=n(70),s=Object.defineProperty;e.f=n(2)?Object.defineProperty:function(t,e,n){if(r(t),e=o(e,!0),r(n),i)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(4);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(23);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,i){return t.call(e,n,r,i)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(1),i=n(7),o=n(8),s=n(3),u=n(10),a=function(t,e,n){var c,f,l,h=t&a.F,p=t&a.G,d=t&a.S,m=t&a.P,v=t&a.B,g=t&a.W,y=p?i:i[e]||(i[e]={}),x=y.prototype,b=p?r:d?r[e]:(r[e]||{}).prototype;p&&(n=e);for(c in n)(f=!h&&b&&void 0!==b[c])&&u(y,c)||(l=f?b[c]:n[c],y[c]=p&&"function"!=typeof b[c]?n[c]:v&&f?o(l,r):g&&b[c]==l?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(l):m&&"function"==typeof l?o(Function.call,l):l,m&&((y.virtual||(y.virtual={}))[c]=l,t&a.R&&x&&!x[c]&&s(x,c,l)))};a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(8),i=n(58),o=n(56),s=n(6),u=n(21),a=n(71),c={},f={},e=t.exports=function(t,e,n,l,h){var p,d,m,v,g=h?function(){return t}:a(t),y=r(n,l,e?2:1),x=0;if("function"!=typeof g)throw TypeError(t+" is not iterable!");if(o(g)){for(p=u(t.length);p>x;x++)if((v=e?y(s(d=t[x])[0],d[1]):y(t[x]))===c||v===f)return v}else for(m=g.call(t);!(d=m.next()).done;)if((v=i(m,y,d.value,e))===c||v===f)return v};e.BREAK=c,e.RETURN=f},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var r=n(30),i=n(9),o=n(64),s=n(3),u=n(11),a=n(59),c=n(17),f=n(61),l=n(0)("iterator"),h=!([].keys&&"next"in[].keys()),p=function(){return this};t.exports=function(t,e,n,d,m,v,g){a(n,e,d);var y,x,b,w=function(t){if(!h&&t in S)return S[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},_=e+" Iterator",O="values"==m,E=!1,S=t.prototype,M=S[l]||S["@@iterator"]||m&&S[m],Y=M||w(m),X=m?O?w("entries"):Y:void 0,z="Array"==e?S.entries||M:M;if(z&&(b=f(z.call(new t)))!==Object.prototype&&b.next&&(c(b,_,!0),r||"function"==typeof b[l]||s(b,l,p)),O&&M&&"values"!==M.name&&(E=!0,Y=function(){return M.call(this)}),r&&!g||!h&&!E&&S[l]||s(S,l,Y),u[e]=Y,u[_]=p,m)if(y={values:O?Y:w("values"),keys:v?Y:w("keys"),entries:X},g)for(x in y)x in S||o(S,x,y[x]);else i(i.P+i.F*(h||E),e,y);return y}},function(t,e,n){var r=n(5).f,i=n(10),o=n(0)("toStringTag");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,o)&&r(t,o,{configurable:!0,value:e})}},function(t,e,n){var r=n(35)("keys"),i=n(22);t.exports=function(t){return r[t]||(r[t]=i(t))}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(28),i=n(15);t.exports=function(t){return r(i(t))}},function(t,e,n){var r=n(19),i=Math.min;t.exports=function(t){return t>0?i(r(t),9007199254740991):0}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var r=n(14),i=n(0)("toStringTag"),o="Arguments"==r(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),i))?n:o?r(e):"Object"==(u=r(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){var r=n(4),i=n(1).document,o=r(i)&&r(i.createElement);t.exports=function(t){return o?i.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var r=n(14);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e){t.exports=!0},function(t,e,n){var r=n(22)("meta"),i=n(4),o=n(10),s=n(5).f,u=0,a=Object.isExtensible||function(){return!0},c=!n(12)(function(){return a(Object.preventExtensions({}))}),f=function(t){s(t,r,{value:{i:"O"+ ++u,w:{}}})},l=function(t,e){if(!i(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!o(t,r)){if(!a(t))return"F";if(!e)return"E";f(t)}return t[r].i},h=function(t,e){if(!o(t,r)){if(!a(t))return!0;if(!e)return!1;f(t)}return t[r].w},p=function(t){return c&&d.NEED&&a(t)&&!o(t,r)&&f(t),t},d=t.exports={KEY:r,NEED:!1,fastKey:l,getWeak:h,onFreeze:p}},function(t,e,n){var r=n(6),i=n(60),o=n(27),s=n(18)("IE_PROTO"),u=function(){},a=function(){var t,e=n(26)("iframe"),r=o.length;for(e.style.display="none",n(54).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;r--;)delete a.prototype[o[r]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=r(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:i(n,e)}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var r=n(3);t.exports=function(t,e,n){for(var i in e)n&&t[i]?t[i]=e[i]:r(t,i,e[i]);return t}},function(t,e,n){var r=n(7),i=n(1),o=i["__core-js_shared__"]||(i["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(30)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var r=n(15);t.exports=function(t){return Object(r(t))}},function(t,e,n){var r=n(4);t.exports=function(t,e){if(!r(t)||t._t!==e)throw TypeError("Incompatible receiver, "+e+" required!");return t}},function(t,e,n){n(84);var r=n(82)(n(39),n(83),"data-v-1e95fd0f",null);r.options.__file="/home/jmatthiesen/Workspace/vue-components/vue-draggable-resizable/src/components/vue-draggable-resizable.vue",r.esModule&&Object.keys(r.esModule).some(function(t){return"default"!==t&&"__esModule"!==t})&&console.error("named exports are not supported in *.vue files."),r.options.functional&&console.error("[vue-loader] vue-draggable-resizable.vue: functional components are not supported with templates, they should use render functions."),t.exports=r.exports},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(43),i=n.n(r),o=n(41);e.default={replace:!0,name:"VueDraggableResizable",props:{active:{type:Boolean,default:!1},draggable:{type:Boolean,default:!0},resizable:{type:Boolean,default:!0},w:{type:Number,default:200,validator:function(t){return t>0}},h:{type:Number,default:200,validator:function(t){return t>0}},minw:{type:Number,default:50,validator:function(t){return t>=0}},minh:{type:Number,default:50,validator:function(t){return t>=0}},x:{type:Number,default:0,validator:function(t){return"number"==typeof t}},y:{type:Number,default:0,validator:function(t){return"number"==typeof t}},z:{type:[String,Number],default:"auto",validator:function(t){return"string"==typeof t?"auto"===t:t>=0}},aspect:{type:Boolean,default:!1},handles:{type:Array,default:function(){return["tl","tm","tr","mr","br","bm","bl","ml"]},validator:function(t){var e=new i.a(["tl","tm","tr","mr","br","bm","bl","ml"]);return new i.a(t.filter(function(t){return e.has(t)})).size===t.length}},dragHandle:{type:String,default:null},dragCancel:{type:String,default:null},axis:{type:String,default:"both",validator:function(t){return-1!==["x","xb","xt","y","yl","yr","both"].indexOf(t)}},grid:{type:Array,default:function(){return[1,1]}},parent:{type:Boolean,default:!1},maximize:{type:Boolean,default:!1}},created:function(){this.parentX=0,this.parentW=9999,this.parentY=0,this.parentH=9999,this.mouseX=0,this.mouseY=0,this.lastMouseX=0,this.lastMouseY=0,this.mouseOffX=0,this.mouseOffY=0,this.elmX=0,this.elmY=0,this.elmW=0,this.elmH=0},mounted:function(){document.documentElement.addEventListener("mousemove",this.handleMove,!0),document.documentElement.addEventListener("mousedown",this.deselect,!0),document.documentElement.addEventListener("mouseup",this.handleUp,!0),document.documentElement.addEventListener("touchmove",this.handleMove,!0),document.documentElement.addEventListener("touchend touchcancel",this.deselect,!0),document.documentElement.addEventListener("touchstart",this.handleUp,!0),this.elmX=parseInt(this.$el.style.left),this.elmY=parseInt(this.$el.style.top),this.elmW=this.$el.offsetWidth||this.$el.clientWidth,this.elmH=this.$el.offsetHeight||this.$el.clientHeight,this.reviewDimensions()},beforeDestroy:function(){document.documentElement.removeEventListener("mousemove",this.handleMove,!0),document.documentElement.removeEventListener("mousedown",this.deselect,!0),document.documentElement.removeEventListener("mouseup",this.handleUp,!0),document.documentElement.addEventListener("touchmove",this.handleMove,!0),document.documentElement.addEventListener("touchend touchcancel",this.deselect,!0),document.documentElement.addEventListener("touchstart",this.handleUp,!0)},data:function(){return{top:this.y,left:this.x,width:this.w,height:this.h,aspectRatio:this.w/this.h,resizing:!1,dragging:!1,enabled:this.active,handle:null,zIndex:this.z}},methods:{reviewDimensions:function(){if(this.minw>this.w&&(this.width=this.minw),this.minh>this.h&&(this.height=this.minh),this.parent){var t=parseInt(this.$el.parentNode.clientWidth,10),e=parseInt(this.$el.parentNode.clientHeight,10);this.parentW=t,this.parentH=e,this.w>this.parentW&&(this.width=t),this.h>this.parentH&&(this.height=e),this.x+this.w>this.parentW&&(this.width=t-this.x),this.y+this.h>this.parentH&&(this.height=e-this.y)}this.elmW=this.width,this.elmH=this.height,this.$emit("resizing",this.left,this.top,this.width,this.height,this)},elmDown:function(t){var e=t.target||t.srcElement;if(this.$el.contains(e)){if(this.dragHandle&&!n.i(o.a)(e,this.dragHandle,this.$el)||this.dragCancel&&n.i(o.a)(e,this.dragCancel,this.$el))return;this.reviewDimensions(),this.enabled||(this.enabled=!0,this.$emit("activated",this),this.$emit("update:active",!0,this)),this.draggable&&(this.dragging=!0)}},deselect:function(t){-1!==t.type.indexOf("touch")?(this.mouseX=t.changedTouches[0].clientX,this.mouseY=t.changedTouches[0].clientY):(this.mouseX=t.pageX||t.clientX+document.documentElement.scrollLeft,this.mouseY=t.pageY||t.clientY+document.documentElement.scrollTop),this.lastMouseX=this.mouseX,this.lastMouseY=this.mouseY;var e=t.target||t.srcElement,n=new RegExp("handle-([trmbl]{2})","");this.$el.contains(e)||n.test(e.className)||this.enabled&&(this.enabled=!1,this.$emit("deactivated",this),this.$emit("update:active",!1,this))},handleDown:function(t,e){this.handle=t,e.stopPropagation&&e.stopPropagation(),e.preventDefault&&e.preventDefault(),this.resizing=!0},fillParent:function(t){var e=this;if(this.parent&&this.resizable&&this.maximize){var n=!1,r=function t(){n||window.requestAnimationFrame(t),e.axis.indexOf("x")>=0?e.width===e.parentW&&e.left===e.parentX&&(n=!0):e.axis.indexOf("y")>=0?e.height===e.parentH&&e.top===e.parentY&&(n=!0):"both"===e.axis&&e.width===e.parentW&&e.height===e.parentH&&e.top===e.parentY&&e.left===e.parentX&&(n=!0),(e.axis.indexOf("x")>=0||"both"===e.axis)&&(e.width<e.parentW&&(e.width++,e.elmW++),e.left>e.parentX&&(e.left--,e.elmX--)),(e.axis.indexOf("y")>=0||"both"===e.axis)&&(e.height<e.parentH&&(e.height++,e.elmH++),e.top>e.parentY&&(e.top--,e.elmY--)),e.$emit("resizing",e.left,e.top,e.width,e.height,e)};window.requestAnimationFrame(r)}},handleMove:function(t){var e=-1!==t.type.indexOf("touchmove");this.mouseX=e?t.touches[0].clientX:t.pageX||t.clientX+document.documentElement.scrollLeft,this.mouseY=e?t.touches[0].clientY:t.pageY||t.clientY+document.documentElement.scrollTop;var n=this.mouseX-this.lastMouseX+this.mouseOffX,r=this.mouseY-this.lastMouseY+this.mouseOffY;this.mouseOffX=this.mouseOffY=0,this.lastMouseX=this.mouseX,this.lastMouseY=this.mouseY;var i=n,o=r;if(this.resizing){var s=this,u=function(){s.elmH+o<s.minh?s.mouseOffY=o-(r=s.minh-s.elmH):s.parent&&s.elmY+s.elmH+o>s.parentH&&(s.mouseOffY=o-(r=s.parentH-s.elmY-s.elmH)),s.elmH+=r,s.aspect&&(s.elmW=s.elmH*s.aspectRatio)},a=function(){s.elmW+i<s.minw?s.mouseOffX=i-(n=s.minw-s.elmW):s.parent&&s.elmX+s.elmW+i>s.parentW&&(s.mouseOffX=i-(n=s.parentW-s.elmX-s.elmW)),s.elmW+=n,s.aspect&&(s.elmH=s.elmW/s.aspectRatio)};if(this.handle.indexOf("t")>=0&&(!function(){s.elmH-o<s.minh?s.mouseOffY=o-(r=s.elmH-s.minh):s.parent&&s.elmY+o<s.parentY&&(s.mouseOffY=o-(r=s.parentY-s.elmY)),s.elmY+=r,s.elmH-=r,s.aspect&&(s.elmW=s.elmH*s.aspectRatio)}(),a()),s.handle.indexOf("b")>=0&&(u(),a()),this.handle.indexOf("l")>=0&&(!function(){s.elmW-i<s.minw?s.mouseOffX=i-(n=s.elmW-s.minw):s.parent&&s.elmX+i<s.parentX&&(s.mouseOffX=i-(n=s.parentX-s.elmX)),s.elmX+=n,s.elmW-=n,s.aspect&&(s.elmH=s.elmW/s.aspectRatio)}(),u()),this.handle.indexOf("r")>=0&&(a(),u()),this.axis.indexOf("x")>=0){var c="t";this.axis.length>1&&(c=this.axis.substring(1,2)),"t"===c?this.elmY=this.y:"b"===c&&(this.elmY=Math.floor(this.y+this.h-this.elmH))}if(this.axis.indexOf("y")>=0){var f="l";this.axis.length>1&&(f=this.axis.substring(1,2)),"l"===f?this.elmX=this.x:"r"===f&&(this.elmX=Math.floor(this.x+this.w-this.elmW))}this.left=Math.round(this.elmX/this.grid[0])*this.grid[0],this.top=Math.round(this.elmY/this.grid[1])*this.grid[1],this.width=Math.round(this.elmW/this.grid[0])*this.grid[0],this.height=Math.round(this.elmH/this.grid[1])*this.grid[1],this.$emit("resizing",this.left,this.top,this.width,this.height,this)}else this.dragging&&(this.parent&&(this.elmX+i<this.parentX?this.mouseOffX=i-(n=this.parentX-this.elmX):this.elmX+this.elmW+i>this.parentW&&(this.mouseOffX=i-(n=this.parentW-this.elmX-this.elmW)),this.elmY+o<this.parentY?this.mouseOffY=o-(r=this.parentY-this.elmY):this.elmY+this.elmH+o>this.parentH&&(this.mouseOffY=o-(r=this.parentH-this.elmY-this.elmH))),this.elmX+=n,this.elmY+=r,(this.axis.indexOf("x")>=0||"both"===this.axis)&&(this.left=Math.round(this.elmX/this.grid[0])*this.grid[0]),(this.axis.indexOf("y")>=0||"both"===this.axis)&&(this.top=Math.round(this.elmY/this.grid[1])*this.grid[1]),this.$emit("dragging",this.left,this.top,this))},handleUp:function(t){-1!==t.type.indexOf("touch")&&(this.lastMouseX=t.changedTouches[0].clientX,this.lastMouseY=t.changedTouches[0].clientY),this.handle=null,this.resizing&&(this.resizing=!1,this.$emit("resizestop",this.left,this.top,this.width,this.height,this)),this.dragging&&(this.dragging=!1,this.$emit("dragstop",this.left,this.top,this)),this.elmX=this.left,this.elmY=this.top}},computed:{style:function(){return{top:this.top+"px",left:this.left+"px",width:this.width+"px",height:this.height+"px",zIndex:this.zIndex}}},watch:{active:function(t){this.enabled=t},z:function(t){(t>=0||"auto"===t)&&(this.zIndex=t)}}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(38),i=n.n(r);n.d(e,"default",function(){return i.a})},function(t,e,n){"use strict";function r(t,e,r){var o=t,s=["matches","webkitMatchesSelector","mozMatchesSelector","msMatchesSelector","oMatchesSelector"].find(function(t){return n.i(i.a)(o[t])});if(!n.i(i.a)(o[s]))return!1;do{if(o[s](e))return!0;if(o===r)return!1;o=o.parentNode}while(o);return!1}e.a=r;var i=n(42)},function(t,e,n){"use strict";function r(t){return"function"==typeof t||"[object Function]"===Object.prototype.toString.call(t)}e.a=r},function(t,e,n){t.exports={default:n(44),__esModule:!0}},function(t,e,n){n(73),n(75),n(79),n(74),n(78),n(77),n(76),t.exports=n(7).Set},function(t,e){t.exports=function(){}},function(t,e,n){var r=n(13);t.exports=function(t,e){var n=[];return r(t,!1,n.push,n,e),n}},function(t,e,n){var r=n(20),i=n(21),o=n(69);t.exports=function(t){return function(e,n,s){var u,a=r(e),c=i(a.length),f=o(s,c);if(t&&n!=n){for(;c>f;)if((u=a[f++])!=u)return!0}else for(;c>f;f++)if((t||f in a)&&a[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(8),i=n(28),o=n(36),s=n(21),u=n(50);t.exports=function(t,e){var n=1==t,a=2==t,c=3==t,f=4==t,l=6==t,h=5==t||l,p=e||u;return function(e,u,d){for(var m,v,g=o(e),y=i(g),x=r(u,d,3),b=s(y.length),w=0,_=n?p(e,b):a?p(e,0):void 0;b>w;w++)if((h||w in y)&&(m=y[w],v=x(m,w,g),t))if(n)_[w]=v;else if(v)switch(t){case 3:return!0;case 5:return m;case 6:return w;case 2:_.push(m)}else if(f)return!1;return l?-1:c||f?f:_}}},function(t,e,n){var r=n(4),i=n(57),o=n(0)("species");t.exports=function(t){var e;return i(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!i(e.prototype)||(e=void 0),r(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var r=n(49);t.exports=function(t,e){return new(r(t))(e)}},function(t,e,n){"use strict";var r=n(5).f,i=n(32),o=n(34),s=n(8),u=n(24),a=n(13),c=n(16),f=n(29),l=n(67),h=n(2),p=n(31).fastKey,d=n(37),m=h?"_s":"size",v=function(t,e){var n,r=p(e);if("F"!==r)return t._i[r];for(n=t._f;n;n=n.n)if(n.k==e)return n};t.exports={getConstructor:function(t,e,n,c){var f=t(function(t,r){u(t,f,e,"_i"),t._t=e,t._i=i(null),t._f=void 0,t._l=void 0,t[m]=0,void 0!=r&&a(r,n,t[c],t)});return o(f.prototype,{clear:function(){for(var t=d(this,e),n=t._i,r=t._f;r;r=r.n)r.r=!0,r.p&&(r.p=r.p.n=void 0),delete n[r.i];t._f=t._l=void 0,t[m]=0},delete:function(t){var n=d(this,e),r=v(n,t);if(r){var i=r.n,o=r.p;delete n._i[r.i],r.r=!0,o&&(o.n=i),i&&(i.p=o),n._f==r&&(n._f=i),n._l==r&&(n._l=o),n[m]--}return!!r},forEach:function(t){d(this,e);for(var n,r=s(t,arguments.length>1?arguments[1]:void 0,3);n=n?n.n:this._f;)for(r(n.v,n.k,this);n&&n.r;)n=n.p},has:function(t){return!!v(d(this,e),t)}}),h&&r(f.prototype,"size",{get:function(){return d(this,e)[m]}}),f},def:function(t,e,n){var r,i,o=v(t,e);return o?o.v=n:(t._l=o={i:i=p(e,!0),k:e,v:n,p:r=t._l,n:void 0,r:!1},t._f||(t._f=o),r&&(r.n=o),t[m]++,"F"!==i&&(t._i[i]=o)),t},getEntry:v,setStrong:function(t,e,n){c(t,e,function(t,n){this._t=d(t,e),this._k=n,this._l=void 0},function(){for(var t=this,e=t._k,n=t._l;n&&n.r;)n=n.p;return t._t&&(t._l=n=n?n.n:t._t._f)?"keys"==e?f(0,n.k):"values"==e?f(0,n.v):f(0,[n.k,n.v]):(t._t=void 0,f(1))},n?"entries":"values",!n,!0),l(e)}}},function(t,e,n){var r=n(25),i=n(46);t.exports=function(t){return function(){if(r(this)!=t)throw TypeError(t+"#toJSON isn't generic");return i(this)}}},function(t,e,n){"use strict";var r=n(1),i=n(9),o=n(31),s=n(12),u=n(3),a=n(34),c=n(13),f=n(24),l=n(4),h=n(17),p=n(5).f,d=n(48)(0),m=n(2);t.exports=function(t,e,n,v,g,y){var x=r[t],b=x,w=g?"set":"add",_=b&&b.prototype,O={};return m&&"function"==typeof b&&(y||_.forEach&&!s(function(){(new b).entries().next()}))?(b=e(function(e,n){f(e,b,t,"_c"),e._c=new x,void 0!=n&&c(n,g,e[w],e)}),d("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","),function(t){var e="add"==t||"set"==t;t in _&&(!y||"clear"!=t)&&u(b.prototype,t,function(n,r){if(f(this,b,t),!e&&y&&!l(n))return"get"==t&&void 0;var i=this._c[t](0===n?0:n,r);return e?this:i})}),y||p(b.prototype,"size",{get:function(){return this._c.size}})):(b=v.getConstructor(e,t,g,w),a(b.prototype,n),o.NEED=!0),h(b,t),O[t]=b,i(i.G+i.W+i.F,O),y||v.setStrong(b,t,g),b}},function(t,e,n){var r=n(1).document;t.exports=r&&r.documentElement},function(t,e,n){t.exports=!n(2)&&!n(12)(function(){return 7!=Object.defineProperty(n(26)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(11),i=n(0)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||o[i]===t)}},function(t,e,n){var r=n(14);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(6);t.exports=function(t,e,n,i){try{return i?e(r(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&r(o.call(t)),e}}},function(t,e,n){"use strict";var r=n(32),i=n(33),o=n(17),s={};n(3)(s,n(0)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(s,{next:i(1,n)}),o(t,e+" Iterator")}},function(t,e,n){var r=n(5),i=n(6),o=n(63);t.exports=n(2)?Object.defineProperties:function(t,e){i(t);for(var n,s=o(e),u=s.length,a=0;u>a;)r.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var r=n(10),i=n(36),o=n(18)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),r(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e,n){var r=n(10),i=n(20),o=n(47)(!1),s=n(18)("IE_PROTO");t.exports=function(t,e){var n,u=i(t),a=0,c=[];for(n in u)n!=s&&r(u,n)&&c.push(n);for(;e.length>a;)r(u,n=e[a++])&&(~o(c,n)||c.push(n));return c}},function(t,e,n){var r=n(62),i=n(27);t.exports=Object.keys||function(t){return r(t,i)}},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";var r=n(9),i=n(23),o=n(8),s=n(13);t.exports=function(t){r(r.S,t,{from:function(t){var e,n,r,u,a=arguments[1];return i(this),e=void 0!==a,e&&i(a),void 0==t?new this:(n=[],e?(r=0,u=o(a,arguments[2],2),s(t,!1,function(t){n.push(u(t,r++))})):s(t,!1,n.push,n),new this(n))}})}},function(t,e,n){"use strict";var r=n(9);t.exports=function(t){r(r.S,t,{of:function(){for(var t=arguments.length,e=new Array(t);t--;)e[t]=arguments[t];return new this(e)}})}},function(t,e,n){"use strict";var r=n(1),i=n(7),o=n(5),s=n(2),u=n(0)("species");t.exports=function(t){var e="function"==typeof i[t]?i[t]:r[t];s&&e&&!e[u]&&o.f(e,u,{configurable:!0,get:function(){return this}})}},function(t,e,n){var r=n(19),i=n(15);t.exports=function(t){return function(e,n){var o,s,u=String(i(e)),a=r(n),c=u.length;return a<0||a>=c?t?"":void 0:(o=u.charCodeAt(a),o<55296||o>56319||a+1===c||(s=u.charCodeAt(a+1))<56320||s>57343?t?u.charAt(a):o:t?u.slice(a,a+2):s-56320+(o-55296<<10)+65536)}}},function(t,e,n){var r=n(19),i=Math.max,o=Math.min;t.exports=function(t,e){return t=r(t),t<0?i(t+e,0):o(t,e)}},function(t,e,n){var r=n(4);t.exports=function(t,e){if(!r(t))return t;var n,i;if(e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;if("function"==typeof(n=t.valueOf)&&!r(i=n.call(t)))return i;if(!e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(25),i=n(0)("iterator"),o=n(11);t.exports=n(7).getIteratorMethod=function(t){if(void 0!=t)return t[i]||t["@@iterator"]||o[r(t)]}},function(t,e,n){"use strict";var r=n(45),i=n(29),o=n(11),s=n(20);t.exports=n(16)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,i(1)):"keys"==e?i(0,n):"values"==e?i(0,t[n]):i(0,[n,t[n]])},"values"),o.Arguments=o.Array,r("keys"),r("values"),r("entries")},function(t,e){},function(t,e,n){"use strict";var r=n(51),i=n(37);t.exports=n(53)("Set",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return r.def(i(this,"Set"),t=0===t?0:t,t)}},r)},function(t,e,n){"use strict";var r=n(68)(!0);n(16)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){n(65)("Set")},function(t,e,n){n(66)("Set")},function(t,e,n){var r=n(9);r(r.P+r.R,"Set",{toJSON:n(52)("Set")})},function(t,e,n){n(72);for(var r=n(1),i=n(3),o=n(11),s=n(0)("toStringTag"),u="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),a=0;a<u.length;a++){var c=u[a],f=r[c],l=f&&f.prototype;l&&!l[s]&&i(l,s,c),o[c]=o.Array}},function(t,e,n){e=t.exports=n(81)(),e.push([t.i,"\n.vdr[data-v-1e95fd0f] {\n  position: absolute;\n  box-sizing: border-box;\n}\n.handle[data-v-1e95fd0f] {\n  box-sizing: border-box;\n  display: none;\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  font-size: 1px;\n  background: #EEE;\n  border: 1px solid #333;\n}\n.handle-tl[data-v-1e95fd0f] {\n  top: -10px;\n  left: -10px;\n  cursor: nw-resize;\n}\n.handle-tm[data-v-1e95fd0f] {\n  top: -10px;\n  left: 50%;\n  margin-left: -5px;\n  cursor: n-resize;\n}\n.handle-tr[data-v-1e95fd0f] {\n  top: -10px;\n  right: -10px;\n  cursor: ne-resize;\n}\n.handle-ml[data-v-1e95fd0f] {\n  top: 50%;\n  margin-top: -5px;\n  left: -10px;\n  cursor: w-resize;\n}\n.handle-mr[data-v-1e95fd0f] {\n  top: 50%;\n  margin-top: -5px;\n  right: -10px;\n  cursor: e-resize;\n}\n.handle-bl[data-v-1e95fd0f] {\n  bottom: -10px;\n  left: -10px;\n  cursor: sw-resize;\n}\n.handle-bm[data-v-1e95fd0f] {\n  bottom: -10px;\n  left: 50%;\n  margin-left: -5px;\n  cursor: s-resize;\n}\n.handle-br[data-v-1e95fd0f] {\n  bottom: -10px;\n  right: -10px;\n  cursor: se-resize;\n}\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n[class*=\"handle-\"][data-v-1e95fd0f]:before {\n    content: '';\n    left: -10px;\n    right: -10px;\n    bottom: -10px;\n    top: -10px;\n    position: absolute;\n}\n}\n",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(r[o]=!0)}for(i=0;i<e.length;i++){var s=e[i];"number"==typeof s[0]&&r[s[0]]||(n&&!s[2]?s[2]=n:n&&(s[2]="("+s[2]+") and ("+n+")"),t.push(s))}},t}},function(t,e){t.exports=function(t,e,n,r){var i,o=t=t||{},s=typeof t.default;"object"!==s&&"function"!==s||(i=t,o=t.default);var u="function"==typeof o?o.options:o;if(e&&(u.render=e.render,u.staticRenderFns=e.staticRenderFns),n&&(u._scopeId=n),r){var a=Object.create(u.computed||null);Object.keys(r).forEach(function(t){var e=r[t];a[t]=function(){return e}}),u.computed=a}return{esModule:i,exports:o,options:u}}},function(t,e,n){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"vdr",class:{draggable:t.draggable,resizable:t.resizable,active:t.enabled,dragging:t.dragging,resizing:t.resizing},style:t.style,on:{mousedown:function(e){return e.stopPropagation(),t.elmDown(e)},touchstart:function(e){return e.preventDefault(),e.stopPropagation(),t.elmDown(e)},dblclick:t.fillParent}},[t._l(t.handles,function(e){return t.resizable?n("div",{key:e,staticClass:"handle",class:"handle-"+e,style:{display:t.enabled?"block":"none"},on:{mousedown:function(n){n.stopPropagation(),n.preventDefault(),t.handleDown(e,n)},touchstart:function(n){n.stopPropagation(),n.preventDefault(),t.handleDown(e,n)},touchend:function(e){e.stopPropagation(),e.preventDefault(),t.handleUp(e)}}}):t._e()}),t._v(" "),t._t("default")],2)},staticRenderFns:[]},t.exports.render._withStripped=!0},function(t,e,n){var r=n(80);"string"==typeof r&&(r=[[t.i,r,""]]),r.locals&&(t.exports=r.locals);n(85)("2fff53fe",r,!1)},function(t,e,n){function r(t){for(var e=0;e<t.length;e++){var n=t[e],r=f[n.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](n.parts[i]);for(;i<n.parts.length;i++)r.parts.push(o(n.parts[i]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{for(var s=[],i=0;i<n.parts.length;i++)s.push(o(n.parts[i]));f[n.id]={id:n.id,refs:1,parts:s}}}}function i(){var t=document.createElement("style");return t.type="text/css",l.appendChild(t),t}function o(t){var e,n,r=document.querySelector('style[data-vue-ssr-id~="'+t.id+'"]');if(r){if(d)return m;r.parentNode.removeChild(r)}if(v){var o=p++;r=h||(h=i()),e=s.bind(null,r,o,!1),n=s.bind(null,r,o,!0)}else r=i(),e=u.bind(null,r),n=function(){r.parentNode.removeChild(r)};return e(t),function(r){if(r){if(r.css===t.css&&r.media===t.media&&r.sourceMap===t.sourceMap)return;e(t=r)}else n()}}function s(t,e,n,r){var i=n?"":r.css;if(t.styleSheet)t.styleSheet.cssText=g(e,i);else{var o=document.createTextNode(i),s=t.childNodes;s[e]&&t.removeChild(s[e]),s.length?t.insertBefore(o,s[e]):t.appendChild(o)}}function u(t,e){var n=e.css,r=e.media,i=e.sourceMap;if(r&&t.setAttribute("media",r),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}var a="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!a)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var c=n(86),f={},l=a&&(document.head||document.getElementsByTagName("head")[0]),h=null,p=0,d=!1,m=function(){},v="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,n){d=n;var i=c(t,e);return r(i),function(e){for(var n=[],o=0;o<i.length;o++){var s=i[o],u=f[s.id];u.refs--,n.push(u)}e?(i=c(t,e),r(i)):i=[];for(var o=0;o<n.length;o++){var u=n[o];if(0===u.refs){for(var a=0;a<u.parts.length;a++)u.parts[a]();delete f[u.id]}}}};var g=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var n=[],r={},i=0;i<e.length;i++){var o=e[i],s=o[0],u=o[1],a=o[2],c=o[3],f={id:t+":"+i,css:u,media:a,sourceMap:c};r[s]?r[s].parts.push(f):n.push(r[s]={id:s,parts:[f]})}return n}}])});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapping-container",staticClass:"is--editor",staticStyle:{"position":"relative"}},[(! _vm.isLoading)?_c('div',{staticStyle:{"z-index":"2","clear":"both"},style:({ width: (30 * _vm.viewport.factor) + 'px', position: 'relative', margin: 'auto' })},[_c('div',{staticClass:"body",style:({ height: (30 * _vm.viewport.factor) + 'px', position: 'relative' })},[_vm._l((_vm.viewport.trigger),function(triggerPoint){return ('cake-topper' !== _vm.baseColorClassName)?_c('div',{staticClass:"h-rule",style:(_vm.triggerLine(triggerPoint.line))},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(triggerPoint.label)+" "+_vm._s(triggerPoint.indicator))])]):_vm._e()}),_vm._v(" "),(_vm.preloadActive)?[_vm._m(0)]:[(0 === _vm.plexipeople.length)?_c('button',{staticClass:"is--uploader",on:{"click":_vm.openUploader}},[_c('i',{staticClass:"icon-upload2",attrs:{"data-v-63411e51":""}}),_vm._v(" "),_c('span',[_vm._v("Foto Upload")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.plexipeople),function(entry,key){return _c('vue-draggable-resizable',{key:entry.uuid,style:({ 'background-image': 'url(' + entry.extraction.source + ')', 'z-index': (entry.active ? 9999 : entry.groove * 1000 + key) }),attrs:{"x":entry.x,"y":(30 * _vm.viewport.factor) - entry.height,"w":entry.width,"h":entry.height,"aspect":true,"parent":true,"handles":['tm'],"plexipeople":entry,"active":entry.active,"axis":"xb"},on:{"activated":_vm.activated,"deactivated":_vm.deactivated,"resizestop":_vm.resized,"dragstop":_vm.dragged}})})]],2),_vm._v(" "),('none' !== _vm.base.color.class && 'cake-topper' !== _vm.base.color.class)?_c('div',{staticClass:"footer",class:[_vm.baseColorClass, 'size-'+_vm.base.width.value],style:({ width: ((_vm.base.width.value / 10) * _vm.viewport.factor) + 'px', height: ((_vm.base.height.value / 10) * _vm.viewport.factor) + 'px'})},[('none' !== _vm.baseColorClassName)?_c('span',{staticClass:"is--label"},[_vm._v(_vm._s(_vm.base.width.label))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sockel--wrapper"},[_c('div',{staticClass:"sockel",class:[_vm.baseColorClass, 'nut-'+_vm.base.grooves.value],style:({ width: ((_vm.base.width.value / 10) * _vm.viewport.factor) + 'px', height: ((_vm.base.height.value / 10) * _vm.viewport.factor * 1.75) + 'px'})},[_c('div',{staticClass:"imgHolder cornerLeft"},[_c('img',{attrs:{"src":'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/'+_vm.base.color.class+'/grooves-'+_vm.base.grooves.value+'_left.png',"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"imgHolder cornerRight"},[_c('img',{attrs:{"src":'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/'+_vm.base.color.class+'/grooves-'+_vm.base.grooves.value+'_right.png',"alt":""}})])])])]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloading-images-indicator"},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg","alt":"Loading"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlexipeopleVisualization_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d658a7a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlexipeopleVisualization_vue__ = __webpack_require__(385);
function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d658a7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlexipeopleVisualization_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d658a7a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlexipeopleVisualization_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(384);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0497f0ce", content, true, {});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "ul.hide--mobile[data-v-8d658a7a]{display:none}@media screen and (min-width:48em){ul.hide--mobile[data-v-8d658a7a]{display:flex;align-items:flex-end;padding-bottom:40px}}ul li.is--size[data-v-8d658a7a]{position:relative;cursor:pointer}ul li.is--size span[data-v-8d658a7a]{position:absolute;bottom:30%;left:0;right:0;text-align:center;font-weight:700;color:#009fe3}ul li.is--size span.is--info-size[data-v-8d658a7a]{position:relative;bottom:0;left:auto;right:auto;font-size:.8rem;line-height:normal;vertical-align:top;font-weight:400;display:inherit}ul li.is--size[data-v-8d658a7a]:before{content:\"\";width:100%;height:100%;display:inline-block;background-size:contain;background-repeat:no-repeat;background-position:bottom}ul li.is--size.is--active span[data-v-8d658a7a]{color:#fff}ul li.is--size.is--active span.is--info-size[data-v-8d658a7a]{color:#009fe3}ul .is--size-s[data-v-8d658a7a]{width:110px;height:80px}ul .is--size-s[data-v-8d658a7a]:before{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/s.svg\")}ul .is--size-s.is--active[data-v-8d658a7a]:before{content:\"\";background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/s-filled.svg\")}ul .is--size-m[data-v-8d658a7a]{width:110px;height:120px;font-size:1.2rem}ul .is--size-m[data-v-8d658a7a]:before{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/m.svg\")}ul .is--size-m.is--active[data-v-8d658a7a]:before{content:\"\";background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/m-filled.svg\")}ul .is--size-l[data-v-8d658a7a]{width:120px;height:160px;font-size:1.4rem}ul .is--size-l[data-v-8d658a7a]:before{background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/l.svg\")}ul .is--size-l.is--active[data-v-8d658a7a]:before{content:\"\";background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/l-filled.svg\")}", ""]);

// exports


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list--unstyled hide--mobile"},_vm._l((_vm.sizes),function(size){return _c('li',{key:size.indicator,staticClass:"is--size",class:[{ 'is--active': size.indicator === _vm.plexipeople.size }, 'is--size-' + size.indicator.toLowerCase()],on:{"click":function($event){return _vm.resize(size)}}},[_c('span',{staticClass:"is--info-size"},[_vm._v(_vm._s(_vm.$t('visualization.max'))+" "+_vm._s(size.label))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceList_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_222d1ab4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceList_vue__ = __webpack_require__(389);
function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-222d1ab4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_222d1ab4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(388);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("ca7b5f0c", content, true, {});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".sizing--product[data-v-222d1ab4]{text-align:center}@media screen and (min-width:48em){.sizing--product[data-v-222d1ab4]{text-align:left}}@media screen and (min-width:48em){.sizing--product.list--unordered[data-v-222d1ab4]{padding-left:0}}.sizing--product .base-info--entry[data-v-222d1ab4]{cursor:pointer;display:inline-block;padding-right:22px}.sizing--product .base-info--entry[data-v-222d1ab4]:before{top:2px;color:#009fe3}.sizing--product .base-info--entry[data-v-222d1ab4]:last-child{padding-right:0}@media screen and (min-width:48em){.sizing--product .base-info--entry[data-v-222d1ab4]{padding-right:0;display:list-item}}.sizing--product .base-info--entry[data-v-222d1ab4]:not(.is--active),.sizing--product .base-info--entry[data-v-222d1ab4]:not(.is--active):before{color:#a3a3a3}", ""]);

// exports


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(! _vm.viewport.isMobile)?_c('div',{staticClass:"content--title mb-1"},[_vm._v(_vm._s(_vm.$t('priceList.calculatedPriceHeadline')))]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"product--base-info sizing--product list--unordered"},_vm._l((_vm.positions),function(position,key){return _c('li',{staticClass:"base-info--entry mb-1",class:{ 'is--active': _vm.activePlexipeople.uuid === position.uuid },on:{"click":function($event){return _vm.activatePlexipeople(position)}}},[(! _vm.viewport.isMobile)?[('cake-topper' !== _vm.base.color.class)?[_vm._v("Aktuelle Plexipeople Größe: "+_vm._s(position.values.width)+" x "+_vm._s(position.values.height)+" cm")]:[_vm._v("CakeTopper")]]:[('cake-topper' !== _vm.base.color.class)?[_vm._v(_vm._s(position.label)+": "+_vm._s(position.values.width)+" x "+_vm._s(position.values.height)+" cm")]:[_vm._v("CakeTopper")]]],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebb1a8c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Base_vue__ = __webpack_require__(411);
function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebb1a8c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Base_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(392);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("525fed07", content, true, {});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "@media screen and (min-width:48em){.base-info{margin-bottom:30px;width:100%;display:block}}.base-info .select-wrapper{flex:1}.base-info .select-wrapper:nth-child(2){margin:0 10px}@media screen and (min-width:48em){.base-info .select-wrapper:nth-child(2){width:100%;margin:0}}@media screen and (min-width:48em){.base-info .select-wrapper:nth-child(3){width:100%}}@media screen and (min-width:48em){.base-info .select-wrapper{flex:none;width:100%;margin-bottom:10px}}.base-info .select-wrapper .select--title{width:40%}@media screen and (min-width:30em){.base-info .select-wrapper .select--title{width:20%}}.base-info .select-wrapper .js--fancy-select select,.base-info .select-wrapper .select-field select{padding:0 20px 0 5px;border-radius:0}.base-info .select-wrapper .js--fancy-select:after,.base-info .select-wrapper .select-field:after{width:20px;border:none}.base-info ul.product--base-info li{cursor:pointer;opacity:.7;display:inline-block;color:#009fe3;padding-right:10px}.base-info ul.product--base-info li label{cursor:pointer}.base-info ul.product--base-info li.base-info--headline{opacity:1;color:#444041}.base-info ul.product--base-info li span.is--label{display:inline-block}.base-info ul.product--base-info li.selected{opacity:1}.base-info ul.product--base-info.is--disabled li{opacity:.3}.base-info ul.product--base-info.is--width{width:80%}.base-info ul.product--base-info.is--width li{color:#444041;display:flex;align-items:center;padding-right:0;font-weight:600}.base-info ul.product--base-info.is--width li span:first-child{padding-right:10px}.base-info ul.product--base-info.is--width li.selected{cursor:zoom-in}.base-info ul.product--base-info.product--base-info[class*=is--grooves] .selected span{color:#009fe3}.base-info .v--modal-box.preview{display:flex}.base-info .v--modal-box.preview div{display:flex;align-items:center;justify-content:center}.cake{display:flex;flex-wrap:wrap}@media screen and (max-width:48em){.cake{width:100%;justify-content:center}}", ""]);

// exports


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Color_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_831d9464_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Color_vue__ = __webpack_require__(396);
function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-831d9464"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Color_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_831d9464_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Color_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(395);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("750e094e", content, true, {});

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "@media screen and (min-width:48em){.base-info[data-v-831d9464]{margin-bottom:30px;width:100%;display:block}}.base-info .select-wrapper[data-v-831d9464]{flex:1}.base-info .select-wrapper[data-v-831d9464]:nth-child(2){margin:0 10px}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-831d9464]:nth-child(2){width:100%;margin:0}}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-831d9464]:nth-child(3){width:100%}}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-831d9464]{flex:none;width:100%;margin-bottom:10px}}.base-info .select-wrapper .select--title[data-v-831d9464]{width:40%}@media screen and (min-width:30em){.base-info .select-wrapper .select--title[data-v-831d9464]{width:20%}}.base-info .select-wrapper .js--fancy-select select[data-v-831d9464],.base-info .select-wrapper .select-field select[data-v-831d9464]{padding:0 20px 0 5px;border-radius:0}.base-info .select-wrapper .js--fancy-select[data-v-831d9464]:after,.base-info .select-wrapper .select-field[data-v-831d9464]:after{width:20px;border:none}.base-info ul.product--base-info li[data-v-831d9464]{cursor:pointer;opacity:.7;display:inline-block;color:#009fe3;padding-right:10px}.base-info ul.product--base-info li label[data-v-831d9464]{cursor:pointer}.base-info ul.product--base-info li.base-info--headline[data-v-831d9464]{opacity:1;color:#444041}.base-info ul.product--base-info li span.is--label[data-v-831d9464]{display:inline-block}.base-info ul.product--base-info li.selected[data-v-831d9464]{opacity:1}.base-info ul.product--base-info.is--disabled li[data-v-831d9464]{opacity:.3}.base-info ul.product--base-info.is--width[data-v-831d9464]{width:80%}.base-info ul.product--base-info.is--width li[data-v-831d9464]{color:#444041;display:flex;align-items:center;padding-right:0;font-weight:600}.base-info ul.product--base-info.is--width li span[data-v-831d9464]:first-child{padding-right:10px}.base-info ul.product--base-info.is--width li.selected[data-v-831d9464]{cursor:zoom-in}.base-info ul.product--base-info.product--base-info[class*=is--grooves] .selected span[data-v-831d9464]{color:#009fe3}.base-info .v--modal-box.preview[data-v-831d9464]{display:flex}.base-info .v--modal-box.preview div[data-v-831d9464]{display:flex;align-items:center;justify-content:center}.cake[data-v-831d9464]{display:flex;flex-wrap:wrap}@media screen and (max-width:48em){.cake[data-v-831d9464]{width:100%;justify-content:center}}", ""]);

// exports


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-wrapper"},[_c('div',{staticClass:"select-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"product--base-info",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.collection),function(item){return _c('option',{class:{ selected: _vm.value === item },domProps:{"selected":_vm.value === item,"value":item}},[_vm._v("\n                    "+_vm._s(item.label)+"\n                ")])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Width_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_206fedad_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Width_vue__ = __webpack_require__(400);
function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-206fedad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Width_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_206fedad_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Width_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(399);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("cb9ca9e6", content, true, {});

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "@media screen and (min-width:48em){.base-info[data-v-206fedad]{margin-bottom:30px;width:100%;display:block}}.base-info .select-wrapper[data-v-206fedad]{flex:1}.base-info .select-wrapper[data-v-206fedad]:nth-child(2){margin:0 10px}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-206fedad]:nth-child(2){width:100%;margin:0}}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-206fedad]:nth-child(3){width:100%}}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-206fedad]{flex:none;width:100%;margin-bottom:10px}}.base-info .select-wrapper .select--title[data-v-206fedad]{width:40%}@media screen and (min-width:30em){.base-info .select-wrapper .select--title[data-v-206fedad]{width:20%}}.base-info .select-wrapper .js--fancy-select select[data-v-206fedad],.base-info .select-wrapper .select-field select[data-v-206fedad]{padding:0 20px 0 5px;border-radius:0}.base-info .select-wrapper .js--fancy-select[data-v-206fedad]:after,.base-info .select-wrapper .select-field[data-v-206fedad]:after{width:20px;border:none}.base-info ul.product--base-info li[data-v-206fedad]{cursor:pointer;opacity:.7;display:inline-block;color:#009fe3;padding-right:10px}.base-info ul.product--base-info li label[data-v-206fedad]{cursor:pointer}.base-info ul.product--base-info li.base-info--headline[data-v-206fedad]{opacity:1;color:#444041}.base-info ul.product--base-info li span.is--label[data-v-206fedad]{display:inline-block}.base-info ul.product--base-info li.selected[data-v-206fedad]{opacity:1}.base-info ul.product--base-info.is--disabled li[data-v-206fedad]{opacity:.3}.base-info ul.product--base-info.is--width[data-v-206fedad]{width:80%}.base-info ul.product--base-info.is--width li[data-v-206fedad]{color:#444041;display:flex;align-items:center;padding-right:0;font-weight:600}.base-info ul.product--base-info.is--width li span[data-v-206fedad]:first-child{padding-right:10px}.base-info ul.product--base-info.is--width li.selected[data-v-206fedad]{cursor:zoom-in}.base-info ul.product--base-info.product--base-info[class*=is--grooves] .selected span[data-v-206fedad]{color:#009fe3}.base-info .v--modal-box.preview[data-v-206fedad]{display:flex}.base-info .v--modal-box.preview div[data-v-206fedad]{display:flex;align-items:center;justify-content:center}.cake[data-v-206fedad]{display:flex;flex-wrap:wrap}@media screen and (max-width:48em){.cake[data-v-206fedad]{width:100%;justify-content:center}}", ""]);

// exports


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('modal',{attrs:{"name":"preview","classes":"preview","transition":"scale","height":'100%',"width":'100%'}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},on:{"click":_vm.closeModal}},[_c('img',{attrs:{"src":_vm.previewImage}})])]),_vm._v(" "),_c('ul',{staticClass:"product--base-info is--width list--unstyled",class:['is--grooves-' + _vm.grooves.value, { 'is--disabled': _vm.disabled }]},_vm._l((_vm.collection),function(item){return _c('li',{staticClass:"base-info--entry",class:{ selected: _vm.value === item },on:{"click":function($event){return _vm.input(item)}}},[_c('span',{class:'is--width-' + item.value},[_c('img',{style:({width: item.value + 'px', display: 'inline-block'}),attrs:{"src":'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/' + _vm.colorClass + '/' + item.value + '-' + _vm.grooves.value + '.png',"alt":""}})]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(item.label))])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Width_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10eb36ee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Width_vue__ = __webpack_require__(404);
function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10eb36ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Width_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10eb36ee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Width_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(403);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("107cde60", content, true, {});

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "@media screen and (min-width:48em){.base-info[data-v-10eb36ee]{margin-bottom:30px;width:100%;display:block}}.base-info .select-wrapper[data-v-10eb36ee]{flex:1}.base-info .select-wrapper[data-v-10eb36ee]:nth-child(2){margin:0 10px}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-10eb36ee]:nth-child(2){width:100%;margin:0}}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-10eb36ee]:nth-child(3){width:100%}}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-10eb36ee]{flex:none;width:100%;margin-bottom:10px}}.base-info .select-wrapper .select--title[data-v-10eb36ee]{width:40%}@media screen and (min-width:30em){.base-info .select-wrapper .select--title[data-v-10eb36ee]{width:20%}}.base-info .select-wrapper .js--fancy-select select[data-v-10eb36ee],.base-info .select-wrapper .select-field select[data-v-10eb36ee]{padding:0 20px 0 5px;border-radius:0}.base-info .select-wrapper .js--fancy-select[data-v-10eb36ee]:after,.base-info .select-wrapper .select-field[data-v-10eb36ee]:after{width:20px;border:none}.base-info ul.product--base-info li[data-v-10eb36ee]{cursor:pointer;opacity:.7;display:inline-block;color:#009fe3;padding-right:10px}.base-info ul.product--base-info li label[data-v-10eb36ee]{cursor:pointer}.base-info ul.product--base-info li.base-info--headline[data-v-10eb36ee]{opacity:1;color:#444041}.base-info ul.product--base-info li span.is--label[data-v-10eb36ee]{display:inline-block}.base-info ul.product--base-info li.selected[data-v-10eb36ee]{opacity:1}.base-info ul.product--base-info.is--disabled li[data-v-10eb36ee]{opacity:.3}.base-info ul.product--base-info.is--width[data-v-10eb36ee]{width:80%}.base-info ul.product--base-info.is--width li[data-v-10eb36ee]{color:#444041;display:flex;align-items:center;padding-right:0;font-weight:600}.base-info ul.product--base-info.is--width li span[data-v-10eb36ee]:first-child{padding-right:10px}.base-info ul.product--base-info.is--width li.selected[data-v-10eb36ee]{cursor:zoom-in}.base-info ul.product--base-info.product--base-info[class*=is--grooves] .selected span[data-v-10eb36ee]{color:#009fe3}.base-info .v--modal-box.preview[data-v-10eb36ee]{display:flex}.base-info .v--modal-box.preview div[data-v-10eb36ee]{display:flex;align-items:center;justify-content:center}.cake[data-v-10eb36ee]{display:flex;flex-wrap:wrap}@media screen and (max-width:48em){.cake[data-v-10eb36ee]{width:100%;justify-content:center}}", ""]);

// exports


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-wrapper"},[_c('div',{staticClass:"select-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"product--base-info is--width",class:{ 'is--disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.collection),function(item){return _c('option',{class:{ selected: _vm.value === item },domProps:{"selected":_vm.value === item,"value":item}},[_vm._v("\n                    "+_vm._s(item.label)+"\n                ")])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grooves_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c6aa74_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grooves_vue__ = __webpack_require__(408);
function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12c6aa74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grooves_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c6aa74_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grooves_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(407);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("c6715ca2", content, true, {});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "@media screen and (min-width:48em){.base-info[data-v-12c6aa74]{margin-bottom:30px;width:100%;display:block}}.base-info .select-wrapper[data-v-12c6aa74]{flex:1}.base-info .select-wrapper[data-v-12c6aa74]:nth-child(2){margin:0 10px}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-12c6aa74]:nth-child(2){width:100%;margin:0}}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-12c6aa74]:nth-child(3){width:100%}}@media screen and (min-width:48em){.base-info .select-wrapper[data-v-12c6aa74]{flex:none;width:100%;margin-bottom:10px}}.base-info .select-wrapper .select--title[data-v-12c6aa74]{width:40%}@media screen and (min-width:30em){.base-info .select-wrapper .select--title[data-v-12c6aa74]{width:20%}}.base-info .select-wrapper .js--fancy-select select[data-v-12c6aa74],.base-info .select-wrapper .select-field select[data-v-12c6aa74]{padding:0 20px 0 5px;border-radius:0}.base-info .select-wrapper .js--fancy-select[data-v-12c6aa74]:after,.base-info .select-wrapper .select-field[data-v-12c6aa74]:after{width:20px;border:none}.base-info ul.product--base-info li[data-v-12c6aa74]{cursor:pointer;opacity:.7;display:inline-block;color:#009fe3;padding-right:10px}.base-info ul.product--base-info li label[data-v-12c6aa74]{cursor:pointer}.base-info ul.product--base-info li.base-info--headline[data-v-12c6aa74]{opacity:1;color:#444041}.base-info ul.product--base-info li span.is--label[data-v-12c6aa74]{display:inline-block}.base-info ul.product--base-info li.selected[data-v-12c6aa74]{opacity:1}.base-info ul.product--base-info.is--disabled li[data-v-12c6aa74]{opacity:.3}.base-info ul.product--base-info.is--width[data-v-12c6aa74]{width:80%}.base-info ul.product--base-info.is--width li[data-v-12c6aa74]{color:#444041;display:flex;align-items:center;padding-right:0;font-weight:600}.base-info ul.product--base-info.is--width li span[data-v-12c6aa74]:first-child{padding-right:10px}.base-info ul.product--base-info.is--width li.selected[data-v-12c6aa74]{cursor:zoom-in}.base-info ul.product--base-info.product--base-info[class*=is--grooves] .selected span[data-v-12c6aa74]{color:#009fe3}.base-info .v--modal-box.preview[data-v-12c6aa74]{display:flex}.base-info .v--modal-box.preview div[data-v-12c6aa74]{display:flex;align-items:center;justify-content:center}.cake[data-v-12c6aa74]{display:flex;flex-wrap:wrap}@media screen and (max-width:48em){.cake[data-v-12c6aa74]{width:100%;justify-content:center}}", ""]);

// exports


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true !== _vm.disabled)?_c('div',{staticClass:"select-wrapper"},[_c('div',{staticClass:"select-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"product--base-info",class:{ 'is--disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.change]}},_vm._l((_vm.collection),function(item){return _c('option',{class:{ selected: _vm.value === item },domProps:{"selected":_vm.value === item,"value":item}},[_vm._v("\n                    "+_vm._s(item.label)+"\n                ")])}),0)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cake_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699a6f34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cake_vue__ = __webpack_require__(410);
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cake_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699a6f34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cake_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cake paul"},[_c('img',{attrs:{"src":'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/cake-topper.jpg',"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"intro",staticClass:"base-info is--flex justify-content-between mb-2"},[_c('app-base-color',{on:{"input":_vm.calculatePrices},model:{value:(_vm.base.color),callback:function ($$v) {_vm.$set(_vm.base, "color", $$v)},expression:"base.color"}}),_vm._v(" "),('none' !== _vm.base.color.class && 'cake-topper' !== _vm.base.color.class)?_c(_vm.baseWidthComponent,{tag:"component",attrs:{"disabled":'none' === _vm.base.color.class || 'cake-topper' === _vm.base.color.class,"color":_vm.base.color,"grooves":_vm.base.grooves},on:{"input":_vm.calculatePrices},model:{value:(_vm.base.width),callback:function ($$v) {_vm.$set(_vm.base, "width", $$v)},expression:"base.width"}}):_vm._e(),_vm._v(" "),('cake-topper' === _vm.base.color.class)?_c('app-base-cake',{model:{value:(_vm.base.cake),callback:function ($$v) {_vm.$set(_vm.base, "cake", $$v)},expression:"base.cake"}}):_vm._e(),_vm._v(" "),_c('app-base-grooves',{attrs:{"disabled":'none' === _vm.base.color.class || 'cake-topper' === _vm.base.color.class},model:{value:(_vm.base.grooves),callback:function ($$v) {_vm.$set(_vm.base, "grooves", $$v)},expression:"base.grooves"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyButton_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38766e30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyButton_vue__ = __webpack_require__(415);
function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38766e30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38766e30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("47a35dde", content, true, {});

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".buybox--button img[data-v-38766e30]{position:absolute;left:4px;height:38px;width:38px}@media screen and (max-width:48em){.buybox--button[data-v-38766e30]{font-size:16px}.buybox--button.is--loading[data-v-38766e30]:before{content:\"\";position:absolute;margin-left:-50px;background-image:url(/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg);height:36px;width:36px;background-size:contain;background-repeat:no-repeat}}.buybox--button-container[data-v-38766e30]{display:flex}@media screen and (min-width:48em){.buybox--form[data-v-38766e30]{width:100%;padding:0}}@media screen and (min-width:48em) and (min-width:30em){.buybox--form[data-v-38766e30]{width:auto}}@media screen and (min-width:48em){.buybox--form .buybox--button[data-v-38766e30]{position:relative;padding:2px 12px;white-space:nowrap}.buybox--form .buybox--button i[data-v-38766e30]{font-size:25px}.buybox--form .buybox--button.is--icon-left[data-v-38766e30]{padding-left:45px}}", ""]);

// exports


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buybox--form",attrs:{"name":"sAddToBasket","data-add-article":"true","data-eventname":"submit","data-showmodal":"false"}},[(! _vm.viewport.isMobile)?_c('div',{staticClass:"buybox--button-container"},[_c('div',{staticClass:"buybox--quantity"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quantity),expression:"quantity"}],staticClass:"is--quantityInput",attrs:{"type":"text","pattern":"\\d*"},domProps:{"value":(_vm.quantity)},on:{"change":_vm.handleQuantity,"input":function($event){if($event.target.composing){ return; }_vm.quantity=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"is--quantityHandler"},[_c('span',{staticClass:"label-plus",on:{"click":_vm.increase}},[_vm._v("+")]),_vm._v(" "),_c('span',{staticClass:"label-minus",on:{"click":_vm.decrease}},[_vm._v("-")])])]),_vm._v(" "),_c('button',{staticClass:"buybox--button btn is--third is--icon-left is--center is--large",attrs:{"disabled":1 > _vm.plexipeople.length || _vm.isLoading},on:{"click":_vm.addToBasket}},[(_vm.isLoading)?_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg","alt":"Loading"}}):_c('i',{staticClass:"icon--basket"}),_vm._v("\n            "+_vm._s(_vm.$t('basket.addToBasketDesktop'))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.viewport.isMobile)?_c('div',{staticClass:"buybox--button-container"},[_c('button',{class:[ { 'is--loading': _vm.isLoading }, 'buybox--button', 'btn', 'is--primary', 'is--center' ],attrs:{"disabled":1 > _vm.plexipeople.length || _vm.isLoading},on:{"click":_vm.addToBasket}},[(0 === _vm.plexipeople.length)?[_vm._v(_vm._s(_vm.$t('basket.empty')))]:[_vm._v(_vm._s(_vm.$t('basket.addToBasket'))+" "+_vm._s(_vm.price)+" "+_vm._s(_vm.$t('basket.addToBasket2')))]],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {// randomColor by David Merfield under the CC0 license
// https://github.com/davidmerfield/randomColor/

;(function(root, factory) {

  // Support CommonJS
  if (true) {
    var randomColor = factory();

    // Support NodeJS & Component, which allow module.exports to be a function
    if (typeof module === 'object' && module && module.exports) {
      exports = module.exports = randomColor;
    }

    // Support CommonJS 1.1.1 spec
    exports.randomColor = randomColor;

  // Support AMD
  } else if (typeof define === 'function' && define.amd) {
    define([], factory);

  // Support vanilla script loading
  } else {
    root.randomColor = factory();
  }

}(this, function() {

  // Seed to get repeatable colors
  var seed = null;

  // Shared color dictionary
  var colorDictionary = {};

  // Populate the color dictionary
  loadColorBounds();

  // check if a range is taken
  var colorRanges = [];

  var randomColor = function (options) {

    options = options || {};

    // Check if there is a seed and ensure it's an
    // integer. Otherwise, reset the seed value.
    if (options.seed !== undefined && options.seed !== null && options.seed === parseInt(options.seed, 10)) {
      seed = options.seed;

    // A string was passed as a seed
    } else if (typeof options.seed === 'string') {
      seed = stringToInteger(options.seed);

    // Something was passed as a seed but it wasn't an integer or string
    } else if (options.seed !== undefined && options.seed !== null) {
      throw new TypeError('The seed value must be an integer or string');

    // No seed, reset the value outside.
    } else {
      seed = null;
    }

    var H,S,B;

    // Check if we need to generate multiple colors
    if (options.count !== null && options.count !== undefined) {

      var totalColors = options.count,
          colors = [];
      // Value false at index i means the range i is not taken yet.
      for (var i = 0; i < options.count; i++) {
        colorRanges.push(false)
        }
      options.count = null;

      while (totalColors > colors.length) {

        // Since we're generating multiple colors,
        // incremement the seed. Otherwise we'd just
        // generate the same color each time...
        if (seed && options.seed) options.seed += 1;

        colors.push(randomColor(options));
      }

      options.count = totalColors;

      return colors;
    }

    // First we pick a hue (H)
    H = pickHue(options);

    // Then use H to determine saturation (S)
    S = pickSaturation(H, options);

    // Then use S and H to determine brightness (B).
    B = pickBrightness(H, S, options);

    // Then we return the HSB color in the desired format
    return setFormat([H,S,B], options);
  };

  function pickHue(options) {
    if (colorRanges.length > 0) {
      var hueRange = getRealHueRange(options.hue)

      var hue = randomWithin(hueRange)

      //Each of colorRanges.length ranges has a length equal approximatelly one step
      var step = (hueRange[1] - hueRange[0]) / colorRanges.length

      var j = parseInt((hue - hueRange[0]) / step)

      //Check if the range j is taken
      if (colorRanges[j] === true) {
        j = (j + 2) % colorRanges.length
      }
      else {
        colorRanges[j] = true
           }

      var min = (hueRange[0] + j * step) % 359,
          max = (hueRange[0] + (j + 1) * step) % 359;

      hueRange = [min, max]

      hue = randomWithin(hueRange)

      if (hue < 0) {hue = 360 + hue;}
      return hue
    }
    else {
      var hueRange = getHueRange(options.hue)

      hue = randomWithin(hueRange);
      // Instead of storing red as two seperate ranges,
      // we group them, using negative numbers
      if (hue < 0) {
        hue = 360 + hue;
      }

      return hue;
    }
  }

  function pickSaturation (hue, options) {

    if (options.hue === 'monochrome') {
      return 0;
    }

    if (options.luminosity === 'random') {
      return randomWithin([0,100]);
    }

    var saturationRange = getSaturationRange(hue);

    var sMin = saturationRange[0],
        sMax = saturationRange[1];

    switch (options.luminosity) {

      case 'bright':
        sMin = 55;
        break;

      case 'dark':
        sMin = sMax - 10;
        break;

      case 'light':
        sMax = 55;
        break;
   }

    return randomWithin([sMin, sMax]);

  }

  function pickBrightness (H, S, options) {

    var bMin = getMinimumBrightness(H, S),
        bMax = 100;

    switch (options.luminosity) {

      case 'dark':
        bMax = bMin + 20;
        break;

      case 'light':
        bMin = (bMax + bMin)/2;
        break;

      case 'random':
        bMin = 0;
        bMax = 100;
        break;
    }

    return randomWithin([bMin, bMax]);
  }

  function setFormat (hsv, options) {

    switch (options.format) {

      case 'hsvArray':
        return hsv;

      case 'hslArray':
        return HSVtoHSL(hsv);

      case 'hsl':
        var hsl = HSVtoHSL(hsv);
        return 'hsl('+hsl[0]+', '+hsl[1]+'%, '+hsl[2]+'%)';

      case 'hsla':
        var hslColor = HSVtoHSL(hsv);
        var alpha = options.alpha || Math.random();
        return 'hsla('+hslColor[0]+', '+hslColor[1]+'%, '+hslColor[2]+'%, ' + alpha + ')';

      case 'rgbArray':
        return HSVtoRGB(hsv);

      case 'rgb':
        var rgb = HSVtoRGB(hsv);
        return 'rgb(' + rgb.join(', ') + ')';

      case 'rgba':
        var rgbColor = HSVtoRGB(hsv);
        var alpha = options.alpha || Math.random();
        return 'rgba(' + rgbColor.join(', ') + ', ' + alpha + ')';

      default:
        return HSVtoHex(hsv);
    }

  }

  function getMinimumBrightness(H, S) {

    var lowerBounds = getColorInfo(H).lowerBounds;

    for (var i = 0; i < lowerBounds.length - 1; i++) {

      var s1 = lowerBounds[i][0],
          v1 = lowerBounds[i][1];

      var s2 = lowerBounds[i+1][0],
          v2 = lowerBounds[i+1][1];

      if (S >= s1 && S <= s2) {

         var m = (v2 - v1)/(s2 - s1),
             b = v1 - m*s1;

         return m*S + b;
      }

    }

    return 0;
  }

  function getHueRange (colorInput) {

    if (typeof parseInt(colorInput) === 'number') {

      var number = parseInt(colorInput);

      if (number < 360 && number > 0) {
        return [number, number];
      }

    }

    if (typeof colorInput === 'string') {

      if (colorDictionary[colorInput]) {
        var color = colorDictionary[colorInput];
        if (color.hueRange) {return color.hueRange;}
      } else if (colorInput.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
        var hue = HexToHSB(colorInput)[0];
        return [ hue, hue ];
      }
    }

    return [0,360];

  }

  function getSaturationRange (hue) {
    return getColorInfo(hue).saturationRange;
  }

  function getColorInfo (hue) {

    // Maps red colors to make picking hue easier
    if (hue >= 334 && hue <= 360) {
      hue-= 360;
    }

    for (var colorName in colorDictionary) {
       var color = colorDictionary[colorName];
       if (color.hueRange &&
           hue >= color.hueRange[0] &&
           hue <= color.hueRange[1]) {
          return colorDictionary[colorName];
       }
    } return 'Color not found';
  }

  function randomWithin (range) {
    if (seed === null) {
      //generate random evenly destinct number from : https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
      var golden_ratio = 0.618033988749895
      var r=Math.random()
      r += golden_ratio
      r %= 1
      return Math.floor(range[0] + r*(range[1] + 1 - range[0]));
    } else {
      //Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
      var max = range[1] || 1;
      var min = range[0] || 0;
      seed = (seed * 9301 + 49297) % 233280;
      var rnd = seed / 233280.0;
      return Math.floor(min + rnd * (max - min));
}
  }

  function HSVtoHex (hsv){

    var rgb = HSVtoRGB(hsv);

    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    }

    var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);

    return hex;

  }

  function defineColor (name, hueRange, lowerBounds) {

    var sMin = lowerBounds[0][0],
        sMax = lowerBounds[lowerBounds.length - 1][0],

        bMin = lowerBounds[lowerBounds.length - 1][1],
        bMax = lowerBounds[0][1];

    colorDictionary[name] = {
      hueRange: hueRange,
      lowerBounds: lowerBounds,
      saturationRange: [sMin, sMax],
      brightnessRange: [bMin, bMax]
    };

  }

  function loadColorBounds () {

    defineColor(
      'monochrome',
      null,
      [[0,0],[100,0]]
    );

    defineColor(
      'red',
      [-26,18],
      [[20,100],[30,92],[40,89],[50,85],[60,78],[70,70],[80,60],[90,55],[100,50]]
    );

    defineColor(
      'orange',
      [19,46],
      [[20,100],[30,93],[40,88],[50,86],[60,85],[70,70],[100,70]]
    );

    defineColor(
      'yellow',
      [47,62],
      [[25,100],[40,94],[50,89],[60,86],[70,84],[80,82],[90,80],[100,75]]
    );

    defineColor(
      'green',
      [63,178],
      [[30,100],[40,90],[50,85],[60,81],[70,74],[80,64],[90,50],[100,40]]
    );

    defineColor(
      'blue',
      [179, 257],
      [[20,100],[30,86],[40,80],[50,74],[60,60],[70,52],[80,44],[90,39],[100,35]]
    );

    defineColor(
      'purple',
      [258, 282],
      [[20,100],[30,87],[40,79],[50,70],[60,65],[70,59],[80,52],[90,45],[100,42]]
    );

    defineColor(
      'pink',
      [283, 334],
      [[20,100],[30,90],[40,86],[60,84],[80,80],[90,75],[100,73]]
    );

  }

  function HSVtoRGB (hsv) {

    // this doesn't work for the values of 0 and 360
    // here's the hacky fix
    var h = hsv[0];
    if (h === 0) {h = 1;}
    if (h === 360) {h = 359;}

    // Rebase the h,s,v values
    h = h/360;
    var s = hsv[1]/100,
        v = hsv[2]/100;

    var h_i = Math.floor(h*6),
      f = h * 6 - h_i,
      p = v * (1 - s),
      q = v * (1 - f*s),
      t = v * (1 - (1 - f)*s),
      r = 256,
      g = 256,
      b = 256;

    switch(h_i) {
      case 0: r = v; g = t; b = p;  break;
      case 1: r = q; g = v; b = p;  break;
      case 2: r = p; g = v; b = t;  break;
      case 3: r = p; g = q; b = v;  break;
      case 4: r = t; g = p; b = v;  break;
      case 5: r = v; g = p; b = q;  break;
    }

    var result = [Math.floor(r*255), Math.floor(g*255), Math.floor(b*255)];
    return result;
  }

  function HexToHSB (hex) {
    hex = hex.replace(/^#/, '');
    hex = hex.length === 3 ? hex.replace(/(.)/g, '$1$1') : hex;

    var red = parseInt(hex.substr(0, 2), 16) / 255,
          green = parseInt(hex.substr(2, 2), 16) / 255,
          blue = parseInt(hex.substr(4, 2), 16) / 255;

    var cMax = Math.max(red, green, blue),
          delta = cMax - Math.min(red, green, blue),
          saturation = cMax ? (delta / cMax) : 0;

    switch (cMax) {
      case red: return [ 60 * (((green - blue) / delta) % 6) || 0, saturation, cMax ];
      case green: return [ 60 * (((blue - red) / delta) + 2) || 0, saturation, cMax ];
      case blue: return [ 60 * (((red - green) / delta) + 4) || 0, saturation, cMax ];
    }
  }

  function HSVtoHSL (hsv) {
    var h = hsv[0],
      s = hsv[1]/100,
      v = hsv[2]/100,
      k = (2-s)*v;

    return [
      h,
      Math.round(s*v / (k<1 ? k : 2-k) * 10000) / 100,
      k/2 * 100
    ];
  }

  function stringToInteger (string) {
    var total = 0
    for (var i = 0; i !== string.length; i++) {
      if (total >= Number.MAX_SAFE_INTEGER) break;
      total += string.charCodeAt(i)
    }
    return total
  }

  // get The range of given hue when options.count!=0
  function getRealHueRange(colorHue)
  { if (!isNaN(colorHue)) {
    var number = parseInt(colorHue);

    if (number < 360 && number > 0) {
      return getColorInfo(colorHue).hueRange
    }
  }
    else if (typeof colorHue === 'string') {

      if (colorDictionary[colorHue]) {
        var color = colorDictionary[colorHue];

        if (color.hueRange) {
          return color.hueRange
       }
    } else if (colorHue.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
        var hue = HexToHSB(colorHue)[0]
        return getColorInfo(hue).hueRange
    }
  }

    return [0,360]
}
  return randomColor;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)(module)))

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*! @vimeo/player v2.10.0 | (c) 2019 Vimeo | MIT License | https://github.com/vimeo/player.js */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/**
 * @module lib/functions
 */

/**
 * Check to see this is a node environment.
 * @type {Boolean}
 */

/* global global */
var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */

function getMethodName(prop, type) {
  if (prop.indexOf(type.toLowerCase()) === 0) {
    return prop;
  }

  return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */

function isDomElement(element) {
  return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */

function isInteger(value) {
  // eslint-disable-next-line eqeqeq
  return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */

function isVimeoUrl(url) {
  return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */

function getVimeoUrl() {
  var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = oEmbedParameters.id;
  var url = oEmbedParameters.url;
  var idOrUrl = id || url;

  if (!idOrUrl) {
    throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
  }

  if (isInteger(idOrUrl)) {
    return "https://vimeo.com/".concat(idOrUrl);
  }

  if (isVimeoUrl(idOrUrl)) {
    return idOrUrl.replace('http:', 'https:');
  }

  if (id) {
    throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
  }

  throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}

var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';

if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
  throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
}

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*!
 * weakmap-polyfill v2.0.0 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2016 polygon planet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function (self) {

  if (self.WeakMap) {
    return;
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  var defineProperty = function (object, name, value) {
    if (Object.defineProperty) {
      Object.defineProperty(object, name, {
        configurable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };

  self.WeakMap = function () {
    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
      if (this === void 0) {
        throw new TypeError("Constructor WeakMap requires 'new'");
      }

      defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])

      if (arguments.length > 0) {
        // Currently, WeakMap `iterable` argument is not supported
        throw new TypeError('WeakMap iterable is not supported');
      }
    } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)


    defineProperty(WeakMap.prototype, 'delete', function (key) {
      checkInstance(this, 'delete');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        delete key[this._id];
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)

    defineProperty(WeakMap.prototype, 'get', function (key) {
      checkInstance(this, 'get');

      if (!isObject(key)) {
        return void 0;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return entry[1];
      }

      return void 0;
    }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)

    defineProperty(WeakMap.prototype, 'has', function (key) {
      checkInstance(this, 'has');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)

    defineProperty(WeakMap.prototype, 'set', function (key, value) {
      checkInstance(this, 'set');

      if (!isObject(key)) {
        throw new TypeError('Invalid value used as weak map key');
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        entry[1] = value;
        return this;
      }

      defineProperty(key, this._id, [key, value]);
      return this;
    });

    function checkInstance(x, methodName) {
      if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
        throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
      }
    }

    function genId(prefix) {
      return prefix + '_' + rand() + '.' + rand();
    }

    function rand() {
      return Math.random().toString().substring(2);
    }

    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
  }();

  function isObject(x) {
    return Object(x) === x;
  }
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

var npo_src = createCommonjsModule(function (module) {
/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/
(function UMD(name, context, definition) {
  // special form of UMD for polyfilling across evironments
  context[name] = context[name] || definition();

  if (module.exports) {
    module.exports = context[name];
  }
})("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

  var builtInProp,
      cycle,
      scheduling_queue,
      ToString = Object.prototype.toString,
      timer = typeof setImmediate != "undefined" ? function timer(fn) {
    return setImmediate(fn);
  } : setTimeout; // dammit, IE8.

  try {
    Object.defineProperty({}, "x", {});

    builtInProp = function builtInProp(obj, name, val, config) {
      return Object.defineProperty(obj, name, {
        value: val,
        writable: true,
        configurable: config !== false
      });
    };
  } catch (err) {
    builtInProp = function builtInProp(obj, name, val) {
      obj[name] = val;
      return obj;
    };
  } // Note: using a queue instead of array for efficiency


  scheduling_queue = function Queue() {
    var first, last, item;

    function Item(fn, self) {
      this.fn = fn;
      this.self = self;
      this.next = void 0;
    }

    return {
      add: function add(fn, self) {
        item = new Item(fn, self);

        if (last) {
          last.next = item;
        } else {
          first = item;
        }

        last = item;
        item = void 0;
      },
      drain: function drain() {
        var f = first;
        first = last = cycle = void 0;

        while (f) {
          f.fn.call(f.self);
          f = f.next;
        }
      }
    };
  }();

  function schedule(fn, self) {
    scheduling_queue.add(fn, self);

    if (!cycle) {
      cycle = timer(scheduling_queue.drain);
    }
  } // promise duck typing


  function isThenable(o) {
    var _then,
        o_type = typeof o;

    if (o != null && (o_type == "object" || o_type == "function")) {
      _then = o.then;
    }

    return typeof _then == "function" ? _then : false;
  }

  function notify() {
    for (var i = 0; i < this.chain.length; i++) {
      notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    }

    this.chain.length = 0;
  } // NOTE: This is a separate function to isolate
  // the `try..catch` so that other code can be
  // optimized better


  function notifyIsolated(self, cb, chain) {
    var ret, _then;

    try {
      if (cb === false) {
        chain.reject(self.msg);
      } else {
        if (cb === true) {
          ret = self.msg;
        } else {
          ret = cb.call(void 0, self.msg);
        }

        if (ret === chain.promise) {
          chain.reject(TypeError("Promise-chain cycle"));
        } else if (_then = isThenable(ret)) {
          _then.call(ret, chain.resolve, chain.reject);
        } else {
          chain.resolve(ret);
        }
      }
    } catch (err) {
      chain.reject(err);
    }
  }

  function resolve(msg) {
    var _then,
        self = this; // already triggered?


    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    try {
      if (_then = isThenable(msg)) {
        schedule(function () {
          var def_wrapper = new MakeDefWrapper(self);

          try {
            _then.call(msg, function $resolve$() {
              resolve.apply(def_wrapper, arguments);
            }, function $reject$() {
              reject.apply(def_wrapper, arguments);
            });
          } catch (err) {
            reject.call(def_wrapper, err);
          }
        });
      } else {
        self.msg = msg;
        self.state = 1;

        if (self.chain.length > 0) {
          schedule(notify, self);
        }
      }
    } catch (err) {
      reject.call(new MakeDefWrapper(self), err);
    }
  }

  function reject(msg) {
    var self = this; // already triggered?

    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    self.msg = msg;
    self.state = 2;

    if (self.chain.length > 0) {
      schedule(notify, self);
    }
  }

  function iteratePromises(Constructor, arr, resolver, rejecter) {
    for (var idx = 0; idx < arr.length; idx++) {
      (function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
          resolver(idx, msg);
        }, rejecter);
      })(idx);
    }
  }

  function MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
  }

  function MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
  }

  function Promise(executor) {
    if (typeof executor != "function") {
      throw TypeError("Not a function");
    }

    if (this.__NPO__ !== 0) {
      throw TypeError("Not a promise");
    } // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise


    this.__NPO__ = 1;
    var def = new MakeDef(this);

    this["then"] = function then(success, failure) {
      var o = {
        success: typeof success == "function" ? success : true,
        failure: typeof failure == "function" ? failure : false
      }; // Note: `then(..)` itself can be borrowed to be used against
      // a different promise constructor for making the chained promise,
      // by substituting a different `this` binding.

      o.promise = new this.constructor(function extractChain(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        o.resolve = resolve;
        o.reject = reject;
      });
      def.chain.push(o);

      if (def.state !== 0) {
        schedule(notify, def);
      }

      return o.promise;
    };

    this["catch"] = function $catch$(failure) {
      return this.then(void 0, failure);
    };

    try {
      executor.call(void 0, function publicResolve(msg) {
        resolve.call(def, msg);
      }, function publicReject(msg) {
        reject.call(def, msg);
      });
    } catch (err) {
      reject.call(def, err);
    }
  }

  var PromisePrototype = builtInProp({}, "constructor", Promise,
  /*configurable=*/
  false); // Note: Android 4 cannot use `Object.defineProperty(..)` here

  Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise

  builtInProp(PromisePrototype, "__NPO__", 0,
  /*configurable=*/
  false);
  builtInProp(Promise, "resolve", function Promise$resolve(msg) {
    var Constructor = this; // spec mandated checks
    // note: best "isPromise" check that's practical for now

    if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
      return msg;
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      resolve(msg);
    });
  });
  builtInProp(Promise, "reject", function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      reject(msg);
    });
  });
  builtInProp(Promise, "all", function Promise$all(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    if (arr.length === 0) {
      return Constructor.resolve([]);
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      var len = arr.length,
          msgs = Array(len),
          count = 0;
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        msgs[idx] = msg;

        if (++count === len) {
          resolve(msgs);
        }
      }, reject);
    });
  });
  builtInProp(Promise, "race", function Promise$race(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        resolve(msg);
      }, reject);
    });
  });
  return Promise;
});
});

/**
 * @module lib/callbacks
 */
var callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */

function storeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!(name in playerCallbacks)) {
    playerCallbacks[name] = [];
  }

  playerCallbacks[name].push(callback);
  callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */

function getCallbacks(player, name) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */

function removeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!playerCallbacks[name]) {
    return true;
  } // If no callback is passed, remove all callbacks for the event


  if (!callback) {
    playerCallbacks[name] = [];
    callbackMap.set(player.element, playerCallbacks);
    return true;
  }

  var index = playerCallbacks[name].indexOf(callback);

  if (index !== -1) {
    playerCallbacks[name].splice(index, 1);
  }

  callbackMap.set(player.element, playerCallbacks);
  return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */

function shiftCallbacks(player, name) {
  var playerCallbacks = getCallbacks(player, name);

  if (playerCallbacks.length < 1) {
    return false;
  }

  var callback = playerCallbacks.shift();
  removeCallback(player, name, callback);
  return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */

function swapCallbacks(oldElement, newElement) {
  var playerCallbacks = callbackMap.get(oldElement);
  callbackMap.set(newElement, playerCallbacks);
  callbackMap.delete(oldElement);
}

/**
 * @module lib/embed
 */
var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */

function getOEmbedParameters(element) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return oEmbedParameters.reduce(function (params, param) {
    var value = element.getAttribute("data-vimeo-".concat(param));

    if (value || value === '') {
      params[param] = value === '' ? 1 : value;
    }

    return params;
  }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */

function createEmbed(_ref, element) {
  var html = _ref.html;

  if (!element) {
    throw new TypeError('An element must be provided');
  }

  if (element.getAttribute('data-vimeo-initialized') !== null) {
    return element.querySelector('iframe');
  }

  var div = document.createElement('div');
  div.innerHTML = html;
  element.appendChild(div.firstChild);
  element.setAttribute('data-vimeo-initialized', 'true');
  return element.querySelector('iframe');
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */

function getOEmbedData(videoUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    if (!isVimeoUrl(videoUrl)) {
      throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
    }

    var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));

    for (var param in params) {
      if (params.hasOwnProperty(param)) {
        url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
      }
    }

    var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
    xhr.open('GET', url, true);

    xhr.onload = function () {
      if (xhr.status === 404) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
        return;
      }

      if (xhr.status === 403) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
        return;
      }

      try {
        var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed

        if (json.domain_status_code === 403) {
          // We still want to create the embed to give users visual feedback
          createEmbed(json, element);
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }

        resolve(json);
      } catch (error) {
        reject(error);
      }
    };

    xhr.onerror = function () {
      var status = xhr.status ? " (".concat(xhr.status, ")") : '';
      reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
    };

    xhr.send();
  });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function initializeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));

  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error creating an embed: ".concat(error));
    }
  };

  elements.forEach(function (element) {
    try {
      // Skip any that have data-vimeo-defer
      if (element.getAttribute('data-vimeo-defer') !== null) {
        return;
      }

      var params = getOEmbedParameters(element);
      var url = getVimeoUrl(params);
      getOEmbedData(url, params, element).then(function (data) {
        return createEmbed(data, element);
      }).catch(handleError);
    } catch (error) {
      handleError(error);
    }
  });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function resizeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  // Prevent execution if users include the player.js script multiple times.
  if (window.VimeoPlayerResizeEmbeds_) {
    return;
  }

  window.VimeoPlayerResizeEmbeds_ = true;

  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    } // 'spacechange' is fired only on embeds with cards


    if (!event.data || event.data.event !== 'spacechange') {
      return;
    }

    var iframes = parent.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow !== event.source) {
        continue;
      } // Change padding-bottom of the enclosing div to accommodate
      // card carousel without distorting aspect ratio


      var space = iframes[i].parentElement;
      space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
      break;
    }
  };

  if (window.addEventListener) {
    window.addEventListener('message', onMessage, false);
  } else if (window.attachEvent) {
    window.attachEvent('onmessage', onMessage);
  }
}

/**
 * @module lib/postmessage
 */
/**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */

function parseMessageData(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (error) {
      // If the message cannot be parsed, throw the error as a warning
      console.warn(error);
      return {};
    }
  }

  return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */

function postMessage(player, method, params) {
  if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
    return;
  }

  var message = {
    method: method
  };

  if (params !== undefined) {
    message.value = params;
  } // IE 8 and 9 do not support passing messages, so stringify them


  var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));

  if (ieVersion >= 8 && ieVersion < 10) {
    message = JSON.stringify(message);
  }

  player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */

function processData(player, data) {
  data = parseMessageData(data);
  var callbacks = [];
  var param;

  if (data.event) {
    if (data.event === 'error') {
      var promises = getCallbacks(player, data.data.method);
      promises.forEach(function (promise) {
        var error = new Error(data.data.message);
        error.name = data.data.name;
        promise.reject(error);
        removeCallback(player, data.data.method, promise);
      });
    }

    callbacks = getCallbacks(player, "event:".concat(data.event));
    param = data.data;
  } else if (data.method) {
    var callback = shiftCallbacks(player, data.method);

    if (callback) {
      callbacks.push(callback);
      param = data.value;
    }
  }

  callbacks.forEach(function (callback) {
    try {
      if (typeof callback === 'function') {
        callback.call(player, param);
        return;
      }

      callback.resolve(param);
    } catch (e) {// empty
    }
  });
}

var playerMap = new WeakMap();
var readyMap = new WeakMap();

var Player =
/*#__PURE__*/
function () {
  /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */
  function Player(element) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Player);

    /* global jQuery */
    if (window.jQuery && element instanceof jQuery) {
      if (element.length > 1 && window.console && console.warn) {
        console.warn('A jQuery object with multiple elements was passed, using the first element.');
      }

      element = element[0];
    } // Find an element by ID


    if (typeof document !== 'undefined' && typeof element === 'string') {
      element = document.getElementById(element);
    } // Not an element!


    if (!isDomElement(element)) {
      throw new TypeError('You must pass either a valid element or a valid id.');
    }

    var win = element.ownerDocument.defaultView; // Already initialized an embed in this div, so grab the iframe

    if (element.nodeName !== 'IFRAME') {
      var iframe = element.querySelector('iframe');

      if (iframe) {
        element = iframe;
      }
    } // iframe url is not a Vimeo url


    if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
      throw new Error('The player element passed isn’t a Vimeo embed.');
    } // If there is already a player object in the map, return that


    if (playerMap.has(element)) {
      return playerMap.get(element);
    }

    this.element = element;
    this.origin = '*';
    var readyPromise = new npo_src(function (resolve, reject) {
      var onMessage = function onMessage(event) {
        if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
          return;
        }

        if (_this.origin === '*') {
          _this.origin = event.origin;
        }

        var data = parseMessageData(event.data);
        var isError = data && data.event === 'error';
        var isReadyError = isError && data.data && data.data.method === 'ready';

        if (isReadyError) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          reject(error);
          return;
        }

        var isReadyEvent = data && data.event === 'ready';
        var isPingResponse = data && data.method === 'ping';

        if (isReadyEvent || isPingResponse) {
          _this.element.setAttribute('data-ready', 'true');

          resolve();
          return;
        }

        processData(_this, data);
      };

      if (win.addEventListener) {
        win.addEventListener('message', onMessage, false);
      } else if (win.attachEvent) {
        win.attachEvent('onmessage', onMessage);
      }

      if (_this.element.nodeName !== 'IFRAME') {
        var params = getOEmbedParameters(element, options);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
          // but store reference to the original element

          _this.element = iframe;
          _this._originalElement = element;
          swapCallbacks(element, iframe);
          playerMap.set(_this.element, _this);
          return data;
        }).catch(reject);
      }
    }); // Store a copy of this Player in the map

    readyMap.set(this, readyPromise);
    playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
    // the player is already ready.

    if (this.element.nodeName === 'IFRAME') {
      postMessage(this, 'ping');
    }

    return this;
  }
  /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */


  _createClass(Player, [{
    key: "callMethod",
    value: function callMethod(name) {
      var _this2 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new npo_src(function (resolve, reject) {
        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return
        return _this2.ready().then(function () {
          storeCallback(_this2, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this2, name, args);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */

  }, {
    key: "get",
    value: function get(name) {
      var _this3 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return

        return _this3.ready().then(function () {
          storeCallback(_this3, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this3, name);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */

  }, {
    key: "set",
    value: function set(name, value) {
      var _this4 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'set');

        if (value === undefined || value === null) {
          throw new TypeError('There must be a value to set.');
        } // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return


        return _this4.ready().then(function () {
          storeCallback(_this4, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this4, name, value);
        }).catch(reject);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */

  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (!callback) {
        throw new TypeError('You must pass a callback function.');
      }

      if (typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var callbacks = getCallbacks(this, "event:".concat(eventName));

      if (callbacks.length === 0) {
        this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }

      storeCallback(this, "event:".concat(eventName), callback);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */

  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (callback && typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener

      if (lastCallback) {
        this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id successfully loaded.
     * @reject {TypeError} The id was not a number.
     */

    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|object} options The id of the video or an object with embed options.
     * @return {LoadVideoPromise}
     */

  }, {
    key: "loadVideo",
    value: function loadVideo(options) {
      return this.callMethod('loadVideo', options);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */

    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */

  }, {
    key: "ready",
    value: function ready() {
      var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
        reject(new Error('Unknown player. Probably unloaded.'));
      });
      return npo_src.resolve(readyPromise);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */

  }, {
    key: "addCuePoint",
    value: function addCuePoint(time) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.callMethod('addCuePoint', {
        time: time,
        data: data
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */

  }, {
    key: "removeCuePoint",
    value: function removeCuePoint(id) {
      return this.callMethod('removeCuePoint', id);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */

    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */

    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */

  }, {
    key: "enableTextTrack",
    value: function enableTextTrack(language, kind) {
      if (!language) {
        throw new TypeError('You must pass a language.');
      }

      return this.callMethod('enableTextTrack', {
        language: language,
        kind: kind
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */

    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */

  }, {
    key: "disableTextTrack",
    value: function disableTextTrack() {
      return this.callMethod('disableTextTrack');
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */

    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */

  }, {
    key: "pause",
    value: function pause() {
      return this.callMethod('pause');
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */

    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */

  }, {
    key: "play",
    value: function play() {
      return this.callMethod('play');
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */

    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */

  }, {
    key: "unload",
    value: function unload() {
      return this.callMethod('unload');
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;

      return new npo_src(function (resolve) {
        readyMap.delete(_this5);
        playerMap.delete(_this5.element);

        if (_this5._originalElement) {
          playerMap.delete(_this5._originalElement);

          _this5._originalElement.removeAttribute('data-vimeo-initialized');
        }

        if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
          _this5.element.parentNode.removeChild(_this5.element);
        }

        resolve();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */

  }, {
    key: "getAutopause",
    value: function getAutopause() {
      return this.get('autopause');
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */

  }, {
    key: "setAutopause",
    value: function setAutopause(autopause) {
      return this.set('autopause', autopause);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */

    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */

  }, {
    key: "getBuffered",
    value: function getBuffered() {
      return this.get('buffered');
    }
    /**
     * A promise to get the color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */

    /**
     * Get the color for this player.
     *
     * @return {GetColorPromise}
     */

  }, {
    key: "getColor",
    value: function getColor() {
      return this.get('color');
    }
    /**
     * A promise to set the color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */

    /**
     * Set the color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */

  }, {
    key: "setColor",
    value: function setColor(color) {
      return this.set('color', color);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */

    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */

  }, {
    key: "getCuePoints",
    value: function getCuePoints() {
      return this.get('cuePoints');
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */

    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.get('currentTime');
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */

    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */

  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(currentTime) {
      return this.set('currentTime', currentTime);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */

    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.get('duration');
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */

    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */

  }, {
    key: "getEnded",
    value: function getEnded() {
      return this.get('ended');
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */

    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getLoop",
    value: function getLoop() {
      return this.get('loop');
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */

    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */

  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      return this.set('loop', loop);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */

    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */

  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      return this.set('muted', muted);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */

    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */

  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.get('muted');
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */

    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getPaused",
    value: function getPaused() {
      return this.get('paused');
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
     */

    /**
     * Get the playback rate of the player on a scale from `0.5` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */

  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.get('playbackRate');
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
     */

    /**
     * Set the playback rate of the player on a scale from `0.5` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */

  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(playbackRate) {
      return this.set('playbackRate', playbackRate);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */

    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */

  }, {
    key: "getPlayed",
    value: function getPlayed() {
      return this.get('played');
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */

    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */

  }, {
    key: "getSeekable",
    value: function getSeekable() {
      return this.get('seekable');
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */

    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */

  }, {
    key: "getSeeking",
    value: function getSeeking() {
      return this.get('seeking');
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */

    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */

  }, {
    key: "getTextTracks",
    value: function getTextTracks() {
      return this.get('textTracks');
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */

    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */

  }, {
    key: "getVideoEmbedCode",
    value: function getVideoEmbedCode() {
      return this.get('videoEmbedCode');
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */

    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */

  }, {
    key: "getVideoId",
    value: function getVideoId() {
      return this.get('videoId');
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */

    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */

  }, {
    key: "getVideoTitle",
    value: function getVideoTitle() {
      return this.get('videoTitle');
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */

    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */

  }, {
    key: "getVideoWidth",
    value: function getVideoWidth() {
      return this.get('videoWidth');
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */

    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */

  }, {
    key: "getVideoHeight",
    value: function getVideoHeight() {
      return this.get('videoHeight');
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */

    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */

  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      return this.get('videoUrl');
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */

    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */

  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.get('volume');
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */

    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      return this.set('volume', volume);
    }
  }]);

  return Player;
}(); // Setup embed only if this is not a node environment


if (!isNode) {
  initializeEmbeds();
  resizeEmbeds();
}

/* harmony default export */ __webpack_exports__["a"] = (Player);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22), __webpack_require__(92).setImmediate))

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Praise_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bdf0fdf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Praise_vue__ = __webpack_require__(421);
function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Praise_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bdf0fdf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Praise_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(420);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0440c058", content, true, {});

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports
exports.i(__webpack_require__(134), "");

// module
exports.push([module.i, ".pb-0{padding-bottom:0}.pb-1{padding-bottom:10px}.pb-2{padding-bottom:20px}.pr-1,.px-1{padding-right:10px}.px-1{padding-left:10px}.py-1{padding-top:5px;padding-bottom:5px}@media screen and (min-width:48em){.py-1{padding-top:10px;padding-bottom:10px}}.py-2{padding-top:20px;padding-bottom:20px}.mb-0{margin-bottom:0}.mb-1{margin-bottom:10px}.mb-15{margin-bottom:15px}.mb-2{margin-bottom:20px}.mb-4{margin-bottom:40px}.mx-auto{margin-left:auto;margin-right:auto}.my-0{margin-top:0;margin-bottom:0}.my-2{margin-top:20px;margin-bottom:20px}.is--flex{display:flex;flex-wrap:wrap;flex-direction:row}.justify-content-start{justify-content:flex-start}.justify-content-center{justify-content:center}.justify-content-end{justify-content:flex-end}.justify-content-between{justify-content:space-between}.justify-content-around{justify-content:space-around}.flex-wrap{flex-wrap:wrap}.align-items-center{align-items:center}.align-items-baseline{align-items:baseline}.align-items-start{align-items:flex-start}.flex-fill{-ms-flex:1 1 auto;flex:1 1 auto}.cursor-pointer{cursor:pointer}.icofont-close:before{content:\"\\EEE4\"}.icofont-info:before{content:\"\\EF50\"}.icofont-plus:before{content:\"\\EFC2\"}.icofont-arrow-left:before{content:\"\\EA5C\"}.btn--plain{background:none;border:none;border-radius:0;font-size:20px}.btn--plain:focus{outline:none}.btn.is--third{padding:2px 12px;line-height:34px}.btn.is--third.is--small{line-height:30px}.btn.is--third.is--large{line-height:38px}.btn--plain.has--extra-space,.btn.has--extra-space{width:40px;height:40px}.btn--plain.has--extra-space-left,.btn.has--extra-space-left{text-align:left}.btn--plain.has--extra-space-right,.btn.has--extra-space-right{text-align:right}.btn--plain.is--primary-icon,.btn--plain i.icon--trash,.btn.is--primary-icon,.btn i.icon--trash{color:#009fe3}.btn--plain.button-guide i,.btn.button-guide i{color:#009600}body{overflow:hidden}#nprogress .spinner{display:none}.is--leonardo{position:fixed;top:0;bottom:0;left:0;right:0;background:#fff;z-index:600}.is--leonardo .leonardo-wrapper{position:relative;height:100%;display:flex;flex-flow:column;margin:0 auto;max-width:78.75em;box-shadow:0 0 5px 0 rgba(0,0,0,.2)}.is--leonardo .leonardo-wrapper .is--intro-video{display:flex;flex-grow:1;flex-direction:column;justify-content:center;align-items:center;background-color:hsla(0,0%,100%,.8)}.is--leonardo .leonardo-wrapper .is--intro-video #player{position:relative;z-index:999;margin:0 auto 30px;flex-grow:1;background-color:#fff;background-image:url(/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg);background-position:50%;background-repeat:no-repeat}.is--leonardo .leonardo-wrapper .is--intro-video #player .is--after-video-uploader,.is--leonardo .leonardo-wrapper .is--intro-video #player.show--border iframe{box-shadow:0 0 20px #009fe3}.is--leonardo .leonardo-wrapper .is--intro-video #player iframe{display:block}.is--leonardo .leonardo-wrapper .is--intro-video #player .is--after-video-uploader{position:relative;background-color:#009fe3;background-image:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/video-upload.png\");background-repeat:no-repeat;background-size:contain;width:100%;height:100%;cursor:pointer}.is--leonardo .leonardo-wrapper .is--intro-video #player .is--after-video-uploader img{position:absolute;left:9px;bottom:9px;width:67px;cursor:pointer}.is--leonardo .leonardo-wrapper .is--intro-video .is-actions{text-align:center;margin-bottom:50px}.is--leonardo .leonardo-wrapper .is--intro-video .is-actions button{background-color:#009600;font-size:19px;margin-bottom:10px}.is--leonardo .leonardo-wrapper .is--intro-video .is-actions .uploadhint{font-size:14px}.is--netiplexipeopleleonardo{flex-grow:1;display:flex;flex-direction:column;justify-content:center;overflow:auto}.is--netiplexipeopleleonardo .content--upload{align-self:center;height:100%;width:100%}.is--netiplexipeopleleonardo .content--title{font-size:1.4rem;font-weight:400}.is--netiplexipeopleleonardo .content--title.hide--mobile{display:none}@media screen and (min-width:48em){.is--netiplexipeopleleonardo .content--title.hide--mobile{display:block}}.is--netiplexipeopleleonardo .product--image-container{width:100%;padding-top:10px;margin-bottom:20px}@media screen and (min-width:48em){.is--netiplexipeopleleonardo .product--image-container{width:65%}}.is--netiplexipeopleleonardo .product--buybox{width:100%}@media screen and (min-width:48em){.is--netiplexipeopleleonardo .product--buybox{width:35%}}.is--netiplexipeopleleonardo .product--buybox .buybox--container{display:flex;justify-content:center;flex-wrap:wrap}@media screen and (min-width:48em){.is--netiplexipeopleleonardo .product--buybox .buybox--container{justify-content:space-between}}.is--netiplexipeopleleonardo .product--buybox .buybox--container .price--container{font-size:20px;color:#009fe3}.is--netiplexipeopleleonardo .product--buybox .buybox--container .price--container .price--content{color:#009fe3}.praise{left:50%;top:50%;width:400px;margin:-235px 0 0 -200px;z-index:1000000002;position:absolute;box-sizing:content-box;padding:10px;background-color:#fff;border-radius:3px;box-shadow:0 1px 10px rgba(0,0,0,.4);-webkit-transition:opacity .1s ease-out;-moz-transition:opacity .1s ease-out;-ms-transition:opacity .1s ease-out;-o-transition:opacity .1s ease-out;transition:opacity .1s ease-out;align-items:center}.praise,.praise button{text-align:center}@media screen and (max-width:420px){.praise{left:inherit;top:inherit;margin:inherit;max-width:320px}}.bg{position:fixed;left:0;top:0;z-index:100000001;right:0;bottom:0;background-color:hsla(0,0%,100%,.6)}.is--show{visibility:visible}.is--out{display:none}", ""]);

// exports


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"praise"},[_c('img',{attrs:{"alt":"Gut gemacht, den Rest machen wir!","src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/praise.png"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn is--primary is--center is--large",on:{"click":_vm.close}},[_vm._v("Ok, weiter zu Größe & Sockel")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Nach")]),_vm._v(" Deiner Bestellung schneiden"),_c('br'),_vm._v(" "),_c('b',[_vm._v("Grafiker")]),_vm._v(" Dein Motiv "),_c('b',[_vm._v("perfekt")]),_vm._v(" aus.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leonardo-wrapper"},[_c('v-dialog'),_vm._v(" "),_c('app-navigation',{ref:"navigation",attrs:{"images":_vm.images,"plexipeople":_vm.plexipeople,"enableButtons":!(_vm.isInAppBrowser || _vm.showBrowserPreloadingSplash || _vm.extractorOpen || _vm.showIntroVideo)},on:{"openExtractor":_vm.openExtractor,"addImage":_vm.addImage,"completeImage":_vm.completeImage,"startIntro":function($event){return _vm.startIntro('navigation', true)},"remove":_vm.removeExtraction,"edit":_vm.openExtractor}}),_vm._v(" "),(_vm.isInAppBrowser)?[_c('in-app-browser-tutorial')]:[(_vm.loadingSplashOpen)?_c('app-loading-splash'):_vm._e(),_vm._v(" "),(_vm.showIntroVideo)?_c('div',{staticClass:"is--intro-video"},[_c('div',{ref:"player",class:{'show--border': _vm.videoLoaded},attrs:{"id":"player"}},[(_vm.introVideoShown)?_c('div',{staticClass:"is--after-video-uploader",style:(_vm.afterVideoLayerStyle),on:{"click":_vm.closeIntroVideo}},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/replay-video.png","alt":"Replay"},on:{"click":function($event){$event.stopPropagation();return _vm.initIntroVideo($event)}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"is-actions"},[_c('button',{staticClass:"btn is--primary is--center",on:{"click":_vm.closeIntroVideo}},[_vm._v("\n                    "+_vm._s(_vm.$t('introVideo.uploadButton'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"uploadhint"},[_vm._v("(JPG,BMP,PNG,TIFF, max. 25 MB)")])])]):_vm._e(),_vm._v(" "),(!_vm.showIntroVideo)?_c('div',{staticClass:"is--netiplexipeopleleonardo"},[(_vm.showBrowserPreloadingSplash)?[_vm._m(0)]:_vm._e(),_vm._v(" "),(!_vm.showBrowserPreloadingSplash && _vm.extractorOpen && !_vm.loadingSplashOpen)?_c('div',{staticClass:"content--upload"},[_c('app-extractor',{attrs:{"viewport":_vm.viewport,"config":_vm.extractor,"preview":_vm.preview,"availableHeight":_vm.availableHeight},on:{"addExtraction":_vm.addExtraction,"addToEditor":_vm.addToEditor,"openExtractor":_vm.openExtractor,"close":_vm.closeExtractor}})],1):_vm._e(),_vm._v(" "),(!(_vm.showBrowserPreloadingSplash || _vm.loadingSplashOpen || _vm.imagesOpen || _vm.extractorOpen))?_c('div',{staticClass:"is--flex mx-2"},[_c('praise',{class:{ 'is--show': _vm.openPraise, 'is--out': ! _vm.openPraise },attrs:{"name":"praise","transition":"scale","height":'100%',"width":'100%'},on:{"closePraise":_vm.closePraise}}),_vm._v(" "),_c('div',{staticClass:"product--image-container"},[(!(_vm.imagesOpen || _vm.extractorOpen))?_c('app-editor',{attrs:{"viewport":_vm.viewport,"plexipeople":_vm.plexipeople,"base":_vm.base,"is-loading":_vm.loadingSplashOpen,"preload-active":_vm.showPreloader},on:{"viewportFactorChanged":_vm.setViewportFactor,"activated":_vm.setActivePlexipeople,"deactivated":_vm.deactivePlexipeople,"preloaderDone":_vm.preloaderDone,"mounted":_vm.restoreDataFromRecord}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"product--buybox hide--mobile"},[_c('app-price-list',{attrs:{"base":_vm.base,"plexipeople":_vm.plexipeople,"viewport":_vm.viewport,"activePlexipeople":_vm.visualization.plexipeople},on:{"activatePlexipeople":_vm.activatePlexipeople,"baseWidthChanged":_vm.setBaseWidth,"priceUpdated":_vm.setPrice}}),_vm._v(" "),(!_vm.viewport.isMobile)?_c('div',{staticClass:"content--title mb-1"},[_vm._v(_vm._s(_vm.$t("editor.chooseBaseHeadline"))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('app-base',{attrs:{"base":_vm.base,"plexipeople":_vm.plexipeople,"viewport":_vm.viewport}}),_vm._v(" "),(! (_vm.loadingSplashOpen || _vm.imagesOpen || _vm.extractorOpen))?_c('div',{staticClass:"buybox--container"},[(!_vm.viewport.isMobile)?_c('div',{staticClass:"price--container"},[_c('div',{staticClass:"product--price"},[_c('span',{staticClass:"price--label"}),_vm._v("Dein Preis\n                                "),_c('span',{staticClass:"price--content"},[_vm._v(_vm._s(_vm.price)+"*")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"price--content",staticStyle:{"font-size":"12px"}},[_vm._v("inkl. MwSt. zzgl. Versandkosten")])]),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),_c('app-buy-button',{attrs:{"base":_vm.base,"plexipeople":_vm.plexipeople,"viewport":_vm.viewport,"price":_vm.price,"quantity":_vm.quantity,"record":_vm.record},on:{"quantity-changed":_vm.updateQuantity}})],1):_vm._e()],1)],1):_vm._e()],2):_vm._e()]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloading-images-indicator mx-auto"},[_c('img',{attrs:{"src":"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg","alt":"Loading"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product--delivery"},[_c('p',{staticClass:"delivery--information"},[_c('span',{staticClass:"delivery--text delivery--text-not-available"},[_c('i',{staticClass:"delivery--status-icon delivery--status-not-available"}),_vm._v("Lieferzeit: "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("Keine garantierte "),_c('br'),_vm._v("Lieferung vor dem Valentinstag ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(424);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 424 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * vue-i18n v8.9.0 
 * (c) 2019 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * utilities
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || Array.isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject(args[1]) || Array.isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/*  */

function extend (Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get () { return this._i18n }
    });
  }

  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
  };

  Vue.prototype.$d = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
  };

  Vue.prototype.$n = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
  };
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages = {};
            options.__i18n.forEach(function (resource) {
              localeMessages = merge(localeMessages, JSON.parse(resource));
            });
            Object.keys(localeMessages).forEach(function (locale) {
              options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
            });
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData();
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (isPlainObject(options.i18n)) {
        // component local i18n
        if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
          options.i18n.root = this.$root;
          options.i18n.formatter = this.$root.$i18n.formatter;
          options.i18n.fallbackLocale = this.$root.$i18n.fallbackLocale;
          options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
          options.i18n.silentFallbackWarn = this.$root.$i18n.silentFallbackWarn;
          options.i18n.pluralizationRules = this.$root.$i18n.pluralizationRules;
          options.i18n.preserveDirectiveContent = this.$root.$i18n.preserveDirectiveContent;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages$1 = {};
            options.__i18n.forEach(function (resource) {
              localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
            });
            options.i18n.messages = localeMessages$1;
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData();
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale();
        }
      } else {
        if (false) {
          warn("Cannot be interpreted 'i18n' option.");
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    var self = this;
    this.$nextTick(function () {
      if (self._subscribing) {
        self._i18n.unsubscribeDataChanging(self);
        delete self._subscribing;
      }

      if (self._i18nWatcher) {
        self._i18nWatcher();
        self._i18n.destroyVM();
        delete self._i18nWatcher;
      }

      if (self._localeWatcher) {
        self._localeWatcher();
        delete self._localeWatcher;
      }

      self._i18n = null;
    });
  }
};

/*  */

var component = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var data = ref.data;
    var children = ref.children;
    var parent = ref.parent;

    var i18n = parent.$i18n;

    children = (children || []).filter(function (child) {
      return child.tag || (child.text = child.text.trim())
    });

    if (!i18n) {
      if (false) {
        warn('Cannot find VueI18n instance!');
      }
      return children
    }

    var path = props.path;
    var locale = props.locale;

    var params = {};
    var places = props.places || {};

    var hasPlaces = Array.isArray(places)
      ? places.length > 0
      : Object.keys(places).length > 0;

    var everyPlace = children.every(function (child) {
      if (child.data && child.data.attrs) {
        var place = child.data.attrs.place;
        return (typeof place !== 'undefined') && place !== ''
      }
    });

    if (false) {
      warn('If places prop is set, all child elements must have place prop set.');
    }

    if (Array.isArray(places)) {
      places.forEach(function (el, i) {
        params[i] = el;
      });
    } else {
      Object.keys(places).forEach(function (key) {
        params[key] = places[key];
      });
    }

    children.forEach(function (child, i) {
      var key = everyPlace
        ? ("" + (child.data.attrs.place))
        : ("" + i);
      params[key] = child;
    });

    return h(props.tag, data, i18n.i(path, locale, params))
  }
};

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) &&
    (looseEqual(binding.value, binding.oldValue) &&
     looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return
  }

  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = '';
  }
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
  el._localeMessage = undefined;
  delete el['_localeMessage'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('VueI18n instance does not exists in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn('value type not supported');
    return
  }

  if (!path) {
    warn('`path` is required in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (typeof value === 'string') {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue;

function install (_Vue) {
  /* istanbul ignore if */
  if (false) {
    warn('already installed.');
    return
  }
  install.installed = true;

  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if (false) {
    warn(("vue-i18n (" + (install.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
    return
  }

  extend(Vue);
  Vue.mixin(mixin);
  Vue.directive('t', { bind: bind, update: update, unbind: unbind });
  Vue.component(component.name, component);

  // use simple mergeStrategies to prevent i18n instance lose '__proto__'
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === '}';

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (false) {
            warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
          }
        }
        break
      case 'unknown':
        if (false) {
          warn("Detect 'unknown' type of token!");
        }
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path parser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  return 'ident'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null
  } else {
    var length = paths.length;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        return null
      }
      last = value;
      i++;
    }

    return last
  }
};

/*  */



var numberFormatKeys = [
  'style',
  'currency',
  'currencyDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits',
  'localeMatcher',
  'formatMatcher'
];
var linkKeyMatcher = /(?:@(?:\.[a-z]+)?:(?:[\w\-_|.]+|\([\w\-_|.]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-z]+))?:/;
var bracketsMatcher = /[()]/g;
var formatters = {
  'upper': function (str) { return str.toLocaleUpperCase(); },
  'lower': function (str) { return str.toLocaleLowerCase(); }
};

var defaultFormatter = new BaseFormatter();

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : !!options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === undefined
    ? false
    : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = [];
  this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
    ? false
    : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};

  this._exist = function (message, key) {
    if (!message || !key) { return false }
    if (!isNull(this$1._path.getPathValue(message, key))) { return true }
    // fallback for flat key
    if (message[key]) { return true }
    return false
  };

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true } };

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data });
  Vue.config.silent = silent;
};

VueI18n.prototype.destroyVM = function destroyVM () {
  this._vm.$destroy();
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.push(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
  var self = this;
  return this._vm.$watch('$data', function () {
    var i = self._dataListeners.length;
    while (i--) {
      Vue.nextTick(function () {
        self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale () {
  /* istanbul ignore if */
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.$i18n.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    target.$forceUpdate();
  }, { immediate: true })
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
prototypeAccessors.availableLocales.get = function () { return Object.keys(this.messages).sort() };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

prototypeAccessors.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
prototypeAccessors.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

prototypeAccessors.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
prototypeAccessors.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (typeof missingRet === 'string') {
      return missingRet
    }
  } else {
    if (false) {
      warn(
        "Cannot translate the value of keypath '" + key + "'. " +
        'Use the value of keypath as default.'
      );
    }
  }
  return key
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale) {
  return this._silentFallbackWarn && (this._isFallbackRoot() || locale !== this.fallbackLocale)
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (Array.isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (typeof ret !== 'string') {
        if (false) {
          warn(("Value of key '" + key + "' is not a string!"));
        }
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (typeof pathRet === 'string') {
      ret = pathRet;
    } else {
      if (false) {
        warn(("Value of key '" + key + "' is not a string!"));
      }
      return null
    }
  }

  // Check for the existence of links within the translated string
  if (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0) {
    ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
  }

  return this._render(ret, interpolateMode, values, key)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
    var this$1 = this;

  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(linkKeyMatcher);
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
      var formatterName = linkKeyPrefixMatches[1];

    // Remove the leading @:, @.case: and the brackets
    var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

    if (visitedLinkStack.includes(linkPlaceholder)) {
      if (false) {
        warn(("Circular reference found. \"" + link + "\" is already visited in the chain of " + (visitedLinkStack.reverse().join(' <- '))));
      }
      return ret
    }
    visitedLinkStack.push(linkPlaceholder);

    // Translate the link
    var translated = this$1._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values,
      visitedLinkStack
    );

    if (this$1._isFallbackRoot(translated)) {
      if (false) {
        warn(("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale."));
      }
      /* istanbul ignore if */
      if (!this$1._root) { throw Error('unexpected error') }
      var root = this$1._root.$i18n;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this$1._warnDefault(
      locale, linkPlaceholder, translated, host,
      Array.isArray(values) ? values : [values]
    );
    if (formatters.hasOwnProperty(formatterName)) {
      translated = formatters[formatterName](translated);
    }

    visitedLinkStack.pop();

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
  var ret = this._formatter.interpolate(message, values, path);

  // If the custom formatter refuses to work - apply the default one
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }

  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' ? ret.join('') : ret
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var res =
    this._interpolate(locale, messages[locale], key, host, interpolateMode, args, [key]);
  if (!isNull(res)) { return res }

  res = this._interpolate(fallback, messages[fallback], key, host, interpolateMode, args, [key]);
  if (!isNull(res)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with '" + fallback + "' locale."));
    }
    return res
  } else {
    return null
  }
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with root locale."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
  } else {
    return this._warnDefault(locale, key, ret, host, values)
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to interpolate the keypath '" + key + "' with root locale."));
    }
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values])
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (typeof locale !== 'string') {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }

  var predefined = { 'count': choice, 'n': choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message && typeof message !== 'string') { return null }
  var choices = message.split('|');

  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
};

/**
 * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
 * @param choicesLength {number} an overall amount of available choices
 * @returns a final choice index
*/
VueI18n.prototype.getChoiceIndex = function getChoiceIndex (choice, choicesLength) {
  // Default (old) getChoiceIndex implementation - english-compatible
  var defaultImpl = function (_choice, _choicesLength) {
    _choice = Math.abs(_choice);

    if (_choicesLength === 2) {
      return _choice
        ? _choice > 1
          ? 1
          : 0
        : 1
    }

    return _choice ? Math.min(_choice, 2) : 0
  };

  if (this.locale in this.pluralizationRules) {
    return this.pluralizationRules[this.locale].apply(this, [choice, choicesLength])
  } else {
    return defaultImpl(choice, choicesLength)
  }
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  this._vm.$set(this._vm.messages, locale, merge(this._vm.messages[locale] || {}, message));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {
      warn(("Fall back to '" + fallback + "' datetime formats from '" + locale + " datetime formats."));
    }
    _locale = fallback;
    formats = dateTimeFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {
  /* istanbul ignore if */
  if (false) {
    warn('Cannot format a Date value due to not supported Intl.DateTimeFormat.');
    return ''
  }

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to datetime localization of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
};

VueI18n.prototype._localizeNumber = function _localizeNumber (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {
      warn(("Fall back to '" + fallback + "' number formats from '" + locale + " number formats."));
    }
    _locale = fallback;
    formats = numberFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (false) {
      warn('Cannot format a Number value due to not supported Intl.NumberFormat.');
    }
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var ret =
    this._localizeNumber(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to number localization of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (numberFormatKeys.includes(key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

var availabilities;
// $FlowFixMe
Object.defineProperty(VueI18n, 'availabilities', {
  get: function get () {
    if (!availabilities) {
      var intlDefined = typeof Intl !== 'undefined';
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
        numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
      };
    }

    return availabilities
  }
});

VueI18n.install = install;
VueI18n.version = '8.9.0';

/* harmony default export */ __webpack_exports__["a"] = (VueI18n);


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(91));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["vue-notification"] = factory(require("vue"));
	else
		root["vue-notification"] = factory(root["vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_20__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return events; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);

var events = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notifications_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notifications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Notifications_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var Notify = {
  install: function install(Vue) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.installed) {
      return;
    }

    this.installed = true;
    this.params = args;

    Vue.component(args.componentName || 'notifications', __WEBPACK_IMPORTED_MODULE_0__Notifications_vue___default.a);

    var notify = function notify(params) {
      if (typeof params === 'string') {
        params = { title: '', text: params };
      }

      if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
        __WEBPACK_IMPORTED_MODULE_1__events__["a" /* events */].$emit('add', params);
      }
    };

    var name = args.name || 'notify';

    Vue.prototype['$' + name] = notify;
    Vue[name] = notify;
  }
};

/* harmony default export */ __webpack_exports__["default"] = (Notify);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(15),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CssGroup',
  props: ['name']
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaults__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VelocityGroup_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VelocityGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__VelocityGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CssGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CssGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CssGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parser__ = __webpack_require__(8);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var STATE = {
  IDLE: 0,
  DESTROYED: 2
};

var Component = {
  name: 'Notifications',
  components: {
    VelocityGroup: __WEBPACK_IMPORTED_MODULE_4__VelocityGroup_vue___default.a,
    CssGroup: __WEBPACK_IMPORTED_MODULE_5__CssGroup_vue___default.a
  },
  props: {
    group: {
      type: String,
      default: ''
    },

    width: {
      type: [Number, String],
      default: 300
    },

    reverse: {
      type: Boolean,
      default: false
    },

    position: {
      type: [String, Array],
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* default */].position;
      }
    },

    classes: {
      type: String,
      default: 'vue-notification'
    },

    animationType: {
      type: String,
      default: 'css',
      validator: function validator(value) {
        return value === 'css' || value === 'velocity';
      }
    },

    animation: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* default */].velocityAnimation;
      }
    },

    animationName: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* default */].cssAnimation
    },

    speed: {
      type: Number,
      default: 300
    },

    cooldown: {
      type: Number,
      default: 0
    },

    duration: {
      type: Number,
      default: 3000
    },

    delay: {
      type: Number,
      default: 0
    },

    max: {
      type: Number,
      default: Infinity
    },

    closeOnClick: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      list: [],
      velocity: __WEBPACK_IMPORTED_MODULE_0__index__["default"].params.velocity
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__events__["a" /* events */].$on('add', this.addItem);
  },

  computed: {
    actualWidth: function actualWidth() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parser__["a" /* default */])(this.width);
    },
    isVA: function isVA() {
      return this.animationType === 'velocity';
    },
    componentName: function componentName() {
      return this.isVA ? 'VelocityGroup' : 'CssGroup';
    },
    styles: function styles() {
      var _listToDirection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* listToDirection */])(this.position),
          x = _listToDirection.x,
          y = _listToDirection.y;

      var width = this.actualWidth.value;
      var suffix = this.actualWidth.type;

      var styles = _defineProperty({
        width: width + suffix
      }, y, '0px');

      if (x === 'center') {
        styles['left'] = 'calc(50% - ' + width / 2 + suffix + ')';
      } else {
        styles[x] = '0px';
      }

      return styles;
    },
    active: function active() {
      return this.list.filter(function (v) {
        return v.state !== STATE.DESTROYED;
      });
    },
    botToTop: function botToTop() {
      return this.styles.hasOwnProperty('bottom');
    }
  },
  methods: {
    addItem: function addItem(event) {
      var _this = this;

      event.group = event.group || '';

      if (this.group !== event.group) {
        return;
      }

      if (event.clean || event.clear) {
        this.destroyAll();
        return;
      }

      var duration = typeof event.duration === 'number' ? event.duration : this.duration;

      var speed = typeof event.speed === 'number' ? event.speed : this.speed;

      var title = event.title,
          text = event.text,
          type = event.type,
          data = event.data;


      var item = {
        id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* Id */])(),
        title: title,
        text: text,
        type: type,
        state: STATE.IDLE,
        speed: speed,
        length: duration + 2 * speed,
        data: data
      };

      if (duration >= 0) {
        item.timer = setTimeout(function () {
          _this.destroy(item);
        }, item.length);
      }

      var direction = this.reverse ? !this.botToTop : this.botToTop;

      var indexToDestroy = -1;

      if (direction) {
        this.list.push(item);

        if (this.active.length > this.max) {
          indexToDestroy = 0;
        }
      } else {
        this.list.unshift(item);

        if (this.active.length > this.max) {
          indexToDestroy = this.active.length - 1;
        }
      }

      if (indexToDestroy !== -1) {
        this.destroy(this.active[indexToDestroy]);
      }
    },
    notifyClass: function notifyClass(item) {
      return ['vue-notification-template', this.classes, item.type];
    },
    notifyWrapperStyle: function notifyWrapperStyle(item) {
      return this.isVA ? null : {
        transition: 'all ' + item.speed + 'ms'
      };
    },
    destroy: function destroy(item) {
      clearTimeout(item.timer);
      item.state = STATE.DESTROYED;

      if (!this.isVA) {
        this.clean();
      }
    },
    destroyAll: function destroyAll() {
      this.active.forEach(this.destroy);
    },
    getAnimation: function getAnimation(index, el) {
      var animation = this.animation[index];

      return typeof animation === 'function' ? animation.call(this, el) : animation;
    },
    enter: function enter(_ref) {
      var el = _ref.el,
          complete = _ref.complete;

      var animation = this.getAnimation('enter', el);

      this.velocity(el, animation, {
        duration: this.speed,
        complete: complete
      });
    },
    leave: function leave(_ref2) {
      var el = _ref2.el,
          complete = _ref2.complete;

      var animation = this.getAnimation('leave', el);

      this.velocity(el, animation, {
        duration: this.speed,
        complete: complete
      });
    },
    clean: function clean() {
      this.list = this.list.filter(function (v) {
        return v.state !== STATE.DESTROYED;
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VelocityGroup',
  methods: {
    enter: function enter(el, complete) {
      this.$emit('enter', { el: el, complete: complete });
    },
    leave: function leave(el, complete) {
      this.$emit('leave', { el: el, complete: complete });
    },
    afterLeave: function afterLeave() {
      this.$emit('afterLeave');
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  position: ['top', 'right'],
  cssAnimation: 'vn-fade',
  velocityAnimation: {
    enter: function enter(el) {
      var height = el.clientHeight;

      return {
        height: [height, 0],
        opacity: [1, 0]
      };
    },
    leave: {
      height: 0,
      opacity: [0, 1]
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parse */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var floatRegexp = '[-+]?[0-9]*.?[0-9]+';

var types = [{
  name: 'px',
  regexp: new RegExp('^' + floatRegexp + 'px$')
}, {
  name: '%',
  regexp: new RegExp('^' + floatRegexp + '%$')
}, {
  name: 'px',
  regexp: new RegExp('^' + floatRegexp + '$')
}];

var getType = function getType(value) {
  if (value === 'auto') {
    return {
      type: value,
      value: 0
    };
  }

  for (var i = 0; i < types.length; i++) {
    var type = types[i];
    if (type.regexp.test(value)) {
      return {
        type: type.name,
        value: parseFloat(value)
      };
    }
  }

  return {
    type: '',
    value: value
  };
};

var parse = function parse(value) {
  switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
    case 'number':
      return { type: 'px', value: value };
    case 'string':
      return getType(value);
    default:
      return { type: '', value: value };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (parse);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Id; });
/* unused harmony export split */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listToDirection; });
var directions = {
  x: ['left', 'center', 'right'],
  y: ['top', 'bottom']
};

var Id = function (i) {
  return function () {
    return i++;
  };
}(0);

var split = function split(value) {
  if (typeof value !== 'string') {
    return [];
  }

  return value.split(/\s+/gi).filter(function (v) {
    return v;
  });
};

var listToDirection = function listToDirection(value) {
  if (typeof value === 'string') {
    value = split(value);
  }

  var x = null;
  var y = null;

  value.forEach(function (v) {
    if (directions.y.indexOf(v) !== -1) {
      y = v;
    }
    if (directions.x.indexOf(v) !== -1) {
      x = v;
    }
  });

  return { x: x, y: y };
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)();
// imports


// module
exports.push([module.i, ".notifications{display:block;position:fixed;z-index:5000}.notification-wrapper{display:block;overflow:hidden;width:100%;margin:0;padding:0}.notification-title{font-weight:600}.vue-notification-template{background:#fff}.vue-notification,.vue-notification-template{display:block;box-sizing:border-box;text-align:left}.vue-notification{font-size:12px;padding:10px;margin:0 5px 5px;color:#fff;background:#44a4fc;border-left:5px solid #187fe7}.vue-notification.warn{background:#ffb648;border-left-color:#f48a06}.vue-notification.error{background:#e54d42;border-left-color:#b82e24}.vue-notification.success{background:#68cd86;border-left-color:#42a85f}.vn-fade-enter-active,.vn-fade-leave-active,.vn-fade-move{transition:all .5s}.vn-fade-enter,.vn-fade-leave-to{opacity:0}", ""]);

// exports


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(14),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications",
    style: (_vm.styles)
  }, [_c(_vm.componentName, {
    tag: "component",
    attrs: {
      "name": _vm.animationName
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave,
      "after-leave": _vm.clean
    }
  }, _vm._l((_vm.active), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "notification-wrapper",
      style: (_vm.notifyWrapperStyle(item)),
      attrs: {
        "data-id": item.id
      }
    }, [_vm._t("body", [_c('div', {
      class: _vm.notifyClass(item),
      on: {
        "click": function($event) {
          if (_vm.closeOnClick) { _vm.destroy(item) }
        }
      }
    }, [(item.title) ? _c('div', {
      staticClass: "notification-title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "notification-content",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])], {
      item: item,
      close: function () { return _vm.destroy(item); }
    })], 2)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "name": _vm.name
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(10);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(18)("2901aeae", content, true);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(19)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["vue-js-modal"]=t():e["vue-js-modal"]=t()}(window,function(){return function(n){var i={};function o(e){if(i[e])return i[e].exports;var t=i[e]={i:e,l:!1,exports:{}};return n[e].call(t.exports,t,t.exports,o),t.l=!0,t.exports}return o.m=n,o.c=i,o.d=function(e,t,n){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(t,e){if(1&e&&(t=o(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)o.d(n,i,function(e){return t[e]}.bind(null,i));return n},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="/dist/",o(o.s=11)}([function(e,t,n){var i=n(6);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);(0,n(4).default)("27d83796",i,!1,{})},function(e,t,n){var i=n(8);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);(0,n(4).default)("0e783494",i,!1,{})},function(e,t,n){var i=n(10);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);(0,n(4).default)("17757f60",i,!1,{})},function(e,t){e.exports=function(n){var a=[];return a.toString=function(){return this.map(function(e){var t=function(e,t){var n=e[1]||"",i=e[3];if(!i)return n;if(t&&"function"==typeof btoa){var o=(a=i,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),r=i.sources.map(function(e){return"/*# sourceURL="+i.sourceRoot+e+" */"});return[n].concat(r).concat([o]).join("\n")}var a;return[n].join("\n")}(e,n);return e[2]?"@media "+e[2]+"{"+t+"}":t}).join("")},a.i=function(e,t){"string"==typeof e&&(e=[[null,e,""]]);for(var n={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(n[o]=!0)}for(i=0;i<e.length;i++){var r=e[i];"number"==typeof r[0]&&n[r[0]]||(t&&!r[2]?r[2]=t:t&&(r[2]="("+r[2]+") and ("+t+")"),a.push(r))}},a}},function(e,t,n){"use strict";function l(e,t){for(var n=[],i={},o=0;o<t.length;o++){var r=t[o],a=r[0],s={id:e+":"+o,css:r[1],media:r[2],sourceMap:r[3]};i[a]?i[a].parts.push(s):n.push(i[a]={id:a,parts:[s]})}return n}n.r(t),n.d(t,"default",function(){return p});var i="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!i)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var d={},o=i&&(document.head||document.getElementsByTagName("head")[0]),r=null,a=0,u=!1,s=function(){},c=null,h="data-vue-ssr-id",f="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function p(a,e,t,n){u=t,c=n||{};var s=l(a,e);return v(s),function(e){for(var t=[],n=0;n<s.length;n++){var i=s[n];(o=d[i.id]).refs--,t.push(o)}e?v(s=l(a,e)):s=[];for(n=0;n<t.length;n++){var o;if(0===(o=t[n]).refs){for(var r=0;r<o.parts.length;r++)o.parts[r]();delete d[o.id]}}}}function v(e){for(var t=0;t<e.length;t++){var n=e[t],i=d[n.id];if(i){i.refs++;for(var o=0;o<i.parts.length;o++)i.parts[o](n.parts[o]);for(;o<n.parts.length;o++)i.parts.push(g(n.parts[o]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{var r=[];for(o=0;o<n.parts.length;o++)r.push(g(n.parts[o]));d[n.id]={id:n.id,refs:1,parts:r}}}}function m(){var e=document.createElement("style");return e.type="text/css",o.appendChild(e),e}function g(t){var n,i,e=document.querySelector("style["+h+'~="'+t.id+'"]');if(e){if(u)return s;e.parentNode.removeChild(e)}if(f){var o=a++;e=r||(r=m()),n=w.bind(null,e,o,!1),i=w.bind(null,e,o,!0)}else e=m(),n=function(e,t){var n=t.css,i=t.media,o=t.sourceMap;i&&e.setAttribute("media",i);c.ssrId&&e.setAttribute(h,t.id);o&&(n+="\n/*# sourceURL="+o.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */");if(e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}.bind(null,e),i=function(){e.parentNode.removeChild(e)};return n(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;n(t=e)}else i()}}var b,y=(b=[],function(e,t){return b[e]=t,b.filter(Boolean).join("\n")});function w(e,t,n,i){var o=n?"":i.css;if(e.styleSheet)e.styleSheet.cssText=y(t,o);else{var r=document.createTextNode(o),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(r,a[t]):e.appendChild(r)}}},function(e,t,n){"use strict";var i=n(0);n.n(i).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.vue-modal-resizer {\n  display: block;\n  overflow: hidden;\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  right: 0;\n  bottom: 0;\n  z-index: 9999999;\n  background: transparent;\n  cursor: se-resize;\n}\n.vue-modal-resizer::after {\n  display: block;\n  position: absolute;\n  content: '';\n  background: transparent;\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 0;\n  border-bottom: 10px solid #ddd;\n  border-left: 10px solid transparent;\n}\n.vue-modal-resizer.clicked::after {\n  border-bottom: 10px solid #369be9;\n}\n",""])},function(e,t,n){"use strict";var i=n(1);n.n(i).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.v--modal-block-scroll {\n  overflow: hidden;\n  width: 100vw;\n}\n.v--modal-overlay {\n  position: fixed;\n  box-sizing: border-box;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 999;\n  opacity: 1;\n}\n.v--modal-overlay.scrollable {\n  height: 100%;\n  min-height: 100vh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.v--modal-overlay .v--modal-background-click {\n  width: 100%;\n  height: 100%;\n}\n.v--modal-overlay .v--modal-box {\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n.v--modal-overlay.scrollable .v--modal-box {\n  margin-bottom: 2px;\n}\n.v--modal {\n  background-color: white;\n  text-align: left;\n  border-radius: 3px;\n  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\n  padding: 0;\n}\n.v--modal.v--modal-fullscreen {\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  left: 0;\n  top: 0;\n}\n.v--modal-top-right {\n  display: block;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.overlay-fade-enter-active,\n.overlay-fade-leave-active {\n  transition: all 0.2s;\n}\n.overlay-fade-enter,\n.overlay-fade-leave-active {\n  opacity: 0;\n}\n.nice-modal-fade-enter-active,\n.nice-modal-fade-leave-active {\n  transition: all 0.4s;\n}\n.nice-modal-fade-enter,\n.nice-modal-fade-leave-active {\n  opacity: 0;\n  transform: translateY(-20px);\n}\n",""])},function(e,t,n){"use strict";var i=n(2);n.n(i).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.vue-dialog div {\n  box-sizing: border-box;\n}\n.vue-dialog .dialog-flex {\n  width: 100%;\n  height: 100%;\n}\n.vue-dialog .dialog-content {\n  flex: 1 0 auto;\n  width: 100%;\n  padding: 15px;\n  font-size: 14px;\n}\n.vue-dialog .dialog-c-title {\n  font-weight: 600;\n  padding-bottom: 15px;\n}\n.vue-dialog .dialog-c-text {\n}\n.vue-dialog .vue-dialog-buttons {\n  display: flex;\n  flex: 0 1 auto;\n  width: 100%;\n  border-top: 1px solid #eee;\n}\n.vue-dialog .vue-dialog-buttons-none {\n  width: 100%;\n  padding-bottom: 15px;\n}\n.vue-dialog-button {\n  font-size: 12px !important;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  cursor: pointer;\n  box-sizing: border-box;\n  line-height: 40px;\n  height: 40px;\n  color: inherit;\n  font: inherit;\n  outline: none;\n}\n.vue-dialog-button:hover {\n  background: rgba(0, 0, 0, 0.01);\n}\n.vue-dialog-button:active {\n  background: rgba(0, 0, 0, 0.025);\n}\n.vue-dialog-button:not(:first-of-type) {\n  border-left: 1px solid #eee;\n}\n",""])},function(e,t,n){"use strict";n.r(t);var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{name:t.overlayTransition}},[t.visibility.overlay?n("div",{ref:"overlay",class:t.overlayClass,attrs:{"aria-expanded":t.visibility.overlay.toString(),"data-modal":t.name}},[n("div",{staticClass:"v--modal-background-click",on:{mousedown:function(e){return e.target!==e.currentTarget?null:t.handleBackgroundClick(e)},touchstart:function(e){return e.target!==e.currentTarget?null:t.handleBackgroundClick(e)}}},[n("div",{staticClass:"v--modal-top-right"},[t._t("top-right")],2),t._v(" "),n("transition",{attrs:{name:t.transition},on:{"before-enter":t.beforeTransitionEnter,"after-enter":t.afterTransitionEnter,"after-leave":t.afterTransitionLeave}},[t.visibility.modal?n("div",{ref:"modal",class:t.modalClass,style:t.modalStyle},[t._t("default"),t._v(" "),t.resizable&&!t.isAutoHeight?n("resizer",{attrs:{"min-width":t.minWidth,"min-height":t.minHeight},on:{resize:t.handleModalResize}}):t._e()],2):t._e()])],1)]):t._e()])},o=function(){var e=this.$createElement;return(this._self._c||e)("div",{class:this.className})};o._withStripped=i._withStripped=!0;var s=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0;return function(){return(e++).toString()}}(),u=function(e,t,n){return n<e?e:t<n?t:n},r=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return function(o){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,i;t=o,i=r[n=e],n in t?Object.defineProperty(t,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[n]=i})}return o}({id:s(),timestamp:Date.now(),canceled:!1},e)},a={name:"VueJsModalResizer",props:{minHeight:{type:Number,default:0},minWidth:{type:Number,default:0}},data:function(){return{clicked:!1,size:{}}},mounted:function(){this.$el.addEventListener("mousedown",this.start,!1)},computed:{className:function(){return{"vue-modal-resizer":!0,clicked:this.clicked}}},methods:{start:function(e){this.clicked=!0,window.addEventListener("mousemove",this.mousemove,!1),window.addEventListener("mouseup",this.stop,!1),e.stopPropagation(),e.preventDefault()},stop:function(){this.clicked=!1,window.removeEventListener("mousemove",this.mousemove,!1),window.removeEventListener("mouseup",this.stop,!1),this.$emit("resize-stop",{element:this.$el.parentElement,size:this.size})},mousemove:function(e){this.resize(e)},resize:function(e){var t=this.$el.parentElement;if(t){var n=e.clientX-t.offsetLeft,i=e.clientY-t.offsetTop;n=u(this.minWidth,window.innerWidth,n),i=u(this.minHeight,window.innerHeight,i),this.size={width:n,height:i},t.style.width=n+"px",t.style.height=i+"px",this.$emit("resize",{element:t,size:this.size})}}}};n(5);function l(e,t,n,i,o,r,a,s){var l,d="function"==typeof e?e.options:e;if(t&&(d.render=t,d.staticRenderFns=n,d._compiled=!0),i&&(d.functional=!0),r&&(d._scopeId="data-v-"+r),a?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),o&&o.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(a)},d._ssrRegister=l):o&&(l=s?function(){o.call(this,this.$root.$options.shadowRoot)}:o),l)if(d.functional){d._injectStyles=l;var u=d.render;d.render=function(e,t){return l.call(t),u(e,t)}}else{var c=d.beforeCreate;d.beforeCreate=c?[].concat(c,l):[l]}return{exports:e,options:d}}var d=l(a,o,[],!1,null,null,null);d.options.__file="src/Resizer.vue";var c=d.exports;function h(e){return(h="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var f="[-+]?[0-9]*.?[0-9]+",p=[{name:"px",regexp:new RegExp("^".concat(f,"px$"))},{name:"%",regexp:new RegExp("^".concat(f,"%$"))},{name:"px",regexp:new RegExp("^".concat(f,"$"))}],v=function(e){switch(h(e)){case"number":return{type:"px",value:e};case"string":return function(e){if("auto"===e)return{type:e,value:0};for(var t=0;t<p.length;t++){var n=p[t];if(n.regexp.test(e))return{type:n.name,value:parseFloat(e)}}return{type:"",value:e}}(e);default:return{type:"",value:e}}},m=function(e){if("string"!=typeof e)return 0<=e;var t=v(e);return("%"===t.type||"px"===t.type)&&0<t.value};var g={name:"VueJsModal",props:{name:{required:!0,type:String},delay:{type:Number,default:0},resizable:{type:Boolean,default:!1},adaptive:{type:Boolean,default:!1},draggable:{type:[Boolean,String],default:!1},scrollable:{type:Boolean,default:!1},reset:{type:Boolean,default:!1},overlayTransition:{type:String,default:"overlay-fade"},transition:{type:String},clickToClose:{type:Boolean,default:!0},classes:{type:[String,Array],default:"v--modal"},minWidth:{type:Number,default:0,validator:function(e){return 0<=e}},minHeight:{type:Number,default:0,validator:function(e){return 0<=e}},maxWidth:{type:Number,default:1/0},maxHeight:{type:Number,default:1/0},width:{type:[Number,String],default:600,validator:m},height:{type:[Number,String],default:300,validator:function(e){return"auto"===e||m(e)}},pivotX:{type:Number,default:.5,validator:function(e){return 0<=e&&e<=1}},pivotY:{type:Number,default:.5,validator:function(e){return 0<=e&&e<=1}}},components:{Resizer:c},data:function(){return{visible:!1,visibility:{modal:!1,overlay:!1},shift:{left:0,top:0},modal:{width:0,widthType:"px",height:0,heightType:"px",renderedHeight:0},window:{width:0,height:0},mutationObserver:null}},created:function(){this.setInitialSize()},beforeMount:function(){var t=this;if(T.event.$on("toggle",this.handleToggleEvent),window.addEventListener("resize",this.handleWindowResize),this.handleWindowResize(),this.scrollable&&!this.isAutoHeight&&console.warn('Modal "'.concat(this.name,'" has scrollable flag set to true ')+'but height is not "auto" ('.concat(this.height,")")),this.isAutoHeight){var e=function(){if("undefined"!=typeof window)for(var e=["","WebKit","Moz","O","Ms"],t=0;t<e.length;t++){var n=e[t]+"MutationObserver";if(n in window)return window[n]}return!1}();e&&(this.mutationObserver=new e(function(e){t.updateRenderedHeight()}))}this.clickToClose&&window.addEventListener("keyup",this.handleEscapeKeyUp)},beforeDestroy:function(){T.event.$off("toggle",this.handleToggleEvent),window.removeEventListener("resize",this.handleWindowResize),this.clickToClose&&window.removeEventListener("keyup",this.handleEscapeKeyUp),this.scrollable&&document.body.classList.remove("v--modal-block-scroll")},computed:{isAutoHeight:function(){return"auto"===this.modal.heightType},position:function(){var e=this.window,t=this.shift,n=this.pivotX,i=this.pivotY,o=this.trueModalWidth,r=this.trueModalHeight,a=e.width-o,s=e.height-r,l=t.left+n*a,d=t.top+i*s;return{left:parseInt(u(0,a,l)),top:parseInt(u(0,s,d))}},trueModalWidth:function(){var e=this.window,t=this.modal,n=this.adaptive,i=this.minWidth,o=this.maxWidth,r="%"===t.widthType?e.width/100*t.width:t.width,a=Math.min(e.width,o);return n?u(i,a,r):r},trueModalHeight:function(){var e=this.window,t=this.modal,n=this.isAutoHeight,i=this.adaptive,o=this.maxHeight,r="%"===t.heightType?e.height/100*t.height:t.height;if(n)return this.modal.renderedHeight;var a=Math.min(e.height,o);return i?u(this.minHeight,a,r):r},overlayClass:function(){return{"v--modal-overlay":!0,scrollable:this.scrollable&&this.isAutoHeight}},modalClass:function(){return["v--modal-box",this.classes]},modalStyle:function(){return{top:this.position.top+"px",left:this.position.left+"px",width:this.trueModalWidth+"px",height:this.isAutoHeight?"auto":this.trueModalHeight+"px"}}},watch:{visible:function(e){var t=this;e?(this.visibility.overlay=!0,setTimeout(function(){t.visibility.modal=!0,t.$nextTick(function(){t.addDraggableListeners(),t.callAfterEvent(!0)})},this.delay)):(this.visibility.modal=!1,setTimeout(function(){t.visibility.overlay=!1,t.$nextTick(function(){t.removeDraggableListeners(),t.callAfterEvent(!1)})},this.delay))}},methods:{handleToggleEvent:function(e,t,n){if(this.name===e){var i=void 0===t?!this.visible:t;this.toggle(i,n)}},setInitialSize:function(){var e=this.modal,t=v(this.width),n=v(this.height);e.width=t.value,e.widthType=t.type,e.height=n.value,e.heightType=n.type},handleEscapeKeyUp:function(e){27===e.which&&this.visible&&this.$modal.hide(this.name)},handleWindowResize:function(){this.window.width=window.innerWidth,this.window.height=window.innerHeight},createModalEvent:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return r(function(o){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,i;t=o,i=r[n=e],n in t?Object.defineProperty(t,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[n]=i})}return o}({name:this.name,ref:this.$refs.modal},e))},handleModalResize:function(e){this.modal.widthType="px",this.modal.width=e.size.width,this.modal.heightType="px",this.modal.height=e.size.height;var t=this.modal.size;this.$emit("resize",this.createModalEvent({size:t}))},toggle:function(e,t){var n=this.reset,i=this.scrollable,o=this.visible;if(o!==e){var r=o?"before-close":"before-open";"before-open"===r?(document.activeElement&&"BODY"!==document.activeElement.tagName&&document.activeElement.blur&&document.activeElement.blur(),n&&(this.setInitialSize(),this.shift.left=0,this.shift.top=0),i&&document.body.classList.add("v--modal-block-scroll")):i&&document.body.classList.remove("v--modal-block-scroll");var a=!1,s=this.createModalEvent({stop:function(){a=!0},state:e,params:t});this.$emit(r,s),a||(this.visible=e)}},getDraggableElement:function(){var e="string"!=typeof this.draggable?".v--modal-box":this.draggable;return e?this.$refs.overlay.querySelector(e):null},handleBackgroundClick:function(){this.clickToClose&&this.toggle(!1)},callAfterEvent:function(e){e?this.connectObserver():this.disconnectObserver();var t=e?"opened":"closed",n=this.createModalEvent({state:e});this.$emit(t,n)},addDraggableListeners:function(){var r=this;if(this.draggable){var e=this.getDraggableElement();if(e){var a=0,s=0,l=0,d=0,u=function(e){return e.touches&&0<e.touches.length?e.touches[0]:e},t=function(e){var t=e.target;if(!t||"INPUT"!==t.nodeName){var n=u(e),i=n.clientX,o=n.clientY;document.addEventListener("mousemove",c),document.addEventListener("touchmove",c),document.addEventListener("mouseup",h),document.addEventListener("touchend",h),a=i,s=o,l=r.shift.left,d=r.shift.top}},c=function(e){var t=u(e),n=t.clientX,i=t.clientY;r.shift.left=l+n-a,r.shift.top=d+i-s,e.preventDefault()},h=function e(t){document.removeEventListener("mousemove",c),document.removeEventListener("touchmove",c),document.removeEventListener("mouseup",e),document.removeEventListener("touchend",e),t.preventDefault()};e.addEventListener("mousedown",t),e.addEventListener("touchstart",t)}}},removeDraggableListeners:function(){},updateRenderedHeight:function(){this.$refs.modal&&(this.modal.renderedHeight=this.$refs.modal.getBoundingClientRect().height)},connectObserver:function(){this.mutationObserver&&this.mutationObserver.observe(this.$refs.overlay,{childList:!0,attributes:!0,subtree:!0})},disconnectObserver:function(){this.mutationObserver&&this.mutationObserver.disconnect()},beforeTransitionEnter:function(){this.connectObserver()},afterTransitionEnter:function(){},afterTransitionLeave:function(){}}},b=(n(7),l(g,i,[],!1,null,null,null));b.options.__file="src/Modal.vue";var y=b.exports,w=function(){var n=this,e=n.$createElement,i=n._self._c||e;return i("modal",{attrs:{name:"dialog",height:"auto",classes:["v--modal","vue-dialog",this.params.class],width:n.width,"pivot-y":.3,adaptive:!0,clickToClose:n.clickToClose,transition:n.transition},on:{"before-open":n.beforeOpened,"before-close":n.beforeClosed,opened:function(e){n.$emit("opened",e)},closed:function(e){n.$emit("closed",e)}}},[i("div",{staticClass:"dialog-content"},[n.params.title?i("div",{staticClass:"dialog-c-title",domProps:{innerHTML:n._s(n.params.title||"")}}):n._e(),n._v(" "),n.params.component?i(n.params.component,n._b({tag:"component"},"component",n.params.props,!1)):i("div",{staticClass:"dialog-c-text",domProps:{innerHTML:n._s(n.params.text||"")}})],1),n._v(" "),n.buttons?i("div",{staticClass:"vue-dialog-buttons"},n._l(n.buttons,function(e,t){return i("button",{key:t,class:e.class||"vue-dialog-button",style:n.buttonStyle,attrs:{type:"button"},domProps:{innerHTML:n._s(e.title)},on:{click:function(e){e.stopPropagation(),n.click(t,e)}}},[n._v("\n      "+n._s(e.title)+"\n    ")])})):i("div",{staticClass:"vue-dialog-buttons-none"})])};w._withStripped=!0;var x={name:"VueJsDialog",props:{width:{type:[Number,String],default:400},clickToClose:{type:Boolean,default:!0},transition:{type:String,default:"fade"}},data:function(){return{params:{},defaultButtons:[{title:"CLOSE"}]}},computed:{buttons:function(){return this.params.buttons||this.defaultButtons},buttonStyle:function(){return{flex:"1 1 ".concat(100/this.buttons.length,"%")}}},methods:{beforeOpened:function(e){window.addEventListener("keyup",this.onKeyUp),this.params=e.params||{},this.$emit("before-opened",e)},beforeClosed:function(e){window.removeEventListener("keyup",this.onKeyUp),this.params={},this.$emit("before-closed",e)},click:function(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:"click",i=this.buttons[e];i&&"function"==typeof i.handler?i.handler(e,t,{source:n}):this.$modal.hide("dialog")},onKeyUp:function(e){if(13===e.which&&0<this.buttons.length){var t=1===this.buttons.length?0:this.buttons.findIndex(function(e){return e.default});-1!==t&&this.click(t,e,"keypress")}}}},_=(n(9),l(x,w,[],!1,null,null,null));_.options.__file="src/Dialog.vue";var E=_.exports,k=function(){var n=this,e=n.$createElement,i=n._self._c||e;return i("div",{attrs:{id:"modals-container"}},n._l(n.modals,function(t){return i("modal",n._g(n._b({key:t.id,on:{closed:function(e){n.remove(t.id)}}},"modal",t.modalAttrs,!1),t.modalListeners),[i(t.component,n._g(n._b({tag:"component",on:{close:function(e){n.$modal.hide(t.modalAttrs.name)}}},"component",t.componentAttrs,!1),n.$listeners))],1)}))};k._withStripped=!0;var S=l({data:function(){return{modals:[]}},created:function(){this.$root._dynamicContainer=this},methods:{add:function(e){var t=this,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},o=3<arguments.length?arguments[3]:void 0,r=s(),a=i.name||"_dynamic_modal_"+r;this.modals.push({id:r,modalAttrs:function(o){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,i;t=o,i=r[n=e],n in t?Object.defineProperty(t,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[n]=i})}return o}({},i,{name:a}),modalListeners:o,component:e,componentAttrs:n}),this.$nextTick(function(){t.$modal.show(a)})},remove:function(e){for(var t in this.modals)if(this.modals[t].id===e)return void this.modals.splice(t,1)}}},k,[],!1,null,null,null);S.options.__file="src/ModalsContainer.vue";var C=S.exports,O={install:function(a){var s=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};this.installed||(this.installed=!0,this.event=new a,this.rootInstance=null,this.componentName=s.componentName||"Modal",a.prototype.$modal={show:function(e,t,n){var i=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{};if("string"!=typeof e){var o=n&&n.root?n.root:O.rootInstance,r=function(e,t,n){if(!n._dynamicContainer&&t.injectModalsContainer){var i=document.createElement("div");document.body.appendChild(i),new e({parent:n,render:function(e){return e(C)}}).$mount(i)}return n._dynamicContainer}(a,s,o);r?r.add(e,t,n,i):console.warn("[vue-js-modal] In order to render dynamic modals, a <modals-container> component must be present on the page")}else O.event.$emit("toggle",e,!0,t)},hide:function(e,t){O.event.$emit("toggle",e,!1,t)},toggle:function(e,t){O.event.$emit("toggle",e,void 0,t)}},a.component(this.componentName,y),s.dialog&&a.component("VDialog",E),s.dynamic&&(a.component("ModalsContainer",C),a.mixin({beforeMount:function(){null===O.rootInstance&&(O.rootInstance=this.$root)}})))}};var T=t.default=O}])});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(429);

__webpack_require__(573);

__webpack_require__(575);

__webpack_require__(577);

__webpack_require__(579);

__webpack_require__(581);

__webpack_require__(583);

__webpack_require__(585);

__webpack_require__(587);

__webpack_require__(589);

__webpack_require__(593);

if (global._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

global._babelPolyfill = true;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(430);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(129);
__webpack_require__(536);
__webpack_require__(217);
__webpack_require__(537);
__webpack_require__(218);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(219);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
module.exports = __webpack_require__(16);


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(15);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(19);
var META = __webpack_require__(42).KEY;
var $fails = __webpack_require__(4);
var shared = __webpack_require__(79);
var setToStringTag = __webpack_require__(56);
var uid = __webpack_require__(46);
var wks = __webpack_require__(9);
var wksExt = __webpack_require__(109);
var wksDefine = __webpack_require__(199);
var enumKeys = __webpack_require__(432);
var isArray = __webpack_require__(112);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(6);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(41);
var createDesc = __webpack_require__(45);
var _create = __webpack_require__(50);
var gOPNExt = __webpack_require__(202);
var $GOPD = __webpack_require__(31);
var $DP = __webpack_require__(13);
var $keys = __webpack_require__(48);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(51).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(69).f = $propertyIsEnumerable;
  __webpack_require__(81).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(47)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(25)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(79)('native-function-to-string', Function.toString);


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(48);
var gOPS = __webpack_require__(81);
var pIE = __webpack_require__(69);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(50) });


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperty: __webpack_require__(13).f });


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperties: __webpack_require__(201) });


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(26);
var $getOwnPropertyDescriptor = __webpack_require__(31).f;

__webpack_require__(32)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(20);
var $getPrototypeOf = __webpack_require__(52);

__webpack_require__(32)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(20);
var $keys = __webpack_require__(48);

__webpack_require__(32)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(32)('getOwnPropertyNames', function () {
  return __webpack_require__(202).f;
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(6);
var meta = __webpack_require__(42).onFreeze;

__webpack_require__(32)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(6);
var meta = __webpack_require__(42).onFreeze;

__webpack_require__(32)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(6);
var meta = __webpack_require__(42).onFreeze;

__webpack_require__(32)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(6);

__webpack_require__(32)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(6);

__webpack_require__(32)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(6);

__webpack_require__(32)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(203) });


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(204) });


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(114).set });


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(70);
var test = {};
test[__webpack_require__(9)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(19)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(205) });


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(15) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(52);
var HAS_INSTANCE = __webpack_require__(9)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(13).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(207);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(208);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var has = __webpack_require__(24);
var cof = __webpack_require__(37);
var inheritIfRequired = __webpack_require__(116);
var toPrimitive = __webpack_require__(41);
var fails = __webpack_require__(4);
var gOPN = __webpack_require__(51).f;
var gOPD = __webpack_require__(31).f;
var dP = __webpack_require__(13).f;
var $trim = __webpack_require__(82).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(50)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(15) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(19)(global, NUMBER, $Number);
}


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(30);
var aNumberValue = __webpack_require__(209);
var repeat = __webpack_require__(117);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(4)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(4);
var aNumberValue = __webpack_require__(209);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(3).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(210) });


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(210);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(208);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(207);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(211);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(118);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(119);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(475) });


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(118);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(211) });


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(118) });


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(119);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(119);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(49);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(12);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(82)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(120)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(121)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(120)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(12);
var context = __webpack_require__(122);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(124)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(122);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(124)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(117)
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(12);
var context = __webpack_require__(122);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(124)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(21)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(21)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(21)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(21)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(21)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(21)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(21)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(21)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(21)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(21)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(21)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(21)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(21)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(20);
var toPrimitive = __webpack_require__(41);

$export($export.P + $export.F * __webpack_require__(4)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(510);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(4);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(19)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(9)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(25)(proto, TO_PRIMITIVE, __webpack_require__(513));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(41);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(112) });


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(35);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(20);
var call = __webpack_require__(213);
var isArrayIter = __webpack_require__(125);
var toLength = __webpack_require__(12);
var createProperty = __webpack_require__(126);
var getIterFn = __webpack_require__(127);

$export($export.S + $export.F * !__webpack_require__(83)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(126);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(4)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(68) != Object || !__webpack_require__(27)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(113);
var cof = __webpack_require__(37);
var toAbsoluteIndex = __webpack_require__(49);
var toLength = __webpack_require__(12);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(4)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(36);
var toObject = __webpack_require__(20);
var fails = __webpack_require__(4);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(27)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(33)(0);
var STRICT = __webpack_require__(27)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(522);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var isArray = __webpack_require__(112);
var SPECIES = __webpack_require__(9)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(33)(1);

$export($export.P + $export.F * !__webpack_require__(27)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(33)(2);

$export($export.P + $export.F * !__webpack_require__(27)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(33)(3);

$export($export.P + $export.F * !__webpack_require__(27)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(33)(4);

$export($export.P + $export.F * !__webpack_require__(27)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(214);

$export($export.P + $export.F * !__webpack_require__(27)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(214);

$export($export.P + $export.F * !__webpack_require__(27)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(80)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(27)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var toInteger = __webpack_require__(30);
var toLength = __webpack_require__(12);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(27)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(215) });

__webpack_require__(58)('copyWithin');


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(128) });

__webpack_require__(58)('fill');


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(33)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(58)(KEY);


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(33)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(58)(KEY);


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Array');


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var inheritIfRequired = __webpack_require__(116);
var dP = __webpack_require__(13).f;
var gOPN = __webpack_require__(51).f;
var isRegExp = __webpack_require__(123);
var $flags = __webpack_require__(84);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(15) && (!CORRECT_NEW || __webpack_require__(4)(function () {
  re2[__webpack_require__(9)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(19)(global, 'RegExp', $RegExp);
}

__webpack_require__(59)('RegExp');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(218);
var anObject = __webpack_require__(5);
var $flags = __webpack_require__(84);
var DESCRIPTORS = __webpack_require__(15);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(19)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(4)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var toLength = __webpack_require__(12);
var advanceStringIndex = __webpack_require__(131);
var regExpExec = __webpack_require__(85);

// @@match logic
__webpack_require__(86)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var toObject = __webpack_require__(20);
var toLength = __webpack_require__(12);
var toInteger = __webpack_require__(30);
var advanceStringIndex = __webpack_require__(131);
var regExpExec = __webpack_require__(85);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(86)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var sameValue = __webpack_require__(204);
var regExpExec = __webpack_require__(85);

// @@search logic
__webpack_require__(86)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(123);
var anObject = __webpack_require__(5);
var speciesConstructor = __webpack_require__(71);
var advanceStringIndex = __webpack_require__(131);
var toLength = __webpack_require__(12);
var callRegExpExec = __webpack_require__(85);
var regexpExec = __webpack_require__(130);
var fails = __webpack_require__(4);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(86)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(132).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(37)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(222);
var validate = __webpack_require__(53);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(89)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(222);
var validate = __webpack_require__(53);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(89)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var each = __webpack_require__(33)(0);
var redefine = __webpack_require__(19);
var meta = __webpack_require__(42);
var assign = __webpack_require__(203);
var weak = __webpack_require__(223);
var isObject = __webpack_require__(6);
var validate = __webpack_require__(53);
var NATIVE_WEAK_MAP = __webpack_require__(53);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(89)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(223);
var validate = __webpack_require__(53);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(89)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(90);
var buffer = __webpack_require__(133);
var anObject = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(49);
var toLength = __webpack_require__(12);
var isObject = __webpack_require__(6);
var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
var speciesConstructor = __webpack_require__(71);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(4)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(59)(ARRAY_BUFFER);


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(90).ABV, {
  DataView: __webpack_require__(133).DataView
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(36);
var anObject = __webpack_require__(5);
var rApply = (__webpack_require__(3).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(4)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(50);
var aFunction = __webpack_require__(36);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(6);
var fails = __webpack_require__(4);
var bind = __webpack_require__(205);
var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(13);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(41);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(4)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(31).f;
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(212)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(52);
var has = __webpack_require__(24);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(6);
var anObject = __webpack_require__(5);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(31);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(52);
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(225) });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(13);
var gOPD = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(52);
var has = __webpack_require__(24);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(45);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(6);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(114);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(574);
module.exports = __webpack_require__(16).Array.includes;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(80)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(58)('includes');


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(576);
module.exports = __webpack_require__(16).String.padStart;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(226);
var userAgent = __webpack_require__(88);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(578);
module.exports = __webpack_require__(16).String.padEnd;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(226);
var userAgent = __webpack_require__(88);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(580);
module.exports = __webpack_require__(109).f('asyncIterator');


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(199)('asyncIterator');


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(582);
module.exports = __webpack_require__(16).Object.getOwnPropertyDescriptors;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(225);
var toIObject = __webpack_require__(26);
var gOPD = __webpack_require__(31);
var createProperty = __webpack_require__(126);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(584);
module.exports = __webpack_require__(16).Object.values;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(227)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(586);
module.exports = __webpack_require__(16).Object.entries;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(227)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(219);
__webpack_require__(588);
module.exports = __webpack_require__(16).Promise['finally'];


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(16);
var global = __webpack_require__(3);
var speciesConstructor = __webpack_require__(71);
var promiseResolve = __webpack_require__(221);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
module.exports = __webpack_require__(16);


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(88);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(132);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(129);
var getKeys = __webpack_require__(48);
var redefine = __webpack_require__(19);
var global = __webpack_require__(3);
var hide = __webpack_require__(25);
var Iterators = __webpack_require__(57);
var wks = __webpack_require__(9);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 593 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() {
    return this || (typeof self === "object" && self);
  })() || Function("return this")()
);


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browserUpdate = __webpack_require__(595);

var _browserUpdate2 = _interopRequireDefault(_browserUpdate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addLoadEvent(func) {
  var ondOnLoad = window.onload;
  if (typeof window.onload !== 'function') {
    window.onload = func;
  } else {
    window.onload = function () {
      if (oldOnLoad) {
        oldOnLoad();
      }
      func();
    };
  }
}

var VueBrowserUpdate = {};
VueBrowserUpdate.install = function (Vue, opts) {
  var options = opts;
  var funcs = {
    show: [],
    click: [],
    close: []
  };
  function dispatch(func, infos) {
    funcs[func].forEach(function (f) {
      return f(infos);
    });
  }

  addLoadEvent(function () {
    options.options.onshow = function (infos) {
      return dispatch('show', infos);
    };
    options.options.onclick = function (infos) {
      return dispatch('click', infos);
    };
    options.options.onclose = function (infos) {
      return dispatch('close', infos);
    };

    if (typeof _browserUpdate2.default === 'undefined') {
      throw new Error('The plugin "browser-update" could not be loaded.');
    } else {
      if (!options.containerAsync) {
        (0, _browserUpdate2.default)(options.options, options.test);
      }
    }
  });

  Vue.browserUpdate = {
    onshow: function onshow(func) {
      return funcs.show.push(func);
    },
    onclick: function onclick(func) {
      return funcs.click.push(func);
    },
    onclose: function onclose(func) {
      return funcs.close.push(func);
    },
    appendContainer: function appendContainer(container) {
      if (container) options.options.container = container;
      (0, _browserUpdate2.default)(options.options, options.test);
    }
  };
};

exports.default = VueBrowserUpdate;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//(c)2017, MIT Style License <browser-update.org/LICENSE.txt>
//it is recommended to directly link to this file because we update the detection code


function $bu_getBrowser(ua_str) {
    var n,ua=ua_str||navigator.userAgent,donotnotify=false;
    var names={i:'Internet Explorer',e:"Edge",f:'Firefox',o:'Opera',o_a:'Opera',s:'Safari',c:"Chrome",a:"Android Browser", y:"Yandex Browser",v:"Vivaldi",uc:"UC Browser",samsung:"Samsung Internet",x:"Other"};
    function ignore(reason,pattern){if (new RegExp(pattern,"i").test(ua)) return reason;}
    var ig=ignore("bot","bot|spider|archiver|transcoder|crawl|checker|monitoring|screenshot|python-|php|uptime|validator|fetcher|facebook|slurp|google|yahoo|microsoft|node|mail.ru|github|cloudflare|addthis|thumb|proxy|feed|fetch|favicon|link|http|scrape|seo|page|search console|AOLBuild|Teoma|Gecko Expeditor")||
//        ignore("discontinued browser","camino|flot|k-meleon|fennec|galeon|chromeframe|coolnovo") ||
        ignore("complicated device browser","SMART-TV|SmartTV") ||
        ignore("niche browser","Dorado|Whale|MIDP|wii|Chromium|Puffin|Opera Mini|maxthon|maxton|dolfin|dolphin|seamonkey|opera mini|netfront|moblin|maemo|arora|kazehakase|epiphany|konqueror|rekonq|symbian|webos|PaleMoon|QupZilla|Otter|Midori|qutebrowser") ||
        ignore("mobile without upgrade path or landing page","kindle|tizen|silk|blackberry|bb10|RIM|PlayBook|meego|nokia|ucweb|ZuneWP7|537.85.10") ||
        ignore("android(chrome) web view","; wv");
    var mobile=(/iphone|ipod|ipad|android|mobile|phone|ios|iemobile/i.test(ua));
    if (ig) 
        return {n:"x",v:0,t:"other browser",donotnotify:ig};    

    var pats=[
        ["CriOS.VV","c"],
        ["FxiOS.VV","f"],
        ["Trident.*rv:VV","i"],
        ["Trident.VV","io"],
        ["UCBrowser.VV","uc"],
        ["MSIE.VV","i"],
        ["Edge.VV","e"],
        ["Vivaldi.VV","v"],
        ["Android.*OPR.VV","o_a"],
        ["OPR.VV","o"],
        ["YaBrowser.VV","y"],
        ["SamsungBrowser.VV","samsung"],
        ["Chrome.VV","c"],
        ["Firefox.VV","f"],
        ["Version.VV.*Safari","s"],
        ["Safari.VV","so"],
        ["Opera.*Version.VV","o"],
        ["Opera.VV","o"]
    ];
    for (var i=0; i < pats.length; i++) {
        if (ua.match(new RegExp(pats[i][0].replace("VV","(\\d+\\.?\\d+)"),"i"))) {
            n=pats[i][1];
            break;
        }        
    }
    var semver=n==="v"||n==="y"||n==="uc";
    if (semver) {//zero pad semver for easy comparing
        var parts = (RegExp.$1).split('.');
        var v=(parts[0] + "." + ("00".substring(0, 2 - parts[1].length) + parts[1]));
    }
    else {
        var v=Math.round(parseFloat(RegExp.$1)*10)/10;
    }
    
    if (!n)
        return {n:"x",v:0,t:names[n],mobile:mobile};
    
    //do not notify old systems since there is no up-to-date browser available
    if (/windows.nt.5.0|windows.nt.4.0|windows.95|windows.98|os x 10.2|os x 10.3|os x 10.4|os x 10.5|os x 10.6|os x 10.7/i.test(ua)) 
        donotnotify="oldOS";
    
    //iOS
    if (/iphone|ipod|ipad|ios/i.test(ua)) {
        ua.replace("_",".").match(new RegExp("OS.(\\d+\\.?\\d?)","i"));//
        n="iOS";
        v=parseFloat(RegExp.$1); 
        var h = Math.max(window.screen.height, window.screen.width);
        if (h<=480 || window.devicePixelRatio<2) //iphone <5 and old iPads  // (h>568 -->iphone 6+)
              return {n:"s",v:v,t:"iOS "+v,donotnotify:"iOS without upgrade path",mobile:mobile};
        return {n:"s",v:v,t:"iOS "+v,donotnotify:false,mobile:mobile};//identify as safari
    }
    //check for android stock browser
    if (ua.indexOf('Android')>-1 && n==="s") {
        var ver=parseInt((/WebKit\/([0-9]+)/i.exec(ua) || 0)[1],10) || 2000;
        if (ver <= 534)
            return {n:"a",v:ver,t:names["a"],mob:true,donotnotify:donotnotify,mobile:mobile};
        //else
        //    return {n:n,v:v,t:names[n]+" "+v,donotnotify:"mobile on android",mobile:mobile};
    }

    //do not notify firefox ESR
    if (n==="f" && Math.round(v)===52)
        donotnotify="ESR";

    if (n==="so") {
        v=4.0;
        n="s";
    }
    if (n==="i" && v===7 && window.XDomainRequest) {
        v=8;
    }
    if (n==="io") {
        n="i";
        if (v>6) v=11;
        else if (v>5) v=10;
        else if (v>4) v=9;
        else if (v>3.1) v=8;
        else if (v>3) v=7;
        else v=9;
    }
    return {n:n,v:v,t:names[n]+" "+v,donotnotify:donotnotify,mobile:mobile};
}

var $buo = function(op,test) {
var n = window.navigator,b,vsmin;
op = window._buorgres=op||{};
var ll = op.l||(n.languages ? n.languages[0] : null) || n.language || n.browserLanguage || n.userLanguage||document.documentElement.getAttribute("lang")||"en";
op.ll=ll=ll.replace("_","-").toLowerCase().substr(0,2);
op.apiver=op.api||op.c||-1;
op.jsv="2.3.3npm";
var vsakt = {e:15,i:15,f:59,o:52,o_a:45,s:11.1,c:66,y:18.2,v:1.14,uc:11.5,samsung:6.4};
var vsdefault = {e:-5,f:-4,o:-4,o_a:-4,s:-1.7,c:-4,a:534,y:-0.02,v:-0.02,uc:-0.03,samsung:-1};
var vsinsecure = {};//{i:10,e:12.10166,c:61,f:55,y:16.09,s:10.0};
if (op.apiver<4)
    vsmin={i:9,f:10,o:20,s:7};
else
    vsmin={i:8,f:5,o:12.5,s:6.2};
var vs =op.notify||op.vs||vsdefault;
var releases_per_month={'f':7/12,'c':8/12,'o':8/12,'i':1/12,'s':1/12,'v':1/12}
vs.e=vs.e||vs.i;
for (b in vsdefault) {
    if (!vs[b])
        vs[b]=vsdefault[b]
    if (vsakt[b]) {
        if (/m/.test(vs[b]))
            vs[b]=vsakt[b]+vs[b].replace('m','')*releases_per_month[b]
        if (vs[b]>=vsakt[b])
            vs[b]=vsakt[b]-0.2
        else if (vs[b]<0)
            vs[b]=vsakt[b]+vs[b]
    }
    if (vsmin[b] && vs[b]<vsmin[b])
        vs[b]=vsmin[b];    
    if ((op.insecure||op.unsecure) && vsinsecure[b] && vs[b]<vsinsecure[b])
        vs[b]=vsinsecure[b];      
}
vs.i=vs.i||vs.e;
op.vsf=vs;
if (op.reminder<0.1 || op.reminder===0)
    op.reminder=0;
else
    op.reminder=op.reminder||24;
op.reminderClosed=op.reminderClosed||(24*7);
op.onshow = op.onshow||function(o){};
op.onclick = op.onclick||function(o){};
op.onclose = op.onclose||function(o){};
op.pageurl = op.pageurl || location.hostname || "x";
op.newwindow=(op.newwindow!==false);

op.test=test||op.test||(location.hash==="#test-bu")||false;

if (Math.random()*1200<1 && !op.test) {
    var i = new Image();    i.src="//browser-update.org/count.php?what=brow&jsv="+op.jsv;
}

var bb=$bu_getBrowser();
if (!op.test) {
    if (!bb || !bb.n || bb.n==="x" || bb.donotnotify!==false || (document.cookie.indexOf("browserupdateorg=pause")>-1 && location.hash!=="#ignorecookie-bu"))
        return;
    if (bb.v>vs[bb.n] || (bb.mobile&&op.mobile===false) )    
        return;
}

op.setCookie=function(hours) {
    document.cookie = 'browserupdateorg=pause; expires='+(new Date(new Date().getTime()+3600000*hours)).toGMTString()+'; path=/';
};
if (op.reminder>0)
    op.setCookie(op.reminder);

if (op.nomessage) {
    op.onshow(op);
    return;
}

$buo_show();
};

module.exports = $buo;

"use strict";
var $buo_show = function() {
var op=window._buorgres;    
var ll=op.ll;
var bb=$bu_getBrowser();
var burl=op.burl || ("http"+(/MSIE/i.test(navigator.userAgent)?"":"s")+"://browser-update.org/");
if (!op.url) {
    op.url= burl+((op.l && (ll+"/"))||"")+"update-browser.html"+(op.test?"?force_outdated=true":"")+"#"+op.jsv+":"+op.pageurl;
}
/*
if (Math.random()*1000<1 && !op.test && !op.betatest) {
    var i = new Image();
    var txt=op["text_"+ll]||op.text||"";
    var extra=encodeURIComponent("frac="+frac+"&txt="+txt+"&apiver="+op.apiver);
    i.src="https://browser-update.org/count.php?what=noti&from="+bb.n+"&fromv="+bb.v + "&ref="+ escape(op.pageurl) + "&jsv="+op.jsv+"&tv="+op.style+"&extra="+extra;
}
*/
function busprintf() {
    var args=arguments;
    var data = args[ 0 ];
    for( var k=1; k<args.length; ++k ) {
        data = data.replace( /%s/, args[ k ] );
    }
    return data;
}


var t={};
t.en='<b class="buorg-mainmsg">Your web browser ({brow_name}) is out of date.</b> <span class="buorg-moremsg">Update your browser for more security, speed and the best experience on this site.</span> <span class="buorg-buttons"><a{up_but}>Update browser</a> <a{ignore_but}>Ignore</a></span>';

//t.af='';
t.ar='<b> متصفح الويب ({brow_name}) الخاص بك قديم.</b> قُم بتحديث متصفحك للحصول على مزيدٍ من الحماية والراحة وتجربة أفضل على هذا الموقع. <a{up_but}> تحديث المتصفح</a> <a{ignore_but}> تجاهل</a>';
t.bg='<b>Вашият браузър ({brow_name}) не е актуализиран.</b> Актуализирайте го за повече сигурност, удобство и най-добро изживяване на сайта. <a{up_but}>Актуализирайте браузъра</a> <a{ignore_but}>Игнорирайте</a>';
t.ca='El teu navegador (%s) està <b>desactualitzat.</b> Té <b>vulnerabilitats</b> conegudes i pot <b>no mostrar totes les característiques</b> d\'aquest i altres llocs web. <a%s>Aprèn a actualitzar el navegador</a>';
t.cs='<b>Váš webový prohlížeč ({brow_name}) je zastaralý .</b> Pro větší bezpečnost, pohodlí a optimální zobrazení této stránky si prosím svůj prohlížeč aktualizujte. <a{up_but}>Aktualizovat prohlížeč</a> <a{ignore_but}>Ignorovat</a>';
t.da='<b>Din netbrowser ({brow_name}) er forældet.</b> Opdater din browser for mere sikkerhed, komfort og den bedste oplevelse på denne side. <a{up_but}>Opdater browser</a> <a{ignore_but}>Ignorer</a>';
t.de='<b>Ihr Browser ({brow_name}) ist veraltet.</b> Aktualisieren Sie Ihren Browser für mehr Sicherheit, Komfort und die einwandfreie Nutzung dieser Webseite. <a{up_but}>Browser aktualisieren</a> <a{ignore_but}>Ignorieren</a>';
t.el='<b>Η έκδοση του προγράμματος περιήγησής σας ({brow_name}) είναι παλιά.</b> Ενημερώστε τον περιηγητή σας για περισσότερη ασφάλεια, άνεση και την βέλτιστη εμπειρία σε αυτή την ιστοσελίδα. <a{up_but}>Αναβάθμιση περιηγητή</a> <a{ignore_but}>Παράβλεψη</a>';
t.es='<b>Tu navegador web ({brow_name}) no está actualizado.</b> Actualiza tu navegador para tener más seguridad y comodidad y tener la mejor experiencia en este sitio. <a{up_but}>Actualizar navegador</a> <a{ignore_but}>Ignorar</a>';
//t.et='';
t.fa = 'مرورگر شما (%s) <b>از رده خارج شده</b> می باشد. این مرورگر دارای <b>مشکلات امنیتی شناخته شده</b> می باشد و <b>نمی تواند تمامی ویژگی های این</b> وب سایت و دیگر وب سایت ها را به خوبی نمایش دهد. <a%s>در خصوص گرفتن راهنمایی درخصوص نحوه ی به روز رسانی مرورگر خود اینجا کلیک کنید.</a>';
t.fi='<b>Selaimesi ({brow_name}) on vanhentunut.</b> Päivitä selaimesi parantaaksesi turvallisuutta, mukavuutta ja käyttökokemusta tällä sivustolla. <a{up_but}>Päivitä selain</a> <a{ignore_but}>Ohita</a>';
t.fr='<b>Votre navigateur web ({brow_name}) n\'est pas à jour.</b> Mettez votre navigateur à jour pour plus de sécurité, de confort et une expérience optimale sur ce site. <a{up_but}>Mettre le navigateur à jour</a> <a{ignore_but}>Ignorer</a>';
t.gl='Tá an líonléitheoir agat (%s) <b>as dáta.</b> Tá <b>laigeachtaí slándála</b> a bhfuil ar eolas ann agus b\'fhéidir <b>nach taispeánfaidh sé gach gné</b> den suíomh gréasáin seo ná cinn eile. <a%s>Foghlaim conas do líonléitheoir a nuashonrú</a>';
t.he='<b>הדפדפן שלך ({brow_name}) אינו מעודכן.</b> עדכן את הדפדפן שלך בשביל אבטחה טובה יותר, נוחיות והחוויה הטובה ביותר באתר הזה.<a{up_but}>עדכן דפדפן</a> <a{ignore_but}>התעלם</a>';
t.hi='यह वेबसाइट आपको याद दिलाना चाहती हैं: आपका ब्राउज़र (%s) <b> आउट ऑफ़ डेट </b> हैं। <a%s> और अधिक सुरक्षा, आराम और इस साइट पर सबसे अच्छा अनुभव करने लिए आपके ब्राउज़र को अपडेट करें</a>।';
//t.hr='';
t.hu='<b>Az ön ({brow_name}) böngészője elavult.</b> Frissítse a böngészőjét több biztonság, kényelem és a legjobb felhasználói élmény érdekében ezen az oldalon. <a{up_but}>Böngésző frissítése</a> <a{ignore_but}>Mellőzés</a>';
t.id='<b>Browser Anda ({brow_name}) sudah usang.</b> Perbarui browser Anda untuk pengalaman terbaik yang lebih aman dan nyaman di situs ini. <a{up_but}>Perbarui Browser</a> <a{ignore_but}>Abaikan</a>';
t.it='<b>Il suo browser web ({brow_name}) non è aggiornato.</b> Aggiorni il suo browser per ottenere maggiore sicurezza, comfort, e la migliore esperienza possibile su questo sito. <a{up_but}>Aggiorna il browser</a> <a{ignore_but}>Ignora</a>';
t.ja='<b>お使いのウェブブラウザ ({brow_name}) は古すぎます</b>。安全性と快適さを向上させ、このサイトで最高の体験が出来るよう、お使いのブラウザをアップデートしましょう。<a{up_but}>ブラウザをアップデートする</a> <a{ignore_but}>無視する</a>';
t.ko='<b>현재 당신의 웹브라우저 ({brow_name})은(는) 구 버전입니다.</b> 본 사이트에서 향상된 보안 및 편안함과 최상의 경험을 위해 브라우저를 업데이트해 주세요. <a{up_but}>브라우저 업데이트</a> <a{ignore_but}>무시하기</a>';
//t.lt='';
t.lv='Jūsu pārlūkprogramma (%s) ir <b>novecojusi.</b>  Tai ir zināmas <b>drošības problēmas</b>, un tā var attēlot šo un citas  tīmekļa lapas <b>nekorekti.</b> <a%s>Uzzini, kā atjaunot savu pārlūkprogrammu</a>';
t.ms='<b>Pelayar web ({brow_name}) anda sudah usang.</b> Kemas kini pelayar anda untuk memperoleh lebih keselamatan, keselesaan dan pengalaman terbaik di tapak ini. <a{up_but}>Kemas kini pelayar</a> <a{ignore_but}>Abaikan</a>';
t.nl='<b>Uw webbrowser ({brow_name}) is verouderd.</b> Update uw browser voor meer veiligheid, comfort en de beste ervaring op deze site. <a{up_but}>Update browser</a> <a{ignore_but}>Negeer</a>';
t.no='<b>Nettleseren din,({brow_name}), er utdatert.</b> Oppdater nettleseren din for mer sikkerhet, komfort og den beste opplevelsen på denne siden. <a{up_but}>Oppdater nettleser</a> <a{ignore_but}>Ignorer</a>';
t.pl='<b>Twoja przeglądarka ({brow_name}) jest nieaktualna.</b> Zaktualizuj swoją przeglądarkę, by zapewnić większe bezpieczeństwo i wygodę oraz lepsze wrażenia w tej witrynie. <a{up_but}>Zaktualizuj</a> <a{ignore_but}>Zignoruj</a>';
t.pt='<b>Seu navegador de internet ({brow_name}) está desatualizado.</b> Atualize seu navegador para obter mais segurança, conforto e a melhor experiência neste site. <a{up_but}>Atualizar navegador</a> <a{ignore_but}>Ignorar</a>';
t.ro='<b>Browserul dumneavoastră ({brow_name}) nu este actualizat.</b> Actualizați-vă browserul pentru securitate sporită, confort și cea mai bună experiență pe site. <a{up_but}>Actualizează browser</a><a{ignore_but}>Ignoră</a>';
t.ru='<b>Ваш веб-браузер ({brow_name}) устарел.</b> Обновите свой браузер, чтобы сделать пребывание на этом сайте более безопасным, комфортным и продуктивным. <a{up_but}>Обновить браузер</a> <a{ignore_but}>Игнорировать</a>';
t.sk='<b> Váš internetový prehliadač ({brow_name}) je zastaraný.</b> Aktualizujte váš prehliadač pre vyššiu bezpečnosť, komfort a najlepší zážitok na tejto stránke. <a{up_but}>Aktualizovať prehliadač</a><a{ignore_but}>Ignorovať</a>';
t.sl='Vaš brskalnik (%s) je <b>zastarel.</b> Ima več <b>varnostnih pomankljivosti</b> in morda <b>ne bo pravilno prikazal</b> te ali drugih strani. <a%s>Poglejte kako lahko posodobite svoj brskalnik</a>';
t.sq='<b>Shfletuesi juaj ({brow_name}) është i vjetruar.</b> Përditësojeni shfletuesin tuaj për më tepër siguri, rehati dhe për funksionimin më të mirë në këtë sajt. <a{up_but}>Përditësojeni shfletuesin</a> <a{ignore_but}>Shpërfille</a>';
//sr-cs"]='';
t.sr='Vaš pretraživač (%s) je <b>zastareo.</b> Ima poznate <b>sigurnosne probleme</b> i najverovatnije <b>neće prikazati sve funkcionalnisti</b> ovog i drugih sajtova. <a%s>Nauči više o nadogradnji svog pretraživača</a>';
t.sv='<b>Din webbläsare ({brow_name}) är föråldrad.</b> Uppdatera din webbläsare för bättre säkerhet, bekvämlighet och den bästa upplevelsen på den här sidan. <a{up_but}>Uppdatera webbläsare</a> <a{ignore_but}>Avstå</a>';
t.th='<b>เว็บเบราว์เซอร์ ({brow_name}) ของคุณตกรุ่นแล้ว </b> อัพเดทเบราว์เซอร์ของคุณเพื่อเพิ่มความปลอดภัย ความสะดวกและประสบการณ์การใช้งานที่ดีที่สุดในเว็บไซท์นี้ <a{up_but}>อัพเดทเบราว์เซอร์</a> <a{ignore_but}>ไม่สนใจ</a>';
t.tr='<b>({brow_name}) internet tarayıcınız güncel değil.</b> Bu sitede daha fazla güvenlik, konfor ve en iyi deneyim için tarayıcınızı güncelleyin. <a{up_but}>Tarayıcıyı güncelle</a> <a{ignore_but}>Yoksay</a>';
t.uk='<b>Ваш браузер ({brow_name}) є застарілим.</b> Оновіть його заради безпечнішого, зручнішого та приємнішого перегляду цього та інших сайтів. <a{up_but}>Оновити</a> <a{ignore_but}>Скасувати</a>';
t.vi='<b>Trình duyệt web của bạn ({brow_name}) đã cũ.</b> Hãy nâng cấp trình duyệt của bạn để được an toàn và thuận lợi hơn đồng thời có được trải nghiệm tốt nhất với trang này';
t.zh='<b>您的网页浏览器 ({brow_name}) 已过期。</b>更新您的浏览器，以提高安全性和舒适性，并获得访问本网站的最佳体验。<a{up_but}>更新浏览器</a> <a{ignore_but}>忽略</a>';
t["zh-tw"]='<b>您的網頁瀏覽器  ({brow_name}) 已經過時。</b> 請更新您的瀏覽器，以在此網站取得更安全、舒適的最佳瀏覽體驗。<a{up_but}>更新瀏覽器</a><a{ignore_but}>忽略</a>';
t=op["text_"+ll]||op.text||t[ll]||t.en;

var tar="";
if (op.newwindow)
    tar=' target="_blank" rel="noopener"';

var div = op.div = document.createElement("div");
div.id="buorg";
div.className="buorg";

var style='<style>.buorg-icon {width: 22px; height: 16px; vertical-align: middle; position: relative; top: -0.05em; display: inline-block; background: no-repeat 0px center url(https://browser-update.org/img/small/'+bb.n+'.png);}</style>';
var style2='<style>.buorg {position:absolute;position:fixed;z-index:111111; width:100%; top:0px; left:0px; border-bottom:1px solid #A29330; text-align:center; cursor:pointer;        background-color: #fff8ea;    font: 18px Calibri,Helvetica,Arial,sans-serif;    box-shadow: 0 0 5px rgba(0,0,0,0.2);}'
    +'.buorg div { padding: 9px;  line-height: 1.7em; }'
    +'.buorg .buorg-buttons { display: block; text-align: center; }'
    +'.buorg div a { text-indent: 0; color: #fff; text-decoration: none; box-shadow: 0 0 2px rgba(0,0,0,0.4); padding: 1px 10px; border-radius: 4px; font-weight: normal; background: #5ab400;    white-space: nowrap;    margin: 0 2px; display: inline-block;}'
    +'#buorgig { background-color: #edbc68; position: relative;}'
    +'@media only screen and (max-width: 700px){.buorg div { padding:5px 12px 5px 9px; line-height: 1.3em;}}'
    +'@keyframes buorgfly {from {opacity:0;transform:translateY(-50px)} to {opacity:1;transform:translateY(0px)}}'
    +'.buorg { animation: 1s ease-out 0s buorgfly}</style>';

if (t.indexOf("{brow_name}")===-1) {//legacy style
    t=busprintf(t,bb.t,' id="buorgul" href="'+op.url+'"'+tar);

    style += '<style>.buorg {position:absolute;position:fixed;z-index:111111; width:100%; top:0px; left:0px; border-bottom:1px solid #A29330; text-align:left; cursor:pointer; font: 13px Arial,sans-serif;color:#000;}'
    +'.buorg div { padding:5px 36px 5px 40px; }'
    +'.buorg>div>a,.buorg>div>a:visited{color:#E25600; text-decoration: underline;}'
    +'#buorgclose{position:absolute;right:6px;top:0px;height:20px;width:12px;font:18px bold;padding:0;}'
    +'#buorga{display:block;}'
    +'@media only screen and (max-width: 700px){.buorg div { padding:5px 15px 5px 9px; }}</style>';
    div.innerHTML= '<div>'+t+'<div id="buorgclose"><a id="buorga">&times;</a></div></div>'+style;
    op.addmargin=true;
}
else {
    if (op.style === "bottom") {
        style2 += '<style>.buorg {bottom:0; top:auto; border-top:1px solid #A29330; } @keyframes buorgfly {from {opacity:0;transform:translateY(50px)} to {opacity:1;transform:translateY(0px)}}</style>';
    }
    else if (op.style === "corner") {
        style2 += '<style> .buorg { text-align: left; width:300px; top:50px; right:50px; left:auto; border:1px solid #A29330; } .buorg div b {display:block;} .buorg-buttons { display: block; } .buorg div a {margin: 4px 2px;} .buorg-icon {display: none;}</style>';
    }
    else {
        op.addmargin=true;
    }
    t = t.replace("{brow_name}", bb.t).replace("{up_but}", ' id="buorgul" href="' + op.url + '"' + tar).replace("{ignore_but}", ' id="buorgig" href="'+burl+"block-ignore-browser-update-warning.html"+'" target="_blank"');
    div.innerHTML = '<div><span class="buorg-icon"> </span>' + t + '</div>' + style+style2;
}

op.text=t;
if (op.container) {
    op.container.appendChild(div);
    op.addmargin=false;
}
else
    document.body.insertBefore(div,document.body.firstChild);

div.onclick=function(){
    if (op.newwindow)
        window.open(op.url,"_blank");
    else
        window.location.href=op.url;
    op.setCookie(op.reminderClosed);
    op.onclick(op);
    return false;
};
try {
document.getElementById("buorgul").onclick = function(e) {
    e = e || window.event;
    if (e.stopPropagation) e.stopPropagation();
    else e.cancelBubble = true;
    op.div.style.display = "none";
    hm.style.marginTop = op.bodymt;    
    op.onclick(op);    
    return true;
};
}
catch(e) {}

if (op.addmargin) {
    var hm=document.getElementsByTagName("html")[0]||document.body;
    op.bodymt = hm.style.marginTop;
    hm.style.marginTop = (div.clientHeight)+"px";
}
(document.getElementById("buorga")||document.getElementById("buorgig")).onclick = function(e) {
    e = e || window.event;
    if (e.stopPropagation) e.stopPropagation();
    else e.cancelBubble = true;
    op.onclose(op);
    if (op.addmargin)
        hm.style.marginTop = op.bodymt;      
    op.setCookie(op.reminderClosed);    
    if(!op.no_permanent_hide && ll==="en" && op.reminderClosed==24*7) {
        op.div.innerHTML='<div><span class="buorg-moremsg">You will be reminded in a week.</span> <span class="buorg-buttons"><a id="buorgpermanent" href="'+burl+"block-ignore-browser-update-warning.html"+'" target="_blank" onclick="">Never show again</a></span></div>' + style+style2
            +'<style>.buorg {transition: visibility 0s 8.5s, opacity 8s ease-out .5s;}</style>';
        div.onclick=null;
        document.getElementById("buorgpermanent").onclick = function(e) {        
            op.setCookie(24*365);
            op.div.style.display = "none";
        }
        op.div.style.opacity=0;
        op.div.style.visibility="hidden";
        return false;
    }
    op.div.style.display = "none";
    return false;
}

if (op.noclose) {
    var el=(document.getElementById("buorga")||document.getElementById("buorgig"));
    el.parentNode.removeChild(el);
}
op.onshow(op);

};




/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(introJs) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.default=e():t.default=e()}(window,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=102)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var r=n(38)("wks"),o=n(37),i=n(0).Symbol,u="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=r},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(8);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var r=n(12),o=n(41);t.exports=n(7)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(0),o=n(2),i=n(14),u=n(4),c=n(10),a=function(t,e,n){var s,f,l,p=t&a.F,v=t&a.G,h=t&a.S,d=t&a.P,y=t&a.B,_=t&a.W,m=v?o:o[e]||(o[e]={}),g=m.prototype,x=v?r:h?r[e]:(r[e]||{}).prototype;for(s in v&&(n=e),n)(f=!p&&x&&void 0!==x[s])&&c(m,s)||(l=f?x[s]:n[s],m[s]=v&&"function"!=typeof x[s]?n[s]:y&&f?i(l,r):_&&x[s]==l?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(l):d&&"function"==typeof l?i(Function.call,l):l,d&&((m.virtual||(m.virtual={}))[s]=l,t&a.R&&g&&!g[s]&&u(g,s,l)))};a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e){t.exports={}},function(t,e,n){t.exports=!n(11)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(3),o=n(98),i=n(97),u=Object.defineProperty;e.f=n(7)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return u(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){var r=n(13);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){"use strict";var r=n(13);t.exports.f=function(t){return new function(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r}),this.resolve=r(e),this.reject=r(n)}(t)}},function(t,e,n){var r=n(12).f,o=n(10),i=n(1)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(21);t.exports=function(t){return Object(r(t))}},function(t,e){t.exports=!0},function(t,e,n){var r=n(38)("keys"),o=n(37);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var r=n(40),o=n(21);t.exports=function(t){return r(o(t))}},function(t,e,n){var r=n(95),o=n(36);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e,n){var r=n(8),o=n(0).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){var r=n(3),o=n(8),i=n(15);t.exports=function(t,e){if(r(t),o(e)&&e.constructor===t)return e;var n=i.f(t);return(0,n.resolve)(e),n.promise}},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var r,o,i,u=n(14),c=n(52),a=n(33),s=n(24),f=n(0),l=f.process,p=f.setImmediate,v=f.clearImmediate,h=f.MessageChannel,d=f.Dispatch,y=0,_={},m=function(){var t=+this;if(_.hasOwnProperty(t)){var e=_[t];delete _[t],e()}},g=function(t){m.call(t.data)};p&&v||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return _[++y]=function(){c("function"==typeof t?t:Function(t),e)},r(y),y},v=function(t){delete _[t]},"process"==n(9)(l)?r=function(t){l.nextTick(u(m,t,1))}:d&&d.now?r=function(t){d.now(u(m,t,1))}:h?(i=(o=new h).port2,o.port1.onmessage=g,r=u(i.postMessage,i,1)):f.addEventListener&&"function"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+"","*")},f.addEventListener("message",g,!1)):r="onreadystatechange"in s("script")?function(t){a.appendChild(s("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(u(m,t,1),0)}),t.exports={set:p,clear:v}},function(t,e,n){var r=n(3),o=n(13),i=n(1)("species");t.exports=function(t,e){var n,u=r(t).constructor;return void 0===u||void 0==(n=r(u)[i])?e:o(n)}},function(t,e,n){t.exports={default:n(59),__esModule:!0}},function(t,e,n){var r=n(9),o=n(1)("toStringTag"),i="Arguments"==r(function(){return arguments}());t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),o))?n:i?r(e):"Object"==(u=r(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){var r=n(30),o=n(1)("iterator"),i=n(6);t.exports=n(2).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e,n){"use strict";var r=n(66)(!0);n(34)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){var r=n(0).document;t.exports=r&&r.documentElement},function(t,e,n){"use strict";var r=n(18),o=n(5),i=n(71),u=n(4),c=n(6),a=n(70),s=n(16),f=n(67),l=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),v=function(){return this};t.exports=function(t,e,n,h,d,y,_){a(n,e,h);var m,g,x,b=function(t){if(!p&&t in E)return E[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",j="values"==d,O=!1,E=t.prototype,P=E[l]||E["@@iterator"]||d&&E[d],S=P||b(d),T=d?j?b("entries"):S:void 0,L="Array"==e&&E.entries||P;if(L&&(x=f(L.call(new t)))!==Object.prototype&&x.next&&(s(x,w,!0),r||"function"==typeof x[l]||u(x,l,v)),j&&P&&"values"!==P.name&&(O=!0,S=function(){return P.call(this)}),r&&!_||!p&&!O&&E[l]||u(E,l,S),c[e]=S,c[w]=v,d)if(m={values:j?S:b("values"),keys:y?S:b("keys"),entries:T},_)for(g in m)g in E||i(E,g,m[g]);else o(o.P+o.F*(p||O),e,m);return m}},function(t,e,n){n(74);for(var r=n(0),o=n(4),i=n(6),u=n(1)("toStringTag"),c="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),a=0;a<c.length;a++){var s=c[a],f=r[s],l=f&&f.prototype;l&&!l[u]&&o(l,u,s),i[s]=i.Array}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e,n){var r=n(2),o=n(0),i=o["__core-js_shared__"]||(o["__core-js_shared__"]={});(t.exports=function(t,e){return i[t]||(i[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(18)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var r=n(20),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{waitTimeout:Number},data:function(){return{timer:null,ready:!1}},created:function(){this.restartTimer()},methods:{restartTimer:function(){var t=this;clearTimeout(this.timer),this.timer=setTimeout(function(){t.ready=!0,t.$emit("ready",t.ready)},this.waitTimeout)},ping:function(){this.restartTimer()}}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){!1===e.value&&(delete t.dataset.intro,delete t.dataset.hint)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(t){return t&&t.__esModule?t:{default:t}}(n(29));e.waitForDirectives=function(){return new r.default(function(t){window.__introjsDiscovery.ready?t():window.__introjsDiscovery.$on("ready",function(){t()})})}},function(t,e,n){"use strict";var r=n(5),o=n(15),i=n(26);r(r.S,"Promise",{try:function(t){var e=o.f(this),n=i(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){"use strict";var r=n(5),o=n(2),i=n(0),u=n(28),c=n(25);r(r.P+r.R,"Promise",{finally:function(t){var e=u(this,o.Promise||i.Promise),n="function"==typeof t;return this.then(n?function(n){return c(e,t()).then(function(){return n})}:t,n?function(n){return c(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){var r=n(1)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],u=i[r]();u.next=function(){return{done:n=!0}},i[r]=function(){return u},t(i)}catch(t){}return n}},function(t,e,n){"use strict";var r=n(0),o=n(2),i=n(12),u=n(7),c=n(1)("species");t.exports=function(t){var e="function"==typeof o[t]?o[t]:r[t];u&&e&&!e[c]&&i.f(e,c,{configurable:!0,get:function(){return this}})}},function(t,e,n){var r=n(4);t.exports=function(t,e,n){for(var o in e)n&&t[o]?t[o]=e[o]:r(t,o,e[o]);return t}},function(t,e,n){var r=n(0).navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var r=n(0),o=n(27).set,i=r.MutationObserver||r.WebKitMutationObserver,u=r.process,c=r.Promise,a="process"==n(9)(u);t.exports=function(){var t,e,n,s=function(){var r,o;for(a&&(r=u.domain)&&r.exit();t;){o=t.fn,t=t.next;try{o()}catch(r){throw t?n():e=void 0,r}}e=void 0,r&&r.enter()};if(a)n=function(){u.nextTick(s)};else if(!i||r.navigator&&r.navigator.standalone)if(c&&c.resolve){var f=c.resolve(void 0);n=function(){f.then(s)}}else n=function(){o.call(r,s)};else{var l=!0,p=document.createTextNode("");new i(s).observe(p,{characterData:!0}),n=function(){p.data=l=!l}}return function(r){var o={fn:r,next:void 0};e&&(e.next=o),t||(t=o,n()),e=o}}},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(6),o=n(1)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){var r=n(3);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(14),o=n(54),i=n(53),u=n(3),c=n(39),a=n(31),s={},f={};(e=t.exports=function(t,e,n,l,p){var v,h,d,y,_=p?function(){return t}:a(t),m=r(n,l,e?2:1),g=0;if("function"!=typeof _)throw TypeError(t+" is not iterable!");if(i(_)){for(v=c(t.length);v>g;g++)if((y=e?m(u(h=t[g])[0],h[1]):m(t[g]))===s||y===f)return y}else for(d=_.call(t);!(h=d.next()).done;)if((y=o(d,m,h.value,e))===s||y===f)return y}).BREAK=s,e.RETURN=f},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){"use strict";var r,o,i,u,c=n(18),a=n(0),s=n(14),f=n(30),l=n(5),p=n(8),v=n(13),h=n(56),d=n(55),y=n(28),_=n(27).set,m=n(51)(),g=n(15),x=n(26),b=n(50),w=n(25),j=a.TypeError,O=a.process,E=O&&O.versions,P=E&&E.v8||"",S=a.Promise,T="process"==f(O),L=function(){},M=o=g.f,k=!!function(){try{var t=S.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(L,L)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(L)instanceof e&&0!==P.indexOf("6.6")&&-1===b.indexOf("Chrome/66")}catch(t){}}(),I=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},R=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var r=t._v,o=1==t._s,i=0,u=function(e){var n,i,u,c=o?e.ok:e.fail,a=e.resolve,s=e.reject,f=e.domain;try{c?(o||(2==t._h&&D(t),t._h=1),!0===c?n=r:(f&&f.enter(),n=c(r),f&&(f.exit(),u=!0)),n===e.promise?s(j("Promise-chain cycle")):(i=I(n))?i.call(n,a,s):a(n)):s(r)}catch(t){f&&!u&&f.exit(),s(t)}};n.length>i;)u(n[i++]);t._c=[],t._n=!1,e&&!t._h&&C(t)})}},C=function(t){_.call(a,function(){var e,n,r,o=t._v,i=A(t);if(i&&(e=x(function(){T?O.emit("unhandledRejection",o,t):(n=a.onunhandledrejection)?n({promise:t,reason:o}):(r=a.console)&&r.error&&r.error("Unhandled promise rejection",o)}),t._h=T||A(t)?2:1),t._a=void 0,i&&e.e)throw e.v})},A=function(t){return 1!==t._h&&0===(t._a||t._c).length},D=function(t){_.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,(e=e._w||e)._v=t,e._s=2,e._a||(e._a=e._c.slice()),R(e,!0))},V=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw j("Promise can't be resolved itself");(e=I(t))?m(function(){var r={_w:n,_d:!1};try{e.call(t,s(V,r,1),s(F,r,1))}catch(t){F.call(r,t)}}):(n._v=t,n._s=1,R(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};k||(S=function(t){h(this,S,"Promise","_h"),v(t),r.call(this);try{t(s(V,this,1),s(F,this,1))}catch(t){F.call(this,t)}},(r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1}).prototype=n(49)(S.prototype,{then:function(t,e){var n=M(y(this,S));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&R(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new r;this.promise=t,this.resolve=s(V,t,1),this.reject=s(F,t,1)},g.f=M=function(t){return t===S||t===u?new i(t):o(t)}),l(l.G+l.W+l.F*!k,{Promise:S}),n(16)(S,"Promise"),n(48)("Promise"),u=n(2).Promise,l(l.S+l.F*!k,"Promise",{reject:function(t){var e=M(this);return(0,e.reject)(t),e.promise}}),l(l.S+l.F*(c||!k),"Promise",{resolve:function(t){return w(c&&this===u?S:this,t)}}),l(l.S+l.F*!(k&&n(47)(function(t){S.all(t).catch(L)})),"Promise",{all:function(t){var e=this,n=M(e),r=n.resolve,o=n.reject,i=x(function(){var n=[],i=0,u=1;d(t,!1,function(t){var c=i++,a=!1;n.push(void 0),u++,e.resolve(t).then(function(t){a||(a=!0,n[c]=t,--u||r(n))},o)}),--u||r(n)});return i.e&&o(i.v),n.promise},race:function(t){var e=this,n=M(e),r=n.reject,o=x(function(){d(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return o.e&&r(o.v),n.promise}})},function(t,e){},function(t,e,n){n(58),n(32),n(35),n(57),n(46),n(45),t.exports=n(2).Promise},function(t,e,n){"use strict";e.__esModule=!0;var r=function(t){return t&&t.__esModule?t:{default:t}}(n(29));e.default=function(t){return function(){var e=t.apply(this,arguments);return new r.default(function(t,n){return function o(i,u){try{var c=e[i](u),a=c.value}catch(t){return void n(t)}if(!c.done)return r.default.resolve(a).then(function(t){o("next",t)},function(t){o("throw",t)});t(a)}("next")})}}},function(t,e,n){var r=n(5),o=n(2),i=n(11);t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],u={};u[t]=e(n),r(r.S+r.F*i(function(){n(1)}),"Object",u)}},function(t,e,n){var r=n(17),o=n(23);n(61)("keys",function(){return function(t){return o(r(t))}})},function(t,e,n){n(62),t.exports=n(2).Object.keys},function(t,e,n){t.exports={default:n(63),__esModule:!0}},function(t,e,n){var r=n(3),o=n(31);t.exports=n(2).getIterator=function(t){var e=o(t);if("function"!=typeof e)throw TypeError(t+" is not iterable!");return r(e.call(t))}},function(t,e,n){var r=n(20),o=n(21);t.exports=function(t){return function(e,n){var i,u,c=String(o(e)),a=r(n),s=c.length;return a<0||a>=s?t?"":void 0:(i=c.charCodeAt(a))<55296||i>56319||a+1===s||(u=c.charCodeAt(a+1))<56320||u>57343?t?c.charAt(a):i:t?c.slice(a,a+2):u-56320+(i-55296<<10)+65536}}},function(t,e,n){var r=n(10),o=n(17),i=n(19)("IE_PROTO"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,e,n){var r=n(12),o=n(3),i=n(23);t.exports=n(7)?Object.defineProperties:function(t,e){o(t);for(var n,u=i(e),c=u.length,a=0;c>a;)r.f(t,n=u[a++],e[n]);return t}},function(t,e,n){var r=n(3),o=n(68),i=n(36),u=n(19)("IE_PROTO"),c=function(){},a=function(){var t,e=n(24)("iframe"),r=i.length;for(e.style.display="none",n(33).appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;r--;)delete a.prototype[i[r]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(c.prototype=r(t),n=new c,c.prototype=null,n[u]=t):n=a(),void 0===e?n:o(n,e)}},function(t,e,n){"use strict";var r=n(69),o=n(41),i=n(16),u={};n(4)(u,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(u,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e,n){t.exports=n(4)},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e){t.exports=function(){}},function(t,e,n){"use strict";var r=n(73),o=n(72),i=n(6),u=n(22);t.exports=n(34)(Array,"Array",function(t,e){this._t=u(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):o(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e,n){n(35),n(32),t.exports=n(65)},function(t,e,n){t.exports={default:n(75),__esModule:!0}},function(t,e){!function(e){"use strict";var n,r=Object.prototype,o=r.hasOwnProperty,i="function"==typeof Symbol?Symbol:{},u=i.iterator||"@@iterator",c=i.asyncIterator||"@@asyncIterator",a=i.toStringTag||"@@toStringTag",s="object"==typeof t,f=e.regeneratorRuntime;if(f)s&&(t.exports=f);else{(f=e.regeneratorRuntime=s?t.exports:{}).wrap=x;var l="suspendedStart",p="suspendedYield",v="executing",h="completed",d={},y={};y[u]=function(){return this};var _=Object.getPrototypeOf,m=_&&_(_(k([])));m&&m!==r&&o.call(m,u)&&(y=m);var g=O.prototype=w.prototype=Object.create(y);j.prototype=g.constructor=O,O.constructor=j,O[a]=j.displayName="GeneratorFunction",f.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===j||"GeneratorFunction"===(e.displayName||e.name))},f.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,O):(t.__proto__=O,a in t||(t[a]="GeneratorFunction")),t.prototype=Object.create(g),t},f.awrap=function(t){return{__await:t}},E(P.prototype),P.prototype[c]=function(){return this},f.AsyncIterator=P,f.async=function(t,e,n,r){var o=new P(x(t,e,n,r));return f.isGeneratorFunction(e)?o:o.next().then(function(t){return t.done?t.value:o.next()})},E(g),g[a]="Generator",g[u]=function(){return this},g.toString=function(){return"[object Generator]"},f.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},f.values=k,M.prototype={constructor:M,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=n,this.done=!1,this.delegate=null,this.method="next",this.arg=n,this.tryEntries.forEach(L),!t)for(var e in this)"t"===e.charAt(0)&&o.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=n)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,o){return c.type="throw",c.arg=t,e.next=r,o&&(e.method="next",e.arg=n),!!o}for(var i=this.tryEntries.length-1;i>=0;--i){var u=this.tryEntries[i],c=u.completion;if("root"===u.tryLoc)return r("end");if(u.tryLoc<=this.prev){var a=o.call(u,"catchLoc"),s=o.call(u,"finallyLoc");if(a&&s){if(this.prev<u.catchLoc)return r(u.catchLoc,!0);if(this.prev<u.finallyLoc)return r(u.finallyLoc)}else if(a){if(this.prev<u.catchLoc)return r(u.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<u.finallyLoc)return r(u.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&o.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var i=r;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var u=i?i.completion:{};return u.type=t,u.arg=e,i?(this.method="next",this.next=i.finallyLoc,d):this.complete(u)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),d},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),L(n),d}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var o=r.arg;L(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:k(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=n),d}}}function x(t,e,n,r){var o=e&&e.prototype instanceof w?e:w,i=Object.create(o.prototype),u=new M(r||[]);return i._invoke=function(t,e,n){var r=l;return function(o,i){if(r===v)throw new Error("Generator is already running");if(r===h){if("throw"===o)throw i;return I()}for(n.method=o,n.arg=i;;){var u=n.delegate;if(u){var c=S(u,n);if(c){if(c===d)continue;return c}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(r===l)throw r=h,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r=v;var a=b(t,e,n);if("normal"===a.type){if(r=n.done?h:p,a.arg===d)continue;return{value:a.arg,done:n.done}}"throw"===a.type&&(r=h,n.method="throw",n.arg=a.arg)}}}(t,n,u),i}function b(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}function w(){}function j(){}function O(){}function E(t){["next","throw","return"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function P(t){var e;this._invoke=function(n,r){function i(){return new Promise(function(e,i){!function e(n,r,i,u){var c=b(t[n],t,r);if("throw"!==c.type){var a=c.arg,s=a.value;return s&&"object"==typeof s&&o.call(s,"__await")?Promise.resolve(s.__await).then(function(t){e("next",t,i,u)},function(t){e("throw",t,i,u)}):Promise.resolve(s).then(function(t){a.value=t,i(a)},u)}u(c.arg)}(n,r,e,i)})}return e=e?e.then(i,i):i()}}function S(t,e){var r=t.iterator[e.method];if(r===n){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=n,S(t,e),"throw"===e.method))return d;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return d}var o=b(r,t.iterator,e.arg);if("throw"===o.type)return e.method="throw",e.arg=o.arg,e.delegate=null,d;var i=o.arg;return i?i.done?(e[t.resultName]=i.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=n),e.delegate=null,d):i:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,d)}function T(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function L(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function M(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(T,this),this.reset(!0)}function k(t){if(t){var e=t[u];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,i=function e(){for(;++r<t.length;)if(o.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=n,e.done=!0,e};return i.next=i}}return{next:I}}function I(){return{value:n,done:!0}}}(function(){return this}()||Function("return this")())},function(t,e,n){var r=function(){return this}()||Function("return this")(),o=r.regeneratorRuntime&&Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime")>=0,i=o&&r.regeneratorRuntime;if(r.regeneratorRuntime=void 0,t.exports=n(77),o)r.regeneratorRuntime=i;else try{delete r.regeneratorRuntime}catch(t){r.regeneratorRuntime=void 0}},function(t,e,n){t.exports=n(78)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=a(n(79)),o=a(n(76)),i=a(n(64)),u=a(n(60)),c=n(44);function a(t){return t&&t.__esModule?t:{default:t}}var s=!1;function f(t){s||(s=!0,t.__introjs.start(),t.__introjs.onAutostartHook&&t.__introjs.onAutostartHook(t),t.hasOwnProperty("__introjsAutoHints")&&(t.__introjs.showHints(),t.__introjs.onAutostartHintsHook&&t.__introjs.onAutostartHintsHook(t)))}e.default=function(){var t=(0,u.default)(r.default.mark(function t(e,n){var u,a,s,l,p,v,h,d,y;return r.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:if(!1!==n.value){t.next=2;break}return t.abrupt("return");case 2:if(e.hasOwnProperty("__introjs")||(e.__introjs=introJs(),e.__introjs.onautostart=function(t){e.__introjs.onAutostartHook=t},e.__introjs.onautostarthints=function(t){e.__introjs.onAutostartHintsHook=t}),"hints"===n.arg&&(e.__introjsAutoHints=!0),"on"!==n.arg){t.next=28;break}for(u=(0,i.default)(n.modifiers),(a=function(t){return n.value(t,e.__introjs)}).bind(e.__introjs),s=!0,l=!1,p=void 0,t.prev=11,v=(0,o.default)(u);!(s=(h=v.next()).done);s=!0)d=h.value,y="on"+d,e.__introjs[y](a);t.next=19;break;case 15:t.prev=15,t.t0=t.catch(11),l=!0,p=t.t0;case 19:t.prev=19,t.prev=20,!s&&v.return&&v.return();case 22:if(t.prev=22,!l){t.next=25;break}throw p;case 25:return t.finish(22);case 26:return t.finish(19);case 27:return t.abrupt("return");case 28:if(!("config"in n.modifiers)){t.next=31;break}return e.__introjs.setOptions(n.value),t.abrupt("return");case 31:return t.prev=31,t.next=34,(0,c.waitForDirectives)();case 34:f(e),t.next=40;break;case 37:t.prev=37,t.t1=t.catch(31),console.error(t.t1);case 40:case"end":return t.stop()}},t,void 0,[[11,15,19,27],[20,,22,26],[31,37]])}));return function(e,n){return t.apply(this,arguments)}}()},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.hintposition=e.value}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.hint=e.value,window.__introjsDiscovery.ping()}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.disableInteraction=e.value}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.scrollto=e.value}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.highlightclass=e.value}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.tooltipclass=e.value}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.position=e.value}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.step=e.value}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={bind:function(t,e){t.dataset.intro=e.value,window.__introjsDiscovery.ping()}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.DIRECTIVES=void 0;var r=h(n(89)),o=h(n(88)),i=h(n(87)),u=h(n(86)),c=h(n(85)),a=h(n(84)),s=h(n(83)),f=h(n(82)),l=h(n(81)),p=h(n(80)),v=h(n(43));function h(t){return t&&t.__esModule?t:{default:t}}e.DIRECTIVES={intro:r.default,step:o.default,position:i.default,tooltipClass:u.default,highlightClass:c.default,scrollTo:a.default,disableInteraction:s.default,hint:f.default,hintPosition:l.default,autostart:p.default,conditional:v.default}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(20),o=Math.max,i=Math.min;t.exports=function(t,e){return(t=r(t))<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(22),o=n(39),i=n(93);t.exports=function(t){return function(e,n,u){var c,a=r(e),s=o(a.length),f=i(u,s);if(t&&n!=n){for(;s>f;)if((c=a[f++])!=c)return!0}else for(;s>f;f++)if((t||f in a)&&a[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(10),o=n(22),i=n(94)(!1),u=n(19)("IE_PROTO");t.exports=function(t,e){var n,c=o(t),a=0,s=[];for(n in c)n!=u&&r(c,n)&&s.push(n);for(;e.length>a;)r(c,n=e[a++])&&(~i(s,n)||s.push(n));return s}},function(t,e,n){"use strict";var r=n(23),o=n(92),i=n(91),u=n(17),c=n(40),a=Object.assign;t.exports=!a||n(11)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=a({},t)[n]||Object.keys(a({},e)).join("")!=r})?function(t,e){for(var n=u(t),a=arguments.length,s=1,f=o.f,l=i.f;a>s;)for(var p,v=c(arguments[s++]),h=f?r(v).concat(f(v)):r(v),d=h.length,y=0;d>y;)l.call(v,p=h[y++])&&(n[p]=v[p]);return n}:a},function(t,e,n){var r=n(8);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){t.exports=!n(7)&&!n(11)(function(){return 7!=Object.defineProperty(n(24)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(5);r(r.S+r.F,"Object",{assign:n(96)})},function(t,e,n){n(99),t.exports=n(2).Object.assign},function(t,e,n){t.exports={default:n(100),__esModule:!0}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=u(n(101));e.autoregister=s;var o=n(90),i=u(n(42));function u(t){return t&&t.__esModule?t:{default:t}}var c={waitTimeout:400},a={install:function(t,e){e=(0,r.default)({},c,e),t.prototype.$intro=function(){return introJs.apply(void 0,arguments)};var n=t.extend(i.default);window.__introjsDiscovery=new n({propsData:e}),t.directive("intro",o.DIRECTIVES.intro),t.directive("intro-step",o.DIRECTIVES.step),t.directive("intro-position",o.DIRECTIVES.position),t.directive("intro-tooltip-class",o.DIRECTIVES.tooltipClass),t.directive("intro-highlight-class",o.DIRECTIVES.highlightClass),t.directive("intro-scroll-to",o.DIRECTIVES.scrollTo),t.directive("intro-disable-interaction",o.DIRECTIVES.disableInteraction),t.directive("intro-hint",o.DIRECTIVES.hint),t.directive("intro-hint-position",o.DIRECTIVES.hintPosition),t.directive("intro-autostart",o.DIRECTIVES.autostart),t.directive("intro-if",o.DIRECTIVES.conditional)}};function s(){window.Vue&&window.Vue.use(a)}e.default=a,s()}])});
//# sourceMappingURL=index.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(597)["introJs"]))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Intro.js v2.9.3
 * https://github.com/usablica/intro.js
 *
 * Copyright (C) 2017 Afshin Mehrabani (@afshinmeh)
 */

(function(f) {
    if (true) {
        module.exports = f();
        // deprecated function
        // @since 2.8.0
        module.exports.introJs = function () {
          console.warn('Deprecated: please use require("intro.js") directly, instead of the introJs method of the function');
          // introJs()
          return f().apply(this, arguments);
        };
    } else if (typeof define === "function" && define.amd) {
        define([], f);
    } else {
        var g;
        if (typeof window !== "undefined") {
            g = window;
        } else if (typeof global !== "undefined") {
            g = global;
        } else if (typeof self !== "undefined") {
            g = self;
        } else {
            g = this;
        }
        g.introJs = f();
    }
})(function () {
  //Default config/variables
  var VERSION = '2.9.3';

  /**
   * IntroJs main class
   *
   * @class IntroJs
   */
  function IntroJs(obj) {
    this._targetElement = obj;
    this._introItems = [];

    this._options = {
      /* Next button label in tooltip box */
      nextLabel: 'Next &rarr;',
      /* Previous button label in tooltip box */
      prevLabel: '&larr; Back',
      /* Skip button label in tooltip box */
      skipLabel: 'Skip',
      /* Done button label in tooltip box */
      doneLabel: 'Done',
      /* Hide previous button in the first step? Otherwise, it will be disabled button. */
      hidePrev: false,
      /* Hide next button in the last step? Otherwise, it will be disabled button. */
      hideNext: false,
      /* Default tooltip box position */
      tooltipPosition: 'bottom',
      /* Next CSS class for tooltip boxes */
      tooltipClass: '',
      /* CSS class that is added to the helperLayer */
      highlightClass: '',
      /* Close introduction when pressing Escape button? */
      exitOnEsc: true,
      /* Close introduction when clicking on overlay layer? */
      exitOnOverlayClick: true,
      /* Show step numbers in introduction? */
      showStepNumbers: true,
      /* Let user use keyboard to navigate the tour? */
      keyboardNavigation: true,
      /* Show tour control buttons? */
      showButtons: true,
      /* Show tour bullets? */
      showBullets: true,
      /* Show tour progress? */
      showProgress: false,
      /* Scroll to highlighted element? */
      scrollToElement: true,
      /*
       * Should we scroll the tooltip or target element?
       *
       * Options are: 'element' or 'tooltip'
       */
      scrollTo: 'element',
      /* Padding to add after scrolling when element is not in the viewport (in pixels) */
      scrollPadding: 30,
      /* Set the overlay opacity */
      overlayOpacity: 0.8,
      /* Precedence of positions, when auto is enabled */
      positionPrecedence: ["bottom", "top", "right", "left"],
      /* Disable an interaction with element? */
      disableInteraction: false,
      /* Set how much padding to be used around helper element */
      helperElementPadding: 10,
      /* Default hint position */
      hintPosition: 'top-middle',
      /* Hint button label */
      hintButtonLabel: 'Got it',
      /* Adding animation to hints? */
      hintAnimation: true,
      /* additional classes to put on the buttons */
      buttonClass: "introjs-button"
    };
  }

  /**
   * Initiate a new introduction/guide from an element in the page
   *
   * @api private
   * @method _introForElement
   * @param {Object} targetElm
   * @param {String} group
   * @returns {Boolean} Success or not?
   */
  function _introForElement(targetElm, group) {
    var allIntroSteps = targetElm.querySelectorAll("*[data-intro]"),
        introItems = [];

    if (this._options.steps) {
      //use steps passed programmatically
      _forEach(this._options.steps, function (step) {
        var currentItem = _cloneObject(step);

        //set the step
        currentItem.step = introItems.length + 1;

        //use querySelector function only when developer used CSS selector
        if (typeof (currentItem.element) === 'string') {
          //grab the element with given selector from the page
          currentItem.element = document.querySelector(currentItem.element);
        }

        //intro without element
        if (typeof (currentItem.element) === 'undefined' || currentItem.element === null) {
          var floatingElementQuery = document.querySelector(".introjsFloatingElement");

          if (floatingElementQuery === null) {
            floatingElementQuery = document.createElement('div');
            floatingElementQuery.className = 'introjsFloatingElement';

            document.body.appendChild(floatingElementQuery);
          }

          currentItem.element  = floatingElementQuery;
          currentItem.position = 'floating';
        }

        currentItem.scrollTo = currentItem.scrollTo || this._options.scrollTo;

        if (typeof (currentItem.disableInteraction) === 'undefined') {
          currentItem.disableInteraction = this._options.disableInteraction;
        }

        if (currentItem.element !== null) {
          introItems.push(currentItem);
        }        
      }.bind(this));

    } else {
      //use steps from data-* annotations
      var elmsLength = allIntroSteps.length;
      var disableInteraction;
      
      //if there's no element to intro
      if (elmsLength < 1) {
        return false;
      }

      _forEach(allIntroSteps, function (currentElement) {
        
        // PR #80
        // start intro for groups of elements
        if (group && (currentElement.getAttribute("data-intro-group") !== group)) {
          return;
        }

        // skip hidden elements
        if (currentElement.style.display === 'none') {
          return;
        }

        var step = parseInt(currentElement.getAttribute('data-step'), 10);

        if (typeof (currentElement.getAttribute('data-disable-interaction')) !== 'undefined') {
          disableInteraction = !!currentElement.getAttribute('data-disable-interaction');
        } else {
          disableInteraction = this._options.disableInteraction;
        }

        if (step > 0) {
          introItems[step - 1] = {
            element: currentElement,
            intro: currentElement.getAttribute('data-intro'),
            step: parseInt(currentElement.getAttribute('data-step'), 10),
            tooltipClass: currentElement.getAttribute('data-tooltipclass'),
            highlightClass: currentElement.getAttribute('data-highlightclass'),
            position: currentElement.getAttribute('data-position') || this._options.tooltipPosition,
            scrollTo: currentElement.getAttribute('data-scrollto') || this._options.scrollTo,
            disableInteraction: disableInteraction
          };
        }
      }.bind(this));

      //next add intro items without data-step
      //todo: we need a cleanup here, two loops are redundant
      var nextStep = 0;

      _forEach(allIntroSteps, function (currentElement) {
        
        // PR #80
        // start intro for groups of elements
        if (group && (currentElement.getAttribute("data-intro-group") !== group)) {
          return;
        }
        
        if (currentElement.getAttribute('data-step') === null) {

          while (true) {
            if (typeof introItems[nextStep] === 'undefined') {
              break;
            } else {
              nextStep++;
            }
          } 

          if (typeof (currentElement.getAttribute('data-disable-interaction')) !== 'undefined') {
            disableInteraction = !!currentElement.getAttribute('data-disable-interaction');
          } else {
            disableInteraction = this._options.disableInteraction;
          }

          introItems[nextStep] = {
            element: currentElement,
            intro: currentElement.getAttribute('data-intro'),
            step: nextStep + 1,
            tooltipClass: currentElement.getAttribute('data-tooltipclass'),
            highlightClass: currentElement.getAttribute('data-highlightclass'),
            position: currentElement.getAttribute('data-position') || this._options.tooltipPosition,
            scrollTo: currentElement.getAttribute('data-scrollto') || this._options.scrollTo,
            disableInteraction: disableInteraction
          };
        }
      }.bind(this));
    }

    //removing undefined/null elements
    var tempIntroItems = [];
    for (var z = 0; z < introItems.length; z++) {
      if (introItems[z]) {
        // copy non-falsy values to the end of the array
        tempIntroItems.push(introItems[z]);  
      } 
    }

    introItems = tempIntroItems;

    //Ok, sort all items with given steps
    introItems.sort(function (a, b) {
      return a.step - b.step;
    });

    //set it to the introJs object
    this._introItems = introItems;

    //add overlay layer to the page
    if(_addOverlayLayer.call(this, targetElm)) {
      //then, start the show
      _nextStep.call(this);

      if (this._options.keyboardNavigation) {
        DOMEvent.on(window, 'keydown', _onKeyDown, this, true);
      }
      //for window resize
      DOMEvent.on(window, 'resize', _onResize, this, true);
    }
    return false;
  }

  function _onResize () {
    this.refresh.call(this);
  }

  /**
  * on keyCode:
  * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
  * This feature has been removed from the Web standards.
  * Though some browsers may still support it, it is in
  * the process of being dropped.
  * Instead, you should use KeyboardEvent.code,
  * if it's implemented.
  *
  * jQuery's approach is to test for
  *   (1) e.which, then
  *   (2) e.charCode, then
  *   (3) e.keyCode
  * https://github.com/jquery/jquery/blob/a6b0705294d336ae2f63f7276de0da1195495363/src/event.js#L638
  *
  * @param type var
  * @return type
  */
  function _onKeyDown (e) {
    var code = (e.code === null) ? e.which : e.code;

    // if code/e.which is null
    if (code === null) {
      code = (e.charCode === null) ? e.keyCode : e.charCode;
    }
    
    if ((code === 'Escape' || code === 27) && this._options.exitOnEsc === true) {
      //escape key pressed, exit the intro
      //check if exit callback is defined
      _exitIntro.call(this, this._targetElement);
    } else if (code === 'ArrowLeft' || code === 37) {
      //left arrow
      _previousStep.call(this);
    } else if (code === 'ArrowRight' || code === 39) {
      //right arrow
      _nextStep.call(this);
    } else if (code === 'Enter' || code === 13) {
      //srcElement === ie
      var target = e.target || e.srcElement;
      if (target && target.className.match('introjs-prevbutton')) {
        //user hit enter while focusing on previous button
        _previousStep.call(this);
      } else if (target && target.className.match('introjs-skipbutton')) {
        //user hit enter while focusing on skip button
        if (this._introItems.length - 1 === this._currentStep && typeof (this._introCompleteCallback) === 'function') {
            this._introCompleteCallback.call(this);
        }

        _exitIntro.call(this, this._targetElement);
      } else if (target && target.getAttribute('data-stepnumber')) {
        // user hit enter while focusing on step bullet
        target.click();
      } else {
        //default behavior for responding to enter
        _nextStep.call(this);
      }

      //prevent default behaviour on hitting Enter, to prevent steps being skipped in some browsers
      if(e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
    }
  }

 /*
   * makes a copy of the object
   * @api private
   * @method _cloneObject
  */
  function _cloneObject(object) {
      if (object === null || typeof (object) !== 'object' || typeof (object.nodeType) !== 'undefined') {
        return object;
      }
      var temp = {};
      for (var key in object) {
        if (typeof(window.jQuery) !== 'undefined' && object[key] instanceof window.jQuery) {
          temp[key] = object[key];
        } else {
          temp[key] = _cloneObject(object[key]);
        }
      }
      return temp;
  }
  /**
   * Go to specific step of introduction
   *
   * @api private
   * @method _goToStep
   */
  function _goToStep(step) {
    //because steps starts with zero
    this._currentStep = step - 2;
    if (typeof (this._introItems) !== 'undefined') {
      _nextStep.call(this);
    }
  }

  /**
   * Go to the specific step of introduction with the explicit [data-step] number
   *
   * @api private
   * @method _goToStepNumber
   */
  function _goToStepNumber(step) {
    this._currentStepNumber = step;
    if (typeof (this._introItems) !== 'undefined') {
      _nextStep.call(this);
    }
  }

  /**
   * Go to next step on intro
   *
   * @api private
   * @method _nextStep
   */
  function _nextStep() {
    this._direction = 'forward';

    if (typeof (this._currentStepNumber) !== 'undefined') {
      _forEach(this._introItems, function (item, i) {
        if( item.step === this._currentStepNumber ) {
          this._currentStep = i - 1;
          this._currentStepNumber = undefined;
        }
      }.bind(this));
    }

    if (typeof (this._currentStep) === 'undefined') {
      this._currentStep = 0;
    } else {
      ++this._currentStep;
    }

    var nextStep = this._introItems[this._currentStep];
    var continueStep = true;

    if (typeof (this._introBeforeChangeCallback) !== 'undefined') {
      continueStep = this._introBeforeChangeCallback.call(this, nextStep.element);
    }

    // if `onbeforechange` returned `false`, stop displaying the element
    if (continueStep === false) {
      --this._currentStep;
      return false;
    }

    if ((this._introItems.length) <= this._currentStep) {
      //end of the intro
      //check if any callback is defined
      if (typeof (this._introCompleteCallback) === 'function') {
        this._introCompleteCallback.call(this);
      }
      _exitIntro.call(this, this._targetElement);
      return;
    }

    _showElement.call(this, nextStep);
  }

  /**
   * Go to previous step on intro
   *
   * @api private
   * @method _previousStep
   */
  function _previousStep() {
    this._direction = 'backward';

    if (this._currentStep === 0) {
      return false;
    }

    --this._currentStep;

    var nextStep = this._introItems[this._currentStep];
    var continueStep = true;

    if (typeof (this._introBeforeChangeCallback) !== 'undefined') {
      continueStep = this._introBeforeChangeCallback.call(this, nextStep.element);
    }

    // if `onbeforechange` returned `false`, stop displaying the element
    if (continueStep === false) {
      ++this._currentStep;
      return false;
    }

    _showElement.call(this, nextStep);
  }

  /**
   * Update placement of the intro objects on the screen
   * @api private
   */
  function _refresh() {
    // re-align intros
    _setHelperLayerPosition.call(this, document.querySelector('.introjs-helperLayer'));
    _setHelperLayerPosition.call(this, document.querySelector('.introjs-tooltipReferenceLayer'));
    _setHelperLayerPosition.call(this, document.querySelector('.introjs-disableInteraction'));

    // re-align tooltip
    if(this._currentStep !== undefined && this._currentStep !== null) {
      var oldHelperNumberLayer = document.querySelector('.introjs-helperNumberLayer'),
        oldArrowLayer        = document.querySelector('.introjs-arrow'),
        oldtooltipContainer  = document.querySelector('.introjs-tooltip');
      _placeTooltip.call(this, this._introItems[this._currentStep].element, oldtooltipContainer, oldArrowLayer, oldHelperNumberLayer);
    }

    //re-align hints
    _reAlignHints.call(this);
    return this;
  }

  /**
   * Exit from intro
   *
   * @api private
   * @method _exitIntro
   * @param {Object} targetElement
   * @param {Boolean} force - Setting to `true` will skip the result of beforeExit callback
   */
  function _exitIntro(targetElement, force) {
    var continueExit = true;

    // calling onbeforeexit callback
    //
    // If this callback return `false`, it would halt the process
    if (this._introBeforeExitCallback !== undefined) {
      continueExit = this._introBeforeExitCallback.call(this);
    }

    // skip this check if `force` parameter is `true`
    // otherwise, if `onbeforeexit` returned `false`, don't exit the intro
    if (!force && continueExit === false) return;

    //remove overlay layers from the page
    var overlayLayers = targetElement.querySelectorAll('.introjs-overlay');

    if (overlayLayers && overlayLayers.length) {
      _forEach(overlayLayers, function (overlayLayer) {
        overlayLayer.style.opacity = 0;
        window.setTimeout(function () {
          if (this.parentNode) {
            this.parentNode.removeChild(this);
          }
        }.bind(overlayLayer), 500);
      }.bind(this));
    }

    //remove all helper layers
    var helperLayer = targetElement.querySelector('.introjs-helperLayer');
    if (helperLayer) {
      helperLayer.parentNode.removeChild(helperLayer);
    }

    var referenceLayer = targetElement.querySelector('.introjs-tooltipReferenceLayer');
    if (referenceLayer) {
      referenceLayer.parentNode.removeChild(referenceLayer);
    }

    //remove disableInteractionLayer
    var disableInteractionLayer = targetElement.querySelector('.introjs-disableInteraction');
    if (disableInteractionLayer) {
      disableInteractionLayer.parentNode.removeChild(disableInteractionLayer);
    }

    //remove intro floating element
    var floatingElement = document.querySelector('.introjsFloatingElement');
    if (floatingElement) {
      floatingElement.parentNode.removeChild(floatingElement);
    }

    _removeShowElement();

    //remove `introjs-fixParent` class from the elements
    var fixParents = document.querySelectorAll('.introjs-fixParent');
    _forEach(fixParents, function (parent) {
      _removeClass(parent, /introjs-fixParent/g);
    });

    //clean listeners
    DOMEvent.off(window, 'keydown', _onKeyDown, this, true);
    DOMEvent.off(window, 'resize', _onResize, this, true);

    //check if any callback is defined
    if (this._introExitCallback !== undefined) {
      this._introExitCallback.call(this);
    }

    //set the step to zero
    this._currentStep = undefined;
  }

  /**
   * Render tooltip box in the page
   *
   * @api private
   * @method _placeTooltip
   * @param {HTMLElement} targetElement
   * @param {HTMLElement} tooltipLayer
   * @param {HTMLElement} arrowLayer
   * @param {HTMLElement} helperNumberLayer
   * @param {Boolean} hintMode
   */
  function _placeTooltip(targetElement, tooltipLayer, arrowLayer, helperNumberLayer, hintMode) {
    var tooltipCssClass = '',
        currentStepObj,
        tooltipOffset,
        targetOffset,
        windowSize,
        currentTooltipPosition;

    hintMode = hintMode || false;

    //reset the old style
    tooltipLayer.style.top        = null;
    tooltipLayer.style.right      = null;
    tooltipLayer.style.bottom     = null;
    tooltipLayer.style.left       = null;
    tooltipLayer.style.marginLeft = null;
    tooltipLayer.style.marginTop  = null;

    arrowLayer.style.display = 'inherit';

    if (typeof(helperNumberLayer) !== 'undefined' && helperNumberLayer !== null) {
      helperNumberLayer.style.top  = null;
      helperNumberLayer.style.left = null;
    }

    //prevent error when `this._currentStep` is undefined
    if (!this._introItems[this._currentStep]) return;

    //if we have a custom css class for each step
    currentStepObj = this._introItems[this._currentStep];
    if (typeof (currentStepObj.tooltipClass) === 'string') {
      tooltipCssClass = currentStepObj.tooltipClass;
    } else {
      tooltipCssClass = this._options.tooltipClass;
    }

    tooltipLayer.className = ('introjs-tooltip ' + tooltipCssClass).replace(/^\s+|\s+$/g, '');
    tooltipLayer.setAttribute('role', 'dialog');

    currentTooltipPosition = this._introItems[this._currentStep].position;

    // Floating is always valid, no point in calculating
    if (currentTooltipPosition !== "floating") { 
      currentTooltipPosition = _determineAutoPosition.call(this, targetElement, tooltipLayer, currentTooltipPosition);
    }

    var tooltipLayerStyleLeft;
    targetOffset  = _getOffset(targetElement);
    tooltipOffset = _getOffset(tooltipLayer);
    windowSize    = _getWinSize();

    _addClass(tooltipLayer, 'introjs-' + currentTooltipPosition);

    switch (currentTooltipPosition) {
      case 'top-right-aligned':
        arrowLayer.className      = 'introjs-arrow bottom-right';

        var tooltipLayerStyleRight = 0;
        _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer);
        tooltipLayer.style.bottom    = (targetOffset.height +  20) + 'px';
        break;

      case 'top-middle-aligned':
        arrowLayer.className      = 'introjs-arrow bottom-middle';

        var tooltipLayerStyleLeftRight = targetOffset.width / 2 - tooltipOffset.width / 2;

        // a fix for middle aligned hints
        if (hintMode) {
          tooltipLayerStyleLeftRight += 5;
        }

        if (_checkLeft(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, tooltipLayer)) {
          tooltipLayer.style.right = null;
          _checkRight(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, windowSize, tooltipLayer);
        }
        tooltipLayer.style.bottom = (targetOffset.height + 20) + 'px';
        break;

      case 'top-left-aligned':
      // top-left-aligned is the same as the default top
      case 'top':
        arrowLayer.className = 'introjs-arrow bottom';

        tooltipLayerStyleLeft = (hintMode) ? 0 : 15;

        _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer);
        tooltipLayer.style.bottom = (targetOffset.height +  20) + 'px';
        break;
      case 'right':
        tooltipLayer.style.left = (targetOffset.width + 20) + 'px';
        if (targetOffset.top + tooltipOffset.height > windowSize.height) {
          // In this case, right would have fallen below the bottom of the screen.
          // Modify so that the bottom of the tooltip connects with the target
          arrowLayer.className = "introjs-arrow left-bottom";
          tooltipLayer.style.top = "-" + (tooltipOffset.height - targetOffset.height - 20) + "px";
        } else {
          arrowLayer.className = 'introjs-arrow left';
        }
        break;
      case 'left':
        if (!hintMode && this._options.showStepNumbers === true) {
          tooltipLayer.style.top = '15px';
        }

        if (targetOffset.top + tooltipOffset.height > windowSize.height) {
          // In this case, left would have fallen below the bottom of the screen.
          // Modify so that the bottom of the tooltip connects with the target
          tooltipLayer.style.top = "-" + (tooltipOffset.height - targetOffset.height - 20) + "px";
          arrowLayer.className = 'introjs-arrow right-bottom';
        } else {
          arrowLayer.className = 'introjs-arrow right';
        }
        tooltipLayer.style.right = (targetOffset.width + 20) + 'px';

        break;
      case 'floating':
        arrowLayer.style.display = 'none';

        //we have to adjust the top and left of layer manually for intro items without element
        tooltipLayer.style.left   = '50%';
        tooltipLayer.style.top    = '50%';
        tooltipLayer.style.marginLeft = '-' + (tooltipOffset.width / 2)  + 'px';
        tooltipLayer.style.marginTop  = '-' + (tooltipOffset.height / 2) + 'px';

        if (typeof(helperNumberLayer) !== 'undefined' && helperNumberLayer !== null) {
          helperNumberLayer.style.left = '-' + ((tooltipOffset.width / 2) + 18) + 'px';
          helperNumberLayer.style.top  = '-' + ((tooltipOffset.height / 2) + 18) + 'px';
        }

        break;
      case 'bottom-right-aligned':
        arrowLayer.className      = 'introjs-arrow top-right';

        tooltipLayerStyleRight = 0;
        _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer);
        tooltipLayer.style.top    = (targetOffset.height +  20) + 'px';
        break;

      case 'bottom-middle-aligned':
        arrowLayer.className      = 'introjs-arrow top-middle';

        tooltipLayerStyleLeftRight = targetOffset.width / 2 - tooltipOffset.width / 2;

        // a fix for middle aligned hints
        if (hintMode) {
          tooltipLayerStyleLeftRight += 5;
        }

        if (_checkLeft(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, tooltipLayer)) {
          tooltipLayer.style.right = null;
          _checkRight(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, windowSize, tooltipLayer);
        }
        tooltipLayer.style.top = (targetOffset.height + 20) + 'px';
        break;

      // case 'bottom-left-aligned':
      // Bottom-left-aligned is the same as the default bottom
      // case 'bottom':
      // Bottom going to follow the default behavior
      default:
        arrowLayer.className = 'introjs-arrow top';

        tooltipLayerStyleLeft = 0;
        _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer);
        tooltipLayer.style.top    = (targetOffset.height +  20) + 'px';
    }
  }

  /**
   * Set tooltip left so it doesn't go off the right side of the window
   *
   * @return boolean true, if tooltipLayerStyleLeft is ok.  false, otherwise.
   */
  function _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer) {
    if (targetOffset.left + tooltipLayerStyleLeft + tooltipOffset.width > windowSize.width) {
      // off the right side of the window
      tooltipLayer.style.left = (windowSize.width - tooltipOffset.width - targetOffset.left) + 'px';
      return false;
    }
    tooltipLayer.style.left = tooltipLayerStyleLeft + 'px';
    return true;
  }

  /**
   * Set tooltip right so it doesn't go off the left side of the window
   *
   * @return boolean true, if tooltipLayerStyleRight is ok.  false, otherwise.
   */
  function _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer) {
    if (targetOffset.left + targetOffset.width - tooltipLayerStyleRight - tooltipOffset.width < 0) {
      // off the left side of the window
      tooltipLayer.style.left = (-targetOffset.left) + 'px';
      return false;
    }
    tooltipLayer.style.right = tooltipLayerStyleRight + 'px';
    return true;
  }

  /**
   * Determines the position of the tooltip based on the position precedence and availability
   * of screen space.
   *
   * @param {Object}    targetElement
   * @param {Object}    tooltipLayer
   * @param {String}    desiredTooltipPosition
   * @return {String}   calculatedPosition
   */
  function _determineAutoPosition(targetElement, tooltipLayer, desiredTooltipPosition) {

    // Take a clone of position precedence. These will be the available
    var possiblePositions = this._options.positionPrecedence.slice();

    var windowSize = _getWinSize();
    var tooltipHeight = _getOffset(tooltipLayer).height + 10;
    var tooltipWidth = _getOffset(tooltipLayer).width + 20;
    var targetElementRect = targetElement.getBoundingClientRect();

    // If we check all the possible areas, and there are no valid places for the tooltip, the element
    // must take up most of the screen real estate. Show the tooltip floating in the middle of the screen.
    var calculatedPosition = "floating";

    /*
    * auto determine position 
    */

    // Check for space below
    if (targetElementRect.bottom + tooltipHeight + tooltipHeight > windowSize.height) {
      _removeEntry(possiblePositions, "bottom");
    }

    // Check for space above
    if (targetElementRect.top - tooltipHeight < 0) {
      _removeEntry(possiblePositions, "top");
    }

    // Check for space to the right
    if (targetElementRect.right + tooltipWidth > windowSize.width) {
      _removeEntry(possiblePositions, "right");
    }

    // Check for space to the left
    if (targetElementRect.left - tooltipWidth < 0) {
      _removeEntry(possiblePositions, "left");
    }

    // @var {String}  ex: 'right-aligned'
    var desiredAlignment = (function (pos) {
      var hyphenIndex = pos.indexOf('-');
      if (hyphenIndex !== -1) {
        // has alignment
        return pos.substr(hyphenIndex);
      }
      return '';
    })(desiredTooltipPosition || '');

    // strip alignment from position
    if (desiredTooltipPosition) {
      // ex: "bottom-right-aligned"
      // should return 'bottom'
      desiredTooltipPosition = desiredTooltipPosition.split('-')[0];
    }

    if (possiblePositions.length) {
      if (desiredTooltipPosition !== "auto" &&
          possiblePositions.indexOf(desiredTooltipPosition) > -1) {
        // If the requested position is in the list, choose that
        calculatedPosition = desiredTooltipPosition;
      } else {
        // Pick the first valid position, in order
        calculatedPosition = possiblePositions[0];
      }
    }

    // only top and bottom positions have optional alignments
    if (['top', 'bottom'].indexOf(calculatedPosition) !== -1) {
      calculatedPosition += _determineAutoAlignment(targetElementRect.left, tooltipWidth, windowSize, desiredAlignment);
    }

    return calculatedPosition;
  }

  /**
  * auto-determine alignment
  * @param {Integer}  offsetLeft
  * @param {Integer}  tooltipWidth
  * @param {Object}   windowSize
  * @param {String}   desiredAlignment
  * @return {String}  calculatedAlignment
  */
  function _determineAutoAlignment (offsetLeft, tooltipWidth, windowSize, desiredAlignment) {
    var halfTooltipWidth = tooltipWidth / 2,
      winWidth = Math.min(windowSize.width, window.screen.width),
      possibleAlignments = ['-left-aligned', '-middle-aligned', '-right-aligned'],
      calculatedAlignment = '';
    
    // valid left must be at least a tooltipWidth
    // away from right side
    if (winWidth - offsetLeft < tooltipWidth) {
      _removeEntry(possibleAlignments, '-left-aligned');
    }

    // valid middle must be at least half 
    // width away from both sides
    if (offsetLeft < halfTooltipWidth || 
      winWidth - offsetLeft < halfTooltipWidth) {
      _removeEntry(possibleAlignments, '-middle-aligned');
    }

    // valid right must be at least a tooltipWidth
    // width away from left side
    if (offsetLeft < tooltipWidth) {
      _removeEntry(possibleAlignments, '-right-aligned');
    }

    if (possibleAlignments.length) {
      if (possibleAlignments.indexOf(desiredAlignment) !== -1) {
        // the desired alignment is valid
        calculatedAlignment = desiredAlignment;
      } else {
        // pick the first valid position, in order
        calculatedAlignment = possibleAlignments[0];
      }
    } else {
      // if screen width is too small 
      // for ANY alignment, middle is 
      // probably the best for visibility
      calculatedAlignment = '-middle-aligned';
    }

    return calculatedAlignment;
  }

  /**
   * Remove an entry from a string array if it's there, does nothing if it isn't there.
   *
   * @param {Array} stringArray
   * @param {String} stringToRemove
   */
  function _removeEntry(stringArray, stringToRemove) {
    if (stringArray.indexOf(stringToRemove) > -1) {
      stringArray.splice(stringArray.indexOf(stringToRemove), 1);
    }
  }

  /**
   * Update the position of the helper layer on the screen
   *
   * @api private
   * @method _setHelperLayerPosition
   * @param {Object} helperLayer
   */
  function _setHelperLayerPosition(helperLayer) {
    if (helperLayer) {
      //prevent error when `this._currentStep` in undefined
      if (!this._introItems[this._currentStep]) return;

      var currentElement  = this._introItems[this._currentStep],
          elementPosition = _getOffset(currentElement.element),
          widthHeightPadding = this._options.helperElementPadding;

      // If the target element is fixed, the tooltip should be fixed as well.
      // Otherwise, remove a fixed class that may be left over from the previous
      // step.
      if (_isFixed(currentElement.element)) {
        _addClass(helperLayer, 'introjs-fixedTooltip');
      } else {
        _removeClass(helperLayer, 'introjs-fixedTooltip');
      }

      if (currentElement.position === 'floating') {
        widthHeightPadding = 0;
      }

      //set new position to helper layer
      helperLayer.style.cssText = 'width: ' + (elementPosition.width  + widthHeightPadding)  + 'px; ' +
                                        'height:' + (elementPosition.height + widthHeightPadding)  + 'px; ' +
                                        'top:'    + (elementPosition.top    - widthHeightPadding / 2)   + 'px;' +
                                        'left: '  + (elementPosition.left   - widthHeightPadding / 2)   + 'px;';

    }
  }

  /**
   * Add disableinteraction layer and adjust the size and position of the layer
   *
   * @api private
   * @method _disableInteraction
   */
  function _disableInteraction() {
    var disableInteractionLayer = document.querySelector('.introjs-disableInteraction');

    if (disableInteractionLayer === null) {
      disableInteractionLayer = document.createElement('div');
      disableInteractionLayer.className = 'introjs-disableInteraction';
      this._targetElement.appendChild(disableInteractionLayer);
    }

    _setHelperLayerPosition.call(this, disableInteractionLayer);
  }

  /**
   * Setting anchors to behave like buttons
   *
   * @api private
   * @method _setAnchorAsButton
   */
  function _setAnchorAsButton(anchor){
    anchor.setAttribute('role', 'button');
    anchor.tabIndex = 0;
  }

  /**
   * Show an element on the page
   *
   * @api private
   * @method _showElement
   * @param {Object} targetElement
   */
  function _showElement(targetElement) {
    if (typeof (this._introChangeCallback) !== 'undefined') {
      this._introChangeCallback.call(this, targetElement.element);
    }

    var self = this,
        oldHelperLayer = document.querySelector('.introjs-helperLayer'),
        oldReferenceLayer = document.querySelector('.introjs-tooltipReferenceLayer'),
        highlightClass = 'introjs-helperLayer',
        nextTooltipButton,
        prevTooltipButton,
        skipTooltipButton,
        scrollParent;

    //check for a current step highlight class
    if (typeof (targetElement.highlightClass) === 'string') {
      highlightClass += (' ' + targetElement.highlightClass);
    }
    //check for options highlight class
    if (typeof (this._options.highlightClass) === 'string') {
      highlightClass += (' ' + this._options.highlightClass);
    }

    if (oldHelperLayer !== null) {
      var oldHelperNumberLayer = oldReferenceLayer.querySelector('.introjs-helperNumberLayer'),
          oldtooltipLayer      = oldReferenceLayer.querySelector('.introjs-tooltiptext'),
          oldArrowLayer        = oldReferenceLayer.querySelector('.introjs-arrow'),
          oldtooltipContainer  = oldReferenceLayer.querySelector('.introjs-tooltip');
          
      skipTooltipButton    = oldReferenceLayer.querySelector('.introjs-skipbutton');
      prevTooltipButton    = oldReferenceLayer.querySelector('.introjs-prevbutton');
      nextTooltipButton    = oldReferenceLayer.querySelector('.introjs-nextbutton');

      //update or reset the helper highlight class
      oldHelperLayer.className = highlightClass;
      //hide the tooltip
      oldtooltipContainer.style.opacity = 0;
      oldtooltipContainer.style.display = "none";

      if (oldHelperNumberLayer !== null) {
        var lastIntroItem = this._introItems[(targetElement.step - 2 >= 0 ? targetElement.step - 2 : 0)];

        if (lastIntroItem !== null && (this._direction === 'forward' && lastIntroItem.position === 'floating') || (this._direction === 'backward' && targetElement.position === 'floating')) {
          oldHelperNumberLayer.style.opacity = 0;
        }
      }

      // scroll to element
      scrollParent = _getScrollParent( targetElement.element );

      if (scrollParent !== document.body) {
        // target is within a scrollable element
        _scrollParentToElement(scrollParent, targetElement.element);
      }

      // set new position to helper layer
      _setHelperLayerPosition.call(self, oldHelperLayer);
      _setHelperLayerPosition.call(self, oldReferenceLayer);

      //remove `introjs-fixParent` class from the elements
      var fixParents = document.querySelectorAll('.introjs-fixParent');
      _forEach(fixParents, function (parent) {
        _removeClass(parent, /introjs-fixParent/g);
      });
      
      //remove old classes if the element still exist
      _removeShowElement();

      //we should wait until the CSS3 transition is competed (it's 0.3 sec) to prevent incorrect `height` and `width` calculation
      if (self._lastShowElementTimer) {
        window.clearTimeout(self._lastShowElementTimer);
      }

      self._lastShowElementTimer = window.setTimeout(function() {
        //set current step to the label
        if (oldHelperNumberLayer !== null) {
          oldHelperNumberLayer.innerHTML = targetElement.step;
        }
        //set current tooltip text
        oldtooltipLayer.innerHTML = targetElement.intro;
        //set the tooltip position
        oldtooltipContainer.style.display = "block";
        _placeTooltip.call(self, targetElement.element, oldtooltipContainer, oldArrowLayer, oldHelperNumberLayer);

        //change active bullet
        if (self._options.showBullets) {
            oldReferenceLayer.querySelector('.introjs-bullets li > a.active').className = '';
            oldReferenceLayer.querySelector('.introjs-bullets li > a[data-stepnumber="' + targetElement.step + '"]').className = 'active';
        }
        oldReferenceLayer.querySelector('.introjs-progress .introjs-progressbar').style.cssText = 'width:' + _getProgress.call(self) + '%;';
        oldReferenceLayer.querySelector('.introjs-progress .introjs-progressbar').setAttribute('aria-valuenow', _getProgress.call(self));

        //show the tooltip
        oldtooltipContainer.style.opacity = 1;
        if (oldHelperNumberLayer) oldHelperNumberLayer.style.opacity = 1;

        //reset button focus
        if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null && /introjs-donebutton/gi.test(skipTooltipButton.className)) {
          // skip button is now "done" button
          skipTooltipButton.focus();
        } else if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
          //still in the tour, focus on next
          nextTooltipButton.focus();
        }

        // change the scroll of the window, if needed
        _scrollTo.call(self, targetElement.scrollTo, targetElement, oldtooltipLayer);
      }, 350);

      // end of old element if-else condition
    } else {
      var helperLayer       = document.createElement('div'),
          referenceLayer    = document.createElement('div'),
          arrowLayer        = document.createElement('div'),
          tooltipLayer      = document.createElement('div'),
          tooltipTextLayer  = document.createElement('div'),
          bulletsLayer      = document.createElement('div'),
          progressLayer     = document.createElement('div'),
          buttonsLayer      = document.createElement('div');

      helperLayer.className = highlightClass;
      referenceLayer.className = 'introjs-tooltipReferenceLayer';

      // scroll to element
      scrollParent = _getScrollParent( targetElement.element );

      if (scrollParent !== document.body) {
        // target is within a scrollable element
        _scrollParentToElement(scrollParent, targetElement.element);
      }

      //set new position to helper layer
      _setHelperLayerPosition.call(self, helperLayer);
      _setHelperLayerPosition.call(self, referenceLayer);

      //add helper layer to target element
      this._targetElement.appendChild(helperLayer);
      this._targetElement.appendChild(referenceLayer);

      arrowLayer.className = 'introjs-arrow';

      tooltipTextLayer.className = 'introjs-tooltiptext';
      tooltipTextLayer.innerHTML = targetElement.intro;

      bulletsLayer.className = 'introjs-bullets';

      if (this._options.showBullets === false) {
        bulletsLayer.style.display = 'none';
      }

      var ulContainer = document.createElement('ul');
      ulContainer.setAttribute('role', 'tablist');

      var anchorClick = function () {
          self.goToStep(this.getAttribute('data-stepnumber'));
      };

      _forEach(this._introItems, function (item, i) {
        var innerLi    = document.createElement('li');
        var anchorLink = document.createElement('a');
        
        innerLi.setAttribute('role', 'presentation');
        anchorLink.setAttribute('role', 'tab');

        anchorLink.onclick = anchorClick;

        if (i === (targetElement.step-1)) {
          anchorLink.className = 'active';
        } 

        _setAnchorAsButton(anchorLink);
        anchorLink.innerHTML = "&nbsp;";
        anchorLink.setAttribute('data-stepnumber', item.step);

        innerLi.appendChild(anchorLink);
        ulContainer.appendChild(innerLi);
      });

      bulletsLayer.appendChild(ulContainer);

      progressLayer.className = 'introjs-progress';

      if (this._options.showProgress === false) {
        progressLayer.style.display = 'none';
      }
      var progressBar = document.createElement('div');
      progressBar.className = 'introjs-progressbar';
      progressBar.setAttribute('role', 'progress');
      progressBar.setAttribute('aria-valuemin', 0);
      progressBar.setAttribute('aria-valuemax', 100);
      progressBar.setAttribute('aria-valuenow', _getProgress.call(this));
      progressBar.style.cssText = 'width:' + _getProgress.call(this) + '%;';

      progressLayer.appendChild(progressBar);

      buttonsLayer.className = 'introjs-tooltipbuttons';
      if (this._options.showButtons === false) {
        buttonsLayer.style.display = 'none';
      }

      tooltipLayer.className = 'introjs-tooltip';
      tooltipLayer.appendChild(tooltipTextLayer);
      tooltipLayer.appendChild(bulletsLayer);
      tooltipLayer.appendChild(progressLayer);

      //add helper layer number
      var helperNumberLayer = document.createElement('span');
      if (this._options.showStepNumbers === true) {
        helperNumberLayer.className = 'introjs-helperNumberLayer';
        helperNumberLayer.innerHTML = targetElement.step;
        referenceLayer.appendChild(helperNumberLayer);
      }

      tooltipLayer.appendChild(arrowLayer);
      referenceLayer.appendChild(tooltipLayer);

      //next button
      nextTooltipButton = document.createElement('a');

      nextTooltipButton.onclick = function() {
        if (self._introItems.length - 1 !== self._currentStep) {
          _nextStep.call(self);
        }
      };

      _setAnchorAsButton(nextTooltipButton);
      nextTooltipButton.innerHTML = this._options.nextLabel;

      //previous button
      prevTooltipButton = document.createElement('a');

      prevTooltipButton.onclick = function() {
        if (self._currentStep !== 0) {
          _previousStep.call(self);
        }
      };

      _setAnchorAsButton(prevTooltipButton);
      prevTooltipButton.innerHTML = this._options.prevLabel;

      //skip button
      skipTooltipButton = document.createElement('a');
      skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton ';
      _setAnchorAsButton(skipTooltipButton);
      skipTooltipButton.innerHTML = this._options.skipLabel;

      skipTooltipButton.onclick = function() {
        if (self._introItems.length - 1 === self._currentStep && typeof (self._introCompleteCallback) === 'function') {
          self._introCompleteCallback.call(self);
        }

        if (self._introItems.length - 1 !== self._currentStep && typeof (self._introExitCallback) === 'function') {
          self._introExitCallback.call(self);
        }

        if (typeof(self._introSkipCallback) === 'function') {
          self._introSkipCallback.call(self);
        }

        _exitIntro.call(self, self._targetElement);
      };

      buttonsLayer.appendChild(skipTooltipButton);

      //in order to prevent displaying next/previous button always
      if (this._introItems.length > 1) {
        buttonsLayer.appendChild(prevTooltipButton);
        buttonsLayer.appendChild(nextTooltipButton);
      }

      tooltipLayer.appendChild(buttonsLayer);

      //set proper position
      _placeTooltip.call(self, targetElement.element, tooltipLayer, arrowLayer, helperNumberLayer);

      // change the scroll of the window, if needed
      _scrollTo.call(this, targetElement.scrollTo, targetElement, tooltipLayer);

      //end of new element if-else condition
    }

    // removing previous disable interaction layer
    var disableInteractionLayer = self._targetElement.querySelector('.introjs-disableInteraction');
    if (disableInteractionLayer) {
      disableInteractionLayer.parentNode.removeChild(disableInteractionLayer);
    }

    //disable interaction
    if (targetElement.disableInteraction) {
      _disableInteraction.call(self);
    }

    // when it's the first step of tour
    if (this._currentStep === 0 && this._introItems.length > 1) {
      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton';
      }
      if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
        nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton';
      }

      if (this._options.hidePrev === true) {
        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
          prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton introjs-hidden';
        }
        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
          _addClass(nextTooltipButton, 'introjs-fullbutton');
        }
      } else {
        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
          prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton introjs-disabled';
        }
      }

      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.innerHTML = this._options.skipLabel;
      }
    } else if (this._introItems.length - 1 === this._currentStep || this._introItems.length === 1) {
      // last step of tour
      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.innerHTML = this._options.doneLabel;
        // adding donebutton class in addition to skipbutton
        _addClass(skipTooltipButton, 'introjs-donebutton');
      }
      if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
        prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton';
      }

      if (this._options.hideNext === true) {
        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
          nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton introjs-hidden';
        }
        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
          _addClass(prevTooltipButton, 'introjs-fullbutton');
        }
      } else {
        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
          nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton introjs-disabled';
        }
      }
    } else {
      // steps between start and end
      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton';
      }
      if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
        prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton';
      }
      if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
        nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton';
      }
      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
        skipTooltipButton.innerHTML = this._options.skipLabel;
      }
    }

    prevTooltipButton.setAttribute('role', 'button');
    nextTooltipButton.setAttribute('role', 'button');
    skipTooltipButton.setAttribute('role', 'button');

    //Set focus on "next" button, so that hitting Enter always moves you onto the next step
    if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
      nextTooltipButton.focus();
    }

    _setShowElement(targetElement);

    if (typeof (this._introAfterChangeCallback) !== 'undefined') {
      this._introAfterChangeCallback.call(this, targetElement.element);
    }
  }

  /**
   * To change the scroll of `window` after highlighting an element
   *
   * @api private
   * @method _scrollTo
   * @param {String} scrollTo
   * @param {Object} targetElement
   * @param {Object} tooltipLayer
   */
  function _scrollTo(scrollTo, targetElement, tooltipLayer) {
    if (scrollTo === 'off') return;  
    var rect;

    if (!this._options.scrollToElement) return;

    if (scrollTo === 'tooltip') {
      rect = tooltipLayer.getBoundingClientRect();
    } else {
      rect = targetElement.element.getBoundingClientRect();
    }

    if (!_elementInViewport(targetElement.element)) {
      var winHeight = _getWinSize().height;
      var top = rect.bottom - (rect.bottom - rect.top);

      // TODO (afshinm): do we need scroll padding now?
      // I have changed the scroll option and now it scrolls the window to
      // the center of the target element or tooltip.

      if (top < 0 || targetElement.element.clientHeight > winHeight) {
        window.scrollBy(0, rect.top - ((winHeight / 2) -  (rect.height / 2)) - this._options.scrollPadding); // 30px padding from edge to look nice

      //Scroll down
      } else {
        window.scrollBy(0, rect.top - ((winHeight / 2) -  (rect.height / 2)) + this._options.scrollPadding); // 30px padding from edge to look nice
      }
    }
  }

  /**
   * To remove all show element(s)
   *
   * @api private
   * @method _removeShowElement
   */
  function _removeShowElement() {
    var elms = document.querySelectorAll('.introjs-showElement');

    _forEach(elms, function (elm) {
      _removeClass(elm, /introjs-[a-zA-Z]+/g);
    });
  }

  /**
   * To set the show element
   * This function set a relative (in most cases) position and changes the z-index
   *
   * @api private
   * @method _setShowElement
   * @param {Object} targetElement
   */
  function _setShowElement(targetElement) {
    var parentElm;
    // we need to add this show element class to the parent of SVG elements
    // because the SVG elements can't have independent z-index
    if (targetElement.element instanceof SVGElement) {
      parentElm = targetElement.element.parentNode;

      while (targetElement.element.parentNode !== null) {
        if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;

        if (parentElm.tagName.toLowerCase() === 'svg') {
          _addClass(parentElm, 'introjs-showElement introjs-relativePosition');
        }

        parentElm = parentElm.parentNode;
      }
    }

    _addClass(targetElement.element, 'introjs-showElement');

    var currentElementPosition = _getPropValue(targetElement.element, 'position');
    if (currentElementPosition !== 'absolute' &&
        currentElementPosition !== 'relative' &&
        currentElementPosition !== 'fixed') {
      //change to new intro item
      _addClass(targetElement.element, 'introjs-relativePosition');
    }

    parentElm = targetElement.element.parentNode;
    while (parentElm !== null) {
      if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;

      //fix The Stacking Context problem.
      //More detail: https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Understanding_z_index/The_stacking_context
      var zIndex = _getPropValue(parentElm, 'z-index');
      var opacity = parseFloat(_getPropValue(parentElm, 'opacity'));
      var transform = _getPropValue(parentElm, 'transform') || _getPropValue(parentElm, '-webkit-transform') || _getPropValue(parentElm, '-moz-transform') || _getPropValue(parentElm, '-ms-transform') || _getPropValue(parentElm, '-o-transform');
      if (/[0-9]+/.test(zIndex) || opacity < 1 || (transform !== 'none' && transform !== undefined)) {
        _addClass(parentElm, 'introjs-fixParent');
      }

      parentElm = parentElm.parentNode;
    }
  }

  /**
  * Iterates arrays
  *
  * @param {Array} arr
  * @param {Function} forEachFnc
  * @param {Function} completeFnc
  * @return {Null}
  */
  function _forEach(arr, forEachFnc, completeFnc) {
    // in case arr is an empty query selector node list
    if (arr) {
      for (var i = 0, len = arr.length; i < len; i++) {
        forEachFnc(arr[i], i);
      }
    }

    if (typeof(completeFnc) === 'function') {
      completeFnc();
    }
  }

  /**
  * Mark any object with an incrementing number
  * used for keeping track of objects
  *
  * @param Object obj   Any object or DOM Element
  * @param String key
  * @return Object
  */
  var _stamp = (function () {
    var keys = {};
    return function stamp (obj, key) {
      
      // get group key
      key = key || 'introjs-stamp';

      // each group increments from 0
      keys[key] = keys[key] || 0;

      // stamp only once per object
      if (obj[key] === undefined) {
        // increment key for each new object
        obj[key] = keys[key]++;
      }

      return obj[key];
    };
  })();

  /**
  * DOMEvent Handles all DOM events
  *
  * methods:
  *
  * on - add event handler
  * off - remove event
  */
  var DOMEvent = (function () {
    function DOMEvent () {
      var events_key = 'introjs_event';
      
      /**
      * Gets a unique ID for an event listener
      *
      * @param Object obj
      * @param String type        event type
      * @param Function listener
      * @param Object context
      * @return String
      */
      this._id = function (obj, type, listener, context) {
        return type + _stamp(listener) + (context ? '_' + _stamp(context) : '');
      };

      /**
      * Adds event listener
      *
      * @param Object obj
      * @param String type        event type
      * @param Function listener
      * @param Object context
      * @param Boolean useCapture
      * @return null
      */
      this.on = function (obj, type, listener, context, useCapture) {
        var id = this._id.apply(this, arguments),
            handler = function (e) {
              return listener.call(context || obj, e || window.event);
            };

        if ('addEventListener' in obj) {
          obj.addEventListener(type, handler, useCapture);
        } else if ('attachEvent' in obj) {
          obj.attachEvent('on' + type, handler);
        }

        obj[events_key] = obj[events_key] || {};
        obj[events_key][id] = handler;
      };

      /**
      * Removes event listener
      *
      * @param Object obj
      * @param String type        event type
      * @param Function listener
      * @param Object context
      * @param Boolean useCapture
      * @return null
      */
      this.off = function (obj, type, listener, context, useCapture) {
        var id = this._id.apply(this, arguments),
            handler = obj[events_key] && obj[events_key][id];

        if (!handler) {
          return;
        }

        if ('removeEventListener' in obj) {
          obj.removeEventListener(type, handler, useCapture);
        } else if ('detachEvent' in obj) {
          obj.detachEvent('on' + type, handler);
        }

        obj[events_key][id] = null;
      };
    }

    return new DOMEvent();
  })();

  /**
   * Append a class to an element
   *
   * @api private
   * @method _addClass
   * @param {Object} element
   * @param {String} className
   * @returns null
   */
  function _addClass(element, className) {
    if (element instanceof SVGElement) {
      // svg
      var pre = element.getAttribute('class') || '';

      element.setAttribute('class', pre + ' ' + className);
    } else {
      if (element.classList !== undefined) {
        // check for modern classList property
        var classes = className.split(' ');
        _forEach(classes, function (cls) {
          element.classList.add( cls );
        });
      } else if (!element.className.match( className )) {
        // check if element doesn't already have className
        element.className += ' ' + className;
      }
    }
  }

  /**
   * Remove a class from an element
   *
   * @api private
   * @method _removeClass
   * @param {Object} element
   * @param {RegExp|String} classNameRegex can be regex or string
   * @returns null
   */
  function _removeClass(element, classNameRegex) {
    if (element instanceof SVGElement) {
      var pre = element.getAttribute('class') || '';

      element.setAttribute('class', pre.replace(classNameRegex, '').replace(/^\s+|\s+$/g, ''));
    } else {
      element.className = element.className.replace(classNameRegex, '').replace(/^\s+|\s+$/g, '');
    }
  }

  /**
   * Get an element CSS property on the page
   * Thanks to JavaScript Kit: http://www.javascriptkit.com/dhtmltutors/dhtmlcascade4.shtml
   *
   * @api private
   * @method _getPropValue
   * @param {Object} element
   * @param {String} propName
   * @returns Element's property value
   */
  function _getPropValue (element, propName) {
    var propValue = '';
    if (element.currentStyle) { //IE
      propValue = element.currentStyle[propName];
    } else if (document.defaultView && document.defaultView.getComputedStyle) { //Others
      propValue = document.defaultView.getComputedStyle(element, null).getPropertyValue(propName);
    }

    //Prevent exception in IE
    if (propValue && propValue.toLowerCase) {
      return propValue.toLowerCase();
    } else {
      return propValue;
    }
  }

  /**
   * Checks to see if target element (or parents) position is fixed or not
   *
   * @api private
   * @method _isFixed
   * @param {Object} element
   * @returns Boolean
   */
  function _isFixed (element) {
    var p = element.parentNode;

    if (!p || p.nodeName === 'HTML') {
      return false;
    }

    if (_getPropValue(element, 'position') === 'fixed') {
      return true;
    }

    return _isFixed(p);
  }

  /**
   * Provides a cross-browser way to get the screen dimensions
   * via: http://stackoverflow.com/questions/5864467/internet-explorer-innerheight
   *
   * @api private
   * @method _getWinSize
   * @returns {Object} width and height attributes
   */
  function _getWinSize() {
    if (window.innerWidth !== undefined) {
      return { width: window.innerWidth, height: window.innerHeight };
    } else {
      var D = document.documentElement;
      return { width: D.clientWidth, height: D.clientHeight };
    }
  }

  /**
   * Check to see if the element is in the viewport or not
   * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
   *
   * @api private
   * @method _elementInViewport
   * @param {Object} el
   */
  function _elementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      (rect.bottom+80) <= window.innerHeight && // add 80 to get the text right
      rect.right <= window.innerWidth
    );
  }

  /**
   * Add overlay layer to the page
   *
   * @api private
   * @method _addOverlayLayer
   * @param {Object} targetElm
   */
  function _addOverlayLayer(targetElm) {
    var overlayLayer = document.createElement('div'),
        styleText = '',
        self = this;

    //set css class name
    overlayLayer.className = 'introjs-overlay';

    //check if the target element is body, we should calculate the size of overlay layer in a better way
    if (!targetElm.tagName || targetElm.tagName.toLowerCase() === 'body') {
      styleText += 'top: 0;bottom: 0; left: 0;right: 0;position: fixed;';
      overlayLayer.style.cssText = styleText;
    } else {
      //set overlay layer position
      var elementPosition = _getOffset(targetElm);
      if (elementPosition) {
        styleText += 'width: ' + elementPosition.width + 'px; height:' + elementPosition.height + 'px; top:' + elementPosition.top + 'px;left: ' + elementPosition.left + 'px;';
        overlayLayer.style.cssText = styleText;
      }
    }

    targetElm.appendChild(overlayLayer);

    overlayLayer.onclick = function() {
      if (self._options.exitOnOverlayClick === true) {
        _exitIntro.call(self, targetElm);
      }
    };

    window.setTimeout(function() {
      styleText += 'opacity: ' + self._options.overlayOpacity.toString() + ';';
      overlayLayer.style.cssText = styleText;
    }, 10);

    return true;
  }

  /**
   * Removes open hint (tooltip hint)
   *
   * @api private
   * @method _removeHintTooltip
   */
  function _removeHintTooltip() {
    var tooltip = document.querySelector('.introjs-hintReference');

    if (tooltip) {
      var step = tooltip.getAttribute('data-step');
      tooltip.parentNode.removeChild(tooltip);
      return step;
    }
  }

  /**
   * Start parsing hint items
   *
   * @api private
   * @param {Object} targetElm
   * @method _startHint
   */
  function _populateHints(targetElm) {

    this._introItems = [];

    if (this._options.hints) {
      _forEach(this._options.hints, function (hint) {
        var currentItem = _cloneObject(hint);

        if (typeof(currentItem.element) === 'string') {
          //grab the element with given selector from the page
          currentItem.element = document.querySelector(currentItem.element);
        }

        currentItem.hintPosition = currentItem.hintPosition || this._options.hintPosition;
        currentItem.hintAnimation = currentItem.hintAnimation || this._options.hintAnimation;

        if (currentItem.element !== null) {
          this._introItems.push(currentItem);
        }
      }.bind(this));
    } else {
      var hints = targetElm.querySelectorAll('*[data-hint]');

      if (!hints || !hints.length) {
        return false;
      }

      //first add intro items with data-step
      _forEach(hints, function (currentElement) {
        // hint animation
        var hintAnimation = currentElement.getAttribute('data-hintanimation');

        if (hintAnimation) {
          hintAnimation = (hintAnimation === 'true');
        } else {
          hintAnimation = this._options.hintAnimation;
        }

        this._introItems.push({
          element: currentElement,
          hint: currentElement.getAttribute('data-hint'),
          hintPosition: currentElement.getAttribute('data-hintposition') || this._options.hintPosition,
          hintAnimation: hintAnimation,
          tooltipClass: currentElement.getAttribute('data-tooltipclass'),
          position: currentElement.getAttribute('data-position') || this._options.tooltipPosition
        });
      }.bind(this));
    }

    _addHints.call(this);

    /* 
    todo:
    these events should be removed at some point 
    */
    DOMEvent.on(document, 'click', _removeHintTooltip, this, false);
    DOMEvent.on(window, 'resize', _reAlignHints, this, true);
  }

  /**
   * Re-aligns all hint elements
   *
   * @api private
   * @method _reAlignHints
   */
  function _reAlignHints() {
    _forEach(this._introItems, function (item) {
      if (typeof(item.targetElement) === 'undefined') {
        return;
      }

      _alignHintPosition.call(this, item.hintPosition, item.element, item.targetElement);
    }.bind(this));
  }

  /**
  * Get a queryselector within the hint wrapper
  *
  * @param {String} selector
  * @return {NodeList|Array}
  */
  function _hintQuerySelectorAll(selector) {
    var hintsWrapper = document.querySelector('.introjs-hints');
    return (hintsWrapper) ? hintsWrapper.querySelectorAll(selector) : [];
  }

  /**
   * Hide a hint
   *
   * @api private
   * @method _hideHint
   */
  function _hideHint(stepId) {
    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];
    
    _removeHintTooltip.call(this);

    if (hint) {
      _addClass(hint, 'introjs-hidehint');
    }

    // call the callback function (if any)
    if (typeof (this._hintCloseCallback) !== 'undefined') {
      this._hintCloseCallback.call(this, stepId);
    }
  }

  /**
   * Hide all hints
   *
   * @api private
   * @method _hideHints
   */
  function _hideHints() {
    var hints = _hintQuerySelectorAll('.introjs-hint');

    _forEach(hints, function (hint) {
      _hideHint.call(this, hint.getAttribute('data-step'));
    }.bind(this));
  }

  /**
   * Show all hints
   *
   * @api private
   * @method _showHints
   */
  function _showHints() {
    var hints = _hintQuerySelectorAll('.introjs-hint');

    if (hints && hints.length) {
      _forEach(hints, function (hint) {
        _showHint.call(this, hint.getAttribute('data-step'));
      }.bind(this));
    } else {
      _populateHints.call(this, this._targetElement);
    }
  }

  /**
   * Show a hint
   *
   * @api private
   * @method _showHint
   */
  function _showHint(stepId) {
    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];

    if (hint) {
      _removeClass(hint, /introjs-hidehint/g);
    }
  }

  /**
   * Removes all hint elements on the page
   * Useful when you want to destroy the elements and add them again (e.g. a modal or popup)
   *
   * @api private
   * @method _removeHints
   */
  function _removeHints() {
    var hints = _hintQuerySelectorAll('.introjs-hint');

    _forEach(hints, function (hint) {
      _removeHint.call(this, hint.getAttribute('data-step'));
    }.bind(this));
  }

  /**
   * Remove one single hint element from the page
   * Useful when you want to destroy the element and add them again (e.g. a modal or popup)
   * Use removeHints if you want to remove all elements.
   *
   * @api private
   * @method _removeHint
   */
  function _removeHint(stepId) {
    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];

    if (hint) {
      hint.parentNode.removeChild(hint);
    }
  }

  /**
   * Add all available hints to the page
   *
   * @api private
   * @method _addHints
   */
  function _addHints() {
    var self = this;

    var hintsWrapper = document.querySelector('.introjs-hints');

    if (hintsWrapper === null) {
      hintsWrapper = document.createElement('div');
      hintsWrapper.className = 'introjs-hints';
    }

    /**
    * Returns an event handler unique to the hint iteration
    * 
    * @param {Integer} i
    * @return {Function}
    */
    var getHintClick = function (i) {
      return function(e) {
        var evt = e ? e : window.event;
        
        if (evt.stopPropagation) {
          evt.stopPropagation();
        }

        if (evt.cancelBubble !== null) {
          evt.cancelBubble = true;
        }

        _showHintDialog.call(self, i);
      };
    };

    _forEach(this._introItems, function(item, i) {
      // avoid append a hint twice
      if (document.querySelector('.introjs-hint[data-step="' + i + '"]')) {
        return;
      }

      var hint = document.createElement('a');
      _setAnchorAsButton(hint);

      hint.onclick = getHintClick(i);

      hint.className = 'introjs-hint';

      if (!item.hintAnimation) {
        _addClass(hint, 'introjs-hint-no-anim');
      }

      // hint's position should be fixed if the target element's position is fixed
      if (_isFixed(item.element)) {
        _addClass(hint, 'introjs-fixedhint');
      }

      var hintDot = document.createElement('div');
      hintDot.className = 'introjs-hint-dot';
      var hintPulse = document.createElement('div');
      hintPulse.className = 'introjs-hint-pulse';

      hint.appendChild(hintDot);
      hint.appendChild(hintPulse);
      hint.setAttribute('data-step', i);

      // we swap the hint element with target element
      // because _setHelperLayerPosition uses `element` property
      item.targetElement = item.element;
      item.element = hint;

      // align the hint position
      _alignHintPosition.call(this, item.hintPosition, hint, item.targetElement);

      hintsWrapper.appendChild(hint);
    }.bind(this));

    // adding the hints wrapper
    document.body.appendChild(hintsWrapper);

    // call the callback function (if any)
    if (typeof (this._hintsAddedCallback) !== 'undefined') {
      this._hintsAddedCallback.call(this);
    }
  }

  /**
   * Aligns hint position
   *
   * @api private
   * @method _alignHintPosition
   * @param {String} position
   * @param {Object} hint
   * @param {Object} element
   */
  function _alignHintPosition(position, hint, element) {
    // get/calculate offset of target element
    var offset = _getOffset.call(this, element);
    var iconWidth = 20;
    var iconHeight = 20;

    // align the hint element
    switch (position) {
      default:
      case 'top-left':
        hint.style.left = offset.left + 'px';
        hint.style.top = offset.top + 'px';
        break;
      case 'top-right':
        hint.style.left = (offset.left + offset.width - iconWidth) + 'px';
        hint.style.top = offset.top + 'px';
        break;
      case 'bottom-left':
        hint.style.left = offset.left + 'px';
        hint.style.top = (offset.top + offset.height - iconHeight) + 'px';
        break;
      case 'bottom-right':
        hint.style.left = (offset.left + offset.width - iconWidth) + 'px';
        hint.style.top = (offset.top + offset.height - iconHeight) + 'px';
        break;
      case 'middle-left':
        hint.style.left = offset.left + 'px';
        hint.style.top = (offset.top + (offset.height - iconHeight) / 2) + 'px';
        break;
      case 'middle-right':
        hint.style.left = (offset.left + offset.width - iconWidth) + 'px';
        hint.style.top = (offset.top + (offset.height - iconHeight) / 2) + 'px';
        break;
      case 'middle-middle':
        hint.style.left = (offset.left + (offset.width - iconWidth) / 2) + 'px';
        hint.style.top = (offset.top + (offset.height - iconHeight) / 2) + 'px';
        break;
      case 'bottom-middle':
        hint.style.left = (offset.left + (offset.width - iconWidth) / 2) + 'px';
        hint.style.top = (offset.top + offset.height - iconHeight) + 'px';
        break;
      case 'top-middle':
        hint.style.left = (offset.left + (offset.width - iconWidth) / 2) + 'px';
        hint.style.top = offset.top + 'px';
        break;
    }
  }

  /**
   * Triggers when user clicks on the hint element
   *
   * @api private
   * @method _showHintDialog
   * @param {Number} stepId
   */
  function _showHintDialog(stepId) {
    var hintElement = document.querySelector('.introjs-hint[data-step="' + stepId + '"]');
    var item = this._introItems[stepId];

    // call the callback function (if any)
    if (typeof (this._hintClickCallback) !== 'undefined') {
      this._hintClickCallback.call(this, hintElement, item, stepId);
    }

    // remove all open tooltips
    var removedStep = _removeHintTooltip.call(this);

    // to toggle the tooltip
    if (parseInt(removedStep, 10) === stepId) {
      return;
    }

    var tooltipLayer = document.createElement('div');
    var tooltipTextLayer = document.createElement('div');
    var arrowLayer = document.createElement('div');
    var referenceLayer = document.createElement('div');

    tooltipLayer.className = 'introjs-tooltip';

    tooltipLayer.onclick = function (e) {
      //IE9 & Other Browsers
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      //IE8 and Lower
      else {
        e.cancelBubble = true;
      }
    };

    tooltipTextLayer.className = 'introjs-tooltiptext';

    var tooltipWrapper = document.createElement('p');
    tooltipWrapper.innerHTML = item.hint;

    var closeButton = document.createElement('a');
    closeButton.className = this._options.buttonClass;
    closeButton.setAttribute('role', 'button');
    closeButton.innerHTML = this._options.hintButtonLabel;
    closeButton.onclick = _hideHint.bind(this, stepId);

    tooltipTextLayer.appendChild(tooltipWrapper);
    tooltipTextLayer.appendChild(closeButton);

    arrowLayer.className = 'introjs-arrow';
    tooltipLayer.appendChild(arrowLayer);

    tooltipLayer.appendChild(tooltipTextLayer);

    // set current step for _placeTooltip function
    this._currentStep = hintElement.getAttribute('data-step');

    // align reference layer position
    referenceLayer.className = 'introjs-tooltipReferenceLayer introjs-hintReference';
    referenceLayer.setAttribute('data-step', hintElement.getAttribute('data-step'));
    _setHelperLayerPosition.call(this, referenceLayer);

    referenceLayer.appendChild(tooltipLayer);
    document.body.appendChild(referenceLayer);

    //set proper position
    _placeTooltip.call(this, hintElement, tooltipLayer, arrowLayer, null, true);
  }

  /**
   * Get an element position on the page
   * Thanks to `meouw`: http://stackoverflow.com/a/442474/375966
   *
   * @api private
   * @method _getOffset
   * @param {Object} element
   * @returns Element's position info
   */
  function _getOffset(element) {
    var body = document.body;
    var docEl = document.documentElement;
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    var x = element.getBoundingClientRect();
    return {
      top: x.top + scrollTop,
      width: x.width,
      height: x.height,
      left: x.left + scrollLeft
    };
  }

  /**
  * Find the nearest scrollable parent
  * copied from https://stackoverflow.com/questions/35939886/find-first-scrollable-parent
  *
  * @param Element element
  * @return Element
  */
  function _getScrollParent(element) {
    var style = window.getComputedStyle(element);
    var excludeStaticParent = (style.position === "absolute");
    var overflowRegex = /(auto|scroll)/;

    if (style.position === "fixed") return document.body;
    
    for (var parent = element; (parent = parent.parentElement);) {
      style = window.getComputedStyle(parent);
      if (excludeStaticParent && style.position === "static") {
        continue;
      }
      if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }

    return document.body;
  }

  /**
  * scroll a scrollable element to a child element
  *
  * @param Element parent
  * @param Element element
  * @return Null
  */
  function _scrollParentToElement (parent, element) {
    parent.scrollTop = element.offsetTop - parent.offsetTop;
  }

  /**
   * Gets the current progress percentage
   *
   * @api private
   * @method _getProgress
   * @returns current progress percentage
   */
  function _getProgress() {
    // Steps are 0 indexed
    var currentStep = parseInt((this._currentStep + 1), 10);
    return ((currentStep / this._introItems.length) * 100);
  }

  /**
   * Overwrites obj1's values with obj2's and adds obj2's if non existent in obj1
   * via: http://stackoverflow.com/questions/171251/how-can-i-merge-properties-of-two-javascript-objects-dynamically
   *
   * @param obj1
   * @param obj2
   * @returns obj3 a new object based on obj1 and obj2
   */
  function _mergeOptions(obj1,obj2) {
    var obj3 = {},
      attrname;
    for (attrname in obj1) { obj3[attrname] = obj1[attrname]; }
    for (attrname in obj2) { obj3[attrname] = obj2[attrname]; }
    return obj3;
  }

  var introJs = function (targetElm) {
    var instance;

    if (typeof (targetElm) === 'object') {
      //Ok, create a new instance
      instance = new IntroJs(targetElm);

    } else if (typeof (targetElm) === 'string') {
      //select the target element with query selector
      var targetElement = document.querySelector(targetElm);

      if (targetElement) {
        instance = new IntroJs(targetElement);
      } else {
        throw new Error('There is no element with given selector.');
      }
    } else {
      instance = new IntroJs(document.body);
    }
    // add instance to list of _instances
    // passing group to _stamp to increment
    // from 0 onward somewhat reliably
    introJs.instances[ _stamp(instance, 'introjs-instance') ] = instance;

    return instance;
  };

  /**
   * Current IntroJs version
   *
   * @property version
   * @type String
   */
  introJs.version = VERSION;

  /**
  * key-val object helper for introJs instances
  *
  * @property instances
  * @type Object
  */
  introJs.instances = {};

  //Prototype
  introJs.fn = IntroJs.prototype = {
    clone: function () {
      return new IntroJs(this);
    },
    setOption: function(option, value) {
      this._options[option] = value;
      return this;
    },
    setOptions: function(options) {
      this._options = _mergeOptions(this._options, options);
      return this;
    },
    start: function (group) {
      _introForElement.call(this, this._targetElement, group);
      return this;
    },
    goToStep: function(step) {
      _goToStep.call(this, step);
      return this;
    },
    addStep: function(options) {
      if (!this._options.steps) {
        this._options.steps = [];
      }

      this._options.steps.push(options);

      return this;
    },
    addSteps: function(steps) {
      if (!steps.length) return;

      for(var index = 0; index < steps.length; index++) {
        this.addStep(steps[index]);
      }

      return this;
    },
    goToStepNumber: function(step) {
      _goToStepNumber.call(this, step);

      return this;
    },
    nextStep: function() {
      _nextStep.call(this);
      return this;
    },
    previousStep: function() {
      _previousStep.call(this);
      return this;
    },
    exit: function(force) {
      _exitIntro.call(this, this._targetElement, force);
      return this;
    },
    refresh: function() {
      _refresh.call(this);
      return this;
    },
    onbeforechange: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._introBeforeChangeCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onbeforechange was not a function');
      }
      return this;
    },
    onchange: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._introChangeCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onchange was not a function.');
      }
      return this;
    },
    onafterchange: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._introAfterChangeCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onafterchange was not a function');
      }
      return this;
    },
    oncomplete: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._introCompleteCallback = providedCallback;
      } else {
        throw new Error('Provided callback for oncomplete was not a function.');
      }
      return this;
    },
    onhintsadded: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._hintsAddedCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onhintsadded was not a function.');
      }
      return this;
    },
    onhintclick: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._hintClickCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onhintclick was not a function.');
      }
      return this;
    },
    onhintclose: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._hintCloseCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onhintclose was not a function.');
      }
      return this;
    },
    onexit: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._introExitCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onexit was not a function.');
      }
      return this;
    },
    onskip: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._introSkipCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onskip was not a function.');
      }
      return this;
    },
    onbeforeexit: function(providedCallback) {
      if (typeof (providedCallback) === 'function') {
        this._introBeforeExitCallback = providedCallback;
      } else {
        throw new Error('Provided callback for onbeforeexit was not a function.');
      }
      return this;
    },
    addHints: function() {
      _populateHints.call(this, this._targetElement);
      return this;
    },
    hideHint: function (stepId) {
      _hideHint.call(this, stepId);
      return this;
    },
    hideHints: function () {
      _hideHints.call(this);
      return this;
    },
    showHint: function (stepId) {
      _showHint.call(this, stepId);
      return this;
    },
    showHints: function () {
      _showHints.call(this);
      return this;
    },
    removeHints: function () {
      _removeHints.call(this);
      return this;
    },
    removeHint: function (stepId) {
      _removeHint.call(this, stepId);
      return this;
    },
    showHintDialog: function (stepId) {
      _showHintDialog.call(this, stepId);
      return this;
    }
  };

  return introJs;
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

    /**
 * Vue Cookies v1.5.12
 * https://github.com/cmp-cc/vue-cookies
 *
 * Copyright 2016, cmp-cc
 * Released under the MIT license
 */

(function() {

    var defaultConfig = {
        expires : '1d',
        path : '; path=/'
    }

    var VueCookies = {
        // install of Vue
        install: function(Vue) {
            Vue.prototype.$cookies = this
            Vue.cookies = this
        },
        config : function(expireTimes,path) {
            if(expireTimes) {
                defaultConfig.expires = expireTimes;
            }
            if(path) {
                defaultConfig.path = '; path=' + path;
            }
        },
        get: function(key) {
            var value = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null

            if(value && value.substring(0,1) === "{" && value.substring(value.length-1,value.length) === "}") {
                try {
                    value = JSON.parse(value)
                }catch (e) {
                    return value;
                }
            }
            return value;
        },
        set: function(key, value, expireTimes, path, domain, secure) {
            if (!key) {
                throw new Error("cookie name is not find in first argument")
            }else if(/^(?:expires|max\-age|path|domain|secure)$/i.test(key)){
                throw new Error("cookie key name illegality ,Cannot be set to ['expires','max-age','path','domain','secure']\t","current key name: "+key);
            }
            // support json object
            if(value && value.constructor === Object ) {
                value = JSON.stringify(value);
            }
            var _expires = "; max-age=86400"; // temp value, default expire time for 1 day
            expireTimes = expireTimes || defaultConfig.expires;
            if (expireTimes) {
                switch (expireTimes.constructor) {
                    case Number:
                        if(expireTimes === Infinity || expireTimes === -1) _expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
                        else _expires = "; max-age=" + expireTimes;
                        break;
                    case String:
                        if (/^(?:\d{1,}(y|m|d|h|min|s))$/i.test(expireTimes)) {
                            // get capture number group
                            var _expireTime = expireTimes.replace(/^(\d{1,})(?:y|m|d|h|min|s)$/i, "$1");
                            // get capture type group , to lower case
                            switch (expireTimes.replace(/^(?:\d{1,})(y|m|d|h|min|s)$/i, "$1").toLowerCase()) {
                                // Frequency sorting
                                case 'm':  _expires = "; max-age=" + +_expireTime * 2592000; break; // 60 * 60 * 24 * 30
                                case 'd':  _expires = "; max-age=" + +_expireTime * 86400; break; // 60 * 60 * 24
                                case 'h': _expires = "; max-age=" + +_expireTime * 3600; break; // 60 * 60
                                case 'min':  _expires = "; max-age=" + +_expireTime * 60; break; // 60
                                case 's': _expires = "; max-age=" + _expireTime; break;
                                case 'y': _expires = "; max-age=" + +_expireTime * 31104000; break; // 60 * 60 * 24 * 30 * 12
                                default: new Error("unknown exception of 'set operation'");
                            }
                        } else {
                            _expires = "; expires=" + expireTimes;
                        }
                        break;
                    case Date:
                        _expires = "; expires=" + expireTimes.toUTCString();
                        break;
                }
            }
            document.cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value) + _expires + (domain ? "; domain=" + domain : "") + (path ? "; path=" + path : defaultConfig.path) + (secure ? "; secure" : "");
            return this;
        },
        remove: function(key, path, domain) {
            if (!key || !this.isKey(key)) {
                return false;
            }
            document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (domain ? "; domain=" + domain : "") + (path ? "; path=" + path : defaultConfig.path);
            return this;
        },
        isKey: function(key) {
            return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
        },
        keys:  function() {
            if(!document.cookie) return [];
            var _keys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
            for (var _index = 0; _index < _keys.length; _index++) {
                _keys[_index] = decodeURIComponent(_keys[_index]);
            }
            return _keys;
        }
    }

    if (true) {
        module.exports = VueCookies;
    } else if (typeof define == "function" && define.amd) {
        define([], function() {
            return VueCookies;
        })
    } else if (window.Vue) {
        Vue.use(VueCookies);
    }
    // vue-cookies can exist independently,no dependencies library
    if(typeof window!=="undefined"){
        window.$cookies = VueCookies;
    }

})()

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Canvas to Blob
 * https://github.com/blueimp/JavaScript-Canvas-to-Blob
 *
 * Copyright 2012, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on stackoverflow user Stoive's code snippet:
 * http://stackoverflow.com/q/4998908
 */

/* global define, Uint8Array, ArrayBuffer, module */

;(function(window) {
  'use strict'

  var CanvasPrototype =
    window.HTMLCanvasElement && window.HTMLCanvasElement.prototype
  var hasBlobConstructor =
    window.Blob &&
    (function() {
      try {
        return Boolean(new Blob())
      } catch (e) {
        return false
      }
    })()
  var hasArrayBufferViewSupport =
    hasBlobConstructor &&
    window.Uint8Array &&
    (function() {
      try {
        return new Blob([new Uint8Array(100)]).size === 100
      } catch (e) {
        return false
      }
    })()
  var BlobBuilder =
    window.BlobBuilder ||
    window.WebKitBlobBuilder ||
    window.MozBlobBuilder ||
    window.MSBlobBuilder
  var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/
  var dataURLtoBlob =
    (hasBlobConstructor || BlobBuilder) &&
    window.atob &&
    window.ArrayBuffer &&
    window.Uint8Array &&
    function(dataURI) {
      var matches,
        mediaType,
        isBase64,
        dataString,
        byteString,
        arrayBuffer,
        intArray,
        i,
        bb
      // Parse the dataURI components as per RFC 2397
      matches = dataURI.match(dataURIPattern)
      if (!matches) {
        throw new Error('invalid data URI')
      }
      // Default to text/plain;charset=US-ASCII
      mediaType = matches[2]
        ? matches[1]
        : 'text/plain' + (matches[3] || ';charset=US-ASCII')
      isBase64 = !!matches[4]
      dataString = dataURI.slice(matches[0].length)
      if (isBase64) {
        // Convert base64 to raw binary data held in a string:
        byteString = atob(dataString)
      } else {
        // Convert base64/URLEncoded data component to raw binary:
        byteString = decodeURIComponent(dataString)
      }
      // Write the bytes of the string to an ArrayBuffer:
      arrayBuffer = new ArrayBuffer(byteString.length)
      intArray = new Uint8Array(arrayBuffer)
      for (i = 0; i < byteString.length; i += 1) {
        intArray[i] = byteString.charCodeAt(i)
      }
      // Write the ArrayBuffer (or ArrayBufferView) to a blob:
      if (hasBlobConstructor) {
        return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
          type: mediaType
        })
      }
      bb = new BlobBuilder()
      bb.append(arrayBuffer)
      return bb.getBlob(mediaType)
    }
  if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
    if (CanvasPrototype.mozGetAsFile) {
      CanvasPrototype.toBlob = function(callback, type, quality) {
        var self = this
        setTimeout(function() {
          if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
            callback(dataURLtoBlob(self.toDataURL(type, quality)))
          } else {
            callback(self.mozGetAsFile('blob', type))
          }
        })
      }
    } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
      CanvasPrototype.toBlob = function(callback, type, quality) {
        var self = this
        setTimeout(function() {
          callback(dataURLtoBlob(self.toDataURL(type, quality)))
        })
      }
    }
  }
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return dataURLtoBlob
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    module.exports = dataURLtoBlob
  } else {
    window.dataURLtoBlob = dataURLtoBlob
  }
})(window)


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(601);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("311713e2", content, true, {});

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".introjs-overlay{position:absolute;box-sizing:content-box;z-index:999999;background-color:#000;opacity:0;background:-moz-radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,.4) 0,rgba(0,0,0,.9) 100%);background:-webkit-gradient(radial,center center,0,center center,100%,color-stop(0,rgba(0,0,0,.4)),color-stop(100%,rgba(0,0,0,.9)));background:-webkit-radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,.4) 0,rgba(0,0,0,.9) 100%);background:-o-radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,.4) 0,rgba(0,0,0,.9) 100%);background:-ms-radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,.4) 0,rgba(0,0,0,.9) 100%);background:radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,.4) 0,rgba(0,0,0,.9) 100%);filter:\"progid:DXImageTransform.Microsoft.gradient(startColorstr='#66000000',endColorstr='#e6000000',GradientType=1)\";-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";filter:alpha(opacity=50);-webkit-transition:all .3s ease-out;-moz-transition:all .3s ease-out;-ms-transition:all .3s ease-out;-o-transition:all .3s ease-out;transition:all .3s ease-out}.introjs-fixParent{z-index:auto!important;opacity:1!important;-webkit-transform:none!important;-moz-transform:none!important;-ms-transform:none!important;-o-transform:none!important;transform:none!important}.introjs-showElement,tr.introjs-showElement>td,tr.introjs-showElement>th{z-index:9999999!important}.introjs-disableInteraction{z-index:99999999!important;position:absolute;background-color:#fff;opacity:0;filter:alpha(opacity=0)}.introjs-relativePosition,tr.introjs-showElement>td,tr.introjs-showElement>th{position:relative}.introjs-helperLayer{z-index:9999998;background-color:#fff;background-color:hsla(0,0%,100%,.9);border:1px solid #777;border:1px solid rgba(0,0,0,.5);border-radius:4px;box-shadow:0 2px 15px rgba(0,0,0,.4)}.introjs-helperLayer,.introjs-tooltipReferenceLayer{box-sizing:content-box;position:absolute;-webkit-transition:all .3s ease-out;-moz-transition:all .3s ease-out;-ms-transition:all .3s ease-out;-o-transition:all .3s ease-out;transition:all .3s ease-out}.introjs-tooltipReferenceLayer{visibility:hidden;z-index:100000000;background-color:transparent}.introjs-helperLayer *,.introjs-helperLayer :after,.introjs-helperLayer :before{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;-ms-box-sizing:content-box;-o-box-sizing:content-box;box-sizing:content-box}.introjs-helperNumberLayer{box-sizing:content-box;position:absolute;visibility:visible;top:-16px;left:-16px;z-index:9999999999!important;padding:2px;font-family:Arial,verdana,tahoma;font-size:13px;font-weight:700;color:#fff;text-align:center;text-shadow:1px 1px 1px rgba(0,0,0,.3);background:#ff3019;background:-webkit-linear-gradient(top,#ff3019,#cf0404);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#ff3019),color-stop(100%,#cf0404));background:-moz-linear-gradient(top,#ff3019 0,#cf0404 100%);background:-ms-linear-gradient(top,#ff3019 0,#cf0404 100%);background:-o-linear-gradient(top,#ff3019 0,#cf0404 100%);background:linear-gradient(180deg,#ff3019 0,#cf0404);width:20px;height:20px;line-height:20px;border:3px solid #fff;border-radius:50%;filter:\"progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3019', endColorstr='#cf0404', GradientType=0)\";filter:\"progid:DXImageTransform.Microsoft.Shadow(direction=135, strength=2, color=ff0000)\";box-shadow:0 2px 5px rgba(0,0,0,.4)}.introjs-arrow{border:5px solid transparent;content:\"\";position:absolute}.introjs-arrow.top,.introjs-arrow.top-right{top:-10px;border-bottom-color:#fff}.introjs-arrow.top-right{right:10px}.introjs-arrow.top-middle{top:-10px;left:50%;margin-left:-5px;border-bottom-color:#fff}.introjs-arrow.right{right:-10px;top:10px;border-left-color:#fff}.introjs-arrow.right-bottom{bottom:10px;right:-10px;border-left-color:#fff}.introjs-arrow.bottom,.introjs-arrow.bottom-right{bottom:-10px;border-top-color:#fff}.introjs-arrow.bottom-right{right:10px}.introjs-arrow.bottom-middle{bottom:-10px;left:50%;margin-left:-5px;border-top-color:#fff}.introjs-arrow.left{left:-10px;top:10px;border-right-color:#fff}.introjs-arrow.left-bottom{left:-10px;bottom:10px;border-right-color:#fff}.introjs-tooltip{box-sizing:content-box;position:absolute;visibility:visible;padding:10px;background-color:#fff;min-width:200px;max-width:300px;border-radius:3px;box-shadow:0 1px 10px rgba(0,0,0,.4);-webkit-transition:opacity .1s ease-out;-moz-transition:opacity .1s ease-out;-ms-transition:opacity .1s ease-out;-o-transition:opacity .1s ease-out;transition:opacity .1s ease-out}.introjs-tooltipbuttons{text-align:right;white-space:nowrap}.introjs-button{box-sizing:content-box;position:relative;overflow:visible;display:inline-block;padding:.3em .8em;border:1px solid #d4d4d4;margin:0;text-decoration:none;text-shadow:1px 1px 0 #fff;font:11px/normal sans-serif;color:#333;white-space:nowrap;cursor:pointer;outline:none;background-color:#ececec;background-image:-webkit-gradient(linear,0 0,0 100%,from(#f4f4f4),to(#ececec));background-image:-moz-linear-gradient(#f4f4f4,#ececec);background-image:-o-linear-gradient(#f4f4f4,#ececec);background-image:linear-gradient(#f4f4f4,#ececec);-webkit-background-clip:padding;-moz-background-clip:padding;-o-background-clip:padding-box;-webkit-border-radius:.2em;-moz-border-radius:.2em;border-radius:.2em;zoom:1;*display:inline;margin-top:10px}.introjs-button:hover{border-color:#bcbcbc;text-decoration:none;box-shadow:0 1px 1px #e3e3e3}.introjs-button:active,.introjs-button:focus{background-image:-webkit-gradient(linear,0 0,0 100%,from(#ececec),to(#f4f4f4));background-image:-moz-linear-gradient(#ececec,#f4f4f4);background-image:-o-linear-gradient(#ececec,#f4f4f4);background-image:linear-gradient(#ececec,#f4f4f4)}.introjs-button::-moz-focus-inner{padding:0;border:0}.introjs-skipbutton{box-sizing:content-box;margin-right:5px;color:#7a7a7a}.introjs-prevbutton{-webkit-border-radius:.2em 0 0 .2em;-moz-border-radius:.2em 0 0 .2em;border-radius:.2em 0 0 .2em;border-right:none}.introjs-prevbutton.introjs-fullbutton{border:1px solid #d4d4d4;-webkit-border-radius:.2em;-moz-border-radius:.2em;border-radius:.2em}.introjs-nextbutton{-webkit-border-radius:0 .2em .2em 0;-moz-border-radius:0 .2em .2em 0;border-radius:0 .2em .2em 0}.introjs-nextbutton.introjs-fullbutton{-webkit-border-radius:.2em;-moz-border-radius:.2em;border-radius:.2em}.introjs-disabled,.introjs-disabled:focus,.introjs-disabled:hover{color:#9a9a9a;border-color:#d4d4d4;box-shadow:none;cursor:default;background-color:#f4f4f4;background-image:none;text-decoration:none}.introjs-hidden{display:none}.introjs-bullets{text-align:center}.introjs-bullets ul{box-sizing:content-box;clear:both;margin:15px auto 0;padding:0;display:inline-block}.introjs-bullets ul li{box-sizing:content-box;list-style:none;float:left;margin:0 2px}.introjs-bullets ul li a{box-sizing:content-box;display:block;width:6px;height:6px;background:#ccc;border-radius:10px;-moz-border-radius:10px;-webkit-border-radius:10px;text-decoration:none;cursor:pointer}.introjs-bullets ul li a.active,.introjs-bullets ul li a:hover{background:#999}.introjs-progress{box-sizing:content-box;overflow:hidden;height:10px;margin:10px 0 5px;border-radius:4px;background-color:#ecf0f1}.introjs-progressbar{box-sizing:content-box;float:left;width:0;height:100%;font-size:10px;line-height:10px;text-align:center;background-color:#08c}.introjsFloatingElement{position:absolute;height:0;width:0;left:50%;top:50%}.introjs-fixedTooltip{position:fixed}.introjs-hint{box-sizing:content-box;position:absolute;background:transparent;width:20px;height:15px;cursor:pointer}.introjs-hint:focus{border:0;outline:0}.introjs-hidehint{display:none}.introjs-fixedhint{position:fixed}.introjs-hint:hover>.introjs-hint-pulse{border:5px solid rgba(60,60,60,.57)}.introjs-hint-pulse{box-sizing:content-box;width:10px;height:10px;border:5px solid rgba(60,60,60,.27);-webkit-border-radius:30px;-moz-border-radius:30px;border-radius:30px;background-color:hsla(0,0%,53%,.24);z-index:10;position:absolute;-webkit-transition:all .2s ease-out;-moz-transition:all .2s ease-out;-ms-transition:all .2s ease-out;-o-transition:all .2s ease-out;transition:all .2s ease-out}.introjs-hint-no-anim .introjs-hint-dot{-webkit-animation:none;-moz-animation:none;animation:none}.introjs-hint-dot{box-sizing:content-box;border:10px solid hsla(0,0%,57%,.36);background:transparent;-webkit-border-radius:60px;-moz-border-radius:60px;border-radius:60px;height:50px;width:50px;-webkit-animation:introjspulse 3s ease-out;-moz-animation:introjspulse 3s ease-out;animation:introjspulse 3s ease-out;-webkit-animation-iteration-count:infinite;-moz-animation-iteration-count:infinite;animation-iteration-count:infinite;position:absolute;top:-25px;left:-25px;z-index:1;opacity:0}@-webkit-keyframes introjspulse{0%{-webkit-transform:scale(0);opacity:0}25%{-webkit-transform:scale(0);opacity:.1}50%{-webkit-transform:scale(.1);opacity:.3}75%{-webkit-transform:scale(.5);opacity:.5}to{-webkit-transform:scale(1);opacity:0}}@-moz-keyframes introjspulse{0%{-moz-transform:scale(0);opacity:0}25%{-moz-transform:scale(0);opacity:.1}50%{-moz-transform:scale(.1);opacity:.3}75%{-moz-transform:scale(.5);opacity:.5}to{-moz-transform:scale(1);opacity:0}}@keyframes introjspulse{0%{transform:scale(0);opacity:0}25%{transform:scale(0);opacity:.1}50%{transform:scale(.1);opacity:.3}75%{transform:scale(.5);opacity:.5}to{transform:scale(1);opacity:0}}", ""]);

// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js